/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 68924:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.defaultConfig = void 0;
exports.defaultConfig = {
    lib: "https://acdn.adnxs.com/ast/ast.js",
    pageOpts: {
        member: 14785,
        disablePsa: true,
        noBidIfUnsold: true,
        keywords: {}
    },
    loadGDPRScript: false,
    allowedFormats: [
        "banner"
    ]
}; //# sourceMappingURL=default.js.map


/***/ }),

/***/ 21818:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.no = exports.se = exports.defaultConfig = void 0;
var default_1 = __webpack_require__(68924);
Object.defineProperty(exports, "defaultConfig", ({
    enumerable: true,
    get: function get() {
        return default_1.defaultConfig;
    }
}));
var se_1 = __webpack_require__(69484);
Object.defineProperty(exports, "se", ({
    enumerable: true,
    get: function get() {
        return se_1.se;
    }
}));
var no_1 = __webpack_require__(56586);
Object.defineProperty(exports, "no", ({
    enumerable: true,
    get: function get() {
        return no_1.no;
    }
})); //# sourceMappingURL=index.js.map


/***/ }),

/***/ 56586:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.no = void 0;
var default_1 = __webpack_require__(68924);
exports.no = _objectSpreadProps(_objectSpread({}, default_1.defaultConfig), {
    loadGDPRScript: true,
    pageOpts: _objectSpreadProps(_objectSpread({}, default_1.defaultConfig.pageOpts), {
        keywords: {
            "no-sno-publishergroup": "schibsted"
        }
    })
}); //# sourceMappingURL=no.js.map


/***/ }),

/***/ 69484:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.se = void 0;
var default_1 = __webpack_require__(68924);
exports.se = _objectSpreadProps(_objectSpread({}, default_1.defaultConfig), {
    loadGDPRScript: true
}); //# sourceMappingURL=se.js.map


/***/ }),

/***/ 7089:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = {
            enumerable: true,
            get: function get() {
                return m[k];
            }
        };
    }
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = this && this.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.adsConfig = void 0;
var appnexus = __importStar(__webpack_require__(21818));
var common = {
    service: "appnexus",
    appnexus: appnexus.defaultConfig,
    headerBiddingEnabled: false
};
exports.adsConfig = {
    dk: _objectSpread({}, common),
    fi: _objectSpread({}, common),
    fr: _objectSpread({}, common),
    gb: _objectSpread({}, common),
    no: _objectSpreadProps(_objectSpread({}, common), {
        appnexus: appnexus.no
    }),
    nz: _objectSpreadProps(_objectSpread({}, common), {
        labelAlign: "bottom"
    }),
    se: _objectSpreadProps(_objectSpread({}, common), {
        appnexus: appnexus.se
    })
}; //# sourceMappingURL=index.js.map


/***/ }),

/***/ 97496:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.dk = void 0;
var ads_1 = __webpack_require__(7089);
var types_1 = __webpack_require__(83109);
exports.dk = {
    countryCode: "dk",
    active: true,
    sitename: "Prisjagt",
    permanentRedirect: true,
    redirectHosts: [
        "m.prisjagt.dk",
        "www.prisjagt.dk"
    ],
    superSearchEndpoint: "https://search.cloud.pji.nu/rfe",
    trackerProxy: "rfe-tracker-2069617015.eu-west-1.elb.amazonaws.com",
    useClassicUrls: false,
    // If true, product tabs are accessed via e.g. #statistics rather than /statistics.
    useHashForProductTabs: true,
    classicProxy: {
        host: "int-classic-dk.prisjakt.io",
        port: 8080
    },
    hrefLang: [
        "da"
    ],
    locale: "da-dk",
    localeStandard: "da-DK",
    sites: {
        production: "https://prisjagt.dk",
        classic: "https://classic.prisjagt.dk",
        analytics: "https://prisjagt.dk/analytics/store/",
        brands: undefined,
        forum: undefined,
        mobile: undefined,
        staging: "https://next-dk.cloud.pji.nu"
    },
    campaigns: {
        previousCampaignDates: {
            "16": "2020-11-11"
        }
    },
    googleTagManager: "GTM-KD9S55X",
    translation: "da",
    timezone: "Europe/Copenhagen",
    currencyCode: "DKK",
    url: {
        campaigns: "/tema",
        legacy: {
            brand: "/brand.php",
            category: "/category.php",
            fight: "/fight.php",
            forum: undefined,
            info: "/info.php",
            lists: "/lists.php",
            minhembio: undefined,
            plugin: "/plugins/",
            product: "/product.php",
            raw: "/raw.php",
            store_info: "/shop.php",
            user_login: "/login/login.php",
            mobile_site: "https://m.prisjagt.dk"
        }
    },
    socialNetworks: {
        facebook: {
            link: "https://www.facebook.com/Prisjagt"
        }
    },
    email: {
        noreply: "noreply@prisjagt.dk",
        security: "security@prisjagt.dk"
    },
    cdn: {
        base: "https://pricespy-75b8.kxcdn.com",
        images: "https://pricespy-75b8.kxcdn.com/",
        offerImages: "https://www.prisjakt.nu/offers-images"
    },
    routes: {
        themes: {
            path: "/tema"
        },
        campaign: {
            path: "/tema/:name"
        },
        productAlert: {
            path: "*--p:id/overvage",
            relativePath: "/overvage"
        },
        productCompare: {
            path: "/sammenlign/produkter/:productIds?"
        },
        editorialContentListing: {
            path: "/artikler"
        },
        categoryIndex: {
            path: "/kategorier"
        },
        promotions: {
            path: "/kampagner"
        },
        promotionProducts: {
            path: "/kampagner/:id"
        },
        usedProducts: {
            path: "/brugt"
        }
    },
    popularCampaignFilterPaths: [],
    infoPages: [
        9,
        5,
        15,
        10,
        12,
        4,
        6,
        14,
        7,
        8
    ],
    infoPageMap: {
        userAgreement: 4,
        priceInformation: 5,
        privacyPolicy: 6,
        cookiePolicy: 7,
        contact: 8,
        about: 9,
        registerShop: 10,
        media: 12,
        disclaimer: 14,
        aboutReviews: 15,
        adlink: "adlink",
        themes: "themes",
        articles: "articles",
        categoryIndex: "categoryIndex",
        used: "used"
    },
    infoPageRegisterShopLink: "https://landing.prisjakt.nu/visible-at-prisjakt-dk",
    newsletter: {
        apiUrl: "https://api.getanewsletter.com/v3/",
        apiKey: "",
        list: "",
        gansubFormId: ""
    },
    apps: {
        ios: "369151774",
        android: "se.prisjakt.pricespy"
    },
    ads: _objectSpread({
        active: true
    }, ads_1.adsConfig.dk),
    paymentProviders: {
        priorities: [
            "PAYPAL",
            "SWISH",
            "VIPPS",
            "KLARNA",
            "SVEA_WEB_PAY",
            "AMEX",
            "MASTER_CARD",
            "VISA",
            "DINERS"
        ],
        groupPriorities: [
            types_1.PaymentProviderGroup.Direct,
            types_1.PaymentProviderGroup.Invoice,
            types_1.PaymentProviderGroup.Card
        ]
    },
    privacySettings: {
        responsive: {
            cookieVersion: "4",
            cookieUrl: "/info/--i7",
            cookieArticleId: "7",
            privacyUrl: "/info/--i6",
            privacyArticleId: "6",
            privacySettingsUrl: "/privacy-settings"
        },
        native: {
            cookieVersion: "hidden"
        }
    },
    modules: {
        categoryInfo: {
            enabled: false
        },
        userReviewPurchaseDate: {
            enabled: false
        },
        readableProductInfo: {
            enabled: true
        }
    },
    showSchibstedCoBranding: true,
    showClassicSwitch: false,
    trackingToggles: [
        {
            name: types_1.PrivacySettingToggle.BehaviourTrackingImprovement,
            default: false
        },
        {
            name: types_1.PrivacySettingToggle.BehaviorTrackingMarketing,
            default: false
        },
        {
            name: types_1.PrivacySettingToggle.BehaviorTrackingSurveys,
            default: false
        },
        {
            name: types_1.PrivacySettingToggle.PersonalizedAds,
            default: false
        },
        {
            name: types_1.PrivacySettingToggle.Personalization,
            default: false
        }
    ],
    shopOfTheYear: false,
    cdnCache: {
        enabled: true,
        mode: "external"
    },
    articles: {
        priceHistoryInfo: {
            path: "/prishistorik--ecYOMFnxIAACQAU7bH"
        },
        newsletterArticlesSidebar: {
            path: "/nyhedsbrev--ecZXF9oBcAACMAX1ZY"
        }
    },
    experts: {
        enabled: false
    },
    keywordLandingPagesEnabled: true,
    featuredCollectionsEnabled: true,
    fallbackRedirects: {
        v100: "/top-100--cv100"
    },
    login: {
        enabled: true
    }
}; //# sourceMappingURL=dk.js.map


/***/ }),

/***/ 72916:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.fi = void 0;
var ads_1 = __webpack_require__(7089);
var types_1 = __webpack_require__(83109);
exports.fi = {
    countryCode: "fi",
    active: true,
    sitename: "Hintaopas",
    permanentRedirect: true,
    redirectHosts: [
        "m.hintaopas.fi",
        "www.hintaopas.fi"
    ],
    superSearchEndpoint: "https://search.cloud.pji.nu/rfe",
    trackerProxy: "rfe-tracker-2069617015.eu-west-1.elb.amazonaws.com",
    useClassicUrls: true,
    classicProxy: {
        host: "int-classic-fi.prisjakt.io",
        port: 8080
    },
    hrefLang: [
        "fi"
    ],
    locale: "fi",
    localeStandard: "fi-FI",
    sites: {
        production: "https://hintaopas.fi",
        classic: "https://classic.hintaopas.fi",
        analytics: "https://classic.hintaopas.fi/analytics/store/",
        brands: undefined,
        forum: undefined,
        mobile: undefined,
        staging: "https://next-fi.cloud.pji.nu"
    },
    campaigns: {
        previousCampaignDates: {
            "2": "2019-11-29",
            "6": "2019-12-02",
            "3": "2019-12-25",
            "16": "2020-11-11"
        }
    },
    googleTagManager: "GTM-KD9S55X",
    translation: "fi",
    timezone: "Europe/Helsinki",
    currencyCode: "EUR",
    url: {
        campaigns: "/teema",
        legacy: {
            brand: "/brand.php",
            category: "/category.php",
            fight: "/fight.php",
            forum: undefined,
            info: "/info.php",
            lists: "/lists.php",
            minhembio: undefined,
            plugin: "/plugins/",
            product: "/product.php",
            raw: "/raw.php",
            store_info: "/shop.php",
            user_login: "/login/login.php",
            mobile_site: "https://m.hintaopas.fi"
        }
    },
    socialNetworks: {
        instagram: {
            link: "https://www.instagram.com/hintaopas/"
        },
        facebook: {
            link: "https://www.facebook.com/hintaopas"
        },
        twitter: {
            link: "https://twitter.com/Hintaopas_FI"
        }
    },
    schibstedOtherSitesLinks: [
        {
            name: "Tori,",
            siteUrl: "https://www.tori.fi/"
        },
        {
            name: "Oikotie,",
            siteUrl: "https://oikotie.fi/"
        },
        {
            name: "Rakentaja",
            siteUrl: "https://www.rakentaja.fi/"
        }
    ],
    email: {
        noreply: "noreply@hintaopas.fi",
        security: "security@hintaopas.fi"
    },
    cdn: {
        base: "https://pricespy-75b8.kxcdn.com",
        images: "https://pricespy-75b8.kxcdn.com/",
        offerImages: "https://www.prisjakt.nu/offers-images"
    },
    routes: {
        themes: {
            path: "/teema"
        },
        campaign: {
            path: "/teema/:name"
        },
        shopOfTheYear: {
            path: "/vuoden-verkkokauppa"
        },
        shopOfTheYearCategory: {
            path: "/vuoden-verkkokauppa/:year/category/:id"
        },
        shopOfTheYearWinners: {
            path: "/vuoden-verkkokauppa/:section"
        },
        productCompare: {
            path: "/vertaa/tuotteet/:productIds?"
        },
        editorialContentListing: {
            path: "/artikkeleita"
        },
        categoryIndex: {
            path: "/tuotekategoriat"
        },
        brand: {
            path: "/brand.php"
        },
        category: {
            path: "/category.php"
        },
        product: {
            path: "/product.php"
        },
        store: {
            path: "/shop.php"
        },
        promotions: {
            path: "/kampanjat"
        },
        promotionProducts: {
            path: "/kampanjat/:id"
        },
        usedProducts: {
            path: "/kaytetyt"
        }
    },
    popularCampaignFilterPaths: [
        {
            title: "Sykemittarit ja \xe4lykellot - parhaat tarjoukset",
            path: "?sort=product.popularity.total&category=1942"
        },
        {
            title: "Matkapuhelimet ja kuulokkeet",
            path: "?category=103%7C148"
        },
        {
            title: "Juoksukeng\xe4t ja tennarit – parhaat tarjoukset",
            path: "?sort=product.popularity.total&category=1428%7C1497"
        },
        {
            title: "Parhaat tarjoukset alle 50€",
            path: "?price=0-50"
        },
        {
            title: "Keitti\xf6 & kodinkoneet - parhaat tarjoukset",
            path: "?category=1671%7C504"
        },
        {
            title: "Televisiot",
            path: "?category=107"
        }
    ],
    infoPages: [
        9,
        5,
        15,
        10,
        12,
        4,
        6,
        14,
        7,
        8
    ],
    infoPageMap: {
        userAgreement: 4,
        priceInformation: 5,
        privacyPolicy: 6,
        cookiePolicy: 7,
        contact: 8,
        about: 9,
        registerShop: 10,
        media: 12,
        disclaimer: 14,
        aboutReviews: 15,
        adlink: "adlink",
        themes: "themes",
        articles: "articles",
        shopOfTheYear: "shopOfTheYear",
        categoryIndex: "categoryIndex",
        used: "used",
        newsroom: "newsroom",
        januarySales: "/teema/tammiale"
    },
    infoPageRegisterShopLink: "https://landing.prisjakt.nu/visible-at-prisjakt-fi",
    newsletter: {
        apiUrl: "https://api.getanewsletter.com/v3/",
        apiKey: "8KV6mYjfJmudQnsQGIm1ba/oRw/hcDhaDiuvgz2yT8f8NfKzl017dhGEpHPOAxQVLiUq4ZibYSS9c6aQuWqaKjByShyixwZjSZgh1cJlSzvDdDx7G1L4+uo5UTV6TFV0xqRIUW4PmgCdXk16Cnzds6a4aImDyrsRO/8eszpZG2g8D5bNcy+t2xBU+eh1LFUZ96CJrs4DzWOMfIOrWs/F61fZJHU5GGNG6QVjiZ4STok+mUD+NEezTNHDVIySuT4",
        list: "SBTmg",
        gansubFormId: "mBEs"
    },
    apps: {
        ios: "369151774",
        android: "se.prisjakt.pricespy"
    },
    ads: _objectSpread({
        active: true
    }, ads_1.adsConfig.fi),
    paymentProviders: {
        priorities: [
            "SWISH",
            "VIPPS",
            "PAYPAL",
            "KLARNA",
            "SVEA_WEB_PAY",
            "AMEX",
            "MASTER_CARD",
            "VISA",
            "DINERS"
        ],
        groupPriorities: [
            types_1.PaymentProviderGroup.Direct,
            types_1.PaymentProviderGroup.Invoice,
            types_1.PaymentProviderGroup.Card
        ]
    },
    privacySettings: {
        responsive: {
            cookieVersion: "4",
            cookieUrl: "/info/evasteet--i7",
            cookieArticleId: "7",
            privacyUrl: "/info/tietosuojakaytannot--i6",
            privacyArticleId: "6",
            privacySettingsUrl: "/privacy-settings"
        },
        native: {
            cookieVersion: "hidden"
        }
    },
    modules: {
        categoryInfo: {
            enabled: false
        },
        userReviewPurchaseDate: {
            enabled: false
        },
        readableProductInfo: {
            enabled: true
        }
    },
    showSchibstedCoBranding: true,
    showClassicSwitch: false,
    trackingToggles: [
        {
            name: types_1.PrivacySettingToggle.BehaviourTrackingImprovement,
            default: false
        },
        {
            name: types_1.PrivacySettingToggle.BehaviorTrackingMarketing,
            default: false
        },
        {
            name: types_1.PrivacySettingToggle.BehaviorTrackingSurveys,
            default: false
        },
        {
            name: types_1.PrivacySettingToggle.PersonalizedAds,
            default: false
        },
        {
            name: types_1.PrivacySettingToggle.Personalization,
            default: false
        }
    ],
    shopOfTheYear: true,
    cdnCache: {
        enabled: true,
        mode: "external"
    },
    articles: {
        priceHistoryInfo: {
            path: "/hintahistoria-nayttaa-miten-hinta-on-muuttunut-ajan-myota--ecYO001xAAACMA0Ed_"
        },
        newsletterArticlesSidebar: {
            path: "/uutiskirje--ecZXLDthcAACQAZSip"
        }
    },
    experts: {
        enabled: false
    },
    keywordLandingPagesEnabled: true,
    featuredCollectionsEnabled: true,
    login: {
        enabled: true
    }
}; //# sourceMappingURL=fi.js.map


/***/ }),

/***/ 91954:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.fr = void 0;
var ads_1 = __webpack_require__(7089);
var types_1 = __webpack_require__(83109);
exports.fr = {
    countryCode: "fr",
    active: true,
    permanentRedirect: true,
    sitename: "leD\xe9nicheur",
    redirectHosts: [
        "m.ledenicheur.fr",
        "www.ledenicheur.fr"
    ],
    useClassicUrls: true,
    superSearchEndpoint: "https://search.cloud.pji.nu/rfe",
    trackerProxy: "rfe-tracker-2069617015.eu-west-1.elb.amazonaws.com",
    classicProxy: {
        host: "int-classic-fr.prisjakt.io",
        port: 8080
    },
    hrefLang: [
        "fr"
    ],
    locale: "fr-fr",
    localeStandard: "fr-FR",
    sites: {
        production: "https://ledenicheur.fr",
        classic: "https://classic.ledenicheur.fr",
        analytics: "https://classic.ledenicheur.fr/analytics/store",
        forum: undefined,
        brands: undefined,
        mobile: "https://m.ledenicheur.fr",
        staging: "https://next-fr.cloud.pji.nu"
    },
    campaigns: {
        previousCampaignDates: {
            "2": "2019-11-29",
            "6": "2019-12-02",
            "12": "2020-01-09"
        }
    },
    googleTagManager: "GTM-KD9S55X",
    translation: "fr",
    timezone: "Europe/Paris",
    currencyCode: "EUR",
    url: {
        campaigns: "/actu",
        legacy: {
            brand: "/brand.php",
            category: "/category.php",
            fight: "/fight.php",
            forum: undefined,
            info: "/info.php",
            lists: "/lists.php",
            minhembio: undefined,
            plugin: "/plugins/",
            product: "/product.php",
            raw: "/raw.php",
            store_info: "/shop.php",
            user_login: "/login/login.php",
            mobile_site: "https://m.ledenicheur.fr"
        }
    },
    socialNetworks: {
        instagram: {
            link: "https://www.instagram.com/ledenicheur/"
        },
        facebook: {
            link: "https://www.facebook.com/leDenicheurFR"
        },
        twitter: {
            link: "https://twitter.com/leDenicheur"
        }
    },
    email: {
        noreply: "noreply@ledenicheur.fr",
        security: "security@ledenicheur.fr"
    },
    cdn: {
        base: "https://pricespy-75b8.kxcdn.com",
        images: "https://pricespy-75b8.kxcdn.com/",
        offerImages: "https://www.prisjakt.nu/offers-images"
    },
    routes: {
        themes: {
            path: "/actu"
        },
        campaign: {
            path: "/actu/:name"
        },
        productCompare: {
            path: "/comparer/produits/:productIds?"
        },
        categoryIndex: {
            path: "/categories"
        },
        brand: {
            path: "/brand.php"
        },
        category: {
            path: "/category.php"
        },
        product: {
            path: "/product.php"
        },
        store: {
            path: "/shop.php"
        },
        promotions: {
            path: "/campagnes"
        },
        promotionProducts: {
            path: "/campagnes/:id"
        },
        usedProducts: {
            path: "/reconditionne-ou-occasion"
        }
    },
    popularCampaignFilterPaths: [
        {
            title: "Smartphones",
            path: "?category=103&price=100-10000"
        },
        {
            title: "Informatique",
            path: "?category=382%7C384%7C393%7C353%7C352%7C1243%7C1313%7C977"
        },
        {
            title: "Enceintes & casques audio",
            path: "?category=148%7C1827&price=15-10000"
        },
        {
            title: "TV",
            path: "?category=107&price=100-10000"
        },
        {
            title: "Gros \xe9lectrom\xe9nager",
            path: "?category=504"
        },
        {
            title: "Cuisine",
            path: "?category=1671&price=30-3000"
        },
        {
            title: "Aspirateurs",
            path: "?category=515%7C520&price=100-2000"
        },
        {
            title: "Chauffages & climatisation",
            path: "?category=507&price=30-3000"
        },
        {
            title: "Outillage & jardinage",
            path: "?category=1064%7C1069&price=30-3000"
        }
    ],
    infoPages: [
        9,
        5,
        15,
        10,
        12,
        4,
        6,
        14,
        7,
        8
    ],
    infoPageMap: {
        userAgreement: 4,
        priceInformation: 5,
        privacyPolicy: 6,
        cookiePolicy: 7,
        contact: 8,
        about: 9,
        registerShop: 10,
        media: 12,
        disclaimer: 14,
        aboutReviews: 15,
        adlink: "adlink",
        themes: "themes",
        articles: "articles",
        categoryIndex: "categoryIndex",
        used: "used",
        privacySettings: "privacySettings",
        newsroom: "newsroom",
        boxingDayDeals: "/actu/soldes-hiver"
    },
    infoPageRegisterShopLink: "https://landing.prisjakt.nu/visible-at-prisjakt-fr",
    newsletter: {
        apiUrl: "https://api.getanewsletter.com/v3/",
        apiKey: "8KV6mYjfJmudQnsQGIm1ba/oRw/hcDhaDiuvgz2yT8f8NfKzl017dhGEpHPOAxQVLiUq4ZibYSS9c6aQuWqaKjByShyixwZjSZgh1cJlSzvDdDx7G1L4+uo5UTV6TFV0xqRIUW4PmgCdXk16Cnzds6a4aImDyrsRO/8eszpZG2g8D5bNcy+t2xBU+eh1LFUZ96CJrs4DzWOMfIOrWs/F61fZJHU5GGNG6QVjiZ4STok+mUD+NEezTNHDVIySuT4",
        list: "SAzT5",
        gansubFormId: "gc6FyDznc6U0BEVZnott"
    },
    apps: {
        ios: "369151774",
        android: "se.prisjakt.pricespy"
    },
    paymentProviders: {
        priorities: [
            "VISA",
            "MASTER_CARD",
            "AMEX",
            "DINERS",
            "SWISH",
            "VIPPS",
            "PAYPAL",
            "KLARNA",
            "SVEA_WEB_PAY"
        ],
        groupPriorities: [
            types_1.PaymentProviderGroup.Card,
            types_1.PaymentProviderGroup.Direct,
            types_1.PaymentProviderGroup.Invoice
        ]
    },
    offerList: {
        filters: {
            hiddenFilters: [
                types_1.FilterType.INTERNATIONAL
            ]
        }
    },
    ads: _objectSpread({
        active: true
    }, ads_1.adsConfig.fr),
    privacySettings: {
        responsive: {
            cookieVersion: "4",
            cookieUrl: "/info/cookies--i7",
            cookieArticleId: "7",
            privacyUrl: "/info/--i6",
            privacyArticleId: "6",
            privacySettingsUrl: "/privacy-settings"
        },
        native: {
            cookieVersion: "hidden"
        }
    },
    modules: {
        categoryInfo: {
            enabled: true
        },
        userReviewPurchaseDate: {
            enabled: true,
            datePlaceholderFormat: "aaaa-mm-jj"
        },
        readableProductInfo: {
            enabled: true
        }
    },
    showClassicSwitch: false,
    trackingToggles: [
        {
            name: types_1.PrivacySettingToggle.BehaviourTrackingImprovement,
            default: false
        },
        {
            name: types_1.PrivacySettingToggle.BehaviorTrackingMarketing,
            default: false
        },
        {
            name: types_1.PrivacySettingToggle.BehaviorTrackingSurveys,
            default: false
        },
        {
            name: types_1.PrivacySettingToggle.PersonalizedAds,
            default: false
        },
        {
            name: types_1.PrivacySettingToggle.Personalization,
            default: false
        }
    ],
    shopOfTheYear: false,
    cdnCache: {
        enabled: true,
        mode: "external"
    },
    articles: {
        priceHistoryInfo: {
            path: "/historique-des-prix--ecYORbihIAACMAWaGg"
        },
        newsletterArticlesSidebar: {
            path: "/newsletter--ecZXLBkxcAACMAZR8L"
        }
    },
    experts: {
        enabled: false
    },
    keywordLandingPagesEnabled: true,
    featuredCollectionsEnabled: true,
    login: {
        enabled: false
    }
}; //# sourceMappingURL=fr.js.map


/***/ }),

/***/ 34732:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.gb = void 0;
var ads_1 = __webpack_require__(7089);
var types_1 = __webpack_require__(83109);
exports.gb = {
    countryCode: "gb",
    active: true,
    permanentRedirect: true,
    sitename: "PriceSpy",
    superSearchEndpoint: "https://search.cloud.pji.nu/rfe",
    redirectHosts: [
        "m.pricespy.co.uk",
        "www.pricespy.co.uk"
    ],
    trackerProxy: "rfe-tracker-2069617015.eu-west-1.elb.amazonaws.com",
    classicProxy: {
        host: "int-classic-gb.prisjakt.io",
        port: 8080
    },
    useClassicUrls: false,
    hrefLang: [
        "en",
        "en-GB"
    ],
    locale: "en-gb",
    localeStandard: "en-GB",
    sites: {
        production: "https://pricespy.co.uk",
        classic: "https://classic.pricespy.co.uk",
        analytics: "https://pricespy.co.uk/analytics/store/",
        brands: undefined,
        forum: undefined,
        staging: "https://next-gb.cloud.pji.nu"
    },
    campaigns: {
        previousCampaignDates: {
            "2": "2019-11-29",
            "6": "2019-12-02",
            "3": "2019-12-26",
            "12": "2020-01-02",
            "16": "2020-11-11"
        }
    },
    googleTagManager: "GTM-KD9S55X",
    translation: "en_GB",
    timezone: "Europe/London",
    currencyCode: "GBP",
    url: {
        campaigns: "/theme",
        legacy: {
            brand: "/brand.php",
            category: "/category.php",
            fight: "/fight.php",
            info: "/info.php",
            lists: "/list.php",
            plugin: "/plugins/",
            product: "/product.php",
            raw: "/expert.php",
            store_info: "/store.php",
            user_login: "/login/login.php",
            mobile_site: "https://m.pricespy.co.uk"
        }
    },
    email: {
        noreply: "noreply@pricespy.co.uk",
        security: "security@pricespy.co.uk"
    },
    socialNetworks: {
        instagram: {
            link: "https://www.instagram.com/pricespy/"
        },
        facebook: {
            link: "https://www.facebook.com/PriceSpyUK"
        },
        twitter: {
            link: "https://twitter.com/PriceSpyUK"
        }
    },
    cdn: {
        base: "https://pricespy-75b8.kxcdn.com",
        images: "https://pricespy-75b8.kxcdn.com/",
        offerImages: "https://www.prisjakt.nu/offers-images"
    },
    routes: {
        themes: {
            path: "/theme"
        },
        campaign: {
            path: "/theme/:name"
        },
        productCompare: {
            path: "/compare/products/:productIds?"
        },
        brand: {
            path: "*--b:id(\\d+)"
        },
        category: {
            path: "*--c:id([sv]?\\d+)"
        },
        product: {
            path: "*--p:id(\\d+)/:section(properties|reviews|statistics)?"
        },
        store: {
            path: "*--s:id(\\d+)/:section(reviews)?"
        },
        promotions: {
            path: "/promotions"
        },
        promotionProducts: {
            path: "/promotions/:id"
        },
        usedProducts: {
            path: "/used"
        }
    },
    popularCampaignFilterPaths: [
        {
            title: "Best TV deals under \xa31000",
            path: "?category=107&price=1-1000&sort=rank%7Cdesc"
        },
        {
            title: "Best deals under \xa350",
            path: "?sort=rank%7Cdesc&price=1-50"
        },
        {
            title: "Best deals \xa350-100",
            path: "?sort=rank%7Cdesc&price=50-100"
        },
        {
            title: "Work from home",
            path: "?category=555%7C148%7C1594"
        },
        {
            title: "Most popular vacuum cleaners",
            path: "?sort=product.popularity.total&category=515"
        }
    ],
    infoPages: [
        9,
        5,
        15,
        10,
        12,
        4,
        6,
        14,
        7,
        8
    ],
    infoPageMap: {
        userAgreement: 4,
        priceInformation: 5,
        privacyPolicy: 6,
        cookiePolicy: 7,
        contact: 8,
        about: 9,
        registerShop: 10,
        media: 12,
        disclaimer: 14,
        aboutReviews: 15,
        adlink: "adlink",
        themes: "themes",
        articles: "articles",
        categoryIndex: "categoryIndex",
        used: "used",
        privacySettings: "privacySettings",
        supportPage: "supportPage",
        newsroom: "newsroom",
        januarySales: "/theme/january-sale"
    },
    infoPageRegisterShopLink: "https://landing.prisjakt.nu/visible-at-prisjakt-uk",
    newsletter: {
        apiUrl: "https://api.getanewsletter.com/v3/",
        apiKey: "8KV6mYjfJmudQnsQGIm1ba/oRw/hcDhaDiuvgz2yT8f8NfKzl017dhGEpHPOAxQVLiUq4ZibYSS9c6aQuWqaKjByShyixwZjSZgh1cJlSzvDdDx7G1L4+uo5UTV6TFV0xqRIUW4PmgCdXk16Cnzds6a4aImDyrsRO/8eszpZG2g8D5bNcy+t2xBU+eh1LFUZ96CJrs4DzWOMfIOrWs/F61fZJHU5GGNG6QVjiZ4STok+mUD+NEezTNHDVIySuT4",
        list: "BYajAsGm",
        gansubFormId: "Q2lk"
    },
    apps: {
        ios: "369151774",
        android: "se.prisjakt.pricespy"
    },
    ads: _objectSpread({
        active: true
    }, ads_1.adsConfig.gb),
    paymentProviders: {
        priorities: [
            "KLARNA",
            "SVEA_WEB_PAY",
            "PAYPAL",
            "SWISH",
            "VIPPS",
            "AMEX",
            "MASTER_CARD",
            "VISA",
            "DINERS"
        ],
        groupPriorities: [
            types_1.PaymentProviderGroup.Invoice,
            types_1.PaymentProviderGroup.Direct,
            types_1.PaymentProviderGroup.Card
        ]
    },
    privacySettings: {
        responsive: {
            cookieVersion: "4",
            cookieUrl: "/info/cookies--i7",
            cookieArticleId: "7",
            privacyUrl: "/info/privacy-policy--i6",
            privacyArticleId: "6",
            privacySettingsUrl: "/privacy-settings"
        },
        native: {
            cookieVersion: "hidden"
        }
    },
    structuredData: {
        "@context": "http://schema.org",
        "@type": "Organization",
        legalName: "PriceSpy Ltd",
        areaServed: "GB",
        url: "https://pricespy.co.uk",
        address: {
            "@type": "PostalAddress",
            streetAddress: "Sweden House, 5 Upper Montagu Street",
            addressLocality: "London",
            postalCode: "W1H 2AG",
            addressCountry: "United Kingdom"
        },
        logo: "https://pricespy-75b8.kxcdn.com/g/rfe/logos/logo_gb.svg",
        sameAs: [
            "https://www.facebook.com/PriceSpyUK",
            "https://twitter.com/pricespyuk"
        ]
    },
    modules: {
        categoryInfo: {
            enabled: false
        },
        userReviewPurchaseDate: {
            enabled: false
        },
        readableProductInfo: {
            enabled: true
        }
    },
    showClassicSwitch: false,
    trackingToggles: [
        {
            name: types_1.PrivacySettingToggle.BehaviourTrackingImprovement,
            default: false
        },
        {
            name: types_1.PrivacySettingToggle.BehaviorTrackingMarketing,
            default: false
        },
        {
            name: types_1.PrivacySettingToggle.BehaviorTrackingSurveys,
            default: false
        },
        {
            name: types_1.PrivacySettingToggle.PersonalizedAds,
            default: false
        },
        {
            name: types_1.PrivacySettingToggle.Personalization,
            default: false
        }
    ],
    shopOfTheYear: true,
    cdnCache: {
        enabled: true,
        mode: "external"
    },
    articles: {
        priceHistoryInfo: {
            path: "/price-history--ecYSSD4hIAACEAXXWu"
        },
        newsletterArticlesSidebar: {
            path: "/newsletter--ecZXGEORcAACYAX3Qm"
        }
    },
    experts: {
        enabled: false
    },
    keywordLandingPagesEnabled: true,
    featuredCollectionsEnabled: true,
    fallbackRedirects: {
        v100: "/top-100--cv100"
    },
    robotsTxt: [
        "Disallow: /amp/*"
    ],
    login: {
        enabled: false
    }
}; //# sourceMappingURL=gb.js.map


/***/ }),

/***/ 92331:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
exports.q = void 0;
var gb_1 = __webpack_require__(34732);
var se_1 = __webpack_require__(76873);
var fi_1 = __webpack_require__(72916);
var fr_1 = __webpack_require__(91954);
var no_1 = __webpack_require__(69909);
var nz_1 = __webpack_require__(49645);
var dk_1 = __webpack_require__(97496);
exports.q = {
    se: se_1.se,
    gb: gb_1.gb,
    fi: fi_1.fi,
    fr: fr_1.fr,
    no: no_1.no,
    nz: nz_1.nz,
    dk: dk_1.dk
}; //# sourceMappingURL=index.js.map


/***/ }),

/***/ 69909:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.no = void 0;
var ads_1 = __webpack_require__(7089);
var types_1 = __webpack_require__(83109);
exports.no = {
    countryCode: "no",
    active: true,
    permanentRedirect: true,
    sitename: "Prisjakt",
    redirectHosts: [
        "m.prisjakt.no",
        "prisjakt.no"
    ],
    superSearchEndpoint: "https://search.cloud.pji.nu/rfe",
    trackerProxy: "rfe-tracker-2069617015.eu-west-1.elb.amazonaws.com",
    useClassicUrls: true,
    classicProxy: {
        host: "int-classic-no.prisjakt.io",
        port: 8080
    },
    hrefLang: [
        "no"
    ],
    locale: "no",
    localeStandard: "nb-NO",
    sites: {
        production: "https://www.prisjakt.no",
        classic: "https://classic.prisjakt.no",
        analytics: "https://classic.prisjakt.no/analytics/store",
        brands: undefined,
        forum: undefined,
        mobile: "https://m.prisjakt.no",
        staging: "https://next-no.cloud.pji.nu"
    },
    campaigns: {
        previousCampaignDates: {
            "2": "2019-11-29",
            "6": "2019-12-02",
            "3": "2019-12-25",
            "12": "2020-01-01",
            "16": "2020-11-11"
        }
    },
    googleTagManager: "GTM-KD9S55X",
    translation: "nb_NO",
    timezone: "Europe/Oslo",
    currencyCode: "NOK",
    url: {
        campaigns: "/tema",
        legacy: {
            brand: "/brand.php",
            category: "/category.php",
            fight: "/fight.php",
            forum: undefined,
            info: "/info.php",
            lists: "/lists.php",
            minhembio: undefined,
            plugin: "/plugins/",
            product: "/product.php",
            raw: "/raw.php",
            store_info: "/shop.php",
            user_login: "/login/login.php",
            mobile_site: "https://m.prisjakt.no"
        }
    },
    socialNetworks: {
        instagram: {
            link: "https://www.instagram.com/prisjakt.no/"
        },
        facebook: {
            link: "https://www.facebook.com/PrisjaktNorge"
        },
        twitter: {
            link: "https://twitter.com/PrisjaktNorge"
        }
    },
    email: {
        noreply: "noreply@prisjakt.no",
        security: "security@prisjakt.no"
    },
    cdn: {
        base: "https://pricespy-75b8.kxcdn.com",
        images: "https://pricespy-75b8.kxcdn.com/",
        offerImages: "https://www.prisjakt.nu/offers-images"
    },
    routes: {
        themes: {
            path: "/tema"
        },
        campaign: {
            path: "/tema/:name"
        },
        shopOfTheYear: {
            path: "/arets-butikk"
        },
        shopOfTheYearCategory: {
            path: "/arets-butikk/:year/category/:id"
        },
        shopOfTheYearWinners: {
            path: "/arets-butikk/:section"
        },
        productCompare: {
            path: "/sammenlign/produkter/:productIds?"
        },
        editorialContentListing: {
            path: "/artikler"
        },
        categoryIndex: {
            path: "/kategorier"
        },
        brand: {
            path: "/brand.php"
        },
        category: {
            path: "/category.php"
        },
        product: {
            path: "/product.php"
        },
        store: {
            path: "/shop.php"
        },
        expertProductTest: {
            path: "/tester/:slug?",
            relativePath: "/tester"
        },
        expertToplists: {
            path: "/topplister/:slug?",
            relativePath: "/topplister"
        },
        expertGuide: {
            path: "/guider/:slug?",
            relativePath: "/guider"
        },
        expertLandingPage: {
            path: "/eksperter"
        },
        expertProfile: {
            path: "/eksperter/profil/:slug?",
            relativePath: "/eksperter/profil"
        },
        expertCategory: {
            path: "/eksperter/:slug",
            relativePath: "/eksperter"
        },
        promotions: {
            path: "/kampanjer"
        },
        promotionProducts: {
            path: "/kampanjer/:id"
        },
        usedProducts: {
            path: "/brukt"
        }
    },
    popularCampaignFilterPaths: [
        {
            title: "Tilbud under 500 kr",
            path: "?price=0-500"
        },
        {
            title: "Tilbud 500-1000 kr",
            path: "?price=500-1000"
        },
        {
            title: "Beste tilbud p\xe5 hodetelefoner",
            path: "?category=148"
        },
        {
            title: "Beste tilbud p\xe5 robotst\xf8vsugere og st\xf8vsugere",
            path: "?category=515%7C520"
        },
        {
            title: "Jobb hjemmefra",
            path: "?category=555%7C148%7C1594"
        },
        {
            title: "Beste tilbud p\xe5 hvitevarer",
            path: "?category=504"
        },
        {
            title: "TVs",
            path: "?category=107"
        }
    ],
    campaignFeaturedList: [
        {
            campaignId: 2,
            listId: 520202
        }
    ],
    infoPages: [
        9,
        10,
        12,
        4,
        6,
        14,
        7,
        8
    ],
    infoPageMap: {
        userAgreement: 4,
        privacyPolicy: 6,
        cookiePolicy: 7,
        contact: 8,
        about: 9,
        registerShop: 10,
        media: 12,
        disclaimer: 14,
        adlink: "adlink",
        themes: "themes",
        articles: "articles",
        shopOfTheYear: "shopOfTheYear",
        categoryIndex: "categoryIndex",
        used: "used",
        promotions: "promotions",
        supportPage: "supportPage",
        newsroom: "newsroom",
        getStarted: "/info/kom-i-gang-med-prisjakt--ipZHmEYRAAACIAfcus",
        howWorks: "/info/apenhetsl\xf8fte-hvordan-prisjakt-fungerer--ipZHhajxAAACMAeHXd",
        transparency: "/info/apenhetsloven--ipZH2UQxAAACIAj9Uf",
        januarySales: "/tema/januarsalg"
    },
    infoPageRegisterShopLink: "https://landing.prisjakt.nu/visible-at-prisjakt-no",
    newsletter: {
        apiUrl: "https://api.getanewsletter.com/v3/",
        apiKey: "8KV6mYjfJmudQnsQGIm1ba/oRw/hcDhaDiuvgz2yT8f8NfKzl017dhGEpHPOAxQVLiUq4ZibYSS9c6aQuWqaKjByShyixwZjSZgh1cJlSzvDdDx7G1L4+uo5UTV6TFV0xqRIUW4PmgCdXk16Cnzds6a4aImDyrsRO/8eszpZG2g8D5bNcy+t2xBU+eh1LFUZ96CJrs4DzWOMfIOrWs/F61fZJHU5GGNG6QVjiZ4STok+mUD+NEezTNHDVIySuT4",
        list: "DiriBRd",
        gansubFormId: "ygTTkGiPETLPh10qRO"
    },
    apps: {
        ios: "369151774",
        android: "se.prisjakt.pricespy"
    },
    paymentProviders: {
        priorities: [
            "KLARNA",
            "SVEA_WEB_PAY",
            "VIPPS",
            "PAYPAL",
            "SWISH",
            "AMEX",
            "MASTER_CARD",
            "VISA",
            "DINERS"
        ],
        groupPriorities: [
            types_1.PaymentProviderGroup.Invoice,
            types_1.PaymentProviderGroup.Direct,
            types_1.PaymentProviderGroup.Card
        ]
    },
    ads: _objectSpread({
        active: true
    }, ads_1.adsConfig.no),
    privacySettings: {
        responsive: {
            cookieVersion: "4",
            cookieUrl: "/info/retningslinjer-for-bruk-av-informasjonskapsler--i7",
            cookieArticleId: "7",
            privacyUrl: "/info/retningslinjer-for-personvern--i6",
            privacyArticleId: "6",
            privacySettingsUrl: "/privacy-settings"
        },
        native: {
            cookieVersion: "hidden"
        }
    },
    modules: {
        categoryInfo: {
            enabled: false
        },
        userReviewPurchaseDate: {
            enabled: false
        },
        readableProductInfo: {
            enabled: true
        }
    },
    showSchibstedCoBranding: true,
    showClassicSwitch: true,
    showBrandingTagline: true,
    trackingToggles: [
        {
            name: types_1.PrivacySettingToggle.BehaviourTrackingImprovement,
            default: false
        },
        {
            name: types_1.PrivacySettingToggle.BehaviorTrackingMarketing,
            default: false
        },
        {
            name: types_1.PrivacySettingToggle.BehaviorTrackingSurveys,
            default: false
        },
        {
            name: types_1.PrivacySettingToggle.PersonalizedAds,
            default: false
        },
        {
            name: types_1.PrivacySettingToggle.Personalization,
            default: false
        }
    ],
    shopOfTheYear: true,
    cdnCache: {
        enabled: true,
        mode: "external"
    },
    articles: {
        aboutExperts: {
            path: "/info/apenhetsl%C3%B8fte-prisjakt-eksperter--ipZIGG3BAAACMAoZJY"
        },
        priceHistoryInfo: {
            path: "/prishistorikk--ecYOasRhIAACMAY7_I"
        },
        newsletterArticlesSidebar: {
            path: "/nyhetsbrev--ecZXFxSRcAACUAXx-i"
        }
    },
    experts: {
        enabled: true,
        lightweightMode: true
    },
    keywordLandingPagesEnabled: true,
    featuredCollectionsEnabled: true,
    robotsTxt: [
        "Disallow: /amp/*"
    ],
    login: {
        enabled: true
    }
}; //# sourceMappingURL=no.js.map


/***/ }),

/***/ 49645:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.nz = void 0;
var ads_1 = __webpack_require__(7089);
var types_1 = __webpack_require__(83109);
exports.nz = {
    countryCode: "nz",
    active: true,
    sitename: "PriceSpy",
    permanentRedirect: true,
    redirectHosts: [
        "m.pricespy.co.nz",
        "www.pricespy.co.nz",
        "pricespy.nz",
        "www.pricespy.nz"
    ],
    superSearchEndpoint: "https://search.pricespy.co.nz/rfe",
    classicProxy: {
        host: "int-classic-nz.prisjakt.io",
        secure: true,
        port: 443
    },
    useClassicUrls: true,
    hrefLang: [
        "en-NZ"
    ],
    locale: "en-nz",
    localeStandard: "en-NZ",
    sites: {
        production: "https://pricespy.co.nz",
        classic: "https://classic.pricespy.co.nz",
        analytics: "https://classic.pricespy.co.nz/analytics/store/",
        brands: undefined,
        forum: "https://classic.pricespy.co.nz/forum",
        mobile: undefined,
        staging: undefined
    },
    campaigns: {
        previousCampaignDates: {
            "2": "2019-11-29",
            "6": "2019-12-02",
            "3": "2019-12-26",
            "16": "2020-11-11"
        }
    },
    googleTagManager: "GTM-KD9S55X",
    translation: "en_NZ",
    timezone: "Pacific/Auckland",
    currencyCode: "NZD",
    url: {
        campaigns: "/theme",
        legacy: {
            brand: "/brand.php",
            category: "/category.php",
            fight: "/fight.php",
            forum: undefined,
            info: "/info.php",
            lists: "/lists.php",
            minhembio: undefined,
            plugin: "/plugins/",
            product: "/product.php",
            raw: "/raw.php",
            store_info: "/shop.php",
            user_login: "/login/login.php",
            mobile_site: "https://m.pricespy.co.nz"
        }
    },
    socialNetworks: {
        instagram: {
            link: "https://www.instagram.com/pricespy.co.nz/"
        },
        facebook: {
            link: "https://www.facebook.com/PriceSpyNZ"
        },
        twitter: {
            link: "https://twitter.com/PriceSpyNZ"
        }
    },
    email: {
        noreply: "noreply@pricespy.co.nz",
        security: "security@pricespy.co.nz"
    },
    cdn: {
        base: "https://pricespy-75b8.kxcdn.com",
        images: "https://pricespy-75b8.kxcdn.com/",
        offerImages: "https://www.prisjakt.nu/offers-images"
    },
    routes: {
        themes: {
            path: "/theme"
        },
        campaign: {
            path: "/theme/:name"
        },
        brand: {
            path: "/brand.php"
        },
        category: {
            path: "/category.php"
        },
        product: {
            path: "/product.php"
        },
        store: {
            path: "/shop.php"
        },
        promotions: {
            path: "/promotions"
        },
        promotionProducts: {
            path: "/promotions/:id"
        },
        usedProducts: {
            path: "/used"
        }
    },
    popularCampaignFilterPaths: [
        {
            title: "Best smartphones",
            path: "?sort=product.user_reviews.rating%7Cdesc&category=103"
        },
        {
            title: "Great deals on headphones",
            path: "?sort=rank%7Cdesc&category=148"
        },
        {
            title: "Best deals kitchen and whiteware",
            path: "?sort=rank%7Cdesc&category=1671%7C504"
        },
        {
            title: "Best deals under $100",
            path: "?price=1-100"
        }
    ],
    infoPages: [
        9,
        5,
        15,
        10,
        12,
        4,
        6,
        14,
        7,
        8
    ],
    infoPageMap: {
        userAgreement: 4,
        priceInformation: 5,
        privacyPolicy: 6,
        cookiePolicy: 7,
        contact: 8,
        about: 9,
        registerShop: 10,
        media: 12,
        disclaimer: 14,
        aboutReviews: 15,
        adlink: "adlink",
        themes: "themes",
        articles: "articles",
        categoryIndex: "categoryIndex",
        newsroom: "newsroom",
        bestDeals: "/theme/daily-deals"
    },
    infoPageRegisterShopLink: "https://pricespy.co.nz/info/register-and-feature-your-shop--i10",
    newsletter: {
        apiUrl: "https://api.getanewsletter.com/v3/",
        apiKey: "8KV6mYjfJmudQnsQGIm1ba/oRw/hcDhaDiuvgz2yT8f8NfKzl017dhGEpHPOAxQVLiUq4ZibYSS9c6aQuWqaKjByShyixwZjSZgh1cJlSzvDdDx7G1L4+uo5UTV6TFV0xqRIUW4PmgCdXk16Cnzds6a4aImDyrsRO/8eszpZG2g8D5bNcy+t2xBU+eh1LFUZ96CJrs4DzWOMfIOrWs/F61fZJHU5GGNG6QVjiZ4STok+mUD+NEezTNHDVIySuT4",
        list: "B7L94dEdgU9jQ",
        gansubFormId: "O5VZ"
    },
    apps: {
        ios: "369151774",
        android: "se.prisjakt.pricespy"
    },
    ads: _objectSpread({
        active: true
    }, ads_1.adsConfig.nz),
    paymentProviders: {
        priorities: [
            "SWISH",
            "VIPPS",
            "PAYPAL",
            "KLARNA",
            "SVEA_WEB_PAY",
            "VISA",
            "MASTER_CARD",
            "AMEX",
            "DINERS"
        ],
        groupPriorities: [
            types_1.PaymentProviderGroup.Direct,
            types_1.PaymentProviderGroup.Invoice,
            types_1.PaymentProviderGroup.Card
        ]
    },
    privacySettings: {
        responsive: {
            cookieVersion: "4",
            cookieUrl: "/info/cookies--i7",
            cookieArticleId: "7",
            privacyUrl: "/info/privacy-policy--i6",
            privacyArticleId: "6",
            privacySettingsUrl: "/privacy-settings"
        },
        native: {
            cookieVersion: "hidden"
        }
    },
    modules: {
        categoryInfo: {
            enabled: false
        },
        userReviewPurchaseDate: {
            enabled: false
        },
        readableProductInfo: {
            enabled: true
        }
    },
    showClassicSwitch: true,
    trackingToggles: [
        {
            name: types_1.PrivacySettingToggle.BehaviourTrackingImprovement,
            default: false
        },
        {
            name: types_1.PrivacySettingToggle.BehaviorTrackingMarketing,
            default: false
        },
        {
            name: types_1.PrivacySettingToggle.BehaviorTrackingSurveys,
            default: false
        },
        {
            name: types_1.PrivacySettingToggle.PersonalizedAds,
            default: false
        },
        {
            name: types_1.PrivacySettingToggle.Personalization,
            default: false
        }
    ],
    shopOfTheYear: true,
    cdnCache: {
        enabled: true,
        mode: "external"
    },
    articles: {
        priceHistoryInfo: {
            path: "/price-history--ecYSSqGxIAACIAXh9N"
        },
        newsletterArticlesSidebar: {
            path: "/newsletter--ecZXbnPhcAACUAd5xi"
        }
    },
    experts: {
        enabled: false
    },
    keywordLandingPagesEnabled: true,
    featuredCollectionsEnabled: false,
    login: {
        enabled: false
    }
}; //# sourceMappingURL=nz.js.map


/***/ }),

/***/ 76873:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.se = void 0;
var ads_1 = __webpack_require__(7089);
var types_1 = __webpack_require__(83109);
exports.se = {
    countryCode: "se",
    active: true,
    permanentRedirect: true,
    sitename: "Prisjakt",
    redirectHosts: [
        "m.prisjakt.nu",
        "prisjakt.nu",
        "beta.prisjakt.nu"
    ],
    superSearchEndpoint: "https://search.cloud.pji.nu/rfe",
    trackerProxy: "rfe-tracker-2069617015.eu-west-1.elb.amazonaws.com",
    useClassicUrls: true,
    classicProxy: {
        host: "int-classic-se.prisjakt.io",
        port: 8080
    },
    hrefLang: [
        "sv"
    ],
    locale: "sv-se",
    localeStandard: "sv-SE",
    sites: {
        production: "https://www.prisjakt.nu",
        classic: "https://classic.prisjakt.nu",
        analytics: "https://classic.prisjakt.nu/analytics/store",
        brands: "https://research.prisjakt.nu",
        forum: "https://www.minhembio.com/forum",
        mobile: "https://m.prisjakt.nu",
        staging: "https://next-se.cloud.pji.nu"
    },
    campaigns: {
        previousCampaignDates: {
            "2": "2019-11-29",
            "6": "2019-12-02",
            "3": "2019-12-25",
            "16": "2020-11-11"
        }
    },
    googleTagManager: "GTM-KD9S55X",
    translation: "sv",
    timezone: "Europe/Stockholm",
    currencyCode: "SEK",
    url: {
        campaigns: "/tema",
        legacy: {
            brand: "/tillverkare.php",
            category: "/kategori.php",
            fight: "/fight.php",
            forum: "https://www.minhembio.com/forum",
            info: "/info.php",
            lists: "/list.php",
            minhembio: "https://www.minhembio.com",
            plugin: "/plugins/",
            product: "/produkt.php",
            raw: "/expert.php",
            store_info: "/butiksinfo.php",
            user_login: "/login/login.php",
            mobile_site: "https://m.prisjakt.nu"
        }
    },
    socialNetworks: {
        instagram: {
            link: "https://www.instagram.com/prisjakt/"
        },
        facebook: {
            link: "https://www.facebook.com/Prisjakt"
        },
        twitter: {
            link: "https://twitter.com/Prisjaktnu"
        }
    },
    email: {
        noreply: "noreply@prisjakt.nu",
        security: "security@prisjakt.nu"
    },
    cdn: {
        base: "https://pricespy-75b8.kxcdn.com",
        images: "https://pricespy-75b8.kxcdn.com/",
        offerImages: "https://www.prisjakt.nu/offers-images"
    },
    routes: {
        themes: {
            path: "/tema"
        },
        campaign: {
            path: "/tema/:name"
        },
        productAlert: {
            path: "*--p:id/bevaka",
            relativePath: "/bevaka"
        },
        productCompare: {
            path: "/jamfor/produkter/:productIds?"
        },
        shopOfTheYear: {
            path: "/arets-butik"
        },
        shopOfTheYearWinners: {
            path: "/arets-butik/:section"
        },
        editorialContentListing: {
            path: "/artiklar"
        },
        categoryIndex: {
            path: "/kategorier"
        },
        expertProductTest: {
            path: "/tester/:slug?",
            relativePath: "/tester"
        },
        expertToplists: {
            path: "/topplistor/:slug?",
            relativePath: "/topplistor"
        },
        expertGuide: {
            path: "/guider/:slug?",
            relativePath: "/guider"
        },
        expertLandingPage: {
            path: "/experter"
        },
        expertProfile: {
            path: "/experter/profil/:slug?",
            relativePath: "/experter/profil"
        },
        expertCategory: {
            path: "/experter/:slug",
            relativePath: "/experter"
        },
        changelog: {
            path: "/changelog"
        },
        changelogLatest: {
            path: "/sok-med-filter-bekann-farg-och-las-vad-hela-varlden-tycker--clY9k8KxAAACUARLc3"
        },
        brand: {
            path: "/tillverkare.php"
        },
        category: {
            path: "/kategori.php"
        },
        product: {
            path: "/produkt.php"
        },
        store: {
            path: "/butiksinfo.php"
        },
        promotions: {
            path: "/kampanjer"
        },
        promotionProducts: {
            path: "/kampanjer/:id"
        },
        usedProducts: {
            path: "/begagnat"
        }
    },
    popularCampaignFilterPaths: [
        {
            title: "Deals under 500 kr",
            path: "?price=19-500&sort=rank%7Cdesc"
        },
        {
            title: "Arbeta hemifr\xe5n",
            path: "?category=555%7C1594%7C148"
        },
        {
            title: "Deals 500 - 1000 kr",
            path: "?sort=product.popularity.total&price=500-1000"
        },
        {
            title: "Popul\xe4ra h\xf6rlurar",
            path: "?category=148&sort=product.popularity.total"
        },
        {
            title: "Vitvaror",
            path: "?category=504"
        },
        {
            title: "Till barnen",
            path: "?category=1815%7C1553"
        }
    ],
    infoPages: [
        9,
        5,
        15,
        10,
        12,
        4,
        6,
        7,
        14,
        8
    ],
    infoPageMap: {
        userAgreement: 4,
        priceInformation: 5,
        privacyPolicy: 6,
        cookiePolicy: 7,
        contact: 8,
        about: 9,
        registerShop: 10,
        media: 12,
        disclaimer: 14,
        aboutReviews: 15,
        adlink: "adlink",
        themes: "themes",
        careers: "careers",
        articles: "articles",
        shopOfTheYear: "shopOfTheYear",
        categoryIndex: "categoryIndex",
        used: "used",
        promotions: "promotions",
        expertLogin: "expertLogin",
        experts: "experts",
        supportPage: "supportPage",
        newsroom: "newsroom",
        januarySales: "/tema/januarirea"
    },
    infoPageRegisterShopLink: "https://landing.prisjakt.nu/visible-at-prisjakt-se",
    newsletter: {
        apiUrl: "https://api.getanewsletter.com/v3/",
        apiKey: "8KV6mYjfJmudQnsQGIm1ba/oRw/hcDhaDiuvgz2yT8f8NfKzl017dhGEpHPOAxQVLiUq4ZibYSS9c6aQuWqaKjByShyixwZjSZgh1cJlSzvDdDx7G1L4+uo5UTV6TFV0xqRIUW4PmgCdXk16Cnzds6a4aImDyrsRO/8eszpZG2g8D5bNcy+t2xBU+eh1LFUZ96CJrs4DzWOMfIOrWs/F61fZJHU5GGNG6QVjiZ4STok+mUD+NEezTNHDVIySuT4",
        list: "B36O",
        gansubFormId: "9wO6UTbrO"
    },
    apps: {
        ios: "369151774",
        android: "se.prisjakt.pricespy"
    },
    ads: _objectSpreadProps(_objectSpread({}, ads_1.adsConfig.se), {
        active: true
    }),
    paymentProviders: {
        priorities: [
            "KLARNA",
            "SVEA_WEB_PAY",
            "SWISH",
            "PAYPAL",
            "VIPPS",
            "AMEX",
            "VISA",
            "MASTER_CARD",
            "DINERS"
        ],
        groupPriorities: [
            types_1.PaymentProviderGroup.Invoice,
            types_1.PaymentProviderGroup.Direct,
            types_1.PaymentProviderGroup.Card
        ]
    },
    privacySettings: {
        responsive: {
            cookieVersion: "4",
            cookieUrl: "/info/cookiepolicy--ipYmj0eBAAACIA1fgC",
            cookieArticleId: "Ymj0eBAAACIA1fgC",
            privacyUrl: "/info/personuppgiftspolicy--i6",
            privacyArticleId: "6",
            privacySettingsUrl: "/privacy-settings"
        },
        native: {
            cookieVersion: "hidden"
        }
    },
    modules: {
        categoryInfo: {
            enabled: false
        },
        userReviewPurchaseDate: {
            enabled: false
        },
        readableProductInfo: {
            enabled: true
        }
    },
    showSchibstedCoBranding: true,
    showClassicSwitch: true,
    showBrandingTagline: true,
    trackingToggles: [
        {
            name: types_1.PrivacySettingToggle.BehaviourTrackingImprovement,
            default: false
        },
        {
            name: types_1.PrivacySettingToggle.BehaviorTrackingMarketing,
            default: false
        },
        {
            name: types_1.PrivacySettingToggle.BehaviorTrackingSurveys,
            default: false
        },
        {
            name: types_1.PrivacySettingToggle.PersonalizedAds,
            default: false
        },
        {
            name: types_1.PrivacySettingToggle.Personalization,
            default: false
        }
    ],
    shopOfTheYear: true,
    structuredData: {
        "@context": "http://schema.org",
        "@type": "Organization",
        legalName: "Prisjakt Sverige AB",
        areaServed: "SE",
        url: "https://www.prisjakt.nu",
        address: {
            "@type": "PostalAddress",
            streetAddress: "Storgatan 47 A",
            addressLocality: "\xc4ngelholm",
            postalCode: "262 32",
            addressCountry: "Sweden"
        },
        logo: "https://pricespy-75b8.kxcdn.com/g/rfe/logos/logo_se.svg",
        sameAs: [
            "https://www.facebook.com/Prisjakt",
            "https://twitter.com/prisjaktnu"
        ]
    },
    cdnCache: {
        enabled: true,
        mode: "external"
    },
    articles: {
        aboutExperts: {
            path: "/info/transparenslofte-prisjakt-experter--ecYmerohAAACMA0AaC"
        },
        recruiting: {
            path: "/vi-soker-nya-experter--ecYS9l2BMAACEAw3yp"
        },
        priceHistoryInfo: {
            path: "/prishistoriken--ecYMguqxEAACQA86mw"
        },
        newsletterArticlesSidebar: {
            path: "/nyhetsbrev--ecZXBQqxcAACQAWgbX"
        }
    },
    experts: {
        enabled: true
    },
    keywordLandingPagesEnabled: true,
    featuredCollectionsEnabled: true,
    productOfTheYear: {
        years: [
            {
                year: 2023,
                releaseDate: "2023-03-09T00:00:00.000Z"
            }
        ]
    },
    login: {
        enabled: true
    }
}; //# sourceMappingURL=se.js.map


/***/ }),

/***/ 83109:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.PaymentProviderGroup = exports.FilterType = exports.PrivacySettingToggle = exports.MARKET_CODES = exports.LANGUAGE_CODES = void 0;
exports.LANGUAGE_CODES = [
    "da",
    "fi",
    "fr",
    "en_GB",
    "nb_NO",
    "en_NZ",
    "sv"
];
exports.MARKET_CODES = [
    "te",
    "se",
    "gb",
    "fi",
    "fr",
    "no",
    "nz",
    "dk"
];
var PrivacySettingToggle;
(function(PrivacySettingToggle) {
    PrivacySettingToggle["BehaviourTrackingImprovement"] = "behavior_tracking_improvement";
    PrivacySettingToggle["BehaviorTrackingMarketing"] = "behavior_tracking_marketing";
    PrivacySettingToggle["BehaviorTrackingSurveys"] = "behavior_tracking_surveys";
    PrivacySettingToggle["PersonalizedAds"] = "personalized_ads";
    PrivacySettingToggle["Personalization"] = "personalization";
})(PrivacySettingToggle || (exports.PrivacySettingToggle = PrivacySettingToggle = {}));
var FilterType;
(function(FilterType) {
    FilterType["PRICES_INC_SHIPPING"] = "prices_inc_shipping";
    FilterType["IN_STOCK"] = "in_stock";
    FilterType["AUTHORIZED_DEALER"] = "authorized_dealer";
    FilterType["PICKUP_ONLY"] = "pickup_only";
    FilterType["INTERNATIONAL"] = "international";
    FilterType["NOT_FOR_SALE"] = "not_for_sale";
    FilterType["VARIANT_SIZE"] = "variant_size";
    FilterType["VARIANT_COLOR"] = "variant_color";
    FilterType["CONDITION"] = "condition";
    FilterType["DELIVERY_METHOD"] = "shipping-delivery-method";
    FilterType["CARRIERS"] = "shipping-carriers";
})(FilterType || (exports.FilterType = FilterType = {}));
var PaymentProviderGroup;
(function(PaymentProviderGroup) {
    PaymentProviderGroup[PaymentProviderGroup["Direct"] = 0] = "Direct";
    PaymentProviderGroup[PaymentProviderGroup["Invoice"] = 1] = "Invoice";
    PaymentProviderGroup[PaymentProviderGroup["Card"] = 2] = "Card";
})(PaymentProviderGroup || (exports.PaymentProviderGroup = PaymentProviderGroup = {})); //# sourceMappingURL=types.js.map


/***/ }),

/***/ 16472:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = {
            enumerable: true,
            get: function get() {
                return m[k];
            }
        };
    }
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) __createBinding(exports1, m, p);
};
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getPreviousUrlFromResponse = exports.getNextUrlFromResponse = exports.getCanonicalUrlFromResponse = exports.getUrlFromResponse = exports.extractFiltersFromUrl = exports.addFilterToUrlBuilder = exports.addFilterToUrl = exports.getStringQuery = exports.getSortedQuery = exports.filtersToQueryObject = exports.filterToQueryParams = void 0;
var query_string_for_all_1 = __importDefault(__webpack_require__(25932));
__exportStar(__webpack_require__(46346), exports);
var EXCLUDED_PARAMS = [
    "offset",
    "sort",
    "direction",
    "size",
    "q",
    "utm_source",
    "utm_content",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "ad"
];
var PREFIXES = {
    rangeGroup: "rg_",
    range: "r_",
    boolean: "b_",
    query: "q_"
};
function unsupportedFilterType(_filter, returnValue) {
    return returnValue;
}
var filterToQueryParams = function(filter) {
    switch(filter.type){
        case "term":
            {
                return _defineProperty({}, filter.property, filter.id);
            }
        case "terms":
            {
                return _defineProperty({}, filter.property, filter.ids.join("|"));
            }
        case "range":
            {
                return _defineProperty({}, "".concat(PREFIXES.range).concat(filter.property), "".concat(filter.from, "-").concat(filter.to));
            }
        case "range-group":
            {
                return _defineProperty({}, "".concat(PREFIXES.rangeGroup).concat(filter.property), Array.isArray(filter.key) ? filter.key.join("|") : filter.key);
            }
        case "boolean":
            {
                var trueValues = [
                    "1",
                    "true",
                    "yes",
                    1,
                    true
                ];
                var value = trueValues.includes(filter.id) ? "1" : "0";
                return _defineProperty({}, "".concat(PREFIXES.boolean).concat(filter.property), value);
            }
        case "name-search":
            {
                return _defineProperty({}, "".concat(PREFIXES.query, "name"), encodeURI(filter.query));
            }
        default:
            return unsupportedFilterType(filter, {});
    }
};
exports.filterToQueryParams = filterToQueryParams;
var filtersToQueryObject = function(filters) {
    return Array.isArray(filters) && filters.length > 0 ? filters.reduce(function(result, filter) {
        return _objectSpread({}, result, (0, exports.filterToQueryParams)(filter));
    }, {}) : {};
};
exports.filtersToQueryObject = filtersToQueryObject;
var getSortedQuery = function(query) {
    return Object.keys(query).sort().reduce(function(result, key) {
        return _objectSpreadProps(_objectSpread({}, result), _defineProperty({}, key, query[key]));
    }, {});
};
exports.getSortedQuery = getSortedQuery;
var getStringQuery = function(query) {
    return query_string_for_all_1.default.stringify((0, exports.getSortedQuery)(query));
};
exports.getStringQuery = getStringQuery;
var addFilterToUrl = function(baseUrl, filter) {
    var ref = _slicedToArray(baseUrl.split("?", 2), 2), baseUrlPathName = ref[0], baseUrlQueryString = ref[1];
    var baseUrlQuery = query_string_for_all_1.default.parse(baseUrlQueryString || "");
    var newQuery = _objectSpread({}, baseUrlQuery, (0, exports.filterToQueryParams)(filter));
    if (Object.keys(newQuery).length === 0) {
        return baseUrlPathName;
    }
    return "".concat(baseUrlPathName, "?").concat((0, exports.getStringQuery)(newQuery));
};
exports.addFilterToUrl = addFilterToUrl;
var addFilterToUrlBuilder = function(urlBuilder, filter) {
    var filterQueryParams = (0, exports.filterToQueryParams)(filter);
    Object.entries(filterQueryParams).forEach(function(param) {
        var _param = _slicedToArray(param, 2), key = _param[0], value = _param[1];
        return urlBuilder.searchParams.set(key, value);
    });
    urlBuilder.searchParams.sort();
};
exports.addFilterToUrlBuilder = addFilterToUrlBuilder;
var extractFiltersFromUrl = function(input) {
    var searchParams = new URL(input, "http://dummy").searchParams;
    var params = _toConsumableArray(searchParams.keys()).filter(function(key) {
        return !EXCLUDED_PARAMS.includes(key);
    });
    return params.map(function(param) {
        var paramValue = searchParams.get(param);
        if (paramValue === null) {
            return null;
        }
        if (param === "".concat(PREFIXES.query, "name")) {
            return {
                type: "name-search",
                query: decodeURI(paramValue)
            };
        }
        if (param.startsWith(PREFIXES.rangeGroup)) {
            // Values can be divided by | which indicates an OR operator
            var values = paramValue.split("|");
            return {
                type: "range-group",
                property: param.substr(PREFIXES.rangeGroup.length),
                key: values
            };
        }
        if (param.startsWith(PREFIXES.range)) {
            var match = paramValue.match(/^(-?\d+\.?\d*)-(-?\d+\.?\d*)$/);
            var from = match && match[1] ? Number.parseFloat(match[1]) : NaN;
            var to = match && match[2] ? Number.parseFloat(match[2]) : NaN;
            return {
                type: "range",
                property: param.substr(PREFIXES.range.length),
                from: !Number.isNaN(from) ? from : null,
                to: !Number.isNaN(to) ? to : null
            };
        }
        if (param.startsWith(PREFIXES.boolean)) {
            return {
                type: "boolean",
                property: param.substr(PREFIXES.boolean.length),
                id: String([
                    "1",
                    "true",
                    "yes"
                ].includes(paramValue))
            };
        }
        // Values can be divided by | or , which indicates OR AND operators
        var delimiter = paramValue.includes(",") ? "," : "|";
        var operator = delimiter === "," ? "AND" : "OR";
        var values1 = paramValue.split(delimiter);
        return values1.length === 1 ? {
            type: "term",
            property: param,
            id: values1[0]
        } : {
            type: "terms",
            property: param,
            ids: values1,
            operator: operator
        };
    }).filter(Boolean);
};
exports.extractFiltersFromUrl = extractFiltersFromUrl;
var getResultsSlice = function(data) {
    return data.slices.find(function(slice) {
        return slice.type === "products" || slice.type === "offers";
    });
};
var addOffsetToUrlBuilder = function(urlBuilder, data) {
    var resultsSlice = getResultsSlice(data);
    if (resultsSlice && resultsSlice.offset > 0) {
        urlBuilder.searchParams.set("offset", "".concat(resultsSlice.offset));
        urlBuilder.searchParams.sort();
    }
    return urlBuilder;
};
var getUrlFromResponse = function(data, baseUrl) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        includeOffset: true
    };
    var urlBuilder = new URL(data.baseUrl, baseUrl);
    data.filters.forEach(function(filter) {
        return (0, exports.addFilterToUrlBuilder)(urlBuilder, filter);
    });
    if (options.includeOffset) {
        addOffsetToUrlBuilder(urlBuilder, data);
    }
    return urlBuilder;
};
exports.getUrlFromResponse = getUrlFromResponse;
var getCanonicalUrlFromResponse = function(data, baseUrl) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        includeOffset: true
    };
    var urlBuilder = new URL(data.baseUrl, baseUrl);
    data.navigationState.previous.forEach(function(param) {
        var filters = param.filters;
        return filters.forEach(function(f) {
            return (0, exports.addFilterToUrlBuilder)(urlBuilder, f);
        });
    });
    if (options.includeOffset) {
        addOffsetToUrlBuilder(urlBuilder, data);
    }
    return urlBuilder;
};
exports.getCanonicalUrlFromResponse = getCanonicalUrlFromResponse;
var getNextUrlFromResponse = function(data, baseUrl) {
    var resultsSlice = getResultsSlice(data);
    if (!resultsSlice || resultsSlice.pagination.currentPage >= resultsSlice.pagination.pages) {
        return null;
    }
    var pagination = resultsSlice.pagination, size = resultsSlice.size;
    var urlBuilder = (0, exports.getCanonicalUrlFromResponse)(data, baseUrl, {
        includeOffset: false
    });
    urlBuilder.searchParams.set("offset", "".concat(pagination.currentPage * size));
    urlBuilder.searchParams.sort();
    return urlBuilder;
};
exports.getNextUrlFromResponse = getNextUrlFromResponse;
var getPreviousUrlFromResponse = function(data, baseUrl) {
    var resultsSlice = getResultsSlice(data);
    if (!resultsSlice || resultsSlice.pagination.currentPage === 1) {
        return null;
    }
    var offset = resultsSlice.offset, size = resultsSlice.size;
    var urlBuilder = (0, exports.getCanonicalUrlFromResponse)(data, baseUrl, {
        includeOffset: false
    });
    var newOffset = offset - size;
    if (newOffset > 0) {
        urlBuilder.searchParams.set("offset", "".concat(newOffset));
        urlBuilder.searchParams.sort();
    }
    return urlBuilder;
};
exports.getPreviousUrlFromResponse = getPreviousUrlFromResponse; //# sourceMappingURL=index.js.map


/***/ }),

/***/ 46346:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
})); //# sourceMappingURL=types.js.map


/***/ }),

/***/ 78764:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _construct(Parent, args, Class) {
    if (isNativeReflectConstruct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") {
            throw new TypeError("Super expression must either be null or a function");
        }
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var __generator = this && this.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var ce = Object.create;
var L = Object.defineProperty;
var ae = Object.getOwnPropertyDescriptor;
var he = Object.getOwnPropertyNames;
var de = Object.getPrototypeOf, le = Object.prototype.hasOwnProperty;
var ue = function(s, e) {
    return function() {
        return e || s((e = {
            exports: {}
        }).exports, e), e.exports;
    };
}, pe = function(s, e) {
    for(var t in e)L(s, t, {
        get: e[t],
        enumerable: !0
    });
}, X = function(s, e, t, i) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (e && typeof e == "object" || typeof e == "function") try {
        var _loop = function() {
            var r = _step.value;
            !le.call(s, r) && r !== t && L(s, r, {
                get: function() {
                    return e[r];
                },
                enumerable: !(i = ae(e, r)) || i.enumerable
            });
        };
        for(var _iterator = he(e)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return s;
};
var K = function(s, e, t) {
    return t = s != null ? ce(de(s)) : {}, X(e || !s || !s.__esModule ? L(t, "default", {
        value: s,
        enumerable: !0
    }) : t, s);
}, fe = function(s) {
    return X(L({}, "__esModule", {
        value: !0
    }), s);
};
var J = ue(function(Le, B) {
    var q = function q() {};
    q.prototype = {
        on: function on(s, e, t) {
            var i = this.e || (this.e = {});
            return (i[s] || (i[s] = [])).push({
                fn: e,
                ctx: t
            }), this;
        },
        once: function once(s, e, t) {
            var i = this;
            function r() {
                i.off(s, r), e.apply(t, arguments);
            }
            return r._ = e, this.on(s, r, t);
        },
        emit: function emit(s) {
            var e = [].slice.call(arguments, 1), t = ((this.e || (this.e = {}))[s] || []).slice(), i = 0, r = t.length;
            for(i; i < r; i++)t[i].fn.apply(t[i].ctx, e);
            return this;
        },
        off: function off(s, e) {
            var t = this.e || (this.e = {}), i = t[s], r = [];
            if (i && e) for(var o = 0, c = i.length; o < c; o++)i[o].fn !== e && i[o].fn._ !== e && r.push(i[o]);
            return r.length ? t[s] = r : delete t[s], this;
        }
    };
    B.exports = q;
    B.exports.TinyEmitter = q;
});
var Oe = {};
pe(Oe, {
    AccountContext: function() {
        return j;
    },
    AccountProvider: function() {
        return re;
    },
    Identity: function() {
        return I;
    },
    Monetization: function() {
        return T;
    },
    Payment: function() {
        return F;
    },
    useAccount: function() {
        return ne;
    }
});
module.exports = fe(Oe);
var me = [
    "boolean",
    "number",
    "string"
], h = /*#__PURE__*/ function(Error1) {
    _inherits(h, Error1);
    var _super = _createSuper(h);
    function h(e, t) {
        _classCallCheck(this, h);
        var _this;
        if (_this = _super.call(this, e), _this.name = "SDKError", typeof t == "object") try {
            Object.assign(_assertThisInitialized(_this), t);
        } catch (e1) {}
        return _possibleConstructorReturn(_this);
    }
    _createClass(h, [
        {
            key: "toString",
            value: function toString() {
                var _this = this;
                var e = "".concat(this.name, ": ").concat(this.message), t = Object.keys(this).filter(function(i) {
                    return i !== "name" && me.includes(_typeof(_this[i]));
                }).map(function(i) {
                    return "    ".concat(i, ": ").concat(_this[i]);
                }).join("\n");
                return t ? "".concat(e, "\n").concat(t) : e;
            }
        }
    ]);
    return h;
}(_wrapNativeSuper(Error));
function n(s) {
    var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "Assertion failed";
    if (!s) throw new h(e);
}
function m(s) {
    return typeof s == "string";
}
function f(s) {
    return typeof s == "string" && s.length > 0;
}
function S(s) {
    return typeof s == "object" && s !== null;
}
function M(s) {
    return S(s) && Object.keys(s).length > 0;
}
function u(s) {
    for(var _len = arguments.length, e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        e[_key - 1] = arguments[_key];
    }
    try {
        var t = new URL(s);
        return e.every(function(i) {
            return t[i];
        });
    } catch (e1) {
        return !1;
    }
}
function U(s) {
    return typeof s == "function";
}
function W(s, e) {
    var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
    var i = function(r) {
        return m(r) && s.toUpperCase() === r.toUpperCase();
    };
    return m(s) && Array.isArray(e) ? t ? e.indexOf(s) !== -1 : e.some(i) : !1;
}
function O() {
    for(var _len = arguments.length, s = new Array(_len), _key = 0; _key < _len; _key++){
        s[_key] = arguments[_key];
    }
    var e = {};
    if (!(s && s.length)) throw new h("No objects to clone");
    return s.forEach(function(t) {
        n(S(t)), M(t) && Object.entries(t).forEach(function(param) {
            var _param = _slicedToArray(param, 2), i = _param[0], r = _param[1];
            r !== void 0 && (e[i] = S(r) ? V(r) : r);
        });
    }), e;
}
function V(s) {
    return n(typeof s == "object", "obj should be an object (even null) but it is ".concat(s)), JSON.parse(JSON.stringify(s)) || s;
}
function _(s, e) {
    return n(f(s), '"url" param must be a non empty string: '.concat(typeof s === "undefined" ? "undefined" : _typeof(s))), M(e) && u(e[s]) ? e[s] : (n(u(s, "hostname"), "Bad URL given: '".concat(s, "'")), s);
}
var Z = {
    ENDPOINTS: {
        SPiD: {
            LOCAL: "http://id.localhost",
            DEV: "https://identity-dev.schibsted.com",
            PRE: "https://identity-pre.schibsted.com",
            PRO: "https://login.schibsted.com",
            PRO_NO: "https://payment.schibsted.no",
            PRO_FI: "https://login.schibsted.fi",
            PRO_DK: "https://login.schibsted.dk"
        },
        BFF: {
            LOCAL: "http://id.localhost/authn/",
            DEV: "https://identity-dev.schibsted.com/authn/",
            PRE: "https://identity-pre.schibsted.com/authn/",
            PRO: "https://login.schibsted.com/authn/",
            PRO_NO: "https://payment.schibsted.no/authn/",
            PRO_FI: "https://login.schibsted.fi/authn/",
            PRO_DK: "https://login.schibsted.dk/authn/"
        },
        SESSION_SERVICE: {
            LOCAL: "http://session-service.id.localhost",
            DEV: "https://session-service.identity-dev.schibsted.com",
            PRE: "https://session-service.identity-pre.schibsted.com",
            PRO: "https://session-service.login.schibsted.com",
            PRO_NO: "https://session-service.payment.schibsted.no",
            PRO_FI: "https://session-service.login.schibsted.fi",
            PRO_DK: "https://session-service.login.schibsted.dk"
        }
    },
    NAMESPACE: {
        LOCAL: "id.localhost",
        DEV: "schibsted.com",
        PRE: "schibsted.com",
        PRO: "schibsted.com",
        PRO_NO: "spid.no",
        PRO_FI: "schibsted.fi",
        PRO_DK: "schibsted.dk"
    }
};
var b = Z.ENDPOINTS, A = Z.NAMESPACE;
var ie = K(J(), 1);
function ge(s) {
    if (!s) return !1;
    try {
        var e = s(), t = "x-x-x-x".replace(/x/g, function() {
            return Math.random();
        }), i = "TEST-VALUE";
        e.setItem(t, i);
        var r = e.getItem(t);
        return e.removeItem(t), r === i;
    } catch (e1) {
        return !1;
    }
}
var z = function z(e) {
    var _this = this;
    _classCallCheck(this, z);
    this.store = e, this.get = function(t) {
        return _this.store.getItem(t);
    }, this.set = function(t, i) {
        return _this.store.setItem(t, i);
    }, this.delete = function(t) {
        return _this.store.removeItem(t);
    };
}, G = function G() {
    var _this = this;
    _classCallCheck(this, G);
    this.store = {}, this.get = function(e) {
        return _this.store[e];
    }, this.set = function(e, t) {
        return _this.store[e] = t;
    }, this.delete = function(e) {
        return delete _this.store[e];
    };
}, Se = Math.pow(2, 31) - 1, P = /*#__PURE__*/ function() {
    function P(e) {
        _classCallCheck(this, P);
        ge(e) ? (this.cache = new z(e()), this.type = "WebStorage") : (this.cache = new G, this.type = "ObjectLiteralStorage");
    }
    _createClass(P, [
        {
            key: "get",
            value: function get(e) {
                var t = function t(i) {
                    try {
                        return JSON.parse(i);
                    } catch (e) {
                        return null;
                    }
                };
                try {
                    var _$i = this.cache.get(e), r = t(_$i);
                    return r && Number.isInteger(r.expiresOn) && r.expiresOn > Date.now() ? r.value : (this.delete(e), null);
                } catch (i) {
                    throw new h(i);
                }
            }
        },
        {
            key: "set",
            value: function set(e, t) {
                var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                var _this = this;
                if (!(i <= 0)) {
                    i = Math.min(Se, i);
                    try {
                        var _$r = Math.floor(Date.now() + i);
                        this.cache.set(e, JSON.stringify({
                            expiresOn: _$r,
                            value: t
                        })), setTimeout(function() {
                            return _this.delete(e);
                        }, i);
                    } catch (r) {
                        throw new h(r);
                    }
                }
            }
        },
        {
            key: "delete",
            value: function _delete(e) {
                try {
                    this.cache.delete(e);
                } catch (t) {
                    throw new h(t);
                }
            }
        }
    ]);
    return P;
}();
function we(s) {
    return n(S(s), "Object must be an object but it is '".concat(s, "'")), Object.keys(s).map(function(e) {
        return "".concat(e, "=").concat(s[e]);
    }).join(",");
}
var _e = {
    scrollbars: "yes",
    location: "yes",
    status: "no",
    menubar: "no",
    toolbar: "no",
    resizable: "yes"
};
function H(s, e) {
    var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    n(S(s), "window was supposed to be an object but it is ".concat(s)), n(S(s.screen), "window should be a valid Window object but it lacks a 'screen' property"), n(U(s.open), "window should be a valid Window object but it lacks an 'open' function"), n(u(e), "Invalid URL for popup");
    var _screen = s.screen, r = _screen.height, o = _screen.width, c = O(_e, i);
    Number.isFinite(c.width) && Number.isFinite(o) && (c.left = (o - c.width) / 2), Number.isFinite(c.height) && Number.isFinite(r) && (c.top = (r - c.height) / 2);
    var d = we(c);
    return s.open(e, t, d);
}
var ye = function(s) {
    return s.map(function(e) {
        return S(e) ? JSON.stringify(e, null, 2) : e;
    }).join(" ");
}, $ = function(s) {
    for(var _len = arguments.length, e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        e[_key - 1] = arguments[_key];
    }
    return typeof s == "function" && s(ye(e));
};
function te(s) {
    var e = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(s).replace(/[!'()~]|%20|%00/g, function(t) {
        return e[t];
    });
}
var be = function() {
    return window.fetch && window.fetch.bind(window);
}, D = /*#__PURE__*/ function() {
    function D1(param) {
        var tmp = param.serverUrl, e = tmp === void 0 ? "PRE" : tmp, t = param.envDic, tmp1 = param.fetch, i = tmp1 === void 0 ? be() : tmp1, r = param.log, tmp2 = param.defaultParams, o = tmp2 === void 0 ? {} : tmp2;
        _classCallCheck(this, D1);
        n(S(o), "defaultParams should be a non-null object"), this.url = new URL(_(e, t)), this.defaultParams = o, r && (n(U(r), "log must be a function but it is ".concat(r)), this.log = r), i && (n(U(i), "Fetch should be a function"), this.fetch = i);
    }
    _createClass(D1, [
        {
            key: "go",
            value: function go(param) {
                var e = param.method, t = param.headers, i = param.pathname, tmp = param.data, r = tmp === void 0 ? {} : tmp, tmp1 = param.useDefaultParams, o = tmp1 === void 0 ? !0 : tmp1, tmp2 = param.fetchOptions, c = tmp2 === void 0 ? {
                    method: e,
                    credentials: "include"
                } : tmp2;
                var _this = this;
                return _asyncToGenerator(function() {
                    var d, _$a, l, a, l1;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                n(U(_this.fetch), "Can't make a call. The reference to fetch is missing or not a function."), n(f(e), 'Method must be a non empty string but it is "'.concat(e, '"')), n(f(i), 'Pathname must be string but it is "'.concat(i, '"')), n(S(r), "data must be a non-null object"), c.headers = S(t) ? O(t) : {};
                                d = _this.makeUrl(i, r, o);
                                $(_this.log, "Request:", c.method.toUpperCase(), d), $(_this.log, "Request Headers:", c.headers), $(_this.log, "Request Body:", c.body);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    _this.fetch(d, c)
                                ];
                            case 2:
                                _$a = _state.sent();
                                if ($(_this.log, "Response Code:", _$a.status, _$a.statusText), !_$a.ok) throw new h(_$a.statusText, {
                                    code: _$a.status
                                });
                                return [
                                    4,
                                    _$a.json()
                                ];
                            case 3:
                                l = _state.sent();
                                return [
                                    2,
                                    ($(_this.log, "Response Parsed:", l), l)
                                ];
                            case 4:
                                a = _state.sent();
                                l1 = m(a) ? a : "Unknown RESTClient error";
                                throw S(a) && m(a.message) && (l1 = a.message), new h("Failed to '".concat(e, "' '").concat(d, "': '").concat(l1, "'"), a);
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "makeUrl",
            value: function makeUrl() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
                var r = new URL(e, this.url);
                return r.search = D.search(t, i, this.defaultParams), r.href;
            }
        },
        {
            key: "get",
            value: function get(e, t) {
                return this.go({
                    method: "get",
                    pathname: e,
                    data: t
                });
            }
        }
    ], [
        {
            key: "search",
            value: function search(e, t, i) {
                var r = t ? O(i, e) : O(e);
                return Object.keys(r).filter(function(o) {
                    return r[o] !== "";
                }).map(function(o) {
                    return "".concat(te(o), "=").concat(te(r[o]));
                }).join("&");
            }
        }
    ]);
    return D1;
}(), y = D;
function C(s) {
    (s.SPiD === null || typeof s.SPiD != "object") && (s.SPiD = {}), (s.SPiD.Talk === null || typeof s.SPiD.Talk != "object") && (s.SPiD.Talk = {}), U(s.SPiD.Talk.response) || (s.SPiD.Talk.response = function(e, t) {
        return s[e](t);
    });
}
var Ue = "4.8.4", k = Ue;
var N = "hasSession-cache", ve = function() {
    return window;
}, I = /*#__PURE__*/ function(_default) {
    _inherits(I, _default);
    var _super = _createSuper(I);
    function I(param) {
        var e = param.clientId, t = param.redirectUri, i = param.sessionDomain, tmp = param.env, r = tmp === void 0 ? "PRE" : tmp, o = param.log, tmp1 = param.window, c = tmp1 === void 0 ? ve() : tmp1;
        _classCallCheck(this, I);
        var _this;
        _this = _super.call(this), n(f(e), "clientId parameter is required"), n(S(c), "The reference to window is missing"), n(!t || u(t), "redirectUri parameter is invalid"), n(i && u(i), "sessionDomain parameter is not a valid URL"), C(c), _this._sessionInitiatedSent = !1, _this.window = c, _this.clientId = e, _this.cache = new P(function() {
            return _this.window && _this.window.sessionStorage;
        }), _this.redirectUri = t, _this.env = r, _this.log = o, _this._sessionDomain = i, _this._enableSessionCaching = !0, _this._session = {}, _this._setSessionServiceUrl(i), _this._setSpidServerUrl(r), _this._setBffServerUrl(r), _this._setOauthServerUrl(r), _this._setGlobalSessionServiceUrl(r);
        return _possibleConstructorReturn(_this);
    }
    _createClass(I, [
        {
            key: "_setSpidServerUrl",
            value: function _setSpidServerUrl(e) {
                n(m(e), "url parameter is invalid: ".concat(e)), this._spid = new y({
                    serverUrl: _(e, b.SPiD),
                    log: this.log,
                    defaultParams: {
                        client_id: this.clientId,
                        redirect_uri: this.redirectUri
                    }
                });
            }
        },
        {
            key: "_setOauthServerUrl",
            value: function _setOauthServerUrl(e) {
                n(m(e), "url parameter is invalid: ".concat(e)), this._oauthService = new y({
                    serverUrl: _(e, b.SPiD),
                    log: this.log,
                    defaultParams: {
                        client_id: this.clientId,
                        redirect_uri: this.redirectUri
                    }
                });
            }
        },
        {
            key: "_setBffServerUrl",
            value: function _setBffServerUrl(e) {
                n(m(e), "url parameter is invalid: ".concat(e)), this._bffService = new y({
                    serverUrl: _(e, b.BFF),
                    log: this.log,
                    defaultParams: {
                        client_id: this.clientId,
                        redirect_uri: this.redirectUri
                    }
                });
            }
        },
        {
            key: "_setSessionServiceUrl",
            value: function _setSessionServiceUrl(e) {
                n(m(e), "domain parameter is invalid: ".concat(e));
                var t = "sdrn:".concat(A[this.env], ":client:").concat(this.clientId);
                this._sessionService = new y({
                    serverUrl: e,
                    log: this.log,
                    defaultParams: {
                        client_sdrn: t,
                        redirect_uri: this.redirectUri,
                        sdk_version: k
                    }
                });
            }
        },
        {
            key: "_setGlobalSessionServiceUrl",
            value: function _setGlobalSessionServiceUrl(e) {
                n(m(e), "url parameter is invalid: ".concat(e));
                var t = "sdrn:".concat(A[this.env], ":client:").concat(this.clientId);
                this._globalSessionService = new y({
                    serverUrl: _(e, b.SESSION_SERVICE),
                    log: this.log,
                    defaultParams: {
                        client_sdrn: t,
                        sdk_version: k
                    }
                });
            }
        },
        {
            key: "_emitSessionEvent",
            value: function _emitSessionEvent(e, t) {
                t.userId && this.emit("login", t), e.userId && !t.userId && this.emit("logout", t), e.userId && t.userId && e.userId !== t.userId && this.emit("userChange", t), e.userId || t.userId ? this.emit("sessionChange", t) : this.emit("notLoggedin", t), t.userId && !this._sessionInitiatedSent && (this._sessionInitiatedSent = !0, this.emit("sessionInit", t)), e.userStatus !== t.userStatus && this.emit("statusChange", t);
            }
        },
        {
            key: "_closePopup",
            value: function _closePopup() {
                this.popup && (this.popup.closed || this.popup.close(), this.popup = null);
            }
        },
        {
            key: "enableVarnishCookie",
            value: function enableVarnishCookie(e) {
                var t = 0, i;
                var ref, ref1, ref2;
                Number.isInteger(e) ? t = e : typeof e == "object" && (ref = e, ref1 = ref.expiresIn, t = ref1 === void 0 ? t : ref1, ref2 = ref.domain, i = ref2 === void 0 ? i : ref2, ref), n(Number.isInteger(t), "'expiresIn' must be an integer"), n(t >= 0, "'expiresIn' cannot be negative"), this.setVarnishCookie = !0, this.varnishExpiresIn = t, this.varnishCookieDomain = i;
            }
        },
        {
            key: "_maybeSetVarnishCookie",
            value: function _maybeSetVarnishCookie(e) {
                if (!this.setVarnishCookie) return;
                var t = new Date;
                if (this.varnishExpiresIn || typeof e.expiresIn == "number" && e.expiresIn > 0) {
                    var c = this.varnishExpiresIn || e.expiresIn;
                    t.setTime(t.getTime() + c * 1e3);
                } else t.setTime(0);
                var r = this.varnishCookieDomain || (typeof e.baseDomain == "string" ? e.baseDomain : document.domain) || "", o = [
                    "SP_ID=".concat(e.sp_id),
                    "expires=".concat(t.toUTCString()),
                    "path=/",
                    "domain=.".concat(r)
                ].join("; ");
                document.cookie = o;
            }
        },
        {
            key: "_maybeClearVarnishCookie",
            value: function _maybeClearVarnishCookie() {
                this.setVarnishCookie && this._clearVarnishCookie();
            }
        },
        {
            key: "_clearVarnishCookie",
            value: function _clearVarnishCookie() {
                var e = this.varnishCookieDomain || (this._session && typeof this._session.baseDomain == "string" ? this._session.baseDomain : document.domain) || "";
                document.cookie = "SP_ID=nothing; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.".concat(e);
            }
        },
        {
            key: "logSettings",
            value: function logSettings() {
                if (!this.log && !window.console) throw new h("You have to provide log method in constructor");
                var e = this.log || console.log, t = {
                    clientId: this.clientId,
                    redirectUri: this.redirectUri,
                    env: this.env,
                    sessionDomain: this._sessionDomain,
                    sdkVersion: k
                };
                e("Schibsted account SDK for browsers settings: \n".concat(JSON.stringify(t, null, 2)));
            }
        },
        {
            key: "hasSession",
            value: function hasSession() {
                var _this = this;
                if (this._hasSessionInProgress) return this._hasSessionInProgress;
                var _this1 = this;
                var e = function(i) {
                    if (i.error) throw new h("HasSession failed", i.error);
                    return _this._maybeSetVarnishCookie(i), _this._emitSessionEvent(_this._session, i), _this._session = i, i;
                }, t = function() {
                    var _ref = _asyncToGenerator(function() {
                        var _$r, i, r, o, _$r1;
                        return __generator(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (_this1._enableSessionCaching) {
                                        _$r = _this1.cache.get(N);
                                        if (_$r) return [
                                            2,
                                            e(_$r)
                                        ];
                                    }
                                    i = null;
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]);
                                    return [
                                        4,
                                        _this1._sessionService.get("/session")
                                    ];
                                case 2:
                                    i = _state.sent();
                                    return [
                                        3,
                                        4
                                    ];
                                case 3:
                                    r = _state.sent();
                                    if (r && r.code === 400 && _this1._enableSessionCaching) {
                                        o = 1e3 * (r.expiresIn || 300);
                                        _this1.cache.set(N, {
                                            error: r
                                        }, o);
                                    }
                                    throw r;
                                case 4:
                                    if (i && _this1._enableSessionCaching) {
                                        _$r1 = 1e3 * (i.expiresIn || 300);
                                        _this1.cache.set(N, i, _$r1);
                                    }
                                    return [
                                        2,
                                        e(i)
                                    ];
                            }
                        });
                    });
                    return function t() {
                        return _ref.apply(this, arguments);
                    };
                }();
                return this._hasSessionInProgress = t().then(function(i) {
                    return _this._hasSessionInProgress = !1, i;
                }, function(i) {
                    throw _this.emit("error", i), _this._hasSessionInProgress = !1, new h("HasSession failed", i);
                }), this._hasSessionInProgress;
            }
        },
        {
            key: "isLoggedIn",
            value: function isLoggedIn() {
                var _this = this;
                return _asyncToGenerator(function() {
                    var e, e1;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.hasSession()
                                ];
                            case 1:
                                e = _state.sent();
                                return [
                                    2,
                                    "result" in e
                                ];
                            case 2:
                                e1 = _state.sent();
                                return [
                                    2,
                                    !1
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "clearCachedUserSession",
            value: function clearCachedUserSession() {
                this.cache.delete(N);
            }
        },
        {
            key: "isConnected",
            value: function isConnected() {
                var _this = this;
                return _asyncToGenerator(function() {
                    var e;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.hasSession()
                                ];
                            case 1:
                                return [
                                    2,
                                    !!_state.sent().result
                                ];
                            case 2:
                                e = _state.sent();
                                return [
                                    2,
                                    !1
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getUser",
            value: function getUser() {
                var _this = this;
                return _asyncToGenerator(function() {
                    var e;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.hasSession()
                                ];
                            case 1:
                                e = _state.sent();
                                if (!e.result) throw new h("The user is not connected to this merchant");
                                return [
                                    2,
                                    V(e)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getUserId",
            value: function getUserId() {
                var _this = this;
                return _asyncToGenerator(function() {
                    var e;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.hasSession()
                                ];
                            case 1:
                                e = _state.sent();
                                if (e.userId && e.result) return [
                                    2,
                                    e.userId
                                ];
                                throw new h("The user is not connected to this merchant");
                        }
                    });
                })();
            }
        },
        {
            key: "getExternalId",
            value: function getExternalId(e) {
                var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
                var _this = this;
                return _asyncToGenerator(function() {
                    var ref, i, r, o;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.hasSession()
                                ];
                            case 1:
                                ref = _state.sent(), i = ref.pairId;
                                if (!i) throw new h("pairId missing in user session!");
                                if (!e || e.length === 0) throw new h("externalParty cannot be empty");
                                r = function(a) {
                                    return Array.from(new Uint8Array(a)).map(function(p) {
                                        return p.toString(16).padStart(2, "0");
                                    }).join("");
                                }, o = function(a) {
                                    return crypto.subtle.digest("SHA-256", a);
                                };
                                return [
                                    2,
                                    (function() {
                                        var _ref = _asyncToGenerator(function(a) {
                                            var l;
                                            return __generator(this, function(_state) {
                                                l = new TextEncoder().encode(a);
                                                return [
                                                    2,
                                                    o(l).then(function(p) {
                                                        return r(p);
                                                    })
                                                ];
                                            });
                                        });
                                        return function(a) {
                                            return _ref.apply(this, arguments);
                                        };
                                    })()(function(a, l, p) {
                                        return p ? "".concat(a, ":").concat(l, ":").concat(p) : "".concat(a, ":").concat(l);
                                    }(i, e, t))
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getUserSDRN",
            value: function getUserSDRN() {
                var _this = this;
                return _asyncToGenerator(function() {
                    var ref, e;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.hasSession()
                                ];
                            case 1:
                                ref = _state.sent(), e = ref.sdrn;
                                if (e) return [
                                    2,
                                    e
                                ];
                                throw new h("Failed to get SDRN from user session");
                        }
                    });
                })();
            }
        },
        {
            key: "getUserUuid",
            value: function getUserUuid() {
                var _this = this;
                return _asyncToGenerator(function() {
                    var e;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.hasSession()
                                ];
                            case 1:
                                e = _state.sent();
                                if (e.uuid && e.result) return [
                                    2,
                                    e.uuid
                                ];
                                throw new h("The user is not connected to this merchant");
                        }
                    });
                })();
            }
        },
        {
            key: "getUserContextData",
            value: function getUserContextData() {
                var _this = this;
                return _asyncToGenerator(function() {
                    var e;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this._globalSessionService.get("/user-context")
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                e = _state.sent();
                                return [
                                    2,
                                    null
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "login",
            value: function login(param) {
                var e = param.state, tmp = param.acrValues, t = tmp === void 0 ? "" : tmp, tmp1 = param.scope, i = tmp1 === void 0 ? "openid" : tmp1, tmp2 = param.redirectUri, r = tmp2 === void 0 ? this.redirectUri : tmp2, tmp3 = param.preferPopup, o = tmp3 === void 0 ? !1 : tmp3, tmp4 = param.loginHint, c = tmp4 === void 0 ? "" : tmp4, tmp5 = param.tag, d = tmp5 === void 0 ? "" : tmp5, tmp6 = param.teaser, a = tmp6 === void 0 ? "" : tmp6, tmp7 = param.maxAge, l = tmp7 === void 0 ? "" : tmp7, tmp8 = param.locale, p = tmp8 === void 0 ? "" : tmp8, tmp9 = param.oneStepLogin, g = tmp9 === void 0 ? !1 : tmp9, tmp10 = param.prompt, x = tmp10 === void 0 ? "select_account" : tmp10;
                this._closePopup(), this.cache.delete(N);
                var v = this.loginUrl({
                    state: e,
                    acrValues: t,
                    scope: i,
                    redirectUri: r,
                    loginHint: c,
                    tag: d,
                    teaser: a,
                    maxAge: l,
                    locale: p,
                    oneStepLogin: g,
                    prompt: x
                });
                return o && (this.popup = H(this.window, v, "Schibsted account", {
                    width: 360,
                    height: 570
                }), this.popup) ? this.popup : (this.window.location.href = v, null);
            }
        },
        {
            key: "getSpId",
            value: function getSpId() {
                var _this = this;
                return _asyncToGenerator(function() {
                    var e;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.hasSession()
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent().sp_id || null
                                ];
                            case 2:
                                e = _state.sent();
                                return [
                                    2,
                                    null
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "logout",
            value: function logout() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.redirectUri;
                this.cache.delete(N), this._maybeClearVarnishCookie(), this.emit("logout"), this.window.location.href = this.logoutUrl(e);
            }
        },
        {
            key: "loginUrl",
            value: function loginUrl(param) {
                var e = param.state, tmp = param.acrValues, t = tmp === void 0 ? "" : tmp, tmp1 = param.scope, i = tmp1 === void 0 ? "openid" : tmp1, tmp2 = param.redirectUri, r = tmp2 === void 0 ? this.redirectUri : tmp2, tmp3 = param.loginHint, o = tmp3 === void 0 ? "" : tmp3, tmp4 = param.tag, c = tmp4 === void 0 ? "" : tmp4, tmp5 = param.teaser, d = tmp5 === void 0 ? "" : tmp5, tmp6 = param.maxAge, a = tmp6 === void 0 ? "" : tmp6, tmp7 = param.locale, l = tmp7 === void 0 ? "" : tmp7, tmp8 = param.oneStepLogin, p = tmp8 === void 0 ? !1 : tmp8, tmp9 = param.prompt, g = tmp9 === void 0 ? "select_account" : tmp9;
                typeof arguments[0] != "object" && (e = arguments[0], t = arguments[1], i = arguments[2] || i, r = arguments[3] || r, o = arguments[4] || o, c = arguments[5] || c, d = arguments[6] || d, a = isNaN(arguments[7]) ? a : arguments[7]);
                var x = function(v) {
                    return W(v, [
                        "password",
                        "otp",
                        "sms",
                        "eid-no",
                        "eid-se",
                        "eid-fi",
                        "eid"
                    ], !0);
                };
                return n(!t || W(t, [
                    "",
                    "otp-email"
                ], !0) || t.split(" ").every(x), "The acrValues parameter is not acceptable: ".concat(t)), n(u(r), "loginUrl(): redirectUri must be a valid url but is ".concat(r)), n(f(e), "the state parameter should be a non empty string but it is ".concat(e)), this._oauthService.makeUrl("oauth/authorize", {
                    response_type: "code",
                    redirect_uri: r,
                    scope: i,
                    state: e,
                    acr_values: t,
                    login_hint: o,
                    tag: c,
                    teaser: d,
                    max_age: a,
                    locale: l,
                    one_step_login: p || "",
                    prompt: t ? "" : g
                });
            }
        },
        {
            key: "logoutUrl",
            value: function logoutUrl() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.redirectUri;
                n(u(e), "logoutUrl(): redirectUri is invalid");
                var t = {
                    redirect_uri: e
                };
                return this._sessionService.makeUrl("logout", t);
            }
        },
        {
            key: "accountUrl",
            value: function accountUrl() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.redirectUri;
                return this._spid.makeUrl("profile-pages", {
                    response_type: "code",
                    redirect_uri: e
                });
            }
        },
        {
            key: "phonesUrl",
            value: function phonesUrl() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.redirectUri;
                return this._spid.makeUrl("profile-pages/about-you/phone", {
                    response_type: "code",
                    redirect_uri: e
                });
            }
        },
        {
            key: "showSimplifiedLoginWidget",
            value: function showSimplifiedLoginWidget(e, t) {
                var _this = this;
                return _asyncToGenerator(function() {
                    var i, r, o, c;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getUserContextData()
                                ];
                            case 1:
                                i = _state.sent(), r = {
                                    client_id: _this.clientId
                                };
                                t && t.encoding && (r.encoding = t.encoding);
                                o = _this._bffService.makeUrl("simplified-login-widget", r, !1), c = function() {
                                    var _ref = _asyncToGenerator(function(d) {
                                        var _tmp;
                                        return __generator(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    _tmp = typeof d.state == "function";
                                                    if (!_tmp) return [
                                                        3,
                                                        2
                                                    ];
                                                    return [
                                                        4,
                                                        d.state()
                                                    ];
                                                case 1:
                                                    _tmp = d.state = _state.sent();
                                                    _state.label = 2;
                                                case 2:
                                                    return [
                                                        2,
                                                        (_tmp, d)
                                                    ];
                                            }
                                        });
                                    });
                                    return function c(d) {
                                        return _ref.apply(this, arguments);
                                    };
                                }();
                                return [
                                    2,
                                    new Promise(function(d, a) {
                                        if (!i || !i.display_text || !i.identifier) return a(new h("Missing user data"));
                                        var l = {
                                            displayText: i.display_text,
                                            env: _this.env,
                                            clientName: i.client_name,
                                            clientId: _this.clientId,
                                            providerId: i.provider_id,
                                            windowWidth: function() {
                                                return window.innerWidth;
                                            },
                                            windowOnResize: function(oe) {
                                                window.onresize = oe;
                                            }
                                        };
                                        t && t.locale && (l.locale = t.locale);
                                        var p = function() {
                                            var _ref = _asyncToGenerator(function() {
                                                var _, _1;
                                                return __generator(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            _ = _this.login;
                                                            _1 = Object.assign;
                                                            return [
                                                                4,
                                                                c(e)
                                                            ];
                                                        case 1:
                                                            _.apply(_this, [
                                                                _1.apply(Object, [
                                                                    _state.sent(),
                                                                    {
                                                                        loginHint: i.identifier
                                                                    }
                                                                ])
                                                            ]);
                                                            return [
                                                                2
                                                            ];
                                                    }
                                                });
                                            });
                                            return function p() {
                                                return _ref.apply(this, arguments);
                                            };
                                        }(), g = function() {
                                            var _ref = _asyncToGenerator(function() {
                                                var _, _1;
                                                return __generator(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            _ = _this.login;
                                                            _1 = Object.assign;
                                                            return [
                                                                4,
                                                                c(e)
                                                            ];
                                                        case 1:
                                                            _.apply(_this, [
                                                                _1.apply(Object, [
                                                                    _state.sent(),
                                                                    {
                                                                        loginHint: i.identifier,
                                                                        prompt: "login"
                                                                    }
                                                                ])
                                                            ]);
                                                            return [
                                                                2
                                                            ];
                                                    }
                                                });
                                            });
                                            return function g() {
                                                return _ref.apply(this, arguments);
                                            };
                                        }(), x = function() {
                                            _this.emit("simplifiedLoginOpened");
                                        }, v = function() {
                                            _this.emit("simplifiedLoginCancelled");
                                        };
                                        if (window.openSimplifiedLoginWidget) return window.openSimplifiedLoginWidget(l, p, g, x, v), d(!0);
                                        var R = document.createElement("script");
                                        R.type = "text/javascript", R.src = o, R.onload = function() {
                                            window.openSimplifiedLoginWidget(l, p, g, x, v), d(!0);
                                        }, R.onerror = function() {
                                            a(new h("Error when loading simplified login widget content"));
                                        }, document.getElementsByTagName("body")[0].appendChild(R);
                                    })
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return I;
}(ie.default);
var se = K(J(), 1);
var Pe = function() {
    return window;
}, T = /*#__PURE__*/ function(_default) {
    _inherits(T, _default);
    var _super = _createSuper(T);
    function T(param) {
        var e = param.clientId, t = param.redirectUri, tmp = param.env, i = tmp === void 0 ? "PRE" : tmp, r = param.sessionDomain, tmp1 = param.window, o = tmp1 === void 0 ? Pe() : tmp1;
        _classCallCheck(this, T);
        var _this;
        _this = _super.call(this), C(o), n(f(e), "clientId parameter is required"), _this.cache = new P(function() {
            return o && o.sessionStorage;
        }), _this.clientId = e, _this.env = i, _this.redirectUri = t, _this._setSpidServerUrl(i), r && (n(u(r), "sessionDomain parameter is not a valid URL"), _this._setSessionServiceUrl(r));
        return _possibleConstructorReturn(_this);
    }
    _createClass(T, [
        {
            key: "_setSpidServerUrl",
            value: function _setSpidServerUrl(e) {
                n(m(e), "url parameter is invalid: ".concat(e)), this._spid = new y({
                    serverUrl: _(e, b.SPiD),
                    defaultParams: {
                        client_id: this.clientId,
                        redirect_uri: this.redirectUri
                    }
                });
            }
        },
        {
            key: "_setSessionServiceUrl",
            value: function _setSessionServiceUrl(e) {
                n(m(e), "domain parameter is invalid: ".concat(e));
                var t = "sdrn:".concat(A[this.env], ":client:").concat(this.clientId);
                this._sessionService = new y({
                    serverUrl: e,
                    log: this.log,
                    defaultParams: {
                        client_sdrn: t,
                        redirect_uri: this.redirectUri,
                        sdk_version: k
                    }
                });
            }
        },
        {
            key: "hasAccess",
            value: function hasAccess(e, t) {
                var _this = this;
                return _asyncToGenerator(function() {
                    var i, r, o, c;
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this._sessionService) throw new h("hasAccess can only be called if 'sessionDomain' is configured");
                                if (!t) throw new h("'userId' must be specified");
                                if (!Array.isArray(e)) throw new h("'productIds' must be an array");
                                i = e.sort(), r = _this._accessCacheKey(e, t), o = _this.cache.get(r);
                                if (!!o) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this._sessionService.get("/hasAccess/".concat(i.join(",")))
                                ];
                            case 1:
                                o = _state.sent();
                                c = o.ttl;
                                _this.cache.set(r, o, c * 1e3);
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    o.entitled ? (_this.emit("hasAccess", {
                                        ids: i,
                                        data: o
                                    }), o) : null
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "clearCachedAccessResult",
            value: function clearCachedAccessResult(e, t) {
                this.cache.delete(this._accessCacheKey(e, t));
            }
        },
        {
            key: "_accessCacheKey",
            value: function _accessCacheKey(e, t) {
                return "prd_".concat(e.sort(), "_").concat(t);
            }
        },
        {
            key: "subscriptionsUrl",
            value: function subscriptionsUrl() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.redirectUri;
                return n(u(e), "subscriptionsUrl(): redirectUri is invalid"), this._spid.makeUrl("account/subscriptions", {
                    redirect_uri: e
                });
            }
        },
        {
            key: "productsUrl",
            value: function productsUrl() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.redirectUri;
                return n(u(e), "productsUrl(): redirectUri is invalid"), this._spid.makeUrl("account/products", {
                    redirect_uri: e
                });
            }
        }
    ]);
    return T;
}(se.default);
var Ie = function() {
    return window;
}, F = /*#__PURE__*/ function() {
    function F(param) {
        var e = param.clientId, t = param.redirectUri, tmp = param.env, i = tmp === void 0 ? "PRE" : tmp, r = param.publisher, tmp1 = param.window, o = tmp1 === void 0 ? Ie() : tmp1;
        _classCallCheck(this, F);
        C(o), n(f(e), "clientId parameter is required"), this.clientId = e, this.redirectUri = t, this.window = o, this.publisher = r, this._setSpidServerUrl(i), this._setBffServerUrl(i);
    }
    _createClass(F, [
        {
            key: "_setSpidServerUrl",
            value: function _setSpidServerUrl(e) {
                n(m(e), "url parameter is invalid: ".concat(e)), this._spid = new y({
                    serverUrl: _(e, b.SPiD),
                    defaultParams: {
                        client_id: this.clientId,
                        redirect_uri: this.redirectUri
                    }
                });
            }
        },
        {
            key: "_setBffServerUrl",
            value: function _setBffServerUrl(e) {
                n(m(e), "url parameter is invalid: ".concat(e)), this._bff = new y({
                    serverUrl: _(e, b.BFF),
                    defaultParams: {
                        client_id: this.clientId,
                        redirect_uri: this.redirectUri
                    }
                });
            }
        },
        {
            key: "_closePopup",
            value: function _closePopup() {
                this.popup && (this.popup.closed || this.popup.close(), this.popup = null);
            }
        },
        {
            key: "payWithPaylink",
            value: function payWithPaylink(param) {
                var e = param.paylink, t = param.preferPopup, tmp = param.redirectUri, i = tmp === void 0 ? this.redirectUri : tmp;
                n(u(i), "payWithPaylink(): redirectUri is invalid"), this._closePopup();
                var r = this.purchasePaylinkUrl(e, i);
                return t && (this.popup = H(this.window, r, "Schibsted account", {
                    width: 360,
                    height: 570
                }), this.popup) ? this.popup : (this.window.location.href = r, null);
            }
        },
        {
            key: "purchaseHistoryUrl",
            value: function purchaseHistoryUrl() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.redirectUri;
                return n(u(e), "purchaseHistoryUrl(): redirectUri is invalid"), this._spid.makeUrl("account/purchasehistory", {
                    redirect_uri: e
                });
            }
        },
        {
            key: "redeemUrl",
            value: function redeemUrl(e) {
                var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.redirectUri;
                return n(u(t), "redeemUrl(): redirectUri is invalid"), this._spid.makeUrl("account/redeem", {
                    voucher_code: e
                });
            }
        },
        {
            key: "purchasePaylinkUrl",
            value: function purchasePaylinkUrl(e) {
                var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.redirectUri;
                return n(u(t), "purchasePaylinkUrl(): redirectUri is invalid"), n(f(e), "purchasePaylinkUrl(): paylinkId is required"), this._bff.makeUrl("payment/purchase", {
                    paylink: e,
                    redirect_uri: t
                });
            }
        },
        {
            key: "purchaseProductFlowUrl",
            value: function purchaseProductFlowUrl(e) {
                var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.redirectUri;
                return n(u(t), "purchaseProductUrl(): redirectUri is invalid"), n(f(e), "purchaseProductFlowUrl(): productId is required"), this._bff.makeUrl("flow/checkout", {
                    response_type: "code",
                    flow: "payment",
                    product_id: e,
                    redirect_uri: t
                });
            }
        },
        {
            key: "purchaseCampaignFlowUrl",
            value: function purchaseCampaignFlowUrl(e, t, i) {
                var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : this.redirectUri;
                return n(u(r), "purchaseCampaignFlowUrl(): redirectUri is invalid"), n(f(e), "purchaseCampaignFlowUrl(): campaignId is required"), n(f(t), "purchaseCampaignFlowUrl(): productId is required"), this._bff.makeUrl("flow/checkout", {
                    response_type: "code",
                    flow: "payment",
                    campaign_id: e,
                    product_id: t,
                    voucher_code: i,
                    redirect_uri: r
                });
            }
        },
        {
            key: "purchasePromoCodeProductFlowUrl",
            value: function purchasePromoCodeProductFlowUrl(e) {
                var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.redirectUri;
                return n(u(i), "purchasePromoCodeProductFlowUrl(): redirectUri is invalid"), n(f(e), "purchasePromoCodeProductFlowUrl(): code is required"), n(f(this.publisher), "purchasePromoCodeProductFlowUrl(): publisher is required in the constructor"), this._bff.makeUrl("payment/purchase/code", {
                    code: e,
                    publisher: this.publisher,
                    state: t,
                    redirect_uri: i
                });
            }
        }
    ]);
    return F;
}();
var w = K(__webpack_require__(50959));
var Q = (typeof window === "undefined" ? "undefined" : _typeof(window)) < "u", Ee = Q ? w.useLayoutEffect : w.useEffect, xe = function() {
    var _ref = _asyncToGenerator(function() {
        return __generator(this, function(_state) {
            return [
                2,
                JSON.stringify({
                    s: Math.random().toString(16),
                    location: Q && window.location.href
                })
            ];
        });
    });
    return function xe() {
        return _ref.apply(this, arguments);
    };
}(), j = (0, w.createContext)(void 0), re = function(param) {
    var s = param.config, e = param.children, tmp = param.getOauthState, t = tmp === void 0 ? void 0 : tmp, tmp1 = param.onSessionChange, i = tmp1 === void 0 ? void 0 : tmp1;
    var r = (0, w.useMemo)(function() {
        return Q ? new I(s.identity) : void 0;
    }, [
        s
    ]), ref = _slicedToArray((0, w.useState)(), 2), o = ref[0], c = ref[1], d = (0, w.useCallback)(/*#__PURE__*/ _asyncToGenerator(function() {
        var l, e;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!r) return [
                        2
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        r.hasSession()
                    ];
                case 2:
                    l = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    l = void 0;
                    return [
                        3,
                        4
                    ];
                case 4:
                    i && i(o, l), c(l);
                    return [
                        2
                    ];
            }
        });
    }), [
        r,
        i,
        o
    ]);
    Ee(function() {
        d();
    }, []);
    var a = (0, w.useMemo)(function() {
        return {
            identity: r,
            session: o,
            config: s,
            getOauthState: t || xe,
            refreshSession: d
        };
    }, [
        r,
        o,
        s,
        t,
        d
    ]);
    return w.default.createElement(j.Provider, {
        value: a
    }, e);
};
var E = __webpack_require__(50959);
var ne = function() {
    var s = (0, E.useContext)(j);
    if (s === void 0) throw new Error("useAccount must be used within an AccountProvider");
    var e = s.identity, t = s.session, i = s.config, r = s.getOauthState, o = s.refreshSession, c = (0, E.useCallback)(function() {
        if (!e) return;
        var p = i.identity.redirectUri;
        r().then(function(g) {
            e.login(_objectSpreadProps(_objectSpread({}, i.login), {
                redirectUri: p,
                state: g
            }));
        }).catch(function(g) {
            console.warn("useAccount, login(): ".concat(g.message));
        });
    }, [
        i.identity.redirectUri,
        i.login,
        r,
        e
    ]), d = (0, E.useCallback)(function() {
        !e || e.logout(window.location.href);
    }, [
        e
    ]), a = (0, E.useCallback)(/*#__PURE__*/ _asyncToGenerator(function() {
        var p, _$g, g;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!e) return [
                        2,
                        !1
                    ];
                    p = i.identity.redirectUri;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        e.showSimplifiedLoginWidget(_objectSpreadProps(_objectSpread({}, i.login), {
                            redirectUri: p,
                            state: r
                        }))
                    ];
                case 2:
                    _$g = _state.sent();
                    if (typeof _$g != "boolean") throw _$g;
                    return [
                        2,
                        _$g
                    ];
                case 3:
                    g = _state.sent();
                    return [
                        2,
                        (console.warn("useAccount, showSimplifiedLoginWidget(): ".concat(g.message)), !1)
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        i.identity.redirectUri,
        i.login,
        r,
        e
    ]), l = (0, E.useCallback)(function() {
        var p = e === null || e === void 0 ? void 0 : e.accountUrl().match(/^(https?:\/\/[^/]+)/i);
        return p ? "".concat(p[1], "/profile-pages?client_id=").concat(i.identity.clientId) : "";
    }, [
        i.identity.clientId,
        e
    ]);
    return {
        session: t,
        refreshSession: o,
        login: c,
        logout: d,
        showSimplifiedLoginWidget: a,
        profilePageUrl: l
    };
};


/***/ }),

/***/ 9285:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lo": () => (/* binding */ USER_SHOP_PREFERENCE_RECEIVE),
/* harmony export */   "XW": () => (/* binding */ dislikeShop),
/* harmony export */   "ZP": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "dt": () => (/* binding */ USER_RECEIVE),
/* harmony export */   "h_": () => (/* binding */ receiveShopPreference),
/* harmony export */   "ie": () => (/* binding */ USER_LIKE_SHOP_REQUEST),
/* harmony export */   "m": () => (/* binding */ likeShop),
/* harmony export */   "oN": () => (/* binding */ USER_DISLIKE_SHOP_REQUEST),
/* harmony export */   "pT": () => (/* binding */ shopPreferenceError),
/* harmony export */   "xX": () => (/* binding */ USER_SHOP_PREFERENCE_ERROR)
/* harmony export */ });
var USER_RECEIVE = "USER_RECEIVE";
var USER_LIKE_SHOP_REQUEST = "USER_LIKE_SHOP";
var USER_DISLIKE_SHOP_REQUEST = "USER_DISLIKE_SHOP";
var USER_SHOP_PREFERENCE_ERROR = "USER_SHOP_PREFERENCE_ERROR";
var USER_SHOP_PREFERENCE_RECEIVE = "USER_SHOP_PREFERENCE_RECEIVE";
var userReceive = function(me) {
    return {
        type: USER_RECEIVE,
        me: me || undefined
    };
};
var likeShop = function(shopId) {
    return {
        type: USER_LIKE_SHOP_REQUEST,
        shopId: shopId
    };
};
var dislikeShop = function(shopId) {
    return {
        type: USER_DISLIKE_SHOP_REQUEST,
        shopId: shopId
    };
};
var shopPreferenceError = function() {
    return {
        type: USER_SHOP_PREFERENCE_ERROR
    };
};
var receiveShopPreference = function(shopPreferenceState) {
    return {
        type: USER_SHOP_PREFERENCE_RECEIVE,
        shopPreferenceState: shopPreferenceState
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
    userReceive: userReceive
});


/***/ }),

/***/ 24757:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E2": () => (/* binding */ ALERT_SETTINGS_CHANGE_REQUEST),
/* harmony export */   "G5": () => (/* binding */ ALERT_SETTINGS_CHANGE),
/* harmony export */   "Os": () => (/* binding */ ALERT_SETTINGS_CHANGE_SUCCESS),
/* harmony export */   "cA": () => (/* binding */ alertSettingsChangeFail),
/* harmony export */   "g5": () => (/* binding */ alertSettingsChangeSuccess),
/* harmony export */   "oD": () => (/* binding */ ALERT_SETTINGS_SAVE_REQUEST)
/* harmony export */ });
/* unused harmony exports ALERT_SETTINGS_CHANGE_FAIL, alertSettingsChange, alertSettingsSaveRequest, alertSettingsChangeRequest */
var ALERT_SETTINGS_CHANGE = "ALERT_SETTINGS_CHANGE";
var ALERT_SETTINGS_SAVE_REQUEST = "ALERT_SETTINGS_SAVE_REQUEST";
var ALERT_SETTINGS_CHANGE_REQUEST = "ALERT_SETTINGS_CHANGE_REQUEST";
var ALERT_SETTINGS_CHANGE_SUCCESS = "ALERT_SETTINGS_CHANGE_SUCCESS";
var ALERT_SETTINGS_CHANGE_FAIL = "ALERT_SETTINGS_CHANGE_FAIL";
var alertSettingsChange = function(setting) {
    return {
        type: ALERT_SETTINGS_CHANGE,
        setting: setting
    };
};
var alertSettingsSaveRequest = function(setting) {
    return {
        type: ALERT_SETTINGS_SAVE_REQUEST,
        setting: setting
    };
};
var alertSettingsChangeRequest = function(setting) {
    return {
        type: ALERT_SETTINGS_CHANGE_REQUEST,
        setting: setting
    };
};
var alertSettingsChangeSuccess = function(setting) {
    return {
        type: ALERT_SETTINGS_CHANGE_SUCCESS,
        setting: setting
    };
};
var alertSettingsChangeFail = function(setting) {
    return {
        type: ALERT_SETTINGS_CHANGE_FAIL,
        setting: setting
    };
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    alertSettingsChange: alertSettingsChange,
    alertSettingsChangeRequest: alertSettingsChangeRequest
});


/***/ }),

/***/ 61928:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Be": () => (/* binding */ displayNameChange),
/* harmony export */   "Kc": () => (/* binding */ DISPLAY_NAME_CHANGE),
/* harmony export */   "hC": () => (/* binding */ setDisplayName),
/* harmony export */   "kr": () => (/* binding */ UPDATE_DISPLAY_NAME)
/* harmony export */ });
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var DISPLAY_NAME_CHANGE = "DISPLAY_NAME_CHANGE";
var UPDATE_DISPLAY_NAME = "UPDATE_DISPLAY_NAME";
var setDisplayName = function(displayName) {
    return {
        type: UPDATE_DISPLAY_NAME,
        displayName: displayName
    };
};
var displayNameChange = function(displayName) {
    return _objectSpreadProps(_objectSpread({}, displayName), {
        editing: "displayName",
        type: DISPLAY_NAME_CHANGE,
        saving: true
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    displayNameChange: displayNameChange
});


/***/ }),

/***/ 41112:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dl": () => (/* binding */ SETTINGS_START_EDITING),
/* harmony export */   "Gd": () => (/* binding */ UPDATE_SUBSCRIPTION_SETTING_REQUEST),
/* harmony export */   "Gn": () => (/* binding */ settingsChangeSuccess),
/* harmony export */   "St": () => (/* binding */ settingsChangeFail),
/* harmony export */   "Ud": () => (/* binding */ startEditing),
/* harmony export */   "Vi": () => (/* binding */ updateSubscriptionSettingRequest),
/* harmony export */   "X2": () => (/* binding */ UPDATE_SUBSCRIPTION_SETTING),
/* harmony export */   "f1": () => (/* binding */ SETTINGS_CHANGE_SUCCESS),
/* harmony export */   "nA": () => (/* binding */ SETTINGS_CHANGE_FAILED),
/* harmony export */   "su": () => (/* binding */ updateSubscriptionSetting)
/* harmony export */ });
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SETTINGS_CHANGE_SUCCESS = "SETTINGS_CHANGE_SUCCESS";
var SETTINGS_CHANGE_FAILED = "SETTINGS_CHANGE_FAILED";
var SETTINGS_START_EDITING = "SETTINGS_START_EDITING";
var UPDATE_SUBSCRIPTION_SETTING = "UPDATE_SUBSCRIPTION_SETTING";
var UPDATE_SUBSCRIPTION_SETTING_REQUEST = "UPDATE_SUBSCRIPTION_SETTING_REQUEST";
var startEditing = function(settings) {
    return {
        type: SETTINGS_START_EDITING,
        settings: settings
    };
};
var settingsChangeSuccess = function(settings) {
    return {
        settings: settings,
        type: SETTINGS_CHANGE_SUCCESS
    };
};
var settingsChangeFail = function(data) {
    return _objectSpreadProps(_objectSpread({}, data), {
        type: SETTINGS_CHANGE_FAILED
    });
};
var updateSubscriptionSetting = function(id, subscribed) {
    return {
        type: UPDATE_SUBSCRIPTION_SETTING,
        id: id,
        subscribed: subscribed
    };
};
var updateSubscriptionSettingRequest = function(id, subscribed) {
    return {
        type: UPDATE_SUBSCRIPTION_SETTING_REQUEST,
        id: id,
        subscribed: subscribed
    };
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    settingsChangeSuccess: settingsChangeSuccess,
    startEditing: startEditing
});


/***/ }),

/***/ 87724:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": () => (/* binding */ updateAlertSetting),
/* harmony export */   "m": () => (/* binding */ updateSetting)
/* harmony export */ });
/* harmony import */ var _globals_api_requests__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11124);

var updateSetting = function(setting, value) {
    return (0,_globals_api_requests__WEBPACK_IMPORTED_MODULE_0__/* .graphql */ .BX)("\n      mutation ($data: SettingInputType!) {\n        updateSetting(data: $data) {\n          success\n        }\n      }\n    ", {
        data: {
            setting: setting,
            value: value
        }
    });
};
var updateAlertSetting = function(setting, value) {
    return updateSetting("alert_method_".concat(setting), Number(value));
};


/***/ }),

/***/ 51018:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export handleSettingsAction */
/* harmony import */ var redux_saga_effects__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38247);
/* harmony import */ var _helpers_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87724);
/* harmony import */ var _actions_settings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41112);
/* harmony import */ var _components_toast_container_actions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88278);
/* harmony import */ var _actions_display_name__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61928);
/* harmony import */ var _globals_api_requests__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11124);
/* harmony import */ var _components_subscription_settings_update_subscription_setting_mutation_graphql__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91302);
/* harmony import */ var _components_subscription_settings_update_subscription_setting_mutation_graphql__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_components_subscription_settings_update_subscription_setting_mutation_graphql__WEBPACK_IMPORTED_MODULE_6__);
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};







function handleSettingsAction(action) {
    var _, ref, response, ref1, _code, e;
    return __generator(this, function(_state) {
        switch(_state.label){
            case 0:
                _ = action.type;
                switch(_){
                    case _actions_display_name__WEBPACK_IMPORTED_MODULE_4__/* .DISPLAY_NAME_CHANGE */ .Kc:
                        return [
                            3,
                            1
                        ];
                }
                return [
                    3,
                    9
                ];
            case 1:
                _state.trys.push([
                    1,
                    6,
                    ,
                    8
                ]);
                return [
                    4,
                    (0,redux_saga_effects__WEBPACK_IMPORTED_MODULE_0__/* .call */ .RE)(_helpers_api__WEBPACK_IMPORTED_MODULE_1__/* .updateSetting */ .m, "display_name", action.displayName)
                ];
            case 2:
                response = _state.sent();
                if ((ref = response.errors) === null || ref === void 0 ? void 0 : ref.length) {
                    ;
                    ;
                    throw new Error((_code = response.errors[0].code) !== null && _code !== void 0 ? _code : (ref1 = response.errors[0].extensions) === null || ref1 === void 0 ? void 0 : ref1.code);
                }
                return [
                    4,
                    (0,redux_saga_effects__WEBPACK_IMPORTED_MODULE_0__/* .put */ .gz)((0,_components_toast_container_actions__WEBPACK_IMPORTED_MODULE_3__/* .promptToast */ .Lf)("success", window.APP_GLOBALS.t("account", "settings.saved")))
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects__WEBPACK_IMPORTED_MODULE_0__/* .put */ .gz)((0,_actions_display_name__WEBPACK_IMPORTED_MODULE_4__/* .setDisplayName */ .hC)(action.displayName))
                ];
            case 4:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects__WEBPACK_IMPORTED_MODULE_0__/* .put */ .gz)((0,_actions_settings__WEBPACK_IMPORTED_MODULE_2__/* .settingsChangeSuccess */ .Gn)(response.data.updateSetting))
                ];
            case 5:
                _state.sent();
                return [
                    3,
                    8
                ];
            case 6:
                e = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects__WEBPACK_IMPORTED_MODULE_0__/* .put */ .gz)((0,_actions_settings__WEBPACK_IMPORTED_MODULE_2__/* .settingsChangeFail */ .St)({
                        settings: action,
                        error: e.message
                    }))
                ];
            case 7:
                _state.sent();
                return [
                    3,
                    8
                ];
            case 8:
                return [
                    3,
                    10
                ];
            case 9:
                {
                    return [
                        3,
                        10
                    ];
                }
                _state.label = 10;
            case 10:
                return [
                    2
                ];
        }
    });
}
function handleUpdateSubscriptionSetting(action) {
    var response;
    return __generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects__WEBPACK_IMPORTED_MODULE_0__/* .put */ .gz)((0,_actions_settings__WEBPACK_IMPORTED_MODULE_2__/* .updateSubscriptionSetting */ .su)(action.id, action.subscribed))
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects__WEBPACK_IMPORTED_MODULE_0__/* .call */ .RE)(_globals_api_requests__WEBPACK_IMPORTED_MODULE_5__/* .graphql */ .BX, (_components_subscription_settings_update_subscription_setting_mutation_graphql__WEBPACK_IMPORTED_MODULE_6___default()), {
                        id: action.id,
                        subscribed: action.subscribed
                    })
                ];
            case 2:
                response = _state.sent();
                if (!!response.errors) return [
                    3,
                    4
                ];
                return [
                    4,
                    (0,redux_saga_effects__WEBPACK_IMPORTED_MODULE_0__/* .put */ .gz)((0,_components_toast_container_actions__WEBPACK_IMPORTED_MODULE_3__/* .promptToast */ .Lf)("success", window.APP_GLOBALS.t("account", "settings.saved")))
                ];
            case 3:
                _state.sent();
                _state.label = 4;
            case 4:
                return [
                    2
                ];
        }
    });
}
function mySaga() {
    return __generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects__WEBPACK_IMPORTED_MODULE_0__/* .takeLatest */ .Fm)([
                        _actions_settings__WEBPACK_IMPORTED_MODULE_2__/* .SETTINGS_CHANGE_SUCCESS */ .f1,
                        _actions_display_name__WEBPACK_IMPORTED_MODULE_4__/* .DISPLAY_NAME_CHANGE */ .Kc
                    ], handleSettingsAction)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects__WEBPACK_IMPORTED_MODULE_0__/* .takeEvery */ .ib)(_actions_settings__WEBPACK_IMPORTED_MODULE_2__/* .UPDATE_SUBSCRIPTION_SETTING_REQUEST */ .Gd, handleUpdateSubscriptionSetting)
                ];
            case 2:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (mySaga);


/***/ }),

/***/ 57378:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30082);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23114);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2222);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_3__);




var ArticlePage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "article";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | article */ 942).then(__webpack_require__.bind(__webpack_require__, 28607));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(28607);
        }
        return eval("require.resolve")("./article");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
});
ArticlePage.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_3___default());
ArticlePage.variables = function(v) {
    return {
        id: parseInt(v.id, 10)
    };
};
ArticlePage.loadOrder = [
    {}
];
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ArticlePage);


/***/ }),

/***/ 98675:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30082);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23114);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51882);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_3__);




var BrandPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "brand";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | brand */ 362).then(__webpack_require__.bind(__webpack_require__, 29092));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(29092);
        }
        return eval("require.resolve")("./components");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
});
BrandPage.variables = function(param) {
    var id = param.id;
    return {
        id: id
    };
};
BrandPage.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_3___default());
BrandPage.loadOrder = [
    {}
];
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BrandPage);


/***/ }),

/***/ 14752:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ru": () => (/* binding */ CAMPAIGN_QUERY),
/* harmony export */   "ZP": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "d6": () => (/* binding */ campaignItemClick)
/* harmony export */ });
/* unused harmony exports CAMPAIGN_ITEM_CLICK, CAMPAIGN_SEARCH_DONE, CAMPAIGN_PAGINATION, CAMPAIGN_POPULAR_QUERY, CAMPAIGN_CATEGORY_FILTER, CAMPAIGN_RANGE_FILTER, campaignQuery, campaignPopularQuery, campaignCategoryFilter, campaignsRangeFilter */
var CAMPAIGN_QUERY = "CAMPAIGN_QUERY";
var CAMPAIGN_ITEM_CLICK = "CAMPAIGN_ITEM_CLICK";
var CAMPAIGN_SEARCH_DONE = "CAMPAIGN_SEARCH_DONE";
var CAMPAIGN_PAGINATION = "CAMPAIGN_PAGINATION";
var CAMPAIGN_POPULAR_QUERY = "CAMPAIGN_POPULAR_QUERY";
var CAMPAIGN_CATEGORY_FILTER = "CAMPAIGN_CATEGORY_FILTER";
var CAMPAIGN_RANGE_FILTER = "CAMPAIGN_RANGE_FILTER";
var campaignQuery = function(data) {
    return {
        type: CAMPAIGN_QUERY,
        data: data
    };
};
var campaignPopularQuery = function(data, filter) {
    return {
        type: CAMPAIGN_POPULAR_QUERY,
        data: data,
        filter: filter
    };
};
var campaignCategoryFilter = function(category) {
    return {
        type: CAMPAIGN_CATEGORY_FILTER,
        category: category
    };
};
var campaignsRangeFilter = function(filter) {
    return {
        type: CAMPAIGN_RANGE_FILTER,
        filter: filter
    };
};
var campaignPagination = function(pageNumber) {
    return {
        type: CAMPAIGN_PAGINATION,
        pageNumber: pageNumber
    };
};
var campaignItemClick = function(item) {
    return {
        type: CAMPAIGN_ITEM_CLICK,
        item: item
    };
};
var campaignSearchDone = function() {
    return {
        type: CAMPAIGN_SEARCH_DONE
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
    campaignItemClick: campaignItemClick,
    campaignSearchDone: campaignSearchDone,
    campaignPagination: campaignPagination,
    campaignCategoryFilter: campaignCategoryFilter,
    campaignsRangeFilter: campaignsRangeFilter
});


/***/ }),

/***/ 52452:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23114);
/* harmony import */ var _themes_query_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98553);
/* harmony import */ var _themes_query_graphql__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_themes_query_graphql__WEBPACK_IMPORTED_MODULE_1__);


var ThemesPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "campaigns";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | campaigns */ 340).then(__webpack_require__.bind(__webpack_require__, 27546));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(27546);
        }
        return eval("require.resolve")("./components/themes");
    }
});
ThemesPage.graphQL = (_themes_query_graphql__WEBPACK_IMPORTED_MODULE_1___default());
ThemesPage.loadOrder = [];
ThemesPage.variables = function() {
    return {};
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ThemesPage);


/***/ }),

/***/ 23902:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23114);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44125);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30082);




var CategoryIndex = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "category-index";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | category-index */ 850).then(__webpack_require__.bind(__webpack_require__, 58390));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(58390);
        }
        return eval("require.resolve")("./category-index");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, null)
});
CategoryIndex.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_2___default());
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CategoryIndex);


/***/ }),

/***/ 5202:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GW": () => (/* binding */ categoryLayoutChanged),
/* harmony export */   "Hp": () => (/* binding */ CATEGORY_LAYOUT_CHANGED),
/* harmony export */   "VV": () => (/* binding */ categoryLayoutRequest),
/* harmony export */   "xV": () => (/* binding */ categoryLayoutFailed)
/* harmony export */ });
/* unused harmony exports CATEGORY_LAYOUT_REQUEST, CATEGORY_LAYOUT_FAILED, CATEGORY_NAVIGATION */
var CATEGORY_LAYOUT_REQUEST = "CATEGORY_LAYOUT_REQUEST";
var CATEGORY_LAYOUT_CHANGED = "CATEGORY_LAYOUT_CHANGED";
var CATEGORY_LAYOUT_FAILED = "CATEGORY_LAYOUT_FAILED";
var CATEGORY_NAVIGATION = "CATEGORY_NAVIGATION";
// Layout Request
var categoryLayoutRequest = function(mode) {
    return {
        type: CATEGORY_LAYOUT_REQUEST,
        mode: mode
    };
};
var categoryLayoutChanged = function(mode) {
    return {
        type: CATEGORY_LAYOUT_CHANGED,
        mode: mode
    };
};
var categoryLayoutFailed = function(mode) {
    return {
        type: CATEGORY_LAYOUT_FAILED,
        mode: mode
    };
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    categoryLayoutRequest: categoryLayoutRequest
});


/***/ }),

/***/ 70721:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$H": () => (/* binding */ FILTER_CHANGE_ACTION),
/* harmony export */   "DQ": () => (/* binding */ filterQuery),
/* harmony export */   "Du": () => (/* binding */ setHorizontalFilter),
/* harmony export */   "HW": () => (/* binding */ COMPARE_PROPERTIES),
/* harmony export */   "I2": () => (/* binding */ FILTER_FETCH_FAILED),
/* harmony export */   "JL": () => (/* binding */ FILTER_QUERY),
/* harmony export */   "MW": () => (/* binding */ propertySearch),
/* harmony export */   "Q": () => (/* binding */ PROPERTY_SEARCH_ACTION),
/* harmony export */   "QL": () => (/* binding */ compareProperties),
/* harmony export */   "WK": () => (/* binding */ FILTER_TOGGLE_MOBILE),
/* harmony export */   "Xi": () => (/* binding */ filterChangeAction),
/* harmony export */   "c8": () => (/* binding */ FILTER_EXPAND_SECTION),
/* harmony export */   "eB": () => (/* binding */ PROPERTY_SEARCH_TOGGLE_SECTION),
/* harmony export */   "fs": () => (/* binding */ toggleMobile),
/* harmony export */   "gd": () => (/* binding */ COMPARE_PROPERTY),
/* harmony export */   "hN": () => (/* binding */ propertySearchComplete),
/* harmony export */   "kx": () => (/* binding */ PROPERTY_SEARCH_COMPLETE),
/* harmony export */   "lf": () => (/* binding */ filterFetchFailed),
/* harmony export */   "m0": () => (/* binding */ filterReceive),
/* harmony export */   "pS": () => (/* binding */ compareProperty),
/* harmony export */   "s0": () => (/* binding */ expandSection),
/* harmony export */   "vN": () => (/* binding */ FILTER_RECEIVE),
/* harmony export */   "vd": () => (/* binding */ SET_HORIZONTAL_FILTER),
/* harmony export */   "wz": () => (/* binding */ propertySearchToggleExpansion)
/* harmony export */ });
/* unused harmony exports FILTER_STARTUP, PROPERTY_SEARCH_CORE_COMPLETE, PROPERTY_SEARCH_SECTION_COMPLETE */
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var FILTER_CHANGE_ACTION = "FILTER_CHANGE_ACTION";
var FILTER_QUERY = "FILTER_QUERY";
var FILTER_RECEIVE = "FILTER_RECEIVE";
var FILTER_FETCH_FAILED = "FILTER_FETCH_FAILED";
var FILTER_STARTUP = "FILTER_STARTUP";
var FILTER_EXPAND_SECTION = "FILTER_OPEN_SECTION";
var FILTER_TOGGLE_MOBILE = "FILTER_TOGGLE_MOBILE";
var SET_HORIZONTAL_FILTER = "SET_HORIZONTAL_FILTER";
var PROPERTY_SEARCH_ACTION = "PROPERTY_SEARCH_ACTION";
var PROPERTY_SEARCH_CORE_COMPLETE = "PROPERTY_SEARCH_CORE_COMPLETE";
var PROPERTY_SEARCH_SECTION_COMPLETE = "PROPERTY_SEARCH_SECTION_COMPLETE";
var PROPERTY_SEARCH_COMPLETE = "PROPERTY_SEARCH_COMPLETE";
var PROPERTY_SEARCH_TOGGLE_SECTION = "PROPERTY_SEARCH_TOGGLE_SECTION";
var COMPARE_PROPERTY = "COMPARE_PROPERTY";
var COMPARE_PROPERTIES = "COMPARE_PROPERTIES";
var filterQuery = function(query) {
    return {
        query: query,
        type: FILTER_QUERY
    };
};
var expandSection = function(name) {
    return {
        name: name,
        type: FILTER_EXPAND_SECTION
    };
};
var filterReceive = function(data, categoryData) {
    return {
        data: data,
        categoryData: categoryData,
        type: FILTER_RECEIVE
    };
};
var filterFetchFailed = function(param, categoryId) {
    var error = param.error;
    return {
        error: error,
        categoryId: categoryId,
        type: FILTER_FETCH_FAILED
    };
};
var filterChangeAction = function(categoryId, data) {
    return _objectSpreadProps(_objectSpread({
        categoryId: categoryId
    }, data), {
        type: FILTER_CHANGE_ACTION
    });
};
var compareProperty = function(propertyId) {
    return {
        propertyId: propertyId,
        type: COMPARE_PROPERTY
    };
};
var compareProperties = function(propertyIds) {
    return {
        propertyIds: propertyIds,
        type: COMPARE_PROPERTIES
    };
};
var toggleMobile = function(open) {
    return {
        open: open,
        type: FILTER_TOGGLE_MOBILE
    };
};
var setHorizontalFilter = function(show) {
    return {
        show: show,
        type: SET_HORIZONTAL_FILTER
    };
};
var propertySearch = function(inputValue) {
    return {
        inputValue: inputValue,
        type: PROPERTY_SEARCH_ACTION
    };
};
var propertySearchToggleExpansion = function(name) {
    return {
        name: name,
        type: PROPERTY_SEARCH_TOGGLE_SECTION
    };
};
var propertySearchComplete = function(filteredCore, filteredSections, filteredValues, expandedSections) {
    return {
        filteredCore: filteredCore,
        filteredSections: filteredSections,
        filteredValues: filteredValues,
        expandedSections: expandedSections,
        type: PROPERTY_SEARCH_COMPLETE
    };
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    filterQuery: filterQuery,
    expandSection: expandSection,
    filterReceive: filterReceive,
    filterFetchFailed: filterFetchFailed,
    filterChangeAction: filterChangeAction,
    toggleMobile: toggleMobile,
    propertySearch: propertySearch,
    propertySearchComplete: propertySearchComplete,
    propertySearchToggleExpansion: propertySearchToggleExpansion,
    compareProperty: compareProperty,
    compareProperties: compareProperties,
    setHorizontalFilter: setHorizontalFilter
});


/***/ }),

/***/ 99120:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30082);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23114);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48472);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_3__);




var Category = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "category";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | category */ 34).then(__webpack_require__.bind(__webpack_require__, 83247));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(83247);
        }
        return eval("require.resolve")("./category");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
});
Category.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_3___default());
Category.variables = function(param) {
    var id = param.id, offset = param.offset, campaignId = param.campaignId, filterId = param.filterId, sort = param.sort, direction = param.direction, brand = param.brand, compare = param.compare, marketCode = param.marketCode;
    return {
        id: id,
        offset: parseInt(offset, 10) || 0,
        campaignId: campaignId,
        categoryDealId: [
            id
        ],
        filterId: filterId,
        sort: sort,
        direction: direction,
        brand: brand,
        compareIds: compare ? compare.split(",") : [
            "_core_"
        ],
        isServices: marketCode === "se" && id === "v1004",
        isVirtualCategory: (id === null || id === void 0 ? void 0 : id.startsWith("s")) || (id === null || id === void 0 ? void 0 : id.startsWith("v")),
        categoryIds: [
            id
        ]
    };
};
Category.group = function(param) {
    var name = param.name, variables = param.variables;
    var groupVariables = variables ? Object.keys(variables).filter(function(key) {
        return [
            "id",
            "brand",
            "filterId",
            "offset"
        ].includes(key);
    }).filter(function(key) {
        return variables[key];
    }).map(function(key) {
        return variables[key];
    }) : [];
    return "".concat(name, "_").concat(groupVariables.join("_"), "_").concat(variables.compareIds.join(":"));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Category);


/***/ }),

/***/ 13736:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23114);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84261);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_1__);


var ChangelogLandingPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "expert";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | expert */ 877).then(__webpack_require__.bind(__webpack_require__, 66408));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(66408);
        }
        return eval("require.resolve")("./landing-page");
    }
});
ChangelogLandingPage.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_1___default());
ChangelogLandingPage.variables = function() {
    return {};
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ChangelogLandingPage);


/***/ }),

/***/ 36579:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30082);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23114);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50973);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_3__);




var EditorialContentListingPageLoader = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "article";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | article */ 942).then(__webpack_require__.bind(__webpack_require__, 7685));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(7685);
        }
        return eval("require.resolve")("./editorial-content-listing");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
});
EditorialContentListingPageLoader.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_3___default());
EditorialContentListingPageLoader.variables = function(param) {
    var offset = param.offset;
    var pageSize = 20;
    var parsedOffset = typeof offset === "string" ? parseInt(offset, 10) : offset;
    return {
        page: parsedOffset === null || parsedOffset === undefined ? 1 : parsedOffset / pageSize + 1,
        pageSize: pageSize
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (EditorialContentListingPageLoader);


/***/ }),

/***/ 13664:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23114);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81474);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30082);




var EditorialContent = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "article";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | article */ 942).then(__webpack_require__.bind(__webpack_require__, 18292));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(18292);
        }
        return eval("require.resolve")("./editorial-content");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, null)
});
EditorialContent.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_2___default());
EditorialContent.variables = function(vars) {
    // Prismic preview feature sends this parameter
    // then we send that along to the Prismic API integration
    // as the `ref` option. This lets us preview unpublished
    // articles.
    if (vars.token) {
        return {
            id: vars.documentId,
            ref: vars.token
        };
    }
    var id = vars.id, ref = vars.ref;
    return {
        id: id,
        ref: ref
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (EditorialContent);


/***/ }),

/***/ 45705:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30082);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23114);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51307);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_3__);




var ExpertCategory = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "expert";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | expert */ 877).then(__webpack_require__.bind(__webpack_require__, 27299));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(27299);
        }
        return eval("require.resolve")("./expert-category");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
});
ExpertCategory.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_3___default());
ExpertCategory.variables = function(param) {
    var slug = param.slug;
    return {
        slug: slug
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ExpertCategory);


/***/ }),

/***/ 82829:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30082);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23114);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78242);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_3__);




var ExpertGuide = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "expert";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | expert */ 877).then(__webpack_require__.bind(__webpack_require__, 9318));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(9318);
        }
        return eval("require.resolve")("./guide");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
});
ExpertGuide.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_3___default());
ExpertGuide.variables = function(param) {
    var slug = param.slug;
    return {
        slug: slug
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ExpertGuide);


/***/ }),

/***/ 53380:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30082);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23114);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6547);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_3__);




var ExpertLandingPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "expert";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | expert */ 877).then(__webpack_require__.bind(__webpack_require__, 32755));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(32755);
        }
        return eval("require.resolve")("./landing-page");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
});
ExpertLandingPage.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_3___default());
ExpertLandingPage.variables = function(param) {
    var marketCode = param.marketCode;
    // Configure popular categories here as a temp solution. These are only used in SE
    return {
        limit: marketCode === "se" ? 4 : 8,
        popCategories: [
            "horlurar",
            "barnvagnar",
            "mobiltelefoner",
            "schampo"
        ]
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ExpertLandingPage);


/***/ }),

/***/ 25485:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30082);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23114);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12551);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_3__);




var ExpertProductTest = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "expert";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | expert */ 877).then(__webpack_require__.bind(__webpack_require__, 2489));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(2489);
        }
        return eval("require.resolve")("./product-test");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
});
ExpertProductTest.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_3___default());
ExpertProductTest.variables = function(param) {
    var slug = param.slug;
    return {
        slug: slug
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ExpertProductTest);


/***/ }),

/***/ 4489:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30082);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23114);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62754);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_3__);




var ExpertProfile = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "expert";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | expert */ 877).then(__webpack_require__.bind(__webpack_require__, 94406));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(94406);
        }
        return eval("require.resolve")("./profile");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
});
ExpertProfile.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_3___default());
ExpertProfile.variables = function(param) {
    var slug = param.slug;
    return {
        slug: slug
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ExpertProfile);


/***/ }),

/***/ 42683:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30082);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23114);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63405);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_3__);




var ExpertToplists = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "expert";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | expert */ 877).then(__webpack_require__.bind(__webpack_require__, 77881));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(77881);
        }
        return eval("require.resolve")("./toplists");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
});
ExpertToplists.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_3___default());
ExpertToplists.variables = function(param) {
    var slug = param.slug;
    return {
        slug: slug
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ExpertToplists);


/***/ }),

/***/ 6416:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I0": () => (/* binding */ sendFailed),
/* harmony export */   "Ly": () => (/* binding */ FEEDBACK_SEND_SUCCESS),
/* harmony export */   "Wr": () => (/* binding */ sendSuccess),
/* harmony export */   "YB": () => (/* binding */ FEEDBACK_CLEAR_FORM),
/* harmony export */   "ZP": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "_d": () => (/* binding */ FEEDBACK_CLOSE),
/* harmony export */   "d2": () => (/* binding */ FEEDBACK_SEND_FAILED),
/* harmony export */   "fn": () => (/* binding */ reportWrongPrice),
/* harmony export */   "hy": () => (/* binding */ FEEDBACK_OPEN),
/* harmony export */   "ou": () => (/* binding */ clearForm),
/* harmony export */   "ph": () => (/* binding */ FEEDBACK_SEND_REQUEST),
/* harmony export */   "r_": () => (/* binding */ FEEDBACK_REPORT_WRONG_PRICE),
/* harmony export */   "wG": () => (/* binding */ sendRequest)
/* harmony export */ });
/* unused harmony export INTERCOM_START_CHAT */
var FEEDBACK_OPEN = "FEEDBACK_OPEN";
var FEEDBACK_CLOSE = "FEEDBACK_CLOSE";
var FEEDBACK_SEND_REQUEST = "FEEDBACK_SEND_REQUEST";
var FEEDBACK_SEND_SUCCESS = "FEEDBACK_SEND_SUCCESS";
var FEEDBACK_SEND_FAILED = "FEEDBACK_SEND_FAILED";
var FEEDBACK_CLEAR_FORM = "FEEDBACK_CLEAR_FORM";
var FEEDBACK_REPORT_WRONG_PRICE = "FEEDBACK_REPORT_WRONG_PRICE";
var INTERCOM_START_CHAT = "INTERCOM_START_CHAT";
var open = function() {
    return {
        type: FEEDBACK_OPEN
    };
};
var close = function() {
    return {
        type: FEEDBACK_CLOSE
    };
};
var startChat = function() {
    return {
        type: INTERCOM_START_CHAT
    };
};
var sendRequest = function(message) {
    return {
        type: FEEDBACK_SEND_REQUEST,
        message: message
    };
};
var sendSuccess = function() {
    return {
        type: FEEDBACK_SEND_SUCCESS
    };
};
var sendFailed = function(message) {
    return {
        type: FEEDBACK_SEND_FAILED,
        message: message
    };
};
var clearForm = function() {
    return {
        type: FEEDBACK_CLEAR_FORM
    };
};
var reportWrongPrice = function(message) {
    return {
        type: FEEDBACK_REPORT_WRONG_PRICE,
        message: message
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
    open: open,
    close: close,
    startChat: startChat,
    sendRequest: sendRequest
});


/***/ }),

/***/ 94680:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40507);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95939);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23114);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61093);
/* harmony import */ var _components_modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58203);
/* harmony import */ var _components_loader__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30082);
/* harmony import */ var _actions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6416);








var FeedbackForm = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "extra";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | extra */ 737).then(__webpack_require__.bind(__webpack_require__, 4087));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(4087);
        }
        return eval("require.resolve")("./components/feedback-form");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_loader__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, null)
});
var Feedback = function(param) {
    var feedback = param.feedback, close = param.close;
    return feedback.open === true ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_modal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        width: 800,
        isOpen: feedback.open,
        onRequestClose: close,
        key: "FeedbackFormModal"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(FeedbackForm, null)) : null;
};
Feedback.propTypes = {
    feedback: prop_types__WEBPACK_IMPORTED_MODULE_1___default().shape({
        open: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool)
    }),
    close: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func)
};
Feedback.defaultProps = {
    feedback: {
        open: false
    },
    close: src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .noop */ .ZT
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .connect */ .$j)(function(state) {
    return {
        feedback: state.feedback
    };
}, _actions__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(Feedback));


/***/ }),

/***/ 96644:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40507);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);


var Page = function(param) {
    var body = param.body;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("article", {
        dangerouslySetInnerHTML: {
            __html: body
        }
    });
};
Page.propTypes = {
    body: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string.isRequired)
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Page);


/***/ }),

/***/ 91762:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30082);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23114);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13278);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40507);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);





var InfoPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "info-page";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | info-page */ 241).then(__webpack_require__.bind(__webpack_require__, 92428));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(92428);
        }
        return eval("require.resolve")("./info-page");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
});
InfoPage.variables = function(param) {
    var id = param.id;
    return {
        id: id
    };
};
InfoPage.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_3___default());
InfoPage.loadOrder = [
    {}
];
InfoPage.propTypes = {
    data: prop_types__WEBPACK_IMPORTED_MODULE_4___default().shape({
        pageContent: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().any)
    })
};
InfoPage.defaultProps = {
    data: {
        pageContent: undefined
    }
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (InfoPage);


/***/ }),

/***/ 25334:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export queryToVariables */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23114);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30082);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25559);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_3__);
/* eslint-disable camelcase */ 



var KeywordLandingPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "keyword-landing-page";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | keyword-landing-page */ 46).then(__webpack_require__.bind(__webpack_require__, 88664));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(88664);
        }
        return eval("require.resolve")("./components");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, null)
});
/**
 * @param {string|undefined} variant
 */ function getProductNumberByVariant(variant) {
    if (!variant || variant === "baseline") return 100;
    return parseInt(variant.substring("items".length), 10);
}
var queryToVariables = function(vars) {
    var ref;
    var slug = vars.slug, query = vars.query;
    return {
        slug: slug,
        query: query ? decodeURI(query) : undefined,
        // set offset to 0 since we're not using pagination (yet)
        offset: 0,
        limit: getProductNumberByVariant((ref = vars.experiments["kwlp-limit-products"]) === null || ref === void 0 ? void 0 : ref.selectedVariant)
    };
};
KeywordLandingPage.variables = queryToVariables;
KeywordLandingPage.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_3___default());
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (KeywordLandingPage);


/***/ }),

/***/ 11782:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30082);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23114);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66120);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_3__);




var KeywordListingPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "keyword-listing";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | keyword-listing */ 56).then(__webpack_require__.bind(__webpack_require__, 13047));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(13047);
        }
        return eval("require.resolve")("./keyword-listing");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
});
KeywordListingPage.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_3___default());
KeywordListingPage.variables = function(param) {
    var id = param.id, limit = param.limit, random = param.random;
    return {
        ids: id.split(","),
        limit: typeof limit === "string" ? limit.replace(/[^\d]/g, "") : 3000,
        includeRandom: typeof random === "string" ? [
            "1",
            "true",
            "yes"
        ].includes(random.toLocaleLowerCase()) : false
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (KeywordListingPage);


/***/ }),

/***/ 25997:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30082);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23114);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77166);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_3__);




var LandingPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "landing-page";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | landing-page */ 781).then(__webpack_require__.bind(__webpack_require__, 29934));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(29934);
        }
        return eval("require.resolve")("./landing-page");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
});
LandingPage.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_3___default());
LandingPage.variables = function(param) {
    var featureToggle = param.featureToggle;
    var skip = featureToggle >= 1;
    return {
        skip: skip
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (LandingPage);


/***/ }),

/***/ 51478:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F_": () => (/* binding */ NAVIGATION_TOGGLE_MENU),
/* harmony export */   "ZP": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "m5": () => (/* binding */ NAVIGATION_CHANGE_CATEGORY)
/* harmony export */ });
/* unused harmony export NAVIGATION_OPEN_CATEGORY_LINK */
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var NAVIGATION_TOGGLE_MENU = "NAVIGATION_TOGGLE_MENU";
var NAVIGATION_CHANGE_CATEGORY = "NAVIGATION_CHANGE_CATEGORY";
var NAVIGATION_OPEN_CATEGORY_LINK = "NAVIGATION_OPEN_CATEGORY_LINK";
var toggleMenu = function(state) {
    return _objectSpreadProps(_objectSpread({}, state), {
        type: NAVIGATION_TOGGLE_MENU
    });
};
var changeCategory = function(state) {
    return _objectSpreadProps(_objectSpread({}, state), {
        type: NAVIGATION_CHANGE_CATEGORY
    });
};
var openCategoryLink = function(state) {
    return _objectSpreadProps(_objectSpread({}, state), {
        type: NAVIGATION_OPEN_CATEGORY_LINK
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
    toggleMenu: toggleMenu,
    changeCategory: changeCategory,
    openCategoryLink: openCategoryLink
});


/***/ }),

/***/ 59361:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CA": () => (/* binding */ NAVIGATE_FROM_MOBILE_MENU),
/* harmony export */   "FB": () => (/* binding */ SELECT_MOBILE_MENU_HISTORY),
/* harmony export */   "QU": () => (/* binding */ OPEN_MOBILE_MENU),
/* harmony export */   "ZP": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "bO": () => (/* binding */ SET_INITIAL_DATA),
/* harmony export */   "cL": () => (/* binding */ CHANGE_MOBILE_MENU_CATEGORIES),
/* harmony export */   "l2": () => (/* binding */ CLOSE_MOBILE_MENU)
/* harmony export */ });
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var OPEN_MOBILE_MENU = "OPEN_MOBILE_MENU";
var CLOSE_MOBILE_MENU = "CLOSE_MOBILE_MENU";
var NAVIGATE_FROM_MOBILE_MENU = "NAVIGATE_FROM_MOBILE_MENU";
var SET_INITIAL_DATA = "SET_INITIAL_MOBILE_MENU_DATA";
var CHANGE_MOBILE_MENU_CATEGORIES = "CHANGE_MOBILE_MENU_CATEGORIES";
var SELECT_MOBILE_MENU_HISTORY = "SELECT_MOBILE_MENU_HISTORY";
var openMenu = function() {
    return {
        type: OPEN_MOBILE_MENU
    };
};
var closeMenu = function() {
    return {
        type: CLOSE_MOBILE_MENU
    };
};
var navigateFromMobileMenu = function() {
    return {
        type: NAVIGATE_FROM_MOBILE_MENU
    };
};
var selectHistory = function(categoryId) {
    return {
        categoryId: categoryId,
        type: SELECT_MOBILE_MENU_HISTORY
    };
};
var setInitialData = function(categories) {
    return {
        categories: categories,
        type: SET_INITIAL_DATA
    };
};
var changeCategories = function(state) {
    return _objectSpreadProps(_objectSpread({}, state), {
        type: CHANGE_MOBILE_MENU_CATEGORIES
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
    openMenu: openMenu,
    closeMenu: closeMenu,
    navigateFromMobileMenu: navigateFromMobileMenu,
    selectHistory: selectHistory,
    setInitialData: setInitialData,
    changeCategories: changeCategories
});


/***/ }),

/***/ 37254:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30082);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23114);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48993);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_3__);




var productCollectionSitemap = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "product-collection";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | product-collection */ 603).then(__webpack_require__.bind(__webpack_require__, 18495));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(18495);
        }
        return eval("require.resolve")("./product-collection-sitemap");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
});
productCollectionSitemap.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_3___default());
productCollectionSitemap.loadOrder = [
    {
        main: true
    }
];
productCollectionSitemap.variables = function(param) {
    var slug = param.slug;
    return {
        slug: slug
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (productCollectionSitemap);


/***/ }),

/***/ 46294:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": () => (/* binding */ FILTER_PORTAL_ID),
/* harmony export */   "x": () => (/* binding */ PRODUCT_COLLECTION_LAYOUT)
/* harmony export */ });
var PRODUCT_COLLECTION_LAYOUT = "pj:productCollectionLayout";
var FILTER_PORTAL_ID = "sidebar-filter";


/***/ }),

/***/ 9543:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30082);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23114);
/* harmony import */ var query_string_for_all__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25932);
/* harmony import */ var query_string_for_all__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(query_string_for_all__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50699);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_4__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var ProductCollection = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "product-collection";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | product-collection */ 603).then(__webpack_require__.bind(__webpack_require__, 22413));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(22413);
        }
        return eval("require.resolve")("./product-collection");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
});
ProductCollection.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_4___default());
// TODO: once we decide how to go about product collection SSR state, we can remove this as well
ProductCollection.ssr = function(param) {
    var _state = param.state, state = _state === void 0 ? {
        aggregations: []
    } : _state, location = param.location;
    var ref = query_string_for_all__WEBPACK_IMPORTED_MODULE_3___default().parse(location.search), offset = ref.offset, sort = ref.sort, direction = ref.direction;
    return _objectSpreadProps(_objectSpread({}, state), {
        offset: parseInt(offset, 10) || 0,
        sort: sort,
        direction: direction,
        url: location.pathname + location.search,
        filters: []
    });
};
ProductCollection.variables = function(param) {
    var id = param.id, slug = param.slug, productPropertyIds = param.productPropertyIds;
    return {
        id: id,
        slug: slug,
        productPropertyIds: productPropertyIds
    };
};
// Calling this with an empty state object needs to match initial state of routeState in product-collection.tsx
ProductCollection.stateToVariables = function(state) {
    var ref;
    var _onlyFeaturedFilters;
    return {
        query: {
            url: state.url,
            // if the url is set, somewhere we extract the filters from the url
            filters: !state.url && state.filters ? state.filters : undefined,
            aggregations: state.aggregations,
            sort: state.sort,
            direction: state.direction,
            offset: state.offset,
            globalPropertySearch: state.globalPropertySearch
        },
        productPropertyIds: (ref = state.propertyColumnIds) === null || ref === void 0 ? void 0 : ref.filter(// SIMULATED_PROPERTY_COLUMNS
        function(column) {
            return ![
                "brand"
            ].includes(column);
        }),
        productPropertyColumnIds: state.propertyColumnIds,
        onlyFeaturedFilters: (_onlyFeaturedFilters = state.onlyFeaturedFilters) !== null && _onlyFeaturedFilters !== void 0 ? _onlyFeaturedFilters : true
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ProductCollection);


/***/ }),

/***/ 53358:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23114);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30082);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88273);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_3__);




var ProductComparePage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "product-compare";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | product-compare */ 373).then(__webpack_require__.bind(__webpack_require__, 70407));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(70407);
        }
        return eval("require.resolve")("./product-compare");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, null)
});
var ProductCompare = function() {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ProductComparePage, null);
};
// Max products value should not exceed limit in services/bff/src/resolvers/product/resolve.ts
ProductCompare.MAX_PRODUCTS = 12;
ProductCompare.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_3___default());
ProductCompare.variables = function(param) {
    var categoryId = param.categoryId, productIds = param.productIds;
    return {
        categoryId: categoryId || 0,
        fetchCategory: !!categoryId,
        productIds: typeof productIds !== "string" ? [] : productIds.split(",").map(function(item) {
            return parseInt(item, 10);
        }).filter(function(id, index, arr) {
            return !isNaN(id) && arr.indexOf(id) === index;
        }) // only keep unique, valid integers
        .slice(0, ProductCompare.MAX_PRODUCTS)
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ProductCompare);


/***/ }),

/***/ 82005:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Px": () => (/* binding */ productMediaSetPosition),
/* harmony export */   "WI": () => (/* binding */ productMediaOpen)
/* harmony export */ });
/* unused harmony exports PRODUCT_MEDIA_OPEN, PRODUCT_MEDIA_SET_POSITION */
var PRODUCT_MEDIA_OPEN = "PRODUCT_MEDIA_OPEN";
var PRODUCT_MEDIA_SET_POSITION = "PRODUCT_MEDIA_SET_POSITION";
var productMediaOpen = function(position) {
    return {
        type: PRODUCT_MEDIA_OPEN,
        show: true,
        position: position
    };
};
var productMediaSetPosition = function(position, param) {
    var action = param.action;
    return {
        type: PRODUCT_MEDIA_SET_POSITION,
        position: position,
        action: action
    };
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    productMediaOpen: productMediaOpen,
    productMediaSetPosition: productMediaSetPosition
});


/***/ }),

/***/ 66917:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30082);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23114);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40857);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52404);





var PublicList = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "lists";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | lists */ 422).then(__webpack_require__.bind(__webpack_require__, 60765));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(60765);
        }
        return eval("require.resolve")("./public-list");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
});
PublicList.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_3___default());
PublicList.variables = function(param) {
    var id = param.id, offset = param.offset;
    return {
        id: Number(id),
        limit: _constants__WEBPACK_IMPORTED_MODULE_4__/* .LIMIT */ .V,
        offset: offset !== undefined ? Number(offset) : 0
    };
};
PublicList.loadOrder = [
    {}
];
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (PublicList);


/***/ }),

/***/ 16288:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bs": () => (/* binding */ DELETE_SHOP_REVIEW),
/* harmony export */   "CA": () => (/* binding */ EDIT_SHOP_REVIEW),
/* harmony export */   "DT": () => (/* binding */ HIDE_SHOP_REVIEW_THANK_YOU),
/* harmony export */   "H1": () => (/* binding */ openReviewDialog),
/* harmony export */   "Hg": () => (/* binding */ SAVE_REVIEW_DRAFT),
/* harmony export */   "ID": () => (/* binding */ editShopReview),
/* harmony export */   "Jy": () => (/* binding */ editShopReviewSuccess),
/* harmony export */   "KW": () => (/* binding */ closeReviewDialog),
/* harmony export */   "Mf": () => (/* binding */ updateReviewSummary),
/* harmony export */   "RL": () => (/* binding */ LIKE_REVIEW_FAILED),
/* harmony export */   "TA": () => (/* binding */ deleteShopReviewSuccess),
/* harmony export */   "TF": () => (/* binding */ CLOSE_REVIEW_DIALOG),
/* harmony export */   "Ty": () => (/* binding */ deleteReviewSuccess),
/* harmony export */   "U9": () => (/* binding */ likeReviewSuccess),
/* harmony export */   "UW": () => (/* binding */ DELETE_SHOP_REVIEW_SUCCESS),
/* harmony export */   "UY": () => (/* binding */ LIKE_REVIEW_SUCCESS),
/* harmony export */   "XN": () => (/* binding */ likeReviewFailed),
/* harmony export */   "XU": () => (/* binding */ createReview),
/* harmony export */   "YM": () => (/* binding */ saveReviewDraft),
/* harmony export */   "Yf": () => (/* binding */ deleteShopReview),
/* harmony export */   "ZP": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "ar": () => (/* binding */ REPORT_REVIEW),
/* harmony export */   "b3": () => (/* binding */ OPEN_REVIEW_DIALOG),
/* harmony export */   "bg": () => (/* binding */ CREATE_REVIEW_SUCCESS),
/* harmony export */   "c1": () => (/* binding */ reportReviewFailed),
/* harmony export */   "cO": () => (/* binding */ EDIT_REVIEW_SUCCESS),
/* harmony export */   "e1": () => (/* binding */ UPDATE_REVIEW_DATA),
/* harmony export */   "eA": () => (/* binding */ CREATE_SHOP_REVIEW_SUCCESS),
/* harmony export */   "eX": () => (/* binding */ likeReviewToggle),
/* harmony export */   "ey": () => (/* binding */ createReviewSuccess),
/* harmony export */   "g0": () => (/* binding */ hideShopReviewThankYouDialog),
/* harmony export */   "g6": () => (/* binding */ DELETE_REVIEW_SUCCESS),
/* harmony export */   "hy": () => (/* binding */ EDIT_REVIEW),
/* harmony export */   "i0": () => (/* binding */ deleteReview),
/* harmony export */   "i_": () => (/* binding */ updateShopReviewData),
/* harmony export */   "kP": () => (/* binding */ editReview),
/* harmony export */   "kX": () => (/* binding */ editReviewSuccess),
/* harmony export */   "l3": () => (/* binding */ CREATE_REVIEW),
/* harmony export */   "mb": () => (/* binding */ CREATE_SHOP_REVIEW),
/* harmony export */   "n0": () => (/* binding */ reviewRequestError),
/* harmony export */   "qG": () => (/* binding */ reportReviewSuccess),
/* harmony export */   "rj": () => (/* binding */ createShopReview),
/* harmony export */   "s6": () => (/* binding */ EDIT_SHOP_REVIEW_SUCCESS),
/* harmony export */   "u9": () => (/* binding */ REVIEW_REQUEST_ERROR),
/* harmony export */   "vH": () => (/* binding */ LIKE_REVIEW_TOGGLE),
/* harmony export */   "y$": () => (/* binding */ DELETE_REVIEW),
/* harmony export */   "zM": () => (/* binding */ UPDATE_REVIEW_SUMMARY),
/* harmony export */   "zk": () => (/* binding */ createShopReviewSuccess)
/* harmony export */ });
/* unused harmony exports REPORT_REVIEW_SUCCESS, REPORT_REVIEW_FAILED, reportReview */
var CREATE_REVIEW = "CREATE_REVIEW";
var EDIT_REVIEW = "EDIT_REVIEW";
var DELETE_REVIEW = "DELETE_REVIEW";
var CREATE_REVIEW_SUCCESS = "CREATE_REVIEW_SUCCESS";
var EDIT_REVIEW_SUCCESS = "EDIT_REVIEW_SUCCESS";
var DELETE_REVIEW_SUCCESS = "DELETE_REVIEW_SUCCESS";
var OPEN_REVIEW_DIALOG = "OPEN_REVIEW_DIALOG";
var CLOSE_REVIEW_DIALOG = "CLOSE_REVIEW_DIALOG";
var REVIEW_REQUEST_ERROR = "REVIEW_REQUEST_ERROR";
var REPORT_REVIEW = "REPORT_REVIEW";
var REPORT_REVIEW_SUCCESS = "REPORT_REVIEW_SUCCESS";
var REPORT_REVIEW_FAILED = "REPORT_REVIEW_FAILED";
var LIKE_REVIEW_TOGGLE = "LIKE_REVIEW_TOGGLE";
var LIKE_REVIEW_SUCCESS = "LIKE_REVIEW_SUCCESS";
var LIKE_REVIEW_FAILED = "LIKE_REVIEW_FAILED";
var CREATE_SHOP_REVIEW = "CREATE_SHOP_REVIEW";
var CREATE_SHOP_REVIEW_SUCCESS = "CREATE_SHOP_REVIEW_SUCCESS";
var EDIT_SHOP_REVIEW = "EDIT_SHOP_REVIEW";
var EDIT_SHOP_REVIEW_SUCCESS = "EDIT_SHOP_REVIEW_SUCCESS";
var DELETE_SHOP_REVIEW = "DELETE_SHOP_REVIEW";
var DELETE_SHOP_REVIEW_SUCCESS = "DELETE_SHOP_REVIEW_SUCCESS";
var HIDE_SHOP_REVIEW_THANK_YOU = "HIDE_SHOP_REVIEW_THANK_YOU";
var UPDATE_REVIEW_SUMMARY = "UPDATE_REVIEW_SUMMARY";
var UPDATE_REVIEW_DATA = "UPDATE_REVIEW_DATA";
var SAVE_REVIEW_DRAFT = "SAVE_REVIEW_DRAFT";
var createReview = function(param) {
    var belongsToId = param.belongsToId, rating = param.rating, reviewType = param.reviewType, reviewText = param.reviewText, purchaseDate = param.purchaseDate, displayName = param.displayName;
    return {
        type: CREATE_REVIEW,
        belongsToId: belongsToId,
        rating: rating,
        reviewType: reviewType,
        reviewText: reviewText,
        purchaseDate: purchaseDate,
        displayName: displayName
    };
};
var createShopReview = function(param) {
    var belongsToId = param.belongsToId, belongsToName = param.belongsToName, rating = param.rating, reviewText = param.reviewText, purchaseDate = param.purchaseDate, answers = param.answers, email = param.email, displayName = param.displayName;
    return {
        type: CREATE_SHOP_REVIEW,
        reviewType: "STORE",
        belongsToId: belongsToId,
        belongsToName: belongsToName,
        rating: rating,
        reviewText: reviewText,
        purchaseDate: purchaseDate,
        answers: answers,
        email: email,
        displayName: displayName
    };
};
var createShopReviewSuccess = function(param) {
    var shopId = param.shopId;
    return {
        type: CREATE_SHOP_REVIEW_SUCCESS,
        shopId: shopId
    };
};
var hideShopReviewThankYouDialog = function() {
    return {
        type: HIDE_SHOP_REVIEW_THANK_YOU
    };
};
var editReview = function(param) {
    var reviewId = param.reviewId, belongsToId = param.belongsToId, reviewType = param.reviewType, rating = param.rating, reviewText = param.reviewText, purchaseDate = param.purchaseDate, location = param.location;
    return {
        type: EDIT_REVIEW,
        reviewId: reviewId,
        belongsToId: belongsToId,
        reviewType: reviewType,
        rating: rating,
        reviewText: reviewText,
        purchaseDate: purchaseDate,
        location: location
    };
};
var editShopReview = function(param) {
    var reviewId = param.reviewId, belongsToId = param.belongsToId, belongsToName = param.belongsToName, rating = param.rating, reviewText = param.reviewText, purchaseDate = param.purchaseDate, answers = param.answers, location = param.location;
    return {
        type: EDIT_SHOP_REVIEW,
        reviewType: "STORE",
        reviewId: reviewId,
        belongsToId: belongsToId,
        belongsToName: belongsToName,
        rating: rating,
        reviewText: reviewText,
        purchaseDate: purchaseDate,
        answers: answers,
        location: location
    };
};
var editShopReviewSuccess = function(param) {
    var shopId = param.shopId, location = param.location;
    return {
        type: EDIT_SHOP_REVIEW_SUCCESS,
        shopId: shopId,
        location: location
    };
};
var deleteReview = function(param) {
    var reviewId = param.reviewId, belongsToId = param.belongsToId, reviewType = param.reviewType, location = param.location;
    return {
        type: DELETE_REVIEW,
        reviewId: reviewId,
        reviewType: reviewType,
        belongsToId: belongsToId,
        location: location
    };
};
var deleteShopReview = function(param) {
    var reviewId = param.reviewId, shopId = param.shopId, shopName = param.shopName, location = param.location;
    return {
        type: DELETE_SHOP_REVIEW,
        reviewId: reviewId,
        shopId: shopId,
        shopName: shopName,
        location: location
    };
};
var deleteShopReviewSuccess = function(param) {
    var shopId = param.shopId, location = param.location;
    return {
        type: DELETE_SHOP_REVIEW_SUCCESS,
        shopId: shopId,
        location: location
    };
};
var createReviewSuccess = function(param) {
    var productId = param.productId;
    return {
        type: CREATE_REVIEW_SUCCESS,
        productId: productId
    };
};
var editReviewSuccess = function(param) {
    var productId = param.productId, location = param.location;
    return {
        type: EDIT_REVIEW_SUCCESS,
        productId: productId,
        location: location
    };
};
var deleteReviewSuccess = function(param) {
    var productId = param.productId, location = param.location;
    return {
        type: DELETE_REVIEW_SUCCESS,
        productId: productId,
        location: location
    };
};
var updateReviewSummary = function(summary) {
    return {
        type: UPDATE_REVIEW_SUMMARY,
        summary: summary
    };
};
var updateShopReviewData = function(param) {
    var shopId = param.shopId, productId = param.productId, nodes = param.nodes, myReview = param.myReview;
    return {
        type: UPDATE_REVIEW_DATA,
        shopId: shopId,
        productId: productId,
        nodes: nodes,
        myReview: myReview
    };
};
var openReviewDialog = function(uid) {
    return {
        type: OPEN_REVIEW_DIALOG,
        uid: uid
    };
};
var closeReviewDialog = function() {
    return {
        type: CLOSE_REVIEW_DIALOG
    };
};
var reviewRequestError = function(errorCode) {
    return {
        type: REVIEW_REQUEST_ERROR,
        errorCode: errorCode
    };
};
var reportReview = function(reviewId, message, email) {
    return {
        type: REPORT_REVIEW,
        reviewId: reviewId,
        message: message,
        email: email
    };
};
var reportReviewSuccess = function() {
    return {
        type: REPORT_REVIEW_SUCCESS
    };
};
var reportReviewFailed = function(message) {
    return {
        type: REPORT_REVIEW_FAILED,
        message: message
    };
};
var likeReviewToggle = function(id, reviewType) {
    return {
        type: LIKE_REVIEW_TOGGLE,
        id: id,
        reviewType: reviewType
    };
};
var likeReviewSuccess = function(id, value) {
    return {
        type: LIKE_REVIEW_SUCCESS,
        id: id,
        value: value
    };
};
var likeReviewFailed = function() {
    return {
        type: LIKE_REVIEW_FAILED
    };
};
var saveReviewDraft = function(draft) {
    return {
        type: SAVE_REVIEW_DRAFT,
        draft: draft
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
    editReview: editReview,
    createReview: createReview,
    deleteReview: deleteReview,
    openReviewDialog: openReviewDialog,
    closeReviewDialog: closeReviewDialog,
    reportReview: reportReview,
    reportReviewSuccess: reportReviewSuccess,
    reportReviewFailed: reportReviewFailed
});


/***/ }),

/***/ 30400:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SL": () => (/* binding */ SET_SEARCH_BAR_IN_HERO),
/* harmony export */   "V7": () => (/* binding */ setSearchBarInHero),
/* harmony export */   "ZP": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony exports SEARCH_SAVE, CLEAR_RECENT, ENTER_SEARCH_MENU, EXIT_SEARCH_MENU, SEARCH_RESULT_CLICK_FULL, SEARCH_RESULT_CLICK_MENU, SEARCH_INPUT_QUERY, SUGGESTION_CLICK, SEARCH_CLICK, SEARCH_FOCUS, SEARCH_BLUR, SEARCH_FILTER, SEARCH_SORT, searchFetchError */
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var SEARCH_SAVE = "SEARCH_SAVE";
var CLEAR_RECENT = "SEARCH_CLEAR_RECENT";
var ENTER_SEARCH_MENU = "ENTER_SEARCH_MENU";
var EXIT_SEARCH_MENU = "EXIT_SEARCH_MENU";
var SEARCH_RESULT_CLICK_FULL = "SEARCH_RESULT_CLICK_FULL";
var SEARCH_RESULT_CLICK_MENU = "SEARCH_RESULT_CLICK_MENU";
var SEARCH_INPUT_QUERY = "SEARCH_INPUT_QUERY";
var SUGGESTION_CLICK = "SUGGESTION_CLICK";
var SEARCH_CLICK = "SEARCH_CLICK";
var SEARCH_FOCUS = "SEARCH_FOCUS";
var SEARCH_BLUR = "SEARCH_BLUR";
var SEARCH_FILTER = "SEARCH_FILTER";
var SEARCH_SORT = "SEARCH_SORT";
var SET_SEARCH_BAR_IN_HERO = "SET_SEARCH_BAR_IN_HERO";
var searchSave = function(query) {
    return {
        type: SEARCH_SAVE,
        query: query
    };
};
var clearRecent = function(content) {
    return {
        type: CLEAR_RECENT,
        content: content
    };
};
var suggestionClick = function(suggestionType, position) {
    return {
        type: SUGGESTION_CLICK,
        suggestion: suggestionType,
        reciprocalRank: 1 / position
    };
};
var searchClick = function(position) {
    return {
        type: SEARCH_CLICK,
        reciprocalRank: 1 / position
    };
};
var searchFilter = function(section) {
    return {
        type: SEARCH_FILTER,
        section: section
    };
};
var searchSort = function(sort) {
    return {
        type: SEARCH_SORT,
        sort: sort
    };
};
var searchFocus = function() {
    return {
        type: SEARCH_FOCUS
    };
};
var searchBlur = function() {
    return {
        type: SEARCH_BLUR
    };
};
var searchInstant = function(action, query, didYouMean) {
    var data = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return _objectSpread({
        type: "SEARCH_INSTANT",
        action: action,
        query: [
            query,
            didYouMean
        ].filter(function(x) {
            return x;
        }).join(" → ")
    }, data);
};
var enterSearchMenu = function() {
    return {
        type: ENTER_SEARCH_MENU
    };
};
var exitSearchMenu = function() {
    return {
        type: EXIT_SEARCH_MENU
    };
};
var searchResultClick = function(actionName) {
    return function(resultType, item) {
        return {
            type: actionName,
            data: {
                type: resultType,
                item: item
            }
        };
    };
};
var searchInputQuery = function(query) {
    return {
        type: SEARCH_INPUT_QUERY,
        data: {
            query: query
        }
    };
};
var setSearchBarInHero = function(state) {
    return {
        type: SET_SEARCH_BAR_IN_HERO,
        state: state
    };
};
var searchFetchError = function(error) {
    return {
        type: "SEARCH_FETCH_ERROR",
        error: error
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
    searchInstant: searchInstant,
    suggestionClick: suggestionClick,
    searchClick: searchClick,
    searchFocus: searchFocus,
    searchBlur: searchBlur,
    searchSave: searchSave,
    clearRecent: clearRecent,
    enterSearchMenu: enterSearchMenu,
    exitSearchMenu: exitSearchMenu,
    searchResultClick: searchResultClick,
    searchInputQuery: searchInputQuery,
    searchFilter: searchFilter,
    searchSort: searchSort
});


/***/ }),

/***/ 93600:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export queryToVariables */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30082);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23114);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13897);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_3__);
/* eslint-disable camelcase */ 



var SearchPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "search";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | search */ 464).then(__webpack_require__.bind(__webpack_require__, 65967));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(65967);
        }
        return eval("require.resolve")("./components/results");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
});
SearchPage.mergeData = function(_, newData) {
    return newData;
};
var queryToVariables = function(param) {
    var _search = param.search, search = _search === void 0 ? "" : _search, _offset = param.offset, offset = _offset === void 0 ? 0 : _offset, _sort = param.sort, sort = _sort === void 0 ? "" : _sort, _category_id = param.category_id, category_id = _category_id === void 0 ? "" : _category_id, _brand_id = param.brand_id, brand_id = _brand_id === void 0 ? "" : _brand_id, _rating_id = param.rating_id, rating_id = _rating_id === void 0 ? "" : _rating_id, _price_id = param.price_id, price_id = _price_id === void 0 ? "" : _price_id, _deals_id = param.deals_id, deals_id = _deals_id === void 0 ? "" : _deals_id, _availability_id = param.availability_id, availability_id = _availability_id === void 0 ? "" : _availability_id, _lowest_price = param.lowest_price, lowest_price = _lowest_price === void 0 ? "" : _lowest_price, _user_rating = param.user_rating, user_rating = _user_rating === void 0 ? "" : _user_rating, _product_detail = param.product_detail, product_detail = _product_detail === void 0 ? "" : _product_detail, _experiments = param.experiments, experiments = _experiments === void 0 ? [] : _experiments, marketCode = param.marketCode;
    var ref;
    var ref1;
    var allProductsFilter = (ref1 = ((ref = experiments["search-page-all-products-searchable"]) === null || ref === void 0 ? void 0 : ref.selectedVariant) === "allProducts") !== null && ref1 !== void 0 ? ref1 : false;
    return {
        id: "search",
        query: search,
        sort: sort.split(":")[0] || "score",
        order: sort.split(":")[1] || "desc",
        offset: parseInt(offset, 10),
        limit: 48,
        filters: [
            {
                id: "category_id",
                selected: category_id.split(",").filter(Boolean)
            },
            {
                id: "brand_id",
                selected: brand_id.split(",").filter(Boolean)
            },
            {
                id: "lowest_price",
                from: parseInt(lowest_price.split(",")[0], 10) || undefined,
                to: parseInt(lowest_price.split(",")[1], 10) || undefined
            },
            {
                id: "user_rating",
                from: parseInt(user_rating.split(",")[0], 10) || undefined,
                to: parseInt(user_rating.split(",")[1], 10) || undefined
            }
        ],
        productModes: [
            "product",
            "raw"
        ],
        categoryFilters: category_id.split(",").filter(Boolean),
        brandFilters: brand_id.split(",").filter(Boolean),
        ratingFilters: rating_id.split(",").filter(Boolean),
        priceFilters: price_id.split(",").filter(Boolean),
        dealsFilters: deals_id.split(",").filter(Boolean),
        availabilityFilters: availability_id.split(",").filter(Boolean),
        productDetailFilters: product_detail.split(",").filter(Boolean),
        getExperts: marketCode !== "nz",
        allProductsFilter: allProductsFilter
    };
};
SearchPage.variables = queryToVariables;
SearchPage.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_3___default());
SearchPage.loadOrder = [
    {}
];
SearchPage.group = function(param) {
    var name = param.name, variables = param.variables;
    var groupVariables = variables ? Object.keys(variables).filter(function(key) {
        return [
            "query",
            "sort",
            "order",
            "offset"
        ].indexOf(key) > -1;
    }).map(function(key) {
        return variables[key];
    }) : [];
    var filterVariables = variables && variables.filters ? variables.filters.map(function(filter) {
        switch(filter.id){
            case "category_id":
            case "brand_id":
                return "".concat(filter.id, ":").concat(filter.selected);
            case "lowest_price":
            case "user_rating":
                return "".concat(filter.id, ":").concat(filter.from, ":").concat(filter.to);
            default:
                return filter.id;
        }
    }) : [];
    return "".concat(name, "_").concat(groupVariables.join("_"), "_").concat(filterVariables.join("_"));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SearchPage);


/***/ }),

/***/ 60473:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": () => (/* binding */ ShopOfTheYearLandingPage)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30082);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23114);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99230);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_3__);




var ShopOfTheYearLandingPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "shop-of-the-year";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | shop-of-the-year */ 406).then(__webpack_require__.bind(__webpack_require__, 26108));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(26108);
        }
        return eval("require.resolve")("./components/landing-page");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
});
ShopOfTheYearLandingPage.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_3___default());
ShopOfTheYearLandingPage.variables = function(param) {
    var section = param.section;
    return {
        section: section
    };
};



/***/ }),

/***/ 83846:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$_": () => (/* binding */ REMOVE_ALERT_SUCCESS),
/* harmony export */   "$b": () => (/* binding */ createAlertRequest),
/* harmony export */   "$x": () => (/* binding */ REMOVE_ALERT_REQUEST),
/* harmony export */   "Jl": () => (/* binding */ restoreAlertSuccess),
/* harmony export */   "Oi": () => (/* binding */ CREATE_ALERT_REQUEST),
/* harmony export */   "SU": () => (/* binding */ openAlerts),
/* harmony export */   "TI": () => (/* binding */ removeAlertError),
/* harmony export */   "VG": () => (/* binding */ OPEN_ALERTS),
/* harmony export */   "VL": () => (/* binding */ CREATE_ALERT_FAILED),
/* harmony export */   "Vp": () => (/* binding */ CLOSE_ALERTS),
/* harmony export */   "XJ": () => (/* binding */ REMOVE_ALERT_ERROR),
/* harmony export */   "Yo": () => (/* binding */ RESTORE_ALERT_SUCCESS),
/* harmony export */   "Zl": () => (/* binding */ sortAlerts),
/* harmony export */   "_X": () => (/* binding */ removeAlertSuccess),
/* harmony export */   "ej": () => (/* binding */ SORT_ALERTS),
/* harmony export */   "f9": () => (/* binding */ RESTORE_ALERT_REQUEST),
/* harmony export */   "fZ": () => (/* binding */ createAlertFailed),
/* harmony export */   "g": () => (/* binding */ restoreAlertError),
/* harmony export */   "mx": () => (/* binding */ CREATE_ALERT_SUCCESS),
/* harmony export */   "s$": () => (/* binding */ removeAlertRequest),
/* harmony export */   "th": () => (/* binding */ restoreAlertRequest),
/* harmony export */   "w4": () => (/* binding */ createAlertSuccess),
/* harmony export */   "ys": () => (/* binding */ closeAlerts)
/* harmony export */ });
/* unused harmony export RESTORE_ALERT_ERROR */
var REMOVE_ALERT_REQUEST = "REMOVE_ALERT_REQUEST";
var REMOVE_ALERT_SUCCESS = "REMOVE_ALERT_SUCCESS";
var REMOVE_ALERT_ERROR = "REMOVE_ALERT_ERROR";
var RESTORE_ALERT_REQUEST = "RESTORE_ALERT_REQUEST";
var RESTORE_ALERT_SUCCESS = "RESTORE_ALERT_SUCCESS";
var RESTORE_ALERT_ERROR = "RESTORE_ALERT_ERROR";
var CREATE_ALERT_REQUEST = "CREATE_ALERT_REQUEST";
var CREATE_ALERT_SUCCESS = "CREATE_ALERT_SUCCESS";
var CREATE_ALERT_FAILED = "CREATE_ALERT_FAILED";
var SORT_ALERTS = "SORT_ALERTS";
var OPEN_ALERTS = "OPEN_ALERTS";
var CLOSE_ALERTS = "CLOSE_ALERTS";
var createAlertRequest = function(data, onSuccess) {
    return {
        type: CREATE_ALERT_REQUEST,
        data: data,
        onSuccess: onSuccess
    };
};
var createAlertSuccess = function(id, productId) {
    return {
        type: CREATE_ALERT_SUCCESS,
        id: id,
        productId: productId
    };
};
var createAlertFailed = function(error) {
    return {
        type: CREATE_ALERT_FAILED,
        error: error
    };
};
var removeAlertRequest = function(id, productId, onSuccess) {
    return {
        type: REMOVE_ALERT_REQUEST,
        id: id,
        productId: productId,
        onSuccess: onSuccess
    };
};
var removeAlertSuccess = function(restoreToken, id, productId) {
    return {
        type: REMOVE_ALERT_SUCCESS,
        restoreToken: restoreToken,
        id: id,
        productId: productId
    };
};
var restoreAlertRequest = function(restoreToken, id, productId) {
    return {
        type: RESTORE_ALERT_REQUEST,
        restoreToken: restoreToken,
        id: id,
        productId: productId
    };
};
var restoreAlertSuccess = function(restoreToken, id, productId) {
    return {
        type: RESTORE_ALERT_SUCCESS,
        restoreToken: restoreToken,
        id: id,
        productId: productId
    };
};
var restoreAlertError = function(error) {
    return {
        type: RESTORE_ALERT_ERROR,
        error: error
    };
};
var removeAlertError = function(error) {
    return {
        type: REMOVE_ALERT_ERROR,
        error: error
    };
};
var sortAlerts = function(sort) {
    return {
        type: SORT_ALERTS,
        sort: sort
    };
};
var openAlerts = function() {
    return {
        type: OPEN_ALERTS,
        open: true
    };
};
var closeAlerts = function() {
    return {
        type: CLOSE_ALERTS,
        open: false
    };
};


/***/ }),

/***/ 7966:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": () => (/* binding */ toggleFilter),
/* harmony export */   "m": () => (/* binding */ TOGGLE_FILTER)
/* harmony export */ });
var TOGGLE_FILTER = "TOGGLE_FILTER";
var toggleFilter = function() {
    return {
        type: TOGGLE_FILTER
    };
};


/***/ }),

/***/ 40054:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A3": () => (/* binding */ restoreListItemSuccess),
/* harmony export */   "B3": () => (/* binding */ RESTORE_LIST_ITEM_SUCCESS),
/* harmony export */   "Ce": () => (/* binding */ EDIT_LIST_SUCCESS),
/* harmony export */   "DU": () => (/* binding */ removeListItemRequest),
/* harmony export */   "En": () => (/* binding */ ADD_LIST_ITEM_REQUEST),
/* harmony export */   "Fc": () => (/* binding */ OPEN_LISTS),
/* harmony export */   "Fz": () => (/* binding */ selectList),
/* harmony export */   "GB": () => (/* binding */ EDIT_LIST_REQUEST),
/* harmony export */   "GV": () => (/* binding */ CLOSE_LISTS),
/* harmony export */   "Gr": () => (/* binding */ importListToMyProducts),
/* harmony export */   "Kj": () => (/* binding */ CREATE_LIST_SUCCESS),
/* harmony export */   "Lj": () => (/* binding */ restoreListRequest),
/* harmony export */   "Ll": () => (/* binding */ removeListError),
/* harmony export */   "M1": () => (/* binding */ createListError),
/* harmony export */   "M2": () => (/* binding */ removeListItemSuccess),
/* harmony export */   "Mr": () => (/* binding */ removeListSuccess),
/* harmony export */   "N$": () => (/* binding */ REMOVE_LIST_REQUEST),
/* harmony export */   "Ne": () => (/* binding */ RESTORE_LIST_REQUEST),
/* harmony export */   "Od": () => (/* binding */ OPEN_LIST_SETTINGS),
/* harmony export */   "Og": () => (/* binding */ REMOVE_LIST_ERROR),
/* harmony export */   "Oz": () => (/* binding */ REMOVE_LIST_ITEM_ERROR),
/* harmony export */   "P": () => (/* binding */ editListSuccess),
/* harmony export */   "Po": () => (/* binding */ ORDER_LISTS_REQUEST),
/* harmony export */   "QE": () => (/* binding */ CREATE_LIST_REQUEST),
/* harmony export */   "RP": () => (/* binding */ restoreListItemRequest),
/* harmony export */   "T3": () => (/* binding */ SELECT_LIST),
/* harmony export */   "WI": () => (/* binding */ restoreListError),
/* harmony export */   "WT": () => (/* binding */ addListItemError),
/* harmony export */   "Zh": () => (/* binding */ SORT_LIST),
/* harmony export */   "_8": () => (/* binding */ importListToMyProductsSuccess),
/* harmony export */   "aF": () => (/* binding */ REMOVE_LIST_ITEM_REQUEST),
/* harmony export */   "c": () => (/* binding */ closeLists),
/* harmony export */   "f$": () => (/* binding */ removeListItemError),
/* harmony export */   "fS": () => (/* binding */ sortList),
/* harmony export */   "gK": () => (/* binding */ RESTORE_LIST_SUCCESS),
/* harmony export */   "hg": () => (/* binding */ addListItemRequest),
/* harmony export */   "if": () => (/* binding */ addItemToMyProductsRequest),
/* harmony export */   "iw": () => (/* binding */ REMOVE_LIST_ITEM_SUCCESS),
/* harmony export */   "j3": () => (/* binding */ addListItemSuccess),
/* harmony export */   "jk": () => (/* binding */ orderListItemsRequest),
/* harmony export */   "jy": () => (/* binding */ closeListSettings),
/* harmony export */   "ng": () => (/* binding */ removeListRequest),
/* harmony export */   "oN": () => (/* binding */ orderListsRequest),
/* harmony export */   "pU": () => (/* binding */ EDIT_LIST_ERROR),
/* harmony export */   "pd": () => (/* binding */ ADD_LIST_ITEM_SUCCESS),
/* harmony export */   "pn": () => (/* binding */ restoreListItemError),
/* harmony export */   "pu": () => (/* binding */ openLists),
/* harmony export */   "qB": () => (/* binding */ RESTORE_LIST_ITEM_REQUEST),
/* harmony export */   "qR": () => (/* binding */ IMPORT_LIST_TO_MY_PRODUCTS_SUCCESS),
/* harmony export */   "qe": () => (/* binding */ restoreListSuccess),
/* harmony export */   "re": () => (/* binding */ createListSuccess),
/* harmony export */   "sh": () => (/* binding */ REMOVE_LIST_SUCCESS),
/* harmony export */   "sy": () => (/* binding */ IMPORT_LIST_TO_MY_PRODUCTS),
/* harmony export */   "tH": () => (/* binding */ editListError),
/* harmony export */   "vz": () => (/* binding */ openListSettings),
/* harmony export */   "w": () => (/* binding */ ORDER_LIST_ITEMS_REQUEST),
/* harmony export */   "xC": () => (/* binding */ ADD_ITEM_TO_MY_PRODUCTS_REQUEST),
/* harmony export */   "xb": () => (/* binding */ editListRequest),
/* harmony export */   "y$": () => (/* binding */ CLOSE_LIST_SETTINGS),
/* harmony export */   "zD": () => (/* binding */ ADD_LIST_ITEM_ERROR)
/* harmony export */ });
/* unused harmony exports RESTORE_LIST_ITEM_ERROR, RESTORE_LIST_ERROR, CREATE_LIST_ERROR, createListRequest */
var ADD_LIST_ITEM_REQUEST = "ADD_LIST_ITEM_REQUEST";
var ADD_LIST_ITEM_SUCCESS = "ADD_LIST_ITEM_SUCCESS";
var ADD_LIST_ITEM_ERROR = "ADD_LIST_ITEM_ERROR";
var REMOVE_LIST_ITEM_REQUEST = "REMOVE_LIST_ITEM_REQUEST";
var REMOVE_LIST_ITEM_SUCCESS = "REMOVE_LIST_ITEM_SUCCESS";
var REMOVE_LIST_ITEM_ERROR = "REMOVE_LIST_ITEM_ERROR";
var RESTORE_LIST_ITEM_REQUEST = "RESTORE_LIST_ITEM_REQUEST";
var RESTORE_LIST_ITEM_SUCCESS = "RESTORE_LIST_ITEM_SUCCESS";
var RESTORE_LIST_ITEM_ERROR = "RESTORE_LIST_ITEM_ERROR";
var REMOVE_LIST_REQUEST = "REMOVE_LIST_REQUEST";
var REMOVE_LIST_SUCCESS = "REMOVE_LIST_SUCCESS";
var REMOVE_LIST_ERROR = "REMOVE_LIST_ERROR";
var RESTORE_LIST_REQUEST = "RESTORE_LIST_REQUEST";
var RESTORE_LIST_SUCCESS = "RESTORE_LIST_SUCCESS";
var RESTORE_LIST_ERROR = "RESTORE_LIST_ERROR";
var CREATE_LIST_REQUEST = "CREATE_LIST_REQUEST";
var CREATE_LIST_SUCCESS = "CREATE_LIST_SUCCESS";
var CREATE_LIST_ERROR = "CREATE_LIST_ERROR";
var EDIT_LIST_REQUEST = "EDIT_LIST_REQUEST";
var EDIT_LIST_SUCCESS = "EDIT_LIST_SUCCESS";
var EDIT_LIST_ERROR = "EDIT_LIST_ERROR";
var SORT_LIST = "SORT_LIST";
var SELECT_LIST = "SELECT_LIST";
var OPEN_LISTS = "OPEN_LISTS";
var CLOSE_LISTS = "CLOSE_LISTS";
var ORDER_LISTS_REQUEST = "ORDER_LISTS_REQUEST";
var ORDER_LIST_ITEMS_REQUEST = "ORDER_LIST_ITEMS_REQUEST";
var ADD_ITEM_TO_MY_PRODUCTS_REQUEST = "ADD_ITEM_TO_MY_PRODUCTS_REQUEST";
var IMPORT_LIST_TO_MY_PRODUCTS = "IMPORT_LIST_TO_MY_PRODUCTS";
var IMPORT_LIST_TO_MY_PRODUCTS_SUCCESS = "IMPORT_LIST_TO_MY_PRODUCTS_SUCCESS";
var OPEN_LIST_SETTINGS = "OPEN_LIST_SETTINGS";
var CLOSE_LIST_SETTINGS = "CLOSE_LIST_SETTINGS";
var addListItemRequest = function(productId, productName, isDesktop) {
    return {
        type: ADD_LIST_ITEM_REQUEST,
        productId: productId,
        productName: productName,
        isDesktop: isDesktop
    };
};
var addListItemSuccess = function(id) {
    return {
        type: ADD_LIST_ITEM_SUCCESS,
        id: id
    };
};
var addListItemError = function(error) {
    return {
        type: ADD_LIST_ITEM_ERROR,
        error: error
    };
};
var removeListItemRequest = function(id, listId) {
    return {
        type: REMOVE_LIST_ITEM_REQUEST,
        id: id,
        listId: listId
    };
};
var removeListItemSuccess = function(restoreToken, id, listId) {
    return {
        type: REMOVE_LIST_ITEM_SUCCESS,
        restoreToken: restoreToken,
        id: id,
        listId: listId
    };
};
var removeListItemError = function(error) {
    return {
        type: REMOVE_LIST_ITEM_ERROR,
        error: error
    };
};
var restoreListItemRequest = function(id, restoreToken) {
    return {
        type: RESTORE_LIST_ITEM_REQUEST,
        restoreToken: restoreToken,
        id: id
    };
};
var restoreListItemSuccess = function(id, restoreToken) {
    return {
        type: RESTORE_LIST_ITEM_SUCCESS,
        id: id,
        restoreToken: restoreToken
    };
};
var restoreListItemError = function(error) {
    return {
        type: RESTORE_LIST_ITEM_ERROR,
        error: error
    };
};
var removeListRequest = function(id) {
    return {
        type: REMOVE_LIST_REQUEST,
        id: id
    };
};
var removeListSuccess = function(restoreToken, id) {
    return {
        type: REMOVE_LIST_SUCCESS,
        restoreToken: restoreToken,
        id: id
    };
};
var removeListError = function(error) {
    return {
        type: REMOVE_LIST_ERROR,
        error: error
    };
};
var restoreListRequest = function(id, restoreToken) {
    return {
        type: RESTORE_LIST_REQUEST,
        restoreToken: restoreToken,
        id: id
    };
};
var restoreListSuccess = function(id, restoreToken) {
    return {
        type: RESTORE_LIST_SUCCESS,
        id: id,
        restoreToken: restoreToken
    };
};
var restoreListError = function(error) {
    return {
        type: RESTORE_LIST_ERROR,
        error: error
    };
};
var createListRequest = function(listName) {
    return {
        type: CREATE_LIST_REQUEST,
        listName: listName
    };
};
var createListSuccess = function(list) {
    return {
        type: CREATE_LIST_SUCCESS,
        list: list
    };
};
var createListError = function(error) {
    return {
        type: CREATE_LIST_ERROR,
        error: error
    };
};
var editListRequest = function(id, name, visibility) {
    return {
        type: EDIT_LIST_REQUEST,
        id: id,
        name: name,
        visibility: visibility
    };
};
var editListSuccess = function(list) {
    return {
        type: EDIT_LIST_SUCCESS,
        list: list
    };
};
var editListError = function(error) {
    return {
        type: EDIT_LIST_ERROR,
        error: error
    };
};
var sortList = function(sort) {
    return {
        type: SORT_LIST,
        sort: sort
    };
};
var selectList = function(id) {
    return {
        type: SELECT_LIST,
        id: id
    };
};
var openLists = function() {
    return {
        type: OPEN_LISTS,
        open: true
    };
};
var closeLists = function() {
    return {
        type: CLOSE_LISTS,
        open: false
    };
};
var orderListsRequest = function(listIds) {
    return {
        type: ORDER_LISTS_REQUEST,
        listIds: listIds
    };
};
var orderListItemsRequest = function(listId, listItemIds) {
    return {
        type: ORDER_LIST_ITEMS_REQUEST,
        listId: listId,
        listItemIds: listItemIds
    };
};
var addItemToMyProductsRequest = function(productId, productName, isDesktop) {
    return {
        type: ADD_ITEM_TO_MY_PRODUCTS_REQUEST,
        productId: productId,
        productName: productName,
        isDesktop: isDesktop
    };
};
var importListToMyProducts = function(listId) {
    return {
        type: IMPORT_LIST_TO_MY_PRODUCTS,
        listId: listId
    };
};
var importListToMyProductsSuccess = function() {
    return {
        type: IMPORT_LIST_TO_MY_PRODUCTS_SUCCESS
    };
};
var openListSettings = function() {
    return {
        type: OPEN_LIST_SETTINGS
    };
};
var closeListSettings = function() {
    return {
        type: CLOSE_LIST_SETTINGS
    };
};


/***/ }),

/***/ 82642:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": () => (/* binding */ setMobileSidebarView),
/* harmony export */   "e": () => (/* binding */ SET_MOBILE_SIDEBAR_VIEW)
/* harmony export */ });
var SET_MOBILE_SIDEBAR_VIEW = "SET_MOBILE_SIDEBAR_VIEW";
var setMobileSidebarView = function(view) {
    return {
        type: SET_MOBILE_SIDEBAR_VIEW,
        currentView: view
    };
};


/***/ }),

/***/ 28319:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30082);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23114);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96398);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_3__);




var StorePage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "store";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | store */ 687).then(__webpack_require__.bind(__webpack_require__, 63449));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(63449);
        }
        return eval("require.resolve")("./store");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
});
StorePage.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_3___default());
StorePage.variables = function(param) {
    var id = param.id, notification = param.notification;
    return {
        id: typeof id === "number" ? id : parseInt(id, 10),
        offset: 0,
        // Invalidate store reviews cache if anonymous review was verified
        invalidateCache: notification === "verify-success" || notification === "delete-success",
        userReviewFilter: "ALL"
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (StorePage);


/***/ }),

/***/ 96283:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "uJ": () => (/* binding */ ADD_INTEREST),
/* harmony export */   "w_": () => (/* binding */ REMOVE_INTEREST)
/* harmony export */ });
var REMOVE_INTEREST = "REMOVE_INTEREST";
var ADD_INTEREST = "ADD_INTEREST";
var removeInterest = function(id) {
    return {
        type: REMOVE_INTEREST,
        id: id
    };
};
var addInterest = function(id) {
    return {
        type: ADD_INTEREST,
        id: id
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
    removeInterest: removeInterest,
    addInterest: addInterest
});


/***/ }),

/***/ 69399:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WD": () => (/* binding */ TRACKING_TOGGLE_SAVE_SUCCESS),
/* harmony export */   "ZP": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "Zm": () => (/* binding */ TRACKING_TOGGLE_CHANGE),
/* harmony export */   "_3": () => (/* binding */ TRACKING_TOGGLE_SAVE_ERROR),
/* harmony export */   "fg": () => (/* binding */ TRACKING_TOGGLE_SAVE)
/* harmony export */ });
/* unused harmony export TRACKING_TOGGLE_CHANGE_SUCCESS */
var TRACKING_TOGGLE_CHANGE = "TRACKING_TOGGLE_CHANGE";
var TRACKING_TOGGLE_CHANGE_SUCCESS = "TRACKING_TOGGLE_CHANGE_SUCCESS";
var TRACKING_TOGGLE_SAVE = "TRACKING_TOGGLE_SAVE";
var TRACKING_TOGGLE_SAVE_SUCCESS = "TRACKING_TOGGLE_SUCCESS";
var TRACKING_TOGGLE_SAVE_ERROR = "TRACKING_TOGGLE_ERROR";
var trackingToggleChange = function(name, active) {
    return {
        type: TRACKING_TOGGLE_CHANGE,
        name: name,
        active: active
    };
};
var trackingToggleSaveSuccess = function(tracking) {
    var showSuccessPrompt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return {
        type: TRACKING_TOGGLE_SAVE_SUCCESS,
        tracking: tracking,
        showSuccessPrompt: showSuccessPrompt
    };
};
var trackingToggleSaveError = function(tracking) {
    return {
        type: TRACKING_TOGGLE_SAVE_ERROR,
        tracking: tracking
    };
};
var trackingToggleSave = function(settings, isLoggedIn) {
    var showSuccessPrompt = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return {
        type: TRACKING_TOGGLE_SAVE,
        settings: settings,
        isLoggedIn: isLoggedIn,
        showSuccessPrompt: showSuccessPrompt
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
    trackingToggleChange: trackingToggleChange,
    trackingToggleSave: trackingToggleSave,
    trackingToggleSaveSuccess: trackingToggleSaveSuccess,
    trackingToggleSaveError: trackingToggleSaveError
});


/***/ }),

/***/ 72275:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23114);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42409);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_1__);


var PersonalizationLoader = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "extra";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | extra */ 737).then(__webpack_require__.bind(__webpack_require__, 48130));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(48130);
        }
        return eval("require.resolve")("./personalization");
    }
});
PersonalizationLoader.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_1___default());
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (PersonalizationLoader);


/***/ }),

/***/ 55964:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": () => (/* binding */ readPersonalizationSettings),
/* harmony export */   "r": () => (/* binding */ writePersonalizationSettings)
/* harmony export */ });
var LOCAL_STORAGE_KEY = "personalizationSettings";
var EMPTY_VALUE = {
    notInterestedIn: {
        categories: []
    }
};
var readPersonalizationSettings = function() {
    if (false) {}
    try {
        var jsonString = window.localStorage.getItem(LOCAL_STORAGE_KEY);
        if (!jsonString) {
            return EMPTY_VALUE;
        }
        var data = JSON.parse(jsonString);
        return data !== null && typeof data === "object" ? data : EMPTY_VALUE;
    } catch (e) {
        if (false) {}
        return EMPTY_VALUE;
    }
};
var writePersonalizationSettings = function(data) {
    var jsonString = JSON.stringify(data);
    localStorage.setItem(LOCAL_STORAGE_KEY, jsonString);
};


/***/ }),

/***/ 73158:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23114);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}


var LoadableComponent = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "extra";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | extra */ 737).then(__webpack_require__.bind(__webpack_require__, 37631));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(37631);
        }
        return eval("require.resolve")("./tracking-settings");
    }
});
var Loader = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(LoadableComponent, _extends({}, props));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Loader);


/***/ }),

/***/ 4779:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";

// NAMESPACE OBJECT: ./src/components/co-branding-banner/actions.ts
var actions_namespaceObject = {};
__webpack_require__.r(actions_namespaceObject);
__webpack_require__.d(actions_namespaceObject, {
  "acknowledgeCoBrandingBanner": () => (acknowledgeCoBrandingBanner)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/intersection-observer@0.12.0/node_modules/intersection-observer/intersection-observer.js
var intersection_observer = __webpack_require__(71324);
// EXTERNAL MODULE: ./node_modules/.pnpm/focus-visible@5.0.1/node_modules/focus-visible/dist/focus-visible.js
var focus_visible = __webpack_require__(94506);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-dom@18.2.0_react@18.2.0/node_modules/react-dom/client.js
var client = __webpack_require__(44478);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@5.2.1_react@18.2.0/node_modules/react-router/esm/react-router.js + 3 modules
var react_router = __webpack_require__(14727);
// EXTERNAL MODULE: ./node_modules/.pnpm/history@4.9.0/node_modules/history/esm/history.js + 2 modules
var esm_history = __webpack_require__(83728);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 24 modules
var es = __webpack_require__(95939);
// EXTERNAL MODULE: ./node_modules/.pnpm/@loadable+component@5.15.2_react@18.2.0/node_modules/@loadable/component/dist/loadable.esm.js + 1 modules
var loadable_esm = __webpack_require__(23114);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/after.js
var after = __webpack_require__(77255);
var after_default = /*#__PURE__*/__webpack_require__.n(after);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/throttle.js
var throttle = __webpack_require__(38209);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);
// EXTERNAL MODULE: ./node_modules/.pnpm/smoothscroll-polyfill@0.4.4/node_modules/smoothscroll-polyfill/dist/smoothscroll.js
var smoothscroll = __webpack_require__(89234);
var smoothscroll_default = /*#__PURE__*/__webpack_require__.n(smoothscroll);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tanstack+react-query@4.23.0_react-dom@18.2.0_react@18.2.0/node_modules/@tanstack/react-query/build/lib/index.mjs + 37 modules
var lib = __webpack_require__(30519);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tanstack+react-query-devtools@4.23.0_@tanstack+react-query@4.23.0_react-dom@18.2.0_react@18.2.0/node_modules/@tanstack/react-query-devtools/build/lib/index.mjs + 24 modules
var build_lib = __webpack_require__(87611);
// EXTERNAL MODULE: ./packages/schibsted-account-react/dist/index.js
var dist = __webpack_require__(78764);
// EXTERNAL MODULE: ./src/components/translate/index.ts + 3 modules
var translate = __webpack_require__(61041);
;// CONCATENATED MODULE: ./src/client/public-path.js
// eslint-disable-next-line
__webpack_require__.p = window.WEBPACK_PUBLIC_PATH;
/* harmony default export */ const public_path = ((/* unused pure expression or super */ null && (undefined)));

// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
;// CONCATENATED MODULE: ./src/client/performance-reporter.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var addPerformanceTiming = function(event) {
    if ( true && window.performance && window.dataLayer) {
        window.dataLayer.push(_defineProperty({
            event: event
        }, event, window.performance.now()));
    }
};
/* harmony default export */ const performance_reporter = (addPerformanceTiming);

// EXTERNAL MODULE: ./node_modules/.pnpm/web-vitals@0.2.4/node_modules/web-vitals/dist/web-vitals.es5.min.js
var web_vitals_es5_min = __webpack_require__(61462);
;// CONCATENATED MODULE: ./src/client/web-vitals-reporter.ts
function web_vitals_reporter_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            web_vitals_reporter_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var sendReport = function(metric) {
    var eventData = _objectSpreadProps(_objectSpread({}, metric), {
        deltaRounded: Math.round(metric.name === "CLS" ? metric.delta * 1000 : metric.delta)
    });
    if ( true && window.dataLayer) {
        window.dataLayer.push({
            event: "webVitalReport",
            webVitalReport: eventData
        });
    }
};
var addWebVitalReport = function(metricName) {
    switch(metricName){
        case "CLS":
            (0,web_vitals_es5_min/* getCLS */.kz)(sendReport);
            break;
        case "FID":
            (0,web_vitals_es5_min/* getFID */.Tx)(sendReport);
            break;
        case "LCP":
            (0,web_vitals_es5_min/* getLCP */.Tb)(sendReport);
            break;
        default:
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            (function() {})();
    }
};
/* harmony default export */ const web_vitals_reporter = (addWebVitalReport);

// EXTERNAL MODULE: ./src/client/store.js + 57 modules
var store = __webpack_require__(31977);
// EXTERNAL MODULE: ./src/components/fetch-context.ts
var fetch_context = __webpack_require__(95698);
// EXTERNAL MODULE: ./src/components/viewport/context.tsx
var context = __webpack_require__(84198);
;// CONCATENATED MODULE: ./src/components/fetch-query-error-context/index.tsx

var FetchQueryErrorContext = /*#__PURE__*/ react.createContext({
    error: undefined
});
var FetchQueryErrorProvider = function(param) {
    var children = param.children, error = param.error;
    var contextValue = (0,react.useMemo)(function() {
        return {
            error: error
        };
    }, [
        error
    ]);
    return /*#__PURE__*/ react.createElement(FetchQueryErrorContext.Provider, {
        value: contextValue
    }, children);
};
function useFetchQueryError() {
    return (0,react.useContext)(FetchQueryErrorContext);
}

// EXTERNAL MODULE: ./src/client/sentry.ts
var sentry = __webpack_require__(99757);
// EXTERNAL MODULE: ./src/components/ads/context/index.js
var ads_context = __webpack_require__(22362);
// EXTERNAL MODULE: ./src/components/ads/services/context.tsx
var services_context = __webpack_require__(31637);
// EXTERNAL MODULE: ./src/components/viewport-tracker/index.tsx
var viewport_tracker = __webpack_require__(39632);
// EXTERNAL MODULE: ./node_modules/.pnpm/querystring@0.2.1/node_modules/querystring/index.js
var querystring = __webpack_require__(97150);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
;// CONCATENATED MODULE: ./src/appStyles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      .header,\n      .header--fixed-margin,\n      .pj-footer {\n        display: none;\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: row;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  min-height: calc(100vh - 390px);\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    order: 99;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    max-width: 100vw;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n\n  /* 1200 is PAGE_CONTENT_GUTTER_BREAKPOINT + 1, since this one is min-width.\n     The magic number was derived from trial and error resizing the window */\n  @media ",
        " {\n    min-width: 1320px;\n  }\n\n  ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var App = styled_components_browser_esm["default"].div.withConfig({
    displayName: "App",
    componentId: "sc-0-0"
})(_templateObject1(), function(props) {
    return props.layout === "raw-mobile" && (0,styled_components_browser_esm.css)(_templateObject());
});
var Main = styled_components_browser_esm["default"].section.withConfig({
    displayName: "Main",
    componentId: "sc-0-1"
})(_templateObject3(), base/* media.largeUp */.BC.largeUp(_templateObject2()));
var Content = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Content",
    componentId: "sc-0-2"
})(_templateObject6(), "screen and (min-width: 1200px)", base/* media.mediumUp */.BC.mediumUp(_templateObject4()), base/* media.mediumDown */.BC.mediumDown(_templateObject5()));

// EXTERNAL MODULE: ./src/areas/feedback/index.js
var feedback = __webpack_require__(94680);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/list/index.js
var list = __webpack_require__(4401);
// EXTERNAL MODULE: ./src/components/text-link/index.tsx + 1 modules
var text_link = __webpack_require__(32673);
// EXTERNAL MODULE: ./src/components/viewport/index.tsx
var viewport = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/country-flag/index.ts + 2 modules
var country_flag = __webpack_require__(72154);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/index.js
var ui_text = __webpack_require__(49955);
;// CONCATENATED MODULE: ./src/areas/footer/components/change-market/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  list-style: none;\n  width: 100%;\n  margin: 0;\n  line-height: unset;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: ",
        " ",
        ";\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  transition: background ",
        ";\n\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  max-width: 15rem;\n\n  &:active {\n    color: ",
        ";\n  }\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n  flex: 0 1 auto;\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = styles_taggedTemplateLiteral([
        "\n  font-weight: ",
        ";\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var Sites = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "Sites",
    componentId: "sc-0-0"
})(styles_templateObject());
var Link = styled_components_browser_esm["default"].a.withConfig({
    displayName: "Link",
    componentId: "sc-0-1"
})(styles_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing075 */.bK.measurements.spacing075);
var Site = styled_components_browser_esm["default"].li.withConfig({
    displayName: "Site",
    componentId: "sc-0-2"
})(styles_templateObject2(), base/* layout.animations.buttonTransition */.bK.animations.buttonTransition, function(p) {
    return p.theme.dropdowns.primary.hoverBackground;
});
var CountryNameWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CountryNameWrapper",
    componentId: "sc-0-3"
})(styles_templateObject3(), function(p) {
    return p.theme.text.primary;
});
var CountryFlag = (0,styled_components_browser_esm["default"])(country_flag/* CountryFlag */.A).withConfig({
    displayName: "CountryFlag",
    componentId: "sc-0-4"
})(styles_templateObject4(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var CountryName = styled_components_browser_esm["default"].span.withConfig({
    displayName: "CountryName",
    componentId: "sc-0-5"
})(styles_templateObject5(), ui_text.FontWeight.HEAVIER);

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/dropdown/index.js
var dropdown = __webpack_require__(42654);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/index.js
var ui = __webpack_require__(54262);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(7336);
;// CONCATENATED MODULE: ./src/areas/footer/components/change-market/index.tsx






var ChangeMarket = function(param) {
    var sites = param.sites, current = param.current;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var siteOptions = sites.filter(function(param) {
        var code = param.code;
        return code !== current;
    }).map(function(param) {
        var url = param.url, code = param.code;
        return {
            code: code,
            url: url,
            // TODO: Typescript cannot map string concatination to correct translation type.
            // Fix by adding single source of truth for markets in config and create new translation key types based on that source of truth.
            // @ts-expect-error -- market code 'te' screwing us over TODO
            name: t("common", "market.".concat(code))
        };
    }).sort(function(a, b) {
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
    });
    var currentMarket = sites.filter(function(param) {
        var code = param.code;
        return code === current;
    })// @ts-expect-error -- market code 'te' screwing us over TODO
    .map(function(param) {
        var code = param.code;
        return t("common", "market.".concat(code));
    }).join();
    return /*#__PURE__*/ react.createElement(dropdown/* Dropdown */.Lt, {
        closeOnItemClick: true
    }, /*#__PURE__*/ react.createElement(dropdown/* DropdownToggle */.Z_, {
        showActiveIcon: true,
        type: variants.ButtonType.OUTLINED,
        containerProps: {
            "data-test": "SiteMarketSelector"
        }
    }, /*#__PURE__*/ react.createElement(CountryFlag, {
        countryCode: current,
        altText: currentMarket
    }), /*#__PURE__*/ react.createElement(CountryNameWrapper, null, /*#__PURE__*/ react.createElement(CountryName, null, currentMarket.toUpperCase()), " -", " ", t("footer", "market.".concat(current, "-url")))), /*#__PURE__*/ react.createElement(dropdown/* DropdownContent */.Nv, {
        placement: ui/* Direction.Up */.Nm.Up
    }, /*#__PURE__*/ react.createElement(Sites, null, siteOptions.map(function(param) {
        var name = param.name, url = param.url, code = param.code;
        return /*#__PURE__*/ react.createElement(Site, {
            key: "site-".concat(code)
        }, /*#__PURE__*/ react.createElement(Link, {
            href: url,
            "data-test": "SiteMarketSelectorOption",
            "data-test-market-id": code
        }, /*#__PURE__*/ react.createElement(CountryFlag, {
            countryCode: code
        }), /*#__PURE__*/ react.createElement(CountryNameWrapper, null, /*#__PURE__*/ react.createElement(CountryName, null, name.toUpperCase()), " -", " ", t("footer", "market.".concat(code, "-url")))));
    }))));
};
/* harmony default export */ const change_market = (ChangeMarket);

// EXTERNAL MODULE: ./src/areas/sidebar/constants.ts
var constants = __webpack_require__(28438);
// EXTERNAL MODULE: ./src/components/static-intercom/index.tsx + 1 modules
var static_intercom = __webpack_require__(43344);
// EXTERNAL MODULE: ./src/components/logo/index.tsx
var logo = __webpack_require__(8589);
// EXTERNAL MODULE: ./src/components/newsletter-signup/index.ts + 2 modules
var newsletter_signup = __webpack_require__(53174);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var text_variants = __webpack_require__(71016);
;// CONCATENATED MODULE: ./src/areas/footer/styles.ts
function footer_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function footer_styles_templateObject() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n  transition: all 200ms ease;\n\n  /* Offset footer to the left behind the invisible sidebar wrapper\n   to keep the footer full width */\n  @media screen and (min-width: ",
        "px) {\n    margin-left: ",
        ";\n  }\n\n  @media screen and (min-width: 1980px) {\n    margin-left: ",
        ";\n  }\n"
    ]);
    footer_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function footer_styles_templateObject1() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n  max-width: ",
        ";\n  display: flex;\n  width: 100%;\n  transition: all 200ms ease;\n  padding: ",
        " ",
        ";\n\n  /* Align footer content with the rest of the page */\n  @media screen and (min-width: ",
        "px) {\n    margin-left: ",
        ";\n  }\n\n  @media screen and (min-width: 1980px) {\n    margin-left: ",
        ";\n  }\n"
    ]);
    footer_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function footer_styles_templateObject2() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n    grid-template-columns: 1fr;\n  "
    ]);
    footer_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function footer_styles_templateObject3() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  width: 100%;\n  gap: ",
        ";\n  align-items: flex-start;\n\n  ",
        "\n"
    ]);
    footer_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function footer_styles_templateObject4() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n    min-width: 180px;\n  "
    ]);
    footer_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function footer_styles_templateObject5() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n    order: -1;\n    flex-basis: 100%;\n  "
    ]);
    footer_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  ",
        ";\n\n  ",
        "\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n    > :not(:last-child) {\n      margin-bottom: ",
        ";\n    }\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n    display: flex;\n    flex-wrap: nowrap;\n    > :not(:last-child) {\n      margin-right: ",
        ";\n    }\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n  ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  margin: 0 ",
        ";\n  line-height: 0;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = footer_styles_taggedTemplateLiteral([
        ""
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n    min-height: 90px;\n    && {\n      align-items: center;\n      flex-direction: column;\n    }\n  "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n  align-items: flex-end;\n  text-align: left;\n  gap: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  text-decoration: underline;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n    display: flex;\n    justify-content: center;\n\n    ",
        " {\n      max-width: 370px;\n      flex-direction: column;\n      text-align: center;\n      gap: ",
        ";\n    }\n  "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n  background: ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n      padding-top: ",
        ";\n    "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n  justify-content: space-between;\n  background: ",
        ";\n\n  ",
        " {\n    padding-top: ",
        ";\n\n    ",
        "\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n      flex-direction: column;\n      gap: ",
        " 0;\n    "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n  background: ",
        ";\n  color: ",
        ";\n\n  ",
        " {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding-top: ",
        ";\n    flex-wrap: wrap;\n    gap: ",
        " ",
        ";\n\n    /* CoBranding */\n    :last-child {\n      border-top: 1px solid ",
        ";\n      align-items: center;\n      text-align: center;\n    }\n\n    ",
        ";\n  }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n  width: 180px;\n  max-width: 100%;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n    flex-direction: column;\n    align-items: center;\n    p {\n      margin-bottom: 0;\n    }\n  "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: flex-end;\n  flex-shrink: 0;\n  gap: ",
        ";\n\n  p {\n    margin-bottom: 6px;\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n\n  input {\n    display: flex;\n    flex-grow: 1;\n  }\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n    margin: 0 auto;\n  "
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n  height: 100%;\n  margin: 0 ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n    width: min-content;\n  "
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n\n  ",
        ";\n\n  @media screen and (max-width: 430px) {\n    width: 100%;\n  }\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n    width: 100%;\n    order: 99;\n  "
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = footer_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  text-decoration: underline;\n\n  span {\n    color: inherit;\n  }\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}






var pageWithSidebarContent = base/* layout.pageContentMaxWidthVal */.bK.pageContentMaxWidthVal + base/* layout.sidebarMenuWidth.desktop.value */.bK.sidebarMenuWidth.desktop.value * 2;
var Footer = styled_components_browser_esm["default"].footer.withConfig({
    displayName: "Footer",
    componentId: "sc-0-0"
})(footer_styles_templateObject(), pageWithSidebarContent, function(props) {
    return props.sidebarOpen ? 0 : "calc(((1250px - 100vw) / 2) + ".concat(base/* layout.sidebarMenuWidth.desktop.rem */.bK.sidebarMenuWidth.desktop.rem, ")");
}, function(props) {
    return props.sidebarOpen ? 0 : "calc(-1 * ".concat(base/* layout.sidebarContentWidth.desktop.rem */.bK.sidebarContentWidth.desktop.rem, ")");
});
var styles_Content = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Content",
    componentId: "sc-0-1"
})(footer_styles_templateObject1(), base/* layout.pageContent.maxWidth.rem */.bK.pageContent.maxWidth.rem, base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, pageWithSidebarContent, function(props) {
    return props.sidebarOpen ? "inherit" : "calc(((100vw - 1250px) / 2) - ".concat(base/* layout.sidebarMenuWidth.desktop.rem */.bK.sidebarMenuWidth.desktop.rem, ")");
}, function(props) {
    return props.sidebarOpen ? "calc(((100vw - 1250px) / 2) - ".concat(base/* layout.sidebarMenuWidth.desktop.value */.bK.sidebarMenuWidth.desktop.value + base/* layout.sidebarContentWidth.desktop.value */.bK.sidebarContentWidth.desktop.value, "px)") : "calc(((100vw - 1250px) / 2) - ".concat(base/* layout.sidebarMenuWidth.desktop.rem */.bK.sidebarMenuWidth.desktop.rem, ")");
});
var Columns = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Columns",
    componentId: "sc-0-2"
})(footer_styles_templateObject3(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* media.mediumDown */.BC.mediumDown(footer_styles_templateObject2()));
var Download = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Download",
    componentId: "sc-0-3"
})(styles_templateObject6(), base/* media.mediumUp */.BC.mediumUp(footer_styles_templateObject4()), base/* media.mediumDown */.BC.mediumDown(footer_styles_templateObject5()));
var DownloadTitle = (0,styled_components_browser_esm["default"])(text_variants.H4Text).withConfig({
    displayName: "DownloadTitle",
    componentId: "sc-0-4"
})(_templateObject7(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var DownloadIcons = styled_components_browser_esm["default"].div.withConfig({
    displayName: "DownloadIcons",
    componentId: "sc-0-5"
})(_templateObject10(), base/* media.mediumUp */.BC.mediumUp(_templateObject8(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050), base/* media.mediumDown */.BC.mediumDown(_templateObject9(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050));
var SocialIcons = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SocialIcons",
    componentId: "sc-0-6"
})(_templateObject11());
var SocialIcon = styled_components_browser_esm["default"].a.withConfig({
    displayName: "SocialIcon",
    componentId: "sc-0-7"
})(_templateObject12(), function(p) {
    return p.theme.colors.base500;
}, (0,base/* remCalc */.vR)(4));
var styles_Sites = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Sites",
    componentId: "sc-0-8"
})(_templateObject13());
var CoBranding = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CoBranding",
    componentId: "sc-0-9"
})(_templateObject15(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.mediumDown */.BC.mediumDown(_templateObject14()));
var CoBrandingLink = styled_components_browser_esm["default"].a.withConfig({
    displayName: "CoBrandingLink",
    componentId: "sc-0-10"
})(_templateObject16(), function(p) {
    return p.theme.colors.base500;
});
var TopSection = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TopSection",
    componentId: "sc-0-11"
})(_templateObject18(), function(p) {
    return p.theme.colors.maybeBlue100;
}, base/* media.mediumDown */.BC.mediumDown(_templateObject17(), styles_Content, base/* layout.measurements.spacing150 */.bK.measurements.spacing150));
var MidSection = styled_components_browser_esm["default"].div.withConfig({
    displayName: "MidSection",
    componentId: "sc-0-12"
})(_templateObject20(), function(p) {
    return p.theme.footer.bg.primary;
}, styles_Content, base/* layout.measurements.spacing250 */.bK.measurements.spacing250, base/* media.mediumDown */.BC.mediumDown(_templateObject19(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150));
var BottomSection = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BottomSection",
    componentId: "sc-0-13"
})(_templateObject22(), function(p) {
    return p.theme.footer.bg.primary;
}, function(p) {
    return p.theme.colors.base500;
}, styles_Content, base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing150 */.bK.measurements.spacing150, function(p) {
    return p.theme.colors.base200;
}, base/* media.mediumDown */.BC.mediumDown(_templateObject21(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100));
var Logo = (0,styled_components_browser_esm["default"])(logo/* Logo */.T).withConfig({
    displayName: "Logo",
    componentId: "sc-0-14"
})(_templateObject23());
var LogoWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "LogoWrapper",
    componentId: "sc-0-15"
})(_templateObject25(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.mediumDown */.BC.mediumDown(_templateObject24()));
var NewsletterSignup = (0,styled_components_browser_esm["default"])(newsletter_signup/* NewsletterSignupFooter */._).withConfig({
    displayName: "NewsletterSignup",
    componentId: "sc-0-16"
})(_templateObject26());
var NewsLetterIllustration = styled_components_browser_esm["default"].img.withConfig({
    displayName: "NewsLetterIllustration",
    componentId: "sc-0-17"
})(_templateObject28(), base/* layout.measurements.spacing250 */.bK.measurements.spacing250, base/* media.mediumDown */.BC.mediumDown(_templateObject27()));
var FeedbackButton = (0,styled_components_browser_esm["default"])(variants.OutlinedButton).withConfig({
    displayName: "FeedbackButton",
    componentId: "sc-0-18"
})(_templateObject30(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* media.mediumDown */.BC.mediumDown(_templateObject29()));
var ButtonText = styled_components_browser_esm["default"].span.withConfig({
    displayName: "ButtonText",
    componentId: "sc-0-19"
})(_templateObject31());
var ClassicSwitchWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ClassicSwitchWrapper",
    componentId: "sc-0-20"
})(_templateObject33(), base/* media.largeUp */.BC.largeUp(_templateObject32()));
var ClassicSwitchLink = styled_components_browser_esm["default"].span.withConfig({
    displayName: "ClassicSwitchLink",
    componentId: "sc-0-21"
})(_templateObject34(), function(p) {
    return p.theme.colors.base500;
});

;// CONCATENATED MODULE: ./src/areas/footer/components/info-pages/styles.ts
function info_pages_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function info_pages_styles_templateObject() {
    var data = info_pages_styles_taggedTemplateLiteral([
        "\n  list-style: none;\n  margin: 0;\n"
    ]);
    info_pages_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function info_pages_styles_templateObject1() {
    var data = info_pages_styles_taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    info_pages_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function info_pages_styles_templateObject2() {
    var data = info_pages_styles_taggedTemplateLiteral([
        "\n  && {\n    color: ",
        ";\n\n    &:hover {\n      color: ",
        ";\n      text-decoration: underline;\n    }\n  }\n"
    ]);
    info_pages_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function info_pages_styles_templateObject3() {
    var data = info_pages_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    info_pages_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var InfoPagesList = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "InfoPagesList",
    componentId: "sc-0-0"
})(info_pages_styles_templateObject());
var ListItem = styled_components_browser_esm["default"].li.withConfig({
    displayName: "ListItem",
    componentId: "sc-0-1"
})(info_pages_styles_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var styles_Link = (0,styled_components_browser_esm["default"])(text_variants.BodyMediumText).withConfig({
    displayName: "Link",
    componentId: "sc-0-2"
})(info_pages_styles_templateObject2(), function(p) {
    return p.theme.footer.fg.primary;
}, function(p) {
    return p.theme.buttons.link.textHover;
});
var Column = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Column",
    componentId: "sc-0-3"
})(info_pages_styles_templateObject3());

// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(58912);
;// CONCATENATED MODULE: ./src/areas/footer/components/info-pages/index.tsx




var InfoPages = function(param) {
    var columns = param.columns;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, columns.map(function(column) {
        return /*#__PURE__*/ react.createElement(Column, {
            key: "column-".concat(column.title)
        }, /*#__PURE__*/ react.createElement(text_variants.H3Text, null, column.title), /*#__PURE__*/ react.createElement(InfoPagesList, null, column.pages.map(function(page) {
            return page && /*#__PURE__*/ react.createElement(ListItem, {
                key: "".concat(page.title, "-").concat(page.id),
                onClick: function() {
                    return (0,tracking/* trackInternalNavigationClick */.p)({
                        scope: tracking/* InternalNavigationScope.FOOTER_INFO_PAGES */.U.FOOTER_INFO_PAGES,
                        nextPage: page.pathName
                    });
                }
            }, /*#__PURE__*/ react.createElement(styles_Link, {
                container: "a",
                containerProps: {
                    href: page.pathName,
                    // These links are nofollow to avoid them getting too much of the internal
                    // pagerank (since they occur on every page).
                    rel: page.follow ? "follow" : "nofollow"
                }
            }, page.title));
        })));
    }));
};
/* harmony default export */ const info_pages = (/*#__PURE__*/(0,react.memo)(InfoPages));

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/social-media-facebook/index.js
var social_media_facebook = __webpack_require__(55137);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/social-media-instagram/index.js
var social_media_instagram = __webpack_require__(68176);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/social-media-twitter/index.js
var social_media_twitter = __webpack_require__(22846);
;// CONCATENATED MODULE: ./src/areas/footer/footerPages.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function footerPages_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function footerPages_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            footerPages_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function footerPages_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function footerPages_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        footerPages_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var SchibstedPolicyMarkets = [
    "no",
    "fi",
    "dk"
];
var ocastLink = {
    no: "https://no-prisjakt.ocast.com/no/",
    se: "https://se-prisjakt.ocast.com/se/",
    fi: "https://hintaopas.ocast.com/fi/",
    gb: "https://uk-pricespy.ocast.com/",
    nz: "https://nz-pricespy.ocast.com/"
};
var careersLink = {
    se: "https://prisjakt.teamtailor.com/"
};
var expertLoginLink = {
    se: "http://expert.prisjakt.nu/login"
};
var newsroomLink = {
    no: "https://nyhetsrom.prisjakt.no",
    se: "https://nyhetsrum.prisjakt.nu",
    fi: "https://uutishuone.hintaopas.fi",
    fr: "https://newsroom.ledenicheur.fr ",
    gb: "https://newsroom.pricespy.co.uk",
    nz: "https://newsroom.pricespy.co.nz"
};
var getPageMap = function(infoPageMap, url, market, linkTo, t, pages) {
    var ref, ref1, ref2;
    var pageMap = {
        themes: !!(url === null || url === void 0 ? void 0 : url.campaigns) && {
            pathName: (url === null || url === void 0 ? void 0 : url.campaigns) || "",
            title: t("campaigns", "themes.title"),
            id: "themes",
            follow: true
        },
        advertiseOnPrisjakt: ocastLink[market.code] && {
            pathName: ocastLink[market.code],
            title: t("footer", "link.ads"),
            id: "adlink",
            follow: false
        },
        careers: careersLink[market.code] && {
            pathName: careersLink[market.code],
            title: t("footer", "link.careers"),
            id: "careers",
            follow: false
        },
        articles: !!(infoPageMap === null || infoPageMap === void 0 ? void 0 : infoPageMap.articles) && {
            pathName: linkTo("editorialContentListing"),
            title: t("common", "article.articles"),
            id: "articles",
            follow: true
        },
        shopOfTheYear: !!(infoPageMap === null || infoPageMap === void 0 ? void 0 : infoPageMap.shopOfTheYear) && {
            pathName: linkTo("shopOfTheYear"),
            title: t("campaigns", "shop-of-the-year.title"),
            id: "shopOfTheYear",
            follow: true
        },
        categoryIndex: !!(infoPageMap === null || infoPageMap === void 0 ? void 0 : infoPageMap.categoryIndex) && {
            pathName: linkTo("categoryIndex"),
            title: t("category", "category-index.categories"),
            id: "categoryIndex",
            follow: true
        },
        // TODO: Uncomment when going live with Promotions hub page
        // promotions: !!infoPageMap?.promotions && {
        //   pathName: linkTo('promotions'),
        //   title: t('search', 'scoped-search.promotion-title'),
        //   id: 'promotions',
        //   follow: true,
        // },
        used: !!(infoPageMap === null || infoPageMap === void 0 ? void 0 : infoPageMap.used) && {
            pathName: linkTo("used"),
            title: t("product", "product.used-products"),
            id: "used",
            follow: true
        },
        privacySettings: !market.sourcepointCmp && {
            pathName: ((ref = market.privacySettings) === null || ref === void 0 ? void 0 : (ref1 = ref.responsive) === null || ref1 === void 0 ? void 0 : ref1.privacySettingsUrl) || "",
            title: t("tracking-settings", "link.privacy-settings"),
            id: "privacySettings",
            follow: false
        },
        supportPage: !!(infoPageMap === null || infoPageMap === void 0 ? void 0 : infoPageMap.supportPage) && {
            pathName: "https://support.prisjakt.nu/".concat(market && market.locale ? "".concat(market.locale.split("_")[0].toLowerCase(), "/") : "en/"),
            title: t("footer", "contact-helpcenter.link"),
            id: "supportPage",
            follow: false
        },
        expertLogin: expertLoginLink[market.code] && {
            pathName: expertLoginLink[market.code],
            title: t("footer", "link.expert-login"),
            id: "expertLogin",
            follow: false
        },
        experts: !!(infoPageMap === null || infoPageMap === void 0 ? void 0 : infoPageMap.experts) && {
            pathName: linkTo("experts"),
            title: t("footer", "link.experts"),
            id: "experts",
            follow: true
        },
        newsroom: newsroomLink[market.code] && {
            pathName: newsroomLink[market.code],
            title: t("footer", "link.newsroom"),
            id: "newsroom",
            follow: true
        },
        blackFriday: !!(infoPageMap === null || infoPageMap === void 0 ? void 0 : infoPageMap.blackFriday) && {
            pathName: "".concat(url === null || url === void 0 ? void 0 : url.campaigns, "/black-friday"),
            title: typeof infoPageMap.blackFriday === "string" ? infoPageMap.blackFriday : "Black Friday ".concat(new Date().getFullYear()),
            id: "blackFriday",
            follow: true
        },
        januarySales: !!(infoPageMap === null || infoPageMap === void 0 ? void 0 : infoPageMap.januarySales) && {
            pathName: infoPageMap.januarySales,
            title: t("footer", "link.january-sales"),
            id: "januarySales",
            follow: true
        },
        bestDeals: !!(infoPageMap === null || infoPageMap === void 0 ? void 0 : infoPageMap.bestDeals) && {
            pathName: infoPageMap.bestDeals,
            title: t("footer", "link.best-deals"),
            id: "bestDeals",
            follow: true
        },
        boxingDayDeals: !!(infoPageMap === null || infoPageMap === void 0 ? void 0 : infoPageMap.boxingDayDeals) && {
            pathName: infoPageMap.boxingDayDeals,
            title: t("footer", "link.boxing-day-deals"),
            id: "boxingDayDeals",
            follow: true
        },
        registerShopInfo: market.infoPageRegisterShopLink && {
            pathName: market.infoPageRegisterShopLink,
            title: t("footer", "link.register-shop-info"),
            id: "registerShopInfo",
            follow: false
        },
        topProducts: !!(infoPageMap === null || infoPageMap === void 0 ? void 0 : infoPageMap.topProducts) && {
            pathName: infoPageMap.topProducts,
            title: t("footer", "link.top-products"),
            id: "topProducts",
            follow: true
        },
        getStarted: !!(infoPageMap === null || infoPageMap === void 0 ? void 0 : infoPageMap.getStarted) && {
            pathName: infoPageMap.getStarted,
            title: t("footer", "link.get-started"),
            id: "getStarted",
            follow: true
        },
        howWorks: !!(infoPageMap === null || infoPageMap === void 0 ? void 0 : infoPageMap.howWorks) && {
            pathName: infoPageMap.howWorks,
            title: t("footer", "link.how-works"),
            id: "howWorks",
            follow: true
        },
        transparency: !!(infoPageMap === null || infoPageMap === void 0 ? void 0 : infoPageMap.transparency) && {
            pathName: infoPageMap.transparency,
            title: t("footer", "link.transparency"),
            id: "transparency",
            follow: true
        },
        businessCenter: {
            pathName: (ref2 = market.sites.production) === null || ref2 === void 0 ? void 0 : ref2.replace(/^http(s)?:\/\/(www\.)?/, "https://business."),
            title: t("footer", "link.business-center"),
            id: "businessCenter",
            follow: false
        }
    };
    // Add `pages` to `pageMap` with their IDs as keys
    if (pages && infoPageMap) {
        pages.nodes.forEach(function(page) {
            var name = Object.keys(infoPageMap).find(function(infoPageName) {
                return page.id === infoPageMap[infoPageName];
            });
            var id = name && infoPageMap[name];
            if (id) {
                pageMap[name] = page;
            }
        });
    }
    return pageMap;
};
var getFooterColumns = function(pageMap, t, market) {
    /*
   * If Schibsted is data controller. Do not show policy links in about pages.
   * Instead this information is accessible from the co-branding footer,
   * in those cases, for markets (FI, NO, DK). SE handled in getNewFooterColumns(...)
   */ var rulesPages = [
        pageMap.userAgreement,
        pageMap.disclaimer
    ].concat(_toConsumableArray(SchibstedPolicyMarkets.includes(market.code) ? [] : [
        pageMap.privacyPolicy
    ]), _toConsumableArray(SchibstedPolicyMarkets.includes(market.code) ? [] : [
        pageMap.cookiePolicy
    ]), [
        pageMap.privacySettings,
        pageMap.transparency
    ]);
    return [
        {
            title: t("footer", "pages.title"),
            pages: [
                pageMap.getStarted,
                pageMap.howWorks,
                pageMap.about,
                pageMap.contact,
                pageMap.advertiseOnPrisjakt,
                pageMap.registerShopInfo,
                pageMap.businessCenter,
                pageMap.supportPage
            ]
        },
        {
            title: t("footer", "pages.rules-title"),
            pages: rulesPages
        },
        {
            title: t("footer", "pages.on-title"),
            pages: // to only show january sales for gb on top and for no on bottom
            _toConsumableArray(market.code === "gb" ? [
                pageMap.januarySales
            ] : []).concat(// leave boxing day deals link for FR in this place
            _toConsumableArray(market.code === "fr" ? [
                pageMap.boxingDayDeals
            ] : []), [
                pageMap.bestDeals,
                pageMap.careers,
                pageMap.themes,
                pageMap.newsroom,
                pageMap.articles,
                pageMap.shopOfTheYear,
                pageMap.categoryIndex,
                // TODO: Uncomment when going live with Promotions hub page
                // pageMap.promotions,
                pageMap.used,
                pageMap.topProducts,
                pageMap.experts,
                pageMap.expertLogin
            ], _toConsumableArray(market.code === "no" ? [
                pageMap.januarySales
            ] : []))
        }
    ];
};
var getNewFooterColumns = function(pageMap, t, prismicArticles) {
    var ref;
    var titleMap = {
        "friskrivning-och-ansvarsbegransning": "Friskrivning och ansvarsbegr\xe4nsning",
        personuppgiftspolicy: "Personuppgiftspolicy",
        cookiepolicy: "Cookiepolicy",
        "kom-igang-med-prisjakt": "Kom ig\xe5ng med Prisjakt",
        "prisjakt-for-butiker": "Varf\xf6r Prisjakt?",
        "transparenslofte-hur-prisjakt-fungerar": "V\xe5rt l\xf6fte till dig",
        "kontakta-oss": "Kontakt",
        "arets-butik-for-butiker": "\xc5rets butik – f\xf6r butiker"
    };
    var formatArticle = function(article) {
        return {
            pathName: article.pathName,
            title: titleMap[article.uid || ""],
            id: article.id,
            follow: false
        };
    };
    var prismicPageMap = (ref = prismicArticles || []) === null || ref === void 0 ? void 0 : ref.reduce(function(tot, currentArticle) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.keys(titleMap)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var mappedUid = _step.value;
                if (currentArticle.uid === mappedUid) {
                    return footerPages_objectSpreadProps(footerPages_objectSpread({}, tot), footerPages_defineProperty({}, currentArticle.uid, formatArticle(currentArticle)));
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return tot;
    }, {});
    return [
        {
            title: t("footer", "column.consumer-title"),
            pages: [
                prismicPageMap["kom-igang-med-prisjakt"],
                prismicPageMap["transparenslofte-hur-prisjakt-fungerar"],
                pageMap.articles,
                pageMap.experts,
                pageMap.themes,
                pageMap.blackFriday,
                pageMap.shopOfTheYear,
                pageMap.categoryIndex,
                // TODO: Uncomment when going live with Promotions hub page
                // pageMap.promotions,
                pageMap.used,
                pageMap.januarySales
            ]
        },
        {
            title: t("footer", "column.store-title"),
            pages: [
                prismicPageMap["prisjakt-for-butiker"],
                pageMap.registerShopInfo,
                pageMap.advertiseOnPrisjakt,
                prismicPageMap["arets-butik-for-butiker"],
                pageMap.businessCenter
            ]
        },
        {
            title: t("footer", "column.about-us-title"),
            pages: [
                pageMap.about,
                pageMap.supportPage,
                prismicPageMap["kontakta-oss"],
                pageMap.careers,
                pageMap.newsroom,
                prismicPageMap["friskrivning-och-ansvarsbegransning"],
                pageMap.privacySettings,
                pageMap.expertLogin
            ]
        }
    ];
};

;// CONCATENATED MODULE: ./src/areas/footer/index.tsx
















var schibstedPolicyPages = {
    se: "https://info.privacy.schibsted.com/se/schibsted-sverige-personuppgiftspolicy/",
    no: "https://info.privacy.schibsted.com/no/schibsted-norge-personvernerklaering/",
    fi: "https://info.privacy.schibsted.com/fi/tietosuoja-ja-evastekaytannot/",
    dk: "https://info.privacy.schibsted.com/dk/persondata-og-cookiepolitik/"
};
var footer_Footer = function(param) {
    var socialNetworks = param.socialNetworks, current = param.current, sites = param.sites, pages = param.pages, url = param.url, sidebarOpen = param.sidebarOpen, prismicArticles = param.prismicArticles;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), t = ref.t, market = ref.market, infoPageMap = ref.market.infoPageMap, linkTo = ref.linkTo;
    var pageMap = getPageMap(infoPageMap, url, market, linkTo, t, pages);
    var infoPageColumns = market.code === "se" ? getNewFooterColumns(pageMap, t, prismicArticles) : getFooterColumns(pageMap, t, market);
    return /*#__PURE__*/ react.createElement(Footer, {
        sidebarOpen: sidebarOpen
    }, /*#__PURE__*/ react.createElement(TopSection, null, /*#__PURE__*/ react.createElement(styles_Content, {
        sidebarOpen: sidebarOpen
    }, /*#__PURE__*/ react.createElement(NewsLetterIllustration, {
        src: "".concat(market.cdn, "/g/rfe/illustrations/newsletter-illustration-188x102px.png"),
        alt: "Footer newsletter illustration"
    }), /*#__PURE__*/ react.createElement(NewsletterSignup, {
        title: t("footer", "newsletter.title"),
        stacked: true,
        variant: "secondary"
    }))), /*#__PURE__*/ react.createElement(MidSection, null, /*#__PURE__*/ react.createElement(styles_Content, {
        sidebarOpen: sidebarOpen
    }, /*#__PURE__*/ react.createElement(Columns, null, pages && /*#__PURE__*/ react.createElement(info_pages, {
        columns: infoPageColumns
    }), /*#__PURE__*/ react.createElement(Download, null, /*#__PURE__*/ react.createElement(static_intercom/* default */.Z, {
        customButton: /*#__PURE__*/ react.createElement(FeedbackButton, {
            fullWidth: true,
            containerProps: {
                title: t("footer", "link.contact"),
                "data-test": "FeedbackButton"
            }
        }, /*#__PURE__*/ react.createElement(ButtonText, null, t("footer", "link.contact")))
    }), /*#__PURE__*/ react.createElement(DownloadTitle, null, t("footer", "mobile-apps.title")), /*#__PURE__*/ react.createElement(DownloadIcons, {
        dangerouslySetInnerHTML: {
            __html: t("footer", "download.text.md")
        }
    }))))), /*#__PURE__*/ react.createElement(BottomSection, null, /*#__PURE__*/ react.createElement(styles_Content, {
        sidebarOpen: sidebarOpen
    }, /*#__PURE__*/ react.createElement(LogoWrapper, null, /*#__PURE__*/ react.createElement(Logo, {
        styling: "v2-dark",
        market: market.code,
        companyName: t("meta", "site.name")
    }), /*#__PURE__*/ react.createElement(viewport/* default */.Z, {
        tablet: true,
        desktop: true
    }, /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement("p", null, t("footer", "info.copyright", {
        year: new Date().getFullYear()
    })))), /*#__PURE__*/ react.createElement(viewport/* default */.Z, {
        mobile: true
    }, /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement("p", null, t("footer", "info.copyright", {
        year: new Date().getFullYear()
    }))))), /*#__PURE__*/ react.createElement(ClassicSwitchWrapper, null, market.schibstedOtherSitesLinks && /*#__PURE__*/ react.createElement(viewport/* default */.Z, {
        tablet: true,
        desktop: true
    }, t("footer", "info.check-it-out"), ":", " ", market.schibstedOtherSitesLinks.map(function(param) {
        var name = param.name, siteUrl = param.siteUrl;
        return url && /*#__PURE__*/ react.createElement(text_link/* TextLink */.h, {
            key: name,
            to: siteUrl,
            isExternal: true
        }, name, "\xa0");
    }))), /*#__PURE__*/ react.createElement(SocialIcons, null, socialNetworks.map(function(param) {
        var name = param.name, link = param.link;
        return link && /*#__PURE__*/ react.createElement(SocialIcon, {
            key: name,
            title: name,
            href: link,
            target: "_blank",
            rel: "noopener nofollow noreferrer"
        }, name === "instagram" && /*#__PURE__*/ react.createElement(social_media_instagram/* IconSocialMediaInstagram */.R, {
            size: 27,
            color: "base500"
        }), name === "facebook" && /*#__PURE__*/ react.createElement(social_media_facebook/* IconSocialMediaFacebook */.E, {
            size: 27,
            color: "base500"
        }), name === "twitter" && /*#__PURE__*/ react.createElement(social_media_twitter/* IconSocialMediaTwitter */.N, {
            size: 27,
            color: "base500"
        }));
    })), /*#__PURE__*/ react.createElement(styles_Sites, null, /*#__PURE__*/ react.createElement(change_market, {
        sites: sites,
        current: current
    }))), market.showSchibstedCoBranding && /*#__PURE__*/ react.createElement(styles_Content, {
        sidebarOpen: sidebarOpen
    }, /*#__PURE__*/ react.createElement(list.List, {
        container: CoBranding
    }, /*#__PURE__*/ react.createElement("img", {
        alt: "Schibsted",
        src: "".concat(market.cdn, "/g/rfe/logos/schibsted/schibsted_dust_black.png"),
        width: "96"
    }), /*#__PURE__*/ react.createElement(text_variants.BodySmallText, {
        style: {
            lineHeight: 1
        }
    }, "".concat(t("tracking-settings", "co-branding.part-of", {
        companyName: t("meta", "company.name")
    }), " ").concat(t("tracking-settings", "co-branding.data-controller"), " "), /*#__PURE__*/ react.createElement(CoBrandingLink, {
        href: schibstedPolicyPages[market.code],
        rel: "nofollow"
    }, t("tracking-settings", "co-branding.read-more")))))));
};
var mapStateToProps = function(state) {
    return {
        socialNetworks: state.footer.socialNetworks,
        current: state.footer.current,
        sites: state.footer.sites,
        pages: state.globals.infoPages,
        url: state.footer.url,
        sidebarOpen: state.areas.sidebar.tab !== constants/* SIDEBAR_STATE.NONE */.$J.NONE,
        prismicArticles: state.footer.articles
    };
};
/* harmony default export */ const footer = ((0,es/* connect */.$j)(mapStateToProps, {})(/*#__PURE__*/ (0,react.memo)(footer_Footer)));

// EXTERNAL MODULE: ./node_modules/.pnpm/redux@4.0.1/node_modules/redux/es/redux.js
var redux = __webpack_require__(59715);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/hideable/index.js
var hideable = __webpack_require__(3709);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(38689);
// EXTERNAL MODULE: ./src/components/search-bar/index.tsx + 19 modules
var search_bar = __webpack_require__(42199);
// EXTERNAL MODULE: ./src/hooks/use-schibsted-account.ts
var use_schibsted_account = __webpack_require__(65195);
// EXTERNAL MODULE: ./src/areas/search/actions/search.js
var search = __webpack_require__(30400);
// EXTERNAL MODULE: ./src/areas/navigation/actions/desktop.js
var desktop = __webpack_require__(51478);
// EXTERNAL MODULE: ./src/areas/navigation/actions/mobile-menu.js
var mobile_menu = __webpack_require__(59361);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/hideable/variants.js
var hideable_variants = __webpack_require__(20305);
// EXTERNAL MODULE: ./src/areas/navigation/components/mega-menu/index.tsx
var mega_menu = __webpack_require__(17720);
;// CONCATENATED MODULE: ./src/areas/navigation/shared/types.js
function types_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function types_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            types_defineProperty(target, key, source[key]);
        });
    }
    return target;
}

var string = (prop_types_default()).string, shape = (prop_types_default()).shape, arrayOf = (prop_types_default()).arrayOf;
var categoryShape = {
    id: string.isRequired,
    name: string,
    semantic_id: string
};
var categoryType = arrayOf(shape(types_objectSpread({
    children: arrayOf(shape(categoryShape))
}, categoryShape)));
/* harmony default export */ const types = (categoryType);

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/floater/index.js
var floater = __webpack_require__(50914);
// EXTERNAL MODULE: ./src/areas/sidebar/components/sidebar-mobile/components/content/index.tsx
var content = __webpack_require__(82878);
// EXTERNAL MODULE: ./src/areas/sidebar/components/sidebar-mobile/actions/index.js
var actions = __webpack_require__(82642);
// EXTERNAL MODULE: ./src/areas/sidebar/tracking/index.ts
var sidebar_tracking = __webpack_require__(15211);
// EXTERNAL MODULE: ./src/components/overlay/index.tsx + 1 modules
var overlay = __webpack_require__(83434);
// EXTERNAL MODULE: ./src/ui/zindex/index.ts
var zindex = __webpack_require__(93497);
;// CONCATENATED MODULE: ./src/areas/sidebar/components/sidebar-mobile/styles.ts
function sidebar_mobile_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function sidebar_mobile_styles_templateObject() {
    var data = sidebar_mobile_styles_taggedTemplateLiteral([
        "\n  && {\n    /* Cover the header so e.g. the search bar on the frontpage won't peek through */\n    z-index: ",
        ";\n  }\n"
    ]);
    sidebar_mobile_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function sidebar_mobile_styles_templateObject1() {
    var data = sidebar_mobile_styles_taggedTemplateLiteral([
        "\n  background: ",
        ";\n  height: ",
        ";\n  position: fixed;\n  right: 0;\n  top: 0;\n  width: 100vw;\n  z-index: ",
        ";\n"
    ]);
    sidebar_mobile_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function sidebar_mobile_styles_templateObject2() {
    var data = sidebar_mobile_styles_taggedTemplateLiteral([
        "\n  /* Needed because ReactSwipe sets e.g. a child div to 2x the view width, for some reason */\n  width: 100vw;\n  max-height: 100vh;\n  overflow: hidden;\n"
    ]);
    sidebar_mobile_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var Overlay = (0,react.memo)((0,styled_components_browser_esm["default"])(overlay/* default */.Z).withConfig({
    displayName: "Overlay",
    componentId: "sc-0-0"
})(sidebar_mobile_styles_templateObject(), zindex/* zindex.menu.mobile.overlay */.Y.menu.mobile.overlay));
var FakeHeader = (0,react.memo)((0,styled_components_browser_esm["default"])(hideable.Hideable).attrs({
    speed: ui/* Speed.Slow */.fD.Slow
}).withConfig({
    displayName: "FakeHeader",
    componentId: "sc-0-1"
})(sidebar_mobile_styles_templateObject1(), function(props) {
    return props.theme.header.bg;
}, base/* layout.headerHeight.mobile.rem */.bK.headerHeight.mobile.rem, zindex/* zindex.menu.header */.Y.menu.header));
var SlideLeftContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SlideLeftContainer",
    componentId: "sc-0-2"
})(sidebar_mobile_styles_templateObject2());

// EXTERNAL MODULE: ./src/areas/sidebar/components/sidebar-mobile/constants.ts
var sidebar_mobile_constants = __webpack_require__(8818);
;// CONCATENATED MODULE: ./src/areas/sidebar/components/sidebar-mobile/index.tsx
function sidebar_mobile_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || sidebar_mobile_unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function sidebar_mobile_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return sidebar_mobile_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return sidebar_mobile_arrayLikeToArray(o, minLen);
}











var SidebarMobile = function(param) {
    var categories = param.categories, currentView = param.currentView, isAuthenticated = param.isAuthenticated, isTraversingUpwards = param.isTraversingUpwards, me = param.me, menuHistory = param.menuHistory, onClose = param.onClose, onMenuChange = param.onMenuChange, onSelectHistory = param.onSelectHistory, open = param.open, selectedList = param.selectedList, setMobileSidebarView = param.setMobileSidebarView, navigateFromMobileMenu = param.navigateFromMobileMenu;
    var ref = _slicedToArray((0,react.useState)(null), 2), previousCategory = ref[0], setPreviousCategory = ref[1];
    var ref1 = _slicedToArray((0,react.useState)("100vh"), 2), viewportHeight = ref1[0], setViewportHeight = ref1[1];
    var ref2 = _slicedToArray((0,react.useState)(false), 2), draggableListsOnMobile = ref2[0], setDraggableListsOnMobile = ref2[1];
    var visible = open && categories && categories.length > 0;
    var currentCategory = menuHistory[menuHistory.length - 1];
    var parentCategory = menuHistory[menuHistory.length - 2];
    (0,react.useEffect)(function() {
        var updateViewportHeight = function() {
            if (false) {}
            // On mobile `vh` does not take browser UI into consideration,
            // causing 100vh to be higher than what is visible.
            // `window.innerHeight` is the actual visible height of the window
            // and will be updated every render.
            setViewportHeight("".concat(window.innerHeight, "px"));
        };
        window.addEventListener("resize", updateViewportHeight);
        updateViewportHeight();
        return function() {
            return window.removeEventListener("resize", updateViewportHeight);
        };
    }, [
        setViewportHeight
    ]);
    var changeMenuLevel = (0,react.useCallback)(function(category) {
        setPreviousCategory(currentCategory);
        onMenuChange({
            categories: category.children,
            parent: category
        });
    }, [
        currentCategory,
        onMenuChange,
        setPreviousCategory
    ]);
    var openParentCategory = (0,react.useCallback)(function() {
        if (parentCategory) {
            setPreviousCategory(currentCategory);
            onSelectHistory(parentCategory.id);
        }
    }, [
        currentCategory,
        onSelectHistory,
        parentCategory
    ]);
    var toggleDraggable = (0,react.useCallback)(function() {
        setDraggableListsOnMobile(!draggableListsOnMobile);
    }, [
        draggableListsOnMobile
    ]);
    var openView = (0,react.useCallback)(function(view) {
        (0,sidebar_tracking/* trackOpeningSidebar */.b)(view);
        setDraggableListsOnMobile(false);
        setMobileSidebarView(view);
    }, [
        setDraggableListsOnMobile,
        setMobileSidebarView
    ]);
    var openRootView = (0,react.useCallback)(function() {
        return openView(sidebar_mobile_constants/* VIEWS.ROOT */.n.ROOT);
    }, [
        openView
    ]);
    var closeMenu = (0,react.useCallback)(function() {
        setPreviousCategory(null);
        onClose();
    }, [
        onClose,
        setPreviousCategory
    ]);
    var closeMenuAndResetState = (0,react.useCallback)(function() {
        closeMenu();
        setMobileSidebarView(sidebar_mobile_constants/* VIEWS.ROOT */.n.ROOT);
    }, [
        closeMenu,
        setMobileSidebarView
    ]);
    var logoutClick = (0,react.useCallback)(function() {
        (0,sidebar_tracking/* trackClosingSidebar */.D)(currentView, "MobileLogoutButton");
        closeMenuAndResetState();
    }, [
        closeMenuAndResetState,
        currentView
    ]);
    var swipeOptions = (0,react.useMemo)(function() {
        return {
            continuous: false,
            transitionEnd: function(index) {
                // Close menu on swipe away
                if (index > 0) {
                    (0,sidebar_tracking/* trackClosingSidebar */.D)(currentView, "MobileSwipeToClose");
                    closeMenuAndResetState();
                }
            }
        };
    }, [
        closeMenuAndResetState,
        currentView
    ]);
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(Overlay, {
        active: visible
    }), /*#__PURE__*/ react.createElement(FakeHeader, {
        visible: visible
    }), /*#__PURE__*/ react.createElement(floater.Floater, {
        zIndex: zindex/* zindex.menu.mobile.overlay */.Y.menu.mobile.overlay,
        positioning: floater.Positioning.Fixed
    }, /*#__PURE__*/ react.createElement(hideable_variants.SlideLeft, {
        visible: visible,
        container: SlideLeftContainer
    }, /*#__PURE__*/ react.createElement(content/* default */.Z, {
        swipeOptions: swipeOptions,
        visible: visible,
        draggableOnMobile: draggableListsOnMobile,
        viewportHeight: viewportHeight,
        closeMenuAndResetState: closeMenuAndResetState,
        currentView: currentView,
        previousCategory: previousCategory,
        currentCategory: currentCategory,
        closeMenu: closeMenu,
        openView: openView,
        isAuthenticated: isAuthenticated,
        me: me,
        openParentCategory: openParentCategory,
        changeMenuLevel: changeMenuLevel,
        isTraversingUpwards: isTraversingUpwards,
        menuHistory: menuHistory,
        toggleMobileDraggable: toggleDraggable,
        selectedList: selectedList,
        onClose: onClose,
        openRootView: openRootView,
        logoutClick: logoutClick,
        navigateFromMobileMenu: navigateFromMobileMenu
    }))));
};
var sidebar_mobile_mapStateToProps = function(state) {
    return {
        selectedList: state.areas.sidebar.selectedList,
        me: state.areas.account.me,
        isAuthenticated: state.areas.account.isAuthenticated,
        currentView: state.areas.mobileSidebar.currentView
    };
};
var dispatchProps = {
    setMobileSidebarView: actions/* setMobileSidebarView */.E,
    navigateFromMobileMenu: mobile_menu/* default.navigateFromMobileMenu */.ZP.navigateFromMobileMenu
};
/* harmony default export */ const sidebar_mobile = ((0,es/* connect */.$j)(sidebar_mobile_mapStateToProps, dispatchProps)(SidebarMobile));

;// CONCATENATED MODULE: ./src/areas/navigation/mobile-navigation.js







var MobileNavigation = function(props) {
    var open = props.open, history = props.history, isTraversingUpwards = props.isTraversingUpwards, categories = props.categories, closeMenu = props.closeMenu, changeCategories = props.changeCategories, selectHistory = props.selectHistory;
    return /*#__PURE__*/ react.createElement(sidebar_mobile, {
        onClose: closeMenu,
        menuHistory: history,
        onSelectHistory: selectHistory,
        categories: categories,
        isTraversingUpwards: isTraversingUpwards,
        onMenuChange: changeCategories,
        open: open
    });
};
var func = (prop_types_default()).func, bool = (prop_types_default()).bool;
MobileNavigation.propTypes = {
    open: bool,
    history: types,
    isTraversingUpwards: bool,
    categories: types,
    closeMenu: func,
    navigateFromMobileMenu: func,
    selectHistory: func,
    changeCategories: func,
    showSidebar: bool
};
MobileNavigation.defaultProps = {
    open: false,
    history: [],
    isTraversingUpwards: false,
    categories: [],
    closeMenu: base/* noop */.ZT,
    navigateFromMobileMenu: base/* noop */.ZT,
    selectHistory: base/* noop */.ZT,
    changeCategories: base/* noop */.ZT,
    showSidebar: false
};
var mobile_navigation_mapStateToProps = function(state) {
    return {
        open: state.areas.navigation.mobileMenu.open,
        history: state.areas.navigation.mobileMenu.history,
        isTraversingUpwards: state.areas.navigation.mobileMenu.isTraversingUpwards,
        categories: state.areas.navigation.mobileMenu.categories
    };
};
var mobile_navigation_dispatchProps = {
    closeMenu: mobile_menu/* default.closeMenu */.ZP.closeMenu,
    changeCategories: mobile_menu/* default.changeCategories */.ZP.changeCategories,
    selectHistory: mobile_menu/* default.selectHistory */.ZP.selectHistory
};
/* harmony default export */ const mobile_navigation = ((0,es/* connect */.$j)(mobile_navigation_mapStateToProps, mobile_navigation_dispatchProps)(MobileNavigation));

// EXTERNAL MODULE: ./src/components/no-scroll/index.tsx
var no_scroll = __webpack_require__(84874);
// EXTERNAL MODULE: ./src/components/outside-click-tracker/index.js + 1 modules
var outside_click_tracker = __webpack_require__(64213);
;// CONCATENATED MODULE: ./src/areas/navigation/styles.ts
/* eslint-disable import/prefer-default-export */ function navigation_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function navigation_styles_templateObject() {
    var data = navigation_styles_taggedTemplateLiteral([
        "\n  height: calc(100vh - ",
        ");\n  top: ",
        ";\n  position: fixed;\n  width: 100%;\n  /* Should be above sidebar */\n  z-index: ",
        ";\n"
    ]);
    navigation_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function navigation_styles_templateObject1() {
    var data = navigation_styles_taggedTemplateLiteral([
        "\n  max-width: 1250px;\n  margin-left: auto;\n  margin-right: auto;\n\n  ul {\n    margin: 0;\n    list-style-type: none;\n  }\n"
    ]);
    navigation_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function navigation_styles_templateObject2() {
    var data = navigation_styles_taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    navigation_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function navigation_styles_templateObject3() {
    var data = navigation_styles_taggedTemplateLiteral([
        "\n  flex: 0 0 100%;\n  position: fixed;\n  background: ",
        ";\n  width: 100%;\n  max-height: 80vh;\n  overflow: hidden;\n  z-index: ",
        ";\n\n  ",
        ";\n"
    ]);
    navigation_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function navigation_styles_templateObject4() {
    var data = navigation_styles_taggedTemplateLiteral([
        "\n  flex: 0 0 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: ",
        ";\n  opacity: 0.9;\n\n  transition: opacity 0.1s ease;\n  visibility: visible;\n  position: fixed;\n  z-index: 9;\n"
    ]);
    navigation_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var NudgedBox = styled_components_browser_esm["default"].div.withConfig({
    displayName: "NudgedBox",
    componentId: "sc-0-0"
})(navigation_styles_templateObject(), base/* layout.headerHeight.desktop.rem */.bK.headerHeight.desktop.rem, base/* layout.headerHeight.desktop.rem */.bK.headerHeight.desktop.rem, zindex/* zindex.menu.mega */.Y.menu.mega);
var Navigation = styled_components_browser_esm["default"].nav.withConfig({
    displayName: "Navigation",
    componentId: "sc-0-1"
})(navigation_styles_templateObject1());
var NavigationWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "NavigationWrapper",
    componentId: "sc-0-2"
})(navigation_styles_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.bg.primary;
}, zindex/* zindex.menu.mega */.Y.menu.mega + 1, base/* media.mediumDown */.BC.mediumDown(navigation_styles_templateObject2()));
var styles_Overlay = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Overlay",
    componentId: "sc-0-3"
})(navigation_styles_templateObject4(), function(p) {
    return p.theme.bg.overlay;
});

;// CONCATENATED MODULE: ./src/areas/navigation/index.js
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function navigation_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function navigation_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            navigation_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function navigation_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function navigation_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        navigation_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}















var NavigationMenu = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    _inherits(NavigationMenu, _PureComponent);
    var _super = _createSuper(NavigationMenu);
    function NavigationMenu(props) {
        _classCallCheck(this, NavigationMenu);
        var _this;
        _this = _super.call(this, props);
        navigation_defineProperty(_assertThisInitialized(_this), "changeMegaMenuCategory", function(openCategory) {
            _this.props.changeCategory({
                openCategory: openCategory
            });
        });
        navigation_defineProperty(_assertThisInitialized(_this), "closeMegaMenu", function() {
            // Trigger redux action to change the state
            _this.props.toggleMenu({
                open: false
            });
            // Callback for side effects in parent component
            _this.props.onCloseMegaMenu();
        });
        navigation_defineProperty(_assertThisInitialized(_this), "openCategoryLink", function(categoryId) {
            _this.props.openCategoryLink({
                categoryId: categoryId
            });
        });
        _this.state = {
            fullTree: false
        };
        return _this;
    }
    _createClass(NavigationMenu, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                var market = this.context.market;
                fetch("/_internal/menu-tree", {
                    credentials: "include"
                }).then(function(res) {
                    return res.json();
                }).then(function(data) {
                    var categories = data.items;
                    var sortedCategories = categories.slice()// Sort mega menu categories by name on the top level
                    .sort(function(a, b) {
                        return a.name.localeCompare(b.name, market.locale.replace("_", "-"));
                    });
                    _this.props.setInitialMobileMenuData(categories);
                    _this.setState({
                        fullTree: true,
                        sortedCategories: sortedCategories
                    });
                    // Open the first category in mega menu by default
                    _this.changeMegaMenuCategory(sortedCategories[0].id);
                }).catch(function(err) {
                    // eslint-disable-next-line no-console
                    console.error(err);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, openCategory = _props.openCategory, open = _props.open;
                var _state = this.state, sortedCategories = _state.sortedCategories, fullTree = _state.fullTree;
                return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(viewport/* default */.Z, {
                    mobile: true,
                    tablet: true
                }, /*#__PURE__*/ react.createElement(mobile_navigation, null)), /*#__PURE__*/ react.createElement(viewport/* default */.Z, {
                    desktop: true
                }, /*#__PURE__*/ react.createElement(hideable_variants.NudgeUp, {
                    visible: open,
                    container: NudgedBox
                }, /*#__PURE__*/ react.createElement(outside_click_tracker/* default */.Z, {
                    onClickOutside: this.closeMegaMenu,
                    onEscapeKey: this.closeMegaMenu
                }, /*#__PURE__*/ react.createElement(NavigationWrapper, null, sortedCategories && /*#__PURE__*/ react.createElement(mega_menu/* default */.Z, {
                    openCategoryId: fullTree ? openCategory : null,
                    categories: sortedCategories,
                    onOpenCategory: this.changeMegaMenuCategory,
                    onClose: this.closeMegaMenu,
                    onOpenCategoryLink: this.openCategoryLink
                })))), /*#__PURE__*/ react.createElement(overlay/* default */.Z, {
                    active: open
                }), /*#__PURE__*/ react.createElement(no_scroll/* default */.Z, {
                    enabled: open
                })));
            }
        }
    ]);
    return NavigationMenu;
}(react.PureComponent);
var navigation_bool = (prop_types_default()).bool, navigation_func = (prop_types_default()).func, navigation_shape = (prop_types_default()).shape, navigation_string = (prop_types_default()).string, navigation_arrayOf = (prop_types_default()).arrayOf, node = (prop_types_default()).node;
NavigationMenu.propTypes = {
    openCategory: navigation_string,
    open: navigation_bool,
    toggleMenu: navigation_func,
    setInitialMobileMenuData: navigation_func,
    rootCategories: navigation_arrayOf(navigation_shape({
        id: navigation_string,
        name: navigation_string,
        semantic_id: navigation_string
    })),
    outsiderTrackContent: node,
    changeCategory: navigation_func,
    openCategoryLink: navigation_func,
    onCloseMegaMenu: navigation_func
};
NavigationMenu.defaultProps = {
    openCategory: null,
    open: false,
    rootCategories: undefined,
    outsiderTrackContent: undefined,
    changeCategory: base/* noop */.ZT,
    openCategoryLink: base/* noop */.ZT,
    onCloseMegaMenu: base/* noop */.ZT,
    toggleMenu: base/* noop */.ZT,
    setInitialMobileMenuData: base/* noop */.ZT
};
NavigationMenu.contextType = app_context/* AppContext */.Il;
/* harmony default export */ const navigation = ((0,es/* connect */.$j)(function(state) {
    return state.areas.navigation.megaMenu;
}, navigation_objectSpreadProps(navigation_objectSpread({}, desktop/* default */.ZP), {
    setInitialMobileMenuData: mobile_menu/* default.setInitialData */.ZP.setInitialData
}))(NavigationMenu));

// EXTERNAL MODULE: ./src/areas/navigation/components/mobile-menu-button/index.tsx + 1 modules
var mobile_menu_button = __webpack_require__(66782);
// EXTERNAL MODULE: ./src/areas/sidebar/actions/lists.js
var lists = __webpack_require__(40054);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/list/variants.js
var list_variants = __webpack_require__(35967);
// EXTERNAL MODULE: ./src/components/user-avatar/index.tsx + 1 modules
var user_avatar = __webpack_require__(93538);
;// CONCATENATED MODULE: ./src/areas/account/menu/styles.ts
function menu_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function menu_styles_templateObject() {
    var data = menu_styles_taggedTemplateLiteral([
        "\n  &:not(:last-child) {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    menu_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function menu_styles_templateObject1() {
    var data = menu_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  text-decoration: underline;\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    menu_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function menu_styles_templateObject2() {
    var data = menu_styles_taggedTemplateLiteral([
        "\n  display: block;\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    menu_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function menu_styles_templateObject3() {
    var data = menu_styles_taggedTemplateLiteral([
        "\n  padding: ",
        ";\n"
    ]);
    menu_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function menu_styles_templateObject4() {
    var data = menu_styles_taggedTemplateLiteral([
        "\n  align-items: center;\n\n  svg {\n    fill: ",
        ";\n  }\n"
    ]);
    menu_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function menu_styles_templateObject5() {
    var data = menu_styles_taggedTemplateLiteral([
        "\n  border-radius: 50%;\n  background: ",
        ";\n  color: ",
        ";\n  width: 40px;\n  height: 40px;\n\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    menu_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function menu_styles_templateObject6() {
    var data = menu_styles_taggedTemplateLiteral([
        "\n  background: none;\n\n  &:hover {\n    background: none;\n  }\n"
    ]);
    menu_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}







var StyledOutlinedButton = (0,styled_components_browser_esm["default"])(variants.OutlinedButton).withConfig({
    displayName: "StyledOutlinedButton",
    componentId: "sc-0-0"
})(menu_styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var SignupLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "SignupLink",
    componentId: "sc-0-1"
})(menu_styles_templateObject1(), function(p) {
    return p.theme.colors.maybeBlue700;
}, function(p) {
    return p.theme.colors.maybeBlue500;
});
var MenuItemLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "MenuItemLink",
    componentId: "sc-0-2"
})(menu_styles_templateObject2(), function(p) {
    return p.theme.text.callToActionHover;
});
var ProfileLinks = (0,styled_components_browser_esm["default"])(list_variants.Column).withConfig({
    displayName: "ProfileLinks",
    componentId: "sc-0-3"
})(menu_styles_templateObject3(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var AnalyticsWrapper = (0,styled_components_browser_esm["default"])(list_variants.Row).withConfig({
    displayName: "AnalyticsWrapper",
    componentId: "sc-0-4"
})(menu_styles_templateObject4(), function(p) {
    return p.theme.colors.maybeBlue700;
});
var DropdownToggle = (0,styled_components_browser_esm["default"])(dropdown/* DropdownToggle */.Z_).withConfig({
    displayName: "DropdownToggle",
    componentId: "sc-0-5"
})(menu_styles_templateObject5(), function(p) {
    return p.theme.colors.informative700;
}, function(p) {
    return p.theme.colors.base0;
}, function(p) {
    return base/* colorUtils.shadeColor */.$n.shadeColor(p.theme.buttons.primary.bg, -20);
});
var UserAvatar = (0,styled_components_browser_esm["default"])(user_avatar/* UserAvatar */.Y).withConfig({
    displayName: "UserAvatar",
    componentId: "sc-0-6"
})(menu_styles_templateObject6());

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/button/index.js
var ui_button = __webpack_require__(17658);
// EXTERNAL MODULE: ./src/client/data-layer.ts
var data_layer = __webpack_require__(80695);
;// CONCATENATED MODULE: ./src/areas/account/menu/index.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}












var AccountMenu = function(param) {
    var style = param.style, className = param.className, closeLists = param.closeLists, selectList = param.selectList, me = param.me;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), t = ref.t, market = ref.market;
    var logout = (0,use_schibsted_account/* useSchibstedAccount */.F)().logout;
    var onLogout = (0,react.useCallback)(function() {
        selectList(null);
        closeLists();
        if (market.login.enabled) {
            (0,data_layer/* pushEvent */.A)("logoutComplete", {
                loggedIn: false
            });
            logout();
        }
    }, [
        selectList,
        closeLists,
        market.login.enabled,
        logout
    ]);
    return /*#__PURE__*/ react.createElement(dropdown/* Dropdown */.Lt, {
        className: className,
        style: style,
        closeOnItemClick: true
    }, /*#__PURE__*/ react.createElement(DropdownToggle, {
        onlyIcon: true,
        type: ui_button.ButtonType.TEXT,
        size: ui_button.ButtonSize.MEDIUM
    }, /*#__PURE__*/ react.createElement(UserAvatar, _extends({}, me, {
        size: 24
    }))), /*#__PURE__*/ react.createElement(dropdown/* DropdownContent */.Nv, {
        width: 200,
        alignment: ui/* Direction.Right */.Nm.Right
    }, /*#__PURE__*/ react.createElement(ProfileLinks, {
        gap: 1
    }, /*#__PURE__*/ react.createElement(MenuItemLink, {
        to: "/account/profile"
    }, /*#__PURE__*/ react.createElement(text_variants.TitleSmallText, null, t("account", "profile.title"))), /*#__PURE__*/ react.createElement(MenuItemLink, {
        to: "/account/profile/settings"
    }, /*#__PURE__*/ react.createElement(text_variants.TitleSmallText, null, t("account", "menu.settings"))), /*#__PURE__*/ react.createElement(StyledOutlinedButton, {
        fullWidth: true,
        onClick: onLogout
    }, t("account", "menu.logout-button")))));
};
var menu_mapStateToProps = function(state) {
    return {
        me: state.areas.account.me
    };
};
var dispatchActions = {
    closeLists: lists/* closeLists */.c,
    selectList: lists/* selectList */.Fz
};
/* harmony default export */ const menu = ((0,es/* connect */.$j)(menu_mapStateToProps, dispatchActions)(AccountMenu));

// EXTERNAL MODULE: ./src/areas/header/styles.ts
var styles = __webpack_require__(47609);
;// CONCATENATED MODULE: ./src/areas/header/index.tsx
function header_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function header_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function header_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function header_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function header_slicedToArray(arr, i) {
    return header_arrayWithHoles(arr) || header_iterableToArrayLimit(arr, i) || header_unsupportedIterableToArray(arr, i) || header_nonIterableRest();
}
function header_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return header_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return header_arrayLikeToArray(o, minLen);
}




















var Header = function(param) {
    var mobileMenuOpen = param.mobileMenuOpen, _megaMenuOpen = param.megaMenuOpen, megaMenuOpen = _megaMenuOpen === void 0 ? false : _megaMenuOpen, toggleMenu = param.toggleMenu, closeMobileMenu = param.closeMobileMenu, isAuthenticated = param.isAuthenticated;
    var megaMenuButtonRef = (0,react.useRef)(null);
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), t = ref.t, market = ref.market;
    var ref1 = header_slicedToArray((0,react.useState)(false), 2), searchBarVisible = ref1[0], setSearchBarVisible = ref1[1];
    var showSearchBarInHero = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.search.visibleInHero;
    });
    (0,react.useEffect)(function() {
        setSearchBarVisible(!showSearchBarInHero);
    }, [
        showSearchBarInHero
    ]);
    var toggleMegaMenu = (0,react.useCallback)(function(e) {
        // Prevent event from triggering an "outside click" for the menu
        e.stopPropagation();
        toggleMenu({
            open: !megaMenuOpen
        });
    }, [
        toggleMenu,
        megaMenuOpen
    ]);
    var onCloseMegaMenu = (0,react.useCallback)(function() {
        if (megaMenuButtonRef.current) {
            megaMenuButtonRef.current.focus();
        }
    }, []);
    var sendFocusSearchEvent = function() {
        window.scrollTo({
            top: 0
        });
        setTimeout(function() {
            var event = new CustomEvent("focus-search-event", {
                detail: {
                    focus: true
                }
            });
            dispatchEvent(event);
        }, 60);
    };
    var menuButtonTitle = megaMenuOpen ? t("symbols", "symbol.close") : t("header", "categories.title");
    var login = (0,use_schibsted_account/* useSchibstedAccount */.F)().login;
    var loginButtonOnClick = function() {
        login();
    };
    return /*#__PURE__*/ react.createElement(styles/* HeaderWrapper */.Pz, null, /*#__PURE__*/ react.createElement(styles/* HeaderBar */.h_, null, /*#__PURE__*/ react.createElement(styles/* MegaMenuItem */.TS, {
        title: menuButtonTitle,
        placement: ui/* Direction.Right */.Nm.Right
    }, /*#__PURE__*/ react.createElement(styles/* MegaMenuButton */.J7, {
        type: "button",
        onClick: toggleMegaMenu,
        "aria-label": menuButtonTitle,
        active: megaMenuOpen,
        "aria-expanded": megaMenuOpen,
        "aria-haspopup": true,
        ref: megaMenuButtonRef,
        "data-test": "MegaMenuToggleButton"
    }, megaMenuOpen ? /*#__PURE__*/ react.createElement(styles/* CloseMegaMenuIcon */.m4, {
        size: 30
    }) : /*#__PURE__*/ react.createElement(styles/* MegaMenuIcon */.pA, {
        size: 30
    }))), /*#__PURE__*/ react.createElement(styles/* Wrapper */.im, null, /*#__PURE__*/ react.createElement(styles/* MenuColumn */.ru, {
        "data-test": "MobileMenuColumn"
    }, /*#__PURE__*/ react.createElement(styles/* MenuItem */.sN, null, /*#__PURE__*/ react.createElement(mobile_menu_button/* default */.Z, null))), /*#__PURE__*/ react.createElement(styles/* LogoColumn */.b1, null, /*#__PURE__*/ react.createElement(styles/* LogoLink */.vw, {
        to: "/",
        onClick: function() {
            (0,tracking/* trackInternalNavigationClick */.p)({
                scope: tracking/* InternalNavigationScope.LOGO */.U.LOGO,
                nextPage: "/"
            });
            if (mobileMenuOpen) {
                closeMobileMenu();
            }
        }
    }, /*#__PURE__*/ react.createElement(logo/* Logo */.T, {
        market: market.code,
        companyName: t("meta", "market.logo-alt"),
        styling: "v2-light"
    }))), /*#__PURE__*/ react.createElement(styles/* SearchBarWrapper */.cI, {
        $visible: searchBarVisible
    }, /*#__PURE__*/ react.createElement(search_bar/* default */.Z, {
        visible: searchBarVisible
    })), /*#__PURE__*/ react.createElement(styles/* RightColumn */.b, null, /*#__PURE__*/ react.createElement(viewport/* default */.Z, {
        mobile: true
    }, /*#__PURE__*/ react.createElement(styles/* MenuItem */.sN, null, /*#__PURE__*/ react.createElement(hideable.Hideable, {
        visible: searchBarVisible
    }, /*#__PURE__*/ react.createElement(styles/* MagnifyerButton */.Yt, {
        "aria-label": t("header", "search.button"),
        onClick: sendFocusSearchEvent
    }, /*#__PURE__*/ react.createElement(styles/* SearchIcon */.W1, {
        size: 30
    }))))), market.login.enabled && /*#__PURE__*/ react.createElement(styles/* UserArea */.TA, null, isAuthenticated ? /*#__PURE__*/ react.createElement(menu, null) : /*#__PURE__*/ react.createElement(variants.TonalButton, {
        container: clickable/* Clickable */.P,
        tone: variants.ButtonTone.DARK,
        onClick: loginButtonOnClick
    }, t("account", "menu.not-logged-in-button")))))), /*#__PURE__*/ react.createElement(navigation, {
        onCloseMegaMenu: onCloseMegaMenu
    }));
};
var header_mapStateToProps = function(state) {
    return {
        mobileMenuOpen: state.areas.navigation.mobileMenu.open,
        megaMenuOpen: state.areas.navigation.megaMenu.open,
        me: state.areas.account.me,
        isAuthenticated: state.areas.account.isAuthenticated,
        ads: state.ads
    };
};
var header_dispatchActions = {
    searchFocus: search/* default.searchFocus */.ZP.searchFocus,
    searchBlur: search/* default.searchBlur */.ZP.searchBlur,
    closeMobileMenu: mobile_menu/* default.closeMenu */.ZP.closeMenu,
    toggleMenu: desktop/* default.toggleMenu */.ZP.toggleMenu
};
/* harmony default export */ const header = ((0,redux.compose)((0,es/* connect */.$j)(header_mapStateToProps, header_dispatchActions))(Header));

// EXTERNAL MODULE: ./src/contexts/wide-context.tsx
var wide_context = __webpack_require__(59547);
// EXTERNAL MODULE: ./src/ui/block/index.ts
var block = __webpack_require__(65176);
// EXTERNAL MODULE: ./src/areas/product-collection/constants/index.js
var product_collection_constants = __webpack_require__(46294);
// EXTERNAL MODULE: ./src/areas/sidebar/views/alerts/index.tsx
var alerts = __webpack_require__(83527);
// EXTERNAL MODULE: ./src/areas/sidebar/views/filter/index.tsx
var filter = __webpack_require__(40399);
// EXTERNAL MODULE: ./src/areas/sidebar/views/list/index.tsx
var views_list = __webpack_require__(96906);
// EXTERNAL MODULE: ./src/areas/sidebar/views/lists/index.tsx
var views_lists = __webpack_require__(90929);
// EXTERNAL MODULE: ./src/areas/changelog/components/badge/index.tsx
var badge = __webpack_require__(27203);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/megaphone/index.js
var megaphone = __webpack_require__(74731);
;// CONCATENATED MODULE: ./src/areas/changelog/components/toggle-button/index.tsx
function toggle_button_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function toggle_button_templateObject() {
    var data = toggle_button_taggedTemplateLiteral([
        "\n    position: relative;\n    color: ",
        ";\n  "
    ]);
    toggle_button_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function toggle_button_templateObject1() {
    var data = toggle_button_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n"
    ]);
    toggle_button_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var ChangelogToggle = function(param) {
    var onClickHandler = param.onClickHandler;
    var t = (0,app_context/* useAppContext */.bp)().t;
    return /*#__PURE__*/ react.createElement(Button, {
        onClick: onClickHandler,
        type: variants.ButtonType.TEXT,
        tone: variants.ButtonTone.LIGHT,
        ariaLabel: t("changelog", "changelog.title")
    }, /*#__PURE__*/ react.createElement(Inner, null, /*#__PURE__*/ react.createElement(badge/* default */.ZP, {
        noOutline: true
    }), /*#__PURE__*/ react.createElement(megaphone/* IconMegaphone */.I, {
        size: 20,
        color: "maybeBlue700"
    })));
};
var Button = (0,styled_components_browser_esm["default"])(variants.IconButton).withConfig({
    displayName: "Button",
    componentId: "sc-0-0"
})(function(p) {
    return (0,styled_components_browser_esm.css)(toggle_button_templateObject(), p.theme.icons.secondary);
});
var Inner = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Inner",
    componentId: "sc-0-1"
})(toggle_button_templateObject1());

// EXTERNAL MODULE: ./src/areas/changelog/changelog-loadable.tsx
var changelog_loadable = __webpack_require__(72062);
// EXTERNAL MODULE: ./src/areas/changelog/styles.ts
var changelog_styles = __webpack_require__(17961);
;// CONCATENATED MODULE: ./src/areas/changelog/desktop-wrapper.tsx





var selectChangelogOpen = function(state) {
    return state.areas.changelog.isOpen;
};
var selectChangelogArticles = function(state) {
    return state.areas.changelog.articles;
};
var ChangelogDesktop = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var articles = (0,es/* useSelector */.v9)(selectChangelogArticles);
    var isOpen = (0,es/* useSelector */.v9)(selectChangelogOpen);
    var toggleOpen = (0,react.useCallback)(function(e) {
        e.preventDefault();
        e.stopPropagation();
        dispatch({
            type: "CHANGELOG_TOGGLE"
        });
    }, [
        dispatch
    ]);
    if (!articles || !articles.length) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(changelog_styles/* ChangelogWrapper */.Xw, null, /*#__PURE__*/ react.createElement(ChangelogToggle, {
        onClickHandler: toggleOpen
    }), isOpen && // Conditionally render this to not load the extra bundle on pageload
    /*#__PURE__*/ react.createElement(changelog_styles/* ChangelogModal */.Xc, {
        visible: isOpen
    }, /*#__PURE__*/ react.createElement(changelog_loadable/* Changelog */.E, null)));
};
/* harmony default export */ const desktop_wrapper = (ChangelogDesktop);

// EXTERNAL MODULE: ./src/areas/sidebar/actions/alert.js
var actions_alert = __webpack_require__(83846);
// EXTERNAL MODULE: ./src/areas/sidebar/actions/filter.js
var actions_filter = __webpack_require__(7966);
;// CONCATENATED MODULE: ./src/areas/sidebar/components/icons/toggle-sidebar.tsx

var ToggleSidebarIcon = function(param) {
    var className = param.className, size = param.size, title = param.title;
    return /*#__PURE__*/ react.createElement("svg", {
        className: className,
        height: size,
        width: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32"
    }, title && /*#__PURE__*/ react.createElement("title", null, title), /*#__PURE__*/ react.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M18.028 9.2L16.5 10.805 21.47 16l-4.97 5.195 1.528 1.605L24.5 16zm-7 0L9.5 10.805 14.47 16 9.5 21.195l1.528 1.605L17.5 16z",
        fill: "#909090"
    })));
};
/* harmony default export */ const toggle_sidebar = (ToggleSidebarIcon);

;// CONCATENATED MODULE: ./src/areas/sidebar/components/sidebar-desktop/components/menu-bar/styles.ts
function menu_bar_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function menu_bar_styles_templateObject() {
    var data = menu_bar_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  align-items: center;\n  width: ",
        ";\n  background-color: ",
        ";\n  padding: ",
        " 0;\n  z-index: ",
        ";\n"
    ]);
    menu_bar_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function menu_bar_styles_templateObject1() {
    var data = menu_bar_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  > * {\n    margin-top: ",
        ";\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    menu_bar_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function menu_bar_styles_templateObject2() {
    var data = menu_bar_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  margin-top: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-bottom: ",
        ";\n  padding-top: ",
        ";\n\n  > * {\n    margin-top: ",
        ";\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    menu_bar_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function menu_bar_styles_templateObject3() {
    var data = menu_bar_styles_taggedTemplateLiteral([
        "\n      color: ",
        ";\n      background-color: ",
        ";\n    "
    ]);
    menu_bar_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function menu_bar_styles_templateObject4() {
    var data = menu_bar_styles_taggedTemplateLiteral([
        "\n      visibility: hidden;\n      opacity: 0;\n      transition:\n        visibility 0s ease 200ms,\n        opacity 200ms;\n    "
    ]);
    menu_bar_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function menu_bar_styles_templateObject5() {
    var data = menu_bar_styles_taggedTemplateLiteral([
        "\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 40px;\n    height: 40px;\n    border-radius: 20px;\n    margin-left: auto;\n    margin-right: auto;\n    transition:\n      background 200ms ease,\n      color 200ms ease,\n      visibility 0s ease 0s,\n      opacity 200ms;\n    background: transparent;\n    color: ",
        ";\n    visibility: visible;\n    opacity: 1;\n\n    ",
        "\n\n    rect,\n    path {\n      fill: ",
        ";\n    }\n\n    ",
        "\n\n    &:hover,\n    &.focus-visible {\n      color: ",
        ";\n    }\n  "
    ]);
    menu_bar_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function menu_bar_styles_templateObject6() {
    var data = menu_bar_styles_taggedTemplateLiteral([
        "\n  pointer-events: none;\n  background: ",
        ";\n  height: 1px;\n  width: 75%;\n"
    ]);
    menu_bar_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = menu_bar_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  &:hover,\n  &.focus-visible {\n    color: ",
        ";\n  }\n  transition: transform 200ms ease;\n  transform: ",
        ";\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}




var padding = base/* layout.measurements.spacing050 */.bK.measurements.spacing050;
var menuWidth = base/* layout.sidebarMenuWidth.desktop */.bK.sidebarMenuWidth.desktop;
var SidebarMenu = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SidebarMenu",
    componentId: "sc-0-0"
})(menu_bar_styles_templateObject(), menuWidth.rem, function(p) {
    return p.theme.colors.base100;
}, padding, zindex/* zindex.menu.left */.Y.menu.left);
var TopBar = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TopBar",
    componentId: "sc-0-1"
})(menu_bar_styles_templateObject1(), padding, padding);
var BottomBar = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BottomBar",
    componentId: "sc-0-2"
})(menu_bar_styles_templateObject2(), padding, padding, padding, padding);
var MenuButton = styled_components_browser_esm["default"].button.withConfig({
    displayName: "MenuButton",
    componentId: "sc-0-3"
})(function(props) {
    return (0,styled_components_browser_esm.css)(menu_bar_styles_templateObject5(), props.theme.colors.base500, props.active && props.hoverEffect === "background" && (0,styled_components_browser_esm.css)(menu_bar_styles_templateObject3(), props.theme.colors.base0, props.theme.icons.callToActionHover), props.active ? props.theme.colors.base0 : "currentColor", props.hidden && (0,styled_components_browser_esm.css)(menu_bar_styles_templateObject4()), props.active ? "inherit" : props.theme.icons.callToActionHover);
});
MenuButton.defaultProps = {
    hoverEffect: "background"
};
var Divider = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Divider",
    componentId: "sc-0-4"
})(menu_bar_styles_templateObject6(), function(p) {
    return p.theme.lines.primary;
});
var styles_ToggleSidebarIcon = (0,styled_components_browser_esm["default"])(toggle_sidebar).withConfig({
    displayName: "ToggleSidebarIcon",
    componentId: "sc-0-5"
})(styles_templateObject7(), function(p) {
    return p.theme.colors.base300;
}, function(p) {
    return p.theme.icons.callToActionHover;
}, function(p) {
    return p.open ? "rotate(180deg)" : "none";
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/filter/index.js
var icon_filter = __webpack_require__(93438);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/heart-filled/index.js
var heart_filled = __webpack_require__(63479);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/heart-outlined/index.js
var heart_outlined = __webpack_require__(92261);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/notification-filled/index.js
var notification_filled = __webpack_require__(35451);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/notification-outlined/index.js
var notification_outlined = __webpack_require__(72523);
// EXTERNAL MODULE: ./src/components/experiment/index.ts + 1 modules
var experiment = __webpack_require__(75234);
// EXTERNAL MODULE: ./src/components/experiment/experiments-list.tsx + 2 modules
var experiments_list = __webpack_require__(98569);
;// CONCATENATED MODULE: ./src/components/experiment/editor-desktop.tsx
function editor_desktop_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function editor_desktop_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function editor_desktop_extends() {
    editor_desktop_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return editor_desktop_extends.apply(this, arguments);
}
function editor_desktop_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function editor_desktop_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function editor_desktop_slicedToArray(arr, i) {
    return editor_desktop_arrayWithHoles(arr) || editor_desktop_iterableToArrayLimit(arr, i) || editor_desktop_unsupportedIterableToArray(arr, i) || editor_desktop_nonIterableRest();
}
function editor_desktop_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return editor_desktop_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return editor_desktop_arrayLikeToArray(o, minLen);
}






var Editor = function(props) {
    var ref = editor_desktop_slicedToArray(react.useState(false), 2), mounted = ref[0], setMounted = ref[1];
    (0,react.useEffect)(function() {
        setMounted(true);
    }, []);
    if (!mounted) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(dropdown/* Dropdown */.Lt, null, /*#__PURE__*/ react.createElement(dropdown/* DropdownToggle */.Z_, {
        onlyIcon: true,
        type: variants.ButtonType.TEXT
    }, /*#__PURE__*/ react.createElement("img", {
        width: "20",
        height: "20",
        alt: "Experiment Editor",
        src: "https://cdn.pji.nu/g/logo/icon192x192.png"
    })), /*#__PURE__*/ react.createElement(dropdown/* DropdownContent */.Nv, {
        alignment: ui/* Direction.Down */.Nm.Down,
        placement: ui/* Direction.Right */.Nm.Right
    }, /*#__PURE__*/ react.createElement(experiments_list/* ExperimentsList */.F, editor_desktop_extends({}, props))));
};
var ExperimentEditorDesktop = function() {
    return /*#__PURE__*/ react.createElement(experiment/* ExperimentContext.Consumer */.T.Consumer, null, function(_param) {
        var showEditor = _param.showEditor, rest = _objectWithoutProperties(_param, [
            "showEditor"
        ]);
        if (!showEditor) {
            return null;
        }
        return /*#__PURE__*/ react.createElement(Editor, editor_desktop_extends({}, rest));
    });
};

;// CONCATENATED MODULE: ./src/areas/sidebar/components/sidebar-desktop/components/menu-bar/index.tsx

















var SidebarMenuBar = function(param) {
    var _tab = param.tab, tab = _tab === void 0 ? constants/* SIDEBAR_STATE.NONE */.$J.NONE : _tab, _previousTab = param.previousTab, previousTab = _previousTab === void 0 ? constants/* SIDEBAR_STATE.LISTS */.$J.LISTS : _previousTab, tmp = param.// eslint-disable-next-line @typescript-eslint/no-empty-function
    closeLists, dispatchCloseLists = tmp === void 0 ? function() {} : tmp, tmp1 = param.// eslint-disable-next-line @typescript-eslint/no-empty-function
    openLists, dispatchOpenLists = tmp1 === void 0 ? function() {} : tmp1, tmp2 = param.// eslint-disable-next-line @typescript-eslint/no-empty-function
    openAlerts, dispatchOpenAlerts = tmp2 === void 0 ? function() {} : tmp2, tmp3 = param.// eslint-disable-next-line @typescript-eslint/no-empty-function
    toggleFilter, dispatchToggleFilter = tmp3 === void 0 ? function() {} : tmp3, showFilter = param.showFilter, showHorizontalFilter = param.showHorizontalFilter;
    var ref = (0,app_context/* useAppContext */.bp)(), t = ref.t, market = ref.market;
    // Generate unique UIDs to use as HTML ids
    var getId = (0,react.useId)();
    var listsTabId = "".concat(getId, "-sidebar-desktop-lists");
    var alertsTabId = "".concat(getId, "-sidebar-desktop-alerts");
    var filterTabId = "".concat(getId, "-sidebar-desktop-filter");
    var isSidebarOpen = tab !== constants/* SIDEBAR_STATE.NONE */.$J.NONE;
    var isListTabActive = tab === constants/* SIDEBAR_STATE.LISTS */.$J.LISTS;
    var isAlertsTabActive = tab === constants/* SIDEBAR_STATE.ALERTS */.$J.ALERTS;
    var isFilterTabActive = tab === constants/* SIDEBAR_STATE.FILTER */.$J.FILTER;
    var toggleView = (0,react.useCallback)(function(state) {
        switch(state){
            case tab:
                dispatchCloseLists();
                break;
            case constants/* SIDEBAR_STATE.LISTS */.$J.LISTS:
                dispatchOpenLists();
                break;
            case constants/* SIDEBAR_STATE.ALERTS */.$J.ALERTS:
                dispatchOpenAlerts();
                break;
            case constants/* SIDEBAR_STATE.FILTER */.$J.FILTER:
                dispatchToggleFilter();
                break;
            default:
                dispatchCloseLists();
        }
    }, [
        dispatchCloseLists,
        dispatchOpenAlerts,
        dispatchOpenLists,
        tab,
        dispatchToggleFilter
    ]);
    var handleListsMenuButton = (0,react.useCallback)(function() {
        if (tab === constants/* SIDEBAR_STATE.LISTS */.$J.LISTS) {
            (0,sidebar_tracking/* trackClosingSidebar */.D)(constants/* SIDEBAR_STATE.LISTS */.$J.LISTS, "sidebarListsButton");
        } else {
            (0,sidebar_tracking/* trackOpeningSidebar */.b)(constants/* SIDEBAR_STATE.LISTS */.$J.LISTS, "sidebarListsButton");
        }
        toggleView(constants/* SIDEBAR_STATE.LISTS */.$J.LISTS);
    }, [
        toggleView,
        tab
    ]);
    var handleAlertsMenuButton = (0,react.useCallback)(function() {
        if (tab === constants/* SIDEBAR_STATE.ALERTS */.$J.ALERTS) {
            (0,sidebar_tracking/* trackClosingSidebar */.D)(constants/* SIDEBAR_STATE.ALERTS */.$J.ALERTS, "sidebarAlertsButton");
        } else {
            (0,sidebar_tracking/* trackOpeningSidebar */.b)(constants/* SIDEBAR_STATE.ALERTS */.$J.ALERTS, "sidebarAlertsButton");
        }
        toggleView(constants/* SIDEBAR_STATE.ALERTS */.$J.ALERTS);
    }, [
        toggleView,
        tab
    ]);
    var handleToggleButton = (0,react.useCallback)(function() {
        if (isSidebarOpen) {
            (0,sidebar_tracking/* trackClosingSidebar */.D)(tab, "sidebarToggleButton");
            toggleView(constants/* SIDEBAR_STATE.NONE */.$J.NONE);
            return;
        }
        // Open default view if previous view was filter but no longer
        // on a leaf category page, or if filter is set to HorizontalFilter,
        // or `previousTab` is empty.
        if (!previousTab || previousTab === constants/* SIDEBAR_STATE.FILTER */.$J.FILTER && !showFilter || previousTab === constants/* SIDEBAR_STATE.FILTER */.$J.FILTER && showHorizontalFilter) {
            (0,sidebar_tracking/* trackOpeningSidebar */.b)(constants/* DEFAULT_SIDEBAR_STATE */.N3, "sidebarToggleButton");
            toggleView(constants/* DEFAULT_SIDEBAR_STATE */.N3);
            return;
        }
        (0,sidebar_tracking/* trackOpeningSidebar */.b)(previousTab, "sidebarToggleButton");
        toggleView(previousTab);
    }, [
        isSidebarOpen,
        previousTab,
        showFilter,
        showHorizontalFilter,
        toggleView,
        tab
    ]);
    var sidebarHasButtons = market.login.enabled || showFilter && !showHorizontalFilter;
    return /*#__PURE__*/ react.createElement(SidebarMenu, null, /*#__PURE__*/ react.createElement(TopBar, null, market.login.enabled && /*#__PURE__*/ react.createElement(MenuButton, {
        active: false,
        hoverEffect: "background",
        onClick: handleToggleButton,
        hidden: !sidebarHasButtons,
        "aria-label": isSidebarOpen ? t("symbols", "symbol.collapse-sidebar") : t("symbols", "symbol.expand-sidebar"),
        "aria-expanded": isSidebarOpen,
        "aria-haspopup": "true"
    }, /*#__PURE__*/ react.createElement(styles_ToggleSidebarIcon, {
        size: 24,
        open: isSidebarOpen
    })), market.login.enabled && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(MenuButton, {
        active: isListTabActive,
        onClick: handleListsMenuButton,
        "data-test": "MenuButtonLists",
        "aria-label": t("lists", "lists.title"),
        "aria-expanded": isListTabActive,
        "aria-haspopup": "true",
        "aria-controls": listsTabId
    }, isListTabActive ? /*#__PURE__*/ react.createElement(heart_filled/* IconHeartFilled */.g, null) : /*#__PURE__*/ react.createElement(heart_outlined/* IconHeartOutlined */.G, null)), /*#__PURE__*/ react.createElement(MenuButton, {
        active: isAlertsTabActive,
        onClick: handleAlertsMenuButton,
        "data-test": "MenuButtonAlerts",
        "aria-label": t("alerts", "alerts.title"),
        "aria-expanded": isAlertsTabActive,
        "aria-haspopup": "true",
        "aria-controls": alertsTabId
    }, isAlertsTabActive ? /*#__PURE__*/ react.createElement(notification_filled/* IconNotificationFilled */.Q, null) : /*#__PURE__*/ react.createElement(notification_outlined/* IconNotificationOutlined */.F, null))), /*#__PURE__*/ react.createElement(MenuButton, {
        active: isFilterTabActive,
        onClick: function() {
            return toggleView(constants/* SIDEBAR_STATE.FILTER */.$J.FILTER);
        },
        hidden: !showFilter || showHorizontalFilter,
        "data-test": "MenuButtonFilter",
        "aria-label": t("filter", "filter.title"),
        "aria-expanded": isFilterTabActive,
        "aria-haspopup": "true",
        "aria-controls": filterTabId
    }, /*#__PURE__*/ react.createElement(icon_filter/* IconFilter */.w, {
        size: 21
    }))), /*#__PURE__*/ react.createElement(block/* DesktopOnly */.NZ, null, /*#__PURE__*/ react.createElement(BottomBar, null, /*#__PURE__*/ react.createElement(desktop_wrapper, null), /*#__PURE__*/ react.createElement(ExperimentEditorDesktop, null))));
};
var menu_bar_mapStateToProps = function(state) {
    return {
        tab: state.areas.sidebar.tab,
        previousTab: state.areas.sidebar.previousTab,
        showFilter: state.areas.category.filter.showFilter || state.areas.sidebar.hasFilter,
        showHorizontalFilter: state.areas.category.filter.showHorizontalFilter
    };
};
var menu_bar_dispatchProps = {
    openLists: lists/* openLists */.pu,
    closeLists: lists/* closeLists */.c,
    openAlerts: actions_alert/* openAlerts */.SU,
    closeAlerts: actions_alert/* closeAlerts */.ys,
    toggleFilter: actions_filter/* toggleFilter */.c
};
/* harmony default export */ const menu_bar = ((0,es/* connect */.$j)(menu_bar_mapStateToProps, menu_bar_dispatchProps)(SidebarMenuBar));

;// CONCATENATED MODULE: ./src/areas/sidebar/components/sidebar-desktop/styles.ts
function sidebar_desktop_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function sidebar_desktop_styles_templateObject() {
    var data = sidebar_desktop_styles_taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    sidebar_desktop_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function sidebar_desktop_styles_templateObject1() {
    var data = sidebar_desktop_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-shrink: 0;\n  z-index: ",
        ";\n\n  width: ",
        ";\n  transition: width ",
        "ms ease;\n  grid-row: 1 / span 2;\n\n  ",
        "\n\n  ",
        ";\n"
    ]);
    sidebar_desktop_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function sidebar_desktop_styles_templateObject2() {
    var data = sidebar_desktop_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  position: fixed;\n  height: calc(100vh - ",
        ");\n  z-index: ",
        ";\n"
    ]);
    sidebar_desktop_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function sidebar_desktop_styles_templateObject3() {
    var data = sidebar_desktop_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  align-items: center;\n  width: ",
        ";\n  background-color: ",
        ";\n  padding: ",
        " 0;\n  z-index: 99;\n"
    ]);
    sidebar_desktop_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function sidebar_desktop_styles_templateObject4() {
    var data = sidebar_desktop_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  flex-shrink: 0;\n  width: ",
        ";\n  border-right: 1px solid ",
        ";\n  overflow: auto;\n  overscroll-behavior: contain;\n  background: ",
        ";\n  z-index: 10;\n  flex-direction: column;\n"
    ]);
    sidebar_desktop_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function sidebar_desktop_styles_templateObject5() {
    var data = sidebar_desktop_styles_taggedTemplateLiteral([
        "\n  height: 100%;\n"
    ]);
    sidebar_desktop_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var styles_padding = base/* layout.measurements.spacing050 */.bK.measurements.spacing050;
var contentWidth = base/* layout.sidebarContentWidth.desktop */.bK.sidebarContentWidth.desktop;
var styles_menuWidth = base/* layout.sidebarMenuWidth.desktop */.bK.sidebarMenuWidth.desktop;
var styles_pageWithSidebarContent = base/* layout.pageContent.maxWidth.value */.bK.pageContent.maxWidth.value + base/* layout.pageContent.gutter.value */.bK.pageContent.gutter.value + (contentWidth.value + styles_menuWidth.value) * 2;
var Sidebar = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Sidebar",
    componentId: "sc-0-0"
})(sidebar_desktop_styles_templateObject1(), zindex/* zindex.menu.left */.Y.menu.left, function(props) {
    return props.tab === "none" ? styles_menuWidth.rem : "calc(".concat(contentWidth.rem, " + ").concat(styles_menuWidth.rem, ")");
}, ui/* speedToDurationMs */.k0[ui/* Speed.Slow */.fD.Slow], function(props) {
    return !props.isWide && "\n      /* Reserve space between page content and sidebar menu to properly align page content */\n      /* Debug or see how it works by setting a background color to this component */\n      @media (min-width: ".concat(styles_pageWithSidebarContent, "px) {\n        width: calc(").concat(contentWidth.rem, " + ").concat(styles_menuWidth.rem, ");\n      }\n\n      @media (max-width: ").concat(styles_pageWithSidebarContent, "px) {\n        min-width: calc((100vw - ").concat(base/* layout.pageContent.maxWidth.rem */.bK.pageContent.maxWidth.rem, ") / 2);\n      }\n    ");
}, base/* media.mediumDown */.BC.mediumDown(sidebar_desktop_styles_templateObject()));
var Sticky = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Sticky",
    componentId: "sc-0-1"
})(sidebar_desktop_styles_templateObject2(), base/* layout.headerHeight.desktop.rem */.bK.headerHeight.desktop.rem, zindex/* zindex.menu.left */.Y.menu.left);
var styles_SidebarMenu = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SidebarMenu",
    componentId: "sc-0-2"
})(sidebar_desktop_styles_templateObject3(), styles_menuWidth.rem, function(p) {
    return p.theme.colors.base100;
}, styles_padding);
var SidebarContent = styled_components_browser_esm["default"].div.attrs({
    role: "dialog"
}).withConfig({
    displayName: "SidebarContent",
    componentId: "sc-0-3"
})(sidebar_desktop_styles_templateObject4(), contentWidth.rem, function(p) {
    return p.theme.lines.primary;
}, function(p) {
    return p.theme.bg.primary;
});
var SidebarFilter = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SidebarFilter",
    componentId: "sc-0-4"
})(sidebar_desktop_styles_templateObject5());

;// CONCATENATED MODULE: ./src/areas/sidebar/components/sidebar-desktop/index.tsx
function sidebar_desktop_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}













var sidebar_desktop_Sidebar = function(param) {
    var className = param.className, _tab = param.tab, tab = _tab === void 0 ? constants/* SIDEBAR_STATE.NONE */.$J.NONE : _tab, selectedList = param.selectedList, showFilter = param.showFilter, filterType = param.filterType;
    var isWide = (0,react.useContext)(wide_context/* WideContext */.Y).isWide;
    var isSidebarOpen = tab !== constants/* SIDEBAR_STATE.NONE */.$J.NONE;
    // Generate unique UIDs to use as HTML ids
    var getId = (0,react.useId)();
    var listsTabId = "".concat(getId, "-sidebar-desktop-lists");
    var alertsTabId = "".concat(getId, "-sidebar-desktop-alerts");
    var filterTabId = "".concat(getId, "-sidebar-desktop-filter");
    var renderSidebarContent = function() {
        var content = function() {
            switch(tab){
                case constants/* SIDEBAR_STATE.LISTS */.$J.LISTS:
                    return selectedList ? /*#__PURE__*/ react.createElement(views_list/* default */.Z, {
                        id: selectedList
                    }) : /*#__PURE__*/ react.createElement(views_lists/* default */.Z, null);
                case constants/* SIDEBAR_STATE.ALERTS */.$J.ALERTS:
                    return /*#__PURE__*/ react.createElement(alerts/* default */.Z, null);
                case constants/* SIDEBAR_STATE.FILTER */.$J.FILTER:
                    if (!showFilter) {
                        return null;
                    }
                    return filterType === "category" ? /*#__PURE__*/ react.createElement(filter/* default */.Z, null) : /*#__PURE__*/ react.createElement(SidebarFilter, {
                        id: product_collection_constants/* FILTER_PORTAL_ID */._
                    });
                default:
                    return null;
            }
        }();
        var _obj;
        var id = (_obj = {}, sidebar_desktop_defineProperty(_obj, constants/* SIDEBAR_STATE.LISTS */.$J.LISTS, listsTabId), sidebar_desktop_defineProperty(_obj, constants/* SIDEBAR_STATE.ALERTS */.$J.ALERTS, alertsTabId), sidebar_desktop_defineProperty(_obj, constants/* SIDEBAR_STATE.FILTER */.$J.FILTER, filterTabId), sidebar_desktop_defineProperty(_obj, constants/* SIDEBAR_STATE.NONE */.$J.NONE, "none"), _obj)[tab];
        return /*#__PURE__*/ react.createElement(SidebarContent, {
            id: id
        }, content);
    };
    return /*#__PURE__*/ react.createElement(Sidebar, {
        tab: tab,
        className: className,
        "data-test": "SidebarDesktop",
        isWide: isWide
    }, /*#__PURE__*/ react.createElement(Sticky, null, /*#__PURE__*/ react.createElement(menu_bar, null), /*#__PURE__*/ react.createElement(block/* DesktopOnly */.NZ, null, /*#__PURE__*/ react.createElement(hideable_variants.SlideLeft, {
        visible: isSidebarOpen
    }, renderSidebarContent()))));
};
sidebar_desktop_Sidebar.displayName = "Sidebar";
var sidebar_desktop_mapStateToProps = function(state) {
    return {
        tab: state.areas.sidebar.tab,
        selectedList: state.areas.sidebar.selectedList,
        filterType: state.areas.sidebar.filterType,
        showFilter: state.areas.category.filter.showFilter || state.areas.sidebar.hasFilter
    };
};
/* harmony default export */ const sidebar_desktop = ((0,es/* connect */.$j)(sidebar_desktop_mapStateToProps, {})(sidebar_desktop_Sidebar));

;// CONCATENATED MODULE: ./src/components/co-branding-banner/actions.ts
var acknowledgeCoBrandingBanner = function() {
    return {
        type: "ACKNOWLEDGE_CO_BRANDING_BANNER"
    };
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/light-theme-colors-raw.js
var light_theme_colors_raw = __webpack_require__(90472);
// EXTERNAL MODULE: ./src/components/button/index.tsx + 1 modules
var components_button = __webpack_require__(38828);
;// CONCATENATED MODULE: ./src/components/co-branding-banner/styles.ts
function co_branding_banner_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function co_branding_banner_styles_templateObject() {
    var data = co_branding_banner_styles_taggedTemplateLiteral([
        "\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 45px;\n  background: ",
        ";\n  z-index: 999;\n"
    ]);
    co_branding_banner_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function co_branding_banner_styles_templateObject1() {
    var data = co_branding_banner_styles_taggedTemplateLiteral([
        "\n  align-items: center;\n"
    ]);
    co_branding_banner_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function co_branding_banner_styles_templateObject2() {
    var data = co_branding_banner_styles_taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    co_branding_banner_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function co_branding_banner_styles_templateObject3() {
    var data = co_branding_banner_styles_taggedTemplateLiteral([
        "\n  flex: 0 0 auto;\n  margin-left: ",
        ";\n  ",
        "\n"
    ]);
    co_branding_banner_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function co_branding_banner_styles_templateObject4() {
    var data = co_branding_banner_styles_taggedTemplateLiteral([
        "\n    font-size: ",
        ";\n  "
    ]);
    co_branding_banner_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function co_branding_banner_styles_templateObject5() {
    var data = co_branding_banner_styles_taggedTemplateLiteral([
        "\n    font-size: ",
        ";\n  "
    ]);
    co_branding_banner_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function co_branding_banner_styles_templateObject6() {
    var data = co_branding_banner_styles_taggedTemplateLiteral([
        "\n  flex: 1 1 auto;\n  text-align: center;\n  color: ",
        ";\n  ",
        "\n  ",
        "\n"
    ]);
    co_branding_banner_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function co_branding_banner_styles_templateObject7() {
    var data = co_branding_banner_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  text-decoration: underline;\n"
    ]);
    co_branding_banner_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = co_branding_banner_styles_taggedTemplateLiteral([
        "\n  width: 2.5rem;\n  height: 2.5rem;\n  border: none;\n"
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}





var bannerBg = base/* colorUtils.rgbaFromRaw */.$n.rgbaFromRaw(light_theme_colors_raw.base100, {
    a: 0.95
});
var Banner = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Banner",
    componentId: "sc-0-0"
})(co_branding_banner_styles_templateObject(), bannerBg);
var ContentsRow = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ContentsRow",
    componentId: "sc-0-1"
})(co_branding_banner_styles_templateObject1());
var styles_Logo = styled_components_browser_esm["default"].img.withConfig({
    displayName: "Logo",
    componentId: "sc-0-2"
})(co_branding_banner_styles_templateObject3(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.smallOnly */.BC.smallOnly(co_branding_banner_styles_templateObject2()));
var Text = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Text",
    componentId: "sc-0-3"
})(co_branding_banner_styles_templateObject6(), function(p) {
    return p.theme.colors.base500;
}, base/* media.smallOnly */.BC.smallOnly(co_branding_banner_styles_templateObject4(), base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall), base/* media.mediumUp */.BC.mediumUp(co_branding_banner_styles_templateObject5(), base/* layout.measurements.fontSizeNormal */.bK.measurements.fontSizeNormal));
var co_branding_banner_styles_Link = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "Link",
    componentId: "sc-0-4"
})(co_branding_banner_styles_templateObject7(), function(p) {
    return p.theme.colors.base500;
});
var CloseButton = (0,styled_components_browser_esm["default"])(components_button/* Button */.z).withConfig({
    displayName: "CloseButton",
    componentId: "sc-0-5"
})(styles_templateObject8());

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/close/index.js
var icon_close = __webpack_require__(15309);
;// CONCATENATED MODULE: ./src/components/co-branding-banner/index.tsx
function co_branding_banner_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function co_branding_banner_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            co_branding_banner_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function co_branding_banner_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function co_branding_banner_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        co_branding_banner_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}










var DISPLAY_THROTTLING_PERIOD = 24 * 60 * 60 * 1000;
var AUTO_ACKNOWLEDGE_DELAY = 6 * 1000;
var co_branding_banner_mapStateToProps = function(state) {
    return co_branding_banner_objectSpreadProps(co_branding_banner_objectSpread({}, state.coBrandingBanner), {
        acceptedCookieBannerVersion: state.globals.cookieBanner.version
    });
};
var CoBrandingBannerImpl = function(param) {
    var isActive = param.isActive, lastAcknowledged = param.lastAcknowledged, acceptedCookieBannerVersion = param.acceptedCookieBannerVersion, acknowledgeCoBrandingBanner = param.acknowledgeCoBrandingBanner;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), market = ref.market, renderMode = ref.renderMode, t = ref.t;
    var isMobile = (0,react.useContext)(viewport/* ViewportContext */.R).isMobile;
    var cookieVersion = (market.privacySettings && market.privacySettings[renderMode]).cookieVersion;
    var isCookieBannerVisible = acceptedCookieBannerVersion !== cookieVersion;
    var shouldBeVisible = lastAcknowledged === undefined || lastAcknowledged < Date.now() - DISPLAY_THROTTLING_PERIOD;
    var isVisible = market.showSchibstedCoBranding && shouldBeVisible && isActive && !isCookieBannerVisible;
    (0,react.useEffect)(function() {
        var timeoutId = isVisible ? window === null || window === void 0 ? void 0 : window.setTimeout(acknowledgeCoBrandingBanner, AUTO_ACKNOWLEDGE_DELAY) : undefined;
        return function() {
            return window === null || window === void 0 ? void 0 : window.clearTimeout(timeoutId);
        };
    }, [
        isVisible,
        acknowledgeCoBrandingBanner
    ]);
    if (!isActive) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(hideable_variants.NudgeDown, {
        visible: isVisible,
        container: Banner,
        speed: ui/* Speed.Slow */.fD.Slow
    }, /*#__PURE__*/ react.createElement(list_variants.Row, {
        gap: 1,
        container: ContentsRow
    }, /*#__PURE__*/ react.createElement(styles_Logo, {
        alt: "Schibsted",
        width: "128",
        src: "".concat(market.cdn, "/g/rfe/logos/schibsted/schibsted_dust_black.png")
    }), /*#__PURE__*/ react.createElement(Text, null, /*#__PURE__*/ react.createElement("span", null, "".concat(isMobile ? "" : t("tracking-settings", "co-branding.part-of", {
        companyName: t("meta", "company.name")
    }), " ").concat(t("tracking-settings", "co-branding.data-controller"), " "), /*#__PURE__*/ react.createElement(co_branding_banner_styles_Link, {
        to: "/privacy-settings"
    }, t("tracking-settings", "co-branding.read-more")))), /*#__PURE__*/ react.createElement(CloseButton, {
        variant: "icon",
        tabIndex: 0,
        icon: /*#__PURE__*/ react.createElement(icon_close.IconClose, null),
        onClick: acknowledgeCoBrandingBanner
    })));
};
var CoBrandingBanner = (0,es/* connect */.$j)(co_branding_banner_mapStateToProps, actions_namespaceObject)(CoBrandingBannerImpl);

// EXTERNAL MODULE: ./src/components/cookie-banner/index.tsx + 13 modules
var cookie_banner = __webpack_require__(63198);
// EXTERNAL MODULE: ./src/components/error-boundary/index.tsx + 1 modules
var error_boundary = __webpack_require__(77078);
// EXTERNAL MODULE: ./src/components/error-message/index.tsx + 1 modules
var error_message = __webpack_require__(40314);
// EXTERNAL MODULE: ./src/components/modal/index.tsx
var modal = __webpack_require__(58203);
;// CONCATENATED MODULE: ./src/components/newsletter-signup-modal/index.tsx
function newsletter_signup_modal_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function newsletter_signup_modal_templateObject() {
    var data = newsletter_signup_modal_taggedTemplateLiteral([
        "\n    width: 100%;\n"
    ]);
    newsletter_signup_modal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function newsletter_signup_modal_templateObject1() {
    var data = newsletter_signup_modal_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    newsletter_signup_modal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








var NEWSLETTER_PARAM = "signup-for-our-newsletter";
var StyledNewsletterSignup = (0,styled_components_browser_esm["default"])(newsletter_signup/* NewsletterSignup */.o).withConfig({
    displayName: "StyledNewsletterSignup",
    componentId: "sc-0-0"
})(newsletter_signup_modal_templateObject1(), base/* media.mediumUp */.BC.mediumUp(newsletter_signup_modal_templateObject()));
var NewsLetterSignupModal = function() {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var history = (0,react_router_dom/* useHistory */.k6)();
    var location = (0,react_router_dom/* useLocation */.TH)();
    var close = (0,react.useCallback)(function() {
        // Remove the `NEWSLETTER_PARAM` from the URL which closes the modal
        var params = querystring.parse(location.search.substr(1));
        delete params[NEWSLETTER_PARAM];
        location.search = querystring.stringify(params);
        history.push(location);
    }, [
        history,
        location
    ]);
    return /*#__PURE__*/ react.createElement(modal/* default */.Z, {
        isOpen: true,
        width: 500,
        onRequestClose: close
    }, /*#__PURE__*/ react.createElement(StyledNewsletterSignup, {
        stacked: true,
        title: t("footer", "newsletter.title"),
        description: t("footer", "newsletter.sub-title"),
        buttonText: t("campaigns", "newsletter.sign-up-button-long")
    }));
};
/* harmony default export */ const newsletter_signup_modal = (NewsLetterSignupModal);

// EXTERNAL MODULE: ./src/components/shutdown-message/index.js
var shutdown_message = __webpack_require__(63014);
// EXTERNAL MODULE: ./src/components/toast-container/index.ts
var toast_container = __webpack_require__(85048);
// EXTERNAL MODULE: ./node_modules/.pnpm/redux-saga@1.0.3/node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js + 1 modules
var redux_saga_effects_npm_proxy_esm = __webpack_require__(38247);
// EXTERNAL MODULE: ./src/components/toast-container/actions/index.ts
var toast_container_actions = __webpack_require__(88278);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/check-filled/index.js
var check_filled = __webpack_require__(89639);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/info-filled/index.js
var info_filled = __webpack_require__(43880);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/close-filled/index.js
var close_filled = __webpack_require__(93347);
;// CONCATENATED MODULE: ./src/components/toast-container/components/message/styles.ts
function message_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function message_styles_templateObject() {
    var data = message_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  line-height: 1;\n"
    ]);
    message_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function message_styles_templateObject1() {
    var data = message_styles_taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n"
    ]);
    message_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function message_styles_templateObject2() {
    var data = message_styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    message_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function message_styles_templateObject3() {
    var data = message_styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    message_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function message_styles_templateObject4() {
    var data = message_styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    message_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}





var Message = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Message",
    componentId: "sc-0-0"
})(message_styles_templateObject());
var iconStyles = (0,styled_components_browser_esm.css)(message_styles_templateObject1(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var Check = (0,styled_components_browser_esm["default"])(check_filled.IconCheckFilled).withConfig({
    displayName: "Check",
    componentId: "sc-0-1"
})(message_styles_templateObject2(), iconStyles);
var Info = (0,styled_components_browser_esm["default"])(info_filled/* IconInfoFilled */.h).withConfig({
    displayName: "Info",
    componentId: "sc-0-2"
})(message_styles_templateObject3(), iconStyles);
var Warning = (0,styled_components_browser_esm["default"])(close_filled.IconCloseFilled).withConfig({
    displayName: "Warning",
    componentId: "sc-0-3"
})(message_styles_templateObject4(), iconStyles);

;// CONCATENATED MODULE: ./src/components/toast-container/components/message/index.tsx


var ToastMessage = function(param) {
    var children = param.children, type = param.type;
    var icon = null;
    var iconSize = 24;
    switch(type){
        case "info":
            icon = /*#__PURE__*/ react.createElement(Info, {
                size: iconSize,
                color: "maybeBlue700"
            });
            break;
        case "success":
            icon = /*#__PURE__*/ react.createElement(Check, {
                size: iconSize,
                color: "positive700"
            });
            break;
        case "warning":
        case "error":
            icon = /*#__PURE__*/ react.createElement(Warning, {
                size: iconSize,
                color: "redio700"
            });
            break;
        default:
    }
    return /*#__PURE__*/ react.createElement(Message, null, icon, children);
};
/* harmony default export */ const message = (ToastMessage);

;// CONCATENATED MODULE: ./src/components/toast-container/sagas/toast.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};




var loadAndDisplayToast = function() {
    var _ref = _asyncToGenerator(function(action) {
        var toast;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        __webpack_require__.e(/* import() | toast */ 578).then(__webpack_require__.bind(__webpack_require__, 18660))
                    ];
                case 1:
                    toast = _state.sent().toast;
                    return [
                        2,
                        toast[action.promptType](/*#__PURE__*/ react.createElement(message, {
                            type: action.promptType
                        }, action.content), action.options)
                    ];
            }
        });
    });
    return function loadAndDisplayToast(action) {
        return _ref.apply(this, arguments);
    };
}();
function handleToastAction(action) {
    var toastContainerLoaded;
    return __generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(function(state) {
                        return state.toast.required;
                    })
                ];
            case 1:
                toastContainerLoaded = _state.sent();
                if (!!toastContainerLoaded) return [
                    3,
                    3
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,toast_container_actions/* requireToastContainer */.i6)())
                ];
            case 2:
                _state.sent();
                _state.label = 3;
            case 3:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(loadAndDisplayToast, action)
                ];
            case 4:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
function toastSaga() {
    return __generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeEvery */.ib)(toast_container_actions/* TOAST_PROMPT */.c7, handleToastAction)
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
if ( true && window && window.registerSaga) {
    window.registerSaga(toastSaga);
}
/* harmony default export */ const toast = ((/* unused pure expression or super */ null && (toastSaga)));

// EXTERNAL MODULE: ./src/routes/config.ts + 58 modules
var config = __webpack_require__(729);
// EXTERNAL MODULE: ./src/components/location-context/index.tsx
var location_context = __webpack_require__(68410);
// EXTERNAL MODULE: ./src/hooks/use-meta-tags.js
var use_meta_tags = __webpack_require__(79965);
;// CONCATENATED MODULE: ./src/components/meta-tags/index.tsx

var MetaTags = function(props) {
    var routeId = props.routeId, locationKey = props.locationKey, metaTags = props.metaTags;
    (0,use_meta_tags/* useMetaTags */.k)({
        routeId: routeId,
        locationKey: locationKey,
        metaTags: metaTags
    });
    return null;
};
/* harmony default export */ const meta_tags = (MetaTags);

;// CONCATENATED MODULE: ./src/components/error-page/index.tsx




var ErrorPage = function(param) {
    var error = param.error;
    var ref, ref1;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var firstError = (ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.errors) === null || ref1 === void 0 ? void 0 : ref1[0];
    var _status;
    var status = (_status = error.status) !== null && _status !== void 0 ? _status : 500;
    if (firstError) {
        var _status1;
        status = (_status1 = firstError.status) !== null && _status1 !== void 0 ? _status1 : 500;
    }
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(error_message/* default */.Z, {
        status: status
    }), /*#__PURE__*/ react.createElement(meta_tags, {
        metaTags: {
            title: "".concat(t("errors", "internal.unknown"), " (").concat(status, ")")
        }
    }));
};

// EXTERNAL MODULE: ./src/components/loader/index.tsx + 1 modules
var loader = __webpack_require__(30082);
;// CONCATENATED MODULE: ./src/components/scroll-to-top/index.tsx


var isScrollToTopAction = function(action) {
    return ![
        "POP",
        "REPLACE"
    ].includes(action);
};
var ScrollToTop = function(param) {
    var disableScrollOnQueryUpdate = param.disableScrollOnQueryUpdate;
    var ref = (0,react_router/* useLocation */.TH)(), pathname = ref.pathname, search = ref.search;
    var action = (0,react_router/* useHistory */.k6)().action;
    var path = (0,react.useMemo)(function() {
        return pathname + (disableScrollOnQueryUpdate ? "" : search);
    }, [
        pathname,
        search,
        disableScrollOnQueryUpdate
    ]);
    (0,react.useEffect)(function() {
        if (isScrollToTopAction(action)) {
            window.scroll(0, 0);
        }
    }, [
        action,
        path
    ]);
    return null;
};

;// CONCATENATED MODULE: ./src/PageNotFound.tsx




var PageNotFound = function() {
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(error_message/* default */.Z, {
        status: 404
    }), /*#__PURE__*/ react.createElement(meta_tags, {
        metaTags: {
            title: "".concat(t("errors", "internal.unknown"), " (", 404, ")")
        }
    }));
};

;// CONCATENATED MODULE: ./src/routes/nextjs.ts
function nextjs_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function nextjs_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return nextjs_arrayLikeToArray(arr);
}
function nextjs_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function nextjs_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function nextjs_toConsumableArray(arr) {
    return nextjs_arrayWithoutHoles(arr) || nextjs_iterableToArray(arr) || nextjs_unsupportedIterableToArray(arr) || nextjs_nonIterableSpread();
}
function nextjs_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return nextjs_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return nextjs_arrayLikeToArray(o, minLen);
}
/**
 * These routes are proxied for all users on all markets.
 */ var PROXY_PATHS_COMMON = [
    "/_next",
    "/api"
];
/**
 * Market specific routes that are proxied for all users.
 */ var PROXY_PATHS_PUBLIC = {
    se: [
        "/guider",
        "/tester"
    ]
};
/**
 * These routes can be opted-in to by enabling the nextjs cookie at /_internal/nextjs
 */ var PROXY_PATHS_EXPERIMENTAL = {
    se: [
        "/topplistor"
    ],
    no: [
        "/topplister",
        "/tester",
        "/guider"
    ]
};
var NEXTJS_EXPERIMENT_SLUG = "use-nextjs-proxy";
var NEXTJS_COOKIE_VERSION = "1";
var NEXTJS_COOKIE = "pj:nextjsproxy";
var NEXTJS_HEADER = "x-nextjs-proxy";
var NEXTJS_USERAGENT = "prisjakt/nextjs-proxy";
var getNextJsProxyRoutes = function(market, useExperimentalRoutes) {
    var experimentalRoutes = useExperimentalRoutes ? PROXY_PATHS_EXPERIMENTAL[market] : [];
    var _market;
    return nextjs_toConsumableArray(PROXY_PATHS_COMMON).concat(nextjs_toConsumableArray((_market = PROXY_PATHS_PUBLIC[market]) !== null && _market !== void 0 ? _market : []), nextjs_toConsumableArray(experimentalRoutes !== null && experimentalRoutes !== void 0 ? experimentalRoutes : []));
};
var isNextJsProxyEnabledClient = function() {
    return  true && Boolean(window.NEXTJS_ENABLE_PROXY);
};
var isNextJsExperimentEnabled = function(ctx, config) {
    var ref;
    return config.experiments.env === "dev" || ((ref = ctx.experiments[NEXTJS_EXPERIMENT_SLUG]) === null || ref === void 0 ? void 0 : ref.selectedVariant) === "enabled";
};
var isNextJsProxyEnabled = function(ctx, config) {
    var _nextjs = config.nextjs, enableProxy = _nextjs.enableProxy, nextJsHost = _nextjs.nextJsHost;
    return isNextJsExperimentEnabled(ctx, config) && enableProxy && typeof nextJsHost === "string" && nextJsHost.length > 0;
};
var isNextJsProxyRequestedByUser = function(ctx) {
    var ref;
    return ctx.cookies.get(NEXTJS_COOKIE) === NEXTJS_COOKIE_VERSION || ctx.get(NEXTJS_HEADER) === "1" || ((ref = ctx.header["user-agent"]) === null || ref === void 0 ? void 0 : ref.indexOf(NEXTJS_USERAGENT)) !== -1;
};
var isNextJsPath = function(path, market) {
    var useExperimentalRoutes = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return getNextJsProxyRoutes(market, useExperimentalRoutes).some(function(proxyPath) {
        return typeof proxyPath === "string" ? path.startsWith(proxyPath) : proxyPath.test(path);
    }) === true;
};

// EXTERNAL MODULE: ./src/hooks/use-is-authenticated.ts
var use_is_authenticated = __webpack_require__(32990);
;// CONCATENATED MODULE: ./src/hooks/use-should-show-login-widget.ts
function use_should_show_login_widget_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function use_should_show_login_widget_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function use_should_show_login_widget_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function use_should_show_login_widget_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function use_should_show_login_widget_slicedToArray(arr, i) {
    return use_should_show_login_widget_arrayWithHoles(arr) || use_should_show_login_widget_iterableToArrayLimit(arr, i) || use_should_show_login_widget_unsupportedIterableToArray(arr, i) || use_should_show_login_widget_nonIterableRest();
}
function use_should_show_login_widget_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return use_should_show_login_widget_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return use_should_show_login_widget_arrayLikeToArray(o, minLen);
}




var useShouldShowLoginWidget = function() {
    var ref = use_should_show_login_widget_slicedToArray((0,react.useState)(false), 2), shouldShowLoginWidget = ref[0], setShouldShowLoginWidget = ref[1];
    var isLoading = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.account.loading;
    });
    var isAuthenticated = (0,use_is_authenticated/* useIsAuthenticated */.k)();
    var market = (0,react.useContext)(app_context/* AppContext */.Il).market;
    (0,react.useEffect)(function() {
        var hasShownSimplifiedLoginWidget = localStorage.getItem("pj:hasShownShowSimplifiedLoginWidget");
        if (!isAuthenticated && !isLoading && market.login.enabled && !hasShownSimplifiedLoginWidget) {
            setShouldShowLoginWidget(true);
        }
    }, [
        isAuthenticated,
        isLoading,
        market.login.enabled
    ]);
    return shouldShowLoginWidget;
};

// EXTERNAL MODULE: ./src/components/login-info-banner/index.tsx
var login_info_banner = __webpack_require__(93910);
// EXTERNAL MODULE: ./src/components/lazy/index.tsx
var lazy = __webpack_require__(67506);
;// CONCATENATED MODULE: ./src/app.tsx
function app_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function app_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function app_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function app_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                app_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                app_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function app_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function app_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function app_slicedToArray(arr, i) {
    return app_arrayWithHoles(arr) || app_iterableToArrayLimit(arr, i) || app_unsupportedIterableToArray(arr, i) || app_nonIterableRest();
}
function app_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return app_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return app_arrayLikeToArray(o, minLen);
}
var app_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};



































var Error500 = function() {
    return /*#__PURE__*/ react.createElement(error_message/* default */.Z, {
        status: 500
    });
};
var handleGraphqlRequestError = function(error) {
    return /*#__PURE__*/ react.createElement(ErrorPage, {
        error: error
    });
};
var isRedirectedFromMarketRegex = /(&|^\?)redirect=(ie|it|pl)(&|$)/;
/**
 * A number so that we can track the render after the
 * initial mounting. This is when experiments are loaded and viewportcontext is updated.
 * This is used to add user performance timings.
 */ var renders = 0;
var app_App = function(param) {
    var callback = param.callback;
    var location = (0,react_router_dom/* useLocation */.TH)();
    var renderToastContainer = (0,es/* useSelector */.v9)(function(state) {
        return state.toast.required;
    });
    var ref = (0,es/* useSelector */.v9)(function(state) {
        return state.globals;
    }), _layout = ref.layout, layout = _layout === void 0 ? "default" : _layout;
    var ref1 = (0,react.useContext)(app_context/* AppContext */.Il), _market = ref1.market, code = _market.code, routes = _market.routes, sourcepointCmp = _market.sourcepointCmp, renderMode = ref1.renderMode;
    var previousLocation = (0,location_context/* useLocationContext */.F)().previousLocation;
    var ref2 = useFetchQueryError(), fetchQueryError = ref2.error;
    var ref3 = app_slicedToArray((0,react.useState)(false), 2), isNextJsLoaderActive = ref3[0], setNextJsLoaderActive = ref3[1];
    renders += 1;
    if (renders === 2) {
        performance_reporter("firstRerender");
    }
    var openNewsletterSignup = Object.keys(querystring.parse(location.search.substr(1))).includes(NEWSLETTER_PARAM);
    var isRedirectedFromMarket = isRedirectedFromMarketRegex.test(location.search);
    var redirectedFromMarket = isRedirectedFromMarket && (isRedirectedFromMarketRegex.exec(location.search) || []).filter(function(match) {
        return /^(ie|it|pl)$/.test(match);
    }).pop();
    var isWebViewLayout = renderMode === "native";
    var routesWithPaths = (0,react.useMemo)(function() {
        return Object.values((0,config/* buildRouteConfig */.v)(code, routes));
    }, [
        code,
        routes
    ]);
    (0,react.useEffect)(function() {
        if (!isNextJsProxyEnabledClient()) {
            return;
        }
        var pathname = location.pathname, search = location.search;
        if (isNextJsPath("".concat(pathname).concat(search), code, NEXTJS_EXPERIMENTAL_ROUTES)) {
            setNextJsLoaderActive(true);
            window.location.reload();
        }
    }, [
        routesWithPaths,
        location,
        code
    ]);
    var ref4 = (0,use_schibsted_account/* useSchibstedAccount */.F)(), showSimplifiedLoginWidget = ref4.showSimplifiedLoginWidget, refreshSession = ref4.refreshSession;
    var shouldShowSimplifiedLoginWidget = useShouldShowLoginWidget();
    (0,react.useEffect)(function() {
        var getWidget = function() {
            var _ref = app_asyncToGenerator(function() {
                var widgetShown;
                return app_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                showSimplifiedLoginWidget()
                            ];
                        case 1:
                            widgetShown = _state.sent();
                            if (widgetShown) {
                                localStorage.setItem("pj:hasShownShowSimplifiedLoginWidget", Math.random().toString(36).slice(2));
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function getWidget() {
                return _ref.apply(this, arguments);
            };
        }();
        if (shouldShowSimplifiedLoginWidget) {
            getWidget();
        }
    }, [
        shouldShowSimplifiedLoginWidget,
        showSimplifiedLoginWidget
    ]);
    (0,react.useEffect)(function() {
        window.addEventListener("focus", refreshSession);
        return function() {
            window.removeEventListener("focus", refreshSession);
        };
    }, [
        refreshSession
    ]);
    return /*#__PURE__*/ react.createElement(error_boundary/* default */.Z, {
        onError: Error500
    }, /*#__PURE__*/ react.createElement(App, {
        layout: layout,
        ref: callback
    }, openNewsletterSignup && /*#__PURE__*/ react.createElement(newsletter_signup_modal, null), /*#__PURE__*/ react.createElement(viewport_tracker/* ViewportTracker */.t, null, !isWebViewLayout && /*#__PURE__*/ react.createElement(header, null), renderToastContainer && /*#__PURE__*/ react.createElement(toast_container/* default */.Z, null), /*#__PURE__*/ react.createElement(feedback/* default */.Z, null), /*#__PURE__*/ react.createElement(error_boundary/* default */.Z, {
        onError: base/* noop */.ZT
    }, /*#__PURE__*/ react.createElement(CoBrandingBanner, null), !sourcepointCmp && /*#__PURE__*/ react.createElement(cookie_banner/* default */.ZP, null)), /*#__PURE__*/ react.createElement(error_boundary/* default */.Z, {
        onError: base/* noop */.ZT
    }, /*#__PURE__*/ react.createElement(static_intercom/* default */.Z, null)), /*#__PURE__*/ react.createElement(error_boundary/* default */.Z, {
        onError: Error500
    }, /*#__PURE__*/ react.createElement(wide_context/* WideContextProvider */.B, null, /*#__PURE__*/ react.createElement(Main, {
        "data-test": "AppMain",
        "data-test-market-id": code
    }, /*#__PURE__*/ react.createElement(lazy/* Lazy */.o, {
        offset: 0
    }, /*#__PURE__*/ react.createElement(login_info_banner/* LoginInfoBanner */.n, null)), !isWebViewLayout && /*#__PURE__*/ react.createElement(sidebar_desktop, null), /*#__PURE__*/ react.createElement(Content, null, /*#__PURE__*/ react.createElement(error_boundary/* default */.Z, {
        onError: handleGraphqlRequestError
    }, /*#__PURE__*/ react.createElement(react_router_dom/* Switch */.rs, null, routesWithPaths.map(function(param) {
        var path = param.path, component = param.component, _exact = param.exact, exact = _exact === void 0 ? true : _exact, disableScrollOnQueryUpdate = param.disableScrollOnQueryUpdate;
        var RouteComponent = component;
        var renderRouteComponent = function() {
            if (isNextJsLoaderActive) {
                return /*#__PURE__*/ react.createElement(loader/* default */.Z, null);
            }
            if (fetchQueryError && !previousLocation) {
                return /*#__PURE__*/ react.createElement(ErrorPage, {
                    error: fetchQueryError
                });
            }
            return /*#__PURE__*/ react.createElement(RouteComponent, null);
        };
        return /*#__PURE__*/ react.createElement(react_router_dom/* Route */.AW, {
            path: path,
            exact: exact,
            key: path.toString()
        }, /*#__PURE__*/ react.createElement(ScrollToTop, {
            disableScrollOnQueryUpdate: disableScrollOnQueryUpdate
        }), renderRouteComponent());
    }), /*#__PURE__*/ react.createElement(react_router_dom/* Route */.AW, {
        path: "*"
    }, /*#__PURE__*/ react.createElement(PageNotFound, null)))), !isWebViewLayout && /*#__PURE__*/ react.createElement(footer, null))))), isRedirectedFromMarket && /*#__PURE__*/ react.createElement(shutdown_message/* default */.Z, {
        redirectedFromMarket: redirectedFromMarket
    }))));
};
/* harmony default export */ const app = (/*#__PURE__*/(0,react.memo)(app_App));

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/debounce.js
var debounce = __webpack_require__(66292);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./src/globals/api/requests.js
var requests = __webpack_require__(11124);
;// CONCATENATED MODULE: ./src/client/experiments.tsx
function experiments_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function experiments_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function experiments_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return experiments_arrayLikeToArray(arr);
}
function experiments_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function experiments_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                experiments_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                experiments_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function experiments_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function experiments_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function experiments_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function experiments_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function experiments_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function experiments_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            experiments_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function experiments_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function experiments_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        experiments_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function experiments_slicedToArray(arr, i) {
    return experiments_arrayWithHoles(arr) || experiments_iterableToArrayLimit(arr, i) || experiments_unsupportedIterableToArray(arr, i) || experiments_nonIterableRest();
}
function experiments_toConsumableArray(arr) {
    return experiments_arrayWithoutHoles(arr) || experiments_iterableToArray(arr) || experiments_unsupportedIterableToArray(arr) || experiments_nonIterableSpread();
}
function experiments_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return experiments_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return experiments_arrayLikeToArray(o, minLen);
}
var experiments_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};





var updateViewedExperiments = function() {
    var _ref = experiments_asyncToGenerator(function(viewedExperiments) {
        var sessionData;
        return experiments_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,requests/* putSession */.hO)("viewedExperiments", viewedExperiments)
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        (0,requests/* getSession */.Gg)()
                    ];
                case 2:
                    sessionData = _state.sent();
                    window.SESSION_DATA = sessionData;
                    (0,data_layer/* pushEvent */.A)("updateViewedExperiments", {
                        experiments: sessionData.experiments.optimize,
                        exp_variant_string: sessionData.experiments.experimentsGA4
                    }, {
                        eventNameAsKey: false
                    });
                    return [
                        2
                    ];
            }
        });
    });
    return function updateViewedExperiments(viewedExperiments) {
        return _ref.apply(this, arguments);
    };
}();
var ExperimentContextContainer = function(param) {
    var children = param.children;
    var _SESSION_DATA = window.SESSION_DATA, session = _SESSION_DATA.session, experiments = _SESSION_DATA.experiments;
    var ref = experiments_slicedToArray(react.useState({
        applicationExperiments: [],
        selectedVariants: {},
        viewedExperiments: session.viewedExperiments || {}
    }), 2), state = ref[0], setState = ref[1];
    var debounceUpdateViewedExperiments = react.useCallback(debounce_default()(function(viewedExperiments) {
        return updateViewedExperiments(viewedExperiments);
    }, 500), []);
    var viewedExperimentsNeedsUpdate = react.useRef(false);
    react.useEffect(function() {
        // No need to update viewed experiments when this component mounts
        // since we get the session viewed experiments from session init callback
        // in `server/react/middlewares/out.js` when page loads and use that as default state
        if (viewedExperimentsNeedsUpdate.current) {
            debounceUpdateViewedExperiments(state.viewedExperiments);
        } else {
            viewedExperimentsNeedsUpdate.current = true;
        }
    }, [
        debounceUpdateViewedExperiments,
        state.viewedExperiments
    ]);
    var methods = react.useMemo(function() {
        var devMode = experiments.env === "dev";
        return {
            registerExperiment: function(experiment) {
                if (!devMode) {
                    return;
                }
                setState(function(currState) {
                    if (currState.applicationExperiments.find(function(e) {
                        return e.id === experiment.id;
                    })) {
                        return currState;
                    }
                    return experiments_objectSpreadProps(experiments_objectSpread({}, currState), {
                        applicationExperiments: experiments_toConsumableArray(currState.applicationExperiments).concat([
                            experiment
                        ])
                    });
                });
            },
            unregisterExperiment: function(id) {
                if (!devMode) return;
                setState(function(prevState) {
                    return experiments_objectSpreadProps(experiments_objectSpread({}, prevState), {
                        applicationExperiments: prevState.applicationExperiments.filter(function(experiment) {
                            return experiment.id !== id;
                        })
                    });
                });
            },
            selectVariant: function(experiment, variant) {
                (0,requests/* putSession */.hO)("selectedVariants", experiments_defineProperty({}, experiment.id, variant));
                setState(function(currState) {
                    return experiments_objectSpreadProps(experiments_objectSpread({}, currState), {
                        selectedVariants: experiments_objectSpreadProps(experiments_objectSpread({}, currState.selectedVariants), experiments_defineProperty({}, experiment.id, experiments_objectSpreadProps(experiments_objectSpread({}, experiment), {
                            selectedVariant: variant,
                            variantIndex: -1
                        })))
                    });
                });
            },
            setViewedExperiment: function(experimentId, variant) {
                if (state.viewedExperiments[experimentId] && state.viewedExperiments[experimentId].variant === variant) {
                    return;
                }
                setState(function(currState) {
                    return experiments_objectSpreadProps(experiments_objectSpread({}, currState), {
                        viewedExperiments: experiments_objectSpreadProps(experiments_objectSpread({}, currState.viewedExperiments), experiments_defineProperty({}, experimentId, {
                            variant: variant
                        }))
                    });
                });
            }
        };
    }, [
        experiments.env,
        state.viewedExperiments
    ]);
    var value = react.useMemo(function() {
        return experiments_objectSpread({
            showEditor: experiments.env === "dev",
            sessionId: session.id,
            selectedVariants: experiments_objectSpread({}, experiments.experiments, state.selectedVariants),
            viewedExperiments: state.viewedExperiments,
            experiments: state.applicationExperiments
        }, methods);
    }, [
        experiments.experiments,
        experiments.env,
        session.id,
        state.applicationExperiments,
        state.selectedVariants,
        state.viewedExperiments,
        methods
    ]);
    return /*#__PURE__*/ react.createElement(experiment/* ExperimentContext.Provider */.T.Provider, {
        value: value
    }, children);
};
/* harmony default export */ const experiments = (ExperimentContextContainer);

// EXTERNAL MODULE: ./src/areas/category/constants.ts
var category_constants = __webpack_require__(63930);
// EXTERNAL MODULE: ./src/components/co-branding-banner/constants.ts
var co_branding_banner_constants = __webpack_require__(45766);
;// CONCATENATED MODULE: ./src/client/local-storage.tsx
function local_storage_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function local_storage_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            local_storage_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function local_storage_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function local_storage_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        local_storage_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/**
 * LocalStorage keys in this array will be checked if they have any content
 * on app instantiation, and a LOCAL_STORAGE_RECEIVE action will be triggered
 * in Redux with the content from LocalStorage. It's then up to individual
 * reducers to handle this data as they see fit.
 *
 * When the state is updated, LocalStorage will be updated at each key with
 * the data returned by the stateSelector function applied to the Redux state.
 */ var persistedStates = [
    {
        localStorageKey: category_constants/* LOCAL_STORAGE_FILTER_KEY */.vg,
        stateSelector: function(state) {
            return state.areas.category.filter.showHorizontalFilter;
        }
    },
    {
        localStorageKey: product_collection_constants/* PRODUCT_COLLECTION_LAYOUT */.x,
        stateSelector: function(state) {
            return state.areas.productCollection.userSelectedLayout;
        }
    },
    {
        localStorageKey: constants/* SIDEBAR_LOCALSTORAGE_KEY */.yT,
        stateSelector: function(state) {
            var _sidebar = state.areas.sidebar, tab = _sidebar.tab, lists = _sidebar.lists;
            return {
                tab: tab,
                listSort: lists.sort && lists.direction ? "".concat(lists.sort, ":").concat(lists.direction) : lists.sort || undefined
            };
        }
    },
    {
        localStorageKey: co_branding_banner_constants/* CO_BRANDING_BANNER_LOCALSTORAGE_STATE_KEY */.s,
        stateSelector: function(param) {
            var lastAcknowledged = param.coBrandingBanner.lastAcknowledged;
            return {
                lastAcknowledged: lastAcknowledged
            };
        }
    }
];
function getLocalStorageItem(key) {
    try {
        var serializedState = localStorage.getItem(key);
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        return undefined;
    }
}
function setLocalStorageItem(key, state) {
    try {
        var serializedState = JSON.stringify(state);
        localStorage.setItem(key, serializedState);
    } catch (e) {
    // Ignore any errors on write
    }
}
function deleteLocalStorageItem(key) {
    try {
        localStorage.removeItem(key);
    } catch (e) {
    // Ignore any errors on delete
    }
}
function getLocalStorageState() {
    return persistedStates.reduce(function(localStorageState, param) {
        var localStorageKey = param.localStorageKey;
        return local_storage_objectSpreadProps(local_storage_objectSpread({}, localStorageState), local_storage_defineProperty({}, localStorageKey, getLocalStorageItem(localStorageKey)));
    }, {});
}
function loadLocalStorageState(store) {
    var localStorageState = getLocalStorageState();
    store.dispatch({
        type: "LOCAL_STORAGE_RECEIVE",
        localStorageState: localStorageState
    });
}
function saveStateToLocalStorage(store) {
    persistedStates.forEach(function(param) {
        var localStorageKey = param.localStorageKey, stateSelector = param.stateSelector;
        var state = stateSelector(store.getState());
        if (state === undefined) {
            deleteLocalStorageItem(localStorageKey);
        } else {
            setLocalStorageItem(localStorageKey, state);
        }
    });
}

// EXTERNAL MODULE: ./src/components/search-bar/search-bar-context.tsx
var search_bar_context = __webpack_require__(31623);
// EXTERNAL MODULE: ./src/client/query.js
var query = __webpack_require__(43517);
;// CONCATENATED MODULE: ./src/client/index.js
// polyfill
function client_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function client_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function client_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                client_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                client_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function client_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function client_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function client_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) client_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) client_defineProperties(Constructor, staticProps);
    return Constructor;
}
function client_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function client_getPrototypeOf(o) {
    client_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return client_getPrototypeOf(o);
}
function client_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) client_setPrototypeOf(subClass, superClass);
}
function client_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            client_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function client_possibleConstructorReturn(self, call) {
    if (call && (client_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return client_assertThisInitialized(self);
}
function client_setPrototypeOf(o, p) {
    client_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return client_setPrototypeOf(o, p);
}
var client_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function client_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function client_createSuper(Derived) {
    var hasNativeReflectConstruct = client_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = client_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = client_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return client_possibleConstructorReturn(this, result);
    };
}
var client_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var ref, ref1;



































(0,sentry/* initSentry */.j6)();
smoothscroll_default().polyfill();
var client_history = (0,esm_history/* createBrowserHistory */.lX)();
var schibstedAccountConfig = {
    identity: (ref = window.CLIENT_MARKET.schibstedAccount) === null || ref === void 0 ? void 0 : ref.identity,
    login: (ref1 = window.CLIENT_MARKET.schibstedAccount) === null || ref1 === void 0 ? void 0 : ref1.login
};
window.__history = client_history;
window.__getState = store/* default.getState */.Z.getState;
window.APP_GLOBALS = {
    t: (0,translate/* translator */.O)(window.TRANSLATIONS, window.CLIENT_MARKET.locale)
};
window.IS_FLOOD_IO = window.navigator.userAgent.indexOf("Flood.io PJ") !== -1;
web_vitals_reporter("CLS");
web_vitals_reporter("FID");
web_vitals_reporter("LCP");
var queryClient = new lib/* QueryClient */.Su({
    defaultOptions: {
        queries: {
            keepPreviousData: true,
            retry: function(failureCount, error) {
                var ref, ref1;
                if ((ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.errors) === null || ref1 === void 0 ? void 0 : ref1.find(function(e) {
                    return e.status === 404;
                })) {
                    return false;
                }
                return failureCount < 2;
            },
            refetchOnWindowFocus: false
        }
    }
});
var dehydratedState = window.__REACT_QUERY_STATE__;
var dispatchSession = function(sessionData) {
    var me = sessionData.me, session = sessionData.session, trackingSettings = sessionData.trackingSettings, gaClientId = sessionData.gaClientId, pulseEnvironmentId = sessionData.pulseEnvironmentId;
    store/* default.dispatch */.Z.dispatch({
        type: "SESSION_RECEIVE",
        session: session,
        privacyCookie: trackingSettings,
        clientId: gaClientId,
        pulseEnvironmentId: pulseEnvironmentId
    });
    if (me) {
        store/* default.dispatch */.Z.dispatch({
            type: "USER_RECEIVE",
            me: me || undefined
        });
    }
};
var refreshReduxSessionState = function() {
    var _ref = client_asyncToGenerator(function() {
        var sessionData;
        return client_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,requests/* getSession */.Gg)()
                    ];
                case 1:
                    sessionData = _state.sent();
                    dispatchSession(sessionData);
                    return [
                        2
                    ];
            }
        });
    });
    return function refreshReduxSessionState() {
        return _ref.apply(this, arguments);
    };
}();
// Handles Schibsted Account session changes
var onSessionChange = function() {
    var _ref = client_asyncToGenerator(function(prev, curr) {
        return client_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    // If user changed for any reason update GTM data layer variable
                    if ((prev === null || prev === void 0 ? void 0 : prev.userId) !== (curr === null || curr === void 0 ? void 0 : curr.userId)) {
                        (0,data_layer/* pushEvent */.A)("schibstedAccountUser", {
                            id: curr === null || curr === void 0 ? void 0 : curr.userId
                        });
                    }
                    // No session active.
                    // No user is logged in yet.
                    // No action needed.
                    if (!prev && !curr) {
                        return [
                            2
                        ];
                    }
                    // New session active.
                    // Happens on login.
                    // Update GTM data layer variable.
                    if (!prev && curr) {
                        (0,data_layer/* pushEvent */.A)("login", {
                            loggedIn: true
                        });
                        return [
                            2
                        ];
                    }
                    // Session associated with current user.
                    // Happens if user is still logged in.
                    // No action needed.
                    if ((prev === null || prev === void 0 ? void 0 : prev.userId) && (curr === null || curr === void 0 ? void 0 : curr.userId) && (prev === null || prev === void 0 ? void 0 : prev.userId) === (curr === null || curr === void 0 ? void 0 : curr.userId)) {
                        return [
                            2
                        ];
                    }
                    if (!((prev === null || prev === void 0 ? void 0 : prev.userId) && (curr === null || curr === void 0 ? void 0 : curr.userId) && (prev === null || prev === void 0 ? void 0 : prev.userId) !== (curr === null || curr === void 0 ? void 0 : curr.userId))) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        refreshReduxSessionState()
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
                case 2:
                    if (!((prev === null || prev === void 0 ? void 0 : prev.userId) && !(curr === null || curr === void 0 ? void 0 : curr.userId))) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0,requests/* destroySchibstedSession */.ph)()
                    ];
                case 3:
                    _state.sent();
                    return [
                        4,
                        refreshReduxSessionState()
                    ];
                case 4:
                    _state.sent();
                    (0,data_layer/* pushEvent */.A)("logoutComplete", {
                        loggedIn: false
                    });
                    _state.label = 5;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function onSessionChange(prev, curr) {
        return _ref.apply(this, arguments);
    };
}();
var AppWithViewport = /*#__PURE__*/ function(_Component) {
    "use strict";
    client_inherits(AppWithViewport, _Component);
    var _super = client_createSuper(AppWithViewport);
    function AppWithViewport(props) {
        client_classCallCheck(this, AppWithViewport);
        var _this;
        _this = _super.call(this, props);
        client_defineProperty(client_assertThisInitialized(_this), "fetchContextValue", client_objectSpread({
            query: query/* default */.Z
        }, window.CONTEXTS.fetch));
        _this.state = {
            initialRender: window.SERVER_SIDE_RENDER_ROUTES === false
        };
        return _this;
    }
    client_createClass(AppWithViewport, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.state.initialRender) {
                    this.setState({
                        initialRender: false
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var AccountProvider = window.CLIENT_MARKET.login.enabled ? function(param) {
                    var children = param.children;
                    return /*#__PURE__*/ react.createElement(dist.AccountProvider, {
                        config: schibstedAccountConfig,
                        getOauthState: requests/* getOauthState */.Xg,
                        onSessionChange: onSessionChange
                    }, children);
                } : react.Fragment;
                return /*#__PURE__*/ react.createElement(react_router/* Router */.F0, {
                    history: client_history
                }, /*#__PURE__*/ react.createElement(app_context/* AppContextContainer */.hw, {
                    rngSeed: window.RNG_SEED,
                    renderMode: window.RENDER_CONTEXT_MODE,
                    market: window.CLIENT_MARKET,
                    locale: window.LOCALE,
                    translations: window.TRANSLATIONS,
                    sentryPromise: sentry/* sentryPromise */._8,
                    productOfTheYear: window.CONTEXTS.productsOfTheYear
                }, /*#__PURE__*/ react.createElement(location_context/* LocationProvider */.v, null, /*#__PURE__*/ react.createElement(lib/* QueryClientProvider */.aH, {
                    client: queryClient
                }, /*#__PURE__*/ react.createElement(lib/* Hydrate */.pO, {
                    state: dehydratedState
                }, /*#__PURE__*/ react.createElement(base/* StyledTheme */.VA, null, /*#__PURE__*/ react.createElement(fetch_context/* default.Provider */.Z.Provider, {
                    value: this.fetchContextValue
                }, /*#__PURE__*/ react.createElement(FetchQueryErrorProvider, {
                    error: window.CONTEXTS.fetchQueryError
                }, /*#__PURE__*/ react.createElement(AccountProvider, null, /*#__PURE__*/ react.createElement(es/* Provider */.zt, {
                    store: store/* default */.Z
                }, /*#__PURE__*/ react.createElement(experiments, null, /*#__PURE__*/ react.createElement(ads_context/* AdContextContainerWithExperiments */.kX, null, /*#__PURE__*/ react.createElement(services_context/* default.Provider */.Z.Provider, null, /*#__PURE__*/ react.createElement(context/* ViewportContextContainer */.Pi, null, /*#__PURE__*/ react.createElement(search_bar_context/* SearchBarProvider */.t, null, /*#__PURE__*/ react.createElement(app, {
                    callback: this.props.callback
                })))))))))))), /*#__PURE__*/ react.createElement(build_lib/* ReactQueryDevtools */.t, {
                    initialIsOpen: false,
                    position: "top-right"
                })))));
            }
        }
    ]);
    return AppWithViewport;
}(react.Component);
performance_reporter("startHydration");
var renderAppCallback = function() {
    performance_reporter("hydrationCompleted");
    window.PRE_TRACK_CLICKS = false;
    dispatchSession(window.SESSION_DATA);
    store/* default.dispatch */.Z.dispatch({
        type: "APP_STARTUP",
        market: window.CLIENT_MARKET.code,
        locale: window.CLIENT_MARKET.localeStandard,
        release: window.RELEASE
    });
    loadLocalStorageState(store/* default */.Z);
    store/* default.subscribe */.Z.subscribe(throttle_default()(function() {
        saveStateToLocalStorage(store/* default */.Z);
    }, 1000));
    if (/[&?]_verify_complete\b/.test(window.location.search)) {
        var paramValue = window.location.search.match(/[&?]_verify_complete=([^&]+)/);
        var mode = paramValue.length > 1 ? paramValue[1] : null;
        store/* default.dispatch */.Z.dispatch({
            type: "VERIFY_ACCOUNT_COMPLETE",
            mode: mode
        });
    }
};
var renderApp = function() {
    var root;
    var container = document.getElementById("root");
    if (!root) {
        // Don't need to call `render` here because `hydrateRoot` will take care of it
        root = (0,client/* hydrateRoot */.a)(container, /*#__PURE__*/ react.createElement(AppWithViewport, {
            callback: renderAppCallback
        }), {
            onRecoverableError: function onRecoverableError(error) {
                (0,sentry/* captureException */.Tb)(error);
            }
        });
    } else {
        root.render(/*#__PURE__*/ react.createElement(AppWithViewport, {
            callback: renderAppCallback
        }));
    }
};
if (!window.TRANSLATIONS) {
    throw new Error("Missing translations, aborting hydrate");
}
var done = after_default()(2, renderApp);
window.sessionReady(done);
(0,loadable_esm/* loadableReady */.TA)(done);


/***/ }),

/***/ 43517:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var js_sha256__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39489);
/* harmony import */ var js_sha256__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(js_sha256__WEBPACK_IMPORTED_MODULE_0__);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};

/**
 NOTE: In order to save sent bytes from the client
 this method tries to run a fetch without uploading the
 query itself. If server and client versions differ
 the fetch reruns with query included
* */ var execQuery = function() {
    var _ref = _asyncToGenerator(function(query, variables) {
        var ref, fetchOptions, res, json;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    fetchOptions = {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        }
                    };
                    return [
                        4,
                        fetch("/_internal/bff", _objectSpreadProps(_objectSpread({}, fetchOptions), {
                            method: "POST",
                            body: JSON.stringify({
                                query: "hash:".concat((0,js_sha256__WEBPACK_IMPORTED_MODULE_0__.sha256)(query)),
                                variables: variables
                            })
                        }))
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        4,
                        res.json()
                    ];
                case 2:
                    json = _state.sent();
                    if (res.status === 200 && !((ref = json.errors) === null || ref === void 0 ? void 0 : ref.length)) {
                        return [
                            2,
                            json
                        ];
                    }
                    // If no success, try again with query
                    return [
                        2,
                        fetch("/_internal/bff", _objectSpreadProps(_objectSpread({}, fetchOptions), {
                            method: "POST",
                            body: JSON.stringify({
                                query: query,
                                variables: variables
                            })
                        })).then(function(x) {
                            return x.json();
                        })
                    ];
            }
        });
    });
    return function execQuery(query, variables) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (execQuery);


/***/ }),

/***/ 31977:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ client_store)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/redux@4.0.1/node_modules/redux/es/redux.js
var redux = __webpack_require__(59715);
// EXTERNAL MODULE: ./node_modules/.pnpm/redux-saga@1.0.3/node_modules/redux-saga/dist/redux-saga-core-npm-proxy.esm.js + 3 modules
var redux_saga_core_npm_proxy_esm = __webpack_require__(47735);
// EXTERNAL MODULE: ./src/globals/actions/index.ts
var actions = __webpack_require__(46095);
;// CONCATENATED MODULE: ./src/globals/reducers/index.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var globals = function() {
    var // eslint-disable-next-line default-param-last
    state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        layout: "default",
        hrefLang: {
            start: {}
        },
        campaigns: {
            active: []
        },
        campaignBanners: {
            active: []
        },
        cookieBanner: {
            version: undefined,
            isActive: false
        },
        infoPages: {
            nodes: [],
            open: function() {}
        }
    }, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case actions/* DANGEROUS_CONFIG_RECEIVE */.R5:
            {
                var marketKeys = Object.keys(action.markets).filter(function(market) {
                    return action.markets[market].active && action.markets[market].translation;
                });
                return _objectSpreadProps(_objectSpread({}, state), {
                    hrefLang: _objectSpreadProps(_objectSpread({}, state.hrefLang), {
                        start: marketKeys.reduce(function(all, market) {
                            return Object.assign(all, _defineProperty({}, action.markets[market].translation.replace("_", "-"), "".concat(action.markets[market].sites.production, "/")));
                        }, {
                            en: "".concat(action.markets.gb.sites.production, "/"),
                            // Render x-default href lang tag only on start page.
                            // Recommendation from Schibsted SEO-guru.
                            "x-default": "".concat(action.markets.gb.sites.production, "/")
                        }),
                        campaignMain: marketKeys.filter(function(market) {
                            return action.markets[market].url && action.markets[market].url.campaigns;
                        }).reduce(function(all, market) {
                            return Object.assign(all, _defineProperty({}, action.markets[market].translation.replace("_", "-"), "".concat(action.markets[market].sites.production).concat(action.markets[market].url.campaigns)));
                        }, {
                            en: "".concat(action.markets.gb.sites.production).concat(action.markets.gb.url.campaigns)
                        })
                    })
                });
            }
        case "APP_STARTUP":
            {
                var renderContext = window.dataLayer[0].renderContext;
                switch(renderContext){
                    case "responsive":
                    case "beta":
                    case "mobile":
                    case "native":
                        return state;
                    case "desktop":
                        {
                            // if pjcua isn't set it will return null. We'll need cookie to
                            // be set to undefined for the cookie banner to be displayed
                            return _objectSpreadProps(_objectSpread({}, state), {
                                cookieBanner: _objectSpreadProps(_objectSpread({}, state.cookieBanner), {
                                    version: localStorage.getItem("pjcua") || undefined
                                })
                            });
                        }
                    default:
                }
                break;
            }
        case actions/* SESSION_RECEIVE */.g8:
            {
                return _objectSpreadProps(_objectSpread({}, state), {
                    cookieBanner: _objectSpreadProps(_objectSpread({}, state.cookieBanner, action.session.cookie_consent_version ? {
                        version: action.session.cookie_consent_version
                    } : {}), {
                        isActive: true
                    })
                });
            }
        case "ACCEPT_COOKIES":
            {
                var renderContext1 = window.dataLayer[0].renderContext;
                if (renderContext1 === "desktop") {
                    localStorage.setItem("pjcua", action.version);
                }
                return _objectSpreadProps(_objectSpread({}, state), {
                    cookieBanner: _objectSpreadProps(_objectSpread({}, state.cookieBanner), {
                        version: action.version
                    })
                });
            }
        case "CAMPAIGNS_RECEIVE":
            {
                return _objectSpreadProps(_objectSpread({}, state), {
                    campaigns: {
                        active: action.campaigns.filter(function(c) {
                            return c.state === "ACTIVE";
                        })
                    },
                    campaignBanners: {
                        active: action.campaigns.reduce(function(allBanners, campaign) {
                            return allBanners.concat(campaign.banners.map(function(banner) {
                                return _objectSpreadProps(_objectSpread({}, banner), {
                                    campaign: campaign
                                });
                            }));
                        }, [])
                    }
                });
            }
        case "FILTER_TOGGLE_MOBILE":
            {
                return _objectSpreadProps(_objectSpread({}, state), {
                    layout: action.open ? "raw-mobile" : "default"
                });
            }
        case "BRAND_MEDIA_TOGGLE":
        case "PRODUCT_MEDIA_OPEN":
            {
                return _objectSpread({}, state);
            }
        case actions/* INFO_PAGES_RECEIVE */.DU:
            {
                return _objectSpreadProps(_objectSpread({}, state), {
                    infoPages: action.pages
                });
            }
        default:
    }
    return state;
};
/* harmony default export */ const reducers = (globals);

// EXTERNAL MODULE: ./src/areas/feedback/actions/index.js
var feedback_actions = __webpack_require__(6416);
;// CONCATENATED MODULE: ./src/areas/feedback/reducers/index.js
function reducers_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function reducers_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            reducers_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function reducers_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function reducers_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        reducers_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var reducer = function(state, action) {
    if (!state) {
        return {
            id: 0,
            open: false,
            sending: false,
            thanks: false,
            error: undefined,
            email: undefined
        };
    }
    switch(action.type){
        case "__DANGEROUS_CONFIG_RECEIVE":
            {
                return reducers_objectSpreadProps(reducers_objectSpread({}, state), {
                    group: action.server.feedbackGroup,
                    tag: action.server.feedbackTag
                });
            }
        case feedback_actions/* FEEDBACK_OPEN */.hy:
            {
                return reducers_objectSpreadProps(reducers_objectSpread({}, state), {
                    open: true
                });
            }
        case feedback_actions/* FEEDBACK_CLOSE */._d:
            {
                return reducers_objectSpreadProps(reducers_objectSpread({}, state), {
                    open: false
                });
            }
        case feedback_actions/* FEEDBACK_CLEAR_FORM */.YB:
            {
                return reducers_objectSpreadProps(reducers_objectSpread({}, state), {
                    id: state.id + 1,
                    thanks: false,
                    error: undefined,
                    open: false
                });
            }
        case feedback_actions/* FEEDBACK_SEND_REQUEST */.ph:
            {
                return reducers_objectSpreadProps(reducers_objectSpread({}, state), {
                    sending: true
                });
            }
        case feedback_actions/* FEEDBACK_REPORT_WRONG_PRICE */.r_:
            {
                return reducers_objectSpreadProps(reducers_objectSpread({}, state), {
                    sending: true
                });
            }
        case feedback_actions/* FEEDBACK_SEND_SUCCESS */.Ly:
            {
                return reducers_objectSpreadProps(reducers_objectSpread({}, state), {
                    sending: false,
                    thanks: true
                });
            }
        case feedback_actions/* FEEDBACK_SEND_FAILED */.d2:
            {
                return reducers_objectSpreadProps(reducers_objectSpread({}, state), {
                    sending: false,
                    error: action.message,
                    thanks: false
                });
            }
        case "SESSION_RECEIVE":
            {
                return reducers_objectSpreadProps(reducers_objectSpread({}, state), {
                    email: action.session.email
                });
            }
        default:
    }
    return state;
};
/* harmony default export */ const feedback_reducers = (reducer);

;// CONCATENATED MODULE: ./src/areas/footer/reducers/types.ts
var FOOTER_ARTICLES_RECEIVE = "FOOTER_ARTICLES_RECEIVE";

;// CONCATENATED MODULE: ./src/areas/footer/reducers/index.tsx
function footer_reducers_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function footer_reducers_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            footer_reducers_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function footer_reducers_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function footer_reducers_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        footer_reducers_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


var initialState = {
    socialNetworks: [],
    current: "",
    sites: [],
    articles: [],
    url: {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    open: function() {}
};
function reducers_reducer() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    if (!state) {
        return footer_reducers_objectSpreadProps(footer_reducers_objectSpread({}, initialState), {
            current: ""
        });
    }
    switch(action.type){
        /**
      NOTE: All config is dispatch, any data returned will be sent
      down to the browser. Make sure no secrets is leaking!
    * */ case actions/* DANGEROUS_CONFIG_RECEIVE */.R5:
            {
                var market = action.market, markets = action.markets, server = action.server;
                return footer_reducers_objectSpreadProps(footer_reducers_objectSpread({}, state), {
                    current: market.countryCode,
                    sites: Object.keys(markets).filter(function(code) {
                        return server.appEnv === "production" ? markets[code].active : true;
                    }).map(function(code) {
                        return {
                            url: markets[code].sites[server.appEnv],
                            code: code
                        };
                    }),
                    socialNetworks: Object.keys(market.socialNetworks || {}).map(function(name) {
                        return {
                            name: name,
                            link: market.socialNetworks[name].link
                        };
                    }),
                    url: {
                        campaigns: market.url && market.url.campaigns ? market.url.campaigns : undefined
                    }
                });
            }
        case FOOTER_ARTICLES_RECEIVE:
            {
                return footer_reducers_objectSpreadProps(footer_reducers_objectSpread({}, state), {
                    articles: action.articles
                });
            }
        default:
    }
    return state;
}

// EXTERNAL MODULE: ./src/areas/product/actions/types.ts
var types = __webpack_require__(58848);
;// CONCATENATED MODULE: ./src/areas/product/reducer/index.ts
function reducer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function reducer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            reducer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function reducer_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function reducer_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        reducer_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var defaultProductState = {
    campaigns: null,
    variantSizes: null,
    condition: "new"
};
/* harmony default export */ function product_reducer(state, action) {
    if (!state) {
        return defaultProductState;
    }
    switch(action.type){
        case types/* ProductActionType.CAMPAIGNS_RECEIVE */.Z.CAMPAIGNS_RECEIVE:
            {
                return reducer_objectSpreadProps(reducer_objectSpread({}, state), {
                    campaigns: action.campaigns && action.campaigns.filter(function(campaign) {
                        return campaign.state === "ACTIVE";
                    })
                });
            }
        default:
            return state;
    }
};

// EXTERNAL MODULE: ./src/areas/sidebar/actions/alert.js
var actions_alert = __webpack_require__(83846);
;// CONCATENATED MODULE: ./src/areas/product-alert/reducers/index.js
function product_alert_reducers_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function product_alert_reducers_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            product_alert_reducers_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function product_alert_reducers_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function product_alert_reducers_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        product_alert_reducers_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

/* harmony default export */ function product_alert_reducers() {
    var // eslint-disable-next-line default-param-last
    state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        sending: false,
        error: false,
        success: false
    }, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case actions_alert/* REMOVE_ALERT_REQUEST */.$x:
        case actions_alert/* CREATE_ALERT_REQUEST */.Oi:
            {
                return product_alert_reducers_objectSpreadProps(product_alert_reducers_objectSpread({}, state), {
                    sending: true,
                    error: false
                });
            }
        case actions_alert/* REMOVE_ALERT_SUCCESS */.$_:
        case actions_alert/* CREATE_ALERT_SUCCESS */.mx:
            {
                return product_alert_reducers_objectSpreadProps(product_alert_reducers_objectSpread({}, state), {
                    sending: false,
                    success: true
                });
            }
        case actions_alert/* REMOVE_ALERT_ERROR */.XJ:
        case actions_alert/* CREATE_ALERT_FAILED */.VL:
            {
                return product_alert_reducers_objectSpreadProps(product_alert_reducers_objectSpread({}, state), {
                    sending: false,
                    error: action.error
                });
            }
        default:
    }
    return state;
};

// EXTERNAL MODULE: ./src/areas/category/actions/category.js
var category = __webpack_require__(5202);
;// CONCATENATED MODULE: ./src/areas/category/reducers/category.js
function category_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function category_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            category_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function category_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function category_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        category_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

/* harmony default export */ function reducers_category(state, action) {
    if (!state) {
        return {
            id: null
        };
    }
    switch(action.type){
        case category/* CATEGORY_LAYOUT_CHANGED */.Hp:
            {
                return category_objectSpreadProps(category_objectSpread({}, state), {
                    mode: action.mode
                });
            }
        case "SESSION_RECEIVE":
            {
                return category_objectSpreadProps(category_objectSpread({}, state), {
                    mode: action.session.categoryLayout || state.mode
                });
            }
        default:
    }
    return state;
};

// EXTERNAL MODULE: ./src/areas/category/actions/filter.js
var filter = __webpack_require__(70721);
// EXTERNAL MODULE: ./src/areas/category/constants.ts
var constants = __webpack_require__(63930);
;// CONCATENATED MODULE: ./src/areas/category/reducers/filter.js
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function filter_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function filter_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            filter_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function filter_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function filter_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        filter_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


var hasChangedCategory = function(action, state) {
    return action.categoryData.categoryId !== state.loadedCategoryId || action.categoryData.categoryId === state.loadedCategoryId && state.toggledBrandCategory;
};
var getSelectionFromQuery = function(_param, currentlySelected) {
    var type = _param.type, categoryId = _param.categoryId, query = _objectWithoutProperties(_param, [
        "type",
        "categoryId"
    ]);
    var filterIds = Object.keys(query).reduce(function(all, sectionId) {
        var values = query[sectionId];
        return Array.isArray(values) ? values.map(function(valueId) {
            return "".concat(sectionId, "-").concat(valueId);
        }).concat(all) : all.concat(sectionId);
    }, []);
    var stillSelected = Object.keys(currentlySelected).filter(function(key) {
        return filterIds.includes(key);
    }).reduce(function(obj, key) {
        return filter_objectSpreadProps(filter_objectSpread({}, obj), filter_defineProperty({}, key, currentlySelected[key]));
    }, {});
    return {
        stillSelected: stillSelected,
        query: query
    };
};
var getSelection = function(_param) {
    var id = _param.id, value = _param.value, checked = _param.checked, filterType = _param.filterType, rest = _objectWithoutProperties(_param, [
        "id",
        "value",
        "checked",
        "filterType"
    ]);
    var data = filter_objectSpread({
        id: id,
        value: value,
        checked: checked,
        filterType: filterType
    }, rest);
    switch(filterType){
        case "list":
            return filter_defineProperty({}, "".concat(id, "-").concat(value), checked ? data : null);
        case "boolean":
        case "slider":
        default:
            return filter_defineProperty({}, id, data);
    }
};
/* harmony default export */ function reducers_filter(state, action) {
    var initialState = {
        selected: [],
        categoryId: null,
        isBrandCategory: false,
        toggledBrandCategory: false,
        loadedCategoryId: undefined,
        query: {},
        definition: [],
        values: {},
        core: [],
        expandedCategories: [],
        mobileOpen: false,
        error: undefined,
        comparing: [],
        showFilter: false,
        productCount: null,
        showHorizontalFilter: undefined
    };
    if (!state) {
        return initialState;
    }
    switch(action.type){
        case "ROUTE_LOADED":
            {
                // NOTE: Reset filter on category receive, noop if same category is received
                if (!action.route || action.route.name !== "category") {
                    return initialState;
                }
                // Abort if category data is missing (404)
                if (!action.data || !action.data.category) {
                    return initialState;
                }
                var category = action.data.category;
                var categoryId = category && category.id;
                var brand = action.route.variables.brand || null;
                var initialStateSetup = filter_objectSpreadProps(filter_objectSpread({}, initialState), {
                    isBrandCategory: !!brand,
                    toggledBrandCategory: !brand && state.isBrandCategory || brand && !state.isBrandCategory,
                    comparing: category && category.products && category.products.pageInfo && category.products.pageInfo.selectedProperties && category.products.pageInfo.selectedProperties.map(function(x) {
                        return x.id;
                    }).slice(0, 3)
                });
                if (state.categoryId === categoryId && state.isBrandCategory !== !!brand) {
                    return initialStateSetup;
                }
                if (state.categoryId === categoryId) {
                    return filter_objectSpreadProps(filter_objectSpread({}, state), {
                        isBrandCategory: !!brand,
                        toggledBrandCategory: !brand && state.isBrandCategory || brand && !state.isBrandCategory
                    });
                }
                return initialStateSetup;
            }
        case filter/* FILTER_CHANGE_ACTION */.$H:
            {
                // When clearing all fields for a section the action data
                // is a new query with the cleared sections removed.
                // Update selection tags to match this.
                if (!action.id) {
                    var ref = getSelectionFromQuery(action, state.selected), stillSelected = ref.stillSelected, query = ref.query;
                    return filter_objectSpreadProps(filter_objectSpread({}, state), {
                        selected: stillSelected,
                        query: query
                    });
                }
                return filter_objectSpreadProps(filter_objectSpread({}, state), {
                    selected: filter_objectSpread({}, state.selected, getSelection(action))
                });
            }
        case filter/* FILTER_EXPAND_SECTION */.c8:
            {
                if (state.expandedCategories.includes(action.name)) {
                    return filter_objectSpreadProps(filter_objectSpread({}, state), {
                        expandedCategories: state.expandedCategories.filter(function(name) {
                            return name !== action.name;
                        })
                    });
                }
                return filter_objectSpreadProps(filter_objectSpread({}, state), {
                    expandedCategories: _toConsumableArray(state.expandedCategories).concat([
                        action.name
                    ])
                });
            }
        case filter/* FILTER_TOGGLE_MOBILE */.WK:
            {
                return filter_objectSpreadProps(filter_objectSpread({}, state), {
                    mobileOpen: action.open
                });
            }
        case filter/* FILTER_RECEIVE */.vN:
            {
                var newState = filter_objectSpreadProps(filter_objectSpread({}, state, action.categoryData), {
                    showFilter: true,
                    error: undefined
                });
                if (action.data.item) {
                    newState.values = filter_objectSpread({}, state.values, action.data.item);
                }
                if (// NOTE: Skip this update if initial load is done
                hasChangedCategory(action, state) && action.data.meta && action.data.meta.property_definitions) {
                    var meta = action.data.meta;
                    var coreProps = new Array(meta.core_properties.length);
                    // Recursively create a new array of filter sections based on `property_definitions`
                    // excluding core property sections but includes the core properties children.
                    var createSubProperties = function(properties) {
                        return properties.map(function(property) {
                            if (meta.core_properties.includes(property.id)) {
                                var index = meta.core_properties.indexOf(property.id);
                                // We need to save the property `child` in its matching `property` index
                                // to maintain the correct order of coreProperties
                                // Sub properties `children` that are not marked as core are moved to its
                                // parent section. So we can null it here
                                coreProps[index] = filter_objectSpreadProps(filter_objectSpread({}, property), {
                                    children: null
                                });
                                if (property.children) {
                                    return createSubProperties(property.children);
                                }
                                return null;
                            }
                            return property;
                        }).filter(function(p) {
                            return p;
                        }).flat();
                    }; // from core-js
                    var defs = meta.property_definitions.map(function(def) {
                        return filter_objectSpreadProps(filter_objectSpread({}, def), {
                            children: createSubProperties(def.children)
                        });
                    });
                    var first = coreProps.filter(function(p) {
                        return [
                            "brands",
                            "price"
                        ].includes(p.id);
                    });
                    var rest = coreProps.filter(function(p) {
                        return ![
                            "brands",
                            "price"
                        ].includes(p.id);
                    });
                    newState.core = _toConsumableArray(first).concat(_toConsumableArray(rest));
                    newState.definition = defs;
                }
                if (// NOTE: Skip this update if initial load is done
                hasChangedCategory(action, state) && action.data.meta) {
                    newState.query = action.data.meta.filter_settings || {};
                    // Brand ids are strings in some API responses and numbers in others. That should be fixed, but it's probably part of a bigger filter overhaul...
                    // In order to support strict equality checks in client-side operations, we just convert them to strings here for now.
                    if (newState.query.brands) {
                        newState.query.brands = newState.query.brands.map(function(id) {
                            return id.toString();
                        });
                    }
                }
                newState.loadedCategoryId = action.categoryData.categoryId;
                return newState;
            }
        case filter/* FILTER_FETCH_FAILED */.I2:
            {
                return filter_objectSpreadProps(filter_objectSpread({}, state), {
                    error: action.error
                });
            }
        case filter/* FILTER_QUERY */.JL:
            {
                return filter_objectSpreadProps(filter_objectSpread({}, state), {
                    query: action.query
                });
            }
        case "LOCAL_STORAGE_RECEIVE":
            {
                var filterStateFromLocalStorage = action.localStorageState[constants/* LOCAL_STORAGE_FILTER_KEY */.vg];
                if (filterStateFromLocalStorage) {
                    return filter_objectSpreadProps(filter_objectSpread({}, state), {
                        showHorizontalFilter: filterStateFromLocalStorage
                    });
                }
                return state;
            }
        case filter/* SET_HORIZONTAL_FILTER */.vd:
            {
                return filter_objectSpreadProps(filter_objectSpread({}, state), {
                    showHorizontalFilter: action.show
                });
            }
        case filter/* COMPARE_PROPERTIES */.HW:
            {
                return filter_objectSpreadProps(filter_objectSpread({}, state), {
                    comparing: action.propertyIds
                });
            }
        case filter/* COMPARE_PROPERTY */.gd:
            {
                var selected = state.comparing.includes(action.propertyId);
                var comparing = selected ? state.comparing.filter(function(x) {
                    return x !== action.propertyId;
                }) : state.comparing.concat(action.propertyId);
                return filter_objectSpreadProps(filter_objectSpread({}, state), {
                    comparing: _toConsumableArray(new Set(comparing))
                });
            }
        default:
            {
                return state;
            }
    }
};

;// CONCATENATED MODULE: ./src/areas/category/reducers/search.js
function search_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function search_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return search_arrayLikeToArray(arr);
}
function search_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function search_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function search_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function search_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            search_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function search_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function search_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        search_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function search_toConsumableArray(arr) {
    return search_arrayWithoutHoles(arr) || search_iterableToArray(arr) || search_unsupportedIterableToArray(arr) || search_nonIterableSpread();
}
function search_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return search_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return search_arrayLikeToArray(o, minLen);
}

var search_initialState = {
    inputValue: "",
    lastInputValue: "",
    filteredCore: [],
    filteredSections: [],
    filteredValues: {},
    disabledExpansions: [],
    categoryId: undefined
};
/* harmony default export */ function search(state, action) {
    if (!state) {
        return search_initialState;
    }
    switch(action.type){
        case "ROUTE_LOADED":
            {
                if (action.route && action.route.name === "category") {
                    var category = action.data && action.data.category;
                    var categoryId = category && category.id;
                    if (state.categoryId === categoryId) {
                        return state;
                    }
                    return search_objectSpreadProps(search_objectSpread({}, search_initialState), {
                        categoryId: categoryId
                    });
                }
                return state;
            }
        case filter/* PROPERTY_SEARCH_ACTION */.Q:
            {
                return search_objectSpreadProps(search_objectSpread({}, state), {
                    lastInputValue: state.inputValue,
                    inputValue: action.inputValue
                });
            }
        case filter/* PROPERTY_SEARCH_TOGGLE_SECTION */.eB:
            {
                if (state.disabledExpansions.includes(action.name)) {
                    return search_objectSpreadProps(search_objectSpread({}, state), {
                        disabledExpansions: state.disabledExpansions.filter(function(name) {
                            return name !== action.name;
                        })
                    });
                }
                return search_objectSpreadProps(search_objectSpread({}, state), {
                    disabledExpansions: search_toConsumableArray(state.disabledExpansions).concat([
                        action.name
                    ])
                });
            }
        case filter/* PROPERTY_SEARCH_COMPLETE */.kx:
            {
                return search_objectSpreadProps(search_objectSpread({}, state), {
                    filteredCore: action.filteredCore,
                    filteredSections: action.filteredSections,
                    filteredValues: action.filteredValues
                });
            }
        default:
            {
                return state;
            }
    }
};

;// CONCATENATED MODULE: ./src/areas/category/reducers/product-list.js
function product_list_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function product_list_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            product_list_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function product_list_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function product_list_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        product_list_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

/* harmony default export */ function product_list(state, action) {
    if (!state) {
        return {
            loading: false
        };
    }
    switch(action.type){
        case "ROUTE_LOADED":
            {
                return product_list_objectSpreadProps(product_list_objectSpread({}, state), {
                    loading: false
                });
            }
        case "SORT_CHANGE":
            {
                return product_list_objectSpreadProps(product_list_objectSpread({}, state), {
                    loading: true
                });
            }
        case filter/* FILTER_CHANGE_ACTION */.$H:
            {
                return product_list_objectSpreadProps(product_list_objectSpread({}, state), {
                    loading: true
                });
            }
        case filter/* FILTER_FETCH_FAILED */.I2:
            {
                return product_list_objectSpreadProps(product_list_objectSpread({}, state), {
                    loading: false
                });
            }
        case filter/* FILTER_RECEIVE */.vN:
            {
                return product_list_objectSpreadProps(product_list_objectSpread({}, state), {
                    loading: false
                });
            }
        default:
    }
    return state;
};

;// CONCATENATED MODULE: ./src/areas/category/reducers/index.js





/* harmony default export */ const category_reducers = ((0,redux.combineReducers)({
    category: reducers_category,
    filter: reducers_filter,
    search: search,
    productList: product_list
}));

// EXTERNAL MODULE: ./src/areas/account/actions/index.js
var account_actions = __webpack_require__(9285);
// EXTERNAL MODULE: ./src/areas/account/settings/actions/settings.js
var actions_settings = __webpack_require__(41112);
// EXTERNAL MODULE: ./src/areas/account/settings/actions/display-name.js
var display_name = __webpack_require__(61928);
// EXTERNAL MODULE: ./src/areas/account/settings/actions/alert-settings.js
var alert_settings = __webpack_require__(24757);
;// CONCATENATED MODULE: ./src/areas/account/reducers/index.js
function reducers_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function reducers_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return reducers_arrayLikeToArray(arr);
}
function account_reducers_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function reducers_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function reducers_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function account_reducers_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            account_reducers_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function account_reducers_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function account_reducers_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        account_reducers_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function reducers_toConsumableArray(arr) {
    return reducers_arrayWithoutHoles(arr) || reducers_iterableToArray(arr) || reducers_unsupportedIterableToArray(arr) || reducers_nonIterableSpread();
}
function reducers_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return reducers_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return reducers_arrayLikeToArray(o, minLen);
}




/* harmony default export */ function account_reducers() {
    var // eslint-disable-next-line default-param-last
    state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        isAuthenticated: false,
        me: undefined,
        id: undefined,
        name: undefined,
        settings: undefined,
        loading: true,
        shopPreference: {
            fetchingLikes: false,
            fetchingDislikes: false
        }
    }, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case "__DANGEROUS_CONFIG_RECEIVE":
            {
                var infoPageMap = action.market.infoPageMap;
                return account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state), {
                    infoPageMap: infoPageMap
                });
            }
        case "SESSION_RECEIVE":
            {
                return account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state), {
                    isAuthenticated: !!action.session.loggedIn,
                    loading: false
                });
            }
        case account_actions/* USER_RECEIVE */.dt:
            {
                var subscriptionGroups = action.me.subscriptionSettings.map(function(group) {
                    var mailId = group.channels.mail && Number(group.channels.mail.id) || null;
                    var pushId = group.channels.push && Number(group.channels.push.id) || null;
                    return {
                        title: group.title,
                        description: group.description,
                        mail: mailId,
                        push: pushId
                    };
                });
                var subscriptionSettings = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = action.me.subscriptionSettings[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var group = _step.value;
                        var mailId = group.channels.mail && Number(group.channels.mail.id) || null;
                        if (mailId) {
                            subscriptionSettings[mailId] = group.channels.mail.subscribed;
                        }
                        var pushId = group.channels.push && Number(group.channels.push.id) || null;
                        if (pushId) {
                            subscriptionSettings[pushId] = group.channels.push.subscribed;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state), {
                    me: account_reducers_objectSpreadProps(account_reducers_objectSpread({}, action.me), {
                        subscriptionGroups: subscriptionGroups,
                        subscriptionSettings: subscriptionSettings
                    }),
                    isAuthenticated: true,
                    loading: false
                });
            }
        case actions_settings/* SETTINGS_START_EDITING */.Dl:
            {
                return account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state), {
                    settings: {
                        editing: action.settings,
                        errors: undefined,
                        saving: false
                    }
                });
            }
        case display_name/* DISPLAY_NAME_CHANGE */.Kc:
            {
                return account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state), {
                    settings: account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state.settings), {
                        saving: true
                    })
                });
            }
        case actions_settings/* SETTINGS_CHANGE_SUCCESS */.f1:
            {
                return account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state), {
                    settings: account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state.settings), {
                        editing: undefined,
                        errors: undefined,
                        saving: false
                    })
                });
            }
        case actions_settings/* SETTINGS_CHANGE_FAILED */.nA:
            {
                var errors = {
                    "registration.username-taken": "name",
                    "auth.invalid-credentials": "password",
                    "registration.password-length": "password",
                    "registration.invalid-email": "email",
                    "registration.email-invalid": "email",
                    "registration.email-in-use": "email",
                    "registration.verification-mail-not-sent": "email",
                    "validation.email-invalid": "email",
                    "request.invalid-parameter": "displayName"
                };
                var error = errors[action.error];
                return account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state), {
                    settings: account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state.settings), {
                        saving: false,
                        errors: account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state.settings.errors), account_reducers_defineProperty({}, error, action.error))
                    })
                });
            }
        case alert_settings/* ALERT_SETTINGS_CHANGE */.G5:
        case alert_settings/* ALERT_SETTINGS_CHANGE_SUCCESS */.Os:
            {
                var settings = {};
                if (Array.isArray(action.setting)) {
                    settings = action.setting.reduce(function(acc, curr) {
                        acc[curr.setting] = curr.value;
                        return acc;
                    }, {});
                } else {
                    settings = account_reducers_defineProperty({}, action.setting.setting, action.setting.value);
                }
                return account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state), {
                    me: account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state.me), {
                        alertSettings: account_reducers_objectSpread({}, state.me.alertSettings, settings)
                    })
                });
            }
        case display_name/* UPDATE_DISPLAY_NAME */.kr:
            {
                return account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state), {
                    me: account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state.me), {
                        displayName: action.displayName
                    })
                });
            }
        case "LIKE_REVIEW_SUCCESS":
            {
                var updatedLikes = action.value === "like" ? [
                    action.id
                ].concat(reducers_toConsumableArray(state.me.likes.reviews)) : state.me.likes.reviews.filter(function(review) {
                    return review !== action.id;
                });
                return account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state), {
                    me: account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state.me), {
                        likes: account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state.me.likes), {
                            reviews: updatedLikes
                        })
                    })
                });
            }
        case "LIKE_LIST_SUCCESS":
            {
                var updatedLikes1 = action.value === "like" ? [
                    action.id
                ].concat(reducers_toConsumableArray(state.me.likes.lists)) : state.me.likes.lists.filter(function(review) {
                    return review !== action.id;
                });
                return account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state), {
                    me: account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state.me), {
                        likes: account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state.me.likes), {
                            lists: updatedLikes1
                        })
                    })
                });
            }
        case "UPDATE_REVIEW_DATA":
            {
                if (!action.productId) return account_reducers_objectSpread({}, state);
                var myReview = action.nodes.find(function(review) {
                    return review.user.id === state.me.id;
                });
                var updatedProducts = reducers_toConsumableArray(state.me.reviewedProducts.filter(function(reviewedProduct) {
                    return reviewedProduct.productId !== action.productId;
                })).concat([
                    myReview ? {
                        productId: action.productId,
                        rating: myReview.rating
                    } : null
                ]).filter(function(x) {
                    return x;
                });
                return account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state), {
                    me: account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state.me), {
                        reviewedProducts: updatedProducts
                    })
                });
            }
        case actions_settings/* UPDATE_SUBSCRIPTION_SETTING */.X2:
            {
                return account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state), {
                    me: account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state.me), {
                        subscriptionSettings: account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state.me.subscriptionSettings), account_reducers_defineProperty({}, action.id, action.subscribed))
                    })
                });
            }
        case account_actions/* USER_LIKE_SHOP_REQUEST */.ie:
            {
                return account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state), {
                    shopPreference: account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state.shopPreference), {
                        fetchingLikes: true
                    })
                });
            }
        case account_actions/* USER_DISLIKE_SHOP_REQUEST */.oN:
            {
                return account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state), {
                    shopPreference: account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state.shopPreference), {
                        fetchingDislikes: true
                    })
                });
            }
        case account_actions/* USER_SHOP_PREFERENCE_ERROR */.xX:
            {
                return account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state), {
                    shopPreference: {
                        fetchingLikes: false,
                        fetchingDislikes: false
                    }
                });
            }
        case account_actions/* USER_SHOP_PREFERENCE_RECEIVE */.Lo:
            {
                return account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state), {
                    shopPreference: {
                        fetchingLikes: false,
                        fetchingDislikes: false
                    },
                    me: account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state.me), {
                        likes: account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state.me.likes), {
                            shops: action.shopPreferenceState.me.likes.shops
                        }),
                        dislikes: account_reducers_objectSpreadProps(account_reducers_objectSpread({}, state.me.dislikes), {
                            shops: action.shopPreferenceState.me.dislikes.shops
                        })
                    })
                });
            }
        default:
    }
    return state;
};

// EXTERNAL MODULE: ./src/areas/navigation/actions/desktop.js
var desktop = __webpack_require__(51478);
;// CONCATENATED MODULE: ./src/areas/navigation/reducers/mega-menu.js
function mega_menu_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function mega_menu_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            mega_menu_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function mega_menu_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function mega_menu_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        mega_menu_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

/* harmony default export */ function mega_menu(state, action) {
    if (!state) {
        return {
            openCategory: null,
            open: false,
            rootCategories: undefined
        };
    }
    switch(action.type){
        case "CATEGORIES_RECEIVE":
            {
                return mega_menu_objectSpreadProps(mega_menu_objectSpread({}, state), {
                    rootCategories: action.categories
                });
            }
        case desktop/* NAVIGATION_TOGGLE_MENU */.F_:
            {
                var open = action.open;
                return mega_menu_objectSpreadProps(mega_menu_objectSpread({}, state), {
                    open: open
                });
            }
        case desktop/* NAVIGATION_CHANGE_CATEGORY */.m5:
            {
                var openCategory = action.openCategory;
                return mega_menu_objectSpreadProps(mega_menu_objectSpread({}, state), {
                    openCategory: openCategory
                });
            }
        default:
    }
    return state;
};

// EXTERNAL MODULE: ./src/areas/navigation/actions/mobile-menu.js
var mobile_menu = __webpack_require__(59361);
;// CONCATENATED MODULE: ./src/areas/navigation/reducers/mobile-menu.js
function mobile_menu_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function mobile_menu_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return mobile_menu_arrayLikeToArray(arr);
}
function mobile_menu_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function mobile_menu_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function mobile_menu_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function mobile_menu_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            mobile_menu_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function mobile_menu_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function mobile_menu_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        mobile_menu_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function mobile_menu_toConsumableArray(arr) {
    return mobile_menu_arrayWithoutHoles(arr) || mobile_menu_iterableToArray(arr) || mobile_menu_unsupportedIterableToArray(arr) || mobile_menu_nonIterableSpread();
}
function mobile_menu_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return mobile_menu_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return mobile_menu_arrayLikeToArray(o, minLen);
}

/* harmony default export */ function reducers_mobile_menu(state, action) {
    if (!state) {
        return {
            open: false,
            history: []
        };
    }
    switch(action.type){
        case mobile_menu/* OPEN_MOBILE_MENU */.QU:
            {
                return mobile_menu_objectSpreadProps(mobile_menu_objectSpread({}, state), {
                    open: true
                });
            }
        case mobile_menu/* CLOSE_MOBILE_MENU */.l2:
            {
                return mobile_menu_objectSpreadProps(mobile_menu_objectSpread({}, state), {
                    open: false
                });
            }
        case mobile_menu/* NAVIGATE_FROM_MOBILE_MENU */.CA:
            {
                return mobile_menu_objectSpreadProps(mobile_menu_objectSpread({}, state), {
                    navigatedFromMobileMenu: true
                });
            }
        case "ROUTE_LOADED":
            {
                return mobile_menu_objectSpreadProps(mobile_menu_objectSpread({}, state), {
                    navigatedFromMobileMenu: false,
                    // Reset mobile menu history, essentially going back to the top level of the mobile menu,
                    // unless we just navigated from mobile menu, e.g. clicked a category link in it.
                    history: state.navigatedFromMobileMenu ? state.history : state.history.slice(0, 1)
                });
            }
        case mobile_menu/* SET_INITIAL_DATA */.bO:
            {
                var categories = action.categories;
                return mobile_menu_objectSpreadProps(mobile_menu_objectSpread({}, state), {
                    categories: categories,
                    history: [
                        {
                            id: "root",
                            name: null,
                            semantic_id: null,
                            children: categories
                        }
                    ]
                });
            }
        case mobile_menu/* CHANGE_MOBILE_MENU_CATEGORIES */.cL:
            {
                var categories1 = action.categories, parent = action.parent;
                return mobile_menu_objectSpreadProps(mobile_menu_objectSpread({}, state), {
                    categories: categories1,
                    history: mobile_menu_toConsumableArray(state.history).concat([
                        parent
                    ]),
                    // Keep track of whether we're traversing up or down the category tree
                    // to determine transition direction
                    isTraversingUpwards: false
                });
            }
        case mobile_menu/* SELECT_MOBILE_MENU_HISTORY */.FB:
            {
                var categoryId = action.categoryId;
                var index = state.history.findIndex(function(current) {
                    return current.id === categoryId;
                });
                if (index >= 0) {
                    return mobile_menu_objectSpreadProps(mobile_menu_objectSpread({}, state), {
                        history: state.history.slice(0, index + 1),
                        categories: state.history[index].children,
                        // Keep track of whether we're traversing up or down the category tree
                        // to determine transition direction
                        isTraversingUpwards: true
                    });
                }
                return mobile_menu_objectSpread({}, state);
            }
        default:
    }
    return state;
};

;// CONCATENATED MODULE: ./src/areas/navigation/actions/account-menu.js
var ACCOUNT_MENU_TOGGLE = "ACCOUNT_MENU_TOGGLE";

;// CONCATENATED MODULE: ./src/areas/navigation/reducers/account-menu.js
function account_menu_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function account_menu_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            account_menu_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function account_menu_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function account_menu_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        account_menu_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

/* harmony default export */ function account_menu(state, action) {
    if (!state) {
        return {
            open: false
        };
    }
    switch(action.type){
        case ACCOUNT_MENU_TOGGLE:
            {
                return account_menu_objectSpreadProps(account_menu_objectSpread({}, state), {
                    open: action.open
                });
            }
        default:
    }
    return state;
};

;// CONCATENATED MODULE: ./src/areas/navigation/reducers/index.js




/* harmony default export */ const navigation_reducers = ((0,redux.combineReducers)({
    megaMenu: mega_menu,
    mobileMenu: reducers_mobile_menu,
    accountMenu: account_menu
}));

;// CONCATENATED MODULE: ./src/areas/campaign/reducers/index.ts
function campaign_reducers_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function campaign_reducers_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            campaign_reducers_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function campaign_reducers_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function campaign_reducers_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        campaign_reducers_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var reducers_initialState = {
    base: undefined,
    popularCampaignFilterPaths: undefined,
    timezone: undefined,
    translation: undefined
};
/* harmony default export */ function campaign_reducers() {
    var // eslint-disable-next-line default-param-last
    state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : reducers_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        /**
      NOTE: All config is dispatched, any data returned will be sent
      down to the browser. Make sure no secrets is leaking!
    * */ case actions/* DANGEROUS_CONFIG_RECEIVE */.R5:
            {
                var market = action.market;
                return campaign_reducers_objectSpreadProps(campaign_reducers_objectSpread({}, state), {
                    translation: market.translation,
                    timezone: market.timezone,
                    base: market.url.campaigns,
                    popularCampaignFilterPaths: market.popularCampaignFilterPaths
                });
            }
        default:
    }
    return state;
};

// EXTERNAL MODULE: ./node_modules/.pnpm/querystring@0.2.1/node_modules/querystring/index.js
var querystring = __webpack_require__(97150);
// EXTERNAL MODULE: ./packages/product-collection-urls/dist/index.js
var dist = __webpack_require__(16472);
// EXTERNAL MODULE: ./src/components/ads/helpers/pagetype.js
var pagetype = __webpack_require__(83982);
;// CONCATENATED MODULE: ./src/components/ads/reducer.js
function ads_reducer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ads_reducer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ads_reducer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ads_reducer_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ads_reducer_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ads_reducer_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ function ads_reducer(state, action) {
    if (!state) return {
        pathKey: null,
        pageType: pagetype/* PAGETYPE_OTHER */.Tj,
        schPageType: pagetype/* SCH_PAGETYPE_OTHER */.vg,
        pathChain: [],
        brand: null,
        priceData: null,
        placements: [],
        placementsMap: {},
        view: null,
        siteName: "",
        product: []
    };
    switch(action.type){
        case "__DANGEROUS_CONFIG_RECEIVE":
            {
                var sitename = action.market.sitename;
                return ads_reducer_objectSpreadProps(ads_reducer_objectSpread({}, state), {
                    siteName: sitename.replace("\xe9", "e")
                });
            }
        case "CATEGORY_LAYOUT_CHANGED":
            {
                return ads_reducer_objectSpreadProps(ads_reducer_objectSpread({}, state), {
                    view: "category_layout:".concat(action.mode)
                });
            }
        case "ADS_VIEW_UPDATE":
            {
                return ads_reducer_objectSpreadProps(ads_reducer_objectSpread({}, state), {
                    view: action.view
                });
            }
        case "ADS_PATHKEY_UPDATE":
            {
                return ads_reducer_objectSpreadProps(ads_reducer_objectSpread({}, state), {
                    pathKey: action.pathKey
                });
            }
        case "ADS_RECEIVE":
            {
                var placements = action.ads;
                var placementsMap = placements.reduce(function(result, item) {
                    var category = "".concat(item.isVirtual ? "v" : "").concat(item.categoryId);
                    var itemKey = "".concat(item.platform, ":").concat(item.containerName, ":").concat(category);
                    return ads_reducer_objectSpreadProps(ads_reducer_objectSpread({}, result), ads_reducer_defineProperty({}, itemKey, item));
                }, {});
                return ads_reducer_objectSpreadProps(ads_reducer_objectSpread({}, state), {
                    placementsMap: placementsMap
                });
            }
        case "SHOW_FULL_SEARCH_RESULTS":
            {
                var query = action.query, pagingInfo = action.pagingInfo;
                var categoriesOffset = pagingInfo.categoriesOffset, productsOffset = pagingInfo.productsOffset, brandsOffset = pagingInfo.brandsOffset, storesOffset = pagingInfo.storesOffset;
                return ads_reducer_objectSpreadProps(ads_reducer_objectSpread({}, state), {
                    pathKey: "search:".concat(query, ":").concat(categoriesOffset, ":").concat(productsOffset, ":").concat(brandsOffset, ":").concat(storesOffset)
                });
            }
        case "ROUTE_LOADED":
            {
                var data = action.data, errors = action.errors, route = action.route, location = action.location;
                // Bail out if any error occoured
                if (errors || !route) {
                    return state;
                }
                var pageData = {};
                switch(route.name){
                    case "start":
                        pageData = {
                            pageType: pagetype/* PAGETYPE_ROOT */.II,
                            schPageType: pagetype/* SCH_PAGETYPE_FRONT */.UZ
                        };
                        break;
                    case "product":
                        {
                            if (!(data === null || data === void 0 ? void 0 : data.product)) {
                                break;
                            }
                            var product = data.product;
                            var priceData = product.priceSummary && product.priceSummary.regular;
                            var pathChain = product.category && product.category.path.reduce(function(acc, curr) {
                                return acc.concat(curr.id);
                            }, []).concat(product.id);
                            pageData = {
                                pageType: pagetype/* PAGETYPE_PRODUCT */.P,
                                schPageType: pagetype/* SCH_PAGETYPE_OBJECT */.VW,
                                pathChain: pathChain,
                                brand: product.brand,
                                priceData: priceData,
                                view: route.name,
                                product: product
                            };
                            break;
                        }
                    case "productCollection":
                        {
                            if (!(data === null || data === void 0 ? void 0 : data.productCollection)) {
                                break;
                            }
                            var productCollection = data.productCollection;
                            var adsSlice = productCollection.slices.find(function(param) {
                                var __typename = param.__typename;
                                return __typename === "AdsSlice";
                            });
                            var qs = querystring.decode(location && location.search ? location.search.substr(1) : "");
                            var offset = qs.offset || "0";
                            var sort = qs.sort || "";
                            var categoryPath = (adsSlice || {
                                categoryPath: []
                            }).categoryPath;
                            pageData = {
                                pageType: pagetype/* PAGETYPE_CATEGORY */.VV,
                                schPageType: pagetype/* SCH_PAGETYPE_SECTION */.xG,
                                pathChain: categoryPath,
                                pathKey: "".concat((0,dist.getStringQuery)((0,dist.filtersToQueryObject)(productCollection.filters)), ":").concat(offset, ":").concat(sort)
                            };
                            break;
                        }
                    case "keywordLandingPage":
                        {
                            var ref, ref1;
                            var keywordLandingPage = data.keywordLandingPage;
                            var ref2;
                            pageData = {
                                pageType: pagetype/* PAGETYPE_KEYWORD */.BZ,
                                schPageType: pagetype/* SCH_PAGETYPE_SECTION */.xG,
                                pathChain: (ref2 = (ref = keywordLandingPage.parentCategory) === null || ref === void 0 ? void 0 : (ref1 = ref.path) === null || ref1 === void 0 ? void 0 : ref1.map(function(p) {
                                    return p.id;
                                })) !== null && ref2 !== void 0 ? ref2 : []
                            };
                            break;
                        }
                    case "category":
                        {
                            if (!(data === null || data === void 0 ? void 0 : data.category)) {
                                break;
                            }
                            var category = data.category;
                            var pathChain1 = category && category.path.reduce(function(acc, curr) {
                                return acc.concat(curr.id);
                            }, []);
                            if (category.filterId) {
                                pathChain1.push(category.filterId);
                            }
                            pageData = {
                                pageType: pagetype/* PAGETYPE_CATEGORY */.VV,
                                schPageType: pagetype/* SCH_PAGETYPE_SECTION */.xG,
                                pathChain: pathChain1,
                                brand: category.brand
                            };
                            break;
                        }
                    case "campaign":
                        {
                            var qs1 = querystring.decode(location && location.search ? location.search.substr(1) : "");
                            pageData = {
                                pathKey: [
                                    "campaign-page",
                                    "cat:".concat(qs1.category || ""),
                                    "offset:".concat(qs1.offset || ""),
                                    "query:".concat(qs1.query || "")
                                ].join(" "),
                                pathChain: (qs1.category || "").split("|"),
                                pageType: pagetype/* PAGETYPE_CAMPAIGN */.Dy,
                                schPageType: pagetype/* SCH_PAGETYPE_SECTION */.xG
                            };
                            break;
                        }
                    case "store":
                        {
                            pageData = {
                                pageType: pagetype/* PAGETYPE_STORE */.Tf
                            };
                            break;
                        }
                    case "brand":
                        {
                            pageData = {
                                pageType: pagetype/* PAGETYPE_BRAND */.Ms
                            };
                            break;
                        }
                    case "search":
                        {
                            var qs2 = querystring.decode(location && location.search ? location.search.substr(1) : "");
                            var query1 = (data.newSearch || (data === null || data === void 0 ? void 0 : data.search) || {}).query;
                            pageData = {
                                pathKey: "search:".concat(querystring.stringify(qs2, ":")),
                                searchQuery: query1
                            };
                            break;
                        }
                    case "services":
                        {
                            pageData = {
                                pageType: pagetype/* PAGETYPE_CATEGORY */.VV,
                                schPageType: pagetype/* SCH_PAGETYPE_SECTION */.xG,
                                pathChain: [
                                    data.categoryTree[0].id || ""
                                ]
                            };
                            break;
                        }
                    default:
                        pageData = {
                            pageType: pagetype/* PAGETYPE_OTHER */.Tj
                        };
                        break;
                }
                return ads_reducer_objectSpread(ads_reducer_objectSpreadProps(ads_reducer_objectSpread({}, state), {
                    priceData: null,
                    pathChain: [],
                    pathKey: location.key,
                    brand: null
                }), pageData);
            }
        default:
    }
    return state;
};

// EXTERNAL MODULE: ./node_modules/.pnpm/query-string-for-all@6.8.3/node_modules/query-string-for-all/dist/index.js
var query_string_for_all_dist = __webpack_require__(25932);
var query_string_for_all_dist_default = /*#__PURE__*/__webpack_require__.n(query_string_for_all_dist);
// EXTERNAL MODULE: ./src/areas/sidebar/constants.ts
var sidebar_constants = __webpack_require__(28438);
// EXTERNAL MODULE: ./src/areas/sidebar/actions/lists.js
var actions_lists = __webpack_require__(40054);
// EXTERNAL MODULE: ./src/areas/sidebar/actions/filter.js
var actions_filter = __webpack_require__(7966);
;// CONCATENATED MODULE: ./src/areas/sidebar/reducer/index.js
function reducer_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function reducer_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return reducer_arrayLikeToArray(arr);
}
function sidebar_reducer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function reducer_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function reducer_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function sidebar_reducer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            sidebar_reducer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function sidebar_reducer_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function sidebar_reducer_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        sidebar_reducer_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || reducer_unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function reducer_toConsumableArray(arr) {
    return reducer_arrayWithoutHoles(arr) || reducer_iterableToArray(arr) || reducer_unsupportedIterableToArray(arr) || reducer_nonIterableSpread();
}
function reducer_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return reducer_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return reducer_arrayLikeToArray(o, minLen);
}





/* harmony default export */ function sidebar_reducer(state, action) {
    if (!state) {
        return {
            tab: sidebar_constants/* SIDEBAR_STATE.NONE */.$J.NONE,
            previousTab: null,
            error: null,
            pending: false,
            deletedListItems: {},
            deletedLists: {},
            tracking: {},
            alerts: {
                sort: "price_change",
                direction: "desc",
                products: []
            },
            selectedList: null,
            lists: {},
            listRefresh: 0,
            hasFilter: false,
            filterType: null,
            filterGroups: []
        };
    }
    switch(action.type){
        case "__DANGEROUS_CONFIG_RECEIVE":
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    tracking: {
                        settings: action.market.trackingToggles.reduce(function(settings, setting) {
                            return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, settings), sidebar_reducer_defineProperty({}, setting.name, setting.default));
                        }, [])
                    }
                });
            }
        case "SESSION_RECEIVE":
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    tracking: sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state.tracking), {
                        settings: sidebar_reducer_objectSpread({}, state.tracking.settings, Object.keys(action.privacyCookie || {}).reduce(function(settings, curr) {
                            return Object.assign(settings, sidebar_reducer_defineProperty({}, curr, Boolean(action.privacyCookie[curr])));
                        }, {}))
                    }),
                    personalization: {
                        clientId: action.clientId,
                        pulseEnvironmentId: action.pulseEnvironmentId
                    }
                });
            }
        case "USER_RECEIVE":
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    pending: false,
                    alerts: sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state.alerts), {
                        products: action.me && action.me.alertsSummary && action.me.alertsSummary.products || []
                    })
                });
            }
        case "ROUTE_LOADED":
            {
                var ref, ref1;
                var hasFilter = false;
                var filterSlice = null;
                if (action.data && action.data.productCollection) {
                    filterSlice = action.data.productCollection.slices.find(function(slice) {
                        return slice.__typename === "FilterSlice";
                    });
                    hasFilter = !!filterSlice && filterSlice.sections.length > 0;
                }
                if (((ref = action.route) === null || ref === void 0 ? void 0 : ref.name) === "category") {
                    var ref2, ref3;
                    hasFilter = !!((ref2 = action.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.category) === null || ref3 === void 0 ? void 0 : ref3.immediateProducts);
                }
                // Close filter when navigating away from a leaf category page
                if (state.tab === sidebar_constants/* SIDEBAR_STATE.FILTER */.$J.FILTER && !hasFilter) {
                    return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                        tab: sidebar_constants/* SIDEBAR_STATE.NONE */.$J.NONE,
                        hasFilter: false,
                        filterType: null,
                        filterGroups: []
                    });
                }
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    hasFilter: hasFilter,
                    filterType: (ref1 = action.route) === null || ref1 === void 0 ? void 0 : ref1.name,
                    filterGroups: filterSlice ? filterSlice.groups : []
                });
            }
        case "LOCAL_STORAGE_RECEIVE":
            {
                var sidebar = query_string_for_all_dist_default().parse(window.location.search).sidebar;
                // Opens the sidebar with a tab if a user lands on a URL containing
                // a parameter `?sidebar=lists|alerts`.
                var sidebarQueryTab = Object.values(sidebar_constants/* SIDEBAR_STATE */.$J).includes(sidebar) ? sidebar : null;
                var sidebarStateFromLocalStorage = action.localStorageState[sidebar_constants/* SIDEBAR_LOCALSTORAGE_KEY */.yT];
                if (sidebarStateFromLocalStorage) {
                    var ref4 = _slicedToArray(sidebarStateFromLocalStorage.listSort ? sidebarStateFromLocalStorage.listSort.split(":") : [], 2), sort = ref4[0], direction = ref4[1];
                    return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                        lists: sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state.lists), {
                            sort: sort,
                            direction: direction
                        }),
                        tab: sidebarQueryTab || sidebarStateFromLocalStorage.tab
                    });
                }
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    tab: sidebarQueryTab || sidebar_constants/* SIDEBAR_STATE.NONE */.$J.NONE
                });
            }
        case actions_alert/* CLOSE_ALERTS */.Vp:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    tab: sidebar_constants/* SIDEBAR_STATE.NONE */.$J.NONE
                });
            }
        case actions_alert/* OPEN_ALERTS */.VG:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    tab: sidebar_constants/* SIDEBAR_STATE.ALERTS */.$J.ALERTS,
                    previousTab: sidebar_constants/* SIDEBAR_STATE.ALERTS */.$J.ALERTS
                });
            }
        case actions_lists/* CLOSE_LISTS */.GV:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    tab: sidebar_constants/* SIDEBAR_STATE.NONE */.$J.NONE
                });
            }
        case actions_lists/* OPEN_LISTS */.Fc:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    tab: sidebar_constants/* SIDEBAR_STATE.LISTS */.$J.LISTS,
                    previousTab: sidebar_constants/* SIDEBAR_STATE.LISTS */.$J.LISTS
                });
            }
        case actions_filter/* TOGGLE_FILTER */.m:
            {
                if (state.tab === sidebar_constants/* SIDEBAR_STATE.FILTER */.$J.FILTER) {
                    return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                        tab: sidebar_constants/* SIDEBAR_STATE.NONE */.$J.NONE
                    });
                }
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    tab: sidebar_constants/* SIDEBAR_STATE.FILTER */.$J.FILTER,
                    previousTab: sidebar_constants/* SIDEBAR_STATE.FILTER */.$J.FILTER
                });
            }
        case actions_alert/* CREATE_ALERT_SUCCESS */.mx:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    alerts: sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state.alerts), {
                        products: reducer_toConsumableArray(new Set(// Since an alert may already exist on current product with
                        // a different alert ID clear all alerts for this product
                        // and add the newly created alert
                        reducer_toConsumableArray(state.alerts.products.filter(function(alert) {
                            return alert.productId !== action.productId;
                        })).concat([
                            {
                                alertId: action.id,
                                productId: action.productId
                            }
                        ])))
                    })
                });
            }
        case actions_alert/* REMOVE_ALERT_REQUEST */.$x:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    pending: true
                });
            }
        case actions_alert/* RESTORE_ALERT_SUCCESS */.Yo:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    alerts: sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state.alerts), {
                        products: reducer_toConsumableArray(new Set(// Since an alert may already exist on current product with
                        // a different alert ID clear all alerts for this product
                        // and add the newly created alert
                        reducer_toConsumableArray(state.alerts.products.filter(function(alert) {
                            return alert.productId !== action.productId;
                        })).concat([
                            {
                                alertId: action.id,
                                productId: action.productId
                            }
                        ])))
                    })
                });
            }
        case actions_alert/* REMOVE_ALERT_SUCCESS */.$_:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    alerts: sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state.alerts), {
                        products: state.alerts.products.filter(function(param) {
                            var alertId = param.alertId, productId = param.productId;
                            return alertId !== action.id && productId !== action.productId;
                        })
                    })
                });
            }
        case actions_alert/* REMOVE_ALERT_ERROR */.XJ:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    pending: false,
                    error: action.error
                });
            }
        case actions_lists/* SORT_LIST */.Zh:
            {
                var ref5 = _slicedToArray(action.sort.value.split(":"), 2), sort1 = ref5[0], direction1 = ref5[1];
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    lists: sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state.lists), {
                        sort: sort1,
                        direction: direction1
                    })
                });
            }
        case actions_alert/* SORT_ALERTS */.ej:
            {
                var ref6 = _slicedToArray(action.sort.value.split(":"), 2), sort2 = ref6[0], direction2 = ref6[1];
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    alerts: sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state.alerts), {
                        sort: sort2,
                        direction: direction2
                    })
                });
            }
        case actions_lists/* SELECT_LIST */.T3:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    selectedList: action.id
                });
            }
        case actions_lists/* REMOVE_LIST_ITEM_REQUEST */.aF:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    pending: true,
                    deletedListItems: sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state.deletedListItems), sidebar_reducer_defineProperty({}, action.id, "pending"))
                });
            }
        case actions_lists/* RESTORE_LIST_ITEM_SUCCESS */.B3:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    deletedListItems: sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state.deletedListItems), sidebar_reducer_defineProperty({}, action.id, undefined))
                });
            }
        case actions_lists/* REMOVE_LIST_ITEM_SUCCESS */.iw:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    listRefresh: state.listRefresh + 1,
                    deletedListItems: sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state.deletedListItems), sidebar_reducer_defineProperty({}, action.id, action.productId || action.listId)),
                    pending: false
                });
            }
        case actions_lists/* REMOVE_LIST_ITEM_ERROR */.Oz:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    pending: false,
                    deletedListItems: sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state.deletedListItems), sidebar_reducer_defineProperty({}, action.id, undefined))
                });
            }
        case actions_lists/* REMOVE_LIST_REQUEST */.N$:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    pending: true,
                    deletedLists: sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state.deletedLists), sidebar_reducer_defineProperty({}, action.id, "pending"))
                });
            }
        case actions_lists/* RESTORE_LIST_SUCCESS */.gK:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    listRefresh: state.listRefresh + 1,
                    deletedLists: sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state.deletedLists), sidebar_reducer_defineProperty({}, action.id, undefined))
                });
            }
        case actions_lists/* REMOVE_LIST_SUCCESS */.sh:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    listRefresh: state.listRefresh + 1,
                    deletedLists: sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state.deletedLists), sidebar_reducer_defineProperty({}, action.id, true)),
                    pending: false
                });
            }
        case actions_lists/* REMOVE_LIST_ERROR */.Og:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    pending: false,
                    listRefresh: state.listRefresh + 1,
                    deletedLists: sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state.deletedLists), sidebar_reducer_defineProperty({}, action.id, undefined))
                });
            }
        case actions_lists/* CREATE_LIST_SUCCESS */.Kj:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    listRefresh: state.listRefresh + 1
                });
            }
        case actions_lists/* EDIT_LIST_REQUEST */.GB:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    pending: true
                });
            }
        case actions_lists/* EDIT_LIST_SUCCESS */.Ce:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    listRefresh: state.listRefresh + 1
                });
            }
        case actions_lists/* EDIT_LIST_ERROR */.pU:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    pending: false
                });
            }
        case actions_lists/* ADD_LIST_ITEM_SUCCESS */.pd:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    listRefresh: state.listRefresh + 1,
                    deletedListItems: sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state.deletedListItems), // If the product ID has been in the list before, we may get the same
                    // list item ID back, so we must mark it as not deleted.
                    sidebar_reducer_defineProperty({}, action.id, undefined))
                });
            }
        case actions_lists/* ORDER_LISTS_REQUEST */.Po:
            {
                return sidebar_reducer_objectSpread({}, state);
            }
        case actions_lists/* ORDER_LIST_ITEMS_REQUEST */.w:
            {
                return sidebar_reducer_objectSpread({}, state);
            }
        case actions_lists/* IMPORT_LIST_TO_MY_PRODUCTS */.sy:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    pending: true
                });
            }
        case actions_lists/* IMPORT_LIST_TO_MY_PRODUCTS_SUCCESS */.qR:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    pending: false,
                    listRefresh: state.listRefresh + 1
                });
            }
        case actions_lists/* ADD_LIST_ITEM_ERROR */.zD:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    pending: false
                });
            }
        case actions_lists/* OPEN_LIST_SETTINGS */.Od:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    isListSettingsOpen: true
                });
            }
        case actions_lists/* CLOSE_LIST_SETTINGS */.y$:
            {
                return sidebar_reducer_objectSpreadProps(sidebar_reducer_objectSpread({}, state), {
                    isListSettingsOpen: false
                });
            }
        default:
            break;
    }
    return state;
};

// EXTERNAL MODULE: ./src/areas/sidebar/components/sidebar-mobile/actions/index.js
var sidebar_mobile_actions = __webpack_require__(82642);
// EXTERNAL MODULE: ./src/areas/sidebar/components/sidebar-mobile/constants.ts
var sidebar_mobile_constants = __webpack_require__(8818);
;// CONCATENATED MODULE: ./src/areas/sidebar/components/sidebar-mobile/reducers/index.js
function sidebar_mobile_reducers_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function sidebar_mobile_reducers_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            sidebar_mobile_reducers_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function sidebar_mobile_reducers_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function sidebar_mobile_reducers_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        sidebar_mobile_reducers_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/* harmony default export */ function sidebar_mobile_reducers(state, action) {
    if (!state) {
        return {
            currentView: sidebar_mobile_constants/* VIEWS.ROOT */.n.ROOT
        };
    }
    switch(action.type){
        case sidebar_mobile_actions/* SET_MOBILE_SIDEBAR_VIEW */.e:
            return sidebar_mobile_reducers_objectSpreadProps(sidebar_mobile_reducers_objectSpread({}, state), {
                currentView: action.currentView
            });
        default:
            break;
    }
    return state;
};

// EXTERNAL MODULE: ./src/areas/user/actions/tracking.js
var actions_tracking = __webpack_require__(69399);
// EXTERNAL MODULE: ./src/areas/user/actions/personalization.js
var personalization = __webpack_require__(96283);
// EXTERNAL MODULE: ./src/areas/user/storage/personalization.js
var storage_personalization = __webpack_require__(55964);
;// CONCATENATED MODULE: ./src/areas/user/reducer/index.js
function user_reducer_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function user_reducer_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return user_reducer_arrayLikeToArray(arr);
}
function user_reducer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function user_reducer_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function user_reducer_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function user_reducer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            user_reducer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function user_reducer_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function user_reducer_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        user_reducer_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function user_reducer_toConsumableArray(arr) {
    return user_reducer_arrayWithoutHoles(arr) || user_reducer_iterableToArray(arr) || user_reducer_unsupportedIterableToArray(arr) || user_reducer_nonIterableSpread();
}
function user_reducer_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return user_reducer_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return user_reducer_arrayLikeToArray(o, minLen);
}




/* harmony default export */ function user_reducer(state, action) {
    if (!state) {
        return {
            tracking: {}
        };
    }
    switch(action.type){
        case actions/* DANGEROUS_CONFIG_RECEIVE */.R5:
            {
                return user_reducer_objectSpreadProps(user_reducer_objectSpread({}, state), {
                    tracking: {
                        settings: action.market.trackingToggles.reduce(function(settings, setting) {
                            return user_reducer_objectSpreadProps(user_reducer_objectSpread({}, settings), user_reducer_defineProperty({}, setting.name, setting.default));
                        }, [])
                    }
                });
            }
        case actions/* SESSION_RECEIVE */.g8:
            {
                return user_reducer_objectSpreadProps(user_reducer_objectSpread({}, state), {
                    tracking: user_reducer_objectSpreadProps(user_reducer_objectSpread({}, state.tracking), {
                        settings: user_reducer_objectSpread({}, state.tracking.settings, Object.keys(action.privacyCookie || {}).reduce(function(settings, curr) {
                            return Object.assign(settings, user_reducer_defineProperty({}, curr, Boolean(action.privacyCookie[curr])));
                        }, {}))
                    }),
                    personalization: {
                        clientId: action.clientId,
                        pulseEnvironmentId: action.pulseEnvironmentId
                    }
                });
            }
        case actions_tracking/* TRACKING_TOGGLE_CHANGE */.Zm:
            {
                return user_reducer_objectSpreadProps(user_reducer_objectSpread({}, state), {
                    tracking: user_reducer_objectSpreadProps(user_reducer_objectSpread({}, state.tracking), {
                        settings: user_reducer_objectSpreadProps(user_reducer_objectSpread({}, state.tracking.settings), user_reducer_defineProperty({}, action.name, action.active))
                    })
                });
            }
        case actions_tracking/* TRACKING_TOGGLE_SAVE */.fg:
            {
                return user_reducer_objectSpreadProps(user_reducer_objectSpread({}, state), {
                    tracking: user_reducer_objectSpreadProps(user_reducer_objectSpread({}, state.tracking), {
                        settings: user_reducer_objectSpread({}, state.tracking.settings, action.settings),
                        success: true
                    })
                });
            }
        case actions_tracking/* TRACKING_TOGGLE_SAVE_ERROR */._3:
            {
                return user_reducer_objectSpreadProps(user_reducer_objectSpread({}, state), {
                    tracking: user_reducer_objectSpreadProps(user_reducer_objectSpread({}, state.tracking), {
                        error: true
                    })
                });
            }
        case personalization/* REMOVE_INTEREST */.w_:
            {
                var id = action.id;
                var personalizationSettings = (0,storage_personalization/* readPersonalizationSettings */.S)();
                var notInterestedIn = personalizationSettings.notInterestedIn;
                var categories = notInterestedIn.categories;
                (0,storage_personalization/* writePersonalizationSettings */.r)(user_reducer_objectSpreadProps(user_reducer_objectSpread({}, personalizationSettings), {
                    notInterestedIn: user_reducer_objectSpreadProps(user_reducer_objectSpread({}, notInterestedIn), {
                        categories: user_reducer_toConsumableArray(categories).concat([
                            {
                                id: id
                            }
                        ])
                    })
                }));
                return state;
            }
        case personalization/* ADD_INTEREST */.uJ:
            {
                var id1 = action.id;
                var personalizationSettings1 = (0,storage_personalization/* readPersonalizationSettings */.S)();
                var notInterestedIn1 = personalizationSettings1.notInterestedIn;
                var categories1 = notInterestedIn1.categories;
                (0,storage_personalization/* writePersonalizationSettings */.r)(user_reducer_objectSpreadProps(user_reducer_objectSpread({}, personalizationSettings1), {
                    notInterestedIn: user_reducer_objectSpreadProps(user_reducer_objectSpread({}, notInterestedIn1), {
                        categories: categories1.filter(function(category) {
                            return category.id !== id1;
                        })
                    })
                }));
                return state;
            }
        default:
            return state;
    }
};

// EXTERNAL MODULE: ./src/components/modal/actions.ts
var modal_actions = __webpack_require__(66571);
;// CONCATENATED MODULE: ./src/components/modal/reducer.ts
function modal_reducer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function modal_reducer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            modal_reducer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function modal_reducer_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function modal_reducer_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        modal_reducer_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var reducer_initialState = {
    current: undefined
};
/* harmony default export */ function modal_reducer() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : reducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    if (!state) {
        return {
            current: undefined
        };
    }
    switch(action.type){
        case modal_actions/* HIDE_MODAL */._D:
        case modal_actions/* SHOW_MODAL */.Hn:
            {
                var modal = action.modal;
                return modal_reducer_objectSpreadProps(modal_reducer_objectSpread({}, state), {
                    current: modal || undefined
                });
            }
        default:
            break;
    }
    return state;
};

// EXTERNAL MODULE: ./src/areas/reviews/actions/index.js
var reviews_actions = __webpack_require__(16288);
;// CONCATENATED MODULE: ./src/areas/reviews/reducers/index.js
function reviews_reducers_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function reviews_reducers_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            reviews_reducers_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function reviews_reducers_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function reviews_reducers_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        reviews_reducers_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var DEFAULT_PAGE_INFO = {
    offset: 0,
    limit: 15
};
/* harmony default export */ function reviews_reducers(state, action) {
    if (!state) {
        return {
            pendingRequest: false,
            requestError: null,
            pageInfo: {
                store: DEFAULT_PAGE_INFO,
                product: DEFAULT_PAGE_INFO,
                profile: DEFAULT_PAGE_INFO
            },
            updatedReviews: null,
            updatedSummary: null,
            drafts: null,
            dialog: {
                openId: null
            },
            thankYouDialog: {
                openId: null
            }
        };
    }
    switch(action.type){
        case reviews_actions/* CREATE_REVIEW */.l3:
            return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                pendingRequest: {
                    type: "create"
                },
                requestError: null
            });
        case reviews_actions/* EDIT_REVIEW */.hy:
            return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                pendingRequest: {
                    type: "edit"
                },
                requestError: null
            });
        case reviews_actions/* DELETE_REVIEW */.y$:
            return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                pendingRequest: {
                    type: "delete"
                },
                requestError: null
            });
        case reviews_actions/* CREATE_REVIEW_SUCCESS */.bg:
            return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                pendingRequest: false
            });
        case reviews_actions/* CREATE_SHOP_REVIEW */.mb:
            return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                pendingRequest: true,
                requestError: null
            });
        case reviews_actions/* CREATE_SHOP_REVIEW_SUCCESS */.eA:
            return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                pendingRequest: false,
                thankYouDialog: {
                    openId: state.dialog.openId
                },
                dialog: {
                    openId: null
                }
            });
        case reviews_actions/* EDIT_SHOP_REVIEW */.CA:
            return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                pendingRequest: true,
                requestError: null
            });
        case reviews_actions/* EDIT_SHOP_REVIEW_SUCCESS */.s6:
            return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                pendingRequest: false,
                dialog: {
                    openId: null
                }
            });
        case reviews_actions/* DELETE_SHOP_REVIEW */.Bs:
            return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                pendingRequest: true,
                requestError: null
            });
        case reviews_actions/* DELETE_SHOP_REVIEW_SUCCESS */.UW:
            {
                var drafts = state.drafts;
                // Delete drafts for the review and shop when deleting a review
                if (drafts && drafts[action.reviewId]) delete drafts[action.reviewId];
                if (drafts && drafts[action.shopId]) delete drafts[action.shopId];
                return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                    pendingRequest: false,
                    dialog: {
                        openId: null
                    },
                    drafts: drafts
                });
            }
        case reviews_actions/* HIDE_SHOP_REVIEW_THANK_YOU */.DT:
            return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                thankYouDialog: {
                    openId: null
                }
            });
        case reviews_actions/* EDIT_REVIEW_SUCCESS */.cO:
            return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                pendingRequest: false
            });
        case reviews_actions/* DELETE_REVIEW_SUCCESS */.g6:
            return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                pendingRequest: false
            });
        case reviews_actions/* UPDATE_REVIEW_DATA */.e1:
            return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                updatedReviews: {
                    shopId: action.shopId,
                    productId: action.productId,
                    nodes: action.nodes,
                    myReview: action.myReview
                }
            });
        case reviews_actions/* UPDATE_REVIEW_SUMMARY */.zM:
            return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                updatedSummary: action.summary
            });
        case reviews_actions/* OPEN_REVIEW_DIALOG */.b3:
            return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                dialog: {
                    openId: action.uid
                },
                requestError: null
            });
        case reviews_actions/* CLOSE_REVIEW_DIALOG */.TF:
            return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                dialog: {
                    openId: null
                },
                requestError: null
            });
        case reviews_actions/* REVIEW_REQUEST_ERROR */.u9:
            return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                requestError: action.errorCode,
                pendingRequest: false
            });
        case reviews_actions/* LIKE_REVIEW_TOGGLE */.vH:
            return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                pendingRequest: true
            });
        case reviews_actions/* LIKE_REVIEW_SUCCESS */.UY:
            return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                pendingRequest: false
            });
        case reviews_actions/* LIKE_REVIEW_FAILED */.RL:
            return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                pendingRequest: false
            });
        case reviews_actions/* SAVE_REVIEW_DRAFT */.Hg:
            {
                var newDrafts = reviews_reducers_objectSpread({}, state.drafts, action.draft);
                return reviews_reducers_objectSpreadProps(reviews_reducers_objectSpread({}, state), {
                    drafts: newDrafts
                });
            }
        default:
    }
    return state;
};

// EXTERNAL MODULE: ./src/areas/product-collection/actions/index.ts
var product_collection_actions = __webpack_require__(95388);
// EXTERNAL MODULE: ./src/components/recently-visited/actions.ts
var recently_visited_actions = __webpack_require__(35527);
;// CONCATENATED MODULE: ./src/components/recently-visited/storage.ts
var LOCAL_STORAGE_KEY = "recentlyVisited";
var withLocalStorage = function(cb) {
    try {
        if ( false || !window.localStorage) {
            // There is no localStorage on the server, and localStorage can be null if
            // disabled in the browser.
            return null;
        }
        return cb(window.localStorage);
    } catch (e) {
        // localStorage may throw an exception when disabled; just ignore it.
        if (false) {}
    }
    return null;
};
var readRecentlyVisited = function() {
    var jsonString = withLocalStorage(function(localStorage) {
        return localStorage.getItem(LOCAL_STORAGE_KEY);
    });
    if (!jsonString) {
        return [];
    }
    try {
        var data = JSON.parse(jsonString);
        return data && Array.isArray(data) ? data : [];
    } catch (e) {
        if (false) {}
        return [];
    }
};
var writeRecentlyVisited = function(data) {
    var jsonString = JSON.stringify(data);
    withLocalStorage(function(localStorage) {
        localStorage.setItem(LOCAL_STORAGE_KEY, jsonString);
    });
};
var deleteRecentlyVisited = function() {
    withLocalStorage(function(localStorage) {
        localStorage.removeItem(LOCAL_STORAGE_KEY);
    });
};

;// CONCATENATED MODULE: ./src/components/recently-visited/reducer.ts
function recently_visited_reducer_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function recently_visited_reducer_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return recently_visited_reducer_arrayLikeToArray(arr);
}
function recently_visited_reducer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function recently_visited_reducer_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function recently_visited_reducer_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function recently_visited_reducer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            recently_visited_reducer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function recently_visited_reducer_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function recently_visited_reducer_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        recently_visited_reducer_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function recently_visited_reducer_toConsumableArray(arr) {
    return recently_visited_reducer_arrayWithoutHoles(arr) || recently_visited_reducer_iterableToArray(arr) || recently_visited_reducer_unsupportedIterableToArray(arr) || recently_visited_reducer_nonIterableSpread();
}
function recently_visited_reducer_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return recently_visited_reducer_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return recently_visited_reducer_arrayLikeToArray(o, minLen);
}





var MAX_ITEMS = 100;
/* harmony default export */ function recently_visited_reducer() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        trackingEnabled: undefined,
        items: [],
        loaded: false
    }, action = arguments.length > 1 ? arguments[1] : void 0;
    if (!state) {
        return {
            trackingEnabled: undefined,
            loaded: false,
            items: []
        };
    }
    switch(action.type){
        case recently_visited_actions/* LOAD_RECENTLY_VISITED */.Bx:
            {
                return recently_visited_reducer_objectSpreadProps(recently_visited_reducer_objectSpread({}, state), {
                    loaded: true,
                    items: readRecentlyVisited()
                });
            }
        case "__DANGEROUS_CONFIG_RECEIVE":
            {
                var ref;
                return recently_visited_reducer_objectSpreadProps(recently_visited_reducer_objectSpread({}, state), {
                    trackingEnabled: (ref = action.market.trackingToggles.find(function(t) {
                        return t.name === "personalization";
                    })) === null || ref === void 0 ? void 0 : ref.default
                });
            }
        case "SESSION_RECEIVE":
            {
                if (action.privacyCookie.personalization === undefined) {
                    return state;
                }
                return recently_visited_reducer_objectSpreadProps(recently_visited_reducer_objectSpread({}, state), {
                    trackingEnabled: !!action.privacyCookie.personalization
                });
            }
        case actions_tracking/* TRACKING_TOGGLE_SAVE */.fg:
            {
                if (!action.settings.personalization) {
                    deleteRecentlyVisited();
                }
                break;
            }
        case product_collection_actions/* UPDATE_PRODUCT_COLLECTION_FILTERS */.On:
            {
                var newUrl = action.filters.reduce(function(url, filter) {
                    return (0,dist.addFilterToUrl)(url, filter);
                }, location.pathname);
                var readItems = readRecentlyVisited();
                var recentlyVisitedProductCollection = readItems.find(function(item) {
                    return item.id === action.id;
                });
                if (!recentlyVisitedProductCollection) break;
                recentlyVisitedProductCollection.url = newUrl;
                var newItems = [
                    recentlyVisitedProductCollection
                ].concat(recently_visited_reducer_toConsumableArray(readItems.filter(function(item) {
                    return item.id !== action.id;
                })));
                writeRecentlyVisited(newItems);
                return recently_visited_reducer_objectSpreadProps(recently_visited_reducer_objectSpread({}, state), {
                    items: newItems
                });
            }
        case "ROUTE_LOADED":
            {
                if (!action.route || !state.trackingEnabled || ![
                    "product",
                    "productCollection"
                ].includes(action.route.name) || !action.data) {
                    break;
                }
                var readItems1 = readRecentlyVisited();
                var newItem = createRecentlyVisited(action.data);
                if (!newItem) break;
                var newItems1 = [
                    newItem
                ].concat(recently_visited_reducer_toConsumableArray(readItems1.filter(function(item) {
                    if (newItem.type !== item.type) return item;
                    if ("id" in item && "id" in newItem) return item.id !== newItem.id;
                    if ("slug" in item && "slug" in newItem) return item.slug !== newItem.slug;
                    return false;
                }))).slice(0, MAX_ITEMS);
                writeRecentlyVisited(newItems1);
                return recently_visited_reducer_objectSpreadProps(recently_visited_reducer_objectSpread({}, state), {
                    items: newItems1
                });
            }
        case recently_visited_actions/* REMOVE_RECENTLY_VISITED_ITEM */.QN:
            {
                var readItems2 = readRecentlyVisited();
                var newItems2 = readItems2.filter(function(item) {
                    return item.id !== action.id;
                });
                writeRecentlyVisited(newItems2);
                return recently_visited_reducer_objectSpreadProps(recently_visited_reducer_objectSpread({}, state), {
                    items: newItems2
                });
            }
        default:
            break;
    }
    return state;
};
function createRecentlyVisited(data) {
    var date = Date.now();
    if ("product" in data && data.product) {
        return {
            type: "product",
            date: date,
            id: data.product.id
        };
    }
    if ("productCollection" in data && data.productCollection) {
        return {
            type: "productCollection",
            date: date,
            id: data.productCollection.id,
            slug: data.productCollection.slug,
            url: data.productCollection.url
        };
    }
    return null;
}

// EXTERNAL MODULE: ./src/components/toast-container/actions/index.ts
var toast_container_actions = __webpack_require__(88278);
;// CONCATENATED MODULE: ./src/components/toast-container/reducers/index.ts

/* harmony default export */ function toast_container_reducers(state, action) {
    if (!state) {
        return {
            required: false
        };
    }
    switch(action.type){
        case toast_container_actions/* TOAST_REQUIRED */.xy:
            return {
                required: action.required
            };
        default:
            break;
    }
    return state;
};

// EXTERNAL MODULE: ./src/areas/product-compare/actions/index.ts
var product_compare_actions = __webpack_require__(73050);
;// CONCATENATED MODULE: ./src/areas/product-compare/reducers/index.ts
function product_compare_reducers_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function product_compare_reducers_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            product_compare_reducers_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function product_compare_reducers_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function product_compare_reducers_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        product_compare_reducers_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var product_compare_reducers_initialState = {
    showSearchInput: false,
    shouldAnimate: false
};
function product_compare_reducers_reducer() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : product_compare_reducers_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    if (!state) {
        return product_compare_reducers_objectSpread({}, product_compare_reducers_initialState);
    }
    switch(action.type){
        case product_compare_actions/* TOGGLE_SEARCH_INPUT */.fo:
            {
                return product_compare_reducers_objectSpreadProps(product_compare_reducers_objectSpread({}, state), {
                    showSearchInput: !state.showSearchInput
                });
            }
        case product_compare_actions/* SET_ADD_PRODUCT_ANIMATION */.nd:
            {
                return product_compare_reducers_objectSpreadProps(product_compare_reducers_objectSpread({}, state), {
                    shouldAnimate: action.state
                });
            }
        default:
    }
    return state;
}

// EXTERNAL MODULE: ./src/components/layout-buttons/types.ts
var layout_buttons_types = __webpack_require__(8458);
// EXTERNAL MODULE: ./src/areas/product-collection/constants/index.js
var product_collection_constants = __webpack_require__(46294);
;// CONCATENATED MODULE: ./src/areas/product-collection/reducers/redux-actions.ts
function redux_actions_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function redux_actions_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            redux_actions_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function redux_actions_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function redux_actions_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        redux_actions_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



var productCollectionReduxReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case "ROUTE_LOADED":
            {
                return redux_actions_objectSpread({}, state);
            }
        case product_collection_actions/* SET_PRODUCT_COLLECTION_LAYOUT */.$3:
            return redux_actions_objectSpreadProps(redux_actions_objectSpread({}, state), {
                userSelectedLayout: action.layout
            });
        case "LOCAL_STORAGE_RECEIVE":
            {
                var productCollectionLayoutFromLocalStorage = action.localStorageState[product_collection_constants/* PRODUCT_COLLECTION_LAYOUT */.x];
                return redux_actions_objectSpreadProps(redux_actions_objectSpread({}, state), {
                    userSelectedLayout: typeof productCollectionLayoutFromLocalStorage !== "undefined" && // Don't set `userSelectedLayout` if localStorage contains a faulty or removed value
                    Object.values(layout_buttons_types/* LayoutMode */.X).includes(productCollectionLayoutFromLocalStorage) ? productCollectionLayoutFromLocalStorage : undefined
                });
            }
        default:
            break;
    }
    return state;
};

// EXTERNAL MODULE: ./src/components/co-branding-banner/constants.ts
var co_branding_banner_constants = __webpack_require__(45766);
;// CONCATENATED MODULE: ./src/components/co-branding-banner/reducer.ts
function co_branding_banner_reducer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function co_branding_banner_reducer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            co_branding_banner_reducer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function co_branding_banner_reducer_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function co_branding_banner_reducer_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        co_branding_banner_reducer_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var co_branding_banner_reducer_initialState = {
    isActive: false,
    lastAcknowledged: undefined
};
/* harmony default export */ function co_branding_banner_reducer() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : co_branding_banner_reducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case "LOCAL_STORAGE_RECEIVE":
            return co_branding_banner_reducer_objectSpread({}, state, action.localStorageState[co_branding_banner_constants/* CO_BRANDING_BANNER_LOCALSTORAGE_STATE_KEY */.s]);
        case "SESSION_RECEIVE":
            return co_branding_banner_reducer_objectSpreadProps(co_branding_banner_reducer_objectSpread({}, state), {
                isActive: true
            });
        case "ACKNOWLEDGE_CO_BRANDING_BANNER":
        case "ACCEPT_COOKIES":
            return co_branding_banner_reducer_objectSpreadProps(co_branding_banner_reducer_objectSpread({}, state), {
                lastAcknowledged: Date.now()
            });
        default:
            return state;
    }
};

// EXTERNAL MODULE: ./src/areas/public-list/actions/index.ts
var public_list_actions = __webpack_require__(97372);
;// CONCATENATED MODULE: ./src/areas/public-list/reducers/index.ts
function public_list_reducers_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function public_list_reducers_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            public_list_reducers_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function public_list_reducers_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function public_list_reducers_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        public_list_reducers_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

function publicListReducer(state, action) {
    if (!state) {
        return {
            openShareId: null
        };
    }
    switch(action.type){
        case public_list_actions/* TOGGLE_LIST_SHARE */.w:
            {
                return public_list_reducers_objectSpreadProps(public_list_reducers_objectSpread({}, state), {
                    openShareId: !state.openShareId ? action.uid : null
                });
            }
        default:
            return state;
    }
}

;// CONCATENATED MODULE: ./src/areas/changelog/reducers/index.ts
function changelog_reducers_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function changelog_reducers_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            changelog_reducers_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function changelog_reducers_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function changelog_reducers_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        changelog_reducers_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var changelog_reducers_initialState = {
    articles: [],
    isOpen: false
};
function changelog_reducers_reducer() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : changelog_reducers_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    if (!state) {
        return changelog_reducers_objectSpread({}, changelog_reducers_initialState);
    }
    switch(action.type){
        case "CHANGELOG_RECEIVE":
            {
                return changelog_reducers_objectSpreadProps(changelog_reducers_objectSpread({}, state), {
                    articles: action.articles
                });
            }
        case "CHANGELOG_TOGGLE":
            {
                return changelog_reducers_objectSpreadProps(changelog_reducers_objectSpread({}, state), {
                    isOpen: !state.isOpen
                });
            }
        case "CHANGELOG_CLOSE":
            {
                return changelog_reducers_objectSpreadProps(changelog_reducers_objectSpread({}, state), {
                    isOpen: false
                });
            }
        default:
    }
    return state;
}

// EXTERNAL MODULE: ./src/areas/search/actions/search.js
var actions_search = __webpack_require__(30400);
;// CONCATENATED MODULE: ./src/areas/search/reducers/index.ts
function search_reducers_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function search_reducers_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            search_reducers_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function search_reducers_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function search_reducers_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        search_reducers_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var search_reducers_initialState = {
    focused: false,
    visibleInHero: false
};
function search_reducers_reducer() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : search_reducers_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    if (!state) {
        return search_reducers_objectSpread({}, search_reducers_initialState);
    }
    switch(action.type){
        case "SEARCH_FOCUS":
            {
                return search_reducers_objectSpreadProps(search_reducers_objectSpread({}, state), {
                    focused: true
                });
            }
        case "SEARCH_BLUR":
            {
                return search_reducers_objectSpreadProps(search_reducers_objectSpread({}, state), {
                    focused: false
                });
            }
        case actions_search/* SET_SEARCH_BAR_IN_HERO */.SL:
            {
                return search_reducers_objectSpreadProps(search_reducers_objectSpread({}, state), {
                    visibleInHero: action.state
                });
            }
        default:
    }
    return state;
}

;// CONCATENATED MODULE: ./src/reducers.ts
























var areas = (0,redux.combineReducers)({
    product: product_reducer,
    productAlert: product_alert_reducers,
    category: category_reducers,
    account: account_reducers,
    navigation: navigation_reducers,
    campaign: campaign_reducers,
    sidebar: sidebar_reducer,
    mobileSidebar: sidebar_mobile_reducers,
    productCollection: productCollectionReduxReducer,
    user: user_reducer,
    review: reviews_reducers,
    compare: product_compare_reducers_reducer,
    publicList: publicListReducer,
    changelog: changelog_reducers_reducer,
    search: search_reducers_reducer
});
var rootReducer = (0,redux.combineReducers)({
    globals: reducers,
    feedback: feedback_reducers,
    areas: areas,
    footer: reducers_reducer,
    ads: ads_reducer,
    modal: modal_reducer,
    recentlyVisited: recently_visited_reducer,
    toast: toast_container_reducers,
    coBrandingBanner: co_branding_banner_reducer
});
/* harmony default export */ const src_reducers = (rootReducer);

// EXTERNAL MODULE: ./node_modules/.pnpm/redux-saga@1.0.3/node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js + 1 modules
var redux_saga_effects_npm_proxy_esm = __webpack_require__(38247);
// EXTERNAL MODULE: ./node_modules/.pnpm/no-scroll@2.1.1/node_modules/no-scroll/index.js
var no_scroll = __webpack_require__(4291);
var no_scroll_default = /*#__PURE__*/__webpack_require__.n(no_scroll);
// EXTERNAL MODULE: ./src/areas/campaign/actions/index.js
var campaign_actions = __webpack_require__(14752);
;// CONCATENATED MODULE: ./src/globals/sagas/scroll-lock.js
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};


/**
 * This scroll lock is mainly for IOS Safari where background is scrollable
 * even if the overflow hidden strategy is used on background content, causing
 * broken UI is some cases.
 *
 * The elastic band functionality will make the content behind be shown
 * in the bottom portion of the phone when the menu slides away.
 */ 



function scrollLockOn() {
    return __generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    no_scroll_default().on()
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
function scrollLockOff() {
    return __generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    no_scroll_default().off()
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
function scrollLockSaga() {
    return __generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(mobile_menu/* OPEN_MOBILE_MENU */.QU, scrollLockOn)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(mobile_menu/* CLOSE_MOBILE_MENU */.l2, scrollLockOff)
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(feedback_actions/* FEEDBACK_OPEN */.hy, scrollLockOn)
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(feedback_actions/* FEEDBACK_CLOSE */._d, scrollLockOff)
                ];
            case 4:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(reviews_actions/* OPEN_REVIEW_DIALOG */.b3, scrollLockOn)
                ];
            case 5:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(reviews_actions/* CLOSE_REVIEW_DIALOG */.TF, scrollLockOff)
                ];
            case 6:
                _state.sent();
                // We release the lock on new route load (campaign query for campaign page)
                // events to handle back actions and other unexpected page changes where the
                // user might not be able to go through the regular close path of
                // modals | menus | dialogs.
                // This might result in the scroll lock being released even if the
                // menu is still open when doing stuff like hitting the back button
                // (because of SPA). But its better than the other way around: the
                // main content being non-scrollable.
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)("ROUTE_LOADED", scrollLockOff)
                ];
            case 7:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(campaign_actions/* CAMPAIGN_QUERY */.Ru, scrollLockOff)
                ];
            case 8:
                _state.sent();
                return [
                    2
                ];
        }
    });
}

;// CONCATENATED MODULE: ./src/globals/sagas/index.js
var sagas_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};




function sortChange(action) {
    var qs, sort, direction, url, historyFunc;
    return sagas_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                qs = querystring.decode(window.location.search.substr(1));
                sort = action.data.value.replace(/:(asc|desc)$/, "");
                direction = action.data.value.match(/:(asc|desc)$/);
                qs.sort = sort;
                qs.direction = direction && direction[1];
                if (!direction) {
                    delete qs.direction;
                }
                delete qs.offset;
                url = window.location.pathname + (Object.keys(qs).length > 0 ? "?".concat(querystring.encode(qs)) : "");
                historyFunc = action.data.replaceHistory ? window.__history.replace : window.__history.push;
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(historyFunc, url)
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
function mySaga() {
    return sagas_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(actions/* SORT_CHANGE */.NH, sortChange)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* fork */.rM)(scrollLockSaga)
                ];
            case 2:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
/* harmony default export */ const sagas = (mySaga);

// EXTERNAL MODULE: ./src/globals/api/requests.js
var requests = __webpack_require__(11124);
// EXTERNAL MODULE: ./src/areas/account/helpers/index.ts
var helpers = __webpack_require__(56699);
;// CONCATENATED MODULE: ./src/areas/feedback/sagas/index.js
var feedback_sagas_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};




function sendFeedback(param) {
    var message, response, e;
    return feedback_sagas_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                message = param.message;
                if (!(!message.email || !(0,helpers/* isValidEmail */.vV)(message.email))) return [
                    3,
                    2
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,feedback_actions/* sendFailed */.I0)("error.missing.email"))
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
            case 2:
                if (!!message.message) return [
                    3,
                    4
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,feedback_actions/* sendFailed */.I0)("error.missing.message"))
                ];
            case 3:
                _state.sent();
                return [
                    2
                ];
            case 4:
                _state.trys.push([
                    4,
                    14,
                    ,
                    16
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* postFeedback */.qr, message)
                ];
            case 5:
                response = _state.sent();
                if (!(response.errors && response.errors.length)) return [
                    3,
                    7
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,feedback_actions/* sendFailed */.I0)(response.errors[0].message))
                ];
            case 6:
                _state.sent();
                return [
                    3,
                    13
                ];
            case 7:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,feedback_actions/* sendSuccess */.Wr)())
                ];
            case 8:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* putSession */.hO, "email", message.email)
                ];
            case 9:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* delay */.gw)(1500)
                ];
            case 10:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,feedback_actions/* clearForm */.ou)())
                ];
            case 11:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(feedback_actions/* default.close */.ZP.close())
                ];
            case 12:
                _state.sent();
                _state.label = 13;
            case 13:
                return [
                    3,
                    16
                ];
            case 14:
                e = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,feedback_actions/* sendFailed */.I0)(e.message))
                ];
            case 15:
                _state.sent();
                return [
                    3,
                    16
                ];
            case 16:
                return [
                    2
                ];
        }
    });
}
function sagas_mySaga() {
    return feedback_sagas_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)("FEEDBACK_SEND_REQUEST", sendFeedback)
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
/* harmony default export */ const feedback_sagas = (sagas_mySaga);

;// CONCATENATED MODULE: ./src/components/cookie-banner/sagas/index.js
var cookie_banner_sagas_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};



function addCookie(param) {
    var version, privacySettings, isLoggedIn, showSuccessPrompt, ref;
    return cookie_banner_sagas_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                version = param.version, privacySettings = param.privacySettings, isLoggedIn = param.isLoggedIn, showSuccessPrompt = param.showSuccessPrompt;
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* putSession */.hO, "cookie_consent_version", version)
                ];
            case 1:
                _state.sent();
                if (!privacySettings) return [
                    3,
                    3
                ];
                (ref = document.getElementById("root-cookiebanner")) === null || ref === void 0 ? void 0 : ref.remove();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(actions_tracking/* default.trackingToggleSave */.ZP.trackingToggleSave(privacySettings, isLoggedIn, showSuccessPrompt))
                ];
            case 2:
                _state.sent();
                _state.label = 3;
            case 3:
                return [
                    2
                ];
        }
    });
}
function cookie_banner_sagas_mySaga() {
    return cookie_banner_sagas_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)("ACCEPT_COOKIES", addCookie)
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
/* harmony default export */ const cookie_banner_sagas = (cookie_banner_sagas_mySaga);

// EXTERNAL MODULE: ./src/client/sentry.ts
var sentry = __webpack_require__(99757);
;// CONCATENATED MODULE: ./src/areas/sidebar/sagas/create-alert.js
var create_alert_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};







function getNotificationTranslationKey(notifyBy) {
    if (notifyBy.email && notifyBy.push) {
        return "alert.saved.email_push";
    }
    if (notifyBy.email) {
        return "alert.saved.email";
    }
    if (notifyBy.push) {
        return "alert.saved.push";
    }
    return "alert.saved";
}
function createAlert(productId, options) {
    return (0,requests/* graphql */.BX)("\n      mutation alertCreate($productId: Int!, $options: AlertCreateOptions) {\n        alertCreate(productId: $productId, options: $options) {\n          id\n          priceThreshold\n          priceStep\n          storePreference\n          storeGradeThreshold\n          alertType\n          notifyBy {\n            email\n            push\n          }\n          product {\n            id\n            pathName\n          }\n        }\n      }\n    ", {
        productId: productId,
        options: options
    });
}
function updateAlert(alertId, options) {
    return (0,requests/* graphql */.BX)("\n      mutation alertEdit($alertId: Int!, $options: AlertCreateOptions) {\n        alertCreate: alertEdit(alertId: $alertId, options: $options) {\n          id\n          priceThreshold\n          priceStep\n          storePreference\n          storeGradeThreshold\n          alertType\n          notifyBy {\n            email\n            push\n          }\n          product {\n            id\n            pathName\n          }\n        }\n      }\n    ", {
        alertId: alertId,
        options: options
    });
}
function createAlertRequest(param) {
    var data, onSuccess, alertId, productId, email, priceThreshold, tab, isAuthenticated, options, response, _tmp, ref, e;
    return create_alert_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                data = param.data, onSuccess = param.onSuccess;
                alertId = data.alertId, productId = data.productId, email = data.email, priceThreshold = data.priceThreshold;
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(function(state) {
                        return state.areas.sidebar;
                    })
                ];
            case 1:
                tab = _state.sent().tab;
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(function(state) {
                        return state.areas.account;
                    })
                ];
            case 2:
                isAuthenticated = _state.sent().isAuthenticated;
                if (!(!productId && !alertId)) return [
                    3,
                    4
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_alert/* createAlertFailed */.fZ)("error.productId.invalid"))
                ];
            case 3:
                _state.sent();
                return [
                    2
                ];
            case 4:
                if (!(email !== undefined && !(0,helpers/* isValidEmail */.vV)(email))) return [
                    3,
                    6
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_alert/* createAlertFailed */.fZ)("alert.invalid-email"))
                ];
            case 5:
                _state.sent();
                return [
                    2
                ];
            case 6:
                options = data;
                delete options.productId;
                delete options.alertId;
                options.priceThreshold = parseFloat(priceThreshold || 0);
                _state.label = 7;
            case 7:
                _state.trys.push([
                    7,
                    20,
                    ,
                    23
                ]);
                if (!(isAuthenticated && alertId)) return [
                    3,
                    9
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(updateAlert, alertId, options)
                ];
            case 8:
                _tmp = _state.sent();
                return [
                    3,
                    11
                ];
            case 9:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(createAlert, productId, options)
                ];
            case 10:
                _tmp = _state.sent();
                _state.label = 11;
            case 11:
                response = _tmp;
                if (!(response.errors && response.errors.length)) return [
                    3,
                    13
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_alert/* createAlertFailed */.fZ)((ref = response.errors[0].extensions) === null || ref === void 0 ? void 0 : ref.code))
                ];
            case 12:
                _state.sent();
                return [
                    3,
                    19
                ];
            case 13:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_alert/* createAlertSuccess */.w4)(response.data.alertCreate.id, response.data.alertCreate.product.id))
                ];
            case 14:
                _state.sent();
                if (!onSuccess) return [
                    3,
                    16
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(onSuccess)
                ];
            case 15:
                _state.sent();
                _state.label = 16;
            case 16:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,toast_container_actions/* promptToast */.Lf)("success", window.APP_GLOBALS.t("product", getNotificationTranslationKey(response.data.alertCreate.notifyBy)), {
                        toastId: productId
                    }))
                ];
            case 17:
                _state.sent();
                if (!(isAuthenticated && tab !== sidebar_constants/* SIDEBAR_STATE.ALERTS */.$J.ALERTS)) return [
                    3,
                    19
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_alert/* openAlerts */.SU)())
                ];
            case 18:
                _state.sent();
                _state.label = 19;
            case 19:
                return [
                    3,
                    23
                ];
            case 20:
                e = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, e)
                ];
            case 21:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_alert/* createAlertFailed */.fZ)(e.message))
                ];
            case 22:
                _state.sent();
                return [
                    3,
                    23
                ];
            case 23:
                return [
                    2
                ];
        }
    });
}
function create_alert_mySaga() {
    return create_alert_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeEvery */.ib)(actions_alert/* CREATE_ALERT_REQUEST */.Oi, createAlertRequest)
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
/* harmony default export */ const create_alert = (create_alert_mySaga);

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 24 modules
var es = __webpack_require__(95939);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./src/components/button/index.tsx + 1 modules
var components_button = __webpack_require__(38828);
;// CONCATENATED MODULE: ./src/areas/sidebar/undo.js





var Undo = function(param) {
    var undo = param.undo, dispatch = param.dispatch;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var handleClick = (0,react.useCallback)(function() {
        return dispatch(undo);
    }, [
        undo,
        dispatch
    ]);
    return /*#__PURE__*/ react.createElement(components_button/* Button */.z, {
        variant: "link",
        color: "positive",
        onClick: handleClick
    }, t("common", "button.undo"));
};
Undo.propTypes = {
    undo: prop_types_default().shape({
        type: (prop_types_default()).string,
        restoreToken: (prop_types_default()).string,
        id: (prop_types_default()).number
    }).isRequired,
    dispatch: (prop_types_default()).func.isRequired
};
/* harmony default export */ const undo = ((0,es/* connect */.$j)()(/*#__PURE__*/ (0,react.memo)(Undo)));

;// CONCATENATED MODULE: ./src/areas/sidebar/sagas/remove-alert.js
var remove_alert_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};







function removeAlertRequest(param) {
    var id, productId, onSuccess, response, restoreToken, err;
    return remove_alert_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                id = param.id, productId = param.productId, onSuccess = param.onSuccess;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    9,
                    ,
                    12
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, "mutation alertDelete($id: Int!) {\n        alertDelete(id: $id) {\n          restoreToken\n        }\n      }", {
                        id: id
                    })
                ];
            case 2:
                response = _state.sent();
                if (!response.errors) return [
                    3,
                    4
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_alert/* removeAlertError */.TI)(response.errors[0]))
                ];
            case 3:
                _state.sent();
                return [
                    2
                ];
            case 4:
                restoreToken = response.data.alertDelete.restoreToken;
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_alert/* removeAlertSuccess */._X)(restoreToken, id, productId))
                ];
            case 5:
                _state.sent();
                if (!onSuccess) return [
                    3,
                    7
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(onSuccess)
                ];
            case 6:
                _state.sent();
                _state.label = 7;
            case 7:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,toast_container_actions/* promptToast */.Lf)("success", /*#__PURE__*/ react.createElement(react.Fragment, null, window.APP_GLOBALS.t("alerts", "confirm.alert-deleted"), /*#__PURE__*/ react.createElement(undo, {
                        undo: (0,actions_alert/* restoreAlertRequest */.th)(restoreToken, id, productId)
                    })), {
                        toastId: productId
                    }))
                ];
            case 8:
                _state.sent();
                return [
                    3,
                    12
                ];
            case 9:
                err = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, err)
                ];
            case 10:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_alert/* removeAlertError */.TI)(err))
                ];
            case 11:
                _state.sent();
                return [
                    3,
                    12
                ];
            case 12:
                return [
                    2
                ];
        }
    });
}
function restoreAlertRequest(param) {
    var restoreToken, id, productId, response, err;
    return remove_alert_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                restoreToken = param.restoreToken, id = param.id, productId = param.productId;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    7,
                    ,
                    10
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, "mutation restoreItem($token: String!) {\n        restoreItem(token: $token) {\n          success\n        }\n      }", {
                        token: restoreToken
                    })
                ];
            case 2:
                response = _state.sent();
                if (!response.errors) return [
                    3,
                    4
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_alert/* restoreAlertError */.g)(response.errors[0]))
                ];
            case 3:
                _state.sent();
                return [
                    2
                ];
            case 4:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_alert/* restoreAlertSuccess */.Jl)(restoreToken, id, productId))
                ];
            case 5:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,toast_container_actions/* promptToast */.Lf)("success", window.APP_GLOBALS.t("alerts", "confirm.alert-restored"), {
                        toastId: productId
                    }))
                ];
            case 6:
                _state.sent();
                return [
                    3,
                    10
                ];
            case 7:
                err = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, err)
                ];
            case 8:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_alert/* restoreAlertError */.g)(err))
                ];
            case 9:
                _state.sent();
                return [
                    3,
                    10
                ];
            case 10:
                return [
                    2
                ];
        }
    });
}
function remove_alert_mySaga() {
    return remove_alert_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(actions_alert/* REMOVE_ALERT_REQUEST */.$x, removeAlertRequest)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(actions_alert/* RESTORE_ALERT_REQUEST */.f9, restoreAlertRequest)
                ];
            case 2:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
/* harmony default export */ const remove_alert = (remove_alert_mySaga);

;// CONCATENATED MODULE: ./src/areas/sidebar/sagas/remove-list-item.js
var remove_list_item_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};







function removeListItem(param) {
    var id, listId, response, restoreToken, err;
    return remove_list_item_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                id = param.id, listId = param.listId;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    7,
                    ,
                    10
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, "mutation listItemDelete($id: Int!, $listId: Int!) {\n        listItemDelete(id: $id, listId: $listId) {\n          restoreToken\n        }\n      }", {
                        id: id,
                        listId: listId
                    })
                ];
            case 2:
                response = _state.sent();
                if (!response.errors) return [
                    3,
                    4
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* removeListItemError */.f$)(response.errors[0]))
                ];
            case 3:
                _state.sent();
                return [
                    2
                ];
            case 4:
                restoreToken = response.data.listItemDelete.restoreToken;
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* removeListItemSuccess */.M2)(restoreToken, id, listId))
                ];
            case 5:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,toast_container_actions/* promptToast */.Lf)("success", /*#__PURE__*/ react.createElement(react.Fragment, null, window.APP_GLOBALS.t("lists", "confirm.item-deleted"), /*#__PURE__*/ react.createElement(undo, {
                        undo: (0,actions_lists/* restoreListItemRequest */.RP)(id, restoreToken)
                    }))))
                ];
            case 6:
                _state.sent();
                return [
                    3,
                    10
                ];
            case 7:
                err = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, err)
                ];
            case 8:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* removeListItemError */.f$)(err))
                ];
            case 9:
                _state.sent();
                return [
                    3,
                    10
                ];
            case 10:
                return [
                    2
                ];
        }
    });
}
function restoreListItem(param) {
    var restoreToken, id, response, err;
    return remove_list_item_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                restoreToken = param.restoreToken, id = param.id;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    7,
                    ,
                    10
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, "mutation restoreItem($token: String!) {\n        restoreItem(token: $token) {\n          success\n        }\n      }", {
                        token: restoreToken
                    })
                ];
            case 2:
                response = _state.sent();
                if (!response.errors) return [
                    3,
                    4
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* restoreListItemError */.pn)(response.errors[0]))
                ];
            case 3:
                _state.sent();
                return [
                    2
                ];
            case 4:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* restoreListItemSuccess */.A3)(id, restoreToken))
                ];
            case 5:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,toast_container_actions/* promptToast */.Lf)("success", window.APP_GLOBALS.t("lists", "confirm.item-restored")))
                ];
            case 6:
                _state.sent();
                return [
                    3,
                    10
                ];
            case 7:
                err = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, err)
                ];
            case 8:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* restoreListItemError */.pn)(err))
                ];
            case 9:
                _state.sent();
                return [
                    3,
                    10
                ];
            case 10:
                return [
                    2
                ];
        }
    });
}
function remove_list_item_mySaga() {
    return remove_list_item_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(actions_lists/* REMOVE_LIST_ITEM_REQUEST */.aF, removeListItem)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(actions_lists/* RESTORE_LIST_ITEM_REQUEST */.qB, restoreListItem)
                ];
            case 2:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
/* harmony default export */ const remove_list_item = (remove_list_item_mySaga);

;// CONCATENATED MODULE: ./src/areas/sidebar/sagas/remove-list.js
var remove_list_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};







function removeList(param) {
    var id, response, restoreToken, err;
    return remove_list_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                id = param.id;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    7,
                    ,
                    10
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, "mutation listDelete($id: Int!) {\n        listDelete(id: $id) {\n          restoreToken\n        }\n      }", {
                        id: id
                    })
                ];
            case 2:
                response = _state.sent();
                if (!response.errors) return [
                    3,
                    4
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* removeListError */.Ll)(response.errors[0]))
                ];
            case 3:
                _state.sent();
                return [
                    2
                ];
            case 4:
                restoreToken = response.data.listDelete.restoreToken;
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* removeListSuccess */.Mr)(restoreToken, id))
                ];
            case 5:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,toast_container_actions/* promptToast */.Lf)("success", /*#__PURE__*/ react.createElement(react.Fragment, null, window.APP_GLOBALS.t("lists", "confirm.list-deleted"), /*#__PURE__*/ react.createElement(undo, {
                        undo: (0,actions_lists/* restoreListRequest */.Lj)(id, restoreToken)
                    }))))
                ];
            case 6:
                _state.sent();
                return [
                    3,
                    10
                ];
            case 7:
                err = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, err)
                ];
            case 8:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* removeListError */.Ll)(err))
                ];
            case 9:
                _state.sent();
                return [
                    3,
                    10
                ];
            case 10:
                return [
                    2
                ];
        }
    });
}
function restoreList(param) {
    var restoreToken, id, response, err;
    return remove_list_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                restoreToken = param.restoreToken, id = param.id;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    7,
                    ,
                    10
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, "mutation restoreItem($token: String!) {\n        restoreItem(token: $token) {\n          success\n        }\n      }", {
                        token: restoreToken
                    })
                ];
            case 2:
                response = _state.sent();
                if (!response.errors) return [
                    3,
                    4
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* restoreListError */.WI)(response.errors[0]))
                ];
            case 3:
                _state.sent();
                return [
                    2
                ];
            case 4:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* restoreListSuccess */.qe)(id, restoreToken))
                ];
            case 5:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,toast_container_actions/* promptToast */.Lf)("success", window.APP_GLOBALS.t("lists", "confirm.list-restored")))
                ];
            case 6:
                _state.sent();
                return [
                    3,
                    10
                ];
            case 7:
                err = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, err)
                ];
            case 8:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* restoreListError */.WI)(err))
                ];
            case 9:
                _state.sent();
                return [
                    3,
                    10
                ];
            case 10:
                return [
                    2
                ];
        }
    });
}
function remove_list_mySaga() {
    return remove_list_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(actions_lists/* REMOVE_LIST_REQUEST */.N$, removeList)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(actions_lists/* RESTORE_LIST_REQUEST */.Ne, restoreList)
                ];
            case 2:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
/* harmony default export */ const remove_list = (remove_list_mySaga);

;// CONCATENATED MODULE: ./src/areas/account/requests/index.js
var request = function(url) {
    return fetch("/_internal/account/".concat(url), {
        credentials: "include",
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    }).then(function(resp) {
        return resp.json();
    });
};
var fetchMe = function() {
    return request("me");
};

;// CONCATENATED MODULE: ./src/areas/sidebar/sagas/update-user.js
var update_user_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};




// Fetch user data again to update the new list name across the app
function updateUser() {
    var response, error;
    return update_user_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    3,
                    ,
                    5
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(fetchMe)
                ];
            case 1:
                response = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(account_actions/* default.userReceive */.ZP.userReceive(response.me))
                ];
            case 2:
                _state.sent();
                return [
                    3,
                    5
                ];
            case 3:
                error = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* editListError */.tH)(error))
                ];
            case 4:
                _state.sent();
                return [
                    3,
                    5
                ];
            case 5:
                return [
                    2
                ];
        }
    });
}
/* harmony default export */ const update_user = (updateUser);

;// CONCATENATED MODULE: ./src/areas/sidebar/sagas/add-list-item.js
var add_list_item_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};










function createList(param) {
    var listName, createdList, response, error;
    return add_list_item_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                listName = param.listName;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    6,
                    ,
                    8
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, "mutation listCreate($name: String!) {\n          listCreate(name: $name) {\n            success\n            list {\n              id\n              name\n            }\n          }\n        }", {
                        name: listName
                    })
                ];
            case 2:
                response = _state.sent();
                if (!response.errors) return [
                    3,
                    4
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* createListError */.M1)(response.errors[0]))
                ];
            case 3:
                _state.sent();
                return [
                    2,
                    false
                ];
            case 4:
                createdList = response.data.listCreate.list;
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* createListSuccess */.re)(createdList))
                ];
            case 5:
                _state.sent();
                return [
                    3,
                    8
                ];
            case 6:
                error = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* createListError */.M1)(error))
                ];
            case 7:
                _state.sent();
                return [
                    2,
                    false
                ];
            case 8:
                return [
                    2,
                    createdList
                ];
        }
    });
}
function addListItem(param) {
    var productId, productName, isDesktop, tab, selectedList, ref, lists, listId, listName, createdList, response, addedItem, err;
    return add_list_item_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                productId = param.productId, productName = param.productName, isDesktop = param.isDesktop;
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(function(state) {
                        return state.areas.sidebar;
                    })
                ];
            case 1:
                tab = _state.sent().tab;
                if (!!isDesktop) return [
                    3,
                    4
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(mobile_menu/* default.openMenu */.ZP.openMenu())
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,sidebar_mobile_actions/* setMobileSidebarView */.E)(sidebar_mobile_constants/* VIEWS.LIST */.n.LIST))
                ];
            case 3:
                _state.sent();
                _state.label = 4;
            case 4:
                if (!(tab !== sidebar_constants/* SIDEBAR_STATE.LISTS */.$J.LISTS)) return [
                    3,
                    6
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* openLists */.pu)())
                ];
            case 5:
                _state.sent();
                _state.label = 6;
            case 6:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(function(state) {
                        return state.areas.sidebar;
                    })
                ];
            case 7:
                selectedList = _state.sent().selectedList;
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(function(state) {
                        return state.areas.account.me.lists;
                    })
                ];
            case 8:
                ref = _state.sent(), lists = ref.nodes;
                listId = selectedList;
                listName = selectedList ? lists.find(function(x) {
                    return x.id === listId;
                }).name : undefined;
                if (!!listId) return [
                    3,
                    11
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(createList, {
                        listName: window.APP_GLOBALS.t("lists", "list.default-name")
                    })
                ];
            case 9:
                createdList = _state.sent();
                listId = createdList.id;
                listName = createList.name;
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* selectList */.Fz)(listId))
                ];
            case 10:
                _state.sent();
                _state.label = 11;
            case 11:
                _state.trys.push([
                    11,
                    17,
                    ,
                    20
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, "\n      mutation listItemAdd($id: ID!, $listId: Int!, $type: ListItemType!) {\n        listItemAdd(id: $id, listId: $listId, type: $type) {\n          success\n          item {\n            id\n          }\n        }\n      }", {
                        id: productId,
                        listId: listId,
                        type: "product"
                    })
                ];
            case 12:
                response = _state.sent();
                if (!response.errors) return [
                    3,
                    14
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* addListItemError */.WT)(response.errors[0]))
                ];
            case 13:
                _state.sent();
                _state.label = 14;
            case 14:
                addedItem = response.data.listItemAdd.item;
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* addListItemSuccess */.j3)(addedItem.id))
                ];
            case 15:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,toast_container_actions/* promptToast */.Lf)("success", window.APP_GLOBALS.t("lists", "confirm.item-added", {
                        productName: productName,
                        listName: listName
                    })))
                ];
            case 16:
                _state.sent();
                return [
                    3,
                    20
                ];
            case 17:
                err = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, err)
                ];
            case 18:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* addListItemError */.WT)(err))
                ];
            case 19:
                _state.sent();
                return [
                    3,
                    20
                ];
            case 20:
                return [
                    2
                ];
        }
    });
}
function add_list_item_mySaga() {
    return add_list_item_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(actions_lists/* ADD_LIST_ITEM_REQUEST */.En, addListItem)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(actions_lists/* CREATE_LIST_REQUEST */.QE, createList)
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(actions_lists/* CREATE_LIST_SUCCESS */.Kj, update_user)
                ];
            case 3:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
/* harmony default export */ const add_list_item = (add_list_item_mySaga);

;// CONCATENATED MODULE: ./src/areas/sidebar/sagas/edit-list.js
var edit_list_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};




function editList(param) {
    var id, name, visibility, response, error;
    return edit_list_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                id = param.id, name = param.name, visibility = param.visibility;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    8,
                    ,
                    10
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, "mutation listEdit($id: Int!, $name: String!, $visibility: ListVisibility!) {\n        listEdit(id: $id, name: $name, visibility: $visibility) {\n          success\n        }\n      }", {
                        id: id,
                        name: name,
                        visibility: visibility
                    })
                ];
            case 2:
                response = _state.sent();
                if (!response.errors) return [
                    3,
                    4
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* editListError */.tH)(response.errors[0]))
                ];
            case 3:
                _state.sent();
                return [
                    2,
                    false
                ];
            case 4:
                if (!response.data.listEdit.success) return [
                    3,
                    7
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* editListSuccess */.P)({
                        id: id,
                        name: name
                    }))
                ];
            case 5:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* closeListSettings */.jy)())
                ];
            case 6:
                _state.sent();
                _state.label = 7;
            case 7:
                return [
                    3,
                    10
                ];
            case 8:
                error = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* editListError */.tH)(error))
                ];
            case 9:
                _state.sent();
                return [
                    2,
                    false
                ];
            case 10:
                return [
                    2,
                    true
                ];
        }
    });
}
function edit_list_mySaga() {
    return edit_list_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(actions_lists/* EDIT_LIST_REQUEST */.GB, editList)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(actions_lists/* EDIT_LIST_SUCCESS */.Ce, update_user)
                ];
            case 2:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
/* harmony default export */ const edit_list = (edit_list_mySaga);

// EXTERNAL MODULE: ./src/areas/reviews/generic-user-review.graphql
var generic_user_review_graphql = __webpack_require__(4692);
var generic_user_review_graphql_default = /*#__PURE__*/__webpack_require__.n(generic_user_review_graphql);
;// CONCATENATED MODULE: ./src/areas/reviews/sagas/index.js
function sagas_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function sagas_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            sagas_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function sagas_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function sagas_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        sagas_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function sagas_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = sagas_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function sagas_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var reviews_sagas_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};









// Remove all query params related to reviews when closing the form
function removeReviewQueryParams() {
    var push, _ref, review, reviewId, code, draft, queryParams;
    return reviews_sagas_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                push = window.__history.push;
                _ref = query_string_for_all_dist_default().parse(window.location.search), review = _ref.review, reviewId = _ref.review_id, code = _ref.code, draft = _ref.draft, queryParams = sagas_objectWithoutProperties(_ref, [
                    "review",
                    "review_id",
                    "code",
                    "draft"
                ]);
                if (!review && !reviewId && !code && !draft) return [
                    2
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(push, decodeURIComponent("".concat(window.location.pathname, "?").concat(query_string_for_all_dist_default().stringify(queryParams))))
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
// Update review data on profile pages
function updateProfileReviews(shouldSave) {
    var limit, isAuthenticated, ref, response, ref1, _code, e;
    return reviews_sagas_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(function(state) {
                        return state.areas.review.pageInfo.profile;
                    })
                ];
            case 1:
                limit = _state.sent().limit;
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(function(state) {
                        return state.areas.account.isAuthenticated;
                    })
                ];
            case 2:
                isAuthenticated = _state.sent().isAuthenticated;
                if (!isAuthenticated) return [
                    2
                ];
                _state.label = 3;
            case 3:
                _state.trys.push([
                    3,
                    10,
                    ,
                    12
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, "\n        query updateProfileReviews(\n          $limit: Int = 10\n          $getProduct: Boolean = true\n          $getStore: Boolean = true\n        ) {\n          me {\n            reviews(offset: 0, limit: $limit) {\n              totalItems\n              pageInfo {\n                limit\n                offset\n                hasNext\n                hasPrevious\n              }\n              nodes {\n                ...GenericUserReview\n              }\n            }\n          }\n        }\n        ".concat((generic_user_review_graphql_default())), {
                        limit: limit
                    })
                ];
            case 4:
                response = _state.sent();
                if (!((ref = response.errors) === null || ref === void 0 ? void 0 : ref.length)) return [
                    3,
                    7
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* reviewRequestError */.n0)((_code = response.errors[0].code) !== null && _code !== void 0 ? _code : (ref1 = response.errors[0].extensions) === null || ref1 === void 0 ? void 0 : ref1.code))
                ];
            case 5:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, response.errors)
                ];
            case 6:
                _state.sent();
                return [
                    2
                ];
            case 7:
                if (!shouldSave) return [
                    3,
                    9
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* updateShopReviewData */.i_)({
                        nodes: response.data.me.reviews.nodes
                    }))
                ];
            case 8:
                _state.sent();
                _state.label = 9;
            case 9:
                return [
                    3,
                    12
                ];
            case 10:
                e = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, e)
                ];
            case 11:
                _state.sent();
                return [
                    3,
                    12
                ];
            case 12:
                return [
                    2
                ];
        }
    });
}
// Updates review data and invalidates previous cached results
function updateReviewsData(param) {
    var shopId, productId, location, shouldSaveProfileData, type, limit, ref, response, ref1, _code, e;
    return reviews_sagas_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                shopId = param.shopId, productId = param.productId, location = param.location;
                shouldSaveProfileData = Boolean(location && location.includes("/account/profile"));
                // Updates and invalidates cache for profile reviews
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(updateProfileReviews, shouldSaveProfileData)
                ];
            case 1:
                _state.sent();
                if (!shopId && !productId) return [
                    2
                ];
                if (shopId) type = "store";
                if (productId) type = "product";
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(function(state) {
                        return state.areas.review.pageInfo[type];
                    })
                ];
            case 2:
                limit = _state.sent().limit;
                _state.label = 3;
            case 3:
                _state.trys.push([
                    3,
                    10,
                    ,
                    12
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, "query updateReviews($id: Int!, $limit: Int!, $getProduct: Boolean = false, $getStore: Boolean = false) {\n          ".concat(type, '(id: $id) {\n            userReviews(limit: $limit, offset: 0, invalidateCache: true) {\n              nodes {\n                ...GenericUserReview\n              }\n              myReview {\n                id\n                rating\n                reviewText\n                createdAt\n                localizedCreatedAt: createdAt(format: "L")\n                localizedUpdatedAt: updatedAt(format: "L")\n              }\n            }\n\n          }\n        }, ').concat((generic_user_review_graphql_default())), {
                        id: shopId || productId,
                        limit: limit,
                        getProduct: type === "product"
                    })
                ];
            case 4:
                response = _state.sent();
                if (!((ref = response.errors) === null || ref === void 0 ? void 0 : ref.length)) return [
                    3,
                    7
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* reviewRequestError */.n0)((_code = response.errors[0].code) !== null && _code !== void 0 ? _code : (ref1 = response.errors[0].extensions) === null || ref1 === void 0 ? void 0 : ref1.code))
                ];
            case 5:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, response.errors)
                ];
            case 6:
                _state.sent();
                return [
                    2
                ];
            case 7:
                if (!!shouldSaveProfileData) return [
                    3,
                    9
                ];
                // Updates and invalidates cache for store and product pages
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* updateShopReviewData */.i_)({
                        shopId: shopId,
                        productId: productId,
                        nodes: response.data[type].userReviews.nodes,
                        myReview: response.data[type].userReviews.myReview
                    }))
                ];
            case 8:
                _state.sent();
                _state.label = 9;
            case 9:
                return [
                    3,
                    12
                ];
            case 10:
                e = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, e)
                ];
            case 11:
                _state.sent();
                return [
                    3,
                    12
                ];
            case 12:
                return [
                    2
                ];
        }
    });
}
function updateSummaryData(id, type) {
    var ref, response, ref1, _code;
    return reviews_sagas_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,requests/* graphql */.BX)("query updateReviewSummary($id: Int!) {\n      ".concat(type.toLowerCase(), "(id: $id) {\n        userReviewSummary {\n          rating\n          count\n          countTotal\n          distributionNew {\n            score\n            count\n            percentage\n          }\n        }\n      }\n    }\n    "), {
                        id: id
                    })
                ];
            case 1:
                response = _state.sent();
                if (!((ref = response.errors) === null || ref === void 0 ? void 0 : ref.length)) return [
                    3,
                    4
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* reviewRequestError */.n0)((_code = response.errors[0].code) !== null && _code !== void 0 ? _code : (ref1 = response.errors[0].extensions) === null || ref1 === void 0 ? void 0 : ref1.code))
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, response.errors)
                ];
            case 3:
                _state.sent();
                _state.label = 4;
            case 4:
                if (!(response.data && response.data.product && response.data.product.userReviewSummary)) return [
                    3,
                    6
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* updateReviewSummary */.Mf)(sagas_objectSpreadProps(sagas_objectSpread({}, response.data.product.userReviewSummary), {
                        belongsToId: id
                    })))
                ];
            case 5:
                _state.sent();
                _state.label = 6;
            case 6:
                return [
                    2
                ];
        }
    });
}
function createReview(param) {
    var belongsToId, rating, type, reviewText, purchaseDate, displayName, ref, response, ref1, _code, e;
    return reviews_sagas_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                belongsToId = param.belongsToId, rating = param.rating, type = param.reviewType, reviewText = param.reviewText, purchaseDate = param.purchaseDate, displayName = param.displayName;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    12,
                    ,
                    14
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, "mutation reviewCreate(\n        $belongsToId: Int!,\n        $type: reviewType!,\n        $rating: Int!,\n        $reviewText: String!,\n        $purchaseDate: String\n        $displayName: String\n        $getProduct: Boolean = false\n        $getStore: Boolean = false) {\n          reviewCreate(\n            type: $type,\n            belongsToId: $belongsToId,\n            rating: $rating,\n            reviewText: $reviewText,\n            purchaseDate: $purchaseDate\n            displayName: $displayName) {\n              ...GenericUserReview\n            }\n      }, ".concat((generic_user_review_graphql_default())), {
                        type: type,
                        belongsToId: belongsToId,
                        rating: parseInt(rating, 10),
                        reviewText: reviewText,
                        purchaseDate: purchaseDate,
                        displayName: displayName
                    })
                ];
            case 2:
                response = _state.sent();
                if (!((ref = response.errors) === null || ref === void 0 ? void 0 : ref.length)) return [
                    3,
                    5
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* reviewRequestError */.n0)((_code = response.errors[0].code) !== null && _code !== void 0 ? _code : (ref1 = response.errors[0].extensions) === null || ref1 === void 0 ? void 0 : ref1.code))
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, response.errors)
                ];
            case 4:
                _state.sent();
                return [
                    2
                ];
            case 5:
                if (!displayName) return [
                    3,
                    7
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,display_name/* setDisplayName */.hC)(displayName))
                ];
            case 6:
                _state.sent();
                _state.label = 7;
            case 7:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* closeReviewDialog */.KW)())
                ];
            case 8:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* createReviewSuccess */.ey)({
                        productId: belongsToId
                    }))
                ];
            case 9:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(updateSummaryData, belongsToId, type)
                ];
            case 10:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,toast_container_actions/* promptToast */.Lf)("success", window.APP_GLOBALS.t("reviews", "dialog.create-success")))
                ];
            case 11:
                _state.sent();
                return [
                    3,
                    14
                ];
            case 12:
                e = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, e)
                ];
            case 13:
                _state.sent();
                return [
                    3,
                    14
                ];
            case 14:
                return [
                    2
                ];
        }
    });
}
function createShopReview(param) {
    var belongsToId, belongsToName, rating, reviewType, reviewText, purchaseDate, answers, email, displayName, ref, response, ref1, _code, e;
    return reviews_sagas_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                belongsToId = param.belongsToId, belongsToName = param.belongsToName, rating = param.rating, reviewType = param.reviewType, reviewText = param.reviewText, purchaseDate = param.purchaseDate, answers = param.answers, email = param.email, displayName = param.displayName;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    11,
                    ,
                    13
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, "mutation reviewCreate(\n        $belongsToId: Int!,\n        $type: reviewType!,\n        $rating: Int!,\n        $reviewText: String!,\n        $purchaseDate: String,\n        $answers: [AnswerInput]\n        $email: String\n        $displayName: String\n        $getProduct: Boolean = false\n        $getStore: Boolean = false) {\n          reviewCreate(\n            type: $type,\n            belongsToId: $belongsToId,\n            rating: $rating,\n            reviewText: $reviewText,\n            purchaseDate: $purchaseDate,\n            answers: $answers,\n            email: $email\n            displayName: $displayName) {\n              ...GenericUserReview\n            }\n      }, ".concat((generic_user_review_graphql_default())), {
                        type: reviewType,
                        belongsToId: belongsToId,
                        rating: parseInt(rating, 10),
                        reviewText: reviewText,
                        purchaseDate: purchaseDate,
                        answers: answers,
                        email: email,
                        displayName: displayName
                    })
                ];
            case 2:
                response = _state.sent();
                if (!((ref = response.errors) === null || ref === void 0 ? void 0 : ref.length)) return [
                    3,
                    5
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* reviewRequestError */.n0)((_code = response.errors[0].code) !== null && _code !== void 0 ? _code : (ref1 = response.errors[0].extensions) === null || ref1 === void 0 ? void 0 : ref1.code))
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, response.errors)
                ];
            case 4:
                _state.sent();
                return [
                    2
                ];
            case 5:
                if (!displayName) return [
                    3,
                    7
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,display_name/* setDisplayName */.hC)(displayName))
                ];
            case 6:
                _state.sent();
                _state.label = 7;
            case 7:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(updateSummaryData, belongsToId, reviewType)
                ];
            case 8:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* createShopReviewSuccess */.zk)(// Don't update data if review needs to be verified before published
                    !email ? {
                        shopId: belongsToId
                    } : {}))
                ];
            case 9:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* closeReviewDialog */.KW)())
                ];
            case 10:
                _state.sent();
                return [
                    3,
                    13
                ];
            case 11:
                e = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, e)
                ];
            case 12:
                _state.sent();
                return [
                    3,
                    13
                ];
            case 13:
                return [
                    2
                ];
        }
    });
}
function editReview(param) {
    var reviewId, reviewType, rating, reviewText, purchaseDate, belongsToId, location, ref, response, ref1, _code, e;
    return reviews_sagas_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                reviewId = param.reviewId, reviewType = param.reviewType, rating = param.rating, reviewText = param.reviewText, purchaseDate = param.purchaseDate, belongsToId = param.belongsToId, location = param.location;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    10,
                    ,
                    12
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, "mutation reviewEdit(\n        $reviewId: String!,\n        $rating: Int!,\n        $reviewText: String!,\n        $purchaseDate: String,\n        $getProduct: Boolean = false\n        $getStore: Boolean = false\n      ) {\n        reviewEdit(\n          reviewId: $reviewId,\n          rating: $rating,\n          reviewText: $reviewText,\n          purchaseDate: $purchaseDate,\n        ) {\n          ...GenericUserReview\n        }\n      }, ".concat((generic_user_review_graphql_default())), {
                        reviewId: reviewId,
                        rating: parseInt(rating, 10),
                        reviewText: reviewText,
                        purchaseDate: purchaseDate,
                        getProduct: reviewType === "PRODUCT"
                    })
                ];
            case 2:
                response = _state.sent();
                if (!((ref = response.errors) === null || ref === void 0 ? void 0 : ref.length)) return [
                    3,
                    5
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* reviewRequestError */.n0)((_code = response.errors[0].code) !== null && _code !== void 0 ? _code : (ref1 = response.errors[0].extensions) === null || ref1 === void 0 ? void 0 : ref1.code))
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, response.errors)
                ];
            case 4:
                _state.sent();
                return [
                    2
                ];
            case 5:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* closeReviewDialog */.KW)())
                ];
            case 6:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* editReviewSuccess */.kX)({
                        productId: belongsToId,
                        location: location
                    }))
                ];
            case 7:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(updateSummaryData, belongsToId, reviewType)
                ];
            case 8:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,toast_container_actions/* promptToast */.Lf)("success", window.APP_GLOBALS.t("reviews", "dialog.edit-success")))
                ];
            case 9:
                _state.sent();
                return [
                    3,
                    12
                ];
            case 10:
                e = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, e)
                ];
            case 11:
                _state.sent();
                return [
                    3,
                    12
                ];
            case 12:
                return [
                    2
                ];
        }
    });
}
function editShopReview(param) {
    var reviewId, reviewType, rating, reviewText, purchaseDate, belongsToId, belongsToName, answers, location, ref, response, ref1, _code, e;
    return reviews_sagas_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                reviewId = param.reviewId, reviewType = param.reviewType, rating = param.rating, reviewText = param.reviewText, purchaseDate = param.purchaseDate, belongsToId = param.belongsToId, belongsToName = param.belongsToName, answers = param.answers, location = param.location;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    10,
                    ,
                    12
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, "mutation editShopReview(\n        $reviewId: ID!\n        $rating: Int!\n        $reviewText: String!\n        $purchaseDate: String\n        $answers: [AnswerInput]\n      ) {\n        editShopReview(\n          reviewId: $reviewId,\n          rating: $rating,\n          reviewText: $reviewText,\n          purchaseDate: $purchaseDate,\n          answers: $answers\n        ) {\n          success\n        }\n      }", {
                        reviewId: reviewId,
                        rating: parseInt(rating, 10),
                        reviewText: reviewText,
                        purchaseDate: purchaseDate,
                        answers: answers
                    })
                ];
            case 2:
                response = _state.sent();
                if (!((ref = response.errors) === null || ref === void 0 ? void 0 : ref.length)) return [
                    3,
                    5
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* reviewRequestError */.n0)((_code = response.errors[0].code) !== null && _code !== void 0 ? _code : (ref1 = response.errors[0].extensions) === null || ref1 === void 0 ? void 0 : ref1.code))
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, response.errors)
                ];
            case 4:
                _state.sent();
                return [
                    2
                ];
            case 5:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* editShopReviewSuccess */.Jy)({
                        shopId: belongsToId,
                        location: location
                    }))
                ];
            case 6:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(updateSummaryData, belongsToId, reviewType)
                ];
            case 7:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* closeReviewDialog */.KW)())
                ];
            case 8:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,toast_container_actions/* promptToast */.Lf)("success", window.APP_GLOBALS.t("reviews", "dialog.edit-success")))
                ];
            case 9:
                _state.sent();
                return [
                    3,
                    12
                ];
            case 10:
                e = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, e)
                ];
            case 11:
                _state.sent();
                return [
                    3,
                    12
                ];
            case 12:
                return [
                    2
                ];
        }
    });
}
function deleteReview(param) {
    var reviewId, reviewType, belongsToId, location, ref, response, ref1, _code, e;
    return reviews_sagas_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                reviewId = param.reviewId, reviewType = param.reviewType, belongsToId = param.belongsToId, location = param.location;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    10,
                    ,
                    12
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, "mutation reviewDelete(\n        $reviewId: String!,\n      ) {\n        reviewDelete(\n          reviewId: $reviewId,\n        ) {\n          success\n        }\n      }", {
                        reviewId: reviewId
                    })
                ];
            case 2:
                response = _state.sent();
                if (!((ref = response.errors) === null || ref === void 0 ? void 0 : ref.length)) return [
                    3,
                    5
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* reviewRequestError */.n0)((_code = response.errors[0].code) !== null && _code !== void 0 ? _code : (ref1 = response.errors[0].extensions) === null || ref1 === void 0 ? void 0 : ref1.code))
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, response.errors)
                ];
            case 4:
                _state.sent();
                return [
                    2
                ];
            case 5:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* closeReviewDialog */.KW)())
                ];
            case 6:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* deleteReviewSuccess */.Ty)({
                        productId: belongsToId,
                        location: location
                    }))
                ];
            case 7:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(updateSummaryData, belongsToId, reviewType)
                ];
            case 8:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,toast_container_actions/* promptToast */.Lf)("success", window.APP_GLOBALS.t("reviews", "dialog.delete-success")))
                ];
            case 9:
                _state.sent();
                return [
                    3,
                    12
                ];
            case 10:
                e = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, e)
                ];
            case 11:
                _state.sent();
                return [
                    3,
                    12
                ];
            case 12:
                return [
                    2
                ];
        }
    });
}
function deleteShopReview(param) {
    var reviewId, shopId, shopName, location, ref, response, ref1, _code, e;
    return reviews_sagas_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                reviewId = param.reviewId, shopId = param.shopId, shopName = param.shopName, location = param.location;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    9,
                    ,
                    11
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, "\n      mutation($reviewId: ID!) {\n        deleteShopReview(id: $reviewId) {\n          success\n        }\n      }\n    ", {
                        reviewId: reviewId
                    })
                ];
            case 2:
                response = _state.sent();
                if (!((ref = response.errors) === null || ref === void 0 ? void 0 : ref.length)) return [
                    3,
                    5
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* reviewRequestError */.n0)((_code = response.errors[0].code) !== null && _code !== void 0 ? _code : (ref1 = response.errors[0].extensions) === null || ref1 === void 0 ? void 0 : ref1.code))
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, response.errors)
                ];
            case 4:
                _state.sent();
                return [
                    2
                ];
            case 5:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* deleteShopReviewSuccess */.TA)({
                        shopId: shopId,
                        reviewId: reviewId,
                        location: location
                    }))
                ];
            case 6:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* closeReviewDialog */.KW)())
                ];
            case 7:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,toast_container_actions/* promptToast */.Lf)("success", window.APP_GLOBALS.t("reviews", "dialog.delete-success")))
                ];
            case 8:
                _state.sent();
                return [
                    3,
                    11
                ];
            case 9:
                e = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, e)
                ];
            case 10:
                _state.sent();
                return [
                    3,
                    11
                ];
            case 11:
                return [
                    2
                ];
        }
    });
}
function reportReview(param) {
    var reviewId, message, email, response, err;
    return reviews_sagas_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                reviewId = param.reviewId, message = param.message, email = param.email;
                if (!(!email || !(0,helpers/* isValidEmail */.vV)(email))) return [
                    3,
                    2
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* reportReviewFailed */.c1)("error.missing.email"))
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
            case 2:
                if (!!message) return [
                    3,
                    4
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* reportReviewFailed */.c1)("error.missing.message"))
                ];
            case 3:
                _state.sent();
                return [
                    2
                ];
            case 4:
                _state.trys.push([
                    4,
                    11,
                    ,
                    14
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, "mutation reviewReport(\n        $reviewId: String!,\n        $message: String!,\n        $email: String!,\n      ) {\n        reviewReport(\n          reviewId: $reviewId,\n          message: $message,\n          email: $email,\n        ) {\n          success\n        }\n      }", {
                        reviewId: reviewId,
                        message: message,
                        email: email
                    })
                ];
            case 5:
                response = _state.sent();
                if (!(response && response.data && response.data.reviewReport && response.data.reviewReport.success)) return [
                    3,
                    8
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* reportReviewSuccess */.qG)())
                ];
            case 6:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,toast_container_actions/* promptToast */.Lf)("success", window.APP_GLOBALS.t("feedback", "report-review.success")))
                ];
            case 7:
                _state.sent();
                return [
                    3,
                    10
                ];
            case 8:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* reportReviewFailed */.c1)(response ? response.errors : undefined))
                ];
            case 9:
                _state.sent();
                _state.label = 10;
            case 10:
                return [
                    3,
                    14
                ];
            case 11:
                err = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, err)
                ];
            case 12:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* reportReviewFailed */.c1)(err.message))
                ];
            case 13:
                _state.sent();
                return [
                    3,
                    14
                ];
            case 14:
                return [
                    2
                ];
        }
    });
}
function likeReview(param) {
    var id, reviewType, query, response, likedReviews, value;
    return reviews_sagas_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                id = param.id, reviewType = param.reviewType;
                query = "\n    mutation($reviewId: String!) {\n      reviewVoteHelpful(reviewId: $reviewId) {\n        success\n      }\n    }\n  ";
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, query, {
                        reviewId: id
                    })
                ];
            case 1:
                response = _state.sent();
                if (!(response.data.reviewVoteHelpful && response.data.reviewVoteHelpful.success)) return [
                    3,
                    4
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(function(state) {
                        return state.areas.account.me.likes.reviews;
                    })
                ];
            case 2:
                likedReviews = _state.sent();
                value = likedReviews && likedReviews.includes(id) ? "unlike" : "like";
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* likeReviewSuccess */.U9)(id, value))
                ];
            case 3:
                _state.sent();
                return [
                    3,
                    6
                ];
            case 4:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,reviews_actions/* likeReviewFailed */.XN)())
                ];
            case 5:
                _state.sent();
                _state.label = 6;
            case 6:
                return [
                    2
                ];
        }
    });
}
function reviews_sagas_mySaga() {
    return reviews_sagas_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(reviews_actions/* CREATE_REVIEW */.l3, createReview)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(reviews_actions/* CREATE_SHOP_REVIEW */.mb, createShopReview)
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(reviews_actions/* EDIT_SHOP_REVIEW */.CA, editShopReview)
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(reviews_actions/* EDIT_REVIEW */.hy, editReview)
                ];
            case 4:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(reviews_actions/* DELETE_REVIEW */.y$, deleteReview)
                ];
            case 5:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(reviews_actions/* DELETE_SHOP_REVIEW */.Bs, deleteShopReview)
                ];
            case 6:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(reviews_actions/* REPORT_REVIEW */.ar, reportReview)
                ];
            case 7:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(reviews_actions/* LIKE_REVIEW_TOGGLE */.vH, likeReview)
                ];
            case 8:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)([
                        reviews_actions/* CREATE_SHOP_REVIEW_SUCCESS */.eA,
                        reviews_actions/* EDIT_SHOP_REVIEW_SUCCESS */.s6,
                        reviews_actions/* DELETE_SHOP_REVIEW_SUCCESS */.UW,
                        reviews_actions/* CREATE_REVIEW_SUCCESS */.bg,
                        reviews_actions/* EDIT_REVIEW_SUCCESS */.cO,
                        reviews_actions/* DELETE_REVIEW_SUCCESS */.g6
                    ], updateReviewsData)
                ];
            case 9:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(reviews_actions/* CLOSE_REVIEW_DIALOG */.TF, removeReviewQueryParams)
                ];
            case 10:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
/* harmony default export */ const reviews_sagas = (reviews_sagas_mySaga);

;// CONCATENATED MODULE: ./src/areas/sidebar/sagas/order-lists.js
var order_lists_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};




function orderLists(param) {
    var listIds, response, err;
    return order_lists_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                listIds = param.listIds;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    3,
                    ,
                    5
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, "mutation listsOrder($listIds: [Int!]!) {\n        listsOrder(listIds: $listIds) {\n          success\n        }\n      }", {
                        listIds: listIds
                    })
                ];
            case 2:
                response = _state.sent();
                if (response.errors) {
                    return [
                        2
                    ];
                }
                return [
                    3,
                    5
                ];
            case 3:
                err = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, err)
                ];
            case 4:
                _state.sent();
                return [
                    3,
                    5
                ];
            case 5:
                return [
                    2
                ];
        }
    });
}
function orderListItems(param) {
    var listItemIds, listId, response, err;
    return order_lists_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                listItemIds = param.listItemIds, listId = param.listId;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    3,
                    ,
                    5
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, "mutation listItemsOrder($listId: Int!, $listItemIds: [Int!]!) {\n        listItemsOrder(listId: $listId, listItemIds: $listItemIds) {\n          success\n        }\n      }", {
                        listItemIds: listItemIds,
                        listId: listId
                    })
                ];
            case 2:
                response = _state.sent();
                if (response.errors) {
                    return [
                        2
                    ];
                }
                return [
                    3,
                    5
                ];
            case 3:
                err = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, err)
                ];
            case 4:
                _state.sent();
                return [
                    3,
                    5
                ];
            case 5:
                return [
                    2
                ];
        }
    });
}
function order_lists_mySaga() {
    return order_lists_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(actions_lists/* ORDER_LISTS_REQUEST */.Po, orderLists)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(actions_lists/* ORDER_LIST_ITEMS_REQUEST */.w, orderListItems)
                ];
            case 2:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
/* harmony default export */ const order_lists = (order_lists_mySaga);

// EXTERNAL MODULE: ./src/areas/sidebar/my-products-mutation.graphql
var my_products_mutation_graphql = __webpack_require__(16242);
var my_products_mutation_graphql_default = /*#__PURE__*/__webpack_require__.n(my_products_mutation_graphql);
// EXTERNAL MODULE: ./src/areas/sidebar/my-products-import.graphql
var my_products_import_graphql = __webpack_require__(50191);
var my_products_import_graphql_default = /*#__PURE__*/__webpack_require__.n(my_products_import_graphql);
;// CONCATENATED MODULE: ./src/areas/sidebar/sagas/my-products.js
var my_products_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};











function addItemToMyProducts(param) {
    var productId, productName, isDesktop, tab, response, err;
    return my_products_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                productId = param.productId, productName = param.productName, isDesktop = param.isDesktop;
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(function(state) {
                        return state.areas.sidebar;
                    })
                ];
            case 1:
                tab = _state.sent().tab;
                if (!!isDesktop) return [
                    3,
                    4
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(mobile_menu/* default.openMenu */.ZP.openMenu())
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,sidebar_mobile_actions/* setMobileSidebarView */.E)(sidebar_mobile_constants/* VIEWS.LIST */.n.LIST))
                ];
            case 3:
                _state.sent();
                _state.label = 4;
            case 4:
                if (!(tab !== sidebar_constants/* SIDEBAR_STATE.LISTS */.$J.LISTS)) return [
                    3,
                    6
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* openLists */.pu)())
                ];
            case 5:
                _state.sent();
                _state.label = 6;
            case 6:
                _state.trys.push([
                    6,
                    14,
                    ,
                    17
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, (my_products_mutation_graphql_default()), {
                        productIds: [
                            productId
                        ]
                    })
                ];
            case 7:
                response = _state.sent();
                if (!response.errors) return [
                    3,
                    9
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* addListItemError */.WT)(response.errors[0]))
                ];
            case 8:
                _state.sent();
                _state.label = 9;
            case 9:
                if (!response.data) return [
                    3,
                    13
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* selectList */.Fz)(response.data.myProductsItemsAdd.id))
                ];
            case 10:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* addListItemSuccess */.j3)())
                ];
            case 11:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,toast_container_actions/* promptToast */.Lf)("success", window.APP_GLOBALS.t("lists", "confirm.item-added", {
                        productName: productName,
                        listName: window.APP_GLOBALS.t("lists", "my-products.title")
                    })))
                ];
            case 12:
                _state.sent();
                _state.label = 13;
            case 13:
                return [
                    3,
                    17
                ];
            case 14:
                err = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, err)
                ];
            case 15:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* addListItemError */.WT)(err))
                ];
            case 16:
                _state.sent();
                return [
                    3,
                    17
                ];
            case 17:
                return [
                    2
                ];
        }
    });
}
function importListToMyProducts(param) {
    var listId, response, selectedList, err;
    return my_products_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                listId = param.listId;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    9,
                    ,
                    12
                ]);
                return [
                    4,
                    (0,requests/* graphql */.BX)((my_products_import_graphql_default()), {
                        listId: listId
                    })
                ];
            case 2:
                response = _state.sent();
                if (!response.errors) return [
                    3,
                    4
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* addListItemError */.WT)(response.errors[0]))
                ];
            case 3:
                _state.sent();
                _state.label = 4;
            case 4:
                if (!response.data) return [
                    3,
                    8
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(function(state) {
                        return state.areas.sidebar.selectedList;
                    })
                ];
            case 5:
                selectedList = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* importListToMyProductsSuccess */._8)())
                ];
            case 6:
                _state.sent();
                if (!(selectedList === sidebar_constants/* NO_MY_PRODUCTS_CREATED_ID */.Ym)) return [
                    3,
                    8
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* selectList */.Fz)(response.data.myProductsImport.id))
                ];
            case 7:
                _state.sent();
                _state.label = 8;
            case 8:
                return [
                    3,
                    12
                ];
            case 9:
                err = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, err)
                ];
            case 10:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,actions_lists/* addListItemError */.WT)(err))
                ];
            case 11:
                _state.sent();
                return [
                    3,
                    12
                ];
            case 12:
                return [
                    2
                ];
        }
    });
}
function myProductsSaga() {
    return my_products_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(actions_lists/* ADD_ITEM_TO_MY_PRODUCTS_REQUEST */.xC, addItemToMyProducts)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeLatest */.Fm)(actions_lists/* IMPORT_LIST_TO_MY_PRODUCTS */.sy, importListToMyProducts)
                ];
            case 2:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
/* harmony default export */ const my_products = (myProductsSaga);

// EXTERNAL MODULE: ./src/client/data-layer.ts
var data_layer = __webpack_require__(80695);
;// CONCATENATED MODULE: ./src/areas/user/sagas/tracking.js
function tracking_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function tracking_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function tracking_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function tracking_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function tracking_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function tracking_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            tracking_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function tracking_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function tracking_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        tracking_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function tracking_slicedToArray(arr, i) {
    return tracking_arrayWithHoles(arr) || tracking_iterableToArrayLimit(arr, i) || tracking_unsupportedIterableToArray(arr, i) || tracking_nonIterableRest();
}
function tracking_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return tracking_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return tracking_arrayLikeToArray(o, minLen);
}
var tracking_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};





function saveTrackingSettings(param) {
    var settings, isLoggedIn, showSuccessPrompt, e, response, e1;
    return tracking_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                settings = param.settings, isLoggedIn = param.isLoggedIn, showSuccessPrompt = param.showSuccessPrompt;
                if (!isLoggedIn) return [
                    3,
                    6
                ];
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    3,
                    ,
                    6
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* all */.$6)(Object.entries(settings).map(function(param) {
                        var _param = tracking_slicedToArray(param, 2), key = _param[0], value = _param[1];
                        return (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* graphql */.BX, "\n              mutation($data: SettingInputType!) {\n                updateSetting(data: $data) {\n                  success\n                }\n              }\n            ", {
                            data: {
                                setting: key,
                                value: value ? "1" : "0"
                            }
                        });
                    }))
                ];
            case 2:
                _state.sent();
                return [
                    3,
                    6
                ];
            case 3:
                e = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(actions_tracking/* default.trackingToggleSaveError */.ZP.trackingToggleSaveError(tracking_objectSpreadProps(tracking_objectSpread({}, settings), {
                        error: true
                    })))
                ];
            case 4:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* cancel */.al)()
                ];
            case 5:
                _state.sent();
                return [
                    3,
                    6
                ];
            case 6:
                _state.trys.push([
                    6,
                    11,
                    ,
                    13
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* putPrivacySettings */.Bp, settings)
                ];
            case 7:
                response = _state.sent();
                if (!(response.status !== 200)) return [
                    3,
                    8
                ];
                throw new Error("tracking save failed");
            case 8:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(actions_tracking/* default.trackingToggleSaveSuccess */.ZP.trackingToggleSaveSuccess(settings, showSuccessPrompt))
                ];
            case 9:
                _state.sent();
                _state.label = 10;
            case 10:
                return [
                    3,
                    13
                ];
            case 11:
                e1 = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(actions_tracking/* default.trackingToggleSaveError */.ZP.trackingToggleSaveError(tracking_objectSpreadProps(tracking_objectSpread({}, settings), {
                        error: true
                    })))
                ];
            case 12:
                _state.sent();
                return [
                    3,
                    13
                ];
            case 13:
                return [
                    2
                ];
        }
    });
}
function trackingSettingsSaved(param) {
    var showSuccessPrompt, sessionData, session, trackingSettings, gaClientId, pulseEnvironmentId;
    return tracking_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                showSuccessPrompt = param.showSuccessPrompt;
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(requests/* getSession */.Gg)
                ];
            case 1:
                sessionData = _state.sent();
                window.SESSION_DATA = sessionData;
                session = sessionData.session, trackingSettings = sessionData.trackingSettings, gaClientId = sessionData.gaClientId, pulseEnvironmentId = sessionData.pulseEnvironmentId;
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(data_layer/* pushEvent */.A, "updateTrackingSettings", {
                        trackingSettings: trackingSettings
                    }, {
                        eventNameAsKey: false
                    })
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)({
                        type: "SESSION_RECEIVE",
                        session: session,
                        privacyCookie: trackingSettings,
                        clientId: gaClientId,
                        pulseEnvironmentId: pulseEnvironmentId
                    })
                ];
            case 3:
                _state.sent();
                if (!showSuccessPrompt) return [
                    3,
                    5
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,toast_container_actions/* promptToast */.Lf)("success", window.APP_GLOBALS.t("account", "settings.saved")))
                ];
            case 4:
                _state.sent();
                _state.label = 5;
            case 5:
                return [
                    2
                ];
        }
    });
}
function userLoggedIn(action) {
    var trackingSettings, tracking, isEqual;
    return tracking_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(function(state) {
                        return state.areas.user.tracking.settings;
                    })
                ];
            case 1:
                trackingSettings = _state.sent();
                tracking = action.me.privacySettings.reduce(function(settings, setting) {
                    return tracking_objectSpreadProps(tracking_objectSpread({}, settings), tracking_defineProperty({}, setting.name, setting.active));
                }, {});
                isEqual = Object.entries(tracking).reduce(function(equal, param) {
                    var _param = tracking_slicedToArray(param, 2), name = _param[0], value = _param[1];
                    return equal && value === trackingSettings[name];
                }, true);
                if (!!isEqual) return [
                    3,
                    3
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)(actions_tracking/* default.trackingToggleSave */.ZP.trackingToggleSave(tracking, true))
                ];
            case 2:
                _state.sent();
                _state.label = 3;
            case 3:
                return [
                    2
                ];
        }
    });
}
function tracking_mySaga() {
    return tracking_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeEvery */.ib)("USER_RECEIVE", userLoggedIn)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeEvery */.ib)(actions_tracking/* TRACKING_TOGGLE_SAVE */.fg, saveTrackingSettings)
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeEvery */.ib)(actions_tracking/* TRACKING_TOGGLE_SAVE_SUCCESS */.WD, trackingSettingsSaved)
                ];
            case 3:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
/* harmony default export */ const tracking = (tracking_mySaga);

// EXTERNAL MODULE: ./src/areas/account/settings/sagas/index.js
var settings_sagas = __webpack_require__(51018);
// EXTERNAL MODULE: ./src/areas/account/sagas/queries/like-shop.graphql
var like_shop_graphql = __webpack_require__(70518);
var like_shop_graphql_default = /*#__PURE__*/__webpack_require__.n(like_shop_graphql);
// EXTERNAL MODULE: ./src/areas/account/sagas/queries/dislike-shop.graphql
var dislike_shop_graphql = __webpack_require__(7432);
var dislike_shop_graphql_default = /*#__PURE__*/__webpack_require__.n(dislike_shop_graphql);
// EXTERNAL MODULE: ./src/areas/account/sagas/queries/shop-preference-state.graphql
var shop_preference_state_graphql = __webpack_require__(74035);
var shop_preference_state_graphql_default = /*#__PURE__*/__webpack_require__.n(shop_preference_state_graphql);
;// CONCATENATED MODULE: ./src/areas/account/sagas/shop-preference.ts
var shop_preference_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};








function likeShopRequest(param) {
    var shopId, mutationResponse, stateResponse, e;
    return shop_preference_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                shopId = param.shopId;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    10,
                    ,
                    14
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(function() {
                        return (0,requests/* graphql */.BX)((like_shop_graphql_default()), {
                            shopId: "".concat(shopId)
                        });
                    })
                ];
            case 2:
                mutationResponse = _state.sent();
                if (!(mutationResponse.errors && mutationResponse.errors.length)) return [
                    3,
                    6
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, mutationResponse.errors)
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,toast_container_actions/* promptToast */.Lf)("error", window.APP_GLOBALS.t("account", "shop-preference.request-error"), {
                        toastId: "likeShop".concat(shopId)
                    }))
                ];
            case 4:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,account_actions/* shopPreferenceError */.pT)())
                ];
            case 5:
                _state.sent();
                return [
                    3,
                    9
                ];
            case 6:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(function() {
                        return (0,requests/* graphql */.BX)((shop_preference_state_graphql_default()));
                    })
                ];
            case 7:
                stateResponse = _state.sent();
                if (!stateResponse.data) return [
                    3,
                    9
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,account_actions/* receiveShopPreference */.h_)(stateResponse.data))
                ];
            case 8:
                _state.sent();
                _state.label = 9;
            case 9:
                return [
                    3,
                    14
                ];
            case 10:
                e = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, e)
                ];
            case 11:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,toast_container_actions/* promptToast */.Lf)("error", window.APP_GLOBALS.t("account", "shop-preference.request-error"), {
                        toastId: "likeShop".concat(shopId)
                    }))
                ];
            case 12:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,account_actions/* shopPreferenceError */.pT)())
                ];
            case 13:
                _state.sent();
                return [
                    3,
                    14
                ];
            case 14:
                return [
                    2
                ];
        }
    });
}
function dislikeShopRequest(param) {
    var shopId, mutationResponse, stateResponse, e;
    return shop_preference_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                shopId = param.shopId;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    10,
                    ,
                    14
                ]);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(function() {
                        return (0,requests/* graphql */.BX)((dislike_shop_graphql_default()), {
                            shopId: "".concat(shopId)
                        });
                    })
                ];
            case 2:
                mutationResponse = _state.sent();
                if (!(mutationResponse.errors && mutationResponse.errors.length)) return [
                    3,
                    6
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, mutationResponse.errors)
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,toast_container_actions/* promptToast */.Lf)("error", window.APP_GLOBALS.t("account", "shop-preference.request-error"), {
                        toastId: "dislikeShop".concat(shopId)
                    }))
                ];
            case 4:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,account_actions/* shopPreferenceError */.pT)())
                ];
            case 5:
                _state.sent();
                return [
                    3,
                    9
                ];
            case 6:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(function() {
                        return (0,requests/* graphql */.BX)((shop_preference_state_graphql_default()));
                    })
                ];
            case 7:
                stateResponse = _state.sent();
                if (!stateResponse.data) return [
                    3,
                    9
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,account_actions/* receiveShopPreference */.h_)(stateResponse.data))
                ];
            case 8:
                _state.sent();
                _state.label = 9;
            case 9:
                return [
                    3,
                    14
                ];
            case 10:
                e = _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(sentry/* captureException */.Tb, e)
                ];
            case 11:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,toast_container_actions/* promptToast */.Lf)("error", window.APP_GLOBALS.t("account", "shop-preference.request-error"), {
                        toastId: "dislikeShop".concat(shopId)
                    }))
                ];
            case 12:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,account_actions/* shopPreferenceError */.pT)())
                ];
            case 13:
                _state.sent();
                return [
                    3,
                    14
                ];
            case 14:
                return [
                    2
                ];
        }
    });
}
function shopPreferenceSaga() {
    return shop_preference_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeEvery */.ib)(account_actions/* USER_LIKE_SHOP_REQUEST */.ie, likeShopRequest)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeEvery */.ib)(account_actions/* USER_DISLIKE_SHOP_REQUEST */.oN, dislikeShopRequest)
                ];
            case 2:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
/* harmony default export */ const shop_preference = (shopPreferenceSaga);

;// CONCATENATED MODULE: ./src/components/filters/reducers/api.js
function api_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function api_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            api_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function api_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function api_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        api_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var filterChildren = function(filteredValues, child) {
    var valueIndex = filteredValues.findIndex(function(v) {
        return v === child.id;
    });
    if (valueIndex !== -1) {
        filteredValues.splice(valueIndex, 1);
    }
    if (child.children) return child.children.reduce(filterChildren, filteredValues);
    return filteredValues;
};
var flattenTree = function(values, parents, children) {
    var autoSelectChildren = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    var reducedParents = parents.reduce(function(filteredValues, parent) {
        if (!parent.children) return filteredValues;
        var childIds = parent.children.map(function(child) {
            return child.id;
        });
        var checked = childIds.map(function(id) {
            return filteredValues.includes(id);
        });
        if (autoSelectChildren && checked.includes(false) === false) {
            filteredValues.push(parent.id);
            return filteredValues.filter(function(value) {
                return !childIds.includes(value);
            });
        }
        if (filteredValues.includes(parent.id)) {
            return filteredValues.filter(function(value) {
                return value !== parent.id;
            });
        }
        return filteredValues;
    }, values);
    var reducedChildren = children.reduce(filterChildren, reducedParents);
    return reducedChildren;
};
var uniqueValues = function(values) {
    return values.filter(function(value, index) {
        return values.indexOf(value) === index;
    });
};
/* harmony default export */ function api(query, action) {
    var checked = action.checked, value = action.value, id = action.id, parents = action.parents, children = action.children, autoSelectChildren = action.autoSelectChildren;
    var values = query[id] || [];
    if (checked) {
        values.push(value);
        return api_objectSpreadProps(api_objectSpread({}, query), api_defineProperty({}, id, uniqueValues(flattenTree(values, parents || [], children || [], autoSelectChildren))));
    }
    // Filter out all children from array
    var childrenIds = children ? children.map(function(child) {
        return child.id;
    }) : [];
    var parentIds = parents ? parents.map(function(p) {
        return p.id;
    }) : [];
    var filtered = values.filter(function(x) {
        return x !== value;
    }).filter(function(x) {
        return !childrenIds.includes(x);
    });
    if (filtered.length === 0) {
        delete query[id]; // eslint-disable-line
        return api_objectSpread({}, query);
    }
    // Need to traverse parent to set new values
    if (filtered.length === values.length) {
        return api_objectSpreadProps(api_objectSpread({}, query), api_defineProperty({}, id, uniqueValues(filtered.concat(parents.reduce(function(results, curr) {
            if (results.done) {
                return results;
            }
            curr.children.forEach(function(child) {
                if (child.id === value) {
                    return;
                }
                results.values.push(child.id);
            });
            // Abort reduce when to level selected has been reached
            if (values.includes(curr.id)) {
                results.done = true; // eslint-disable-line
            }
            return results;
        }, {
            done: false,
            values: []
        }).values)// Filter out all parents from array
        .filter(function(value) {
            return !parentIds.includes(value);
        }))));
    }
    return api_objectSpreadProps(api_objectSpread({}, query), api_defineProperty({}, id, uniqueValues(filtered.filter(function(x) {
        return !parentIds.includes(x);
    }))));
};

// EXTERNAL MODULE: ./src/globals/helpers/is-numeric.js
var is_numeric = __webpack_require__(56121);
;// CONCATENATED MODULE: ./src/areas/category/sagas/filter.js
function sagas_filter_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function sagas_filter_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            sagas_filter_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function sagas_filter_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function sagas_filter_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        sagas_filter_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var filter_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};





var filter_reducer = function(query, action) {
    switch(action.filterType){
        case "boolean":
            {
                if (action.value === null) {
                    // eslint-disable-next-line no-param-reassign
                    delete query[action.id];
                    return sagas_filter_objectSpread({}, query);
                }
                return sagas_filter_objectSpreadProps(sagas_filter_objectSpread({}, query), sagas_filter_defineProperty({}, action.id, action.value));
            }
        case "slider":
            {
                if (action.value === null) {
                    // eslint-disable-next-line no-param-reassign
                    delete query[action.id];
                    return sagas_filter_objectSpread({}, query);
                }
                return sagas_filter_objectSpreadProps(sagas_filter_objectSpread({}, query), sagas_filter_defineProperty({}, action.id, action.value));
            }
        case "list":
            {
                return api(query, action);
            }
        case "string":
            {
                return sagas_filter_objectSpreadProps(sagas_filter_objectSpread({}, query), sagas_filter_defineProperty({}, action.id, action.value));
            }
        default:
            {
                return query;
            }
    }
};
var getQuery = function(state) {
    return state.areas.category.filter.query;
};
var getCompareProperties = function(state) {
    return state.areas.category.filter.comparing;
};
var getLoadedCategoryId = function(state) {
    return state.areas.category.filter.loadedCategoryId;
};
var getFilter = function(code, id, items) {
    return fetch("/_internal/filters/".concat(id).concat(items ? "/".concat(items) : ""), {
        credentials: "include"
    }).then(function(res) {
        if (res.status !== 200) {
            throw new Error("Filter fetch failed for ID ".concat(id).concat(items ? ", Items ".concat(items) : ""));
        }
        return res.json();
    }).catch(function(err) {
        return {
            error: err
        };
    });
};
var postFilter = function(code, id, query) {
    return fetch("/_internal/filters/".concat(id), {
        credentials: "include",
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(query)
    }).then(function(res) {
        if (res.status !== 200) {
            throw new Error("Filter create failed for ID ".concat(id));
        }
        return res.json();
    }).then(function(data) {
        return data.items[0];
    }).catch(function(err) {
        return {
            error: err
        };
    });
};
// Utility to get certain properties from an object as a new object
var pickProperties = function(props, obj) {
    return Object.keys(obj).reduce(function(params, key) {
        return props.includes(key) ? Object.assign(params, sagas_filter_defineProperty({}, key, obj[key])) : params;
    }, {});
};
function handleFilterActions(action) {
    var _, qs, loadedCategoryId, categoryState, ref, immediateProducts, productCount, _variables, id, filterId, brand, categoryData, toggledBrandCategory, hasChangedCategory, brandFilterId, brandFilter, data, useClassicUrls, replace, query, newQuery, categoryId, newFilter, filterId1, qs1, paramsToPropagate, newQueryString, data1, replace1, compare, selectedProps, currentParams, newQueryString1;
    return filter_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                _ = action.type;
                switch(_){
                    case "ROUTE_LOADED":
                        return [
                            3,
                            1
                        ];
                    case filter/* FILTER_CHANGE_ACTION */.$H:
                        return [
                            3,
                            13
                        ];
                    case filter/* COMPARE_PROPERTY */.gd:
                        return [
                            3,
                            28
                        ];
                }
                return [
                    3,
                    31
                ];
            case 1:
                if (!action.route) {
                    return [
                        3,
                        32
                    ];
                }
                qs = querystring.decode(location.search.substr(1));
                if (!qs.compare) return [
                    3,
                    3
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,filter/* compareProperties */.QL)(qs.compare.split(",").filter(is_numeric/* default */.Z)))
                ];
            case 2:
                _state.sent();
                _state.label = 3;
            case 3:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(getLoadedCategoryId)
                ];
            case 4:
                loadedCategoryId = _state.sent();
                if (action.route.name !== "category" || !action.data || !action.data.category) {
                    return [
                        3,
                        32
                    ];
                }
                categoryState = action.data.category;
                ref = action.category || categoryState, immediateProducts = ref.immediateProducts, productCount = ref.productCount;
                _variables = action.route.variables, id = _variables.id, filterId = _variables.filterId, brand = _variables.brand;
                categoryData = {
                    categoryId: id,
                    productCount: productCount
                };
                if (!immediateProducts) {
                    return [
                        3,
                        32
                    ];
                }
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(function(state) {
                        return state.areas.category.filter.toggledBrandCategory;
                    })
                ];
            case 5:
                toggledBrandCategory = _state.sent();
                hasChangedCategory = loadedCategoryId !== id || loadedCategoryId === id && toggledBrandCategory;
                if (!hasChangedCategory) return [
                    3,
                    12
                ];
                brandFilterId = null;
                if (!brand) return [
                    3,
                    7
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(postFilter, window.CLIENT_MARKET.code, id, {
                        brands: [
                            String(brand)
                        ]
                    })
                ];
            case 6:
                brandFilter = _state.sent();
                brandFilterId = brandFilter.id;
                _state.label = 7;
            case 7:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(getFilter, window.CLIENT_MARKET.code, brandFilterId || filterId || id)
                ];
            case 8:
                data = _state.sent();
                if (!data.error) return [
                    3,
                    10
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,filter/* filterFetchFailed */.lf)(data, id))
                ];
            case 9:
                _state.sent();
                return [
                    3,
                    12
                ];
            case 10:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,filter/* filterReceive */.m0)(data, categoryData))
                ];
            case 11:
                _state.sent();
                _state.label = 12;
            case 12:
                return [
                    3,
                    32
                ];
            case 13:
                useClassicUrls = window.CLIENT_MARKET.useClassicUrls;
                replace = window.__history.replace; // No idea why this is undefined in scope above
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(getQuery)
                ];
            case 14:
                query = _state.sent();
                newQuery = filter_reducer(query, action);
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,filter/* filterQuery */.DQ)(newQuery))
                ];
            case 15:
                _state.sent();
                categoryId = action.categoryId;
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(postFilter, window.CLIENT_MARKET.code, categoryId, newQuery)
                ];
            case 16:
                newFilter = _state.sent();
                if (!newFilter.error) return [
                    3,
                    18
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,filter/* filterFetchFailed */.lf)({
                        error: newFilter.error
                    }, categoryId))
                ];
            case 17:
                _state.sent();
                return [
                    2
                ];
            case 18:
                filterId1 = newFilter.id;
                qs1 = querystring.decode(location.search.substr(1));
                paramsToPropagate = pickProperties([
                    "brand",
                    "t",
                    "sort",
                    "k",
                    "b",
                    "m",
                    "o",
                    "catId",
                    "compare",
                    "direction"
                ], qs1);
                if (!(Object.keys(newQuery).length === 0)) return [
                    3,
                    20
                ];
                if (useClassicUrls) {
                    paramsToPropagate.k = newFilter.parent.id;
                    delete paramsToPropagate.catId;
                }
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(replace, "".concat(window.location.pathname, "?").concat(querystring.encode(paramsToPropagate)))
                ];
            case 19:
                _state.sent();
                return [
                    3,
                    22
                ];
            case 20:
                newQueryString = paramsToPropagate;
                if (useClassicUrls) {
                    newQueryString.catId = categoryId;
                    newQueryString.k = filterId1;
                } else {
                    newQueryString.filterId = filterId1;
                }
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(replace, "".concat(window.location.pathname, "?").concat(querystring.encode(newQueryString)))
                ];
            case 21:
                _state.sent();
                _state.label = 22;
            case 22:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(getFilter, window.CLIENT_MARKET.code, filterId1)
                ];
            case 23:
                data1 = _state.sent();
                if (!data1.error) return [
                    3,
                    25
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,filter/* filterFetchFailed */.lf)(data1, categoryId))
                ];
            case 24:
                _state.sent();
                return [
                    3,
                    27
                ];
            case 25:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,filter/* filterReceive */.m0)(data1, {
                        categoryId: categoryId
                    }))
                ];
            case 26:
                _state.sent();
                _state.label = 27;
            case 27:
                return [
                    3,
                    32
                ];
            case 28:
                replace1 = window.__history.replace; // No idea why this is undefined in scope above
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(getCompareProperties)
                ];
            case 29:
                compare = _state.sent();
                selectedProps = compare.filter(is_numeric/* default */.Z);
                currentParams = querystring.decode(window.location.search.substring(1));
                newQueryString1 = sagas_filter_objectSpreadProps(sagas_filter_objectSpread({}, currentParams), {
                    compare: selectedProps.join(",")
                });
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* call */.RE)(replace1, "".concat(window.location.pathname, "?").concat(querystring.encode(newQueryString1)))
                ];
            case 30:
                _state.sent();
                return [
                    3,
                    32
                ];
            case 31:
                {
                    return [
                        3,
                        32
                    ];
                }
                _state.label = 32;
            case 32:
                return [
                    2
                ];
        }
    });
}
function filter_mySaga() {
    return filter_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeEvery */.ib)([
                        "ROUTE_LOADED",
                        filter/* FILTER_CHANGE_ACTION */.$H,
                        filter/* COMPARE_PROPERTY */.gd
                    ], handleFilterActions)
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
/* harmony default export */ const sagas_filter = (filter_mySaga);

;// CONCATENATED MODULE: ./src/areas/category/sagas/search.js
function sagas_search_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function sagas_search_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            sagas_search_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function sagas_search_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function sagas_search_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        sagas_search_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var search_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};


var getInputValues = function(state) {
    return {
        inputValue: state.areas.category.search.inputValue,
        lastInputValue: state.areas.category.search.lastInputValue
    };
};
var search_getFilter = function(state) {
    return state.areas.category.filter;
};
function filterValues(values, loweredInput) {
    var newValues = [];
    values.forEach(function(val) {
        var filteredChildren = val.children ? filterValues(val.children, loweredInput) : null;
        if (val.name.toLowerCase().indexOf(loweredInput) >= 0) {
            newValues.push(sagas_search_objectSpread({}, val));
        } else if (filteredChildren && filteredChildren.length > 0) {
            newValues.push(sagas_search_objectSpreadProps(sagas_search_objectSpread({}, val), {
                children: filteredChildren
            }));
        }
    });
    return newValues;
}
function includeFilter(filter, loweredInput, values, filteredValues) {
    var visible = false;
    if (filter.type && filter.type.indexOf("list") >= 0 && values[filter.id] && values[filter.id].values) {
        filteredValues[filter.id] = {}; // eslint-disable-line no-param-reassign
        var newValues = filterValues(values[filter.id].values, loweredInput);
        if (newValues.length > 0) {
            visible = newValues.length > 0 || visible;
            filteredValues[filter.id].values = newValues; // eslint-disable-line no-param-reassign
        } else {
            filteredValues[filter.id] = sagas_search_objectSpread({}, values[filter.id]); // eslint-disable-line no-param-reassign
        }
    } else {
        filteredValues[filter.id] = sagas_search_objectSpread({}, values[filter.id]); // eslint-disable-line no-param-reassign
    }
    if (filter.name.toLowerCase().indexOf(loweredInput) >= 0 || filter.unit && filter.unit.toLowerCase().indexOf(loweredInput) >= 0) {
        visible = true;
    }
    var filteredChildren = null;
    if (filter.children) {
        filteredChildren = filter.children.map(function(child) {
            return includeFilter(child, loweredInput, values, filteredValues);
        }).filter(function(x) {
            return x;
        });
        visible = filteredChildren.length > 0 || visible;
    }
    return visible ? sagas_search_objectSpreadProps(sagas_search_objectSpread({}, filter), {
        children: filteredChildren
    }) : null;
}
function filterSection(section, loweredInput, values, filteredValues) {
    var filteredChildren = section.children.map(function(filter) {
        return includeFilter(filter, loweredInput, values, filteredValues);
    }).filter(function(x) {
        return x;
    });
    // If we only have a hit on the section name, we display the
    // whole section but with the expansion intact.
    if (filteredChildren.length === 0 && section.name.toLowerCase().indexOf(loweredInput) >= 0) {
        return sagas_search_objectSpread({}, section);
    }
    return filteredChildren.length > 0 ? sagas_search_objectSpreadProps(sagas_search_objectSpread({}, section), {
        children: filteredChildren
    }) : null;
}
function handleSearchActions(action) {
    var _, ref, inputValue, lastInputValue, inputFilter, loweredInput, values, core, definition, filteredValues, filteredCore, filteredSections;
    return search_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                _ = action.type;
                switch(_){
                    case filter/* FILTER_RECEIVE */.vN:
                        return [
                            3,
                            1
                        ];
                    case filter/* PROPERTY_SEARCH_ACTION */.Q:
                        return [
                            3,
                            1
                        ];
                }
                return [
                    3,
                    8
                ];
            case 1:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(getInputValues)
                ];
            case 2:
                ref = _state.sent(), inputValue = ref.inputValue, lastInputValue = ref.lastInputValue;
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* select */.Ys)(search_getFilter)
                ];
            case 3:
                inputFilter = _state.sent();
                if (!(inputValue.length < 2)) return [
                    3,
                    6
                ];
                if (!(action.type === filter/* FILTER_RECEIVE */.vN || lastInputValue.length > 1)) return [
                    3,
                    5
                ];
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,filter/* propertySearchComplete */.hN)(inputFilter.core, inputFilter.definition, inputFilter.values))
                ];
            case 4:
                _state.sent();
                _state.label = 5;
            case 5:
                return [
                    2
                ];
            case 6:
                loweredInput = inputValue.toLowerCase();
                values = inputFilter.values, core = inputFilter.core, definition = inputFilter.definition;
                filteredValues = {};
                filteredCore = core.map(function(filter) {
                    return includeFilter(filter, loweredInput, values, filteredValues);
                }).filter(function(x) {
                    return x;
                });
                filteredSections = definition.map(function(section) {
                    return filterSection(section, loweredInput, values, filteredValues);
                }).filter(function(x) {
                    return x;
                });
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* put */.gz)((0,filter/* propertySearchComplete */.hN)(filteredCore, filteredSections, filteredValues))
                ];
            case 7:
                _state.sent();
                return [
                    3,
                    9
                ];
            case 8:
                return [
                    3,
                    9
                ];
            case 9:
                return [
                    2
                ];
        }
    });
}
function search_mySaga() {
    return search_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects_npm_proxy_esm/* takeEvery */.ib)([
                        filter/* PROPERTY_SEARCH_ACTION */.Q,
                        filter/* FILTER_RECEIVE */.vN
                    ], handleSearchActions)
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
/* harmony default export */ const sagas_search = (search_mySaga);

;// CONCATENATED MODULE: ./src/sagas.ts















// FIXME: These sagas need the ROUTE_LOADED event to work correctly.
// Since this event is sometimes dispatched any lazily loaded code,
// they need to be here.


/* harmony default export */ const src_sagas = ([
    sagas,
    feedback_sagas,
    cookie_banner_sagas,
    create_alert,
    remove_alert,
    remove_list_item,
    order_lists,
    remove_list,
    add_list_item,
    edit_list,
    reviews_sagas,
    sagas_filter,
    sagas_search,
    tracking,
    my_products,
    settings_sagas/* default */.Z,
    shop_preference
]);

;// CONCATENATED MODULE: ./src/client/save-location.js
var saveLocation = function(data) {
    try {
        localStorage.setItem("ref", JSON.stringify(data));
    } catch (err) {} // eslint-disable-line
};
/* harmony default export */ function save_location() {
    return function(next) {
        return function(action) {
            next(action);
            if (action.type !== "ROUTE_LOADED" || !action.route) {
                return;
            }
            var data = action.data, route = action.route, location = action.location;
            var name = route.name;
            var path = location.pathname + location.search;
            switch(name){
                case "product":
                case "category":
                case "campaign":
                case "store":
                case "brand":
                case "shopOfTheYearLandingPage":
                case "shopOfTheYearCategory":
                case "search":
                case "infoPage":
                case "article":
                case "productCompare":
                case "productAlert":
                case "productCollection":
                case "createPurchaseReview":
                case "editPurchaseReview":
                case "user":
                case "expertProductTest":
                case "expertToplists":
                case "expertGuide":
                case "expertProfile":
                case "expertCategory":
                case "expertLandingPage":
                    saveLocation({
                        path: path,
                        name: data && data[name] && data[name].name
                    });
                    break;
                case "start":
                    saveLocation({
                        path: path
                    });
                    break;
                default:
            }
        };
    };
};

;// CONCATENATED MODULE: ./src/client/store.js
function store_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function store_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return store_arrayLikeToArray(arr);
}
function store_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function store_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function store_toConsumableArray(arr) {
    return store_arrayWithoutHoles(arr) || store_iterableToArray(arr) || store_unsupportedIterableToArray(arr) || store_nonIterableSpread();
}
function store_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return store_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return store_arrayLikeToArray(o, minLen);
}






var sagaMiddleware = (0,redux_saga_core_npm_proxy_esm/* default */.ZP)();
var middleware = [
    sagaMiddleware,
    data_layer/* default */.Z,
    save_location
];
if (false) { var createLogger; }
var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || redux.compose;
var store_initialState = window.INITIAL_STATE;
var store = (0,redux.createStore)(src_reducers, store_initialState, composeEnhancers(redux.applyMiddleware.apply(void 0, store_toConsumableArray(middleware))));
window.registerSaga = function(saga) {
    sagaMiddleware.run(saga);
};
src_sagas.forEach(sagaMiddleware.run);
/* harmony default export */ const client_store = (store);


/***/ }),

/***/ 22362:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QN": () => (/* binding */ AdContext),
/* harmony export */   "kX": () => (/* binding */ AdContextContainerWithExperiments)
/* harmony export */ });
/* unused harmony exports AdContextContainerPreConnected, AdContextContainer */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40507);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95939);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38209);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_throttle__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18026);
/* harmony import */ var src_components_experiment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75234);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89311);
/* harmony import */ var _helpers_cookie__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(54274);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}








(0,_helpers_cookie__WEBPACK_IMPORTED_MODULE_7__/* .updateAdContextCookie */ .Ny)();
var adContextCookie = (0,_helpers_cookie__WEBPACK_IMPORTED_MODULE_7__/* .getAdContextCookie */ .RT)();
var AdContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createContext();
AdContext.displayName = "AdContext";
var AdContextContainerPreConnected = function(param) {
    var children = param.children, ads = param.ads, experiments = param.experiments;
    var ref = _slicedToArray(react__WEBPACK_IMPORTED_MODULE_0__.useState((0,_helpers__WEBPACK_IMPORTED_MODULE_6__/* .getBrowserState */ .G0)()), 2), browserState = ref[0], setBrowserState = ref[1];
    var context = react__WEBPACK_IMPORTED_MODULE_0__.useContext(src_components_app_context__WEBPACK_IMPORTED_MODULE_4__/* .AppContext */ .Il);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function() {
        var resizeHandler = lodash_throttle__WEBPACK_IMPORTED_MODULE_3___default()(function() {
            return setBrowserState((0,_helpers__WEBPACK_IMPORTED_MODULE_6__/* .getBrowserState */ .G0)());
        }, 200);
        if (true) {
            window.addEventListener("resize", resizeHandler);
            window.addEventListener("orientationchange", resizeHandler);
        }
        // Cleanup
        return function() {
            if (true) {
                window.removeEventListener("resize", resizeHandler);
                window.removeEventListener("orientationchange", resizeHandler);
            }
        };
    }, []);
    var adContext = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function() {
        return {
            active: context.market.ads.active,
            market: context.market.code,
            experiments: experiments,
            state: {},
            actions: {
                log: function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    if (adContextCookie.debug) {
                        args.unshift("[AdContext]");
                        console.log.apply(null, args); // eslint-disable-line no-console
                    }
                }
            }
        };
    }, [
        context.market.ads.active,
        context.market.code,
        experiments
    ]);
    var value = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function() {
        return _objectSpreadProps(_objectSpread({}, adContext), {
            state: _objectSpread({}, browserState, ads)
        });
    }, [
        adContext,
        ads,
        browserState
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(AdContext.Provider, {
        value: value
    }, children);
};
var element = (prop_types__WEBPACK_IMPORTED_MODULE_1___default().element), object = (prop_types__WEBPACK_IMPORTED_MODULE_1___default().object), array = (prop_types__WEBPACK_IMPORTED_MODULE_1___default().array);
AdContextContainerPreConnected.propTypes = {
    children: element.isRequired,
    ads: object.isRequired,
    experiments: array
};
AdContextContainerPreConnected.defaultProps = {
    experiments: []
};
var AdContextContainer = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .connect */ .$j)(function(state, ownProps) {
    return {
        ads: state.ads,
        experiments: ownProps.experiments
    };
})(AdContextContainerPreConnected);
AdContextContainer.displayName = "AdContextContainer";
var AdContextContainerWithExperiments = function(param) {
    var children = param.children;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_experiment__WEBPACK_IMPORTED_MODULE_5__/* .ExperimentContext.Consumer */ .T.Consumer, null, function(experiments) {
        var selectedExperimentVariants = Object.keys(experiments.selectedVariants).map(function(experiment) {
            return {
                id: experiments.selectedVariants[experiment].optimizeId,
                variant: experiments.selectedVariants[experiment].variantIndex
            };
        }).filter(function(experiment) {
            return experiment.id;
        });
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(AdContextContainer, {
            experiments: selectedExperimentVariants
        }, children);
    });
};
AdContextContainerWithExperiments.propTypes = {
    children: element.isRequired
};


/***/ }),

/***/ 54274:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ny": () => (/* binding */ updateAdContextCookie),
/* harmony export */   "RT": () => (/* binding */ getAdContextCookie)
/* harmony export */ });
/* unused harmony export setAdContextCookie */
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var getAdContextCookie = function() {
    if (false) {}
    var cookies =  true ? document.cookie : 0;
    var cookieData = cookies.split(";").find(function(val) {
        return /^pj:ads/.test(val.trim());
    });
    var cookieValue = (cookieData || "").replace(/\s?pj:ads=/, "");
    try {
        return _objectSpread({}, JSON.parse(atob(cookieValue)));
    } catch (err) {
        return {};
    }
};
var setAdContextCookie = function(value) {
    if (false) {}
    var cookieValue = btoa(JSON.stringify(_objectSpread({}, getAdContextCookie(), value)));
    document.cookie = "pj:ads=".concat(cookieValue);
};
var getQueryParam = function(query, param) {
    var testRegexp = new RegExp("[&?]".concat(param, "\\b"));
    if (!testRegexp.test(query)) {
        return undefined;
    }
    var matchRegexp = new RegExp("[&?]".concat(param, "=([^&]+)"));
    var match = query.match(matchRegexp);
    return match && match.length > 1 ? match[1] : null;
};
var updateAdContextCookie = function() {
    if (false) {}
    var search = window.location.search;
    var values = [
        "ad_service",
        "ad_debug"
    ].reduce(function(result, param) {
        var paramValue = getQueryParam(search, param);
        return paramValue === undefined ? result : _objectSpreadProps(_objectSpread({}, result), _defineProperty({}, param.substr(3), paramValue));
    }, {});
    // Special case for appnexus test crew
    if (search.indexOf("appnexus=1") > -1) {
        values.service = "appnexus";
    }
    if (Object.keys(values).length) {
        setAdContextCookie(values);
    }
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    getAdContextCookie: getAdContextCookie,
    setAdContextCookie: setAdContextCookie,
    updateAdContextCookie: updateAdContextCookie
});


/***/ }),

/***/ 89311:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G0": () => (/* binding */ getBrowserState),
/* harmony export */   "Lu": () => (/* binding */ injectScript),
/* harmony export */   "X$": () => (/* binding */ loadGDPRTransparencyScript)
/* harmony export */ });
/* unused harmony exports SITEMODE_MOBILE, SITEMODE_DESKTOP, SITEMODE_BREAKPOINT, getSiteMode */
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61093);

var SITEMODE_MOBILE = "mobile";
var SITEMODE_DESKTOP = "desktop";
var SITEMODE_BREAKPOINT = src_components_base__WEBPACK_IMPORTED_MODULE_0__/* .breakpoints.smallOnly */ .AV.smallOnly;
var getSiteMode = function() {
    return  true && "matchMedia" in window && window.matchMedia(SITEMODE_BREAKPOINT).matches ? SITEMODE_MOBILE : SITEMODE_DESKTOP;
};
var getBrowserState = function() {
    return  true ? {
        windowWidth: window.innerWidth,
        windowHeight: window.innerHeight,
        siteMode: getSiteMode()
    } : 0;
};
var injectScript = function(source, isLoaded) {
    var numRetries = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 10;
    return new Promise(function(resolve, reject) {
        if (typeof isLoaded === "function" && isLoaded()) {
            resolve();
            return;
        }
        var retries = numRetries;
        var done = function() {
            requestAnimationFrame(function() {
                if (typeof isLoaded !== "function" || isLoaded()) {
                    resolve();
                } else if (retries >= 0) {
                    retries--; // eslint-disable-line no-plusplus
                    setTimeout(function() {
                        return done();
                    }, 50);
                }
            });
        };
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.src = source;
        script.onload = done;
        script.onerror = reject;
        (document.head || document.getElementsByTagName("head")[0]).appendChild(script);
    });
};
var loadGDPRTransparencyScript = function() {
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src = "//cogwheel.inventory.schibsted.io/prod/latest/gdpr-bundle.js";
    (document.head || document.getElementsByTagName("head")[0]).appendChild(script);
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    getSiteMode: getSiteMode,
    getBrowserState: getBrowserState,
    injectScript: injectScript
});


/***/ }),

/***/ 83982:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BZ": () => (/* binding */ PAGETYPE_KEYWORD),
/* harmony export */   "Dy": () => (/* binding */ PAGETYPE_CAMPAIGN),
/* harmony export */   "II": () => (/* binding */ PAGETYPE_ROOT),
/* harmony export */   "LE": () => (/* binding */ pageTypeIsRoot),
/* harmony export */   "Ms": () => (/* binding */ PAGETYPE_BRAND),
/* harmony export */   "P": () => (/* binding */ PAGETYPE_PRODUCT),
/* harmony export */   "Tf": () => (/* binding */ PAGETYPE_STORE),
/* harmony export */   "Tj": () => (/* binding */ PAGETYPE_OTHER),
/* harmony export */   "UZ": () => (/* binding */ SCH_PAGETYPE_FRONT),
/* harmony export */   "VV": () => (/* binding */ PAGETYPE_CATEGORY),
/* harmony export */   "VW": () => (/* binding */ SCH_PAGETYPE_OBJECT),
/* harmony export */   "vg": () => (/* binding */ SCH_PAGETYPE_OTHER),
/* harmony export */   "xG": () => (/* binding */ SCH_PAGETYPE_SECTION)
/* harmony export */ });
/* unused harmony exports SCH_PAGETYPE_ARTICLE, SCH_PAGETYPE_MYPAGES, SCH_PAGETYPE_RESULT */
var PAGETYPE_ROOT = "index";
var PAGETYPE_PRODUCT = "product";
var PAGETYPE_CATEGORY = "category";
var PAGETYPE_KEYWORD = "kwlp";
var PAGETYPE_CAMPAIGN = "campaign";
var PAGETYPE_STORE = "shop";
var PAGETYPE_BRAND = "manufacturer";
var PAGETYPE_OTHER = "other";
var pageTypeIsRoot = function(pageType) {
    return pageType === PAGETYPE_ROOT;
};
// "Schibstedt page types"
var SCH_PAGETYPE_ARTICLE = "article";
var SCH_PAGETYPE_FRONT = "front";
var SCH_PAGETYPE_MYPAGES = "mypages";
var SCH_PAGETYPE_OBJECT = "object";
var SCH_PAGETYPE_OTHER = "other";
var SCH_PAGETYPE_RESULT = "result";
var SCH_PAGETYPE_SECTION = "section";
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    PAGETYPE_ROOT: PAGETYPE_ROOT,
    PAGETYPE_PRODUCT: PAGETYPE_PRODUCT,
    PAGETYPE_CATEGORY: PAGETYPE_CATEGORY,
    PAGETYPE_CAMPAIGN: PAGETYPE_CAMPAIGN,
    PAGETYPE_STORE: PAGETYPE_STORE,
    PAGETYPE_BRAND: PAGETYPE_BRAND,
    PAGETYPE_OTHER: PAGETYPE_OTHER,
    pageTypeIsRoot: pageTypeIsRoot
});


/***/ }),

/***/ 10440:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ii": () => (/* binding */ getAdService)
});

// UNUSED EXPORTS: AD_SERVICES, default

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./src/components/ads/helpers/index.js
var helpers = __webpack_require__(89311);
;// CONCATENATED MODULE: ./src/components/ads/services/appnexus/helpers.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var getUpdates = function(prevState, newState, keys) {
    return keys.reduce(function(result, key) {
        return _objectSpreadProps(_objectSpread({}, result), _defineProperty({}, key, prevState[key] !== newState[key]));
    }, {});
};
var isLoaded = function() {
    return  true && typeof window.apntag !== "undefined";
};
var get = function() {
    return isLoaded() ? window.apntag : null;
};
/* harmony default export */ const appnexus_helpers = ({
    getUpdates: getUpdates,
    isLoaded: isLoaded,
    get: get
});

// EXTERNAL MODULE: ./src/components/ads/helpers/pagetype.js
var pagetype = __webpack_require__(83982);
;// CONCATENATED MODULE: ./src/components/ads/helpers/placement.js


var shape = (prop_types_default()).shape, string = (prop_types_default()).string, bool = (prop_types_default()).bool, number = (prop_types_default()).number, arrayOf = (prop_types_default()).arrayOf;
// Represents the placement data we fetch from API
var PlacementType = shape({
    platform: string.isRequired,
    categoryId: string.isRequired,
    countryCode: string.isRequired,
    isVirtual: bool.isRequired,
    containerId: string.isRequired,
    containerName: string.isRequired,
    placementCode: string.isRequired,
    sizes: arrayOf(arrayOf(number.isRequired)).isRequired
});
var findPlacement = function(placementsMap, placementName, pathChain, pageType, siteMode) {
    var pathArray = Array.isArray(pathChain) ? pathChain.slice().reverse() : [];
    if ((0,pagetype/* pageTypeIsRoot */.LE)(pageType)) {
        pathArray.push("root");
    }
    pathArray.push("fallback");
    for(var i = 0; i < pathArray.length; i += 1){
        var key = "".concat(siteMode, ":").concat(placementName, ":").concat(pathArray[i]);
        if (placementsMap[key]) {
            return key;
        }
    }
    return null;
};
/* harmony default export */ const placement = ({
    PlacementType: PlacementType,
    findPlacement: findPlacement
});

;// CONCATENATED MODULE: ./src/components/ads/context/type.js

var type_bool = (prop_types_default()).bool, type_string = (prop_types_default()).string, type_shape = (prop_types_default()).shape, object = (prop_types_default()).object, type_number = (prop_types_default()).number, type_arrayOf = (prop_types_default()).arrayOf, oneOfType = (prop_types_default()).oneOfType, func = (prop_types_default()).func;
/* harmony default export */ const type = (type_shape({
    active: type_bool,
    market: type_string,
    config: object,
    service: object,
    state: type_shape({
        siteName: type_string,
        siteMode: type_string,
        priceData: type_number,
        pageType: type_string,
        pathKey: type_string,
        pathChain: type_arrayOf(oneOfType([
            type_string,
            type_number
        ])),
        windowWidth: type_number,
        windowHeight: type_number,
        placementsMap: object
    }),
    actions: type_shape({
        setService: func,
        createAd: func
    })
}));

;// CONCATENATED MODULE: ./src/components/ads/services/appnexus/provider.js
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function provider_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function provider_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            provider_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function provider_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function provider_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        provider_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}








var PANORAMA_WIDTH = 980;
var TAKEOVER_LARGE_WIDTH = 1600;
var TAKEOVER_LARGE_HEIGHT = 120;
var TAKEOVER_BIG_L_HEIGHT = 240;
var AppNexusProvider = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    _inherits(AppNexusProvider, _PureComponent);
    var _super = _createSuper(AppNexusProvider);
    function AppNexusProvider(props) {
        _classCallCheck(this, AppNexusProvider);
        var _this;
        _this = _super.call(this, props);
        _this.definedTags = [];
        _this.loadedTags = [];
        _this.apntag = {
            anq: []
        };
        _this.log = props.adContext.actions.log;
        _this.uniqueIdCounter = 0;
        _this.registeredAds = [];
        _this.state = {
            context: {
                register: function(ad) {
                    var uniqueId = _this.getUniqueId();
                    _this.registeredAds.push({
                        id: uniqueId,
                        update: ad.update
                    });
                    return uniqueId;
                },
                unregister: function(ad) {
                    _this.registeredAds = _this.registeredAds.filter(function(param) {
                        var id = param.id;
                        return ad.id !== id;
                    });
                },
                update: function() {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = _this.registeredAds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var ad = _step.value;
                            ad.update();
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                },
                actions: {
                    reload: function(flush) {
                        return _this.reload(flush);
                    },
                    queue: function(action) {
                        return _this.queue(action);
                    },
                    defineTag: function(placement, asyncTag) {
                        return _this.defineTag(placement, asyncTag);
                    },
                    findPlacement: function(placement) {
                        return _this.findPlacement(placement);
                    },
                    getPlacementOptions: function(placement) {
                        return _this.getPlacementOptions(placement);
                    }
                }
            }
        };
        _this.abortIdle = null;
        return _this;
    }
    _createClass(AppNexusProvider, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                if (window && window.requestIdleCallback) {
                    var idleHandler = window.requestIdleCallback(this.init.bind(this), {
                        timeout: 10000
                    });
                    this.abortIdle = function() {
                        window.cancelIdleCallback(idleHandler);
                        _this.abortIdle = null;
                    };
                } else {
                    this.init();
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.abortIdle) {
                    this.abortIdle();
                }
                this.queue(function(apntag) {
                    return apntag.offEvent("adLoaded");
                });
                this.flush();
            }
        },
        {
            key: "init",
            value: function init() {
                var _this = this;
                var loadGDPRScript = this.props.config.loadGDPRScript;
                (0,helpers/* injectScript */.Lu)(this.props.config.lib, isLoaded).then(function() {
                    _this.log("[AppNexus] LIB LOADED");
                    var queue = _this.apntag.anq;
                    _this.apntag = get();
                    queue.forEach(function(item) {
                        return _this.apntag.anq.push(item);
                    });
                    _this.reload(false);
                    if (loadGDPRScript) {
                        (0,helpers/* loadGDPRTransparencyScript */.X$)();
                    }
                }).catch(function() {
                    if (window.dataLayer) {
                        window.dataLayer.push({
                            adblock: "active"
                        });
                    }
                });
                this.queue(function(apntag) {
                    apntag.onEvent("adLoaded", function(obj) {
                        _this.loadedTags.push(obj);
                        if (obj.targetId.includes("ad_panorama_top")) {
                            var isTakeoverFormat = obj.width > PANORAMA_WIDTH;
                            _this.setState(function(prevState) {
                                return provider_objectSpreadProps(provider_objectSpread({}, prevState), {
                                    context: provider_objectSpreadProps(provider_objectSpread({}, prevState.context), {
                                        takeover: isTakeoverFormat ? {
                                            width: obj.width,
                                            height: obj.height,
                                            offgrid: obj.width >= TAKEOVER_LARGE_WIDTH,
                                            topMargin: obj.width < TAKEOVER_LARGE_WIDTH ? TAKEOVER_BIG_L_HEIGHT : TAKEOVER_LARGE_HEIGHT
                                        } : undefined
                                    })
                                });
                            });
                        }
                    });
                });
            }
        },
        {
            key: "queue",
            value: function queue(action) {
                this.apntag.anq.push(function() {
                    return action(get());
                });
            }
        },
        {
            key: "flush",
            value: function flush() {
                this.log("[AppNexus] FLUSH");
                this.queue(function(apntag) {
                    return apntag.clearRequest();
                });
                this.uniqueIdCounter %= 10000;
            }
        },
        {
            key: "reload",
            value: function reload() {
                var flush = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                var _this = this;
                // Use flush to reload all ads on page
                if (flush) {
                    this.flush();
                }
                // Use this hack to ensure AdContainers are rendered/updated
                window.requestAnimationFrame(function() {
                    _this.loadTags();
                });
            }
        },
        {
            key: "getPageOpts",
            value: function getPageOpts() {
                var _adContext = this.props.adContext, market = _adContext.market, _experiments = _adContext.experiments, experiments = _experiments === void 0 ? [] : _experiments, _state = _adContext.state, siteMode = _state.siteMode, siteName = _state.siteName, pageType = _state.pageType, pathChain = _state.pathChain, brand = _state.brand, priceData = _state.priceData, schPageType = _state.schPageType, _searchQuery = _state.searchQuery, searchQuery = _searchQuery === void 0 ? "" : _searchQuery, view = _state.view;
                var pageOpts = this.props.config.pageOpts;
                var location = window.location, screen = window.screen, innerHeight = window.innerHeight, innerWidth = window.innerWidth;
                var adTestMode = location.search ? location.search.indexOf("adtest=1") > -1 : false;
                var test = adTestMode ? "-Test" : "";
                var publisher = "".concat(market.toUpperCase(), "-").concat(siteName).concat(test);
                var supplyType = siteMode === "desktop" ? "web_desktop" : "web_phone";
                var pagegen = [
                    "mobile",
                    "desktop"
                ].includes(this.context.renderMode) ? "classic" : this.context.market.ads.pageGen;
                var ads = this.context.market.ads;
                if (ads && ads.memberIdOverride) {
                    pageOpts.member = ads.memberIdOverride;
                }
                var referrer = AppNexusProvider.getReferrer();
                var pageTypeSearch = view === "search" ? "search" : undefined;
                var brandKeywordKey = "se-generic-brand";
                var searchQueryParam = searchQuery;
                if (pageTypeSearch) {
                    var ref;
                    var searchParams = new URLSearchParams(window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.search);
                    searchQueryParam = searchParams.get("search") || "";
                }
                return provider_objectSpreadProps(provider_objectSpread({}, pageOpts), {
                    keywords: provider_objectSpread(provider_objectSpreadProps(provider_objectSpread({}, pageOpts.keywords), {
                        "aa-sch-page_type": pageTypeSearch || schPageType,
                        "aa-sch-supply_type": supplyType,
                        "aa-sch-country_code": adTestMode ? "te" : market,
                        "aa-sch-publisher": publisher,
                        "se-generic-pagegen": pagegen,
                        "se-generic-appmode": "notinapp",
                        "se-generic-screenheight": screen.height,
                        "se-generic-screenwidth": screen.width,
                        "se-generic-viewportheight": innerHeight,
                        "se-generic-viewportwidth": innerWidth,
                        "se-generic-sitemode": siteMode,
                        "se-generic-page": pageTypeSearch || pageType,
                        "se-generic-price": priceData,
                        "se-generic-experiments": experiments.map(function(experiment) {
                            return "".concat(experiment.id, ":").concat(experiment.variant);
                        }).join(","),
                        "se-generic-section": pathChain,
                        "se-generic-searchword": searchQueryParam,
                        "se-prisjakt-section": pageType === pagetype/* PAGETYPE_PRODUCT */.P && Array.isArray(pathChain) && pathChain.length ? pathChain.slice(0, -1).concat("p".concat(pathChain[pathChain.length - 1])) : pathChain
                    }), referrer && {
                        "se-generic-test": referrer
                    }, brand && brand.name && provider_defineProperty({}, brandKeywordKey, brand.name.toLowerCase()), market === "no" && {
                        "NO-SNO-Prisjakt-Page": pageType,
                        "NO-SNO-Prisjakt-Section": pathChain
                    })
                });
            }
        },
        {
            /**
   * A counter to give each ad placement a unique (HTML element) ID.
   */ key: "getUniqueId",
            value: function getUniqueId() {
                return this.uniqueIdCounter++; // eslint-disable-line no-plusplus
            }
        },
        {
            key: "findPlacement",
            value: function findPlacement1(placement) {
                var state = this.props.adContext.state;
                var key = findPlacement(state.placementsMap, placement, state.pathChain, state.pageType, state.siteMode);
                this.log("[AppNexus] LOOKING FOR PLACEMENT", placement, key);
                var placementOptions = key ? provider_objectSpreadProps(provider_objectSpread({}, state.placementsMap[key], this.getPlacementOptions(placement)), {
                    key: key,
                    containerId: "".concat(state.placementsMap[key].containerId, "-").concat(this.getUniqueId())
                }) : null;
                return placementOptions;
            }
        },
        {
            key: "getPlacementOptions",
            value: function getPlacementOptions(placement) {
                var placementOptions = this.props.config.placementOptions;
                return placementOptions && placementOptions[placement] ? placementOptions[placement] : {};
            }
        },
        {
            key: "defineTag",
            value: function defineTag(placement) {
                var asyncTag = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                this.log("[AppNexus] DEFINE TAG", placement);
                this.definedTags.push(placement);
                if (asyncTag) {
                    this.loadTags();
                }
            }
        },
        {
            key: "loadTags",
            value: function loadTags() {
                var _this = this;
                var market = this.props.adContext.market;
                var allowedFormats = this.props.config.allowedFormats;
                var pageOpts = this.getPageOpts();
                this.queue(function(apntag) {
                    _this.log("[AppNexus] LOAD TAGS", _this.definedTags);
                    apntag.setPageOpts(pageOpts);
                    _this.definedTags.forEach(function(tag) {
                        var containerId = tag.containerId, placementCode = tag.placementCode, sizes = tag.sizes, formats = tag.formats;
                        var adSizes = sizes;
                        apntag.defineTag({
                            invCode: placementCode,
                            targetId: containerId,
                            allowedFormats: allowedFormats,
                            sizes: sizes,
                            keywords: provider_objectSpread({
                                "se-generic-adformat": formats,
                                "se-generic-adsize": adSizes.map(function(size) {
                                    return size.join("x");
                                })
                            }, market === "no" && {
                                "NO-SNO-Adformat": formats
                            })
                        });
                    });
                    apntag.loadTags();
                    _this.definedTags = [];
                    _this.loadedTags = [];
                });
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var updates = getUpdates(prevProps.adContext.state, this.props.adContext.state, [
                    "pathKey",
                    "pageType",
                    "siteMode",
                    "view"
                ]);
                if (Object.values(updates).some(function(item) {
                    return !!item;
                })) {
                    var onlyViewUpdated = Object.keys(updates).every(function(key) {
                        return !updates[key] || key === "view" && updates.view;
                    });
                    this.reload(!onlyViewUpdated);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var BaseProvider = this.props.baseProvider;
                return /*#__PURE__*/ react.createElement(BaseProvider, {
                    value: this.state.context
                }, this.props.children);
            }
        }
    ], [
        {
            key: "getReferrer",
            value: function getReferrer() {
                var ref;
                var searchQuery = window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.search;
                if (!searchQuery) {
                    return undefined;
                }
                var searchParams = new URLSearchParams(searchQuery);
                return searchParams.get("ad");
            }
        }
    ]);
    return AppNexusProvider;
}(react.PureComponent);
var provider_element = (prop_types_default()).element, provider_object = (prop_types_default()).object, provider_func = (prop_types_default()).func, provider_shape = (prop_types_default()).shape;
AppNexusProvider.propTypes = {
    adContext: type.isRequired,
    baseProvider: provider_object.isRequired,
    config: provider_object.isRequired,
    children: provider_element.isRequired
};
AppNexusProvider.contextType = app_context/* AppContext */.Il;
var AppNexusContextType = provider_shape({
    actions: provider_shape({
        queue: provider_func,
        defineTag: provider_func,
        findPlacement: provider_func,
        getPlacementOptions: provider_func
    })
});
/* harmony default export */ const provider = (AppNexusProvider);

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/throttle.js
var throttle = __webpack_require__(38209);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 24 modules
var es = __webpack_require__(95939);
// EXTERNAL MODULE: ./src/components/ads/context/withAds.tsx
var withAds = __webpack_require__(38817);
// EXTERNAL MODULE: ./src/components/ads/services/appnexus/styles.ts
var styles = __webpack_require__(59533);
// EXTERNAL MODULE: ./src/components/ads/constants.ts
var constants = __webpack_require__(85505);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-dom@18.2.0_react@18.2.0/node_modules/react-dom/index.js
var react_dom = __webpack_require__(10422);
;// CONCATENATED MODULE: ./src/components/ads/services/appnexus/container.js
function container_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function container_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function container_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function container_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) container_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) container_defineProperties(Constructor, staticProps);
    return Constructor;
}
function container_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function container_getPrototypeOf(o) {
    container_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return container_getPrototypeOf(o);
}
function container_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) container_setPrototypeOf(subClass, superClass);
}
function container_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            container_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function container_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function container_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        container_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function container_possibleConstructorReturn(self, call) {
    if (call && (container_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return container_assertThisInitialized(self);
}
function container_setPrototypeOf(o, p) {
    container_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return container_setPrototypeOf(o, p);
}
var container_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function container_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function container_createSuper(Derived) {
    var hasNativeReflectConstruct = container_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = container_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = container_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return container_possibleConstructorReturn(this, result);
    };
}













var adLoadedAction = function(placement, obj) {
    return {
        type: "AD_LOADED",
        placement: placement,
        ad: container_objectSpreadProps(container_objectSpread({}, obj), {
            revenue: obj.cpm_publisher_currency * 0.001
        })
    };
};
var HAS_BID_STATES = Object.freeze({
    MAYBE: "MAYBE",
    YES: "YES",
    NO: "NO"
});
var AppNexusContainer = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    container_inherits(AppNexusContainer, _PureComponent);
    var _super = container_createSuper(AppNexusContainer);
    function AppNexusContainer(props) {
        container_classCallCheck(this, AppNexusContainer);
        var _this;
        _this = _super.call(this, props);
        _this.formats = props.formats.concat(props.format).filter(Boolean);
        if (!_this.formats || _this.formats.length === 0) {
            throw new Error("Missing format for ad container with placement: ".concat(props.placement));
        }
        _this.containerId = null;
        _this.state = {
            width: undefined,
            height: undefined,
            placementId: null,
            placementKey: null,
            placementOptions: null,
            hasBid: HAS_BID_STATES.MAYBE,
            updating: false
        };
        _this.adContainerRef = /*#__PURE__*/ (0,react.createRef)();
        _this.log = props.adContext ? props.adContext.actions.log : function() {};
        _this.log("[AppNexus:Ad] CREATED", props.placement);
        _this.resizeHandler = throttle_default()(function() {
            return requestAnimationFrame(function() {
                return _this.handleScalable();
            });
        }, 200);
        return _this;
    }
    container_createClass(AppNexusContainer, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                window.addEventListener("resize", this.resizeHandler);
                window.addEventListener("orientationchange", this.resizeHandler);
                if (this.props.async) this.updateCurrentPlacement();
                if (this.props.adServiceContext) {
                    this.containerId = this.props.adServiceContext.register({
                        update: this.updateCurrentPlacement.bind(this)
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                window.removeEventListener("resize", this.resizeHandler);
                window.removeEventListener("orientationchange", this.resizeHandler);
                if (this.state.placementId) {
                    this.removeListeners(this.state.placementId);
                }
                if (this.props.adServiceContext) {
                    this.props.adServiceContext.unregister({
                        id: this.containerId
                    });
                }
            }
        },
        {
            key: "isWithinLimits",
            value: function isWithinLimits() {
                var windowWidth = this.props.adContext.state.windowWidth;
                var _props = this.props, min = _props.min, max = _props.max;
                return (min === undefined || min < windowWidth) && (max === undefined || max > windowWidth);
            }
        },
        {
            key: "isTakeover",
            value: function isTakeover() {
                var _state = this.state, placementId = _state.placementId, width = _state.width;
                if (!placementId) {
                    return false;
                }
                return placementId.indexOf("ad_panorama_top") === 0 && width > 980;
            }
        },
        {
            key: "updateCurrentPlacement",
            value: function updateCurrentPlacement() {
                var _this = this;
                if (this.state.updating) {
                    this.log("[AppNexus:Ad] ABORT UPDATE");
                    return;
                }
                this.setState({
                    placementId: null,
                    placementKey: null,
                    placementOptions: null,
                    updating: true
                }, function() {
                    var actions = _this.props.adServiceContext.actions;
                    var placementOptions = actions.findPlacement(_this.props.placement);
                    var placementKey = placementOptions ? placementOptions.key : null;
                    if (placementKey) {
                        _this.setState({
                            placementId: placementOptions.containerId,
                            placementKey: placementOptions.key,
                            placementOptions: placementOptions,
                            updating: false
                        });
                    } else {
                        _this.setState({
                            updating: false
                        });
                    }
                });
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var _state = this.state, placementId = _state.placementId, placementKey = _state.placementKey, placementOptions = _state.placementOptions;
                var stateUpdates = getUpdates(prevState, this.state, [
                    "placementId",
                    "placementKey"
                ]);
                var viewUpdates = getUpdates(prevProps.adContext.state, this.props.adContext.state, [
                    "view"
                ]);
                if (Object.values(viewUpdates).some(function(item) {
                    return !!item;
                }) && this.state.placementId) {
                    // Triggers visiblity update
                    this.props.onStatusChange({
                        targetId: this.state.placementId
                    }, "adViewUpdated");
                }
                if (stateUpdates.placementId) {
                    this.log("[AppNexus:Ad] PLACEMENT UPDATE", "| ".concat(prevState.placementId, " > ").concat(placementId), "| ".concat(prevState.placementKey, " > ").concat(placementKey));
                    if (placementId) {
                        this.addListeners(placementId);
                    }
                    if (prevState.placementId) {
                        this.removeListeners(prevState.placementId);
                    }
                    this.props.onStatusChange({
                        targetId: placementId
                    }, "adUpdated");
                }
                if (stateUpdates.placementKey && placementOptions) {
                    this.props.adServiceContext.actions.defineTag(container_objectSpreadProps(container_objectSpread({}, placementOptions), {
                        formats: this.formats
                    }), this.props.async);
                }
                var becameVisible = !prevProps.isVisible && this.props.isVisible;
                var becameReady = !prevProps.isReady && this.props.isReady;
                if ((becameVisible || becameReady) && this.props.isReady && this.props.isVisible && this.state.hasBid === HAS_BID_STATES.YES) {
                    this.log("[AppNexus:Ad] VISIBLE", this.props.placement);
                    this.props.onStatusChange({
                        targetId: placementId
                    }, "adReady");
                    if (this.props.autoLoad) {
                        this.props.adServiceContext.actions.queue(function(apntag) {
                            apntag.showTag(placementId);
                        });
                    }
                }
            }
        },
        {
            key: "addListeners",
            value: function addListeners(id) {
                var _this = this;
                this.props.adServiceContext.actions.queue(function(apntag) {
                    apntag.onEvent("adAvailable", id, function(obj) {
                        _this.log("[AppNexus:Ad] adAvailable", id);
                        // flusync is needed to prevent batching, at the time of React 18.1 at least.
                        (0,react_dom.flushSync)(function() {
                            _this.setState({
                                hasBid: HAS_BID_STATES.YES
                            }, function() {
                                _this.handleScalable();
                                _this.props.onStatusChange(obj, "adAvailable");
                            });
                        });
                        if (_this.props.isVisible && _this.props.isReady) {
                            _this.log("[AppNexus:Ad] VISIBLE ON LOAD", id);
                            _this.props.onStatusChange(obj, "adReady");
                            if (_this.props.autoLoad) {
                                apntag.showTag(id);
                            }
                        }
                    });
                    apntag.onEvent("adLoaded", id, function(obj) {
                        _this.log("[AppNexus:Ad] adLoaded", id, obj);
                        _this.props.onStatusChange(obj, "adLoaded");
                        _this.props.adLoadedAction(_this.props.placement, obj);
                        _this.setState({
                            width: obj.width,
                            height: obj.height
                        });
                    });
                    apntag.onEvent("adNoBid", id, function(obj) {
                        _this.log("[AppNexus:Ad] adNoBid", id);
                        _this.setState({
                            hasBid: HAS_BID_STATES.NO
                        }, function() {
                            return _this.props.onStatusChange(obj, "adNoBid");
                        });
                    });
                });
            }
        },
        {
            key: "removeListeners",
            value: function removeListeners(id) {
                this.props.adServiceContext.actions.queue(function(apntag) {
                    apntag.offEvent("adAvailable", id);
                    apntag.offEvent("adLoaded", id);
                    apntag.offEvent("adNoBid", id);
                });
            }
        },
        {
            key: "handleScalable",
            value: function handleScalable() {
                var scalable = this.props.scalable;
                var adContainer = this.adContainerRef.current;
                if (!adContainer || !scalable || this.isTakeover()) {
                    return;
                }
                var _props = this.props, scaleBase = _props.scaleBase, scaleParent = _props.scaleParent, scaleOrigin = _props.scaleOrigin;
                var scaleBaseElement = adContainer.closest(scaleBase);
                var containerWidth = adContainer.offsetWidth;
                var baseWidth = scaleBaseElement ? scaleBaseElement.offsetWidth : window.innerWidth;
                // Do not resize when base is larger than ad, reset any transformations
                var scaleBy = baseWidth / containerWidth;
                if (scaleBy > 1) {
                    adContainer.style.transform = "none";
                    if (scaleParent) {
                        var parentEl = adContainer.closest(scaleParent);
                        parentEl.style.height = "auto";
                        parentEl.style.width = "auto";
                    }
                    return;
                }
                adContainer.style.transform = "scale(".concat(scaleBy, ")");
                adContainer.style.transformOrigin = scaleOrigin;
                // Scaled elements as the one above will not affect parent nodes, i.e.
                // containers will not adapt to a scaled child element, adjust dimensions to match.
                if (scaleParent) {
                    var parentEl1 = adContainer.closest(scaleParent);
                    var offsetHeight = adContainer.offsetHeight, offsetWidth = adContainer.offsetWidth;
                    var ref = this.props.spacing || {}, _top = ref.top, top = _top === void 0 ? 0 : _top, _bottom = ref.bottom, bottom = _bottom === void 0 ? 0 : _bottom;
                    var heightWithSpacing = offsetHeight + parseInt(top, 10) + parseInt(bottom, 10);
                    parentEl1.style.height = "".concat(Math.round(heightWithSpacing * scaleBy), "px");
                    parentEl1.style.width = "".concat(Math.round(offsetWidth * scaleBy), "px");
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var shouldRenderAd = Boolean(this.state.placementOptions && this.state.hasBid === HAS_BID_STATES.YES && this.props.isReady && this.isWithinLimits());
                if (!shouldRenderAd) {
                    return null;
                }
                var _props = this.props, spacing = _props.spacing, order = _props.order;
                var placementId = this.state.placementId;
                return /*#__PURE__*/ react.createElement(styles/* AdPlacementWrapper */.G, {
                    isTakeover: this.isTakeover(),
                    style: {
                        order: order,
                        width: this.props.width || this.state.width || 0,
                        height: this.props.height || this.state.height || 0,
                        marginTop: spacing && !this.isTakeover() && spacing.top || 0,
                        marginBottom: spacing && spacing.bottom || 0
                    }
                }, /*#__PURE__*/ react.createElement(styles/* AdPlacementContainer */.zM, {
                    id: placementId,
                    ref: this.adContainerRef,
                    className: constants/* adBlockerClassName */._,
                    isTakeover: this.isTakeover()
                }, /*#__PURE__*/ react.createElement(styles/* AdCogwheel */.tO, {
                    id: "".concat(placementId, "-button")
                }), this.props.children));
            }
        }
    ]);
    return AppNexusContainer;
}(react.PureComponent);
var container_string = (prop_types_default()).string, container_bool = (prop_types_default()).bool, container_number = (prop_types_default()).number, container_func = (prop_types_default()).func, node = (prop_types_default()).node, container_shape = (prop_types_default()).shape, container_arrayOf = (prop_types_default()).arrayOf;
AppNexusContainer.propTypes = {
    adContext: type.isRequired,
    adServiceContext: AppNexusContextType.isRequired,
    placement: container_string.isRequired,
    format: container_string,
    formats: container_arrayOf(container_string),
    min: container_number,
    max: container_number,
    width: container_string,
    height: container_string,
    adLoadedAction: (prop_types_default()).func,
    scalable: container_bool,
    scaleBase: container_string,
    scaleParent: container_string,
    scaleOrigin: container_string,
    isReady: container_bool,
    isVisible: container_bool,
    autoLoad: container_bool,
    onStatusChange: container_func,
    children: node,
    spacing: container_shape({
        top: container_string,
        bottom: container_string
    }),
    async: container_bool,
    order: container_number
};
AppNexusContainer.defaultProps = {
    min: undefined,
    max: undefined,
    format: undefined,
    formats: [],
    width: undefined,
    height: undefined,
    scalable: false,
    scaleBase: null,
    scaleParent: null,
    scaleOrigin: "top center",
    isReady: true,
    isVisible: true,
    autoLoad: true,
    onStatusChange: base/* noop */.ZT,
    adLoadedAction: base/* noop */.ZT,
    children: null,
    spacing: null,
    async: false,
    order: undefined
};
AppNexusContainer.contextType = app_context/* AppContext */.Il;
var AppNexusContainerWithAds = (0,withAds/* withAds */.I)(function(props) {
    return props.adContext && props.adServiceContext ? /*#__PURE__*/ react.createElement(AppNexusContainer, _extends({}, props)) : null;
});
AppNexusContainerWithAds.propTypes = {
    adContext: type,
    adServiceContext: AppNexusContextType
};
AppNexusContainerWithAds.defaultProps = {
    adContext: undefined,
    adServiceContext: undefined
};
/* harmony default export */ const container = ((0,es/* connect */.$j)(undefined, {
    adLoadedAction: adLoadedAction
})(AppNexusContainerWithAds));

;// CONCATENATED MODULE: ./src/components/ads/services/appnexus/index.js


/* harmony default export */ const appnexus = ({
    provider: provider,
    container: container
});

;// CONCATENATED MODULE: ./src/components/ads/services/index.js
function services_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function services_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            services_defineProperty(target, key, source[key]);
        });
    }
    return target;
}



var FallbackProvider = function(props) {
    return /*#__PURE__*/ react.createElement(props.baseProvider, {
        value: props.value
    }, props.children);
};
FallbackProvider.propTypes = {
    children: (prop_types_default()).element.isRequired
};
var fallback = {
    provider: FallbackProvider,
    container: function() {
        return null;
    }
};
var AD_SERVICES = {
    appnexus: services_objectSpread({}, fallback, appnexus),
    fallback: fallback
};
var getAdService = function(service) {
    return AD_SERVICES[service] || AD_SERVICES.fallback;
};
/* harmony default export */ const services = ({
    AD_SERVICES: AD_SERVICES,
    getAdService: getAdService
});


/***/ }),

/***/ 61093:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "VA": () => (/* reexport */ styled_theme),
  "ry": () => (/* reexport */ animation_utils_namespaceObject),
  "sF": () => (/* reexport */ animations),
  "D2": () => (/* reexport */ variables/* brandColors */.D2),
  "AV": () => (/* reexport */ variables/* breakpoints */.AV),
  "TV": () => (/* reexport */ browser_support),
  "$n": () => (/* reexport */ color_utils),
  "O9": () => (/* reexport */ variables/* colors */.O9),
  "bK": () => (/* reexport */ variables/* layout */.bK),
  "BC": () => (/* reexport */ variables/* media */.BC),
  "ZT": () => (/* binding */ noop),
  "A": () => (/* reexport */ variables/* pixelCalc */.A),
  "m4": () => (/* reexport */ variables/* ratingStarColors */.m4),
  "vR": () => (/* reexport */ variables/* remCalc */.vR),
  "au": () => (/* reexport */ styled_utils_namespaceObject)
});

// UNUSED EXPORTS: campaignColors, darkTheme, defaultTheme

// NAMESPACE OBJECT: ./src/components/base/src/animation-utils.js
var animation_utils_namespaceObject = {};
__webpack_require__.r(animation_utils_namespaceObject);
__webpack_require__.d(animation_utils_namespaceObject, {
  "easing": () => (easing),
  "tween": () => (tween)
});

// NAMESPACE OBJECT: ./src/components/base/src/styled-utils.ts
var styled_utils_namespaceObject = {};
__webpack_require__.r(styled_utils_namespaceObject);
__webpack_require__.d(styled_utils_namespaceObject, {
  "overlay": () => (overlay)
});

// EXTERNAL MODULE: ./src/components/base/styles/variables.ts
var variables = __webpack_require__(11093);
// EXTERNAL MODULE: ./src/components/base/src/color-utils.ts
var color_utils = __webpack_require__(55318);
// EXTERNAL MODULE: ./node_modules/.pnpm/raf@3.4.1/node_modules/raf/index.js
var raf = __webpack_require__(19616);
var raf_default = /*#__PURE__*/__webpack_require__.n(raf);
;// CONCATENATED MODULE: ./src/components/base/src/animation-utils.js

var easing = {
    easeOut: function(progress) {
        return progress * (2 - progress);
    }
};
function tween() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _from = ref.from, from = _from === void 0 ? 0 : _from, _to = ref.to, to = _to === void 0 ? 1 : _to, _duration = ref.duration, duration = _duration === void 0 ? 200 : _duration, _easingFunction = ref.easingFunction, easingFunction = _easingFunction === void 0 ? easing.easeOut : _easingFunction, _onUpdate = ref.// eslint-disable-next-line no-unused-vars
    onUpdate, onUpdate = _onUpdate === void 0 ? function(_) {} : _onUpdate, _onComplete = ref.onComplete, onComplete = _onComplete === void 0 ? function() {} : _onComplete;
    var update = function update(time) {
        var progress = duration === 0 ? 1 : Math.min(Math.max(0, (time - startTime) / duration), 1);
        var value = from + (to - from) * easingFunction(progress);
        onUpdate(value);
        return progress < 1;
    };
    var startTime;
    function animate(time) {
        if (startTime === undefined) {
            // Estimate start time to one frame ago (at 60 fps). We do it this way to get decently accurate timing without
            // having to mess with performance.now() compatibility.
            startTime = time - 1000 / 60;
        }
        var rafHandle = raf_default()(animate);
        var result = update(time);
        // If animation has finished, cancel it/unregister handle.
        if (!result) {
            raf_default().cancel(rafHandle);
            onComplete();
        }
    }
    raf_default()(animate);
}

// EXTERNAL MODULE: ./src/components/base/src/animations/index.ts + 1 modules
var animations = __webpack_require__(80370);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/light-theme-colors.js
var light_theme_colors = __webpack_require__(24774);
;// CONCATENATED MODULE: ./src/components/base/src/styled-utils.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  content: '';\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: ",
        ";\n  z-index: 1;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/**
 * An overlay helper that can be included within a pseudo-element like ::before or ::after, in
 * order to cover the whole area of the nearest positioning context with the specified color.
 *
 * Can be used instead of a background-color in order to avoid white boxes around e.g. product
 * images, which generally have a white background.
 */ var overlay = function(color) {
    return (0,styled_components_browser_esm.css)(_templateObject(), color || (0,color_utils.setRgbaAlpha)(light_theme_colors.base800, 0.04));
};

;// CONCATENATED MODULE: ./src/components/base/src/browser-support.js
var checks = {};
// Check if browser supports passive option for addEventListener
// See: https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
var passiveEventListener = function() {
    if (Object.keys(checks).includes("passiveEventListener")) {
        return checks.passiveEventListener;
    }
    try {
        var options = {
            // eslint-disable-next-line getter-return
            get passive () {
                checks.passiveEventListener = true;
            }
        };
        window.addEventListener("test", options, options);
        window.removeEventListener("test", options, options);
    } catch (err) {
        checks.passiveEventListener = false;
    }
    return checks.passiveEventListener;
};
/* harmony default export */ const browser_support = ({
    passiveEventListener: passiveEventListener
});

;// CONCATENATED MODULE: ./src/components/base/styles/themes/default.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var theme = {
    colors: _objectSpread({}, light_theme_colors),
    bg: {
        primary: light_theme_colors.base0,
        secondary: light_theme_colors.base100,
        tertiary: light_theme_colors.base200,
        quaternary: "#F0F2F3",
        overlay: (0,color_utils.setRgbaAlpha)(light_theme_colors.base700, "0.2"),
        productCompare: light_theme_colors.yellove500,
        productCompareLight: (0,color_utils.setRgbaAlpha)(light_theme_colors.yellove500, "0.05")
    },
    header: {
        bg: light_theme_colors.maybeBlue500,
        fg: light_theme_colors.base100
    },
    footer: {
        bg: {
            primary: light_theme_colors.base100,
            secondary: light_theme_colors.base100
        },
        fg: {
            primary: light_theme_colors.base600
        }
    },
    lines: {
        primary: light_theme_colors.base200,
        secondary: light_theme_colors.base300,
        tertiary: light_theme_colors.base500,
        quaternary: light_theme_colors.base700,
        highlight: light_theme_colors.maybeBlue700,
        groupHeader: light_theme_colors.yellove500
    },
    text: {
        primary: light_theme_colors.base800,
        secondary: light_theme_colors.base600,
        tertiary: light_theme_colors.base500,
        quaternary: light_theme_colors.base400,
        linkExternal: light_theme_colors.maybeBlue700,
        linkExternalHover: light_theme_colors.maybeBlue500,
        linkInternal: light_theme_colors.base700,
        linkInternalHover: light_theme_colors.base700,
        callToAction: light_theme_colors.maybeBlue700,
        callToActionHover: light_theme_colors.maybeBlue500,
        negative: light_theme_colors.negative700,
        positive: light_theme_colors.positive500
    },
    icons: {
        primary: light_theme_colors.base600,
        secondary: light_theme_colors.base500,
        tertiary: light_theme_colors.base400,
        quaternary: light_theme_colors.base300,
        light: light_theme_colors.base500,
        callToAction: light_theme_colors.maybeBlue700,
        callToActionHover: light_theme_colors.maybeBlue500,
        positive: light_theme_colors.positive500,
        negative: light_theme_colors.negative700
    },
    buttons: {
        primary: {
            bg: light_theme_colors.maybeBlue700,
            bgActive: light_theme_colors.maybeBlue100,
            text: light_theme_colors.base0,
            textHover: light_theme_colors.base0
        },
        secondary: {
            bg: light_theme_colors.base500,
            text: light_theme_colors.base0,
            textHover: light_theme_colors.base0
        },
        tertiary: {
            bg: light_theme_colors.base200,
            text: light_theme_colors.base700,
            textHover: light_theme_colors.base700
        },
        quarternary: {
            bg: light_theme_colors.base700,
            text: light_theme_colors.base0,
            textHover: light_theme_colors.base0
        },
        positive: {
            bg: light_theme_colors.positive700,
            text: light_theme_colors.base0,
            textHover: light_theme_colors.base0
        },
        negative: {
            bg: light_theme_colors.negative700,
            text: light_theme_colors.base0,
            textHover: light_theme_colors.base0
        },
        link: {
            bg: "transparent",
            text: light_theme_colors.maybeBlue700,
            textHover: light_theme_colors.maybeBlue500
        },
        disabled: {
            bg: light_theme_colors.base500,
            text: light_theme_colors.base0,
            textHover: light_theme_colors.base0
        },
        category: {
            bg: light_theme_colors.base0,
            bgActive: (0,color_utils.setRgbaAlpha)(light_theme_colors.maybeBlue700, "0.08"),
            text: light_theme_colors.base700,
            textHover: light_theme_colors.maybeBlue700
        },
        panning: {
            bg: "rgba(0, 0, 0, 0.6)",
            bgHover: "rgba(0, 0, 0, 0.4)",
            text: light_theme_colors.base0
        }
    },
    pill: {
        primary: {
            bg: light_theme_colors.maybeBlue700,
            text: light_theme_colors.base0
        },
        inverted: {
            bg: light_theme_colors.base0,
            text: light_theme_colors.base700
        }
    },
    inputs: {
        primary: {
            bg: light_theme_colors.base0,
            border: light_theme_colors.base500,
            borderFocus: light_theme_colors.maybeBlue700
        },
        secondary: {
            bg: light_theme_colors.base100,
            border: light_theme_colors.base100,
            borderFocus: light_theme_colors.maybeBlue700
        }
    },
    dropdowns: {
        primary: {
            bg: light_theme_colors.base0,
            hoverBackground: (0,color_utils.setRgbaAlpha)(light_theme_colors.maybeBlue700, "0.2"),
            borderRadius: "5px",
            borderColor: {
                active: light_theme_colors.base700,
                inactive: light_theme_colors.base700
            }
        },
        secondary: {
            bg: light_theme_colors.base0,
            hoverBackground: (0,color_utils.setRgbaAlpha)(light_theme_colors.maybeBlue700, "0.2"),
            borderRadius: 0,
            borderColor: {
                active: light_theme_colors.base200,
                inactive: "transparent"
            }
        }
    },
    placeholders: {
        bg: light_theme_colors.base100,
        fg: light_theme_colors.base300
    },
    cookieBanner: {
        bg: (0,color_utils.setRgbaAlpha)(light_theme_colors.base700, "0.9"),
        fg: light_theme_colors.base0
    },
    actionBar: {
        bg: light_theme_colors.base700,
        fg: light_theme_colors.base0,
        boxShadow: "0 -2px 10px 0 rgba(0, 0, 0, 0.2)"
    },
    ratings: {
        positive: {
            bg: light_theme_colors.positive300,
            fg: light_theme_colors.positive700
        },
        neutral: {
            bg: light_theme_colors.notice300,
            fg: light_theme_colors.yellove900
        },
        negative: {
            bg: light_theme_colors.negative300,
            fg: light_theme_colors.negative700
        },
        disabled: {
            bg: light_theme_colors.base200,
            fg: light_theme_colors.base500
        }
    },
    notifications: {
        info: {
            bg: (0,color_utils.setRgbaAlpha)(light_theme_colors.maybeBlue700, "0.04"),
            fg: light_theme_colors.maybeBlue700
        },
        issue: {
            bg: (0,color_utils.setRgbaAlpha)(light_theme_colors.negative300, "0.2"),
            fg: (0,color_utils.setRgbaAlpha)(light_theme_colors.negative700, "0.7")
        },
        neutral: {
            bg: light_theme_colors.base100,
            fg: light_theme_colors.base600
        }
    },
    promos: {
        bg: light_theme_colors.maybeBlue100,
        fg: light_theme_colors.base600
    }
};
/* harmony default export */ const themes_default = (theme);

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/dark-theme-colors.js
var dark_theme_colors = __webpack_require__(30294);
;// CONCATENATED MODULE: ./src/components/base/styles/themes/dark.ts
function dark_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function dark_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            dark_defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var darkTheme = {
    colors: dark_objectSpread({}, dark_theme_colors),
    bg: {
        primary: "#404040",
        secondary: dark_theme_colors.base600,
        tertiary: dark_theme_colors.base600,
        quaternary: (0,color_utils.setRgbaAlpha)(dark_theme_colors.base800, "0.06"),
        overlay: "#000",
        productCompare: dark_theme_colors.yellove500,
        productCompareLight: (0,color_utils.setRgbaAlpha)(dark_theme_colors.yellove500, "0.05")
    },
    header: {
        bg: dark_theme_colors.maybeBlue500,
        fg: dark_theme_colors.base100
    },
    footer: {
        bg: {
            primary: dark_theme_colors.base100,
            secondary: dark_theme_colors.base100
        },
        fg: {
            primary: dark_theme_colors.base600
        }
    },
    text: {
        primary: "white",
        secondary: "#eee",
        tertiary: "#bbb",
        quaternary: "#aaa",
        linkExternal: dark_theme_colors.maybeBlue700,
        linkExternalHover: dark_theme_colors.maybeBlue500,
        linkInternal: dark_theme_colors.base0,
        linkInternalHover: dark_theme_colors.base0,
        callToAction: dark_theme_colors.maybeBlue700,
        callToActionHover: dark_theme_colors.maybeBlue500,
        negative: dark_theme_colors.negative700,
        positive: dark_theme_colors.positive500
    },
    icons: {
        primary: dark_theme_colors.base600,
        secondary: dark_theme_colors.base500,
        tertiary: dark_theme_colors.base400,
        quaternary: dark_theme_colors.base300,
        light: dark_theme_colors.base500,
        callToAction: dark_theme_colors.maybeBlue700,
        callToActionHover: dark_theme_colors.maybeBlue500,
        positive: dark_theme_colors.positive300,
        negative: dark_theme_colors.negative700
    },
    lines: {
        primary: "#303030",
        secondary: "#202020",
        tertiary: "#101010",
        quaternary: "#000",
        highlight: dark_theme_colors.maybeBlue700,
        groupHeader: dark_theme_colors.yellove500
    },
    buttons: {
        primary: {
            bg: dark_theme_colors.maybeBlue700,
            bgActive: dark_theme_colors.maybeBlue100,
            text: dark_theme_colors.base0,
            textHover: dark_theme_colors.base0
        },
        secondary: {
            bg: dark_theme_colors.base500,
            text: dark_theme_colors.base0,
            textHover: dark_theme_colors.base0
        },
        tertiary: {
            bg: dark_theme_colors.base600,
            text: dark_theme_colors.base0,
            textHover: dark_theme_colors.base0
        },
        quarternary: {
            bg: dark_theme_colors.base700,
            text: dark_theme_colors.base0,
            textHover: dark_theme_colors.base0
        },
        positive: {
            bg: dark_theme_colors.positive700,
            text: dark_theme_colors.base0,
            textHover: dark_theme_colors.base0
        },
        negative: {
            bg: dark_theme_colors.negative700,
            text: dark_theme_colors.base0,
            textHover: dark_theme_colors.base0
        },
        link: {
            bg: "transparent",
            text: dark_theme_colors.maybeBlue700,
            textHover: dark_theme_colors.maybeBlue500
        },
        disabled: {
            bg: dark_theme_colors.base500,
            text: dark_theme_colors.base0,
            textHover: dark_theme_colors.base0
        },
        category: {
            bg: "#404040",
            bgActive: dark_theme_colors.base600,
            text: dark_theme_colors.base0,
            textHover: dark_theme_colors.base100
        },
        panning: {
            bg: "rgba(0, 0, 0, 0.6)",
            bgHover: "rgba(0, 0, 0, 0.4)",
            text: dark_theme_colors.base0
        }
    },
    pill: {
        primary: {
            bg: dark_theme_colors.maybeBlue700,
            text: dark_theme_colors.base0
        },
        inverted: {
            bg: dark_theme_colors.base0,
            text: dark_theme_colors.base700
        }
    },
    inputs: {
        primary: {
            bg: dark_theme_colors.base0,
            border: dark_theme_colors.base500,
            borderFocus: dark_theme_colors.maybeBlue700
        },
        secondary: {
            bg: dark_theme_colors.base100,
            border: dark_theme_colors.base100,
            borderFocus: dark_theme_colors.maybeBlue700
        }
    },
    dropdowns: {
        primary: {
            bg: dark_theme_colors.base0,
            hoverBackground: (0,color_utils.setRgbaAlpha)(dark_theme_colors.maybeBlue700, "0.2"),
            borderRadius: "5px",
            borderColor: {
                active: dark_theme_colors.base700,
                inactive: dark_theme_colors.base700
            }
        },
        secondary: {
            bg: dark_theme_colors.base0,
            hoverBackground: (0,color_utils.setRgbaAlpha)(dark_theme_colors.maybeBlue700, "0.2"),
            borderRadius: 0,
            borderColor: {
                active: dark_theme_colors.base200,
                inactive: "transparent"
            }
        }
    },
    placeholders: {
        bg: dark_theme_colors.base100,
        fg: dark_theme_colors.base300
    },
    cookieBanner: {
        bg: (0,color_utils.setRgbaAlpha)(dark_theme_colors.base700, "0.9"),
        fg: dark_theme_colors.base0
    },
    actionBar: {
        bg: dark_theme_colors.base700,
        fg: dark_theme_colors.base0,
        boxShadow: "0 -2px 10px 0 rgba(0, 0, 0, 0.2)"
    },
    ratings: {
        positive: {
            bg: dark_theme_colors.positive300,
            fg: dark_theme_colors.positive700
        },
        neutral: {
            bg: dark_theme_colors.notice300,
            fg: dark_theme_colors.yellove900
        },
        negative: {
            bg: dark_theme_colors.negative300,
            fg: dark_theme_colors.negative700
        },
        disabled: {
            bg: dark_theme_colors.base200,
            fg: dark_theme_colors.base500
        }
    },
    notifications: {
        info: {
            bg: (0,color_utils.setRgbaAlpha)(dark_theme_colors.maybeBlue700, "0.04"),
            fg: dark_theme_colors.maybeBlue700
        },
        issue: {
            bg: (0,color_utils.setRgbaAlpha)(dark_theme_colors.negative300, "0.2"),
            fg: (0,color_utils.setRgbaAlpha)(dark_theme_colors.negative700, "0.7")
        },
        neutral: {
            bg: dark_theme_colors.base100,
            fg: dark_theme_colors.base600
        }
    },
    promos: {
        bg: dark_theme_colors.maybeBlue100,
        fg: dark_theme_colors.base600
    }
};
/* harmony default export */ const dark = ((/* unused pure expression or super */ null && (darkTheme)));

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
;// CONCATENATED MODULE: ./src/components/base/styles/styled-theme.tsx
function styled_theme_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function styled_theme_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            styled_theme_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



var StyledTheme = function(param) {
    var children = param.children, _layout = param.layout, layout = _layout === void 0 ? "default" : _layout;
    var theme = react.useMemo(function() {
        return _objectSpreadProps(styled_theme_objectSpread({}, themes_default), {
            layout: layout
        });
    }, [
        layout
    ]);
    return /*#__PURE__*/ react.createElement(styled_components_browser_esm.ThemeProvider, {
        theme: theme
    }, children);
};
/* harmony default export */ const styled_theme = (StyledTheme);

;// CONCATENATED MODULE: ./src/components/base/index.js









var noop = function() {};



/***/ }),

/***/ 48596:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40507);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3616);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95939);
/* harmony import */ var src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58912);





var InfoPageLink = function(param) {
    var id = param.id, children = param.children, pages = param.nodes, className = param.className, url = param.url;
    var page = pages.find(function(p) {
        return p.id === id;
    });
    var pathName = url || (page === null || page === void 0 ? void 0 : page.pathName);
    if (!pathName) {
        return null;
    }
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_router_dom__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .rU, {
        className: className,
        to: pathName,
        onClick: function() {
            return (0,src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_4__/* .trackInternalNavigationClick */ .p)({
                scope: src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_4__/* .InternalNavigationScope.ABOUT_REVIEWS */ .U.ABOUT_REVIEWS,
                nextPage: pathName
            });
        }
    }, children);
};
var number = (prop_types__WEBPACK_IMPORTED_MODULE_1___default().number), node = (prop_types__WEBPACK_IMPORTED_MODULE_1___default().node), arrayOf = (prop_types__WEBPACK_IMPORTED_MODULE_1___default().arrayOf), shape = (prop_types__WEBPACK_IMPORTED_MODULE_1___default().shape), string = (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string);
InfoPageLink.propTypes = {
    id: number,
    children: node,
    nodes: arrayOf(shape({
        id: number.isRequired,
        pathName: string.isRequired
    })),
    className: string,
    url: string
};
InfoPageLink.defaultProps = {
    children: undefined,
    id: null,
    nodes: [],
    className: undefined,
    url: undefined
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .connect */ .$j)(function(state) {
    return state.globals.infoPages;
})(InfoPageLink));


/***/ }),

/***/ 31794:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ login_promo)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 24 modules
var es = __webpack_require__(95939);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./src/hooks/use-schibsted-account.ts
var use_schibsted_account = __webpack_require__(65195);
// EXTERNAL MODULE: ./src/components/modal/index.tsx
var modal = __webpack_require__(58203);
// EXTERNAL MODULE: ./src/components/modal/actions.ts
var actions = __webpack_require__(66571);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(7336);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/check-filled/index.js
var check_filled = __webpack_require__(89639);
;// CONCATENATED MODULE: ./src/components/modal/styles.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  list-style: none;\n  margin: 10px 0 20px 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 10px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  vertical-align: middle;\n  margin-right: 0.5em;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  text-align: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 10px;\n  margin-bottom: 5px;\n  width: 100%;\n  text-align: center;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var FeatureList = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "FeatureList",
    componentId: "sc-0-0"
})(_templateObject());
var FeatureListItem = styled_components_browser_esm["default"].li.withConfig({
    displayName: "FeatureListItem",
    componentId: "sc-0-1"
})(_templateObject1());
var FeatureListCheckIcon = (0,styled_components_browser_esm["default"])(check_filled.IconCheckFilled).attrs({
    color: "positive500"
}).withConfig({
    displayName: "FeatureListCheckIcon",
    componentId: "sc-0-2"
})(_templateObject2());
var StyledPrimaryButton = (0,styled_components_browser_esm["default"])(variants.PrimaryButton).withConfig({
    displayName: "StyledPrimaryButton",
    componentId: "sc-0-3"
})(_templateObject3());
var StyledTextButton = (0,styled_components_browser_esm["default"])(variants.TextButton).withConfig({
    displayName: "StyledTextButton",
    componentId: "sc-0-4"
})(_templateObject4());

;// CONCATENATED MODULE: ./src/components/modal/login-promo.js









var LoginPromoModal = function(param) {
    var hideModalAction = param.hideModalAction, onRequestClose = param.onRequestClose, id = param.id, isOpen = param.isOpen;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var login = (0,use_schibsted_account/* useSchibstedAccount */.F)().login;
    var loginOnClick = function(e) {
        e.preventDefault();
        login();
    };
    return /*#__PURE__*/ react.createElement(modal/* default */.Z, {
        id: id,
        isOpen: isOpen,
        onRequestClose: onRequestClose || hideModalAction,
        width: 400
    }, /*#__PURE__*/ react.createElement("h3", null, t("account", "sign-in-promo.modal-title")), /*#__PURE__*/ react.createElement(FeatureList, null, /*#__PURE__*/ react.createElement(FeatureListItem, null, /*#__PURE__*/ react.createElement(FeatureListCheckIcon, null), t("account", "sign-in-promo.list-item-sync-your-info")), /*#__PURE__*/ react.createElement(FeatureListItem, null, /*#__PURE__*/ react.createElement(FeatureListCheckIcon, null), t("account", "sign-in-promo.list-item-optimise-alerts")), /*#__PURE__*/ react.createElement(FeatureListItem, null, /*#__PURE__*/ react.createElement(FeatureListCheckIcon, null), t("account", "sign-in-promo.list-item-organise-lists"))), /*#__PURE__*/ react.createElement(StyledPrimaryButton, {
        container: react_router_dom/* Link */.rU,
        onClick: loginOnClick,
        containerProps: {
            "data-test": "SignInButton",
            to: "/login"
        }
    }, t("account", "sign-in-promo.sign-in-button")), /*#__PURE__*/ react.createElement(StyledTextButton, {
        container: react_router_dom/* Link */.rU,
        onClick: loginOnClick,
        containerProps: {
            "data-test": "CreateAccountButton",
            to: "/signup"
        }
    }, t("account", "sign-in-promo.create-account-button")));
};
var func = (prop_types_default()).func, string = (prop_types_default()).string, bool = (prop_types_default()).bool;
LoginPromoModal.propTypes = {
    hideModalAction: func,
    onRequestClose: func,
    id: string,
    isOpen: bool
};
LoginPromoModal.defaultProps = {
    hideModalAction: undefined,
    onRequestClose: undefined,
    id: undefined,
    isOpen: false
};
/* harmony default export */ const login_promo = ((0,es/* connect */.$j)(null, {
    hideModalAction: actions/* default.hideModal */.ZP.hideModal
})(/*#__PURE__*/ (0,react.memo)(LoginPromoModal)));


/***/ }),

/***/ 64213:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ outside_click_tracker)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
;// CONCATENATED MODULE: ./src/components/outside-click-tracker/styles.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  body {\n    /* For some reason iOS Safari requires a pointer cursor to trigger click events... */\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  cursor: default;\n  height: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var OutsideArea = (0,styled_components_browser_esm.createGlobalStyle)(_templateObject());
var InsideArea = styled_components_browser_esm["default"].div.withConfig({
    displayName: "InsideArea",
    componentId: "sc-0-0"
})(_templateObject1());

;// CONCATENATED MODULE: ./src/components/outside-click-tracker/index.js
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}




var OutsideClickTracker = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    _inherits(OutsideClickTracker, _PureComponent);
    var _super = _createSuper(OutsideClickTracker);
    function OutsideClickTracker(props) {
        _classCallCheck(this, OutsideClickTracker);
        var _this;
        _this = _super.call(this, props);
        _defineProperty(_assertThisInitialized(_this), "listenerOptions", {
            capture: true
        });
        _defineProperty(_assertThisInitialized(_this), "mouseDownListener", function(e) {
            if (_this.props.active && _this.wrapperRef.current && !_this.wrapperRef.current.contains(e.target) && document.getElementById("root").contains(e.target)) {
                _this.props.onMouseDownOutside();
            }
        });
        _defineProperty(_assertThisInitialized(_this), "clickListener", function(e) {
            if (_this.props.active && _this.wrapperRef.current && !_this.wrapperRef.current.contains(e.target) && // We dont want to close things like the mobile sidebar when trying to close
            // a toast notification or when accepting cookies from the cookie banner
            document.getElementById("root").contains(e.target)) {
                e.stopPropagation();
                _this.props.onClickOutside();
            }
        });
        _defineProperty(_assertThisInitialized(_this), "keyUpListener", function(e) {
            if (_this.props.active && e.keyCode === 27) {
                _this.props.onEscapeKey();
            }
        });
        _this.wrapperRef = /*#__PURE__*/ react.createRef();
        return _this;
    }
    _createClass(OutsideClickTracker, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.active) {
                    this.addListeners();
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.removeListeners();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (this.props.active && !prevProps.active) {
                    this.addListeners();
                }
                if (!this.props.active && prevProps.active) {
                    this.removeListeners();
                }
            }
        },
        {
            key: "addListeners",
            value: function addListeners() {
                window.addEventListener("mousedown", this.mouseDownListener, this.listenerOptions);
                window.addEventListener("click", this.clickListener, this.listenerOptions);
                window.addEventListener("keyup", this.keyUpListener, this.listenerOptions);
            }
        },
        {
            key: "removeListeners",
            value: function removeListeners() {
                window.removeEventListener("mousedown", this.clickListener, this.listenerOptions);
                window.removeEventListener("click", this.clickListener, this.listenerOptions);
                window.removeEventListener("keyup", this.keyUpListener, this.listenerOptions);
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(OutsideArea, null), /*#__PURE__*/ react.createElement(InsideArea, {
                    className: this.props.className,
                    ref: this.wrapperRef
                }, this.props.children));
            }
        }
    ]);
    return OutsideClickTracker;
}(react.PureComponent);
OutsideClickTracker.propTypes = {
    children: prop_types.node,
    className: prop_types.string,
    onMouseDownOutside: prop_types.func,
    onClickOutside: prop_types.func,
    onEscapeKey: prop_types.func,
    active: prop_types.bool
};
OutsideClickTracker.defaultProps = {
    children: undefined,
    className: undefined,
    onMouseDownOutside: base/* noop */.ZT,
    onClickOutside: base/* noop */.ZT,
    onEscapeKey: base/* noop */.ZT,
    active: true
};
/* harmony default export */ const outside_click_tracker = (OutsideClickTracker);


/***/ }),

/***/ 23428:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ sentiment_badge)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/like-filled/index.js
var like_filled = __webpack_require__(41421);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
;// CONCATENATED MODULE: ./src/components/sentiment-badge/styles.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n\n  svg {\n    margin-right: 3px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 5px;\n  line-height: 1.3em;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: 10px;\n  color: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var Badge = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Badge",
    componentId: "sc-0-0"
})(_templateObject());
var Text = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Text",
    componentId: "sc-0-1"
})(_templateObject1());
var RelatedReviews = styled_components_browser_esm["default"].span.withConfig({
    displayName: "RelatedReviews",
    componentId: "sc-0-2"
})(_templateObject2(), function(props) {
    return props.theme.text.secondary;
});

;// CONCATENATED MODULE: ./src/components/sentiment-badge/index.js





var SentimentBadge = function(param) {
    var badge = param.badge, minPositive = param.minPositive, showNrOfReviewsAs = param.showNrOfReviewsAs;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    if (badge.nrOfPositiveReviews < minPositive) {
        return null;
    }
    var renderNumberOfReviews = function() {
        return showNrOfReviewsAs === "text" ? t("product", "sentiment-badge.n-related-reviews", {
            n: badge.nrOfReviews
        }) : "(".concat(badge.nrOfReviews, ")");
    };
    var textElement = /*#__PURE__*/ react.createElement(Text, null, /*#__PURE__*/ react.createElement("span", null, t("product", "sentiment-badge.".concat(badge.name, "-").concat(badge.sentiment))), /*#__PURE__*/ react.createElement(RelatedReviews, null, showNrOfReviewsAs && renderNumberOfReviews()));
    return /*#__PURE__*/ react.createElement(Badge, null, /*#__PURE__*/ react.createElement(like_filled/* IconLikeFilled */.G, {
        size: 16,
        color: "positive500"
    }), textElement);
};
SentimentBadge.propTypes = {
    badge: prop_types_default().shape({
        name: (prop_types_default()).string,
        sentiment: prop_types_default().oneOf([
            "positive",
            "negative"
        ])
    }),
    minPositive: (prop_types_default()).number,
    showNrOfReviewsAs: prop_types_default().oneOf([
        "number",
        "text"
    ])
};
SentimentBadge.defaultProps = {
    badge: null,
    minPositive: 2,
    showNrOfReviewsAs: undefined
};
/* harmony default export */ const sentiment_badge = (/*#__PURE__*/(0,react.memo)(SentimentBadge));


/***/ }),

/***/ 63014:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* export default binding */ __WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23114);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}


var ShutdownMessageModal = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "extra";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | extra */ 737).then(__webpack_require__.bind(__webpack_require__, 37118));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(37118);
        }
        return eval("require.resolve")("./modal");
    }
});
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ShutdownMessageModal, _extends({}, props));
};


/***/ }),

/***/ 11124:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BX": () => (/* binding */ graphql),
/* harmony export */   "Bp": () => (/* binding */ putPrivacySettings),
/* harmony export */   "Gg": () => (/* binding */ getSession),
/* harmony export */   "Xg": () => (/* binding */ getOauthState),
/* harmony export */   "hO": () => (/* binding */ putSession),
/* harmony export */   "ph": () => (/* binding */ destroySchibstedSession),
/* harmony export */   "qr": () => (/* binding */ postFeedback)
/* harmony export */ });
/* harmony import */ var src_client_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43517);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

var getSession = function() {
    return fetch("/_internal/session", {
        method: "GET",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
            "X-Set-Viewed-Experiments": "1"
        }
    }).then(function(res) {
        return res.json();
    });
};
var putSession = function(key, value) {
    return fetch("/_internal/session", {
        method: "PUT",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
            "X-Set-Viewed-Experiments": "1"
        },
        body: JSON.stringify(_defineProperty({}, key, value))
    });
};
var putPrivacySettings = function(value) {
    return fetch("/_internal/privacy-settings", {
        method: "PUT",
        credentials: "include",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(value)
    });
};
var getOauthState = function() {
    return fetch("/_internal/auth/schibsted/state?location=".concat(encodeURIComponent(window.location.href)), {
        method: "GET",
        credentials: "include",
        headers: {
            "Content-Type": "application/json"
        }
    }).then(function(res) {
        if (!res.ok) {
            throw new Error("Unable to generate OAuth state, ".concat(res.status, " ").concat(res.statusText));
        }
        return res;
    }).then(function(res) {
        return res.json();
    }).then(function(json) {
        return json.data;
    });
};
var destroySchibstedSession = function() {
    return fetch("/_internal/auth/schibsted/destroy", {
        method: "GET",
        credentials: "include",
        headers: {
            "Content-Type": "application/json"
        }
    }).then(function(res) {
        return res.json();
    });
};
var graphql = function(query, variables) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return (0,src_client_query__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(query, variables, undefined, undefined, options);
};
var postFeedback = function(message) {
    return graphql("\n      mutation ($data: FeedbackInputType!) {\n        feedback(data: $data) {\n          success\n        }\n      }\n    ", {
        data: message
    });
};


/***/ }),

/***/ 56121:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ isNumeric)
/* harmony export */ });
function isNumeric(n) {
    // eslint-disable-next-line no-restricted-globals
    return !isNaN(parseFloat(n)) && isFinite(n);
}


/***/ }),

/***/ 10681:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DE": () => (/* binding */ NEW_PRODUCT_CLICK),
/* harmony export */   "IT": () => (/* binding */ OTHER_POPULAR_PRODUCT_CLICK),
/* harmony export */   "LT": () => (/* binding */ POPULAR_CLICK),
/* harmony export */   "dL": () => (/* binding */ OTHERS_ALSO_VISITED_PRODUCT_CLICK),
/* harmony export */   "fT": () => (/* binding */ TRENDING_PRODUCT_CLICK),
/* harmony export */   "gv": () => (/* binding */ SEGMENT_PRODUCT_CLICK),
/* harmony export */   "qq": () => (/* binding */ RECENTLY_VISITED_CLICK)
/* harmony export */ });
/* unused harmony exports RECOMMENDED_CLICK, COMING_SOON_CLICK, PRISMIC_PRODUCT_LIST_CLICK */
var RECOMMENDED_CLICK = "Recommended click";
var POPULAR_CLICK = "Popular click";
var RECENTLY_VISITED_CLICK = "Recently visited click";
var NEW_PRODUCT_CLICK = "New product click";
var COMING_SOON_CLICK = "Coming soon click";
var PRISMIC_PRODUCT_LIST_CLICK = "Article product list click";
var TRENDING_PRODUCT_CLICK = "Trending product click";
var SEGMENT_PRODUCT_CLICK = "Segment / navigation category product click";
var OTHER_POPULAR_PRODUCT_CLICK = "Popular product click";
var OTHERS_ALSO_VISITED_PRODUCT_CLICK = "Other visited product click";


/***/ }),

/***/ 79965:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": () => (/* binding */ useMetaTags)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18026);
/* harmony import */ var src_components_location_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68410);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



var makeTag = function(tagName) {
    var attributes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, properties = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var element = document.createElement(tagName);
    Object.keys(attributes).forEach(function(attrName) {
        element.setAttribute(attrName, attributes[attrName]);
    });
    Object.keys(properties).forEach(function(propName) {
        element[propName] = properties[propName];
    });
    return element;
};
var makeOpenGraphTags = function() {
    var openGraphEntries = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return openGraphEntries.filter(Boolean).map(function(openGraphEntry) {
        return makeTag("meta", {
            property: "og:".concat(openGraphEntry.key),
            content: openGraphEntry.content
        });
    });
};
var makeLinkedDataTag = function(content) {
    return content && makeTag("script", {
        type: "application/ld+json"
    }, {
        innerHTML: JSON.stringify(content)
    });
};
var makeBreadcrumbDataTags = function(market, breadcrumb) {
    return makeLinkedDataTag({
        "@context": "http://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: breadcrumb.map(function(item, index) {
            return {
                "@type": "ListItem",
                position: index + 1,
                item: {
                    "@id": market.domain + item.pathName,
                    name: item.name
                }
            };
        })
    });
};
var makeStructuredDataTags = function(market, breadcrumb, structuredData) {
    var structuredDataArray;
    if (!structuredData) {
        structuredDataArray = [];
    } else {
        structuredDataArray = !Array.isArray(structuredData) ? [
            structuredData
        ] : structuredData;
    }
    return [
        breadcrumb && makeBreadcrumbDataTags(market, breadcrumb)
    ].concat(_toConsumableArray(structuredDataArray.map(makeLinkedDataTag))).filter(Boolean);
};
var makeHrefLangTags = function() {
    var hrefLang = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return hrefLang.map(function(param) {
        var locale = param.locale, url = param.url;
        return makeTag("link", {
            rel: "alternate",
            hrefLang: locale,
            href: url
        });
    });
};
function useMetaTags(props) {
    var routeId = props.routeId, locationKey = props.locationKey, metaTags = props.metaTags;
    var market = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_1__/* .AppContext */ .Il).market;
    var previousLocation = (0,src_components_location_context__WEBPACK_IMPORTED_MODULE_2__/* .useLocationContext */ .F)().previousLocation;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if ( false || routeId === "initial" && locationKey === undefined || !previousLocation) {
            // For initial request, do not mess with the meta tags sent from server
            return;
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = document.head.querySelectorAll("[data-route-id]")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var metaTagElement = _step.value;
                metaTagElement.parentNode.removeChild(metaTagElement);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var title = metaTags.title, breadcrumb = metaTags.breadcrumb, description = metaTags.description, thumbnail = metaTags.thumbnail, canonical = metaTags.canonical, structuredData = metaTags.structuredData, _openGraph = metaTags.openGraph, openGraph = _openGraph === void 0 ? [] : _openGraph, _hrefLang = metaTags.hrefLang, hrefLang = _hrefLang === void 0 ? [] : _hrefLang, prev = metaTags.prev, next = metaTags.next, noIndex = metaTags.noIndex, _botify = metaTags.botify, botify = _botify === void 0 ? {} : _botify, hasAdultContent = metaTags.hasAdultContent;
        var elements = [
            title && makeTag("title", {}, {
                innerText: title
            }),
            hasAdultContent && makeTag("rating", {
                content: "adult"
            })
        ].concat(_toConsumableArray(makeOpenGraphTags(openGraph)), [
            noIndex && makeTag("meta", {
                name: "robots",
                content: "noindex"
            }),
            description && makeTag("meta", {
                name: "description",
                content: description
            }),
            thumbnail && makeTag("meta", {
                name: "thumbnail",
                content: thumbnail
            }),
            canonical && makeTag("link", {
                rel: "canonical",
                href: canonical
            }),
            prev && makeTag("link", {
                rel: "prev",
                href: prev
            }),
            next && makeTag("link", {
                rel: "next",
                href: next
            })
        ], _toConsumableArray(makeHrefLangTags(hrefLang)), _toConsumableArray(makeStructuredDataTags(market, breadcrumb, structuredData)), [
            botify && makeTag("meta", _objectSpreadProps(_objectSpread({}, botify), {
                name: "botify"
            }))
        ]).filter(Boolean);
        elements.forEach(function(element) {
            element.setAttribute("data-route-id", routeId !== null && routeId !== void 0 ? routeId : "1337");
            document.head.appendChild(element);
        });
    }, [
        routeId,
        locationKey,
        metaTags
    ]);
}


/***/ }),

/***/ 55196:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ match_route)
});

// UNUSED EXPORTS: generateKey

// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@5.2.1_react@18.2.0/node_modules/react-router/esm/react-router.js + 3 modules
var react_router = __webpack_require__(14727);
// EXTERNAL MODULE: ./node_modules/.pnpm/querystring@0.2.1/node_modules/querystring/index.js
var querystring = __webpack_require__(97150);
;// CONCATENATED MODULE: ./src/routes/shared.ts
function getProductPageTabFromHash(hash) {
    var hashContent = hash && hash.substr(1);
    if (hashContent === "properties" || hashContent === "reviews" || hashContent === "statistics") {
        return hashContent;
    }
    return "main";
}

;// CONCATENATED MODULE: ./src/routes/match-classic-route.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

var idFromQuery = function() {
    var query = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, identifiers = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var id = identifiers.find(function(identifier) {
        return query[identifier];
    });
    return query[id];
};
// eslint-disable-next-line no-bitwise
var is32BitInt = function(x) {
    return (x | 0) === x;
};
function getProductPageTabFromQuery(query, id) {
    if (parseInt(query.e, 10) === id) {
        return "properties";
    }
    if (parseInt(query.o, 10) === id) {
        return "reviews";
    }
    if (parseInt(query.pu, 10) === id) {
        return "statistics";
    }
    return "main";
}
var matchClassicRoute = function(data) {
    var pathname = data.pathname, _query = data.query, query = _query === void 0 ? {} : _query, _hash = data.hash, hash = _hash === void 0 ? "" : _hash, _useHashForProductTabs = data.useHashForProductTabs, useHashForProductTabs = _useHashForProductTabs === void 0 ? false : _useHashForProductTabs, _routeConfig = data.routeConfig, routeConfig = _routeConfig === void 0 ? {} : _routeConfig;
    var name = "/".concat(pathname.split("/")[1]);
    switch(name){
        case routeConfig.product.path:
            {
                // The following pages does not exist anymore and should be permanently redirected
                var redirectQueryParams = [
                    "cc",
                    "em",
                    "g",
                    "map",
                    "pid",
                    "r",
                    "rec",
                    "rel"
                ];
                if (redirectQueryParams.some(function(key) {
                    return query[key] !== undefined;
                })) {
                    return false;
                }
                // Bastardised version of the price history URL, e.g. /product.php/statistics?p=1234
                // This should be redirected, so not matched here.
                if (/statistics$/.test(pathname)) {
                    return false;
                }
                var route = "product";
                var id = parseInt(idFromQuery(query, [
                    "p",
                    "e",
                    "rec",
                    "o",
                    "pu",
                    "g",
                    "rel",
                    "em",
                    "map",
                    "r",
                    "pid",
                    "cc"
                ]), 10);
                if (!is32BitInt(id)) {
                    return undefined;
                }
                // Render 404 on missing id
                if (!id) {
                    return undefined;
                }
                var section = useHashForProductTabs ? getProductPageTabFromHash(hash) : getProductPageTabFromQuery(query, id);
                // If using hash for product tabs, we want to redirect the query variant to that,
                // so not matched here.
                if (useHashForProductTabs && getProductPageTabFromQuery(query, id) !== "main") {
                    return false;
                }
                return {
                    route: route,
                    params: {
                        id: id,
                        section: section
                    }
                };
            }
        case routeConfig.category.path:
            {
                var id1 = idFromQuery(query, [
                    "k",
                    "c",
                    "l",
                    "m",
                    "b",
                    "lb"
                ]);
                var filterId;
                if (id1 === "all") {
                    return undefined;
                }
                if (/^s/.test(id1) && query.catId) {
                    filterId = id1;
                    id1 = query.catId;
                }
                // No category id exists and we don't have a category index page
                // Load 404 route instead
                if (!id1 && !filterId) {
                    return undefined;
                }
                // Make sure id is in correct format
                if (!/^(s|v)?\d+$/.test(id1)) {
                    return undefined;
                }
                return {
                    route: "category",
                    params: _objectSpread({
                        id: id1,
                        filterId: filterId
                    }, query.t && parseInt(query.t, 10) > 0 ? {
                        brand: query.t
                    } : {})
                };
            }
        case routeConfig.store.path:
            {
                var id2 = parseInt(idFromQuery(query, [
                    "f",
                    "ftgid"
                ]), 10);
                // Render 404 on missing id
                if (!id2) {
                    return undefined;
                }
                return {
                    route: "store",
                    params: {
                        id: id2
                    }
                };
            }
        case routeConfig.brand.path:
            {
                var id3 = parseInt(idFromQuery(query, [
                    "t"
                ]), 10);
                // Render 404 on missing id
                if (!id3) {
                    return undefined;
                }
                return {
                    route: "brand",
                    params: {
                        id: id3
                    }
                };
            }
        default:
            return undefined;
    }
};
/* harmony default export */ const match_classic_route = (matchClassicRoute);

;// CONCATENATED MODULE: ./src/routes/match-route.js
function match_route_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function match_route_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            match_route_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




var isConflictingRoute = function(pathname) {
    switch(pathname.split("/")[1]){
        case "news":
        case "nyheter":
            {
                return true;
            }
        default:
            return false;
    }
};
var generateKey = function(name, variables) {
    var sortedVariables = Object.keys(variables).sort(function(a, b) {
        return a.localeCompare(b);
    }).reduce(function(all, key) {
        return all + key + JSON.stringify(variables[key]);
    }, "");
    return name + JSON.stringify(sortedVariables);
};
/* harmony default export */ function match_route(param) {
    var useClassicUrls = param.useClassicUrls, useHashForProductTabs = param.useHashForProductTabs, routeConfig = param.routeConfig, location = param.location, marketCode = param.marketCode, experiments = param.experiments;
    var query = querystring.decode(location.search.substr(1));
    if (useClassicUrls) {
        var classicMatch = match_classic_route({
            pathname: location.pathname,
            query: query,
            hash: location.hash,
            useHashForProductTabs: useHashForProductTabs,
            routeConfig: routeConfig
        });
        // matchClassicRoute returns explicit false
        // when it is a redirect and we should skip
        // any further attempts at matching routes.
        if (classicMatch === false) {
            return undefined;
        }
        if (classicMatch) {
            var match = (0,react_router/* matchPath */.LX)(location.pathname, {
                path: "*",
                exact: false
            });
            match.params = classicMatch.params;
            var _route = routeConfig[classicMatch.route], component = _route.component, metaTags = _route.metaTags, cacheControl = _route.cacheControl, props = _route.props;
            var variables = component.variables ? component.variables(_objectSpreadProps(match_route_objectSpread({}, query, classicMatch.params), {
                marketCode: marketCode,
                experiments: experiments,
                /* The app feature level from .env config (APP_FEATURE_LEVEL). featureToggle is set
             * from "server/init.js". window.FEATURE_TOGGLE is set from "server/react/middelware/out.js".
             */ featureToggle: FEATURE_TOGGLE
            })) : {};
            return {
                name: classicMatch.route,
                component: component,
                variables: variables,
                metaTags: metaTags,
                cacheControl: cacheControl,
                key: generateKey(classicMatch.route, variables),
                match: match,
                ssr: component.ssr,
                props: props
            };
        }
    }
    /**
   * Some classic routes are in conflict with our new routes.
   * Ex. "/news/whatever--something" will match the store route (--s:id).
   * Handle this special case here for now by simply bypassing the matchPath loop.
   */ if (isConflictingRoute(location.pathname)) {
        return undefined;
    }
    /**
      This is very similar to what react-router switch does,
      simply run matchPath (which is used internally in react router)
      and return first match. Runs as a for loop to avoid unnessary iterations
    * */ var routeKeys = Object.keys(routeConfig);
    // eslint-disable-next-line no-plusplus
    for(var i = 0; i < routeKeys.length; i++){
        var name = routeKeys[i];
        var _name = routeConfig[name], path = _name.path, _exact = _name.exact, exact = _exact === void 0 ? true : _exact;
        var match1 = (0,react_router/* matchPath */.LX)(location.pathname, {
            path: path,
            exact: exact
        });
        if (match1) {
            var _name1 = routeConfig[name], component1 = _name1.component, metaTags1 = _name1.metaTags, cacheControl1 = _name1.cacheControl, props1 = _name1.props;
            if (name === "product" && useHashForProductTabs) {
                var section = getProductPageTabFromHash(location.hash);
                if (section !== "main") {
                    match1.params.section = section;
                }
            }
            var variables1 = component1.variables ? component1.variables(_objectSpreadProps(match_route_objectSpread({}, query, match1.params), {
                marketCode: marketCode,
                experiments: experiments,
                /* The app feature level from .env config (APP_FEATURE_LEVEL). featureToggle is set
             * from "server/init.js". window.FEATURE_TOGGLE is set from "server/react/middelware/out.js".
             */ featureToggle: FEATURE_TOGGLE
            })) : {};
            return {
                name: name,
                component: component1,
                variables: variables1,
                key: generateKey(name, variables1),
                metaTags: metaTags1,
                cacheControl: cacheControl1,
                match: match1,
                ssr: component1.ssr,
                props: props1
            };
        }
    }
    return undefined;
};


/***/ }),

/***/ 56699:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "vV": () => (/* binding */ isValidEmail)
/* harmony export */ });
/* unused harmony exports isCapsLockOn, getCurrentRef */
function isValidEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}
function isCapsLockOn(e) {
    return e.getModifierState("CapsLock");
}
function getCurrentRef() {
    var localRef = {
        path: "/"
    };
    try {
        var item = localStorage.getItem("ref");
        if (item) {
            localRef = JSON.parse(item);
        }
    } catch (err) {} // eslint-disable-line
    return localRef;
}


/***/ }),

/***/ 78879:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": () => (/* binding */ SchibstedLoginRedirect),
/* harmony export */   "T": () => (/* binding */ SchibstedLoginError)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30082);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23114);



var SchibstedLoginRedirect = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "user";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | user */ 378).then(__webpack_require__.bind(__webpack_require__, 75490));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(75490);
        }
        return eval("require.resolve")("./schibsted-login-redirect");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
});
var SchibstedLoginError = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "user";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | user */ 378).then(__webpack_require__.bind(__webpack_require__, 23790));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(23790);
        }
        return eval("require.resolve")("./schibsted-login-error");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
});



/***/ }),

/***/ 84026:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export MyProfile */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23114);
/* harmony import */ var _me_graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60591);
/* harmony import */ var _me_graphql__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_me_graphql__WEBPACK_IMPORTED_MODULE_2__);



var MyProfile = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "profile";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | profile */ 845).then(__webpack_require__.bind(__webpack_require__, 6797));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(6797);
        }
        return eval("require.resolve")("./views/my-profile");
    }
});
// Fixes loadable type errors `Property 'graphQL' does not exist on type`
var MyProfilePage = function() {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MyProfile, null);
};
MyProfilePage.variables = function(param) {
    var _offset = param.offset, offset = _offset === void 0 ? 0 : _offset;
    return {
        offset: typeof offset === "string" ? parseInt(offset, 10) : offset
    };
};
MyProfilePage.group = function(param) {
    var name = param.name, variables = param.variables;
    var groupVariables = variables ? Object.keys(variables).filter(function(key) {
        return key === "offset";
    }).filter(function(key) {
        return variables[key];
    }).map(function(key) {
        return variables[key];
    }) : [];
    return "".concat(name, "_").concat(groupVariables.join("_"));
};
MyProfilePage.graphQL = (_me_graphql__WEBPACK_IMPORTED_MODULE_2___default());
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (MyProfilePage);


/***/ }),

/***/ 6859:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export UserProfile */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23114);
/* harmony import */ var _user_graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97731);
/* harmony import */ var _user_graphql__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_user_graphql__WEBPACK_IMPORTED_MODULE_2__);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}



var UserProfile = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "profile";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | profile */ 845).then(__webpack_require__.bind(__webpack_require__, 45113));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(45113);
        }
        return eval("require.resolve")("./views/user-profile");
    }
});
// Fixes loadable type errors `Property 'graphQL' does not exist on type`
var UserProfilePage = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(UserProfile, _extends({}, props));
};
UserProfilePage.graphQL = (_user_graphql__WEBPACK_IMPORTED_MODULE_2___default());
UserProfilePage.variables = function(param) {
    var id = param.id, offset = param.offset, section = param.section;
    return {
        id: parseInt(id, 10),
        offset: parseInt(offset, 10) || 0,
        isListsTab: section === "lists",
        isReviewsTab: section === "reviews" || !section,
        section: section
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (UserProfilePage);


/***/ }),

/***/ 36151:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export Unsubscribe */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23114);


var Unsubscribe = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "profile";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | profile */ 845).then(__webpack_require__.bind(__webpack_require__, 72143));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(72143);
        }
        return eval("require.resolve")("./unsubscribe-landing-page");
    }
});
// Fixes loadable type errors `Property 'graphQL' does not exist on type`
var UnsubscribeLandingPage = function() {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Unsubscribe, null);
};
UnsubscribeLandingPage.variables = function(props) {
    return {
        id: props.group_id,
        subscribed: false,
        userID: props.user_id,
        hash: props.hash
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (UnsubscribeLandingPage);


/***/ }),

/***/ 37067:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30082);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23114);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19478);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_3__);




var CampaignPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "campaigns";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | campaigns */ 340).then(__webpack_require__.bind(__webpack_require__, 71073));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(71073);
        }
        return eval("require.resolve")("../scoped-search-pages/deals-page");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, null)
});
var Campaign = function() {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CampaignPage, null);
};
Campaign.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_3___default());
Campaign.loadOrder = [
    {}
];
var FILTER_URL_PARAMS = [
    "category",
    "price",
    "productRating",
    "storeRating",
    "stores",
    "offset"
];
Campaign.variables = function(variables) {
    var name = variables.name, page = variables.page, marketCode = variables.marketCode;
    var currentPageFromUrl = page ? Number(page) : undefined;
    return {
        id: /^\d+$/.test(name) ? parseInt(name, 10) : undefined,
        campaignSlug: name,
        limit: 20,
        filters: FILTER_URL_PARAMS.map(function(key) {
            return variables[key] ? {
                key: key,
                value: variables[key]
            } : null;
        }).filter(Boolean),
        campaignDeals: name === "black-friday",
        // To get the first page from the API, we pass 0 as the page number.
        // In the URL and in the UI, we call this page "page=1". To pass the right value
        // to the API, we therefore need to subtract 1 from currentPageFromUrl.
        page: currentPageFromUrl && currentPageFromUrl > 0 ? currentPageFromUrl - 1 : 0,
        sortType: marketCode === "nz" ? "trending" : "popularity",
        filtersV2: []
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Campaign);


/***/ }),

/***/ 63930:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fo": () => (/* binding */ sortOptions),
/* harmony export */   "I8": () => (/* binding */ bothDirectionsSortOptions),
/* harmony export */   "vg": () => (/* binding */ LOCAL_STORAGE_FILTER_KEY)
/* harmony export */ });
var LOCAL_STORAGE_FILTER_KEY = "pj:filterExpanded";
var sortOptions = [
    "name",
    "popularity",
    "user_reviews"
];
var bothDirectionsSortOptions = [
    "price",
    "price_include_shipping"
];


/***/ }),

/***/ 72062:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": () => (/* binding */ Changelog)
/* harmony export */ });
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23114);

var Changelog = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "changelog";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | changelog */ 827).then(__webpack_require__.bind(__webpack_require__, 90014));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(90014);
        }
        return eval("require.resolve")("./changelog");
    }
});


/***/ }),

/***/ 27203:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony exports BadgeIndicator, useCheckChangelogUnreadStatus */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71993);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95939);
/* harmony import */ var _prisjakt_ui_hideable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3709);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: ",
        "px;\n  height: ",
        "px;\n  background: ",
        ";\n  border-radius: 99px;\n  position: absolute;\n  top: -",
        "px;\n  right: -",
        "px;\n  box-shadow: ",
        ";\n  transition: transform 150ms ease;\n  z-index: 1;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var BADGE_SIZE = 12;
var STORAGE_KEY = "pj:changelogRead";
var Badge = function(param) {
    var noOutline = param.noOutline;
    var hasUnread = useCheckChangelogUnreadStatus();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BadgeIndicator, {
        visible: hasUnread,
        $outline: !noOutline
    });
};
var BadgeIndicator = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])(_prisjakt_ui_hideable__WEBPACK_IMPORTED_MODULE_3__.Hideable).withConfig({
    displayName: "BadgeIndicator",
    componentId: "sc-0-0"
})(_templateObject(), BADGE_SIZE, BADGE_SIZE, function(p) {
    return p.theme.colors.yellove500;
}, BADGE_SIZE / 10, BADGE_SIZE / 10, function(p) {
    return p.$outline ? "0 0 0 2px ".concat(p.theme.header.bg) : "none";
});
var selectChangelogArticles = function(state) {
    return state.areas.changelog.articles.map(function(a) {
        return a.id;
    });
};
var selectChangelogOpen = function(state) {
    return state.areas.changelog.isOpen;
};
function useCheckChangelogUnreadStatus() {
    var ids = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(selectChangelogArticles);
    var isOpen = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(selectChangelogOpen);
    var ref = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), 2), unread = ref[0], setUnread = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (isOpen) {
            setReadUpdates();
        }
        if (!isOpen) {
            setUnreadStatus();
        }
    }, [
        isOpen
    ]);
    var setUnreadStatus = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        try {
            var ref;
            var read = ((ref = localStorage.getItem(STORAGE_KEY)) === null || ref === void 0 ? void 0 : ref.split(";")) || [];
            setUnread(ids.filter(function(id) {
                return !read.includes(id);
            }));
        } catch (e) {} // eslint-disable-line no-empty
    }, [
        ids
    ]);
    var setReadUpdates = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        try {
            localStorage.setItem(STORAGE_KEY, ids.join(";"));
            setUnread([]);
        } catch (e) {} // eslint-disable-line no-empty
    }, [
        ids
    ]);
    return Boolean(unread.length);
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Badge);


/***/ }),

/***/ 17961:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H3": () => (/* binding */ H3),
/* harmony export */   "Qg": () => (/* binding */ ReadAllButton),
/* harmony export */   "W4": () => (/* binding */ ButtonWrapper),
/* harmony export */   "Xc": () => (/* binding */ ChangelogModal),
/* harmony export */   "Xw": () => (/* binding */ ChangelogWrapper),
/* harmony export */   "ck": () => (/* binding */ Item),
/* harmony export */   "or": () => (/* binding */ Main),
/* harmony export */   "zx": () => (/* binding */ Button)
/* harmony export */ });
/* unused harmony export ReadMoreButton */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71993);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61093);
/* harmony import */ var _prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35967);
/* harmony import */ var _prisjakt_ui_hideable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3709);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71016);
/* harmony import */ var _prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7336);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  left: 100%;\n  bottom: 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  background: ",
        ";\n  box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.1);\n  width: 320px;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  padding: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: center;\n  width: 100%;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 0;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n    max-width: 100%;\n    width: auto;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 1rem;\n  min-width: 160px;\n  max-width: fit-content;\n  text-align: center;\n\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  text-align: center;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  text-align: center;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}






var ChangelogWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "ChangelogWrapper",
    componentId: "sc-0-0"
})(_templateObject());
var alternateModalPosition = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject1());
var ChangelogModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_hideable__WEBPACK_IMPORTED_MODULE_3__.Hideable).withConfig({
    displayName: "ChangelogModal",
    componentId: "sc-0-1"
})(_templateObject2(), function(p) {
    return p.theme.bg.primary;
}, alternateModalPosition);
var Main = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_2__.Column).withConfig({
    displayName: "Main",
    componentId: "sc-0-2"
})(_templateObject3(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100);
var Item = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Item",
    componentId: "sc-0-3"
})(_templateObject4());
var Button = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_5__.PrimaryButton).withConfig({
    displayName: "Button",
    componentId: "sc-0-4"
})(_templateObject5());
var H3 = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_4__.H3Text).withConfig({
    displayName: "",
    componentId: "sc-0-5"
})(_templateObject6());
var ButtonWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_5__.PrimaryButton).withConfig({
    displayName: "ButtonWrapper",
    componentId: "sc-0-6"
})(_templateObject8(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject7()));
var ReadMoreButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_5__.PrimaryButton).withConfig({
    displayName: "ReadMoreButton",
    componentId: "sc-0-7"
})(_templateObject9());
var ReadAllButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_5__.OutlinedButton).withConfig({
    displayName: "ReadAllButton",
    componentId: "sc-0-8"
})(_templateObject10());


/***/ }),

/***/ 29035:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D7": () => (/* binding */ TextContent),
/* harmony export */   "DK": () => (/* binding */ SubTitle),
/* harmony export */   "Dx": () => (/* binding */ Title),
/* harmony export */   "VM": () => (/* binding */ Hero)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71993);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61093);
/* harmony import */ var _rich_text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76891);
/* harmony import */ var _slice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23816);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      background-position: center right;\n      background-image: ",
        ";\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      background-image: ",
        ";\n      background-size: cover;\n      background-position: center center;\n      border-left: 0;\n\n      ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    background-color: ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n        padding: 40px 16px 24px;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    color: ",
        ";\n    border-left: 0;\n    padding: 56px 32px 32px 24px;\n    gap: 16px;\n    ",
        "\n    ",
        ";\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    max-width: 100%;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    max-width: ",
        ";\n\n    ",
        ";\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n    text-align: ",
        ";\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n    text-align: ",
        ";\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}




var heroBackground = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(function(props) {
    var ref, ref1, ref2;
    var hasHeroImage = props.heroImage && props.heroImage.url;
    if (hasHeroImage) return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject1(), props.heroImage && ((ref = props.heroImage.Desktop) === null || ref === void 0 ? void 0 : ref.url) ? "url(".concat(props.heroImage.Desktop.url, ")") : "none", src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.smallOnly */ .BC.smallOnly(_templateObject(), ((ref1 = props.heroImage) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Mobile) === null || ref2 === void 0 ? void 0 : ref2.url) ? "url(".concat(props.heroImage.Mobile.url, ")") : "none"));
    var _heroBackgroundColor;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject2(), (_heroBackgroundColor = props.heroBackgroundColor) !== null && _heroBackgroundColor !== void 0 ? _heroBackgroundColor : src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .colors.lightTheme.maybeBlue500 */ .O9.lightTheme.maybeBlue500);
});
var Hero = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_slice__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    displayName: "Hero",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject4(), props.textColor, heroBackground, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.smallOnly */ .BC.smallOnly(_templateObject3()));
});
var TextContent = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "TextContent",
    componentId: "sc-0-1"
})(_templateObject7(), function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject6(), props.titleBoxWidth, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.smallOnly */ .BC.smallOnly(_templateObject5()));
});
var Title = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_rich_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    displayName: "Title",
    componentId: "sc-0-2"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject8(), !props.textAlign ? "left" : props.textAlign);
});
var SubTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_rich_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    displayName: "SubTitle",
    componentId: "sc-0-3"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject9(), !props.textAlign ? "left" : props.textAlign);
});


/***/ }),

/***/ 76891:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ rich_text),
  "K": () => (/* binding */ plainText)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/prismic-dom@2.2.7/node_modules/prismic-dom/dist/prismic-dom.min.js
var prismic_dom_min = __webpack_require__(24605);
var prismic_dom_min_default = /*#__PURE__*/__webpack_require__.n(prismic_dom_min);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
;// CONCATENATED MODULE: ./src/areas/editorial-content/components/slices/rich-text/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      font-size: 32px;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      font-size: 20px;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      font-size: 18px;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      font-size: 18px;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  &,\n  p {\n    font-size: ",
        ";\n    font-weight: 400;\n    line-height: 1.5;\n    color: inherit;\n  }\n\n  p {\n    margin-bottom: ",
        ";\n  }\n\n  h1 {\n    font-size: 40px;\n    font-weight: 800;\n    line-height: 1.25;\n    margin-bottom: ",
        ";\n\n    ",
        ";\n  }\n\n  h2 {\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 1.333;\n    margin-bottom: ",
        ";\n\n    ",
        ";\n  }\n\n  h3 {\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 1.4;\n    margin-bottom: ",
        ";\n\n    ",
        ";\n  }\n\n  h4 {\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 1.5;\n    margin-bottom: ",
        ";\n  }\n\n  h5 {\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 1.4;\n    margin-bottom: ",
        ";\n\n    ",
        ";\n  }\n\n  strong: {\n    font-weight: 700;\n  }\n\n  ol,\n  ul {\n    padding-inline-start: ",
        ";\n\n    li {\n      &:not(:last-of-type) {\n        margin-bottom: ",
        ";\n      }\n      &:last-of-type {\n        margin-bottom: ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var RichTextSection = styled_components_browser_esm["default"].section.withConfig({
    displayName: "RichTextSection",
    componentId: "sc-0-0"
})(_templateObject4(), base/* layout.measurements.fontSizeMedium */.bK.measurements.fontSizeMedium, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.smallOnly */.BC.smallOnly(_templateObject()), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.smallOnly */.BC.smallOnly(_templateObject1()), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.smallOnly */.BC.smallOnly(_templateObject2()), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.smallOnly */.BC.smallOnly(_templateObject3()), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing200 */.bK.measurements.spacing200);

;// CONCATENATED MODULE: ./src/areas/editorial-content/components/slices/rich-text/index.tsx

// @ts-expect-error -- Untyped


var RichText = function(param) {
    var data = param.data, linkResolver = param.linkResolver, serializer = param.serializer, container = param.container, className = param.className;
    if (!Array.isArray(data) || !data.length) {
        return null;
    }
    var html = prismic_dom_min_default().RichText.asHtml(data, linkResolver, serializer);
    var Component = container || RichTextSection;
    return /*#__PURE__*/ react.createElement(Component, {
        className: className,
        dangerouslySetInnerHTML: {
            __html: html
        }
    });
};
var plainText = function(data) {
    var ref;
    return (ref = prismic_dom_min_default().RichText.asText(data)) !== null && ref !== void 0 ? ref : "";
};
/* harmony default export */ const rich_text = (RichText);


/***/ }),

/***/ 35241:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61093);

var DEFAULTS = {
    dark: src_components_base__WEBPACK_IMPORTED_MODULE_0__/* .colors.lightTheme.base900 */ .O9.lightTheme.base900,
    light: src_components_base__WEBPACK_IMPORTED_MODULE_0__/* .colors.lightTheme.base0 */ .O9.lightTheme.base0,
    white: src_components_base__WEBPACK_IMPORTED_MODULE_0__/* .colors.lightTheme.base0 */ .O9.lightTheme.base0,
    "light grey": src_components_base__WEBPACK_IMPORTED_MODULE_0__/* .colors.lightTheme.base100 */ .O9.lightTheme.base100,
    "dark grey": src_components_base__WEBPACK_IMPORTED_MODULE_0__/* .colors.lightTheme.base500 */ .O9.lightTheme.base500,
    "primary blue": src_components_base__WEBPACK_IMPORTED_MODULE_0__/* .colors.lightTheme.maybeBlue500 */ .O9.lightTheme.maybeBlue500,
    "light blue": src_components_base__WEBPACK_IMPORTED_MODULE_0__/* .colors.lightTheme.maybeBlue100 */ .O9.lightTheme.maybeBlue100,
    "dark blue": src_components_base__WEBPACK_IMPORTED_MODULE_0__/* .colors.lightTheme.maybeBlue900 */ .O9.lightTheme.maybeBlue900
};
var backgroundColor = function(color) {
    if (!color) return "inherit";
    var colorLowerCase = color.toLowerCase();
    if ([
        "dark",
        "light"
    ].includes(colorLowerCase)) return "inherit";
    return DEFAULTS[colorLowerCase];
};
var textColor = function(color) {
    if (!color) return "inherit";
    var colorLowerCase = color.toLowerCase();
    if ([
        "dark",
        "light"
    ].includes(colorLowerCase)) return DEFAULTS[colorLowerCase];
    if ([
        "primary blue",
        "dark blue",
        "dark grey"
    ].includes(colorLowerCase)) return src_components_base__WEBPACK_IMPORTED_MODULE_0__/* .colors.lightTheme.base0 */ .O9.lightTheme.base0;
    return "inherit";
};
var linkColor = function(color) {
    if (color && [
        "primary blue",
        "dark blue"
    ].includes(color.toLowerCase())) return src_components_base__WEBPACK_IMPORTED_MODULE_0__/* .colors.lightTheme.maybeBlue300 */ .O9.lightTheme.maybeBlue300;
    return src_components_base__WEBPACK_IMPORTED_MODULE_0__/* .colors.lightTheme.maybeBlue700 */ .O9.lightTheme.maybeBlue700;
};
var colorMap = function(color) {
    return {
        bg: backgroundColor(color),
        text: textColor(color),
        link: linkColor(color)
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (colorMap);


/***/ }),

/***/ 23816:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ slice)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 24 modules
var es = __webpack_require__(95939);
// EXTERNAL MODULE: ./src/areas/sidebar/constants.ts
var constants = __webpack_require__(28438);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
;// CONCATENATED MODULE: ./src/areas/editorial-content/components/slices/slice/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      padding: ",
        " ",
        ";\n      border-left: 0;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    padding: ",
        ";\n    background-color: ",
        ";\n    color: ",
        ";\n    border-left: 1px solid ",
        ";\n\n    a:not([class]) {\n      color: ",
        ";\n\n      &:hover {\n        color: ",
        ";\n      }\n    }\n\n    ",
        ";\n\n    /* Offset to the left behind the invisible sidebar wrapper to keep full width */\n    @media screen and (min-width: ",
        "px) {\n      margin-left: ",
        ";\n    }\n\n    @media screen and (min-width: 1980px) {\n      margin-left: ",
        ";\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    /* Align content with the rest of the page */\n    @media screen and (min-width: ",
        "px) {\n      margin-left: ",
        ";\n    }\n\n    @media screen and (min-width: 1980px) {\n      margin-left: ",
        ";\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var pageContentMaxWidthVal = base/* layout.pageContentMaxWidthVal */.bK.pageContentMaxWidthVal, sidebarMenuWidth = base/* layout.sidebarMenuWidth */.bK.sidebarMenuWidth, sidebarContentWidth = base/* layout.sidebarContentWidth */.bK.sidebarContentWidth;
var pageWithSidebarContent = pageContentMaxWidthVal + sidebarMenuWidth.desktop.value * 2;
var Slice = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Slice",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject1(), props.isWhiteBG ? "0 ".concat(base/* layout.measurements.spacing150 */.bK.measurements.spacing150, " ") : base/* layout.measurements.spacing150 */.bK.measurements.spacing150, props.backgroundColor, props.textColor, props.theme.bg.primary, props.linkColor, props.theme.text.callToActionHover, base/* media.smallOnly */.BC.smallOnly(_templateObject(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing100 */.bK.measurements.spacing100), pageWithSidebarContent, props.sidebarOpen ? 0 : "calc(((1250px - 100vw) / 2) + ".concat(sidebarMenuWidth.desktop.rem, ")"), props.sidebarOpen ? 0 : "calc(-1 * ".concat(base/* layout.sidebarContentWidth.desktop.rem */.bK.sidebarContentWidth.desktop.rem, ")"));
});
var SliceContent = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SliceContent",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject2(), pageWithSidebarContent, props.sidebarOpen ? "inherit" : "calc(((100vw - 1250px) / 2) - ".concat(sidebarMenuWidth.desktop.rem, ")"), props.sidebarOpen ? "calc(((100vw - 1250px) / 2) - ".concat(sidebarMenuWidth.desktop.value + sidebarContentWidth.desktop.value, "px)") : "calc(((100vw - 1250px) / 2) - ".concat(sidebarMenuWidth.desktop.rem, ")"));
});

;// CONCATENATED MODULE: ./src/areas/editorial-content/components/slices/slice/index.tsx




var slice_Slice = function(param) {
    var className = param.className, children = param.children, _colors = param.colors, colors = _colors === void 0 ? {
        bg: "inherit",
        text: "inherit",
        link: "inherit"
    } : _colors, sidebarOpen = param.sidebarOpen, isWhiteBG = param.isWhiteBG;
    return /*#__PURE__*/ react.createElement(Slice, {
        className: className,
        sidebarOpen: sidebarOpen,
        backgroundColor: colors.bg,
        textColor: colors.text,
        linkColor: colors.link,
        isWhiteBG: isWhiteBG
    }, /*#__PURE__*/ react.createElement(SliceContent, {
        sidebarOpen: sidebarOpen
    }, children));
};
var mapStateToProps = function(state) {
    return {
        sidebarOpen: state.areas.sidebar.tab !== constants/* SIDEBAR_STATE.NONE */.$J.NONE
    };
};
/* harmony default export */ const slice = ((0,es/* connect */.$j)(mapStateToProps, {})(/*#__PURE__*/ (0,react.memo)(slice_Slice)));


/***/ }),

/***/ 82072:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _rich_text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76891);
/* harmony import */ var _shared_color_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35241);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23256);




var Text = function(param) {
    var text = param.text, textAlign = param.textAlign, backgroundColor = param.backgroundColor;
    var colors = (0,_shared_color_map__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(backgroundColor);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_3__/* .TextContainer */ .l, {
        textAlign: textAlign !== null && textAlign !== void 0 ? textAlign : "left",
        backgroundColor: colors.bg,
        textColor: colors.text
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_rich_text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        data: text
    }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Text);


/***/ }),

/***/ 23256:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": () => (/* binding */ TextContainer)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71993);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61093);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      max-width: 100%;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      padding: ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    max-width: 100%;\n    border-radius: ",
        ";\n    text-align: ",
        ";\n    background-color: ",
        ";\n    color: ",
        " ",
        ";\n\n    ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var TextContainer = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "TextContainer",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject2(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.borderRadius */ .bK.borderRadius, props.textAlign, props.backgroundColor, props.textColor, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.smallOnly */ .BC.smallOnly(_templateObject()), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumUp */ .BC.mediumUp(_templateObject1(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing200 */ .bK.measurements.spacing200));
});


/***/ }),

/***/ 11347:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71993);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  height: ",
        "px;\n  object-fit: cover;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Image = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].img.withConfig({
    displayName: "Image",
    componentId: "sc-0-0"
})(_templateObject(), function(p) {
    return p.height;
});
var CardImage = function(param) {
    var src = param.src, height = param.height, alt = param.alt;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Image, {
        src: src,
        alt: alt,
        height: height
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CardImage);


/***/ }),

/***/ 17437:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ expert_avatar)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(38689);
// EXTERNAL MODULE: ./src/components/user-avatar/index.tsx + 1 modules
var user_avatar = __webpack_require__(93538);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
;// CONCATENATED MODULE: ./src/areas/expert/components/expert-avatar/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  height: fit-content;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ExpertAvatar = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ExpertAvatar",
    componentId: "sc-0-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/areas/expert/components/expert-avatar/index.tsx





var expert_avatar_ExpertAvatar = function(param) {
    var avatar = param.avatar, className = param.className, displayName = param.displayName, link = param.link, size = param.size;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), renderMode = ref.renderMode, linkTo = ref.linkTo;
    var children = /*#__PURE__*/ react.createElement(user_avatar/* UserAvatar */.Y, {
        size: size,
        avatar: avatar,
        displayName: displayName
    });
    return /*#__PURE__*/ react.createElement(ExpertAvatar, {
        className: className
    }, link ? /*#__PURE__*/ react.createElement(clickable/* Clickable */.P, {
        to: linkTo("expertProfile", {
            semantic_id: link || ""
        }, renderMode === "native" ? {
            view: "native"
        } : undefined)
    }, children) : children);
};
/* harmony default export */ const expert_avatar = (expert_avatar_ExpertAvatar);


/***/ }),

/***/ 9131:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": () => (/* binding */ ExpertUserCard)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(38689);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(71016);
// EXTERNAL MODULE: ./src/areas/expert/components/expert-avatar/index.tsx + 1 modules
var expert_avatar = __webpack_require__(17437);
// EXTERNAL MODULE: ./src/areas/expert/types.ts
var types = __webpack_require__(99104);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(58912);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
;// CONCATENATED MODULE: ./src/areas/expert/components/expert-user-card/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    align-self: center;\n    grid-area: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    font-size: ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  grid-area: 1 / 1 / 3 / 2;\n  align-self: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    display: grid;\n    grid-template-columns: ",
        "px 1fr;\n    grid-template-rows: auto auto;\n    column-gap: ",
        ";\n    margin-left: ",
        ";\n    z-index: ",
        ";\n\n    p {\n      margin: 0;\n    }\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    ",
        "\n    max-height: ",
        "px;\n\n    &[href]:hover {\n      ",
        " {\n        color: ",
        ";\n      }\n    }\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}





var USER_AVATAR_SIZE_SMALL = 32;
var USER_AVATAR_SIZE_MEDIUM = 48;
var Title = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Title",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject(), props.$showSubtitle ? "1 / 2 / 2 / 3" : "1 / 2 / 3 / 3");
});
var Subtitle = (0,styled_components_browser_esm["default"])(variants.CaptionText).withConfig({
    displayName: "Subtitle",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject1(), props.$size === types/* ExpertUserCardSize.MEDIUM */.M.MEDIUM ? base/* layout.measurements.fontSizeNormal */.bK.measurements.fontSizeNormal : base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall);
});
var Avatar = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Avatar",
    componentId: "sc-0-2"
})(_templateObject2());
var Expert = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Expert",
    componentId: "sc-0-3"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject3(), props.$size, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, props.$overlap ? "-".concat(props.$size * props.$overlap / 2, "px") : "0", props.$index);
});
var Container = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "Container",
    componentId: "sc-0-4"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject4(), props.$pointer ? "cursor: pointer;" : "", props.$size, Title, props.theme.text.callToActionHover);
});

;// CONCATENATED MODULE: ./src/areas/expert/components/expert-user-card/index.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}








var ExpertUserCard = function(props) {
    var className = props.className, customTitle = props.customTitle, experts = props.experts, _size = props.size, size = _size === void 0 ? types/* ExpertUserCardSize.SMALL */.M.SMALL : _size, subtitle = props.subtitle, _pointer = props.pointer, pointer = _pointer === void 0 ? false : _pointer;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), t = ref.t, renderMode = ref.renderMode, linkTo = ref.linkTo;
    var avatarSize = size === types/* ExpertUserCardSize.MEDIUM */.M.MEDIUM ? USER_AVATAR_SIZE_MEDIUM : USER_AVATAR_SIZE_SMALL;
    var container = experts.length === 1 ? clickable/* Clickable */.P : "div";
    var containerProps = experts.length === 1 && experts[0].url ? {
        to: linkTo("expertProfile", {
            semantic_id: experts[0].url
        }, renderMode === "native" ? {
            view: "native"
        } : undefined),
        isExternal: renderMode === "native",
        onClick: function() {
            if (experts[0].url) {
                (0,tracking/* trackInternalNavigationClick */.p)({
                    scope: tracking/* InternalNavigationScope.EXPERT_PROFILE_GO_TO */.U.EXPERT_PROFILE_GO_TO,
                    nextPage: experts[0].url
                });
            }
        }
    } : undefined;
    var getSingularExpertText = function(expert) {
        if (customTitle) return /*#__PURE__*/ react.createElement(Title, {
            $showSubtitle: false
        }, customTitle);
        return /*#__PURE__*/ react.createElement(react.Fragment, null, size === types/* ExpertUserCardSize.MEDIUM */.M.MEDIUM ? /*#__PURE__*/ react.createElement(Title, {
            $showSubtitle: Boolean(subtitle)
        }, /*#__PURE__*/ react.createElement(variants.TitleMediumText, {
            behavior: variants.Behavior.Oneline
        }, expert.name)) : /*#__PURE__*/ react.createElement(Title, {
            $showSubtitle: Boolean(subtitle)
        }, /*#__PURE__*/ react.createElement(variants.TitleSmallText, {
            behavior: variants.Behavior.Oneline
        }, expert.name)));
    };
    var getPluralExpertText = function() {
        if (customTitle) return /*#__PURE__*/ react.createElement(Title, {
            $showSubtitle: false
        }, customTitle);
        return /*#__PURE__*/ react.createElement(react.Fragment, null, size === types/* ExpertUserCardSize.MEDIUM */.M.MEDIUM ? /*#__PURE__*/ react.createElement(Title, null, /*#__PURE__*/ react.createElement(variants.TitleMediumText, {
            behavior: variants.Behavior.Oneline
        }, t("expert", "guide.lists-expert-plural", {
            count: experts.length
        }))) : /*#__PURE__*/ react.createElement(Title, null, /*#__PURE__*/ react.createElement(variants.TitleSmallText, {
            behavior: variants.Behavior.Oneline
        }, t("expert", "guide.lists-expert-plural", {
            count: experts.length
        }))));
    };
    return /*#__PURE__*/ react.createElement(Container, _extends({
        className: className,
        as: container,
        $size: avatarSize,
        $pointer: experts.length === 1 && pointer
    }, containerProps), experts.map(function(expert, index) {
        return /*#__PURE__*/ react.createElement(Expert, {
            key: expert.name,
            $index: experts.length - index,
            $overlap: index,
            $size: avatarSize
        }, /*#__PURE__*/ react.createElement(Avatar, null, /*#__PURE__*/ react.createElement(expert_avatar/* default */.Z, {
            avatar: expert.avatar,
            displayName: expert.name,
            size: avatarSize
        })), experts.length === 1 && getSingularExpertText(expert), experts.length > 1 && index === experts.length - 1 && getPluralExpertText());
    }));
};


/***/ }),

/***/ 99104:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": () => (/* binding */ ExpertUserCardSize),
/* harmony export */   "b": () => (/* binding */ ContentTypes)
/* harmony export */ });
var ContentTypes;
(function(ContentTypes) {
    ContentTypes["TEST"] = "AdvizedTest";
    ContentTypes["TOPLIST"] = "AdvizedToplist";
    ContentTypes["TOPLIST_HEADLINE"] = "ToplistHeadline";
    ContentTypes["GUIDE"] = "ExpertGuide";
    ContentTypes["ARTICLE"] = "SearchArticleItem";
    ContentTypes["VIDEO"] = "SearchVideoItem";
})(ContentTypes || (ContentTypes = {}));
var ExpertUserCardSize;
(function(ExpertUserCardSize) {
    ExpertUserCardSize["SMALL"] = "SMALL";
    ExpertUserCardSize["MEDIUM"] = "MEDIUM";
})(ExpertUserCardSize || (ExpertUserCardSize = {}));


/***/ }),

/***/ 47609:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cb": () => (/* binding */ height),
/* harmony export */   "J7": () => (/* binding */ MegaMenuButton),
/* harmony export */   "Pz": () => (/* binding */ HeaderWrapper),
/* harmony export */   "TA": () => (/* binding */ UserArea),
/* harmony export */   "TS": () => (/* binding */ MegaMenuItem),
/* harmony export */   "W1": () => (/* binding */ SearchIcon),
/* harmony export */   "Yt": () => (/* binding */ MagnifyerButton),
/* harmony export */   "b": () => (/* binding */ RightColumn),
/* harmony export */   "b1": () => (/* binding */ LogoColumn),
/* harmony export */   "cI": () => (/* binding */ SearchBarWrapper),
/* harmony export */   "h_": () => (/* binding */ HeaderBar),
/* harmony export */   "im": () => (/* binding */ Wrapper),
/* harmony export */   "m4": () => (/* binding */ CloseMegaMenuIcon),
/* harmony export */   "pA": () => (/* binding */ MegaMenuIcon),
/* harmony export */   "ru": () => (/* binding */ MenuColumn),
/* harmony export */   "sN": () => (/* binding */ MenuItem),
/* harmony export */   "vw": () => (/* binding */ LogoLink)
/* harmony export */ });
/* unused harmony exports FixedMargin, PromoText */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71993);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3616);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61093);
/* harmony import */ var _prisjakt_ui_tooltip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(714);
/* harmony import */ var src_ui_zindex__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93497);
/* harmony import */ var _prisjakt_ui_icon_categories__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12099);
/* harmony import */ var _prisjakt_ui_icon_close__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15309);
/* harmony import */ var _prisjakt_ui_icon_magnifier__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(38314);
/* harmony import */ var _prisjakt_ui_clickable__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25181);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    height: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: sticky;\n  height: ",
        ";\n  ",
        "\n  z-index: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    background: transparent;\n    height: auto;\n    max-height: ",
        ";\n\n    ::before {\n      background: ",
        ";\n      content: '';\n      display: block;\n      height: ",
        ";\n      left: -50px;\n      position: absolute;\n      right: 0;\n      top: 0;\n      z-index: -1;\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  background: ",
        ";\n  width: 100%;\n  position: fixed;\n  top: 0;\n  height: ",
        ";\n  /* Should be above mega menu */\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    height: ",
        ";\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    justify-content: flex-start;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 1;\n  justify-content: space-between;\n  align-items: stretch;\n  width: 100%;\n  max-width: ",
        "px;\n  height: 100%;\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  /* Should be above SlidingBox */\n  z-index: 2;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  height: 100%;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n    width: 100px;\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  width: 50px;\n  height: 100%;\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  width: auto;\n\n  ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  height: ",
        ";\n  flex-grow: 0;\n\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  cursor: pointer;\n  display: block;\n  height: 100%;\n  width: ",
        ";\n  background: ",
        ";\n  color: ",
        ";\n  transition:\n    background-color 0.1s linear,\n    color 0.1s linear;\n\n  &:hover,\n  &.focus-visible {\n    background: ",
        ";\n  }\n\n  /* Double selector to override aggressive user-agent styles in e.g. Firefox */\n  &:focus:focus {\n    outline: none;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  fill: currentColor;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  fill: currentColor;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n    max-width: 200px;\n  "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n    height: ",
        ";\n    width: auto;\n  "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        '\n\n  /* Special case for a certain interval of viewport widths where we set this whole column as fixed position and aligned to the left.\n     This is because we want the mega menu button to align with the sidebar, but it also has to play nicely with the logo when they "collide".\n     See also the Wrapper component which adds a pseudo-element at this same interval to reserve space for the column. */\n  @media screen and (min-width: ',
        "px) and (max-width: ",
        "px) {\n    left: 0;\n    height: ",
        ";\n  }\n\n  ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n    margin-left: 0;\n  "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n      height: ",
        ";\n    "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n      height: ",
        ";\n    "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  justify-content: center;\n  height: 100%;\n  padding: 0 10px;\n\n  ",
        ";\n\n  img {\n    height: ",
        ";\n\n    ",
        ";\n\n    ",
        ";\n  }\n\n  &.focus-visible {\n    background: ",
        ";\n    outline: none;\n  }\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _taggedTemplateLiteral([
        "\n    flex: 0 0 50px;\n    width: auto;\n  "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _taggedTemplateLiteral([
        "\n    flex-grow: 1;\n  "
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _taggedTemplateLiteral([
        "\n    justify-content: flex-end;\n  "
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  width: auto;\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _taggedTemplateLiteral([
        "\n      display: none;\n    "
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        "\n\n    display: flex;\n    align-items: center;\n    color: ",
        ";\n    margin-left: ",
        ";\n    font-size: 12px;\n    font-weight: 600;\n    letter-spacing: 0.4px;\n    max-width: 120px;\n    margin-right: ",
        ";\n  "
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  fill: currentColor;\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = _taggedTemplateLiteral([
        "\n    /* Needed in order to bring the search box closer to center when there is no login button. */\n    min-width: ",
        "};\n  "
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = _taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-right: ",
        ";\n  margin-left: auto;\n  position: relative;\n  ",
        "\n\n  > :not(:last-child) {\n    margin-right: ",
        ";\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = _taggedTemplateLiteral([
        "\n    height: 0;\n    width: 0;\n    overflow: hidden;\n    position: absolute;\n  "
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  ",
        "\n  align-items: center;\n  justify-content: center;\n  flex-grow: 1;\n  margin: 0 50px;\n"
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}









var logoHeight = {
    small: "30px",
    medium: "35px",
    large: "38px"
};
var height = {
    desktop: src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.headerHeight.desktop.rem */ .bK.headerHeight.desktop.rem,
    mobile: src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.headerHeight.mobile.rem */ .bK.headerHeight.mobile.rem,
    mobileWithSearch: src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.headerHeight.mobileWithSearch.rem */ .bK.headerHeight.mobileWithSearch.rem
};
var headerMaxWidth = src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.pageContent.maxWidth */ .bK.pageContent.maxWidth;
// The viewport width above which the collapsed sidebar no longer occupies the same horizontal area as the header content
var sidebarOutsideHeaderWidth = headerMaxWidth.value + src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.sidebarMenuWidth.desktop.value */ .bK.sidebarMenuWidth.desktop.value * 2;
var mobileHeaderHeight = function(param) {
    var mobileSearchOpen = param.mobileSearchOpen;
    return mobileSearchOpen ? src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.headerHeight.mobileWithSearch.value */ .bK.headerHeight.mobileWithSearch.value : src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.headerHeight.mobile.value */ .bK.headerHeight.mobile.value;
};
var FixedMargin = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "FixedMargin",
    componentId: "sc-0-0"
})(function(props) {
    return [
        {
            display: props.theme.layout === "raw-mobile" ? "none" : "block",
            height: height.desktop,
            transition: "height 300ms ease",
            willChange: "height"
        },
        src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.smallOnly */ .BC.smallOnly({
            height: (0,src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .remCalc */ .vR)(mobileHeaderHeight(props))
        })
    ];
});
var HeaderWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].header.withConfig({
    displayName: "HeaderWrapper",
    componentId: "sc-0-1"
})(_templateObject1(), height.desktop, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.mediumDown */ .BC.mediumDown(_templateObject(), height.mobile), src_ui_zindex__WEBPACK_IMPORTED_MODULE_4__/* .zindex.menu.header */ .Y.menu.header);
var HeaderBar = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].header.attrs({
    "data-test": "Header"
}).withConfig({
    displayName: "HeaderBar",
    componentId: "sc-0-2"
})(_templateObject3(), function(p) {
    return p.theme.header.bg;
}, height.desktop, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.smallOnly */ .BC.smallOnly(_templateObject2(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.headerHeight.mobileWithSearch.rem */ .bK.headerHeight.mobileWithSearch.rem, function(p) {
    return p.theme.header.bg;
}, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.headerHeight.mobile.rem */ .bK.headerHeight.mobile.rem));
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-3"
})(_templateObject6(), headerMaxWidth.value + src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.sidebarMenuWidth.desktop.value */ .bK.sidebarMenuWidth.desktop.value, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.smallOnly */ .BC.smallOnly(_templateObject4(), height.mobile), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.mediumOnly */ .BC.mediumOnly(_templateObject5()));
var columnStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject7());
var MenuItem = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "MenuItem",
    componentId: "sc-0-4"
})(_templateObject9(), function(props) {
    return props.wideOnTablet && src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.mediumOnly */ .BC.mediumOnly(_templateObject8());
});
var MenuColumn = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "MenuColumn",
    componentId: "sc-0-5"
})(_templateObject11(), columnStyles, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.largeUp */ .BC.largeUp(_templateObject10()));
var MegaMenuItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_tooltip__WEBPACK_IMPORTED_MODULE_3__/* .Tooltip */ .u).withConfig({
    displayName: "MegaMenuItem",
    componentId: "sc-0-6"
})(_templateObject13(), height.desktop, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.mediumDown */ .BC.mediumDown(_templateObject12()));
var MegaMenuButton = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].button.withConfig({
    displayName: "MegaMenuButton",
    componentId: "sc-0-7"
})(_templateObject14(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.sidebarMenuWidth.desktop.rem */ .bK.sidebarMenuWidth.desktop.rem, function(p) {
    return p.active ? "white" : "transparent";
}, function(p) {
    return p.active ? p.theme.icons.callToAction : p.theme.header.fg;
}, function(p) {
    return p.active ? "white" : p.theme.buttons.primary.bg;
});
var MegaMenuIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_icon_categories__WEBPACK_IMPORTED_MODULE_5__/* .IconCategories */ .L).attrs(function(p) {
    return {
        color: p.theme.header.fg
    };
}).withConfig({
    displayName: "MegaMenuIcon",
    componentId: "sc-0-8"
})(_templateObject15());
var CloseMegaMenuIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_icon_close__WEBPACK_IMPORTED_MODULE_6__.IconClose).attrs(function(p) {
    return {
        color: p.theme.colors.maybeBlue700
    };
}).withConfig({
    displayName: "CloseMegaMenuIcon",
    componentId: "sc-0-9"
})(_templateObject16());
var LogoColumn = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "LogoColumn",
    componentId: "sc-0-10"
})(_templateObject19(), columnStyles, headerMaxWidth.value, sidebarOutsideHeaderWidth, height.desktop, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.mediumOnly */ .BC.mediumOnly(_templateObject17()), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.smallOnly */ .BC.smallOnly(_templateObject18(), height.mobile));
var LogoLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(react_router_dom__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rU).withConfig({
    displayName: "LogoLink",
    componentId: "sc-0-11"
})(_templateObject23(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.showOutsiderAd */ .BC.showOutsiderAd(_templateObject20()), logoHeight.small, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.mediumUp */ .BC.mediumUp(_templateObject21(), logoHeight.medium), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.largeUp */ .BC.largeUp(_templateObject22(), logoHeight.large), function(p) {
    return p.theme.buttons.primary.bg;
});
var RightColumn = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "RightColumn",
    componentId: "sc-0-12"
})(_templateObject27(), columnStyles, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.smallOnly */ .BC.smallOnly(_templateObject24()), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.mediumOnly */ .BC.mediumOnly(_templateObject25()), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.mediumDown */ .BC.mediumDown(_templateObject26()));
var PromoText = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "PromoText",
    componentId: "sc-0-13"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject29(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.mediumDown */ .BC.mediumDown(_templateObject28()), props.theme.colors.base0, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing200 */ .bK.measurements.spacing200, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
});
var SearchIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_icon_magnifier__WEBPACK_IMPORTED_MODULE_7__/* .IconMagnifier */ .j).attrs(function(p) {
    return {
        color: p.theme.header.fg
    };
}).withConfig({
    displayName: "SearchIcon",
    componentId: "sc-0-14"
})(_templateObject30(), function(p) {
    return p.theme.header.fg;
});
var UserArea = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "UserArea",
    componentId: "sc-0-15"
})(_templateObject33(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.largeUp */ .BC.largeUp(_templateObject31(), (0,src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .remCalc */ .vR)(96)), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.mediumDown */ .BC.mediumDown(_templateObject32()));
var MagnifyerButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_clickable__WEBPACK_IMPORTED_MODULE_8__.Clickable).withConfig({
    displayName: "MagnifyerButton",
    componentId: "sc-0-16"
})(_templateObject34());
var SearchBarWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "SearchBarWrapper",
    componentId: "sc-0-17"
})(_templateObject36(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.smallOnly */ .BC.smallOnly(_templateObject35()), function(p) {
    return !p.$visible ? "display: none;" : "display: flex;";
});


/***/ }),

/***/ 85944:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": () => (/* binding */ useIsKWLP),
/* harmony export */   "e": () => (/* binding */ IsKWLPContext)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);

var IsKWLPContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(false);
var useIsKWLP = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(IsKWLPContext);
};


/***/ }),

/***/ 17720:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23114);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}


var MegaMenuLoadable = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "mega-menu";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | mega-menu */ 495).then(__webpack_require__.bind(__webpack_require__, 62369));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(62369);
        }
        return eval("require.resolve")("./mega-menu");
    }
});
var MegaMenu = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MegaMenuLoadable, _extends({}, props));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (MegaMenu);


/***/ }),

/***/ 66782:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ mobile_menu_button)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 24 modules
var es = __webpack_require__(95939);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./src/areas/changelog/components/badge/index.tsx
var badge = __webpack_require__(27203);
// EXTERNAL MODULE: ./src/areas/navigation/actions/mobile-menu.js
var mobile_menu = __webpack_require__(59361);
// EXTERNAL MODULE: ./src/areas/sidebar/tracking/index.ts
var tracking = __webpack_require__(15211);
// EXTERNAL MODULE: ./src/areas/sidebar/components/sidebar-mobile/constants.ts
var constants = __webpack_require__(8818);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/menu-hamburger/index.js
var menu_hamburger = __webpack_require__(63460);
;// CONCATENATED MODULE: ./src/areas/navigation/components/mobile-menu-button/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  line-height: inherit;\n  text-align: left;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n  position: relative;\n\n  ",
        ";\n\n  &.focus-visible {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  min-width: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var MenuButton = styled_components_browser_esm["default"].button.attrs({
    type: "button"
}).withConfig({
    displayName: "MenuButton",
    componentId: "sc-0-0"
})(_templateObject1(), function(props) {
    return props.theme.header.fg;
}, base/* media.largeUp */.BC.largeUp(_templateObject()), function(p) {
    return p.active ? "white" : p.theme.buttons.primary.bg;
});
var MenuIcon = (0,styled_components_browser_esm["default"])(menu_hamburger/* IconMenuHamburger */.P).attrs({
    size: 32,
    color: "base100"
}).withConfig({
    displayName: "MenuIcon",
    componentId: "sc-0-1"
})(_templateObject2(), (0,base/* remCalc */.vR)(27));

;// CONCATENATED MODULE: ./src/areas/navigation/components/mobile-menu-button/index.tsx









var MobileButton = function(param) {
    var _handleOnClick = param.handleOnClick, handleOnClick = _handleOnClick === void 0 ? base/* noop */.ZT : _handleOnClick;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var open = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.navigation.mobileMenu;
    }).open;
    var dispatch = (0,es/* useDispatch */.I0)();
    var toggleMenu = function() {
        if (open) {
            dispatch(mobile_menu/* default.closeMenu */.ZP.closeMenu());
        } else {
            (0,tracking/* trackOpeningSidebar */.b)(constants/* VIEWS.ROOT */.n.ROOT, "MobileMenuButton");
            dispatch(mobile_menu/* default.openMenu */.ZP.openMenu());
            handleOnClick();
        }
    };
    return /*#__PURE__*/ react.createElement(MenuButton, {
        onClick: toggleMenu,
        "aria-label": t("header", "mobile-menu.title"),
        "data-test": "MobileMenuButton"
    }, /*#__PURE__*/ react.createElement(badge/* default */.ZP, null), /*#__PURE__*/ react.createElement(MenuIcon, {
        size: 32
    }));
};
/* harmony default export */ const mobile_menu_button = (MobileButton);


/***/ }),

/***/ 40407:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": () => (/* binding */ EmailHint)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71993);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    margin: 0.5rem 0;\n\n    display: ",
        ";\n\n    a {\n      text-decoration: underline !important;\n      ",
        "\n    }\n\n    ",
        "\n\n    p {\n      margin: 0;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var EmailHint = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.attrs({
    "data-test": "EmailHint"
}).withConfig({
    displayName: "EmailHint",
    componentId: "sc-0-0"
})(_templateObject(), function(p) {
    return p.visible ? "block" : "none";
}, function(p) {
    return p.discreetLink && "color: ".concat(p.theme.colors.base500, ";");
}, function(p) {
    return p.error && "color: ".concat(p.theme.colors.negative700, ";");
});


/***/ }),

/***/ 94778:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D1": () => (/* binding */ Errors),
/* harmony export */   "d_": () => (/* binding */ AlertTypes),
/* harmony export */   "lc": () => (/* binding */ ShopPreference)
/* harmony export */ });
var AlertTypes;
(function(AlertTypes) {
    AlertTypes["IN_STOCK"] = "IN_STOCK";
    AlertTypes["PRICE_DROPS"] = "PRICE_DROPS";
    AlertTypes["IN_STOCK_PRICE_DROPS"] = "IN_STOCK_PRICE_DROPS";
})(AlertTypes || (AlertTypes = {}));
var ShopPreference;
(function(ShopPreference) {
    ShopPreference["NONE"] = "NONE";
    ShopPreference["LIKED"] = "LIKED";
    ShopPreference["EXCLUDE_DISLIKED"] = "EXCLUDE_DISLIKED";
})(ShopPreference || (ShopPreference = {}));
var Errors;
(function(Errors) {
    Errors["ERROR_EMAIL_INVALID"] = "alert.invalid-email";
    Errors["ERROR_EMAIL_IN_USE"] = "EMAIL_ASSOCIATED_WITH_USER";
    Errors["ERROR_UNKNOWN"] = "alert.error";
    Errors["ERROR_THRESHOLD_TOO_LOW"] = "alert.threshold-too-low";
})(Errors || (Errors = {}));


/***/ }),

/***/ 95388:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$3": () => (/* binding */ SET_PRODUCT_COLLECTION_LAYOUT),
/* harmony export */   "E8": () => (/* binding */ updateProductCollectionFilters),
/* harmony export */   "On": () => (/* binding */ UPDATE_PRODUCT_COLLECTION_FILTERS),
/* harmony export */   "l2": () => (/* binding */ setProductCollectionLayout)
/* harmony export */ });
var SET_PRODUCT_COLLECTION_LAYOUT = "SET_PRODUCT_COLLECTION_LAYOUT";
var UPDATE_PRODUCT_COLLECTION_FILTERS = "UPDATE_PRODUCT_COLLECTION_FILTERS";
var setProductCollectionLayout = function(layout) {
    return {
        type: SET_PRODUCT_COLLECTION_LAYOUT,
        layout: layout
    };
};
var updateProductCollectionFilters = function(id, filters) {
    return {
        type: UPDATE_PRODUCT_COLLECTION_FILTERS,
        id: id,
        filters: filters
    };
};


/***/ }),

/***/ 3049:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61093);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71993);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  background: ",
        ";\n  border-radius: 1px;\n  box-shadow: 0 0 0 0.2em\n    ",
        ";\n  font-style: normal;\n  font-weight: bold;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/**
 * Accepts a string containing search highlight markup and returns a formatted React element.
 */ var HighlightedSearchResult = function(param) {
    var children = param.children, component = param.component;
    var highlightPattern = /\[highlight\](.+?)\[\/highlight\]/g;
    var parts = [];
    var match = highlightPattern.exec(children);
    var nextPartStartIndex = 0;
    var Component = component || Highlight;
    while(match !== null){
        // Yield a text node of the part from the start of the string or the end of the previous match
        // to the start of the current match
        parts.push(children.substring(nextPartStartIndex, match.index));
        // Yield the formatted content of the current match
        parts.push(/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(Component, {
            key: match.index
        }, match[1]));
        // Remember the end of the current match, and try to match the next highlight (if any)
        nextPartStartIndex = highlightPattern.lastIndex;
        match = highlightPattern.exec(children);
    }
    // Yield a text node of the part from the end of the last match to the end of the string
    parts.push(children.substr(nextPartStartIndex));
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null, parts);
};
var Highlight = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].em.withConfig({
    displayName: "Highlight",
    componentId: "sc-0-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return src_components_base__WEBPACK_IMPORTED_MODULE_0__/* .colorUtils.setRgbaAlpha */ .$n.setRgbaAlpha(theme.colors.yellove500, 0.2);
}, function(param) {
    var theme = param.theme;
    return src_components_base__WEBPACK_IMPORTED_MODULE_0__/* .colorUtils.setRgbaAlpha */ .$n.setRgbaAlpha(theme.colors.yellove500, 0.2);
});
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (HighlightedSearchResult);


/***/ }),

/***/ 73050:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ie": () => (/* binding */ toggleSearchInput),
/* harmony export */   "_6": () => (/* binding */ setAddProductAnimation),
/* harmony export */   "fo": () => (/* binding */ TOGGLE_SEARCH_INPUT),
/* harmony export */   "nd": () => (/* binding */ SET_ADD_PRODUCT_ANIMATION)
/* harmony export */ });
var TOGGLE_SEARCH_INPUT = "TOGGLE_SEARCH_INPUT";
var SET_ADD_PRODUCT_ANIMATION = "SET_ADD_PRODUCT_ANIMATION";
var toggleSearchInput = function() {
    return {
        type: TOGGLE_SEARCH_INPUT
    };
};
var setAddProductAnimation = function(state) {
    return {
        type: SET_ADD_PRODUCT_ANIMATION,
        state: state
    };
};


/***/ }),

/***/ 36483:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Yc": () => (/* binding */ headerClickEvent),
  "nA": () => (/* binding */ productClickOutBounce),
  "$0": () => (/* binding */ productNavigation),
  "Po": () => (/* binding */ productPriceClick)
});

;// CONCATENATED MODULE: ./src/areas/product/actions/ga.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function getTypeFromStatus(status) {
    switch(status){
        case "international":
        case "variant":
        case "":
            return "normal";
        case undefined:
        case "raw":
        default:
            return "";
    }
}
function getGAPriceFromObject(price, status) {
    switch(price.__typename){
        case "Price":
            return price;
        default:
            return _objectSpreadProps(_objectSpread({}, price), {
                type: getTypeFromStatus(status)
            });
    }
}
function getGAPrice(price, status) {
    return typeof price === "object" && price !== null ? getGAPriceFromObject(price, status) : {
        price: price,
        type: getTypeFromStatus(status)
    };
}
function getGAFeatured(featured) {
    return featured ? "Featured" : "Not Featured";
}

// EXTERNAL MODULE: ./src/areas/product/actions/types.ts
var types = __webpack_require__(58848);
;// CONCATENATED MODULE: ./src/areas/product/actions/product.ts
function product_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function product_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            product_defineProperty(target, key, source[key]);
        });
    }
    return target;
}


// NOTE: Any changes done to data or structure of PRODUCT_PRICE_CLICK needs to be
// reflected in react/middlewares/out.js pre click for tracking clicks before JS bundle
var productPriceClick = function(productId, price, featured, status, isAlternative, context, stockStatus, condition) {
    return {
        type: types/* ProductActionType.PRODUCT_PRICE_CLICK */.Z.PRODUCT_PRICE_CLICK,
        pretrack: false,
        productId: productId,
        price: getGAPrice(price, status),
        featured: getGAFeatured(featured),
        status: status,
        isAlternative: isAlternative,
        context: context,
        stockStatus: stockStatus,
        condition: condition
    };
};
var productNavigation = function(action, index) {
    return {
        type: types/* ProductActionType.PRODUCT_NAVIGATION */.Z.PRODUCT_NAVIGATION,
        action: action,
        index: index
    };
};
var productClickOutBounce = function(data) {
    return product_objectSpread({
        type: types/* ProductActionType.PRODUCT_PRICE_CLICK_BOUNCE */.Z.PRODUCT_PRICE_CLICK_BOUNCE
    }, data);
};
var headerClickEvent = function(event) {
    return {
        type: types/* ProductActionType.PRODUCT_HEADER_CLICK */.Z.PRODUCT_HEADER_CLICK,
        event: event
    };
};


/***/ }),

/***/ 58848:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ ProductActionType)
/* harmony export */ });
var ProductActionType;
(function(ProductActionType) {
    ProductActionType["PRODUCT_RECEIVE"] = "PRODUCT_RECEIVE";
    ProductActionType["PRODUCT_FETCH_ERROR"] = "PRODUCT_FETCH_ERROR";
    ProductActionType["PRODUCT_RATE_REQUEST"] = "PRODUCT_RATE_REQUEST";
    ProductActionType["PRODUCT_REVIEW_FAILED"] = "PRODUCT_REVIEW_FAILED";
    ProductActionType["PRODUCT_PRICE_CLICK"] = "PRODUCT_PRICE_CLICK";
    ProductActionType["PRODUCT_NAVIGATION"] = "PRODUCT_NAVIGATION";
    ProductActionType["PRODUCT_PRICE_CLICK_BOUNCE"] = "PRODUCT_PRICE_CLICK_BOUNCE";
    ProductActionType["PRODUCT_HEADER_CLICK"] = "PRODUCT_HEADER_CLICK";
    ProductActionType["CAMPAIGNS_RECEIVE"] = "CAMPAIGNS_RECEIVE";
    ProductActionType["ROUTE_LOADED"] = "ROUTE_LOADED";
})(ProductActionType || (ProductActionType = {}));


/***/ }),

/***/ 3460:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xV": () => (/* reexport */ CampaignBadge),
  "fd": () => (/* reexport */ MembershipBadge),
  "pb": () => (/* reexport */ MembershipInformation)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/badge/index.js
var badge = __webpack_require__(29242);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(71016);
;// CONCATENATED MODULE: ./src/areas/product/components/badges/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      font-size: 10px;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        "\n    font-style: italic;\n    margin-left: ",
        ";\n    margin-right: ",
        ";\n    white-space: break-spaces;\n\n    /* Small mobile resolutions, e.g. Galaxy Fold */\n    @media screen and (max-width: 280px) {\n      margin-left: 0;\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      justify-content: flex-end;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        "\n    display: flex;\n    align-items: center;\n    gap: ",
        ";\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var StyledTextWrapper = (0,styled_components_browser_esm["default"])(variants.CaptionText).withConfig({
    displayName: "StyledTextWrapper",
    componentId: "sc-0-0"
})(_templateObject());
var StyledText = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledText",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject2(), props.$smallerTextSize && (0,styled_components_browser_esm.css)(_templateObject1()), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
});
var StyledBadgeWrapper = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledBadgeWrapper",
    componentId: "sc-0-2"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject4(), props.$alignRight && (0,styled_components_browser_esm.css)(_templateObject3()), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
});

;// CONCATENATED MODULE: ./src/areas/product/components/badges/membership-badge.tsx




var MembershipBadge = function(param) {
    var alignRight = param.alignRight, isMembershipPrice = param.isMembershipPrice;
    var t = (0,app_context/* useAppContext */.bp)().t;
    if (!isMembershipPrice) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(StyledBadgeWrapper, {
        $alignRight: alignRight
    }, /*#__PURE__*/ react.createElement(badge.Badge, {
        color: "YELLOW",
        size: badge.BadgeSize.SMALL,
        text: t("product", "promotions.members-price"),
        containerProps: {
            "data-testid": "MembershipPriceBadge"
        }
    }));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/info-outlined/index.js
var info_outlined = __webpack_require__(12525);
;// CONCATENATED MODULE: ./src/areas/product/components/badges/membership-information.tsx





var MembershipInformation = function(param) {
    var isMembershipPrice = param.isMembershipPrice, isPaidMembership = param.isPaidMembership, smallerTextSize = param.smallerTextSize;
    var t = (0,app_context/* useAppContext */.bp)().t;
    if (!isMembershipPrice || !isPaidMembership) return null;
    return /*#__PURE__*/ react.createElement(StyledTextWrapper, {
        emphasis: variants.FontEmphasis.HIGH,
        color: variants.FontColor.DARK
    }, /*#__PURE__*/ react.createElement(info_outlined/* IconInfoOutlined */.e, {
        size: 12
    }), /*#__PURE__*/ react.createElement(StyledText, {
        $smallerTextSize: smallerTextSize,
        "data-testid": "PaidMembershipInfo"
    }, t("product", "promotions.membership-price-info")));
};

// EXTERNAL MODULE: ./src/components/offer/price/offer-price/utils.ts
var utils = __webpack_require__(48652);
// EXTERNAL MODULE: ./src/components/offer/price/offer-price/price-data.ts + 1 modules
var price_data = __webpack_require__(88584);
;// CONCATENATED MODULE: ./src/areas/product/components/badges/campaign-badge.tsx






var CampaignBadge = function(param) {
    var alignRight = param.alignRight, containerProps = param.containerProps, isCampaign = param.isCampaign, originalPrice = param.originalPrice, price = param.price, priceExpires = param.priceExpires;
    var ref = (0,app_context/* useAppContext */.bp)(), market = ref.market, t = ref.t;
    if (!isCampaign || !originalPrice || !price || originalPrice <= price) {
        return null;
    }
    var percentage = (0,utils/* getSalesPricePercentage */.U)(price, originalPrice);
    if (!percentage) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(StyledBadgeWrapper, {
        $alignRight: alignRight
    }, /*#__PURE__*/ react.createElement(badge.Badge, {
        color: "RED",
        size: badge.BadgeSize.SMALL,
        text: priceExpires ? t("campaigns", "campaign-card.sale-badge-end-date-percentage", {
            percentage: percentage,
            date: (0,price_data/* parseUTCDate */.kT)(priceExpires, market.localeStandard)
        }) : t("campaigns", "campaign-card.sale-percentage", {
            percentage: percentage
        }),
        containerProps: containerProps
    }));
};

;// CONCATENATED MODULE: ./src/areas/product/components/badges/index.ts





/***/ }),

/***/ 56829:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": () => (/* binding */ CAROUSEL_HEIGHT),
/* harmony export */   "R": () => (/* binding */ OtherAlsoVisitedCarousel)
/* harmony export */ });
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23114);

var CAROUSEL_HEIGHT = "340px";
var OtherAlsoVisitedCarousel = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "extra";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | extra */ 737).then(__webpack_require__.bind(__webpack_require__, 65436));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(65436);
        }
        return eval("require.resolve")("./others-also-visited-carousel");
    }
});


/***/ }),

/***/ 17512:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": () => (/* binding */ PartnerVideoModal)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/modal/index.js
var modal = __webpack_require__(58709);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/modal-v2/index.tsx
var modal_v2 = __webpack_require__(54674);
// EXTERNAL MODULE: ./src/components/youtube/index.tsx + 1 modules
var youtube = __webpack_require__(5549);
;// CONCATENATED MODULE: ./src/areas/product/components/carousel-products/components/partner-video-carousel/components/partner-video-modal/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    height: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  height: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  height: 100%;\n\n  div {\n    background-color: ",
        ";\n    background-repeat-x: no-repeat;\n    background-position-x: center;\n    background-size: auto 100%;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var StyledModal = (0,styled_components_browser_esm["default"])(modal_v2/* default */.Z).withConfig({
    displayName: "StyledModal",
    componentId: "sc-0-0"
})(_templateObject());
var StyledModalBody = (0,styled_components_browser_esm["default"])(modal/* ModalBody */.fe).withConfig({
    displayName: "StyledModalBody",
    componentId: "sc-0-1"
})(_templateObject1());
var StyledYoutubeLoader = (0,styled_components_browser_esm["default"])(youtube/* default */.Z).withConfig({
    displayName: "StyledYoutubeLoader",
    componentId: "sc-0-2"
})(_templateObject2(), function(p) {
    return p.theme.colors.base900;
});

;// CONCATENATED MODULE: ./src/areas/product/components/carousel-products/components/partner-video-carousel/components/partner-video-modal/index.tsx



var PartnerVideoModal = function(props) {
    var closeModal = props.closeModal, isOpen = props.isOpen, thumbnail = props.thumbnail, title = props.title, videoId = props.videoId;
    return /*#__PURE__*/ react.createElement(StyledModal, {
        isOpen: isOpen,
        onRequestClose: closeModal,
        size: modal/* ModalSizeEnum.FULL */.E$.FULL,
        title: title || ""
    }, /*#__PURE__*/ react.createElement(StyledModalBody, null, /*#__PURE__*/ react.createElement(StyledYoutubeLoader, {
        thumbnail: thumbnail,
        id: videoId
    })));
};


/***/ }),

/***/ 29184:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": () => (/* binding */ CarouselProducts)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95939);
/* harmony import */ var _components_cards_carousel_carousel_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22556);
/* harmony import */ var src_components_cards_carousel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59307);
/* harmony import */ var src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58912);
/* harmony import */ var _actions_product__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36483);
/* harmony import */ var src_globals_helpers_navigation_action__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10681);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48458);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(92752);









function getInternalNavigationScope(carouselType) {
    switch(carouselType){
        case _types__WEBPACK_IMPORTED_MODULE_8__/* .CarouselTypeEnum.OTHER_POPULAR_PRODUCTS */ .c.OTHER_POPULAR_PRODUCTS:
            return src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_4__/* .InternalNavigationScope.OTHER_PRODUCTS_PRODUCT_CARD */ .U.OTHER_PRODUCTS_PRODUCT_CARD;
        case _types__WEBPACK_IMPORTED_MODULE_8__/* .CarouselTypeEnum.OTHERS_VISITED */ .c.OTHERS_VISITED:
            return src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_4__/* .InternalNavigationScope.OTHER_VISITED_PRODUCTS_PRODUCT_CARD */ .U.OTHER_VISITED_PRODUCTS_PRODUCT_CARD;
        case _types__WEBPACK_IMPORTED_MODULE_8__/* .CarouselTypeEnum.TRENDING_PRODUCTS */ .c.TRENDING_PRODUCTS:
            return src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_4__/* .InternalNavigationScope.TRENDING_PRODUCTS_PRODUCT_CARD */ .U.TRENDING_PRODUCTS_PRODUCT_CARD;
        default:
            break;
    }
    return src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_4__/* .InternalNavigationScope.TRENDING_PRODUCTS_PRODUCT_CARD */ .U.TRENDING_PRODUCTS_PRODUCT_CARD;
}
function getNavigationAction(carouselType) {
    switch(carouselType){
        case _types__WEBPACK_IMPORTED_MODULE_8__/* .CarouselTypeEnum.OTHERS_VISITED */ .c.OTHERS_VISITED:
            return src_globals_helpers_navigation_action__WEBPACK_IMPORTED_MODULE_6__/* .OTHERS_ALSO_VISITED_PRODUCT_CLICK */ .dL;
        case _types__WEBPACK_IMPORTED_MODULE_8__/* .CarouselTypeEnum.OTHER_POPULAR_PRODUCTS */ .c.OTHER_POPULAR_PRODUCTS:
            return src_globals_helpers_navigation_action__WEBPACK_IMPORTED_MODULE_6__/* .OTHER_POPULAR_PRODUCT_CLICK */ .IT;
        case _types__WEBPACK_IMPORTED_MODULE_8__/* .CarouselTypeEnum.TRENDING_PRODUCTS */ .c.TRENDING_PRODUCTS:
            return src_globals_helpers_navigation_action__WEBPACK_IMPORTED_MODULE_6__/* .TRENDING_PRODUCT_CLICK */ .fT;
        default:
            break;
    }
    return src_globals_helpers_navigation_action__WEBPACK_IMPORTED_MODULE_6__/* .TRENDING_PRODUCT_CLICK */ .fT;
}
var CarouselProducts = function(param) {
    var carouselType = param.carouselType, _contextId = param.contextId, contextId = _contextId === void 0 ? _constants__WEBPACK_IMPORTED_MODULE_7__/* .PRODUCT_CONTEXT_ID */ .S : _contextId, products = param.products, _title = param.title, title = _title === void 0 ? "" : _title;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    var handleProductClick = function(index, link, productId) {
        dispatch((0,_actions_product__WEBPACK_IMPORTED_MODULE_5__/* .productNavigation */ .$0)(getNavigationAction(carouselType), index + 1));
        (0,src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_4__/* .trackInternalNavigationClick */ .p)({
            scope: getInternalNavigationScope(carouselType),
            nextPage: link,
            index: index
        });
    };
    if (!(products === null || products === void 0 ? void 0 : products.length)) return null;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_cards_carousel_carousel_context__WEBPACK_IMPORTED_MODULE_2__/* .CarouselContextContainer */ .L, {
        items: products,
        negativeMargin: true,
        onCardClick: function(param) {
            var index = param.index, link = param.link, productId = param.productId;
            return handleProductClick(index, link, productId);
        },
        title: title
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_cards_carousel__WEBPACK_IMPORTED_MODULE_3__/* .CardsCarousel */ .T, null));
};


/***/ }),

/***/ 92752:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": () => (/* binding */ CarouselTypeEnum)
/* harmony export */ });
var CarouselTypeEnum;
(function(CarouselTypeEnum) {
    CarouselTypeEnum["OTHERS_VISITED"] = "others-visited";
    CarouselTypeEnum["SIMILAR_PRODUCTS"] = "similar-products";
    CarouselTypeEnum["TRENDING_PRODUCTS"] = "trending-products";
    CarouselTypeEnum["OTHER_POPULAR_PRODUCTS"] = "other-popular-products";
    CarouselTypeEnum["PERSONALIZED"] = "personalized";
})(CarouselTypeEnum || (CarouselTypeEnum = {}));


/***/ }),

/***/ 28510:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": () => (/* binding */ mapCarouselProducts)
/* harmony export */ });
var mapCarouselProducts = function(items) {
    if (!items) return null;
    var _pathName;
    return items.filter(function(tp) {
        return Boolean(tp);
    }).filter(function(tp) {
        return Boolean(tp.pathName);
    }).map(function(product) {
        return {
            id: Number(product.id),
            name: String(product.name),
            pathName: (_pathName = product.pathName) !== null && _pathName !== void 0 ? _pathName : "",
            media: {
                first: product.imageUrl,
                count: 1
            },
            priceSummary: {
                regular: product.price
            },
            classicFullPath: String(product.url),
            userReviewSummary: product.userReviewSummary,
            aggregatedRating: product.aggregatedRating,
            isExpertTopRated: product.isExpertTopRated
        };
    });
};


/***/ }),

/***/ 17965:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": () => (/* binding */ CarrierLogo)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18026);


var CarrierLogo = function(name) {
    var inStorePickup = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var market = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_1__/* .AppContext */ .Il).market;
    var imgWrapper = function(imgName) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
            alt: imgName,
            src: "".concat(market.cdn, "/g/rfe/carriers/").concat(imgName, ".svg")
        });
    };
    if (inStorePickup) {
        return imgWrapper("instore-pickup");
    }
    // Note: the carrier logos below should be the same as in Business Center
    switch(name.toLocaleLowerCase()){
        case "airmee":
            return imgWrapper("airmee");
        case "best":
            return imgWrapper("best");
        case "bring":
            return imgWrapper("bring");
        case "budbee":
            return imgWrapper("budbee");
        case "city mail":
            return imgWrapper("city_mail");
        case "dachser":
            return imgWrapper("dachser");
        case "db schenker":
            return imgWrapper("db_schenker");
        case "dhl":
            return imgWrapper("dhl");
        case "dooris":
            return imgWrapper("dooris");
        case "early bird":
            return imgWrapper("early_bird");
        case "fedex":
            return imgWrapper("fedex");
        case "instabox":
            return imgWrapper("instabox");
        case "jetpak":
            return imgWrapper("jetpak");
        case "postnord":
            return imgWrapper("postnord");
        case "ups":
            return imgWrapper("ups");
        case "gls":
            return imgWrapper("gls");
        default:
            return imgWrapper("unknown-provider");
    }
};


/***/ }),

/***/ 65884:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": () => (/* binding */ useOfferListFilterContext),
/* harmony export */   "p": () => (/* binding */ OfferListFilterContextContainer)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_price_list_filters_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87990);
/* harmony import */ var src_globals_tracking_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35298);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18026);
/* harmony import */ var _price_list_offer_list_filters_shipping_filters_delivery_methods_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68443);
/* harmony import */ var src_components_price_list_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79126);
/* eslint-disable no-param-reassign */ function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}






var initialContextValue = {
    getInitialFilters: function() {
        return [];
    },
    getActiveFilters: function() {
        return [];
    },
    getAdditiveFilters: function() {
        return [];
    },
    getFilter: function() {
        return undefined;
    },
    getTranslatedLabel: function() {
        return "";
    },
    getFilterByPlacement: function() {
        return [];
    },
    getPriceDisplay: function() {
        return src_components_price_list_types__WEBPACK_IMPORTED_MODULE_5__/* .PriceDisplayEnum.PRICE */ .wB.PRICE;
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    toggleFilter: function() {},
    updateMultipleFilters: function() {
        return undefined;
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setFilterSelection: function() {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    resetFilters: function() {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    resetFiltersByPlacement: function() {},
    filtersToggledOnByUser: function() {
        return [];
    }
};
var OfferListFilterContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(initialContextValue);
var useOfferListFilterContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(OfferListFilterContext);
};
var OfferListFilterContextContainer = function(param) {
    var children = param.children;
    var ref, ref1;
    var market = (0,src_components_app_context__WEBPACK_IMPORTED_MODULE_3__/* .useAppContext */ .bp)().market;
    var ref2 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((0,src_components_price_list_filters_config__WEBPACK_IMPORTED_MODULE_1__/* .getFiltersConfig */ .I)()), 2), filters = ref2[0], setFilters = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        initFilters();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    var setDefaultHiddenFilters = function(filtersList, type) {
        return filtersList.map(function(filter) {
            var updatedFilter = _objectSpread({}, filter);
            if (!type.includes(filter.type)) {
                updatedFilter.hidden = true;
            }
            return updatedFilter;
        });
    };
    var initFilters = function() {
        var ref, ref1, ref2;
        var initialFilters = (0,src_components_price_list_filters_config__WEBPACK_IMPORTED_MODULE_1__/* .getFiltersConfig */ .I)();
        var ref3;
        var hiddenFilters = (ref3 = (ref = market.offerList) === null || ref === void 0 ? void 0 : (ref1 = ref.filters) === null || ref1 === void 0 ? void 0 : ref1.hiddenFilters) !== null && ref3 !== void 0 ? ref3 : [];
        var updatedFilters = setDefaultHiddenFilters(initialFilters, hiddenFilters);
        var searchParams = new URLSearchParams(window.location.search);
        var filtersFromQuery = ((ref2 = searchParams.get("filters")) === null || ref2 === void 0 ? void 0 : ref2.split(",")) || [];
        var filtersFromQueryString = updatedFilters.map(function(filter) {
            var isInQueryString = filtersFromQuery.includes(filter.type);
            return _objectSpreadProps(_objectSpread({}, filter), {
                active: isInQueryString || filter.active
            });
        });
        setFilters(filtersFromQueryString);
    };
    var contextValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var getInitialFilters = function() {
            return (0,src_components_price_list_filters_config__WEBPACK_IMPORTED_MODULE_1__/* .getFiltersConfig */ .I)().filter(function(filter) {
                return filter.active;
            });
        };
        var getActiveFilters = function() {
            return filters.filter(function(filter) {
                return filter.active;
            });
        };
        var getAdditiveFilters = function() {
            return filters.filter(function(filter) {
                return filter.additive;
            });
        };
        var getFilter = function(filterType) {
            return filters.find(function(filter) {
                return filter.type === filterType;
            });
        };
        var getFilterByPlacement = function(placement) {
            return filters.filter(function(filter) {
                return filter.placement.includes(placement);
            });
        };
        var getPriceDisplay = function() {
            var ref;
            return ((ref = getFilter(src_components_price_list_types__WEBPACK_IMPORTED_MODULE_5__/* .FilterType.PRICES_INC_SHIPPING */ .vA.PRICES_INC_SHIPPING)) === null || ref === void 0 ? void 0 : ref.active) ? src_components_price_list_types__WEBPACK_IMPORTED_MODULE_5__/* .PriceDisplayEnum.PRICE_INCLUDES_SHIPPING */ .wB.PRICE_INCLUDES_SHIPPING : src_components_price_list_types__WEBPACK_IMPORTED_MODULE_5__/* .PriceDisplayEnum.PRICE */ .wB.PRICE;
        };
        var getTranslatedLabel = function(t, type, prefix) {
            var filter = getFilter(type);
            var hasSelections = (filter === null || filter === void 0 ? void 0 : filter.selection) && (filter === null || filter === void 0 ? void 0 : filter.selection.length) > 0;
            var newPrefix = prefix || "product";
            var key;
            if (filter === null || filter === void 0 ? void 0 : filter.label) {
                key = filter === null || filter === void 0 ? void 0 : filter.label;
            }
            if ((filter === null || filter === void 0 ? void 0 : filter.type) === src_components_price_list_types__WEBPACK_IMPORTED_MODULE_5__/* .FilterType.DELIVERY_METHOD */ .vA.DELIVERY_METHOD && hasSelections) {
                var deliveryOption = (0,_price_list_offer_list_filters_shipping_filters_delivery_methods_utils__WEBPACK_IMPORTED_MODULE_4__/* .getDeliveryMethodsConfig */ .m)().find(function(option) {
                    return option.type === filter.selection[0];
                });
                key = deliveryOption === null || deliveryOption === void 0 ? void 0 : deliveryOption.translationString;
            }
            if (key) {
                // @ts-expect-error -- Typed too loosely
                return t(newPrefix, key);
            }
            if (hasSelections) {
                return filter.selection.join(", ");
            }
            return "";
        };
        var updateMultipleFilters = function(newFilters) {
            var updatedFilters = filters.map(function(filter) {
                var replacedFilter = filter;
                newFilters.forEach(function(newFilter) {
                    if (newFilter.type === filter.type) {
                        replacedFilter = newFilter;
                    }
                });
                return replacedFilter;
            });
            setFilters(updatedFilters);
        };
        var setFilterSelection = function(filterType, selection, resetCarriers) {
            var updatedFilters = filters.map(function(filter) {
                if (resetCarriers && filter.type === src_components_price_list_types__WEBPACK_IMPORTED_MODULE_5__/* .FilterType.CARRIERS */ .vA.CARRIERS) {
                    return _objectSpreadProps(_objectSpread({}, filter), {
                        selection: [],
                        active: false
                    });
                }
                if (filterType === filter.type) {
                    return _objectSpreadProps(_objectSpread({}, filter), {
                        selection: selection,
                        active: Boolean(selection === null || selection === void 0 ? void 0 : selection.length)
                    });
                }
                return filter;
            });
            setFilters(updatedFilters);
            if (selection.length) {
                (0,src_globals_tracking_filter__WEBPACK_IMPORTED_MODULE_2__/* .trackFilterSelectEvent */ .f9)({
                    value: selection[0],
                    scope: src_globals_tracking_filter__WEBPACK_IMPORTED_MODULE_2__/* .PageScope.PRODUCT */ .VN.PRODUCT,
                    property: filterType,
                    layout: "quick-filter",
                    type: "list"
                });
            } else {
                (0,src_globals_tracking_filter__WEBPACK_IMPORTED_MODULE_2__/* .trackFilterRemoveEvent */ .YD)({
                    value: "all",
                    scope: src_globals_tracking_filter__WEBPACK_IMPORTED_MODULE_2__/* .PageScope.PRODUCT */ .VN.PRODUCT,
                    property: filterType,
                    layout: "quick-filter",
                    type: "list"
                });
            }
        };
        var toggleFilter = function(filterType) {
            var filter = filters.find(function(f) {
                return f.type === filterType;
            });
            var newVal = !(filter === null || filter === void 0 ? void 0 : filter.active);
            var trackingVal = (filter === null || filter === void 0 ? void 0 : filter.additive) ? !newVal : newVal;
            var updatedFilters = filters.map(function(f) {
                if (filterType === f.type) {
                    return _objectSpreadProps(_objectSpread({}, f), {
                        active: newVal
                    });
                }
                return f;
            });
            setFilters(updatedFilters);
            if (newVal) {
                (0,src_globals_tracking_filter__WEBPACK_IMPORTED_MODULE_2__/* .trackFilterSelectEvent */ .f9)({
                    value: trackingVal.toString(),
                    scope: src_globals_tracking_filter__WEBPACK_IMPORTED_MODULE_2__/* .PageScope.PRODUCT */ .VN.PRODUCT,
                    property: filterType,
                    layout: "quick-filter",
                    type: "boolean"
                });
            } else {
                (0,src_globals_tracking_filter__WEBPACK_IMPORTED_MODULE_2__/* .trackFilterRemoveEvent */ .YD)({
                    value: trackingVal.toString(),
                    scope: src_globals_tracking_filter__WEBPACK_IMPORTED_MODULE_2__/* .PageScope.PRODUCT */ .VN.PRODUCT,
                    property: filterType,
                    layout: "quick-filter",
                    type: "boolean"
                });
            }
        };
        var resetFiltersByPlacement = function(filterPlacement) {
            var updatedFilters = filters.map(function(filter) {
                if (filter.placement.includes(filterPlacement)) {
                    var activeState = false;
                    if (filter.additive) {
                        activeState = true;
                    }
                    return _objectSpreadProps(_objectSpread({}, filter), {
                        active: activeState,
                        selection: []
                    });
                }
                return filter;
            });
            setFilters(updatedFilters);
        };
        var resetFilters = function() {
            var ref, ref1;
            var initialFilters = (0,src_components_price_list_filters_config__WEBPACK_IMPORTED_MODULE_1__/* .getFiltersConfig */ .I)();
            var ref2;
            var hiddenFilters = (ref2 = (ref = market.offerList) === null || ref === void 0 ? void 0 : (ref1 = ref.filters) === null || ref1 === void 0 ? void 0 : ref1.hiddenFilters) !== null && ref2 !== void 0 ? ref2 : [];
            var updatedFilters = setDefaultHiddenFilters(initialFilters, hiddenFilters);
            setFilters(updatedFilters);
        };
        var filtersToggledOnByUser = function() {
            var appliedNormalFilters = filters.filter(function(f) {
                return !f.additive && f.active;
            }).filter(function(f) {
                var ref, ref1;
                return !f.selection || ((ref = f.selection) === null || ref === void 0 ? void 0 : ref.toString()) !== ((ref1 = f.initialSelection) === null || ref1 === void 0 ? void 0 : ref1.toString());
            });
            var appliedAdditiveFilters = getAdditiveFilters().filter(function(f) {
                return f.additive && !f.active;
            });
            return _toConsumableArray(appliedNormalFilters).concat(_toConsumableArray(appliedAdditiveFilters));
        };
        return {
            getInitialFilters: getInitialFilters,
            getActiveFilters: getActiveFilters,
            getAdditiveFilters: getAdditiveFilters,
            getFilter: getFilter,
            getTranslatedLabel: getTranslatedLabel,
            getFilterByPlacement: getFilterByPlacement,
            getPriceDisplay: getPriceDisplay,
            toggleFilter: toggleFilter,
            updateMultipleFilters: updateMultipleFilters,
            setFilterSelection: setFilterSelection,
            resetFilters: resetFilters,
            resetFiltersByPlacement: resetFiltersByPlacement,
            filtersToggledOnByUser: filtersToggledOnByUser
        };
    }, [
        filters,
        (ref = market.offerList) === null || ref === void 0 ? void 0 : (ref1 = ref.filters) === null || ref1 === void 0 ? void 0 : ref1.hiddenFilters
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(OfferListFilterContext.Provider, {
        value: contextValue
    }, children);
};


/***/ }),

/***/ 5372:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": () => (/* binding */ MobileTopAd)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_ads__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66589);
/* harmony import */ var src_ui_block__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65176);



var MobileTopAd = function() {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_ui_block__WEBPACK_IMPORTED_MODULE_2__/* .MobileOnly */ .iB, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_ads__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        placement: "dubbelpanorama_top",
        min: 0,
        max: 860,
        format: "toppanorama",
        spacing: {
            top: "10px"
        }
    }));
};


/***/ }),

/***/ 39733:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": () => (/* binding */ InfoMessage)
/* harmony export */ });
/* harmony import */ var _prisjakt_ui_icon_error_outlined__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73624);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71016);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50959);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53378);




var InfoMessage = function(param) {
    var message = param.message;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_styles__WEBPACK_IMPORTED_MODULE_3__/* .MessageWrapper */ .e5, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_prisjakt_ui_icon_error_outlined__WEBPACK_IMPORTED_MODULE_0__/* .IconErrorOutlined */ .a, null), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_styles__WEBPACK_IMPORTED_MODULE_3__/* .MessageGroup */ .dm, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_styles__WEBPACK_IMPORTED_MODULE_3__/* .Message */ .v0, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_1__.BodySmallText, {
        emphasis: _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_1__.FontEmphasis.MEDIUM
    }, message.text), message.link || null)));
};


/***/ }),

/***/ 53378:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fg": () => (/* binding */ StyledLink),
/* harmony export */   "dm": () => (/* binding */ MessageGroup),
/* harmony export */   "e5": () => (/* binding */ MessageWrapper),
/* harmony export */   "iE": () => (/* binding */ StyledModalBody),
/* harmony export */   "v0": () => (/* binding */ Message)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71993);
/* harmony import */ var _prisjakt_design_tokens_light_theme_colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24774);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61093);
/* harmony import */ var _prisjakt_ui_card__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89695);
/* harmony import */ var _prisjakt_ui_clickable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25181);
/* harmony import */ var _prisjakt_ui_modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58709);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  background-color: ",
        ";\n  padding: ",
        " ",
        ";\n  flex-direction: row;\n  margin-bottom: ",
        ";\n  gap: ",
        ";\n\n  > svg {\n    width: 20px;\n    height: 20px;\n\n    > path {\n      fill: rgba(0, 22, 36, 0.72);\n    }\n  }\n\n  > img {\n    max-height: 52px;\n    max-width: 52px;\n    align-self: center;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    align-items: flex-start;\n    flex-direction: column;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  justify-content: space-between;\n  flex-grow: 1;\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    flex-direction: column;\n    align-items: baseline;\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  gap: ",
        ";\n  align-items: center;\n\n  > a {\n    text-decoration: underline;\n\n    &:hover {\n      color: ",
        ";\n    }\n  }\n\n  > h4 {\n    margin: 0;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  margin: ",
        " 0;\n  text-decoration: underline;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n      padding: 0;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        "\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}






var MessageWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_card__WEBPACK_IMPORTED_MODULE_3__.Card).withConfig({
    displayName: "MessageWrapper",
    componentId: "sc-0-0"
})(_templateObject(), function(p) {
    return !p.$elevated && "border: 1px solid ".concat(_prisjakt_design_tokens_light_theme_colors__WEBPACK_IMPORTED_MODULE_1__.base200, ";");
}, _prisjakt_design_tokens_light_theme_colors__WEBPACK_IMPORTED_MODULE_1__.informative100, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, function(p) {
    return p.$elevated && "box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12), 0px 1px 4px rgba(0, 0, 0, 0.12);";
});
var MessageGroup = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "MessageGroup",
    componentId: "sc-0-1"
})(_templateObject2(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.smallOnly */ .BC.smallOnly(_templateObject1()));
var Message = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Message",
    componentId: "sc-0-2"
})(_templateObject4(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, _prisjakt_design_tokens_light_theme_colors__WEBPACK_IMPORTED_MODULE_1__.maybeBlue700, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.smallOnly */ .BC.smallOnly(_templateObject3()));
var StyledLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_clickable__WEBPACK_IMPORTED_MODULE_4__.Clickable).withConfig({
    displayName: "StyledLink",
    componentId: "sc-0-3"
})(_templateObject5(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var StyledModalBody = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_modal__WEBPACK_IMPORTED_MODULE_5__/* .ModalBody */ .fe).withConfig({
    displayName: "StyledModalBody",
    componentId: "sc-0-4"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject7(), props.$noPadding && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject6()));
});


/***/ }),

/***/ 8407:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": () => (/* binding */ AllFiltersLoader)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23114);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}


var AllFilters = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "product-page-filters";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | product-page-filters */ 283).then(__webpack_require__.bind(__webpack_require__, 76234));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(76234);
        }
        return eval("require.resolve")("./all-filters");
    }
});
var AllFiltersLoader = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(AllFilters, _extends({}, props));
};


/***/ }),

/***/ 68443:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": () => (/* binding */ getTranslation),
/* harmony export */   "m": () => (/* binding */ getDeliveryMethodsConfig)
/* harmony export */ });
var getDeliveryMethodsConfig = function() {
    return [
        {
            translationDomain: "product",
            translationString: "variants.all",
            type: null
        },
        {
            translationDomain: "product",
            translationString: "delivery-option.home-delivery",
            type: "HOME"
        },
        {
            translationDomain: "product",
            translationString: "delivery-option.mailbox",
            type: "MAILBOX"
        },
        {
            translationDomain: "product",
            translationString: "delivery-option.package-locker",
            type: "PACKAGE_LOCKER"
        },
        {
            translationDomain: "product",
            translationString: "delivery-option.service-point",
            type: "SERVICE_POINT"
        },
        {
            translationDomain: "product",
            translationString: "delivery-option.pickup-instore",
            type: "INSTORE_PICKUP"
        }
    ];
};
var getTranslation = function(t, type) {
    var deliveryMethodsConfig = getDeliveryMethodsConfig();
    var config = deliveryMethodsConfig.find(function(c) {
        return c.type === type;
    });
    if (!config) {
        return null;
    }
    // @ts-expect-error -- Typed too loosely
    return t(config.translationDomain, config.translationString);
};


/***/ }),

/***/ 37585:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": () => (/* binding */ ShippingFilters)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(71016);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./src/areas/product/components/product-context/index.ts
var product_context = __webpack_require__(16130);
// EXTERNAL MODULE: ./src/areas/product/components/offer-list-filter-context/index.tsx
var offer_list_filter_context = __webpack_require__(65884);
// EXTERNAL MODULE: ./src/components/price-list/types.ts
var types = __webpack_require__(79126);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/offer-list-filters/shipping-filters/carriers/utils.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var createNewSelection = function(val, variantSelection) {
    if (!val) {
        return [];
    }
    return variantSelection.includes(val) ? variantSelection.filter(function(v) {
        return v !== val;
    }) : _toConsumableArray(variantSelection).concat([
        val
    ]);
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/button/index.js
var ui_button = __webpack_require__(17658);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/index.js
var ui_text = __webpack_require__(49955);
// EXTERNAL MODULE: ./src/areas/product/components/carrier-logos/carrier-logos.tsx
var carrier_logos = __webpack_require__(17965);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/offer-list-filters/shipping-filters/carriers/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n  gap: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  min-width: 62px;\n  padding: 1px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  > img {\n    height: 20px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var GridWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "GridWrapper",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var GridCell = styled_components_browser_esm["default"].div.withConfig({
    displayName: "GridCell",
    componentId: "sc-0-1"
})(_templateObject1());
var CarrierLogoWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CarrierLogoWrapper",
    componentId: "sc-0-2"
})(_templateObject2());

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/offer-list-filters/shipping-filters/carriers/selection-button.tsx







var CarrierSelectionButton = function(props) {
    var val = props.val, title = props.title, handleSelection = props.handleSelection, disabled = props.disabled;
    var getFilter = (0,offer_list_filter_context/* useOfferListFilterContext */.o)().getFilter;
    var filter = getFilter(types/* FilterType.CARRIERS */.vA.CARRIERS);
    var currentSelection = (filter === null || filter === void 0 ? void 0 : filter.active) ? filter === null || filter === void 0 ? void 0 : filter.selection : null;
    var isSelected = Boolean(val && (currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.includes(val)) || !val && !currentSelection);
    return /*#__PURE__*/ react.createElement(ui_button.Button, {
        onClick: function() {
            return handleSelection(val);
        },
        selectable: true,
        selected: isSelected,
        fullWidth: true,
        type: ui_button.ButtonType.OUTLINED,
        elevation: ui_button.ButtonElevation.NONE,
        disabled: disabled === true
    }, /*#__PURE__*/ react.createElement(CarrierLogoWrapper, null, val && (0,carrier_logos/* CarrierLogo */.p)(title)), /*#__PURE__*/ react.createElement(ui_button.ButtonText, {
        behavior: ui_text.Behavior.OnelineEllipsis
    }, title));
};

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/offer-list-filters/shipping-filters/carriers/carrier-buttons-grid.tsx






var CarrieButtonsGrid = function(props) {
    var aggregatedShippingInfo = props.aggregatedShippingInfo, handleSelection = props.handleSelection;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var getFilter = (0,offer_list_filter_context/* useOfferListFilterContext */.o)().getFilter;
    var sortedCarriers = aggregatedShippingInfo.allCarriers.sort(function(a, b) {
        return a.localeCompare(b);
    });
    var isDisabled = function(carrier) {
        var ref;
        var filter = getFilter(types/* FilterType.DELIVERY_METHOD */.vA.DELIVERY_METHOD);
        if (!(filter === null || filter === void 0 ? void 0 : filter.active) || !((ref = filter.selection) === null || ref === void 0 ? void 0 : ref.length)) {
            return false;
        }
        return !aggregatedShippingInfo.deliveryMethods.find(function(item) {
            return item.type === filter.selection[0] && item.carriers.includes(carrier);
        });
    };
    return /*#__PURE__*/ react.createElement(GridWrapper, null, /*#__PURE__*/ react.createElement(GridCell, null, /*#__PURE__*/ react.createElement(CarrierSelectionButton, {
        handleSelection: handleSelection,
        title: t("product", "variants.all"),
        val: null
    })), sortedCarriers.map(function(carrier) {
        return /*#__PURE__*/ react.createElement(GridCell, {
            key: carrier
        }, /*#__PURE__*/ react.createElement(CarrierSelectionButton, {
            handleSelection: handleSelection,
            title: carrier,
            val: carrier,
            disabled: isDisabled(carrier)
        }));
    }));
};

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/offer-list-filters/shipping-filters/carriers/index.tsx





var FILTER_DEF = types/* FilterType.CARRIERS */.vA.CARRIERS;
var CarrierFilters = function(props) {
    var aggregatedShippingInfo = props.aggregatedShippingInfo;
    var ref = (0,offer_list_filter_context/* useOfferListFilterContext */.o)(), getFilter = ref.getFilter, setFilterSelection = ref.setFilterSelection, toggleFilter = ref.toggleFilter;
    var filter = getFilter(FILTER_DEF);
    var currentSelection = (filter === null || filter === void 0 ? void 0 : filter.active) ? filter === null || filter === void 0 ? void 0 : filter.selection : null;
    var handleSelection = function(val) {
        var newSelection = createNewSelection(val, (currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.length) ? currentSelection : []);
        if ((filter === null || filter === void 0 ? void 0 : filter.active) && newSelection.length === 0) {
            toggleFilter(FILTER_DEF);
        }
        setFilterSelection(FILTER_DEF, newSelection);
    };
    return /*#__PURE__*/ react.createElement(CarrieButtonsGrid, {
        handleSelection: handleSelection,
        aggregatedShippingInfo: aggregatedShippingInfo
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/radiobutton/index.js
var radiobutton = __webpack_require__(9225);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/offer-list-filters/shipping-filters/delivery-methods/utils.ts
var utils = __webpack_require__(68443);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/offer-list-filters/shipping-filters/delivery-methods/style.ts
function style_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function style_templateObject() {
    var data = style_taggedTemplateLiteral([
        "\n  display: grid;\n"
    ]);
    style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Wrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-0"
})(style_templateObject());

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/offer-list-filters/shipping-filters/delivery-methods/index.tsx
function delivery_methods_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function delivery_methods_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return delivery_methods_arrayLikeToArray(arr);
}
function delivery_methods_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function delivery_methods_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || delivery_methods_unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function delivery_methods_toConsumableArray(arr) {
    return delivery_methods_arrayWithoutHoles(arr) || delivery_methods_iterableToArray(arr) || delivery_methods_unsupportedIterableToArray(arr) || delivery_methods_nonIterableSpread();
}
function delivery_methods_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return delivery_methods_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return delivery_methods_arrayLikeToArray(o, minLen);
}







var DeliveryMetodFilters = function(props) {
    var items = props.items;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref = (0,offer_list_filter_context/* useOfferListFilterContext */.o)(), getFilter = ref.getFilter, setFilterSelection = ref.setFilterSelection;
    var filter = getFilter(types/* FilterType.DELIVERY_METHOD */.vA.DELIVERY_METHOD);
    var currentSelection = (filter === null || filter === void 0 ? void 0 : filter.active) ? filter === null || filter === void 0 ? void 0 : filter.selection : null;
    var ref1 = _slicedToArray((0,react.useState)((currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.length) ? currentSelection[0] : null), 2), selectedValue = ref1[0], setSelectedValue = ref1[1];
    var handleSelection = function(val) {
        var selection = [];
        if (val) {
            selection = [
                val
            ];
        }
        setSelectedValue(val);
        setFilterSelection(types/* FilterType.DELIVERY_METHOD */.vA.DELIVERY_METHOD, selection, true);
    };
    var allItem = {
        type: null,
        offersCount: 100,
        carriers: []
    };
    var radioButtons = [
        allItem
    ].concat(delivery_methods_toConsumableArray(items));
    return /*#__PURE__*/ react.createElement(Wrapper, null, radioButtons.map(function(button) {
        var id = button.type ? button.type : "all";
        var translation = (0,utils/* getTranslation */.i)(t, button.type);
        if (button.offersCount === 0 || !translation) {
            return null;
        }
        return /*#__PURE__*/ react.createElement(radiobutton/* RadioButton */.EU, {
            key: button.type,
            id: id,
            name: "deliveryOption",
            onClickHandler: handleSelection,
            selectedValue: selectedValue,
            value: button.type,
            text: translation
        });
    }));
};

;// CONCATENATED MODULE: ./src/areas/product/hooks/use-offer-shipping-info.ts
function use_offer_shipping_info_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function use_offer_shipping_info_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return use_offer_shipping_info_arrayLikeToArray(arr);
}
function use_offer_shipping_info_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function use_offer_shipping_info_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function use_offer_shipping_info_toConsumableArray(arr) {
    return use_offer_shipping_info_arrayWithoutHoles(arr) || use_offer_shipping_info_iterableToArray(arr) || use_offer_shipping_info_unsupportedIterableToArray(arr) || use_offer_shipping_info_nonIterableSpread();
}
function use_offer_shipping_info_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return use_offer_shipping_info_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return use_offer_shipping_info_arrayLikeToArray(o, minLen);
}
var useOfferShippingInfo = function(offers, deliveryMethodsConfig) {
    var deliveryMethods = [];
    var allCarriers = new Set();
    deliveryMethodsConfig.forEach(function(config) {
        var carriers = new Set();
        var offersCount = 0;
        if (config.type) {
            offers.forEach(function(offer) {
                var ref;
                var hasDeliveryMethod = (ref = offer.shipping) === null || ref === void 0 ? void 0 : ref.nodes.some(function(node) {
                    return config.type === node.deliveryMethod;
                });
                if (hasDeliveryMethod) {
                    var ref1;
                    offersCount += 1;
                    (ref1 = offer.shipping) === null || ref1 === void 0 ? void 0 : ref1.nodes.forEach(function(node) {
                        if (config.type === node.deliveryMethod && node.carrier) {
                            carriers.add(node.carrier);
                        }
                    });
                }
            });
            deliveryMethods.push({
                type: config.type,
                offersCount: offersCount,
                carriers: use_offer_shipping_info_toConsumableArray(carriers)
            });
        }
    });
    offers.forEach(function(offer) {
        var ref;
        (ref = offer.shipping) === null || ref === void 0 ? void 0 : ref.nodes.forEach(function(node) {
            if (node.carrier) {
                allCarriers.add(node.carrier);
            }
        });
    });
    return {
        deliveryMethods: deliveryMethods,
        allCarriers: use_offer_shipping_info_toConsumableArray(allCarriers)
    };
};

// EXTERNAL MODULE: ./src/areas/product/components/price-list/offer-list-filters/styles.ts
var styles = __webpack_require__(4252);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/offer-list-filters/shipping-filters/index.tsx









var MIN_OFFERS_LIMIT = 1;
var ShippingFilters = function() {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var allOffersWithActiveAdditives = (0,product_context/* useProductContext */.$h)().allOffersWithActiveAdditives;
    var aggregatedShippingInfo = useOfferShippingInfo(allOffersWithActiveAdditives, (0,utils/* getDeliveryMethodsConfig */.m)());
    var offersWithShippingCount = allOffersWithActiveAdditives.filter(function(offer) {
        var ref;
        return (ref = offer.shipping) === null || ref === void 0 ? void 0 : ref.nodes.some(function(node) {
            return Boolean(node.deliveryMethod);
        });
    }, 0);
    if (offersWithShippingCount.length < MIN_OFFERS_LIMIT) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(styles/* FilterRow */.TH, null, /*#__PURE__*/ react.createElement(variants.TitleMediumText, null, t("store", "store.delivery-options")), /*#__PURE__*/ react.createElement(DeliveryMetodFilters, {
        items: aggregatedShippingInfo.deliveryMethods
    })), aggregatedShippingInfo.allCarriers.length > 0 && /*#__PURE__*/ react.createElement(styles/* FilterRow */.TH, null, /*#__PURE__*/ react.createElement(CarrierFilters, {
        aggregatedShippingInfo: aggregatedShippingInfo
    })));
};


/***/ }),

/***/ 4252:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FJ": () => (/* binding */ FilterOptionWrapper),
/* harmony export */   "HA": () => (/* binding */ CheckboxClickarea),
/* harmony export */   "TH": () => (/* binding */ FilterRow),
/* harmony export */   "g6": () => (/* binding */ FiltersDropDown),
/* harmony export */   "gC": () => (/* binding */ FilterPanelWrapper),
/* harmony export */   "hR": () => (/* binding */ FilterPanel),
/* harmony export */   "hY": () => (/* binding */ ScrollingFiltersList),
/* harmony export */   "kP": () => (/* binding */ ButtonBadge),
/* harmony export */   "nv": () => (/* binding */ MobileWrapper),
/* harmony export */   "qj": () => (/* binding */ ShippingFilterTextButton),
/* harmony export */   "rO": () => (/* binding */ FilterBlocker)
/* harmony export */ });
/* unused harmony export ScrollingFiltersListWrapper */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71993);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61093);
/* harmony import */ var _prisjakt_ui_floater__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50914);
/* harmony import */ var _prisjakt_ui_badge__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29242);
/* harmony import */ var _prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7336);
/* harmony import */ var src_ui_zindex__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93497);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    min-width: ",
        "px;\n    max-width: ",
        "px;\n    min-height: ",
        "px;\n    max-height: ",
        "px;\n    overflow-y: auto;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  background: ",
        ";\n  padding: ",
        ";\n  border-radius: 8px;\n  width: 100%;\n  margin-bottom: ",
        ";\n  border: 1px solid ",
        ";\n  box-shadow: ",
        ";\n\n  display: grid;\n  gap: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  z-index: ",
        ";\n  transform: translate(0.5rem, 4.5em);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  z-index: ",
        ";\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    grid-template-rows: auto;\n    grid-auto-flow: row;\n    grid-template-columns: 1fr;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  gap: ",
        ";\n  width: 100%;\n\n  grid-template-rows: auto;\n  grid-auto-flow: row;\n  grid-template-columns: 1fr;\n\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  > span {\n    display: block;\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  :last-child {\n    padding-right: 20px;\n  }"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  position: absolute;\n  top: -30%;\n  right: -",
        ";\n  width: 24px;\n  height: 24px;\n\n  > span {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n    width: 100%;\n    overflow-x: auto;\n    position: relative;\n    padding: 0.5rem;\n    left: -0.5rem;\n    width: calc(100% + 1rem);\n    padding-bottom: 0;\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 1px;\n  width: 100%;\n\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n    flex-wrap: wrap;\n  "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n    > li:last-child { padding-right: ",
        " }\n  "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  list-style: none;\n  margin: 0;\n  gap: ",
        ";\n  padding-bottom: ",
        ";\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  margin: ",
        " 0;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}






var DESKTOP_DIALOG = {
    MIN_WIDTH: 200,
    MAX_WIDTH: 320,
    MIN_HEIGHT: 130,
    MAX_HEIGHT: 356
};
var FilterPanelWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "FilterPanelWrapper",
    componentId: "sc-0-0"
})(_templateObject1(), function(p) {
    return p.theme.bg.primary;
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, function(p) {
    return p.theme.lines.primary;
}, function(p) {
    return "0px 2px 8px 0px ".concat(src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .colorUtils.setRgbaAlpha */ .$n.setRgbaAlpha(p.theme.colors.base800, 0.24));
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing150 */ .bK.measurements.spacing150, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumUp */ .BC.mediumUp(_templateObject(), DESKTOP_DIALOG.MIN_WIDTH, DESKTOP_DIALOG.MAX_WIDTH, DESKTOP_DIALOG.MIN_HEIGHT, DESKTOP_DIALOG.MAX_HEIGHT));
var FiltersDropDown = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_floater__WEBPACK_IMPORTED_MODULE_2__.Floater).withConfig({
    displayName: "FiltersDropDown",
    componentId: "sc-0-1"
})(_templateObject2(), src_ui_zindex__WEBPACK_IMPORTED_MODULE_5__/* .zindex.menu.offerlistFilters */ .Y.menu.offerlistFilters);
var FilterBlocker = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "FilterBlocker",
    componentId: "sc-0-2"
})(_templateObject3(), src_ui_zindex__WEBPACK_IMPORTED_MODULE_5__/* .zindex.overlay */ .Y.overlay);
var FilterPanel = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "FilterPanel",
    componentId: "sc-0-3"
})(_templateObject5(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing150 */ .bK.measurements.spacing150, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject4()));
var FilterRow = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "FilterRow",
    componentId: "sc-0-4"
})(_templateObject6(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var FilterOptionWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "FilterOptionWrapper",
    componentId: "sc-0-5"
})(_templateObject8(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.smallOnly */ .BC.smallOnly(_templateObject7()));
var CheckboxClickarea = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "CheckboxClickarea",
    componentId: "sc-0-6"
})(_templateObject9());
var ButtonBadge = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_badge__WEBPACK_IMPORTED_MODULE_3__.Badge).withConfig({
    displayName: "ButtonBadge",
    componentId: "sc-0-7"
})(_templateObject10(), function(p) {
    return p.theme.colors.maybeBlue500;
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing075 */ .bK.measurements.spacing075, function(p) {
    return p.theme.colors.base0;
});
var ScrollingFiltersList = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "ScrollingFiltersList",
    componentId: "sc-0-8"
})(_templateObject12(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.smallOnly */ .BC.smallOnly(_templateObject11()));
var ScrollingFiltersListWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].ul.withConfig({
    displayName: "ScrollingFiltersListWrapper",
    componentId: "sc-0-9"
})(_templateObject15(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumUp */ .BC.mediumUp(_templateObject13()), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.smallOnly */ .BC.smallOnly(_templateObject14(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050));
var MobileWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "MobileWrapper",
    componentId: "sc-0-10"
})(_templateObject16(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing150 */ .bK.measurements.spacing150, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100);
var ShippingFilterTextButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_4__.TextButton).withConfig({
    displayName: "ShippingFilterTextButton",
    componentId: "sc-0-11"
})(_templateObject17(), function(p) {
    return p.theme.colors.base900;
});


/***/ }),

/***/ 70264:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": () => (/* binding */ PriceRowContextContainer),
/* harmony export */   "m": () => (/* binding */ usePriceRowContext)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_filter_dropdown__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6340);
/* harmony import */ var _product_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16130);
/* harmony import */ var _price_row_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3382);
/* harmony import */ var _utils_product_condition_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83071);





var initialValue = {
    offer: {
        featured: false,
        authorizedDealer: false,
        condition: _utils_product_condition_types__WEBPACK_IMPORTED_MODULE_4__/* .ConditionEnum.NEW */ .M.NEW,
        isInternationalPrice: false,
        ourChoiceScore: 0,
        dealOffers: [],
        featuredOverride: _price_row_types__WEBPACK_IMPORTED_MODULE_3__/* .FeaturedStatusEnum.UNKNOWN */ .$x.UNKNOWN
    },
    product: _product_context__WEBPACK_IMPORTED_MODULE_2__/* .EmptyProduct */ .jG,
    showUnfeaturedHideButton: false,
    showUsedOffers: false,
    collapseUnfeaturedFn: undefined,
    sorting: src_components_filter_dropdown__WEBPACK_IMPORTED_MODULE_1__/* .OptionTypeEnum.CHEAPEST_PRICE */ .M7.CHEAPEST_PRICE,
    viewSize: _price_row_types__WEBPACK_IMPORTED_MODULE_3__/* .ViewSize.SMALL */ .du.SMALL
};
var PriceRowContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(initialValue);
var usePriceRowContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(PriceRowContext);
};
var PriceRowContextContainer = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PriceRowContext.Provider, {
        value: props
    }, props.children);
};


/***/ }),

/***/ 83717:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": () => (/* binding */ ConditionTypeBadge)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/badge/index.js
var badge = __webpack_require__(29242);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/recycle/index.js
var recycle = __webpack_require__(4781);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/condition-type-badge/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  justify-content: flex-end;\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var BadgeWrapper = styled_components_browser_esm["default"].span.withConfig({
    displayName: "BadgeWrapper",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

// EXTERNAL MODULE: ./src/areas/product/utils/product-condition/index.ts
var product_condition = __webpack_require__(83681);
// EXTERNAL MODULE: ./src/areas/product/utils/product-condition/types.ts
var types = __webpack_require__(83071);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/condition-type-badge/index.tsx







var ConditionTypeBadge = function(props) {
    var condition = props.condition;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var label = (0,product_condition/* getConditionName */.v)(condition, t);
    if (condition === types/* ConditionEnum.NEW */.M.NEW) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(BadgeWrapper, null, /*#__PURE__*/ react.createElement(badge.Badge, {
        icon: recycle/* IconRecycle */.L,
        color: "GREEN",
        size: badge.BadgeSize.SMALL,
        text: label
    }));
};


/***/ }),

/***/ 29781:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": () => (/* binding */ GoToStoreButton)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row-context.tsx
var price_row_context = __webpack_require__(70264);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/chevron-right/index.js
var chevron_right = __webpack_require__(46695);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/button/index.js
var ui_button = __webpack_require__(17658);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(7336);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row/types.ts
var types = __webpack_require__(3382);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/go-to-store-button/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n\n  /* Small mobile resolutions, e.g. Galaxy Fold */\n  @media screen and (max-width: 280px) {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      width: 24px;\n      align-self: stretch;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        "\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var StyledWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledWrapper",
    componentId: "sc-0-0"
})(_templateObject());
var StyledButton = (0,styled_components_browser_esm["default"])(variants.PrimaryButton).withConfig({
    displayName: "StyledButton",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject2(), props.$viewSize === types/* ViewSize.SMALL */.du.SMALL && (0,styled_components_browser_esm.css)(_templateObject1()));
});
var StyledIconWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledIconWrapper",
    componentId: "sc-0-2"
})(_templateObject3());

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/go-to-store-button/index.tsx








var GoToStoreButton = function(props) {
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var viewSize = props.viewSize;
    var isOurChoice = (0,price_row_context/* usePriceRowContext */.m)().isOurChoice;
    var renderButton = function() {
        if (viewSize === types/* ViewSize.SMALL */.du.SMALL && !isOurChoice) {
            return /*#__PURE__*/ react.createElement(chevron_right.IconChevronRight, {
                color: "maybeBlue500",
                size: 24
            });
        }
        return /*#__PURE__*/ react.createElement(StyledButton, {
            ariaLabel: t("product", "external-link.view-in-shop"),
            tabIndex: -1,
            $viewSize: viewSize
        }, viewSize >= types/* ViewSize.MEDIUM */.du.MEDIUM && /*#__PURE__*/ react.createElement(variants.ButtonText, null, t("product", "external-link.view-in-shop")), /*#__PURE__*/ react.createElement(ui_button.ButtonIcon, null, /*#__PURE__*/ react.createElement(chevron_right.IconChevronRight, null)));
    };
    return /*#__PURE__*/ react.createElement(StyledWrapper, {
        "data-test": "GoToStoreButton"
    }, renderButton());
};


/***/ }),

/***/ 50762:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Be": () => (/* binding */ StyledFlexVertical),
/* harmony export */   "D": () => (/* binding */ StyledProductName),
/* harmony export */   "M6": () => (/* binding */ StyledMiddleColumnMobilePadding),
/* harmony export */   "Qp": () => (/* binding */ StyledFeaturedRow),
/* harmony export */   "Y": () => (/* binding */ StyledEndColumn),
/* harmony export */   "YW": () => (/* binding */ StyledMiddleColumn),
/* harmony export */   "a2": () => (/* binding */ StyledProductNameWrapper),
/* harmony export */   "f4": () => (/* binding */ StyledTopMiddleRow),
/* harmony export */   "oJ": () => (/* binding */ StyledBadgeWrapper),
/* harmony export */   "pS": () => (/* binding */ StyledMiddleColumnDesktopPadding),
/* harmony export */   "po": () => (/* binding */ StyledFlexHorizontal),
/* harmony export */   "ry": () => (/* binding */ StyledUnfeaturedRow),
/* harmony export */   "xL": () => (/* binding */ StyledCollapseUnfeaturedBtn)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71993);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61093);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71016);
/* harmony import */ var _prisjakt_ui_card__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89695);
/* harmony import */ var _prisjakt_ui_tooltip__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(714);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3382);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      &&:hover:after {\n        content: '';\n        border-bottom-left-radius: 0;\n        border-bottom-right-radius: 0;\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 1 auto;\n  cursor: pointer;\n  overflow: visible;\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      align-items: flex-start;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      padding-top: ",
        ";\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    display: grid;\n    flex-shrink: 1;\n    height: 100%;\n    align-items: center;\n    max-width: 60%;\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    white-space: initial;\n    color: ",
        ";\n    display: inline;\n\n    line-height: 22px;\n\n    ",
        "\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      padding: ",
        ";\n      gap: 0;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n  justify-content: space-between;\n  flex: 1;\n  padding: 0 ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n      &:hover::after {\n        box-shadow:\n          0 2px 10px 0 rgb(0, 0, 0, 0.1),\n          0 0 0 1px rgb(0, 0, 0, 0);\n      }\n      ::after {\n        transition: box-shadow 200ms ease;\n        content: '';\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        pointer-events: none;\n        border-radius: 8px;\n      }\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    align-items: center;\n    flex-grow: 1;\n    height: 100%;\n    width: 100%;\n\n    ",
        "\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n      padding: ",
        ";\n    "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n      padding-left: ",
        ";\n      padding-right: ",
        ";\n    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n      visibility: hidden;\n    "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-shrink: 0;\n    align-items: stretch;\n    height: 100%;\n    padding: ",
        ";\n    padding-left: 0;\n\n    ",
        "\n\n    ",
        "\n\n    /* Small mobile resolutions, e.g. Galaxy Fold */\n    @media screen and (max-width: 280px) {\n      padding-right: ",
        ";\n    }\n\n    ",
        "\n  "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n      cursor: default;\n      gap: ",
        ";\n    "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex: 2;\n    align-items: center;\n\n    ",
        "\n\n    &:target {\n      outline: ",
        " dotted 1px;\n      outline: -webkit-focus-ring-color auto 1px;\n    }\n  "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n      right: ",
        ";\n    "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n      right: ",
        ";\n    "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n    cursor: pointer;\n    position: absolute;\n    display: flex;\n    align-self: center;\n    right: 0;\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  justify-content: center;\n  white-space: nowrap;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n  gap: ",
        ";\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n      padding: ",
        " 0;\n    "
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        "\n\n    &:hover::after {\n      box-shadow:\n        0 2px 10px 0 rgb(0, 0, 0, 0.1),\n        0 0 0 1px rgb(0, 0, 0, 0);\n    }\n  "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _taggedTemplateLiteral([
        "\n      padding: ",
        ";\n    "
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0 ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}






var StyledFeaturedRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_card__WEBPACK_IMPORTED_MODULE_3__.CardActionArea).withConfig({
    displayName: "StyledFeaturedRow",
    componentId: "sc-0-0"
})(_templateObject1(), function(props) {
    return props.$hasPromotion && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject());
});
var StyledProductNameWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "StyledProductNameWrapper",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject4(), props.$alignStart && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject2()), props.$alignStart && props.$paddingTop && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject3(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050));
});
var StyledProductName = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_2__.BodySmallText).withConfig({
    displayName: "StyledProductName",
    componentId: "sc-0-2"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject6(), props.$featured ? props.theme.text.primary : props.theme.text.tertiary, props.$isAlternative && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject5()));
});
var StyledTopMiddleRow = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "StyledTopMiddleRow",
    componentId: "sc-0-3"
})(_templateObject8(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, function(props) {
    return props.$viewSize !== undefined && props.$viewSize >= _types__WEBPACK_IMPORTED_MODULE_5__/* .ViewSize.MEDIUM */ .du.MEDIUM && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject7(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025);
});
var StyledMiddleColumn = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "StyledMiddleColumn",
    componentId: "sc-0-4"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject10(), props.$featured && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject9()));
});
var StyledEndColumn = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "StyledEndColumn",
    componentId: "sc-0-5"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject14(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, props.$viewSize === _types__WEBPACK_IMPORTED_MODULE_5__/* .ViewSize.MEDIUM */ .du.MEDIUM && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject11(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050), props.$viewSize === _types__WEBPACK_IMPORTED_MODULE_5__/* .ViewSize.LARGE */ .du.LARGE && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject12(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, !props.$featured && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject13()));
});
var StyledUnfeaturedRow = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].a.withConfig({
    displayName: "StyledUnfeaturedRow",
    componentId: "sc-0-6"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject16(), !props.$featured && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject15(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .colors.borderLightGray */ .O9.borderLightGray);
});
var StyledCollapseUnfeaturedBtn = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_tooltip__WEBPACK_IMPORTED_MODULE_4__/* .Tooltip */ .u).withConfig({
    displayName: "StyledCollapseUnfeaturedBtn",
    componentId: "sc-0-7"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject19(), props.$viewSize === _types__WEBPACK_IMPORTED_MODULE_5__/* .ViewSize.MEDIUM */ .du.MEDIUM && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject17(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050), props.$viewSize === _types__WEBPACK_IMPORTED_MODULE_5__/* .ViewSize.LARGE */ .du.LARGE && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject18(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100));
});
var StyledFlexHorizontal = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "StyledFlexHorizontal",
    componentId: "sc-0-8"
})(_templateObject20());
var StyledFlexVertical = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "StyledFlexVertical",
    componentId: "sc-0-9"
})(_templateObject21());
var StyledBadgeWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(StyledFlexVertical).withConfig({
    displayName: "StyledBadgeWrapper",
    componentId: "sc-0-10"
})(_templateObject22(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025);
var StyledMiddleColumnMobilePadding = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(StyledFlexVertical).withConfig({
    displayName: "StyledMiddleColumnMobilePadding",
    componentId: "sc-0-11"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject24(), props.$viewSize === _types__WEBPACK_IMPORTED_MODULE_5__/* .ViewSize.SMALL */ .du.SMALL && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject23(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050));
});
var StyledMiddleColumnDesktopPadding = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(StyledFlexVertical).withConfig({
    displayName: "StyledMiddleColumnDesktopPadding",
    componentId: "sc-0-12"
})(_templateObject26(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, function(props) {
    return props.$viewSize !== undefined && props.$viewSize >= _types__WEBPACK_IMPORTED_MODULE_5__/* .ViewSize.MEDIUM */ .du.MEDIUM && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject25(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
});


/***/ }),

/***/ 56031:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": () => (/* binding */ ReportButton)
/* harmony export */ });
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23114);

var ReportButton = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "extra";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | extra */ 737).then(__webpack_require__.bind(__webpack_require__, 75120));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(75120);
        }
        return eval("require.resolve")("./report-button");
    }
});


/***/ }),

/***/ 5884:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": () => (/* binding */ ReportModal)
/* harmony export */ });
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23114);

var ReportModal = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "extra";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | extra */ 737).then(__webpack_require__.bind(__webpack_require__, 37852));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(37852);
        }
        return eval("require.resolve")("./report-modal");
    }
});


/***/ }),

/***/ 31291:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": () => (/* binding */ PriceRow)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row-context.tsx
var price_row_context = __webpack_require__(70264);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/alternative-price-row-context.tsx

var initialValue = {
    alternativeOffer: undefined
};
var AlternativePriceRowContext = /*#__PURE__*/ (0,react.createContext)(initialValue);
var useAlternativePriceRowContext = function() {
    return (0,react.useContext)(AlternativePriceRowContext);
};
var AlternativePriceRowContextContainer = function(props) {
    return /*#__PURE__*/ react.createElement(AlternativePriceRowContext.Provider, {
        value: props
    }, props.children);
};

// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/dropdown-down/index.js
var dropdown_down = __webpack_require__(19258);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/dropdown-up/index.js
var dropdown_up = __webpack_require__(12641);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/menu-kebab/index.js
var menu_kebab = __webpack_require__(47481);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row/types.ts
var types = __webpack_require__(3382);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/expand-button/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  outline: none;\n\n  &.focus-visible {\n    outline: ",
        " dotted 1px;\n    outline: -webkit-focus-ring-color auto 1px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var StyledExpandButton = styled_components_browser_esm["default"].button.withConfig({
    displayName: "StyledExpandButton",
    componentId: "sc-0-0"
})(_templateObject(), function(p) {
    return p.theme.text.linkExternalHover;
});

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/expand-button/index.tsx








var ExpandButton = function(param) {
    var _expanded = param.expanded, expanded = _expanded === void 0 ? false : _expanded, onClick = param.onClick;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var viewSize = (0,price_row_context/* usePriceRowContext */.m)().viewSize;
    var title = t("product", "price.more-info");
    return /*#__PURE__*/ react.createElement(StyledExpandButton, {
        type: "button",
        "aria-label": title,
        onClick: onClick,
        title: title,
        "data-test": "ExpandButton"
    }, viewSize === types/* ViewSize.SMALL */.du.SMALL && /*#__PURE__*/ react.createElement(menu_kebab/* IconMenuKebab */.Q, {
        color: "base900",
        size: 20
    }), viewSize >= types/* ViewSize.MEDIUM */.du.MEDIUM && expanded && /*#__PURE__*/ react.createElement(dropdown_up.IconDropdownUp, {
        color: "base900",
        size: 20
    }), viewSize >= types/* ViewSize.MEDIUM */.du.MEDIUM && !expanded && /*#__PURE__*/ react.createElement(dropdown_down.IconDropdownDown, {
        color: "base900",
        size: 20
    }));
};

// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(38689);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row/components/go-to-store-button/index.tsx + 1 modules
var go_to_store_button = __webpack_require__(29781);
// EXTERNAL MODULE: ./src/areas/product/components/offer-list-filter-context/index.tsx
var offer_list_filter_context = __webpack_require__(65884);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/index.js
var ui = __webpack_require__(54262);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(71016);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/badge/index.js
var badge = __webpack_require__(29242);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/leaf/index.js
var leaf = __webpack_require__(88818);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/tooltip/index.js
var tooltip = __webpack_require__(714);
// EXTERNAL MODULE: ./src/areas/product/components/product-context/index.ts
var product_context = __webpack_require__(16130);
// EXTERNAL MODULE: ./src/components/offer/price/offer-price/price-data.ts + 1 modules
var price_data = __webpack_require__(88584);
// EXTERNAL MODULE: ./src/components/badges/deals-badge/index.tsx + 1 modules
var deals_badge = __webpack_require__(56355);
// EXTERNAL MODULE: ./src/areas/product/components/badges/index.ts + 4 modules
var badges = __webpack_require__(3460);
// EXTERNAL MODULE: ./src/areas/product/utils/index.ts
var utils = __webpack_require__(33996);
// EXTERNAL MODULE: ./src/components/offer/price/offer-price/utils.ts
var offer_price_utils = __webpack_require__(48652);
// EXTERNAL MODULE: ./src/components/price-list/types.ts
var price_list_types = __webpack_require__(79126);
// EXTERNAL MODULE: ./src/areas/product/utils/product-condition/types.ts
var product_condition_types = __webpack_require__(83071);
// EXTERNAL MODULE: ./src/components/offer/price/offer-price/styles.ts
var styles = __webpack_require__(46140);
;// CONCATENATED MODULE: ./src/components/offer/price/offer-price/index.tsx















var OfferPriceLabel = function(props) {
    var container = props.container, offerPrice = props.offerPrice, priceDisplay = props.priceDisplay, selectedOffer = props.selectedOffer, shipping = props.shipping;
    var ref = (0,app_context/* useAppContext */.bp)(), t = ref.t, market = ref.market;
    var ref1 = (0,price_row_context/* usePriceRowContext */.m)(), offer = ref1.offer, product = ref1.product;
    var ref2 = (0,product_context/* useProductContext */.$h)(), filteredOffers = ref2.offers.filteredOffers;
    var alternativeOffer = useAlternativePriceRowContext().alternativeOffer;
    var isUsed = selectedOffer.condition !== product_condition_types/* ConditionEnum.NEW */.M.NEW;
    var featured = alternativeOffer ? (0,utils/* getIsFeatured */.ZF)(offer, alternativeOffer) : offer.featured;
    if (!selectedOffer.price) {
        return null;
    }
    var priceData = (0,price_data/* getCompiledPriceData */.cJ)(selectedOffer.price, offerPrice, priceDisplay, featured);
    var isOnSalePrice = priceData.isOnSalePrice, secondaryPrice = priceData.secondaryPrice, isMemberPrice = priceData.isMemberPrice;
    var showSalesPrice = isOnSalePrice && Boolean(secondaryPrice) && !isUsed && !isMemberPrice;
    var isDeal = offer.dealOffers.some(function(deal) {
        return deal.shopOfferId === selectedOffer.shopOfferId;
    });
    var getPriceLabel = function() {
        var ref;
        var shippingCost = (shipping === null || shipping === void 0 ? void 0 : shipping.shippingCost) || 0;
        var cost = ((ref = selectedOffer.price) === null || ref === void 0 ? void 0 : ref.exclShipping) || 0;
        if (priceDisplay === price_list_types/* PriceDisplayEnum.PRICE_INCLUDES_SHIPPING */.wB.PRICE_INCLUDES_SHIPPING) {
            return cost + shippingCost;
        }
        return cost;
    };
    var fontColor = function() {
        return showSalesPrice ? variants.FontColor.NEGATIVE : undefined;
    };
    var renderSalesPriceBadge = function() {
        if (!showSalesPrice) {
            return null;
        }
        var localeStandard = market.localeStandard;
        var promotionLabel = (0,price_data/* getonSalePriceLabel */.Un)(offerPrice, localeStandard, t);
        if (!promotionLabel) {
            return null;
        }
        return /*#__PURE__*/ react.createElement(badge.Badge, {
            color: "RED",
            size: badge.BadgeSize.SMALL,
            text: promotionLabel
        });
    };
    var renderDealsBadge = function() {
        var ref, ref1, ref2;
        if (!product.dealInfo || !((ref = offer.price) === null || ref === void 0 ? void 0 : ref.exclShipping)) return null;
        var dealPercentage = (0,offer_price_utils/* getDealPercentage */.A)(product.dealInfo, filteredOffers, (ref1 = offer.price) === null || ref1 === void 0 ? void 0 : ref1.exclShipping);
        if (!dealPercentage) return null;
        return /*#__PURE__*/ react.createElement(deals_badge/* DealsBadge */.T, {
            badgeType: deals_badge/* BadgeTypeEnum.ICON_BADGE */.Q.ICON_BADGE,
            "data-testid": "DealsBadge",
            priceDrop: dealPercentage,
            price: ((ref2 = offer.price) === null || ref2 === void 0 ? void 0 : ref2.exclShipping) || 0,
            popoverUniqueId: "product-page-offer"
        });
    };
    var renderMembershipBadge = function() {
        return /*#__PURE__*/ react.createElement(badges/* MembershipBadge */.fd, {
            isMembershipPrice: Boolean(isMemberPrice),
            alignRight: true
        });
    };
    return /*#__PURE__*/ react.createElement(styles/* Wrapper */.im, null, /*#__PURE__*/ react.createElement(styles/* StyledBadges */._d, null, renderSalesPriceBadge(), renderMembershipBadge()), /*#__PURE__*/ react.createElement(styles/* PriceAndShipping */.y, null, isDeal && renderDealsBadge(), secondaryPrice && !isUsed && /*#__PURE__*/ react.createElement(styles/* StyledSecondaryPrice */.ng, {
        memberPrice: isMemberPrice,
        value: secondaryPrice,
        emphasis: isMemberPrice ? variants.FontEmphasis.MEDIUM : variants.FontEmphasis.LOW,
        weight: variants.FontWeight.NORMAL,
        isSecondaryPrice: true
    }), getPriceLabel() && /*#__PURE__*/ react.createElement(styles/* StyledPriceLabel */.Zb, {
        container: container,
        emphasis: featured ? variants.FontEmphasis.HIGH : variants.FontEmphasis.LOW,
        fontColor: fontColor(),
        value: getPriceLabel(),
        weight: variants.FontWeight.HEAVIEST
    })));
};

// EXTERNAL MODULE: ./src/components/offer/price/price-label/index.tsx + 1 modules
var price_label = __webpack_require__(47477);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/verified/index.js
var verified = __webpack_require__(75994);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/authorized-dealer/index.tsx









var AuthorizedDealerBadge = function(param) {
    var className = param.className;
    var ref = (0,price_row_context/* usePriceRowContext */.m)(), offer = ref.offer, product = ref.product, viewSize = ref.viewSize;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var content = /*#__PURE__*/ react.createElement(react.Fragment, null, viewSize === types/* ViewSize.SMALL */.du.SMALL && /*#__PURE__*/ react.createElement(badge.Badge, {
        circular: true,
        color: "BLUE",
        icon: verified/* IconVerfied */.b
    }), viewSize >= types/* ViewSize.MEDIUM */.du.MEDIUM && /*#__PURE__*/ react.createElement(badge.Badge, {
        color: "BLUE",
        icon: verified/* IconVerfied */.b,
        text: /*#__PURE__*/ react.createElement(variants.BodySmallText, {
            weight: 600,
            style: {
                fontSize: 12
            }
        }, t("store", "brand.recommended-retailer"))
    }));
    if (!product.brand || !offer.store) {
        return content;
    }
    return /*#__PURE__*/ react.createElement(tooltip/* Tooltip */.u, {
        className: className,
        title: t("store", "store.recommended-retailer-brand", {
            brand: product.brand.name,
            store: offer.store.name
        }),
        placement: ui/* Direction.Left */.Nm.Left
    }, content);
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/index.js
var ui_text = __webpack_require__(49955);
// EXTERNAL MODULE: ./src/components/filter-dropdown/index.tsx + 1 modules
var filter_dropdown = __webpack_require__(6340);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/stock-price-info/types.ts
var StockStatusEnum;
(function(StockStatusEnum) {
    StockStatusEnum["IN_STOCK"] = "in_stock";
    StockStatusEnum["INCOMING"] = "incoming";
    StockStatusEnum["PREORDER"] = "in_stock_preorder";
    StockStatusEnum["UNAVAILABLE"] = "not_in_stock";
    StockStatusEnum["UNKNOWN"] = "unknown";
})(StockStatusEnum || (StockStatusEnum = {}));

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/delivery-time/utils.ts

var ShippingType;
(function(ShippingType) {
    ShippingType["CHEAPEST"] = "cheapest";
    ShippingType["FASTEST"] = "fastest";
})(ShippingType || (ShippingType = {}));
var getDeliveryDays = function(shipping) {
    if (!shipping) {
        return null;
    }
    if (!shipping.deliveryDays || shipping.deliveryDays.min < 0 || shipping.deliveryDays.max < 0) {
        return null;
    }
    return {
        min: shipping.deliveryDays.min,
        max: shipping.deliveryDays.max
    };
};
var getDeliveryDaysGeneric = function(t, deliveryDays) {
    if (!deliveryDays) {
        return undefined;
    }
    var day = t("product", "delivery-time.days-label");
    var days = t("product", "delivery-time.days-label-plural");
    if (deliveryDays.min === 1 && deliveryDays.max === 1) {
        return "".concat(deliveryDays.max, " ").concat(day);
    }
    if (deliveryDays.min === 0 && deliveryDays.max === 0) {
        return "".concat(deliveryDays.max, " ").concat(days);
    }
    if (deliveryDays.min === deliveryDays.max) {
        return "".concat(deliveryDays.max, " ").concat(days);
    }
    return "".concat(deliveryDays.min, "-").concat(deliveryDays.max, " ").concat(days);
};
var isShippingInstorePickup = function(shipping) {
    return Boolean((shipping === null || shipping === void 0 ? void 0 : shipping.deliveryMethod) === "INSTORE_PICKUP");
};
var getShippingDays = function(t, shipping) {
    var deliveryDays = getDeliveryDays(shipping);
    return getDeliveryDaysGeneric(t, deliveryDays);
};
var getTranslatedShipping = function(t, deliveryDays) {
    var upTo = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 6;
    if (!deliveryDays || !deliveryDays.min && !deliveryDays.max) {
        return t("product", "delivery-time.up-to", {
            n: upTo
        });
    }
    return getDeliveryDaysGeneric(t, deliveryDays);
};
var getStandardizedDeliveryText = function(t, stockStatus) {
    switch(stockStatus){
        case StockStatusEnum.IN_STOCK:
            return "".concat(t("product", "delivery-time.unknown")).toLowerCase();
        case StockStatusEnum.INCOMING:
            return t("product", "delivery-time.unknown-date").toLowerCase();
        case StockStatusEnum.PREORDER:
            return t("product", "stock-status.in_stock_preorder");
        case StockStatusEnum.UNAVAILABLE:
            return t("product", "delivery-time.unavailable");
        case StockStatusEnum.UNKNOWN:
        default:
            return t("product", "delivery-time.unknown");
    }
};
var getDeliveryTimeText = function(t, market, shippingDays, stockStatus, availability) {
    if (stockStatus === StockStatusEnum.PREORDER || stockStatus === StockStatusEnum.INCOMING) {
        if (availability === null || availability === void 0 ? void 0 : availability.availabilityDate) {
            return formatAvailibilityDate(availability.availabilityDate, market);
        }
        return t("product", "delivery-time.unknown-date");
    }
    if (shippingDays) {
        return shippingDays;
    }
    return getStandardizedDeliveryText(t, stockStatus);
};
var getDeliveryTextIsBold = function(shippingDays, stockStatus, availability, isInstorePickup) {
    if (isInstorePickup) {
        return false;
    }
    if (stockStatus === StockStatusEnum.IN_STOCK && shippingDays) {
        return true;
    }
    if ((stockStatus === StockStatusEnum.PREORDER || stockStatus === StockStatusEnum.INCOMING) && (availability === null || availability === void 0 ? void 0 : availability.availabilityDate)) {
        return true;
    }
    return false;
};
var getLabel = function(t, stockStatus) {
    if (stockStatus === StockStatusEnum.INCOMING) {
        return "".concat(t("product", "delivery-time.instock-date"), " ");
    }
    if (stockStatus === StockStatusEnum.PREORDER) {
        return "".concat(t("product", "delivery-time.available"), " ");
    }
    if (stockStatus === StockStatusEnum.IN_STOCK) {
        return "".concat(t("product", "delivery-time.label-experiment"), " ");
    }
    return "";
};
var formatAvailibilityDate = function(date, market) {
    return new Date(date).toLocaleDateString(market.localeStandard, {
        day: "numeric",
        month: "short"
    });
};

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/delivery-time/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  white-space: nowrap;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  /* Do not show label on smaller screens to prevent layout from breaking */\n  @media screen and (max-width: 410px) {\n    display: none;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var StyledDeliveryTime = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledDeliveryTime",
    componentId: "sc-0-0"
})(styles_templateObject(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var StyledDeliveryText = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledDeliveryText",
    componentId: "sc-0-1"
})(_templateObject1());
var StyledLabel = (0,styled_components_browser_esm["default"])(variants.CaptionText).withConfig({
    displayName: "StyledLabel",
    componentId: "sc-0-2"
})(_templateObject2());

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/delivery-time/index.tsx










var DeliveryTime = function(props) {
    var shipping = props.shipping, stockStatus = props.stockStatus, availability = props.availability;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), t = ref.t, market = ref.market;
    var ref1 = (0,price_row_context/* usePriceRowContext */.m)(), sorting = ref1.sorting, viewSize = ref1.viewSize;
    var sort = ShippingType.CHEAPEST;
    if (sorting === filter_dropdown/* OptionTypeEnum.FASTEST_DELIVERY */.M7.FASTEST_DELIVERY) {
        sort = ShippingType.FASTEST;
    }
    var label = getLabel(t, stockStatus);
    var isInstorePickup = isShippingInstorePickup(shipping);
    var shippingDays = getShippingDays(t, shipping);
    var deliveryText = getDeliveryTimeText(t, market, shippingDays, stockStatus, availability);
    var highlightText = getDeliveryTextIsBold(shippingDays, stockStatus, availability, isInstorePickup);
    var deliveryEmphasis = highlightText ? ui_text.FontEmphasis.HIGH : ui_text.FontEmphasis.MEDIUM;
    var deliveryFontWeight = highlightText ? ui_text.FontWeight.HEAVIEST : ui_text.FontWeight.NORMAL;
    var hasAvailabilityDate = (availability === null || availability === void 0 ? void 0 : availability.availabilityDate) && (stockStatus === StockStatusEnum.INCOMING || stockStatus === StockStatusEnum.PREORDER);
    var showDeliveryTime = shippingDays || hasAvailabilityDate || isInstorePickup || sort === ShippingType.FASTEST;
    var renderMobileDeliveryTime = function() {
        return /*#__PURE__*/ react.createElement("div", null, !isInstorePickup && /*#__PURE__*/ react.createElement(StyledLabel, {
            emphasis: ui_text.FontEmphasis.MEDIUM
        }, label), /*#__PURE__*/ react.createElement(variants.CaptionText, {
            emphasis: deliveryEmphasis,
            weight: deliveryFontWeight
        }, isInstorePickup ? t("product", "delivery-option.pickup-instore") : deliveryText));
    };
    var renderDesktopDeliveryTime = function() {
        return /*#__PURE__*/ react.createElement(StyledDeliveryText, null, !isInstorePickup && /*#__PURE__*/ react.createElement(variants.CaptionText, {
            emphasis: ui_text.FontEmphasis.MEDIUM
        }, label), /*#__PURE__*/ react.createElement(variants.CaptionText, {
            emphasis: deliveryEmphasis,
            weight: deliveryFontWeight
        }, isInstorePickup ? t("product", "delivery-option.pickup-instore") : deliveryText));
    };
    // If no delivery time is available,
    // no delivery text should be visible unless sorting on fastest delivery.
    if (!showDeliveryTime) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(StyledDeliveryTime, null, viewSize === types/* ViewSize.SMALL */.du.SMALL && renderMobileDeliveryTime(), viewSize >= types/* ViewSize.MEDIUM */.du.MEDIUM && renderDesktopDeliveryTime());
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/info-outlined/index.js
var info_outlined = __webpack_require__(12525);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/stock-price-info/styles.ts
function stock_price_info_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function stock_price_info_styles_templateObject() {
    var data = stock_price_info_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  flex: 1 0 auto;\n"
    ]);
    stock_price_info_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = stock_price_info_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  gap: ",
        ";\n  align-items: center;\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = stock_price_info_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = stock_price_info_styles_taggedTemplateLiteral([
        "\n  gap: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = stock_price_info_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n\n  svg {\n    width: ",
        "px;\n    height: ",
        "px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = stock_price_info_styles_taggedTemplateLiteral([
        "\n      svg {\n        width: ",
        "px;\n        height: ",
        "px;\n      }\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = stock_price_info_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = stock_price_info_styles_taggedTemplateLiteral([
        "\n  line-height: 1.25;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = stock_price_info_styles_taggedTemplateLiteral([
        "\n    margin: ",
        ";\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}





var Column = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Column",
    componentId: "sc-0-0"
})(stock_price_info_styles_templateObject());
var Row = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Row",
    componentId: "sc-0-1"
})(styles_templateObject1(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var CenteredFlexBox = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CenteredFlexBox",
    componentId: "sc-0-2"
})(styles_templateObject2());
var FirstRow = (0,styled_components_browser_esm["default"])(Row).withConfig({
    displayName: "FirstRow",
    componentId: "sc-0-3"
})(_templateObject3(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var ICON_SIZE_PRICE_INFO = 24;
var ICON_SIZE_STOCK_STATUS_MOBILE = 20;
var PriceInfoElement = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PriceInfoElement",
    componentId: "sc-0-4"
})(_templateObject4(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, ICON_SIZE_PRICE_INFO, ICON_SIZE_PRICE_INFO);
var StockStatusWrapper = (0,styled_components_browser_esm["default"])(PriceInfoElement).withConfig({
    displayName: "StockStatusWrapper",
    componentId: "sc-0-5"
})(function(props) {
    return props.$viewSize === types/* ViewSize.SMALL */.du.SMALL && (0,styled_components_browser_esm.css)(_templateObject5(), ICON_SIZE_STOCK_STATUS_MOBILE, ICON_SIZE_STOCK_STATUS_MOBILE);
});
var IconWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "IconWrapper",
    componentId: "sc-0-6"
})(_templateObject6());
var StyledCaptionText = (0,styled_components_browser_esm["default"])(variants.CaptionText).withConfig({
    displayName: "StyledCaptionText",
    componentId: "sc-0-7"
})(_templateObject7());
var StyledSustainabilityBadge = (0,styled_components_browser_esm["default"])(badge.Badge).withConfig({
    displayName: "StyledSustainabilityBadge",
    componentId: "sc-0-8"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject8(), props.$addExtraSpacing ? "2px" : "0");
});

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/stock-price-info/price-type-badge.tsx








var PriceTypeNoticeBadge = function(props) {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var priceAvailability = props.priceAvailability;
    if (!priceAvailability) {
        return null;
    }
    if (priceAvailability.condition !== "Download" && priceAvailability.condition !== "NotAvailableForOrder") {
        return null;
    }
    var label = priceAvailability.condition === "Download" ? t("product", "price-notice.download") : t("product", "price-notice.not_available_for_purchase");
    return /*#__PURE__*/ react.createElement(PriceInfoElement, null, /*#__PURE__*/ react.createElement(tooltip/* Tooltip */.u, {
        placement: ui/* Direction.Up */.Nm.Up,
        title: label,
        renderOnMouseOver: true
    }, /*#__PURE__*/ react.createElement(IconWrapper, null, /*#__PURE__*/ react.createElement(info_outlined/* IconInfoOutlined */.e, {
        color: "base300"
    }))), /*#__PURE__*/ react.createElement(variants.CaptionText, {
        emphasis: ui_text.FontEmphasis.MEDIUM
    }, label));
};

// EXTERNAL MODULE: ./src/components/country-flag/index.ts + 2 modules
var country_flag = __webpack_require__(72154);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/stock-price-info/country-badge.tsx




var CountryBadge = function(props) {
    var countryCode = props.countryCode;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var title = t("common", "market.".concat(countryCode));
    return /*#__PURE__*/ react.createElement(country_flag/* CountryFlag */.A, {
        countryCode: countryCode,
        title: title,
        altText: title,
        tooltipPlacement: ui/* Direction.Up */.Nm.Up
    });
};

// EXTERNAL MODULE: ./src/components/stock-status/index.tsx + 1 modules
var stock_status = __webpack_require__(74233);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/stock-price-info/stock-badge.tsx







var StockBadge = function(props) {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var viewSize = (0,price_row_context/* usePriceRowContext */.m)().viewSize;
    var status = props.status, featuredOffer = props.featuredOffer;
    var statusText = status === StockStatusEnum.PREORDER || status === StockStatusEnum.INCOMING ? t("product", "stock-status.incoming") : t("product", "stock-status.".concat(status || "unknown"));
    return /*#__PURE__*/ react.createElement(StockStatusWrapper, {
        $viewSize: viewSize
    }, /*#__PURE__*/ react.createElement(stock_status/* StockStatus */.B, {
        status: status,
        tooltip: statusText,
        tooltipPlacement: ui/* Direction.Up */.Nm.Up,
        featuredOffer: featuredOffer
    }));
};

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/stock-price-info/index.tsx






















var StockPriceInfo = function() {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref = (0,price_row_context/* usePriceRowContext */.m)(), offer = ref.offer, sorting = ref.sorting, viewSize = ref.viewSize;
    var alternativeOffer = useAlternativePriceRowContext().alternativeOffer;
    var ref1 = (0,offer_list_filter_context/* useOfferListFilterContext */.o)(), getActiveFilters = ref1.getActiveFilters, getPriceDisplay = ref1.getPriceDisplay;
    var authorizedDealer = offer.authorizedDealer, availability = offer.availability, isInternationalPrice = offer.isInternationalPrice, price = offer.price, store = offer.store;
    var getShippingBySort = function(shipping) {
        return sorting === filter_dropdown/* OptionTypeEnum.FASTEST_DELIVERY */.M7.FASTEST_DELIVERY ? shipping === null || shipping === void 0 ? void 0 : shipping.fastest : shipping === null || shipping === void 0 ? void 0 : shipping.cheapest;
    };
    var getCheapestShippingNonMember = function(shipping) {
        if (!shipping) {
            return null;
        }
        var cheapestShippingNonMember = shipping.filter(function(eligibilityCheck) {
            return eligibilityCheck.eligibility !== price_list_types/* EligibilityEnum.MEMBERS */.hs.MEMBERS;
        }).reduce(function(prev, curr) {
            if (prev === null) return curr;
            var prevCost = prev.shippingCost || 0;
            var currCost = curr.shippingCost || 0;
            return prevCost < currCost ? prev : curr;
        }, null);
        return (cheapestShippingNonMember === null || cheapestShippingNonMember === void 0 ? void 0 : cheapestShippingNonMember.shippingCost) || null;
    };
    // Get props from alternative offer if supplied
    var featured = alternativeOffer ? (0,utils/* getIsFeatured */.ZF)(offer, alternativeOffer) : offer.featured;
    var selectedOffer = alternativeOffer || offer;
    var offerPrice = alternativeOffer ? alternativeOffer.price : price;
    var offerPrices = alternativeOffer ? alternativeOffer.offerPrices : offer.offerPrices;
    var shipping = alternativeOffer ? getShippingBySort(alternativeOffer.shipping) : getShippingBySort(offer.shipping);
    var stock = alternativeOffer ? alternativeOffer.stock : offer.stock;
    var priceAvailability = alternativeOffer ? alternativeOffer.availability : availability;
    var isDownload = (availability === null || availability === void 0 ? void 0 : availability.condition) === "Download";
    var hasSustainableShipping = (shipping === null || shipping === void 0 ? void 0 : shipping.sustainability) === price_list_types/* SustainabilityEnum.SUSTAINABLE */.$z.SUSTAINABLE;
    var hasMemberShipping = (shipping === null || shipping === void 0 ? void 0 : shipping.eligibility) === price_list_types/* EligibilityEnum.MEMBERS */.hs.MEMBERS;
    var getDeliveryText = function() {
        if (hasMemberShipping) {
            var ref, ref1;
            var cheapestShippingNonMember = getCheapestShippingNonMember(((ref = offer.shipping) === null || ref === void 0 ? void 0 : ref.nodes) || (alternativeOffer === null || alternativeOffer === void 0 ? void 0 : (ref1 = alternativeOffer.shipping) === null || ref1 === void 0 ? void 0 : ref1.nodes));
            if (cheapestShippingNonMember !== (shipping === null || shipping === void 0 ? void 0 : shipping.shippingCost)) {
                return /*#__PURE__*/ react.createElement("span", null, (shipping === null || shipping === void 0 ? void 0 : shipping.carrier) ? "".concat(shipping === null || shipping === void 0 ? void 0 : shipping.carrier, ", ") : null, "(", /*#__PURE__*/ react.createElement(price_label/* PriceLabel */.l, {
                    value: cheapestShippingNonMember,
                    weight: variants.FontWeight.NORMAL
                }), ") ", t("product", "price.free-shipping"));
            }
        }
        if ((shipping === null || shipping === void 0 ? void 0 : shipping.shippingCost) === 0) {
            return /*#__PURE__*/ react.createElement("span", null, (shipping === null || shipping === void 0 ? void 0 : shipping.carrier) ? "".concat(shipping === null || shipping === void 0 ? void 0 : shipping.carrier, ", ") : null, t("product", "price.free-shipping"));
        }
        if (!(shipping === null || shipping === void 0 ? void 0 : shipping.shippingCost)) {
            return /*#__PURE__*/ react.createElement("span", null, (shipping === null || shipping === void 0 ? void 0 : shipping.carrier) ? "".concat(shipping === null || shipping === void 0 ? void 0 : shipping.carrier, ", ") : null, t("product", "price.unknown-shipping"));
        }
        // Prefix the shipping cost with carrier or shipping label
        return (shipping === null || shipping === void 0 ? void 0 : shipping.carrier) ? /*#__PURE__*/ react.createElement(react.Fragment, null, shipping === null || shipping === void 0 ? void 0 : shipping.carrier, ",", " ", /*#__PURE__*/ react.createElement(price_label/* PriceLabel */.l, {
            value: shipping.shippingCost,
            weight: variants.FontWeight.NORMAL
        })) : /*#__PURE__*/ react.createElement(react.Fragment, null, t("product", "delivery-time.label"), " ", /*#__PURE__*/ react.createElement(price_label/* PriceLabel */.l, {
            value: shipping.shippingCost,
            weight: variants.FontWeight.NORMAL
        }));
    };
    var deliveryText = getDeliveryText();
    var showDeliveryText = function() {
        if (!deliveryText) return false;
        var filteredOnShippingInfo = Boolean(getActiveFilters().find(function(item) {
            return item.type === price_list_types/* FilterType.PRICES_INC_SHIPPING */.vA.PRICES_INC_SHIPPING || item.type === price_list_types/* FilterType.DELIVERY_METHOD */.vA.DELIVERY_METHOD || item.type === price_list_types/* FilterType.CARRIERS */.vA.CARRIERS;
        }));
        return sorting === filter_dropdown/* OptionTypeEnum.FASTEST_DELIVERY */.M7.FASTEST_DELIVERY || filteredOnShippingInfo;
    };
    return /*#__PURE__*/ react.createElement(Column, null, /*#__PURE__*/ react.createElement(FirstRow, null, !featured && viewSize >= types/* ViewSize.MEDIUM */.du.MEDIUM && /*#__PURE__*/ react.createElement(CenteredFlexBox, null, isInternationalPrice && (store === null || store === void 0 ? void 0 : store.primaryMarket) && /*#__PURE__*/ react.createElement(CountryBadge, {
        countryCode: store.primaryMarket
    })), offerPrice && /*#__PURE__*/ react.createElement(react.Fragment, null, !featured && /*#__PURE__*/ react.createElement(StockBadge, {
        featuredOffer: featured,
        status: stock === null || stock === void 0 ? void 0 : stock.status
    }), /*#__PURE__*/ react.createElement(OfferPriceLabel, {
        container: "h4",
        priceDisplay: getPriceDisplay(),
        selectedOffer: selectedOffer,
        shipping: shipping !== null && shipping !== void 0 ? shipping : undefined,
        offerPrice: offerPrices
    }))), featured && /*#__PURE__*/ react.createElement(react.Fragment, null, showDeliveryText() ? /*#__PURE__*/ react.createElement(Row, null, hasSustainableShipping && /*#__PURE__*/ react.createElement(tooltip/* Tooltip */.u, {
        placement: ui/* Direction.Up */.Nm.Up,
        title: t("product", "shipping.sustainable")
    }, /*#__PURE__*/ react.createElement(StyledSustainabilityBadge, {
        circular: true,
        color: "GREEN",
        icon: leaf/* IconLeaf */.y,
        size: badge.BadgeSize.SMALL,
        $addExtraSpacing: Boolean(authorizedDealer)
    })), /*#__PURE__*/ react.createElement(StyledCaptionText, {
        emphasis: variants.FontEmphasis.MEDIUM
    }, deliveryText)) : null, /*#__PURE__*/ react.createElement(Row, null, !alternativeOffer && authorizedDealer && viewSize === types/* ViewSize.LARGE */.du.LARGE && /*#__PURE__*/ react.createElement(AuthorizedDealerBadge, null), viewSize >= types/* ViewSize.MEDIUM */.du.MEDIUM && /*#__PURE__*/ react.createElement(react.Fragment, null, priceAvailability && /*#__PURE__*/ react.createElement(PriceTypeNoticeBadge, {
        priceAvailability: priceAvailability
    }), isInternationalPrice && (store === null || store === void 0 ? void 0 : store.primaryMarket) && /*#__PURE__*/ react.createElement(CountryBadge, {
        countryCode: store.primaryMarket
    }), !isDownload && /*#__PURE__*/ react.createElement(StockBadge, {
        featuredOffer: featured,
        status: stock === null || stock === void 0 ? void 0 : stock.status
    })), !isDownload && viewSize === types/* ViewSize.SMALL */.du.SMALL && /*#__PURE__*/ react.createElement(StockBadge, {
        featuredOffer: featured,
        status: stock === null || stock === void 0 ? void 0 : stock.status
    }), !isDownload && /*#__PURE__*/ react.createElement(DeliveryTime, {
        shipping: shipping,
        stockStatus: stock === null || stock === void 0 ? void 0 : stock.status,
        availability: priceAvailability
    })), !alternativeOffer && authorizedDealer && viewSize === types/* ViewSize.MEDIUM */.du.MEDIUM && /*#__PURE__*/ react.createElement(Row, null, /*#__PURE__*/ react.createElement(AuthorizedDealerBadge, null))));
};

// EXTERNAL MODULE: ./src/components/store-logo/index.tsx
var store_logo = __webpack_require__(19247);
// EXTERNAL MODULE: ./src/components/rating/smiley-rating/index.tsx + 1 modules
var smiley_rating = __webpack_require__(58239);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/store-rating-average/styles.ts
function store_rating_average_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function store_rating_average_styles_templateObject() {
    var data = store_rating_average_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"
    ]);
    store_rating_average_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var RatingContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "RatingContainer",
    componentId: "sc-0-0"
})(store_rating_average_styles_templateObject());

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/store-rating-average/index.tsx





var StoreRatingAverage = function() {
    var ref = (0,price_row_context/* usePriceRowContext */.m)(), offer = ref.offer, viewSize = ref.viewSize;
    var featured = offer.featured, store = offer.store, rating = offer.rating;
    if (!store || !rating || rating.whole <= 0) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(RatingContainer, {
        "data-rating": rating.roundedString
    }, /*#__PURE__*/ react.createElement(smiley_rating/* default */.Z, {
        featured: featured,
        rating: rating,
        scoreVisibility: "row",
        size: "small",
        reviewCount: viewSize >= types/* ViewSize.MEDIUM */.du.MEDIUM ? store.userReviewSummary.countTotal : undefined
    }));
};

// EXTERNAL MODULE: ./src/areas/store/constants.ts
var constants = __webpack_require__(70320);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/store-info-column/styles.ts
function store_info_column_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function store_info_column_styles_templateObject() {
    var data = store_info_column_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  flex-shrink: 0;\n  gap: ",
        ";\n  width: 104px;\n  padding: ",
        ";\n  margin: 0;\n\n  /* Small mobile resolutions, e.g. Galaxy Fold */\n  @media screen and (max-width: ",
        ") {\n    width: calc(\n      ",
        "px + ",
        "\n    );\n  }\n"
    ]);
    store_info_column_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function store_info_column_styles_templateObject1() {
    var data = store_info_column_styles_taggedTemplateLiteral([
        "\n  /* Visually hidden since this text is primarily for Google */\n  position: absolute;\n  left: -10000px;\n  top: auto;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n"
    ]);
    store_info_column_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function store_info_column_styles_templateObject2() {
    var data = store_info_column_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: ",
        ";\n"
    ]);
    store_info_column_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var EXTRA_SMALL_DISPLAY_WIDTH = "280px";
var StoreInfo = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StoreInfo",
    componentId: "sc-0-0"
})(store_info_column_styles_templateObject(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, EXTRA_SMALL_DISPLAY_WIDTH, store_logo/* DEFAULT_STORE_LOGO_MAX_WIDTH */.uZ, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StoreInfoTitle = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StoreInfoTitle",
    componentId: "sc-0-1"
})(store_info_column_styles_templateObject1());
var InfoGroup = styled_components_browser_esm["default"].div.withConfig({
    displayName: "InfoGroup",
    componentId: "sc-0-2"
})(store_info_column_styles_templateObject2(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025);

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/store-info-column/index.tsx









var StoreInfoColumn = function() {
    var ref = (0,price_row_context/* usePriceRowContext */.m)(), offer = ref.offer, viewSize = ref.viewSize, isInPriceList = ref.isInPriceList;
    var featured = offer.featured, store = offer.store, isInternationalPrice = offer.isInternationalPrice;
    if (!store) {
        return null;
    }
    var highResolutionLogo = store.logo ? {
        url: store.logo,
        width: constants/* SHOP_LOGO_WIDTH */.L9
    } : null;
    return /*#__PURE__*/ react.createElement(StoreInfo, null, /*#__PURE__*/ react.createElement(StoreInfoTitle, null, store.name), /*#__PURE__*/ react.createElement(store_logo/* StoreLogo */.Xv, {
        featured: featured,
        hasImage: Boolean(store.hasLogo),
        logoUrl: highResolutionLogo === null || highResolutionLogo === void 0 ? void 0 : highResolutionLogo.url,
        name: store.name,
        showHighResolutionLogo: Boolean(highResolutionLogo),
        storeId: store.id,
        variant: store_logo/* StoreLogoVariant.PRICE_LIST */.mA.PRICE_LIST,
        width: highResolutionLogo === null || highResolutionLogo === void 0 ? void 0 : highResolutionLogo.width
    }), /*#__PURE__*/ react.createElement(InfoGroup, null, isInPriceList && /*#__PURE__*/ react.createElement(StoreRatingAverage, null), featured && offer.authorizedDealer && viewSize === types/* ViewSize.SMALL */.du.SMALL && /*#__PURE__*/ react.createElement(AuthorizedDealerBadge, null), isInternationalPrice && (store === null || store === void 0 ? void 0 : store.primaryMarket) && viewSize === types/* ViewSize.SMALL */.du.SMALL && /*#__PURE__*/ react.createElement(CountryBadge, {
        countryCode: store.primaryMarket
    })));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/prisjakt/index.js
var prisjakt = __webpack_require__(74951);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/our-choice-badge/styles.ts
function our_choice_badge_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function our_choice_badge_styles_templateObject() {
    var data = our_choice_badge_styles_taggedTemplateLiteral([
        "\n      top: -",
        ";\n    "
    ]);
    our_choice_badge_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function our_choice_badge_styles_templateObject1() {
    var data = our_choice_badge_styles_taggedTemplateLiteral([
        "\n  height: 10px;\n  width: ",
        "px;\n  position: relative;\n  top: -",
        ";\n  cursor: pointer;\n\n  ",
        "\n"
    ]);
    our_choice_badge_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function our_choice_badge_styles_templateObject2() {
    var data = our_choice_badge_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  left: -",
        ";\n"
    ]);
    our_choice_badge_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var WIDTH_FOR_TOOLTIP_BASE = 210;
var StyledOurChoiceBadgeWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledOurChoiceBadgeWrapper",
    componentId: "sc-0-0"
})(our_choice_badge_styles_templateObject1(), WIDTH_FOR_TOOLTIP_BASE, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, function(props) {
    return props.$viewSize !== undefined && props.$viewSize >= types/* ViewSize.MEDIUM */.du.MEDIUM && (0,styled_components_browser_esm.css)(our_choice_badge_styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
});
var StyledOurChoiceBadge = (0,styled_components_browser_esm["default"])(badge.Badge).withConfig({
    displayName: "StyledOurChoiceBadge",
    componentId: "sc-0-1"
})(our_choice_badge_styles_templateObject2(), base/* layout.measurements.spacing200 */.bK.measurements.spacing200);

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/our-choice-badge/index.tsx








var OurChoiceBadge = function() {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var viewSize = (0,price_row_context/* usePriceRowContext */.m)().viewSize;
    return /*#__PURE__*/ react.createElement(StyledOurChoiceBadgeWrapper, {
        $viewSize: viewSize
    }, /*#__PURE__*/ react.createElement(tooltip/* Tooltip */.u, {
        title: t("product", "prices.our-choice-explanation"),
        placement: ui/* Direction.Up */.Nm.Up
    }, /*#__PURE__*/ react.createElement(StyledOurChoiceBadge, {
        size: badge.BadgeSize.SMALL,
        color: "BLUE_INVERTED",
        text: t("product", "prices.our-choice"),
        icon: prisjakt/* IconPrisjakt */.w
    })));
};

// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row/components/condition-type-badge/index.tsx + 1 modules
var condition_type_badge = __webpack_require__(83717);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/utils.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var setAntiBotFlag = function(e) {
    if (false) {}
    var oldHref = e.currentTarget.href;
    var newHref = oldHref.includes("&bc=1") ? oldHref : "".concat(oldHref, "&bc=1");
    e.currentTarget.href = newHref;
};
var baseLinkProps = {
    rel: "nofollow noopener",
    onMouseDown: setAntiBotFlag,
    onTouchStart: setAntiBotFlag,
    onKeyDown: setAntiBotFlag,
    target: "_blank"
};
var setTableLinkProps = function(featured, onClick, externalUri) {
    return _objectSpreadProps(_objectSpread({}, baseLinkProps), {
        href: featured ? externalUri || undefined : undefined,
        onClick: onClick,
        target: "_blank",
        disabled: !featured
    });
};
var getContainerProps = function(name, featured, onClick, externalUri) {
    return _objectSpreadProps(_objectSpread({}, baseLinkProps), {
        to: externalUri || undefined,
        "aria-label": name,
        isExternal: true,
        disabled: !externalUri,
        onClick: onClick,
        featured: featured
    });
};

// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row/components/price-row-columns/styles.ts
var price_row_columns_styles = __webpack_require__(50762);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/price-row-columns/featured-columns.tsx













var FeaturedColumns = function(props) {
    var ref, ref1, ref2;
    var onClick = props.onClick;
    var ref3 = (0,price_row_context/* usePriceRowContext */.m)(), offer = ref3.offer, viewSize = ref3.viewSize, isOurChoice = ref3.isOurChoice, isInPriceList = ref3.isInPriceList;
    var alternativeOffer = useAlternativePriceRowContext().alternativeOffer;
    var isAlternative = Boolean(alternativeOffer);
    var name = (alternativeOffer === null || alternativeOffer === void 0 ? void 0 : alternativeOffer.name) || offer.name;
    var condition = (alternativeOffer === null || alternativeOffer === void 0 ? void 0 : alternativeOffer.condition) || offer.condition;
    var isMembershipPrice = Boolean((ref = alternativeOffer || offer) === null || ref === void 0 ? void 0 : (ref1 = ref.offerPrices) === null || ref1 === void 0 ? void 0 : ref1.memberPrice);
    var isPaidMembership = Boolean((ref2 = offer.membershipProgram) === null || ref2 === void 0 ? void 0 : ref2.requiresCompensation);
    var externalUri = isAlternative ? alternativeOffer === null || alternativeOffer === void 0 ? void 0 : alternativeOffer.externalUri : offer.externalUri;
    var containerProps = getContainerProps(name || "", true, onClick, externalUri);
    var renderMembershipInformation = function() {
        return /*#__PURE__*/ react.createElement(badges/* MembershipInformation */.pb, {
            isMembershipPrice: isMembershipPrice,
            isPaidMembership: isPaidMembership,
            smallerTextSize: false
        });
    };
    return /*#__PURE__*/ react.createElement(price_row_columns_styles/* StyledFeaturedRow */.Qp, {
        container: clickable/* Clickable */.P,
        containerProps: containerProps,
        $hasPromotion: Boolean(offer.promotion)
    }, /*#__PURE__*/ react.createElement(price_row_columns_styles/* StyledFlexHorizontal */.po, null, /*#__PURE__*/ react.createElement(price_row_columns_styles/* StyledMiddleColumnMobilePadding */.M6, {
        $viewSize: viewSize
    }, viewSize === types/* ViewSize.SMALL */.du.SMALL && renderMembershipInformation(), /*#__PURE__*/ react.createElement(price_row_columns_styles/* StyledFlexVertical */.Be, null, isOurChoice && isInPriceList && !alternativeOffer && /*#__PURE__*/ react.createElement(OurChoiceBadge, null), /*#__PURE__*/ react.createElement(price_row_columns_styles/* StyledFlexHorizontal */.po, null, !isAlternative && /*#__PURE__*/ react.createElement(StoreInfoColumn, null), /*#__PURE__*/ react.createElement(price_row_columns_styles/* StyledMiddleColumnDesktopPadding */.pS, {
        $viewSize: viewSize
    }, viewSize >= types/* ViewSize.MEDIUM */.du.MEDIUM && /*#__PURE__*/ react.createElement(price_row_columns_styles/* StyledFlexVertical */.Be, null, renderMembershipInformation()), /*#__PURE__*/ react.createElement(price_row_columns_styles/* StyledFlexHorizontal */.po, null, /*#__PURE__*/ react.createElement(price_row_columns_styles/* StyledProductNameWrapper */.a2, {
        $alignStart: isMembershipPrice && !alternativeOffer
    }, (viewSize >= types/* ViewSize.MEDIUM */.du.MEDIUM || isAlternative) && /*#__PURE__*/ react.createElement(price_row_columns_styles/* StyledProductName */.D, {
        $featured: true,
        $isAlternative: isAlternative
    }, name)), /*#__PURE__*/ react.createElement(price_row_columns_styles/* StyledFlexVertical */.Be, null, /*#__PURE__*/ react.createElement(price_row_columns_styles/* StyledBadgeWrapper */.oJ, null, /*#__PURE__*/ react.createElement(condition_type_badge/* ConditionTypeBadge */.b, {
        condition: condition
    })), /*#__PURE__*/ react.createElement(StockPriceInfo, null))))))), /*#__PURE__*/ react.createElement(price_row_columns_styles/* StyledEndColumn */.Y, {
        $featured: true,
        $viewSize: viewSize
    }, /*#__PURE__*/ react.createElement(go_to_store_button/* GoToStoreButton */.a, {
        viewSize: viewSize
    }))));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/button/variants.js
var button_variants = __webpack_require__(7336);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/popover/index.js
var popover = __webpack_require__(22448);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/eyehidden/index.js
var eyehidden = __webpack_require__(83338);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/price-row-columns/unfeatured-columns.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
















var UnfeaturedColumns = function(props) {
    var priceRowRef = props.priceRowRef, setShowDisabledInfo = props.setShowDisabledInfo, showDisabledInfo = props.showDisabledInfo, tableLinkProps = props.tableLinkProps;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref = (0,price_row_context/* usePriceRowContext */.m)(), setShowUnfeaturedPlaceholder = ref.collapseUnfeaturedFn, showUnfeaturedHideButton = ref.showUnfeaturedHideButton, offer = ref.offer, viewSize = ref.viewSize;
    var alternativeOffer = useAlternativePriceRowContext().alternativeOffer;
    var featured = offer.featured, priceId = offer.priceId;
    var isAlternative = Boolean(alternativeOffer);
    var isFeatured = isAlternative ? (0,utils/* getIsFeatured */.ZF)(offer, alternativeOffer) : featured;
    var name = (alternativeOffer === null || alternativeOffer === void 0 ? void 0 : alternativeOffer.name) || offer.name;
    var condition = (alternativeOffer === null || alternativeOffer === void 0 ? void 0 : alternativeOffer.condition) || offer.condition;
    var handleOutSideClick = (0,react.useCallback)(function(e) {
        if (priceRowRef && priceRowRef.current && priceRowRef.current.contains(e.target)) {
            return;
        }
        setShowDisabledInfo === null || setShowDisabledInfo === void 0 ? void 0 : setShowDisabledInfo(false);
    }, [
        priceRowRef,
        setShowDisabledInfo
    ]);
    // componentWillUnmount
    (0,react.useEffect)(function() {
        return function() {
            window.removeEventListener("click", handleOutSideClick);
        };
    }, [
        handleOutSideClick
    ]);
    // Callback for showDisabledInfo state change
    (0,react.useEffect)(function() {
        if (!setShowDisabledInfo) return;
        if (showDisabledInfo) {
            window.addEventListener("click", handleOutSideClick);
        } else {
            window.removeEventListener("click", handleOutSideClick);
        }
    }, [
        handleOutSideClick,
        setShowDisabledInfo,
        showDisabledInfo
    ]);
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(price_row_columns_styles/* StyledUnfeaturedRow */.ry, _extends({}, tableLinkProps, {
        "aria-describedby": "click-out-".concat(priceId),
        "data-test": "UnfeaturedRow",
        $featured: isFeatured
    }), !isAlternative && /*#__PURE__*/ react.createElement(StoreInfoColumn, null), /*#__PURE__*/ react.createElement(price_row_columns_styles/* StyledMiddleColumn */.YW, null, /*#__PURE__*/ react.createElement(price_row_columns_styles/* StyledTopMiddleRow */.f4, {
        $viewSize: viewSize
    }, /*#__PURE__*/ react.createElement(price_row_columns_styles/* StyledProductNameWrapper */.a2, null, (viewSize >= types/* ViewSize.MEDIUM */.du.MEDIUM || isAlternative) && /*#__PURE__*/ react.createElement(price_row_columns_styles/* StyledProductName */.D, {
        $isAlternative: isAlternative
    }, name)), /*#__PURE__*/ react.createElement(price_row_columns_styles/* StyledFlexVertical */.Be, null, /*#__PURE__*/ react.createElement(price_row_columns_styles/* StyledBadgeWrapper */.oJ, null, /*#__PURE__*/ react.createElement(condition_type_badge/* ConditionTypeBadge */.b, {
        condition: condition
    })), /*#__PURE__*/ react.createElement(StockPriceInfo, null)))), /*#__PURE__*/ react.createElement(price_row_columns_styles/* StyledEndColumn */.Y, {
        $viewSize: viewSize
    }, /*#__PURE__*/ react.createElement(go_to_store_button/* GoToStoreButton */.a, {
        viewSize: viewSize
    }))), !isAlternative && showUnfeaturedHideButton && /*#__PURE__*/ react.createElement(price_row_columns_styles/* StyledCollapseUnfeaturedBtn */.xL, {
        placement: ui/* Direction.Left */.Nm.Left,
        title: t("product", "price-list.unfeatured-shops-hide-all"),
        $viewSize: viewSize
    }, /*#__PURE__*/ react.createElement(button_variants.TextButton, {
        ariaLabel: t("product", "price-list.unfeatured-shops-hide-all"),
        onClick: function() {
            return setShowUnfeaturedPlaceholder === null || setShowUnfeaturedPlaceholder === void 0 ? void 0 : setShowUnfeaturedPlaceholder();
        },
        onlyIcon: true,
        size: button_variants.ButtonSize.SMALL
    }, /*#__PURE__*/ react.createElement(eyehidden.IconEyeHidden, {
        color: "maybeBlue700"
    }))), /*#__PURE__*/ react.createElement(popover/* Popover */.J2, {
        id: "click-out-".concat(priceId),
        visible: Boolean(showDisabledInfo),
        width: 250,
        horizontalAlign: popover/* Alignment.Center */.v2.Center,
        verticalAlign: popover/* Alignment.Center */.v2.Center,
        onClose: function() {
            return setShowDisabledInfo === null || setShowDisabledInfo === void 0 ? void 0 : setShowDisabledInfo(!showDisabledInfo);
        }
    }, /*#__PURE__*/ react.createElement(variants.BodySmallText, null, t("product", "transparency.store-info"))));
};

// EXTERNAL MODULE: ./src/components/viewport/index.tsx
var viewport = __webpack_require__(10297);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/dropdown/index.js
var dropdown = __webpack_require__(42654);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/flag-outlined/index.js
var flag_outlined = __webpack_require__(69001);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row/components/report-modal/index.tsx
var report_modal = __webpack_require__(5884);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row/row-types/styles.ts
var row_types_styles = __webpack_require__(40710);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/row-types/alternative-price-row/styles.ts
function alternative_price_row_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function alternative_price_row_styles_templateObject() {
    var data = alternative_price_row_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  flex-flow: column;\n  transition: opacity ease 0.25s;\n  justify-content: center;\n"
    ]);
    alternative_price_row_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function alternative_price_row_styles_templateObject1() {
    var data = alternative_price_row_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  white-space: nowrap;\n  cursor: pointer;\n  padding: ",
        ";\n\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    alternative_price_row_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function alternative_price_row_styles_templateObject2() {
    var data = alternative_price_row_styles_taggedTemplateLiteral([
        "\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n"
    ]);
    alternative_price_row_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = alternative_price_row_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  animation: ",
        " 250ms ease-in-out 1;\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = alternative_price_row_styles_taggedTemplateLiteral([
        "\n  min-height: 100%;\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var Options = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Options",
    componentId: "sc-0-0"
})(alternative_price_row_styles_templateObject());
var Option = styled_components_browser_esm["default"].button.withConfig({
    displayName: "Option",
    componentId: "sc-0-1"
})(alternative_price_row_styles_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.theme.dropdowns.secondary.hoverBackground;
});
var fadeIn = (0,styled_components_browser_esm.keyframes)(alternative_price_row_styles_templateObject2());
var ReportOverlay = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ReportOverlay",
    componentId: "sc-0-2"
})(styles_templateObject3(), function(p) {
    return p.theme.text.secondary;
}, fadeIn);
var Dropdown = (0,styled_components_browser_esm["default"])(dropdown/* Dropdown */.Lt).withConfig({
    displayName: "Dropdown",
    componentId: "sc-0-3"
})(styles_templateObject4());

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/row-types/alternative-price-row/options-cloumn.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}












var OptionsColumn = function(props) {
    var ref, ref1, ref2;
    var className = props.className, isFeatured = props.isFeatured;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var isMobile = (0,react.useContext)(viewport/* ViewportContext */.R).isMobile;
    var ref3 = (0,price_row_context/* usePriceRowContext */.m)(), store = ref3.offer.store, product = ref3.product;
    var alternativeOffer = useAlternativePriceRowContext().alternativeOffer;
    var ref4 = _slicedToArray((0,react.useState)(false), 2), modalIsOpen = ref4[0], setModalIsOpen = ref4[1];
    var openModal = (0,react.useCallback)(function(e) {
        // Stops the PriceRow link and onClick from firing
        e.preventDefault();
        e.stopPropagation();
        setModalIsOpen(true);
    }, [
        setModalIsOpen
    ]);
    var closeModal = (0,react.useCallback)(function() {
        return setModalIsOpen(false);
    }, [
        setModalIsOpen
    ]);
    if (!alternativeOffer) return null;
    return /*#__PURE__*/ react.createElement(row_types_styles/* Column */.sg, {
        className: className
    }, /*#__PURE__*/ react.createElement(report_modal/* ReportModal */.y, {
        isOpen: modalIsOpen,
        closeModal: closeModal,
        priceId: alternativeOffer.id,
        priceValue: (ref = alternativeOffer.price) === null || ref === void 0 ? void 0 : ref.exclShipping,
        productName: alternativeOffer.name,
        productImage: (ref1 = product.media) === null || ref1 === void 0 ? void 0 : ref1.first,
        stockStatus: (ref2 = alternativeOffer.stock) === null || ref2 === void 0 ? void 0 : ref2.status,
        isFeatured: isFeatured,
        store: store
    }), /*#__PURE__*/ react.createElement(Options, null, /*#__PURE__*/ react.createElement(Dropdown, {
        closeOnItemClick: true,
        onToggle: function(event) {
            event.stopPropagation();
            event.preventDefault();
        }
    }, /*#__PURE__*/ react.createElement(dropdown/* DropdownToggle */.Z_, {
        onlyIcon: true,
        size: button_variants.ButtonSize.MEDIUM,
        type: button_variants.ButtonType.TEXT,
        ariaLabel: t("feedback", "dialog.prompt-button")
    }, /*#__PURE__*/ react.createElement(flag_outlined/* IconFlagOutlined */.b, {
        color: "base600",
        size: 18
    })), /*#__PURE__*/ react.createElement(dropdown/* DropdownContent */.Nv, {
        placement: isMobile ? ui/* Direction.Up */.Nm.Up : ui/* Direction.Down */.Nm.Down
    }, /*#__PURE__*/ react.createElement(ReportOverlay, null, /*#__PURE__*/ react.createElement(Option, {
        type: "button",
        onClick: openModal
    }, t("feedback", "dialog.prompt-button")))))));
};

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/row-types/alternative-price-row/index.tsx









var AlternativePriceRow = function(param) {
    var priceRowRef = param.priceRowRef, tableLinkProps = param.tableLinkProps;
    var ref = (0,price_row_context/* usePriceRowContext */.m)(), offer = ref.offer, viewSize = ref.viewSize;
    var alternativeOffer = useAlternativePriceRowContext().alternativeOffer;
    var externalUri = (alternativeOffer !== null && alternativeOffer !== void 0 ? alternativeOffer : {}).externalUri;
    var isFeatured = (0,utils/* getIsFeatured */.ZF)(offer, alternativeOffer);
    if (!alternativeOffer) return null;
    return /*#__PURE__*/ react.createElement(row_types_styles/* StyledCard */.rg, {
        $expanded: true,
        $featured: isFeatured,
        $isAlternative: true
    }, /*#__PURE__*/ react.createElement(row_types_styles/* Row */.X2, {
        $expanded: true,
        $featured: isFeatured,
        $isAlternative: true,
        $noExternalUri: !externalUri,
        "data-test": "AlternativePriceRow"
    }, viewSize === types/* ViewSize.SMALL */.du.SMALL && /*#__PURE__*/ react.createElement(OptionsColumn, {
        isFeatured: isFeatured
    }), viewSize >= types/* ViewSize.MEDIUM */.du.MEDIUM && /*#__PURE__*/ react.createElement(OptionsColumn, {
        isFeatured: isFeatured
    }), isFeatured && alternativeOffer.externalUri && /*#__PURE__*/ react.createElement(FeaturedColumns, {
        onClick: tableLinkProps.onClick
    }), (!isFeatured || !alternativeOffer.externalUri) && /*#__PURE__*/ react.createElement(UnfeaturedColumns, {
        priceRowRef: priceRowRef,
        tableLinkProps: tableLinkProps
    })));
};

// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row/components/report-button/index.tsx
var report_button = __webpack_require__(56031);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/chevron-right/index.js
var chevron_right = __webpack_require__(46695);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(58912);
// EXTERNAL MODULE: ./src/components/store-payment/utils.ts + 1 modules
var store_payment_utils = __webpack_require__(83563);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/payment-provider/styles.ts
function payment_provider_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function payment_provider_styles_templateObject() {
    var data = payment_provider_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: ",
        ";\n  align-items: center;\n"
    ]);
    payment_provider_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function payment_provider_styles_templateObject1() {
    var data = payment_provider_styles_taggedTemplateLiteral([
        "\n  height: ",
        ";\n"
    ]);
    payment_provider_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function payment_provider_styles_templateObject2() {
    var data = payment_provider_styles_taggedTemplateLiteral([
        ""
    ]);
    payment_provider_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var PaymentProviders = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PaymentProviders",
    componentId: "sc-0-0"
})(payment_provider_styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var PaymentProviderLogotype = styled_components_browser_esm["default"].img.withConfig({
    displayName: "PaymentProviderLogotype",
    componentId: "sc-0-1"
})(payment_provider_styles_templateObject1(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var PaymentProviderMoreLabel = (0,styled_components_browser_esm["default"])(variants.CaptionText).withConfig({
    displayName: "PaymentProviderMoreLabel",
    componentId: "sc-0-2"
})(payment_provider_styles_templateObject2());

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/payment-provider/index.tsx





var OfferPaymentProviders = function(param) {
    var store = param.store, showAll = param.showAll, limit = param.limit;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), market = ref.market, t = ref.t;
    var paymentProviders = (0,store_payment_utils/* getPaymentProviders */.Qk)(store, market);
    var providers = (0,store_payment_utils/* getGroupedPaymentProviders */._L)(store, market);
    var visibleProviders = providers;
    if (limit && (providers === null || providers === void 0 ? void 0 : providers.length) > limit) {
        visibleProviders = providers.slice(0, limit);
    }
    var invisibleProviders = paymentProviders.providers.filter(function(p) {
        return p.active && !visibleProviders.find(function(v) {
            return v.name === p.name;
        });
    });
    if (!paymentProviders.hasProviders) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(variants.H4Text, null, t("store", "store.payment-options")), /*#__PURE__*/ react.createElement(PaymentProviders, null, showAll && paymentProviders.providers.map(function(provider) {
        return Boolean(provider.active) && /*#__PURE__*/ react.createElement(PaymentProviderLogotype, {
            src: provider.logoUrl,
            alt: provider.label,
            title: provider.label,
            key: provider.name
        });
    }), !showAll && visibleProviders.map(function(provider) {
        return /*#__PURE__*/ react.createElement(PaymentProviderLogotype, {
            src: provider.logoUrl,
            alt: provider.label,
            title: provider.label,
            key: provider.name
        });
    }), !showAll && invisibleProviders.length > 0 && /*#__PURE__*/ react.createElement(PaymentProviderMoreLabel, null, /*#__PURE__*/ react.createElement("span", null, "+"), invisibleProviders.length)));
};

// EXTERNAL MODULE: ./src/areas/product/components/carrier-logos/carrier-logos.tsx
var carrier_logos = __webpack_require__(17965);
// EXTERNAL MODULE: ./src/components/currency/index.tsx
var currency = __webpack_require__(49763);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/offer-list-filters/shipping-filters/delivery-methods/utils.ts
var delivery_methods_utils = __webpack_require__(68443);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/store-info/delivery-options/styles.ts
function delivery_options_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function delivery_options_styles_templateObject() {
    var data = delivery_options_styles_taggedTemplateLiteral([
        ""
    ]);
    delivery_options_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function delivery_options_styles_templateObject1() {
    var data = delivery_options_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  padding: ",
        " 0;\n\n  > img {\n    width: 48px;\n  }\n\n  &:not(:last-child) {\n    border-bottom: 1px solid ",
        ";\n  }\n"
    ]);
    delivery_options_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function delivery_options_styles_templateObject2() {
    var data = delivery_options_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  font-weight: bold;\n"
    ]);
    delivery_options_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function delivery_options_styles_templateObject3() {
    var data = delivery_options_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  flex-grow: 1;\n"
    ]);
    delivery_options_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function delivery_options_styles_templateObject4() {
    var data = delivery_options_styles_taggedTemplateLiteral([
        "\n  align-self: baseline;\n"
    ]);
    delivery_options_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = delivery_options_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  row-gap: ",
        ";\n  max-width: ",
        ";\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = delivery_options_styles_taggedTemplateLiteral([
        "\n  line-height: 1.2;\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}




var ShippingOptionList = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ShippingOptionList",
    componentId: "sc-0-0"
})(delivery_options_styles_templateObject());
var ShippingOptionItem = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ShippingOptionItem",
    componentId: "sc-0-1"
})(delivery_options_styles_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* colors.borderLightGray */.O9.borderLightGray);
var ItemTitle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ItemTitle",
    componentId: "sc-0-2"
})(delivery_options_styles_templateObject2());
var TitleWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TitleWrapper",
    componentId: "sc-0-3"
})(delivery_options_styles_templateObject3());
var StyledBadge = (0,styled_components_browser_esm["default"])(badge.Badge).withConfig({
    displayName: "StyledBadge",
    componentId: "sc-0-4"
})(delivery_options_styles_templateObject4());
var SUSTAINABLE_DESCRIPTION_MAX_WIDTH = "480px";
var StyledSustainableDescription = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledSustainableDescription",
    componentId: "sc-0-5"
})(styles_templateObject5(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, SUSTAINABLE_DESCRIPTION_MAX_WIDTH);
var styles_StyledCaptionText = (0,styled_components_browser_esm["default"])(variants.CaptionText).withConfig({
    displayName: "StyledCaptionText",
    componentId: "sc-0-6"
})(styles_templateObject6());

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/store-info/delivery-options/delivery-options.tsx











var DeliveryOptions = function(param) {
    var offer = param.offer;
    var ref, ref1;
    var ref2 = (0,app_context/* useAppContext */.bp)(), market = ref2.market, t = ref2.t;
    var missingInfoText = t("product", "delivery.missing-shipping-information", {
        store: ((ref = offer.store) === null || ref === void 0 ? void 0 : ref.name) || ""
    });
    var deliveryMethodTranslation = function(optionMethod) {
        var deliveryOption = (0,delivery_methods_utils/* getDeliveryMethodsConfig */.m)().find(function(option) {
            return option.type === optionMethod;
        });
        var key = deliveryOption === null || deliveryOption === void 0 ? void 0 : deliveryOption.translationString;
        if (!key) {
            return null;
        }
        // @ts-expect-error -- Types too loose
        return t("product", key);
    };
    var getDeliveryInfo = function(node) {
        if (!(node === null || node === void 0 ? void 0 : node.deliveryMethod)) {
            return missingInfoText;
        }
        var carrierText = (node === null || node === void 0 ? void 0 : node.carrier) ? " • ".concat(node.carrier) : "";
        return "".concat(deliveryMethodTranslation((node === null || node === void 0 ? void 0 : node.deliveryMethod) || "")).concat(carrierText);
    };
    var renderShippingOptions = function() {
        var ref;
        var nodes = (ref = offer.unfilteredShippings) === null || ref === void 0 ? void 0 : ref.filter(function(node) {
            return (node === null || node === void 0 ? void 0 : node.carrier) || (node === null || node === void 0 ? void 0 : node.deliveryMethod) === "INSTORE_PICKUP";
        }).sort(function(a, b) {
            var aCarrier = a.carrier || "";
            var bCarrier = b.carrier || "";
            var aShippingCost = (a === null || a === void 0 ? void 0 : a.shippingCost) || 0;
            var bShippingCost = (b === null || b === void 0 ? void 0 : b.shippingCost) || 0;
            return aCarrier.localeCompare(bCarrier) || aShippingCost - bShippingCost;
        });
        if (!nodes || (nodes === null || nodes === void 0 ? void 0 : nodes.length) <= 0) {
            return /*#__PURE__*/ react.createElement(ShippingOptionItem, null, /*#__PURE__*/ react.createElement("img", {
                src: "".concat(market.cdn, "/g/rfe/illustrations/icon-no-shipping-info.svg"),
                alt: "package-icon"
            }), /*#__PURE__*/ react.createElement(TitleWrapper, null, missingInfoText));
        }
        var isInstorePickup = function(shipping) {
            return shipping.deliveryMethod === "INSTORE_PICKUP";
        };
        return nodes === null || nodes === void 0 ? void 0 : nodes.map(function(node, i) {
            var ref, ref1;
            var deliveryDays = {
                min: (node === null || node === void 0 ? void 0 : (ref = node.deliveryDays) === null || ref === void 0 ? void 0 : ref.min) || 0,
                max: (node === null || node === void 0 ? void 0 : (ref1 = node.deliveryDays) === null || ref1 === void 0 ? void 0 : ref1.max) || 0
            };
            return /*#__PURE__*/ react.createElement(ShippingOptionItem, {
                key: i
            }, (0,carrier_logos/* CarrierLogo */.p)(node.carrier || "", isInstorePickup(node)), /*#__PURE__*/ react.createElement(TitleWrapper, null, node.sustainability === price_list_types/* SustainabilityEnum.SUSTAINABLE */.$z.SUSTAINABLE && /*#__PURE__*/ react.createElement(StyledBadge, {
                color: "GREEN",
                icon: leaf/* IconLeaf */.y,
                size: badge.BadgeSize.SMALL,
                text: t("product", "shipping.sustainable")
            }), /*#__PURE__*/ react.createElement(ItemTitle, null, !isInstorePickup(node) && /*#__PURE__*/ react.createElement(variants.TitleSmallText, {
                flex: false
            }, getTranslatedShipping(t, deliveryDays))), /*#__PURE__*/ react.createElement(variants.BodySmallText, null, getDeliveryInfo(node))), /*#__PURE__*/ react.createElement(variants.TitleSmallText, {
                flex: false
            }, /*#__PURE__*/ react.createElement(currency/* Currency */.F, {
                price: node === null || node === void 0 ? void 0 : node.shippingCost
            })));
        });
    };
    var hasSustainableDeliveryOptions = Boolean((ref1 = offer.shipping) === null || ref1 === void 0 ? void 0 : ref1.nodes.find(function(node) {
        return node.sustainability === price_list_types/* SustainabilityEnum.SUSTAINABLE */.$z.SUSTAINABLE;
    }));
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(variants.H4Text, null, t("store", "store.delivery-options")), hasSustainableDeliveryOptions && /*#__PURE__*/ react.createElement(StyledSustainableDescription, null, /*#__PURE__*/ react.createElement(StyledBadge, {
        color: "GREEN",
        icon: leaf/* IconLeaf */.y,
        size: badge.BadgeSize.SMALL,
        text: t("product", "shipping.sustainable")
    }), /*#__PURE__*/ react.createElement(styles_StyledCaptionText, {
        emphasis: variants.FontEmphasis.MEDIUM
    }, t("product", "shipping.sustainable-description"))), /*#__PURE__*/ react.createElement(ShippingOptionList, null, renderShippingOptions()));
};

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/store-info/delivery-options/index.tsx



;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/store-info/recommended-retailer/styles.ts
function recommended_retailer_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function recommended_retailer_styles_templateObject() {
    var data = recommended_retailer_styles_taggedTemplateLiteral([
        "\n    color: ",
        ";\n    display: inline-flex;\n    flex-direction: column;\n    margin-bottom: ",
        ";\n  "
    ]);
    recommended_retailer_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function recommended_retailer_styles_templateObject1() {
    var data = recommended_retailer_styles_taggedTemplateLiteral([
        "\n  align-self: flex-start;\n"
    ]);
    recommended_retailer_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function recommended_retailer_styles_templateObject2() {
    var data = recommended_retailer_styles_taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n  width: ",
        "px;\n  height: ",
        "px;\n"
    ]);
    recommended_retailer_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function recommended_retailer_styles_templateObject3() {
    var data = recommended_retailer_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  column-gap: ",
        ";\n  margin-left: -",
        ";\n"
    ]);
    recommended_retailer_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function recommended_retailer_styles_templateObject4() {
    var data = recommended_retailer_styles_taggedTemplateLiteral([
        "\n  margin: 0;\n"
    ]);
    recommended_retailer_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function recommended_retailer_styles_templateObject5() {
    var data = recommended_retailer_styles_taggedTemplateLiteral([
        "\n  margin: ",
        " 0;\n"
    ]);
    recommended_retailer_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var BRAND_LOGO_WIDTH = 88;
var BRAND_LOGO_HEIGHT = 31;
var RecommendedRetailerExpansion = styled_components_browser_esm["default"].div.withConfig({
    displayName: "RecommendedRetailerExpansion",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(recommended_retailer_styles_templateObject(), props.theme.text.secondary, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
});
var LogoWrapper = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "LogoWrapper",
    componentId: "sc-0-1"
})(recommended_retailer_styles_templateObject1());
var Logo = styled_components_browser_esm["default"].img.withConfig({
    displayName: "Logo",
    componentId: "sc-0-2"
})(recommended_retailer_styles_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, BRAND_LOGO_WIDTH, BRAND_LOGO_HEIGHT);
var IconAndTextWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "IconAndTextWrapper",
    componentId: "sc-0-3"
})(recommended_retailer_styles_templateObject3(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var Text = styled_components_browser_esm["default"].p.withConfig({
    displayName: "Text",
    componentId: "sc-0-4"
})(recommended_retailer_styles_templateObject4());
var styles_AuthorizedDealerBadge = (0,styled_components_browser_esm["default"])(badge.Badge).withConfig({
    displayName: "AuthorizedDealerBadge",
    componentId: "sc-0-5"
})(recommended_retailer_styles_templateObject5(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/store-info/recommended-retailer/index.tsx





var RecommendedRetailer = /*#__PURE__*/ (0,react.memo)(function(props) {
    var storeName = props.storeName, brandName = props.brandName, logo = props.logo, pathName = props.pathName, id = props.id;
    var ref = (0,app_context/* useAppContext */.bp)(), linkTo = ref.linkTo, t = ref.t;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, logo && /*#__PURE__*/ react.createElement(LogoWrapper, {
        to: linkTo("brand", {
            pathName: pathName,
            id: id
        })
    }, /*#__PURE__*/ react.createElement(Logo, {
        src: logo,
        alt: brandName
    })), /*#__PURE__*/ react.createElement(styles_AuthorizedDealerBadge, {
        text: /*#__PURE__*/ react.createElement(variants.BodySmallText, {
            weight: 600,
            style: {
                fontSize: 12
            }
        }, t("store", "store.recommended-retailer-brand", {
            brand: brandName,
            store: storeName
        })),
        icon: verified/* IconVerfied */.b,
        color: "BLUE"
    }));
});

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/store-info/store-info-list/styles.ts
function store_info_list_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function store_info_list_styles_templateObject() {
    var data = store_info_list_styles_taggedTemplateLiteral([
        "\n  list-style-position: inside;\n  margin-bottom: ",
        ";\n"
    ]);
    store_info_list_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function store_info_list_styles_templateObject1() {
    var data = store_info_list_styles_taggedTemplateLiteral([
        "\n    color: ",
        ";\n  "
    ]);
    store_info_list_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var StyledStoreInfoList = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "StyledStoreInfoList",
    componentId: "sc-0-0"
})(store_info_list_styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledStoreInfoText = styled_components_browser_esm["default"].li.withConfig({
    displayName: "StyledStoreInfoText",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(store_info_list_styles_templateObject1(), props.theme.text.secondary);
});

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/store-info/store-info-list/index.tsx


var StoreInfoList = /*#__PURE__*/ react.memo(function(param) {
    var storeInfo = param.storeInfo;
    return storeInfo && storeInfo.length && storeInfo.filter(function(item) {
        return item;
    }).length ? /*#__PURE__*/ react.createElement(StyledStoreInfoList, null, storeInfo.map(function(value, index) {
        return /*#__PURE__*/ react.createElement(StyledStoreInfoText, {
            // eslint-disable-next-line react/no-array-index-key
            key: "store-info-".concat(index)
        }, /*#__PURE__*/ react.createElement("span", null, value));
    })) : null;
}, function(param, param1) {
    var prevStoreInfo = param.storeInfo, nextStoreInfo = param1.storeInfo;
    if (!prevStoreInfo && !nextStoreInfo) {
        return true;
    }
    if (!prevStoreInfo && nextStoreInfo || prevStoreInfo && !nextStoreInfo || (prevStoreInfo === null || prevStoreInfo === void 0 ? void 0 : prevStoreInfo.length) !== (nextStoreInfo === null || nextStoreInfo === void 0 ? void 0 : nextStoreInfo.length)) {
        return false;
    }
    if (prevStoreInfo && nextStoreInfo) {
        return prevStoreInfo.every(function(value, i) {
            return value === nextStoreInfo[i];
        });
    }
    return false;
});

// EXTERNAL MODULE: ./src/globals/helpers/format-number.ts
var format_number = __webpack_require__(24847);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/store-info/store-reviews/styles.ts
function store_reviews_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function store_reviews_styles_templateObject() {
    var data = store_reviews_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  margin-bottom: ",
        ";\n"
    ]);
    store_reviews_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function store_reviews_styles_templateObject1() {
    var data = store_reviews_styles_taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n  :hover {\n    color: ",
        ";\n  }\n"
    ]);
    store_reviews_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function store_reviews_styles_templateObject2() {
    var data = store_reviews_styles_taggedTemplateLiteral([
        "\n  margin: 0 ",
        ";\n"
    ]);
    store_reviews_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var StyledStoreReviews = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledStoreReviews",
    componentId: "sc-0-0"
})(store_reviews_styles_templateObject(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var StyledStoreLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "StyledStoreLink",
    componentId: "sc-0-1"
})(store_reviews_styles_templateObject1(), base/* layout.measurements.fontSizeNormal */.bK.measurements.fontSizeNormal, ui_text.FontWeight.HEAVIER, function(p) {
    return p.theme.text.callToAction;
}, function(p) {
    return p.theme.text.callToActionHover;
});
var StyledSeparator = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledSeparator",
    componentId: "sc-0-2"
})(store_reviews_styles_templateObject2(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025);

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/store-info/store-reviews/index.tsx







var StoreReviews = function(props) {
    var reviewCount = props.reviewCount, storeLink = props.storeLink;
    var offer = (0,price_row_context/* usePriceRowContext */.m)().offer;
    var featured = offer.featured, rating = offer.rating;
    var ref = (0,app_context/* useAppContext */.bp)(), market = ref.market, t = ref.t;
    return /*#__PURE__*/ react.createElement(StyledStoreReviews, null, rating && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(smiley_rating/* default */.Z, {
        featured: featured,
        rating: rating,
        scoreVisibility: "row"
    }), /*#__PURE__*/ react.createElement(StyledSeparator, null, "|")), /*#__PURE__*/ react.createElement(StyledStoreLink, {
        to: storeLink,
        "aria-label": t("reviews", "rating.n-reviews", {
            n: reviewCount,
            count: (0,format_number/* default */.Z)(reviewCount, market.code)
        }),
        "data-test": "StoreInfoLink",
        tabIndex: 0,
        onClick: function() {
            return (0,tracking/* trackInternalNavigationClick */.p)({
                scope: tracking/* InternalNavigationScope.STORE_REVIEW */.U.STORE_REVIEW,
                nextPage: storeLink
            });
        }
    }, t("reviews", "rating.n-reviews", {
        n: reviewCount,
        count: (0,format_number/* default */.Z)(reviewCount, market.code)
    })));
};

// EXTERNAL MODULE: ./src/client/data-layer.ts
var data_layer = __webpack_require__(80695);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/store-info/membership-info/tracking.ts

var trackMembershipReadMoreClicked = function(name, externalUrl, productId) {
    (0,data_layer/* pushEvent */.A)("membershipReadMoreClicked", {
        name: name,
        externalUrl: externalUrl,
        productId: productId
    });
};

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/store-info/membership-info/styles.ts
function membership_info_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function membership_info_styles_templateObject() {
    var data = membership_info_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n\n  svg {\n    margin-left: ",
        ";\n\n    > path {\n      fill: ",
        ";\n    }\n\n    :hover {\n      color: ",
        ";\n\n      svg > path {\n        fill: ",
        ";\n      }\n    }\n  }\n"
    ]);
    membership_info_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function membership_info_styles_templateObject1() {
    var data = membership_info_styles_taggedTemplateLiteral([
        "\n    color: ",
        ";\n    margin-right: ",
        ";\n  "
    ]);
    membership_info_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function membership_info_styles_templateObject2() {
    var data = membership_info_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    membership_info_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var MembershipLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "MembershipLink",
    componentId: "sc-0-0"
})(membership_info_styles_templateObject(), base/* layout.measurements.fontSizeNormal */.bK.measurements.fontSizeNormal, variants.FontWeight.HEAVIER, function(p) {
    return p.theme.text.callToAction;
}, base/* layout.measurements.spacing025 */.bK.measurements.spacing025, function(p) {
    return p.theme.text.callToAction;
}, function(p) {
    return p.theme.text.callToActionHover;
}, function(p) {
    return p.theme.text.callToActionHover;
});
var MembershipInfoText = styled_components_browser_esm["default"].span.withConfig({
    displayName: "MembershipInfoText",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(membership_info_styles_templateObject1(), props.theme.text.secondary, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
});
var InfoLinkWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "InfoLinkWrapper",
    componentId: "sc-0-2"
})(membership_info_styles_templateObject2());

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/outgoing-link/index.js
var outgoing_link = __webpack_require__(43709);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/store-info/membership-info/index.tsx







var MembershipInfo = function() {
    var ref, ref1, ref2, ref3;
    var ref4 = (0,price_row_context/* usePriceRowContext */.m)(), offer = ref4.offer, product = ref4.product;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var hasMemberPriceOffer = ((ref = offer.offerPrices) === null || ref === void 0 ? void 0 : ref.memberPrice) || ((ref1 = offer.alternativePrices) === null || ref1 === void 0 ? void 0 : ref1.map(function(alt) {
        var ref;
        return alt === null || alt === void 0 ? void 0 : (ref = alt.offerPrices) === null || ref === void 0 ? void 0 : ref.memberPrice;
    }).some(function(isTrue) {
        return isTrue;
    }));
    if (!hasMemberPriceOffer) {
        return null;
    }
    var isFree = !((ref2 = offer.membershipProgram) === null || ref2 === void 0 ? void 0 : ref2.requiresCompensation);
    var name = ((ref3 = offer.membershipProgram) === null || ref3 === void 0 ? void 0 : ref3.name) || t("product", "promotions.membership");
    var readMore = t("product", "transparency.read-more");
    var membershipText = isFree ? t("product", "promotions.membership-name-price-info-free", {
        name: name
    }) : t("product", "promotions.membership-name-price-info", {
        name: name
    });
    return /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(variants.H4Text, null, t("product", "promotions.membership")), /*#__PURE__*/ react.createElement(InfoLinkWrapper, null, /*#__PURE__*/ react.createElement(MembershipInfoText, null, membershipText), offer.membershipLink && /*#__PURE__*/ react.createElement(MembershipLink, {
        to: {
            pathname: offer.membershipLink
        },
        target: "_blank",
        "aria-label": readMore,
        "data-test": "MembershipLink",
        tabIndex: 0,
        onClick: function() {
            var ref;
            return trackMembershipReadMoreClicked(((ref = offer.membershipProgram) === null || ref === void 0 ? void 0 : ref.name) || "", offer.membershipLink || "", product.id);
        }
    }, readMore, /*#__PURE__*/ react.createElement(outgoing_link/* IconOutgoingLink */.v, null))));
};

// EXTERNAL MODULE: ./src/components/location-and-currency-info/index.tsx + 1 modules
var location_and_currency_info = __webpack_require__(59106);
// EXTERNAL MODULE: ./src/areas/store/components/soty-badge-link/soty-badge/index.tsx + 1 modules
var soty_badge = __webpack_require__(30163);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/store-info/styles.ts
function store_info_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function store_info_styles_templateObject() {
    var data = store_info_styles_taggedTemplateLiteral([
        "\n  padding: ",
        ";\n"
    ]);
    store_info_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function store_info_styles_templateObject1() {
    var data = store_info_styles_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: 1fr auto;\n"
    ]);
    store_info_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function store_info_styles_templateObject2() {
    var data = store_info_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  margin-bottom: ",
        ";\n  > svg > path {\n    fill: currentColor;\n  }\n"
    ]);
    store_info_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function store_info_styles_templateObject3() {
    var data = store_info_styles_taggedTemplateLiteral([
        "\n  grid-area: 2 / 1 / 3 / 3;\n  display: flex;\n  flex-direction: column;\n  > h4,\n  > div > h4 {\n    margin-top: ",
        ";\n  }\n"
    ]);
    store_info_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function store_info_styles_templateObject4() {
    var data = store_info_styles_taggedTemplateLiteral([
        "\n  align-items: baseline;\n"
    ]);
    store_info_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function store_info_styles_templateObject5() {
    var data = store_info_styles_taggedTemplateLiteral([
        "\n      max-width: 88px;\n    "
    ]);
    store_info_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function store_info_styles_templateObject6() {
    var data = store_info_styles_taggedTemplateLiteral([
        "\n  margin: ",
        ";\n  align-items: normal;\n\n  ",
        "\n"
    ]);
    store_info_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}






var StyledExpandedInfo = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledExpandedInfo",
    componentId: "sc-0-0"
})(store_info_styles_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var StyledFirstSection = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledFirstSection",
    componentId: "sc-0-1"
})(store_info_styles_templateObject1());
var styles_StyledStoreLink = (0,styled_components_browser_esm["default"])(variants.H4Text).withConfig({
    displayName: "StyledStoreLink",
    componentId: "sc-0-2"
})(store_info_styles_templateObject2(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var StyledGeneralInfo = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledGeneralInfo",
    componentId: "sc-0-3"
})(store_info_styles_templateObject3(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var StyledLocationAndCurrencyInfo = (0,styled_components_browser_esm["default"])(location_and_currency_info/* default */.Z).withConfig({
    displayName: "StyledLocationAndCurrencyInfo",
    componentId: "sc-0-4"
})(store_info_styles_templateObject4());
var StyledSotyBadge = (0,styled_components_browser_esm["default"])(soty_badge/* SotyBadge */.L).withConfig({
    displayName: "StyledSotyBadge",
    componentId: "sc-0-5"
})(store_info_styles_templateObject6(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, function(props) {
    return props.$viewSize === types/* ViewSize.SMALL */.du.SMALL && (0,styled_components_browser_esm.css)(store_info_styles_templateObject5());
});

// EXTERNAL MODULE: ./src/areas/product/components/product-header/components/our-choice/styles.ts
var our_choice_styles = __webpack_require__(7235);
;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/our-choice/info-text.tsx




var OurChoiceInfoText = function() {
    var ref;
    var ref1 = (0,app_context/* useAppContext */.bp)(), t = ref1.t, market = ref1.market;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(variants.H4Text, null, t("product", "prices.our-choice")), /*#__PURE__*/ react.createElement("p", null, /*#__PURE__*/ react.createElement(variants.BodySmallText, null, t("product", "prices.our-choice-explanation")), " ", /*#__PURE__*/ react.createElement(our_choice_styles/* StyleUnderlinedInfoPageLink */.BR, {
        id: (ref = market.infoPageMap) === null || ref === void 0 ? void 0 : ref.priceInformation
    }, t("common", "button.read-more"))));
};

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/store-info/index.tsx














var store_info_StoreInfo = function(props) {
    var ref;
    var sotyBadge = props.sotyBadge;
    var ref1 = (0,price_row_context/* usePriceRowContext */.m)(), offer = ref1.offer, product = ref1.product, viewSize = ref1.viewSize, isOurChoice = ref1.isOurChoice;
    var authorizedDealer = offer.authorizedDealer, priceId = offer.priceId, store = offer.store, storeInfo = offer.storeInfo;
    var t = (0,app_context/* useAppContext */.bp)().t;
    if (!store) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(StyledExpandedInfo, null, /*#__PURE__*/ react.createElement(StyledFirstSection, null, /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(styles_StyledStoreLink, {
        container: react_router_dom/* Link */.rU,
        containerProps: {
            to: store.pathName,
            title: store.name,
            "data-test": "StoreInfoLink",
            "aria-label": t("product", "store-info.more-about-store", {
                store_name: store.name
            }),
            tabIndex: 0,
            onClick: function() {
                return (0,tracking/* trackInternalNavigationClick */.p)({
                    scope: tracking/* InternalNavigationScope.STORE_GO_TO */.U.STORE_GO_TO,
                    nextPage: store.pathName
                });
            }
        }
    }, store.name, /*#__PURE__*/ react.createElement(chevron_right.IconChevronRight, null)), store.userReviewSummary.countTotal && store.userReviewSummary.countTotal > 0 ? /*#__PURE__*/ react.createElement(StoreReviews, {
        reviewCount: store.userReviewSummary.countTotal,
        storeLink: store.pathName
    }) : null, /*#__PURE__*/ react.createElement(StoreInfoList, {
        storeInfo: storeInfo
    })), (sotyBadge === null || sotyBadge === void 0 ? void 0 : sotyBadge.logo) ? /*#__PURE__*/ react.createElement(StyledSotyBadge, {
        imgUrl: sotyBadge.logo,
        name: sotyBadge.name,
        year: (ref = sotyBadge.year) === null || ref === void 0 ? void 0 : ref.toString(),
        $viewSize: viewSize
    }) : null), /*#__PURE__*/ react.createElement(StyledGeneralInfo, null, /*#__PURE__*/ react.createElement(StyledLocationAndCurrencyInfo, {
        countryCode: store.countryCode,
        countryName: store.countryName,
        currency: store.currency,
        marketplace: Boolean(store.marketplace),
        id: priceId || store.id.toString(),
        storeName: store.name,
        minify: true,
        textSize: "small"
    }), isOurChoice && /*#__PURE__*/ react.createElement(OurChoiceInfoText, null), authorizedDealer && product.brand && offer.store && /*#__PURE__*/ react.createElement(RecommendedRetailer, {
        id: product.brand.id,
        pathName: product.brand.pathName,
        logo: product.brand.logo,
        brandName: product.brand.name,
        storeName: offer.store.name
    }), /*#__PURE__*/ react.createElement(MembershipInfo, null), /*#__PURE__*/ react.createElement(OfferPaymentProviders, {
        store: store,
        showAll: true
    }), /*#__PURE__*/ react.createElement(DeliveryOptions, {
        offer: offer
    })));
};

// EXTERNAL MODULE: ./src/areas/product/styles.tsx
var product_styles = __webpack_require__(68798);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/info-modal/index.tsx
function info_modal_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function info_modal_templateObject() {
    var data = info_modal_taggedTemplateLiteral([
        "\n  && {\n    overflow-y: scroll;\n    max-height: 90vh;\n  }\n"
    ]);
    info_modal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function info_modal_templateObject1() {
    var data = info_modal_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  row-gap: ",
        ";\n"
    ]);
    info_modal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function info_modal_templateObject2() {
    var data = info_modal_taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    info_modal_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}










var InfoModal = function(props) {
    var offer = (0,price_row_context/* usePriceRowContext */.m)().offer;
    var alternativePrices = props.alternativePrices, closeModal = props.closeModal, closeReportOverlay = props.closeReportOverlay, isOpen = props.isOpen, priceRowReport = props.priceRowReport, reportRowId = props.reportRowId, sotyBadge = props.sotyBadge, tableLinkProps = props.tableLinkProps;
    return /*#__PURE__*/ react.createElement(StyledModal, {
        isOpen: isOpen,
        onRequestClose: closeModal,
        shouldShowCloseIcon: true,
        width: 526
    }, /*#__PURE__*/ react.createElement(StyledContainer, null, /*#__PURE__*/ react.createElement(store_info_StoreInfo, {
        sotyBadge: sotyBadge
    }), alternativePrices && offer.featured ? /*#__PURE__*/ react.createElement("div", null, alternativePrices.map(function(altPrice) {
        if (!altPrice) return null;
        return /*#__PURE__*/ react.createElement(AlternativePriceRowContextContainer, {
            alternativeOffer: altPrice,
            key: altPrice.id || "alternative-price-row"
        }, /*#__PURE__*/ react.createElement(AlternativePriceRowWrapper, null, /*#__PURE__*/ react.createElement(AlternativePriceRow, {
            tableLinkProps: tableLinkProps(altPrice)
        }), priceRowReport === types/* ReportRowType.ALTERNATIVE */.Zu.ALTERNATIVE && reportRowId === altPrice.id && /*#__PURE__*/ react.createElement(report_button/* ReportButton */.f, {
            priceId: altPrice.id,
            priceValue: altPrice.price && altPrice.price.exclShipping,
            stockStatus: altPrice.stock && altPrice.stock.status,
            onClose: closeReportOverlay,
            productName: altPrice.name,
            isAlternative: true
        })));
    })) : null));
};
var StyledModal = (0,styled_components_browser_esm["default"])(product_styles/* Modal */.u_).withConfig({
    displayName: "StyledModal",
    componentId: "sc-0-0"
})(info_modal_templateObject());
var StyledContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledContainer",
    componentId: "sc-0-1"
})(info_modal_templateObject1(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var AlternativePriceRowWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AlternativePriceRowWrapper",
    componentId: "sc-0-2"
})(info_modal_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

// EXTERNAL MODULE: ./src/globals/api/requests.js
var requests = __webpack_require__(11124);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/requests.ts

var fetchSotyAwardsByStoreId = function(id) {
    return (0,requests/* graphql */.BX)("\n      query storePage($id: Int!) {\n        store(id: $id) {\n          id\n          name\n          storeOfTheYearAwards {\n            id\n            name\n            resourceName\n            logo\n            year\n            mainAward\n            isSpecial\n            isPrimary\n          }\n        }\n      }\n    ", {
        id: id
    });
};

// EXTERNAL MODULE: ./src/components/viewport/context.tsx
var context = __webpack_require__(84198);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/modal/index.js
var modal = __webpack_require__(58709);
// EXTERNAL MODULE: ./src/components/modal-v2/index.tsx
var modal_v2 = __webpack_require__(54674);
// EXTERNAL MODULE: ./src/components/cdn-image/index.tsx
var cdn_image = __webpack_require__(23437);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 24 modules
var es = __webpack_require__(95939);
// EXTERNAL MODULE: ./src/components/product-card-old/components/new-click-out-button.tsx
var new_click_out_button = __webpack_require__(93256);
// EXTERNAL MODULE: ./src/utils/click-out-bounce-helper.ts
var click_out_bounce_helper = __webpack_require__(9690);
// EXTERNAL MODULE: ./src/areas/product/actions/product.ts + 1 modules
var actions_product = __webpack_require__(36483);
// EXTERNAL MODULE: ./src/globals/tracking/conversion.ts + 1 modules
var conversion = __webpack_require__(56290);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/promotion-bar/promotion-modal/tracking.ts




var handlePromotionModalClickout = function(offer, product, showUsedOffers, dispatch) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    if (!offer.priceId || !offer.externalUri) return;
    var _condition;
    var dispatchParams = (0,actions_product/* productPriceClick */.Po)(product.id, offer, true, "", false, "PromotionModal", (ref = offer.stock) === null || ref === void 0 ? void 0 : ref.status, (_condition = offer.condition) !== null && _condition !== void 0 ? _condition : product_condition_types/* ConditionEnum.NEW */.M.NEW);
    dispatch(dispatchParams);
    var condition = showUsedOffers && offer.condition ? offer.condition : undefined;
    var isInternational = ((ref1 = offer.store) === null || ref1 === void 0 ? void 0 : ref1.market) === "secondary";
    var isPjDeal = ((ref2 = product.dealInfo) === null || ref2 === void 0 ? void 0 : ref2.dealPercentage) ? true : undefined;
    var stockStatus = (0,conversion/* mapStockStatusToGTMStockStatus */._L)((ref3 = offer.stock) === null || ref3 === void 0 ? void 0 : ref3.status);
    var priceType = "regular";
    if ((ref4 = offer.offerPrices) === null || ref4 === void 0 ? void 0 : ref4.memberPrice) {
        priceType = "member";
    } else if ((ref5 = offer.offerPrices) === null || ref5 === void 0 ? void 0 : ref5.originalPrice) {
        priceType = "sale";
    }
    (0,conversion/* trackOfferClickWithRevenue */.Rx)({
        scope: conversion/* TrackClickScope.PROMOTION_MODAL */.b8.PROMOTION_MODAL,
        priceId: offer.priceId,
        condition: condition,
        hasShippingInfo: ((ref6 = offer.shipping) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.nodes) === null || ref7 === void 0 ? void 0 : ref7.length) ? true : undefined,
        isInternational: isInternational ? true : undefined,
        isPartOfPromotion: true,
        isPjDeal: isPjDeal,
        priceType: priceType,
        stockStatus: stockStatus
    });
};
var trackInternalPromotionLinkClick = function(url) {
    var trackingData = {
        scope: tracking/* InternalNavigationScope.PROMOTION_MODAL */.U.PROMOTION_MODAL,
        nextPage: url
    };
    (0,tracking/* trackInternalNavigationClick */.p)(trackingData);
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/index.js
var design_tokens = __webpack_require__(43220);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/promotion-bar/promotion-modal/styles.ts
function promotion_modal_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function promotion_modal_styles_templateObject() {
    var data = promotion_modal_styles_taggedTemplateLiteral([
        "\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n  "
    ]);
    promotion_modal_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function promotion_modal_styles_templateObject1() {
    var data = promotion_modal_styles_taggedTemplateLiteral([
        "\n  padding: 0;\n\n  ",
        "\n"
    ]);
    promotion_modal_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function promotion_modal_styles_templateObject2() {
    var data = promotion_modal_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  padding: ",
        ";\n  gap: ",
        ";\n"
    ]);
    promotion_modal_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function promotion_modal_styles_templateObject3() {
    var data = promotion_modal_styles_taggedTemplateLiteral([
        "height: ",
        "px;"
    ]);
    promotion_modal_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function promotion_modal_styles_templateObject4() {
    var data = promotion_modal_styles_taggedTemplateLiteral([
        "height: ",
        "px;"
    ]);
    promotion_modal_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function promotion_modal_styles_templateObject5() {
    var data = promotion_modal_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.2);\n\n  ",
        "\n  ",
        "\n"
    ]);
    promotion_modal_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function promotion_modal_styles_templateObject6() {
    var data = promotion_modal_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: ",
        ";\n  left: ",
        ";\n  background: ",
        ";\n  padding: ",
        ";\n  border-radius: 8px;\n  box-shadow: 0px 2px 4px 0px rgba(5, 37, 46, 0.24);\n"
    ]);
    promotion_modal_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = promotion_modal_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: ",
        ";\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = promotion_modal_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  text-align: center;\n"
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = promotion_modal_styles_taggedTemplateLiteral([
        "\n  text-overflow: ellipsis;\n  /* stylelint-disable value-no-vendor-prefix  */\n  display: -webkit-box;\n  /* stylelint-disable property-no-vendor-prefix */\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  overflow: hidden;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = promotion_modal_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  line-height: 20px;\n  gap: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = promotion_modal_styles_taggedTemplateLiteral([
        "\n    border-top-left-radius: 5px;\n    border-bottom-left-radius: 5px;\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = promotion_modal_styles_taggedTemplateLiteral([
        "\n  object-fit: cover;\n\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = promotion_modal_styles_taggedTemplateLiteral([
        "max-height: ",
        "px;"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = promotion_modal_styles_taggedTemplateLiteral([
        "max-height: ",
        "px;"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = promotion_modal_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = promotion_modal_styles_taggedTemplateLiteral([
        "\n    flex-direction: column;\n    gap: ",
        ";\n  "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = promotion_modal_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = promotion_modal_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}







var IMAGE_HEIGHT_MOBILE = 200;
var IMAGE_HEIGHT_TABLET = 500;
var StyledModalBody = (0,styled_components_browser_esm["default"])(modal/* ModalBody */.fe).withConfig({
    displayName: "StyledModalBody",
    componentId: "sc-0-0"
})(promotion_modal_styles_templateObject1(), base/* media.largeUp */.BC.largeUp(promotion_modal_styles_templateObject()));
var StyledContent = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledContent",
    componentId: "sc-0-1"
})(promotion_modal_styles_templateObject2(), design_tokens.measurements.spacing100, design_tokens.measurements.spacing100);
var StyledPlaceholderImg = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledPlaceholderImg",
    componentId: "sc-0-2"
})(promotion_modal_styles_templateObject5(), base/* media.smallOnly */.BC.smallOnly(promotion_modal_styles_templateObject3(), IMAGE_HEIGHT_MOBILE), base/* media.mediumOnly */.BC.mediumOnly(promotion_modal_styles_templateObject4(), IMAGE_HEIGHT_TABLET));
var StyledLogoImg = (0,styled_components_browser_esm["default"])(cdn_image/* CdnImage */.l).withConfig({
    displayName: "StyledLogoImg",
    componentId: "sc-0-3"
})(promotion_modal_styles_templateObject6(), design_tokens.measurements.spacing100, design_tokens.measurements.spacing100, function(p) {
    return p.theme.colors.base0;
}, design_tokens.measurements.spacing050);
var StyledButtonWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledButtonWrapper",
    componentId: "sc-0-4"
})(styles_templateObject7(), design_tokens.measurements.spacing050);
var StyledOutlinedButton = (0,styled_components_browser_esm["default"])(button_variants.OutlinedButton).withConfig({
    displayName: "StyledOutlinedButton",
    componentId: "sc-0-5"
})(styles_templateObject8());
var StyledDescription = (0,styled_components_browser_esm["default"])(variants.BodySmallText).withConfig({
    displayName: "StyledDescription",
    componentId: "sc-0-6"
})(_templateObject9());
var StyledIconWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledIconWrapper",
    componentId: "sc-0-7"
})(_templateObject10(), design_tokens.measurements.spacing050);
var StyledPromotionImg = styled_components_browser_esm["default"].img.withConfig({
    displayName: "StyledPromotionImg",
    componentId: "sc-0-8"
})(_templateObject12(), base/* media.largeUp */.BC.largeUp(_templateObject11()));
var StyledImgWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledImgWrapper",
    componentId: "sc-0-9"
})(_templateObject15(), base/* media.smallOnly */.BC.smallOnly(_templateObject13(), IMAGE_HEIGHT_MOBILE), base/* media.mediumOnly */.BC.mediumOnly(_templateObject14(), IMAGE_HEIGHT_TABLET));
var StyledDetails = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledDetails",
    componentId: "sc-0-10"
})(_templateObject17(), design_tokens.measurements.spacing100, base/* media.mediumUp */.BC.mediumUp(_templateObject16(), design_tokens.measurements.spacing025));
var StyledFooterWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledFooterWrapper",
    componentId: "sc-0-11"
})(_templateObject18(), design_tokens.measurements.spacing050);

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/promotion-bar/promotion-modal/promotion-buttons.tsx










var PromotionButtons = function() {
    var ref = (0,app_context/* useAppContext */.bp)(), linkTo = ref.linkTo, t = ref.t;
    var ref1 = (0,price_row_context/* usePriceRowContext */.m)(), offer = ref1.offer, product = ref1.product, showUsedOffers = ref1.showUsedOffers;
    var externalUri = offer.externalUri, promotion = offer.promotion;
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleClickOut = function() {
        handlePromotionModalClickout(offer, product, showUsedOffers, dispatch);
        (0,click_out_bounce_helper/* handleClickOutBounce */.y)(handleBounce);
    };
    var handleBounce = function() {
        var ref;
        dispatch((0,actions_product/* productClickOutBounce */.nA)({
            productId: product.id,
            priceId: offer.priceId,
            storeName: (ref = offer.store) === null || ref === void 0 ? void 0 : ref.name
        }));
    };
    if (!promotion) return null;
    var linkToPromotionPage = linkTo("promotions", promotion);
    return /*#__PURE__*/ react.createElement(react.Fragment, null, externalUri && /*#__PURE__*/ react.createElement(StyledButtonWrapper, null, /*#__PURE__*/ react.createElement(new_click_out_button/* NewClickOutButton */.I, {
        onClick: handleClickOut,
        external: true,
        href: externalUri,
        text: t("product", "external-link.view-product")
    })), /*#__PURE__*/ react.createElement(StyledOutlinedButton, {
        container: clickable/* Clickable */.P,
        containerProps: {
            to: linkToPromotionPage
        },
        onClick: function() {
            return trackInternalPromotionLinkClick(linkToPromotionPage);
        }
    }, t("product", "promotion.to-campaign")));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/schedule/index.js
var schedule = __webpack_require__(73090);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/inventory/index.js
var inventory = __webpack_require__(78287);
// EXTERNAL MODULE: ./src/globals/helpers/format-date.ts
var format_date = __webpack_require__(52998);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/promotion-bar/promotion-modal/promotion-info.tsx










var PromotionInfo = function() {
    var ref = (0,app_context/* useAppContext */.bp)(), market = ref.market, t = ref.t;
    var isDesktop = (0,context/* useViewportContext */.Ak)().isDesktop;
    var offer = (0,price_row_context/* usePriceRowContext */.m)().offer;
    var promotion = offer.promotion;
    if (!promotion) return null;
    var dateFormatOptions = {
        day: "numeric",
        month: "short"
    };
    var startDate = promotion.startDate && (0,format_date/* formatDate */.p)(promotion.startDate, market.localeStandard, dateFormatOptions);
    var endDate = promotion.endDate && (0,format_date/* formatDate */.p)(promotion.endDate, market.localeStandard, dateFormatOptions);
    return /*#__PURE__*/ react.createElement(StyledContent, null, /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(variants.BodySmallText, null, t("product", "promotion.from-shop", {
        shop: promotion.owner.name
    })), /*#__PURE__*/ react.createElement(variants.H2Text, null, promotion.title), /*#__PURE__*/ react.createElement(StyledDetails, null, startDate && endDate && /*#__PURE__*/ react.createElement(StyledIconWrapper, null, /*#__PURE__*/ react.createElement(schedule/* IconSchedule */.c, {
        size: 16
    }), /*#__PURE__*/ react.createElement(variants.CaptionText, {
        emphasis: variants.FontEmphasis.HIGH
    }, t("product", "promotions.valid-timespan", {
        startDate: startDate,
        endDate: endDate
    }))), promotion.numberOfProducts && /*#__PURE__*/ react.createElement(StyledIconWrapper, null, /*#__PURE__*/ react.createElement(inventory/* IconInventory */.h, {
        size: 16
    }), /*#__PURE__*/ react.createElement(variants.CaptionText, {
        emphasis: variants.FontEmphasis.HIGH
    }, t("campaigns", "deals.n-products-subtitle", {
        n: promotion.numberOfProducts
    }))))), /*#__PURE__*/ react.createElement(StyledDescription, null, promotion === null || promotion === void 0 ? void 0 : promotion.description), isDesktop ? /*#__PURE__*/ react.createElement(PromotionButtons, null) : null, /*#__PURE__*/ react.createElement(variants.CaptionText, {
        emphasis: variants.FontEmphasis.MEDIUM
    }, t("product", "promotion.paying-shop", {
        shop: promotion.owner.name
    })));
};

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/promotion-bar/promotion-modal/index.tsx










var PromotionModal = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose;
    var isDesktop = (0,context/* useViewportContext */.Ak)().isDesktop;
    var offer = (0,price_row_context/* usePriceRowContext */.m)().offer;
    var promotion = offer.promotion;
    if (!promotion) return null;
    return /*#__PURE__*/ react.createElement(modal_v2/* default */.Z, {
        isOpen: isOpen,
        onRequestClose: onClose,
        style: isDesktop ? {
            content: {
                maxWidth: "800px"
            }
        } : undefined
    }, /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(StyledModalBody, null, (promotion === null || promotion === void 0 ? void 0 : promotion.imageUrl) ? /*#__PURE__*/ react.createElement(StyledImgWrapper, null, /*#__PURE__*/ react.createElement(StyledPromotionImg, {
        src: promotion.imageUrl,
        alt: ""
    })) : /*#__PURE__*/ react.createElement(StyledPlaceholderImg, null, /*#__PURE__*/ react.createElement(cdn_image/* CdnImage */.l, {
        name: promotion.owner.id,
        width: constants/* SHOP_LOGO_WIDTH */.L9,
        alt: promotion.owner.name,
        logoType: promotion.owner.type
    })), /*#__PURE__*/ react.createElement(PromotionInfo, null), /*#__PURE__*/ react.createElement(StyledLogoImg, {
        name: promotion.owner.id,
        width: constants/* SHOP_LOGO_WIDTH_SMALL */.jr,
        alt: promotion.owner.name,
        logoType: promotion.owner.type
    })), isDesktop ? null : /*#__PURE__*/ react.createElement(modal/* ModalFooter */.mz, null, /*#__PURE__*/ react.createElement(StyledFooterWrapper, null, /*#__PURE__*/ react.createElement(PromotionButtons, null)))));
};

;// CONCATENATED MODULE: ./src/globals/tracking/modal.ts

var trackModalOpenEvent = function(data) {
    (0,data_layer/* pushEvent */.A)("modal_open", {
        scope: data.scope,
        type: data.type
    });
};
var TrackModalScope;
(function(TrackModalScope) {
    TrackModalScope["PRICE_LIST"] = "product_price_list";
})(TrackModalScope || (TrackModalScope = {}));
var TrackModalType;
(function(TrackModalType) {
    TrackModalType["PROMOTION"] = "promotion";
})(TrackModalType || (TrackModalType = {}));

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/promotion-bar/styles.ts
function promotion_bar_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function promotion_bar_styles_templateObject() {
    var data = promotion_bar_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: ",
        ";\n  cursor: pointer;\n  background: ",
        ";\n  padding: ",
        " ",
        ";\n  box-shadow: 0 0 0 1px ",
        ";\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n  width: 100%;\n  transition: box-shadow 200ms ease;\n\n  &:hover {\n    box-shadow: 0 2px 10px 0 rgb(0, 0, 0, 0.1);\n  }\n"
    ]);
    promotion_bar_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function promotion_bar_styles_templateObject1() {
    var data = promotion_bar_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  flex: 0 1 auto;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n"
    ]);
    promotion_bar_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var StyledSection = styled_components_browser_esm["default"].button.withConfig({
    displayName: "StyledSection",
    componentId: "sc-0-0"
})(promotion_bar_styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.theme.colors.yellove100;
}, base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, function(p) {
    return p.theme.colors.base200;
});
var StyledText = (0,styled_components_browser_esm["default"])(variants.CaptionStrongText).withConfig({
    displayName: "StyledText",
    componentId: "sc-0-1"
})(promotion_bar_styles_templateObject1(), function(p) {
    return p.theme.colors.base900;
});

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/components/promotion-bar/index.tsx
function promotion_bar_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function promotion_bar_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function promotion_bar_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function promotion_bar_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function promotion_bar_slicedToArray(arr, i) {
    return promotion_bar_arrayWithHoles(arr) || promotion_bar_iterableToArrayLimit(arr, i) || promotion_bar_unsupportedIterableToArray(arr, i) || promotion_bar_nonIterableRest();
}
function promotion_bar_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return promotion_bar_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return promotion_bar_arrayLikeToArray(o, minLen);
}







var PromotionBar = function() {
    var offer = (0,price_row_context/* usePriceRowContext */.m)().offer;
    var ref = promotion_bar_slicedToArray((0,react.useState)(false), 2), modalOpen = ref[0], setModalOpen = ref[1];
    if (!offer.promotion) return null;
    var handleOnClick = function() {
        setModalOpen(true);
        trackModalOpenEvent({
            scope: TrackModalScope.PRICE_LIST,
            type: TrackModalType.PROMOTION
        });
    };
    return /*#__PURE__*/ react.createElement(react.Fragment, null, modalOpen && /*#__PURE__*/ react.createElement(PromotionModal, {
        isOpen: modalOpen,
        onClose: function() {
            return setModalOpen(false);
        }
    }), /*#__PURE__*/ react.createElement(StyledSection, {
        onClick: handleOnClick
    }, /*#__PURE__*/ react.createElement(StyledText, {
        emphasis: ui_text.FontEmphasis.HIGH
    }, offer.promotion.title), /*#__PURE__*/ react.createElement(info_outlined/* IconInfoOutlined */.e, {
        color: "base900",
        size: 16
    })));
};

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/row-types/regular/styles.ts
function regular_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function regular_styles_templateObject() {
    var data = regular_styles_taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n\n  padding: 0.75rem;\n  padding-top: 0;\n\n  > div {\n    box-shadow: rgb(230 232 234) 0px 0px 0px 1px;\n  }\n"
    ]);
    regular_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function regular_styles_templateObject1() {
    var data = regular_styles_taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n"
    ]);
    regular_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function regular_styles_templateObject2() {
    var data = regular_styles_taggedTemplateLiteral([
        "\n      border-bottom-left-radius: 0;\n    "
    ]);
    regular_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function regular_styles_templateObject3() {
    var data = regular_styles_taggedTemplateLiteral([
        "\n    display: flex;\n    align-items: stretch;\n    justify-content: center;\n    width: 40px;\n\n    border-right: 1px solid ",
        ";\n    border-top-left-radius: 8px;\n    border-bottom-left-radius: 8px;\n\n    transition: background-color ",
        ";\n    background-color: transparent;\n\n    &:hover {\n      background-color: ",
        ";\n    }\n\n    ",
        "\n  "
    ]);
    regular_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var StyledAlternativePricesArea = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledAlternativePricesArea",
    componentId: "sc-0-0"
})(regular_styles_templateObject(), function(props) {
    return props.theme.colors.base100;
});
var StyledInfoRow = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledInfoRow",
    componentId: "sc-0-1"
})(regular_styles_templateObject1(), function(props) {
    return props.theme.colors.base100;
});
var StyledExpandButtonWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledExpandButtonWrapper",
    componentId: "sc-0-2"
})(function(props) {
    return (0,styled_components_browser_esm.css)(regular_styles_templateObject3(), props.theme.colors.staticBase200, base/* layout.animations.buttonTransition */.bK.animations.buttonTransition, props.theme.colors.base100, props.$expanded && (0,styled_components_browser_esm.css)(regular_styles_templateObject2()));
});

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/row-types/regular/index.tsx
function regular_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function regular_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function regular_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function regular_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function regular_slicedToArray(arr, i) {
    return regular_arrayWithHoles(arr) || regular_iterableToArrayLimit(arr, i) || regular_unsupportedIterableToArray(arr, i) || regular_nonIterableRest();
}
function regular_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return regular_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return regular_arrayLikeToArray(o, minLen);
}

















var RegularPriceRow = function(props) {
    var onClickOutBounce = props.onClickOutBounce, onPriceClick = props.onPriceClick, className = props.className;
    var ref = regular_slicedToArray((0,react.useState)(false), 2), showDisabledInfo = ref[0], setShowDisabledInfo = ref[1];
    var ref1 = regular_slicedToArray((0,react.useState)(false), 2), expanded = ref1[0], setExpanded = ref1[1];
    var ref2 = regular_slicedToArray((0,react.useState)(types/* ReportRowType.NONE */.Zu.NONE), 2), priceRowReport = ref2[0], setPriceRowReport = ref2[1];
    var ref3 = regular_slicedToArray((0,react.useState)(), 2), sotyBadge = ref3[0], setSotyBadge = ref3[1];
    var ref4 = regular_slicedToArray((0,react.useState)(null), 2), reportRowId = ref4[0], setReportRowId = ref4[1];
    var ref5 = regular_slicedToArray((0,react.useState)(false), 2), infoModalOpen = ref5[0], setInfoModalOpen = ref5[1];
    var priceRowRef = (0,react.useRef)(null);
    var ref6 = (0,price_row_context/* usePriceRowContext */.m)(), offer = ref6.offer, product = ref6.product, isInPriceList = ref6.isInPriceList, isOurChoice = ref6.isOurChoice, viewSize = ref6.viewSize;
    var authorizedDealer = offer.authorizedDealer, alternativePrices = offer.alternativePrices, externalUri = offer.externalUri, featured = offer.featured, price = offer.price, priceId = offer.priceId, promotion = offer.promotion, stock = offer.stock, store = offer.store;
    var startBounceTimer = (0,react.useCallback)(function(id) {
        // Start a timer when a user clicks out on a product
        // if they return to Prisjakt within 15 seconds
        // display an error report button in the price row.
        var startTime = Date.now();
        var onRefocus = function() {
            if (Date.now() - startTime > 15000 && document.visibilityState === "visible") {
                document.removeEventListener("visibilitychange", onRefocus);
                return;
            }
            if (document.visibilityState === "visible") {
                setReportRowId(id);
                // Action event for tracking
                onClickOutBounce(product.id, priceId);
                document.removeEventListener("visibilitychange", onRefocus);
            }
        };
        document.addEventListener("visibilitychange", onRefocus);
    }, [
        onClickOutBounce,
        priceId,
        product.id,
        setReportRowId
    ]);
    var handleClickOut = (0,react.useCallback)(function(e, id, altPrice) {
        var ref;
        var isInternational = (offer === null || offer === void 0 ? void 0 : (ref = offer.store) === null || ref === void 0 ? void 0 : ref.market) === "secondary";
        var status = getGAStatus(isInternational, Boolean(altPrice));
        var isFeatured = altPrice ? (0,utils/* getIsFeatured */.ZF)(offer, altPrice) : featured;
        var offerId = altPrice ? altPrice.id : id;
        setPriceRowReport(altPrice ? types/* ReportRowType.ALTERNATIVE */.Zu.ALTERNATIVE : types/* ReportRowType.DEFAULT */.Zu.DEFAULT);
        if (isFeatured && externalUri) {
            if ( true && offerId) startBounceTimer(offerId);
            if (!showDisabledInfo && !e.defaultPrevented) onPriceClick(featured, status, Boolean(altPrice));
        } else {
            e.preventDefault();
            setShowDisabledInfo(!showDisabledInfo);
        }
    }, [
        offer,
        featured,
        externalUri,
        startBounceTimer,
        showDisabledInfo,
        onPriceClick
    ]);
    var getTableLinkProps = function(altPrice) {
        return setTableLinkProps(featured, function(e) {
            return handleClickOut(e, priceId, altPrice);
        }, externalUri);
    };
    var handleExpandButtonClick = function(event) {
        event.preventDefault();
        event.stopPropagation();
        if (viewSize === types/* ViewSize.SMALL */.du.SMALL) {
            setInfoModalOpen(function(state) {
                return !state;
            });
        } else {
            setExpanded(!expanded);
        }
        if (!infoModalOpen && !expanded && sotyBadge === undefined && (store === null || store === void 0 ? void 0 : store.id)) {
            fetchSotyAwardsByStoreId(store.id).then(function(response) {
                var ref, ref1, ref2;
                if (response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : (ref1 = ref.store) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.storeOfTheYearAwards) === null || ref2 === void 0 ? void 0 : ref2.length) {
                    setSotyBadge(response.data.store.storeOfTheYearAwards[0]);
                } else {
                    setSotyBadge(null);
                }
            });
        }
    };
    var closeReportOverlay = (0,react.useCallback)(function() {
        setPriceRowReport(types/* ReportRowType.NONE */.Zu.NONE);
        setReportRowId(null);
    }, [
        setReportRowId
    ]);
    return /*#__PURE__*/ react.createElement(react.Fragment, {
        key: (store === null || store === void 0 ? void 0 : store.id) || "price-row"
    }, /*#__PURE__*/ react.createElement(row_types_styles/* StyledCard */.rg, {
        className: className,
        containerProps: {
            ref: priceRowRef
        },
        $expanded: expanded,
        $featured: featured,
        $extraMargin: isOurChoice && isInPriceList,
        $hasPromotion: Boolean(promotion)
    }, /*#__PURE__*/ react.createElement(row_types_styles/* Row */.X2, {
        className: "pj-ui-price-row" // Used to track click out (see out.js)
        ,
        "data-test": "PriceRow",
        $expanded: expanded,
        $featured: featured,
        $hasAuthorizedDealer: Boolean(authorizedDealer),
        $noExternalUri: !externalUri
    }, isInPriceList && /*#__PURE__*/ react.createElement(StyledExpandButtonWrapper, {
        onClick: handleExpandButtonClick,
        $expanded: expanded
    }, /*#__PURE__*/ react.createElement(ExpandButton, {
        expanded: expanded
    })), featured && /*#__PURE__*/ react.createElement(FeaturedColumns, {
        onClick: function(e) {
            return handleClickOut(e, priceId);
        }
    }), !featured && /*#__PURE__*/ react.createElement(UnfeaturedColumns, {
        priceRowRef: priceRowRef,
        setShowDisabledInfo: setShowDisabledInfo,
        showDisabledInfo: showDisabledInfo,
        tableLinkProps: getTableLinkProps()
    })), infoModalOpen && /*#__PURE__*/ react.createElement(InfoModal, {
        alternativePrices: alternativePrices,
        closeModal: function() {
            return setInfoModalOpen(false);
        },
        closeReportOverlay: closeReportOverlay,
        isOpen: infoModalOpen,
        priceRowReport: priceRowReport,
        reportRowId: reportRowId,
        sotyBadge: sotyBadge,
        tableLinkProps: function(altPrice) {
            return getTableLinkProps(altPrice);
        }
    }), expanded && store && /*#__PURE__*/ react.createElement(StyledInfoRow, {
        "data-test": "ColumnExpanded"
    }, /*#__PURE__*/ react.createElement(store_info_StoreInfo, {
        sotyBadge: sotyBadge
    })), expanded && alternativePrices && /*#__PURE__*/ react.createElement(StyledAlternativePricesArea, null, alternativePrices.map(function(altPrice) {
        if (!altPrice) return null;
        return /*#__PURE__*/ react.createElement(AlternativePriceRowContextContainer, {
            key: altPrice.id || "alternative-price-row",
            alternativeOffer: altPrice
        }, /*#__PURE__*/ react.createElement(AlternativePriceRow, {
            priceRowRef: priceRowRef,
            tableLinkProps: getTableLinkProps(altPrice)
        }), priceRowReport === types/* ReportRowType.ALTERNATIVE */.Zu.ALTERNATIVE && reportRowId === altPrice.id && /*#__PURE__*/ react.createElement(report_button/* ReportButton */.f, {
            priceId: altPrice.id,
            priceValue: altPrice.price && altPrice.price.exclShipping,
            stockStatus: altPrice.stock && altPrice.stock.status,
            onClose: closeReportOverlay,
            productName: altPrice.name,
            isAlternative: true
        }));
    }))), Boolean(promotion) && /*#__PURE__*/ react.createElement(PromotionBar, null), isInPriceList && priceRowReport === types/* ReportRowType.DEFAULT */.Zu.DEFAULT && reportRowId === priceId && /*#__PURE__*/ react.createElement(report_button/* ReportButton */.f, {
        priceId: priceId,
        priceValue: price && price.exclShipping,
        stockStatus: stock && stock.status,
        onClose: closeReportOverlay,
        productName: product.name
    }));
};
function getGAStatus(isInternational, isAlternative) {
    if (isInternational) {
        return "international";
    }
    if (isAlternative) {
        return "variant";
    }
    return "";
}

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/tracking.ts

var trackStockStatusClickOut = function(isPrimaryButton) {
    var statusData = {
        isPrimaryButton: isPrimaryButton
    };
    (0,data_layer/* pushEvent */.A)("ctaExperimentOfferClicked", statusData);
};

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/row-types/index.tsx








var PriceRow = function(props) {
    var item = props.item, index = props.index, className = props.className;
    var ref = (0,price_row_context/* usePriceRowContext */.m)(), product = ref.product, showUsedOffers = ref.showUsedOffers;
    var rowKey = "".concat(item.id, "-").concat(index);
    var dispatch = (0,es/* useDispatch */.I0)();
    return /*#__PURE__*/ react.createElement(RegularPriceRow, {
        key: rowKey,
        onClickOutBounce: function() {
            var ref;
            dispatch((0,actions_product/* productClickOutBounce */.nA)({
                productId: product.id,
                priceId: item.id,
                storeName: (ref = item.store) === null || ref === void 0 ? void 0 : ref.name
            }));
        },
        onPriceClick: function(featured, status, isAlternative) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
            if (((ref = item.stock) === null || ref === void 0 ? void 0 : ref.status) !== "not_in_stock" && !isAlternative) {
                trackStockStatusClickOut(true);
            } else if (((ref1 = item.stock) === null || ref1 === void 0 ? void 0 : ref1.status) === "not_in_stock" && !isAlternative) {
                trackStockStatusClickOut(false);
            }
            var _condition;
            // NOTE: Any changes done to data or structure of PRODUCT_PRICE_CLICK needs to be
            // reflected in react/middlewares/out pre click for tracking clicks before JS bundle
            dispatch((0,actions_product/* productPriceClick */.Po)(product.id, item, featured, status, isAlternative, "", isAlternative ? "" : (ref2 = item.stock) === null || ref2 === void 0 ? void 0 : ref2.status, (_condition = item.condition) !== null && _condition !== void 0 ? _condition : product_condition_types/* ConditionEnum.NEW */.M.NEW));
            var condition = showUsedOffers && item.condition ? item.condition : undefined;
            var isInternational = ((ref3 = item.store) === null || ref3 === void 0 ? void 0 : ref3.market) === "secondary";
            var isPjDeal = ((ref4 = product.dealInfo) === null || ref4 === void 0 ? void 0 : ref4.dealPercentage) ? true : undefined;
            var stockStatus = (0,conversion/* mapStockStatusToGTMStockStatus */._L)((ref5 = item.stock) === null || ref5 === void 0 ? void 0 : ref5.status);
            var priceType = "regular";
            if ((ref6 = item.offerPrices) === null || ref6 === void 0 ? void 0 : ref6.memberPrice) {
                priceType = "member";
            } else if ((ref7 = item.offerPrices) === null || ref7 === void 0 ? void 0 : ref7.originalPrice) {
                priceType = "sale";
            }
            (0,conversion/* trackOfferClickWithRevenue */.Rx)({
                scope: isAlternative ? conversion/* TrackClickScope.PRICE_LIST_EXPANDED */.b8.PRICE_LIST_EXPANDED : conversion/* TrackClickScope.PRICE_LIST */.b8.PRICE_LIST,
                priceId: item.id,
                condition: condition,
                hasShippingInfo: ((ref8 = item.shipping) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.nodes) === null || ref9 === void 0 ? void 0 : ref9.length) ? true : undefined,
                isInternational: isInternational ? true : undefined,
                isPartOfPromotion: item.promotion ? true : undefined,
                isPjDeal: isPjDeal,
                priceType: priceType,
                stockStatus: stockStatus
            });
        },
        className: className
    });
};


/***/ }),

/***/ 40710:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X2": () => (/* binding */ Row),
/* harmony export */   "dN": () => (/* binding */ ROW_HEIGHT),
/* harmony export */   "rg": () => (/* binding */ StyledCard),
/* harmony export */   "sg": () => (/* binding */ Column)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71993);
/* harmony import */ var _prisjakt_ui_card__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89695);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61093);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      flex: 2;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    align-items: stretch;\n\n    ",
        "\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      cursor: default;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      color: ",
        ";\n      &:hover {\n        color: ",
        ";\n      }\n      background: ",
        ";\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  line-height: 1.3em;\n  position: relative;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n      margin: ",
        " 0;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n      border-radius: 0;\n\n      :first-child {\n        border-top-left-radius: 8px;\n        border-top-right-radius: 8px;\n      }\n\n      :last-child {\n        border-bottom-left-radius: 8px;\n        border-bottom-right-radius: 8px;\n      }\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      box-shadow: none;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n      border-bottom-left-radius: 0;\n      border-bottom-right-radius: 0;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        "\n\n    background-color: ",
        ";\n    flex: 1;\n\n    ",
        "\n\n    ",
        ";\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n      background: none;\n      height: ",
        ";\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n      border-bottom: 1px solid ",
        ";\n    "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n      background: none;\n      border: none;\n    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        ";\n    border-radius: inherit;\n    display: flex;\n    align-items: stretch;\n    background: ",
        ";\n\n    ",
        "\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}



var ROW_HEIGHT = "54px";
var Column = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Column",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject1(), props.expand && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject()));
});
var rowStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject4(), function(props) {
    return props.$noExternalUri && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject2());
}, function(props) {
    return !props.$featured && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject3(), props.theme.text.secondary, props.theme.text.secondary, props.theme.colors.base100);
});
var StyledCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_card__WEBPACK_IMPORTED_MODULE_1__.Card).withConfig({
    displayName: "StyledCard",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject9(), rowStyles, props.theme.colors.base100, props.$extraMargin && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject5(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100), props.$isAlternative && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject6()), !props.$featured && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject7()), props.$hasPromotion && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject8()));
});
var Row = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Row",
    componentId: "sc-0-2"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject13(), rowStyles, props.theme.bg.primary, !props.$featured && !props.$isAlternative && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject10(), ROW_HEIGHT), props.$expanded && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject11(), props.theme.colors.base200), props.$isAlternative && !props.$featured && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject12()));
});


/***/ }),

/***/ 3382:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$x": () => (/* binding */ FeaturedStatusEnum),
/* harmony export */   "Zu": () => (/* binding */ ReportRowType),
/* harmony export */   "du": () => (/* binding */ ViewSize)
/* harmony export */ });
/* unused harmony export ProductPageProductClick */
var ViewSize;
(function(ViewSize) {
    ViewSize[ViewSize["SMALL"] = 0] = "SMALL";
    ViewSize[ViewSize["MEDIUM"] = 1] = "MEDIUM";
    ViewSize[ViewSize["LARGE"] = 2] = "LARGE";
})(ViewSize || (ViewSize = {}));
var FeaturedStatusEnum;
(function(FeaturedStatusEnum) {
    FeaturedStatusEnum["UNKNOWN"] = "FEATURED_STATUS_UNKNOWN";
    FeaturedStatusEnum["FEATURED"] = "FEATURED";
    FeaturedStatusEnum["NOT_FEATURED"] = "NOT_FEATURED";
})(FeaturedStatusEnum || (FeaturedStatusEnum = {}));
var ProductPageProductClick = "ProductPage";
var ReportRowType;
(function(ReportRowType) {
    ReportRowType["NONE"] = "none";
    ReportRowType["DEFAULT"] = "default";
    ReportRowType["ALTERNATIVE"] = "alternative";
})(ReportRowType || (ReportRowType = {}));


/***/ }),

/***/ 4976:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JZ": () => (/* binding */ createOfferFromPriceItem),
/* harmony export */   "a0": () => (/* binding */ getViewSize),
/* harmony export */   "nh": () => (/* binding */ getSortOptions)
/* harmony export */ });
/* harmony import */ var src_components_rating_rating_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46626);
/* harmony import */ var src_components_filter_dropdown__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6340);
/* harmony import */ var _price_row_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3382);
/* harmony import */ var _utils_product_condition_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83071);




var getStoreRating = function(store) {
    var ref;
    return (store === null || store === void 0 ? void 0 : (ref = store.userReviewSummary) === null || ref === void 0 ? void 0 : ref.rating) ? src_components_rating_rating_helper__WEBPACK_IMPORTED_MODULE_0__/* ["default"].convert */ .Z.convert(store.userReviewSummary.rating) : undefined;
};
var _requiresCompensation;
var mapMemberShipProgram = function(membershipProgram) {
    return membershipProgram ? {
        name: membershipProgram.name || "",
        requiresCompensation: (_requiresCompensation = membershipProgram.requiresCompensation) !== null && _requiresCompensation !== void 0 ? _requiresCompensation : false,
        url: membershipProgram.url || ""
    } : null;
};
function createOfferFromPriceItem(item) {
    var _condition, _shopHasUniqueShippings;
    return {
        name: item.name,
        price: item.price,
        offerPrices: item.offerPrices,
        priceId: item.id,
        condition: (_condition = item.condition) !== null && _condition !== void 0 ? _condition : _utils_product_condition_types__WEBPACK_IMPORTED_MODULE_3__/* .ConditionEnum.NEW */ .M.NEW,
        availability: item.availability,
        store: item.store,
        shopOfferId: item.shopOfferId,
        featured: item.featured,
        storeInfo: item.store && item.store.providedByStore ? item.store.providedByStore.generalInformation : null,
        rating: getStoreRating(item.store),
        stock: item.stock,
        externalUri: item.externalUri,
        alternativePrices: item.alternativePrices,
        authorizedDealer: Boolean(item.authorizedDealer),
        isInternationalPrice: Boolean(item.store && item.store.market === "secondary"),
        shipping: item.shipping,
        unfilteredShippings: item.unfilteredShippings,
        ourChoiceScore: item.ourChoiceScore,
        dealOffers: item.dealOffers,
        featuredOverride: item.featuredOverride,
        membershipProgram: mapMemberShipProgram(item.membershipProgram),
        shopHasUniqueShippings: (_shopHasUniqueShippings = item.shopHasUniqueShippings) !== null && _shopHasUniqueShippings !== void 0 ? _shopHasUniqueShippings : false,
        promotion: item.promotion,
        membershipLink: item.membershipLink
    };
}
var getSortOptions = function(t, allOffers) {
    var hasDeliveryDays = allOffers.some(function(offer) {
        var ref;
        return (ref = offer.shipping) === null || ref === void 0 ? void 0 : ref.nodes.some(function(node) {
            return node === null || node === void 0 ? void 0 : node.deliveryDays;
        });
    });
    if (!hasDeliveryDays) {
        return [];
    }
    return [
        {
            title: t("campaigns", "sort.price.offer|asc"),
            type: src_components_filter_dropdown__WEBPACK_IMPORTED_MODULE_1__/* .OptionTypeEnum.CHEAPEST_PRICE */ .M7.CHEAPEST_PRICE
        },
        {
            title: t("common", "sort.fastest-delivery"),
            type: src_components_filter_dropdown__WEBPACK_IMPORTED_MODULE_1__/* .OptionTypeEnum.FASTEST_DELIVERY */ .M7.FASTEST_DELIVERY
        }
    ];
};
var getViewSize = function(viewport) {
    if (viewport.isDesktop) return _price_row_types__WEBPACK_IMPORTED_MODULE_2__/* .ViewSize.LARGE */ .du.LARGE;
    if (viewport.isTablet) return _price_row_types__WEBPACK_IMPORTED_MODULE_2__/* .ViewSize.MEDIUM */ .du.MEDIUM;
    return _price_row_types__WEBPACK_IMPORTED_MODULE_2__/* .ViewSize.SMALL */ .du.SMALL;
};


/***/ }),

/***/ 88057:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": () => (/* binding */ ProductBreadCrumb)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/breadcrumbs/index.tsx
var breadcrumbs = __webpack_require__(45183);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
;// CONCATENATED MODULE: ./src/areas/product/components/product-breadcrumb/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  margin: ",
        " 0 ",
        "\n    ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var BreadCrumbWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BreadCrumbWrapper",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/areas/product/components/product-breadcrumb/index.tsx



var ProductBreadCrumb = function(props) {
    var ref;
    var product = props.product;
    var ref1;
    return /*#__PURE__*/ react.createElement(BreadCrumbWrapper, {
        "data-test": "Breadcrumbs"
    }, /*#__PURE__*/ react.createElement(breadcrumbs/* Breadcrumbs */.O, {
        crumbs: (ref1 = (ref = product.category) === null || ref === void 0 ? void 0 : ref.path.map(function(param) {
            var title = param.name, href = param.pathName;
            return {
                href: href,
                title: title
            };
        })) !== null && ref1 !== void 0 ? ref1 : [],
        lastItemClickable: true
    }));
};


/***/ }),

/***/ 65956:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _components_campaign_deals__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71897);
/* harmony import */ var _components_error_boundary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77078);
/* harmony import */ var src_components_lazy__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67506);




var ProductCampaignDeals = function(props) {
    var ref;
    var product = props.product;
    return product.category && product.category.deals && ((ref = product.category) === null || ref === void 0 ? void 0 : ref.deals.length) > 0 ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_error_boundary__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        onError: returnNull
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_lazy__WEBPACK_IMPORTED_MODULE_3__/* .Lazy */ .o, {
        offset: 100
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_campaign_deals__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        deals: product.category.deals,
        campaignLinkQuery: "?category=".concat(product.category.id)
    }))) : null;
};
var returnNull = function() {
    return null;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ProductCampaignDeals);


/***/ }),

/***/ 16130:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$h": () => (/* binding */ useProductContext),
/* harmony export */   "HS": () => (/* binding */ ProductContext),
/* harmony export */   "jG": () => (/* binding */ EmptyProduct)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);

var EmptyProduct = {
    id: 0,
    media: {
        count: 0
    },
    name: "",
    classicFullPath: "",
    pathName: "",
    priceSummary: {},
    userReviewSummary: {},
    coreProperties: {},
    isExpertTopRated: false
};
var initialContextValue = {
    product: EmptyProduct,
    offers: {
        filteredOffers: [],
        initialOffers: []
    },
    allOffers: [],
    allOffersWithActiveAdditives: [],
    dealOffers: [],
    priceInfoArticles: undefined
};
var ProductContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(initialContextValue);
var useProductContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ProductContext);
};


/***/ }),

/***/ 56632:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": () => (/* binding */ ListModal)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71993);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61093);
/* harmony import */ var _prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7336);
/* harmony import */ var _prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35967);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71016);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18026);
/* harmony import */ var _list_context__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56672);
/* harmony import */ var _prisjakt_ui_radiobutton__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9225);
/* harmony import */ var src_components_modal_v2__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(54674);
/* harmony import */ var _prisjakt_ui_modal__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(58709);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  gap: ",
        ";\n  margin: 0;\n  list-style: none;\n  overflow: hidden;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var ListModal = function(props) {
    var addToList = props.addToList, addToMyProducts = props.addToMyProducts, closeModal = props.closeModal, isOpen = props.isOpen, isDesktop = props.isDesktop, lists = props.lists;
    var t = (0,src_components_app_context__WEBPACK_IMPORTED_MODULE_6__/* .useAppContext */ .bp)().t;
    var ref = (0,_list_context__WEBPACK_IMPORTED_MODULE_7__/* .useListContext */ .U)(), fetchMoreLists = ref.fetchMoreLists, moreLists = ref.moreLists, pageInfo = ref.pageInfo;
    var ref1 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), 2), selectedValue = ref1[0], setSelectedValue = ref1[1];
    var ref2 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), 2), listItemSelected = ref2[0], setListItemSelected = ref2[1];
    var handleOptionClick = function(listId) {
        setSelectedValue(listId);
        if (!selectedValue) setListItemSelected(function(state) {
            return !state;
        });
    };
    var onSubmit = function() {
        if (selectedValue === "my-products") {
            addToMyProducts();
        } else if (typeof selectedValue === "number") {
            addToList(selectedValue);
        }
        closeModal();
    };
    var handleSaveToNewListClick = function() {
        addToList();
        closeModal();
    };
    var allLists = _toConsumableArray(lists || []).concat(_toConsumableArray(moreLists || []));
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_modal_v2__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        isOpen: isOpen,
        onRequestClose: closeModal,
        size: isDesktop ? _prisjakt_ui_modal__WEBPACK_IMPORTED_MODULE_10__/* .ModalSizeEnum.SMALL */ .E$.SMALL : _prisjakt_ui_modal__WEBPACK_IMPORTED_MODULE_10__/* .ModalSizeEnum.FULL */ .E$.FULL,
        title: "".concat(t("lists", "list.save-to-list"), ":")
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_modal__WEBPACK_IMPORTED_MODULE_10__/* .ModalBody */ .fe, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ListWrapper, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_radiobutton__WEBPACK_IMPORTED_MODULE_8__/* .RadioButton */ .EU, {
        id: "my-products",
        name: "list",
        selectedValue: selectedValue,
        value: "my-products",
        text: t("lists", "my-products.title"),
        onClickHandler: function() {
            return handleOptionClick("my-products");
        }
    })), allLists.map(function(list) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", {
            key: list.id
        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_radiobutton__WEBPACK_IMPORTED_MODULE_8__/* .RadioButton */ .EU, {
            id: list.id.toString(),
            name: "list",
            selectedValue: selectedValue,
            value: list.id,
            text: list.name,
            onClickHandler: function() {
                return handleOptionClick(list.id);
            }
        }));
    }), (pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.hasNext) && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__.TextButton, {
        onClick: fetchMoreLists
    }, t("common", "button.show-more")))), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_modal__WEBPACK_IMPORTED_MODULE_10__/* .ModalFooter */ .mz, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_4__.Row, {
        equallySizedChildren: true,
        gap: 1
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__.OutlinedButton, {
        onClick: handleSaveToNewListClick
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_5__.TitleSmallText, null, t("lists", "list.save-to-new-list"))), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__.PrimaryButton, {
        onClick: onSubmit,
        disabled: !listItemSelected
    }, t("common", "button.save"))))));
};
var ListWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].ul.withConfig({
    displayName: "ListWrapper",
    componentId: "sc-0-0"
})(_templateObject(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025);


/***/ }),

/***/ 7235:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BR": () => (/* binding */ StyleUnderlinedInfoPageLink),
/* harmony export */   "Ij": () => (/* binding */ StyledPopoverContent),
/* harmony export */   "Kt": () => (/* binding */ StyledBlueInfoPageLink),
/* harmony export */   "Mv": () => (/* binding */ StyledIconWrapper),
/* harmony export */   "PU": () => (/* binding */ TitleRow),
/* harmony export */   "tw": () => (/* binding */ OurChoiceWrapper)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71993);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61093);
/* harmony import */ var src_components_info_page_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48596);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      width: 320px;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  margin-top: ",
        ";\n  position: relative;\n  gap: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: auto 1fr 1fr;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  height: 16px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  &:hover {\n    color: ",
        ";\n  }\n  text-decoration: underline;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var OurChoiceWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "OurChoiceWrapper",
    componentId: "sc-0-0"
})(_templateObject1(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumUp */ .BC.mediumUp(_templateObject()));
var TitleRow = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "TitleRow",
    componentId: "sc-0-1"
})(_templateObject2(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025);
var StyledIconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "StyledIconWrapper",
    componentId: "sc-0-2"
})(_templateObject3());
var StyledPopoverContent = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "StyledPopoverContent",
    componentId: "sc-0-3"
})(_templateObject4(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing075 */ .bK.measurements.spacing075);
var StyledBlueInfoPageLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_components_info_page_link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    displayName: "StyledBlueInfoPageLink",
    componentId: "sc-0-4"
})(_templateObject5(), function(p) {
    return p.theme.colors.maybeBlue700;
});
var StyleUnderlinedInfoPageLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_components_info_page_link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    displayName: "StyleUnderlinedInfoPageLink",
    componentId: "sc-0-5"
})(_templateObject6(), function(p) {
    return p.theme.colors.maybeBlue700;
});


/***/ }),

/***/ 66030:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": () => (/* binding */ getOurChoiceOffer)
/* harmony export */ });
/* harmony import */ var src_areas_product_components_price_list_price_row_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3382);
/* harmony import */ var src_areas_product_utils_product_condition_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83071);


var ALLOWED_MARKETS = [
    "gb",
    "fr"
];
var MIN_PRICE_DIFF_TO_SHOPS_WITH_SCORE = 0.18;
var MIN_PRICE_DIFF_TO_CHEAPEST = 0.2;
var MAX_PRICE_DIFF_TO_CHEAPEST = 1.2;
var sortByScore = function(a, b) {
    if (a.ourChoiceScore === b.ourChoiceScore) {
        return 0;
    }
    return a.ourChoiceScore > b.ourChoiceScore ? -1 : 1;
};
var isMuchCheaperOfferWithOneScoreBelow = function(offer, ourChoice) {
    var ref, ref1;
    var ourChoicePrice = ((ref = ourChoice.price) === null || ref === void 0 ? void 0 : ref.exclShipping) || Infinity;
    var price = ((ref1 = offer.price) === null || ref1 === void 0 ? void 0 : ref1.exclShipping) || Infinity;
    var percentage = price / ourChoicePrice;
    return offer.ourChoiceScore === (ourChoice === null || ourChoice === void 0 ? void 0 : ourChoice.ourChoiceScore) - 1 && percentage <= 1 - MIN_PRICE_DIFF_TO_SHOPS_WITH_SCORE;
};
var isTooExpensiveRecommendation = function(ourChoice, offersSortedByPrice) {
    var ref, ref1, ref2;
    var ourChoicePrice = ((ref = ourChoice.price) === null || ref === void 0 ? void 0 : ref.exclShipping) || -1;
    var otherCheapestPrice = ((ref1 = offersSortedByPrice.find(function(offer) {
        var ref;
        return ((ref = offer.store) === null || ref === void 0 ? void 0 : ref.name) !== ourChoice.store;
    })) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.price) === null || ref2 === void 0 ? void 0 : ref2.exclShipping) || -1;
    if (ourChoicePrice === -1 || otherCheapestPrice === -1) {
        return false;
    }
    return ourChoicePrice >= otherCheapestPrice * MAX_PRICE_DIFF_TO_CHEAPEST;
};
var isSuspiciouslyCheapRecommendation = function(ourChoice, offersSortedByPrice) {
    var ref, ref1, ref2;
    var ourChoicePrice = (ref = ourChoice.price) === null || ref === void 0 ? void 0 : ref.exclShipping;
    var otherCheapestPrice = (ref1 = offersSortedByPrice.find(function(offer) {
        var ref;
        return ((ref = offer.store) === null || ref === void 0 ? void 0 : ref.name) !== ourChoice.store;
    })) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.price) === null || ref2 === void 0 ? void 0 : ref2.exclShipping;
    if (!ourChoicePrice || !otherCheapestPrice) {
        return false;
    }
    return ourChoicePrice < otherCheapestPrice * MIN_PRICE_DIFF_TO_CHEAPEST;
};
var getOurChoiceOffer = function(offersSortedByPrice, market) {
    if (!ALLOWED_MARKETS.includes(market)) {
        return undefined;
    }
    var filteredOffers = offersSortedByPrice.filter(function(offer) {
        var ref, ref1;
        return offer.condition === src_areas_product_utils_product_condition_types__WEBPACK_IMPORTED_MODULE_1__/* .ConditionEnum.NEW */ .M.NEW && ((ref = offer.store) === null || ref === void 0 ? void 0 : ref.featured) && offer.featuredOverride !== src_areas_product_components_price_list_price_row_types__WEBPACK_IMPORTED_MODULE_0__/* .FeaturedStatusEnum.NOT_FEATURED */ .$x.NOT_FEATURED && ((ref1 = offer.stock) === null || ref1 === void 0 ? void 0 : ref1.status) === "in_stock" && offer.ourChoiceScore > 0;
    });
    if (filteredOffers.length === 0) {
        return undefined;
    }
    var sortedOnScore = filteredOffers.sort(sortByScore);
    var ourChoice = sortedOnScore[0];
    if (isTooExpensiveRecommendation(ourChoice, offersSortedByPrice) || isSuspiciouslyCheapRecommendation(ourChoice, offersSortedByPrice)) {
        return undefined;
    }
    var cheapestOfferWithSecondBestRank = sortedOnScore.find(function(offer) {
        return isMuchCheaperOfferWithOneScoreBelow(offer, ourChoice);
    });
    if (cheapestOfferWithSecondBestRank) {
        return cheapestOfferWithSecondBestRank;
    }
    return ourChoice;
};


/***/ }),

/***/ 29779:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ ProductPageHeader)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/areas/product/components/product-header/list-context.tsx
var list_context = __webpack_require__(56672);
// EXTERNAL MODULE: ./src/components/viewport/index.tsx
var viewport = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./src/areas/product/components/product-context/index.ts
var product_context = __webpack_require__(16130);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
// EXTERNAL MODULE: ./src/ui/block/index.ts
var block = __webpack_require__(65176);
// EXTERNAL MODULE: ./src/areas/product/components/offer-list-filter-context/index.tsx
var offer_list_filter_context = __webpack_require__(65884);
// EXTERNAL MODULE: ./src/components/price-list/filtering.ts + 2 modules
var filtering = __webpack_require__(88257);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/index.js
var ui = __webpack_require__(54262);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/dropdown/index.js
var dropdown = __webpack_require__(42654);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/button/index.js
var ui_button = __webpack_require__(17658);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/index.js
var ui_text = __webpack_require__(49955);
// EXTERNAL MODULE: ./src/ui/zindex/index.ts
var zindex = __webpack_require__(93497);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var text_variants = __webpack_require__(71016);
;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/size-variants/utils/index.ts
var getSizeTitle = function(t) {
    return "".concat(t("product", "label.size"));
};
var getFractalRepresentation = function(numericString) {
    var integerValue = parseInt(numericString, 10);
    var decimalValue = parseFloat(numericString) % 1;
    if (isNaN(integerValue) || isNaN(decimalValue)) {
        return numericString;
    }
    if (decimalValue > 0.4 && decimalValue < 0.6) {
        return "".concat(integerValue, " \xbd");
    }
    if (decimalValue > 0.25 && decimalValue < 0.4) {
        return "".concat(integerValue, " ⅓");
    }
    if (decimalValue > 0.6 && decimalValue < 0.75) {
        return "".concat(integerValue, " ⅔");
    }
    return numericString;
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/color-variants/utils/colors.ts
var getColor = function(color) {
    switch(color){
        case "Black":
            return {
                hex: "#000000",
                order: 1,
                translationKey: "colors.black"
            };
        case "White":
            return {
                hex: "#FFFFFF",
                order: 2,
                translationKey: "colors.white"
            };
        case "Grey":
            return {
                hex: "#808080",
                order: 3,
                translationKey: "colors.grey"
            };
        case "Blue":
            return {
                hex: "#1E90FF",
                order: 4,
                translationKey: "colors.blue"
            };
        case "Red":
            return {
                hex: "#FF002B",
                order: 5,
                translationKey: "colors.red"
            };
        case "Green":
            return {
                hex: "#00D471",
                order: 6,
                translationKey: "colors.green"
            };
        case "Beige":
            return {
                hex: "#F5F5DC",
                order: 7,
                translationKey: "colors.beige"
            };
        case "Orange":
            return {
                hex: "#FFA500",
                order: 8,
                translationKey: "colors.orange"
            };
        case "Pink":
            return {
                hex: "#FFA6B6",
                order: 9,
                translationKey: "colors.pink"
            };
        case "Brown":
            return {
                hex: "#915B25",
                order: 10,
                translationKey: "colors.brown"
            };
        case "Yellow":
            return {
                hex: "#FFEA00",
                order: 11,
                translationKey: "colors.yellow"
            };
        case "Silver":
            return {
                hex: "#C0C0C0",
                order: 12,
                translationKey: "colors.silver"
            };
        case "Purple":
            return {
                hex: "#800080",
                order: 13,
                translationKey: "colors.purple"
            };
        case "Turquoise":
            return {
                hex: "#40E0D0",
                order: 14,
                translationKey: "colors.turquoise"
            };
        case "Khaki":
            return {
                hex: "#8A865D",
                order: 15,
                translationKey: "colors.khaki"
            };
        case "Gold":
            return {
                hex: "#D4AF37",
                order: 16,
                translationKey: "colors.gold"
            };
        default:
            // In case we get non-normalized values from backend
            return {
                hex: null,
                order: 100,
                translationKey: null,
                nonNormalizedColor: color !== null && color !== void 0 ? color : ""
            };
    }
};
var getColorTranslation = function(t, color) {
    var colorVal = getColor(color);
    if (colorVal.translationKey) {
        return t("common", // @ts-expect-error -- Typed too loosely
        colorVal.translationKey);
    }
    if (colorVal.nonNormalizedColor) {
        return colorVal.nonNormalizedColor;
    }
    return "";
};

// EXTERNAL MODULE: ./src/components/price-list/types.ts
var types = __webpack_require__(79126);
;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/utils/selections.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



var createNewSelection = function(variant, variantSelection) {
    if (!variant) {
        return [];
    }
    return variantSelection.includes(variant) ? variantSelection.filter(function(v) {
        return v !== variant;
    }) : _toConsumableArray(variantSelection).concat([
        variant
    ]);
};
var getSelectionsString = function(t, filter) {
    var selected = (filter === null || filter === void 0 ? void 0 : filter.active) ? filter === null || filter === void 0 ? void 0 : filter.selection : null;
    if (!(selected === null || selected === void 0 ? void 0 : selected.length)) {
        return null;
    }
    var prettified = selected.map(function(variant) {
        switch(filter === null || filter === void 0 ? void 0 : filter.type){
            case types/* FilterType.VARIANT_SIZE */.vA.VARIANT_SIZE:
                return getFractalRepresentation(variant);
            case types/* FilterType.VARIANT_COLOR */.vA.VARIANT_COLOR:
                return getColorTranslation(t, variant);
            default:
                return variant;
        }
    });
    return prettified.sort().join(", ");
};

// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/styles-common.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: auto;\n  min-width: 206px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: left;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    max-height: 340px;\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding: 1px;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var VariantGridTitle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "VariantGridTitle",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var DropdownToggle = (0,styled_components_browser_esm["default"])(dropdown/* DropdownToggle */.Z_).withConfig({
    displayName: "DropdownToggle",
    componentId: "sc-0-1"
})(_templateObject1());
var DropdownButtonText = (0,styled_components_browser_esm["default"])(ui_button.ButtonText).withConfig({
    displayName: "DropdownButtonText",
    componentId: "sc-0-2"
})(_templateObject2());
var SelectionHighlightedText = styled_components_browser_esm["default"].span.withConfig({
    displayName: "SelectionHighlightedText",
    componentId: "sc-0-3"
})(_templateObject3(), function(p) {
    return p.theme.colors.maybeBlue700;
});
var ScrollableArea = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ScrollableArea",
    componentId: "sc-0-4"
})(_templateObject5(), base/* media.mediumUp */.BC.mediumUp(_templateObject4()));

;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/size-variants/size-variants-button-label.tsx









var SizeVariantsButtonLabel = function() {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var getFilter = (0,offer_list_filter_context/* useOfferListFilterContext */.o)().getFilter;
    var title = getSizeTitle(t);
    var filter = getFilter(types/* FilterType.VARIANT_SIZE */.vA.VARIANT_SIZE);
    var ref;
    var selectedVariants = (ref = getSelectionsString(t, filter)) !== null && ref !== void 0 ? ref : t("product", "variants.all");
    return /*#__PURE__*/ react.createElement(DropdownButtonText, {
        behavior: ui_text.Behavior.OnelineEllipsis
    }, /*#__PURE__*/ react.createElement(text_variants.TitleSmallText, null, title, ":", " ", /*#__PURE__*/ react.createElement(SelectionHighlightedText, null, selectedVariants)));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/button/variants.js
var button_variants = __webpack_require__(7336);
;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/size-variants/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n    margin: 0 ",
        ";\n    grid-template-columns: repeat(5, max-content);\n  "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: repeat(4, [col] 1fr);\n  gap: ",
        ";\n\n  & + & {\n    margin-top: ",
        ";\n    padding-top: ",
        ";\n    border-top: 1px solid ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  min-width: 62px;\n  padding: 1px;\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n  max-width: 100px;\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = styles_taggedTemplateLiteral([
        "\n  grid-column: col / span 4;\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var VariantGridWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "VariantGridWrapper",
    componentId: "sc-0-0"
})(styles_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.theme.lines.primary;
}, base/* media.mediumUp */.BC.mediumUp(styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050));
var VariantGridCell = styled_components_browser_esm["default"].div.withConfig({
    displayName: "VariantGridCell",
    componentId: "sc-0-1"
})(styles_templateObject2());
var SelectionButtonText = (0,styled_components_browser_esm["default"])(ui_button.ButtonText).withConfig({
    displayName: "SelectionButtonText",
    componentId: "sc-0-2"
})(styles_templateObject3());
var StyledShowMoreButtonWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledShowMoreButtonWrapper",
    componentId: "sc-0-3"
})(styles_templateObject4());

;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/size-variants/size-variant-selection-button.tsx





var SizeVariantSelectionButton = function(props) {
    var variant = props.variant, title = props.title, selection = props.selection, disabled = props.disabled, handleSelection = props.handleSelection, isMobile = props.isMobile;
    var sizeWithFractal = title ? getFractalRepresentation(title) : "";
    var isSelected = Boolean(variant && (selection === null || selection === void 0 ? void 0 : selection.includes(variant)) || !variant && !selection);
    var onSelect = function() {
        return handleSelection(variant);
    };
    return /*#__PURE__*/ react.createElement(ui_button.Button, {
        onClick: onSelect,
        selectable: true,
        selected: isSelected,
        fullWidth: true,
        type: ui_button.ButtonType.OUTLINED,
        elevation: ui_button.ButtonElevation.NONE,
        disabled: disabled,
        size: isMobile ? ui_button.ButtonSize.NORMAL : ui_button.ButtonSize.SMALL
    }, /*#__PURE__*/ react.createElement(SelectionButtonText, {
        behavior: ui_text.Behavior.OnelineEllipsis
    }, sizeWithFractal));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/size-variants/utils/group-size-variants.ts
function group_size_variants_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || group_size_variants_unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function group_size_variants_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return group_size_variants_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return group_size_variants_arrayLikeToArray(o, minLen);
}
var getGroupedVariants = function(variants) {
    var _sizeSystem;
    var groups = groupBy(variants, function(variant) {
        return (_sizeSystem = variant.sizeSystem) !== null && _sizeSystem !== void 0 ? _sizeSystem : undefined;
    });
    var sortedGroups = groups.sort(function(param, param1) {
        var _param = _slicedToArray(param, 1), aKey = _param[0], _param1 = _slicedToArray(param1, 1), bKey = _param1[0];
        return getSizeSystemNumber(bKey) - getSizeSystemNumber(aKey);
    });
    return sortedGroups.map(function(param) {
        var _param = _slicedToArray(param, 2), group = _param[1];
        return group.sort(compareVariants);
    });
};
var compareVariants = function(a, b) {
    if (!a.size || !b.size) {
        return 0;
    }
    if (a.sizeSystem === "CLOTHESNONNUMERIC" && b.sizeSystem === "CLOTHESNONNUMERIC") {
        return getCloathesNonNumericNumber(a.size) - getCloathesNonNumericNumber(b.size);
    }
    return a.size.localeCompare(b.size, undefined, {
        numeric: true,
        sensitivity: "base"
    });
};
var getSizeSystemNumber = function(sizeSystem) {
    switch(sizeSystem){
        case "CLOTHESNUMERIC":
            return 1;
        case "CLOTHESNONNUMERIC":
            return 2;
        default:
            return Infinity;
    }
};
var getCloathesNonNumericNumber = function(size) {
    if (!size) {
        return Infinity;
    }
    switch(size.toUpperCase()){
        case "XXS":
            return 1;
        case "XS":
            return 2;
        case "S":
            return 3;
        case "S/M":
            return 4;
        case "M":
            return 5;
        case "M/L":
            return 6;
        case "L":
            return 7;
        case "L/XL":
            return 8;
        case "XL":
            return 9;
        case "XXL":
            return 10;
        case "XXXL":
            return 11;
        case "XXXXL":
            return 12;
        case "XXXXXL":
            return 13;
        case "ONE SIZE":
            return 14;
        default:
            return Infinity;
    }
};
function groupBy(input, generateKey) {
    var set = new Map();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = input[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            var ref;
            var key = generateKey(element);
            if (!set.has(key)) {
                set.set(key, []);
            }
            (ref = set.get(key)) === null || ref === void 0 ? void 0 : ref.push(element);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return Array.from(set.entries());
}

;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/size-variants/utils/collapsing.ts

var getSelectedSizesAsVariants = function(variantGroup, selection) {
    var findSizeInVariantGroup = function(size) {
        return variantGroup.find(function(variant) {
            return variant.size === size;
        });
    };
    var selectedSizes = (selection === null || selection === void 0 ? void 0 : selection.filter(findSizeInVariantGroup)) || [];
    return selectedSizes.map(function(size) {
        return findSizeInVariantGroup(size);
    });
};
var getSelectedAndFirstFewVariants = function(variantGroup, showSelectAll, limit, selection) {
    var selectedVariants = getSelectedSizesAsVariants(variantGroup, selection);
    var numSelected = selectedVariants.length || 0;
    var extraButtons = showSelectAll ? 1 : 0;
    var numNonSelectedVariantsToKeep = Math.max(0, limit - numSelected) - extraButtons;
    var variantIsNotSelected = function(variant) {
        return !selectedVariants.find(function(selectedVariant) {
            return (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.size) === variant.size;
        });
    };
    var nonSelectedVariantsToKeep = variantGroup.filter(variantIsNotSelected).slice(0, numNonSelectedVariantsToKeep);
    var result = selectedVariants.concat(nonSelectedVariantsToKeep);
    return result.sort(compareVariants);
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/size-variants/size-variants-grid.tsx
function size_variants_grid_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function size_variants_grid_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function size_variants_grid_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function size_variants_grid_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function size_variants_grid_slicedToArray(arr, i) {
    return size_variants_grid_arrayWithHoles(arr) || size_variants_grid_iterableToArrayLimit(arr, i) || size_variants_grid_unsupportedIterableToArray(arr, i) || size_variants_grid_nonIterableRest();
}
function size_variants_grid_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return size_variants_grid_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return size_variants_grid_arrayLikeToArray(o, minLen);
}











var SizeVariantsGrid = function(props) {
    var title = props.title, variants = props.variants, handleSelection = props.handleSelection, isMobile = props.isMobile;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var getFilter = (0,offer_list_filter_context/* useOfferListFilterContext */.o)().getFilter;
    var ref = size_variants_grid_slicedToArray((0,react.useState)(false), 2), isExpanded = ref[0], setIsExpanded = ref[1];
    var filter = getFilter(types/* FilterType.VARIANT_SIZE */.vA.VARIANT_SIZE);
    var selection = (filter === null || filter === void 0 ? void 0 : filter.active) ? filter === null || filter === void 0 ? void 0 : filter.selection : undefined;
    var groupedVariants = getGroupedVariants(variants === null || variants === void 0 ? void 0 : variants.filter(Boolean));
    var LIMIT_CELLS = isMobile ? 12 : Number.MAX_VALUE;
    var selectAllCell = /*#__PURE__*/ react.createElement(VariantGridCell, null, /*#__PURE__*/ react.createElement(SizeVariantSelectionButton, {
        handleSelection: handleSelection,
        title: t("product", "variants.all"),
        selection: selection,
        variant: null,
        isMobile: isMobile
    }));
    var variantGroupCells = function(i, variantGroup, showSelectAll) {
        var key = "size-group-".concat(i);
        var variantsToDisplay = isExpanded ? variantGroup : getSelectedAndFirstFewVariants(variantGroup, showSelectAll, LIMIT_CELLS, selection);
        return /*#__PURE__*/ react.createElement(VariantGridWrapper, {
            key: key
        }, showSelectAll && selectAllCell, variantsToDisplay.map(function(sizeVariant) {
            return /*#__PURE__*/ react.createElement(VariantGridCell, {
                key: sizeVariant.size
            }, /*#__PURE__*/ react.createElement(SizeVariantSelectionButton, {
                handleSelection: handleSelection,
                title: sizeVariant.size,
                variant: sizeVariant.size,
                selection: selection,
                disabled: sizeVariant.disabled,
                isMobile: isMobile
            }));
        }), isMobile && variantGroup.length > LIMIT_CELLS && /*#__PURE__*/ react.createElement(StyledShowMoreButtonWrapper, null, /*#__PURE__*/ react.createElement(button_variants.OutlinedButton, {
            fullWidth: true,
            onClick: function() {
                return setIsExpanded(!isExpanded);
            }
        }, isExpanded ? t("common", "button.show-less") : t("common", "button.show-more"))));
    };
    return /*#__PURE__*/ react.createElement("div", null, title && /*#__PURE__*/ react.createElement(VariantGridTitle, null, /*#__PURE__*/ react.createElement(text_variants.H4Text, null, title)), /*#__PURE__*/ react.createElement(ScrollableArea, null, groupedVariants.map(function(group, i) {
        return variantGroupCells(i, group, i === 0);
    })));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/size-variants/size-variants-desktop-version.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}









var SizeVariantsDesktopVersion = function(props) {
    return /*#__PURE__*/ react.createElement(dropdown/* Dropdown */.Lt, {
        zIndex: zindex/* zindex.overlay */.Y.overlay
    }, /*#__PURE__*/ react.createElement(DropdownToggle, {
        showActiveIcon: true,
        fullWidth: true,
        size: ui_button.ButtonSize.SMALL
    }, /*#__PURE__*/ react.createElement(DropdownButtonText, {
        behavior: ui_text.Behavior.OnelineEllipsis
    }, /*#__PURE__*/ react.createElement(SizeVariantsButtonLabel, null))), /*#__PURE__*/ react.createElement(dropdown/* DropdownContent */.Nv, {
        alignment: ui/* Direction.Down */.Nm.Down
    }, /*#__PURE__*/ react.createElement(SizeVariantsGrid, _extends({}, props))));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/size-variants/size-variants-mobile-version.tsx




var SizeVariantsMobileVersion = function(props) {
    var variants = props.variants, handleSelection = props.handleSelection, isMobile = props.isMobile;
    var t = (0,app_context/* useAppContext */.bp)().t;
    return /*#__PURE__*/ react.createElement(SizeVariantsGrid, {
        variants: variants,
        handleSelection: handleSelection,
        title: getSizeTitle(t),
        isMobile: isMobile
    });
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/size-variants/index.tsx






var FILTER_TYPE = types/* FilterType.VARIANT_SIZE */.vA.VARIANT_SIZE;
var SizeVariants = function(props) {
    var distinctValues = props.distinctValues, isMobile = props.isMobile;
    var ref = (0,offer_list_filter_context/* useOfferListFilterContext */.o)(), getFilter = ref.getFilter, setFilterSelection = ref.setFilterSelection, toggleFilter = ref.toggleFilter;
    var filter = getFilter(FILTER_TYPE);
    var selection = (filter === null || filter === void 0 ? void 0 : filter.active) && (filter === null || filter === void 0 ? void 0 : filter.selection) ? filter === null || filter === void 0 ? void 0 : filter.selection : [];
    var handleSelection = function(variant) {
        var newSelection = createNewSelection(variant, (selection === null || selection === void 0 ? void 0 : selection.length) ? selection : []);
        if ((filter === null || filter === void 0 ? void 0 : filter.active) && newSelection.length === 0) {
            toggleFilter(FILTER_TYPE);
        } else {
            setFilterSelection(FILTER_TYPE, newSelection);
        }
    };
    if (distinctValues.length <= 1) {
        return null;
    }
    return isMobile ? /*#__PURE__*/ react.createElement(SizeVariantsMobileVersion, {
        handleSelection: handleSelection,
        variants: distinctValues,
        isMobile: isMobile
    }) : /*#__PURE__*/ react.createElement(SizeVariantsDesktopVersion, {
        handleSelection: handleSelection,
        variants: distinctValues,
        isMobile: isMobile
    });
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/color-variants/color-variants-button-label.tsx








var ColorVariantsButtonLabel = function() {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var getFilter = (0,offer_list_filter_context/* useOfferListFilterContext */.o)().getFilter;
    var filter = getFilter(types/* FilterType.VARIANT_COLOR */.vA.VARIANT_COLOR);
    var ref;
    var selectedVariants = (ref = getSelectionsString(t, filter)) !== null && ref !== void 0 ? ref : t("product", "variants.all");
    return /*#__PURE__*/ react.createElement(DropdownButtonText, {
        behavior: ui_text.Behavior.OnelineEllipsis
    }, /*#__PURE__*/ react.createElement(text_variants.TitleSmallText, null, t("product", "label.color"), ":", " ", /*#__PURE__*/ react.createElement(SelectionHighlightedText, null, selectedVariants)));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/color-variants/styles.ts
function color_variants_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function color_variants_styles_templateObject() {
    var data = color_variants_styles_taggedTemplateLiteral([
        "\n    width: max-content;\n    max-width: 340px;\n    margin: 0 ",
        ";\n  "
    ]);
    color_variants_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function color_variants_styles_templateObject1() {
    var data = color_variants_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: ",
        ";\n  width: 100%;\n  flex-wrap: wrap;\n\n  ",
        "\n"
    ]);
    color_variants_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function color_variants_styles_templateObject2() {
    var data = color_variants_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  padding: 1px;\n  order: ",
        ";\n"
    ]);
    color_variants_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function color_variants_styles_templateObject3() {
    var data = color_variants_styles_taggedTemplateLiteral([
        "\n      border: 1px solid ",
        ";\n    "
    ]);
    color_variants_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function color_variants_styles_templateObject4() {
    var data = color_variants_styles_taggedTemplateLiteral([
        "\n    width: ",
        ";\n    min-width: ",
        ";\n    height: ",
        ";\n    min-height: ",
        ";\n    border-radius: ",
        ";\n    background: ",
        ";\n\n    ",
        ";\n  "
    ]);
    color_variants_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var styles_VariantGridWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "VariantGridWrapper",
    componentId: "sc-0-0"
})(color_variants_styles_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.mediumUp */.BC.mediumUp(color_variants_styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050));
var styles_VariantGridCell = styled_components_browser_esm["default"].div.withConfig({
    displayName: "VariantGridCell",
    componentId: "sc-0-1"
})(color_variants_styles_templateObject2(), function(props) {
    return props.$order;
});
var StyledColorDot = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledColorDot",
    componentId: "sc-0-2"
})(function(props) {
    return (0,styled_components_browser_esm.css)(color_variants_styles_templateObject4(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, props.$hex, props.$hex === "#FFFFFF" && (0,styled_components_browser_esm.css)(color_variants_styles_templateObject3(), props.theme.colors.base300));
});

;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/color-variants/color-variant-selection-button.tsx






var ColorVariantSelectionButton = function(props) {
    var variant = props.variant, title = props.title, selection = props.selection, disabled = props.disabled, handleSelection = props.handleSelection, isMobile = props.isMobile;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var colorVal = getColor(variant);
    var buttonText = title !== null && title !== void 0 ? title : getColorTranslation(t, variant);
    var isSelected = Boolean(variant && (selection === null || selection === void 0 ? void 0 : selection.includes(variant)) || !variant && !selection);
    var onSelect = function() {
        return handleSelection(variant);
    };
    return /*#__PURE__*/ react.createElement(styles_VariantGridCell, {
        $order: colorVal.order
    }, /*#__PURE__*/ react.createElement(ui_button.Button, {
        onClick: onSelect,
        selectable: true,
        selected: isSelected,
        fullWidth: true,
        type: ui_button.ButtonType.OUTLINED,
        elevation: ui_button.ButtonElevation.NONE,
        disabled: disabled,
        size: isMobile ? ui_button.ButtonSize.NORMAL : ui_button.ButtonSize.SMALL
    }, /*#__PURE__*/ react.createElement(react.Fragment, null, colorVal.hex && /*#__PURE__*/ react.createElement(ui_button.ButtonIcon, null, /*#__PURE__*/ react.createElement(StyledColorDot, {
        $hex: colorVal.hex
    })), /*#__PURE__*/ react.createElement(ui_button.ButtonText, {
        behavior: ui_text.Behavior.OnelineEllipsis
    }, buttonText))));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/color-variants/color-variants-grid.tsx








var ColorVariantsGrid = function(props) {
    var title = props.title, variants = props.variants, handleSelection = props.handleSelection, isMobile = props.isMobile;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var getFilter = (0,offer_list_filter_context/* useOfferListFilterContext */.o)().getFilter;
    var filter = getFilter(types/* FilterType.VARIANT_COLOR */.vA.VARIANT_COLOR);
    var selection = (filter === null || filter === void 0 ? void 0 : filter.active) ? filter === null || filter === void 0 ? void 0 : filter.selection : undefined;
    var sortedVariants = variants === null || variants === void 0 ? void 0 : variants.filter(Boolean);
    return /*#__PURE__*/ react.createElement("div", null, title && /*#__PURE__*/ react.createElement(VariantGridTitle, null, /*#__PURE__*/ react.createElement(text_variants.H4Text, null, title)), /*#__PURE__*/ react.createElement(ScrollableArea, null, /*#__PURE__*/ react.createElement(styles_VariantGridWrapper, null, /*#__PURE__*/ react.createElement(styles_VariantGridCell, {
        $order: 0
    }, /*#__PURE__*/ react.createElement(ColorVariantSelectionButton, {
        variant: null,
        title: t("product", "variants.all"),
        selection: selection,
        handleSelection: handleSelection,
        isMobile: isMobile
    })), sortedVariants === null || sortedVariants === void 0 ? void 0 : sortedVariants.map(function(variant) {
        return /*#__PURE__*/ react.createElement(ColorVariantSelectionButton, {
            variant: variant.color,
            selection: selection,
            handleSelection: handleSelection,
            disabled: variant.disabled,
            key: variant.color,
            isMobile: isMobile
        });
    }))));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/color-variants/color-variants-desktop-version.tsx
function color_variants_desktop_version_extends() {
    color_variants_desktop_version_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return color_variants_desktop_version_extends.apply(this, arguments);
}









var ColorVariantsDesktopVersion = function(props) {
    return /*#__PURE__*/ react.createElement(dropdown/* Dropdown */.Lt, {
        zIndex: zindex/* zindex.overlay */.Y.overlay
    }, /*#__PURE__*/ react.createElement(DropdownToggle, {
        showActiveIcon: true,
        fullWidth: true,
        size: ui_button.ButtonSize.SMALL
    }, /*#__PURE__*/ react.createElement(DropdownButtonText, {
        behavior: ui_text.Behavior.OnelineEllipsis
    }, /*#__PURE__*/ react.createElement(ColorVariantsButtonLabel, null))), /*#__PURE__*/ react.createElement(dropdown/* DropdownContent */.Nv, {
        alignment: ui/* Direction.Down */.Nm.Down
    }, /*#__PURE__*/ react.createElement(ColorVariantsGrid, color_variants_desktop_version_extends({}, props))));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/color-variants/color-variants-mobile-version.tsx



var ColorVariantsMobileVersion = function(props) {
    var variants = props.variants, handleSelection = props.handleSelection, isMobile = props.isMobile;
    var t = (0,app_context/* useAppContext */.bp)().t;
    return /*#__PURE__*/ react.createElement(ColorVariantsGrid, {
        variants: variants,
        handleSelection: handleSelection,
        title: t("product", "label.color"),
        isMobile: isMobile
    });
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/color-variants/index.tsx






var color_variants_FILTER_TYPE = types/* FilterType.VARIANT_COLOR */.vA.VARIANT_COLOR;
var ColorVariants = function(props) {
    var distinctValues = props.distinctValues, isMobile = props.isMobile;
    var ref = (0,offer_list_filter_context/* useOfferListFilterContext */.o)(), getFilter = ref.getFilter, setFilterSelection = ref.setFilterSelection, toggleFilter = ref.toggleFilter;
    var filter = getFilter(color_variants_FILTER_TYPE);
    var selection = (filter === null || filter === void 0 ? void 0 : filter.active) && (filter === null || filter === void 0 ? void 0 : filter.selection) ? filter === null || filter === void 0 ? void 0 : filter.selection : [];
    var handleSelection = function(variant) {
        var newSelection = createNewSelection(variant, (selection === null || selection === void 0 ? void 0 : selection.length) ? selection : []);
        if ((filter === null || filter === void 0 ? void 0 : filter.active) && newSelection.length === 0) {
            toggleFilter(color_variants_FILTER_TYPE);
        } else {
            setFilterSelection(color_variants_FILTER_TYPE, newSelection);
        }
    };
    if (distinctValues.length <= 1) {
        return null;
    }
    return isMobile ? /*#__PURE__*/ react.createElement(ColorVariantsMobileVersion, {
        handleSelection: handleSelection,
        variants: distinctValues,
        isMobile: isMobile
    }) : /*#__PURE__*/ react.createElement(ColorVariantsDesktopVersion, {
        handleSelection: handleSelection,
        variants: distinctValues,
        isMobile: isMobile
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/dropdown-down/index.js
var dropdown_down = __webpack_require__(19258);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/dropdown-up/index.js
var dropdown_up = __webpack_require__(12641);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/modal/index.js
var modal = __webpack_require__(58709);
// EXTERNAL MODULE: ./src/components/modal-v2/index.tsx
var modal_v2 = __webpack_require__(54674);
// EXTERNAL MODULE: ./src/areas/product/utils/price-list/split-list.ts
var split_list = __webpack_require__(65596);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/light-theme-colors.js
var light_theme_colors = __webpack_require__(24774);
;// CONCATENATED MODULE: ./src/areas/product/components/product-filters/styles.ts
function product_filters_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function product_filters_styles_templateObject() {
    var data = product_filters_styles_taggedTemplateLiteral([
        "\n    margin: 0;\n  "
    ]);
    product_filters_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function product_filters_styles_templateObject1() {
    var data = product_filters_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  row-gap: ",
        ";\n\n  ",
        "\n"
    ]);
    product_filters_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function product_filters_styles_templateObject2() {
    var data = product_filters_styles_taggedTemplateLiteral([
        "\n  width: fit-content;\n"
    ]);
    product_filters_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function product_filters_styles_templateObject3() {
    var data = product_filters_styles_taggedTemplateLiteral([
        "\n  display: grid;\n  gap: ",
        ";\n"
    ]);
    product_filters_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function product_filters_styles_templateObject4() {
    var data = product_filters_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  column-gap: ",
        ";\n"
    ]);
    product_filters_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = product_filters_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  gap: ",
        ";\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = product_filters_styles_taggedTemplateLiteral([
        "\n  min-width: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = product_filters_styles_taggedTemplateLiteral([
        "\n  flex: 1;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = product_filters_styles_taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = product_filters_styles_taggedTemplateLiteral([
        "\n  ",
        "\n\n  span {\n    overflow: hidden;\n    max-width: 280px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = product_filters_styles_taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = product_filters_styles_taggedTemplateLiteral([
        "\n  z-index: ",
        ";\n  margin-bottom: ",
        ";\n\n  button > span {\n    overflow: hidden;\n    max-width: 280px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = product_filters_styles_taggedTemplateLiteral([
        "display: none"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = product_filters_styles_taggedTemplateLiteral([
        "\n    padding: ",
        " ",
        ";\n  "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = product_filters_styles_taggedTemplateLiteral([
        "\n  padding: ",
        " ",
        ";\n\n  ",
        "\n\n  ",
        "\n\n  a {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = product_filters_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: flex-end;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}






var FiltersWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FiltersWrapper",
    componentId: "sc-0-0"
})(product_filters_styles_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.mediumDown */.BC.mediumDown(product_filters_styles_templateObject()));
var Filter = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Filter",
    componentId: "sc-0-1"
})(product_filters_styles_templateObject2());
var StyledModalInner = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledModalInner",
    componentId: "sc-0-2"
})(product_filters_styles_templateObject3(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150);
var StyledIconImageText = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledIconImageText",
    componentId: "sc-0-3"
})(product_filters_styles_templateObject4(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledFooterInner = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledFooterInner",
    componentId: "sc-0-4"
})(styles_templateObject5(), base/* layout.measurements.spacing075 */.bK.measurements.spacing075);
var CLEAR_BTN_MIN_WIDTH = "120px";
var StyledClearButton = (0,styled_components_browser_esm["default"])(button_variants.TonalButton).withConfig({
    displayName: "StyledClearButton",
    componentId: "sc-0-5"
})(_templateObject6(), CLEAR_BTN_MIN_WIDTH);
var StyledPrimaryButton = (0,styled_components_browser_esm["default"])(button_variants.PrimaryButton).withConfig({
    displayName: "StyledPrimaryButton",
    componentId: "sc-0-6"
})(_templateObject7());
var OutlinedModalButton = (0,styled_components_browser_esm["default"])(button_variants.OutlinedButton).withConfig({
    displayName: "OutlinedModalButton",
    componentId: "sc-0-7"
})(_templateObject9(), base/* media.mediumUp */.BC.mediumUp(_templateObject8()));
var StyledRelationsDropDown = (0,styled_components_browser_esm["default"])(dropdown/* Dropdown */.Lt).withConfig({
    displayName: "StyledRelationsDropDown",
    componentId: "sc-0-8"
})(_templateObject11(), zindex/* zindex.overlay */.Y.overlay, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.smallDown */.BC.smallDown(_templateObject10()));
var RelationItem = styled_components_browser_esm["default"].div.withConfig({
    displayName: "RelationItem",
    componentId: "sc-0-9"
})(_templateObject14(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.spacing075 */.bK.measurements.spacing075, function(p) {
    return p.$selected && base/* media.mediumUp */.BC.mediumUp(_templateObject12());
}, base/* media.smallOnly */.BC.smallOnly(_templateObject13(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing075 */.bK.measurements.spacing075), light_theme_colors.maybeBlue700);
var ModalFooterContent = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ModalFooterContent",
    componentId: "sc-0-10"
})(_templateObject15());

;// CONCATENATED MODULE: ./src/areas/product/components/product-filters/utils/index.ts


var getVariantSelections = function(t, getFilter) {
    var sizes = getSelectionsString(t, getFilter(types/* FilterType.VARIANT_SIZE */.vA.VARIANT_SIZE));
    var colors = getSelectionsString(t, getFilter(types/* FilterType.VARIANT_COLOR */.vA.VARIANT_COLOR));
    return [
        sizes,
        colors
    ].filter(function(x) {
        return x;
    }).join(", ");
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-filters/modal-view.tsx
function modal_view_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function modal_view_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function modal_view_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function modal_view_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function modal_view_slicedToArray(arr, i) {
    return modal_view_arrayWithHoles(arr) || modal_view_iterableToArrayLimit(arr, i) || modal_view_unsupportedIterableToArray(arr, i) || modal_view_nonIterableRest();
}
function modal_view_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return modal_view_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return modal_view_arrayLikeToArray(o, minLen);
}















var ModalView = function(props) {
    var components = props.components;
    var ref = (0,app_context/* useAppContext */.bp)(), market = ref.market, t = ref.t;
    var ref1 = (0,offer_list_filter_context/* useOfferListFilterContext */.o)(), getActiveFilters = ref1.getActiveFilters, getFilter = ref1.getFilter, resetFiltersByPlacement = ref1.resetFiltersByPlacement;
    var offers = (0,product_context/* useProductContext */.$h)().offers;
    var selections = getVariantSelections(t, getFilter);
    var ref2 = modal_view_slicedToArray((0,react.useState)(false), 2), visible = ref2[0], setVisible = ref2[1];
    var closeHandler = function() {
        return setVisible(false);
    };
    var toggleHandler = function() {
        return setVisible(!visible);
    };
    var filterHits = (0,split_list/* getSplitOfferlist */.Z1)(offers.filteredOffers, getActiveFilters()).mainList.length;
    var renderButtonLabel = function() {
        var singleComponentWithCustomButton = components.length === 1 && components[0].buttonLabelComponent;
        if (singleComponentWithCustomButton) {
            // For single variant selection
            return /*#__PURE__*/ react.createElement(react.Fragment, null, singleComponentWithCustomButton, /*#__PURE__*/ react.createElement(button_variants.ButtonIcon, null, visible ? /*#__PURE__*/ react.createElement(dropdown_up.IconDropdownUp, null) : /*#__PURE__*/ react.createElement(dropdown_down.IconDropdownDown, null)));
        }
        return /*#__PURE__*/ react.createElement(StyledIconImageText, null, /*#__PURE__*/ react.createElement("img", {
            src: "".concat(market.cdn, "/g/rfe/illustrations/icon-color-wheel-20x20px.png"),
            srcSet: "".concat(market.cdn, "/g/rfe/illustrations/icon-color-wheel-20x20px.png 1x, ").concat(market.cdn, "/g/rfe/illustrations/icon-color-wheel-40x40px.png 2x"),
            alt: ""
        }), /*#__PURE__*/ react.createElement(text_variants.TitleSmallText, {
            behavior: text_variants.Behavior.OnelineEllipsis
        }, t("product", "variants.select-variants"), Boolean(selections) && /*#__PURE__*/ react.createElement(SelectionHighlightedText, null, " (", selections, ")")));
    };
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(button_variants.OutlinedButton, {
        onClick: toggleHandler,
        fullWidth: true,
        selectable: true
    }, renderButtonLabel()), visible && /*#__PURE__*/ react.createElement(modal_v2/* default */.Z, {
        isOpen: true,
        onRequestClose: closeHandler,
        title: t("product", "variants.select-variants")
    }, /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(modal/* ModalBody */.fe, null, /*#__PURE__*/ react.createElement(StyledModalInner, null, components.map(function(component) {
        return /*#__PURE__*/ react.createElement("div", {
            key: component.key
        }, component.selectorComponent);
    }))), /*#__PURE__*/ react.createElement(modal/* ModalFooter */.mz, null, /*#__PURE__*/ react.createElement(StyledFooterInner, null, /*#__PURE__*/ react.createElement(StyledClearButton, {
        onClick: function() {
            return resetFiltersByPlacement(types/* FilterUIPlacementEnum.PRODUCT_HEADER */.jm.PRODUCT_HEADER);
        }
    }, t("common", "button.clear")), /*#__PURE__*/ react.createElement(StyledPrimaryButton, {
        onClick: closeHandler
    }, t("product", "prices.filter-offers-count", {
        n: filterHits ? String(filterHits) : "0"
    })))))));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/utils/common.ts
function common_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function common_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return common_arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function common_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function common_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function common_toConsumableArray(arr) {
    return common_arrayWithoutHoles(arr) || common_iterableToArray(arr) || common_unsupportedIterableToArray(arr) || common_nonIterableSpread();
}
function common_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return common_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return common_arrayLikeToArray(o, minLen);
}

var getVariantProp = function(variantType, variant) {
    switch(variantType){
        case types/* FilterType.VARIANT_SIZE */.vA.VARIANT_SIZE:
            return variant.size;
        case types/* FilterType.VARIANT_COLOR */.vA.VARIANT_COLOR:
            return variant.color;
        default:
            return "";
    }
};
var getDistinct = function(variantType, values) {
    if (variantType === types/* FilterType.VARIANT_SIZE */.vA.VARIANT_SIZE) {
        return common_toConsumableArray(new Map(values.filter(function(v) {
            return v.size;
        }).map(function(item) {
            return [
                item.size,
                item
            ];
        })).values());
    }
    if (variantType === types/* FilterType.VARIANT_COLOR */.vA.VARIANT_COLOR) {
        return common_toConsumableArray(new Map(values.filter(function(v) {
            return v.color;
        }).map(function(item) {
            return [
                item.color,
                item
            ];
        })).values());
    }
    return [];
};
var getValuesFromVariant = function(variantType, variant) {
    var ref;
    var values = [];
    if (variantType === types/* FilterType.VARIANT_SIZE */.vA.VARIANT_SIZE && (variant === null || variant === void 0 ? void 0 : variant.size) && (variant === null || variant === void 0 ? void 0 : variant.sizeSystem)) {
        var val = {
            size: variant === null || variant === void 0 ? void 0 : variant.size,
            sizeSystem: variant === null || variant === void 0 ? void 0 : variant.sizeSystem
        };
        values.push(val);
    }
    if (variantType === types/* FilterType.VARIANT_COLOR */.vA.VARIANT_COLOR && (variant === null || variant === void 0 ? void 0 : variant.colors) && (variant === null || variant === void 0 ? void 0 : (ref = variant.colors) === null || ref === void 0 ? void 0 : ref.length) > 0) {
        variant === null || variant === void 0 ? void 0 : variant.colors.forEach(function(color) {
            values.push({
                color: color
            });
        });
    }
    return values;
};
var disableVariantValues = function(variantType, allVariantValues, currentVariantValues) {
    return allVariantValues.map(function(variant) {
        return _objectSpreadProps(_objectSpread({}, variant), {
            disabled: !currentVariantValues.some(function(current) {
                return getVariantProp(variantType, variant) === getVariantProp(variantType, current);
            })
        });
    });
};
var getDistinctVariantValues = function(variantType, offers) {
    var allValues = [];
    offers.forEach(function(offer) {
        var ref;
        var values = getValuesFromVariant(variantType, offer.variantInfo);
        if (values.length > 0) {
            var _allValues;
            (_allValues = allValues).push.apply(_allValues, common_toConsumableArray(values));
        }
        (ref = offer.alternativePrices) === null || ref === void 0 ? void 0 : ref.forEach(function(alt) {
            var altValues = getValuesFromVariant(variantType, alt === null || alt === void 0 ? void 0 : alt.variantInfo);
            if (altValues.length > 0) {
                var _allValues;
                (_allValues = allValues).push.apply(_allValues, common_toConsumableArray(altValues));
            }
        });
    });
    return getDistinct(variantType, allValues);
};
var getVariantValues = function(variantType, filteredOffers, allOffers) {
    var filteredVariantsValues = getDistinctVariantValues(variantType, filteredOffers);
    var allVariantValues = getDistinctVariantValues(variantType, allOffers);
    return disableVariantValues(variantType, allVariantValues, filteredVariantsValues);
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/color-variants/utils/whitelist.ts
var ENABLED_MARKETS = [
    "se",
    "no",
    "fi",
    "fr",
    "gb"
];
var CATEGORY_WHITE_LIST = [
    "1944",
    "148",
    "1827",
    "707",
    "1594",
    "401",
    "2621",
    "1349",
    "1351",
    "767",
    "769",
    "770",
    "1987",
    "2062",
    "1915",
    "2251",
    "3273",
    "2222",
    "2040",
    "551",
    "1110",
    "1918",
    "2027",
    "3215",
    "2086",
    "3172",
    "1153",
    "1166",
    "1327",
    "1326",
    "1325",
    "1152",
    "2019",
    "3187",
    "2020",
    "2021",
    "103",
    "879",
    "1808",
    "1792",
    "2668",
    "2741",
    "1973",
    "2760",
    "2395",
    "2047",
    "2772",
    "2774",
    "917",
    "3582",
    "3437",
    "3439",
    "2401",
    "1155",
    "2064",
    "1672",
    "1726",
    "2603",
    "1634",
    "1629",
    "3533",
    "1182",
    "1869",
    "1180",
    "1512",
    "1621",
    "3541",
    "1406",
    "1976",
    "1401",
    "1402",
    "1405",
    "1914",
    "1754",
    "2",
    "5130"
];
var isWhitelistedForColors = function(market, category) {
    var ref, ref1;
    if (!ENABLED_MARKETS.some(function(code) {
        return code === market.code;
    })) {
        return false;
    }
    return Boolean((category === null || category === void 0 ? void 0 : (ref = category.path) === null || ref === void 0 ? void 0 : ref.length) && (category === null || category === void 0 ? void 0 : (ref1 = category.path) === null || ref1 === void 0 ? void 0 : ref1.some(function(categoryPath) {
        return CATEGORY_WHITE_LIST.includes(categoryPath.id);
    })));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/size-variants/utils/whitelist.ts
var WHITE_LIST = [
    "1944"
];
var isWhitelistedForSizes = function(category) {
    var ref, ref1;
    return Boolean((category === null || category === void 0 ? void 0 : (ref = category.path) === null || ref === void 0 ? void 0 : ref.length) && (category === null || category === void 0 ? void 0 : (ref1 = category.path) === null || ref1 === void 0 ? void 0 : ref1.some(function(categoryPath) {
        return WHITE_LIST.includes(categoryPath.id);
    })));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-variants/color-variants/utils/blacklist.ts
var BLACK_LIST = [
    "401"
];
var isBlacklistedForColors = function(category) {
    var ref, ref1;
    return Boolean((category === null || category === void 0 ? void 0 : (ref = category.path) === null || ref === void 0 ? void 0 : ref.length) && (category === null || category === void 0 ? void 0 : (ref1 = category.path) === null || ref1 === void 0 ? void 0 : ref1.some(function(categoryPath) {
        return BLACK_LIST.includes(categoryPath.id);
    })));
};

// EXTERNAL MODULE: ./src/hooks/experiments.ts
var experiments = __webpack_require__(46353);
;// CONCATENATED MODULE: ./src/areas/product/components/product-filters/product-filter-components.tsx

















var ProductFilterComponents = function(props) {
    var isMobile = props.isMobile;
    var market = (0,app_context/* useAppContext */.bp)().market;
    var product = (0,product_context/* useProductContext */.$h)().product;
    var allOffers = (0,product_context/* useProductContext */.$h)().allOffers;
    var getActiveFilters = (0,offer_list_filter_context/* useOfferListFilterContext */.o)().getActiveFilters;
    var showAllVariantsExperiment = (0,experiments/* useShowAllVariantsExperiment */.U_)();
    var components = [];
    var getValuesForVariantFilterType = function(variantFilter) {
        // Values should be based on all offers found in current filtered offerlist
        var activeFilters = getActiveFilters();
        // But we want to keep offers that are filtered out based on the selection of the specified variant
        var filtersExclSpecifiedType = activeFilters.filter(function(f) {
            return f.type !== variantFilter;
        });
        var filteredOffers = (0,filtering/* filterOffers */.h)(filtersExclSpecifiedType, product.prices);
        return getVariantValues(variantFilter, filteredOffers, allOffers);
    };
    var CreateSizeVariantsComponent = function() {
        var show = showAllVariantsExperiment || isWhitelistedForSizes(product.category);
        if (!show) {
            return;
        }
        var variantValues = getValuesForVariantFilterType(types/* FilterType.VARIANT_SIZE */.vA.VARIANT_SIZE);
        if (allOffers.length > 1 && variantValues.length > 1) {
            components.push({
                key: "size-variants",
                buttonLabelComponent: /*#__PURE__*/ react.createElement(SizeVariantsButtonLabel, null),
                selectorComponent: /*#__PURE__*/ react.createElement(SizeVariants, {
                    distinctValues: variantValues,
                    isMobile: isMobile
                })
            });
        }
    };
    CreateSizeVariantsComponent();
    var CreateColorVariantsComponent = function() {
        var show = showAllVariantsExperiment || isWhitelistedForColors(market, product.category) && !isBlacklistedForColors(product.category);
        if (!show) {
            return;
        }
        var variantValues = getValuesForVariantFilterType(types/* FilterType.VARIANT_COLOR */.vA.VARIANT_COLOR);
        if (allOffers.length > 1 && variantValues.length > 1) {
            components.push({
                key: "color-variants",
                buttonLabelComponent: /*#__PURE__*/ react.createElement(ColorVariantsButtonLabel, null),
                selectorComponent: /*#__PURE__*/ react.createElement(ColorVariants, {
                    distinctValues: variantValues,
                    isMobile: isMobile
                })
            });
        }
    };
    CreateColorVariantsComponent();
    var hasComponents = components.length > 0;
    var onlyConditionComponentVisible = components.length === 1 && components.find(function(c) {
        return c.key === "conditions";
    });
    var showModal = isMobile && hasComponents && !onlyConditionComponentVisible;
    return showModal ? /*#__PURE__*/ react.createElement(ModalView, {
        components: components
    }) : /*#__PURE__*/ react.createElement(react.Fragment, null, components.map(function(component) {
        return /*#__PURE__*/ react.createElement(Filter, {
            key: component.key
        }, component.selectorComponent);
    }));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
;// CONCATENATED MODULE: ./src/areas/product/components/product-filters/relations-dropdown.tsx
function relations_dropdown_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function relations_dropdown_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function relations_dropdown_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function relations_dropdown_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function relations_dropdown_slicedToArray(arr, i) {
    return relations_dropdown_arrayWithHoles(arr) || relations_dropdown_iterableToArrayLimit(arr, i) || relations_dropdown_unsupportedIterableToArray(arr, i) || relations_dropdown_nonIterableRest();
}
function relations_dropdown_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return relations_dropdown_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return relations_dropdown_arrayLikeToArray(o, minLen);
}









var RelationsDropdown = function(param) {
    var relationType = param.relationType, title = param.title;
    var ref = relations_dropdown_slicedToArray((0,react.useState)(), 2), relationItems = ref[0], setRelationItems = ref[1];
    var ref1 = relations_dropdown_slicedToArray((0,react.useState)(), 2), selected = ref1[0], setSelected = ref1[1];
    var ref2 = relations_dropdown_slicedToArray((0,react.useState)(false), 2), isOpen = ref2[0], setIsOpen = ref2[1];
    var product = (0,product_context/* useProductContext */.$h)().product;
    (0,react.useEffect)(function() {
        var ref;
        if (!(product === null || product === void 0 ? void 0 : product.relations) || ((ref = product.relations) === null || ref === void 0 ? void 0 : ref.length) <= 0) {
            return;
        }
        getRelationList();
    }, []);
    var getRelationList = function() {
        var ref, ref1;
        var relations = (ref1 = (ref = product.relations) === null || ref === void 0 ? void 0 : ref.filter(function(relation) {
            return relation.type === relationType;
        })[0]) === null || ref1 === void 0 ? void 0 : ref1.relations.filter(function(item) {
            return item.sortPriority !== 0;
        }).sort(function(a, b) {
            return a.sortPriority - b.sortPriority;
        });
        if (!relations) {
            return;
        }
        setSelected(relations.filter(function(item) {
            return item.selected;
        })[0]);
        setRelationItems(relations);
    };
    if (!selected || !relationItems || relationItems.length <= 1) {
        return null;
    }
    var renderRelationList = function() {
        var items = relationItems === null || relationItems === void 0 ? void 0 : relationItems.map(function(item) {
            var ref;
            var searchEncoded = encodeURIComponent(item.name);
            var categoryEncoded = encodeURIComponent("pc:".concat((ref = product.category) === null || ref === void 0 ? void 0 : ref.pathName.replace("/c/", "")));
            var link = "search?search=".concat(searchEncoded, "&category_id=").concat(categoryEncoded);
            return /*#__PURE__*/ react.createElement(RelationItem, {
                key: item.name
            }, /*#__PURE__*/ react.createElement(text_variants.TitleSmallText, null, "Del ".concat(item.sortPriority, ": "), /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
                to: link
            }, item.name)));
        });
        return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(RelationItem, {
            $selected: true
        }, /*#__PURE__*/ react.createElement(text_variants.TitleSmallText, null, "Del ".concat(selected.sortPriority, ": ").concat(selected.name))), items);
    };
    var renderContent = function() {
        return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(RelationItem, null, /*#__PURE__*/ react.createElement(text_variants.H4Text, null, title)), renderRelationList());
    };
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(modal/* Modal */.u_, {
        isOpen: isOpen,
        onRequestClose: function() {
            return setIsOpen(false);
        },
        title: title
    }, renderRelationList(), /*#__PURE__*/ react.createElement(modal/* ModalFooter */.mz, null, /*#__PURE__*/ react.createElement(ModalFooterContent, null, /*#__PURE__*/ react.createElement(button_variants.TonalButton, {
        onClick: function() {
            return setIsOpen(false);
        }
    }, "Close")))), /*#__PURE__*/ react.createElement(OutlinedModalButton, {
        onClick: function() {
            return setIsOpen(true);
        }
    }, /*#__PURE__*/ react.createElement("span", null, /*#__PURE__*/ react.createElement(text_variants.TitleSmallText, null, "Del ".concat(selected.sortPriority, ": ")), /*#__PURE__*/ react.createElement(text_variants.TitleSmallText, {
        color: text_variants.FontColor.PRIMARY
    }, selected.name)), /*#__PURE__*/ react.createElement(dropdown_down.IconDropdownDown, null)), /*#__PURE__*/ react.createElement(StyledRelationsDropDown, null, /*#__PURE__*/ react.createElement(dropdown/* DropdownToggle */.Z_, {
        showActiveIcon: true
    }, /*#__PURE__*/ react.createElement("span", null, /*#__PURE__*/ react.createElement(text_variants.TitleSmallText, null, "Del ".concat(selected.sortPriority, ": ")), /*#__PURE__*/ react.createElement(text_variants.TitleSmallText, {
        color: text_variants.FontColor.PRIMARY
    }, selected.name))), /*#__PURE__*/ react.createElement(dropdown/* DropdownContent */.Nv, {
        height: 280,
        width: 320
    }, renderContent())));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-filters/index.tsx






var ProductFilters = function() {
    var market = (0,app_context/* useAppContext */.bp)().market;
    var renderProductFilterComponents = function(isMobile) {
        return /*#__PURE__*/ react.createElement(FiltersWrapper, null, /*#__PURE__*/ react.createElement(ProductFilterComponents, {
            isMobile: isMobile
        }));
    };
    return /*#__PURE__*/ react.createElement(react.Fragment, null, market.code === "se" && /*#__PURE__*/ react.createElement(RelationsDropdown, {
        title: "Delar i serien",
        relationType: "Book series SE/Sweden"
    }), /*#__PURE__*/ react.createElement(block/* MediumUp */.TD, null, renderProductFilterComponents(false)), /*#__PURE__*/ react.createElement(block/* MobileOnly */.iB, null, renderProductFilterComponents(true)));
};

// EXTERNAL MODULE: ./src/components/error-boundary/index.tsx + 1 modules
var error_boundary = __webpack_require__(77078);
// EXTERNAL MODULE: ./src/components/rating/index.tsx + 1 modules
var rating = __webpack_require__(9160);
// EXTERNAL MODULE: ./src/components/rating/rating-helper.ts
var rating_helper = __webpack_require__(46626);
// EXTERNAL MODULE: ./src/components/rating/star-icons.tsx
var star_icons = __webpack_require__(89602);
// EXTERNAL MODULE: ./src/components/sentiment-badge/index.js + 1 modules
var sentiment_badge = __webpack_require__(23428);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 24 modules
var es = __webpack_require__(95939);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/image/index.js
var icon_image = __webpack_require__(24297);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/play-circle-outlined/index.js
var play_circle_outlined = __webpack_require__(68716);
// EXTERNAL MODULE: ./src/components/badges/image-badges.tsx
var image_badges = __webpack_require__(39986);
// EXTERNAL MODULE: ./src/components/product-of-the-year/hooks.ts
var hooks = __webpack_require__(78060);
// EXTERNAL MODULE: ./src/areas/product/components/product-media-lightbox/index.ts
var product_media_lightbox = __webpack_require__(50547);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/areas/product/components/product-media/media-counter.js
function media_counter_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function media_counter_templateObject() {
    var data = media_counter_taggedTemplateLiteral([
        "\n  display: inline-block;\n  margin-left: 5px;\n  margin-right: 5px;\n\n  > svg {\n    margin-right: 2px;\n    vertical-align: -4px;\n\n    path {\n      fill: currentColor;\n    }\n  }\n"
    ]);
    media_counter_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Wrapper = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-0"
})(media_counter_templateObject());
var MediaCounter = function(param) {
    var Icon = param.icon, mediaList = param.mediaList;
    return mediaList && mediaList.length > 0 ? /*#__PURE__*/ react.createElement(Wrapper, null, /*#__PURE__*/ react.createElement(Icon, {
        size: 18
    }), mediaList.length) : null;
};
MediaCounter.propTypes = {
    icon: (prop_types_default()).any.isRequired,
    mediaList: (prop_types_default()).array
};
MediaCounter.defaultProps = {
    mediaList: null
};
/* harmony default export */ const media_counter = (MediaCounter);

// EXTERNAL MODULE: ./src/areas/product/actions/media.js
var actions_media = __webpack_require__(82005);
;// CONCATENATED MODULE: ./src/areas/product/components/product-media/styles.ts
function product_media_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function product_media_styles_templateObject() {
    var data = product_media_styles_taggedTemplateLiteral([
        "\n      opacity: 0.2;\n      max-height: 100%;\n      max-width: 100%;\n    "
    ]);
    product_media_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function product_media_styles_templateObject1() {
    var data = product_media_styles_taggedTemplateLiteral([
        "\n      cursor: pointer;\n    "
    ]);
    product_media_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function product_media_styles_templateObject2() {
    var data = product_media_styles_taggedTemplateLiteral([
        "\n    width: 100px;\n    height: 100px;\n  "
    ]);
    product_media_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function product_media_styles_templateObject3() {
    var data = product_media_styles_taggedTemplateLiteral([
        "\n  width: 200px;\n  height: 210px;\n  position: relative;\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    product_media_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function product_media_styles_templateObject4() {
    var data = product_media_styles_taggedTemplateLiteral([
        "\n  max-width: 200px;\n  max-height: 200px;\n"
    ]);
    product_media_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function product_media_styles_templateObject5() {
    var data = product_media_styles_taggedTemplateLiteral([
        "\n  padding: 5px 5px;\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  background-color: rgba(255, 255, 255, 0.8);\n  border-radius: 5px;\n  transform: translate(-50%, 0);\n  color: ",
        ";\n  white-space: nowrap; /* Prevent wrapping in mobile mode (kludge) */\n"
    ]);
    product_media_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var StyledProductMedia = styled_components_browser_esm["default"].button.withConfig({
    displayName: "StyledProductMedia",
    componentId: "sc-0-0"
})(product_media_styles_templateObject3(), function(props) {
    return props.$isFallbackImage && (0,styled_components_browser_esm.css)(product_media_styles_templateObject());
}, function(props) {
    return props.$more && (0,styled_components_browser_esm.css)(product_media_styles_templateObject1());
}, base/* media.smallOnly */.BC.smallOnly(product_media_styles_templateObject2()));
var StyledFirstImage = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledFirstImage",
    componentId: "sc-0-1"
})(product_media_styles_templateObject4());
var StyledCounters = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledCounters",
    componentId: "sc-0-2"
})(product_media_styles_templateObject5(), function(p) {
    return p.theme.colors.base500;
});

// EXTERNAL MODULE: ./src/hooks/use-gql-query.ts
var use_gql_query = __webpack_require__(63113);
// EXTERNAL MODULE: ./src/areas/product/components/product-media/query.graphql
var query_graphql = __webpack_require__(50536);
var query_graphql_default = /*#__PURE__*/__webpack_require__.n(query_graphql);
;// CONCATENATED MODULE: ./src/areas/product/components/product-media/use-product-media.ts


function useProductMedia(variables) {
    return (0,use_gql_query/* useGqlQuery */.n)({
        queryKey: [
            "product",
            "media"
        ],
        query: (query_graphql_default()),
        variables: variables
    });
}

;// CONCATENATED MODULE: ./src/areas/product/components/expert-review-badge/styles.tsx
function expert_review_badge_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function expert_review_badge_styles_templateObject() {
    var data = expert_review_badge_styles_taggedTemplateLiteral([
        "\n    width: 2rem\n  "
    ]);
    expert_review_badge_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function expert_review_badge_styles_templateObject1() {
    var data = expert_review_badge_styles_taggedTemplateLiteral([
        "\n  width: 3.5rem;\n  position: absolute;\n  right: 0;\n  top: 0;\n  ",
        "\n"
    ]);
    expert_review_badge_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var StyledExpertReviewBadge = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledExpertReviewBadge",
    componentId: "sc-0-0"
})(expert_review_badge_styles_templateObject1(), base/* media.smallDown */.BC.smallDown(expert_review_badge_styles_templateObject()));

;// CONCATENATED MODULE: ./src/areas/product/components/expert-review-badge/index.tsx



var ExpertReviewBadge = function() {
    var market = (0,react.useContext)(app_context/* AppContext */.Il).market;
    var logo = "".concat(market.cdn, "/g/expert/").concat(market.code, "/expert-toprated-badge.png");
    return /*#__PURE__*/ react.createElement(StyledExpertReviewBadge, null, /*#__PURE__*/ react.createElement("img", {
        src: logo,
        alt: ""
    }));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-media/index.tsx
function product_media_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function product_media_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function product_media_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function product_media_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function product_media_slicedToArray(arr, i) {
    return product_media_arrayWithHoles(arr) || product_media_iterableToArrayLimit(arr, i) || product_media_unsupportedIterableToArray(arr, i) || product_media_nonIterableRest();
}
function product_media_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return product_media_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return product_media_arrayLikeToArray(o, minLen);
}













var ProductMedia = function(props) {
    var ref, ref1, ref2, ref3;
    var id = props.id, category = props.category, className = props.className, name = props.name, _isExpertTopRated = props.isExpertTopRated, isExpertTopRated = _isExpertTopRated === void 0 ? false : _isExpertTopRated;
    var data = useProductMedia({
        id: id
    }).data;
    var ref4 = product_media_slicedToArray((0,react.useState)(false), 2), show = ref4[0], setShow = ref4[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var media = data === null || data === void 0 ? void 0 : (ref = data.product) === null || ref === void 0 ? void 0 : ref.media;
    // Filters out null values in arrays
    var images = media === null || media === void 0 ? void 0 : (ref1 = media.images) === null || ref1 === void 0 ? void 0 : ref1.filter(function(item) {
        return item;
    });
    var large = media === null || media === void 0 ? void 0 : (ref2 = media.large) === null || ref2 === void 0 ? void 0 : ref2.filter(function(item) {
        return item;
    });
    var videos = media === null || media === void 0 ? void 0 : (ref3 = media.videos) === null || ref3 === void 0 ? void 0 : ref3.filter(function(item) {
        return item;
    });
    var hasLightboxContent = function() {
        return Boolean((large === null || large === void 0 ? void 0 : large.length) || (videos === null || videos === void 0 ? void 0 : videos.length));
    };
    var open = function() {
        if (!hasLightboxContent()) {
            return;
        }
        setShow(true);
        dispatch((0,actions_media/* productMediaOpen */.WI)());
    };
    var close = function() {
        return setShow(false);
    };
    var product = (0,product_context/* useProductContext */.$h)().product;
    var productOfTheYearAward = (0,hooks/* useGetProductOfTheYear */.i)(product.id);
    if (!media) {
        return /*#__PURE__*/ react.createElement(StyledProductMedia, {
            className: className,
            "data-test": "ProductMedia",
            "data-test-has-lightbox-content": false,
            $isFallbackImage: false,
            $more: false
        });
    }
    return /*#__PURE__*/ react.createElement(react.Fragment, null, show && /*#__PURE__*/ react.createElement(product_media_lightbox/* default */.Z, {
        media: media,
        close: close
    }), /*#__PURE__*/ react.createElement(StyledProductMedia, {
        className: className,
        onClick: open,
        "data-test": "ProductMedia",
        "data-test-has-lightbox-content": hasLightboxContent(),
        $isFallbackImage: !(media === null || media === void 0 ? void 0 : media.first),
        $more: Boolean(images)
    }, (productOfTheYearAward === null || productOfTheYearAward === void 0 ? void 0 : productOfTheYearAward.awardLogo) && /*#__PURE__*/ react.createElement(image_badges/* ProductHeaderImageBadge */.ER, {
        badgeUrl: productOfTheYearAward.awardLogo,
        title: "".concat(productOfTheYearAward.awardName, " ").concat(productOfTheYearAward.year)
    }), /*#__PURE__*/ react.createElement(StyledFirstImage, null, /*#__PURE__*/ react.createElement("img", {
        src: media.first || (category === null || category === void 0 ? void 0 : category.logo) || undefined,
        alt: name
    })), isExpertTopRated && !productOfTheYearAward ? /*#__PURE__*/ react.createElement(ExpertReviewBadge, null) : null, (images || videos) && /*#__PURE__*/ react.createElement(StyledCounters, null, /*#__PURE__*/ react.createElement(media_counter, {
        icon: icon_image/* IconImage */.Z,
        mediaList: images
    }), /*#__PURE__*/ react.createElement(media_counter, {
        icon: play_circle_outlined/* IconPlayCircleOutlined */.o,
        mediaList: videos
    }))));
};

// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(58912);
// EXTERNAL MODULE: ./src/areas/product/components/product-tabs/types.ts
var product_tabs_types = __webpack_require__(84870);
;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/LinkToReviews.tsx





var LinkToReviewsComponent = function(param) {
    var children = param.children;
    var location = (0,react_router_dom/* useLocation */.TH)();
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var to = "".concat(location.pathname).concat(location.search).concat(product_tabs_types/* TabAnchor.REVIEWS */.X.REVIEWS);
    var onClick = function() {
        (0,tracking/* trackInternalNavigationClick */.p)({
            scope: tracking/* InternalNavigationScope.PRODUCT_HEADER */.U.PRODUCT_HEADER,
            nextPage: to
        });
    };
    return /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
        to: to,
        onClick: onClick,
        "aria-label": t("product", "tabs.reviews")
    }, children);
};
var LinkToReviews = /*#__PURE__*/ (0,react.memo)(LinkToReviewsComponent);

// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@5.2.1_react@18.2.0/node_modules/react-router/esm/react-router.js + 3 modules
var react_router = __webpack_require__(14727);
// EXTERNAL MODULE: ./src/areas/expert/components/expert-user-card/index.tsx + 1 modules
var expert_user_card = __webpack_require__(9131);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/arrow-right/index.js
var arrow_right = __webpack_require__(86401);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/index.js
var design_tokens = __webpack_require__(43220);
;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/header-desktop/expert-content-link/styles.ts
function expert_content_link_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function expert_content_link_styles_templateObject() {
    var data = expert_content_link_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  margin-top: ",
        ";\n"
    ]);
    expert_content_link_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function expert_content_link_styles_templateObject1() {
    var data = expert_content_link_styles_taggedTemplateLiteral([
        "\n    display: flex;\n    gap: ",
        ";\n    align-items: center;\n    background: ",
        ";\n    padding: ",
        ";\n    padding-right: ",
        ";\n    border-radius: 20px;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  "
    ]);
    expert_content_link_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var StyledLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "StyledLink",
    componentId: "sc-0-0"
})(expert_content_link_styles_templateObject(), design_tokens.measurements.spacing075);
var StyledContent = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledContent",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(expert_content_link_styles_templateObject1(), design_tokens.measurements.spacing050, props.theme.colors.informative100, design_tokens.measurements.spacing025, design_tokens.measurements.spacing100);
});

;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/header-desktop/expert-content-link/index.tsx
function expert_content_link_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function expert_content_link_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            expert_content_link_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function expert_content_link_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function expert_content_link_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        expert_content_link_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}









var ProductHeaderExpertLink = function() {
    var ref, ref1;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var product = (0,product_context/* useProductContext */.$h)().product;
    var ref2 = (0,react_router/* useLocation */.TH)(), pathname = ref2.pathname, search = ref2.search;
    var experts = (ref = product.expertContent) === null || ref === void 0 ? void 0 : (ref1 = ref.experts) === null || ref1 === void 0 ? void 0 : ref1.map(function(x) {
        return expert_content_link_objectSpreadProps(expert_content_link_objectSpread({}, x), {
            url: undefined
        });
    }).slice(0, 2); // Show maximum two expert avatars
    if (!(experts === null || experts === void 0 ? void 0 : experts.length)) return null;
    var expertLink = "".concat(pathname).concat(search, "#experts");
    return /*#__PURE__*/ react.createElement(StyledLink, {
        to: expertLink,
        onClick: function() {
            (0,tracking/* trackInternalNavigationClick */.p)({
                scope: tracking/* InternalNavigationScope.PRODUCT_HEADER */.U.PRODUCT_HEADER,
                nextPage: expertLink
            });
        }
    }, /*#__PURE__*/ react.createElement(StyledContent, null, /*#__PURE__*/ react.createElement(expert_user_card/* ExpertUserCard */.E, {
        customTitle: /*#__PURE__*/ react.createElement(text_variants.CaptionText, {
            emphasis: text_variants.FontEmphasis.HIGH
        }, t("product", "expert.header-link")),
        experts: experts
    }), /*#__PURE__*/ react.createElement(arrow_right/* IconArrowRight */.E, {
        size: 16
    })));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/badge/index.js
var ui_badge = __webpack_require__(29242);
// EXTERNAL MODULE: ./src/areas/product/actions/product.ts + 1 modules
var product = __webpack_require__(36483);
;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/header-desktop/rank-badge.tsx
function rank_badge_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function rank_badge_templateObject() {
    var data = rank_badge_taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    rank_badge_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function rank_badge_templateObject1() {
    var data = rank_badge_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  cursor: pointer;\n  outline: none;\n\n  &:hover,\n  &:focus {\n    color: ",
        ";\n  }\n"
    ]);
    rank_badge_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var RankBadge = function(props) {
    var category = props.category, isExperiment = props.isExperiment, rank = props.rank;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleRankCategoryClick = function() {
        return dispatch((0,product/* headerClickEvent */.Yc)("rank-category"));
    };
    var renderBadge = function(linkLocation) {
        if (!rank) return null;
        var badge = /*#__PURE__*/ react.createElement(ui_badge.Badge, {
            color: isExperiment ? "BLUE_INVERTED" : "GREY",
            key: "categoryRank",
            text: t("product", "rank.position", {
                rank: /*#__PURE__*/ react.createElement("span", {
                    key: "rank"
                }, rank)
            })
        });
        if (!linkLocation) {
            return badge;
        }
        return /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
            to: linkLocation
        }, badge);
    };
    return /*#__PURE__*/ react.createElement(StyledRankBadge, null, /*#__PURE__*/ react.createElement(Link, {
        to: category.pathName,
        key: "categoryLink",
        onClick: handleRankCategoryClick
    }, renderBadge()));
};
var StyledRankBadge = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledRankBadge",
    componentId: "sc-0-0"
})(rank_badge_templateObject(), function(p) {
    return p.theme.colors.base600;
});
var Link = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "Link",
    componentId: "sc-0-1"
})(rank_badge_templateObject1(), function(p) {
    return p.theme.colors.maybeBlue700;
}, function(p) {
    return p.theme.colors.maybeBlue500;
});

// EXTERNAL MODULE: ./src/areas/product/components/product-price-history/index.tsx + 1 modules
var product_price_history = __webpack_require__(30702);
// EXTERNAL MODULE: ./src/components/currency/index.tsx
var currency = __webpack_require__(49763);
;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/header-desktop/price-history-summary/styles.ts
function price_history_summary_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function price_history_summary_styles_templateObject() {
    var data = price_history_summary_styles_taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    gap: ",
        ";\n  "
    ]);
    price_history_summary_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function price_history_summary_styles_templateObject1() {
    var data = price_history_summary_styles_taggedTemplateLiteral([
        "\n  display: none;\n\n  ",
        "\n"
    ]);
    price_history_summary_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function price_history_summary_styles_templateObject2() {
    var data = price_history_summary_styles_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: auto auto;\n  justify-content: space-between;\n"
    ]);
    price_history_summary_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var styles_StyledLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "StyledLink",
    componentId: "sc-0-0"
})(price_history_summary_styles_templateObject1(), base/* media.largeUp */.BC.largeUp(price_history_summary_styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050));
var StyledTitleRow = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledTitleRow",
    componentId: "sc-0-1"
})(price_history_summary_styles_templateObject2());

;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/header-desktop/price-history-summary/index.tsx












var PriceHistorySummary = function() {
    var ref;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var offers = (0,product_context/* useProductContext */.$h)().offers;
    var location = (0,react_router_dom/* useLocation */.TH)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var link = "".concat(location.pathname).concat(location.search).concat(product_tabs_types/* TabAnchor.STATISTICS */.X.STATISTICS);
    var handlePriceHistoryClick = function() {
        dispatch((0,product/* headerClickEvent */.Yc)("price-history"));
        (0,tracking/* trackInternalNavigationClick */.p)({
            scope: tracking/* InternalNavigationScope.PRODUCT_PRODUCT_HEADER */.U.PRODUCT_PRODUCT_HEADER,
            currentPage: location.pathname + location.search + location.hash,
            nextPage: link
        });
    };
    return /*#__PURE__*/ react.createElement(styles_StyledLink, {
        to: link,
        onClick: handlePriceHistoryClick,
        "aria-label": t("product", "tabs.price-history"),
        "data-test": "PriceHistorySummary"
    }, offers.initialOffers.length > 0 && /*#__PURE__*/ react.createElement(StyledTitleRow, null, /*#__PURE__*/ react.createElement(text_variants.BodySmallText, {
        emphasis: text_variants.FontEmphasis.MEDIUM
    }, t("product", "price-history.title")), /*#__PURE__*/ react.createElement(text_variants.TitleSmallText, {
        emphasis: text_variants.FontEmphasis.MEDIUM
    }, t("product", "price-history.current-lowest-price", {
        lowestPrice: /*#__PURE__*/ react.createElement(currency/* Currency */.F, {
            key: "lowestPrice",
            price: (ref = offers.initialOffers[0].price) === null || ref === void 0 ? void 0 : ref.exclShipping
        })
    }))), /*#__PURE__*/ react.createElement(product_price_history/* ProductPriceHistory */.N, {
        mode: "mini"
    }));
};

// EXTERNAL MODULE: ./src/components/filter-dropdown/index.tsx + 1 modules
var filter_dropdown = __webpack_require__(6340);
// EXTERNAL MODULE: ./src/components/price-list/sort-by-price.ts
var sort_by_price = __webpack_require__(31780);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row-context.tsx
var price_row_context = __webpack_require__(70264);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/utils/index.ts
var utils = __webpack_require__(4976);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row/row-types/index.tsx + 56 modules
var row_types = __webpack_require__(31291);
// EXTERNAL MODULE: ./src/components/store-logo/styles.ts
var styles = __webpack_require__(97659);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/row-types/our-choice-offer-in-header/styles.ts
function our_choice_offer_in_header_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function our_choice_offer_in_header_styles_templateObject() {
    var data = our_choice_offer_in_header_styles_taggedTemplateLiteral([
        "\n  box-shadow:\n    0px 1px 2px rgba(0, 0, 0, 0.12),\n    0px 1px 4px rgba(0, 0, 0, 0.12);\n\n  ",
        " {\n    max-width: ",
        "px;\n  }\n"
    ]);
    our_choice_offer_in_header_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var StyledOurChoicePriceRow = (0,styled_components_browser_esm["default"])(row_types/* PriceRow */.a).withConfig({
    displayName: "StyledOurChoicePriceRow",
    componentId: "sc-0-0"
})(our_choice_offer_in_header_styles_templateObject(), styles/* StoreLogo */.Xv, styles/* DEFAULT_STORE_LOGO_MAX_WIDTH */.uZ);

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/row-types/our-choice-offer-in-header/index.tsx


var OurChoicePriceRow = function(props) {
    var item = props.item, index = props.index;
    return /*#__PURE__*/ react.createElement(StyledOurChoicePriceRow, {
        item: item,
        index: index
    });
};

// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row/types.ts
var price_row_types = __webpack_require__(3382);
// EXTERNAL MODULE: ./src/areas/product/components/product-header/components/our-choice/utils/index.ts
var our_choice_utils = __webpack_require__(66030);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/popover/index.js
var popover = __webpack_require__(22448);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/info-outlined/index.js
var info_outlined = __webpack_require__(12525);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/clickable/index.js
var clickable = __webpack_require__(25181);
// EXTERNAL MODULE: ./src/areas/product/components/product-header/components/our-choice/styles.ts
var our_choice_styles = __webpack_require__(7235);
;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/our-choice/title-with-popover.tsx
function title_with_popover_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function title_with_popover_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function title_with_popover_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function title_with_popover_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function title_with_popover_slicedToArray(arr, i) {
    return title_with_popover_arrayWithHoles(arr) || title_with_popover_iterableToArrayLimit(arr, i) || title_with_popover_unsupportedIterableToArray(arr, i) || title_with_popover_nonIterableRest();
}
function title_with_popover_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return title_with_popover_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return title_with_popover_arrayLikeToArray(o, minLen);
}







var OurChoiceHeader = function() {
    var ref;
    var ref1 = (0,app_context/* useAppContext */.bp)(), t = ref1.t, market = ref1.market;
    var ref2 = title_with_popover_slicedToArray((0,react.useState)(false), 2), showPopover = ref2[0], setShowPopover = ref2[1];
    return /*#__PURE__*/ react.createElement(our_choice_styles/* TitleRow */.PU, null, /*#__PURE__*/ react.createElement(text_variants.TitleSmallText, null, t("product", "prices.our-choice")), /*#__PURE__*/ react.createElement(clickable.Clickable, {
        onClick: function() {
            return setShowPopover(!showPopover);
        },
        containerProps: {
            title: t("common", "button.read-more"),
            "aria-label": t("common", "button.read-more"),
            "aria-haspopup": "dialog"
        }
    }, /*#__PURE__*/ react.createElement(our_choice_styles/* StyledIconWrapper */.Mv, null, /*#__PURE__*/ react.createElement(info_outlined/* IconInfoOutlined */.e, {
        color: "base600",
        size: 16
    }))), /*#__PURE__*/ react.createElement(popover/* Popover */.J2, {
        id: "our-choice-explanation",
        visible: showPopover,
        width: 300,
        horizontalAlign: popover/* Alignment.Center */.v2.Center,
        verticalAlign: popover/* Alignment.Center */.v2.Center,
        onClose: function() {
            return setShowPopover(false);
        }
    }, /*#__PURE__*/ react.createElement(our_choice_styles/* StyledPopoverContent */.Ij, null, /*#__PURE__*/ react.createElement(text_variants.BodySmallText, null, t("product", "prices.our-choice-explanation")), /*#__PURE__*/ react.createElement(our_choice_styles/* StyledBlueInfoPageLink */.Kt, {
        id: (ref = market.infoPageMap) === null || ref === void 0 ? void 0 : ref.priceInformation
    }, /*#__PURE__*/ react.createElement(text_variants.TitleSmallText, null, t("common", "button.read-more"))))));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/our-choice/index.tsx













var OurChoice = function(props) {
    var campaign = props.campaign;
    var market = (0,app_context/* useAppContext */.bp)().market;
    var ref = (0,product_context/* useProductContext */.$h)(), product = ref.product, offers = ref.offers;
    var getPriceDisplay = (0,offer_list_filter_context/* useOfferListFilterContext */.o)().getPriceDisplay;
    var currentSorting = filter_dropdown/* OptionTypeEnum.CHEAPEST_PRICE */.M7.CHEAPEST_PRICE;
    var offersSorted = (0,sort_by_price/* sortOffersByPrice */.bo)(getPriceDisplay(), offers.filteredOffers);
    var ourChoice = (0,our_choice_utils/* getOurChoiceOffer */.T)(offersSorted, market.code);
    if (!ourChoice) {
        return null;
    }
    var offer = (0,utils/* createOfferFromPriceItem */.JZ)(ourChoice);
    return /*#__PURE__*/ react.createElement(our_choice_styles/* OurChoiceWrapper */.tw, null, /*#__PURE__*/ react.createElement(OurChoiceHeader, null), /*#__PURE__*/ react.createElement(price_row_context/* PriceRowContextContainer */.B, {
        offer: offer,
        product: product,
        sorting: currentSorting,
        campaign: campaign,
        viewSize: price_row_types/* ViewSize.SMALL */.du.SMALL,
        isInPriceList: false,
        isOurChoice: true
    }, /*#__PURE__*/ react.createElement(OurChoicePriceRow, {
        item: ourChoice,
        index: 0
    })));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/compare/index.js
var compare = __webpack_require__(19975);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/heart-outlined/index.js
var heart_outlined = __webpack_require__(92261);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/heart-filled/index.js
var heart_filled = __webpack_require__(63479);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/notification-filled/index.js
var notification_filled = __webpack_require__(35451);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/notification-outlined/index.js
var notification_outlined = __webpack_require__(72523);
// EXTERNAL MODULE: ./src/areas/sidebar/actions/lists.js
var lists = __webpack_require__(40054);
// EXTERNAL MODULE: ./src/areas/product/components/product-header/components/action-buttons/list-modal.tsx
var list_modal = __webpack_require__(56632);
// EXTERNAL MODULE: ./src/components/modal/actions.ts
var actions = __webpack_require__(66571);
// EXTERNAL MODULE: ./src/areas/product/constants.ts
var constants = __webpack_require__(48458);
;// CONCATENATED MODULE: ./src/areas/product/components/product-header/utils.ts




var useOnAction = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    return function(type) {
        dispatch((0,product/* headerClickEvent */.Yc)(type));
        if (type === "alert-create") {
            dispatch((0,actions/* showModal */.K4)(constants/* PRODUCT_ALERT_MODAL_ID */.U));
        }
    };
};

// EXTERNAL MODULE: ./src/components/modal/login-promo.js + 1 modules
var login_promo = __webpack_require__(31794);
// EXTERNAL MODULE: ./src/hooks/use-is-authenticated.ts
var use_is_authenticated = __webpack_require__(32990);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/tooltip/index.js
var tooltip = __webpack_require__(714);
;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/action-buttons/styles.tsx
function action_buttons_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function action_buttons_styles_templateObject() {
    var data = action_buttons_styles_taggedTemplateLiteral([
        "\n  list-style: none;\n  margin: 0;\n"
    ]);
    action_buttons_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function action_buttons_styles_templateObject1() {
    var data = action_buttons_styles_taggedTemplateLiteral([
        "\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  "
    ]);
    action_buttons_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function action_buttons_styles_templateObject2() {
    var data = action_buttons_styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    action_buttons_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function action_buttons_styles_templateObject3() {
    var data = action_buttons_styles_taggedTemplateLiteral([
        "\n  flex: 0;\n  width: 100%;\n\n  & > div {\n    z-index: ",
        ";\n  }\n"
    ]);
    action_buttons_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function action_buttons_styles_templateObject4() {
    var data = action_buttons_styles_taggedTemplateLiteral([
        "\n    white-space: nowrap;\n    overflow: hidden;\n  "
    ]);
    action_buttons_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function action_buttons_styles_templateObject5() {
    var data = action_buttons_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n\n  ",
        "\n"
    ]);
    action_buttons_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = action_buttons_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  background-color: ",
        ";\n  justify-content: left;\n  margin: ",
        " 0;\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = action_buttons_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  margin-bottom: ",
        ";\n\n  ",
        "\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = action_buttons_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  background-color: ",
        ";\n  justify-content: left;\n  margin: ",
        " 0;\n"
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = action_buttons_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n\n  ",
        "\n"
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}






var ListContainer = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "ListContainer",
    componentId: "sc-0-0"
})(action_buttons_styles_templateObject());
var ButtonText = (0,styled_components_browser_esm["default"])(text_variants.TitleSmallText).withConfig({
    displayName: "ButtonText",
    componentId: "sc-0-1"
})(action_buttons_styles_templateObject2(), base/* media.mediumUp */.BC.mediumUp(action_buttons_styles_templateObject1()));
var StyledTooltip = (0,styled_components_browser_esm["default"])(tooltip/* Tooltip */.u).attrs({
    width: "160px",
    "data-test": "Tooltip"
}).withConfig({
    displayName: "StyledTooltip",
    componentId: "sc-0-2"
})(action_buttons_styles_templateObject3(), zindex/* zindex.tooltip */.Y.tooltip);
var ContentWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ContentWrapper",
    componentId: "sc-0-3"
})(action_buttons_styles_templateObject5(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* media.mediumUp */.BC.mediumUp(action_buttons_styles_templateObject4()));
var StyledOutlinedButton = (0,styled_components_browser_esm["default"])(button_variants.OutlinedButton).withConfig({
    displayName: "StyledOutlinedButton",
    componentId: "sc-0-4"
})(styles_templateObject7(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.mediumDown */.BC.mediumDown(styles_templateObject6(), base/* colors.lightTheme.base0 */.O9.lightTheme.base0, base/* layout.measurements.spacing025 */.bK.measurements.spacing025));
var StyledTonalButton = (0,styled_components_browser_esm["default"])(button_variants.TonalButton).withConfig({
    displayName: "StyledTonalButton",
    componentId: "sc-0-5"
})(styles_templateObject9(), base/* media.mediumDown */.BC.mediumDown(styles_templateObject8(), base/* colors.lightTheme.base0 */.O9.lightTheme.base0, base/* layout.measurements.spacing025 */.bK.measurements.spacing025));

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/menu-kebab/index.js
var menu_kebab = __webpack_require__(47481);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/list/variants.js
var variants = __webpack_require__(35967);
;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/action-buttons/container.tsx









var ItemContainer = function(props) {
    var children = props.children;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(block/* MediumDown */.H5, null, /*#__PURE__*/ react.createElement(dropdown/* Dropdown */.Lt, {
        style: {
            height: "fit-content"
        },
        zIndex: zindex/* zindex.actionButtonDropdown */.Y.actionButtonDropdown
    }, /*#__PURE__*/ react.createElement(dropdown/* DropdownToggle */.Z_, {
        onlyIcon: true,
        type: ui_button.ButtonType.TONAL,
        size: ui_button.ButtonSize.MEDIUM
    }, /*#__PURE__*/ react.createElement(ui_button.ButtonIcon, null, /*#__PURE__*/ react.createElement(menu_kebab/* IconMenuKebab */.Q, null))), /*#__PURE__*/ react.createElement(dropdown/* DropdownContent */.Nv, {
        alignment: ui/* Direction.Right */.Nm.Right,
        width: 200
    }, /*#__PURE__*/ react.createElement(ListContainer, null, children)))), /*#__PURE__*/ react.createElement(block/* DesktopOnly */.NZ, null, /*#__PURE__*/ react.createElement(variants.Row, {
        equallySizedChildren: true,
        gap: 0.5
    }, children)));
};

// EXTERNAL MODULE: ./src/components/viewport/context.tsx
var context = __webpack_require__(84198);
;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/action-buttons/index.tsx
function action_buttons_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function action_buttons_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function action_buttons_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function action_buttons_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function action_buttons_slicedToArray(arr, i) {
    return action_buttons_arrayWithHoles(arr) || action_buttons_iterableToArrayLimit(arr, i) || action_buttons_unsupportedIterableToArray(arr, i) || action_buttons_nonIterableRest();
}
function action_buttons_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return action_buttons_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return action_buttons_arrayLikeToArray(o, minLen);
}










 // Should not depend on other areas








var ActionButtons = function(props) {
    var ref, ref1;
    var className = props.className, isDesktop = props.isDesktop;
    var ref2 = (0,app_context/* useAppContext */.bp)(), linkTo = ref2.linkTo, t = ref2.t, market = ref2.market;
    var product = (0,product_context/* useProductContext */.$h)().product;
    var ref3 = (0,context/* useViewportContext */.Ak)(), isTablet = ref3.isTablet, isMobile = ref3.isMobile;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref4 = action_buttons_slicedToArray((0,react.useState)(false), 2), addedToList = ref4[0], setAddedToListState = ref4[1];
    var ref5 = action_buttons_slicedToArray((0,react.useState)(false), 2), listOpen = ref5[0], setListOpen = ref5[1];
    var ref6 = action_buttons_slicedToArray((0,react.useState)(false), 2), showLoginPromo = ref6[0], setLoginPromoState = ref6[1];
    var me = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.account.me;
    });
    var userProductAlerts = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.sidebar.alerts.products;
    });
    var deletedLists = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.sidebar.deletedLists;
    });
    var selectedList = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.sidebar.selectedList;
    });
    var isAuthenticated = (0,use_is_authenticated/* useIsAuthenticated */.k)();
    var userAlert = userProductAlerts.find(function(alert) {
        return alert.productId === product.id;
    });
    var alertId = userAlert && userAlert.alertId;
    var isBookmarked = alertId && isAuthenticated;
    var onAction = useOnAction();
    var ref7;
    var latestLists = (ref7 = me === null || me === void 0 ? void 0 : (ref = me.lists) === null || ref === void 0 ? void 0 : (ref1 = ref.nodes) === null || ref1 === void 0 ? void 0 : ref1.filter(function(list) {
        return deletedLists[list.id] !== true;
    }).filter(function(list) {
        return !list.inventory;
    }).sort(function(a) {
        if (a.id === selectedList) {
            return 1;
        }
        return 0;
    })) !== null && ref7 !== void 0 ? ref7 : [];
    var handleListClick = function() {
        return setListOpen(function(state) {
            return !state;
        });
    };
    var handleAlertClick = function() {
        return onAction("alert-create");
    };
    var addToList = function(listId) {
        dispatch((0,lists/* selectList */.Fz)(listId));
        dispatch((0,lists/* addListItemRequest */.hg)(product.id, product.name, isDesktop));
        onAction("list-add");
        setAddedToListState(true);
    };
    var addToMyProducts = function() {
        dispatch((0,lists/* addItemToMyProductsRequest */["if"])(product.id, product.name, isDesktop));
        onAction("list-add");
        setAddedToListState(true);
    };
    var toggleLoginPromo = function() {
        return setLoginPromoState(!showLoginPromo);
    };
    return /*#__PURE__*/ react.createElement("div", {
        className: className
    }, listOpen && /*#__PURE__*/ react.createElement(list_modal/* ListModal */.a, {
        addToList: addToList,
        addToMyProducts: addToMyProducts,
        isOpen: listOpen,
        closeModal: function() {
            return setListOpen(false);
        },
        lists: latestLists,
        isDesktop: isDesktop
    }), showLoginPromo && /*#__PURE__*/ react.createElement(login_promo/* default */.Z, {
        isOpen: showLoginPromo,
        onRequestClose: toggleLoginPromo
    }), isDesktop && !isTablet && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(StyledTooltip, {
        title: t("product", "action-button.alert-tooltip")
    }, /*#__PURE__*/ react.createElement(StyledOutlinedButton, {
        onClick: handleAlertClick,
        size: button_variants.ButtonSize.MEDIUM,
        containerProps: {
            "data-test": "CreateAlertButton"
        }
    }, /*#__PURE__*/ react.createElement(ContentWrapper, null, isBookmarked ? /*#__PURE__*/ react.createElement(button_variants.ButtonIcon, {
        size: 20
    }, /*#__PURE__*/ react.createElement(notification_filled/* IconNotificationFilled */.Q, null)) : /*#__PURE__*/ react.createElement(button_variants.ButtonIcon, {
        size: 20
    }, /*#__PURE__*/ react.createElement(notification_outlined/* IconNotificationOutlined */.F, null)), /*#__PURE__*/ react.createElement(ButtonText, null, t("product", "alert.create-button-exp"))))), /*#__PURE__*/ react.createElement(ItemContainer, null, market.login.enabled && /*#__PURE__*/ react.createElement(StyledTooltip, {
        title: t("product", "action-button.list-tooltip")
    }, /*#__PURE__*/ react.createElement(StyledTonalButton, {
        onClick: isAuthenticated ? handleListClick : toggleLoginPromo,
        size: button_variants.ButtonSize.SMALL,
        containerProps: {
            "data-test": "SaveToListButton"
        }
    }, /*#__PURE__*/ react.createElement(ContentWrapper, null, addedToList ? /*#__PURE__*/ react.createElement(button_variants.ButtonIcon, {
        size: 16
    }, /*#__PURE__*/ react.createElement(heart_filled/* IconHeartFilled */.g, null)) : /*#__PURE__*/ react.createElement(button_variants.ButtonIcon, {
        size: 16
    }, /*#__PURE__*/ react.createElement(heart_outlined/* IconHeartOutlined */.G, null)), addedToList ? /*#__PURE__*/ react.createElement(ButtonText, null, t("common", "button.saved")) : /*#__PURE__*/ react.createElement(ButtonText, null, t("common", "button.save"))))), /*#__PURE__*/ react.createElement(StyledTooltip, {
        title: t("product", "action-button.compare-tooltip")
    }, /*#__PURE__*/ react.createElement(StyledTonalButton, {
        container: react_router_dom/* Link */.rU,
        containerProps: {
            to: linkTo("productCompare", {
                category: product.category,
                products: [
                    product
                ]
            }),
            rel: "nofollow",
            "data-test": "CompareButton"
        },
        size: button_variants.ButtonSize.SMALL
    }, /*#__PURE__*/ react.createElement(ContentWrapper, null, /*#__PURE__*/ react.createElement(button_variants.ButtonIcon, {
        size: 16
    }, /*#__PURE__*/ react.createElement(compare/* IconCompare */.P, null)), /*#__PURE__*/ react.createElement(ButtonText, null, t("product", "product-compare.compare"))))))), (isTablet || isMobile) && /*#__PURE__*/ react.createElement(ItemContainer, null, /*#__PURE__*/ react.createElement(StyledTonalButton, {
        onClick: handleAlertClick,
        containerProps: {
            "data-test": "CreateAlertButton"
        },
        size: button_variants.ButtonSize.MEDIUM
    }, /*#__PURE__*/ react.createElement(ContentWrapper, null, isBookmarked ? /*#__PURE__*/ react.createElement(button_variants.ButtonIcon, {
        size: 16
    }, /*#__PURE__*/ react.createElement(notification_filled/* IconNotificationFilled */.Q, null)) : /*#__PURE__*/ react.createElement(button_variants.ButtonIcon, {
        size: 16
    }, /*#__PURE__*/ react.createElement(notification_outlined/* IconNotificationOutlined */.F, null)), /*#__PURE__*/ react.createElement(ButtonText, null, t("product", "alert.create-button-exp")))), market.login.enabled && /*#__PURE__*/ react.createElement(StyledTonalButton, {
        onClick: isAuthenticated ? handleListClick : toggleLoginPromo,
        size: button_variants.ButtonSize.SMALL,
        containerProps: {
            "data-test": "SaveToListButton"
        }
    }, /*#__PURE__*/ react.createElement(ContentWrapper, null, addedToList ? /*#__PURE__*/ react.createElement(button_variants.ButtonIcon, {
        size: 16
    }, /*#__PURE__*/ react.createElement(heart_filled/* IconHeartFilled */.g, null)) : /*#__PURE__*/ react.createElement(button_variants.ButtonIcon, {
        size: 16
    }, /*#__PURE__*/ react.createElement(heart_outlined/* IconHeartOutlined */.G, null)), addedToList ? /*#__PURE__*/ react.createElement(ButtonText, null, t("common", "button.saved")) : /*#__PURE__*/ react.createElement(ButtonText, null, t("common", "button.save")))), /*#__PURE__*/ react.createElement(StyledTonalButton, {
        container: react_router_dom/* Link */.rU,
        containerProps: {
            to: linkTo("productCompare", {
                category: product.category,
                products: [
                    product
                ]
            }),
            rel: "nofollow",
            "data-test": "CompareButton"
        },
        size: button_variants.ButtonSize.SMALL
    }, /*#__PURE__*/ react.createElement(ContentWrapper, null, /*#__PURE__*/ react.createElement(button_variants.ButtonIcon, {
        size: 16
    }, /*#__PURE__*/ react.createElement(compare/* IconCompare */.P, null)), /*#__PURE__*/ react.createElement(ButtonText, null, t("product", "product-compare.compare"))))));
};

;// CONCATENATED MODULE: ./src/components/core-properties/styles.ts
function core_properties_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function core_properties_styles_templateObject() {
    var data = core_properties_styles_taggedTemplateLiteral([
        "\n    line-height: ",
        ";\n    max-height: ",
        ";\n    overflow: ",
        ";\n    color: ",
        ";\n  "
    ]);
    core_properties_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function core_properties_styles_templateObject1() {
    var data = core_properties_styles_taggedTemplateLiteral([
        "\n  background: ",
        ";\n  height: ",
        ";\n  width: 200px;\n  border-radius: 3px;\n"
    ]);
    core_properties_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var lineHeight = function(size) {
    switch(size){
        case "tiny":
            return 12;
        case "small":
            return 16;
        default:
            return 18;
    }
};
var PropertyList = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PropertyList",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(core_properties_styles_templateObject(), (0,base/* remCalc */.vR)(lineHeight(props.size)), props.maxRows ? (0,base/* remCalc */.vR)(props.maxRows * lineHeight(props.size) - 1) : "none", props.maxRows ? "hidden" : "visible", props.toneDown ? props.theme.text.secondary : props.theme.text.primary);
});
var placeholderHeight = function(size) {
    switch(size){
        case "tiny":
            return 14;
        case "small":
            return 18;
        default:
            return 21;
    }
};
var PlaceholderProperty = styled_components_browser_esm["default"].li.withConfig({
    displayName: "PlaceholderProperty",
    componentId: "sc-0-1"
})(core_properties_styles_templateObject1(), function(props) {
    return props.toneDown ? props.theme.colors.base100 : props.theme.colors.base200;
}, function(props) {
    return (0,base/* remCalc */.vR)(placeholderHeight(props.size));
});

;// CONCATENATED MODULE: ./src/components/core-properties/index.tsx


var ProductCoreProperties = function(param) {
    var className = param.className, properties = param.properties, _toneDown = param.toneDown, toneDown = _toneDown === void 0 ? false : _toneDown, maxrows = param.maxrows, _size = param.size, size = _size === void 0 ? "large" : _size;
    return /*#__PURE__*/ react.createElement(PropertyList, {
        className: className,
        toneDown: toneDown,
        maxRows: maxrows,
        size: size
    }, properties ? properties.filter(function(v) {
        return v;
    }).join(", ") : /*#__PURE__*/ react.createElement(PlaceholderProperty, {
        toneDown: toneDown,
        size: size
    }));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/header-desktop/styles.tsx
function header_desktop_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function header_desktop_styles_templateObject() {
    var data = header_desktop_styles_taggedTemplateLiteral([
        "\n    flex-flow: row wrap;\n    padding: ",
        " ",
        " ",
        " ",
        ";\n    position: relative;\n    border-bottom: 1px solid ",
        ";\n\n    display: grid;\n    grid-template-columns: 200px 1fr 310px;\n    gap: ",
        ';\n    grid-template-areas: "Media Content ProductSummary"\n  '
    ]);
    header_desktop_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function header_desktop_styles_templateObject1() {
    var data = header_desktop_styles_taggedTemplateLiteral([
        "\n    padding-left: ",
        ";\n    padding-right: ",
        ';\n    padding-bottom: 1rem;\n    grid-template-columns: 200px 1fr auto;\n    grid-template-areas:\n      "TabletTitle TabletTitle TabletTitle"\n      "Media Content ProductSummary"\n  '
    ]);
    header_desktop_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function header_desktop_styles_templateObject2() {
    var data = header_desktop_styles_taggedTemplateLiteral([
        "\n  display: none;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    header_desktop_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function header_desktop_styles_templateObject3() {
    var data = header_desktop_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    header_desktop_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function header_desktop_styles_templateObject4() {
    var data = header_desktop_styles_taggedTemplateLiteral([
        "\n      margin-right: 20px;\n    "
    ]);
    header_desktop_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function header_desktop_styles_templateObject5() {
    var data = header_desktop_styles_taggedTemplateLiteral([
        "\n      flex: 1 0 auto;\n      margin-bottom: 0;\n      margin-right: 0px;\n    "
    ]);
    header_desktop_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function header_desktop_styles_templateObject6() {
    var data = header_desktop_styles_taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    header_desktop_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function header_desktop_styles_templateObject7() {
    var data = header_desktop_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n"
    ]);
    header_desktop_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function header_desktop_styles_templateObject8() {
    var data = header_desktop_styles_taggedTemplateLiteral([
        "\n  flex: 1 1;\n  justify-content: space-between;\n  padding-right: ",
        ";\n  padding-left: ",
        ";\n  min-width: 0;\n  grid-area: Content;\n"
    ]);
    header_desktop_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function header_desktop_styles_templateObject9() {
    var data = header_desktop_styles_taggedTemplateLiteral([
        "\n  grid-area: Media;\n  position: relative;\n  margin-right: ",
        ";\n"
    ]);
    header_desktop_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    var data = header_desktop_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  text-align: center;\n  bottom: calc(100% + 2px);\n  max-height: 25px;\n  right: 10px;\n\n  img {\n    max-width: 88px;\n  }\n"
    ]);
    styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    var data = header_desktop_styles_taggedTemplateLiteral([
        "\n  cursor: pointer;\n  color: ",
        ";\n  font-weight: 600;\n  display: flex;\n  flex-wrap: nowrap;\n  gap: ",
        ";\n  align-items: center;\n\n  &:hover,\n  &:focus {\n    color: ",
        ";\n    text-decoration: underline;\n  }\n"
    ]);
    styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function styles_templateObject12() {
    var data = header_desktop_styles_taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n  color: ",
        ";\n\n  span {\n    color: inherit;\n  }\n  &:hover span {\n    color: ",
        ";\n  }\n"
    ]);
    styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function styles_templateObject13() {
    var data = header_desktop_styles_taggedTemplateLiteral([
        "\n  margin: 0 0 ",
        ";\n"
    ]);
    styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function styles_templateObject14() {
    var data = header_desktop_styles_taggedTemplateLiteral([
        "\n  margin: 0 0 ",
        ";\n"
    ]);
    styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function styles_templateObject15() {
    var data = header_desktop_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: ",
        ";\n  align-items: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1;\n"
    ]);
    styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = header_desktop_styles_taggedTemplateLiteral([
        "\n    display: block;\n  "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = header_desktop_styles_taggedTemplateLiteral([
        "\n  display: none;\n  grid-area: TabletTitle;\n\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = header_desktop_styles_taggedTemplateLiteral([
        "\n    display: block;\n  "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = header_desktop_styles_taggedTemplateLiteral([
        "\n  display: none;\n\n  ",
        "\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}





var StyledDesktopHeader = styled_components_browser_esm["default"].header.withConfig({
    displayName: "StyledDesktopHeader",
    componentId: "sc-0-0"
})(header_desktop_styles_templateObject2(), base/* media.mediumUp */.BC.mediumUp(header_desktop_styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.theme.lines.primary;
}, base/* layout.measurements.spacing100 */.bK.measurements.spacing100), base/* media.mediumDown */.BC.mediumDown(header_desktop_styles_templateObject1(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100));
var StyledProductSummaryArea = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledProductSummaryArea",
    componentId: "sc-0-1"
})(header_desktop_styles_templateObject3());
var StyledTitle = (0,styled_components_browser_esm["default"])(text_variants.H2Text).attrs({
    container: "h1"
}).withConfig({
    displayName: "StyledTitle",
    componentId: "sc-0-2"
})(header_desktop_styles_templateObject6(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(props) {
    return props.$inner && (0,styled_components_browser_esm.css)(header_desktop_styles_templateObject4());
}, function(props) {
    return props.$outer && (0,styled_components_browser_esm.css)(header_desktop_styles_templateObject5());
});
var StyledMore = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledMore",
    componentId: "sc-0-3"
})(header_desktop_styles_templateObject7());
var styles_StyledContent = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledContent",
    componentId: "sc-0-4"
})(header_desktop_styles_templateObject8(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledMedia = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledMedia",
    componentId: "sc-0-5"
})(header_desktop_styles_templateObject9(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var StyledStoreLogo = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "StyledStoreLogo",
    componentId: "sc-0-6"
})(styles_templateObject10());
var StyledWriteReview = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledWriteReview",
    componentId: "sc-0-7"
})(styles_templateObject11(), function(p) {
    return p.theme.text.linkExternal;
}, (0,base/* remCalc */.vR)(4), function(p) {
    return p.theme.text.linkExternalHover;
});
var StyledRatingWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledRatingWrapper",
    componentId: "sc-0-8"
})(styles_templateObject12(), (0,base/* remCalc */.vR)(10), function(p) {
    return p.theme.text.callToAction;
}, function(p) {
    return p.theme.text.callToActionHover;
});
var StyledDisplayProperties = (0,styled_components_browser_esm["default"])(ProductCoreProperties).withConfig({
    displayName: "StyledDisplayProperties",
    componentId: "sc-0-9"
})(styles_templateObject13(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledReviewBadges = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledReviewBadges",
    componentId: "sc-0-10"
})(styles_templateObject14(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledBadges = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledBadges",
    componentId: "sc-0-11"
})(styles_templateObject15(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledTabletTitle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledTabletTitle",
    componentId: "sc-0-12"
})(_templateObject17(), base/* media.mediumDown */.BC.mediumDown(_templateObject16()));
var StyledDesktopTitle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledDesktopTitle",
    componentId: "sc-0-13"
})(_templateObject19(), base/* media.largeUp */.BC.largeUp(_templateObject18()));

;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/header-desktop/index.tsx


















var ProductHeaderDesktop = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var className = props.className, currentCampaign = props.currentCampaign, isExpertTopRated = props.isExpertTopRated;
    var product = (0,product_context/* useProductContext */.$h)().product;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var headerStyle = {
        minWidth: "100%"
    };
    var getDisplayProperties = function(nodes) {
        return nodes.map(function(node) {
            return node.prettyVerbose;
        }).filter(function(item) {
            return item;
        });
    };
    var displayProperties = product && product.coreProperties ? getDisplayProperties(product.coreProperties.nodes) : [];
    var hasNoReviews = ((ref = product.aggregatedRatingSummary) === null || ref === void 0 ? void 0 : ref.summary.rating.count) === 0 || !product.aggregatedRatingSummary && product.userReviewSummary.count === 0;
    return /*#__PURE__*/ react.createElement(StyledDesktopHeader, {
        className: className,
        "data-test": "DesktopProductHeader"
    }, /*#__PURE__*/ react.createElement(StyledTabletTitle, {
        style: headerStyle,
        "data-test": "ProductTitle"
    }, /*#__PURE__*/ react.createElement(StyledTitle, {
        $outer: true
    }, product.name)), /*#__PURE__*/ react.createElement(StyledMedia, null, /*#__PURE__*/ react.createElement(error_boundary/* default */.Z, {
        onError: base/* noop */.ZT
    }, /*#__PURE__*/ react.createElement(StyledBadges, null, product.category && product.popularity && Boolean(product.popularity.inCategory) && /*#__PURE__*/ react.createElement(RankBadge, {
        category: {
            pathName: product.category.pathName,
            name: product.category.name || ""
        },
        rank: product.popularity.inCategory,
        isExperiment: true
    }))), /*#__PURE__*/ react.createElement(error_boundary/* default */.Z, {
        onError: base/* noop */.ZT
    }, product.media && /*#__PURE__*/ react.createElement(ProductMedia, {
        id: product.id,
        name: product.name,
        category: product.category,
        isExpertTopRated: isExpertTopRated
    }))), /*#__PURE__*/ react.createElement(styles_StyledContent, null, /*#__PURE__*/ react.createElement(StyledDesktopTitle, {
        "data-test": "ProductTitle"
    }, /*#__PURE__*/ react.createElement(StyledTitle, {
        $inner: true
    }, product.name)), /*#__PURE__*/ react.createElement(error_boundary/* default */.Z, {
        onError: base/* noop */.ZT
    }, /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(StyledMore, null, /*#__PURE__*/ react.createElement(StyledRatingWrapper, null, /*#__PURE__*/ react.createElement(LinkToReviews, null, /*#__PURE__*/ react.createElement(rating/* default */.Z, {
        hide: hasNoReviews,
        rate: ((ref1 = product.aggregatedRatingSummary) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.summary) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.rating) === null || ref3 === void 0 ? void 0 : ref3.score) || product.userReviewSummary.rating,
        count: ((ref4 = product.aggregatedRatingSummary) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.summary) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.rating) === null || ref6 === void 0 ? void 0 : ref6.count) || product.userReviewSummary.count,
        size: "large",
        showRate: true,
        showRateAs: "number",
        showCounterAs: "number",
        styleCounterAsLink: true
    }), hasNoReviews && /*#__PURE__*/ react.createElement(StyledWriteReview, null, /*#__PURE__*/ react.createElement(star_icons/* default */.Z, {
        stars: [
            1
        ],
        rating: rating_helper/* default.convert */.Z.convert(0),
        halfStar: false
    }), t("reviews", "button.write-review")))), Boolean(displayProperties.length) && /*#__PURE__*/ react.createElement(StyledDisplayProperties, {
        toneDown: true,
        maxrows: 3,
        properties: displayProperties// Cut off at max three core properties
        .slice(0, 3)
    }), product.reviewBadges && product.reviewBadges.length > 0 ? /*#__PURE__*/ react.createElement(StyledReviewBadges, null, product.reviewBadges.slice(0, 3).map(function(badge) {
        return /*#__PURE__*/ react.createElement(sentiment_badge/* default */.Z, {
            badge: badge,
            key: badge.id,
            showNrOfReviewsAs: "text"
        });
    })) : ""), /*#__PURE__*/ react.createElement(ProductFilters, null), /*#__PURE__*/ react.createElement(OurChoice, {
        campaign: currentCampaign
    }), ((ref7 = product.expertContent) === null || ref7 === void 0 ? void 0 : ref7.totalCount) ? /*#__PURE__*/ react.createElement(ProductHeaderExpertLink, null) : null))), /*#__PURE__*/ react.createElement(StyledProductSummaryArea, null, /*#__PURE__*/ react.createElement(error_boundary/* default */.Z, {
        onError: base/* noop */.ZT
    }, /*#__PURE__*/ react.createElement(PriceHistorySummary, null), /*#__PURE__*/ react.createElement(ActionButtons, {
        isDesktop: true
    }))), product.brand && product.brand.featured && /*#__PURE__*/ react.createElement(StyledStoreLogo, {
        title: t("product", "store-info.more-about-store", {
            store_name: product.brand.name
        }),
        to: product.brand.pathName
    }, product.brand.featured && product.brand.logo ? /*#__PURE__*/ react.createElement("img", {
        src: product.brand.logo,
        alt: product.brand.name
    }) : product.brand.name));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/header-mobile/styles.tsx
function header_mobile_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function header_mobile_styles_templateObject() {
    var data = header_mobile_styles_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: ",
        ";\n  flex: 1 0 auto;\n"
    ]);
    header_mobile_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function header_mobile_styles_templateObject1() {
    var data = header_mobile_styles_taggedTemplateLiteral([
        "\n    margin-bottom: ",
        "; "
    ]);
    header_mobile_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function header_mobile_styles_templateObject2() {
    var data = header_mobile_styles_taggedTemplateLiteral([
        "\n  margin-bottom: 0px;\n\n  ",
        "\n"
    ]);
    header_mobile_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function header_mobile_styles_templateObject3() {
    var data = header_mobile_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: grid;\n  grid-template-columns: auto 1fr;\n"
    ]);
    header_mobile_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function header_mobile_styles_templateObject4() {
    var data = header_mobile_styles_taggedTemplateLiteral([
        "\n  display: inline-block;\n  cursor: pointer;\n  &:hover span {\n    color: ",
        ";\n  }\n"
    ]);
    header_mobile_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function header_mobile_styles_templateObject5() {
    var data = header_mobile_styles_taggedTemplateLiteral([
        "\n  min-width: ",
        ";\n  margin-right: ",
        ";\n"
    ]);
    header_mobile_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function header_mobile_styles_templateObject6() {
    var data = header_mobile_styles_taggedTemplateLiteral([
        "display: none;"
    ]);
    header_mobile_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function header_mobile_styles_templateObject7() {
    var data = header_mobile_styles_taggedTemplateLiteral([
        "\n  ",
        "\n\n  display: flex;\n  flex-direction: column;\n  margin: ",
        ";\n  row-gap: ",
        ";\n  border-bottom: 1px solid ",
        ";\n  padding-bottom: ",
        ";\n\n  ",
        " {\n    flex-grow: 1;\n  }\n"
    ]);
    header_mobile_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}




var mediaImageSize = "100px";
var TitleWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TitleWrapper",
    componentId: "sc-0-0"
})(header_mobile_styles_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var Title = (0,styled_components_browser_esm["default"])(text_variants.H3Text).attrs({
    container: "h1"
}).withConfig({
    displayName: "Title",
    componentId: "sc-0-1"
})(header_mobile_styles_templateObject2(), base/* media.smallOnly */.BC.smallOnly(header_mobile_styles_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050));
var MainSection = styled_components_browser_esm["default"].div.withConfig({
    displayName: "MainSection",
    componentId: "sc-0-2"
})(header_mobile_styles_templateObject3());
var StyledRating = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledRating",
    componentId: "sc-0-3"
})(header_mobile_styles_templateObject4(), function(p) {
    return p.theme.text.callToActionHover;
});
var styles_ProductMedia = (0,styled_components_browser_esm["default"])(ProductMedia).withConfig({
    displayName: "ProductMedia",
    componentId: "sc-0-4"
})(header_mobile_styles_templateObject5(), mediaImageSize, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var MobileHeader = styled_components_browser_esm["default"].header.withConfig({
    displayName: "MobileHeader",
    componentId: "sc-0-5"
})(header_mobile_styles_templateObject7(), base/* media.mediumUp */.BC.mediumUp(header_mobile_styles_templateObject6()), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.theme.lines.primary;
}, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, Title);

;// CONCATENATED MODULE: ./src/areas/product/components/product-header/components/header-mobile/index.tsx










var ProductHeaderMobile = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var currentCampaign = props.currentCampaign, isExpertTopRated = props.isExpertTopRated;
    var product = (0,product_context/* useProductContext */.$h)().product;
    var hasNoReviews = ((ref = product.aggregatedRatingSummary) === null || ref === void 0 ? void 0 : ref.summary.rating.count) === 0 || !product.aggregatedRatingSummary && product.userReviewSummary.count === 0;
    return /*#__PURE__*/ react.createElement(MobileHeader, {
        "data-test": "MobileProductHeader"
    }, /*#__PURE__*/ react.createElement(MainSection, null, /*#__PURE__*/ react.createElement(error_boundary/* default */.Z, {
        onError: base/* noop */.ZT
    }, product && /*#__PURE__*/ react.createElement(styles_ProductMedia, {
        id: product.id,
        name: product.name,
        category: product.category,
        isExpertTopRated: isExpertTopRated
    })), /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(TitleWrapper, null, /*#__PURE__*/ react.createElement(Title, {
        "data-test": "ProductTitle"
    }, product.name), /*#__PURE__*/ react.createElement(ActionButtons, {
        isDesktop: false
    })), /*#__PURE__*/ react.createElement(LinkToReviews, null, product.userReviewSummary && product.userReviewSummary.count !== 0 ? /*#__PURE__*/ react.createElement(StyledRating, null, /*#__PURE__*/ react.createElement(rating/* default */.Z, {
        hide: hasNoReviews,
        rate: ((ref1 = product.aggregatedRatingSummary) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.summary) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.rating) === null || ref3 === void 0 ? void 0 : ref3.score) || product.userReviewSummary.rating,
        count: ((ref4 = product.aggregatedRatingSummary) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.summary) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.rating) === null || ref6 === void 0 ? void 0 : ref6.count) || product.userReviewSummary.count,
        size: "medium",
        showRate: true,
        showRateAs: "number",
        showCounterAs: "number",
        styleCounterAsLink: true
    })) : null))), /*#__PURE__*/ react.createElement(ProductFilters, null), /*#__PURE__*/ react.createElement(OurChoice, {
        campaign: currentCampaign
    }));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-header/product-header.tsx
function product_header_extends() {
    product_header_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return product_header_extends.apply(this, arguments);
}





var ProductHeader = /*#__PURE__*/ react.memo(function(props) {
    return /*#__PURE__*/ react.createElement(list_context/* ListContextContainer */.V, null, /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(viewport/* default */.Z, {
        desktop: true,
        tablet: true
    }, /*#__PURE__*/ react.createElement(ProductHeaderDesktop, product_header_extends({}, props))), /*#__PURE__*/ react.createElement(viewport/* default */.Z, {
        mobile: true
    }, /*#__PURE__*/ react.createElement(ProductHeaderMobile, product_header_extends({}, props)))));
});

;// CONCATENATED MODULE: ./src/areas/product/components/product-header/index.tsx


var ProductPageHeader = function(props) {
    var currentCampaign = props.currentCampaign, isExpertTopRated = props.isExpertTopRated;
    return /*#__PURE__*/ react.createElement(ProductHeader, {
        currentCampaign: currentCampaign,
        isExpertTopRated: isExpertTopRated
    });
};


/***/ }),

/***/ 56672:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": () => (/* binding */ useListContext),
/* harmony export */   "V": () => (/* binding */ ListContextContainer)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95939);
/* harmony import */ var src_components_fetch_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95698);
/* harmony import */ var _lists_query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66490);
/* harmony import */ var _lists_query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_lists_query_graphql__WEBPACK_IMPORTED_MODULE_3__);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};




var OFFSET = 30;
var initialContextValue = {
    fetchMoreLists: function() {
        return undefined;
    },
    moreLists: undefined,
    pageInfo: undefined
};
var ListContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(initialContextValue);
var useListContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ListContext);
};
var ListContextContainer = function(props) {
    var fetchContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_fetch_context__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z);
    var me = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.areas.account.me;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (setPageInfo) setPageInfo(me === null || me === void 0 ? void 0 : me.lists.pageInfo);
    }, [
        me
    ]);
    var ref = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(OFFSET), 2), offset = ref[0], setOffset = ref[1];
    var ref1 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(undefined), 2), moreLists = ref1[0], setMoreLists = ref1[1];
    var ref2 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(undefined), 2), pageInfo = ref2[0], setPageInfo = ref2[1];
    var fetchMoreLists = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(/*#__PURE__*/ _asyncToGenerator(function() {
        var response;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetchContext.query((_lists_query_graphql__WEBPACK_IMPORTED_MODULE_3___default()), {
                            limit: OFFSET,
                            offset: offset
                        })
                    ];
                case 1:
                    response = _state.sent();
                    setMoreLists(response.data.me.lists.nodes);
                    setPageInfo(response.data.me.lists.pageInfo);
                    setOffset(function(state) {
                        return state + OFFSET;
                    });
                    return [
                        2
                    ];
            }
        });
    }), []);
    var contextValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return {
            fetchMoreLists: fetchMoreLists,
            moreLists: moreLists,
            pageInfo: pageInfo
        };
    }, [
        fetchMoreLists,
        moreLists,
        pageInfo
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ListContext.Provider, {
        value: contextValue
    }, props.children);
};


/***/ }),

/***/ 50547:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23114);

var ProductMediaLightboxLoader = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "extra";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | extra */ 737).then(__webpack_require__.bind(__webpack_require__, 48335));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(48335);
        }
        return eval("require.resolve")("./product-media-lightbox");
    }
});
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ProductMediaLightboxLoader);


/***/ }),

/***/ 81092:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": () => (/* binding */ PriceHistoryMiniLoader)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23114);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96531);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}



var LoadableComponent = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "product-price-history-mini";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | product-price-history-mini */ 554).then(__webpack_require__.bind(__webpack_require__, 4595));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(4595);
        }
        return eval("require.resolve")("./mini-chart-content");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .StyledLoader */ .Hl, {
        "data-testid": "chart-loader"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .StyledSkeleton */ .ps, {
        width: "100%",
        height: "100%"
    }))
});
var PriceHistoryMiniLoader = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(LoadableComponent, _extends({}, props));
};


/***/ }),

/***/ 23748:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": () => (/* binding */ PriceHistorySectionLoader)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23114);
/* harmony import */ var src_components_skeleton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70867);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96531);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}




var LoadableComponent = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "product-price-history-section";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | product-price-history-section */ 625).then(__webpack_require__.bind(__webpack_require__, 55126));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(55126);
        }
        return eval("require.resolve")("./price-history-section-content");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_3__/* .StyledSectionContentLoader */ .Hn, {
        "data-testid": "chart-loader"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_skeleton__WEBPACK_IMPORTED_MODULE_2__/* .SkeletonParagraph */ .Bp, {
        width: "100%",
        height: "100%"
    }))
});
var PriceHistorySectionLoader = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(LoadableComponent, _extends({}, props));
};


/***/ }),

/***/ 30702:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": () => (/* binding */ ProductPriceHistory)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/areas/product/components/product-context/index.ts
var product_context = __webpack_require__(16130);
// EXTERNAL MODULE: ./src/hooks/use-gql-query.ts
var use_gql_query = __webpack_require__(63113);
// EXTERNAL MODULE: ./src/areas/product/components/product-price-history/queries/query.graphql
var query_graphql = __webpack_require__(59086);
var query_graphql_default = /*#__PURE__*/__webpack_require__.n(query_graphql);
;// CONCATENATED MODULE: ./src/areas/product/components/product-price-history/queries/use-price-history-query.ts


var usePriceHistoryQuery = function(productId, timeRange, importantDates) {
    return (0,use_gql_query/* useGqlQuery */.n)({
        query: (query_graphql_default()),
        queryKey: [
            "price-history"
        ],
        variables: {
            id: productId,
            timeRange: timeRange,
            importantDates: importantDates
        }
    });
};

// EXTERNAL MODULE: ./src/areas/product/components/product-price-history/components/price-history-section-loader/index.tsx
var price_history_section_loader = __webpack_require__(23748);
// EXTERNAL MODULE: ./src/areas/product/components/product-price-history/components/mini-chart-content-loader/index.tsx
var mini_chart_content_loader = __webpack_require__(81092);
// EXTERNAL MODULE: ./src/areas/product/components/product-price-history/utils/index.ts
var utils = __webpack_require__(94766);
// EXTERNAL MODULE: ./src/areas/product/components/product-price-history/types.ts
var types = __webpack_require__(48393);
// EXTERNAL MODULE: ./src/areas/product/components/product-price-history/styles.ts
var styles = __webpack_require__(96531);
;// CONCATENATED MODULE: ./src/areas/product/components/product-price-history/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}








/**
 * Price history component
 * This component uses Recharts visualization lib and is loaded async for performance
 *
 * @param props  - Use mode to determine if the component should be rendered as a mini chart or a full chart
 */ var ProductPriceHistory = function(props) {
    var mode = props.mode;
    var ref = _slicedToArray((0,react.useState)(false), 2), activeChart = ref[0], setActiveChart = ref[1];
    var ref1 = (0,product_context/* useProductContext */.$h)(), product = ref1.product, offers = ref1.offers;
    var ref2 = _slicedToArray((0,react.useState)("ThreeMonths"), 2), selectedTimeRange = ref2[0], setSelectedTimeRange = ref2[1];
    var ref3 = _slicedToArray((0,react.useState)(mode === "normal"), 2), showImportantDates = ref3[0], setShowImportantDates = ref3[1];
    (0,react.useEffect)(function() {
        setActiveChart(true);
    }, []);
    var result = usePriceHistoryQuery(product.id, selectedTimeRange, showImportantDates);
    var ref4 = (0,utils/* getHistoryItems */.zq)(result.data), historyItems = ref4.historyItems, historyShops = ref4.historyShops;
    var correctedHistoryItems = offers.initialOffers.length > 0 ? (0,utils/* updateWithTodaysCheapestOffer */.RM)(historyItems, offers.initialOffers[0]) : historyItems;
    var isEmptyDataResult = (0,utils/* isResultWithMissingPriceData */.Vk)(result, correctedHistoryItems);
    var renderState = (0,utils/* getRenderState */.tP)(result, isEmptyDataResult);
    var importantDates = (0,utils/* getImportantDates */.Vs)(result.data);
    (0,react.useEffect)(function() {
        if (isEmptyDataResult) {
            setSelectedTimeRange("All");
        }
    }, [
        isEmptyDataResult
    ]);
    var retry = (0,react.useCallback)(function() {
        // Trigger a re-render
        setSelectedTimeRange(selectedTimeRange);
    }, [
        selectedTimeRange
    ]);
    var miniChart = activeChart && renderState !== types/* RENDER_STATE.ERROR */.q.ERROR && renderState !== types/* RENDER_STATE.NO_DATA */.q.NO_DATA ? /*#__PURE__*/ react.createElement(mini_chart_content_loader/* PriceHistoryMiniLoader */.C, {
        historyItems: correctedHistoryItems,
        renderState: renderState
    }) : /*#__PURE__*/ react.createElement(styles/* StyledLoader */.Hl, {
        "data-testid": "chart-loader"
    }, /*#__PURE__*/ react.createElement(styles/* StyledSkeleton */.ps, {
        width: "100%",
        height: "100%"
    }));
    return /*#__PURE__*/ react.createElement(styles/* StyledPriceHistoryArea */.Lx, null, mode === "normal" && /*#__PURE__*/ react.createElement("div", {
        "data-test": "PriceHistoryGraph"
    }, /*#__PURE__*/ react.createElement(price_history_section_loader/* PriceHistorySectionLoader */.u, {
        data: result.data,
        productId: product.id,
        initialOffers: offers.initialOffers,
        allHistoryShops: historyShops,
        correctedHistoryItems: correctedHistoryItems,
        importantDates: importantDates,
        retryFn: retry,
        state: {
            renderState: renderState,
            selectedTimeRange: selectedTimeRange,
            setSelectedTimeRange: setSelectedTimeRange,
            showImportantDates: showImportantDates,
            setShowImportantDates: setShowImportantDates
        }
    })), mode === "mini" && renderState !== types/* RENDER_STATE.NO_DATA */.q.NO_DATA && /*#__PURE__*/ react.createElement(styles/* StyledMiniChartWrapper */.En, null, miniChart));
};


/***/ }),

/***/ 96531:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bk": () => (/* binding */ MINI_CHART),
/* harmony export */   "En": () => (/* binding */ StyledMiniChartWrapper),
/* harmony export */   "Hl": () => (/* binding */ StyledLoader),
/* harmony export */   "Hn": () => (/* binding */ StyledSectionContentLoader),
/* harmony export */   "Lx": () => (/* binding */ StyledPriceHistoryArea),
/* harmony export */   "ps": () => (/* binding */ StyledSkeleton)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71993);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61093);
/* harmony import */ var src_components_skeleton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70867);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  min-height: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: ",
        "px;\n  height: ",
        "px;\n  margin: -",
        ";\n  margin-bottom: ",
        ";\n  position: relative;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  height: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  height: 100%;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  margin: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var CONTENT_MIN_HEIGHT_DESKTOP = "476px";
var MINI_CHART = {
    WIDTH: 326,
    HEIGHT: 110
};
var StyledPriceHistoryArea = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "StyledPriceHistoryArea",
    componentId: "sc-0-0"
})(_templateObject(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var StyledMiniChartWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "StyledMiniChartWrapper",
    componentId: "sc-0-1"
})(_templateObject1(), MINI_CHART.WIDTH, MINI_CHART.HEIGHT, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var StyledSectionContentLoader = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "StyledSectionContentLoader",
    componentId: "sc-0-2"
})(_templateObject2(), CONTENT_MIN_HEIGHT_DESKTOP);
var StyledLoader = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "StyledLoader",
    componentId: "sc-0-3"
})(_templateObject3());
var StyledSkeleton = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_components_skeleton__WEBPACK_IMPORTED_MODULE_2__/* .SkeletonParagraph */ .Bp).withConfig({
    displayName: "StyledSkeleton",
    componentId: "sc-0-4"
})(_templateObject4(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);


/***/ }),

/***/ 48393:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": () => (/* binding */ RENDER_STATE)
/* harmony export */ });
var RENDER_STATE;
(function(RENDER_STATE) {
    RENDER_STATE[RENDER_STATE["LOADING"] = 0] = "LOADING";
    RENDER_STATE[RENDER_STATE["SHOW"] = 1] = "SHOW";
    RENDER_STATE[RENDER_STATE["ERROR"] = 2] = "ERROR";
    RENDER_STATE[RENDER_STATE["NO_DATA"] = 3] = "NO_DATA";
})(RENDER_STATE || (RENDER_STATE = {}));


/***/ }),

/***/ 66569:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B7": () => (/* binding */ formatShopData),
/* harmony export */   "Bq": () => (/* binding */ createDate),
/* harmony export */   "lv": () => (/* binding */ formatData),
/* harmony export */   "zk": () => (/* binding */ isToday)
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var createDate = function(str) {
    var date = str ? new Date(str) : new Date();
    return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
};
var daysDiff = function(a, b) {
    return Math.round((b.getTime() - a.getTime()) / (1000 * 60 * 60 * 24));
};
var isToday = function(item) {
    if (!item) return false;
    return createDate(item.date).getTime() === createDate().getTime();
};
var createPriceHistoryItem = function(historyItem) {
    var date = createDate(historyItem.date);
    var price = historyItem.active ? historyItem.price : null;
    var isMembershipPrice = historyItem.isMembershipPrice, isPaidMembership = historyItem.isPaidMembership, name = historyItem.name, shopId = historyItem.shopId, shopName = historyItem.shopName;
    return {
        date: date,
        isMembershipPrice: isMembershipPrice,
        isPaidMembership: isPaidMembership,
        name: name,
        price: price,
        shopId: shopId,
        shopName: shopName,
        shopDatas: {}
    };
};
var copyItem = function(priceHistoryItem, nbr) {
    var items = [];
    for(var i = 1; i < nbr; i += 1){
        var nextDay = new Date(priceHistoryItem.date);
        nextDay.setUTCDate(nextDay.getUTCDate() + i);
        items.push(_objectSpreadProps(_objectSpread({}, priceHistoryItem), {
            date: nextDay
        }));
    }
    return items;
};
var copyItemsUntil = function(item, until) {
    var graphItems = [];
    if (item) {
        var daysInBetween = daysDiff(item.date, until);
        if (daysInBetween > 1) {
            var _graphItems;
            (_graphItems = graphItems).push.apply(_graphItems, _toConsumableArray(copyItem(item, daysInBetween)));
        }
    }
    return graphItems;
};
// The current implementation of the price history graph does not handle
// UTC dates correctly, adjusting the dates fixes this for now.
var mapHistoryItemFromUTCToLocale = function(item) {
    var dateStr = item.date;
    var date = dateStr ? new Date(dateStr) : new Date();
    date.setHours(date.getHours() - date.getTimezoneOffset() / 60);
    return _objectSpreadProps(_objectSpread({}, item), {
        date: date.toISOString()
    });
};
var formatData = function(data) {
    var _graphItems;
    var dataItems = _toConsumableArray(data).map(mapHistoryItemFromUTCToLocale);
    var graphItems = [];
    var lastPriceHistoryItem;
    if (dataItems.length === 0) {
        return [];
    }
    while(dataItems.length > 0){
        var // Fill in blank days
        _graphItems1;
        var nextDataItem = dataItems.shift();
        // For today's date we are only interrested in the last item (which is the same as the cheapest in the price list)
        while(dataItems.length > 0 && isToday(nextDataItem)){
            nextDataItem = dataItems.shift();
        }
        if (!nextDataItem) break;
        var nextPriceHistoryItem = createPriceHistoryItem(nextDataItem);
        (_graphItems1 = graphItems).push.apply(_graphItems1, _toConsumableArray(copyItemsUntil(lastPriceHistoryItem, nextPriceHistoryItem.date)));
        lastPriceHistoryItem = nextPriceHistoryItem;
        graphItems.push(nextPriceHistoryItem);
    }
    // Fill up with days up until today
    var now = new Date();
    var tomorrow = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + 1));
    (_graphItems = graphItems).push.apply(_graphItems, _toConsumableArray(copyItemsUntil(lastPriceHistoryItem, tomorrow)));
    return graphItems;
};
var formatShopData = function(data) {
    var ref;
    return _objectSpreadProps(_objectSpread({}, data), {
        product: _objectSpreadProps(_objectSpread({}, data.product), {
            shopHistory: (((ref = data.product) === null || ref === void 0 ? void 0 : ref.shopHistory) || []).map(function(shopHistory) {
                return _objectSpreadProps(_objectSpread({}, shopHistory), {
                    productHistory: _objectSpreadProps(_objectSpread({}, shopHistory.productHistory), {
                        historyItems: (shopHistory.productHistory.historyItems || []).map(function(historyItem) {
                            return mapHistoryItemFromUTCToLocale(historyItem);
                        })
                    })
                });
            })
        })
    });
};


/***/ }),

/***/ 94766:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RM": () => (/* binding */ updateWithTodaysCheapestOffer),
/* harmony export */   "Vk": () => (/* binding */ isResultWithMissingPriceData),
/* harmony export */   "Vs": () => (/* binding */ getImportantDates),
/* harmony export */   "tP": () => (/* binding */ getRenderState),
/* harmony export */   "yv": () => (/* binding */ getHistoryItemRange),
/* harmony export */   "zq": () => (/* binding */ getHistoryItems)
/* harmony export */ });
/* unused harmony export getDateFromUTCString */
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48393);
/* harmony import */ var _format_data__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66569);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


var getDateFromUTCString = function(str) {
    if (!str) {
        return undefined;
    }
    return new Date(str);
};
var getRenderState = function(result, isEmptyDataResult) {
    if (result.error) {
        return _types__WEBPACK_IMPORTED_MODULE_0__/* .RENDER_STATE.ERROR */ .q.ERROR;
    }
    if (isEmptyDataResult) {
        return _types__WEBPACK_IMPORTED_MODULE_0__/* .RENDER_STATE.NO_DATA */ .q.NO_DATA;
    }
    if (result.isSuccess && result.data) {
        return _types__WEBPACK_IMPORTED_MODULE_0__/* .RENDER_STATE.SHOW */ .q.SHOW;
    }
    return _types__WEBPACK_IMPORTED_MODULE_0__/* .RENDER_STATE.LOADING */ .q.LOADING;
};
var getHistoryItems = function(data) {
    var ref, ref1, ref2, ref3;
    var ref4, ref5;
    return {
        historyItems: (ref4 = data === null || data === void 0 ? void 0 : (ref = data.product) === null || ref === void 0 ? void 0 : (ref1 = ref.historyV2) === null || ref1 === void 0 ? void 0 : ref1.historyItems) !== null && ref4 !== void 0 ? ref4 : [],
        historyShops: (ref5 = data === null || data === void 0 ? void 0 : (ref2 = data.product) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.historyV2) === null || ref3 === void 0 ? void 0 : ref3.historyAllShops) !== null && ref5 !== void 0 ? ref5 : []
    };
};
var getHistoryItemRange = function(data) {
    var ref, ref1, ref2, ref3;
    var oldestHistoryItem = getDateFromUTCString(data === null || data === void 0 ? void 0 : (ref = data.product) === null || ref === void 0 ? void 0 : (ref1 = ref.historyV2) === null || ref1 === void 0 ? void 0 : ref1.oldestHistoryItem);
    var newestHistoryItem = getDateFromUTCString(data === null || data === void 0 ? void 0 : (ref2 = data.product) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.historyV2) === null || ref3 === void 0 ? void 0 : ref3.newestHistoryItem);
    if (!oldestHistoryItem || !newestHistoryItem) {
        return null;
    }
    return [
        oldestHistoryItem,
        newestHistoryItem
    ];
};
var getImportantDates = function(data) {
    var ref;
    var items = data === null || data === void 0 ? void 0 : (ref = data.importantDates) === null || ref === void 0 ? void 0 : ref.map(function(item) {
        var ref;
        var startDate = new Date((ref = item === null || item === void 0 ? void 0 : item.startDate) !== null && ref !== void 0 ? ref : 0);
        var ref1;
        var endDate = new Date((ref1 = item === null || item === void 0 ? void 0 : item.endDate) !== null && ref1 !== void 0 ? ref1 : 0);
        endDate.setUTCDate(endDate.getUTCDate() + 1);
        return {
            name: item === null || item === void 0 ? void 0 : item.name,
            startDate: startDate,
            endDate: endDate
        };
    }).filter(function(i) {
        return i.name && i.endDate.getTime() > i.startDate.getTime();
    });
    return items !== null && items !== void 0 ? items : [];
};
var updateWithTodaysCheapestOffer = function(data, offer) {
    var ref, ref1, ref2, ref3, ref4;
    if (data.length === 0) {
        return data;
    }
    var modifiedHistoryItems = _toConsumableArray(data);
    var lastHistoryItem = modifiedHistoryItems[modifiedHistoryItems.length - 1];
    var isMembershipPrice = Boolean((ref = offer.offerPrices) === null || ref === void 0 ? void 0 : ref.memberPrice);
    var isPaidMembership = Boolean((ref1 = offer.membershipProgram) === null || ref1 === void 0 ? void 0 : ref1.requiresCompensation);
    var _name, ref5, ref6, ref7;
    var newDataForToday = {
        active: true,
        date: (0,_format_data__WEBPACK_IMPORTED_MODULE_1__/* .createDate */ .Bq)().toISOString(),
        name: (_name = offer.name) !== null && _name !== void 0 ? _name : lastHistoryItem.name,
        price: (ref5 = (ref2 = offer.price) === null || ref2 === void 0 ? void 0 : ref2.exclShipping) !== null && ref5 !== void 0 ? ref5 : lastHistoryItem.price,
        shopId: (ref6 = (ref3 = offer.store) === null || ref3 === void 0 ? void 0 : ref3.id) !== null && ref6 !== void 0 ? ref6 : lastHistoryItem.shopId,
        shopName: (ref7 = (ref4 = offer.store) === null || ref4 === void 0 ? void 0 : ref4.name) !== null && ref7 !== void 0 ? ref7 : lastHistoryItem.shopName,
        isPaidMembership: isPaidMembership,
        isMembershipPrice: isMembershipPrice
    };
    if ((0,_format_data__WEBPACK_IMPORTED_MODULE_1__/* .isToday */ .zk)(lastHistoryItem)) {
        // Replace last history item with data from cheapest offer today
        modifiedHistoryItems[modifiedHistoryItems.length - 1] = newDataForToday;
    } else {
        // Add cheapest offer today as a new history item
        modifiedHistoryItems.push(newDataForToday);
    }
    return modifiedHistoryItems;
};
var isResultWithMissingPriceData = function(result, historyItems) {
    if (!result.isSuccess || result.isError) {
        return false;
    }
    return !historyItems.some(function(item) {
        return item.active;
    });
};


/***/ }),

/***/ 40456:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _components_campaign_banners_promo_banner__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27347);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33996);



var ProductBeforePromoBanner = function(props) {
    var campaignBanners = props.campaignBanners;
    var campaignPromoBanners = (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getCampaignPromoBanners */ .qz)(campaignBanners);
    return campaignPromoBanners.before && campaignPromoBanners.before.length > 0 ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_campaign_banners_promo_banner__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        inverted: true,
        banners: campaignPromoBanners.before
    }) : null;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ProductBeforePromoBanner);


/***/ }),

/***/ 81898:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _components_campaign_banners_promo_banner__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27347);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33996);



var ProductDuringPromoBanner = function(props) {
    var campaignBanners = props.campaignBanners;
    var campaignPromoBanners = (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getCampaignPromoBanners */ .qz)(campaignBanners);
    return campaignPromoBanners.during && campaignPromoBanners.during.length > 0 ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_campaign_banners_promo_banner__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        banners: campaignPromoBanners.during
    })) : null;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ProductDuringPromoBanner);


/***/ }),

/***/ 29415:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": () => (/* binding */ ProductPropertiesLoader)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23114);
/* harmony import */ var _loading_state__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48786);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}



var LoadableComponent = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "product-properties";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | product-properties */ 835).then(__webpack_require__.bind(__webpack_require__, 43518));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(43518);
        }
        return eval("require.resolve")("../../product-properties");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_loading_state__WEBPACK_IMPORTED_MODULE_2__/* .LoadingState */ .G, null)
});
var ProductPropertiesLoader = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(LoadableComponent, _extends({}, props));
};


/***/ }),

/***/ 48786:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": () => (/* binding */ LoadingState)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/skeleton/index.ts + 3 modules
var skeleton = __webpack_require__(70867);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
;// CONCATENATED MODULE: ./src/areas/product/components/product-properties/components/loader/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  height: ",
        "px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var PRODUCT_PROPERTIES_MIN_HEIGHT = 200;
var StyledSectionContentLoader = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledSectionContentLoader",
    componentId: "sc-0-0"
})(_templateObject(), PRODUCT_PROPERTIES_MIN_HEIGHT);

;// CONCATENATED MODULE: ./src/areas/product/components/product-properties/components/loader/loading-state.tsx



var LoadingState = function() {
    return /*#__PURE__*/ react.createElement(StyledSectionContentLoader, {
        "data-testid": "product-properties-loader"
    }, /*#__PURE__*/ react.createElement(skeleton/* SkeletonParagraph */.Bp, {
        width: "100%",
        height: "100%"
    }));
};


/***/ }),

/***/ 26783:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_scroll__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67016);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18026);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68798);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33996);
/* harmony import */ var _prisjakt_ui_icon_chevron_up__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(912);






var ProductScrollTopButton = function() {
    var t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_2__/* .AppContext */ .Il).t;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_scroll__WEBPACK_IMPORTED_MODULE_1__/* .ScrollLink */ .Rv, {
        to: "Top",
        onClick: _utils__WEBPACK_IMPORTED_MODULE_4__/* .blurActiveElement */ .sD
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_3__/* .BackToTopButton */ .zV, {
        "aria-label": t("product", "back-to-top.button-description")
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_icon_chevron_up__WEBPACK_IMPORTED_MODULE_5__.IconChevronUp, null)));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ProductScrollTopButton);


/***/ }),

/***/ 15248:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": () => (/* binding */ ProductNavigation)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/sticky-tab-nav/index.tsx + 1 modules
var sticky_tab_nav = __webpack_require__(20132);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./src/areas/product/components/product-tabs/types.ts
var types = __webpack_require__(84870);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
;// CONCATENATED MODULE: ./src/areas/product/components/product-section-navigation/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ProductNavigationLink = styled_components_browser_esm["default"].span.withConfig({
    displayName: "ProductNavigationLink",
    componentId: "sc-0-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/areas/product/components/product-section-navigation/utils.tsx




var useNavigationLinks = function() {
    var t = (0,app_context/* useAppContext */.bp)().t;
    return [
        {
            id: types/* TabAnchor.ALL */.X.ALL,
            title: /*#__PURE__*/ react.createElement(ProductNavigationLink, {
                "data-test": "TabButton",
                "data-test-section": "main"
            }, t("product", "tabs.prices")),
            scrollToTop: true
        },
        {
            id: types/* TabAnchor.REVIEWS */.X.REVIEWS,
            title: /*#__PURE__*/ react.createElement(ProductNavigationLink, {
                "data-test": "TabButton",
                "data-test-section": "reviews"
            }, t("product", "tabs.reviews"))
        },
        {
            id: types/* TabAnchor.STATISTICS */.X.STATISTICS,
            title: /*#__PURE__*/ react.createElement(ProductNavigationLink, {
                "data-test": "TabButton",
                "data-test-section": "statistics"
            }, t("product", "tabs.price-history"))
        },
        {
            id: types/* TabAnchor.PROPERTIES */.X.PROPERTIES,
            title: /*#__PURE__*/ react.createElement(ProductNavigationLink, {
                "data-test": "TabButton",
                "data-test-section": "properties"
            }, t("product", "tabs.properties"))
        }
    ];
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-section-navigation/index.tsx



var ProductNavigation = function() {
    var navigationTabs = useNavigationLinks();
    return /*#__PURE__*/ react.createElement(sticky_tab_nav/* StickyTabNavigation */.g, {
        defaultActiveTabId: navigationTabs[0].id,
        tabs: navigationTabs,
        background: true
    });
};


/***/ }),

/***/ 20588:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": () => (/* binding */ ProductTabs)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/lazy/index.tsx
var lazy = __webpack_require__(67506);
// EXTERNAL MODULE: ./src/areas/product/components/product-context/index.ts
var product_context = __webpack_require__(16130);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./src/areas/product/components/carousel-products/index.tsx
var carousel_products = __webpack_require__(29184);
// EXTERNAL MODULE: ./src/areas/product/components/carousel-products/types.ts
var types = __webpack_require__(92752);
// EXTERNAL MODULE: ./src/areas/product/components/carousel-products/components/others-also-visited-carousel/index.tsx
var others_also_visited_carousel = __webpack_require__(56829);
// EXTERNAL MODULE: ./src/areas/product/components/carousel-products/utils.ts
var utils = __webpack_require__(28510);
;// CONCATENATED MODULE: ./src/areas/product/components/carousel-products/components/others-also-visited-carousel/others-also-visited-legacy.tsx




var OtherAlsoVisitedCarouselLegacy = function(param) {
    var recommendations = param.recommendations;
    var t = (0,app_context/* useAppContext */.bp)().t;
    if (!(recommendations === null || recommendations === void 0 ? void 0 : recommendations.length)) return null;
    var recommendedProducts = recommendations.flatMap(function(rec) {
        return rec.recommendations.map(function(p) {
            return p.product;
        });
    }).filter(function(isTruthy) {
        return isTruthy;
    }).map(function(p) {
        var ref, ref1;
        return {
            aggregatedRating: p.aggregatedRating,
            category: p.category,
            classicFullPath: p.uri,
            id: p.id,
            imageUrl: (ref = p.media) === null || ref === void 0 ? void 0 : ref.first,
            name: p.name,
            // @ts-expect-error Should get fixed (in other MR) with the new resolver not to also include the domain etc.
            pathName: p.pathName,
            price: (ref1 = p.price) === null || ref1 === void 0 ? void 0 : ref1.regular,
            type: recommendations[0].model,
            url: p.webUri,
            userReviewSummary: p.userReviews,
            isExpertTopRated: p.isExpertTopRated
        };
    });
    if (!recommendedProducts.length) return null;
    var carouselType = recommendations[0].model;
    return /*#__PURE__*/ react.createElement(carousel_products/* CarouselProducts */.S, {
        carouselType: carouselType,
        products: (0,utils/* mapCarouselProducts */.b)(recommendedProducts) || [],
        title: t("product", "recommendations.others-visited")
    });
};

// EXTERNAL MODULE: ./src/components/ads/index.tsx
var ads = __webpack_require__(66589);
// EXTERNAL MODULE: ./src/components/page/index.ts + 3 modules
var page = __webpack_require__(62372);
// EXTERNAL MODULE: ./src/components/scroll/index.ts + 2 modules
var components_scroll = __webpack_require__(67016);
// EXTERNAL MODULE: ./src/components/ux-feedback/index.tsx
var ux_feedback = __webpack_require__(38539);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 24 modules
var es = __webpack_require__(95939);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@5.2.1_react@18.2.0/node_modules/react-router/esm/react-router.js + 3 modules
var react_router = __webpack_require__(14727);
// EXTERNAL MODULE: ./src/areas/product/components/offer-list-filter-context/index.tsx
var offer_list_filter_context = __webpack_require__(65884);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(71016);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
// EXTERNAL MODULE: ./src/components/info-page-link/index.js
var info_page_link = __webpack_require__(48596);
;// CONCATENATED MODULE: ./src/areas/product/components/price-information/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    flex-direction: row;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  color: $text-color-lighten;\n  font-size: 12px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  border-bottom: none;\n  flex-direction: column;\n  gap: 0.5rem;\n  justify-content: space-between;\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  color: inherit;\n  text-decoration: underline;\n  align-items: baseline;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var StyledPriceInformation = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledPriceInformation",
    componentId: "sc-0-0"
})(_templateObject1(), base/* media.mediumUp */.BC.mediumUp(_templateObject()));
var StyledInfoPageLinkWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledInfoPageLinkWrapper",
    componentId: "sc-0-1"
})(_templateObject2());
var StyledInfoPageLink = (0,styled_components_browser_esm["default"])(info_page_link/* default */.Z).withConfig({
    displayName: "StyledInfoPageLink",
    componentId: "sc-0-2"
})(_templateObject3(), function(p) {
    return p.theme.colors.maybeBlue700;
});

;// CONCATENATED MODULE: ./src/areas/product/components/price-information/index.tsx





var PriceInformation = function(props) {
    var ref, ref1, ref2;
    var ref3 = (0,react.useContext)(app_context/* AppContext */.Il), t = ref3.t, market = ref3.market;
    var priceInfoArticles = (0,product_context/* useProductContext */.$h)().priceInfoArticles;
    var priceInfoUrl = (priceInfoArticles === null || priceInfoArticles === void 0 ? void 0 : priceInfoArticles.length) ? priceInfoArticles[0].pathName : undefined;
    return /*#__PURE__*/ react.createElement(StyledPriceInformation, null, /*#__PURE__*/ react.createElement(variants.BodySmallText, {
        emphasis: variants.FontEmphasis.MEDIUM,
        scale: variants.FontScale.XS
    }, t("product", "price-comparison-information.featured-stores-ratio", {
        totalCount: ((ref = props.storeStatistics) === null || ref === void 0 ? void 0 : ref.totalCount) || 0,
        featuredCount: ((ref1 = props.storeStatistics) === null || ref1 === void 0 ? void 0 : ref1.featuredCount) || 0
    }), /*#__PURE__*/ react.createElement("br", null), t("product", "price-comparison-information.listed-stores-information")), /*#__PURE__*/ react.createElement(StyledInfoPageLinkWrapper, null, /*#__PURE__*/ react.createElement(StyledInfoPageLink, {
        id: (ref2 = market.infoPageMap) === null || ref2 === void 0 ? void 0 : ref2.priceInformation,
        url: priceInfoUrl
    }, /*#__PURE__*/ react.createElement(variants.BodySmallText, {
        emphasis: variants.FontEmphasis.MEDIUM,
        scale: variants.FontScale.XS
    }, t("product", "price-comparison-information.read-more")))));
};

// EXTERNAL MODULE: ./src/components/price-list/sort-by-price.ts
var sort_by_price = __webpack_require__(31780);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/index.js
var ui = __webpack_require__(54262);
// EXTERNAL MODULE: ./src/components/modal-v2/index.tsx
var modal_v2 = __webpack_require__(54674);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/modal/index.js
var modal = __webpack_require__(58709);
// EXTERNAL MODULE: ./src/components/filter-dropdown/index.tsx + 1 modules
var filter_dropdown = __webpack_require__(6340);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/checkbox/variants.js
var checkbox_variants = __webpack_require__(14948);
// EXTERNAL MODULE: ./src/components/price-list/types.ts
var price_list_types = __webpack_require__(79126);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/offer-list-filters/styles.ts
var styles = __webpack_require__(4252);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/offer-list-filters/components/header-filters.tsx






var HeaderFilters = function() {
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var ref = (0,offer_list_filter_context/* useOfferListFilterContext */.o)(), getFilterByPlacement = ref.getFilterByPlacement, getTranslatedLabel = ref.getTranslatedLabel, toggleFilter = ref.toggleFilter;
    var headerFilters = getFilterByPlacement(price_list_types/* FilterUIPlacementEnum.OFFERLIST_HEADER */.jm.OFFERLIST_HEADER);
    return /*#__PURE__*/ react.createElement(react.Fragment, null, headerFilters.map(function(filter) {
        return /*#__PURE__*/ react.createElement(styles/* FilterOptionWrapper */.FJ, {
            key: filter.label
        }, /*#__PURE__*/ react.createElement(styles/* CheckboxClickarea */.HA, null, /*#__PURE__*/ react.createElement(checkbox_variants/* CheckboxSwitch */.K_, {
            id: filter.label,
            text: getTranslatedLabel(t, filter.type, filter.translationPrefix),
            onChange: function() {
                return toggleFilter(filter.type);
            },
            checked: Boolean(filter.active)
        })));
    }));
};

// EXTERNAL MODULE: ./src/areas/product/components/price-list/utils/index.ts
var price_list_utils = __webpack_require__(4976);
// EXTERNAL MODULE: ./src/ui/block/index.ts
var block = __webpack_require__(65176);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/button/variants.js
var button_variants = __webpack_require__(7336);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/dropdown-down/index.js
var dropdown_down = __webpack_require__(19258);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/dropdown-up/index.js
var dropdown_up = __webpack_require__(12641);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/offer-list-filters/components/filter-toggle-button.tsx





var FilterToggleButton = function(props) {
    var toggleHandler = props.toggleHandler, title = props.title, icon = props.icon, _activeFilters = props.activeFilters, activeFilters = _activeFilters === void 0 ? 0 : _activeFilters, hideNumber = props.hideNumber, showToggleButton = props.showToggleButton, isOpen = props.isOpen;
    return /*#__PURE__*/ react.createElement(button_variants.OutlinedButton, {
        onClick: toggleHandler,
        selectable: true,
        selected: !!activeFilters
    }, activeFilters > 0 && /*#__PURE__*/ react.createElement(styles/* ButtonBadge */.kP, {
        circular: true,
        text: !hideNumber && activeFilters
    }), /*#__PURE__*/ react.createElement(button_variants.ButtonIcon, null, icon), /*#__PURE__*/ react.createElement(button_variants.ButtonText, null, title), showToggleButton && /*#__PURE__*/ react.createElement(button_variants.ButtonIcon, null, isOpen ? /*#__PURE__*/ react.createElement(dropdown_up.IconDropdownUp, null) : /*#__PURE__*/ react.createElement(dropdown_down.IconDropdownDown, null)));
};
/* harmony default export */ const filter_toggle_button = (FilterToggleButton);

// EXTERNAL MODULE: ./src/areas/product/components/price-list/offer-list-filters/components/all-filters/index.tsx
var all_filters = __webpack_require__(8407);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/sliders/index.js
var sliders = __webpack_require__(7269);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/offer-list-filters/components/main-offerlist-filters-dropdown.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}







var MainOfferlistFiltersDropdown = function(props) {
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var applicableFilters = props.applicableFilters, activeOfferlistFilters = props.activeOfferlistFilters, className = props.className;
    var toggleFilter = (0,offer_list_filter_context/* useOfferListFilterContext */.o)().toggleFilter;
    var ref = _slicedToArray((0,react.useState)(false), 2), showFilters = ref[0], setShowFilters = ref[1];
    var closeHandler = function() {
        return setShowFilters(false);
    };
    var toggleHandler = function() {
        return setShowFilters(!showFilters);
    };
    return /*#__PURE__*/ react.createElement("div", {
        className: className
    }, /*#__PURE__*/ react.createElement(filter_toggle_button, {
        toggleHandler: toggleHandler,
        activeFilters: activeOfferlistFilters.length,
        title: t("filter", "filter.title"),
        icon: /*#__PURE__*/ react.createElement(sliders/* IconSliders */.O, null)
    }), showFilters && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(styles/* FilterBlocker */.rO, {
        onClick: function() {
            return closeHandler();
        }
    }), /*#__PURE__*/ react.createElement(styles/* FiltersDropDown */.g6, null, /*#__PURE__*/ react.createElement(styles/* FilterPanelWrapper */.gC, null, /*#__PURE__*/ react.createElement(all_filters/* AllFiltersLoader */.m, {
        filters: applicableFilters,
        onToggleFilter: toggleFilter
    })))));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/radiobutton/index.js
var radiobutton = __webpack_require__(9225);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/offer-list-filters/components/main-offerlist-filters-mobile.tsx
function main_offerlist_filters_mobile_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function main_offerlist_filters_mobile_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function main_offerlist_filters_mobile_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function main_offerlist_filters_mobile_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function main_offerlist_filters_mobile_slicedToArray(arr, i) {
    return main_offerlist_filters_mobile_arrayWithHoles(arr) || main_offerlist_filters_mobile_iterableToArrayLimit(arr, i) || main_offerlist_filters_mobile_unsupportedIterableToArray(arr, i) || main_offerlist_filters_mobile_nonIterableRest();
}
function main_offerlist_filters_mobile_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return main_offerlist_filters_mobile_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return main_offerlist_filters_mobile_arrayLikeToArray(o, minLen);
}











var MainOfferlistFiltersMobile = function(props) {
    var applicableFilters = props.applicableFilters, activeOfferlistFilters = props.activeOfferlistFilters, onSort = props.onSort, currentSorting = props.currentSorting, sortOptions = props.sortOptions, className = props.className;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var toggleFilter = (0,offer_list_filter_context/* useOfferListFilterContext */.o)().toggleFilter;
    var ref = main_offerlist_filters_mobile_slicedToArray((0,react.useState)(false), 2), showFilters = ref[0], setShowFilters = ref[1];
    var closeHandler = function() {
        return setShowFilters(false);
    };
    var toggleHandler = function() {
        return setShowFilters(!showFilters);
    };
    var renderSortingRadios = function() {
        return sortOptions === null || sortOptions === void 0 ? void 0 : sortOptions.map(function(option) {
            /*#__PURE__*/ return react.createElement("div", {
                key: option.title
            }, /*#__PURE__*/ react.createElement(radiobutton/* RadioButton */.EU, {
                onClickHandler: function() {
                    onSort === null || onSort === void 0 ? void 0 : onSort(option);
                },
                text: option.title,
                value: (option === null || option === void 0 ? void 0 : option.title) || sortOptions[0].title,
                selectedValue: currentSorting === null || currentSorting === void 0 ? void 0 : currentSorting.title
            }));
        });
    };
    var getSortFilter = function() {
        if (sortOptions === null || sortOptions === void 0 ? void 0 : sortOptions.length) {
            return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(variants.H4Text, null, t("common", "sort.title")), renderSortingRadios());
        }
        return /*#__PURE__*/ react.createElement(variants.TitleSmallText, {
            flex: false,
            emphasis: variants.FontEmphasis.LOW,
            behavior: variants.Behavior.Oneline
        }, t("product", "sorting.sorted-by-cheapest-price"));
    };
    return /*#__PURE__*/ react.createElement("div", {
        className: className
    }, /*#__PURE__*/ react.createElement(filter_toggle_button, {
        toggleHandler: toggleHandler,
        activeFilters: activeOfferlistFilters.length,
        title: t("filter", "filter.title"),
        icon: /*#__PURE__*/ react.createElement(sliders/* IconSliders */.O, null)
    }), showFilters && /*#__PURE__*/ react.createElement(modal_v2/* default */.Z, {
        isOpen: showFilters,
        onRequestClose: closeHandler
    }, /*#__PURE__*/ react.createElement(modal/* ModalBody */.fe, null, /*#__PURE__*/ react.createElement(styles/* MobileWrapper */.nv, null, Boolean(sortOptions === null || sortOptions === void 0 ? void 0 : sortOptions.length) && /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(styles/* FilterRow */.TH, null, getSortFilter())), /*#__PURE__*/ react.createElement(all_filters/* AllFiltersLoader */.m, {
        filters: applicableFilters,
        onToggleFilter: toggleFilter
    })))));
};

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/offer-list-filters/index.tsx
/* eslint-disable jsx-a11y/no-static-element-interactions */ 



var OfferListFilters = function(param) {
    var applicableFilters = param.applicableFilters, activeOfferlistFilters = param.activeOfferlistFilters, onSort = param.onSort, currentSorting = param.currentSorting, sortOptions = param.sortOptions;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(block/* MobileOnly */.iB, null, /*#__PURE__*/ react.createElement(MainOfferlistFiltersMobile, {
        applicableFilters: applicableFilters,
        activeOfferlistFilters: activeOfferlistFilters,
        onSort: onSort,
        currentSorting: currentSorting,
        sortOptions: sortOptions
    })), /*#__PURE__*/ react.createElement(block/* MediumUp */.TD, null, /*#__PURE__*/ react.createElement(MainOfferlistFiltersDropdown, {
        applicableFilters: applicableFilters,
        activeOfferlistFilters: activeOfferlistFilters
    })));
};

;// CONCATENATED MODULE: ./src/areas/product/utils/price-list/filter-filters.ts

var getApplicableFilters = function(filters, offers, allOffersWithActiveAdditives) {
    var hasAuthorizedInOffers = getHasAuthorizedInOffers(allOffersWithActiveAdditives);
    var hasInternationalOffers = getHasInternationalOffers(offers);
    var hasNotAvailableOffers = getHasNotAvailableOffers(offers);
    var updatedFilters = filters.filter(function(filter) {
        return (filter.type !== price_list_types/* FilterType.AUTHORIZED_DEALER */.vA.AUTHORIZED_DEALER || hasAuthorizedInOffers) && (filter.type !== price_list_types/* FilterType.INTERNATIONAL */.vA.INTERNATIONAL || hasInternationalOffers) && (filter.type !== price_list_types/* FilterType.NOT_FOR_SALE */.vA.NOT_FOR_SALE || hasNotAvailableOffers);
    });
    return updatedFilters;
};
var getHasAuthorizedInOffers = function(offers) {
    return offers.some(function(offer) {
        return offer.authorizedDealer;
    });
};
var getHasInternationalOffers = function(offers) {
    return offers.some(function(offer) {
        return !offer.primaryMarket || getHasInternationalAlternatives(offer);
    });
};
var getHasInternationalAlternatives = function(offer) {
    var _alternativePrices;
    var alternativeOffers = (_alternativePrices = offer.alternativePrices) !== null && _alternativePrices !== void 0 ? _alternativePrices : [];
    if (alternativeOffers.length === 0) {
        return false;
    }
    return alternativeOffers.some(function(altOffer) {
        return !altOffer.primaryMarket;
    });
};
var getHasNotAvailableOffers = function(offers) {
    return offers.some(function(offer) {
        var ref;
        return ((ref = offer.availability) === null || ref === void 0 ? void 0 : ref.condition) === "NotAvailableForOrder" || getHasNotAvailableAlternatives(offer);
    });
};
var getHasNotAvailableAlternatives = function(offer) {
    var _alternativePrices;
    var alternativeOffers = (_alternativePrices = offer.alternativePrices) !== null && _alternativePrices !== void 0 ? _alternativePrices : [];
    if (alternativeOffers.length === 0) {
        return false;
    }
    return alternativeOffers.some(function(altOffer) {
        var ref;
        return ((ref = altOffer.availability) === null || ref === void 0 ? void 0 : ref.condition) === "NotAvailableForOrder";
    });
};

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n    padding-top: 0;\n  "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  padding-top: ",
        ";\n\n  ",
        ";\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  @media screen and (max-width: 340px) {\n    margin-left: -",
        ";\n    margin-right: -",
        ";\n  }\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n      order: 3;\n    "
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  border-bottom: none;\n\n  ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = styles_taggedTemplateLiteral([
        "\n  font-weight: 100;\n  font-size: ",
        ";\n  margin-left: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = styles_taggedTemplateLiteral([
        "\n  align-items: center;\n\n  z-index: 3; /* Needed for sorting dropdown */\n  margin-top: 0;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = styles_taggedTemplateLiteral([
        "\n    position: absolute;\n    width: calc(100vw - ",
        ");\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = styles_taggedTemplateLiteral([
        "\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}



var compensateForPadding = (0,base/* remCalc */.vR)(base/* layout.gridColumnGutter.small.value */.bK.gridColumnGutter.small.value / 2);
var PriceListPanelWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PriceListPanelWrapper",
    componentId: "sc-0-0"
})(styles_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.smallOnly */.BC.smallOnly(styles_templateObject()));
var AdContainer = (0,styled_components_browser_esm["default"])(ads/* default */.Z).withConfig({
    displayName: "AdContainer",
    componentId: "sc-0-1"
})(styles_templateObject2(), compensateForPadding, compensateForPadding);
var AdvertTableRowElement = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AdvertTableRowElement",
    componentId: "sc-0-2"
})(_templateObject4(), function(p) {
    return p.withPosition && (0,styled_components_browser_esm.css)(styles_templateObject3());
});
var TitleCount = styled_components_browser_esm["default"].span.withConfig({
    displayName: "TitleCount",
    componentId: "sc-0-3"
})(_templateObject5(), base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall, base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var Header = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Header",
    componentId: "sc-0-4"
})(_templateObject6());
var HeaderButtons = styled_components_browser_esm["default"].div.withConfig({
    displayName: "HeaderButtons",
    componentId: "sc-0-5"
})(_templateObject7(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var DisclaimerWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "DisclaimerWrapper",
    componentId: "sc-0-6"
})(_templateObject9(), base/* media.smallOnly */.BC.smallOnly(_templateObject8(), (0,base/* remCalc */.vR)(base/* layout.pageContent.gutter.value */.bK.pageContent.gutter.value * 2)));
var HeaderFlex = styled_components_browser_esm["default"].div.withConfig({
    displayName: "HeaderFlex",
    componentId: "sc-0-7"
})(_templateObject10(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

// EXTERNAL MODULE: ./src/areas/product/components/price-list/offer-list-filters/shipping-filters/index.tsx + 8 modules
var shipping_filters = __webpack_require__(37585);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/delivery/index.js
var delivery = __webpack_require__(10919);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-list-panel/styles.ts
function price_list_panel_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function price_list_panel_styles_templateObject() {
    var data = price_list_panel_styles_taggedTemplateLiteral([
        "\n  margin: 0;\n  padding: 0;\n  margin-top: ",
        ";\n  list-style: none;\n\n  > li:not(:last-child) {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    price_list_panel_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function price_list_panel_styles_templateObject1() {
    var data = price_list_panel_styles_taggedTemplateLiteral([
        "\n    margin-bottom: 30px;\n  "
    ]);
    price_list_panel_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function price_list_panel_styles_templateObject2() {
    var data = price_list_panel_styles_taggedTemplateLiteral([
        "\n  margin-bottom: 20px;\n\n  ",
        "\n\n  > ul:not(:last-child) {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    price_list_panel_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function price_list_panel_styles_templateObject3() {
    var data = price_list_panel_styles_taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    price_list_panel_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = price_list_panel_styles_taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = price_list_panel_styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = price_list_panel_styles_taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = price_list_panel_styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = price_list_panel_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  padding-right: ",
        ";\n"
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = price_list_panel_styles_taggedTemplateLiteral([
        "\n    width: 100%;\n    overflow-x: auto;\n    position: relative;\n    padding: ",
        ";\n    left: -",
        ";\n    width: calc(100% + ",
        ");\n    padding-bottom: 0;\n  "
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    var data = price_list_panel_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  margin-bottom: ",
        ";\n\n  ",
        "\n"
    ]);
    styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = price_list_panel_styles_taggedTemplateLiteral([
        "\n    flex-wrap: wrap;\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = price_list_panel_styles_taggedTemplateLiteral([
        "\n    > li:last-child { padding-right: ",
        " }\n  "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = price_list_panel_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  list-style: none;\n  margin: 0;\n  gap: ",
        ";\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = price_list_panel_styles_taggedTemplateLiteral([
        "\n  padding-bottom: 2px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}


var PriceList = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "PriceList",
    componentId: "sc-0-0"
})(price_list_panel_styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var PricePanel = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PricePanel",
    componentId: "sc-0-1"
})(price_list_panel_styles_templateObject2(), base/* media.mediumUp */.BC.mediumUp(price_list_panel_styles_templateObject1()), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var HeaderWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "HeaderWrapper",
    componentId: "sc-0-2"
})(price_list_panel_styles_templateObject3(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var MobileButton = styled_components_browser_esm["default"].div.withConfig({
    displayName: "MobileButton",
    componentId: "sc-0-3"
})(styles_templateObject5(), base/* media.mediumUp */.BC.mediumUp(styles_templateObject4()));
var MediumUpButton = styled_components_browser_esm["default"].div.withConfig({
    displayName: "MediumUpButton",
    componentId: "sc-0-4"
})(styles_templateObject7(), base/* media.smallDown */.BC.smallDown(styles_templateObject6()));
var ShippingWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ShippingWrapper",
    componentId: "sc-0-5"
})(styles_templateObject8(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var ScrollingChipList = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ScrollingChipList",
    componentId: "sc-0-6"
})(styles_templateObject10(), base/* layout.measurements.spacing075 */.bK.measurements.spacing075, base/* media.smallOnly */.BC.smallOnly(styles_templateObject9(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing100 */.bK.measurements.spacing100));
var ScrollingChipListWrapper = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "ScrollingChipListWrapper",
    componentId: "sc-0-7"
})(_templateObject13(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.mediumUp */.BC.mediumUp(_templateObject11()), base/* media.smallOnly */.BC.smallOnly(_templateObject12(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050));
var StyledChip = styled_components_browser_esm["default"].li.withConfig({
    displayName: "StyledChip",
    componentId: "sc-0-8"
})(_templateObject14());

// EXTERNAL MODULE: ./src/areas/product/components/price-list/offer-list-filters/shipping-filters/delivery-methods/utils.ts
var delivery_methods_utils = __webpack_require__(68443);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/offer-list-filters/shipping-filters/shippingFilterButton.tsx





var ShippingFilterButton = function(props) {
    var toggleHandler = props.toggleHandler, title = props.title, icon = props.icon, _activeFilters = props.activeFilters, activeFilters = _activeFilters === void 0 ? 0 : _activeFilters, hideNumber = props.hideNumber, showToggleButton = props.showToggleButton, isOpen = props.isOpen;
    return /*#__PURE__*/ react.createElement(styles/* ShippingFilterTextButton */.qj, {
        onClick: toggleHandler,
        selectable: true,
        selected: !!activeFilters
    }, activeFilters > 0 && /*#__PURE__*/ react.createElement(styles/* ButtonBadge */.kP, {
        circular: true,
        text: !hideNumber && activeFilters
    }), /*#__PURE__*/ react.createElement(button_variants.ButtonIcon, null, icon), /*#__PURE__*/ react.createElement(button_variants.ButtonText, null, title), showToggleButton && /*#__PURE__*/ react.createElement(button_variants.ButtonIcon, null, isOpen ? /*#__PURE__*/ react.createElement(dropdown_up.IconDropdownUp, null) : /*#__PURE__*/ react.createElement(dropdown_down.IconDropdownDown, null)));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/light-theme-colors.js
var light_theme_colors = __webpack_require__(24774);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/index.js
var design_tokens = __webpack_require__(43220);
;// CONCATENATED MODULE: ./src/areas/product/components/onboarding-popover/styles.ts
function onboarding_popover_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function onboarding_popover_styles_templateObject() {
    var data = onboarding_popover_styles_taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    onboarding_popover_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function onboarding_popover_styles_templateObject1() {
    var data = onboarding_popover_styles_taggedTemplateLiteral([
        "\n      &::before {\n        bottom: -20px;\n        left: 50%;\n        transform: translateX(-50%) rotate(0deg);\n        border-top-color: ",
        ";\n      }\n    "
    ]);
    onboarding_popover_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function onboarding_popover_styles_templateObject2() {
    var data = onboarding_popover_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  background-color: ",
        ";\n  width: auto;\n  padding: ",
        ";\n  border: 1px solid rgba(5, 30, 46, 0.12);\n  border-radius: ",
        ";\n  z-index: 101;\n  bottom: 57px;\n\n  &::before {\n    content: '';\n    position: absolute;\n    border: solid transparent;\n    border-width: 10px;\n  }\n\n  ",
        "\n"
    ]);
    onboarding_popover_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function onboarding_popover_styles_templateObject3() {
    var data = onboarding_popover_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: -2px;\n  right: -1px;\n  border: none;\n  cursor: pointer;\n  padding: ",
        ";\n"
    ]);
    onboarding_popover_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function onboarding_popover_styles_templateObject4() {
    var data = onboarding_popover_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    onboarding_popover_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function onboarding_popover_styles_templateObject5() {
    var data = onboarding_popover_styles_taggedTemplateLiteral([
        "\n  & button {\n    box-shadow: ",
        ";\n  }\n"
    ]);
    onboarding_popover_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Container",
    componentId: "sc-0-0"
})(onboarding_popover_styles_templateObject());
var Background = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Background",
    componentId: "sc-0-1"
})(onboarding_popover_styles_templateObject2(), light_theme_colors.maybeBlue900, design_tokens.measurements.spacing075, design_tokens.measurements.spacing050, function(props) {
    return props.$arrowPosition === "bottom-middle" && (0,styled_components_browser_esm.css)(onboarding_popover_styles_templateObject1(), light_theme_colors.maybeBlue900);
});
var CloseButton = styled_components_browser_esm["default"].button.withConfig({
    displayName: "CloseButton",
    componentId: "sc-0-2"
})(onboarding_popover_styles_templateObject3(), design_tokens.measurements.spacing025);
var TextPopover = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TextPopover",
    componentId: "sc-0-3"
})(onboarding_popover_styles_templateObject4());
var PopoverChildren = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PopoverChildren",
    componentId: "sc-0-4"
})(onboarding_popover_styles_templateObject5(), function(props) {
    return props.$isVisible ? "0 0 transparent, 0 0 0 1px rgba(5, 30, 46, 0.12), 0 0 0 2px rgba(0, 52, 81, 1)" : "none";
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/close/index.js
var icon_close = __webpack_require__(15309);
;// CONCATENATED MODULE: ./src/areas/product/components/onboarding-popover/index.tsx
function onboarding_popover_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function onboarding_popover_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function onboarding_popover_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function onboarding_popover_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function onboarding_popover_slicedToArray(arr, i) {
    return onboarding_popover_arrayWithHoles(arr) || onboarding_popover_iterableToArrayLimit(arr, i) || onboarding_popover_unsupportedIterableToArray(arr, i) || onboarding_popover_nonIterableRest();
}
function onboarding_popover_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return onboarding_popover_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return onboarding_popover_arrayLikeToArray(o, minLen);
}




var OnboardingPopoverExperiment = function(param) {
    var title = param.title, body = param.body, popoverFeature = param.children;
    var ref = onboarding_popover_slicedToArray((0,react.useState)(false), 2), isVisible = ref[0], setIsVisible = ref[1];
    (0,react.useEffect)(function() {
        var timer;
        var hasSeenOnboardingPopoverPP = localStorage.getItem("hasSeenOnboardingPopoverPP");
        if (!hasSeenOnboardingPopoverPP) {
            timer = setTimeout(function() {
                setIsVisible(true);
            }, 5000);
        } else {
            setIsVisible(false);
        }
        return function() {
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, []);
    var handleClosePopover = function() {
        setIsVisible(false);
        localStorage.setItem("hasSeenOnboardingPopoverPP", "true");
    };
    return /*#__PURE__*/ react.createElement(Container, null, isVisible && /*#__PURE__*/ react.createElement(Background, {
        $arrowPosition: "bottom-middle"
    }, /*#__PURE__*/ react.createElement(TextPopover, null, /*#__PURE__*/ react.createElement(variants.TitleSmallText, {
        color: variants.FontColor.LIGHT
    }, title), /*#__PURE__*/ react.createElement(variants.CaptionText, {
        color: variants.FontColor.LIGHT,
        emphasis: variants.FontEmphasis.MEDIUM
    }, body)), /*#__PURE__*/ react.createElement(CloseButton, {
        onClick: handleClosePopover
    }, /*#__PURE__*/ react.createElement(icon_close.IconClose, {
        color: "base300"
    }))), /*#__PURE__*/ react.createElement(PopoverChildren, {
        onClick: handleClosePopover,
        $isVisible: isVisible
    }, popoverFeature));
};
/* harmony default export */ const onboarding_popover = (OnboardingPopoverExperiment);

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-list-panel/price-list-header.tsx
function price_list_header_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function price_list_header_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function price_list_header_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function price_list_header_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function price_list_header_slicedToArray(arr, i) {
    return price_list_header_arrayWithHoles(arr) || price_list_header_iterableToArrayLimit(arr, i) || price_list_header_unsupportedIterableToArray(arr, i) || price_list_header_nonIterableRest();
}
function price_list_header_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return price_list_header_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return price_list_header_arrayLikeToArray(o, minLen);
}























var PriceListHeader = function(param) {
    var allOffers = param.allOffers, allOffersWithActiveAdditives = param.allOffersWithActiveAdditives, onSort = param.onSort, sorting = param.sorting;
    var ref, ref1;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref2 = (0,offer_list_filter_context/* useOfferListFilterContext */.o)(), getFilterByPlacement = ref2.getFilterByPlacement, getFilter = ref2.getFilter;
    var ref3 = price_list_header_slicedToArray((0,react.useState)([]), 2), applicableFilters = ref3[0], setApplicableFilters = ref3[1];
    var ref4 = price_list_header_slicedToArray((0,react.useState)(false), 2), showShipping = ref4[0], setShowShipping = ref4[1];
    var ref5 = price_list_header_slicedToArray((0,react.useState)(false), 2), showShippingModal = ref5[0], setShowShippingModal = ref5[1];
    var filtersByPlacement = getFilterByPlacement(price_list_types/* FilterUIPlacementEnum.FILTER_MENU */.jm.FILTER_MENU);
    var sortOptions = (0,price_list_utils/* getSortOptions */.nh)(t, allOffers);
    var currentSorting = sortOptions.length === 0 ? undefined : sortOptions.find(function(sort) {
        return sort.type === sorting;
    }) || sortOptions[0];
    (0,react.useEffect)(function() {
        var initializeFilters = function() {
            var updatedFilters = getApplicableFilters(filtersByPlacement, allOffers, allOffersWithActiveAdditives);
            setApplicableFilters(updatedFilters);
        };
        initializeFilters();
    }, [
        allOffers,
        allOffersWithActiveAdditives
    ]);
    var activeFiltersInFilterMenu = (filtersByPlacement === null || filtersByPlacement === void 0 ? void 0 : filtersByPlacement.filter(function(filter) {
        var isNotHidden = !!filter.hidden;
        var activeAdditive = !filter.active && filter.additive;
        var active = filter.active && !filter.additive;
        return isNotHidden && (active || activeAdditive);
    })) || [];
    var activeDeliveryMethod = ((ref = getFilter(price_list_types/* FilterType.DELIVERY_METHOD */.vA.DELIVERY_METHOD)) === null || ref === void 0 ? void 0 : ref.selection) || [];
    var selectedCarriers = ((ref1 = getFilter(price_list_types/* FilterType.CARRIERS */.vA.CARRIERS)) === null || ref1 === void 0 ? void 0 : ref1.selection) || [];
    var offersWithShippingCount = allOffersWithActiveAdditives.filter(function(offer) {
        var ref;
        return (ref = offer.shipping) === null || ref === void 0 ? void 0 : ref.nodes.some(function(node) {
            return Boolean(node.deliveryMethod);
        });
    }, 0);
    var getSortFilter = function() {
        if (currentSorting) {
            return(// div needed to handle MediumUp children bug on mobile
            /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(onboarding_popover, {
                title: t("product", "onboarding-popover.title"),
                body: t("product", "onboarding-popover.body")
            }, /*#__PURE__*/ react.createElement(filter_dropdown/* FilterDropdown */.ML, {
                alignment: ui/* Direction.Right */.Nm.Right,
                defaultSelected: currentSorting,
                options: sortOptions,
                onFilterChange: function(option) {
                    return onSort(option);
                }
            }))));
        }
        return /*#__PURE__*/ react.createElement(variants.TitleSmallText, {
            flex: false,
            emphasis: variants.FontEmphasis.LOW,
            behavior: variants.Behavior.Oneline
        }, t("product", "sorting.sorted-by-cheapest-price"));
    };
    var getDeliveryTitle = function() {
        var activeCarriers = "";
        var title = t("product", "filter.delivery");
        var hasActiveMethod = activeDeliveryMethod.length > 0;
        if (hasActiveMethod) {
            title = (0,delivery_methods_utils/* getTranslation */.i)(t, activeDeliveryMethod[0]) || "";
        }
        if (selectedCarriers.length > 0 && !hasActiveMethod) {
            title = selectedCarriers[0];
        }
        if (hasActiveMethod && selectedCarriers.length > 0) {
            activeCarriers = "+".concat(selectedCarriers.length);
        }
        if (!hasActiveMethod && selectedCarriers.length > 1) {
            activeCarriers = "+".concat(selectedCarriers.length - 1);
        }
        return "".concat(title, " ").concat(activeCarriers);
    };
    return /*#__PURE__*/ react.createElement(Header, {
        "data-test": "PricePanelHeader"
    }, /*#__PURE__*/ react.createElement(styles/* ScrollingFiltersList */.hY, null, /*#__PURE__*/ react.createElement(HeaderFlex, null, /*#__PURE__*/ react.createElement(HeaderButtons, null, /*#__PURE__*/ react.createElement(OfferListFilters, {
        applicableFilters: applicableFilters,
        activeOfferlistFilters: activeFiltersInFilterMenu,
        onSort: onSort,
        currentSorting: currentSorting,
        sortOptions: sortOptions
    }), /*#__PURE__*/ react.createElement(HeaderFilters, null), offersWithShippingCount.length > 0 && /*#__PURE__*/ react.createElement(ShippingWrapper, null, /*#__PURE__*/ react.createElement(MobileButton, null, /*#__PURE__*/ react.createElement(filter_toggle_button, {
        toggleHandler: function() {
            return setShowShippingModal(!showShipping);
        },
        activeFilters: activeDeliveryMethod.length || selectedCarriers.length,
        hideNumber: true,
        title: getDeliveryTitle(),
        showToggleButton: true,
        icon: /*#__PURE__*/ react.createElement(delivery/* IconDeliveryOutlined */._R, null),
        isOpen: showShipping
    })), /*#__PURE__*/ react.createElement(MediumUpButton, null, /*#__PURE__*/ react.createElement(ShippingFilterButton, {
        toggleHandler: function() {
            return setShowShipping(!showShipping);
        },
        activeFilters: activeDeliveryMethod.length || selectedCarriers.length,
        hideNumber: true,
        title: getDeliveryTitle(),
        showToggleButton: true,
        icon: /*#__PURE__*/ react.createElement(delivery/* IconDeliveryOutlined */._R, null),
        isOpen: showShipping
    })), showShipping && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(styles/* FilterBlocker */.rO, {
        onClick: function() {
            return setShowShipping(false);
        }
    }), /*#__PURE__*/ react.createElement(styles/* FiltersDropDown */.g6, null, /*#__PURE__*/ react.createElement(styles/* FilterPanelWrapper */.gC, null, /*#__PURE__*/ react.createElement(shipping_filters/* ShippingFilters */.O, null)))))), /*#__PURE__*/ react.createElement(block/* MediumUp */.TD, null, getSortFilter()))), showShippingModal && /*#__PURE__*/ react.createElement(modal_v2/* default */.Z, {
        isOpen: showShippingModal,
        onRequestClose: function() {
            return setShowShippingModal(false);
        }
    }, /*#__PURE__*/ react.createElement(modal/* ModalBody */.fe, null, /*#__PURE__*/ react.createElement(styles/* MobileWrapper */.nv, null, /*#__PURE__*/ react.createElement(shipping_filters/* ShippingFilters */.O, null)))));
};

// EXTERNAL MODULE: ./src/components/viewport/context.tsx
var context = __webpack_require__(84198);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row-context.tsx
var price_row_context = __webpack_require__(70264);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/ads/index.tsx
function ads_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return ads_arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || ads_unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function ads_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ads_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ads_arrayLikeToArray(o, minLen);
}



var advertSpacing = {
    top: "10px",
    bottom: "10px"
};
var INDEXES = [
    4,
    10,
    16
].concat(// Ad every 10th price row
_toConsumableArray(Array(16).fill(10).map(function(v, i) {
    return v + v * i + 16;
})));
var getMobileAd = function(index, mounted) {
    var isFirstAdInList = index === INDEXES[0];
    return /*#__PURE__*/ react.createElement(AdvertTableRowElement, {
        key: "mobile-ad-container-".concat(index)
    }, /*#__PURE__*/ react.createElement(block/* MobileOnly */.iB, null, /*#__PURE__*/ react.createElement(AdContainer, {
        placement: isFirstAdInList ? "dubbelpanorama1" : "dubbelpanorama2",
        format: isFirstAdInList ? "panorama_1" : "panorama_2",
        min: 0,
        max: 860,
        spacing: advertSpacing,
        triggerPoint: isFirstAdInList ? undefined : 100,
        async: mounted && index > 1
    })));
};
var getDesktopAd = function(index, mounted) {
    var isFirstAdInList = index === INDEXES[0];
    return /*#__PURE__*/ react.createElement(AdvertTableRowElement, {
        withPosition: true,
        key: "desktop-ad-container-".concat(index),
        className: "pj-ui-pricelist--advert"
    }, /*#__PURE__*/ react.createElement(AdContainer, {
        min: 860,
        max: 10000,
        scalable: true,
        scaleBase: ".pj-ui-pricelist--advert",
        spacing: advertSpacing,
        placement: isFirstAdInList ? "panorama_extra" : "panorama_extra_2",
        format: isFirstAdInList ? "panorama_1_wde" : "panorama_2_wde",
        triggerPoint: isFirstAdInList ? undefined : 100,
        async: mounted && index > 1
    }));
};
var insertTableAds = function(tableRows, mounted) {
    var mobileIndexes = INDEXES;
    // Only max 3 ads in desktop viewport
    var desktopIndexes = INDEXES.slice(0, 3);
    var adjustedMobileAdsIndexes = mobileIndexes.filter(function(index) {
        return index <= tableRows.length;
    });
    var adjustedDesktopAdsIndexes = desktopIndexes.filter(function(index) {
        return index <= tableRows.length;
    });
    var tableRowWithAds = [];
    tableRows.forEach(function(row, index) {
        tableRowWithAds.push(row);
        if (adjustedMobileAdsIndexes.find(function(i) {
            return i === index + 1;
        })) tableRowWithAds.push(getMobileAd(index + 1, mounted));
        if (adjustedDesktopAdsIndexes.find(function(i) {
            return i === index + 1;
        })) tableRowWithAds.push(getDesktopAd(index + 1, mounted));
    });
    // special case for short list
    if (!adjustedMobileAdsIndexes.length) tableRowWithAds.push(getMobileAd(0, mounted));
    if (!adjustedDesktopAdsIndexes.length) tableRowWithAds.push(getDesktopAd(0, mounted));
    return tableRowWithAds;
};

// EXTERNAL MODULE: ./src/hooks/experiments.ts
var experiments = __webpack_require__(46353);
// EXTERNAL MODULE: ./src/client/data-layer.ts
var data_layer = __webpack_require__(80695);
;// CONCATENATED MODULE: ./src/globals/tracking/expand.ts

var trackExpandEvent = function(data) {
    (0,data_layer/* pushEvent */.A)("component_expand", {
        scope: data.scope
    });
};
var TrackExpandScope;
(function(TrackExpandScope) {
    TrackExpandScope["PRICE_LIST"] = "product_price_list";
})(TrackExpandScope || (TrackExpandScope = {}));

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-list-panel/price-list-footer.tsx






var ShowMoreButton = function(props) {
    var offersCount = props.offersCount, showMorePrices = props.showMorePrices, numberOfVisiblePrices = props.numberOfVisiblePrices, setShowMorePrices = props.setShowMorePrices;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var isMobile = (0,context/* useViewportContext */.Ak)().isMobile;
    var shortenOfferlistExperiment = (0,experiments/* useShortenOfferlistHideAdsExperiment */.k0)();
    var showMorePricesLabel = "".concat(t("product", "prices.show-more-prices-button"), " (+").concat(offersCount - numberOfVisiblePrices, ")");
    var handleOnClick = function() {
        setShowMorePrices(true);
        trackExpandEvent({
            scope: TrackExpandScope.PRICE_LIST
        });
    };
    return /*#__PURE__*/ react.createElement("div", null, !showMorePrices && offersCount > numberOfVisiblePrices && /*#__PURE__*/ react.createElement(react.Fragment, null, shortenOfferlistExperiment === "shorten-plus-button" ? /*#__PURE__*/ react.createElement(react.Fragment, null, isMobile ? /*#__PURE__*/ react.createElement(button_variants.PrimaryButton, {
        onClick: handleOnClick,
        style: {
            margin: "0 auto"
        },
        fullWidth: true
    }, showMorePricesLabel) : /*#__PURE__*/ react.createElement(button_variants.TonalButton, {
        onClick: handleOnClick,
        style: {
            margin: "0 auto"
        }
    }, showMorePricesLabel)) : /*#__PURE__*/ react.createElement(button_variants.TextButton, {
        onClick: handleOnClick,
        style: {
            margin: "0 auto"
        }
    }, /*#__PURE__*/ react.createElement(button_variants.ButtonText, null, showMorePricesLabel))));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/index.js
var ui_text = __webpack_require__(49955);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/trending-down/index.js
var trending_down = __webpack_require__(90258);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row/components/condition-type-badge/index.tsx + 1 modules
var condition_type_badge = __webpack_require__(83717);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row/components/go-to-store-button/index.tsx + 1 modules
var go_to_store_button = __webpack_require__(29781);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row/components/price-row-columns/styles.ts
var price_row_columns_styles = __webpack_require__(50762);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/card/index.js
var card = __webpack_require__(89695);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/card/variants.js
var card_variants = __webpack_require__(11049);
// EXTERNAL MODULE: ./src/components/offer/price/price-label/index.tsx + 1 modules
var price_label = __webpack_require__(47477);
// EXTERNAL MODULE: ./src/components/offer/price/offer-price/styles.ts
var offer_price_styles = __webpack_require__(46140);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row/row-types/styles.ts
var row_types_styles = __webpack_require__(40710);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/row-types/collapsed-offers-placeholder/styles.ts
function collapsed_offers_placeholder_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function collapsed_offers_placeholder_styles_templateObject() {
    var data = collapsed_offers_placeholder_styles_taggedTemplateLiteral([
        "\n      background: ",
        ";\n    "
    ]);
    collapsed_offers_placeholder_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function collapsed_offers_placeholder_styles_templateObject1() {
    var data = collapsed_offers_placeholder_styles_taggedTemplateLiteral([
        "\n    margin-bottom: ",
        ";\n\n    ",
        "\n  "
    ]);
    collapsed_offers_placeholder_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function collapsed_offers_placeholder_styles_templateObject2() {
    var data = collapsed_offers_placeholder_styles_taggedTemplateLiteral([
        "\n      padding: ",
        " 0 ",
        " ",
        ";\n    "
    ]);
    collapsed_offers_placeholder_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function collapsed_offers_placeholder_styles_templateObject3() {
    var data = collapsed_offers_placeholder_styles_taggedTemplateLiteral([
        "\n      padding-left: ",
        ";\n    "
    ]);
    collapsed_offers_placeholder_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function collapsed_offers_placeholder_styles_templateObject4() {
    var data = collapsed_offers_placeholder_styles_taggedTemplateLiteral([
        "\n  && {\n    flex: 1;\n    cursor: pointer;\n    gap: ",
        ";\n    padding: ",
        " 0;\n    padding-left: ",
        ";\n    height: ",
        ";\n\n    ",
        "\n\n    ",
        "\n  }\n\n  &.focus-visible {\n    outline: 2px solid ",
        ";\n    border-radius: ",
        ";\n  }\n"
    ]);
    collapsed_offers_placeholder_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function collapsed_offers_placeholder_styles_templateObject5() {
    var data = collapsed_offers_placeholder_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 1;\n  align-items: center;\n"
    ]);
    collapsed_offers_placeholder_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function collapsed_offers_placeholder_styles_templateObject6() {
    var data = collapsed_offers_placeholder_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  text-align: initial;\n"
    ]);
    collapsed_offers_placeholder_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function collapsed_offers_placeholder_styles_templateObject7() {
    var data = collapsed_offers_placeholder_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  align-items: flex-end;\n"
    ]);
    collapsed_offers_placeholder_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function collapsed_offers_placeholder_styles_templateObject8() {
    var data = collapsed_offers_placeholder_styles_taggedTemplateLiteral([
        "\n  white-space: nowrap;\n"
    ]);
    collapsed_offers_placeholder_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function collapsed_offers_placeholder_styles_templateObject9() {
    var data = collapsed_offers_placeholder_styles_taggedTemplateLiteral([
        "\n  flex: 0 1 auto;\n  font-size: ",
        ";\n"
    ]);
    collapsed_offers_placeholder_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function collapsed_offers_placeholder_styles_templateObject10() {
    var data = collapsed_offers_placeholder_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  visibility: hidden;\n"
    ]);
    collapsed_offers_placeholder_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    var data = collapsed_offers_placeholder_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function styles_templateObject12() {
    var data = collapsed_offers_placeholder_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  border-radius: 50%;\n  background-color: ",
        ";\n  padding: ",
        ";\n"
    ]);
    styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}








var StyledRowCard = (0,styled_components_browser_esm["default"])(card_variants/* RowCard */.Jz).withConfig({
    displayName: "StyledRowCard",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(collapsed_offers_placeholder_styles_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, !props.$emphasized && (0,styled_components_browser_esm.css)(collapsed_offers_placeholder_styles_templateObject(), props.theme.colors.base100));
});
var StyledCardActionArea = (0,styled_components_browser_esm["default"])(card.CardActionArea).withConfig({
    displayName: "StyledCardActionArea",
    componentId: "sc-0-1"
})(collapsed_offers_placeholder_styles_templateObject4(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing150 */.bK.measurements.spacing150, row_types_styles/* ROW_HEIGHT */.dN, base/* media.mediumOnly */.BC.mediumOnly(collapsed_offers_placeholder_styles_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing150 */.bK.measurements.spacing150), base/* media.smallOnly */.BC.smallOnly(collapsed_offers_placeholder_styles_templateObject3(), base/* layout.measurements.spacing075 */.bK.measurements.spacing075), function(props) {
    return props.theme.colors.maybeBlue300;
}, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledContentWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledContentWrapper",
    componentId: "sc-0-2"
})(collapsed_offers_placeholder_styles_templateObject5());
var StyledFirstWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledFirstWrapper",
    componentId: "sc-0-3"
})(collapsed_offers_placeholder_styles_templateObject6());
var StyledSecondWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledSecondWrapper",
    componentId: "sc-0-4"
})(collapsed_offers_placeholder_styles_templateObject7());
var StyledBodyText = (0,styled_components_browser_esm["default"])(variants.BodySmallText).withConfig({
    displayName: "StyledBodyText",
    componentId: "sc-0-5"
})(collapsed_offers_placeholder_styles_templateObject8());
var StyledPriceLabel = (0,styled_components_browser_esm["default"])(price_label/* PriceLabel */.l).withConfig({
    displayName: "StyledPriceLabel",
    componentId: "sc-0-6"
})(collapsed_offers_placeholder_styles_templateObject9(), offer_price_styles/* PRICE_LABEL_SIZE */.j8);
var StyledCTAPlaceholder = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledCTAPlaceholder",
    componentId: "sc-0-7"
})(collapsed_offers_placeholder_styles_templateObject10());
var StyledPriceWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledPriceWrapper",
    componentId: "sc-0-8"
})(styles_templateObject11(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledDealsIcon = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledDealsIcon",
    componentId: "sc-0-9"
})(styles_templateObject12(), function(props) {
    return props.theme.colors.informative100;
}, base/* layout.measurements.spacing025 */.bK.measurements.spacing025);

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-row/row-types/collapsed-offers-placeholder/index.tsx












var CollapsedOffersPlaceholder = function(props) {
    var data = props.data, onClick = props.onClick;
    var title = data.title, count = data.count, cheapestOffer = data.cheapestOffer, hasDealOffers = data.hasDealOffers, ariaLabel = data.ariaLabel, emphasized = data.emphasized;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var product = (0,product_context/* useProductContext */.$h)().product;
    var viewport = (0,context/* useViewportContext */.Ak)();
    var viewSize = (0,price_list_utils/* getViewSize */.a0)(viewport);
    return /*#__PURE__*/ react.createElement(StyledRowCard, {
        outlined: true,
        $emphasized: emphasized
    }, /*#__PURE__*/ react.createElement(StyledCardActionArea, {
        containerProps: {
            onClick: function() {
                return onClick(product.id);
            },
            role: "button",
            "aria-label": ariaLabel
        }
    }, /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(StyledContentWrapper, null, /*#__PURE__*/ react.createElement(StyledFirstWrapper, null, /*#__PURE__*/ react.createElement(variants.CaptionText, null, t("common", "items.show-count", {
        count: count
    })), /*#__PURE__*/ react.createElement(variants.TitleSmallText, null, title)), /*#__PURE__*/ react.createElement(StyledSecondWrapper, null, cheapestOffer.condition && /*#__PURE__*/ react.createElement(condition_type_badge/* ConditionTypeBadge */.b, {
        condition: cheapestOffer.condition
    }), cheapestOffer.price && /*#__PURE__*/ react.createElement(StyledPriceWrapper, null, hasDealOffers && /*#__PURE__*/ react.createElement(StyledDealsIcon, null, /*#__PURE__*/ react.createElement(trending_down/* IconTrendingDown */.j, {
        color: "maybeBlue700",
        size: 16
    })), /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(StyledBodyText, {
        emphasis: emphasized ? ui_text.FontEmphasis.HIGH : ui_text.FontEmphasis.LOW
    }, t("product", "price.from-abbr"), " "), /*#__PURE__*/ react.createElement(StyledPriceLabel, {
        emphasis: emphasized ? ui_text.FontEmphasis.HIGH : ui_text.FontEmphasis.LOW,
        value: cheapestOffer.price.exclShipping,
        weight: ui_text.FontWeight.HEAVIEST
    }))))), /*#__PURE__*/ react.createElement(StyledCTAPlaceholder, null, /*#__PURE__*/ react.createElement(price_row_columns_styles/* StyledEndColumn */.Y, {
        $featured: true,
        $viewSize: viewSize
    }, /*#__PURE__*/ react.createElement(go_to_store_button/* GoToStoreButton */.a, {
        viewSize: viewSize
    }))))));
};

// EXTERNAL MODULE: ./src/areas/product/utils/product-condition/types.ts
var product_condition_types = __webpack_require__(83071);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-list-panel/components/used-placeholders.tsx
function used_placeholders_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function used_placeholders_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return used_placeholders_arrayLikeToArray(arr);
}
function used_placeholders_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function used_placeholders_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function used_placeholders_toConsumableArray(arr) {
    return used_placeholders_arrayWithoutHoles(arr) || used_placeholders_iterableToArray(arr) || used_placeholders_unsupportedIterableToArray(arr) || used_placeholders_nonIterableSpread();
}
function used_placeholders_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return used_placeholders_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return used_placeholders_arrayLikeToArray(o, minLen);
}




var isUsedOffer = function(offer) {
    return offer.condition !== product_condition_types/* ConditionEnum.NEW */.M.NEW;
};
var isNewOffer = function(offer) {
    return offer.condition === product_condition_types/* ConditionEnum.NEW */.M.NEW;
};
var getUsedPlaceHolderData = function(offers, collapseUnfeatured, unfeaturedPlaceholderData, t) {
    // Filter out other offers that will be collapsed
    var filteredOffers = collapseUnfeatured ? offers.filter(isFeaturedOffer) : offers;
    var candidateOffers = filteredOffers.filter(isUsedOffer);
    var cheapestUsedOffer = candidateOffers[0];
    var shouldBeAfterUnfeaturedPlaceholder = function() {
        if (!collapseUnfeatured || !(unfeaturedPlaceholderData === null || unfeaturedPlaceholderData === void 0 ? void 0 : unfeaturedPlaceholderData.cheapestOffer) || !cheapestUsedOffer) {
            return false;
        }
        // Compare original indexes for cheapest offers in Unfeatured vs Used placeholders
        var firstUnfeaturedOfferOriginalIndex = offers.findIndex(function(offer) {
            return offer.id === unfeaturedPlaceholderData.cheapestOffer.id;
        });
        var firstUsedOriginalIndex = offers.findIndex(function(offer) {
            return offer.id === cheapestUsedOffer.id;
        });
        return firstUnfeaturedOfferOriginalIndex < firstUsedOriginalIndex;
    };
    var position = filteredOffers.findIndex(isUsedOffer);
    if (shouldBeAfterUnfeaturedPlaceholder()) {
        position += 1;
    }
    return candidateOffers.length > 0 ? {
        title: t("product", "title.used-products", {
            n: candidateOffers.length
        }),
        count: candidateOffers.length,
        position: position,
        cheapestOffer: cheapestUsedOffer,
        hasDealOffers: false,
        ariaLabel: t("product", "price-list.used-placeholder-show-all"),
        emphasized: true
    } : undefined;
};
var insertUsedPlaceholder = function(offerRows, setUserHasExpandedUsed, placeholderData) {
    // If index in offer list for placeholder is more than offerRows.length,
    // the placeholder should not be visible.
    // This occurs when offerRows are sliced by numberOfVisiblePrices.
    if (!placeholderData || (placeholderData === null || placeholderData === void 0 ? void 0 : placeholderData.position) > offerRows.length) return offerRows;
    return used_placeholders_toConsumableArray(offerRows.slice(0, placeholderData === null || placeholderData === void 0 ? void 0 : placeholderData.position)).concat([
        /*#__PURE__*/ react.createElement(CollapsedOffersPlaceholder, {
            key: "used-placeholder-card",
            data: placeholderData,
            onClick: function() {
                setUserHasExpandedUsed(true);
            }
        })
    ], used_placeholders_toConsumableArray(offerRows.slice(placeholderData === null || placeholderData === void 0 ? void 0 : placeholderData.position)));
};

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-list-panel/components/unfeatured-placeholders.tsx
function unfeatured_placeholders_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function unfeatured_placeholders_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return unfeatured_placeholders_arrayLikeToArray(arr);
}
function unfeatured_placeholders_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function unfeatured_placeholders_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function unfeatured_placeholders_toConsumableArray(arr) {
    return unfeatured_placeholders_arrayWithoutHoles(arr) || unfeatured_placeholders_iterableToArray(arr) || unfeatured_placeholders_unsupportedIterableToArray(arr) || unfeatured_placeholders_nonIterableSpread();
}
function unfeatured_placeholders_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return unfeatured_placeholders_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return unfeatured_placeholders_arrayLikeToArray(o, minLen);
}



var isUnfeaturedOffer = function(offer) {
    return !offer.featured;
};
var isFeaturedOffer = function(offer) {
    return offer.featured;
};
var getUnfeaturedPlaceHolderData = function(offers, collapseUsed, t) {
    // Filter out other offers that will be collapsed
    var filteredOffers = collapseUsed ? offers.filter(isNewOffer) : offers;
    var firstOfferIndex = filteredOffers.findIndex(isUnfeaturedOffer);
    var candidateOffers = filteredOffers.filter(isUnfeaturedOffer);
    var hasDealOffers = candidateOffers.some(function(offer) {
        return offer.dealOffers.some(function(deal) {
            return deal.shopOfferId === offer.shopOfferId;
        });
    });
    return candidateOffers.length > 0 ? {
        title: t("product", "title.unfeatured-products", {
            n: candidateOffers.length
        }),
        count: candidateOffers.length,
        position: firstOfferIndex,
        cheapestOffer: filteredOffers[firstOfferIndex],
        hasDealOffers: hasDealOffers,
        ariaLabel: t("product", "price-list.unfeatured-placeholder-show-all"),
        emphasized: false
    } : undefined;
};
var insertUnfeaturedPlaceholder = function(offerRows, setUserHasExpandedUnfeatured, placeholderData) {
    // If index in offer list for unfeatured placeholder is more than offerRows.length,
    // the placeholder should not be visible.
    // This occurs when offerRows are sliced by numberOfVisiblePrices.
    if (!placeholderData || (placeholderData === null || placeholderData === void 0 ? void 0 : placeholderData.position) > offerRows.length) return offerRows;
    return unfeatured_placeholders_toConsumableArray(offerRows.slice(0, placeholderData === null || placeholderData === void 0 ? void 0 : placeholderData.position)).concat([
        /*#__PURE__*/ react.createElement(CollapsedOffersPlaceholder, {
            key: "unfeatured-placeholder-card",
            data: placeholderData,
            onClick: function() {
                setUserHasExpandedUnfeatured(true);
            }
        })
    ], unfeatured_placeholders_toConsumableArray(offerRows.slice(placeholderData === null || placeholderData === void 0 ? void 0 : placeholderData.position)));
};

// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row/row-types/index.tsx + 56 modules
var row_types = __webpack_require__(31291);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-list-panel/utils/index.ts
function utils_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function utils_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return utils_arrayLikeToArray(arr);
}
function utils_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function utils_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function utils_toConsumableArray(arr) {
    return utils_arrayWithoutHoles(arr) || utils_iterableToArray(arr) || utils_unsupportedIterableToArray(arr) || utils_nonIterableSpread();
}
function utils_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return utils_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return utils_arrayLikeToArray(o, minLen);
}


var filterOutCollapsedOffers = function(offers, collapseUnfeatured, collapseUsed) {
    var filteredOffers = utils_toConsumableArray(offers);
    var filteredOnUnfeatured = collapseUnfeatured ? filteredOffers.filter(isFeaturedOffer) : filteredOffers;
    var filterOnUsed = collapseUsed ? filteredOnUnfeatured.filter(isNewOffer) : filteredOnUnfeatured;
    return filterOnUsed;
};
var getExpandUsedFromQuerystring = function(location) {
    var ref;
    var searchParams = new URLSearchParams(location.search);
    var expandedFromQuery = ((ref = searchParams.get("expand")) === null || ref === void 0 ? void 0 : ref.split(",")) || [];
    return expandedFromQuery.includes("used");
};
var getExpandUnfeaturedByDefault = function(offers) {
    return offers.every(function(offer) {
        return isUnfeaturedOffer(offer) && isNewOffer(offer);
    }) && offers.length >= 1;
};

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-list-panel/price-list-body.tsx
function price_list_body_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function price_list_body_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function price_list_body_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function price_list_body_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function price_list_body_slicedToArray(arr, i) {
    return price_list_body_arrayWithHoles(arr) || price_list_body_iterableToArrayLimit(arr, i) || price_list_body_unsupportedIterableToArray(arr, i) || price_list_body_nonIterableRest();
}
function price_list_body_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return price_list_body_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return price_list_body_arrayLikeToArray(o, minLen);
}















var PriceListBody = function(props) {
    var sortedPrices = props.sortedPrices, numberOfVisiblePrices = props.numberOfVisiblePrices, campaign = props.campaign, isPrimaryList = props.isPrimaryList, _currentSorting = props.currentSorting, currentSorting = _currentSorting === void 0 ? filter_dropdown/* OptionTypeEnum.CHEAPEST_PRICE */.M7.CHEAPEST_PRICE : _currentSorting, ourChoiceStoreId = props.ourChoiceStoreId, userHasExpandedUnfeatured = props.userHasExpandedUnfeatured, userHasExpandedUsed = props.userHasExpandedUsed, setUserHasExpandedUnfeatured = props.setUserHasExpandedUnfeatured, setUserHasExpandedUsed = props.setUserHasExpandedUsed;
    var product = (0,product_context/* useProductContext */.$h)().product;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var viewport = (0,context/* useViewportContext */.Ak)();
    var nbrOfPlaceholders = 0;
    var ref = price_list_body_slicedToArray((0,react.useState)(false), 2), showMorePrices = ref[0], setShowMorePrices = ref[1];
    var ref1 = price_list_body_slicedToArray((0,react.useState)(false), 2), mounted = ref1[0], setMounted = ref1[1];
    var shortenOfferlistExperiment = (0,experiments/* useShortenOfferlistHideAdsExperiment */.k0)();
    // Decide if we should collapse unfeatured offers and show placeholder
    var unfeaturedPlaceholderData = getUnfeaturedPlaceHolderData(sortedPrices, !userHasExpandedUsed, t);
    var collapseUnfeaturedOffers = !userHasExpandedUnfeatured && Boolean(unfeaturedPlaceholderData);
    // Decide if we should collapse used offers and show placeholder
    var usedPlaceHolderData = getUsedPlaceHolderData(sortedPrices, collapseUnfeaturedOffers, unfeaturedPlaceholderData, t);
    var collapseUsedOffers = !userHasExpandedUsed && Boolean(usedPlaceHolderData);
    // Delay toggling of async prop on ad container (otherwise ads breaks)
    (0,react.useEffect)(function() {
        setMounted(true);
    }, []);
    if (!sortedPrices || sortedPrices.length === 0) {
        return null;
    }
    // Filter out offers that should be hidden in placeholders
    var offers = filterOutCollapsedOffers(sortedPrices, collapseUnfeaturedOffers, collapseUsedOffers);
    // Create price rows
    var priceRows = offers.map(function(item, index) {
        var ref;
        var rowKey = "".concat(item.id, "-").concat(index);
        var offer = (0,price_list_utils/* createOfferFromPriceItem */.JZ)(item);
        return /*#__PURE__*/ react.createElement(price_row_context/* PriceRowContextContainer */.B, {
            key: rowKey,
            campaign: campaign,
            offer: offer,
            product: product,
            sorting: currentSorting,
            collapseUnfeaturedFn: function() {
                return setUserHasExpandedUnfeatured(false);
            },
            showUnfeaturedHideButton: Boolean(!unfeaturedPlaceholderData),
            showUsedOffers: userHasExpandedUsed && Boolean(usedPlaceHolderData),
            viewSize: (0,price_list_utils/* getViewSize */.a0)(viewport),
            isOurChoice: ((ref = offer.store) === null || ref === void 0 ? void 0 : ref.id) === ourChoiceStoreId,
            isInPriceList: true
        }, /*#__PURE__*/ react.createElement(row_types/* PriceRow */.a, {
            item: item,
            index: index,
            isInPrimaryList: isPrimaryList
        }));
    });
    // Insert collapsed unfeatured offers placeholder
    if (collapseUnfeaturedOffers) {
        priceRows = insertUnfeaturedPlaceholder(priceRows, setUserHasExpandedUnfeatured, unfeaturedPlaceholderData);
        nbrOfPlaceholders += 1;
    }
    // Insert collapsed used offers placeholder
    if (collapseUsedOffers) {
        priceRows = insertUsedPlaceholder(priceRows, setUserHasExpandedUsed, usedPlaceHolderData);
        nbrOfPlaceholders += 1;
    }
    // Limit number of visible prices
    priceRows = priceRows.slice(0, showMorePrices ? undefined : numberOfVisiblePrices);
    // Insert ads
    var priceRowsWithAds = shortenOfferlistExperiment === "baseline" ? insertTableAds(priceRows, mounted) : priceRows;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(PriceList, {
        "data-testid": isPrimaryList ? "primary-price-list" : "secondary-price-list"
    }, priceRowsWithAds.map(function(row) {
        return /*#__PURE__*/ react.createElement("li", {
            key: row.key
        }, row);
    })), /*#__PURE__*/ react.createElement(ShowMoreButton, {
        offersCount: offers.length,
        showMorePrices: showMorePrices,
        numberOfVisiblePrices: numberOfVisiblePrices - nbrOfPlaceholders,
        setShowMorePrices: setShowMorePrices
    }));
};

// EXTERNAL MODULE: ./src/components/price-list/utils.ts
var components_price_list_utils = __webpack_require__(67589);
;// CONCATENATED MODULE: ./src/components/price-list/sort-by-fastest-delivery.ts
function sort_by_fastest_delivery_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function sort_by_fastest_delivery_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return sort_by_fastest_delivery_arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function sort_by_fastest_delivery_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function sort_by_fastest_delivery_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function sort_by_fastest_delivery_toConsumableArray(arr) {
    return sort_by_fastest_delivery_arrayWithoutHoles(arr) || sort_by_fastest_delivery_iterableToArray(arr) || sort_by_fastest_delivery_unsupportedIterableToArray(arr) || sort_by_fastest_delivery_nonIterableSpread();
}
function sort_by_fastest_delivery_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return sort_by_fastest_delivery_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return sort_by_fastest_delivery_arrayLikeToArray(o, minLen);
}


var placeAfter = 1;
var placeBefore = -1;
var sortDownloadable = function(a, b) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    if (((ref = a.availability) === null || ref === void 0 ? void 0 : ref.condition) === "Download" && ((ref1 = b.availability) === null || ref1 === void 0 ? void 0 : ref1.condition) === "Download") return 0;
    if (((ref2 = a.availability) === null || ref2 === void 0 ? void 0 : ref2.condition) === "Download" && ((ref3 = b.availability) === null || ref3 === void 0 ? void 0 : ref3.condition) !== "Download") return placeBefore;
    if (((ref4 = a.availability) === null || ref4 === void 0 ? void 0 : ref4.condition) !== "Download" && ((ref5 = b.availability) === null || ref5 === void 0 ? void 0 : ref5.condition) === "Download") return placeAfter;
    return 0;
};
var sortFeatured = function(a, b) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    if (!("store" in a) || !("store" in b)) return 0;
    if (((ref = a.store) === null || ref === void 0 ? void 0 : ref.featured) && ((ref1 = b.store) === null || ref1 === void 0 ? void 0 : ref1.featured)) return 0;
    if (((ref2 = a.store) === null || ref2 === void 0 ? void 0 : ref2.featured) && !((ref3 = b.store) === null || ref3 === void 0 ? void 0 : ref3.featured)) return placeBefore;
    if (!((ref4 = a.store) === null || ref4 === void 0 ? void 0 : ref4.featured) && ((ref5 = b.store) === null || ref5 === void 0 ? void 0 : ref5.featured)) return placeAfter;
    return 0;
};
var sortStockStatus = function(a, b) {
    var ref, ref1;
    var ref2;
    var aStockStatus = getNumericSortStock((ref2 = (ref = a.stock) === null || ref === void 0 ? void 0 : ref.status) !== null && ref2 !== void 0 ? ref2 : undefined);
    var ref3;
    var bStockStatus = getNumericSortStock((ref3 = (ref1 = b.stock) === null || ref1 === void 0 ? void 0 : ref1.status) !== null && ref3 !== void 0 ? ref3 : undefined);
    return aStockStatus - bStockStatus;
};
var getNumericSortStock = function(stockStatus) {
    switch(stockStatus){
        case "in_stock":
            return 1;
        case "in_stock_preorder":
            return 2;
        case "incoming":
            return 3;
        case "not_in_stock":
            return 4;
        case "unknown":
            return 5;
        default:
            return 6;
    }
};
var sortShipping = function(a, b) {
    var ref, ref1, ref2, ref3;
    var ref4;
    var s1 = (ref4 = (ref = a.shipping) === null || ref === void 0 ? void 0 : (ref1 = ref.fastest) === null || ref1 === void 0 ? void 0 : ref1.deliveryDays) !== null && ref4 !== void 0 ? ref4 : null;
    var ref5;
    var s2 = (ref5 = (ref2 = b.shipping) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.fastest) === null || ref3 === void 0 ? void 0 : ref3.deliveryDays) !== null && ref5 !== void 0 ? ref5 : null;
    if (s1 === null && s2 !== null) return placeAfter;
    if (s1 !== null && s2 === null) return placeBefore;
    if (s1 === null && s2 === null) return 0;
    if (s1.min !== s2.min) {
        return s1.min - s2.min;
    }
    return s1.max - s2.max;
};
var sortAvailability = function(a, b) {
    var ref, ref1, ref2, ref3;
    var aDate = ((ref = a.availability) === null || ref === void 0 ? void 0 : ref.availabilityDate) ? new Date((ref1 = a.availability) === null || ref1 === void 0 ? void 0 : ref1.availabilityDate) : null;
    var bDate = ((ref2 = b.availability) === null || ref2 === void 0 ? void 0 : ref2.availabilityDate) ? new Date((ref3 = b.availability) === null || ref3 === void 0 ? void 0 : ref3.availabilityDate) : null;
    if (aDate === null && bDate !== null) return placeAfter;
    if (aDate !== null && bDate === null) return placeBefore;
    if (aDate === null || bDate === null) return 0;
    return aDate.getTime() - bDate.getTime();
};
var sortByFastest = function(offerList, filters) {
    var isAlternative = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (offerList.length <= 0) {
        return offerList;
    }
    var sortedOffersAndAlternatives = sort_by_fastest_delivery_toConsumableArray(offerList);
    sortedOffersAndAlternatives.sort(function(a, b) {
        var downloadableSort = sortDownloadable(a, b);
        if (downloadableSort) {
            return downloadableSort;
        }
        var featuredSort = sortFeatured(a, b);
        if (featuredSort && !isAlternative) {
            return featuredSort;
        }
        var stockStatusSort = sortStockStatus(a, b);
        if (stockStatusSort) {
            return stockStatusSort;
        }
        var shippingSort = sortShipping(a, b);
        if (shippingSort) {
            return shippingSort;
        }
        var availabilitySort = sortAvailability(a, b);
        if (availabilitySort) {
            return availabilitySort;
        }
        return 0;
    });
    return sortedOffersAndAlternatives;
};
var sortAlternativePricesByFastestDelivery = function(offer, filters) {
    var altOffers = offer.alternativePrices ? sort_by_fastest_delivery_toConsumableArray(offer.alternativePrices) : [];
    if (!altOffers.length) return offer.alternativePrices;
    return sortByFastest(altOffers, filters, true);
};
var sortByFastestDelivery = function(offerList, currentSorting) {
    var filters = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    var newOffers = _objectSpread({}, offerList);
    if (currentSorting === filter_dropdown/* OptionTypeEnum.FASTEST_DELIVERY */.M7.FASTEST_DELIVERY) {
        newOffers.mainList = sortByFastest(sort_by_fastest_delivery_toConsumableArray(newOffers.mainList), filters);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = newOffers.mainList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var offer = _step.value;
                offer.alternativePrices = sortAlternativePricesByFastestDelivery(offer, filters);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        newOffers.mainList = newOffers.mainList.map(function(offer) {
            var ref;
            return (0,components_price_list_utils/* replaceMainOfferWithAlternativeOffer */.O)(offer, (ref = offer.alternativePrices) === null || ref === void 0 ? void 0 : ref[0]);
        });
    }
    return newOffers;
};

// EXTERNAL MODULE: ./src/areas/sidebar/actions/alert.js
var actions_alert = __webpack_require__(83846);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/debounce.js
var debounce = __webpack_require__(66292);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/list/variants.js
var list_variants = __webpack_require__(35967);
// EXTERNAL MODULE: ./src/areas/product-alert/components/product-alert-form/email-hint-styles.ts
var email_hint_styles = __webpack_require__(40407);
// EXTERNAL MODULE: ./src/areas/product-alert/components/product-alert-form/types.ts
var product_alert_form_types = __webpack_require__(94778);
// EXTERNAL MODULE: ./src/components/render-context/ctx-link.tsx
var ctx_link = __webpack_require__(95037);
// EXTERNAL MODULE: ./src/components/inputs/index.ts + 10 modules
var inputs = __webpack_require__(24084);
// EXTERNAL MODULE: ./src/hooks/use-is-authenticated.ts
var use_is_authenticated = __webpack_require__(32990);
// EXTERNAL MODULE: ./src/hooks/use-schibsted-account.ts
var use_schibsted_account = __webpack_require__(65195);
// EXTERNAL MODULE: ./src/areas/account/helpers/index.ts
var helpers = __webpack_require__(56699);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/offer-list-empty-message/styles.ts
var offer_list_empty_message_styles = __webpack_require__(53378);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/offer-list-empty-message/stock-status-alert-modal.tsx
function stock_status_alert_modal_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function stock_status_alert_modal_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function stock_status_alert_modal_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function stock_status_alert_modal_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function stock_status_alert_modal_slicedToArray(arr, i) {
    return stock_status_alert_modal_arrayWithHoles(arr) || stock_status_alert_modal_iterableToArrayLimit(arr, i) || stock_status_alert_modal_unsupportedIterableToArray(arr, i) || stock_status_alert_modal_nonIterableRest();
}
function stock_status_alert_modal_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return stock_status_alert_modal_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return stock_status_alert_modal_arrayLikeToArray(o, minLen);
}

















var StockStatusAlertModal = function(props) {
    var ref, ref1;
    var closeModal = props.closeModal, isOpen = props.isOpen, onSubmit = props.onSubmit;
    var ref2 = (0,app_context/* useAppContext */.bp)(), market = ref2.market, t = ref2.t;
    var isAuthenticated = (0,use_is_authenticated/* useIsAuthenticated */.k)();
    var ref3 = stock_status_alert_modal_slicedToArray((0,react.useState)(""), 2), email = ref3[0], setEmail = ref3[1];
    var ref4 = stock_status_alert_modal_slicedToArray((0,react.useState)(undefined), 2), error = ref4[0], setError = ref4[1];
    var errorState = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.productAlert.error;
    });
    var successState = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.productAlert.success;
    });
    (0,react.useEffect)(function() {
        if (errorState) {
            switch(errorState){
                case product_alert_form_types/* Errors.ERROR_EMAIL_INVALID */.D1.ERROR_EMAIL_INVALID:
                case product_alert_form_types/* Errors.ERROR_EMAIL_IN_USE */.D1.ERROR_EMAIL_IN_USE:
                    {
                        setError(errorState);
                        break;
                    }
                default:
                    {
                        setError(product_alert_form_types/* Errors.ERROR_UNKNOWN */.D1.ERROR_UNKNOWN);
                    }
            }
        } else if (successState) {
            setEmail("");
            setError(undefined);
            closeModal();
        }
    }, [
        errorState,
        successState
    ]);
    var privacyPolicyUri = market === null || market === void 0 ? void 0 : (ref = market.privacySettings) === null || ref === void 0 ? void 0 : (ref1 = ref.responsive) === null || ref1 === void 0 ? void 0 : ref1.privacyUrl;
    var handleEmailChange = debounce_default()(function(event) {
        setError((0,helpers/* isValidEmail */.vV)(event.target.value) ? undefined : product_alert_form_types/* Errors.ERROR_EMAIL_INVALID */.D1.ERROR_EMAIL_INVALID);
        setEmail(event.target.value);
    }, 500);
    var login = (0,use_schibsted_account/* useSchibstedAccount */.F)().login;
    return /*#__PURE__*/ react.createElement(modal_v2/* default */.Z, {
        isOpen: isOpen,
        onRequestClose: closeModal,
        title: t("product", "alert.stock-status-alert-email")
    }, /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(offer_list_empty_message_styles/* StyledModalBody */.iE, {
        $noPadding: isAuthenticated
    }, /*#__PURE__*/ react.createElement("form", {
        id: "stock-status-alert-form",
        method: "post",
        onSubmit: function(event) {
            return onSubmit(event, email, setError);
        },
        noValidate: true
    }, !isAuthenticated && /*#__PURE__*/ react.createElement(list_variants.Column, {
        gap: 1.5
    }, /*#__PURE__*/ react.createElement(inputs/* TextInput */.oi, {
        autoFocus: true,
        type: "email",
        name: "email",
        defaultValue: email,
        onChange: handleEmailChange,
        placeholder: t("alerts", "alert-form.email-placeholder"),
        tabIndex: 0,
        // Do not send this element to CUX (cux.io)
        "data-cux-exclude": true,
        variant: "rounded"
    }), /*#__PURE__*/ react.createElement(email_hint_styles/* EmailHint */.T, {
        error: true,
        visible: error === product_alert_form_types/* Errors.ERROR_EMAIL_IN_USE */.D1.ERROR_EMAIL_IN_USE
    }, t("alerts", "alert-form.email-in-use-error"), "\xa0", /*#__PURE__*/ react.createElement(ctx_link/* CtxLink */.b, {
        to: "/login",
        onClick: function(e) {
            e.preventDefault();
            login();
        }
    }, t("alerts", "alert-form.login-error"))), /*#__PURE__*/ react.createElement(email_hint_styles/* EmailHint */.T, {
        error: true,
        visible: error === product_alert_form_types/* Errors.ERROR_EMAIL_INVALID */.D1.ERROR_EMAIL_INVALID
    }, t("alerts", "alert-form.invalid-email-error")), privacyPolicyUri && /*#__PURE__*/ react.createElement(offer_list_empty_message_styles/* StyledLink */.Fg, null, /*#__PURE__*/ react.createElement(ctx_link/* CtxLink */.b, {
        to: privacyPolicyUri
    }, /*#__PURE__*/ react.createElement(variants.BodySmallText, {
        emphasis: variants.FontEmphasis.MEDIUM
    }, t("product", "alert.how-your-email-is-used"))))))), /*#__PURE__*/ react.createElement(modal/* ModalFooter */.mz, null, /*#__PURE__*/ react.createElement(button_variants.PrimaryButton, {
        disabled: Boolean(error),
        htmlType: "submit",
        fullWidth: true,
        containerProps: {
            form: "stock-status-alert-form"
        }
    }, t("product", "alert.create-stock-status-alert")))));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/button/index.js
var ui_button = __webpack_require__(17658);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/offer-list-empty-message/prompt-message.tsx






var PromptMessage = function(param) {
    var message = param.message;
    var market = (0,app_context/* useAppContext */.bp)().market;
    return /*#__PURE__*/ react.createElement(offer_list_empty_message_styles/* MessageWrapper */.e5, {
        $elevated: true
    }, /*#__PURE__*/ react.createElement("img", {
        alt: "no offers",
        width: "52px",
        height: "52px",
        src: "".concat(market.cdn, "/g/rfe/illustrations/no-offers-illustration_112x112.png")
    }), /*#__PURE__*/ react.createElement(offer_list_empty_message_styles/* MessageGroup */.dm, null, /*#__PURE__*/ react.createElement(offer_list_empty_message_styles/* Message */.v0, null, /*#__PURE__*/ react.createElement(variants.H4Text, null, message.message)), /*#__PURE__*/ react.createElement(button_variants.PrimaryButton, {
        onClick: function() {
            return message.buttonOnClick();
        }
    }, message.iconPosition === "left" && /*#__PURE__*/ react.createElement(ui_button.ButtonIcon, null, message.icon), message.buttonText, message.iconPosition === "right" && /*#__PURE__*/ react.createElement(ui_button.ButtonIcon, null, message.icon))));
};

// EXTERNAL MODULE: ./src/areas/product/components/price-list/offer-list-empty-message/info-message.tsx
var info_message = __webpack_require__(39733);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/chevron-right/index.js
var chevron_right = __webpack_require__(46695);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/notification-outlined/index.js
var notification_outlined = __webpack_require__(72523);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/offer-list-empty-message/index.tsx
function offer_list_empty_message_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function offer_list_empty_message_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function offer_list_empty_message_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return offer_list_empty_message_arrayLikeToArray(arr);
}
function offer_list_empty_message_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function offer_list_empty_message_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function offer_list_empty_message_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function offer_list_empty_message_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function offer_list_empty_message_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function offer_list_empty_message_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            offer_list_empty_message_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function offer_list_empty_message_slicedToArray(arr, i) {
    return offer_list_empty_message_arrayWithHoles(arr) || offer_list_empty_message_iterableToArrayLimit(arr, i) || offer_list_empty_message_unsupportedIterableToArray(arr, i) || offer_list_empty_message_nonIterableRest();
}
function offer_list_empty_message_toConsumableArray(arr) {
    return offer_list_empty_message_arrayWithoutHoles(arr) || offer_list_empty_message_iterableToArray(arr) || offer_list_empty_message_unsupportedIterableToArray(arr) || offer_list_empty_message_nonIterableSpread();
}
function offer_list_empty_message_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return offer_list_empty_message_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return offer_list_empty_message_arrayLikeToArray(o, minLen);
}
















var PromptMessageEnum;
(function(PromptMessageEnum) {
    PromptMessageEnum["outOfStock"] = "outOfStock";
    PromptMessageEnum["noOffers"] = "noOffers";
    PromptMessageEnum["noFeaturedSellsProduct"] = "noFeaturedSellsProduct";
})(PromptMessageEnum || (PromptMessageEnum = {}));
var InfoMessageEnum;
(function(InfoMessageEnum) {
    InfoMessageEnum["noFiltersMatch"] = "noFiltersMatch";
    InfoMessageEnum["noInfoOnDelivery"] = "noInfoOnDelivery";
    InfoMessageEnum["outOfStock"] = "outOfStock";
})(InfoMessageEnum || (InfoMessageEnum = {}));
var OfferListEmptyMessage = function(param) {
    var offers = param.offers;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var dispatch = (0,es/* useDispatch */.I0)();
    var isAuthenticated = (0,use_is_authenticated/* useIsAuthenticated */.k)();
    var ref = (0,offer_list_filter_context/* useOfferListFilterContext */.o)(), filtersToggledOnByUser = ref.filtersToggledOnByUser, resetFilters = ref.resetFilters, toggleFilter = ref.toggleFilter;
    var product = (0,product_context/* useProductContext */.$h)().product;
    var history = (0,react_router_dom/* useHistory */.k6)();
    var ref1;
    var userProductAlerts = (ref1 = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.sidebar.alerts.products;
    })) !== null && ref1 !== void 0 ? ref1 : [];
    var filtersToggled = filtersToggledOnByUser();
    var ref2 = offer_list_empty_message_slicedToArray((0,react.useState)(false), 2), modalOpen = ref2[0], setModalOpen = ref2[1];
    var ref3 = offer_list_empty_message_slicedToArray((0,react.useState)(), 2), prompt = ref3[0], setPrompt = ref3[1];
    var ref4 = offer_list_empty_message_slicedToArray((0,react.useState)(null), 2), message = ref4[0], setMessage = ref4[1];
    var ref5 = offer_list_empty_message_slicedToArray((0,react.useState)(offer_list_empty_message_toConsumableArray(offers.mainList).concat(offer_list_empty_message_toConsumableArray(offers.secondaryList))), 1), allShownOffers = ref5[0];
    var hasOffers = offers.mainList.filter(function(offer) {
        var ref;
        return ((ref = offer.stock) === null || ref === void 0 ? void 0 : ref.status) === "in_stock";
    }).length > 0;
    var hasAnyOffers = allShownOffers.length > 0;
    var hasAnyInStock = allShownOffers.filter(function(offer) {
        var ref;
        return ((ref = offer.stock) === null || ref === void 0 ? void 0 : ref.status) === "in_stock";
    }).length > 0;
    var hasFeaturedOffers = hasAnyInStock && offers.mainList.filter(function(offer) {
        return offer.featured;
    }).length > 0;
    var anyOffersInList = offers.mainList.length > 0;
    var inclShippingSelected = filtersToggled.filter(function(filter) {
        return filter.type === price_list_types/* FilterType.PRICES_INC_SHIPPING */.vA.PRICES_INC_SHIPPING;
    }).length > 0;
    var inStockSelected = filtersToggled.filter(function(filter) {
        return filter.type === price_list_types/* FilterType.IN_STOCK */.vA.IN_STOCK;
    }).length > 0;
    (0,react.useEffect)(function() {
        setupPrompt();
    }, []);
    (0,react.useEffect)(function() {
        setMessage(null);
        setupMessage();
    }, [
        offers
    ]);
    var submitAlert = function(event, email, onError) {
        event.preventDefault();
        if (!isAuthenticated && email && !(0,helpers/* isValidEmail */.vV)(email) && onError) return onError(product_alert_form_types/* Errors.ERROR_EMAIL_INVALID */.D1.ERROR_EMAIL_INVALID);
        var userAlert = userProductAlerts.find(function(alert) {
            return alert.productId === product.id;
        });
        var stockStatusAlert = {
            alertId: userAlert === null || userAlert === void 0 ? void 0 : userAlert.alertId,
            email: !isAuthenticated ? email : undefined,
            productId: product.id,
            type: product_alert_form_types/* AlertTypes.IN_STOCK */.d_.IN_STOCK
        };
        return dispatch((0,actions_alert/* createAlertRequest */.$b)(stockStatusAlert));
    };
    var handleReset = function() {
        resetFilters();
    };
    var handleResetShipping = function() {
        toggleFilter(price_list_types/* FilterType.PRICES_INC_SHIPPING */.vA.PRICES_INC_SHIPPING);
    };
    var getCategory = function() {
        var ref;
        var category = offer_list_empty_message_objectSpread({}, (ref = product.category) === null || ref === void 0 ? void 0 : ref.path.slice(-1)[0]);
        category.name = (category === null || category === void 0 ? void 0 : category.name) || "";
        category.pathName = (category === null || category === void 0 ? void 0 : category.pathName) || "";
        return category;
    };
    var resetFilterLink = // eslint-disable-next-line
    /*#__PURE__*/ react.createElement("a", {
        onClick: handleReset
    }, t("filter", "button.clear-filters"));
    var resetShippingLink = // eslint-disable-next-line
    /*#__PURE__*/ react.createElement("a", {
        onClick: handleResetShipping
    }, t("filter", "empty-message.show-without-delivery-cost"));
    var setupPrompt = function() {
        var newPrompt = null;
        if (!hasAnyOffers) {
            newPrompt = PromptMessageEnum.noOffers;
        } else if (!hasAnyInStock) {
            newPrompt = PromptMessageEnum.outOfStock;
        } else if (!hasFeaturedOffers) {
            newPrompt = PromptMessageEnum.noFeaturedSellsProduct;
        }
        setPrompt(newPrompt);
    };
    var setupMessage = function() {
        var newMessage = null;
        if (!anyOffersInList && filtersToggled.length > 1) {
            newMessage = InfoMessageEnum.noFiltersMatch;
        } else if (inclShippingSelected && !anyOffersInList) {
            newMessage = InfoMessageEnum.noInfoOnDelivery;
        } else if (!hasOffers && filtersToggled.length > 0 && inStockSelected && prompt) {
            newMessage = InfoMessageEnum.outOfStock;
        }
        setMessage(newMessage);
    };
    //  NoStockStatus prompt should only be shown for 'new' products.
    //  That's because the prompt has an incentive to create a stock alert,
    //  and the stock alert function doesn't send notifications for 'used' products that is out of stock.
    //  Don't show it either if there is any filter activated, because it has it's own empty offer list message.
    var renderNothingInStockMessage = function() {
        if (!prompt) {
            return null;
        }
        var category = getCategory();
        var promptMessage = {
            message: "",
            buttonText: "",
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            buttonOnClick: function() {},
            icon: null,
            iconPosition: "left"
        };
        switch(prompt){
            case PromptMessageEnum.noOffers:
                promptMessage = {
                    message: t("filter", "empty-message.no-store-sells-product"),
                    buttonText: t("filter", "empty-message.see-other-categories", {
                        category: category.name
                    }),
                    buttonOnClick: function() {
                        return history.push(category.pathName);
                    },
                    icon: /*#__PURE__*/ react.createElement(chevron_right.IconChevronRight, null),
                    iconPosition: "right"
                };
                break;
            case PromptMessageEnum.outOfStock:
                promptMessage = {
                    message: t("filter", "empty-message.no-product-in-store"),
                    buttonText: t("filter", "empty-message.notify-me-button"),
                    buttonOnClick: function() {
                        return setModalOpen(true);
                    },
                    icon: /*#__PURE__*/ react.createElement(notification_outlined/* IconNotificationOutlined */.F, null),
                    iconPosition: "left"
                };
                break;
            case PromptMessageEnum.noFeaturedSellsProduct:
                promptMessage = {
                    message: t("filter", "empty-message.no-featured-store-sells-product"),
                    buttonText: t("filter", "empty-message.see-other-categories", {
                        category: category.name
                    }),
                    buttonOnClick: function() {
                        return history.push(category.pathName);
                    },
                    icon: /*#__PURE__*/ react.createElement(chevron_right.IconChevronRight, null),
                    iconPosition: "right"
                };
                break;
            default:
                return null;
        }
        return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(StockStatusAlertModal, {
            closeModal: function() {
                return setModalOpen(false);
            },
            isOpen: modalOpen,
            onSubmit: submitAlert
        }), /*#__PURE__*/ react.createElement(PromptMessage, {
            message: promptMessage
        }));
    };
    var renderMessage = function() {
        if (!message) {
            return null;
        }
        var infoMessage = {
            text: "",
            link: null
        };
        switch(message){
            case InfoMessageEnum.noFiltersMatch:
                infoMessage = {
                    text: t("filter", "empty-message.no-filter-match"),
                    link: resetFilterLink
                };
                break;
            case InfoMessageEnum.noInfoOnDelivery:
                infoMessage = {
                    text: t("filter", "empty-message.no-info-on-delivery-cost"),
                    link: resetShippingLink
                };
                break;
            case InfoMessageEnum.outOfStock:
                infoMessage = {
                    text: t("filter", "empty-message.no-product-in-store"),
                    link: resetShippingLink
                };
                break;
            default:
                return null;
        }
        return /*#__PURE__*/ react.createElement(info_message/* InfoMessage */.$, {
            message: infoMessage
        });
    };
    return /*#__PURE__*/ react.createElement(react.Fragment, null, renderMessage(), renderNothingInStockMessage());
};
/* harmony default export */ const offer_list_empty_message = (OfferListEmptyMessage);

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-list-panel/components/expanded-placeholder-chips.tsx







var ExpandedPlaceholderChips = function(props) {
    var userHasExpandedUnfeatured = props.userHasExpandedUnfeatured, userHasExpandedUsed = props.userHasExpandedUsed, setUserHasExpandedUnfeatured = props.setUserHasExpandedUnfeatured, setUserHasExpandedUsed = props.setUserHasExpandedUsed;
    var t = (0,app_context/* useAppContext */.bp)().t;
    if (!userHasExpandedUnfeatured && !userHasExpandedUsed) {
        return null;
    }
    var renderChip = function(label, ariaLabel, setUserHasExpandedFn) {
        return /*#__PURE__*/ react.createElement(StyledChip, null, /*#__PURE__*/ react.createElement(button_variants.TonalButton, {
            size: ui_button.ButtonSize.SMALL,
            onClick: function() {
                setUserHasExpandedFn(false);
            },
            ariaLabel: ariaLabel
        }, /*#__PURE__*/ react.createElement(ui_button.ButtonText, {
            behavior: ui_text.Behavior.Oneline,
            weight: ui_text.FontWeight.NORMAL
        }, label), /*#__PURE__*/ react.createElement(ui_button.ButtonIcon, null, /*#__PURE__*/ react.createElement(icon_close.IconClose, null))));
    };
    return /*#__PURE__*/ react.createElement(ScrollingChipList, null, /*#__PURE__*/ react.createElement(ScrollingChipListWrapper, null, userHasExpandedUsed && renderChip(t("product", "price-list.used-shops-include-all"), t("product", "price-list.used-shops-hide-all"), setUserHasExpandedUsed), userHasExpandedUnfeatured && renderChip(t("product", "price-list.unfeatured-shops-include-all"), t("product", "price-list.unfeatured-shops-hide-all"), setUserHasExpandedUnfeatured)));
};

// EXTERNAL MODULE: ./src/areas/product/utils/price-list/split-list.ts
var split_list = __webpack_require__(65596);
// EXTERNAL MODULE: ./src/areas/product/components/product-header/components/our-choice/utils/index.ts
var our_choice_utils = __webpack_require__(66030);
// EXTERNAL MODULE: ./src/globals/tracking/filter.ts
var filter = __webpack_require__(35298);
;// CONCATENATED MODULE: ./src/areas/product/components/price-list/price-list-panel/index.tsx
function price_list_panel_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function price_list_panel_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function price_list_panel_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function price_list_panel_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function price_list_panel_slicedToArray(arr, i) {
    return price_list_panel_arrayWithHoles(arr) || price_list_panel_iterableToArrayLimit(arr, i) || price_list_panel_unsupportedIterableToArray(arr, i) || price_list_panel_nonIterableRest();
}
function price_list_panel_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return price_list_panel_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return price_list_panel_arrayLikeToArray(o, minLen);
}




















var PriceListPanel = function(props) {
    var ref, ref1;
    var storeStatistics = props.storeStatistics, campaign = props.campaign;
    var ref2 = (0,app_context/* useAppContext */.bp)(), t = ref2.t, market = ref2.market;
    var ref3 = (0,offer_list_filter_context/* useOfferListFilterContext */.o)(), getActiveFilters = ref3.getActiveFilters, getPriceDisplay = ref3.getPriceDisplay;
    var ref4 = (0,product_context/* useProductContext */.$h)(), offers = ref4.offers, allOffers = ref4.allOffers, allOffersWithActiveAdditives = ref4.allOffersWithActiveAdditives;
    var shortenOfferlistExperiment = (0,experiments/* useShortenOfferlistHideAdsExperiment */.k0)();
    var location = (0,react_router/* useLocation */.TH)();
    var ref5 = price_list_panel_slicedToArray((0,react.useState)(filter_dropdown/* OptionTypeEnum.CHEAPEST_PRICE */.M7.CHEAPEST_PRICE), 2), currentSorting = ref5[0], setCurrentSorting = ref5[1];
    var ref6 = price_list_panel_slicedToArray((0,react.useState)({
        mainList: offers.filteredOffers,
        secondaryList: []
    }), 2), sortedOffers = ref6[0], setSortedOffers = ref6[1];
    var ref7 = price_list_panel_slicedToArray((0,react.useState)((0,our_choice_utils/* getOurChoiceOffer */.T)(offers.filteredOffers, market.code)), 2), ourChoice = ref7[0], setOurChoice = ref7[1];
    var ref8 = price_list_panel_slicedToArray((0,react.useState)(getExpandUnfeaturedByDefault(offers.filteredOffers)), 2), userHasExpandedUnfeatured = ref8[0], setUserHasExpandedUnfeatured = ref8[1];
    var ref9 = price_list_panel_slicedToArray((0,react.useState)(getExpandUsedFromQuerystring(location)), 2), userHasExpandedUsed = ref9[0], setUserHasExpandedUsed = ref9[1];
    (0,react.useEffect)(function() {
        getOffersList();
    }, [
        currentSorting,
        offers
    ]);
    var getOffersList = function() {
        var offersSorted = (0,sort_by_price/* sortOffersByPrice */.bo)(getPriceDisplay(), offers.filteredOffers);
        setOurChoice((0,our_choice_utils/* getOurChoiceOffer */.T)(offersSorted, market.code));
        var splitOfferList = (0,split_list/* getSplitOfferlist */.Z1)(offersSorted, getActiveFilters());
        var newSortedOffers = sortByFastestDelivery(splitOfferList, currentSorting, getActiveFilters());
        setSortedOffers(newSortedOffers);
    };
    var handleSort = function(option) {
        if (!option.type || option.type === currentSorting) {
            return;
        }
        setCurrentSorting(option.type);
        (0,filter/* trackSortingSelectEvent */.Em)({
            property: option.type,
            value: option.type,
            scope: filter/* PageScope.PRODUCT */.VN.PRODUCT
        });
    };
    var listLimits = (0,split_list/* getListLimits */.oV)(sortedOffers, shortenOfferlistExperiment !== "baseline");
    return /*#__PURE__*/ react.createElement(PricePanel, null, allOffers.length > 0 && /*#__PURE__*/ react.createElement(PriceListHeader, {
        onSort: handleSort,
        sorting: currentSorting,
        allOffers: allOffers,
        allOffersWithActiveAdditives: allOffersWithActiveAdditives
    }), /*#__PURE__*/ react.createElement(offer_list_empty_message, {
        offers: sortedOffers
    }), /*#__PURE__*/ react.createElement(ExpandedPlaceholderChips, {
        userHasExpandedUnfeatured: userHasExpandedUnfeatured,
        userHasExpandedUsed: userHasExpandedUsed,
        setUserHasExpandedUnfeatured: setUserHasExpandedUnfeatured,
        setUserHasExpandedUsed: setUserHasExpandedUsed
    }), sortedOffers.mainList.length > 0 && /*#__PURE__*/ react.createElement(PriceListBody, {
        isPrimaryList: true,
        sortedPrices: sortedOffers.mainList,
        numberOfVisiblePrices: listLimits.mainListLimit,
        currentSorting: currentSorting,
        campaign: campaign,
        ourChoiceStoreId: ourChoice === null || ourChoice === void 0 ? void 0 : (ref = ourChoice.store) === null || ref === void 0 ? void 0 : ref.id,
        userHasExpandedUnfeatured: userHasExpandedUnfeatured,
        userHasExpandedUsed: userHasExpandedUsed,
        setUserHasExpandedUnfeatured: setUserHasExpandedUnfeatured,
        setUserHasExpandedUsed: setUserHasExpandedUsed
    }), sortedOffers.secondaryList.length > 0 && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(HeaderWrapper, null, /*#__PURE__*/ react.createElement(variants.H4Text, {
        scale: variants.FontScale.S,
        weight: variants.FontWeight.HEAVIER
    }, t("product", "splitlist-other.description"))), /*#__PURE__*/ react.createElement(PriceListBody, {
        isPrimaryList: false,
        sortedPrices: sortedOffers.secondaryList,
        numberOfVisiblePrices: listLimits.secondaryListLimit,
        currentSorting: currentSorting,
        campaign: campaign,
        ourChoiceStoreId: ourChoice === null || ourChoice === void 0 ? void 0 : (ref1 = ourChoice.store) === null || ref1 === void 0 ? void 0 : ref1.id,
        userHasExpandedUnfeatured: userHasExpandedUnfeatured,
        userHasExpandedUsed: userHasExpandedUsed,
        setUserHasExpandedUnfeatured: setUserHasExpandedUnfeatured,
        setUserHasExpandedUsed: setUserHasExpandedUsed
    })), storeStatistics && Boolean(storeStatistics.totalCount) && /*#__PURE__*/ react.createElement(PriceInformation, {
        storeStatistics: storeStatistics
    }));
};

;// CONCATENATED MODULE: ./src/areas/product/components/price-list/index.tsx




var price_list_PriceList = function(props) {
    var storeStatistics = props.storeStatistics, campaign = props.campaign;
    var me = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.account.me;
    });
    return /*#__PURE__*/ react.createElement(PriceListPanelWrapper, null, /*#__PURE__*/ react.createElement(PriceListPanel, {
        me: me,
        storeStatistics: storeStatistics,
        campaign: campaign
    }));
};

// EXTERNAL MODULE: ./src/components/viewport/index.tsx
var viewport = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/error-boundary/index.tsx + 1 modules
var error_boundary = __webpack_require__(77078);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/translate/index.ts + 3 modules
var translate = __webpack_require__(61041);
;// CONCATENATED MODULE: ./src/areas/product/components/readable-product-information/components/store-count.js



var StoreCount = function(param) {
    var name = param.name, prices = param.prices;
    var numberOfStores = prices && prices.meta && prices.meta.storeStatistics && prices.meta.storeStatistics.totalCount ? Math.max(1, prices.meta.storeStatistics.totalCount) : 1;
    return name ? /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "product",
        product: name,
        n: numberOfStores
    }, "product-info.store-count") : null;
};
var string = (prop_types_default()).string, number = (prop_types_default()).number, shape = (prop_types_default()).shape;
StoreCount.propTypes = {
    name: string,
    prices: shape({
        meta: shape({
            storeStatistics: shape({
                totalCount: number
            })
        })
    })
};
StoreCount.defaultProps = {
    name: undefined,
    prices: undefined
};
/* harmony default export */ const store_count = (StoreCount);

// EXTERNAL MODULE: ./src/components/currency/index.tsx
var currency = __webpack_require__(49763);
;// CONCATENATED MODULE: ./src/areas/product/components/readable-product-information/components/price-summary.js




var PriceSummary = function(param) {
    var productName = param.productName, priceSummary = param.priceSummary, prices = param.prices;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var regular = (priceSummary || {}).regular;
    if (!regular) {
        return null;
    }
    var priceUsed = prices && Array.isArray(prices.nodes) ? prices.nodes.find(function(item) {
        return item.type === "used_product" && // Consider checking 'not_in_mint_condition'?
        item.store && item.store.market === "primary" && item.stock && (item.stock.status === "in_stock" || item.stock.status === null);
    }) : null;
    return priceUsed && priceUsed.price && priceUsed.price.exclShipping < regular ? /*#__PURE__*/ react.createElement(react.Fragment, null, t("product", "product-info.price-used", {
        product: productName,
        price: /*#__PURE__*/ react.createElement(currency/* Currency */.F, {
            price: regular
        }),
        priceUsed: /*#__PURE__*/ react.createElement(currency/* Currency */.F, {
            price: priceUsed.price.exclShipping
        })
    })) : /*#__PURE__*/ react.createElement(react.Fragment, null, t("product", "product-info.price", {
        product: productName,
        price: /*#__PURE__*/ react.createElement(currency/* Currency */.F, {
            key: regular,
            price: regular
        })
    }));
};
var price_summary_string = (prop_types_default()).string, price_summary_number = (prop_types_default()).number, price_summary_shape = (prop_types_default()).shape, arrayOf = (prop_types_default()).arrayOf;
PriceSummary.propTypes = {
    productName: price_summary_string,
    priceSummary: price_summary_shape({
        alternative: price_summary_number,
        regular: price_summary_number
    }),
    prices: price_summary_shape({
        nodes: arrayOf(price_summary_shape({
            price: price_summary_shape({
                exclShipping: price_summary_number,
                inclShipping: price_summary_number
            }),
            type: price_summary_string
        }))
    })
};
PriceSummary.defaultProps = {
    productName: undefined,
    priceSummary: undefined,
    prices: undefined
};
/* harmony default export */ const price_summary = (PriceSummary);

;// CONCATENATED MODULE: ./src/areas/product/components/readable-product-information/components/category-rank.js
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}




var subPropIsEqual = function(prev, next, prop, subProp) {
    return prev[prop] && next[prop] ? prev[prop][subProp] === next[prop][subProp] : !prev[prop] === !next[prop];
};
var CategoryRank = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(CategoryRank, _Component);
    var _super = _createSuper(CategoryRank);
    function CategoryRank() {
        _classCallCheck(this, CategoryRank);
        return _super.apply(this, arguments);
    }
    _createClass(CategoryRank, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                var propsAreEqual = this.props.name === nextProps.name && subPropIsEqual(this.props, nextProps, "category", "name") && subPropIsEqual(this.props, nextProps, "category", "pathName") && subPropIsEqual(this.props, nextProps, "popularity", "inCategory") && subPropIsEqual(this.props, nextProps, "userReviewSummary", "rating");
                return !propsAreEqual;
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, name = _props.name, category = _props.category, popularity = _props.popularity, userReviewSummary = _props.userReviewSummary;
                var t = this.context.t;
                return category && popularity && popularity.inCategory > 0 && popularity.inCategory < 100 ? t("product", "product-info.rank".concat(popularity.inCategory <= 10 ? "-popular" : ""), {
                    product: name,
                    category: /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
                        key: category.id,
                        to: category.pathName
                    }, category.name),
                    rating: userReviewSummary && userReviewSummary.rating ? t("product", "product-info.rank-rating", {
                        rating: Number(userReviewSummary.rating).toFixed(1)
                    }) : "",
                    n: popularity.inCategory
                }) : null;
            }
        }
    ]);
    return CategoryRank;
}(react.Component);
var category_rank_string = (prop_types_default()).string, category_rank_number = (prop_types_default()).number, category_rank_shape = (prop_types_default()).shape;
CategoryRank.contextType = app_context/* AppContext */.Il;
CategoryRank.propTypes = {
    name: category_rank_string,
    category: category_rank_shape({
        name: category_rank_string,
        pathName: category_rank_string
    }),
    popularity: category_rank_shape({
        inCategory: category_rank_number
    }),
    userReviewSummary: category_rank_shape({
        rating: category_rank_number
    })
};
CategoryRank.defaultProps = {
    name: undefined,
    category: undefined,
    popularity: undefined,
    userReviewSummary: undefined
};
/* harmony default export */ const category_rank = (CategoryRank);

;// CONCATENATED MODULE: ./src/areas/product/components/readable-product-information/components/user-sentiments.js




var CompareLink = function(param) {
    var id = param.id, pathName = param.pathName, reviewBadges = param.reviewBadges;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), t = ref.t, linkTo = ref.linkTo;
    if (!reviewBadges || reviewBadges.length === 0) {
        return null;
    }
    var ref1 = reviewBadges[0], name = ref1.name, sentiment = ref1.sentiment;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, t("product", "product-info.user-sentiments", {
        sentiment: /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
            to: linkTo("productReviews", {
                id: id,
                pathName: pathName
            })
        }, t("product", "sentiment-badge.".concat(name, "-").concat(sentiment)))
    }));
};
var user_sentiments_arrayOf = (prop_types_default()).arrayOf, user_sentiments_shape = (prop_types_default()).shape, user_sentiments_number = (prop_types_default()).number, user_sentiments_string = (prop_types_default()).string;
CompareLink.propTypes = {
    id: user_sentiments_number.isRequired,
    pathName: user_sentiments_string.isRequired,
    reviewBadges: user_sentiments_arrayOf(user_sentiments_shape({
        product: user_sentiments_shape({
            name: user_sentiments_string,
            sentiment: user_sentiments_string
        })
    }))
};
CompareLink.defaultProps = {
    reviewBadges: undefined
};
/* harmony default export */ const user_sentiments = (CompareLink);

// EXTERNAL MODULE: ./src/components/data-list/index.tsx + 1 modules
var data_list = __webpack_require__(57607);
// EXTERNAL MODULE: ./src/components/data-list/components/parseNodes.tsx
var parseNodes = __webpack_require__(45656);
;// CONCATENATED MODULE: ./src/areas/product/components/readable-product-information/styles.ts
function readable_product_information_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function readable_product_information_styles_templateObject() {
    var data = readable_product_information_styles_taggedTemplateLiteral([
        "\n  max-width: 500px;\n\n  color: ",
        ";\n  a {\n    color: ",
        ";\n    text-decoration: underline;\n  }\n"
    ]);
    readable_product_information_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function readable_product_information_styles_templateObject1() {
    var data = readable_product_information_styles_taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    readable_product_information_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var ProductInfo = styled_components_browser_esm["default"].p.withConfig({
    displayName: "ProductInfo",
    componentId: "sc-0-0"
})(readable_product_information_styles_templateObject(), function(p) {
    return p.theme.text.secondary;
}, function(p) {
    return p.theme.text.secondary;
});
var SubSection = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SubSection",
    componentId: "sc-0-1"
})(readable_product_information_styles_templateObject1(), base/* layout.measurements.spacing200 */.bK.measurements.spacing200);

// EXTERNAL MODULE: ./src/ui/accordion/index.tsx + 5 modules
var accordion = __webpack_require__(84270);
;// CONCATENATED MODULE: ./src/areas/product/components/product-faq/index.tsx




var ProductFAQ = function(props) {
    var t = (0,app_context/* useAppContext */.bp)().t;
    return /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(variants.H3Text, null, t("common", "text.faq")), props.items.filter(Boolean).map(function(item) {
        return /*#__PURE__*/ react.createElement(accordion/* Accordion */.UQ, {
            key: item.id,
            id: item.id.toString()
        }, /*#__PURE__*/ react.createElement(accordion/* AccordionHeader */._m, null, item.question), /*#__PURE__*/ react.createElement(accordion/* AccordionContent */.vF, null, item.answer));
    }));
};

;// CONCATENATED MODULE: ./src/ui/list/index.ts
function list_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function list_templateObject() {
    var data = list_taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n\n  ::marker {\n    color: ",
        ";\n  }\n  && {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    list_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function list_templateObject1() {
    var data = list_taggedTemplateLiteral([
        ""
    ]);
    list_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function list_templateObject2() {
    var data = list_taggedTemplateLiteral([
        "\n  list-style: none;\n  > ",
        " {\n    margin-left: 0;\n  }\n"
    ]);
    list_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var Li = styled_components_browser_esm["default"].li.withConfig({
    displayName: "",
    componentId: "sc-0-0"
})(list_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, function(props) {
    return props.theme.text.callToAction;
}, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var Ul = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "",
    componentId: "sc-0-1"
})(list_templateObject1());
var UnStyledUl = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "UnStyledUl",
    componentId: "sc-0-2"
})(list_templateObject2(), Li);

// EXTERNAL MODULE: ./src/ui/link/index.ts
var ui_link = __webpack_require__(59303);
;// CONCATENATED MODULE: ./src/ui/text/index.ts
function text_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function text_templateObject() {
    var data = text_taggedTemplateLiteral([
        "\n  text-align: justify;\n"
    ]);
    text_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function text_templateObject1() {
    var data = text_taggedTemplateLiteral([
        "\n  text-align: justify;\n"
    ]);
    text_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function text_templateObject2() {
    var data = text_taggedTemplateLiteral([
        ""
    ]);
    text_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var P = (0,styled_components_browser_esm["default"])(variants.BodySmallText).attrs({
    container: "p"
}).withConfig({
    displayName: "P",
    componentId: "sc-0-0"
})(text_templateObject());
var Text = (0,styled_components_browser_esm["default"])(variants.BodySmallText).withConfig({
    displayName: "Text",
    componentId: "sc-0-1"
})(text_templateObject1());
var Strong = (0,styled_components_browser_esm["default"])(variants.BodySmallText).attrs({
    container: "strong",
    weight: variants.FontWeight.HEAVIER
}).withConfig({
    displayName: "Strong",
    componentId: "sc-0-2"
})(text_templateObject2());

;// CONCATENATED MODULE: ./src/areas/product/components/product-description/styles.ts
function product_description_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function product_description_styles_templateObject() {
    var data = product_description_styles_taggedTemplateLiteral([
        "\n    column-gap: ",
        ";\n    break-inside: avoid-column;\n    columns: 2;\n    "
    ]);
    product_description_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function product_description_styles_templateObject1() {
    var data = product_description_styles_taggedTemplateLiteral([
        "\n  > li {\n    /* stylelint-disable property-no-vendor-prefix */\n    -webkit-column-break-inside: avoid;\n    page-break-inside: avoid;\n    break-inside: avoid;\n  }\n  ",
        "\n"
    ]);
    product_description_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var StyledUl = (0,styled_components_browser_esm["default"])(UnStyledUl).withConfig({
    displayName: "StyledUl",
    componentId: "sc-0-0"
})(product_description_styles_templateObject1(), base/* media.mediumUp */.BC.mediumUp(product_description_styles_templateObject(), base/* layout.measurements.spacing200 */.bK.measurements.spacing200));

;// CONCATENATED MODULE: ./src/areas/product/components/product-description/index.tsx







var ProductDescription = function(param) {
    var description = param.description;
    var preamble = description.preamble, descriptionPoints = description.descriptionPoints, articles = description.articles;
    var t = (0,app_context/* useAppContext */.bp)().t;
    return /*#__PURE__*/ react.createElement("div", null, preamble && /*#__PURE__*/ react.createElement(P, null, preamble), descriptionPoints && (descriptionPoints === null || descriptionPoints === void 0 ? void 0 : descriptionPoints.length) > 0 && /*#__PURE__*/ react.createElement(StyledUl, null, descriptionPoints.filter(Boolean).map(function(point) {
        return /*#__PURE__*/ react.createElement(Li, {
            key: point.title
        }, /*#__PURE__*/ react.createElement(Strong, null, point.title), /*#__PURE__*/ react.createElement(P, null, point.text));
    })), articles && (articles === null || articles === void 0 ? void 0 : articles.length) > 0 && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(variants.H4Text, {
        container: Strong
    }, t("common", "article.articles")), /*#__PURE__*/ react.createElement(Ul, null, articles.filter(Boolean).map(function(article) {
        var url = new URL(article.url).pathname;
        return /*#__PURE__*/ react.createElement(Li, {
            key: url
        }, /*#__PURE__*/ react.createElement(ui_link/* InternalLink */.h, {
            to: url
        }, article.name));
    }))));
};

;// CONCATENATED MODULE: ./src/areas/product/components/readable-product-information/index.tsx
function readable_product_information_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function readable_product_information_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            readable_product_information_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}















var ReadableProductInformation = /*#__PURE__*/ (0,react.memo)(function() {
    var ref, ref1;
    var ref2 = (0,react.useContext)(app_context/* AppContext */.Il), t = ref2.t, linkTo = ref2.linkTo, market = ref2.market;
    var product = (0,product_context/* useProductContext */.$h)().product;
    if (!product || !((ref = market.modules) === null || ref === void 0 ? void 0 : ref.readableProductInfo) || !((ref1 = market.modules) === null || ref1 === void 0 ? void 0 : ref1.readableProductInfo.enabled)) {
        return null;
    }
    var id = product.id, pathName = product.pathName, name = product.name, priceSummary = product.priceSummary, prices = product.prices, category = product.category, popularity = product.popularity, description = product.description, coreProperties = product.coreProperties, reviewBadges = product.reviewBadges, userReviewSummary = product.userReviewSummary, brand = product.brand, productDescription = product.productDescription, faqs = product.faqs;
    // Add brand as a custom "fake" core prop
    var brandProp = brand && category ? {
        id: "brand",
        name: t("product", "property.brand"),
        type: "string",
        value: brand.name,
        pretty: brand.name,
        valueId: brand.id.toString(),
        categoryLink: linkTo("brandCategory", _objectSpreadProps(readable_product_information_objectSpread({}, category), {
            brandId: brand.id
        }))
    } : null;
    var brandProperties = brandProp ? [
        brandProp
    ] : [];
    var modifiedCoreProperties = brandProperties.concat((coreProperties === null || coreProperties === void 0 ? void 0 : coreProperties.nodes) || []).filter(Boolean).slice(0, 10); // Some products apparently has _a lot_ of core props
    return /*#__PURE__*/ react.createElement(error_boundary/* default */.Z, {
        onError: onError
    }, /*#__PURE__*/ react.createElement("div", {
        "data-test": "Panel",
        "data-test-type": "product-info"
    }, /*#__PURE__*/ react.createElement(variants.H2Text, null, t("product", "product-info.title")), description && /*#__PURE__*/ react.createElement(viewport/* default */.Z, {
        mobile: true
    }, /*#__PURE__*/ react.createElement(SubSection, null, /*#__PURE__*/ react.createElement(ProductInfo, {
        dangerouslySetInnerHTML: {
            __html: description
        }
    }))), /*#__PURE__*/ react.createElement(SubSection, null, productDescription ? /*#__PURE__*/ react.createElement(ProductDescription, {
        description: productDescription
    }) : /*#__PURE__*/ react.createElement(ProductInfo, null, /*#__PURE__*/ react.createElement(price_summary, {
        productName: name,
        priceSummary: priceSummary,
        prices: prices
    }), " ", /*#__PURE__*/ react.createElement(category_rank, {
        name: name,
        category: category,
        popularity: popularity,
        userReviewSummary: userReviewSummary
    }), " ", /*#__PURE__*/ react.createElement(user_sentiments, {
        id: id,
        pathName: pathName,
        reviewBadges: reviewBadges
    }), " ", /*#__PURE__*/ react.createElement(store_count, {
        name: name,
        prices: prices
    }), " ")), faqs && /*#__PURE__*/ react.createElement(SubSection, null, /*#__PURE__*/ react.createElement(ProductFAQ, {
        items: faqs
    })), modifiedCoreProperties && /*#__PURE__*/ react.createElement(SubSection, null, /*#__PURE__*/ react.createElement(data_list/* DataList */.F, {
        properties: modifiedCoreProperties.map(function(childNode) {
            return (0,parseNodes/* parseNodes */.E)(childNode, t, false);
        })
    }))));
});
var onError = function() {
    return null;
};

// EXTERNAL MODULE: ./src/hooks/use-show-ux-feedback.ts
var use_show_ux_feedback = __webpack_require__(17716);
// EXTERNAL MODULE: ./src/hooks/use-localstorage.ts
var use_localstorage = __webpack_require__(74993);
// EXTERNAL MODULE: ./src/areas/product/components/product-tabs/sections/main/styles.ts
var main_styles = __webpack_require__(80053);
;// CONCATENATED MODULE: ./src/areas/product/components/product-tabs/sections/main/product-tab-main.tsx
function product_tab_main_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function product_tab_main_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function product_tab_main_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function product_tab_main_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function product_tab_main_slicedToArray(arr, i) {
    return product_tab_main_arrayWithHoles(arr) || product_tab_main_iterableToArrayLimit(arr, i) || product_tab_main_unsupportedIterableToArray(arr, i) || product_tab_main_nonIterableRest();
}
function product_tab_main_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return product_tab_main_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return product_tab_main_arrayLikeToArray(o, minLen);
}



















var ProductTabMain = function(props) {
    var ref, ref1;
    var currentCampaign = props.currentCampaign, recommendations = props.recommendations;
    var product = (0,product_context/* useProductContext */.$h)().product;
    var market = (0,app_context/* useAppContext */.bp)().market;
    var shortenOfferlistExperiment = (0,experiments/* useShortenOfferlistHideAdsExperiment */.k0)();
    var ref2 = product_tab_main_slicedToArray((0,use_localstorage/* useLocalStorage */._)("pj:productUXFeedbackTime", 0), 1), productUXFeedbackTime = ref2[0];
    var showUXFeedback = (0,use_show_ux_feedback/* useShowUXFeedback */.k)(use_show_ux_feedback/* ONE_DAY */.s * 7, productUXFeedbackTime, 0.5);
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var displayTrendingProducts = (product.trendingProducts || []).length > 0;
    var displayOtherVisited = (recommendations || []).length > 0;
    var displayPopularProducts = !displayTrendingProducts && !displayOtherVisited && (product.popularProducts || []).length > 0;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(main_styles/* StyledPageSection */.C, {
        noPad: "top",
        recessed: true
    }, /*#__PURE__*/ react.createElement(components_scroll/* ScrollElement */.xL, {
        name: "Pricelist",
        "data-test": "MainTabContent"
    }, /*#__PURE__*/ react.createElement(price_list_PriceList, {
        storeStatistics: (ref = product.prices) === null || ref === void 0 ? void 0 : (ref1 = ref.meta) === null || ref1 === void 0 ? void 0 : ref1.storeStatistics,
        campaign: currentCampaign
    })), shortenOfferlistExperiment !== "baseline" && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(ads/* default */.Z, {
        placement: "panorama_target",
        format: "panorama_3_wde",
        min: 861,
        max: 10000,
        scalable: true,
        scaleBase: ".pj-ui-panel--row",
        spacing: {
            top: "10px",
            bottom: "10px"
        }
    }), /*#__PURE__*/ react.createElement(ads/* default */.Z, {
        placement: "dubbelpanorama3",
        format: "panorama_3",
        min: 0,
        max: 860,
        spacing: {
            top: "10px",
            bottom: "10px"
        }
    })), displayOtherVisited && /*#__PURE__*/ react.createElement(OtherAlsoVisitedCarouselLegacy, {
        recommendations: recommendations
    }), [
        "no"
    ].includes(market.code) && !displayOtherVisited ? /*#__PURE__*/ react.createElement(lazy/* Lazy */.o, {
        offset: 0,
        placeholder: /*#__PURE__*/ react.createElement(main_styles/* StyledRecommendationsPlaceholder */.q, null)
    }, /*#__PURE__*/ react.createElement(others_also_visited_carousel/* OtherAlsoVisitedCarousel */.R, null)) : null, displayTrendingProducts && /*#__PURE__*/ react.createElement(carousel_products/* CarouselProducts */.S, {
        products: (0,utils/* mapCarouselProducts */.b)(product.trendingProducts) || [],
        title: t("landing", "trending-products.title"),
        carouselType: types/* CarouselTypeEnum.TRENDING_PRODUCTS */.c.TRENDING_PRODUCTS
    }), displayPopularProducts && /*#__PURE__*/ react.createElement(carousel_products/* CarouselProducts */.S, {
        carouselType: types/* CarouselTypeEnum.OTHER_POPULAR_PRODUCTS */.c.OTHER_POPULAR_PRODUCTS,
        products: (0,utils/* mapCarouselProducts */.b)(product.popularProducts) || [],
        title: t("product", "popular-products.title")
    }), showUXFeedback && /*#__PURE__*/ react.createElement(ux_feedback/* UxLiteQuestions */.X, {
        page: "product"
    })), /*#__PURE__*/ react.createElement(page/* PageSection */.NP, {
        noBorder: true
    }, /*#__PURE__*/ react.createElement(ReadableProductInformation, null)));
};

// EXTERNAL MODULE: ./src/hooks/use-gql-query.ts
var use_gql_query = __webpack_require__(63113);
// EXTERNAL MODULE: ./src/areas/product/components/product-properties/queries/query.graphql
var query_graphql = __webpack_require__(547);
var query_graphql_default = /*#__PURE__*/__webpack_require__.n(query_graphql);
;// CONCATENATED MODULE: ./src/areas/product/components/product-properties/queries/use-product-properties-query.ts


var useProductPropertiesQuery = function(productId) {
    return (0,use_gql_query/* useGqlQuery */.n)({
        query: (query_graphql_default()),
        queryKey: [
            "product-properties"
        ],
        variables: {
            id: productId
        }
    });
};

// EXTERNAL MODULE: ./src/areas/product/components/product-properties/components/loader/index.tsx
var loader = __webpack_require__(29415);
;// CONCATENATED MODULE: ./src/areas/product/components/product-properties/index.tsx




/**
 * Product properties component (loads the data and content async)
 */ var ProductProperties = function() {
    var product = (0,product_context/* useProductContext */.$h)().product;
    var result = useProductPropertiesQuery(product.id);
    return /*#__PURE__*/ react.createElement(loader/* ProductPropertiesLoader */.o, {
        queryResult: result
    });
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-tabs/sections/properties/index.tsx





var ProductTabProperties = function() {
    var t = (0,app_context/* useAppContext */.bp)().t;
    return /*#__PURE__*/ react.createElement(components_scroll/* ScrollElement */.xL, {
        name: "Product Properties",
        "data-test": "PropertiesTabContent"
    }, /*#__PURE__*/ react.createElement(variants.H2Text, null, t("product", "tabs.properties")), /*#__PURE__*/ react.createElement(ProductProperties, null));
};

// EXTERNAL MODULE: ./src/areas/product/components/product-tabs/sections/reviews/index.tsx
var reviews = __webpack_require__(13926);
// EXTERNAL MODULE: ./src/areas/product/components/product-price-history/index.tsx + 1 modules
var product_price_history = __webpack_require__(30702);
;// CONCATENATED MODULE: ./src/areas/product/components/product-tabs/sections/statistics/styles.ts
function statistics_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function statistics_styles_templateObject() {
    var data = statistics_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    statistics_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function statistics_styles_templateObject1() {
    var data = statistics_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: ",
        ";\n  align-items: baseline;\n"
    ]);
    statistics_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function statistics_styles_templateObject2() {
    var data = statistics_styles_taggedTemplateLiteral([
        "\n  flex: 0 0 auto;\n"
    ]);
    statistics_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function statistics_styles_templateObject3() {
    var data = statistics_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n\n  &:hover {\n    text-decoration: underline;\n  }\n"
    ]);
    statistics_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function statistics_styles_templateObject4() {
    var data = statistics_styles_taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    statistics_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var StyledPriceHistoryWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledPriceHistoryWrapper",
    componentId: "sc-0-0"
})(statistics_styles_templateObject());
var StyledTitleRow = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledTitleRow",
    componentId: "sc-0-1"
})(statistics_styles_templateObject1(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var StyledTitle = (0,styled_components_browser_esm["default"])(variants.H2Text).withConfig({
    displayName: "StyledTitle",
    componentId: "sc-0-2"
})(statistics_styles_templateObject2());
var StyledLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "StyledLink",
    componentId: "sc-0-3"
})(statistics_styles_templateObject3(), function(p) {
    return p.theme.colors.maybeBlue700;
});
var StyledIntroText = (0,styled_components_browser_esm["default"])(variants.BodySmallText).withConfig({
    displayName: "StyledIntroText",
    componentId: "sc-0-4"
})(statistics_styles_templateObject4(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150);

// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(58912);
;// CONCATENATED MODULE: ./src/areas/product/components/product-tabs/sections/statistics/index.tsx








var ProductTabStatistics = function() {
    var ref, ref1;
    var ref2 = (0,app_context/* useAppContext */.bp)(), t = ref2.t, market = ref2.market;
    var location = (0,react_router_dom/* useLocation */.TH)();
    var onClickReadMoreLink = function() {
        var ref, ref1;
        (0,tracking/* trackInternalNavigationClick */.p)({
            scope: tracking/* InternalNavigationScope.PRODUCT_PRICE_HISTORY */.U.PRODUCT_PRICE_HISTORY,
            currentPage: location.pathname + location.search + location.hash,
            nextPage: ((ref = market.articles) === null || ref === void 0 ? void 0 : (ref1 = ref.priceHistoryInfo) === null || ref1 === void 0 ? void 0 : ref1.path) || ""
        });
    };
    return /*#__PURE__*/ react.createElement(components_scroll/* ScrollElement */.xL, {
        name: "Product Information",
        "data-test": "StatisticsTabContent"
    }, /*#__PURE__*/ react.createElement(StyledPriceHistoryWrapper, null, /*#__PURE__*/ react.createElement(StyledTitleRow, null, /*#__PURE__*/ react.createElement(StyledTitle, null, t("product", "price-history.title")), /*#__PURE__*/ react.createElement(StyledLink, {
        to: ((ref = market.articles) === null || ref === void 0 ? void 0 : (ref1 = ref.priceHistoryInfo) === null || ref1 === void 0 ? void 0 : ref1.path) || "",
        onClick: onClickReadMoreLink
    }, /*#__PURE__*/ react.createElement(variants.TitleSmallText, null, t("product", "price-history.read-more-link")))), /*#__PURE__*/ react.createElement(StyledIntroText, {
        emphasis: variants.FontEmphasis.MEDIUM
    }, t("product", "price-history.intro-text")), /*#__PURE__*/ react.createElement(product_price_history/* ProductPriceHistory */.N, {
        mode: "normal"
    })));
};

;// CONCATENATED MODULE: ./src/areas/product/components/product-tabs/sections/index.ts






// EXTERNAL MODULE: ./src/areas/product/components/product-tabs/sections/expert-content/index.tsx
var expert_content = __webpack_require__(64642);
;// CONCATENATED MODULE: ./src/areas/product/components/product-tabs/utils.ts
function product_tabs_utils_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function product_tabs_utils_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return product_tabs_utils_arrayLikeToArray(arr);
}
function product_tabs_utils_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function product_tabs_utils_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function product_tabs_utils_toConsumableArray(arr) {
    return product_tabs_utils_arrayWithoutHoles(arr) || product_tabs_utils_iterableToArray(arr) || product_tabs_utils_unsupportedIterableToArray(arr) || product_tabs_utils_nonIterableSpread();
}
function product_tabs_utils_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return product_tabs_utils_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return product_tabs_utils_arrayLikeToArray(o, minLen);
}
var delayedScrollIntoView = function(targetElement) {
    var ref;
    var timeout = 0;
    var navBarHeight = 71;
    var header = (ref = window.document.getElementsByTagName("header")) === null || ref === void 0 ? void 0 : ref[0];
    var _height;
    var offset = ((_height = header === null || header === void 0 ? void 0 : header.getBoundingClientRect().height) !== null && _height !== void 0 ? _height : 0) + navBarHeight;
    var sizeObserver = new ResizeObserver(function() {
        clearTimeout(timeout);
        _scrollTo(targetElement, offset);
        timeout = window === null || window === void 0 ? void 0 : window.setTimeout(function() {
            _scrollTo(targetElement, offset);
            sizeObserver.disconnect();
        }, 500);
    });
    sizeObserver.observe(window.document.body);
};
function _scrollTo(targetElement, yOffset) {
    var y = ((targetElement === null || targetElement === void 0 ? void 0 : targetElement.getBoundingClientRect().top) || 0) + window.scrollY - yOffset;
    window.scrollTo({
        top: y
    });
}
var getSimilarProductsCompareLink = function(similarProducts, product, linkTo) {
    var ref;
    if (!(similarProducts === null || similarProducts === void 0 ? void 0 : (ref = similarProducts.recommendations) === null || ref === void 0 ? void 0 : ref.length)) return null;
    var products = similarProducts.recommendations.filter(function(item) {
        return item.product;
    }).map(function(item) {
        return item.product;
    });
    return products.length ? linkTo("productCompare", {
        category: product.category,
        products: product ? [
            product
        ].concat(product_tabs_utils_toConsumableArray(products)) : products
    }) : null;
};

// EXTERNAL MODULE: ./src/areas/product/components/product-tabs/types.ts
var product_tabs_types = __webpack_require__(84870);
;// CONCATENATED MODULE: ./src/areas/product/components/product-tabs/styles.ts
function product_tabs_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function product_tabs_styles_templateObject() {
    var data = product_tabs_styles_taggedTemplateLiteral([
        "\n      min-height: ",
        ";\n    "
    ]);
    product_tabs_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function product_tabs_styles_templateObject1() {
    var data = product_tabs_styles_taggedTemplateLiteral([
        "\n        min-height: ",
        ";\n      "
    ]);
    product_tabs_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function product_tabs_styles_templateObject2() {
    var data = product_tabs_styles_taggedTemplateLiteral([
        "\n      min-height: ",
        ";\n\n      ",
        "\n    "
    ]);
    product_tabs_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function product_tabs_styles_templateObject3() {
    var data = product_tabs_styles_taggedTemplateLiteral([
        "\n    ",
        "\n\n    ",
        "\n  "
    ]);
    product_tabs_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var REVIEWS_MIN_HEIGHT = "400px"; // Reviews section height with a title and no reviews
var STATISTICS_MIN_HEIGHT_DESKTOP = "634px"; // Height with top padding, but no ads
var STATISTICS_MIN_HEIGHT_MOBILE = "803px"; // Height with top padding, but no ads
var SectionWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SectionWrapper",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(product_tabs_styles_templateObject3(), props.id === product_tabs_types/* TabAnchor.REVIEWS */.X.REVIEWS && (0,styled_components_browser_esm.css)(product_tabs_styles_templateObject(), REVIEWS_MIN_HEIGHT), props.id === product_tabs_types/* TabAnchor.STATISTICS */.X.STATISTICS && (0,styled_components_browser_esm.css)(product_tabs_styles_templateObject2(), STATISTICS_MIN_HEIGHT_MOBILE, base/* media.mediumUp */.BC.mediumUp(product_tabs_styles_templateObject1(), STATISTICS_MIN_HEIGHT_DESKTOP)));
});

;// CONCATENATED MODULE: ./src/areas/product/components/product-tabs/index.tsx












var ProductTabs = function(props) {
    var currentCampaign = props.currentCampaign, recommendations = props.recommendations;
    var product = (0,product_context/* useProductContext */.$h)().product;
    var location = (0,react_router_dom/* useLocation */.TH)();
    var firstRender = (0,react.useRef)(true);
    (0,react.useEffect)(function() {
        if (location.hash !== "" && location.hash !== product_tabs_types/* TabAnchor.ALL */.X.ALL && firstRender.current) {
            firstRender.current = false;
            var targetElement = document.getElementById(location.hash);
            delayedScrollIntoView(targetElement);
        }
    }, [
        location.hash
    ]);
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(SectionWrapper, {
        id: product_tabs_types/* TabAnchor.ALL */.X.ALL
    }, /*#__PURE__*/ react.createElement(ProductTabMain, {
        currentCampaign: currentCampaign,
        recommendations: recommendations
    })), /*#__PURE__*/ react.createElement(SectionWrapper, {
        id: product_tabs_types/* TabAnchor.REVIEWS */.X.REVIEWS
    }, /*#__PURE__*/ react.createElement(error_boundary/* default */.Z, {
        onError: function() {
            return null;
        }
    }, /*#__PURE__*/ react.createElement(lazy/* Lazy */.o, null, /*#__PURE__*/ react.createElement(reviews/* ProductTabReviews */.L, {
        product: product
    })))), /*#__PURE__*/ react.createElement(SectionWrapper, {
        id: "#experts"
    }, /*#__PURE__*/ react.createElement(error_boundary/* default */.Z, {
        onError: function() {
            return null;
        }
    }, /*#__PURE__*/ react.createElement(lazy/* Lazy */.o, null, /*#__PURE__*/ react.createElement(expert_content/* ProductExpertContent */.i, null)))), /*#__PURE__*/ react.createElement(SectionWrapper, {
        id: product_tabs_types/* TabAnchor.STATISTICS */.X.STATISTICS
    }, /*#__PURE__*/ react.createElement(page/* PageSection */.NP, {
        noBorder: true,
        noPad: "bottom"
    }, /*#__PURE__*/ react.createElement(ads/* default */.Z, {
        placement: "panorama_target",
        format: "panorama_3_wde",
        min: 861,
        max: 10000,
        scalable: true,
        scaleBase: ".pj-ui-panel--row",
        spacing: {
            top: "10px",
            bottom: "10px"
        }
    }), /*#__PURE__*/ react.createElement(ads/* default */.Z, {
        placement: "dubbelpanorama3",
        format: "panorama_3",
        min: 0,
        max: 860,
        spacing: {
            top: "10px",
            bottom: "10px"
        }
    }), /*#__PURE__*/ react.createElement(error_boundary/* default */.Z, {
        onError: function() {
            return null;
        }
    }, /*#__PURE__*/ react.createElement(lazy/* Lazy */.o, null, /*#__PURE__*/ react.createElement(ProductTabStatistics, null))))), /*#__PURE__*/ react.createElement(SectionWrapper, {
        id: product_tabs_types/* TabAnchor.PROPERTIES */.X.PROPERTIES
    }, /*#__PURE__*/ react.createElement(page/* PageSection */.NP, {
        noBorder: true
    }, /*#__PURE__*/ react.createElement(ads/* default */.Z, {
        placement: "panorama_target",
        format: "panorama_3_wde",
        min: 861,
        max: 10000,
        scalable: true,
        scaleBase: ".pj-ui-panel--row",
        spacing: {
            top: "10px",
            bottom: "10px"
        }
    }), /*#__PURE__*/ react.createElement(error_boundary/* default */.Z, {
        onError: function() {
            return null;
        }
    }, /*#__PURE__*/ react.createElement(lazy/* Lazy */.o, null, /*#__PURE__*/ react.createElement(ProductTabProperties, null))), /*#__PURE__*/ react.createElement(ads/* default */.Z, {
        placement: "dubbelpanorama3",
        format: "panorama_3",
        min: 0,
        max: 860,
        spacing: {
            top: "10px",
            bottom: "10px"
        }
    }))));
};


/***/ }),

/***/ 64642:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": () => (/* binding */ ProductExpertContent)
/* harmony export */ });
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23114);

var ProductExpertContent = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "product-expert-content";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | product-expert-content */ 536).then(__webpack_require__.bind(__webpack_require__, 17669));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(17669);
        }
        return eval("require.resolve")("./product-expert-content");
    }
});


/***/ }),

/***/ 80053:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": () => (/* binding */ StyledPageSection),
/* harmony export */   "q": () => (/* binding */ StyledRecommendationsPlaceholder)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71993);
/* harmony import */ var src_components_page__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62372);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61093);
/* harmony import */ var _carousel_products_components_others_also_visited_carousel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56829);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  > * {\n    margin-bottom: ",
        ";\n\n    > *:not(:last-child) {\n      margin-bottom: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  min-height: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var StyledPageSection = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_components_page__WEBPACK_IMPORTED_MODULE_1__/* .PageSection */ .NP).withConfig({
    displayName: "StyledPageSection",
    componentId: "sc-0-0"
})(_templateObject(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing250 */ .bK.measurements.spacing250, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing250 */ .bK.measurements.spacing250);
var StyledRecommendationsPlaceholder = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "StyledRecommendationsPlaceholder",
    componentId: "sc-0-1"
})(_templateObject1(), _carousel_products_components_others_also_visited_carousel__WEBPACK_IMPORTED_MODULE_3__/* .CAROUSEL_HEIGHT */ .A);


/***/ }),

/***/ 13926:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": () => (/* binding */ ProductTabReviews)
/* harmony export */ });
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23114);

var ProductTabReviews = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "product-tab-reviews";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | product-tab-reviews */ 191).then(__webpack_require__.bind(__webpack_require__, 83751));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(83751);
        }
        return eval("require.resolve")("./product-tab-reviews");
    }
});


/***/ }),

/***/ 84870:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": () => (/* binding */ TabAnchor)
/* harmony export */ });
var TabAnchor;
(function(TabAnchor) {
    TabAnchor["ALL"] = "#all";
    TabAnchor["PROPERTIES"] = "#properties";
    TabAnchor["REVIEWS"] = "#reviews";
    TabAnchor["STATISTICS"] = "#statistics";
})(TabAnchor || (TabAnchor = {}));


/***/ }),

/***/ 48458:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": () => (/* binding */ PRODUCT_CONTEXT_ID),
/* harmony export */   "U": () => (/* binding */ PRODUCT_ALERT_MODAL_ID)
/* harmony export */ });
var PRODUCT_ALERT_MODAL_ID = "product-alert-modal";
var PRODUCT_CONTEXT_ID = "product-page";


/***/ }),

/***/ 7119:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": () => (/* binding */ ProductPage)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95939);
/* harmony import */ var react_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14727);
/* harmony import */ var _components_offer_list_filter_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65884);
/* harmony import */ var _components_product_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16130);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18026);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23114);
/* harmony import */ var _prisjakt_ui_panel__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63073);
/* harmony import */ var src_components_lazy__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67506);
/* harmony import */ var src_components_scroll__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67016);
/* harmony import */ var src_components_price_list_filtering__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(88257);
/* harmony import */ var src_components_price_list_sort_by_price__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(31780);
/* harmony import */ var src_client_data_layer__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(80695);
/* harmony import */ var src_components_page__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(62372);
/* harmony import */ var _components_ads__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(66589);
/* harmony import */ var _components_recently_visited__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(11169);
/* harmony import */ var _components_product_header__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(29779);
/* harmony import */ var _components_product_tabs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(20588);
/* harmony import */ var _components_product_promo_banner_product_during_promo_banner__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(81898);
/* harmony import */ var _components_product_breadcrumb__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(88057);
/* harmony import */ var _components_product_promo_banner_product_before_promo_banner__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(40456);
/* harmony import */ var _components_product_scroll_top_button__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(26783);
/* harmony import */ var _components_product_campaign_deals__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(65956);
/* harmony import */ var _components_product_section_navigation__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(15248);
/* harmony import */ var _components_price_list_ads_mobile_top_ad__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(5372);
/* harmony import */ var src_components_modal_actions__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(66571);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(33996);
/* harmony import */ var _utils_deals__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(91658);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(48458);
/* harmony import */ var src_components_price_list_types__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(79126);
/* harmony import */ var _utils_product_condition_types__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(83071);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(68798);
































var ProductAlertModalContent = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "extra";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | extra */ 737).then(__webpack_require__.bind(__webpack_require__, 22610));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(22610);
        }
        return eval("require.resolve")("../product-alert/components/product-alert-modal-content");
    }
});
var ProductPage = function(param) {
    var data = param.data, _routeSection = param.routeSection, routeSection = _routeSection === void 0 ? "main" : _routeSection;
    var ref, ref1;
    var location = (0,react_router__WEBPACK_IMPORTED_MODULE_2__/* .useLocation */ .TH)();
    var history = (0,react_router__WEBPACK_IMPORTED_MODULE_2__/* .useHistory */ .k6)();
    var market = (0,src_components_app_context__WEBPACK_IMPORTED_MODULE_5__/* .useAppContext */ .bp)().market;
    var ref2 = (0,_components_offer_list_filter_context__WEBPACK_IMPORTED_MODULE_3__/* .useOfferListFilterContext */ .o)(), getActiveFilters = ref2.getActiveFilters, getInitialFilters = ref2.getInitialFilters;
    var product = data.product, prismicArticles = data.prismicArticles, recommendations = data.recommendations;
    var currentModal = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.modal.current;
    });
    var campaignBanners = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.globals.campaignBanners;
    });
    var activeCampaign = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        var ref, ref1;
        return (ref = state.globals.campaigns) === null || ref === void 0 ? void 0 : (ref1 = ref.active) === null || ref1 === void 0 ? void 0 : ref1.find(function(c) {
            return c.type === "OFFER";
        });
    });
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    // Check if uri contains query param for opening alert modal.
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (/[&?]create_alert/.test(location.search)) dispatch((0,src_components_modal_actions__WEBPACK_IMPORTED_MODULE_25__/* .showModal */ .K4)(_constants__WEBPACK_IMPORTED_MODULE_28__/* .PRODUCT_ALERT_MODAL_ID */ .U));
    }, [
        dispatch,
        location.search
    ]);
    // Handles closing modal and browser history if user visits a product page with param 'create_alert'
    var handleAlertQueryParam = function() {
        if (/[&?]create_alert/.test(location.search)) {
            var params = new URLSearchParams(location.search);
            params.delete("create_alert");
            history.push({
                pathname: location.pathname,
                search: params.toString()
            });
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if ( false || !product || !product.id) {
            return;
        }
        (0,src_client_data_layer__WEBPACK_IMPORTED_MODULE_12__/* .pushEvent */ .A)("viewItem", {
            ecommerce: {
                items: [
                    {
                        item_id: product.id,
                        item_name: product.name
                    }
                ]
            }
        }, {
            clearExistingData: true,
            eventNameAsKey: false
        });
    }, [
        product && product.id
    ]); // eslint-disable-line
    // Legacy deals
    product.campaigns = [];
    var currentCampaign = (0,_utils__WEBPACK_IMPORTED_MODULE_26__/* .getCurrentCampaign */ .uY)(activeCampaign, product);
    var privacyPolicyUri = market === null || market === void 0 ? void 0 : (ref = market.privacySettings) === null || ref === void 0 ? void 0 : (ref1 = ref.responsive) === null || ref1 === void 0 ? void 0 : ref1.privacyUrl;
    var productPrices = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return (0,_utils__WEBPACK_IMPORTED_MODULE_26__/* .mapAlternativeOffersWithUniqueShipping */ .v8)(product);
    }, [
        product
    ]);
    // Initial filters and offers
    var initialFilters = getInitialFilters();
    var initialOffers = (0,src_components_price_list_sort_by_price__WEBPACK_IMPORTED_MODULE_11__/* .sortOffersByPrice */ .bo)(src_components_price_list_types__WEBPACK_IMPORTED_MODULE_29__/* .PriceDisplayEnum.PRICE */ .wB.PRICE, (0,src_components_price_list_filtering__WEBPACK_IMPORTED_MODULE_10__/* .filterOffers */ .h)(initialFilters, productPrices).filter(function(offer) {
        return offer.condition === _utils_product_condition_types__WEBPACK_IMPORTED_MODULE_30__/* .ConditionEnum.NEW */ .M.NEW;
    }) // Filtering out used offers because these should not be used in calculations for Price history, deal styling etc.
    );
    // New deals
    var dealOffers = (0,_utils_deals__WEBPACK_IMPORTED_MODULE_27__/* .getDealOffersForProduct */ .b)(product.dealInfo, initialOffers);
    // Currently active filters
    var activeFilters = getActiveFilters();
    var activeAdditiveFilters = activeFilters.filter(function(filter) {
        return Boolean(filter.additive);
    });
    // Offers filtered by all active filters
    var filteredOffers = (0,src_components_price_list_filtering__WEBPACK_IMPORTED_MODULE_10__/* .filterOffers */ .h)(activeFilters, productPrices, dealOffers);
    var allOffersWithActiveAdditives = (0,src_components_price_list_filtering__WEBPACK_IMPORTED_MODULE_10__/* .filterOffers */ .h)(activeAdditiveFilters, productPrices);
    // All offers unfiltered (incl those initially hidden by addative filters)
    var allOffers = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return (0,src_components_price_list_filtering__WEBPACK_IMPORTED_MODULE_10__/* .createExtendedPrices */ .F)(productPrices, dealOffers);
    }, [
        productPrices,
        dealOffers
    ]);
    var contextValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return {
            product: product,
            offers: {
                filteredOffers: filteredOffers,
                initialOffers: initialOffers
            },
            allOffers: allOffers,
            allOffersWithActiveAdditives: allOffersWithActiveAdditives,
            priceInfoArticles: prismicArticles === null || prismicArticles === void 0 ? void 0 : prismicArticles.nodes,
            dealOffers: dealOffers
        };
    }, [
        product,
        filteredOffers,
        initialOffers,
        allOffers,
        allOffersWithActiveAdditives,
        prismicArticles === null || prismicArticles === void 0 ? void 0 : prismicArticles.nodes,
        dealOffers
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_product_context__WEBPACK_IMPORTED_MODULE_4__/* .ProductContext.Provider */ .HS.Provider, {
        value: contextValue
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_31__/* .ProductPage */ .em, null, currentModal === _constants__WEBPACK_IMPORTED_MODULE_28__/* .PRODUCT_ALERT_MODAL_ID */ .U && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_31__/* .Modal */ .u_, {
        id: _constants__WEBPACK_IMPORTED_MODULE_28__/* .PRODUCT_ALERT_MODAL_ID */ .U,
        onRequestClose: function() {
            handleAlertQueryParam();
            dispatch((0,src_components_modal_actions__WEBPACK_IMPORTED_MODULE_25__/* .hideModal */ .VG)());
        },
        width: 500
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ProductAlertModalContent, {
        productId: product.id,
        hideModal: function() {
            handleAlertQueryParam();
            dispatch((0,src_components_modal_actions__WEBPACK_IMPORTED_MODULE_25__/* .hideModal */ .VG)());
        },
        privacyPolicyUri: privacyPolicyUri || undefined
    })), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_product_promo_banner_product_during_promo_banner__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
        product: product,
        campaignBanners: campaignBanners
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_price_list_ads_mobile_top_ad__WEBPACK_IMPORTED_MODULE_24__/* .MobileTopAd */ .b, null), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_product_breadcrumb__WEBPACK_IMPORTED_MODULE_19__/* .ProductBreadCrumb */ .b, {
        product: product
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_scroll__WEBPACK_IMPORTED_MODULE_9__/* .ScrollElement */ .xL, {
        name: "Top"
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_product_header__WEBPACK_IMPORTED_MODULE_16__/* .ProductPageHeader */ .Z, {
        currentCampaign: currentCampaign,
        isExpertTopRated: product.isExpertTopRated
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_product_scroll_top_button__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, null), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_product_section_navigation__WEBPACK_IMPORTED_MODULE_23__/* .ProductNavigation */ .u, null), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_product_tabs__WEBPACK_IMPORTED_MODULE_17__/* .ProductTabs */ .c, {
        currentCampaign: currentCampaign,
        recommendations: recommendations,
        routeSection: routeSection
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_panel__WEBPACK_IMPORTED_MODULE_7__/* .Panel */ .s_, {
        className: "post-tabs-ad"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_ads__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
        placement: "panorama_target",
        format: "panorama_3_wde",
        min: 861,
        max: 10000,
        scalable: true,
        scaleBase: ".post-tabs-ad",
        triggerPoint: 100
    })), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_product_campaign_deals__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
        product: product
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("section", null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_lazy__WEBPACK_IMPORTED_MODULE_8__/* .Lazy */ .o, {
        offset: 100
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_page__WEBPACK_IMPORTED_MODULE_13__/* .PageSection */ .NP, {
        recessed: true
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_recently_visited__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
        offset: 1
    })))), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_product_promo_banner_product_before_promo_banner__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
        campaignBanners: campaignBanners
    }))));
};


/***/ }),

/***/ 68798:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "em": () => (/* binding */ ProductPage),
/* harmony export */   "u_": () => (/* binding */ Modal),
/* harmony export */   "zV": () => (/* binding */ BackToTopButton)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71993);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61093);
/* harmony import */ var src_components_viewport_tracker__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39632);
/* harmony import */ var src_components_modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58203);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n\n  /* This is needed or the review action dropdown will be obscured */\n  .pj-ui-panel--row {\n    overflow: visible;\n  }\n\n  /* this is not great */\n  .pj-ui-scroll-link {\n    button:hover {\n      color: ",
        ";\n      text-decoration: underline;\n    }\n  }\n\n  .pj-ui-price-row {\n    width: 100%;\n  }\n\n  .product-header--content {\n    flex-direction: row;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    right: 10px;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    left: 50%;\n    margin-left: ",
        "px;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  bottom: 10px;\n  ",
        ";\n  ",
        ";\n  background: ",
        ";\n  border-radius: ",
        ";\n  box-shadow: ",
        ";\n  border: 1px solid ",
        ";\n  cursor: pointer;\n  padding: 10px 12px;\n  visibility: ",
        ";\n  opacity: ",
        ";\n  transition: opacity 0.2s linear;\n  z-index: 4;\n\n  :hover {\n    color: ",
        ";\n    background-color: ",
        ";\n  }\n\n  :focus {\n    background-color: ",
        ";\n    box-shadow:\n      ",
        ",\n      0 0 0 4px #000;\n    opacity: 1;\n  }\n\n  :focus:not(:focus-visible) {\n    box-shadow: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      width: 100vw;\n      max-width: 100vw;\n      min-height: 30vh;\n      bottom: 0;\n      margin: 0;\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    padding: ",
        " ",
        "\n      ",
        " ",
        ";\n\n    ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var ProductPage = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.attrs({
    "data-test": "ProductPage"
}).withConfig({
    displayName: "ProductPage",
    componentId: "sc-0-0"
})(_templateObject(), function(p) {
    return p.theme.text.callToActionHover;
});
var backToTopButtonDropShadow = "0 1px 3px rgba(0, 0, 0, 0.3)";
var BackToTopButtonComponent = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].button.attrs(function() {
    return {
        type: "button"
    };
}).withConfig({
    displayName: "BackToTopButtonComponent",
    componentId: "sc-0-1"
})(_templateObject3(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.hideOutsiderAd */ .BC.hideOutsiderAd(_templateObject1()), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.showOutsiderAd */ .BC.showOutsiderAd(_templateObject2(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.siteWidth.value */ .bK.siteWidth.value * 0.5 - 200), function(p) {
    return p.theme.colors.yellove500;
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.borderRadius */ .bK.borderRadius, backToTopButtonDropShadow, function(p) {
    return p.theme.colors.yellove500;
}, function(props) {
    return props.viewport && props.viewport.top > 500 && props.viewport.scroll.yDirection > 0 ? "visible" : "hidden";
}, function(props) {
    return props.viewport && props.viewport.top > 500 && props.viewport.scroll.yDirection > 0 ? 0.9 : 0;
}, function(p) {
    return p.theme.text.callToActionHover;
}, function(p) {
    return p.theme.colors.yellove500;
}, function(p) {
    return p.theme.colors.yellove500;
}, backToTopButtonDropShadow, backToTopButtonDropShadow);
var BackToTopButton = (0,src_components_viewport_tracker__WEBPACK_IMPORTED_MODULE_2__/* .withViewport */ .s)(BackToTopButtonComponent);
var Modal = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_components_modal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    displayName: "Modal",
    componentId: "sc-0-2"
})(_templateObject5(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing150 */ .bK.measurements.spacing150, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing150 */ .bK.measurements.spacing150, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing150 */ .bK.measurements.spacing150, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.smallOnly */ .BC.smallOnly(_templateObject4()));


/***/ }),

/***/ 91658:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": () => (/* binding */ getDealOffersForProduct)
/* harmony export */ });
var getDealOffersForProduct = function(dealInfo, initialOffers) {
    var ref;
    if (!dealInfo) return [];
    var dealInfoOffer = dealInfo.offers[0];
    // Find the offer or alt offer that matches the deal offer
    var offerWithDeal;
    initialOffers.forEach(function(offer) {
        var ref, ref1;
        if (offerWithDeal || ((ref = offer.store) === null || ref === void 0 ? void 0 : ref.id) !== dealInfoOffer.shopId) {
            return;
        }
        if (dealInfoOffer.shopOfferId === offer.shopOfferId) {
            offerWithDeal = offer;
            return;
        }
        offerWithDeal = (ref1 = offer.alternativePrices) === null || ref1 === void 0 ? void 0 : ref1.find(function(altOffer) {
            return (altOffer === null || altOffer === void 0 ? void 0 : altOffer.shopOfferId) === dealInfoOffer.shopOfferId;
        });
    });
    var ref1;
    var dealPriceThreshold = (ref1 = offerWithDeal === null || offerWithDeal === void 0 ? void 0 : (ref = offerWithDeal.price) === null || ref === void 0 ? void 0 : ref.exclShipping) !== null && ref1 !== void 0 ? ref1 : 0;
    if (dealPriceThreshold === 0) return [];
    var allDealOffers = [];
    // Add shop ids for all offers with the same or lower price
    initialOffers.forEach(function(offer) {
        var ref, ref1, // Same for alternative offers
        ref2;
        if (!((ref = offer.store) === null || ref === void 0 ? void 0 : ref.id) || !validateAsDeal(offer, dealPriceThreshold)) {
            return;
        }
        allDealOffers.push({
            shopId: ((ref1 = offer.store) === null || ref1 === void 0 ? void 0 : ref1.id) || -1,
            shopOfferId: offer.shopOfferId || ""
        });
        (ref2 = offer.alternativePrices) === null || ref2 === void 0 ? void 0 : ref2.forEach(function(altOffer) {
            if (altOffer && validateAsDeal(altOffer, dealPriceThreshold)) {
                var ref;
                allDealOffers.push({
                    shopId: ((ref = offer.store) === null || ref === void 0 ? void 0 : ref.id) || -1,
                    shopOfferId: altOffer.shopOfferId || ""
                });
            }
        });
    });
    return allDealOffers;
};
var validateAsDeal = function(offer, dealPriceThreshold) {
    var ref, ref1;
    if (!((ref = offer.price) === null || ref === void 0 ? void 0 : ref.exclShipping) || !offer.shopOfferId) {
        return false;
    }
    if (offer.price.exclShipping > dealPriceThreshold) {
        return false;
    }
    if (((ref1 = offer.stock) === null || ref1 === void 0 ? void 0 : ref1.status) === "not_in_stock") {
        return false;
    }
    return true;
};


/***/ }),

/***/ 33996:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZF": () => (/* binding */ getIsFeatured),
/* harmony export */   "qz": () => (/* binding */ getCampaignPromoBanners),
/* harmony export */   "sD": () => (/* binding */ blurActiveElement),
/* harmony export */   "uY": () => (/* binding */ getCurrentCampaign),
/* harmony export */   "v8": () => (/* binding */ mapAlternativeOffersWithUniqueShipping)
/* harmony export */ });
/* harmony import */ var _components_price_list_price_row_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3382);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var getCurrentCampaign = function(activeCampaign, product) {
    return activeCampaign && product.campaigns && product.campaigns.filter(function(c) {
        return c && String(c.id) === String(activeCampaign.id);
    }).map(function(campaign) {
        return _objectSpreadProps(_objectSpread({}, campaign), {
            name: activeCampaign.name || "",
            path: "".concat(activeCampaign.web_uri ? activeCampaign.web_uri.responsive : "").concat(product.category ? "?category=".concat(product.category.id) : ""),
            media: _objectSpread({}, activeCampaign.media)
        });
    }).find(function() {
        return true;
    });
};
var getCampaignPromoBanners = function(campaignBanners) {
    return {
        before: campaignBanners && campaignBanners.active.filter(function(b) {
            return b && b.type === "BEFORE_PROMO_BANNER";
        }),
        during: campaignBanners && campaignBanners.active.filter(function(b) {
            return b && b.type === "DURING_PROMO_BANNER";
        })
    };
};
var blurActiveElement = function() {
    if (_instanceof(document.activeElement, HTMLElement)) {
        document.activeElement.blur();
    }
};
var getIsFeatured = function(offer, alternativeOffer) {
    switch((alternativeOffer === null || alternativeOffer === void 0 ? void 0 : alternativeOffer.featuredOverride) || offer.featuredOverride){
        case _components_price_list_price_row_types__WEBPACK_IMPORTED_MODULE_0__/* .FeaturedStatusEnum.FEATURED */ .$x.FEATURED:
            return true;
        case _components_price_list_price_row_types__WEBPACK_IMPORTED_MODULE_0__/* .FeaturedStatusEnum.NOT_FEATURED */ .$x.NOT_FEATURED:
            return false;
        default:
            var ref;
            return Boolean(((ref = offer.store) === null || ref === void 0 ? void 0 : ref.featured) && offer.externalUri);
    }
};
var mapAlternativeOffersWithUniqueShipping = function(product) {
    var ref, ref1;
    return _objectSpreadProps(_objectSpread({}, product.prices), {
        nodes: (ref = product.prices) === null || ref === void 0 ? void 0 : (ref1 = ref.nodes) === null || ref1 === void 0 ? void 0 : ref1.map(function(offer) {
            var ref;
            return _objectSpreadProps(_objectSpread({}, offer), {
                alternativePrices: offer === null || offer === void 0 ? void 0 : (ref = offer.alternativePrices) === null || ref === void 0 ? void 0 : ref.map(function(altOffer) {
                    return _objectSpreadProps(_objectSpread({}, altOffer), {
                        shipping: (altOffer === null || altOffer === void 0 ? void 0 : altOffer.shopHasUniqueShippings) ? altOffer.shipping : offer.shipping
                    });
                })
            });
        })
    });
};


/***/ }),

/***/ 65596:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z1": () => (/* binding */ getSplitOfferlist),
/* harmony export */   "oV": () => (/* binding */ getListLimits)
/* harmony export */ });
/* unused harmony exports TOTAL_OFFERS_LIMIT, MAIN_LIST_DEFAULT_LIMIT, SECOND_LIST_DEFAULT_LIMIT */
var offerHasFilteredInfo = function(offer, filters) {
    return filters.every(function(filter) {
        if (filter.treatUnfeaturedAsMissingInfo && !offer.featured) {
            return false;
        }
        return !filter.missingInfoFn || !filter.missingInfoFn(offer);
    });
};
var getSplitOfferlist = function(offers, filters) {
    var splittedList = {
        mainList: [],
        secondaryList: []
    };
    if (!offers.length) {
        return splittedList;
    }
    if (!filters.length) {
        splittedList.mainList = offers;
        return splittedList;
    }
    offers.forEach(function(offer) {
        if (offerHasFilteredInfo(offer, filters)) {
            splittedList.mainList.push(offer);
        } else {
            splittedList.secondaryList.push(offer);
        }
    });
    return splittedList;
};
var EXPERIMENT_LIST_LIMIT = 5;
var TOTAL_OFFERS_LIMIT = 15;
var MAIN_LIST_DEFAULT_LIMIT = 10;
var SECOND_LIST_DEFAULT_LIMIT = TOTAL_OFFERS_LIMIT - MAIN_LIST_DEFAULT_LIMIT;
var getListLimits = function(offers, shortenOfferlistExperiment) {
    var maxMainOffers = Math.min(offers.mainList.length, TOTAL_OFFERS_LIMIT);
    var maxSecondOffers = Math.min(offers.secondaryList.length, TOTAL_OFFERS_LIMIT);
    var maxMainOffersWhenSecondaryListIsLimitedByDefault = maxSecondOffers > SECOND_LIST_DEFAULT_LIMIT ? MAIN_LIST_DEFAULT_LIMIT : TOTAL_OFFERS_LIMIT - maxSecondOffers;
    var mainListLimit = Math.min(maxMainOffers, maxMainOffersWhenSecondaryListIsLimitedByDefault);
    var secondaryListLimit = TOTAL_OFFERS_LIMIT - mainListLimit;
    return {
        mainListLimit: shortenOfferlistExperiment ? EXPERIMENT_LIST_LIMIT : mainListLimit,
        secondaryListLimit: shortenOfferlistExperiment ? EXPERIMENT_LIST_LIMIT : secondaryListLimit
    };
};


/***/ }),

/***/ 83681:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": () => (/* binding */ getConditionName)
/* harmony export */ });
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83071);

var getConditionName = function(type, t) {
    switch(type){
        case _types__WEBPACK_IMPORTED_MODULE_0__/* .ConditionEnum.NEW */ .M.NEW:
            return t("product", "condition-type.new");
        case _types__WEBPACK_IMPORTED_MODULE_0__/* .ConditionEnum.DEMO */ .M.DEMO:
            return t("product", "condition-type.demo");
        case _types__WEBPACK_IMPORTED_MODULE_0__/* .ConditionEnum.REFURBISHED */ .M.REFURBISHED:
            return t("product", "condition-type.refurbished");
        case _types__WEBPACK_IMPORTED_MODULE_0__/* .ConditionEnum.DAMAGED_PACKAGING */ .M.DAMAGED_PACKAGING:
            return t("product", "condition-type.damaged-packaging");
        case _types__WEBPACK_IMPORTED_MODULE_0__/* .ConditionEnum.ALMOST_NEW */ .M.ALMOST_NEW:
            return t("product", "condition-type.almostnew");
        case _types__WEBPACK_IMPORTED_MODULE_0__/* .ConditionEnum.USED */ .M.USED:
        default:
            return t("product", "condition-type.used");
    }
};


/***/ }),

/***/ 83071:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": () => (/* binding */ ConditionEnum)
/* harmony export */ });
var ConditionEnum;
(function(ConditionEnum) {
    ConditionEnum["NEW"] = "new";
    ConditionEnum["USED"] = "used";
    ConditionEnum["DEMO"] = "demo";
    ConditionEnum["REFURBISHED"] = "refurbished";
    ConditionEnum["DAMAGED_PACKAGING"] = "damagedpackaging";
    ConditionEnum["ALMOST_NEW"] = "almostnew";
})(ConditionEnum || (ConditionEnum = {}));


/***/ }),

/***/ 97372:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": () => (/* binding */ toggleListShare),
/* harmony export */   "w": () => (/* binding */ TOGGLE_LIST_SHARE)
/* harmony export */ });
var TOGGLE_LIST_SHARE = "TOGGLE_LIST_SHARE";
var toggleListShare = function(uid) {
    return {
        type: TOGGLE_LIST_SHARE,
        uid: uid
    };
};


/***/ }),

/***/ 52404:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": () => (/* binding */ LIMIT)
/* harmony export */ });
var LIMIT = 30;


/***/ }),

/***/ 68977:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": () => (/* binding */ getPreviousPrice)
/* harmony export */ });
var getPreviousPrice = function(priceDrop, price, memberPrice) {
    var priceDropDecimal = priceDrop / 100;
    return (memberPrice || price) / (1 - priceDropDecimal);
};


/***/ }),

/***/ 32561:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23114);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30082);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58948);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_3__);




var PromotionProducts = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "promotion-products";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | promotion-products */ 119).then(__webpack_require__.bind(__webpack_require__, 77262));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(77262);
        }
        return eval("require.resolve")("./promotion-products");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, null)
});
// Fixes loadable type errors `Property 'graphQL' does not exist on type
var PromotionProductsPage = function() {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PromotionProducts, null);
};
PromotionProductsPage.graphQL = (_query_graphql__WEBPACK_IMPORTED_MODULE_3___default());
PromotionProductsPage.variables = function(param) {
    var id = param.id;
    return {
        id: id
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (PromotionProductsPage);


/***/ }),

/***/ 63644:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23114);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30082);
/* harmony import */ var _queries_promotions_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68035);
/* harmony import */ var _queries_promotions_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_queries_promotions_graphql__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _shared_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89505);
/* harmony import */ var src_components_error_message__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40314);
/* harmony import */ var src_hooks_experiments__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46353);







var PromotionsPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "promotions";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | promotions */ 570).then(__webpack_require__.bind(__webpack_require__, 13070));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(13070);
        }
        return eval("require.resolve")("./promotions");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, null)
});
// Fixes loadable type errors `Property 'graphQL' does not exist on type
var Promotions = function() {
    // TODO: Remove experiment and error page when going live with Promotions hub page
    var showPromotionsPage = (0,src_hooks_experiments__WEBPACK_IMPORTED_MODULE_6__/* .usePromotionsPageExperiment */ .V3)();
    if (showPromotionsPage) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PromotionsPage, null);
    }
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_error_message__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        status: 404
    });
};
Promotions.graphQL = (_queries_promotions_graphql__WEBPACK_IMPORTED_MODULE_3___default());
Promotions.variables = function() {
    return {
        filters: [],
        page: 0,
        sortType: _shared_types__WEBPACK_IMPORTED_MODULE_4__/* .SortOptionValueEnum.PRODUCT_POPULARITY_TOTAL */ .TG.PRODUCT_POPULARITY_TOTAL
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Promotions);


/***/ }),

/***/ 89505:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BB": () => (/* binding */ PromotionOwnerTypeEnum),
/* harmony export */   "E1": () => (/* binding */ PriceDropPercent),
/* harmony export */   "MS": () => (/* binding */ PriceRange),
/* harmony export */   "TG": () => (/* binding */ SortOptionValueEnum),
/* harmony export */   "tl": () => (/* binding */ ConditionFilterValueEnum),
/* harmony export */   "zh": () => (/* binding */ SearchPageType)
/* harmony export */ });
/* unused harmony export SortDirectionEnum */
var SearchPageType;
(function(SearchPageType) {
    SearchPageType["BRAND_PROMOTIONS"] = "brand_promotions";
    SearchPageType["BRAND_PROMOTIONS_PRODUCTS"] = "brand_promotions_products";
    SearchPageType["DEALS"] = "deals";
    SearchPageType["PROMOTIONS"] = "promotions";
    SearchPageType["SHOP_PROMOTIONS"] = "shop_promotions";
    SearchPageType["SHOP_PROMOTIONS_PRODUCTS"] = "shop_promotions_products";
    SearchPageType["USED"] = "used";
})(SearchPageType || (SearchPageType = {}));
var SortDirectionEnum;
(function(SortDirectionEnum) {
    SortDirectionEnum[SortDirectionEnum["Ascending"] = 0] = "Ascending";
    SortDirectionEnum[SortDirectionEnum["Descending"] = 1] = "Descending";
})(SortDirectionEnum || (SortDirectionEnum = {}));
var SortOptionValueEnum;
(function(SortOptionValueEnum) {
    SortOptionValueEnum["PRODUCT_POPULARITY_TOTAL"] = "popularity";
    SortOptionValueEnum["PRICE_OFFER_ASC"] = "priceLowest";
    SortOptionValueEnum["PRICE_OFFER_DESC"] = "priceHighest";
    SortOptionValueEnum["PRODUCT_USER_REVIEWS_RATING_DESC"] = "rating";
    SortOptionValueEnum["PRICE_DIFF_PERCENTAGE_DESC"] = "dealValue";
    SortOptionValueEnum["DEAL_UPDATE_TIME"] = "dealUpdateTime";
})(SortOptionValueEnum || (SortOptionValueEnum = {}));
var ConditionFilterValueEnum;
(function(ConditionFilterValueEnum) {
    ConditionFilterValueEnum["USED"] = "Used";
    ConditionFilterValueEnum["ALMOSTNEW"] = "AlmostNew";
    ConditionFilterValueEnum["NEW"] = "New";
})(ConditionFilterValueEnum || (ConditionFilterValueEnum = {}));
var PriceRange;
(function(PriceRange) {
    PriceRange["FROM_0_TO_200"] = "FROM_0_TO_200";
    PriceRange["FROM_200_TO_1000"] = "FROM_200_TO_1000";
    PriceRange["FROM_1000_TO_ALL"] = "FROM_1000_TO_ALL";
})(PriceRange || (PriceRange = {}));
var PriceDropPercent;
(function(PriceDropPercent) {
    PriceDropPercent["PERCENT_50"] = "PERCENT_50";
    PriceDropPercent["PERCENT_25"] = "PERCENT_25";
    PriceDropPercent["PERCENT_10"] = "PERCENT_10";
    PriceDropPercent["PERCENT_5"] = "PERCENT_5";
})(PriceDropPercent || (PriceDropPercent = {}));
var PromotionOwnerTypeEnum;
(function(PromotionOwnerTypeEnum) {
    PromotionOwnerTypeEnum["BRAND"] = "brand";
    PromotionOwnerTypeEnum["SHOP"] = "shop";
})(PromotionOwnerTypeEnum || (PromotionOwnerTypeEnum = {}));


/***/ }),

/***/ 41258:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23114);
/* harmony import */ var src_components_loader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30082);
/* harmony import */ var _queries_used_products_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76599);
/* harmony import */ var _queries_used_products_graphql__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_queries_used_products_graphql__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _shared_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89505);





var UsedProducts = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "used-products";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | used-products */ 617).then(__webpack_require__.bind(__webpack_require__, 81126));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(81126);
        }
        return eval("require.resolve")("./used-products");
    }
}, {
    fallback: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, null)
});
// Fixes loadable type errors `Property 'graphQL' does not exist on type`
var UsedProductsPage = function() {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(UsedProducts, null);
};
UsedProductsPage.graphQL = (_queries_used_products_graphql__WEBPACK_IMPORTED_MODULE_3___default());
UsedProductsPage.variables = function() {
    return {
        filters: [
            {
                key: "condition",
                value: _shared_types__WEBPACK_IMPORTED_MODULE_4__/* .ConditionFilterValueEnum.USED */ .tl.USED
            }
        ],
        page: 0,
        sortType: _shared_types__WEBPACK_IMPORTED_MODULE_4__/* .SortOptionValueEnum.PRODUCT_POPULARITY_TOTAL */ .TG.PRODUCT_POPULARITY_TOTAL
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (UsedProductsPage);


/***/ }),

/***/ 55918:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DS": () => (/* binding */ deleteRecentSearch),
/* harmony export */   "KM": () => (/* binding */ getRecentSearches),
/* harmony export */   "_": () => (/* binding */ addRecentSearch),
/* harmony export */   "lU": () => (/* binding */ clearRecentSearches)
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var LOCAL_STORAGE_KEY = "pj:recentSearches";
var LIMIT = 10;
var getRecentSearches = function() {
    var limit = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : LIMIT;
    try {
        var previousSearches = localStorage.getItem(LOCAL_STORAGE_KEY);
        return previousSearches ? JSON.parse(previousSearches).reverse().slice(0, limit) : [];
    // eslint-disable-next-line no-empty
    } catch (e) {}
    return [];
};
var deleteRecentSearch = function(query) {
    var previousSearches = getRecentSearches(LIMIT);
    var queries = new Set();
    if (previousSearches) {
        previousSearches.forEach(queries.add, queries);
        queries.delete(query);
    }
    try {
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(_toConsumableArray(queries).reverse()));
    } catch (e) {
    // Swallow the exception
    }
};
var addRecentSearch = function(query) {
    if (!query || query.length < 2) {
        return;
    }
    var trimmed = query.trim();
    try {
        var previousSearches = getRecentSearches(LIMIT);
        var queries = new Set();
        if (previousSearches) {
            previousSearches.reverse()// doing this because a bug where we were storing the search query with the path
            .filter(function(x) {
                return !x.toLowerCase().startsWith("/search?");
            }).forEach(queries.add, queries);
        }
        // Move existing query to the top as most recent
        if (_toConsumableArray(queries).includes(trimmed)) {
            queries.delete(trimmed);
        }
        queries.add(trimmed);
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(_toConsumableArray(queries).reverse().slice(0, LIMIT).reverse()));
    // eslint-disable-next-line no-empty
    } catch (e) {}
};
var clearRecentSearches = function() {
    try {
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify([]));
    // eslint-disable-next-line no-empty
    } catch (e) {}
};


/***/ }),

/***/ 82878:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23114);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}


var SidebarMobileContentLoadable = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "sidebar-mobile";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | sidebar-mobile */ 557).then(__webpack_require__.bind(__webpack_require__, 30021));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(30021);
        }
        return eval("require.resolve")("./content");
    }
});
var SidebarMobileContent = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SidebarMobileContentLoadable, _extends({}, props));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SidebarMobileContent);


/***/ }),

/***/ 8818:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": () => (/* binding */ VIEWS)
/* harmony export */ });
var VIEWS;
(function(VIEWS) {
    VIEWS["ROOT"] = "root";
    VIEWS["ALERTS"] = "alerts";
    VIEWS["LISTS"] = "lists";
    VIEWS["LIST"] = "list";
    VIEWS["USER"] = "user";
    VIEWS["CHANGELOG"] = "changelog";
})(VIEWS || (VIEWS = {}));


/***/ }),

/***/ 28438:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$J": () => (/* binding */ SIDEBAR_STATE),
/* harmony export */   "E8": () => (/* binding */ LIST_DELETE_TRANSITION_TIME),
/* harmony export */   "N3": () => (/* binding */ DEFAULT_SIDEBAR_STATE),
/* harmony export */   "Ym": () => (/* binding */ NO_MY_PRODUCTS_CREATED_ID),
/* harmony export */   "aP": () => (/* binding */ SORT_OPTIONS),
/* harmony export */   "yT": () => (/* binding */ SIDEBAR_LOCALSTORAGE_KEY)
/* harmony export */ });
var SIDEBAR_LOCALSTORAGE_KEY = "pj:sidebarState";
var SIDEBAR_STATE;
(function(SIDEBAR_STATE) {
    SIDEBAR_STATE["NONE"] = "none";
    SIDEBAR_STATE["LISTS"] = "lists";
    SIDEBAR_STATE["ALERTS"] = "alerts";
    SIDEBAR_STATE["FILTER"] = "filter";
    SIDEBAR_STATE["SETTINGS"] = "settings";
    SIDEBAR_STATE["LOGIN"] = "login";
})(SIDEBAR_STATE || (SIDEBAR_STATE = {}));
var DEFAULT_SIDEBAR_STATE = SIDEBAR_STATE.ALERTS;
var SORT_OPTIONS;
(function(SORT_OPTIONS) {
    SORT_OPTIONS["USER_DEFINED"] = "user_defined";
    SORT_OPTIONS["ADDED"] = "added";
    SORT_OPTIONS["NAME"] = "name";
    SORT_OPTIONS["PRICE"] = "price";
    SORT_OPTIONS["PRICE_ASC"] = "price:asc";
    SORT_OPTIONS["PRICE_DESC"] = "price:desc";
    SORT_OPTIONS["CATEGORY"] = "category";
    SORT_OPTIONS["ACCESSED"] = "accessed";
})(SORT_OPTIONS || (SORT_OPTIONS = {}));
var LIST_DELETE_TRANSITION_TIME = 500;
var NO_MY_PRODUCTS_CREATED_ID = -1;


/***/ }),

/***/ 15211:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": () => (/* binding */ trackClosingSidebar),
/* harmony export */   "b": () => (/* binding */ trackOpeningSidebar)
/* harmony export */ });
/* harmony import */ var _client_data_layer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80695);

var trackOpeningSidebar = function(view) {
    var element = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    (0,_client_data_layer__WEBPACK_IMPORTED_MODULE_0__/* .pushEvent */ .A)("trackOpeningSidebar", {
        view: view,
        element: element
    });
};
var trackClosingSidebar = function(view) {
    var element = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    (0,_client_data_layer__WEBPACK_IMPORTED_MODULE_0__/* .pushEvent */ .A)("trackClosingSidebar", {
        view: view,
        element: element
    });
};


/***/ }),

/***/ 83527:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23114);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}


var AlertsLoadable = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "sidebar-views";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | sidebar-views */ 408).then(__webpack_require__.bind(__webpack_require__, 15348));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(15348);
        }
        return eval("require.resolve")("./view");
    }
});
var Alerts = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(AlertsLoadable, _extends({}, props));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Alerts);


/***/ }),

/***/ 40399:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23114);


var SidebarFilterLoadable = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "sidebar-views-filter";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | sidebar-views-filter */ 970).then(__webpack_require__.bind(__webpack_require__, 94868));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(94868);
        }
        return eval("require.resolve")("./view");
    }
});
var SidebarFilter = function() {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SidebarFilterLoadable, null);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SidebarFilter);


/***/ }),

/***/ 96906:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23114);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}


var ListLoadable = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "sidebar-views";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | sidebar-views */ 408).then(__webpack_require__.bind(__webpack_require__, 48005));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(48005);
        }
        return eval("require.resolve")("./view");
    }
});
var List = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ListLoadable, _extends({}, props));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (List);


/***/ }),

/***/ 90929:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23114);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}


var ListsLoadable = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "sidebar-views";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | sidebar-views */ 408).then(__webpack_require__.bind(__webpack_require__, 37299));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(37299);
        }
        return eval("require.resolve")("./view");
    }
});
var Lists = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ListsLoadable, _extends({}, props));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Lists);


/***/ }),

/***/ 30163:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": () => (/* binding */ SotyBadge)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
;// CONCATENATED MODULE: ./src/areas/store/components/soty-badge-link/soty-badge/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    width: ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var StyledSotyBadge = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledSotyBadge",
    componentId: "sc-0-0"
})(_templateObject());
var StyledImageWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledImageWrapper",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject1(), "".concat(props.size, "px"));
});

;// CONCATENATED MODULE: ./src/areas/store/components/soty-badge-link/soty-badge/index.tsx



var SotyBadge = function(props) {
    var className = props.className, imgUrl = props.imgUrl, name = props.name, _size = props.size, size = _size === void 0 ? 115 : _size, year = props.year;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), t = ref.t, market = ref.market;
    var altText = "".concat(t("campaigns", "shop-of-the-year.winners-title", {
        year: year || ""
    })).concat(name ? " - ".concat(name) : null);
    // replaces soty badges img urls from 2010, 2011 and 2012 with generic badge
    // because badges for those years are missing on cdn.
    var url = year && parseInt(year, 10) < 2013 ? "".concat(market.cdn, "/g/store_of_the_year/generic_store_of_the_year.png") : imgUrl;
    return /*#__PURE__*/ react.createElement(StyledSotyBadge, {
        className: className
    }, /*#__PURE__*/ react.createElement(StyledImageWrapper, {
        size: size
    }, /*#__PURE__*/ react.createElement("img", {
        src: url,
        alt: altText,
        title: altText
    })));
};


/***/ }),

/***/ 70320:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L9": () => (/* binding */ SHOP_LOGO_WIDTH),
/* harmony export */   "QO": () => (/* binding */ CONTENT_TITLE_SIZE),
/* harmony export */   "XZ": () => (/* binding */ MAIN_TITLE_SIZE),
/* harmony export */   "eZ": () => (/* binding */ SECTION_TITLE_SIZE),
/* harmony export */   "jr": () => (/* binding */ SHOP_LOGO_WIDTH_SMALL),
/* harmony export */   "yH": () => (/* binding */ SUB_TITLE_SIZE)
/* harmony export */ });
var MAIN_TITLE_SIZE = 20; // h1
var SECTION_TITLE_SIZE = 18; // h2
var CONTENT_TITLE_SIZE = 16; // h3
var SUB_TITLE_SIZE = 16; // h4
var SHOP_LOGO_WIDTH = 176;
var SHOP_LOGO_WIDTH_SMALL = 88;


/***/ }),

/***/ 80695:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": () => (/* binding */ pushEvent),
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// Converts uppercase event types to camelCase
// Ex: MY_EVENT -> myEvent
var typeToEvent = function(type) {
    return type.split("_").map(function(x) {
        return x.toLowerCase();
    }).map(function(x, i) {
        return i === 0 ? x : x[0].toUpperCase() + x.slice(1);
    }).join("");
};
var defaultDataLayerOptions = {
    eventNameAsKey: true,
    clearExistingData: false
};
var pushEvent = function(name) {
    var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, optionsArg = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if ( false || !window.dataLayer) {
        return;
    }
    var options = _objectSpread({}, defaultDataLayerOptions, optionsArg);
    var eventData = options.eventNameAsKey ? _defineProperty({}, name, data) : _objectSpread({}, data);
    if (optionsArg.clearExistingData) {
        eventData._clear = true;
    }
    window.dataLayer.push(_objectSpread({
        event: name
    }, eventData));
};
var middleware = function() {
    return function(next) {
        return function(action) {
            next(action);
            if (!window.dataLayer) {
                return;
            }
            switch(action.type){
                case "ROUTE_LOADED":
                    break;
                // NOTE: Any changes done to data or structure of PRODUCT_PRICE_CLICK needs to be
                // reflected in react/middlewares/out.js pre click
                case "PRODUCT_PRICE_CLICK":
                default:
                    {
                        var type = action.type, rest = _objectWithoutProperties(action, [
                            "type"
                        ]);
                        var name = typeToEvent(type);
                        pushEvent(name, rest);
                    }
            }
        };
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (middleware);


/***/ }),

/***/ 35063:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": () => (/* binding */ gqlClient)
/* harmony export */ });
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71345);
/* harmony import */ var graphql_request__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(graphql_request__WEBPACK_IMPORTED_MODULE_0__);

var gqlClient = new graphql_request__WEBPACK_IMPORTED_MODULE_0__.GraphQLClient("/_internal/bff");


/***/ }),

/***/ 99757:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Tb": () => (/* binding */ captureException),
/* harmony export */   "_8": () => (/* binding */ sentryPromise),
/* harmony export */   "j6": () => (/* binding */ initSentry)
/* harmony export */ });
/* unused harmony export captureMessage */
/* eslint-disable no-param-reassign, no-console, no-plusplus, no-continue, @typescript-eslint/no-empty-function, @typescript-eslint/consistent-type-imports */ function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var sentryBrowserPromise = __webpack_require__.e(/* import() | sentry */ 897).then(__webpack_require__.bind(__webpack_require__, 81823));
var sentryIntegrationsPromise = __webpack_require__.e(/* import() | sentry-integrations */ 722).then(__webpack_require__.bind(__webpack_require__, 3991));
function createRejectedSentryPromise() {
    return new Promise(function() {});
}
var sentryPromise = typeof window !== "undefined" && window.SENTRY ? Promise.all([
    sentryBrowserPromise,
    sentryIntegrationsPromise
]).then(function(param) {
    var _param = _slicedToArray(param, 2), sentryBrowser = _param[0], sentryIntegrations = _param[1];
    return _objectSpread({}, sentryBrowser, sentryIntegrations);
}) : createRejectedSentryPromise();
var typeErrorFetchFailedValues = new Set([
    "Failed to fetch",
    "NetworkError when attempting to fetch resource.",
    "Load failed"
]);
function shouldIgnoreError(error, hint) {
    return isRecaptchaBadTimeoutRejection(error, hint) || isNotFoundError(error) || isBlockedByAdblockNetworkError(error);
}
// https://github.com/getsentry/sentry-javascript/issues/2514
function isRecaptchaBadTimeoutRejection(_, hint) {
    return hint.originalException === "Timeout";
}
function isBlockedByAdblockNetworkError(error) {
    var ref, ref1;
    var exception = (ref = error.exception) === null || ref === void 0 ? void 0 : (ref1 = ref.values) === null || ref1 === void 0 ? void 0 : ref1[0];
    var now = Date.now();
    // Schibsted ads/tracking SDK is not try-catching their stuff properly so it ends up here
    // Since not all errors have stack traces attached to them (see https://github.com/getsentry/sentry-javascript/issues/7275#issuecomment-1443091905),
    // we have to filter by breadcrumbs. Since we cannot assume that the error is the last breadcrumb (I remember seeing an instance of this in Sentry, however, can't find the link any more), we need to check all of them.
    if ((exception === null || exception === void 0 ? void 0 : exception.type) !== "TypeError" || !typeErrorFetchFailedValues.has(exception.value)) {
        return false;
    }
    if (!error.breadcrumbs) {
        return false;
    }
    // We go from the back since the last breadcrumb is most likely the erroneous one
    for(var i = error.breadcrumbs.length - 1; i >= 0; i--){
        var breadcrumb = error.breadcrumbs[i];
        if (!breadcrumb) continue;
        // We only need to check the last 5s of breadcrumbs as any earlier breadcrumbs are definitely unrelated
        if (breadcrumb.timestamp && now - breadcrumb.timestamp * 1000 > 5000) {
            break;
        }
        if (isBlockedByAdblockBreadcrumb(breadcrumb)) {
            return true;
        }
    }
    return false;
}
function isBlockedByAdblockBreadcrumb(breadcrumb) {
    var ref;
    if (breadcrumb.level !== "error" || breadcrumb.category !== "xhr" && breadcrumb.category !== "fetch") {
        return false;
    }
    var url = (ref = breadcrumb.data) === null || ref === void 0 ? void 0 : ref.url;
    if (!url) return false;
    return url === "https://secure.adnxs.com/getuidj" || // cis.schibsted.com, cis.prisjakt.nu, cis.prisjagt.dk etc.
    url.startsWith("https://cis.") || // https://collector.schibsted.io/api/v1/track/sdrn:schibsted:client:prisjaktse, ...:prisjaktno, ...:prisjagtdk etc.
    url.startsWith("https://collector.schibsted.io") || // Ads endpoint
    url === "https://pagead2.googlesyndication.com/pagead/buyside_topics/set/";
}
function isNotFoundError(error) {
    return error.status === 404 || error.status === 410;
}
function initSentry() {
    sentryPromise.then(function(param) {
        var BrowserClient = param.BrowserClient, defaultStackParser = param.defaultStackParser, getCurrentHub = param.getCurrentHub, GlobalHandlers = param.GlobalHandlers, InboundFilters = param.InboundFilters, FunctionToString = param.FunctionToString, TryCatch = param.TryCatch, Breadcrumbs = param.Breadcrumbs, LinkedErrors = param.LinkedErrors, HttpContext = param.HttpContext, Dedupe = param.Dedupe, makeFetchTransport = param.makeFetchTransport, BrowserTracing = param.BrowserTracing, RewriteFrames = param.RewriteFrames;
        // See https://docs.sentry.io/platforms/javascript/configuration/tree-shaking/ for what is happening
        var client = new BrowserClient({
            // debug is defined in webpack.config.js with DefinePlugin
            dsn: window.SENTRY,
            release: window.RELEASE,
            environment: window.ENVIRONMENT,
            tracesSampleRate: 0.0001,
            transport: makeFetchTransport,
            stackParser: defaultStackParser,
            beforeSend: function(event, hint) {
                return shouldIgnoreError(event, hint) ? null : addEventTags(event);
            },
            beforeSendTransaction: addEventTags,
            normalizeDepth: 6,
            ignoreErrors: [
                "auth.invalid-user-credentials",
                'Blocked a frame with origin "https://www.prisjakt.nu" from accessing a cross-origin frame'
            ],
            integrations: [
                new BrowserTracing(),
                new GlobalHandlers(),
                new InboundFilters(),
                new FunctionToString(),
                new TryCatch(),
                new Breadcrumbs(),
                new LinkedErrors(),
                new HttpContext(),
                new Dedupe(),
                new RewriteFrames({
                    root: "webpack://@prisjakt/responsive-frontend/./",
                    prefix: "rfe-browser:///"
                })
            ],
            allowUrls: [
                /^https:\/\/pjrfe-75b8\.kxcdn\.com/,
                /^https:\/\/www\.prisjakt\.(nu|no)/,
                /^https:\/\/pricespy\.co\.(uk|nz)/,
                /^https:\/\/prisjagt\.dk/,
                /^https:\/\/hintaopas\.fi/,
                /^https:\/\/ledenicheur\.fr/,
                /^https?:\/\/local\.prisjakt\.nu/,
                /^https?:\/\/localhost/
            ]
        });
        getCurrentHub().bindClient(client);
    });
}
function addEventTags(event) {
    var _tags;
    event.tags = (_tags = event.tags) !== null && _tags !== void 0 ? _tags : {};
    event.tags.market = window.CLIENT_MARKET.code;
    return event;
}
// Used by sagas
function captureException() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    sentryPromise.then(function(param) {
        var sentryCaptureException = param.captureException;
        return sentryCaptureException.apply(void 0, _toConsumableArray(args));
    }).catch(function() {
        var _console;
        (_console = console).error.apply(_console, _toConsumableArray(args));
    });
}
// Used by sagas
function captureMessage() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    sentryPromise.then(function(param) {
        var sentryCaptureMessage = param.captureMessage;
        return sentryCaptureMessage.apply(void 0, _toConsumableArray(args));
    }).catch(function() {
        var _console;
        (_console = console).log.apply(_console, _toConsumableArray(args));
    });
}


/***/ }),

/***/ 99447:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": () => (/* binding */ AddToListModalsWrapper)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95939);
/* harmony import */ var _viewport__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10297);
/* harmony import */ var src_areas_product_components_product_header_components_action_buttons_list_modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56632);
/* harmony import */ var _modal_login_promo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31794);
/* harmony import */ var src_areas_sidebar_actions_lists__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40054);
/* harmony import */ var _hooks_use_is_authenticated__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32990);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}







var AddToListModalsWrapper = function(param) {
    var children = param.children, productId = param.productId, productName = param.productName;
    var ref;
    var isDesktop = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_viewport__WEBPACK_IMPORTED_MODULE_2__/* .ViewportContext */ .R).isDesktop;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    var ref1 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), 2), showLoginPromo = ref1[0], setLoginPromoState = ref1[1];
    var toggleLoginPromo = function(e) {
        if (e) {
            e.stopPropagation();
            e.preventDefault();
        }
        setLoginPromoState(!showLoginPromo);
    };
    // Highlights the heart if the product was recently added to a list.
    // Kind of an ugly hack; should be fixed once we can get this information
    // from GraphQL.
    var ref2 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), 2), addedToList = ref2[0], setAddedToListState = ref2[1];
    var ref3 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), 2), listOpen = ref3[0], setListOpen = ref3[1];
    var me = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.areas.account.me;
    });
    var isAuthenticated = (0,_hooks_use_is_authenticated__WEBPACK_IMPORTED_MODULE_6__/* .useIsAuthenticated */ .k)();
    var deletedLists = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.areas.sidebar.deletedLists;
    });
    var selectedList = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.areas.sidebar.selectedList;
    });
    var latestLists = me === null || me === void 0 ? void 0 : (ref = me.lists) === null || ref === void 0 ? void 0 : ref.nodes.filter(function(list) {
        return deletedLists[list.id] !== true;
    }).filter(function(list) {
        return !list.inventory;
    }).sort(function(a) {
        return a.id === selectedList ? 1 : 0;
    });
    var addToMyProducts = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        dispatch((0,src_areas_sidebar_actions_lists__WEBPACK_IMPORTED_MODULE_5__/* .addItemToMyProductsRequest */ ["if"])(productId, productName, isDesktop));
        setAddedToListState(true);
    }, [
        dispatch,
        isDesktop,
        productId,
        productName
    ]);
    var addToList = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(listId) {
        if (listId) dispatch((0,src_areas_sidebar_actions_lists__WEBPACK_IMPORTED_MODULE_5__/* .selectList */ .Fz)(listId));
        dispatch((0,src_areas_sidebar_actions_lists__WEBPACK_IMPORTED_MODULE_5__/* .addListItemRequest */ .hg)(productId, productName, isDesktop));
        setAddedToListState(true);
    }, [
        dispatch,
        isDesktop,
        productId,
        productName
    ]);
    var handleOnClick = function() {
        return isAuthenticated ? function() {
            return !latestLists || latestLists.length === 0 ? addToList() : setListOpen(true);
        } : toggleLoginPromo;
    };
    if (!productId) return null;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, showLoginPromo && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_modal_login_promo__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        isOpen: showLoginPromo,
        onRequestClose: toggleLoginPromo
    }), listOpen && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_areas_product_components_product_header_components_action_buttons_list_modal__WEBPACK_IMPORTED_MODULE_3__/* .ListModal */ .a, {
        addToList: addToList,
        addToMyProducts: addToMyProducts,
        isOpen: listOpen,
        closeModal: function() {
            return setListOpen(false);
        },
        lists: latestLists,
        isDesktop: Boolean(isDesktop)
    }), children(handleOnClick(), addedToList));
};


/***/ }),

/***/ 27890:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": () => (/* binding */ AddToListButton)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18026);
/* harmony import */ var _prisjakt_ui_icon_heart_filled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63479);
/* harmony import */ var _prisjakt_ui_icon_heart_outlined__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92261);
/* harmony import */ var _base_button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21134);
/* harmony import */ var _add_to_list_wrapper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99447);






var AddToListButton = function(param) {
    var productId = param.productId, productName = param.productName, tooltipAlign = param.tooltipAlign, tooltipPlacement = param.tooltipPlacement;
    var t = (0,src_components_app_context__WEBPACK_IMPORTED_MODULE_1__/* .useAppContext */ .bp)().t;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_add_to_list_wrapper__WEBPACK_IMPORTED_MODULE_5__/* .AddToListModalsWrapper */ .w, {
        productId: productId,
        productName: productName
    }, function(onClick, addedToList) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_base_button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            isActive: addedToList,
            icon: addedToList ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_icon_heart_filled__WEBPACK_IMPORTED_MODULE_2__/* .IconHeartFilled */ .g, null) : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_icon_heart_outlined__WEBPACK_IMPORTED_MODULE_3__/* .IconHeartOutlined */ .G, null),
            ariaLabel: t("common", "button.save"),
            onClick: onClick,
            tooltip: t("product", "action-button.list-tooltip"),
            tooltipAlign: tooltipAlign,
            tooltipPlacement: tooltipPlacement,
            "data-testid": "AddToListButton"
        });
    });
};


/***/ }),

/***/ 16772:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": () => (/* binding */ AlertModal)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23114);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18026);
/* harmony import */ var src_components_modal_v2__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54674);
/* harmony import */ var _prisjakt_ui_modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58709);





var ProductAlertModalContent = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "extra";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | extra */ 737).then(__webpack_require__.bind(__webpack_require__, 22610));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(22610);
        }
        return eval("require.resolve")("../../../areas/product-alert/components/product-alert-modal-content");
    }
});
var AlertModal = function(props) {
    var ref, ref1;
    var market = (0,src_components_app_context__WEBPACK_IMPORTED_MODULE_2__/* .useAppContext */ .bp)().market;
    var closeModal = props.closeModal, isOpen = props.isOpen, productId = props.productId;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, isOpen && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_modal_v2__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        isOpen: isOpen,
        onRequestClose: closeModal
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_modal__WEBPACK_IMPORTED_MODULE_4__/* .ModalBody */ .fe, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ProductAlertModalContent, {
        productId: productId,
        hideModal: closeModal,
        privacyPolicyUri: market === null || market === void 0 ? void 0 : (ref = market.privacySettings) === null || ref === void 0 ? void 0 : (ref1 = ref.responsive) === null || ref1 === void 0 ? void 0 : ref1.privacyUrl
    }))));
};


/***/ }),

/***/ 21134:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _prisjakt_ui_tooltip__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(714);
/* harmony import */ var _prisjakt_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54262);
/* harmony import */ var _prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7336);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35848);





var BaseButton = function(param) {
    var isActive = param.isActive, icon = param.icon, ariaLabel = param.ariaLabel, dataTestid = param["data-testid"], tooltip = param.tooltip, _tooltipAlign = param.tooltipAlign, tooltipAlign = _tooltipAlign === void 0 ? _prisjakt_ui__WEBPACK_IMPORTED_MODULE_2__/* .Direction.Right */ .Nm.Right : _tooltipAlign, _tooltipPlacement = param.tooltipPlacement, tooltipPlacement = _tooltipPlacement === void 0 ? _prisjakt_ui__WEBPACK_IMPORTED_MODULE_2__/* .Direction.Up */ .Nm.Up : _tooltipPlacement, onClick = param.onClick, layout = param.layout;
    if (layout === "button") {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__.OutlinedButton, {
            onClick: onClick,
            containerProps: {
                "data-testid": dataTestid
            }
        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__.ButtonIcon, null, icon), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__.ButtonText, null, ariaLabel));
    }
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_tooltip__WEBPACK_IMPORTED_MODULE_1__/* .Tooltip */ .u, {
        title: tooltip,
        align: tooltipAlign,
        placement: tooltipPlacement,
        width: "180px"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_4__/* .IconButton */ .hU, {
        role: "button",
        active: isActive,
        "aria-label": ariaLabel,
        onClick: onClick,
        "data-testid": dataTestid
    }, icon));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BaseButton);


/***/ }),

/***/ 35848:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lt": () => (/* binding */ Dropdown),
/* harmony export */   "hP": () => (/* binding */ DropdownItem),
/* harmony export */   "hU": () => (/* binding */ IconButton)
/* harmony export */ });
/* unused harmony export IconWrapper */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71993);
/* harmony import */ var src_components_dropdown_new__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16312);
/* harmony import */ var src_components_dropdown_new_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79470);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61093);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 32px;\n  height: 32px;\n  background: rgba(255, 255, 255, 0.72);\n  border-radius: 100%;\n  color: ",
        ";\n\n  svg,\n  path {\n    fill: currentcolor;\n  }\n\n  &:hover {\n    svg {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  border: 0;\n\n  ",
        " {\n    top: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 200px;\n  height: 40px;\n  display: block;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n\n  &:first-child {\n    display: flex;\n    border-bottom: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var IconButton = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].button.withConfig({
    displayName: "IconButton",
    componentId: "sc-0-0"
})(_templateObject(), function(p) {
    return p.active ? p.theme.icons.callToActionHover : p.theme.icons.secondary;
}, function(p) {
    return p.theme.icons.callToActionHover;
});
var Dropdown = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_components_dropdown_new__WEBPACK_IMPORTED_MODULE_1__/* .DropdownNew */ .cw).withConfig({
    displayName: "Dropdown",
    componentId: "sc-0-1"
})(_templateObject1(), src_components_dropdown_new_styles__WEBPACK_IMPORTED_MODULE_2__/* .DropdownContent */ .Nv);
var DropdownItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_components_dropdown_new__WEBPACK_IMPORTED_MODULE_1__/* .ListItem */ .HC).withConfig({
    displayName: "DropdownItem",
    componentId: "sc-0-2"
})(_templateObject2(), function(p) {
    return p.theme.lines.primary;
});
var IconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "IconWrapper",
    componentId: "sc-0-3"
})(_templateObject3(), src_components_base__WEBPACK_IMPORTED_MODULE_3__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, function(p) {
    return p.theme.icons.callToAction;
});


/***/ }),

/***/ 85505:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": () => (/* binding */ adBlockerClassName)
/* harmony export */ });
// A class name that should be blocked by most major ad blockers. Used to save space when an ad blocker is active.
// This particular class name is arbitrarily chosen from https://easylist-downloads.adblockplus.org/easylist.txt
var adBlockerClassName = "AdBox";


/***/ }),

/***/ 38817:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": () => (/* binding */ withAds)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22362);
/* harmony import */ var _services_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31637);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}



function withAds(Component) {
    var wrapper = function(props, ref) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(___WEBPACK_IMPORTED_MODULE_1__/* .AdContext.Consumer */ .QN.Consumer, null, function(adContext) {
            return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_services_context__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Consumer */ .Z.Consumer, null, function(adServiceContext) {
                return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, _extends({}, props, {
                    ref: ref,
                    adContext: adContext,
                    adServiceContext: adServiceContext
                }));
            });
        });
    };
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(wrapper);
}


/***/ }),

/***/ 66589:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1236);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18026);
/* harmony import */ var _error_boundary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77078);
/* harmony import */ var _services__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10440);
/* harmony import */ var _helpers_cookie__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54274);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34511);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85505);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}








var IN_VIEW_THRESHOLD = [
    0
];
var AdContainer = function(props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_2__/* .AppContext */ .Il), t = ref.t, market = ref.market;
    var service = (0,_services__WEBPACK_IMPORTED_MODULE_4__/* .getAdService */ .ii)(props.serviceName);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_6__/* .AdContainerSkeleton */ .Z, {
        $placement: props.placement,
        $spacing: props.spacing,
        className: _constants__WEBPACK_IMPORTED_MODULE_7__/* .adBlockerClassName */ ._
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(service.container, _extends({}, props), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_6__/* .AdLabel */ .p, {
        $align: market.ads.labelAlign
    }, t("common", "ads.label"))));
};
var AdContainerWithVisibility = function(props) {
    var ref = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), 2), isVisible = ref[0], setIsVisible = ref[1];
    var className = props.className, renderWhenInScreen = props.renderWhenInScreen, triggerPoint = props.triggerPoint;
    var market = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_2__/* .AppContext */ .Il).market;
    var serviceName = (0,_helpers_cookie__WEBPACK_IMPORTED_MODULE_5__/* .getAdContextCookie */ .RT)().service || market.ads.service;
    var onChangeHandler = function(inView) {
        if (isVisible !== inView) {
            setIsVisible(inView);
        }
    };
    if (props.onlyWithServices && Array.isArray(props.onlyWithServices) && !props.onlyWithServices.includes(serviceName)) {
        return null;
    }
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_intersection_observer__WEBPACK_IMPORTED_MODULE_1__/* .InView */ .df, {
        threshold: IN_VIEW_THRESHOLD,
        onChange: onChangeHandler,
        rootMargin: "0px 0px ".concat(triggerPoint, "px 0px")
    }, function(param) {
        var ref = param.ref;
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
            ref: ref,
            className: className,
            "data-test": "AdContainer"
        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(AdContainer, _extends({}, props, {
            isVisible: renderWhenInScreen ? !!isVisible : true,
            serviceName: serviceName
        })));
    });
};
AdContainerWithVisibility.defaultProps = {
    renderWhenInScreen: true,
    className: undefined,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onStatusChange: function() {},
    triggerPoint: 300
};
var AdContainerWithErrorBoundary = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_error_boundary__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        onError: function() {
            return null;
        }
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(AdContainerWithVisibility, _extends({}, props)));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AdContainerWithErrorBoundary);


/***/ }),

/***/ 59533:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": () => (/* binding */ AdPlacementWrapper),
/* harmony export */   "tO": () => (/* binding */ AdCogwheel),
/* harmony export */   "zM": () => (/* binding */ AdPlacementContainer)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71993);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61093);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34511);
/* harmony import */ var src_components_page_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44307);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      margin-left: 0;\n      margin-right: 0;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  margin-left: ",
        ";\n  margin-right: ",
        ";\n\n  ",
        "\n\n  @media ",
        " {\n    margin-left: auto;\n    margin-right: auto;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n          margin-top: 0;\n          margin-left: 0;\n          margin-right: 0;\n          overflow: hidden;\n        "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n          border: 1px solid ",
        ";\n        "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 0;\n  text-align: center;\n  display: block;\n  box-sizing: content-box;\n  max-height: none;\n  position: absolute;\n  left: 0;\n  top: 0;\n  border: 0;\n\n  ",
        "\n\n  ",
        " {\n    z-index: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  right: 0;\n  width: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var AdPlacementWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "AdPlacementWrapper",
    componentId: "sc-0-0"
})(_templateObject1(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, function(p) {
    return p.isTakeover && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject());
}, "screen and (max-width: ".concat(src_components_page_constants__WEBPACK_IMPORTED_MODULE_3__/* .PAGE_CONTENT_GUTTER_BREAKPOINT */ .OC, ")"));
var AdPlacementContainer = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "AdPlacementContainer",
    componentId: "sc-0-1"
})(_templateObject4(), function(p) {
    return p.isTakeover ? (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject2()) : (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject3(), p.theme.lines.secondary);
}, _styles__WEBPACK_IMPORTED_MODULE_2__/* .AdLabel */ .p, function(p) {
    return p.isTakeover ? 11 : 1;
});
var AdCogwheel = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "AdCogwheel",
    componentId: "sc-0-2"
})(_templateObject5(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing150 */ .bK.measurements.spacing150);


/***/ }),

/***/ 31637:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "d": () => (/* binding */ useAdServiceContext)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18026);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22362);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10440);
/* harmony import */ var _helpers_cookie__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54274);





var AdServiceContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
AdServiceContext.displayName = "AdServiceContext";
var AdServiceContextProvider = function(props) {
    var market = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_1__/* .AppContext */ .Il).market;
    var adContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context__WEBPACK_IMPORTED_MODULE_2__/* .AdContext */ .QN);
    var serviceName = (0,_helpers_cookie__WEBPACK_IMPORTED_MODULE_4__/* .getAdContextCookie */ .RT)().service || market.ads.service;
    var service = (0,___WEBPACK_IMPORTED_MODULE_3__/* .getAdService */ .ii)(serviceName);
    var config = market.ads[serviceName] || {};
    return adContext.active ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(service.provider, {
        config: config,
        adContext: adContext,
        baseProvider: AdServiceContext.Provider
    }, props.children) : props.children;
};
var useAdServiceContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(AdServiceContext);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
    Provider: /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(AdServiceContextProvider),
    Consumer: AdServiceContext.Consumer
});


/***/ }),

/***/ 34511:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ AdContainerSkeleton),
/* harmony export */   "p": () => (/* binding */ AdLabel)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71993);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61093);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  z-index: 1;\n  pointer-events: none;\n  left: 0;\n  ",
        ": 0;\n  display: block;\n  background-color: ",
        ";\n  color: ",
        ";\n  font-size: 11px;\n  padding: 0 ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    min-height: ",
        "};\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    margin-top: 0px;\n    margin-bottom: 0px;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n\n  min-height: ",
        ";\n\n  ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var AdLabel = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({
    displayName: "AdLabel",
    componentId: "sc-0-0"
})(_templateObject(), function(props) {
    return props.$align || "top";
}, function(props) {
    return props.theme.colors.base200;
}, function(props) {
    return props.theme.colors.base600;
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025);
var ref, ref1;
var AdContainerSkeleton = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "AdContainerSkeleton",
    componentId: "sc-0-1"
})(_templateObject3(), function(props) {
    var ref1;
    return (ref = (ref1 = props.$spacing) === null || ref1 === void 0 ? void 0 : ref1.top) !== null && ref !== void 0 ? ref : 0;
}, function(props) {
    var ref;
    return (ref1 = (ref = props.$spacing) === null || ref === void 0 ? void 0 : ref.bottom) !== null && ref1 !== void 0 ? ref1 : 0;
}, function(props) {
    return getHeightFromPlacementMobile(props.$placement);
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumUp */ .BC.mediumUp(_templateObject1(), function(props) {
    return getHeightFromPlacementDesktop(props.$placement);
}), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject2()));
function getHeightFromPlacementDesktop(placement) {
    if (!placement) {
        return "auto";
    }
    switch(placement){
        case "panorama_top":
        case "panorama_extra":
        case "panorama_extra_2":
            return "120px";
        case "dubbelpanorama1":
        case "dubbelpanorama2":
        case "dubbelpanorama3":
        case "mob-banner-ad-a":
        case "mob-banner-ad-b":
        case "skyscraper_1":
        case "skyscraper_2":
        case "skyscraper_3":
        case "panorama_target":
        default:
            return "auto";
    }
}
function getHeightFromPlacementMobile(placement) {
    if (!placement) {
        return "auto";
    }
    switch(placement){
        case "dubbelpanorama1":
        case "dubbelpanorama2":
        case "dubbelpanorama3":
        case "dubbelpanorama_top":
            return "160px;";
        case "panorama_top":
        case "mob-banner-ad-a":
        case "mob-banner-ad-b":
        case "skyscraper_1":
        case "skyscraper_2":
        case "skyscraper_3":
        case "panorama_target":
        case "panorama_extra":
        case "panorama_extra_2":
        default:
            return "auto";
    }
}


/***/ }),

/***/ 18026:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Il": () => (/* binding */ AppContext),
/* harmony export */   "bp": () => (/* binding */ useAppContext),
/* harmony export */   "hw": () => (/* binding */ AppContextContainer)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_translate__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61041);
/* harmony import */ var seedrandom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68116);
/* harmony import */ var seedrandom__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(seedrandom__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _link_to__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73199);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





var crash = function() {
    throw new Error("AppContext value is not initialized.");
};
var initialValue = {
    renderMode: "",
    market: "",
    linkTo: crash,
    t: crash,
    Translate: crash,
    captureMessage: crash,
    captureException: crash,
    productOfTheYear: []
};
var AppContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(initialValue);
AppContext.displayName = "AppContext";
var captureEvent = function(sentryPromise, sentryMethodName, data) {
    sentryPromise.then(function(sentry) {
        sentry[sentryMethodName](data);
    }).catch(function() {
        var consoleMethodName = {
            captureMessage: "log",
            captureException: "error"
        }[sentryMethodName];
        console[consoleMethodName](data); // eslint-disable-line no-console
    });
};
var AppContextContainer = function(param) {
    var children = param.children, translations = param.translations, renderMode = param.renderMode, market = param.market, locale = param.locale, sentryPromise = param.sentryPromise, rngSeed = param.rngSeed, _productOfTheYear = param.productOfTheYear, productOfTheYear = _productOfTheYear === void 0 ? [] : _productOfTheYear;
    var context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var translate = (0,src_components_translate__WEBPACK_IMPORTED_MODULE_1__/* .translator */ .O)(translations, locale);
        var ctx = {
            renderMode: renderMode,
            market: market,
            random: seedrandom__WEBPACK_IMPORTED_MODULE_2___default()(rngSeed),
            linkTo: function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return(// .bind only has TS support with up to 4 arguments, so using wrapper function here instead.
                _link_to__WEBPACK_IMPORTED_MODULE_3__/* .linkTo.apply */ .kZ.apply(void 0, [
                    market.useClassicUrls,
                    market.useHashForProductTabs,
                    market.classicRoutes,
                    market.routes,
                    market.fallbackRedirects
                ].concat(_toConsumableArray(args))));
            },
            t: translate,
            captureMessage: function(data) {
                return captureEvent(sentryPromise, "captureMessage", data);
            },
            captureException: function(data) {
                captureEvent(sentryPromise, "captureException", data);
            },
            sentry: sentryPromise,
            productOfTheYear: productOfTheYear
        };
        return ctx;
    }, [
        translations,
        locale,
        renderMode,
        market,
        rngSeed,
        sentryPromise,
        productOfTheYear
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(AppContext.Provider, {
        value: context
    }, children);
};
var useAppContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(AppContext);
};
AppContextContainer.defaultProps = {
    children: null,
    locale: undefined
};


/***/ }),

/***/ 73199:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "kZ": () => (/* binding */ linkTo),
/* harmony export */   "pS": () => (/* binding */ withQueryString)
/* harmony export */ });
/* unused harmony export addQueryToUrl */
/* harmony import */ var querystring__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97150);
/* harmony import */ var _prisjakt_product_collection_urls__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16472);
/* harmony import */ var _prisjakt_product_collection_urls__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_prisjakt_product_collection_urls__WEBPACK_IMPORTED_MODULE_1__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


var hasQueryString = function(url) {
    return typeof url === "string" && url.indexOf("?") !== -1;
};
var removeQueryString = function(url) {
    return url && hasQueryString(url) ? url.substring(0, url.indexOf("?")) : url;
};
var queryStringFromUrl = function(url) {
    return url ? url.substr(url.indexOf("?")).substr(1) : "";
};
var addQueryToUrl = function(url, qs) {
    var baseUrl = hasQueryString(url) ? removeQueryString(url) : url;
    if (!baseUrl) return "";
    var qsFragment = qs ? "?".concat(qs) : "";
    return "".concat(baseUrl).concat(qsFragment);
};
var sortWithProductIdFirst = function(a, b) {
    return b === "p" ? -1 : b.localeCompare(a);
};
// eslint-disable-next-line @typescript-eslint/ban-types
var getQueryString = function(url, query) {
    // Combine parameters from URL with query object
    var combinedQuery = Object.assign(querystring__WEBPACK_IMPORTED_MODULE_0__.decode(queryStringFromUrl(url)), query);
    // Sort object keys to ensure constant parameter order
    // Special case for the product page where we always want ?p= to come first.
    var sortedQuery = Object.keys(combinedQuery).sort(sortWithProductIdFirst).reduce(function(q, key) {
        return _objectSpreadProps(_objectSpread({}, q), _defineProperty({}, key, combinedQuery[key]));
    }, {});
    return querystring__WEBPACK_IMPORTED_MODULE_0__.encode(sortedQuery);
};
var withQueryString = function(url, query) {
    return addQueryToUrl(url, getQueryString(url, query));
};
function productSectionToClassicIdParam() {
    var section = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "main";
    switch(section){
        case "properties":
            return "e";
        case "reviews":
            return "o";
        case "statistics":
            return "pu";
        default:
            return "p";
    }
}
function getPath(path) {
    return Array.isArray(path) ? path[0] : path || "";
}
var linkTo = function(useClassicUrls, useHashForProductTabs, classicRoutes, routes, fallbackRedirects, type) {
    var item = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : undefined, query = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : {};
    var linkToProduct = function linkToProduct(section) {
        var classicIdParam = useHashForProductTabs ? "p" : productSectionToClassicIdParam(section);
        var path = useClassicUrls ? withQueryString(classicRoutes.product, _objectSpreadProps(_objectSpread({}, query), _defineProperty({}, classicIdParam, item === null || item === void 0 ? void 0 : item.id))) : "".concat(withQueryString(semanticId, query)).concat(!useHashForProductTabs && section ? "/".concat(section) : "");
        return useHashForProductTabs && section ? "".concat(path, "#").concat(section) : path;
    };
    // Support both graphql schema and api schema
    var semanticId = item && (item.pathName || item.semantic_id || item.path);
    var externalUri = item && (item.externalUri || item.redirect_uri);
    switch(type){
        case "raw":
            {
                return externalUri;
            }
        case "product":
        case "raw_sorted":
            {
                return linkToProduct();
            }
        case "productProperties":
            {
                return linkToProduct("properties");
            }
        case "productReviews":
            {
                return linkToProduct("reviews");
            }
        case "productPriceHistory":
            {
                return linkToProduct("statistics");
            }
        case "productAlert":
            {
                var ref, ref1;
                var classicUrl = "".concat(classicRoutes.product).concat(routes === null || routes === void 0 ? void 0 : (ref = routes.productAlert) === null || ref === void 0 ? void 0 : ref.relativePath);
                var semanticUrl = "".concat(semanticId).concat(routes === null || routes === void 0 ? void 0 : (ref1 = routes.productAlert) === null || ref1 === void 0 ? void 0 : ref1.relativePath);
                return useClassicUrls ? withQueryString(classicUrl, _objectSpreadProps(_objectSpread({}, query), {
                    p: item === null || item === void 0 ? void 0 : item.id
                })) : withQueryString(semanticUrl, query);
            }
        case "productCompare":
            {
                var ref2;
                var category = item.category, products = item.products;
                var categoryId = category && category.id;
                var productIds = Array.isArray(products) ? products.map(function(p) {
                    return p.id;
                }).join(",") : "";
                var path = getPath(routes === null || routes === void 0 ? void 0 : (ref2 = routes.productCompare) === null || ref2 === void 0 ? void 0 : ref2.path);
                return withQueryString(path.replace(":productIds", productIds), categoryId ? {
                    categoryId: categoryId
                } : {});
            }
        case "brand":
            {
                return useClassicUrls ? withQueryString(classicRoutes.brand, _objectSpreadProps(_objectSpread({}, query), {
                    t: item === null || item === void 0 ? void 0 : item.id
                })) : withQueryString(semanticId, query);
            }
        case "store":
            {
                return useClassicUrls ? withQueryString(classicRoutes.store_info, _objectSpreadProps(_objectSpread({}, query), {
                    f: item === null || item === void 0 ? void 0 : item.id
                })) : withQueryString(semanticId, query);
            }
        case "brandCategory":
        case "brand_category":
        case "brand_virtual_category":
            if ((item === null || item === void 0 ? void 0 : item.product_collection) || (item === null || item === void 0 ? void 0 : item.productCollection)) {
                // eslint-disable-next-line no-param-reassign
                query.brand = item === null || item === void 0 ? void 0 : item.brandId;
            } else if (useClassicUrls) {
                // eslint-disable-next-line no-param-reassign
                query.t = item === null || item === void 0 ? void 0 : item.brandId;
            } else {
                // eslint-disable-next-line no-param-reassign
                query.brand = item === null || item === void 0 ? void 0 : item.brandId;
            }
        case "virtual_category":
        case "virtualCategory":
        case "category":
            {
                if ((item === null || item === void 0 ? void 0 : item.type) === "productCollection" || (item === null || item === void 0 ? void 0 : item.product_collection) || (item === null || item === void 0 ? void 0 : item.productCollection)) {
                    return withQueryString(item.product_collection || item.productCollection || item.path, query);
                }
                if (useClassicUrls) {
                    return withQueryString(classicRoutes.category, _objectSpreadProps(_objectSpread({}, query), {
                        k: item === null || item === void 0 ? void 0 : item.id
                    }));
                }
                if (semanticId == null && fallbackRedirects && fallbackRedirects[item === null || item === void 0 ? void 0 : item.id]) {
                    return fallbackRedirects[item === null || item === void 0 ? void 0 : item.id];
                }
                return withQueryString(semanticId, query);
            }
        case "shopOfTheYear":
            {
                var ref3;
                return getPath(routes === null || routes === void 0 ? void 0 : (ref3 = routes.shopOfTheYear) === null || ref3 === void 0 ? void 0 : ref3.path);
            }
        case "shopOfTheYearCategory":
            {
                var ref4;
                return getPath(routes === null || routes === void 0 ? void 0 : (ref4 = routes.shopOfTheYearCategory) === null || ref4 === void 0 ? void 0 : ref4.path).replace(":year", item === null || item === void 0 ? void 0 : item.year).replace(":id", item === null || item === void 0 ? void 0 : item.id);
            }
        case "shopOfTheYearWinners":
            {
                var ref5;
                return "".concat(getPath(routes === null || routes === void 0 ? void 0 : (ref5 = routes.shopOfTheYearWinners) === null || ref5 === void 0 ? void 0 : ref5.path).replace(":section", item === null || item === void 0 ? void 0 : item.year), "#winners");
            }
        case "productCollection":
            {
                var _filters = item.filters, filters = _filters === void 0 ? [] : _filters;
                return filters.reduce(_prisjakt_product_collection_urls__WEBPACK_IMPORTED_MODULE_1__.addFilterToUrl, semanticId);
            }
        case "productCollectionSitemap":
            {
                var baseUrl = item.baseUrl;
                return removeQueryString(baseUrl.replace("/c/", "/cm/"));
            }
        case "editorialContentListing":
            {
                var ref6;
                return getPath(routes === null || routes === void 0 ? void 0 : (ref6 = routes.editorialContentListing) === null || ref6 === void 0 ? void 0 : ref6.path);
            }
        case "user":
            {
                return "/user/".concat(item === null || item === void 0 ? void 0 : item.id);
            }
        case "list":
            {
                return withQueryString(semanticId, query);
            }
        case "categoryIndex":
            {
                var ref7;
                return getPath(routes === null || routes === void 0 ? void 0 : (ref7 = routes.categoryIndex) === null || ref7 === void 0 ? void 0 : ref7.path);
            }
        case "expertTest":
            {
                return withQueryString(semanticId, query);
            }
        case "expertToplist":
            {
                return withQueryString(semanticId, query);
            }
        case "expertCategory":
            {
                return withQueryString(semanticId, query);
            }
        case "expertProfile":
            {
                return withQueryString(semanticId, query);
            }
        case "expertContent":
            {
                return withQueryString(semanticId, query);
            }
        case "expertMedia":
            {
                return withQueryString(semanticId, query);
            }
        case "expertArticle":
            {
                return withQueryString(semanticId, query);
            }
        case "experts":
            {
                var ref8;
                return withQueryString(getPath(routes === null || routes === void 0 ? void 0 : (ref8 = routes.expertLandingPage) === null || ref8 === void 0 ? void 0 : ref8.path), query);
            }
        case "changelog":
            {
                var ref9;
                return getPath(routes === null || routes === void 0 ? void 0 : (ref9 = routes.changelogLandingPage) === null || ref9 === void 0 ? void 0 : ref9.path);
            }
        case "changelogArticle":
            {
                return "/".concat(item === null || item === void 0 ? void 0 : item.path);
            }
        case "changelogLatest":
            {
                var ref10;
                return getPath(routes === null || routes === void 0 ? void 0 : (ref10 = routes.changelogLatest) === null || ref10 === void 0 ? void 0 : ref10.path);
            }
        case "keywordListing":
            {
                var slug = (item === null || item === void 0 ? void 0 : item.url) && item.url.slug ? item.url.slug : item === null || item === void 0 ? void 0 : item.slug;
                return "/kw/".concat(slug || (item === null || item === void 0 ? void 0 : item.id));
            }
        case "search":
            {
                return "/search?search=".concat(item === null || item === void 0 ? void 0 : item.query);
            }
        case "promotions":
            {
                var ref11, ref12;
                var id = item === null || item === void 0 ? void 0 : item.id;
                var path1 = getPath(routes === null || routes === void 0 ? void 0 : (ref11 = routes.promotionProducts) === null || ref11 === void 0 ? void 0 : ref11.path);
                if (id && path1) {
                    return path1.replace(":id", id);
                }
                return getPath(routes === null || routes === void 0 ? void 0 : (ref12 = routes.promotions) === null || ref12 === void 0 ? void 0 : ref12.path);
            }
        case "used":
            {
                var ref13;
                return getPath(routes === null || routes === void 0 ? void 0 : (ref13 = routes.usedProducts) === null || ref13 === void 0 ? void 0 : ref13.path);
            }
        default:
            return "";
    }
};



/***/ }),

/***/ 8172:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": () => (/* binding */ article_card_ArticleCard)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/card/index.js
var card = __webpack_require__(89695);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(38689);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(71016);
// EXTERNAL MODULE: ./src/components/info-list/index.tsx + 1 modules
var info_list = __webpack_require__(80245);
// EXTERNAL MODULE: ./src/components/user-avatar/index.tsx + 1 modules
var user_avatar = __webpack_require__(93538);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
;// CONCATENATED MODULE: ./src/components/article-card/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  height: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  gap: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    justify-content: flex-end;\n    flex: 0 1 auto;\n    border-top: 1px solid ",
        ";\n    width: 100%;\n    padding-top: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  & > :not(:last-child) {\n    margin-bottom: unset;\n  }\n\n  ",
        " {\n    margin-bottom: ",
        ";\n  }\n\n  ",
        " {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var ArticleCard = (0,styled_components_browser_esm["default"])(card.Card).withConfig({
    displayName: "ArticleCard",
    componentId: "sc-0-0"
})(_templateObject());
var Header = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Header",
    componentId: "sc-0-1"
})(_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var Footer = (0,styled_components_browser_esm["default"])(card.CardContent).withConfig({
    displayName: "Footer",
    componentId: "sc-0-2"
})(_templateObject2(), function(p) {
    return p.theme.lines.primary;
}, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var Title = (0,styled_components_browser_esm["default"])(variants.TitleMediumText).withConfig({
    displayName: "Title",
    componentId: "sc-0-3"
})(_templateObject3());
var Content = (0,styled_components_browser_esm["default"])(card.CardContent).withConfig({
    displayName: "Content",
    componentId: "sc-0-4"
})(_templateObject4(), Header, base/* layout.measurements.spacing075 */.bK.measurements.spacing075, Title, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);

;// CONCATENATED MODULE: ./src/components/article-card/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}








var article_card_ArticleCard = function(param) {
    var pretitle = param.pretitle, className = param.className, date = param.date, grade = param.grade, onClick = param.onClick, likes = param.likes, media = param.media, icon = param.icon, titleAndCategory = param.titleAndCategory, url = param.url, footer = param.footer, _footerPartOfLink = param.footerPartOfLink, footerPartOfLink = _footerPartOfLink === void 0 ? false : _footerPartOfLink;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), renderMode = ref.renderMode, linkTo = ref.linkTo, t = ref.t, market = ref.market;
    var getInfoListItems = function() {
        var render = function(string) {
            return /*#__PURE__*/ react.createElement(variants.CaptionText, {
                emphasis: variants.FontEmphasis.HIGH,
                color: variants.FontColor.DARK
            }, string);
        };
        var likesString = likes && likes >= 50 ? t("expert", "likes.count", {
            n: likes,
            count: likes.toLocaleString(market.localeStandard)
        }) : undefined;
        return _toConsumableArray(date ? [
            render(date)
        ] : []).concat(_toConsumableArray(likesString ? [
            render(likesString)
        ] : []));
    };
    var linkToString = linkTo("expertContent", {
        semantic_id: url
    }, renderMode === "native" ? {
        view: "native"
    } : undefined);
    return /*#__PURE__*/ react.createElement(ArticleCard, {
        className: className
    }, /*#__PURE__*/ react.createElement(card.CardActionArea, {
        container: url ? clickable/* Clickable */.P : undefined,
        containerProps: {
            onClick: onClick,
            to: linkToString,
            isExternal: renderMode === "native"
        },
        style: {
            flex: "1 0 auto"
        }
    }, media && /*#__PURE__*/ react.createElement(card.CardMedia, {
        $background: true
    }, grade, media, icon), /*#__PURE__*/ react.createElement(Content, null, pretitle && /*#__PURE__*/ react.createElement(Header, null, (pretitle === null || pretitle === void 0 ? void 0 : pretitle.image) && /*#__PURE__*/ react.createElement(user_avatar/* UserAvatar */.Y, {
        avatar: pretitle.image,
        displayName: pretitle.name
    }), /*#__PURE__*/ react.createElement(variants.BodySmallText, {
        behavior: variants.Behavior.OnelineEllipsis,
        emphasis: variants.FontEmphasis.MEDIUM
    }, pretitle === null || pretitle === void 0 ? void 0 : pretitle.name)), /*#__PURE__*/ react.createElement(Title, null, titleAndCategory), /*#__PURE__*/ react.createElement(info_list/* InfoList */.Q, {
        list: getInfoListItems()
    })), footer && footerPartOfLink && /*#__PURE__*/ react.createElement(Footer, null, footer)), footer && !footerPartOfLink && /*#__PURE__*/ react.createElement(Footer, null, footer));
};


/***/ }),

/***/ 56355:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": () => (/* binding */ BadgeTypeEnum),
  "T": () => (/* binding */ DealsBadge)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./src/components/viewport/context.tsx
var context = __webpack_require__(84198);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/info-outlined/index.js
var info_outlined = __webpack_require__(12525);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/trending-down/index.js
var trending_down = __webpack_require__(90258);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/popover/index.js
var popover = __webpack_require__(22448);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(71016);
// EXTERNAL MODULE: ./src/areas/scoped-search-pages/deals-page/utils.ts
var utils = __webpack_require__(68977);
// EXTERNAL MODULE: ./src/components/currency/index.tsx
var currency = __webpack_require__(49763);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/index.js
var design_tokens = __webpack_require__(43220);
;// CONCATENATED MODULE: ./src/components/badges/deals-badge/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  white-space: initial;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      top: 24px;\n      left: -18px;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    position: relative;\n    z-index: 101;\n    white-space: initial;\n    top: 30px;\n\n    ",
        "\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      padding: 0 ",
        ";\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      border-radius: 50%;\n      padding: ",
        ";\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    display: inline-flex;\n    align-items: center;\n    background-color: ",
        ";\n    color: ",
        ";\n    border-radius: 0.225rem;\n    padding: 0.125rem ",
        ";\n    gap: ",
        ";\n    cursor: pointer;\n    white-space: nowrap;\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  cursor: initial;\n  user-select: text;\n  text-align: initial;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}



var StyledDealsBadge = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledDealsBadge",
    componentId: "sc-0-0"
})(_templateObject());
var StyledPopoverWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledPopoverWrapper",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject2(), props.$isLabelBadge && (0,styled_components_browser_esm.css)(_templateObject1()));
});
var DealsBadgeWithInfoTooltip = styled_components_browser_esm["default"].div.withConfig({
    displayName: "DealsBadgeWithInfoTooltip",
    componentId: "sc-0-2"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject5(), design_tokens.lightThemeColors.staticInformative100, design_tokens.lightThemeColors.maybeBlue700, design_tokens.measurements.spacing050, design_tokens.measurements.spacing025, props.$isLabelBadge && (0,styled_components_browser_esm.css)(_templateObject3(), design_tokens.measurements.spacing050), props.$circular && (0,styled_components_browser_esm.css)(_templateObject4(), design_tokens.measurements.spacing025));
});
var StyledSmallVerticalGap = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledSmallVerticalGap",
    componentId: "sc-0-3"
})(_templateObject6(), design_tokens.measurements.spacing025);
var StyledBigVerticalGap = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledBigVerticalGap",
    componentId: "sc-0-4"
})(_templateObject7(), design_tokens.measurements.spacing075);
var StyledPopover = (0,styled_components_browser_esm["default"])(popover/* Popover */.J2).withConfig({
    displayName: "StyledPopover",
    componentId: "sc-0-5"
})(_templateObject8());

;// CONCATENATED MODULE: ./src/components/badges/deals-badge/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}










var BadgeTypeEnum;
(function(BadgeTypeEnum) {
    BadgeTypeEnum["BADGE"] = "badge";
    BadgeTypeEnum["ICON_BADGE"] = "icon-badge";
    BadgeTypeEnum["LABEL_BADGE"] = "label-badge";
})(BadgeTypeEnum || (BadgeTypeEnum = {}));
var DealsBadge = function(param) {
    var _badgeType = param.badgeType, badgeType = _badgeType === void 0 ? BadgeTypeEnum.BADGE : _badgeType, dataTestId = param["data-testid"], popoverUniqueId = param.popoverUniqueId, price = param.price, priceDrop = param.priceDrop, hidePopover = param.hidePopover;
    var ref = (0,app_context/* useAppContext */.bp)(), t = ref.t, market = ref.market;
    var isDesktop = (0,context/* useViewportContext */.Ak)().isDesktop;
    var ref1 = _slicedToArray((0,react.useState)(false), 2), showPopover = ref1[0], setShowPopover = ref1[1];
    var expectedPrice = (0,currency/* formatCurrency */.xG)(Math.round((0,utils/* getPreviousPrice */.L)(priceDrop, price)), market.code, false).toString();
    var text = badgeType === BadgeTypeEnum.LABEL_BADGE && isDesktop ? t("campaigns", "product-card.percentage-below-trend", {
        percentage: priceDrop.toString()
    }) : "".concat(priceDrop, "%");
    return /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(StyledPopoverWrapper, {
        onClick: function(event) {
            if (hidePopover) {
                return;
            }
            event.preventDefault();
            event.stopPropagation();
        },
        $isLabelBadge: badgeType === BadgeTypeEnum.LABEL_BADGE
    }, /*#__PURE__*/ react.createElement(StyledPopover, {
        id: "popover-deals-badge-".concat(popoverUniqueId),
        visible: showPopover,
        width: isDesktop ? 210 : 140,
        // The setTimeout here is needed due to the Popover-onClose triggering before the Badge-onClick.
        onClose: function(event) {
            if (hidePopover) {
                return;
            }
            event === null || event === void 0 ? void 0 : event.preventDefault();
            event === null || event === void 0 ? void 0 : event.stopPropagation();
            setTimeout(function() {
                return setShowPopover(false);
            });
        },
        horizontalAlign: popover/* Alignment.Start */.v2.Start,
        verticalAlign: popover/* Alignment.Start */.v2.Start
    }, /*#__PURE__*/ react.createElement(StyledBigVerticalGap, null, /*#__PURE__*/ react.createElement(StyledSmallVerticalGap, null, /*#__PURE__*/ react.createElement(variants.TitleSmallText, {
        color: variants.FontColor.DARK
    }, t("campaigns", "product-card.percentage-below-trend", {
        percentage: priceDrop.toString()
    })), /*#__PURE__*/ react.createElement(variants.BodySmallText, {
        color: variants.FontColor.DARK
    }, t("campaigns", "product-card.expected-price-explanation", {
        expectedPrice: expectedPrice
    })))))), /*#__PURE__*/ react.createElement(StyledDealsBadge, {
        "data-testid": dataTestId,
        onClick: function(event) {
            if (hidePopover) {
                return;
            }
            event.preventDefault();
            event.stopPropagation();
        }
    }, /*#__PURE__*/ react.createElement(DealsBadgeWithInfoTooltip, {
        onClick: function(event) {
            if (hidePopover) {
                return;
            }
            event.preventDefault();
            event.stopPropagation();
            setShowPopover(true);
        },
        $circular: badgeType === BadgeTypeEnum.ICON_BADGE,
        $isLabelBadge: badgeType === BadgeTypeEnum.LABEL_BADGE
    }, /*#__PURE__*/ react.createElement(trending_down/* IconTrendingDown */.j, {
        color: "maybeBlue700",
        size: badgeType === BadgeTypeEnum.LABEL_BADGE ? 11 : 16
    }), badgeType !== BadgeTypeEnum.ICON_BADGE && /*#__PURE__*/ react.createElement(react.Fragment, null, badgeType === BadgeTypeEnum.BADGE ? /*#__PURE__*/ react.createElement(variants.TitleSmallText, null, text) : /*#__PURE__*/ react.createElement(variants.CaptionText, {
        emphasis: variants.FontEmphasis.HIGH
    }, text)), badgeType !== BadgeTypeEnum.ICON_BADGE && /*#__PURE__*/ react.createElement(info_outlined/* IconInfoOutlined */.e, {
        size: 16,
        color: "maybeBlue700"
    }))));
};


/***/ }),

/***/ 39986:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ER": () => (/* binding */ ProductHeaderImageBadge),
/* harmony export */   "d3": () => (/* binding */ ImageBadge),
/* harmony export */   "gE": () => (/* binding */ MiniCardImageBadge),
/* harmony export */   "ni": () => (/* binding */ GridCardImageBadge),
/* harmony export */   "rn": () => (/* binding */ ListCardImageBadge)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71993);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61093);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  z-index: 1;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: 56px;\n  position: absolute;\n  z-index: auto;\n  right: 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  width: 32px;\n  top: -",
        ";\n  right: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  width: 32px;\n  top: 0;\n  right: 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    width: 48px;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  width: 40px;\n  right: 0;\n  top: 0;\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var ImageBadgeImg = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].img.withConfig({
    displayName: "ImageBadgeImg",
    componentId: "sc-0-0"
})(_templateObject());
var ImageBadge = function(param) {
    var badgeUrl = param.badgeUrl, title = param.title, className = param.className;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ImageBadgeImg, {
        className: className,
        src: badgeUrl,
        alt: title,
        title: title
    });
};
var GridCardImageBadge = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])(ImageBadge).withConfig({
    displayName: "GridCardImageBadge",
    componentId: "sc-0-1"
})(_templateObject1());
var ListCardImageBadge = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])(ImageBadge).withConfig({
    displayName: "ListCardImageBadge",
    componentId: "sc-0-2"
})(_templateObject2(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025);
var MiniCardImageBadge = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])(ImageBadge).withConfig({
    displayName: "MiniCardImageBadge",
    componentId: "sc-0-3"
})(_templateObject3());
var ProductHeaderImageBadge = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])(ImageBadge).withConfig({
    displayName: "ProductHeaderImageBadge",
    componentId: "sc-0-4"
})(_templateObject5(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.mediumUp */ .BC.mediumUp(_templateObject4()));


/***/ }),

/***/ 80370:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "HIGHLIGHT_NEW_CONTENT_DURATION": () => (/* reexport */ HIGHLIGHT_NEW_CONTENT_DURATION),
  "fadeInKeyframes": () => (/* binding */ fadeInKeyframes),
  "fromZeroWidthKeyframes": () => (/* binding */ fromZeroWidthKeyframes),
  "highlightNewContentAnimation": () => (/* reexport */ highlightNewContentAnimation)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/styles/variables.ts
var variables = __webpack_require__(11093);
// EXTERNAL MODULE: ./src/components/base/src/color-utils.ts
var color_utils = __webpack_require__(55318);
;// CONCATENATED MODULE: ./src/components/base/src/animations/highlight-new-content.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  from {\n    background-color: ",
        ";\n  }\n  25% {\n    background-color: ",
        ";\n  }\n  50% {\n    background-color: ",
        ";\n  }\n  to {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  animation: ",
        "\n    ",
        "ms ease-out 1;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var INITIAL_COLOR = (0,color_utils.setRgbaAlpha)(variables/* colors.lightTheme.yellove500 */.O9.lightTheme.yellove500, "0");
var HIGHLIGHT_COLOR = (0,color_utils.setRgbaAlpha)(variables/* colors.lightTheme.yellove500 */.O9.lightTheme.yellove500, "0.2");
var highlightNewContentKeyframes = function() {
    var initialColor = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : INITIAL_COLOR, transitionColor = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : HIGHLIGHT_COLOR;
    return (0,styled_components_browser_esm.keyframes)(_templateObject(), initialColor, transitionColor, transitionColor, initialColor);
};
var HIGHLIGHT_NEW_CONTENT_DURATION = 750;
var highlightNewContentAnimation = function(initialColor, transitionColor) {
    return (0,styled_components_browser_esm.css)(_templateObject1(), highlightNewContentKeyframes(initialColor, transitionColor), HIGHLIGHT_NEW_CONTENT_DURATION);
};

;// CONCATENATED MODULE: ./src/components/base/src/animations/index.ts
function animations_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function animations_templateObject() {
    var data = animations_taggedTemplateLiteral([
        "\nfrom { opacity: 0; }\nto { opacity: 1; }\n"
    ]);
    animations_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function animations_templateObject1() {
    var data = animations_taggedTemplateLiteral([
        "\nfrom { max-width: 0%; word-break: break-all; }\nto { max-width: 100%; word-break: unset; }\n"
    ]);
    animations_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var fadeInKeyframes = (0,styled_components_browser_esm.keyframes)(animations_templateObject());
var fromZeroWidthKeyframes = (0,styled_components_browser_esm.keyframes)(animations_templateObject1());


/***/ }),

/***/ 55318:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "blendColors": () => (/* binding */ blendColors),
/* harmony export */   "blendHexColors": () => (/* binding */ blendHexColors),
/* harmony export */   "extractRgba": () => (/* binding */ extractRgba),
/* harmony export */   "hexToRgb": () => (/* binding */ hexToRgb),
/* harmony export */   "hexToRgbaString": () => (/* binding */ hexToRgbaString),
/* harmony export */   "rgbToHex": () => (/* binding */ rgbToHex),
/* harmony export */   "rgbaFromRaw": () => (/* binding */ rgbaFromRaw),
/* harmony export */   "setRgbaAlpha": () => (/* binding */ setRgbaAlpha),
/* harmony export */   "shadeColor": () => (/* binding */ shadeColor)
/* harmony export */ });
/**
 * Shades a color, `amt` is a percentage.
 *
 * `amt`: Negative values make the color lighter, while positive values make the color darker.
 */ function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var regexHexSingleDigit = /^#?([\da-fA-F])([\da-fA-F])([\da-fA-F])$/;
var regexHexDoubleDigit = /^#?([\da-fA-F]{2})([\da-fA-F]{2})([\da-fA-F]{2})$/;
var regexRgb = /^rgb\(\d+,\s?\d+,\s?\d+\)$/;
var regexRgba = /^rgba\(\d+,\s?\d+,\s?\d+,\s?(1|0?\.\d+)\)$/;
var clamp0to255 = function(x) {
    return Math.min(255, Math.max(0, x));
};
var shadeColor = function(color, amt) {
    var hex = rgbToHex(color);
    var num = parseInt(hex.slice(1), 16);
    var R = (num >> 16) + amt; // eslint-disable-line no-bitwise
    var G = (num >> 8 & 0x00ff) + amt; // eslint-disable-line no-bitwise
    var B = (num & 0x0000ff) + amt; // eslint-disable-line no-bitwise
    var nR = clamp0to255(R) * 0x10000;
    var nG = clamp0to255(G) * 0x100;
    var nB = clamp0to255(B);
    return "#".concat((0x1000000 + nR + nG + nB // eslint-disable-line no-nested-ternary
    ).toString(16).slice(1));
};
var hexToRgb = function() {
    var memo = {};
    return function(hex) {
        if (memo[hex]) {
            return memo[hex];
        }
        var res = {
            r: 0,
            g: 0,
            b: 0
        };
        var matches = regexHexSingleDigit.exec(hex) || regexHexDoubleDigit.exec(hex);
        if (!matches || matches.length !== 4) {
            memo[hex] = res;
            return res;
        }
        var r = parseInt(matches[1], 16);
        var g = parseInt(matches[2], 16);
        var b = parseInt(matches[3], 16);
        res = {
            r: r,
            g: g,
            b: b
        };
        memo[hex] = res;
        return res;
    };
}();
var rgbToHex = function() {
    var memo = {};
    return function(rgb) {
        if (memo[rgb]) {
            return "#".concat(memo[rgb]);
        }
        var res = extractRgba(rgb).map(function(v) {
            return v.toString(16);
        }).map(function(v) {
            return v.length === 1 ? "0".concat(v) : v;
        }).slice(0, -1).join("");
        memo[rgb] = res;
        return "#".concat(res);
    };
}();
var hexToRgbaString = function(hex) {
    var alpha = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    if (hex === "transparent") {
        return hex;
    }
    var r = hexToRgb(hex);
    return "rgba(".concat(r.r, ", ").concat(r.g, ", ").concat(r.b, ", ").concat(alpha, ")");
};
var extractRgba = function(colorStr) {
    if (colorStr === "transparent") {
        return [
            0,
            0,
            0,
            0
        ];
    }
    if (regexHexSingleDigit.test(colorStr) || regexHexDoubleDigit.test(colorStr)) {
        var rgb = hexToRgb(colorStr);
        return [
            rgb.r,
            rgb.g,
            rgb.b,
            1
        ];
    }
    if (regexRgb.test(colorStr) || regexRgba.test(colorStr)) {
        var rgb1 = colorStr.match(/[\d.]+/g).map(function(v) {
            return /^\d+\.\d+$/.test(v) ? parseFloat(v) : parseInt(v, 10);
        });
        return rgb1.length === 3 ? rgb1.concat([
            1
        ]) : rgb1;
    }
    return [
        0,
        0,
        0,
        0
    ];
};
var blendColors = function(color1, color2, amount) {
    var alpha = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1.0;
    var rgb1 = extractRgba(color1);
    var rgb2 = extractRgba(color2);
    var newRgb = [
        (1 - amount) * rgb1[0] + amount * rgb2[0],
        (1 - amount) * rgb1[1] + amount * rgb2[1],
        (1 - amount) * rgb1[2] + amount * rgb2[2]
    ];
    return "rgba(".concat(newRgb.join(","), ",").concat(alpha, ")");
};
var blendHexColors = blendColors;
var setRgbaAlpha = function(color, newAlpha) {
    var rgba = extractRgba(color);
    return "rgba(".concat(rgba[0], ", ").concat(rgba[1], ", ").concat(rgba[2], ", ").concat(newAlpha, ")");
};
var rgbaFromRaw = function(rgbaColor) {
    var overrides = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var newColor = _objectSpread({}, rgbaColor, overrides);
    return "rgba(".concat(newColor.r, ", ").concat(newColor.g, ", ").concat(newColor.b, ", ").concat(newColor.a, ")");
};


/***/ }),

/***/ 11093:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": () => (/* binding */ pixelCalc),
/* harmony export */   "AV": () => (/* binding */ breakpoints),
/* harmony export */   "BC": () => (/* binding */ media),
/* harmony export */   "D2": () => (/* binding */ brandColors),
/* harmony export */   "O9": () => (/* binding */ colors),
/* harmony export */   "PS": () => (/* binding */ breakpointNames),
/* harmony export */   "bK": () => (/* binding */ layout),
/* harmony export */   "m4": () => (/* binding */ ratingStarColors),
/* harmony export */   "vR": () => (/* binding */ remCalc)
/* harmony export */ });
/* unused harmony exports campaignColors, extraMedia */
/* harmony import */ var _prisjakt_design_tokens_light_theme_colors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24774);
/* harmony import */ var _prisjakt_design_tokens_measurements__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70416);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71993);
/* harmony import */ var _src_color_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55318);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      @media ",
        " {\n        ",
        ";\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var BASE_FONT_SIZE = parseInt(_prisjakt_design_tokens_measurements__WEBPACK_IMPORTED_MODULE_1__.root, 10);
var PADDING_WRAPPER = 20;
var MARGIN_TOP_SUB_COMPONENT = 30;
var MARGIN_BOTTOM_SUB_COMPONENT = 30;
var GLOBAL_WIDTH = 1000;
// Transforms a pixel value to rem
// round to 5 digits to match Foundation rem-calc
function remCalc(pixelSize) {
    var remSize = pixelSize / BASE_FONT_SIZE;
    return "".concat(remSize.toFixed(5), "rem");
}
// Transforms a rem value to pixel (without px unit)
function pixelCalc(remSize) {
    return parseFloat(remSize) * BASE_FONT_SIZE;
}
var colors = {
    backgroundDarkGray: (0,_src_color_utils__WEBPACK_IMPORTED_MODULE_3__.setRgbaAlpha)(_prisjakt_design_tokens_light_theme_colors__WEBPACK_IMPORTED_MODULE_0__.base800, "0.05"),
    backgroundLightGray: "rgba(0, 0, 0, 0.06)",
    borderDarkGray: "rgba(0, 0, 0, 0.85);",
    borderLightGray: "rgba(0, 0, 0, 0.09);",
    lightTheme: _prisjakt_design_tokens_light_theme_colors__WEBPACK_IMPORTED_MODULE_0__
};
var campaignColors = {
    blackFriday: {
        id: 2,
        background: "#000",
        text: _prisjakt_design_tokens_light_theme_colors__WEBPACK_IMPORTED_MODULE_0__.base0
    },
    christmasSale: {
        id: 3,
        background: "#B70016",
        text: _prisjakt_design_tokens_light_theme_colors__WEBPACK_IMPORTED_MODULE_0__.base0
    },
    dailyDeals: {
        id: 4,
        background: "#9B051A",
        text: _prisjakt_design_tokens_light_theme_colors__WEBPACK_IMPORTED_MODULE_0__.base0
    },
    cyberMonday: {
        id: 6,
        background: "#5AA546",
        text: _prisjakt_design_tokens_light_theme_colors__WEBPACK_IMPORTED_MODULE_0__.base0
    },
    blackFridayWeekend: {
        id: 7,
        background: "#000",
        text: _prisjakt_design_tokens_light_theme_colors__WEBPACK_IMPORTED_MODULE_0__.base0
    },
    januarySale: {
        id: 12,
        background: "#4895B6",
        text: _prisjakt_design_tokens_light_theme_colors__WEBPACK_IMPORTED_MODULE_0__.base0
    }
};
var brandColors = {
    twitter: "#00ACED",
    facebook: "#3B5998",
    pricespy: "#4895B6",
    expert: _prisjakt_design_tokens_light_theme_colors__WEBPACK_IMPORTED_MODULE_0__.maybeBlue500
};
var ratingStarColors = {
    inactive: _prisjakt_design_tokens_light_theme_colors__WEBPACK_IMPORTED_MODULE_0__.base300,
    active: _prisjakt_design_tokens_light_theme_colors__WEBPACK_IMPORTED_MODULE_0__.yellove500
};
var layoutMap = {
    measurements: _prisjakt_design_tokens_measurements__WEBPACK_IMPORTED_MODULE_1__,
    fontSizes: {
        base: {
            mobile: {
                value: parseInt(_prisjakt_design_tokens_measurements__WEBPACK_IMPORTED_MODULE_1__.fontSizeNormal, 10),
                rem: _prisjakt_design_tokens_measurements__WEBPACK_IMPORTED_MODULE_1__.fontSizeNormal
            },
            desktop: {
                value: parseInt(_prisjakt_design_tokens_measurements__WEBPACK_IMPORTED_MODULE_1__.fontSizeNormal, 10),
                rem: _prisjakt_design_tokens_measurements__WEBPACK_IMPORTED_MODULE_1__.fontSizeNormal
            }
        },
        small: {
            mobile: {
                value: parseInt(_prisjakt_design_tokens_measurements__WEBPACK_IMPORTED_MODULE_1__.fontSizeSmall, 10),
                rem: _prisjakt_design_tokens_measurements__WEBPACK_IMPORTED_MODULE_1__.fontSizeSmall
            },
            desktop: {
                value: parseInt(_prisjakt_design_tokens_measurements__WEBPACK_IMPORTED_MODULE_1__.fontSizeSmall, 10),
                rem: _prisjakt_design_tokens_measurements__WEBPACK_IMPORTED_MODULE_1__.fontSizeSmall
            }
        },
        h1: {
            desktop: {
                value: 64,
                rem: remCalc(64)
            },
            mobile: {
                value: 36,
                rem: remCalc(36)
            }
        },
        h2: {
            desktop: {
                value: 24,
                rem: remCalc(24)
            },
            mobile: {
                value: 20,
                rem: remCalc(20)
            }
        },
        h3: {
            desktop: {
                value: 18,
                rem: remCalc(18)
            },
            mobile: {
                value: 18,
                rem: remCalc(18)
            }
        },
        h4: {
            desktop: {
                value: 17,
                rem: remCalc(17)
            },
            mobile: {
                value: 17,
                rem: remCalc(17)
            }
        },
        h5: {
            desktop: {
                value: 17,
                rem: remCalc(17)
            },
            mobile: {
                value: 17,
                rem: remCalc(17)
            }
        },
        h6: {
            desktop: {
                value: 16,
                rem: remCalc(16)
            },
            mobile: {
                value: 16,
                rem: remCalc(16)
            }
        }
    },
    margins: {
        wrapper: {
            mobile: {
                value: 12,
                rem: remCalc(12)
            },
            desktop: {
                value: 10,
                rem: remCalc(10)
            }
        },
        component: {
            mobile: {
                value: 20,
                rem: remCalc(20)
            },
            desktop: {
                value: 30,
                rem: remCalc(30)
            }
        }
    },
    headerHeight: {
        desktop: {
            value: 72,
            rem: remCalc(72)
        },
        mobile: {
            value: 48,
            rem: remCalc(48)
        },
        mobileWithSearch: {
            value: 101,
            rem: remCalc(101)
        }
    },
    fontFamily: "Mulish, Helvetica Neue, Helvetica, Arial, Roboto, sans-serif",
    sidebarContentWidth: {
        desktop: {
            value: 304,
            rem: remCalc(304)
        }
    },
    sidebarMenuWidth: {
        desktop: {
            value: 56,
            rem: remCalc(56)
        }
    },
    pageContent: {
        gutter: {
            value: 10,
            rem: remCalc(10)
        },
        maxWidth: {
            value: 1300,
            rem: remCalc(1300)
        }
    },
    siteWidth: {
        value: GLOBAL_WIDTH,
        rem: remCalc(GLOBAL_WIDTH)
    },
    borderRadius: "5px",
    lineHeight: 1.5,
    stickyNavigationHeight: {
        value: 50,
        rem: remCalc(50)
    },
    dragAndDropHandleSize: {
        mobile: {
            value: 32,
            rem: remCalc(32)
        },
        desktop: {
            value: 16,
            rem: remCalc(16)
        }
    },
    pageContentMaxWidthVal: 1300,
    pageContentGutterVal: 10,
    // Ad layout
    takeOverTopMargin: "120px",
    takeOverWidth: "1600px",
    takeOverHeight: "900px",
    outsiderMinWidth: "200px",
    listSideMargin: "0.6rem",
    listSidePadding: "0.6rem",
    listSideHeight: "2.6rem",
    // Product card
    productCardMinWidthMobile: "146px",
    productCardMinWidth: "200px",
    productCardMaxWidth: "255px",
    productCardImageSize: "130px",
    productCardPaddingSmall: _prisjakt_design_tokens_measurements__WEBPACK_IMPORTED_MODULE_1__.spacing025,
    productCardPaddingLarge: _prisjakt_design_tokens_measurements__WEBPACK_IMPORTED_MODULE_1__.spacing100,
    pageNotFound: {
        maxWidth: "750px"
    },
    // Foundation grid
    gridColumnGutter: {
        small: {
            value: 25,
            rem: remCalc(25)
        },
        large: {
            value: PADDING_WRAPPER,
            rem: remCalc(PADDING_WRAPPER)
        }
    },
    // Search
    searchBar: {
        height: {
            desktop: {
                value: 40,
                rem: remCalc(40)
            },
            mobile: {
                value: 35,
                rem: remCalc(35)
            }
        },
        borderWidth: 1
    },
    animations: {
        buttonTransition: "150ms ease"
    }
};
var layoutMapDeprecated = {
    paddingWrapperVal: PADDING_WRAPPER,
    paddingWrapper: remCalc(PADDING_WRAPPER),
    marginTopSubComponentVal: MARGIN_TOP_SUB_COMPONENT,
    marginTopSubComponent: remCalc(MARGIN_TOP_SUB_COMPONENT),
    marginBottomSubComponentVal: MARGIN_BOTTOM_SUB_COMPONENT,
    marginBottomSubComponent: remCalc(MARGIN_BOTTOM_SUB_COMPONENT)
};
var fullLayoutMap = _objectSpread({}, layoutMapDeprecated, layoutMap);
var layout =  false ? 0 : fullLayoutMap;
// Foundation breakpoints
var breakpointNames = [
    "small",
    "medium",
    "large",
    "xlarge",
    "xxlarge"
];
// Force each breakpoint to provide Up|Only|Down matchers
// 1em ≙ 16px
var breakpoints = {
    smallUp: "screen",
    smallOnly: "screen and (max-width: 39.9375em)",
    smallDown: "screen and (max-width: 39.9375em)",
    mediumUp: "screen and (min-width: 40em)",
    mediumOnly: "screen and (max-width: 63.9375em) and (min-width: 40em)",
    mediumDown: "screen and (max-width: 63.9375em)",
    largeUp: "screen and (min-width: 64em)",
    largeOnly: "screen and (max-width: 89.9375em) and (min-width: 64em)",
    largeDown: "screen and (max-width: 89.9375emem)",
    xlargeUp: "screen and (min-width: 90em)",
    xlargeOnly: "screen and (max-width: 104.9375em) and  (min-width: 90em) ",
    xlargeDown: "screen and (max-width: 104.9375em)",
    xxlargeUp: "screen and (min-width: 105em)",
    xxlargeOnly: "screen and (min-width: 105em)",
    xxlargeDown: "screen"
};
var extraMedia = {
    hideOutsiderAd: "screen and (max-width: 1199px)",
    showOutsiderAd: "screen and (min-width: 1200px)"
};
var media = Object.entries(_objectSpread({}, breakpoints, extraMedia)).reduce(function(accumulator, param) {
    var _param = _slicedToArray(param, 2), key = _param[0], value = _param[1];
    return _objectSpreadProps(_objectSpread({}, accumulator), _defineProperty({}, key, function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject(), value, styled_components__WEBPACK_IMPORTED_MODULE_2__.css.apply(void 0, _toConsumableArray(args)));
    }));
}, {});


/***/ }),

/***/ 45183:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": () => (/* binding */ Breadcrumbs)
/* harmony export */ });
/* harmony import */ var src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58912);
/* harmony import */ var _prisjakt_ui_breadcrumbs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40727);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50959);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3616);
/* harmony import */ var _app_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18026);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





var LinkWithTracking = function(props) {
    var onClick = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        (0,src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_0__/* .trackInternalNavigationClick */ .p)(props.tracking);
    }, [
        props.tracking
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(react_router_dom__WEBPACK_IMPORTED_MODULE_3__/* .Link */ .rU, _extends({
        onClick: onClick
    }, props));
};
var Breadcrumbs = function(param) {
    var crumbs = param.crumbs, _lastItemClickable = param.lastItemClickable, lastItemClickable = _lastItemClickable === void 0 ? false : _lastItemClickable;
    var t = (0,_app_context__WEBPACK_IMPORTED_MODULE_4__/* .useAppContext */ .bp)().t;
    var links = [
        {
            href: "/",
            title: t("common", "breadcrumb.home")
        }
    ].concat(_toConsumableArray(crumbs));
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_prisjakt_ui_breadcrumbs__WEBPACK_IMPORTED_MODULE_1__/* .Breadcrumbs */ .O, {
        lastItemClickable: lastItemClickable
    }, links.map(function(param, index) {
        var href = param.href, title = param.title;
        return href ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement(LinkWithTracking, {
            to: href,
            key: href,
            tracking: {
                scope: src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_0__/* .InternalNavigationScope.BREADCRUMB */ .U.BREADCRUMB,
                nextPage: href,
                index: index
            }
        }, title) : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createElement("span", {
            key: title
        }, title);
    }));
};


/***/ }),

/***/ 38828:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": () => (/* binding */ button_Button)
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-tools@1.7.2/node_modules/styled-tools/dist/es/index.js + 7 modules
var es = __webpack_require__(55703);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
;// CONCATENATED MODULE: ./src/components/button/styles.ts
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n        color: ",
        ";\n        background: ",
        ";\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n        border-radius: 100%;\n        padding: 0;\n        height: ",
        "px;\n        width: ",
        "px;\n        &:focus,\n        &:hover {\n          background: ",
        ";\n        }\n\n        &:active {\n          background: transparent;\n        }\n\n        svg {\n          transform: ",
        ";\n          path {\n            fill: ",
        ";\n          }\n        }\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n        border-radius: 100%;\n        padding: 0;\n        height: ",
        ";\n        width: ",
        ";\n        background: ",
        ";\n        svg {\n          transform: scale(",
        ");\n          path {\n            fill: ",
        ";\n          }\n        }\n        &:focus,\n        &:hover,\n        &:active {\n          background: ",
        ";\n          svg {\n            path {\n              fill: ",
        ";\n            }\n          }\n        }\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n        background: ",
        ";\n        color: ",
        ";\n        white-space: normal;\n\n        &:focus,\n        &:hover {\n          background: ",
        ";\n          color: ",
        ";\n        }\n\n        &:active {\n          background: transparent;\n          color: ",
        ";\n        }\n      "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n        background: transparent;\n        border: ",
        ";\n        border-color: ",
        ";\n\n        color: ",
        ";\n\n        &:focus,\n        &:hover {\n          background: ",
        ";\n          border-color: ",
        ";\n          color: ",
        ";\n        }\n\n        &:active {\n          background: transparent;\n        }\n      "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    border-radius: 4px;\n    font-weight: 600;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    vertical-align: middle;\n    white-space: nowrap;\n\n    font-size: ",
        ";\n    padding: ",
        ";\n\n    svg {\n      transform: ",
        ";\n      path {\n        fill: currentColor;\n      }\n    }\n\n    cursor: ",
        ";\n    pointer-events: ",
        ";\n    opacity: ",
        ";\n    transition:\n      background ",
        ",\n      color ",
        ";\n\n    &:hover,\n    &:focus {\n      background: ",
        ";\n      color: ",
        ";\n    }\n\n    &:active {\n      background: ",
        ";\n    }\n\n    /* Reset non-button elements like links <a role=\"button\" /> */\n    &[type='button'] {\n      appearance: none;\n      outline: none;\n    }\n\n    ",
        "\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n      display: inline;\n      text-align: center;\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      margin-bottom: ",
        ";\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n      margin-top: ",
        ";\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n      margin-right: ",
        ";\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n      margin-left: ",
        ";\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: ",
        "px;\n  height: ",
        "px;\n  font-size: ",
        "px;\n\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}




var buttonColors = function(theme) {
    return {
        primary: {
            text: theme.buttons.primary.text,
            hoverText: theme.buttons.primary.textHover,
            background: theme.buttons.primary.bg,
            hoverBackground: base/* colorUtils.shadeColor */.$n.shadeColor(theme.buttons.primary.bg, -20),
            activeBackground: theme.buttons.primary.bgActive,
            iconFill: theme.buttons.primary.bg
        },
        secondary: {
            text: theme.buttons.secondary.text,
            hoverText: theme.buttons.secondary.textHover,
            background: theme.buttons.secondary.bg,
            hoverBackground: base/* colorUtils.shadeColor */.$n.shadeColor(theme.buttons.secondary.bg, -20),
            iconFill: theme.buttons.secondary.bg
        },
        tertiary: {
            text: theme.buttons.tertiary.text,
            hoverText: theme.buttons.tertiary.textHover,
            background: theme.buttons.tertiary.bg,
            hoverBackground: base/* colorUtils.shadeColor */.$n.shadeColor(theme.buttons.tertiary.bg, -20),
            iconFill: theme.buttons.tertiary.bg
        },
        quarternary: {
            text: theme.buttons.quarternary.text,
            hoverText: theme.buttons.quarternary.textHover,
            background: theme.buttons.quarternary.bg,
            hoverBackground: base/* colorUtils.shadeColor */.$n.shadeColor(theme.buttons.quarternary.bg, 40),
            iconFill: theme.buttons.quarternary.bg
        },
        positive: {
            text: theme.buttons.positive.text,
            hoverText: theme.buttons.positive.textHover,
            background: theme.buttons.positive.bg,
            hoverBackground: base/* colorUtils.shadeColor */.$n.shadeColor(theme.buttons.positive.bg, -20),
            iconFill: theme.buttons.positive.bg
        },
        negative: {
            text: theme.buttons.negative.text,
            hoverText: theme.buttons.negative.textHover,
            background: theme.buttons.negative.bg,
            hoverBackground: base/* colorUtils.shadeColor */.$n.shadeColor(theme.buttons.negative.bg, -20),
            iconFill: theme.buttons.negative.bg
        },
        link: {
            text: theme.buttons.link.text,
            hoverText: theme.buttons.link.textHover,
            background: theme.buttons.link.bg,
            hoverBackground: theme.buttons.link.bg,
            iconFill: theme.buttons.link.text
        },
        disabled: {
            text: theme.buttons.disabled.text,
            hoverText: theme.buttons.disabled.textHover,
            background: theme.buttons.disabled.bg,
            hoverBackground: theme.buttons.disabled.bg,
            iconFill: theme.buttons.disabled.bg
        }
    };
};
var fontSize = {
    small: base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall,
    medium: base/* layout.measurements.fontSizeNormal */.bK.measurements.fontSizeNormal,
    large: base/* layout.measurements.fontSizeLarge */.bK.measurements.fontSizeLarge
};
var iconSize = {
    small: 19,
    medium: 24,
    large: 29
};
var padding = {
    small: "6px 10px",
    medium: "8px 20px",
    large: "8px 20px"
};
// Cloning allows us to dynamically render an element based on its props
// For example: We render <a /> if we pass `href` to the component
// Only forwarding `rest` to the cloned element stops the Unknown Prop warnings
// in the test suites. Should be replaced by `shouldForwardProp` when this
// feature lands in Styled Components.
var Button = (0,styled_components_browser_esm["default"])(function(_param) {
    var component = _param.component, isLink = _param.isLink, scaleIcon = _param.scaleIcon, iconPosition = _param.iconPosition, $active = _param.$active, rest = _objectWithoutProperties(_param, [
        "component",
        "isLink",
        "scaleIcon",
        "iconPosition",
        "$active"
    ]);
    return (0,react.cloneElement)(component, rest);
}).withConfig({
    displayName: "Button",
    componentId: "sc-0-0"
})(function(param) {
    var color = param.color, disabled = param.disabled, size = param.size, theme = param.theme, $active = param.$active, scaleIcon = param.scaleIcon;
    return (0,styled_components_browser_esm.css)(_templateObject5(), fontSize[size], padding[size], scaleIcon ? "scale(".concat(iconSize[size] / iconSize.medium, ")") : "none", disabled ? "default" : "pointer", disabled ? "none" : "inherit", disabled ? "0.5" : "1", base/* layout.animations.buttonTransition */.bK.animations.buttonTransition, base/* layout.animations.buttonTransition */.bK.animations.buttonTransition, buttonColors(theme)[color].hoverBackground, buttonColors(theme)[color].hoverText, buttonColors(theme)[color].background, (0,es/* switchProp */.db)("variant", {
        default: (0,styled_components_browser_esm.css)(_templateObject(), buttonColors(theme)[color].text, buttonColors(theme)[color].background),
        icon: (0,styled_components_browser_esm.css)(_templateObject1(), iconSize[size] + 10, iconSize[size] + 10, base/* colorUtils.setRgbaAlpha */.$n.setRgbaAlpha(buttonColors(theme)[color].iconFill, "0.2"), scaleIcon ? "scale(".concat(iconSize[size] / iconSize.medium, ")") : "none", buttonColors(theme)[color].iconFill),
        iconOutlined: (0,styled_components_browser_esm.css)(_templateObject2(), iconSize[size] + 10, iconSize[size] + 10, $active ? base/* colorUtils.setRgbaAlpha */.$n.setRgbaAlpha(buttonColors(theme)[color].iconFill, "0.2") : theme.colors.base100, iconSize[size] / iconSize.medium, $active ? buttonColors(theme)[color].iconFill : theme.colors.base500, base/* colorUtils.setRgbaAlpha */.$n.setRgbaAlpha(buttonColors(theme)[color].iconFill, "0.2"), buttonColors(theme)[color].iconFill),
        text: (0,styled_components_browser_esm.css)(_templateObject3(), $active && buttonColors(theme)[color].activeBackground || "transparent", // eslint-disable-next-line no-nested-ternary
        disabled ? buttonColors(theme).disabled.background : color === "link" ? buttonColors(theme).link.text : buttonColors(theme)[color].background, $active && buttonColors(theme)[color].activeBackground || "transparent", base/* colorUtils.setRgbaAlpha */.$n.setRgbaAlpha(color === "link" ? buttonColors(theme).link.text : buttonColors(theme)[color].background, "0.7"), buttonColors(theme).link.text),
        outlined: (0,styled_components_browser_esm.css)(_templateObject4(), color === "link" ? 0 : "solid 1px", disabled ? buttonColors(theme).disabled.background : buttonColors(theme)[color].background, // eslint-disable-next-line no-nested-ternary
        disabled ? buttonColors(theme).disabled.background : color === "link" ? buttonColors(theme).link.text : buttonColors(theme)[color].background, color === "link" ? buttonColors(theme).link.background : base/* colorUtils.setRgbaAlpha */.$n.setRgbaAlpha(buttonColors(theme)[color].background, "0.2"), buttonColors(theme)[color].background, color === "link" ? buttonColors(theme).link.hoverText : buttonColors(theme)[color].background)
    }));
});
var Inner = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Inner",
    componentId: "sc-0-1"
})(function(param) {
    var variant = param.variant, truncate = param.truncate;
    return [
        {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            lineHeight: "1.75",
            width: "100%"
        },
        variant !== "icon" && (0,es/* switchProp */.db)("iconPosition", {
            top: {
                flexDirection: "column"
            },
            bottom: {
                flexDirection: "column"
            },
            left: {
                flexDirection: "row"
            },
            right: {
                flexDirection: "row"
            }
        }),
        truncate && (0,styled_components_browser_esm.css)(_templateObject6())
    ];
});
var IconWrapper = styled_components_browser_esm["default"].span.withConfig({
    displayName: "IconWrapper",
    componentId: "sc-0-2"
})(_templateObject11(), function(p) {
    return iconSize[p.size];
}, function(p) {
    return iconSize[p.size];
}, function(p) {
    return iconSize[p.size];
}, (0,es/* switchProp */.db)("iconPosition", {
    top: (0,styled_components_browser_esm.css)(_templateObject7(), function(p) {
        return p.noMargin ? 0 : "5px";
    }),
    bottom: (0,styled_components_browser_esm.css)(_templateObject8(), function(p) {
        return p.noMargin ? 0 : "5px";
    }),
    left: (0,styled_components_browser_esm.css)(_templateObject9(), function(p) {
        return p.noMargin ? 0 : "5px";
    }),
    right: (0,styled_components_browser_esm.css)(_templateObject10(), function(p) {
        return p.noMargin ? 0 : "5px";
    })
}));

;// CONCATENATED MODULE: ./src/components/button/index.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function button_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = button_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function button_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var renderChildrenWithIcon = function(iconPosition, icon, children, size) {
    switch(iconPosition){
        case "bottom":
        case "right":
            return /*#__PURE__*/ react.createElement(react.Fragment, null, children, icon && /*#__PURE__*/ react.createElement(IconWrapper, {
                iconPosition: iconPosition,
                size: size
            }, icon));
        default:
            return /*#__PURE__*/ react.createElement(react.Fragment, null, icon && /*#__PURE__*/ react.createElement(IconWrapper, {
                iconPosition: iconPosition,
                size: size
            }, icon), children);
    }
};
/**
 * @deprecated Use Button from `@prisjakt/ui` instead. Whenever possible replace existing usage so that this can be removed
 */ var button_Button = function(props) {
    var component = props.component, children = props.children, className = props.className, style = props.style, disabled = props.disabled, iconPosition = props.iconPosition, icon = props.icon, iconOutlined = props.iconOutlined, onClick = props.onClick, tabIndex = props.tabIndex, href = props.href, variant = props.variant, size = props.size, color = props.color, ariaLabel = props.ariaLabel, type = props.type, truncate = props.truncate, title = props.title, active = props.active, scaleIcon = props.scaleIcon, dataTest = props["data-test"], dataTestId = props["data-testid"], anchorProps = button_objectWithoutProperties(props, [
        "component",
        "children",
        "className",
        "style",
        "disabled",
        "iconPosition",
        "icon",
        "iconOutlined",
        "onClick",
        "tabIndex",
        "href",
        "variant",
        "size",
        "color",
        "ariaLabel",
        "type",
        "truncate",
        "title",
        "active",
        "scaleIcon",
        "data-test",
        "data-testid"
    ]);
    return /*#__PURE__*/ react.createElement(Button, {
        component: // eslint-disable-next-line jsx-a11y/anchor-has-content, jsx-a11y/control-has-associated-label
        href ? /*#__PURE__*/ react.createElement("a", _extends({
            href: href
        }, anchorProps)) : component,
        type: type,
        "aria-label": ariaLabel,
        isLink: !!href || color === "link",
        onClick: onClick,
        iconPosition: iconPosition,
        variant: variant,
        size: size,
        className: className,
        style: style,
        tabIndex: disabled ? "-1" : tabIndex,
        disabled: disabled,
        color: color,
        "data-test": dataTest,
        "data-testid": dataTestId,
        title: title,
        $active: active,
        scaleIcon: scaleIcon
    }, /*#__PURE__*/ react.createElement(Inner, {
        variant: variant,
        iconPosition: iconPosition,
        truncate: truncate
    }, [
        "icon",
        "iconOutlined"
    ].includes(variant) ? icon && /*#__PURE__*/ react.createElement(IconWrapper, {
        noMargin: react.Children.count(children) <= 1,
        iconPosition: iconPosition,
        size: size
    }, variant === "iconOutlined" && iconOutlined && !active ? iconOutlined : icon) : renderChildrenWithIcon(iconPosition, icon, children, size)));
};
button_Button.defaultProps = {
    children: null,
    className: undefined,
    type: "button",
    style: undefined,
    disabled: false,
    tabIndex: "0",
    onClick: undefined,
    icon: undefined,
    iconOutlined: undefined,
    href: undefined,
    iconPosition: "left",
    size: "medium",
    variant: "default",
    color: "secondary",
    ariaLabel: undefined,
    component: /*#__PURE__*/ react.createElement("button", {
        type: "button"
    }),
    truncate: false,
    "data-test": undefined,
    "data-testid": undefined,
    title: "",
    active: undefined,
    scaleIcon: true
};
/* harmony default export */ const components_button = ((/* unused pure expression or super */ null && (button_Button)));


/***/ }),

/***/ 27347:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ promo_banner)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./src/components/app-context/link-to.ts
var link_to = __webpack_require__(73199);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/arrow-right/index.js
var arrow_right = __webpack_require__(86401);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(71016);
;// CONCATENATED MODULE: ./src/components/campaign-banners/promo-banner/utils.ts
var ICON_SIZE = 40;
var getLogoUrl = function(market) {
    return {
        "1x": "".concat(market.cdn, "/g/campaigns/4/banner_logo_").concat(ICON_SIZE, ".png"),
        "2x": "".concat(market.cdn, "/g/campaigns/4/banner_logo_").concat(ICON_SIZE * 2, ".png")
    };
};

// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
;// CONCATENATED MODULE: ./src/components/campaign-banners/promo-banner/styles.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      border-radius: 0;\n      margin-top: 0;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      padding-left: calc(",
        " + ",
        "px);\n      background-image: image-set(\n        url(",
        ") 1x,\n        url(",
        ") 2x\n      );\n      background-position-y: 50%;\n      background-position-x: ",
        ";\n      background-repeat: no-repeat;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      border: 2px solid ",
        ";\n      background-color: ",
        ";\n      color: ",
        ";\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    min-height: 56px;\n    display: flex;\n    justify-content: space-between;\n    flex-direction: row;\n    align-items: center;\n    padding: ",
        ";\n    margin: ",
        " 0;\n    border-radius: 8px;\n    background-color: ",
        ";\n\n    ",
        "\n\n    ",
        "\n\n  ",
        "\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 0;\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n    line-height: 20px;\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: normal;\n\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}





var StyledBanner = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "StyledBanner",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject3(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, props.$themeColor || "transparent", base/* media.mediumDown */.BC.mediumDown(_templateObject()), props.$logo && (0,styled_components_browser_esm.css)(_templateObject1(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, ICON_SIZE, props.$logo["1x"], props.$logo["2x"], base/* layout.measurements.spacing050 */.bK.measurements.spacing050), props.$inverted && (0,styled_components_browser_esm.css)(_templateObject2(), props.$themeColor || props.theme.lines.primary, props.theme.bg.primary, props.$themeColor || props.theme.text.primary));
});
var StyledH4Text = (0,styled_components_browser_esm["default"])(variants.H4Text).withConfig({
    displayName: "StyledH4Text",
    componentId: "sc-0-1"
})(_templateObject5(), base/* media.smallOnly */.BC.smallOnly(_templateObject4()));
var StyledDivider = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledDivider",
    componentId: "sc-0-2"
})(_templateObject7(), base/* media.smallOnly */.BC.smallOnly(_templateObject6()));
var StyledText = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledText",
    componentId: "sc-0-3"
})(_templateObject8(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledTagline = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledTagline",
    componentId: "sc-0-4"
})(_templateObject10(), base/* media.smallOnly */.BC.smallOnly(_templateObject9()));
var StyledLinkText = (0,styled_components_browser_esm["default"])(variants.TitleSmallText).withConfig({
    displayName: "StyledLinkText",
    componentId: "sc-0-5"
})(_templateObject12(), base/* media.smallOnly */.BC.smallOnly(_templateObject11()));

// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(58912);
;// CONCATENATED MODULE: ./src/components/campaign-banners/promo-banner/index.tsx








var PromoBanner = function(props) {
    var ref, ref1;
    var banners = props.banners, className = props.className, _inverted = props.inverted, inverted = _inverted === void 0 ? false : _inverted, linkParams = props.linkParams;
    var market = (0,app_context/* useAppContext */.bp)().market;
    if (!(banners === null || banners === void 0 ? void 0 : banners.length)) return null;
    // TODO: render banner based on priority
    var activeBanner = banners[0];
    var options = activeBanner.options || {};
    var customLink = options.customLink && options.customLink.url;
    var path = customLink && linkParams ? (0,link_to/* withQueryString */.pS)(customLink, linkParams) : customLink;
    var tagline = (ref = options.tagline) === null || ref === void 0 ? void 0 : ref.text;
    var linkText = (ref1 = options.customLink) === null || ref1 === void 0 ? void 0 : ref1.text;
    var color = options.fallbackColor || "#000";
    var logo = options.showLogo ? getLogoUrl(market) : undefined;
    var fontColor = inverted ? variants.FontColor.DARK : variants.FontColor.LIGHT;
    if (!path) {
        return null;
    }
    var onClick = function() {
        return (0,tracking/* trackInternalNavigationClick */.p)({
            nextPage: path,
            scope: tracking/* InternalNavigationScope.BANNER */.U.BANNER
        });
    };
    return /*#__PURE__*/ react.createElement(StyledBanner, {
        className: className,
        to: path,
        onClick: onClick,
        $logo: logo,
        $themeColor: color,
        $inverted: inverted
    }, /*#__PURE__*/ react.createElement(StyledH4Text, {
        color: fontColor
    }, "Black Friday", " ", tagline && /*#__PURE__*/ react.createElement(StyledTagline, null, /*#__PURE__*/ react.createElement(StyledDivider, null, "-"), " ", tagline)), /*#__PURE__*/ react.createElement(StyledText, null, linkText && /*#__PURE__*/ react.createElement(StyledLinkText, {
        color: fontColor
    }, linkText), /*#__PURE__*/ react.createElement(arrow_right/* IconArrowRight */.E, {
        color: inverted ? "base900" : "base100",
        size: 22
    })));
};
/* harmony default export */ const promo_banner = (PromoBanner);


/***/ }),

/***/ 71897:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23114);

var CampaignDealsLoader = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "secondary-content";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | secondary-content */ 88).then(__webpack_require__.bind(__webpack_require__, 37918));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(37918);
        }
        return eval("require.resolve")("./campaign-deals");
    }
});
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CampaignDealsLoader);


/***/ }),

/***/ 22556:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": () => (/* binding */ useCarouselContext),
/* harmony export */   "L": () => (/* binding */ CarouselContextContainer)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);

var initialValue = {
    backgroundColor: undefined,
    dataTestType: undefined,
    items: undefined,
    linkPath: undefined,
    linkTitle: undefined,
    negativeMargin: undefined,
    onHeaderLinkClick: undefined,
    onCardClick: undefined,
    productsInCarousel: undefined,
    removeProductsWithNoImage: undefined,
    shouldLazyLoadImages: undefined,
    showCreateAlertButton: undefined,
    showLinkAsButton: undefined,
    subTitle: undefined,
    title: "",
    type: undefined
};
var CarouselContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(initialValue);
var useCarouselContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(CarouselContext);
};
var CarouselContextContainer = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CarouselContext.Provider, {
        value: props
    }, props.children);
};


/***/ }),

/***/ 59307:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": () => (/* binding */ CardsCarousel)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/info-outlined/index.js
var info_outlined = __webpack_require__(12525);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/panel/index.js
var panel = __webpack_require__(63073);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(71016);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/cards-carousel/carousel-context.tsx
var carousel_context = __webpack_require__(22556);
// EXTERNAL MODULE: ./src/ui/link/index.ts
var ui_link = __webpack_require__(59303);
// EXTERNAL MODULE: ./src/components/product-card/index.ts + 5 modules
var product_card = __webpack_require__(33409);
;// CONCATENATED MODULE: ./src/components/cards-carousel/carousel-deals-card/index.tsx


var CarouselDealsCard = /*#__PURE__*/ (0,react.memo)(function(param) {
    var product = param.product, index = param.index;
    return /*#__PURE__*/ react.createElement(product_card/* DealsProductCard */.N8, {
        key: product.productId,
        product: product,
        trackingIndex: index
    });
});

// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./src/components/product-card-old/product-card-context.tsx
var product_card_context = __webpack_require__(39728);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@5.2.1_react@18.2.0/node_modules/react-router/esm/react-router.js + 3 modules
var react_router = __webpack_require__(14727);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 24 modules
var es = __webpack_require__(95939);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/notification-filled/index.js
var notification_filled = __webpack_require__(35451);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/notification-outlined/index.js
var notification_outlined = __webpack_require__(72523);
// EXTERNAL MODULE: ./src/areas/sidebar/actions/alert.js
var actions_alert = __webpack_require__(83846);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
;// CONCATENATED MODULE: ./src/components/new-product-releases/components/alert-button/styles.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-around;\n\n  button {\n    display: flex;\n    line-height: 20px;\n    color: ",
        ";\n    margin: 20px 0;\n    padding: 10px 20px;\n    border-radius: 4px;\n    border: 1px solid ",
        ";\n    cursor: pointer;\n  }\n\n  svg {\n    fill: ",
        ";\n    width: 20px !important;\n    height: 20px !important;\n    margin-right: 5px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var AlertButton = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AlertButton",
    componentId: "sc-0-0"
})(_templateObject(), function(p) {
    return p.theme.icons.tertiary;
}, function(p) {
    return p.theme.lines.tertiary;
}, function(p) {
    return p.theme.icons.tertiary;
});

;// CONCATENATED MODULE: ./src/components/new-product-releases/components/alert-button/index.js









var alert_button_AlertButton = function(props) {
    var linkTo = (0,react.useContext)(app_context/* AppContext */.Il).linkTo;
    var product = props.product, account = props.account, userProductAlerts = props.userProductAlerts, createAlertRequest = props.createAlertRequest, removeAlertRequest = props.removeAlertRequest, text = props.text, type = props.type, history = props.history;
    var isAuthenticated = (account || {}).isAuthenticated;
    var userAlert = userProductAlerts.find(function(alert) {
        return alert.productId === product.id;
    });
    var alertId = userAlert && userAlert.alertId;
    return /*#__PURE__*/ react.createElement(AlertButton, null, /*#__PURE__*/ react.createElement("button", {
        type: "button",
        onClick: function() {
            if (isAuthenticated) {
                if (!alertId) {
                    createAlertRequest({
                        productId: product.id,
                        type: type
                    });
                } else {
                    removeAlertRequest(alertId, product.id);
                }
            } else {
                history.push(linkTo("productAlert", product));
            }
        }
    }, alertId ? /*#__PURE__*/ react.createElement(notification_filled/* IconNotificationFilled */.Q, {
        color: "base400",
        size: 20
    }) : /*#__PURE__*/ react.createElement(notification_outlined/* IconNotificationOutlined */.F, {
        color: "base400",
        size: 20
    }), text));
};
alert_button_AlertButton.propTypes = {
    userProductAlerts: prop_types_default().arrayOf(prop_types_default().shape({
        productId: (prop_types_default()).number,
        alertId: (prop_types_default()).number
    })),
    account: prop_types_default().shape({
        isAuthenticated: (prop_types_default()).bool
    }),
    product: prop_types_default().shape({
        alert: prop_types_default().shape({
            id: (prop_types_default()).number
        }),
        id: (prop_types_default()).number,
        pathName: (prop_types_default()).string
    }),
    createAlertRequest: (prop_types_default()).func.isRequired,
    removeAlertRequest: (prop_types_default()).func.isRequired,
    text: (prop_types_default()).string.isRequired,
    type: (prop_types_default()).string,
    history: (prop_types_default()).object.isRequired
};
alert_button_AlertButton.defaultProps = {
    account: {
        isAuthenticated: false
    },
    userProductAlerts: [],
    product: {},
    type: "IN_STOCK"
};
var dispatchActions = {
    createAlertRequest: actions_alert/* createAlertRequest */.$b,
    removeAlertRequest: actions_alert/* removeAlertRequest */.s$
};
/* harmony default export */ const alert_button = ((0,es/* connect */.$j)(function(state) {
    return {
        account: state.areas.account,
        userProductAlerts: state.areas.sidebar.alerts.products
    };
}, dispatchActions)(/*#__PURE__*/ (0,react.memo)((0,react_router/* withRouter */.EN)(alert_button_AlertButton))));

// EXTERNAL MODULE: ./src/components/product-card-old/index.tsx + 24 modules
var product_card_old = __webpack_require__(62688);
;// CONCATENATED MODULE: ./src/components/cards-carousel/carousel-product-card/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var CarouselProductCard = /*#__PURE__*/ (0,react.memo)(function(props) {
    var ref;
    var index = props.index, onCardClick = props.onCardClick, product = props.product, _shouldLazyLoadImages = props.shouldLazyLoadImages, shouldLazyLoadImages = _shouldLazyLoadImages === void 0 ? true : _shouldLazyLoadImages, showCreateAlertButton = props.showCreateAlertButton;
    var ref1 = (0,app_context/* useAppContext */.bp)(), t = ref1.t, linkTo = ref1.linkTo, market = ref1.market;
    return /*#__PURE__*/ react.createElement(product_card_context/* ProductCardContextContainer */.h, {
        key: product.id,
        background: true,
        diffPercentage: ((ref = product.price) === null || ref === void 0 ? void 0 : ref.diffPercentage) || product.diffPercentage,
        FooterArea: showCreateAlertButton ? /*#__PURE__*/ react.createElement(alert_button, {
            product: product,
            text: t("product", "alert.create-button"),
            type: "PRICE_DROPS"
        }) : null,
        hasExpertBadge: product.isExpertTopRated,
        onClick: function() {
            onCardClick === null || onCardClick === void 0 ? void 0 : onCardClick({
                index: index,
                link: "".concat(market.domain).concat(product.pathName),
                productId: product.id
            });
        },
        product: _objectSpreadProps(_objectSpread({}, product), {
            pathName: linkTo("product", product)
        }),
        shouldLazyLoadImage: shouldLazyLoadImages
    }, /*#__PURE__*/ react.createElement(product_card_old/* ProductGridCard */.r4, null));
});

// EXTERNAL MODULE: ./src/components/article-card/index.tsx + 1 modules
var article_card = __webpack_require__(8172);
// EXTERNAL MODULE: ./src/areas/expert/components/card-image/index.tsx
var card_image = __webpack_require__(11347);
// EXTERNAL MODULE: ./src/areas/product/components/carousel-products/components/partner-video-carousel/components/partner-video-modal/index.tsx + 1 modules
var partner_video_modal = __webpack_require__(17512);
// EXTERNAL MODULE: ./src/components/youtube-icon/index.tsx + 1 modules
var youtube_icon = __webpack_require__(77973);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/index.js
var design_tokens = __webpack_require__(43220);
;// CONCATENATED MODULE: ./src/components/cards-carousel/carousel-video-card/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  bottom: ",
        ";\n  left: ",
        ";\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var StyledYoutubeIcon = (0,styled_components_browser_esm["default"])(youtube_icon/* YoutubeIcon */.L).withConfig({
    displayName: "StyledYoutubeIcon",
    componentId: "sc-0-0"
})(styles_templateObject(), design_tokens.measurements.spacing025, design_tokens.measurements.spacing050);

;// CONCATENATED MODULE: ./src/components/cards-carousel/carousel-video-card/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}






var CarouselVideoCard = /*#__PURE__*/ (0,react.memo)(function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var item = props.item;
    var onCardClick = (0,carousel_context/* useCarouselContext */.G)().onCardClick;
    var ref7 = _slicedToArray((0,react.useState)(false), 2), isPartnerVideoModalOpen = ref7[0], setIsPartnerVideoModalOpen = ref7[1];
    if (!((ref = item.previewImage) === null || ref === void 0 ? void 0 : (ref1 = ref.large) === null || ref1 === void 0 ? void 0 : ref1.url) || !item.videoId) return null;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(partner_video_modal/* PartnerVideoModal */.o, {
        closeModal: function() {
            return setIsPartnerVideoModalOpen(false);
        },
        isOpen: isPartnerVideoModalOpen,
        thumbnail: item.previewImage.large.url,
        title: item.title,
        videoId: item.videoId
    }), /*#__PURE__*/ react.createElement(article_card/* ArticleCard */.T, {
        pretitle: {
            name: ((ref2 = item.author) === null || ref2 === void 0 ? void 0 : ref2.name) || "",
            image: (ref3 = item.author) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.avatar) === null || ref4 === void 0 ? void 0 : ref4.url
        },
        titleAndCategory: item.title,
        media: ((ref5 = item.previewImage) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.small) === null || ref6 === void 0 ? void 0 : ref6.url) && /*#__PURE__*/ react.createElement(card_image/* default */.Z, {
            src: item.previewImage.small.url,
            height: 150
        }),
        icon: /*#__PURE__*/ react.createElement(StyledYoutubeIcon, null),
        onClick: function() {
            if (onCardClick) onCardClick({
                link: item.videoUrl || "",
                index: 0,
                productId: 0
            });
            setIsPartnerVideoModalOpen(true);
        }
    }));
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/list/variants.js
var list_variants = __webpack_require__(35967);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
// EXTERNAL MODULE: ./src/components/button/index.tsx + 1 modules
var components_button = __webpack_require__(38828);
// EXTERNAL MODULE: ./src/components/horizontal-scroll/variants/medium-card-horizontal-scroll.tsx
var medium_card_horizontal_scroll = __webpack_require__(19184);
// EXTERNAL MODULE: ./src/components/cards-carousel/types.ts
var types = __webpack_require__(75782);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon-interactive/index.js
var icon_interactive = __webpack_require__(28148);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/popover/index.js
var popover = __webpack_require__(22448);
;// CONCATENATED MODULE: ./src/components/cards-carousel/styles.ts
function cards_carousel_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function cards_carousel_styles_templateObject() {
    var data = cards_carousel_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  gap: ",
        ";\n"
    ]);
    cards_carousel_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = cards_carousel_styles_taggedTemplateLiteral([
        "\n        padding: ",
        " ",
        ";\n        margin-right: -",
        ";\n        margin-left: -",
        ";\n        border-radius: 0;\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = cards_carousel_styles_taggedTemplateLiteral([
        "\n      border-radius: ",
        ";\n      padding: ",
        ";\n\n      ",
        "\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = cards_carousel_styles_taggedTemplateLiteral([
        "\n      background: ",
        ";\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = cards_carousel_styles_taggedTemplateLiteral([
        "\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = cards_carousel_styles_taggedTemplateLiteral([
        "\n      margin: 0;\n      flex-direction: column;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = cards_carousel_styles_taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = cards_carousel_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = cards_carousel_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-self: center;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = cards_carousel_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  position: relative;\n  z-index: 105;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = cards_carousel_styles_taggedTemplateLiteral([
        "\n  cursor: initial;\n  user-select: text;\n  height: 115px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = cards_carousel_styles_taggedTemplateLiteral([
        "\n          width: calc(",
        " - (",
        " / 2));\n        "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = cards_carousel_styles_taggedTemplateLiteral([
        "\n      li > * {\n        ",
        "\n      }\n    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = cards_carousel_styles_taggedTemplateLiteral([
        "\n    cursor: pointer;\n    ",
        "\n  "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}









var PANEL_BACKGROUND_PADDING = base/* layout.measurements.spacing100 */.bK.measurements.spacing100;
var FlexColumn = (0,styled_components_browser_esm["default"])(list_variants.Column).withConfig({
    displayName: "FlexColumn",
    componentId: "sc-0-0"
})(cards_carousel_styles_templateObject(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var StyledPanel = (0,styled_components_browser_esm["default"])(panel/* Panel */.s_).withConfig({
    displayName: "StyledPanel",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject4(), props.$backgroundColor && (0,styled_components_browser_esm.css)(_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, PANEL_BACKGROUND_PADDING, base/* media.smallOnly */.BC.smallOnly(_templateObject1(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050)), props.$backgroundColor === types/* CarouselBackgroundColorsEnum.GREY */.Z.GREY && (0,styled_components_browser_esm.css)(_templateObject3(), props.theme.colors.base200));
});
var StyledPanelHeader = (0,styled_components_browser_esm["default"])(panel/* PanelHeader */.V9).withConfig({
    displayName: "StyledPanelHeader",
    componentId: "sc-0-2"
})(_templateObject6(), base/* media.smallOnly */.BC.smallOnly(_templateObject5()));
var CallToActionButton = (0,styled_components_browser_esm["default"])(components_button/* Button */.z).attrs({
    color: "primary",
    variant: "outlined"
}).withConfig({
    displayName: "CallToActionButton",
    componentId: "sc-0-3"
})(_templateObject7(), function(p) {
    return p.theme.text.callToAction;
});
var StyledInteractiveIconTooltip = (0,styled_components_browser_esm["default"])(icon_interactive/* InteractiveIcon */.z).withConfig({
    displayName: "StyledInteractiveIconTooltip",
    componentId: "sc-0-4"
})(_templateObject8());
var StyledPopoverWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledPopoverWrapper",
    componentId: "sc-0-5"
})(_templateObject9());
var StyledPopover = (0,styled_components_browser_esm["default"])(popover/* Popover */.J2).withConfig({
    displayName: "StyledPopover",
    componentId: "sc-0-6"
})(_templateObject10());
var StyledMediumCardHorizontalScroll = (0,styled_components_browser_esm["default"])(medium_card_horizontal_scroll/* MediumCardHorizontalScroll */._).withConfig({
    displayName: "StyledMediumCardHorizontalScroll",
    componentId: "sc-0-7"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject13(), props.$hasBackground && (0,styled_components_browser_esm.css)(_templateObject12(), base/* media.mediumUp */.BC.mediumUp(_templateObject11(), medium_card_horizontal_scroll/* CARD_WIDTH_DESKTOP */.J, PANEL_BACKGROUND_PADDING)));
});

;// CONCATENATED MODULE: ./src/components/cards-carousel/index.tsx
function cards_carousel_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function cards_carousel_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function cards_carousel_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function cards_carousel_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function cards_carousel_slicedToArray(arr, i) {
    return cards_carousel_arrayWithHoles(arr) || cards_carousel_iterableToArrayLimit(arr, i) || cards_carousel_unsupportedIterableToArray(arr, i) || cards_carousel_nonIterableRest();
}
function cards_carousel_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return cards_carousel_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return cards_carousel_arrayLikeToArray(o, minLen);
}














var HeaderLink = function() {
    var ref = (0,carousel_context/* useCarouselContext */.G)(), linkPath = ref.linkPath, linkTitle = ref.linkTitle, onHeaderLinkClick = ref.onHeaderLinkClick, showLinkAsButton = ref.showLinkAsButton;
    if (!linkTitle || !linkPath) return null;
    return showLinkAsButton ? /*#__PURE__*/ react.createElement(CallToActionButton, {
        component: /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
            to: linkPath
        })
    }, linkTitle) : /*#__PURE__*/ react.createElement(ui_link/* InternalLink */.h, {
        to: linkPath,
        onClick: function() {
            onHeaderLinkClick === null || onHeaderLinkClick === void 0 ? void 0 : onHeaderLinkClick({
                link: linkPath
            });
        }
    }, /*#__PURE__*/ react.createElement(variants.TitleMediumText, {
        color: variants.FontColor.PRIMARY
    }, linkTitle));
};
var CardsCarousel = function(props) {
    var ref = (0,carousel_context/* useCarouselContext */.G)(), backgroundColor = ref.backgroundColor, dataTestType = ref.dataTestType, items = ref.items, negativeMargin = ref.negativeMargin, onCardClick = ref.onCardClick, _productsInCarousel = ref.productsInCarousel, productsInCarousel = _productsInCarousel === void 0 ? 12 : _productsInCarousel, _removeProductsWithNoImage = ref.removeProductsWithNoImage, removeProductsWithNoImage = _removeProductsWithNoImage === void 0 ? true : _removeProductsWithNoImage, _shouldLazyLoadImages = ref.shouldLazyLoadImages, shouldLazyLoadImages = _shouldLazyLoadImages === void 0 ? true : _shouldLazyLoadImages, showCreateAlertButton = ref.showCreateAlertButton, subTitle = ref.subTitle, title = ref.title, _type = ref.type, type = _type === void 0 ? types/* CardTypeEnum.PRODUCT_CARD */.m.PRODUCT_CARD : _type;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref1 = cards_carousel_slicedToArray((0,react.useState)(false), 2), showPopover = ref1[0], setShowPopover = ref1[1];
    var getCards = function() {
        switch(type){
            case types/* CardTypeEnum.VIDEO_CARD */.m.VIDEO_CARD:
                return items === null || items === void 0 ? void 0 : items.map(function(item) {
                    return /*#__PURE__*/ react.createElement(CarouselVideoCard, {
                        item: item,
                        key: item.videoId
                    });
                }).slice(0, productsInCarousel);
            case types/* CardTypeEnum.DEALS_CARD */.m.DEALS_CARD:
                return items.filter(function(p) {
                    if (!removeProductsWithNoImage) return p;
                    return (p === null || p === void 0 ? void 0 : p.logo) !== undefined;
                }).map(function(product, index) {
                    return /*#__PURE__*/ react.createElement(CarouselDealsCard, {
                        key: product.productId,
                        index: index,
                        product: product
                    });
                }).slice(0, productsInCarousel);
            default:
                return items.filter(function(p) {
                    var ref;
                    if (!removeProductsWithNoImage) return p;
                    return (p === null || p === void 0 ? void 0 : (ref = p.media) === null || ref === void 0 ? void 0 : ref.first) !== undefined;
                }).map(function(product, index) {
                    return /*#__PURE__*/ react.createElement(CarouselProductCard, {
                        key: product.id,
                        index: index,
                        onCardClick: onCardClick,
                        product: product,
                        shouldLazyLoadImages: shouldLazyLoadImages,
                        showCreateAlertButton: showCreateAlertButton
                    });
                }).slice(0, productsInCarousel);
        }
    };
    if (!items || !items.length) return null;
    return /*#__PURE__*/ react.createElement(StyledPanel, {
        className: props.className,
        containerProps: dataTestType ? {
            "data-test": "Panel",
            "data-test-type": dataTestType
        } : "",
        $backgroundColor: backgroundColor
    }, /*#__PURE__*/ react.createElement(StyledPanelHeader, null, /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(FlexColumn, null, /*#__PURE__*/ react.createElement(panel/* PanelTitle */.pY, null, title), type === types/* CardTypeEnum.DEALS_CARD */.m.DEALS_CARD && /*#__PURE__*/ react.createElement(StyledPopoverWrapper, null, /*#__PURE__*/ react.createElement(StyledInteractiveIconTooltip, {
        icon: info_outlined/* IconInfoOutlined */.e,
        size: 20,
        onClick: function() {
            return setShowPopover(true);
        }
    }), /*#__PURE__*/ react.createElement(StyledPopover, {
        id: "popover-carousel-deals-info-icon",
        visible: showPopover,
        width: 290,
        onClose: function() {
            return setTimeout(function() {
                return setShowPopover(false);
            });
        },
        horizontalAlign: popover/* Alignment.End */.v2.End,
        verticalAlign: popover/* Alignment.StartOutside */.v2.StartOutside
    }, /*#__PURE__*/ react.createElement(variants.BodySmallText, {
        color: variants.FontColor.DARK
    }, t("campaigns", "campaign.deals-info-icon"))))), subTitle && /*#__PURE__*/ react.createElement(variants.CaptionText, null, subTitle)), /*#__PURE__*/ react.createElement(HeaderLink, null)), /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(StyledMediumCardHorizontalScroll, {
        loadingHeight: 140,
        negativeMargin: negativeMargin,
        $hasBackground: Boolean(backgroundColor)
    }, getCards())));
};


/***/ }),

/***/ 75782:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ CarouselBackgroundColorsEnum),
/* harmony export */   "m": () => (/* binding */ CardTypeEnum)
/* harmony export */ });
var CardTypeEnum;
(function(CardTypeEnum) {
    CardTypeEnum["PRODUCT_CARD"] = "product-card";
    CardTypeEnum["VIDEO_CARD"] = "video-card";
    CardTypeEnum["DEALS_CARD"] = "deals-card";
})(CardTypeEnum || (CardTypeEnum = {}));
var CarouselBackgroundColorsEnum;
(function(CarouselBackgroundColorsEnum) {
    CarouselBackgroundColorsEnum["GREY"] = "grey";
})(CarouselBackgroundColorsEnum || (CarouselBackgroundColorsEnum = {}));


/***/ }),

/***/ 23437:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": () => (/* binding */ CdnImage)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18026);
/* harmony import */ var src_areas_store_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70320);



var getFolderName = function(name) {
    return name.toString().slice(-1);
};
var getShopUrl = function(cdnUrl, name, width) {
    return width === src_areas_store_constants__WEBPACK_IMPORTED_MODULE_2__/* .SHOP_LOGO_WIDTH */ .L9 ? "".concat(cdnUrl, "g/ftg_logos/sizes/").concat(src_areas_store_constants__WEBPACK_IMPORTED_MODULE_2__/* .SHOP_LOGO_WIDTH */ .L9, "/").concat(getFolderName(name), "/").concat(name, ".png") : "".concat(cdnUrl, "g/ftg_logos/store_").concat(name, ".png");
};
var getBrandUrl = function(cdnUrl, name) {
    return "".concat(cdnUrl, "g/ftg_logos/brand_sizes/").concat(src_areas_store_constants__WEBPACK_IMPORTED_MODULE_2__/* .SHOP_LOGO_WIDTH */ .L9, "/").concat(getFolderName(name), "/").concat(name, ".png");
};
var makeImageUrl = function(cdnUrl, name, logoType, width) {
    return logoType === "shop" ? getShopUrl(cdnUrl, name, width) : getBrandUrl(cdnUrl, name);
};
var CdnImage = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(function(param) {
    var className = param.className, name = param.name, alt = param.alt, logoUrl = param.logoUrl, width = param.width, height = param.height, _logoType = param.logoType, logoType = _logoType === void 0 ? "shop" : _logoType;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_1__/* .AppContext */ .Il), _market = ref.market, _imageCdnUrl = _market.imageCdnUrl, imageCdnUrl = _imageCdnUrl === void 0 ? "" : _imageCdnUrl;
    var imageUrl = logoUrl !== null && logoUrl !== void 0 ? logoUrl : makeImageUrl(imageCdnUrl, name, logoType, width);
    var styles = {};
    if (height) {
        styles.height = height;
    }
    return(// @ts-expect-error picture is typed as HTMLElement which does not have alt attribute
    /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("picture", {
        alt: alt,
        className: className
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", {
        srcSet: imageUrl,
        type: "image/png"
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
        src: imageUrl,
        alt: alt,
        width: width,
        style: styles
    })));
});


/***/ }),

/***/ 38689:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": () => (/* binding */ Clickable)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
;// CONCATENATED MODULE: ./src/components/clickable/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  font: inherit;\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var styles = (0,styled_components_browser_esm.css)(_templateObject());
var Button = styled_components_browser_esm["default"].button.attrs({
    type: "button"
}).withConfig({
    displayName: "Button",
    componentId: "sc-0-0"
})(_templateObject1(), styles);
var InternalLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "InternalLink",
    componentId: "sc-0-1"
})(_templateObject2(), styles);
var ExternalLink = styled_components_browser_esm["default"].a.withConfig({
    displayName: "ExternalLink",
    componentId: "sc-0-2"
})(_templateObject3(), styles);

;// CONCATENATED MODULE: ./src/components/clickable/index.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var Clickable = function(_param) {
    var to = _param.to, isExternal = _param.isExternal, disabled = _param.disabled, containerProps = _param.containerProps, props = _objectWithoutProperties(_param, [
        "to",
        "isExternal",
        "disabled",
        "containerProps"
    ]);
    if (!to) {
        return /*#__PURE__*/ react.createElement(Button, _extends({
            disabled: disabled
        }, props, containerProps));
    }
    return isExternal || disabled ? /*#__PURE__*/ react.createElement(ExternalLink, _extends({
        href: disabled ? undefined : to
    }, props, containerProps)) : /*#__PURE__*/ react.createElement(InternalLink, _extends({
        to: to
    }, props, containerProps, {
        "data-test": props["data-test"] || "InternalLink"
    }));
};


/***/ }),

/***/ 45766:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": () => (/* binding */ CO_BRANDING_BANNER_LOCALSTORAGE_STATE_KEY)
/* harmony export */ });
var CO_BRANDING_BANNER_LOCALSTORAGE_STATE_KEY = "pj:coBrandingBanner";


/***/ }),

/***/ 61034:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var acceptCookies = function(version, privacySettings, isLoggedIn, showSuccessPrompt) {
    return {
        type: "ACCEPT_COOKIES",
        version: version,
        privacySettings: privacySettings,
        isLoggedIn: isLoggedIn,
        showSuccessPrompt: showSuccessPrompt
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (acceptCookies);


/***/ }),

/***/ 63198:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": () => (/* binding */ cookie_banner),
  "k3": () => (/* binding */ privacySettingAllRejected)
});

// UNUSED EXPORTS: privacySettingAllAccepted

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 24 modules
var es = __webpack_require__(95939);
// EXTERNAL MODULE: ./config/dist/markets/types.js
var types = __webpack_require__(83109);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./src/components/cookie-banner/actions/index.ts
var actions = __webpack_require__(61034);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/modal/index.js
var modal = __webpack_require__(58709);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(7336);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/measurements.js
var measurements = __webpack_require__(70416);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
;// CONCATENATED MODULE: ./src/components/cookie-banner/components/schibsted-logo.tsx


var SchibstedLogo = function(param) {
    var className = param.className;
    var market = (0,app_context/* useAppContext */.bp)().market;
    var logoSrc = "".concat(market.cdn, "/g/rfe/logos/schibsted/schibsted_dust_black.png");
    return /*#__PURE__*/ react.createElement("img", {
        className: className,
        src: logoSrc,
        alt: "Schibsted",
        width: "110",
        height: "20"
    });
};

// EXTERNAL MODULE: ./src/components/logo/index.tsx
var logo = __webpack_require__(8589);
;// CONCATENATED MODULE: ./src/components/cookie-banner/components/welcome/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 0 auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  width: 150px;\n  height: 40px;\n  margin: 0px auto;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var styles_SchibstedLogo = (0,styled_components_browser_esm["default"])(SchibstedLogo).withConfig({
    displayName: "SchibstedLogo",
    componentId: "sc-0-0"
})(_templateObject());
var Body = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Body",
    componentId: "sc-0-1"
})(_templateObject1(), measurements.spacing100, measurements.spacing100);
var PjCookieBannerLogo = (0,styled_components_browser_esm["default"])(logo/* Logo */.T).withConfig({
    displayName: "PjCookieBannerLogo",
    componentId: "sc-0-2"
})(_templateObject2());

// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(38689);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/light-theme-colors.js
var light_theme_colors = __webpack_require__(24774);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var text_variants = __webpack_require__(71016);
;// CONCATENATED MODULE: ./src/components/cookie-banner/components/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  &:hover,\n  :focus {\n    text-decoration: underline;\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  text-align: center;\n  color: ",
        ";\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var ButtonLikeLink = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "ButtonLikeLink",
    componentId: "sc-0-0"
})(styles_templateObject(), light_theme_colors.maybeBlue500);
var CoBrandingText = (0,styled_components_browser_esm["default"])(text_variants.BodySmallText).withConfig({
    displayName: "CoBrandingText",
    componentId: "sc-0-1"
})(styles_templateObject1(), light_theme_colors.base500);
var ActionButtons = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ActionButtons",
    componentId: "sc-0-2"
})(styles_templateObject2(), measurements.spacing100);

;// CONCATENATED MODULE: ./src/components/cookie-banner/components/welcome/welcome.tsx







var Welcome = function(param) {
    var onAcceptClick = param.onAcceptClick, onRejectClick = param.onRejectClick, onPrivacySettingsClick = param.onPrivacySettingsClick, onCookiePolicyClick = param.onCookiePolicyClick;
    var ref = (0,app_context/* useAppContext */.bp)(), t = ref.t, market = ref.market;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(modal/* ModalBody */.fe, null, /*#__PURE__*/ react.createElement(Body, null, market.showSchibstedCoBranding ? /*#__PURE__*/ react.createElement(styles_SchibstedLogo, null) : /*#__PURE__*/ react.createElement(PjCookieBannerLogo, {
        market: market.code,
        companyName: t("meta", "market.logo-alt"),
        styling: "v2-dark"
    }), market.showSchibstedCoBranding && /*#__PURE__*/ react.createElement(CoBrandingText, null, t("tracking-settings", "co-branding.part-of", {
        companyName: t("meta", "company.name")
    })), /*#__PURE__*/ react.createElement(text_variants.BodyMediumText, null, t("common", "cookie-banner.description", {
        cookiePolicyLink: /*#__PURE__*/ react.createElement(ButtonLikeLink, {
            onClick: onCookiePolicyClick
        }, t("common", "cookie-banner.cookie-policy"))
    })))), /*#__PURE__*/ react.createElement(modal/* ModalFooter */.mz, null, /*#__PURE__*/ react.createElement(ActionButtons, {
        "data-test": "CookieBanner"
    }, /*#__PURE__*/ react.createElement(variants.PrimaryButton, {
        onClick: onAcceptClick,
        fullWidth: true,
        containerProps: {
            "data-test": "CookieBannerAcceptButton"
        }
    }, t("common", "cookie-banner.accept-button")), [
        "fr",
        "dk"
    ].includes(market.code) ? /*#__PURE__*/ react.createElement(variants.OutlinedButton, {
        onClick: onRejectClick,
        fullWidth: true
    }, t("common", "cookie-banner.reject-button")) : null, /*#__PURE__*/ react.createElement(variants.OutlinedButton, {
        onClick: onPrivacySettingsClick,
        fullWidth: true
    }, t("common", "cookie-banner.privacy-policy-settings")))));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/checkbox/variants.js
var checkbox_variants = __webpack_require__(14948);
// EXTERNAL MODULE: ./src/areas/user/actions/tracking.js
var tracking = __webpack_require__(69399);
;// CONCATENATED MODULE: ./src/components/cookie-banner/components/privacy-settings/use-tracking-settings.ts

function useTrackingSettings() {
    return (0,es/* useSelector */.v9)(function(state) {
        return state.areas.user.tracking.settings;
    });
}

;// CONCATENATED MODULE: ./src/components/cookie-banner/components/privacy-settings/styles.ts
function privacy_settings_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function privacy_settings_styles_templateObject() {
    var data = privacy_settings_styles_taggedTemplateLiteral([
        "\n  margin: 0 auto ",
        " auto;\n"
    ]);
    privacy_settings_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function privacy_settings_styles_templateObject1() {
    var data = privacy_settings_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    privacy_settings_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function privacy_settings_styles_templateObject2() {
    var data = privacy_settings_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  border: none;\n  border-bottom: 1px solid ",
        ";\n  margin: ",
        " 0;\n"
    ]);
    privacy_settings_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = privacy_settings_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = privacy_settings_styles_taggedTemplateLiteral([
        "\n  white-space: nowrap;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}






var privacy_settings_styles_SchibstedLogo = (0,styled_components_browser_esm["default"])(SchibstedLogo).withConfig({
    displayName: "SchibstedLogo",
    componentId: "sc-0-0"
})(privacy_settings_styles_templateObject(), measurements.spacing100);
var styles_Body = (0,styled_components_browser_esm["default"])(modal/* ModalBody */.fe).withConfig({
    displayName: "Body",
    componentId: "sc-0-1"
})(privacy_settings_styles_templateObject1(), measurements.spacing100);
var Divider = styled_components_browser_esm["default"].hr.withConfig({
    displayName: "Divider",
    componentId: "sc-0-2"
})(privacy_settings_styles_templateObject2(), light_theme_colors.base200, measurements.spacing100);
var CheckboxWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CheckboxWrapper",
    componentId: "sc-0-3"
})(_templateObject3());
var InfoTextButton = (0,styled_components_browser_esm["default"])(variants.TextButton).withConfig({
    displayName: "InfoTextButton",
    componentId: "sc-0-4"
})(_templateObject4());

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/chevron-down/index.js
var chevron_down = __webpack_require__(70796);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/chevron-up/index.js
var chevron_up = __webpack_require__(912);
;// CONCATENATED MODULE: ./src/components/cookie-banner/components/privacy-settings/privacy-settings-checkbox.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}










var PrivacySettingsCheckbox = function(param) {
    var type = param.type, disabled = param.disabled, checked = param.checked;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref = _slicedToArray((0,react.useState)(false), 2), infoTextOpen = ref[0], setInfoTextOpen = ref[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var settings = useTrackingSettings();
    return /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(CheckboxWrapper, null, /*#__PURE__*/ react.createElement(checkbox_variants/* CheckboxSwitch */.K_, {
        text: t("tracking-settings", "".concat(type, ".title")),
        name: type,
        disabled: disabled,
        onChange: function(e) {
            return dispatch(tracking/* default.trackingToggleChange */.ZP.trackingToggleChange(e.target.name, !settings[e.target.name]));
        },
        checked: checked !== undefined ? checked : settings[type]
    }), /*#__PURE__*/ react.createElement(InfoTextButton, {
        onClick: function() {
            return setInfoTextOpen(!infoTextOpen);
        }
    }, t("common", "button.read-more"), infoTextOpen ? /*#__PURE__*/ react.createElement(chevron_up.IconChevronUp, null) : /*#__PURE__*/ react.createElement(chevron_down/* IconChevronDown */.C, null))), infoTextOpen && /*#__PURE__*/ react.createElement(text_variants.BodySmallText, null, t("tracking-settings", "".concat(type, ".text"))));
};

// EXTERNAL MODULE: ./src/hooks/use-is-authenticated.ts
var use_is_authenticated = __webpack_require__(32990);
;// CONCATENATED MODULE: ./src/components/cookie-banner/components/privacy-settings/use-accept-cookies.ts




function useAcceptCookies() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var settings = useTrackingSettings();
    var isAuthenticated = (0,use_is_authenticated/* useIsAuthenticated */.k)();
    return function() {
        return dispatch((0,actions/* default */.Z)(settings.cookieVersion, settings, isAuthenticated, true));
    };
}

// EXTERNAL MODULE: ./src/hooks/useEffectOnMount.ts
var useEffectOnMount = __webpack_require__(53249);
;// CONCATENATED MODULE: ./src/components/cookie-banner/components/privacy-settings/use-pulse-env-id.ts
function use_pulse_env_id_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function use_pulse_env_id_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function use_pulse_env_id_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function use_pulse_env_id_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function use_pulse_env_id_slicedToArray(arr, i) {
    return use_pulse_env_id_arrayWithHoles(arr) || use_pulse_env_id_iterableToArrayLimit(arr, i) || use_pulse_env_id_unsupportedIterableToArray(arr, i) || use_pulse_env_id_nonIterableRest();
}
function use_pulse_env_id_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return use_pulse_env_id_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return use_pulse_env_id_arrayLikeToArray(o, minLen);
}


function usePulseEnvId() {
    var ref = use_pulse_env_id_slicedToArray((0,react.useState)(), 2), pulseEnvId = ref[0], setPulseEnvId = ref[1];
    (0,useEffectOnMount/* useEffectOnMount */.O)(function() {
        if (false) {}
        // @ts-expect-error -- Untyped
        if (typeof window.pulse !== "function") {
            return;
        }
        // @ts-expect-error -- Untyped
        window.pulse(function(sdk) {
            return sdk.getEnvironmentId().then(function(id) {
                return setPulseEnvId(id);
            });
        });
    });
    return pulseEnvId;
}

// EXTERNAL MODULE: ./src/ui/link/index.ts
var ui_link = __webpack_require__(59303);
;// CONCATENATED MODULE: ./src/components/cookie-banner/components/privacy-settings/privacy-settings.tsx













var PrivacySettings = function(param) {
    var onPrivacyPolicyClick = param.onPrivacyPolicyClick, onCookiePolicyClick = param.onCookiePolicyClick, onRejectClick = param.onRejectClick, onSave = param.onSave, onGoBack = param.onGoBack;
    var ref = (0,app_context/* useAppContext */.bp)(), market = ref.market, t = ref.t;
    var settings = useTrackingSettings();
    var acceptCookies = useAcceptCookies();
    var pulseEnvId = usePulseEnvId();
    var handleSave = function() {
        acceptCookies();
        onSave();
    };
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(styles_Body, null, market.showSchibstedCoBranding && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(privacy_settings_styles_SchibstedLogo, null), /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(text_variants.H3Text, {
        container: "h1"
    }, t("tracking-settings", "schibsted-ads.title")), /*#__PURE__*/ react.createElement(text_variants.BodyMediumText, null, t("tracking-settings", "schibsted-ads.text", {
        editAdPreferencesLink: /*#__PURE__*/ react.createElement(ui_link/* ExternalLink */.d, {
            id: "schibsted-ad-settings",
            href: "https://aboutme.schibsted.com/p/".concat(market.code, "/ads/").concat(pulseEnvId)
        }, t("tracking-settings", "schibsted-ads.edit-preferences-link")),
        adsReadMoreLink: /*#__PURE__*/ react.createElement(ui_link/* ExternalLink */.d, {
            href: "https://info.privacy.schibsted.com/".concat(market.code, "/s005/")
        }, t("tracking-settings", "schibsted-ads.read-more-link"))
    })))), /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(text_variants.H3Text, {
        container: "h1"
    }, t("tracking-settings", "personal-data.title")), /*#__PURE__*/ react.createElement(text_variants.BodyMediumText, null, t("tracking-settings", "personal-data.text", {
        cookiePolicyLink: /*#__PURE__*/ react.createElement(ButtonLikeLink, {
            onClick: onCookiePolicyClick
        }, t("common", "cookie-banner.cookie-policy")),
        privacyPolicyLink: /*#__PURE__*/ react.createElement(ButtonLikeLink, {
            onClick: onPrivacyPolicyClick
        }, t("common", "cookie-banner.privacy-policy"))
    }))), /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(PrivacySettingsCheckbox, {
        type: "necessary-data",
        disabled: true,
        checked: true
    }), /*#__PURE__*/ react.createElement(Divider, null), /*#__PURE__*/ react.createElement(PrivacySettingsCheckbox, {
        type: types.PrivacySettingToggle.BehaviourTrackingImprovement
    }), /*#__PURE__*/ react.createElement(Divider, null), /*#__PURE__*/ react.createElement(PrivacySettingsCheckbox, {
        type: types.PrivacySettingToggle.Personalization,
        disabled: !settings[types.PrivacySettingToggle.BehaviourTrackingImprovement]
    }), /*#__PURE__*/ react.createElement(Divider, null), /*#__PURE__*/ react.createElement(PrivacySettingsCheckbox, {
        type: types.PrivacySettingToggle.BehaviorTrackingSurveys
    }), /*#__PURE__*/ react.createElement(Divider, null), /*#__PURE__*/ react.createElement(PrivacySettingsCheckbox, {
        type: types.PrivacySettingToggle.BehaviorTrackingMarketing
    }))), /*#__PURE__*/ react.createElement(modal/* ModalFooter */.mz, null, /*#__PURE__*/ react.createElement(ActionButtons, null, /*#__PURE__*/ react.createElement(variants.PrimaryButton, {
        onClick: handleSave,
        fullWidth: true
    }, t("common", "button.save")), /*#__PURE__*/ react.createElement(variants.OutlinedButton, {
        onClick: onRejectClick,
        fullWidth: true
    }, t("common", "cookie-banner.reject-button")), /*#__PURE__*/ react.createElement(variants.OutlinedButton, {
        onClick: onGoBack,
        fullWidth: true
    }, t("common", "button.back")))));
};

// EXTERNAL MODULE: ./src/areas/info/components/page/index.js
var page = __webpack_require__(96644);
// EXTERNAL MODULE: ./src/areas/editorial-content/query.graphql
var query_graphql = __webpack_require__(81474);
var query_graphql_default = /*#__PURE__*/__webpack_require__.n(query_graphql);
// EXTERNAL MODULE: ./src/areas/info/query.graphql
var info_query_graphql = __webpack_require__(13278);
var info_query_graphql_default = /*#__PURE__*/__webpack_require__.n(info_query_graphql);
// EXTERNAL MODULE: ./src/hooks/use-gql-query.ts
var use_gql_query = __webpack_require__(63113);
// EXTERNAL MODULE: ./src/components/loader/index.tsx + 1 modules
var loader = __webpack_require__(30082);
// EXTERNAL MODULE: ./src/areas/editorial-content/components/slices/shared/color-map.ts
var color_map = __webpack_require__(35241);
// EXTERNAL MODULE: ./src/areas/editorial-content/components/slices/text/index.tsx
var slices_text = __webpack_require__(82072);
// EXTERNAL MODULE: ./src/areas/editorial-content/components/slices/text/styles.ts
var styles = __webpack_require__(23256);
;// CONCATENATED MODULE: ./src/components/cookie-banner/components/article/styles.ts
function article_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function article_styles_templateObject() {
    var data = article_styles_taggedTemplateLiteral([
        "\n  h1 {\n    font-size: 2rem;\n  }\n"
    ]);
    article_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function article_styles_templateObject1() {
    var data = article_styles_taggedTemplateLiteral([
        "\n  ",
        " {\n    padding: 0;\n  }\n  a {\n    color: ",
        ";\n\n    &:hover {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    article_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var InfoPageWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "InfoPageWrapper",
    componentId: "sc-0-0"
})(article_styles_templateObject());
var Slice = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Slice",
    componentId: "sc-0-1"
})(article_styles_templateObject1(), styles/* TextContainer */.l, light_theme_colors.maybeBlue700, light_theme_colors.maybeBlue500);

// EXTERNAL MODULE: ./src/areas/editorial-content/components/slices/hero/styles.ts
var hero_styles = __webpack_require__(29035);
;// CONCATENATED MODULE: ./src/components/cookie-banner/components/article/cookie-policy-prismic-article.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}





var CookiePolicyPrismicArticle = function(param) {
    var article = param.article;
    var renderSlice = function(slice, index) {
        var key = "".concat(slice.type, "_").concat(index);
        var backgroundColor = getBackgroundColor(slice.primary);
        var colors = (0,color_map/* default */.Z)(backgroundColor);
        switch(slice.primary.__typename){
            case "PrismicSliceHeroTitle":
                return /*#__PURE__*/ react.createElement(Hero, _extends({
                    key: key
                }, slice.primary, {
                    textColor: colors.text,
                    heroBackgroundColor: colors.bg
                }));
            case "PrismicSliceText":
                return /*#__PURE__*/ react.createElement(Slice, {
                    key: key
                }, /*#__PURE__*/ react.createElement(slices_text/* default */.Z, _extends({}, slice.primary)));
            default:
                return null;
        }
    };
    return /*#__PURE__*/ react.createElement("div", null, article.data.body.map(renderSlice));
};
var getBackgroundColor = function(primary) {
    if ("heroBackgroundColor" in primary && primary.heroBackgroundColor) {
        return primary.heroBackgroundColor;
    }
    if ("backgroundColor" in primary) {
        return primary.backgroundColor;
    }
    if ("textColor" in primary) {
        return primary.textColor;
    }
    return null;
};
var Hero = function(param) {
    var title = param.title, secondaryTitle = param.secondaryTitle;
    return /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(hero_styles/* TextContent */.D7, null, /*#__PURE__*/ react.createElement(hero_styles/* Title */.Dx, {
        data: title
    }), /*#__PURE__*/ react.createElement(hero_styles/* SubTitle */.DK, {
        data: secondaryTitle
    })));
};

;// CONCATENATED MODULE: ./src/components/cookie-banner/components/article/article.tsx











var InfoPageArticle = function(param) {
    var id = param.id;
    var ref;
    var ref1 = (0,use_gql_query/* useGqlQuery */.n)({
        queryKey: [
            "cookie_policy",
            "info_page"
        ],
        query: (info_query_graphql_default()),
        variables: {
            id: id
        }
    }), data = ref1.data, isLoading = ref1.isLoading;
    return isLoading ? /*#__PURE__*/ react.createElement(loader/* default */.Z, null) : /*#__PURE__*/ react.createElement(InfoPageWrapper, null, /*#__PURE__*/ react.createElement(page/* default */.Z, {
        body: data === null || data === void 0 ? void 0 : (ref = data.pageContent) === null || ref === void 0 ? void 0 : ref.body
    }));
};
var PrismicArticle = function(param) {
    var id = param.id;
    var ref = (0,use_gql_query/* useGqlQuery */.n)({
        queryKey: [
            "cookie_policy",
            "prismic"
        ],
        query: (query_graphql_default()),
        variables: {
            id: id
        }
    }), data = ref.data, isLoading = ref.isLoading;
    return isLoading ? /*#__PURE__*/ react.createElement(loader/* default */.Z, null) : /*#__PURE__*/ react.createElement(CookiePolicyPrismicArticle, {
        article: data === null || data === void 0 ? void 0 : data.prismicArticle
    });
};
var Article = function(param) {
    var onClose = param.onClose, id = param.id;
    var t = (0,app_context/* useAppContext */.bp)().t;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(modal/* ModalBody */.fe, null, /^\d+$/.test(id) ? /*#__PURE__*/ react.createElement(InfoPageArticle, {
        id: id
    }) : /*#__PURE__*/ react.createElement(PrismicArticle, {
        id: id
    })), /*#__PURE__*/ react.createElement(modal/* ModalFooter */.mz, null, /*#__PURE__*/ react.createElement(variants.PrimaryButton, {
        onClick: onClose,
        fullWidth: true
    }, t("common", "button.back"))));
};

;// CONCATENATED MODULE: ./src/components/cookie-banner/index.tsx
function cookie_banner_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function cookie_banner_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function cookie_banner_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function cookie_banner_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function cookie_banner_slicedToArray(arr, i) {
    return cookie_banner_arrayWithHoles(arr) || cookie_banner_iterableToArrayLimit(arr, i) || cookie_banner_unsupportedIterableToArray(arr, i) || cookie_banner_nonIterableRest();
}
function cookie_banner_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return cookie_banner_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return cookie_banner_arrayLikeToArray(o, minLen);
}









var APP_ROOT_ID = "root";
var MODAL_ROOT_ID = "root-modal";
var View;
(function(View) {
    View[View["PRIVACY_SETTINGS"] = 0] = "PRIVACY_SETTINGS";
    View[View["PRIVACY_POLICY"] = 1] = "PRIVACY_POLICY";
    View[View["COOKIE_POLICY"] = 2] = "COOKIE_POLICY";
    View[View["WELCOME"] = 3] = "WELCOME";
})(View || (View = {}));
var _obj;
var privacySettingAllRejected = (_obj = {}, _defineProperty(_obj, types.PrivacySettingToggle.BehaviorTrackingMarketing, false), _defineProperty(_obj, types.PrivacySettingToggle.BehaviorTrackingSurveys, false), _defineProperty(_obj, types.PrivacySettingToggle.BehaviourTrackingImprovement, false), _defineProperty(_obj, types.PrivacySettingToggle.PersonalizedAds, false), _defineProperty(_obj, types.PrivacySettingToggle.Personalization, false), _obj);
var _obj1;
var privacySettingAllAccepted = (_obj1 = {}, _defineProperty(_obj1, types.PrivacySettingToggle.BehaviorTrackingMarketing, true), _defineProperty(_obj1, types.PrivacySettingToggle.BehaviorTrackingSurveys, true), _defineProperty(_obj1, types.PrivacySettingToggle.BehaviourTrackingImprovement, true), _defineProperty(_obj1, types.PrivacySettingToggle.PersonalizedAds, true), _defineProperty(_obj1, types.PrivacySettingToggle.Personalization, true), _obj1);
var getCookie = function() {
    var nameEQ = "privacy_settings=";
    var ca = document.cookie.split(";");
    for(var i = 0; i < ca.length; i += 1){
        var c = ca[i];
        while(c.charAt(0) === " ")c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
};
var CookieBanner = function(param) {
    var acceptCookies = param.acceptCookies, rejectCookies = param.rejectCookies, settings = param.settings, isLoggedIn = param.isLoggedIn;
    var ref = cookie_banner_slicedToArray((0,react.useState)(false), 2), open = ref[0], setOpen = ref[1];
    var ref1 = cookie_banner_slicedToArray((0,react.useState)(View.WELCOME), 2), view = ref1[0], setView = ref1[1];
    var ref2 = (0,react.useContext)(app_context/* AppContext */.Il), renderMode = ref2.renderMode, market = ref2.market;
    (0,react.useEffect)(function() {
        setOpen(true);
    }, []);
    var privacySettings = market && market.privacySettings && (market.privacySettings[renderMode] || market.privacySettings.responsive);
    var onAcceptCookies = (0,react.useCallback)(function() {
        acceptCookies(privacySettings.cookieVersion, _objectSpread({}, settings, privacySettingAllAccepted), isLoggedIn);
        setOpen(false);
    }, [
        isLoggedIn,
        privacySettings,
        acceptCookies,
        settings
    ]);
    var onRejectCookies = (0,react.useCallback)(function() {
        rejectCookies(privacySettings.cookieVersion, _objectSpread({}, settings, privacySettingAllRejected), isLoggedIn);
        setOpen(false);
    }, [
        isLoggedIn,
        privacySettings,
        rejectCookies,
        settings
    ]);
    if (!open || renderMode === "native" || getCookie() !== null || (window === null || window === void 0 ? void 0 : window.IS_FLOOD_IO)) {
        return null;
    }
    var renderView = function() {
        switch(view){
            case View.PRIVACY_SETTINGS:
                {
                    return /*#__PURE__*/ react.createElement(PrivacySettings, {
                        onCookiePolicyClick: function() {
                            return setView(View.COOKIE_POLICY);
                        },
                        onPrivacyPolicyClick: function() {
                            return setView(View.PRIVACY_POLICY);
                        },
                        onRejectClick: onRejectCookies,
                        onSave: function() {
                            return setOpen(false);
                        },
                        onGoBack: function() {
                            return setView(View.WELCOME);
                        }
                    });
                }
            case View.PRIVACY_POLICY:
                {
                    var ref, ref1;
                    var id = (ref = market.privacySettings) === null || ref === void 0 ? void 0 : (ref1 = ref.responsive) === null || ref1 === void 0 ? void 0 : ref1.privacyArticleId;
                    return id ? /*#__PURE__*/ react.createElement(Article, {
                        onClose: function() {
                            return setView(View.WELCOME);
                        },
                        id: id
                    }) : null;
                }
            case View.COOKIE_POLICY:
                {
                    var ref2, ref3;
                    var id1 = (ref2 = market.privacySettings) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.responsive) === null || ref3 === void 0 ? void 0 : ref3.cookieArticleId;
                    return id1 ? /*#__PURE__*/ react.createElement(Article, {
                        onClose: function() {
                            return setView(View.WELCOME);
                        },
                        id: id1
                    }) : null;
                }
            default:
            case View.WELCOME:
                {
                    return /*#__PURE__*/ react.createElement(Welcome, {
                        onAcceptClick: onAcceptCookies,
                        onRejectClick: onRejectCookies,
                        onPrivacySettingsClick: function() {
                            return setView(View.PRIVACY_SETTINGS);
                        },
                        onCookiePolicyClick: function() {
                            return setView(View.COOKIE_POLICY);
                        }
                    });
                }
        }
    };
    return /*#__PURE__*/ react.createElement(modal/* Modal */.u_, {
        parentSelectorId: MODAL_ROOT_ID,
        rootId: APP_ROOT_ID,
        isOpen: open,
        size: modal/* ModalSizeEnum.SMALL */.E$.SMALL,
        shouldHaveCloseButton: false,
        style: {
            overlay: {
                zIndex: 1000
            }
        }
    }, renderView());
};
var mapStateToProps = function(state) {
    return {
        version: state.globals.cookieBanner.version,
        isActive: state.globals.cookieBanner.isActive,
        settings: state.areas.user.tracking.settings,
        isLoggedIn: state.areas.account.isAuthenticated
    };
};
var dispatchProps = {
    acceptCookies: actions/* default */.Z,
    rejectCookies: actions/* default */.Z
};
/* harmony default export */ const cookie_banner = ((0,es/* connect */.$j)(mapStateToProps, dispatchProps)(CookieBanner));


/***/ }),

/***/ 72154:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": () => (/* reexport */ country_flag_CountryFlag)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/index.js
var ui = __webpack_require__(54262);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/tooltip/index.js
var tooltip = __webpack_require__(714);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
;// CONCATENATED MODULE: ./src/components/country-flag/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      max-width: ",
        "px;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    margin: 2px;\n\n    ",
        "\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    font-size: 10px;\n    color: ",
        ";\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var Image = styled_components_browser_esm["default"].img.withConfig({
    displayName: "Image",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject1(), props.size && (0,styled_components_browser_esm.css)(_templateObject(), props.size));
});
var CountryFlag = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CountryFlag",
    componentId: "sc-0-1"
})(_templateObject2());
var Text = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Text",
    componentId: "sc-0-2"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject3(), props.theme.text.tertiary);
});

;// CONCATENATED MODULE: ./src/components/country-flag/country-flag.tsx




var SIZE = 16;
var country_flag_CountryFlag = function(param) {
    var className = param.className, countryCode = param.countryCode, altText = param.altText, title = param.title, _showTitleAsTooltip = param.showTitleAsTooltip, showTitleAsTooltip = _showTitleAsTooltip === void 0 ? true : _showTitleAsTooltip, _tooltipPlacement = param.tooltipPlacement, tooltipPlacement = _tooltipPlacement === void 0 ? ui/* Direction.Left */.Nm.Left : _tooltipPlacement;
    var renderImage = function() {
        return /*#__PURE__*/ react.createElement(Image, {
            title: altText,
            alt: altText,
            size: SIZE,
            src: "https://cdn.pji.nu/g/rfe/icons/flags/svg/".concat(countryCode, ".svg")
        });
    };
    return showTitleAsTooltip ? /*#__PURE__*/ react.createElement(tooltip/* Tooltip */.u, {
        placement: tooltipPlacement,
        title: title,
        className: className,
        renderOnMouseOver: true
    }, /*#__PURE__*/ react.createElement(CountryFlag, null, renderImage())) : /*#__PURE__*/ react.createElement(CountryFlag, {
        className: className
    }, renderImage());
};

;// CONCATENATED MODULE: ./src/components/country-flag/index.ts



/***/ }),

/***/ 35623:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": () => (/* binding */ CurrencySettings)
/* harmony export */ });
// U+00A0 = non-breaking space
var eur = {
    symbol: "€",
    withDecimals: true,
    thousandSeparator: "\xa0",
    numberOfDecimals: 2,
    decimalSign: ",",
    minimumStepValue: 0.1,
    format: {
        pos: "%v\xa0%s",
        neg: "-%v\xa0%s",
        zero: "%v\xa0%s"
    }
};
var gbp = {
    symbol: "\xa3",
    withDecimals: true,
    thousandSeparator: ",",
    numberOfDecimals: 2,
    decimalSign: ".",
    minimumStepValue: 0.1,
    format: {
        pos: "%s%v",
        neg: "-%s%v",
        zero: "%s%v"
    }
};
var nok = {
    symbol: ",-",
    withDecimals: false,
    thousandSeparator: "\xa0",
    numberOfDecimals: 0,
    decimalSign: ",",
    minimumStepValue: 1,
    format: {
        pos: "%v\xa0%s",
        neg: "-%v\xa0%s",
        zero: "%v\xa0%s"
    }
};
var nzd = {
    symbol: "$",
    withDecimals: true,
    thousandSeparator: ",",
    numberOfDecimals: 2,
    decimalSign: ".",
    minimumStepValue: 0.1,
    format: {
        pos: "%s%v",
        neg: "-%s%v",
        zero: "%s%v"
    }
};
var sek = {
    symbol: "kr",
    withDecimals: false,
    format: {
        pos: "%v\xa0%s",
        neg: "-%v\xa0%s",
        zero: "%v\xa0%s"
    },
    thousandSeparator: "\xa0",
    numberOfDecimals: 0,
    decimalSign: ".",
    minimumStepValue: 1
};
var dkk = {
    symbol: "kr",
    withDecimals: false,
    format: {
        pos: "%v\xa0%s",
        neg: "-%v\xa0%s",
        zero: "%v\xa0%s"
    },
    thousandSeparator: "\xa0",
    numberOfDecimals: 0,
    decimalSign: ".",
    minimumStepValue: 1
};
var CurrencySettings = {
    eur: eur,
    gbp: gbp,
    nok: nok,
    nzd: nzd,
    sek: sek,
    dkk: dkk
};


/***/ }),

/***/ 49763:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": () => (/* binding */ Currency),
/* harmony export */   "Gr": () => (/* reexport safe */ _market_settings__WEBPACK_IMPORTED_MODULE_2__.G),
/* harmony export */   "xG": () => (/* binding */ formatCurrency)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var accounting_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96144);
/* harmony import */ var accounting_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(accounting_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _market_settings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81439);
/* harmony import */ var _codes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35623);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18026);






var formatCurrency = function(price, market, asDiff, code) {
    var omitCode = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    var settings = _market_settings__WEBPACK_IMPORTED_MODULE_2__/* .MarketSettings */ .G[market];
    if (!settings || price === undefined || price === null) {
        return null;
    }
    var overrideCode = typeof code === "string" ? _codes__WEBPACK_IMPORTED_MODULE_3__/* .CurrencySettings */ .B[code.toLowerCase()] : undefined;
    var ref = overrideCode || settings, withDecimals = ref.withDecimals, numberOfDecimals = ref.numberOfDecimals, symbol = ref.symbol, format = ref.format;
    var decimals = numberOfDecimals !== undefined ? numberOfDecimals : 2;
    var options = {
        symbol: omitCode ? "\xa4" : symbol,
        decimal: settings.decimalSign,
        precision: withDecimals ? decimals : 0,
        thousand: settings.thousandSeparator,
        format: format
    };
    var formattedPrice = accounting_js__WEBPACK_IMPORTED_MODULE_1___default().formatMoney(price, options);
    if (omitCode) {
        formattedPrice = formattedPrice.replace("\xa4", "").trim();
    }
    if (asDiff && Number(price) > 0) {
        return "+".concat(formattedPrice);
    }
    return formattedPrice;
};
var Currency = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(function(props) {
    var ref;
    var price = props.price, market = props.market, _asDiff = props.asDiff, asDiff = _asDiff === void 0 ? false : _asDiff, _code = props.code, code = _code === void 0 ? "" : _code, _omitCode = props.omitCode, omitCode = _omitCode === void 0 ? false : _omitCode;
    var context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_4__/* .AppContext */ .Il);
    var marketFromParamOrContext = market !== null && market !== void 0 ? market : (ref = context.market) === null || ref === void 0 ? void 0 : ref.code;
    var curr = formatCurrency(price, marketFromParamOrContext, asDiff, code, omitCode);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, curr);
});


/***/ }),

/***/ 81439:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": () => (/* binding */ MarketSettings)
/* harmony export */ });
/* harmony import */ var _codes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35623);

var eur = _codes__WEBPACK_IMPORTED_MODULE_0__/* .CurrencySettings.eur */ .B.eur, gbp = _codes__WEBPACK_IMPORTED_MODULE_0__/* .CurrencySettings.gbp */ .B.gbp, nok = _codes__WEBPACK_IMPORTED_MODULE_0__/* .CurrencySettings.nok */ .B.nok, sek = _codes__WEBPACK_IMPORTED_MODULE_0__/* .CurrencySettings.sek */ .B.sek, nzd = _codes__WEBPACK_IMPORTED_MODULE_0__/* .CurrencySettings.nzd */ .B.nzd, dkk = _codes__WEBPACK_IMPORTED_MODULE_0__/* .CurrencySettings.dkk */ .B.dkk;
var MarketSettings = {
    gb: gbp,
    fr: eur,
    fi: eur,
    no: nok,
    nz: nzd,
    se: sek,
    dk: dkk
};


/***/ }),

/***/ 87052:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "No": () => (/* binding */ No),
  "sk": () => (/* binding */ Yes)
});

// UNUSED EXPORTS: Unknown, default

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/translate/index.ts + 3 modules
var translate = __webpack_require__(61041);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/close-filled/index.js
var close_filled = __webpack_require__(93347);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/check-filled/index.js
var check_filled = __webpack_require__(89639);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/question-filled/index.js
var question_filled = __webpack_require__(57322);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
;// CONCATENATED MODULE: ./src/components/data-list/components/colored-icon/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  color: ",
        ";\n  svg {\n    margin-right: 0.4em;\n    path {\n      fill: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ColoredIconWrapper = styled_components_browser_esm["default"].span.withConfig({
    displayName: "ColoredIconWrapper",
    componentId: "sc-0-0"
})(_templateObject(), function(props) {
    return props.color;
}, function(props) {
    return props.color;
});

;// CONCATENATED MODULE: ./src/components/data-list/components/colored-icon/index.tsx







var ColoredIcon = function(param) {
    var children = param.children, color = param.color;
    return /*#__PURE__*/ react.createElement(ColoredIconWrapper, {
        color: color
    }, children);
};
var Yes = function() {
    return /*#__PURE__*/ react.createElement(ColoredIcon, {
        color: base/* colors.lightTheme.positive500 */.O9.lightTheme.positive500
    }, /*#__PURE__*/ react.createElement(check_filled.IconCheckFilled, {
        size: 18,
        color: "positive500"
    }), /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "product"
    }, "property.boolean-yes"));
};
var No = function() {
    return /*#__PURE__*/ react.createElement(ColoredIcon, {
        color: base/* colors.lightTheme.negative700 */.O9.lightTheme.negative700
    }, /*#__PURE__*/ react.createElement(close_filled.IconCloseFilled, {
        size: 18,
        color: "negative700"
    }), /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "product"
    }, "property.boolean-no"));
};
var Unknown = function() {
    return /*#__PURE__*/ React.createElement(ColoredIcon, {
        color: colors.lightTheme.base400
    }, /*#__PURE__*/ React.createElement(IconQuestionFilled, {
        size: 18,
        color: "base400"
    }));
};
/* harmony default export */ const colored_icon = ((/* unused pure expression or super */ null && (ColoredIcon)));


/***/ }),

/***/ 45656:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": () => (/* binding */ parseNodes)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_text_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32673);
/* harmony import */ var src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58912);



var isPropertyType = function(node) {
    return Boolean(node.type);
};
function parseNodes(node, t) {
    var noChildren = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var ref;
    var property = {
        name: node.name || undefined,
        value: {
            type: node.type,
            text: "",
            urls: []
        },
        byline: node.comment ? node.comment : "",
        children: node.children && ((ref = node.children) === null || ref === void 0 ? void 0 : ref.length) && !noChildren ? node.children.map(function(child) {
            return isPropertyType(child) && parseNodes(child, t, noChildren);
        }).filter(function(child) {
            return child !== undefined;
        }) : [],
        column: {}
    };
    switch(node.type){
        case "boolean":
            {
                var value = node.boolean;
                if (value !== null) {
                    property.value.text = value ? t("product", "property.boolean-yes") : t("product", "property.boolean-no");
                    property.value.value = value;
                }
                return property;
            }
        case "integer":
        case "decimal":
            {
                var value1 = node.number;
                var unit = node.unit;
                var text = value1 !== null && value1 !== void 0 ? value1 : node.pretty;
                if (text === null || text === undefined) {
                    property.value.text = "";
                } else {
                    property.value.text = unit ? "".concat(text, " ").concat(unit) : String(text);
                    property.value.value = text;
                }
                return property;
            }
        case "list":
            {
                var values = node.values, categoryLinks = node.categoryLinks;
                if (!values) {
                    return property;
                }
                property.value.text = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, values.map(function(value, index) {
                    var link = categoryLinks === null || categoryLinks === void 0 ? void 0 : categoryLinks[index];
                    var isLastValue = index < values.length - 1;
                    if (!value) {
                        return null;
                    }
                    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        key: value
                    }, link ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_text_link__WEBPACK_IMPORTED_MODULE_1__/* .TextLink */ .h, {
                        to: link
                    }, value) : value, isLastValue ? ", " : "");
                }));
                return property;
            }
        case "interval":
            {
                var values1 = [
                    node.from,
                    node.to
                ].filter(function(n) {
                    return n !== null;
                }).filter(function(value, index, self) {
                    return self.indexOf(value) === index;
                }).join(" - ");
                var text1 = values1 !== null && values1 !== void 0 ? values1 : node.pretty;
                property.value.text = text1 ? "".concat(text1, " ").concat(node.unit || "").trim() : "";
                return property;
            }
        case "link":
            {
                var links = node.links;
                property.value.urls = links && links.length ? links.map(function(link) {
                    return link && link.url;
                }).filter(function(link) {
                    return !!link;
                }) : [];
                property.column = {
                    full: true
                };
                return property;
            }
        case "string":
            {
                var value2 = node.value, unit1 = node.unit, categoryLink = node.categoryLink, pretty = node.pretty;
                var text2 = value2 !== null && value2 !== void 0 ? value2 : pretty;
                if (text2 === null || text2 === undefined) {
                    property.value.text = "";
                } else {
                    var valueWithUnit = unit1 ? "".concat(text2, " ").concat(unit1) : text2;
                    property.value.text = categoryLink ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_text_link__WEBPACK_IMPORTED_MODULE_1__/* .TextLink */ .h, {
                        onClick: function() {
                            return (0,src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_2__/* .trackInternalNavigationClick */ .p)({
                                scope: src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_2__/* .InternalNavigationScope.PRODUCT_INFORMATION */ .U.PRODUCT_INFORMATION,
                                nextPage: categoryLink
                            });
                        },
                        to: categoryLink
                    }, valueWithUnit) : valueWithUnit;
                }
                return property;
            }
        default:
            {
                return property;
            }
    }
}


/***/ }),

/***/ 57607:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": () => (/* binding */ data_list_DataList)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/text-link/index.tsx + 1 modules
var text_link = __webpack_require__(32673);
// EXTERNAL MODULE: ./src/components/review-form/components/title/index.tsx
var title = __webpack_require__(67295);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(71016);
;// CONCATENATED MODULE: ./src/components/data-list/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  break-inside: avoid;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      width: 100%;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  box-sizing: border-box;\n  padding: ",
        " 0;\n  word-wrap: break-word;\n\n  &:nth-of-type(odd) {\n    flex: 0 0 35%;\n    max-width: 50%;\n  }\n\n  &:nth-of-type(even) {\n    flex: 1 0 50%;\n    padding-left: ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      border-top: ",
        ";\n      border-bottom: none;\n      & > ",
        ":nth-of-type(odd) {\n        padding-left: ",
        ";\n      }\n\n      & > & > ",
        ":nth-of-type(odd) {\n        padding-left: ",
        ";\n      }\n\n      & > & > & > ",
        ":nth-of-type(odd) {\n        padding-left: ",
        ";\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  width: 100%;\n  border-bottom: ",
        ";\n\n  &:last-of-type {\n    border-bottom: none;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  color: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}



var borderStyle = "1px solid  ".concat(base/* colors.lightTheme.base200 */.O9.lightTheme.base200);
var DataList = styled_components_browser_esm["default"].div.withConfig({
    displayName: "DataList",
    componentId: "sc-0-0"
})(_templateObject());
var Section = styled_components_browser_esm["default"].section.withConfig({
    displayName: "Section",
    componentId: "sc-0-1"
})(_templateObject1());
var Column = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Column",
    componentId: "sc-0-2"
})(_templateObject3(), base/* layout.measurements.spacing075 */.bK.measurements.spacing075, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.full && (0,styled_components_browser_esm.css)(_templateObject2());
});
var Row = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Row",
    componentId: "sc-0-3"
})(_templateObject5(), borderStyle, function(p) {
    return p.inline && (0,styled_components_browser_esm.css)(_templateObject4(), borderStyle, Column, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, Column, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, Column, base/* layout.measurements.spacing150 */.bK.measurements.spacing150);
});
var Title = (/* unused pure expression or super */ null && (H3Text));
var Byline = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Byline",
    componentId: "sc-0-4"
})(_templateObject6(), function(p) {
    return p.theme.colors.base600;
});
var PropertyName = (0,styled_components_browser_esm["default"])(variants.BodySmallText).attrs({
    emphasis: variants.FontEmphasis.MEDIUM
}).withConfig({
    displayName: "PropertyName",
    componentId: "sc-0-5"
})(_templateObject7());
var PropertyValue = (0,styled_components_browser_esm["default"])(variants.BodySmallText).withConfig({
    displayName: "PropertyValue",
    componentId: "sc-0-6"
})(_templateObject8());

// EXTERNAL MODULE: ./src/components/data-list/components/colored-icon/index.tsx + 1 modules
var colored_icon = __webpack_require__(87052);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(58912);
;// CONCATENATED MODULE: ./src/components/data-list/index.tsx






function renderValue(property) {
    var value = property.value;
    switch(value.type){
        case "link":
            return (value.urls || []).map(function(url, index) {
                return /*#__PURE__*/ react.createElement("a", {
                    key: "".concat(url, "-").concat(index.toString()),
                    href: url,
                    target: "_blank",
                    rel: "nofollow noopener noreferrer"
                }, url);
            });
        case "boolean":
            {
                if (typeof value.value !== "boolean") {
                    return null;
                }
                return value.value ? /*#__PURE__*/ react.createElement(colored_icon/* Yes */.sk, null) : /*#__PURE__*/ react.createElement(colored_icon.No, null);
            }
        default:
            return value.link ? /*#__PURE__*/ react.createElement(text_link/* TextLink */.h, {
                to: value.link,
                onClick: function() {
                    (0,tracking/* trackInternalNavigationClick */.p)({
                        scope: tracking/* InternalNavigationScope.PRODUCT_INFORMATION */.U.PRODUCT_INFORMATION,
                        nextPage: value.link
                    });
                }
            }, value.text) : value.text;
    }
}
var renderList = function(properties) {
    var inline = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return properties.map(function(property, index) {
        var ref, ref1;
        var key = "".concat(property.name, "-").concat(index.toString());
        return /*#__PURE__*/ react.createElement(Row, {
            inline: inline,
            key: key,
            role: "listitem"
        }, /*#__PURE__*/ react.createElement(Column, {
            full: (ref = property.column) === null || ref === void 0 ? void 0 : ref.full
        }, /*#__PURE__*/ react.createElement(PropertyName, null, property.name)), /*#__PURE__*/ react.createElement(Column, {
            full: (ref1 = property.column) === null || ref1 === void 0 ? void 0 : ref1.full
        }, /*#__PURE__*/ react.createElement(PropertyValue, null, property.value && renderValue(property)), property.byline && /*#__PURE__*/ react.createElement(Byline, {
            key: property.byline
        }, property.byline)), property.children && renderList(property.children, true));
    });
};
var data_list_DataList = function(props) {
    return /*#__PURE__*/ react.createElement(Section, {
        key: props.title,
        role: "list"
    }, props.title && /*#__PURE__*/ react.createElement(title/* default */.Z, null, props.title), renderList(props.properties));
};


/***/ }),

/***/ 16312:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "cw": () => (/* reexport */ DropdownNew),
  "HC": () => (/* reexport */ ListItem)
});

// UNUSED EXPORTS: SharedListItemStyles

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/button/index.tsx + 1 modules
var components_button = __webpack_require__(38828);
// EXTERNAL MODULE: ./src/components/dropdown-new/styles.ts
var styles = __webpack_require__(79470);
;// CONCATENATED MODULE: ./src/components/dropdown-new/dropdown-new.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



var Dropdown = function(props) {
    var ref = _slicedToArray((0,react.useState)(false), 2), expanded = ref[0], setExpandedState = ref[1];
    var dropdownRef = (0,react.useRef)(null);
    var className = props.className, children = props.children, _grow = props.grow, grow = _grow === void 0 ? "none" : _grow, toggleElement = props.toggleElement, _showArrow = props.showArrow, showArrow = _showArrow === void 0 ? true : _showArrow, _variant = props.variant, variant = _variant === void 0 ? "primary" : _variant, onSelect = props.onSelect;
    var toggleDropdown = (0,react.useCallback)(function() {
        setExpandedState(!expanded);
    }, [
        expanded
    ]);
    var onToggleElementClick = (0,react.useCallback)(function(e) {
        if (typeof toggleElement !== "string" && toggleElement.props.onClick) {
            toggleElement.props.onClick(e);
        } else {
            e.preventDefault();
            e.stopPropagation();
            toggleDropdown();
        }
    }, [
        toggleDropdown,
        toggleElement
    ]);
    var handleClickOutside = function(e) {
        if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
            setExpandedState(false);
        }
    };
    (0,react.useEffect)(function() {
        document.addEventListener("click", handleClickOutside);
        return function() {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);
    return /*#__PURE__*/ react.createElement(styles/* Dropdown */.Lt, {
        variant: variant,
        expanded: expanded,
        ref: dropdownRef,
        className: className,
        "data-test": props["data-test"]
    }, typeof toggleElement === "string" ? /*#__PURE__*/ react.createElement(components_button/* Button */.z, {
        style: styles/* sharedButtonStyles */.Rg,
        variant: "text",
        color: "link",
        onClick: toggleDropdown,
        iconPosition: "right",
        icon: showArrow ? /*#__PURE__*/ react.createElement(styles/* Arrow */.Eh, {
            expanded: expanded ? 1 : 0
        }) : null,
        "data-test": "DropdownToggle"
    }, toggleElement) : /*#__PURE__*/ react.createElement(toggleElement.type, _extends({
        style: styles/* sharedButtonStyles */.Rg,
        "data-test": "DropdownToggle"
    }, toggleElement.props, {
        onClick: onToggleElementClick,
        className: "dropdown-toggle-element"
    }), toggleElement.props.children, " ", showArrow && /*#__PURE__*/ react.createElement(styles/* Arrow */.Eh, {
        expanded: expanded ? 1 : 0
    })), /*#__PURE__*/ react.createElement(styles/* DropdownHideable */.Lr, {
        visible: expanded
    }, /*#__PURE__*/ react.createElement(styles/* DropdownContent */.Nv, {
        variant: variant,
        expanded: expanded,
        grow: grow
    }, react.Children.map(children, function(child) {
        if (!child) {
            return null;
        }
        return /*#__PURE__*/ react.cloneElement(child, _objectSpreadProps(_objectSpread({}, child.props), {
            onClick: function onClick(e) {
                if (child.props.onClick) {
                    child.props.onClick(e);
                }
                if (onSelect) {
                    onSelect(child.key || undefined);
                }
                if (child.props.to || child.props.onClick || onSelect) {
                    toggleDropdown();
                }
            },
            "data-test": "DropdownOption",
            "data-test-key": child.key
        }));
    }))));
};
var DropdownNew = /*#__PURE__*/ (0,react.memo)(Dropdown);

// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(38689);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
;// CONCATENATED MODULE: ./src/components/dropdown-new/item.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  padding: ",
        ";\n  cursor: pointer;\n  width: 100%;\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: ",
        ";\n  &:disabled {\n    color: rgba(16, 16, 16, 0.3);\n  }\n\n  svg {\n    margin-right: ",
        ";\n  }\n\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var SharedListItemStyles = (0,styled_components_browser_esm.css)(_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.theme.text.primary;
}, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.theme.dropdowns.secondary.hoverBackground;
});
var ListItem = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "ListItem",
    componentId: "sc-0-0"
})(_templateObject1(), SharedListItemStyles);

;// CONCATENATED MODULE: ./src/components/dropdown-new/index.ts





/***/ }),

/***/ 79470:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Eh": () => (/* binding */ Arrow),
/* harmony export */   "Lr": () => (/* binding */ DropdownHideable),
/* harmony export */   "Lt": () => (/* binding */ Dropdown),
/* harmony export */   "Nv": () => (/* binding */ DropdownContent),
/* harmony export */   "Rg": () => (/* binding */ sharedButtonStyles)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71993);
/* harmony import */ var _prisjakt_ui_icon_chevron_down__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70796);
/* harmony import */ var _prisjakt_ui_hideable_variants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20305);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      svg,\n      path {\n        fill: currentColor;\n      }\n\n      border-color: transparent;\n\n      &:hover {\n        & > button {\n          color: ",
        ";\n        }\n      }\n\n      & > button {\n        color: ",
        ";\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      border-color: ",
        ";\n\n      background: ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    position: relative;\n    border: ",
        ";\n    border-bottom: ",
        ";\n    border-top-left-radius: ",
        ";\n    border-top-right-radius: ",
        ";\n    border-bottom-left-radius: ",
        ";\n    border-bottom-right-radius: ",
        ";\n\n    color: ",
        ";\n\n    ",
        ";\n\n    ",
        ";\n\n    .dropdown-toggle-element {\n      &:hover {\n        color: ",
        ";\n      }\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  z-index: 11;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      top: calc(100% - 2px);\n      left: -",
        "px;\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n      top: calc(100% - 2px);\n      right: -",
        "px;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n      top: calc(100% - 2px);\n      left: -",
        "px;\n      right: -",
        "px;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n    display: block; /* display flex + absolute position breaks in IE11 */\n    position: absolute;\n    border: ",
        ";\n    border-top: ",
        ";\n    background: ",
        ";\n    border-top-left-radius: ",
        ";\n    border-top-right-radius: ",
        ";\n    border-bottom-left-radius: ",
        ";\n    border-bottom-right-radius: ",
        ";\n\n    ",
        ";\n\n    ",
        ";\n\n    ",
        ";\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: auto;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n\n  && {\n    transform: ",
        ";\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}



var borderSize = 1;
var dropdownBorder = function(props) {
    var transparent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return "".concat(borderSize, "px solid ").concat(transparent ? "transparent" : props.theme.dropdowns[props.variant].borderColor.active);
};
var sharedButtonStyles = {
    cursor: "pointer"
};
var Dropdown = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Dropdown",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject2(), dropdownBorder(props), props.expanded && props.variant === "primary" ? dropdownBorder(props, true) : dropdownBorder(props), props.theme.dropdowns[props.variant].borderRadius, props.theme.dropdowns[props.variant].borderRadius, props.expanded ? 0 : props.theme.dropdowns[props.variant].borderRadius, props.expanded ? 0 : props.theme.dropdowns[props.variant].borderRadius, props.theme.icons.tertiary, props.variant === "secondary" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject(), props.theme.icons.callToAction, props.expanded ? props.theme.icons.callToAction : undefined), props.variant !== "secondary" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject1(), props.expanded ? props.theme.dropdowns[props.variant].borderColor.active : props.theme.dropdowns[props.variant].borderColor.inactive, props.expanded ? props.theme.dropdowns[props.variant].bg : "transparent"), function(p) {
        return p.theme.buttons.link.textHover;
    });
});
var DropdownHideable = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_hideable_variants__WEBPACK_IMPORTED_MODULE_2__.NudgeUp).withConfig({
    displayName: "DropdownHideable",
    componentId: "sc-0-1"
})(_templateObject3());
var DropdownContent = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "DropdownContent",
    componentId: "sc-0-2"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject7(), dropdownBorder(props), props.expanded && props.variant === "primary" ? dropdownBorder(props, true) : dropdownBorder(props), props.theme.dropdowns[props.variant].bg, props.expanded ? 0 : props.theme.dropdowns[props.variant].borderRadius, props.expanded ? 0 : props.theme.dropdowns[props.variant].borderRadius, props.theme.dropdowns[props.variant].borderRadius, props.theme.dropdowns[props.variant].borderRadius, props.grow === "right" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject4(), borderSize), props.grow === "left" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject5(), borderSize), props.grow === "none" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject6(), borderSize, borderSize));
});
var arrowStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject8());
var Arrow = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_icon_chevron_down__WEBPACK_IMPORTED_MODULE_1__/* .IconChevronDown */ .C).withConfig({
    displayName: "Arrow",
    componentId: "sc-0-3"
})(_templateObject9(), arrowStyles, function(p) {
    return p.expanded ? "rotate(180deg)" : "rotate(0)";
});


/***/ }),

/***/ 77078:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ error_boundary)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@5.2.1_react@18.2.0/node_modules/react-router/esm/react-router.js + 3 modules
var react_router = __webpack_require__(14727);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
;// CONCATENATED MODULE: ./src/components/error-boundary/error-boundary-inner.tsx
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}


var ErrorBoundaryInner = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(ErrorBoundaryInner, _Component);
    var _super = _createSuper(ErrorBoundaryInner);
    function ErrorBoundaryInner(props) {
        _classCallCheck(this, ErrorBoundaryInner);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            hasError: false
        };
        return _this;
    }
    var _proto = ErrorBoundaryInner.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this = this;
        this.unlisten = this.props.history.listen(function(location) {
            if (_this.state.hasError && _this.state.pathname !== location.pathname) {
                _this.setState({
                    hasError: false
                });
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        var _obj, ref;
        (ref = (_obj = this).unlisten) === null || ref === void 0 ? void 0 : ref.call(_obj);
    };
    _proto.componentDidCatch = function componentDidCatch(error, info) {
        var captureException = this.context.captureException;
        Object.assign(error, {
            info: info
        });
        captureException(error);
        this.setState({
            error: error,
            hasError: true,
            pathname: this.props.history.location.pathname
        });
    };
    _proto.render = function render() {
        if (this.state.hasError) {
            return this.props.onError(this.state.error || {}) || null;
        }
        return this.props.children;
    };
    return ErrorBoundaryInner;
}(react.Component);
ErrorBoundaryInner.contextType = app_context/* AppContext */.Il;

;// CONCATENATED MODULE: ./src/components/error-boundary/index.tsx



var ErrorBoundary = function(props) {
    var history = (0,react_router/* useHistory */.k6)();
    return /*#__PURE__*/ react.createElement(ErrorBoundaryInner, {
        history: history,
        onError: props.onError
    }, props.children);
};
/* harmony default export */ const error_boundary = (ErrorBoundary);


/***/ }),

/***/ 40314:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ error_message)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./src/components/translate/index.ts + 3 modules
var translate = __webpack_require__(61041);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(71016);
;// CONCATENATED MODULE: ./src/components/error-message/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n  display: block;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  padding: ",
        ";\n  max-width: ",
        ";\n\n  img {\n    max-width: 304px;\n    align-self: center;\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    flex-direction: column;\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  padding: ",
        ";\n  min-height: 400px;\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    margin-left: auto;\n    margin-right: auto;\n    margin-bottom: ",
        ";\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: 12rem;\n  width: 328px;\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n    padding-left: 0;\n    padding-right: 0;\n    margin-left: 0;\n    flex-wrap: wrap;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  margin-left: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n    margin-top: 0px;\n    text-align: left;\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n    text-align: left;\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  margin-bottom: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    text-align: left;\n  "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: baseline;\n  margin-top: ",
        ";\n\n  color: ",
        ";\n\n  > a {\n    color: ",
        ";\n    text-decoration-line: underline;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  margin-bottom: ",
        ";\n\n  a:not(:last-child) {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n    text-align: left;\n  "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n\n  color: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n  display: none;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}



var Header = (0,styled_components_browser_esm["default"])(variants.H1Text).withConfig({
    displayName: "Header",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150);
var Body = (0,styled_components_browser_esm["default"])(variants.BodyLargeText).withConfig({
    displayName: "Body",
    componentId: "sc-0-1"
})(_templateObject1(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var PageNotFoundWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PageNotFoundWrapper",
    componentId: "sc-0-2"
})(_templateObject2(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.pageNotFound.maxWidth */.bK.pageNotFound.maxWidth, base/* layout.measurements.spacing150 */.bK.measurements.spacing150);
var ErrorMessageWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ErrorMessageWrapper",
    componentId: "sc-0-3"
})(_templateObject4(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* media.smallOnly */.BC.smallOnly(_templateObject3()));
var ErrorMessageMedia = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ErrorMessageMedia",
    componentId: "sc-0-4"
})(_templateObject6(), base/* media.smallOnly */.BC.smallOnly(_templateObject5(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100));
var ErrorMessageContent = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ErrorMessageContent",
    componentId: "sc-0-5"
})(_templateObject8(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.smallOnly */.BC.smallOnly(_templateObject7()));
var ErrorMessageTitle = (0,styled_components_browser_esm["default"])(variants.H1Text).withConfig({
    displayName: "ErrorMessageTitle",
    componentId: "sc-0-6"
})(_templateObject10(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.smallOnly */.BC.smallOnly(_templateObject9()));
var ErrorMessageSubtitle = (0,styled_components_browser_esm["default"])(variants.BodyLargeText).withConfig({
    displayName: "ErrorMessageSubtitle",
    componentId: "sc-0-7"
})(_templateObject12(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.smallOnly */.BC.smallOnly(_templateObject11()));
var ErrorMessageSupportLabel = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ErrorMessageSupportLabel",
    componentId: "sc-0-8"
})(_templateObject14(), base/* layout.measurements.spacing200 */.bK.measurements.spacing200, function(param) {
    var theme = param.theme;
    return theme.text.secondary;
}, function(param) {
    var theme = param.theme;
    return theme.text.secondary;
}, base/* media.smallOnly */.BC.smallOnly(_templateObject13()));
var ButtonGroup = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ButtonGroup",
    componentId: "sc-0-9"
})(_templateObject15(), base/* layout.measurements.spacing250 */.bK.measurements.spacing250, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var ErrorMessageErrorLabel = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ErrorMessageErrorLabel",
    componentId: "sc-0-10"
})(_templateObject17(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, function(param) {
    var theme = param.theme;
    return theme.text.secondary;
}, function(p) {
    return p.$centered && base/* media.smallOnly */.BC.smallOnly(_templateObject16());
});
var ErrorMessageHidden = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ErrorMessageHidden",
    componentId: "sc-0-11"
})(_templateObject18());

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/button/variants.js
var button_variants = __webpack_require__(7336);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 24 modules
var es = __webpack_require__(95939);
;// CONCATENATED MODULE: ./src/components/error-message/index.tsx






/*
  When using compose from DataContainer we can only get
  the contexts requested by the DataContainer component.
*/ var ErrorMessage = function(param) {
    var _status = param.status, status = _status === void 0 ? 500 : _status, onRetry = param.onRetry;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), locale = ref.market.locale, t = ref.t, market = ref.market;
    var campaigns = (0,es/* useSelector */.v9)(function(state) {
        return state.globals.campaigns;
    });
    var renderStatusMessage = function() {
        var centered = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        if (!status) {
            return null;
        }
        return /*#__PURE__*/ react.createElement(ErrorMessageErrorLabel, {
            $centered: centered
        }, t("errors", "error-page.error-code", {
            code: status
        }));
    };
    var makeButton = function(text) {
        var link = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        return /*#__PURE__*/ react.createElement(button_variants.TonalButton, {
            container: "a",
            containerProps: {
                href: link
            }
        }, text);
    };
    var getDailyDealsLink = function() {
        var ref;
        var dailyDeals = campaigns === null || campaigns === void 0 ? void 0 : campaigns.active.find(function(campaign) {
            return campaign.type === "OFFER";
        });
        var link = dailyDeals === null || dailyDeals === void 0 ? void 0 : (ref = dailyDeals.web_uri) === null || ref === void 0 ? void 0 : ref.responsive;
        return link || "";
    };
    var renderPageNotFoundButtons = function() {
        var hotProductsLink = "/category.php?k=v100";
        if (market.code === "se") {
            hotProductsLink = "/kategori.php?k=v100";
        } else if (market.code === "gb") {
            hotProductsLink = "/top-100--cv100";
        }
        return /*#__PURE__*/ react.createElement(ButtonGroup, null, makeButton(t("campaigns", "daily-deals.title"), getDailyDealsLink()), locale === "sv" ? makeButton("Guider och topplistor fr\xe5n v\xe5ra experter", "/experter") : null, makeButton(t("landing", "hot-products.title"), hotProductsLink));
    };
    var renderErrorPage = function() {
        if (status === 404 || status === 410) {
            return /*#__PURE__*/ react.createElement(PageNotFoundWrapper, null, /*#__PURE__*/ react.createElement(Header, null, t("errors", "error-page.page-not-found-title")), /*#__PURE__*/ react.createElement(Body, null, t("errors", "error-page.page-not-found-subtitle")), renderPageNotFoundButtons(), /*#__PURE__*/ react.createElement("img", {
                src: "https://cdn.pji.nu/g/rfe/icons/Error_404_cute_logo.png",
                alt: ""
            }), renderStatusMessage());
        }
        return /*#__PURE__*/ react.createElement(ErrorMessageWrapper, null, /*#__PURE__*/ react.createElement(ErrorMessageContent, null, /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(ErrorMessageTitle, null, t("errors", "error-page.title")), /*#__PURE__*/ react.createElement(ErrorMessageSubtitle, null, t("errors", "internal.unknown"), " ", t("errors", "error-page.page-not-found-subtitle")), renderPageNotFoundButtons()), /*#__PURE__*/ react.createElement(ErrorMessageMedia, null, /*#__PURE__*/ react.createElement("img", {
            alt: "Error",
            src: "https://cdn.pji.nu/g/rfe/illustrations/illo-error-500-dog-656x484.png"
        })), status >= 500 && /*#__PURE__*/ react.createElement(ErrorMessageSupportLabel, null, renderStatusMessage(true), /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
            domain: "errors"
        }, "support.text-link.md"))));
    };
    return /*#__PURE__*/ react.createElement("div", {
        "data-test": "ErrorMessage",
        "data-status": status
    }, renderErrorPage());
};
/* harmony default export */ const error_message = (ErrorMessage);


/***/ }),

/***/ 34430:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": () => (/* binding */ ExperimentContext)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);

var ExperimentContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({
    showEditor: false,
    selectedVariants: {},
    viewedExperiments: {},
    experiments: [],
    registerExperiment: function() {
        return null;
    },
    unregisterExperiment: function() {
        return null;
    },
    selectVariant: function() {
        return null;
    },
    setViewedExperiment: function() {
        return null;
    }
});
ExperimentContext.displayName = "ExperimentContext";


/***/ }),

/***/ 98569:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": () => (/* binding */ ExperimentsList)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(7336);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
;// CONCATENATED MODULE: ./src/components/experiment/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-gap: 0.5rem;\n  padding: 0.5rem 1rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0.5rem;\n  display: flex;\n  flex-direction: column;\n  min-width: 250px;\n  align-items: flex-start;\n  background-color: ",
        ";\n  border-radius: 0.5rem;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-gap: 0.5rem;\n  grid-auto-flow: column;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var ExperimentsListWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ExperimentsListWrapper",
    componentId: "sc-0-0"
})(_templateObject());
var ExperimentsListGrid = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ExperimentsListGrid",
    componentId: "sc-0-1"
})(_templateObject1(), function(p) {
    return p.theme.colors.base100;
});
var ExperimentSelectWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ExperimentSelectWrapper",
    componentId: "sc-0-2"
})(_templateObject2());

;// CONCATENATED MODULE: ./src/components/experiment/experiment-select.tsx



var ExperimentSelect = function(param) {
    var experiment = param.experiment, selectedVariant = param.selectedVariant, onClick = param.onClick;
    var selected = selectedVariant !== null && selectedVariant !== void 0 ? selectedVariant : "baseline";
    return /*#__PURE__*/ react.createElement(ExperimentSelectWrapper, null, [
        "baseline"
    ].concat(Object.keys(experiment.variants)).map(function(variant) {
        /*#__PURE__*/ return react.createElement(variants.OutlinedButton, {
            key: variant,
            size: variants.ButtonSize.SMALL,
            type: variant === selected ? variants.ButtonType.PRIMARY : variants.ButtonType.OUTLINED,
            onClick: function() {
                return onClick === null || onClick === void 0 ? void 0 : onClick(variant);
            }
        }, variant);
    }));
};

;// CONCATENATED MODULE: ./src/components/experiment/experiments-list.tsx



var fromKebab = function(s) {
    return s.replace(/-/g, " ");
};
var fromCamel = function(s) {
    return s.replace(/([a-z])([A-Z])/g, "$1 $2");
};
var unCase = function(s) {
    return fromCamel(fromKebab(s));
};
var ExperimentsList = function(param) {
    var experiments = param.experiments, selectVariant = param.selectVariant, selectedVariants = param.selectedVariants;
    return /*#__PURE__*/ react.createElement(ExperimentsListWrapper, null, experiments === null || experiments === void 0 ? void 0 : experiments.map(function(experiment) {
        var ref;
        /*#__PURE__*/ return react.createElement(ExperimentsListGrid, {
            key: experiment.id
        }, /*#__PURE__*/ react.createElement("h4", null, unCase(experiment.id)), /*#__PURE__*/ react.createElement(ExperimentSelect, {
            experiment: experiment,
            selectedVariant: selectedVariants === null || selectedVariants === void 0 ? void 0 : (ref = selectedVariants[experiment.id]) === null || ref === void 0 ? void 0 : ref.selectedVariant,
            onClick: function(variant) {
                selectVariant === null || selectVariant === void 0 ? void 0 : selectVariant(experiment, variant);
            }
        }));
    }), !(experiments === null || experiments === void 0 ? void 0 : experiments.length) ? /*#__PURE__*/ react.createElement("div", {
        style: {
            whiteSpace: "nowrap"
        }
    }, "There are no experiments on this page") : null);
};


/***/ }),

/***/ 75234:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": () => (/* reexport */ context/* ExperimentContext */.T),
  "m": () => (/* reexport */ createExperimentHook)
});

// EXTERNAL MODULE: ./src/components/experiment/context.ts
var context = __webpack_require__(34430);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
;// CONCATENATED MODULE: ./src/components/experiment/hook.ts


var createExperimentHook = function(id, baseline, variants) {
    if (typeof id === "undefined" || typeof baseline === "undefined" || typeof variants === "undefined") {
        throw new Error("createExperimentHook expects 3 arguments: id, baseline, variants");
    }
    return function() {
        var shouldSetAsViewed = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        var ref = react.useContext(context/* ExperimentContext */.T), selectedVariants = ref.selectedVariants, registerExperiment = ref.registerExperiment, setViewedExperiment = ref.setViewedExperiment, unregisterExperiment = ref.unregisterExperiment;
        var variantName = selectedVariants && selectedVariants[id] && selectedVariants[id].selectedVariant;
        react.useEffect(function() {
            registerExperiment({
                id: id,
                baseline: baseline,
                variants: variants
            });
            return function() {
                return unregisterExperiment(id);
            };
        }, [
            registerExperiment,
            unregisterExperiment
        ]);
        react.useEffect(function() {
            if (shouldSetAsViewed) {
                setViewedExperiment(id, variantName && variantName in variants ? variantName : "baseline");
            }
        }, [
            shouldSetAsViewed,
            setViewedExperiment,
            variantName
        ]);
        return variantName && variantName in variants ? variants[variantName] : baseline;
    };
};

;// CONCATENATED MODULE: ./src/components/experiment/index.ts




/***/ }),

/***/ 95698:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);

var FetchContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({
    query: function() {
        return null;
    }
});
FetchContext.displayName = "FetchContext";
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (FetchContext);


/***/ }),

/***/ 6340:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "VY": () => (/* binding */ Content),
  "ML": () => (/* binding */ FilterDropdown),
  "M7": () => (/* binding */ OptionTypeEnum)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/button/index.js
var ui_button = __webpack_require__(17658);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/dropdown/index.js
var dropdown = __webpack_require__(42654);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/radiobutton/index.js
var radiobutton = __webpack_require__(9225);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(38689);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/light-theme-colors.js
var light_theme_colors = __webpack_require__(24774);
;// CONCATENATED MODULE: ./src/components/filter-dropdown/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  padding: ",
        ";\n  cursor: pointer;\n  width: 100%;\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  ",
        ";\n\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var DropdownItem = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "DropdownItem",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return !p.disabled && "color: ".concat(light_theme_colors.base900);
}, function(p) {
    return p.theme.dropdowns.secondary.hoverBackground;
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/sort/index.js
var sort = __webpack_require__(26110);
;// CONCATENATED MODULE: ./src/components/filter-dropdown/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}






var OptionTypeEnum;
(function(OptionTypeEnum) {
    OptionTypeEnum["CHEAPEST_PRICE"] = "CHEAPEST_PRICE";
    OptionTypeEnum["FASTEST_DELIVERY"] = "FASTEST_DELIVERY";
})(OptionTypeEnum || (OptionTypeEnum = {}));
var FilterDropdown = function(param) {
    var alignment = param.alignment, className = param.className, defaultSelected = param.defaultSelected, onFilterChange = param.onFilterChange, options = param.options, width = param.width, _showAsRadioButtons = param.showAsRadioButtons, showAsRadioButtons = _showAsRadioButtons === void 0 ? false : _showAsRadioButtons, _showIcon = param.showIcon, showIcon = _showIcon === void 0 ? true : _showIcon;
    var ref = _slicedToArray((0,react.useState)(defaultSelected || options[0]), 2), selected = ref[0], setSelected = ref[1];
    (0,react.useEffect)(function() {
        setSelected(defaultSelected);
    }, [
        defaultSelected
    ]);
    var handleOnClick = (0,react.useCallback)(function(option) {
        setSelected(option);
        onFilterChange(option);
    }, [
        onFilterChange
    ]);
    return /*#__PURE__*/ react.createElement(dropdown/* Dropdown */.Lt, {
        closeOnItemClick: true,
        className: className,
        containerProps: {
            "data-test": "FilterDropdown"
        }
    }, /*#__PURE__*/ react.createElement(dropdown/* DropdownToggle */.Z_, {
        showActiveIcon: true,
        type: ui_button.ButtonType.TEXT,
        containerProps: {
            "data-test": "DropdownToggle"
        }
    }, showIcon && /*#__PURE__*/ react.createElement(sort/* IconSort */.M, null), selected === null || selected === void 0 ? void 0 : selected.title), /*#__PURE__*/ react.createElement(dropdown/* DropdownContent */.Nv, {
        alignment: alignment,
        width: width
    }, /*#__PURE__*/ react.createElement(Content, {
        onClick: handleOnClick,
        options: options,
        selected: selected,
        showAsRadioButtons: showAsRadioButtons
    })));
};
var Content = function(props) {
    var onClick = props.onClick, options = props.options, selected = props.selected, showAsRadioButtons = props.showAsRadioButtons;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, options.sort().map(function(option) {
        return /*#__PURE__*/ react.createElement("div", {
            key: option.title
        }, showAsRadioButtons ? /*#__PURE__*/ react.createElement(radiobutton/* RadioButton */.EU, {
            text: option.title,
            selectedValue: (selected === null || selected === void 0 ? void 0 : selected.value) === option.value,
            value: true,
            onClickHandler: function() {
                return onClick(option);
            }
        }) : /*#__PURE__*/ react.createElement(DropdownItem, {
            onClick: function() {
                return onClick(option);
            },
            disabled: Boolean((selected === null || selected === void 0 ? void 0 : selected.title) === option.title),
            "data-test": "DropdownOption"
        }, option.title));
    }));
};


/***/ }),

/***/ 55913:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ HorizontalScroll),
  "C": () => (/* binding */ horizontal_scroll)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/chevron-left/index.js
var chevron_left = __webpack_require__(22062);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/chevron-right/index.js
var chevron_right = __webpack_require__(46695);
// EXTERNAL MODULE: ./src/components/spinner/index.ts + 2 modules
var spinner = __webpack_require__(56627);
;// CONCATENATED MODULE: ./src/components/horizontal-scroll/constants.ts
var LOAD_MORE_ITEMS_LIMIT = 3;
var TRANSITION_TIME_MAX = 400;
var TRANSITION_TIME_MIN = 100;
var SHADOW_OVERLAY = 20;
var EPSILON = 32;
var MOCK_DIV = {
    scrollLeft: 0,
    clientWidth: 0
};

// EXTERNAL MODULE: ./src/components/horizontal-scroll/styles.ts
var styles = __webpack_require__(65773);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/button/index.js
var ui_button = __webpack_require__(17658);
;// CONCATENATED MODULE: ./src/components/horizontal-scroll/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}








function useHorizontalScroll(props) {
    var innerContainerRef = (0,react.useRef)();
    var outerContainerRef = (0,react.useRef)();
    var _showArrows;
    var ref = _slicedToArray((0,react.useState)((_showArrows = props.showArrows) !== null && _showArrows !== void 0 ? _showArrows : false), 2), hasStartArrow = ref[0], setHasStartArrow = ref[1];
    var _showArrows1;
    var ref1 = _slicedToArray((0,react.useState)((_showArrows1 = props.showArrows) !== null && _showArrows1 !== void 0 ? _showArrows1 : false), 2), hasEndArrow = ref1[0], setHasEndArrow = ref1[1];
    var getWidths = function() {
        if (!outerContainerRef.current || !innerContainerRef.current) return {
            scrollWidth: 0,
            clientWidth: 0,
            scrollableWidth: 0
        };
        return {
            clientWidth: innerContainerRef.current.clientWidth,
            scrollWidth: innerContainerRef.current.scrollWidth,
            scrollableWidth: Math.max(0, innerContainerRef.current.scrollWidth - innerContainerRef.current.clientWidth)
        };
    };
    var toggleArrows = (0,react.useCallback)(function(scrollLeft) {
        var ref = getWidths(), scrollWidth = ref.scrollWidth, scrollableWidth = ref.scrollableWidth, clientWidth = ref.clientWidth;
        var scrollRight = scrollableWidth - scrollLeft;
        setHasStartArrow(props.showArrows === "always" || scrollWidth > clientWidth && scrollLeft > 0);
        setHasEndArrow(props.showArrows === "always" || scrollWidth > clientWidth && scrollRight > 0);
    }, [
        props.showArrows
    ]);
    var handleScroll = function(e) {
        var ref;
        var ref1;
        toggleArrows((ref1 = (ref = e.target) === null || ref === void 0 ? void 0 : ref.scrollLeft) !== null && ref1 !== void 0 ? ref1 : 0);
    };
    var scrollTo = function(param) {
        var from = param.from, to = param.to;
        if (from === to) return;
        var distanceNormalize = Math.abs(to - from) / TRANSITION_TIME_MIN;
        var duration = Math.max(TRANSITION_TIME_MIN, Math.min(TRANSITION_TIME_MAX, TRANSITION_TIME_MIN * distanceNormalize));
        base/* animationUtils.tween */.ry.tween({
            from: from,
            to: to,
            duration: duration,
            onUpdate: function(value) {
                if (outerContainerRef.current) {
                    outerContainerRef.current.scrollLeft = Math.round(value);
                }
            }
        });
    };
    var togglePage = function(direction) {
        var round = function round(value, rounded) {
            return Math.abs(rounded - value) <= EPSILON ? rounded : value;
        };
        var ref;
        var ref1;
        var scrollLeft = (ref1 = (ref = outerContainerRef.current) === null || ref === void 0 ? void 0 : ref.scrollLeft) !== null && ref1 !== void 0 ? ref1 : 0;
        var ref2 = getWidths(), scrollableWidth = ref2.scrollableWidth, clientWidth = ref2.clientWidth;
        // This needs to match margin-left offset on li:not(:first-child)
        // so that it moves a complete "set" of items each click
        var marginOffset = 12;
        scrollTo({
            from: scrollLeft,
            to: direction === "prev" ? Math.max(0, round(scrollLeft - clientWidth - marginOffset, 0)) : Math.min(scrollableWidth, round(scrollLeft + clientWidth + marginOffset, scrollableWidth))
        });
    };
    var childrenCount = react.Children.count(props.children);
    (0,react.useEffect)(function() {
        var ref;
        var ref1;
        toggleArrows((ref1 = (ref = outerContainerRef.current) === null || ref === void 0 ? void 0 : ref.scrollLeft) !== null && ref1 !== void 0 ? ref1 : 0);
    }, [
        toggleArrows,
        childrenCount
    ]);
    return {
        innerContainerRef: innerContainerRef,
        outerContainerRef: outerContainerRef,
        handleScroll: handleScroll,
        togglePage: togglePage,
        hasStartArrow: hasStartArrow,
        hasEndArrow: hasEndArrow
    };
}
var HorizontalScroll = function(_param) {
    var itemWidth = _param.itemWidth, negativeMargin = _param.negativeMargin, _buttonSize = _param.buttonSize, buttonSize = _buttonSize === void 0 ? ui_button.ButtonSize.NORMAL : _buttonSize, props = _objectWithoutProperties(_param, [
        "itemWidth",
        "negativeMargin",
        "buttonSize"
    ]);
    var ref = useHorizontalScroll(props), innerContainerRef = ref.innerContainerRef, outerContainerRef = ref.outerContainerRef, handleScroll = ref.handleScroll, togglePage = ref.togglePage, hasStartArrow = ref.hasStartArrow, hasEndArrow = ref.hasEndArrow;
    return /*#__PURE__*/ react.createElement(styles/* HorizontalScrollContainer */.Oc, {
        "data-test": "HorizontalScroll",
        className: props.className,
        negativeMargin: negativeMargin
    }, /*#__PURE__*/ react.createElement(styles/* Inner */.Nh, {
        ref: function(div) {
            outerContainerRef.current = div;
        },
        onScroll: handleScroll
    }, props.showArrows !== false && /*#__PURE__*/ react.createElement(react.Fragment, null, hasStartArrow && /*#__PURE__*/ react.createElement(styles/* LeftArrow */.IT, {
        onClick: function() {
            return togglePage("prev");
        },
        size: buttonSize
    }, /*#__PURE__*/ react.createElement(chevron_left.IconChevronLeft, null)), hasEndArrow && /*#__PURE__*/ react.createElement(styles/* RightArrow */.UV, {
        onClick: function() {
            return togglePage("next");
        },
        size: buttonSize
    }, /*#__PURE__*/ react.createElement(chevron_right.IconChevronRight, null))), /*#__PURE__*/ react.createElement(styles/* List */.aV, {
        ref: function(div) {
            innerContainerRef.current = div;
        }
    }, react.Children.map(props.children, function(child, i) {
        return /*#__PURE__*/ react.createElement("li", {
            // eslint-disable-next-line react/no-array-index-key
            key: i,
            style: {
                flex: itemWidth ? "0 0 ".concat(itemWidth, "px") : undefined
            }
        }, child);
    }), props.loading && /*#__PURE__*/ react.createElement(styles/* Loader */.aN, {
        style: {
            lineHeight: "".concat(props.loadingHeight, "px")
        }
    }, /*#__PURE__*/ react.createElement(spinner/* Spinner */.$, {
        position: "none",
        isActive: true
    })))));
};
/* harmony default export */ const horizontal_scroll = (HorizontalScroll);


/***/ }),

/***/ 65773:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IT": () => (/* binding */ LeftArrow),
/* harmony export */   "Nh": () => (/* binding */ Inner),
/* harmony export */   "Oc": () => (/* binding */ HorizontalScrollContainer),
/* harmony export */   "UV": () => (/* binding */ RightArrow),
/* harmony export */   "aN": () => (/* binding */ Loader),
/* harmony export */   "aV": () => (/* binding */ List)
/* harmony export */ });
/* unused harmony exports ArrowIconRight, ArrowIconLeft */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71993);
/* harmony import */ var _prisjakt_ui_icon_chevron_left__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22062);
/* harmony import */ var _prisjakt_ui_icon_chevron_right__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46695);
/* harmony import */ var _prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7336);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61093);
/* harmony import */ var _prisjakt_design_tokens__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43220);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    width: calc(100% + 0.5em);\n    margin-right: -",
        ";\n    margin-left: -",
        ";\n\n    li:first-child {\n      padding-left: ",
        ";\n    }\n\n    li:last-child {\n      padding-right: ",
        ";\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    overflow: hidden;\n\n    li:first-child {\n      padding-left: ",
        ";\n    }\n\n    li:last-child {\n      padding-right: ",
        ";\n    }\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  height: 100%;\n  width: 100%;\n  position: relative;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  background: ",
        ";\n  &:hover {\n    background: ",
        ";\n  }\n  z-index: 2;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  opacity: 0;\n  transition: all 250ms ease;\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  left: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  right: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  -ms-overflow-style: none;\n  -webkit-overflow-scrolling: touch;\n  overflow: -moz-scrollbars-none;\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  user-select: none;\n  overflow-x: scroll;\n\n  &:hover {\n    > button {\n      opacity: 1;\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  list-style: none;\n  margin: 0;\n  display: flex;\n\n  > li {\n    padding: 1px;\n    padding-bottom: ",
        ";\n  }\n\n  > li:not(:first-child) {\n    margin-left: 12px;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  float: left;\n  width: 100px;\n  text-align: center;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}






var ArrowIconRight = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_icon_chevron_right__WEBPACK_IMPORTED_MODULE_2__.IconChevronRight).attrs(function() {
    return {
        color: "base300"
    };
}).withConfig({
    displayName: "ArrowIconRight",
    componentId: "sc-0-0"
})(_templateObject());
var ArrowIconLeft = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_icon_chevron_left__WEBPACK_IMPORTED_MODULE_1__.IconChevronLeft).attrs(function() {
    return {
        color: "base300"
    };
}).withConfig({
    displayName: "ArrowIconLeft",
    componentId: "sc-0-1"
})(_templateObject1());
var HorizontalScrollContainer = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "HorizontalScrollContainer",
    componentId: "sc-0-2"
})(_templateObject4(), src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .media.largeUp */ .BC.largeUp(_templateObject2(), _prisjakt_design_tokens__WEBPACK_IMPORTED_MODULE_5__.measurements.spacing050, _prisjakt_design_tokens__WEBPACK_IMPORTED_MODULE_5__.measurements.spacing050, _prisjakt_design_tokens__WEBPACK_IMPORTED_MODULE_5__.measurements.spacing050, _prisjakt_design_tokens__WEBPACK_IMPORTED_MODULE_5__.measurements.spacing050), src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .media.mediumDown */ .BC.mediumDown(_templateObject3(), _prisjakt_design_tokens__WEBPACK_IMPORTED_MODULE_5__.measurements.spacing050, _prisjakt_design_tokens__WEBPACK_IMPORTED_MODULE_5__.measurements.spacing050));
var arrow = function(theme) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject6(), theme.colors.base0, theme.colors.base100, src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .media.smallOnly */ .BC.smallOnly(_templateObject5()));
};
var arrowButtonAttrs = {
    elevation: _prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__.ButtonElevation.HIGH,
    type: _prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__.ButtonType.OUTLINED
};
var LeftArrow = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__.IconButton).attrs(arrowButtonAttrs).withConfig({
    displayName: "LeftArrow",
    componentId: "sc-0-3"
})(_templateObject7(), function(p) {
    return arrow(p.theme);
}, src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing075 */ .bK.measurements.spacing075);
var RightArrow = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__.IconButton).attrs(arrowButtonAttrs).withConfig({
    displayName: "RightArrow",
    componentId: "sc-0-4"
})(_templateObject8(), function(p) {
    return arrow(p.theme);
}, src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing075 */ .bK.measurements.spacing075);
var Inner = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Inner",
    componentId: "sc-0-5"
})(_templateObject9());
var List = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].ul.withConfig({
    displayName: "List",
    componentId: "sc-0-6"
})(_templateObject10(), src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var Loader = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].li.withConfig({
    displayName: "Loader",
    componentId: "sc-0-7"
})(_templateObject11());


/***/ }),

/***/ 19184:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": () => (/* binding */ CARD_WIDTH_DESKTOP),
/* harmony export */   "_": () => (/* binding */ MediumCardHorizontalScroll)
/* harmony export */ });
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61093);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71993);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55913);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    width: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    width: ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  li > * {\n    ",
        "\n\n    ",
        "\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var CARD_WIDTH_DESKTOP = "235px";
var CARD_WIDTH_MOBILE = "215px";
/**
 * Styled variant of HorizontalScroll that fits:
 * 1) four product cards (ProductGridCard) on each "page" of the component.
 * 2) Four article previews
 */ var MediumCardHorizontalScroll = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])(___WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .C).withConfig({
    displayName: "MediumCardHorizontalScroll",
    componentId: "sc-0-0"
})(_templateObject2(), src_components_base__WEBPACK_IMPORTED_MODULE_0__/* .media.smallUp */ .BC.smallUp(_templateObject(), CARD_WIDTH_MOBILE), src_components_base__WEBPACK_IMPORTED_MODULE_0__/* .media.mediumUp */ .BC.mediumUp(_templateObject1(), CARD_WIDTH_DESKTOP));


/***/ }),

/***/ 80245:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": () => (/* binding */ InfoList)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
;// CONCATENATED MODULE: ./src/components/info-list/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-wrap: wrap;\n    list-style: none;\n    margin: 0;\n    color: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  &:not(:last-child)::after {\n    content: '•';\n    padding: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var List = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "List",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject(), props.theme.text.secondary);
});
var Content = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Content",
    componentId: "sc-0-1"
})(_templateObject1());
var Item = styled_components_browser_esm["default"].li.withConfig({
    displayName: "Item",
    componentId: "sc-0-2"
})(_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/components/info-list/index.tsx
/* eslint-disable react/no-array-index-key */ 

var isStringArray = function(test) {
    return Array.isArray(test) && test.every(function(value) {
        return typeof value === "string";
    });
};
var InfoList = function(param) {
    var className = param.className, list = param.list;
    if (!(list === null || list === void 0 ? void 0 : list.length)) return null;
    return /*#__PURE__*/ react.createElement(List, {
        className: className
    }, list && isStringArray(list) && list.map(function(item, index) {
        return item && /*#__PURE__*/ react.createElement(Item, {
            key: index
        }, /*#__PURE__*/ react.createElement(Content, null, item));
    }), list && !isStringArray(list) && list.map(function(item, index) {
        return item && /*#__PURE__*/ react.createElement(Item, {
            key: index
        }, item);
    }));
};


/***/ }),

/***/ 24084:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "XZ": () => (/* reexport */ components_checkbox),
  "Y2": () => (/* reexport */ number_input),
  "Y8": () => (/* reexport */ components_radio),
  "ol": () => (/* reexport */ search),
  "Kx": () => (/* reexport */ text_area),
  "oi": () => (/* reexport */ text_input)
});

// UNUSED EXPORTS: CheckboxInput

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/ui/icons/index.ts + 4 modules
var icons = __webpack_require__(92356);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
;// CONCATENATED MODULE: ./src/components/inputs/components/checkbox/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  user-select: none;\n  font-weight: normal;\n  opacity: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  appearance: none;\n  outline: 0;\n  opacity: 0;\n  position: absolute;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      background-color: ",
        ";\n      border-color: ",
        ";\n      outline: 1px solid ",
        ";\n\n      svg {\n        background-color: ",
        ";\n      }\n\n      ",
        ":focus + & {\n        background-color: ",
        ";\n        border-color: ",
        ";\n        outline: 2px solid ",
        ";\n        svg {\n          background-color: ",
        ";\n        }\n      }\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      svg {\n        background-color: ",
        ";\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    border: 1px solid ",
        ";\n\n    ",
        " {\n      &:focus + & {\n        border-color: ",
        ";\n        outline: 1px solid ",
        ";\n      }\n    }\n\n    svg {\n      position: relative;\n      left: 1px;\n      top: 1px;\n      stroke-width: 6px;\n      path {\n        stroke: ",
        ";\n        fill: none;\n      }\n    }\n\n    ",
        ";\n\n    ",
        ";\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n      color: ",
        ";\n      font-weight: 600;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n  display: flex;\n  flex-direction: column;\n  color: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        " {\n        &:hover {\n          color: ",
        ";\n        }\n      }\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n      cursor: no-drop;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    cursor: pointer;\n    position: relative;\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}


var Checkbox = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Checkbox",
    componentId: "sc-0-0"
})(_templateObject(), function(props) {
    return props.disabled ? "0.5" : "1";
});
var Input = styled_components_browser_esm["default"].input.withConfig({
    displayName: "Input",
    componentId: "sc-0-1"
})(_templateObject1());
var CheckIconWrapper = styled_components_browser_esm["default"].span.withConfig({
    displayName: "CheckIconWrapper",
    componentId: "sc-0-2"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject4(), props.theme.lines.secondary, Input, props.theme.colors.maybeBlue700, props.theme.colors.maybeBlue700, props.theme.colors.base0, (props.checked || props.partial) && (0,styled_components_browser_esm.css)(_templateObject2(), props.theme.colors.maybeBlue700, props.theme.colors.maybeBlue700, props.theme.colors.maybeBlue700, props.theme.colors.maybeBlue700, Input, props.theme.colors.maybeBlue700, props.theme.colors.maybeBlue700, props.theme.colors.maybeBlue700, props.theme.colors.maybeBlue700), (props.checked || props.partial) && (0,styled_components_browser_esm.css)(_templateObject3(), props.theme.lines.highlight));
});
var LabelText = styled_components_browser_esm["default"].span.withConfig({
    displayName: "LabelText",
    componentId: "sc-0-3"
})(_templateObject6(), base/* layout.listSideMargin */.bK.listSideMargin, function(props) {
    return props.theme.colors.base600;
}, function(props) {
    return props.labelStyle === "bold" && (0,styled_components_browser_esm.css)(_templateObject5(), function(p) {
        return p.theme.text.callToAction;
    });
});
var Label = styled_components_browser_esm["default"].label.withConfig({
    displayName: "Label",
    componentId: "sc-0-4"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject9(), !props.disabled && (0,styled_components_browser_esm.css)(_templateObject7(), LabelText, props.theme.text.callToActionHover), props.disabled && (0,styled_components_browser_esm.css)(_templateObject8()));
});
var Helper = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Helper",
    componentId: "sc-0-5"
})(_templateObject10(), (0,base/* remCalc */.vR)(12), function(props) {
    return props.warning ? props.theme.colors.negative700 : props.theme.colors.base500;
});

;// CONCATENATED MODULE: ./src/components/inputs/components/checkbox/index.tsx
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var CheckboxInput = function(param) {
    var name = param.name, onChange = param.onChange, checked = param.checked, partial = param.partial, tabIndex = param.tabIndex, disabled = param.disabled, required = param.required;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(Input, {
        required: required,
        id: name,
        name: name,
        type: "checkbox",
        checked: checked,
        onChange: onChange,
        disabled: disabled,
        tabIndex: tabIndex,
        value: checked ? "1" : "0"
    }), /*#__PURE__*/ react.createElement(CheckIconWrapper, {
        checked: checked,
        partial: partial
    }, /*#__PURE__*/ react.createElement(icons/* CheckIcon */.nQ, {
        checked: checked,
        partial: partial,
        height: 14
    })));
};
CheckboxInput.defaultProps = {
    name: undefined,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onChange: function() {},
    checked: false,
    partial: false,
    tabIndex: "0",
    disabled: false,
    required: false
};
var checkbox_Checkbox = function(_param) {
    var name = _param.name, checked = _param.checked, partial = _param.partial, helper = _param.helper, warning = _param.warning, label = _param.label, _labelStyle = _param.labelStyle, labelStyle = _labelStyle === void 0 ? "normal" : _labelStyle, onChange = _param.onChange, className = _param.className, tabIndex = _param.tabIndex, disabled = _param.disabled, children = _param.children, required = _param.required, props = _objectWithoutProperties(_param, [
        "name",
        "checked",
        "partial",
        "helper",
        "warning",
        "label",
        "labelStyle",
        "onChange",
        "className",
        "tabIndex",
        "disabled",
        "children",
        "required"
    ]);
    var labelText = children || label;
    return /*#__PURE__*/ react.createElement(Checkbox, {
        className: className,
        disabled: disabled,
        "data-test": props["data-test"]
    }, /*#__PURE__*/ react.createElement(Label, {
        htmlFor: name,
        disabled: disabled
    }, /*#__PURE__*/ react.createElement(CheckboxInput, {
        name: name,
        onChange: onChange,
        checked: checked,
        partial: partial,
        tabIndex: tabIndex,
        disabled: disabled,
        required: required
    }), /*#__PURE__*/ react.createElement(LabelText, {
        labelStyle: labelStyle
    }, /*#__PURE__*/ react.createElement("span", null, labelText), helper && /*#__PURE__*/ react.createElement(Helper, {
        warning: warning
    }, helper))));
};
checkbox_Checkbox.defaultProps = {
    label: null,
    labelStyle: "normal",
    checked: false,
    partial: false,
    helper: null,
    warning: false,
    className: null,
    tabIndex: "0",
    disabled: false,
    children: null,
    required: false,
    "data-test": undefined
};
/* harmony default export */ const components_checkbox = (checkbox_Checkbox);

// EXTERNAL MODULE: ./node_modules/.pnpm/styled-tools@1.7.2/node_modules/styled-tools/dist/es/index.js + 7 modules
var es = __webpack_require__(55703);
;// CONCATENATED MODULE: ./src/components/inputs/components/input/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n      border-color: ",
        ";\n    "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n      border-radius: 4px;\n    "
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  background: ",
        ";\n  padding: ",
        ";\n  border: 1px solid ",
        ";\n  outline: 0;\n  ",
        "\n\n  ",
        "\n\n  &:focus {\n    border-color: ",
        ";\n    box-shadow: inset 0 0 0 1px ",
        ";\n  }\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = styles_taggedTemplateLiteral([
        "\n      background: ",
        ";\n      border: 1px solid ",
        ";\n    "
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = styles_taggedTemplateLiteral([
        "\n  ",
        ";\n\n  ",
        "\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = styles_taggedTemplateLiteral([
        "\n  ",
        ";\n  resize: vertical;\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = styles_taggedTemplateLiteral([
        "\n  cursor: pointer;\n  user-select: none;\n"
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = styles_taggedTemplateLiteral([
        "\n      color: ",
        ";\n    "
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    var data = styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = styles_taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = styles_taggedTemplateLiteral([
        "\n  white-space: nowrap;\n  margin-left: ",
        ";\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}



var sharedInputStyle = (0,styled_components_browser_esm.css)(styles_templateObject2(), function(p) {
    return p.theme.inputs.primary.bg;
}, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.theme.inputs.primary.border;
}, function(props) {
    return props.warning && (0,styled_components_browser_esm.css)(styles_templateObject(), function(p) {
        return p.theme.text.negative;
    });
}, (0,es/* switchProp */.db)("variant", {
    rounded: (0,styled_components_browser_esm.css)(styles_templateObject1())
}), function(p) {
    return p.theme.inputs.primary.borderFocus;
}, function(p) {
    return p.theme.inputs.primary.borderFocus;
});
var InputWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "InputWrapper",
    componentId: "sc-0-0"
})(styles_templateObject3());
var styles_Input = styled_components_browser_esm["default"].input.withConfig({
    displayName: "Input",
    componentId: "sc-0-1"
})(styles_templateObject5(), sharedInputStyle, function(p) {
    return p.disabled && (0,styled_components_browser_esm.css)(styles_templateObject4(), p.theme.inputs.secondary.bg, p.theme.inputs.secondary.border);
});
var TextArea = styled_components_browser_esm["default"].textarea.withConfig({
    displayName: "TextArea",
    componentId: "sc-0-2"
})(styles_templateObject6(), sharedInputStyle);
var styles_Label = styled_components_browser_esm["default"].label.withConfig({
    displayName: "Label",
    componentId: "sc-0-3"
})(styles_templateObject7());
var styles_LabelText = styled_components_browser_esm["default"].span.withConfig({
    displayName: "LabelText",
    componentId: "sc-0-4"
})(styles_templateObject8());
var styles_Helper = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Helper",
    componentId: "sc-0-5"
})(styles_templateObject10(), function(props) {
    return props.warning && (0,styled_components_browser_esm.css)(styles_templateObject9(), function(p) {
        return p.theme.text.negative;
    });
});
var HelperWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "HelperWrapper",
    componentId: "sc-0-6"
})(_templateObject11(), base/* layout.measurements.fontSizeNormal */.bK.measurements.fontSizeNormal, function(p) {
    return p.theme.text.tertiary;
});
var CharCounter = styled_components_browser_esm["default"].span.withConfig({
    displayName: "CharCounter",
    componentId: "sc-0-7"
})(_templateObject12(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/components/inputs/components/input/text-input.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function text_input_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = text_input_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function text_input_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



var TextInput = function(_param) {
    var name = _param.name, _onChange = _param.onChange, onChange = _onChange === void 0 ? base/* noop */.ZT : _onChange, _onKeyUp = _param.onKeyUp, onKeyUp = _onKeyUp === void 0 ? base/* noop */.ZT : _onKeyUp, label = _param.label, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, defaultValue = _param.defaultValue, value = _param.value, _type = _param.type, type = _type === void 0 ? "text" : _type, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? undefined : _placeholder, _tabIndex = _param.tabIndex, tabIndex = _tabIndex === void 0 ? 0 : _tabIndex, _helper = _param.helper, helper = _helper === void 0 ? null : _helper, _warning = _param.warning, warning = _warning === void 0 ? false : _warning, _className = _param.className, className = _className === void 0 ? undefined : _className, _children = _param.children, children = _children === void 0 ? null : _children, inputRef = _param.inputRef, _required = _param.required, required = _required === void 0 ? false : _required, minLength = _param.minLength, maxLength = _param.maxLength, _customInputProps = _param.customInputProps, customInputProps = _customInputProps === void 0 ? {} : _customInputProps, _variant = _param.variant, variant = _variant === void 0 ? "default" : _variant, autoFocus = _param.autoFocus, autoComplete = _param.autoComplete, ariaLabel = _param.ariaLabel, onInvalid = _param.onInvalid, cancelButton = _param.cancelButton, onClick = _param.onClick, showCounter = _param.showCounter, otherProps = text_input_objectWithoutProperties(_param, [
        "name",
        "onChange",
        "onKeyUp",
        "label",
        "disabled",
        "defaultValue",
        "value",
        "type",
        "placeholder",
        "tabIndex",
        "helper",
        "warning",
        "className",
        "children",
        "inputRef",
        "required",
        "minLength",
        "maxLength",
        "customInputProps",
        "variant",
        "autoFocus",
        "autoComplete",
        "ariaLabel",
        "onInvalid",
        "cancelButton",
        "onClick",
        "showCounter"
    ]);
    var ref = _slicedToArray((0,react.useState)((defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.length) || (value === null || value === void 0 ? void 0 : value.length) || 0), 2), characterCount = ref[0], setCharacterCount = ref[1];
    var handleOnChange = function(event) {
        setCharacterCount(event.target.value.length);
        onChange(event);
    };
    return /*#__PURE__*/ react.createElement(InputWrapper, {
        className: className
    }, /*#__PURE__*/ react.createElement(styles_Label, {
        htmlFor: name
    }, /*#__PURE__*/ react.createElement(styles_LabelText, null, label), cancelButton, children), /*#__PURE__*/ react.createElement(styles_Input, _extends({
        autoFocus: autoFocus,
        warning: warning,
        required: required,
        name: name,
        id: name,
        type: type,
        defaultValue: defaultValue,
        value: value,
        placeholder: placeholder,
        tabIndex: tabIndex,
        disabled: disabled,
        onChange: handleOnChange,
        onKeyUp: onKeyUp,
        ref: inputRef,
        minLength: minLength,
        maxLength: maxLength,
        variant: variant,
        "aria-label": ariaLabel,
        autoComplete: autoComplete,
        onInvalid: onInvalid,
        onClick: onClick
    }, customInputProps, otherProps)), helper && /*#__PURE__*/ react.createElement(HelperWrapper, null, /*#__PURE__*/ react.createElement(styles_Helper, {
        warning: warning
    }, helper), showCounter && maxLength && /*#__PURE__*/ react.createElement(CharCounter, null, "".concat(characterCount, " / ").concat(maxLength))));
};
/* harmony default export */ const text_input = (TextInput);

;// CONCATENATED MODULE: ./src/components/inputs/components/input/text-area.tsx


var text_area_TextArea = function(param) {
    var name = param.name, onChange = param.onChange, label = param.label, disabled = param.disabled, defaultValue = param.defaultValue, placeholder = param.placeholder, tabIndex = param.tabIndex, helper = param.helper, warning = param.warning, className = param.className, children = param.children, rows = param.rows, inputRef = param.inputRef, required = param.required, minLength = param.minLength, _variant = param.variant, variant = _variant === void 0 ? "default" : _variant, onInvalid = param.onInvalid;
    return /*#__PURE__*/ react.createElement(InputWrapper, {
        className: className
    }, /*#__PURE__*/ react.createElement(styles_Label, {
        htmlFor: name
    }, /*#__PURE__*/ react.createElement(styles_LabelText, null, label), children), /*#__PURE__*/ react.createElement(TextArea, {
        warning: warning,
        required: required,
        ref: inputRef,
        name: name,
        id: name,
        rows: rows,
        placeholder: placeholder,
        tabIndex: tabIndex,
        disabled: disabled,
        onChange: onChange,
        defaultValue: defaultValue,
        minLength: minLength,
        onInvalid: onInvalid,
        variant: variant
    }), /*#__PURE__*/ react.createElement(styles_Helper, {
        warning: warning
    }, helper));
};
text_area_TextArea.defaultProps = {
    label: null,
    defaultValue: undefined,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onChange: function() {},
    disabled: false,
    placeholder: null,
    tabIndex: "0",
    helper: null,
    warning: false,
    className: null,
    children: null,
    rows: 4,
    inputRef: undefined,
    required: false,
    minlength: 0
};
/* harmony default export */ const text_area = (text_area_TextArea);

;// CONCATENATED MODULE: ./src/components/inputs/components/input/number-input.tsx
function number_input_extends() {
    number_input_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return number_input_extends.apply(this, arguments);
}


var NumberInput = function(props) {
    return /*#__PURE__*/ react.createElement(text_input, number_input_extends({
        type: "number"
    }, props));
};
/* harmony default export */ const number_input = (NumberInput);

;// CONCATENATED MODULE: ./src/components/inputs/components/radio/styles.ts
function radio_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function radio_styles_templateObject() {
    var data = radio_styles_taggedTemplateLiteral([
        "\n  user-select: none;\n  font-weight: normal;\n  opacity: ",
        ";\n"
    ]);
    radio_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function radio_styles_templateObject1() {
    var data = radio_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  cursor: pointer;\n  position: relative;\n"
    ]);
    radio_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function radio_styles_templateObject2() {
    var data = radio_styles_taggedTemplateLiteral([
        "\n  &:focus {\n    border-color: ",
        ";\n  }\n"
    ]);
    radio_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function radio_styles_templateObject3() {
    var data = radio_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  color: ",
        ";\n  padding-left: ",
        ";\n"
    ]);
    radio_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function radio_styles_templateObject4() {
    var data = radio_styles_taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  width: 100%;\n  color: ",
        ";\n"
    ]);
    radio_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var Radio = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Radio",
    componentId: "sc-0-0"
})(radio_styles_templateObject(), function(props) {
    return props.disabled ? "0.5" : "1";
});
var radio_styles_Label = styled_components_browser_esm["default"].label.withConfig({
    displayName: "Label",
    componentId: "sc-0-1"
})(radio_styles_templateObject1());
var radio_styles_Input = styled_components_browser_esm["default"].input.withConfig({
    displayName: "Input",
    componentId: "sc-0-2"
})(radio_styles_templateObject2(), function(p) {
    return p.theme.colors.base700;
});
var radio_styles_LabelText = styled_components_browser_esm["default"].span.withConfig({
    displayName: "LabelText",
    componentId: "sc-0-3"
})(radio_styles_templateObject3(), function(p) {
    return p.theme.colors.base700;
}, (0,base/* remCalc */.vR)(6));
var radio_styles_Helper = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Helper",
    componentId: "sc-0-4"
})(radio_styles_templateObject4(), (0,base/* remCalc */.vR)(12), function(p) {
    return p.warning ? p.theme.colors.negative700 : p.theme.colors.base500;
});

;// CONCATENATED MODULE: ./src/components/inputs/components/radio/index.tsx


var radio_Radio = function(param) {
    var name = param.name, id = param.id, helper = param.helper, warning = param.warning, label = param.label, onChange = param.onChange, className = param.className, tabIndex = param.tabIndex, disabled = param.disabled, children = param.children, value = param.value, required = param.required, defaultChecked = param.defaultChecked, checked = param.checked;
    var labelText = children || label;
    return /*#__PURE__*/ react.createElement(Radio, {
        className: className,
        disabled: disabled
    }, /*#__PURE__*/ react.createElement(radio_styles_Label, {
        htmlFor: id
    }, /*#__PURE__*/ react.createElement(radio_styles_Input, {
        checked: checked,
        defaultChecked: defaultChecked,
        required: required,
        id: id,
        name: name,
        type: "radio",
        onChange: onChange,
        disabled: disabled,
        tabIndex: tabIndex,
        value: value
    }), /*#__PURE__*/ react.createElement(radio_styles_LabelText, null, /*#__PURE__*/ react.createElement("span", null, labelText), helper && /*#__PURE__*/ react.createElement(radio_styles_Helper, {
        warning: warning
    }, helper))));
};
radio_Radio.defaultProps = {
    label: null,
    helper: null,
    warning: false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onChange: function() {},
    className: null,
    tabIndex: "0",
    disabled: false,
    children: null,
    value: "",
    required: false
};
/* harmony default export */ const components_radio = (radio_Radio);

// EXTERNAL MODULE: ./src/components/spinner/index.ts + 2 modules
var spinner = __webpack_require__(56627);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/close-outlined/index.js
var close_outlined = __webpack_require__(40483);
;// CONCATENATED MODULE: ./src/components/inputs/components/search/styles.ts
function search_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function search_styles_templateObject() {
    var data = search_styles_taggedTemplateLiteral([
        "\n    height: ",
        "px;\n  "
    ]);
    search_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function search_styles_templateObject1() {
    var data = search_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: ",
        "px;\n  overflow: hidden;\n  position: relative;\n  border-radius: ",
        ";\n  background: white;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    search_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function search_styles_templateObject2() {
    var data = search_styles_taggedTemplateLiteral([
        "\n  background: transparent;\n  border: none;\n  width: 100%;\n  height: 100%;\n  flex-grow: 1;\n  padding: 0.5rem 10px;\n  border-radius: 5px;\n\n  &:focus {\n    outline: none;\n  }\n"
    ]);
    search_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function search_styles_templateObject3() {
    var data = search_styles_taggedTemplateLiteral([
        "\n    height: ",
        ";\n    padding: 0 10px;\n  "
    ]);
    search_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function search_styles_templateObject4() {
    var data = search_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  outline: none;\n  height: ",
        "px;\n  margin: -0.2rem;\n  padding: 0 20px;\n  border-top-right-radius: ",
        ";\n  border-bottom-right-radius: ",
        ";\n  background: ",
        ";\n  border-left: 1px solid ",
        ";\n\n  ",
        "\n\n  svg path {\n    fill: ",
        ";\n  }\n"
    ]);
    search_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function search_styles_templateObject5() {
    var data = search_styles_taggedTemplateLiteral([
        "\n  font-size: 19px;\n  padding: 0.6rem;\n  visibility: hidden;\n  outline: none;\n\n  ",
        "\n"
    ]);
    search_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function search_styles_templateObject6() {
    var data = search_styles_taggedTemplateLiteral([
        ""
    ]);
    search_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var searchHeightMobile = base/* layout.searchBar.height.mobile.value */.bK.searchBar.height.mobile.value;
var searchHeight = base/* layout.searchBar.height.desktop.value */.bK.searchBar.height.desktop.value;
var Block = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Block",
    componentId: "sc-0-0"
})(search_styles_templateObject1(), searchHeight, base/* layout.borderRadius */.bK.borderRadius, function(p) {
    return p.hasResults ? "border-radius: ".concat(base/* layout.borderRadius */.bK.borderRadius, " ").concat(base/* layout.borderRadius */.bK.borderRadius, " 0px 0px;") : "";
}, base/* media.smallOnly */.BC.smallOnly(search_styles_templateObject(), searchHeightMobile));
var search_styles_Input = styled_components_browser_esm["default"].input.withConfig({
    displayName: "Input",
    componentId: "sc-0-1"
})(search_styles_templateObject2());
var FullSearchButton = styled_components_browser_esm["default"].button.withConfig({
    displayName: "FullSearchButton",
    componentId: "sc-0-2"
})(search_styles_templateObject4(), searchHeight - 10, base/* layout.borderRadius */.bK.borderRadius, base/* layout.borderRadius */.bK.borderRadius, function(p) {
    return base/* colorUtils.setRgbaAlpha */.$n.setRgbaAlpha(p.theme.bg.secondary, 0);
}, function(p) {
    return p.theme.colors.base200;
}, base/* media.smallOnly */.BC.smallOnly(search_styles_templateObject3(), searchHeightMobile - 10), base/* colorUtils.shadeColor */.$n.shadeColor(base/* brandColors.pricespy */.D2.pricespy, 15));
var ClearButton = styled_components_browser_esm["default"].button.withConfig({
    displayName: "ClearButton",
    componentId: "sc-0-3"
})(search_styles_templateObject5(), function(p) {
    return p.visible ? "visibility: visible;" : "";
});
var CloseIcon = (0,styled_components_browser_esm["default"])(close_outlined/* IconCloseOutlined */.H).attrs({
    color: "base400"
}).withConfig({
    displayName: "CloseIcon",
    componentId: "sc-0-4"
})(search_styles_templateObject6());

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/magnifier/index.js
var magnifier = __webpack_require__(38314);
;// CONCATENATED MODULE: ./src/components/inputs/components/search/index.tsx




var Search = function(param) {
    var className = param.className, inputValue = param.inputValue, onChange = param.onChange, onFocus = param.onFocus, onBlur = param.onBlur, onSearch = param.onSearch, hasResults = param.hasResults, placeholder = param.placeholder, setInputValue = param.setInputValue, isSearching = param.isSearching;
    var clearInput = react.useCallback(function() {
        onChange("");
        setInputValue("");
    }, [
        onChange,
        setInputValue
    ]);
    var onSearchButtonClick = react.useCallback(function() {
        onSearch(inputValue);
    }, [
        onSearch,
        inputValue
    ]);
    var onInputChange = react.useCallback(function(param) {
        var target = param.target;
        onChange(target.value);
        setInputValue(target.value);
    }, [
        onChange,
        setInputValue
    ]);
    var handleFocus = react.useCallback(function(e) {
        onFocus(e.target.value);
    }, [
        onFocus
    ]);
    return /*#__PURE__*/ react.createElement(Block, {
        hasResults: hasResults,
        className: className
    }, /*#__PURE__*/ react.createElement(search_styles_Input, {
        onChange: onInputChange,
        type: "text",
        value: inputValue,
        placeholder: placeholder,
        onFocus: handleFocus,
        onBlur: onBlur
    }), /*#__PURE__*/ react.createElement(ClearButton, {
        type: "button",
        visible: inputValue,
        onClick: clearInput
    }, /*#__PURE__*/ react.createElement(CloseIcon, {
        size: 20
    })), /*#__PURE__*/ react.createElement(FullSearchButton, {
        type: "button",
        onClick: onSearchButtonClick
    }, isSearching ? /*#__PURE__*/ react.createElement(spinner/* Spinner */.$, {
        isActive: isSearching,
        position: "none"
    }) : /*#__PURE__*/ react.createElement(magnifier/* IconMagnifier */.j, null)));
};
Search.defaultProps = {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onChange: function() {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onFocus: function() {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onSearch: function() {},
    hasResults: false,
    placeholder: undefined
};
/* harmony default export */ const search = (Search);

;// CONCATENATED MODULE: ./src/components/inputs/index.ts









/***/ }),

/***/ 8458:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": () => (/* binding */ LayoutMode)
/* harmony export */ });
var LayoutMode;
(function(LayoutMode) {
    LayoutMode["GRID"] = "grid";
    LayoutMode["LIST"] = "list";
    LayoutMode["COMPACT_LIST"] = "compact_list";
    LayoutMode["TABLE"] = "table";
})(LayoutMode || (LayoutMode = {}));


/***/ }),

/***/ 67506:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": () => (/* binding */ Lazy)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1236);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


function usePrevious(value) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        ref.current = value;
    });
    return ref.current;
}
var Lazy = function(param) {
    var _className = param.className, className = _className === void 0 ? undefined : _className, _children = param.children, children = _children === void 0 ? null : _children, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? null : _placeholder, _offset = param.offset, offset = _offset === void 0 ? 100 : _offset, _loadOnIdle = param.loadOnIdle, loadOnIdle = _loadOnIdle === void 0 ? false : _loadOnIdle;
    var scheduleLoadOnIdle = function scheduleLoadOnIdle() {
        if (window && window.requestIdleCallback) {
            var idleHandler = window.requestIdleCallback(load);
            setAbortIdle(function() {
                window.cancelIdleCallback(idleHandler);
                setAbortIdle(null);
            });
        } else {
            var timeoutHandler = setTimeout(load, 100);
            setAbortIdle(function() {
                clearTimeout(timeoutHandler);
                setAbortIdle(null);
            });
        }
    };
    var ref = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function() {
        return "production" === "test";
    }), 2), shouldLoad = ref[0], setShouldLoad = ref[1];
    // eslint-disable-next-line @typescript-eslint/ban-types
    var ref1 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), 2), abortIdle = ref1[0], setAbortIdle = ref1[1];
    var previousLoadOnIdle = usePrevious(loadOnIdle);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (loadOnIdle && shouldLoad) {
            scheduleLoadOnIdle();
        }
        return function() {
            if (abortIdle) {
                abortIdle();
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!previousLoadOnIdle && loadOnIdle && !shouldLoad) {
            scheduleLoadOnIdle();
        }
    });
    var load = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        setShouldLoad(true);
        if (abortIdle) {
            abortIdle();
        }
    }, [
        abortIdle
    ]);
    var onChangeHandler = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(inView, entry) {
        if (!shouldLoad && isInView(inView, entry)) {
            load();
        }
    }, [
        load,
        shouldLoad
    ]);
    if (shouldLoad) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
    }
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_intersection_observer__WEBPACK_IMPORTED_MODULE_1__/* .InView */ .df, {
        rootMargin: "".concat(offset, "px"),
        onChange: onChangeHandler
    }, function(param) {
        var ref = param.ref, inView = param.inView;
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
            ref: ref,
            className: className
        }, typeof placeholder === "function" ? placeholder({
            inView: inView
        }) : placeholder);
    });
};
function isInView(inView, entry) {
    return inView || entry && entry.intersectionRatio > 0;
}


/***/ }),

/***/ 30082:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ loader)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/spinner/index.ts + 2 modules
var spinner = __webpack_require__(56627);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
;// CONCATENATED MODULE: ./src/components/loader/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n        0% { opacity: 0; }\n        50% { opacity: 0 }\n        100%   { opacity: 1; }\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      opacity: 0;\n      animation: ",
        " 0.8s;\n      animation-fill-mode: forwards;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  height: 70vh;\n\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var LoaderRoot = styled_components_browser_esm["default"].div.withConfig({
    displayName: "LoaderRoot",
    componentId: "sc-0-0"
})(_templateObject2(), function(props) {
    return props.fadeIn && (0,styled_components_browser_esm.css)(_templateObject1(), (0,styled_components_browser_esm.keyframes)(_templateObject()));
});

;// CONCATENATED MODULE: ./src/components/loader/index.tsx



var Loader = function(param) {
    var _fadeIn = param.fadeIn, fadeIn = _fadeIn === void 0 ? true : _fadeIn, dataTestId = param.dataTestId;
    return /*#__PURE__*/ react.createElement(LoaderRoot, {
        fadeIn: fadeIn,
        "data-testid": dataTestId
    }, /*#__PURE__*/ react.createElement(spinner/* Spinner */.$, {
        size: 48,
        isActive: true
    }));
};
/* harmony default export */ const loader = (Loader);


/***/ }),

/***/ 59106:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ location_and_currency_info)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./src/components/show-more/index.tsx + 1 modules
var show_more = __webpack_require__(12884);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
// EXTERNAL MODULE: ./src/components/country-flag/index.ts + 2 modules
var country_flag = __webpack_require__(72154);
;// CONCATENATED MODULE: ./src/components/location-and-currency-info/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      font-size: ",
        ";\n      color: ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    align-items: center;\n    color: ",
        ";\n    margin: 0;\n\n    ",
        "\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  margin-right: ",
        ";\n\n  img {\n    height: auto;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var LocationAndCurrencyInfo = styled_components_browser_esm["default"].div.withConfig({
    displayName: "LocationAndCurrencyInfo",
    componentId: "sc-0-0"
})(_templateObject());
var Text = styled_components_browser_esm["default"].p.withConfig({
    displayName: "Text",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject2(), props.theme.text.secondary, props.textSize === "small" && (0,styled_components_browser_esm.css)(_templateObject1(), base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall, props.theme.text.tertiary));
});
var CountryFlag = (0,styled_components_browser_esm["default"])(country_flag/* CountryFlag */.A).withConfig({
    displayName: "CountryFlag",
    componentId: "sc-0-2"
})(_templateObject3(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025);

;// CONCATENATED MODULE: ./src/components/location-and-currency-info/index.tsx




var location_and_currency_info_LocationAndCurrencyInfo = function(param) {
    var className = param.className, countryCode = param.countryCode, countryName = param.countryName, currency = param.currency, id = param.id, marketplace = param.marketplace, _minify = param.minify, minify = _minify === void 0 ? false : _minify, storeName = param.storeName, _textSize = param.textSize, textSize = _textSize === void 0 ? "normal" : _textSize;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var shouldMinify = minify && marketplace;
    var textIdentifier = "text-id-".concat(id);
    var renderLocationAndCurrencyInfo = function(locationAndCurrencyInfo) {
        return /*#__PURE__*/ react.createElement(LocationAndCurrencyInfo, {
            className: className
        }, /*#__PURE__*/ react.createElement(CountryFlag, {
            countryCode: countryCode,
            showTitleAsTooltip: false
        }), shouldMinify ? /*#__PURE__*/ react.createElement(show_more/* default */.Z, {
            textIdentifier: textIdentifier,
            hideOnExpand: true,
            maxHeight: 32,
            size: "small"
        }, /*#__PURE__*/ react.createElement(Text, {
            id: textIdentifier,
            textSize: textSize
        }, locationAndCurrencyInfo)) : /*#__PURE__*/ react.createElement(Text, {
            textSize: textSize
        }, locationAndCurrencyInfo));
    };
    if (marketplace && storeName && countryName) return renderLocationAndCurrencyInfo([
        t("store", "store.is-marketplace", {
            storeName: storeName,
            country: countryName
        }),
        currency && t("store", "store.uses-currency", {
            currency: currency
        })
    ].filter(function(item) {
        return item;
    }).join(" "));
    var locationAndCurrencyInfo = [
        countryName && t("store", "store.located-in", {
            country: countryName
        }),
        currency && t("store", "store.uses-currency", {
            currency: currency
        })
    ].filter(function(item) {
        return item;
    }).join(" ");
    return renderLocationAndCurrencyInfo(locationAndCurrencyInfo);
};
/* harmony default export */ const location_and_currency_info = (location_and_currency_info_LocationAndCurrencyInfo);


/***/ }),

/***/ 68410:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": () => (/* binding */ useLocationContext),
/* harmony export */   "v": () => (/* binding */ LocationProvider)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3616);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


var LocationContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createContext({
    currentLocation: undefined,
    previousLocation: undefined
});
var LocationProvider = function(param) {
    var children = param.children;
    var location = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_1__/* .useLocation */ .TH)();
    var ref = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), 2), previousLocation = ref[0], setPreviousLocation = ref[1];
    var ref1 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), 2), currentLocation = ref1[0], setCurrentLocation = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (currentLocation) {
            setPreviousLocation(currentLocation);
        }
        setCurrentLocation(location.pathname + location.search);
    }, [
        location.pathname,
        location.search
    ]);
    var contextValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return {
            currentLocation: currentLocation,
            previousLocation: previousLocation
        };
    }, [
        currentLocation,
        previousLocation
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(LocationContext.Provider, {
        value: contextValue
    }, children);
};
function useLocationContext() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(LocationContext);
}


/***/ }),

/***/ 93910:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": () => (/* binding */ LoginInfoBanner)
/* harmony export */ });
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23114);

var LoginInfoBanner = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "login-info-banner";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | login-info-banner */ 802).then(__webpack_require__.bind(__webpack_require__, 93785));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(93785);
        }
        return eval("require.resolve")("./login-info-banner");
    }
});


/***/ }),

/***/ 8589:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": () => (/* binding */ Logo)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18026);


var suffix = function(styling) {
    switch(styling){
        case "light":
            return "_white";
        case "beta":
            return "_beta";
        case "v2-light":
            return "_v2_light";
        case "v2-dark":
            return "_v2_dark";
        default:
            return "";
    }
};
var Logo = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(function(param) {
    var companyName = param.companyName, market = param.market, styling = param.styling, className = param.className;
    var context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_1__/* .AppContext */ .Il);
    if (!market) {
        return null;
    }
    var cdn = context.market && context.market.cdn ? context.market.cdn : "https://cdn.pji.nu";
    var logo = "".concat(cdn, "/g/rfe/logos/logo_").concat(market).concat(suffix(styling), ".svg");
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
        alt: companyName,
        src: logo,
        className: className
    });
});


/***/ }),

/***/ 54674:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23114);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}


var Modal = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "extra";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | extra */ 737).then(__webpack_require__.bind(__webpack_require__, 62122));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(62122);
        }
        return eval("require.resolve")("./modal");
    }
});
var ModalLoader = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Modal, _extends({}, props));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ModalLoader);


/***/ }),

/***/ 62122:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _prisjakt_ui_modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58709);


var APP_ROOT_ID = "root";
var MODAL_ROOT_ID = "root-modal";
var ModalComponent = function(props) {
    var children = props.children, className = props.className, isOpen = props.isOpen, onRequestClose = props.onRequestClose, _size = props.size, size = _size === void 0 ? _prisjakt_ui_modal__WEBPACK_IMPORTED_MODULE_1__/* .ModalSizeEnum.SMALL */ .E$.SMALL : _size, style = props.style, title = props.title;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_modal__WEBPACK_IMPORTED_MODULE_1__/* .Modal */ .u_, {
        className: className,
        isOpen: isOpen,
        onRequestClose: onRequestClose,
        parentSelectorId: MODAL_ROOT_ID,
        rootId: APP_ROOT_ID,
        size: size,
        style: style,
        title: title
    }, children);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ModalComponent);


/***/ }),

/***/ 66571:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hn": () => (/* binding */ SHOW_MODAL),
/* harmony export */   "K4": () => (/* binding */ showModal),
/* harmony export */   "VG": () => (/* binding */ hideModal),
/* harmony export */   "ZP": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "_D": () => (/* binding */ HIDE_MODAL)
/* harmony export */ });
var SHOW_MODAL = "SHOW_MODAL";
var HIDE_MODAL = "HIDE_MODAL";
var showModal = function(modal) {
    return {
        type: SHOW_MODAL,
        modal: modal
    };
};
var hideModal = function() {
    return {
        type: HIDE_MODAL
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
    showModal: showModal,
    hideModal: hideModal
});


/***/ }),

/***/ 58203:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23114);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}


var Modal = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "extra";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | extra */ 737).then(__webpack_require__.bind(__webpack_require__, 22993));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(22993);
        }
        return eval("require.resolve")("./modal");
    }
});
var ModalLoader = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Modal, _extends({}, props));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ModalLoader);


/***/ }),

/***/ 53174:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": () => (/* reexport */ NewsletterSignup),
  "_": () => (/* reexport */ NewsletterSignupFooter)
});

// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/spinner/index.ts + 2 modules
var spinner = __webpack_require__(56627);
// EXTERNAL MODULE: ./src/components/newsletter-signup/styles.ts
var styles = __webpack_require__(68360);
// EXTERNAL MODULE: ./src/components/newsletter-signup/useNewsletterSignup.ts + 1 modules
var useNewsletterSignup = __webpack_require__(25772);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(7336);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(58912);
;// CONCATENATED MODULE: ./src/components/newsletter-signup/newsletter-signup.tsx








var NewsletterSignup = function(props) {
    var className = props.className, title = props.title, description = props.description, buttonText = props.buttonText, buttonClass = props.buttonClass, stacked = props.stacked, _variant = props.variant, variant = _variant === void 0 ? "primary" : _variant;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var ref = (0,useNewsletterSignup/* useNewsletterSignup */.H)(), _state = ref.state, signupFeedbackTranslationKey = _state.signupFeedbackTranslationKey, isSubscribed = _state.isSubscribed, loading = _state.loading, handleSubmit = ref.handleSubmit, handleChange = ref.handleChange, privacyPolicyUri = ref.privacyPolicyUri;
    return /*#__PURE__*/ react.createElement(styles/* NewsLetter */.M7, {
        stacked: stacked,
        variant: variant,
        className: className
    }, title && /*#__PURE__*/ react.createElement(styles/* Title */.Dx, null, title), description && /*#__PURE__*/ react.createElement(styles/* Text */.xv, null, description), !isSubscribed ? /*#__PURE__*/ react.createElement(styles/* Form */.l0, {
        method: "post",
        onSubmit: handleSubmit
    }, /*#__PURE__*/ react.createElement(styles/* Flex */.kC, null, /*#__PURE__*/ react.createElement(styles/* InlineInput */.ZQ, {
        type: "email",
        name: "email",
        helper: t("campaigns", signupFeedbackTranslationKey),
        onChange: handleChange,
        stacked: stacked,
        variant: "rounded",
        placeholder: t("campaigns", "newsletter.email-placeholder"),
        ariaLabel: t("campaigns", "newsletter.email-input-aria-label"),
        // Do not send this element to CUX (cux.io)
        "data-cux-exclude": true
    }), /*#__PURE__*/ react.createElement(styles/* Button */.zx, {
        className: buttonClass || "",
        disabled: loading,
        htmlType: "submit"
    }, loading ? /*#__PURE__*/ react.createElement(variants.ButtonIcon, null, /*#__PURE__*/ react.createElement(spinner/* Spinner */.$, {
        position: "none",
        isActive: loading
    })) : /*#__PURE__*/ react.createElement(variants.ButtonText, null, buttonText || t("campaigns", "newsletter.sign-up-button"))))) : /*#__PURE__*/ react.createElement(styles/* Text */.xv, null, /*#__PURE__*/ react.createElement(styles/* SubscribedCheckIcon */._t, null), /*#__PURE__*/ react.createElement(styles/* SubscribeTitle */.cB, null, t("campaigns", "newsletter.sign-up-success"))), /*#__PURE__*/ react.createElement(styles/* Legal */.Q2, null, privacyPolicyUri && /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
        to: privacyPolicyUri,
        // This link is nofollow to avoid it getting too much of the internal
        // pagerank (since it occurs on every page).
        rel: "nofollow",
        onClick: function() {
            return (0,tracking/* trackInternalNavigationClick */.p)({
                scope: tracking/* InternalNavigationScope.NEWSLETTER_EMAIL_PRIVACY */.U.NEWSLETTER_EMAIL_PRIVACY,
                nextPage: privacyPolicyUri
            });
        }
    }, t("product", "alert.how-your-email-is-used"))));
};

// EXTERNAL MODULE: ./src/components/newsletter-signup/legal-link.tsx
var legal_link = __webpack_require__(15866);
;// CONCATENATED MODULE: ./src/components/newsletter-signup/newsletter-signup-footer.tsx






var NewsletterSignupFooter = function(props) {
    var className = props.className, title = props.title, buttonText = props.buttonText, buttonClass = props.buttonClass, stacked = props.stacked, _variant = props.variant, variant = _variant === void 0 ? "primary" : _variant;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var ref = (0,useNewsletterSignup/* useNewsletterSignup */.H)(), _state = ref.state, signupFeedbackTranslationKey = _state.signupFeedbackTranslationKey, isSubscribed = _state.isSubscribed, loading = _state.loading, handleSubmit = ref.handleSubmit, handleChange = ref.handleChange, privacyPolicyUri = ref.privacyPolicyUri;
    return /*#__PURE__*/ react.createElement(styles/* NewsLetterFooter */.CO, {
        stacked: false,
        variant: variant,
        className: className
    }, /*#__PURE__*/ react.createElement(styles/* NewsLetterFooterText */.ay, null, title && /*#__PURE__*/ react.createElement(styles/* Title */.Dx, null, title)), /*#__PURE__*/ react.createElement(styles/* NewsLetterFooterInput */.AL, null, !isSubscribed ? /*#__PURE__*/ react.createElement(styles/* Form */.l0, {
        method: "post",
        onSubmit: handleSubmit
    }, /*#__PURE__*/ react.createElement(styles/* Flex */.kC, null, /*#__PURE__*/ react.createElement(styles/* InlineInput */.ZQ, {
        type: "email",
        name: "email",
        helper: t("campaigns", signupFeedbackTranslationKey),
        onChange: handleChange,
        stacked: stacked,
        variant: "rounded",
        placeholder: t("campaigns", "newsletter.email-placeholder"),
        ariaLabel: t("campaigns", "newsletter.email-input-aria-label"),
        // Do not send this element to CUX (cux.io)
        "data-cux-exclude": true
    }), /*#__PURE__*/ react.createElement(styles/* Button */.zx, {
        className: buttonClass || "",
        disabled: loading,
        htmlType: "submit"
    }, loading && /*#__PURE__*/ react.createElement(styles/* ButtonIcon */.Ei, null, /*#__PURE__*/ react.createElement(spinner/* Spinner */.$, {
        position: "none",
        isActive: loading
    })), /*#__PURE__*/ react.createElement(styles/* ButtonText */.oD, {
        $hide: loading
    }, buttonText || t("campaigns", "newsletter.sign-up-button"))))) : /*#__PURE__*/ react.createElement(styles/* Text */.xv, null, /*#__PURE__*/ react.createElement(styles/* SubscribedCheckIcon */._t, null), /*#__PURE__*/ react.createElement(styles/* SubscribeTitle */.cB, null, t("campaigns", "newsletter.sign-up-success")))), /*#__PURE__*/ react.createElement(legal_link/* default */.Z, {
        privacyPolicyUri: privacyPolicyUri
    }));
};

;// CONCATENATED MODULE: ./src/components/newsletter-signup/index.ts





/***/ }),

/***/ 15866:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3616);
/* harmony import */ var src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58912);
/* harmony import */ var _app_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18026);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68360);





var LegalLink = function(param) {
    var privacyPolicyUri = param.privacyPolicyUri;
    var t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_app_context__WEBPACK_IMPORTED_MODULE_3__/* .AppContext */ .Il).t;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_4__/* .Legal */ .Q2, null, privacyPolicyUri && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_router_dom__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rU, {
        to: privacyPolicyUri,
        // This link is nofollow to avoid it getting too much of the internal
        // pagerank (since it occurs on every page).
        rel: "nofollow",
        onClick: function() {
            return (0,src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_2__/* .trackInternalNavigationClick */ .p)({
                scope: src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_2__/* .InternalNavigationScope.NEWSLETTER_EMAIL_PRIVACY */ .U.NEWSLETTER_EMAIL_PRIVACY,
                nextPage: privacyPolicyUri
            });
        }
    }, t("product", "alert.how-your-email-is-used")));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (LegalLink);


/***/ }),

/***/ 68360:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AL": () => (/* binding */ NewsLetterFooterInput),
/* harmony export */   "CO": () => (/* binding */ NewsLetterFooter),
/* harmony export */   "Dx": () => (/* binding */ Title),
/* harmony export */   "Ei": () => (/* binding */ ButtonIcon),
/* harmony export */   "M7": () => (/* binding */ NewsLetter),
/* harmony export */   "Q2": () => (/* binding */ Legal),
/* harmony export */   "ZQ": () => (/* binding */ InlineInput),
/* harmony export */   "_t": () => (/* binding */ SubscribedCheckIcon),
/* harmony export */   "ay": () => (/* binding */ NewsLetterFooterText),
/* harmony export */   "cB": () => (/* binding */ SubscribeTitle),
/* harmony export */   "kC": () => (/* binding */ Flex),
/* harmony export */   "l0": () => (/* binding */ Form),
/* harmony export */   "oD": () => (/* binding */ ButtonText),
/* harmony export */   "x2": () => (/* binding */ Feedback),
/* harmony export */   "xv": () => (/* binding */ Text),
/* harmony export */   "zx": () => (/* binding */ Button)
/* harmony export */ });
/* unused harmony exports SubscribeSubTitle, ButtonFooter, TextFooter */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71993);
/* harmony import */ var src_components_inputs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24084);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61093);
/* harmony import */ var _prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7336);
/* harmony import */ var _prisjakt_ui_icon_check_filled__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89639);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71016);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    font-size: ",
        ";\n    order: 9;\n    align-self: flex-start;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  text-decoration: underline;\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n  margin-top: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  border-radius: 16px;\n  background-color: white;\n  vertical-align: middle;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n  margin-top: ",
        ";\n  flex-grow: 1;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n      margin-right: 20px;\n      margin-top: 2px;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  flex-grow: 1;\n\n  > input {\n    height: 100%;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: top;\n  flex-direction: 'row';\n  background-color: 'red';\n  flex-grow: 1;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n  height: min-content;\n  width: 100%;\n  flex: 1;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  visibility: ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  left: 50%;\n  transform: translate(-50%, 0);\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  margin: ",
        ";\n  color: ",
        ";\n  ",
        " {\n    color: ",
        ";\n  }\n  ",
        " a {\n    color: ",
        ";\n\n    :hover {\n      color: ",
        ";\n    }\n  }\n  ",
        " {\n    color: ",
        ";\n  }\n  ",
        " {\n    flex-direction: ",
        ";\n  }\n  ",
        " {\n    ",
        "\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n    flex-grow: 1;\n    max-width: 260px;\n  "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  > * {\n    margin: 0;\n  }\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n      width: 100%;\n      margin-left: 0;\n      margin-top: ",
        ";\n    "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n      flex-direction: column;\n    "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  max-width: 370px;\n  flex-grow: 1;\n\n  form {\n    margin: 0;\n  }\n\n  ",
        " {\n    width: unset;\n\n    ",
        "\n  }\n\n  > form > ",
        " {\n    ",
        "\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n  height: min-content;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n      text-align: left;\n    "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n    align-items: center;\n    gap: ",
        ";\n  "
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  margin: 0;\n  color: ",
        ";\n  ",
        " {\n    color: ",
        ";\n  }\n  ",
        " {\n    a {\n      color: ",
        ";\n\n      :hover {\n        color: ",
        ";\n      }\n    }\n\n    ",
        "\n  }\n  ",
        " {\n    color: ",
        ";\n  }\n  ",
        " {\n    flex-wrap: nowrap;\n    flex-direction: ",
        ";\n  }\n  ",
        " {\n    ",
        "\n  }\n\n  ",
        "\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}






var Legal = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Legal",
    componentId: "sc-0-0"
})(_templateObject1(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.fontSizeSmall */ .bK.measurements.fontSizeSmall, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.mediumDown */ .BC.mediumDown(_templateObject(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.fontSizeSmall */ .bK.measurements.fontSizeSmall));
var Feedback = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Feedback",
    componentId: "sc-0-1"
})(_templateObject2(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.fontSizeSmall */ .bK.measurements.fontSizeSmall);
// Empty SC component to allow for it to be CSS selected
var Title = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_5__.H3Text).withConfig({
    displayName: "Title",
    componentId: "sc-0-2"
})(_templateObject3());
var SubscribeTitle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].b.withConfig({
    displayName: "SubscribeTitle",
    componentId: "sc-0-3"
})(_templateObject4(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var SubscribeSubTitle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "SubscribeSubTitle",
    componentId: "sc-0-4"
})(_templateObject5(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var SubscribedCheckIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_icon_check_filled__WEBPACK_IMPORTED_MODULE_4__.IconCheckFilled).attrs(function() {
    return {
        size: 16,
        color: "positive500"
    };
}).withConfig({
    displayName: "SubscribedCheckIcon",
    componentId: "sc-0-5"
})(_templateObject6());
var Form = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].form.withConfig({
    displayName: "Form",
    componentId: "sc-0-6"
})(_templateObject7(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100);
var InlineInput = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_components_inputs__WEBPACK_IMPORTED_MODULE_1__/* .TextInput */ .oi).withConfig({
    displayName: "InlineInput",
    componentId: "sc-0-7"
})(_templateObject9(), function(p) {
    return !p.stacked && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject8());
});
var Flex = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Flex",
    componentId: "sc-0-8"
})(_templateObject10());
var Text = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_5__.BodySmallText).withConfig({
    displayName: "Text",
    componentId: "sc-0-9"
})(_templateObject11(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100);
var Button = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__.PrimaryButton).withConfig({
    displayName: "Button",
    componentId: "sc-0-10"
})(_templateObject12(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var ButtonText = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__.ButtonText).withConfig({
    displayName: "ButtonText",
    componentId: "sc-0-11"
})(_templateObject13(), function(p) {
    return p.$hide ? "hidden" : "visible";
});
var ButtonIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__.ButtonIcon).withConfig({
    displayName: "ButtonIcon",
    componentId: "sc-0-12"
})(_templateObject14());
var NewsLetter = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "NewsLetter",
    componentId: "sc-0-13"
})(_templateObject15(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, function(p) {
    return p.variant === "secondary" && p.theme.colors.base600;
}, Title, function(p) {
    return p.variant === "secondary" && p.theme.colors.base700;
}, Legal, function(p) {
    return p.variant === "primary" ? p.theme.colors.base600 : p.theme.colors.base600;
}, function(p) {
    return p.variant === "primary" ? p.theme.colors.base600 : p.theme.text.callToActionHover;
}, Feedback, function(p) {
    return p.variant === "primary" ? p.theme.colors.negative700 : p.theme.colors.base600;
}, Flex, function(p) {
    return p.stacked ? "column" : "row";
}, Button, function(p) {
    return p.stacked && "margin-left: 0;\n    margin-top: ".concat(src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, ";");
});
var NewsLetterFooterText = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "NewsLetterFooterText",
    componentId: "sc-0-14"
})(_templateObject17(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.mediumDown */ .BC.mediumDown(_templateObject16()));
var NewsLetterFooterInput = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "NewsLetterFooterInput",
    componentId: "sc-0-15"
})(_templateObject20(), Button, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.mediumDown */ .BC.mediumDown(_templateObject18(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100), Flex, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.mediumDown */ .BC.mediumDown(_templateObject19()));
var ButtonFooter = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_3__.PrimaryButton).withConfig({
    displayName: "ButtonFooter",
    componentId: "sc-0-16"
})(_templateObject21(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var NewsLetterFooter = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "NewsLetterFooter",
    componentId: "sc-0-17"
})(_templateObject24(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, function(p) {
    return p.variant === "secondary" && p.theme.colors.base600;
}, Title, function(p) {
    return p.variant === "secondary" && p.theme.colors.base700;
}, Legal, function(p) {
    return p.variant === "primary" ? p.theme.colors.base600 : p.theme.colors.base600;
}, function(p) {
    return p.variant === "primary" ? p.theme.colors.base600 : p.theme.text.callToActionHover;
}, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.mediumDown */ .BC.mediumDown(_templateObject22()), Feedback, function(p) {
    return p.variant === "primary" ? p.theme.colors.negative700 : p.theme.colors.base600;
}, Flex, function(p) {
    return p.stacked ? "column" : "row";
}, Button, function(p) {
    return p.stacked && "margin-left: 0;\n    margin-top: ".concat(src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, ";");
}, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.mediumDown */ .BC.mediumDown(_templateObject23(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing150 */ .bK.measurements.spacing150));
var TextFooter = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_5__.BodyMediumText).withConfig({
    displayName: "TextFooter",
    componentId: "sc-0-18"
})(_templateObject25(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100);


/***/ }),

/***/ 25772:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": () => (/* binding */ useNewsletterSignup)
});

// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./node_modules/.pnpm/form-serialize@0.7.2/node_modules/form-serialize/index.js
var form_serialize = __webpack_require__(96712);
var form_serialize_default = /*#__PURE__*/__webpack_require__.n(form_serialize);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/client/data-layer.ts
var data_layer = __webpack_require__(80695);
;// CONCATENATED MODULE: ./src/components/newsletter-signup/tracking.ts

function trackNewsletterSignup() {
    (0,data_layer/* pushEvent */.A)("newsletter_signup");
}

;// CONCATENATED MODULE: ./src/components/newsletter-signup/useNewsletterSignup.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}




var useNewsletterSignup = function() {
    var ref, ref1;
    var ref2 = _slicedToArray((0,react.useReducer)(function(state, newState) {
        return _objectSpread({}, state, newState);
    }, {
        email: "",
        isSubscribed: false,
        loading: false
    }), 2), ref3 = ref2[0], email = ref3.email, signupFeedbackTranslationKey = ref3.signupFeedbackTranslationKey, isSubscribed = ref3.isSubscribed, loading = ref3.loading, setState = ref2[1];
    var ref4 = (0,react.useContext)(app_context/* AppContext */.Il), market = ref4.market, renderMode = ref4.renderMode;
    var subscribeNewsletter = (0,react.useCallback)(function(subscriptionEmail) {
        return fetch("/_internal/newsletter/subscribe", {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                email: subscriptionEmail
            })
        }).then(function(res) {
            return res.json();
        });
    }, []);
    var handleSubmit = (0,react.useCallback)(function(e) {
        if (!e) {
            return;
        }
        var formData = form_serialize_default()(e.target, {
            hash: true
        });
        e.preventDefault();
        if (formData.email) {
            setState({
                loading: true
            });
            subscribeNewsletter(formData.email).then(function(res) {
                setState({
                    isSubscribed: res.success,
                    signupFeedbackTranslationKey: res.success ? "newsletter.sign-up-success" : "newsletter.sign-up-error",
                    loading: false
                });
                if (res.success) {
                    trackNewsletterSignup();
                }
            }).catch(function() {
                setState({
                    signupFeedbackTranslationKey: "newsletter.sign-up-error",
                    loading: false
                });
            });
        }
    }, [
        subscribeNewsletter
    ]);
    var handleChange = (0,react.useCallback)(function(event) {
        if (!event) {
            return;
        }
        setState(_defineProperty({}, event.target.name, event.target.value));
    }, []);
    var privacyPolicyUri = ((market === null || market === void 0 ? void 0 : (ref = market.privacySettings) === null || ref === void 0 ? void 0 : ref[renderMode]) || (market === null || market === void 0 ? void 0 : (ref1 = market.privacySettings) === null || ref1 === void 0 ? void 0 : ref1.responsive)).privacyUrl;
    return {
        state: {
            email: email,
            signupFeedbackTranslationKey: signupFeedbackTranslationKey,
            isSubscribed: isSubscribed,
            loading: loading
        },
        handleSubmit: handleSubmit,
        handleChange: handleChange,
        privacyPolicyUri: privacyPolicyUri
    };
};


/***/ }),

/***/ 84874:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71993);
/* harmony import */ var _viewport__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10297);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n&& {\n  body {\n    position: fixed;\n    top: 0;\n    overflow: hidden;\n    width: 100%;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/* We used to keep the enabled/disabled logic and viewport checks inside this styled component,
 but due to the way createGlobalStyle works it caused bugs when maintaining multiple instances
 of the component in the app. It's better to avoid using props in the component and only mount
 it when we want the styles to be applied. */ var NoScrollGlobalStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__.createGlobalStyle)(_templateObject());
var NoScroll = function(param) {
    var _enabled = param.enabled, enabled = _enabled === void 0 ? true : _enabled, mobile = param.mobile, tablet = param.tablet;
    if (!enabled) {
        return null;
    }
    // If no viewport props are set, render the styles unconditionally
    if (!mobile && !tablet) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(NoScrollGlobalStyle, null);
    }
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_viewport__WEBPACK_IMPORTED_MODULE_2__/* .ViewportContext.Consumer */ .R.Consumer, null, function(param) {
        var isMobile = param.isMobile, isTablet = param.isTablet;
        return mobile && isMobile || tablet && isTablet ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(NoScrollGlobalStyle, null) : null;
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (NoScroll);


/***/ }),

/***/ 88584:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "cJ": () => (/* binding */ getCompiledPriceData),
  "Un": () => (/* binding */ getonSalePriceLabel),
  "kT": () => (/* binding */ parseUTCDate)
});

// UNUSED EXPORTS: getIsMemberPrice, getIsOnSalePrice, getSecondaryPrice, pricesAreEqual

// EXTERNAL MODULE: ./src/components/price-list/types.ts
var types = __webpack_require__(79126);
;// CONCATENATED MODULE: ./src/components/offer/price/price-display.ts

function getDisplayPrice(price, priceDisplay) {
    if (!price) {
        return null;
    }
    return priceDisplay === types/* PriceDisplayEnum.PRICE_INCLUDES_SHIPPING */.wB.PRICE_INCLUDES_SHIPPING && price.inclShipping ? price.inclShipping || null : price.exclShipping || null;
}

;// CONCATENATED MODULE: ./src/components/offer/price/offer-price/price-data.ts

function getCompiledPriceData(price, offerPrice, priceDisplay, isFeatured) {
    if (!price) {
        return {
            label: null,
            mainPrice: null,
            secondaryPrice: null
        };
    }
    var isMemberPrice = getIsMemberPrice(price, offerPrice, isFeatured);
    var isOnSalePrice = getIsOnSalePrice(price, offerPrice, isFeatured);
    var secondaryPrice = getSecondaryPrice(offerPrice, priceDisplay, isOnSalePrice, isMemberPrice);
    return {
        mainPrice: getDisplayPrice(price, priceDisplay),
        secondaryPrice: secondaryPrice,
        isMemberPrice: isMemberPrice,
        isOnSalePrice: isOnSalePrice
    };
}
function getIsOnSalePrice(price, offerPrice, featured) {
    var ref, ref1;
    return featured && (offerPrice === null || offerPrice === void 0 ? void 0 : offerPrice.originalPrice) && pricesAreEqual(price, offerPrice) ? (offerPrice === null || offerPrice === void 0 ? void 0 : (ref = offerPrice.price) === null || ref === void 0 ? void 0 : ref.exclShipping) !== (offerPrice === null || offerPrice === void 0 ? void 0 : (ref1 = offerPrice.originalPrice) === null || ref1 === void 0 ? void 0 : ref1.exclShipping) : false;
}
function getIsMemberPrice(price, offerPrice, featured) {
    return featured && pricesAreEqual(price, offerPrice) ? Boolean(offerPrice === null || offerPrice === void 0 ? void 0 : offerPrice.memberPrice) : false;
}
function pricesAreEqual(price, offerPrice) {
    var ref;
    return (price === null || price === void 0 ? void 0 : price.exclShipping) === (offerPrice === null || offerPrice === void 0 ? void 0 : (ref = offerPrice.price) === null || ref === void 0 ? void 0 : ref.exclShipping);
}
function getSecondaryPrice(offerPrice, priceDisplay, isOnSalePrice, isMemberPrice) {
    return (offerPrice === null || offerPrice === void 0 ? void 0 : offerPrice.originalPrice) && (isOnSalePrice || isMemberPrice) ? getDisplayPrice(offerPrice.originalPrice, priceDisplay) : null;
}
function getonSalePriceLabel(offerPrice, locale, t) {
    var ref;
    if (offerPrice === null || offerPrice === void 0 ? void 0 : (ref = offerPrice.price) === null || ref === void 0 ? void 0 : ref.endDate) {
        return "".concat(t("campaigns", "campaign-card.sale-badge-end-date", {
            date: parseUTCDate(offerPrice.price.endDate, locale)
        }));
    }
    return t("campaigns", "campaign-card.sale");
}
function parseUTCDate(dateString, locale) {
    var date = new Date(dateString);
    var timeDiff = date.getTimezoneOffset() * 60000;
    var adjustedUTCDate = new Date(date.valueOf() + timeDiff);
    var localizedDate;
    try {
        localizedDate = adjustedUTCDate.toLocaleDateString(locale, {
            day: "numeric",
            month: "short"
        });
    } catch (e) {
        localizedDate = adjustedUTCDate.toLocaleDateString("en", {
            day: "numeric",
            month: "short"
        });
    }
    return localizedDate;
}


/***/ }),

/***/ 46140:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Zb": () => (/* binding */ StyledPriceLabel),
/* harmony export */   "_d": () => (/* binding */ StyledBadges),
/* harmony export */   "im": () => (/* binding */ Wrapper),
/* harmony export */   "j8": () => (/* binding */ PRICE_LABEL_SIZE),
/* harmony export */   "ng": () => (/* binding */ StyledSecondaryPrice),
/* harmony export */   "y": () => (/* binding */ PriceAndShipping)
/* harmony export */ });
/* unused harmony export StyledBadge */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71993);
/* harmony import */ var _price_label__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47477);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61093);
/* harmony import */ var _prisjakt_ui_badge__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29242);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  line-height: ",
        ";\n  text-align: right;\n  margin-bottom: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  line-height: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  column-gap: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n  column-gap: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  > span {\n    font-weight: 400;\n    font-size: 0.85em;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  gap: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var PRICE_LABEL_SIZE = "16px";
var PRICE_LABEL_LINE_HEIGHT = "24px";
var SECONDARY_PRICE_LABEL_LINE_HEIGHT = "22px";
var StyledPriceLabel = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_price_label__WEBPACK_IMPORTED_MODULE_1__/* .PriceLabel */ .l).withConfig({
    displayName: "StyledPriceLabel",
    componentId: "sc-0-0"
})(_templateObject(), PRICE_LABEL_SIZE, PRICE_LABEL_LINE_HEIGHT);
var StyledSecondaryPrice = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_price_label__WEBPACK_IMPORTED_MODULE_1__/* .PriceLabel */ .l).withConfig({
    displayName: "StyledSecondaryPrice",
    componentId: "sc-0-1"
})(_templateObject1(), function(p) {
    return !p.memberPrice && "text-decoration: line-through;";
}, SECONDARY_PRICE_LABEL_LINE_HEIGHT);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-2"
})(_templateObject2(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var PriceAndShipping = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "PriceAndShipping",
    componentId: "sc-0-3"
})(_templateObject3(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var StyledBadge = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_badge__WEBPACK_IMPORTED_MODULE_3__.Badge).withConfig({
    displayName: "StyledBadge",
    componentId: "sc-0-4"
})(_templateObject4());
var StyledBadges = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "StyledBadges",
    componentId: "sc-0-5"
})(_templateObject5(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025);


/***/ }),

/***/ 48652:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": () => (/* binding */ getDealPercentage),
/* harmony export */   "U": () => (/* binding */ getSalesPricePercentage)
/* harmony export */ });
/* harmony import */ var src_areas_scoped_search_pages_deals_page_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68977);

function getSalesPricePercentage(price, originalPrice) {
    if (!price || !originalPrice) {
        return 0;
    }
    return Math.round((1 - price / originalPrice) * 100);
}
var getExpectedPrice = function(dealInfo, filteredOffers) {
    var ref, ref1, ref2;
    // To calculate the offers expected price, we need to get the offer that the deals systems dealPercentage is based on (the originalDealOffer).
    // We're calculating the expected price based on that particular offers price and the dealPercentage.
    // The expectedPrice is always the same, no matter the deal price of an offer.
    var originalDealOfferId = (ref = dealInfo.offers[dealInfo.offers.length - 1]) === null || ref === void 0 ? void 0 : ref.shopOfferId;
    if (!originalDealOfferId) return null;
    var originalDealOffer = filteredOffers.find(function(offer) {
        return offer.shopOfferId === originalDealOfferId;
    });
    if (!(originalDealOffer === null || originalDealOffer === void 0 ? void 0 : (ref1 = originalDealOffer.price) === null || ref1 === void 0 ? void 0 : ref1.exclShipping)) return null;
    return (0,src_areas_scoped_search_pages_deals_page_utils__WEBPACK_IMPORTED_MODULE_0__/* .getPreviousPrice */ .L)(dealInfo.dealPercentage, (ref2 = originalDealOffer.price) === null || ref2 === void 0 ? void 0 : ref2.exclShipping);
};
var getDealPercentage = function(dealInfo, filteredOffers, offerPrice) {
    // Since a product can have multiple deal offers, and since there can be a delay between an updated offers price and the deals systems dealPercentage,
    // we are calculating each individual offers deal percentage so that we display the correct percentage based on the offer price.
    var expectedPrice = getExpectedPrice(dealInfo, filteredOffers);
    if (!expectedPrice) return null;
    var dealPercentage = Math.round((1 - offerPrice / expectedPrice) * 100);
    return dealPercentage;
};


/***/ }),

/***/ 47477:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": () => (/* binding */ price_label_PriceLabel)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(71016);
// EXTERNAL MODULE: ./src/components/currency/index.tsx
var currency = __webpack_require__(49763);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
;// CONCATENATED MODULE: ./src/components/offer/price/price-label/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: inherit;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var PriceLabel = (0,styled_components_browser_esm["default"])(variants.BodySmallText).attrs({
    containerProps: {
        "data-test": "PriceLabel"
    }
}).withConfig({
    displayName: "PriceLabel",
    componentId: "sc-0-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/components/offer/price/price-label/index.tsx





var price_label_PriceLabel = function(param) {
    var className = param.className, _container = param.container, container = _container === void 0 ? "span" : _container, _emphasis = param.emphasis, emphasis = _emphasis === void 0 ? variants.FontEmphasis.HIGH : _emphasis, _fontColor = param.fontColor, fontColor = _fontColor === void 0 ? variants.FontColor.DARK : _fontColor, value = param.value, _weight = param.weight, weight = _weight === void 0 ? variants.FontWeight.HEAVIER : _weight, _isSecondaryPrice = param.isSecondaryPrice, isSecondaryPrice = _isSecondaryPrice === void 0 ? false : _isSecondaryPrice, _memberPrice = param.memberPrice, memberPrice = _memberPrice === void 0 ? false : _memberPrice;
    var context = (0,react.useContext)(app_context/* AppContext */.Il);
    var formatPrice = function(num) {
        var ref;
        return (0,currency/* formatCurrency */.xG)(num, (ref = context.market) === null || ref === void 0 ? void 0 : ref.code, false, "", false);
    };
    var renderFormattedPrice = function() {
        if (typeof value !== "number") return value;
        if (isSecondaryPrice && memberPrice) return "(".concat(formatPrice(value), ")");
        if (isSecondaryPrice) return "".concat(formatPrice(value));
        return /*#__PURE__*/ react.createElement(currency/* Currency */.F, {
            price: value
        });
    };
    return /*#__PURE__*/ react.createElement(PriceLabel, {
        className: className,
        color: fontColor,
        container: container,
        emphasis: emphasis,
        weight: weight
    }, renderFormattedPrice());
};


/***/ }),

/***/ 28254:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": () => (/* binding */ PriceText)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _prisjakt_ui_text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49955);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var PriceText = function(props) {
    var scale = props.scale, weight = props.weight, otherProps = _objectWithoutProperties(props, [
        "scale",
        "weight"
    ]);
    var newScale = scale !== null && scale !== void 0 ? scale : _prisjakt_ui_text__WEBPACK_IMPORTED_MODULE_1__.FontScale.M;
    var newWeight = weight !== null && weight !== void 0 ? weight : _prisjakt_ui_text__WEBPACK_IMPORTED_MODULE_1__.FontWeight.HEAVIEST;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_text__WEBPACK_IMPORTED_MODULE_1__.Text, _extends({}, otherProps, {
        scale: newScale,
        weight: newWeight
    }));
};


/***/ }),

/***/ 83434:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ overlay)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-dom@18.2.0_react@18.2.0/node_modules/react-dom/index.js
var react_dom = __webpack_require__(10422);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/hideable/index.js
var hideable = __webpack_require__(3709);
// EXTERNAL MODULE: ./src/ui/zindex/index.ts
var zindex = __webpack_require__(93497);
;// CONCATENATED MODULE: ./src/components/overlay/styles.ts



var Overlay = (0,styled_components_browser_esm["default"])(hideable.Hideable).withConfig({
    displayName: "Overlay",
    componentId: "sc-0-0"
})(function(props) {
    return {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: props.theme.bg.overlay,
        zIndex: zindex/* zindex.overlay */.Y.overlay
    };
});

;// CONCATENATED MODULE: ./src/components/overlay/index.tsx



var overlay_Overlay = function(props) {
    if (false) {}
    var rootEl = document.getElementById("root-overlay");
    if (!rootEl) {
        return null;
    }
    return /*#__PURE__*/ react_dom.createPortal(/*#__PURE__*/ react.createElement(Overlay, {
        visible: props.active
    }), rootEl);
};
overlay_Overlay.defaultProps = {
    active: false
};
/* harmony default export */ const overlay = (overlay_Overlay);


/***/ }),

/***/ 44307:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HN": () => (/* binding */ SIDEBAR_CONTENT_WIDTH),
/* harmony export */   "Ky": () => (/* binding */ PAGE_WITH_SIDEBAR_CONTENT_WIDTH),
/* harmony export */   "OC": () => (/* binding */ PAGE_CONTENT_GUTTER_BREAKPOINT),
/* harmony export */   "_A": () => (/* binding */ SIDEBAR_MENU_WIDTH),
/* harmony export */   "uw": () => (/* binding */ OUTSIDE_AD_MAX_WIDTH)
/* harmony export */ });
/* unused harmony export OUTSIDE_AD_MIN_WIDTH */
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61093);

var PAGE_CONTENT_GUTTER_BREAKPOINT = "".concat(1200 - 1, "px");
var OUTSIDE_AD_MIN_WIDTH = "200px";
var OUTSIDE_AD_MAX_WIDTH = "300px";
var SIDEBAR_CONTENT_WIDTH = src_components_base__WEBPACK_IMPORTED_MODULE_0__/* .layout.sidebarContentWidth.desktop.value */ .bK.sidebarContentWidth.desktop.value;
var SIDEBAR_MENU_WIDTH = src_components_base__WEBPACK_IMPORTED_MODULE_0__/* .layout.sidebarMenuWidth.desktop.value */ .bK.sidebarMenuWidth.desktop.value;
var PAGE_WITH_SIDEBAR_CONTENT_WIDTH = src_components_base__WEBPACK_IMPORTED_MODULE_0__/* .layout.pageContent.maxWidth.value */ .bK.pageContent.maxWidth.value + src_components_base__WEBPACK_IMPORTED_MODULE_0__/* .layout.pageContent.gutter.value */ .bK.pageContent.gutter.value + (SIDEBAR_CONTENT_WIDTH + SIDEBAR_MENU_WIDTH) * 2;


/***/ }),

/***/ 62372:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "JH": () => (/* reexport */ page_content/* default */.Z),
  "mr": () => (/* reexport */ page_header/* default */.Z),
  "WH": () => (/* reexport */ page_header_media),
  "NP": () => (/* reexport */ PageSection)
});

// EXTERNAL MODULE: ./src/components/page/page-content/index.tsx + 1 modules
var page_content = __webpack_require__(81013);
// EXTERNAL MODULE: ./src/components/page/page-header/index.tsx + 1 modules
var page_header = __webpack_require__(57538);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/viewport/context.tsx
var context = __webpack_require__(84198);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
;// CONCATENATED MODULE: ./src/components/page/page-header-media/index.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding-left: ",
        ";\n  padding-top: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Root = styled_components_browser_esm["default"].img.withConfig({
    displayName: "Root",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var PageHeaderMedia = function(param) {
    var src = param.src, alt = param.alt, className = param.className;
    var isMobile = (0,context/* useViewportContext */.Ak)().isMobile;
    return /*#__PURE__*/ react.createElement(Root, {
        className: className,
        src: src,
        alt: alt,
        width: isMobile ? 64 : 88
    });
};
/* harmony default export */ const page_header_media = (PageHeaderMedia);

;// CONCATENATED MODULE: ./src/components/page/page-section/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n      background-color: ",
        ";\n    "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n        border-bottom: 1px solid ",
        ";\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n            border-bottom: 1px solid ",
        ";\n          "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n            background-color: ",
        ";\n          "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = styles_taggedTemplateLiteral([
        "\n      :before {\n        position: absolute;\n        left: -50vw;\n        right: -50vw;\n        z-index: -1;\n        content: '';\n        height: 100%;\n\n        ",
        ";\n\n        ",
        ";\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = styles_taggedTemplateLiteral([
        "\n    ",
        "\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = styles_taggedTemplateLiteral([
        "\n  position: relative;\n  padding: 0 ",
        ";\n\n  ",
        ";\n\n  &,\n  :before,\n  :after {\n    ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = styles_taggedTemplateLiteral([
        "\n            padding-top: ",
        ";\n        "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = styles_taggedTemplateLiteral([
        "\n        padding-top: ",
        ";\n        padding-bottom: 0;\n        ",
        ";\n      "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = styles_taggedTemplateLiteral([
        "\n          padding-bottom: ",
        ";\n        "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = styles_taggedTemplateLiteral([
        "\n        padding-bottom: ",
        ";\n        padding-top: 0;\n        ",
        ";\n      "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = styles_taggedTemplateLiteral([
        "\n        padding: 0;\n      "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = styles_taggedTemplateLiteral([
        "\n        padding: ",
        " 0;\n      "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = styles_taggedTemplateLiteral([
        "\n      padding: ",
        " 0;\n      ",
        ";\n    "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = styles_taggedTemplateLiteral([
        "\n  ",
        ";\n\n  :empty {\n    display: none;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = styles_taggedTemplateLiteral([
        "\n  html {\n    overflow-x: hidden !important;\n\n    &:has(> body.ReactModal__Body--open) {\n      overflow: hidden;\n    }\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}


var PageSectionWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PageSectionWrapper",
    componentId: "sc-0-0"
})(_templateObject6(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(param) {
    var recessed = param.recessed, theme = param.theme;
    return recessed && (0,styled_components_browser_esm.css)(styles_templateObject(), theme.bg.quaternary);
}, function(p) {
    return !p.noBorder && !p.recessed && (0,styled_components_browser_esm.css)(_templateObject1(), p.theme.lines.primary);
}, function(p) {
    return (0,styled_components_browser_esm.css)(_templateObject5(), base/* media.largeUp */.BC.largeUp(_templateObject4(), !p.noBorder && !p.recessed && (0,styled_components_browser_esm.css)(_templateObject2(), p.theme.lines.primary), p.recessed && (0,styled_components_browser_esm.css)(_templateObject3(), p.theme.bg.quaternary)));
});
var PageSectionContent = styled_components_browser_esm["default"].section.withConfig({
    displayName: "PageSectionContent",
    componentId: "sc-0-1"
})(_templateObject14(), function(p) {
    if (p.noPad === "bottom") {
        return (0,styled_components_browser_esm.css)(_templateObject8(), base/* layout.measurements.spacing200 */.bK.measurements.spacing200, base/* media.mediumUp */.BC.mediumUp(_templateObject7(), base/* layout.measurements.spacing400 */.bK.measurements.spacing400));
    }
    if (p.noPad === "top") {
        return (0,styled_components_browser_esm.css)(_templateObject10(), base/* layout.measurements.spacing200 */.bK.measurements.spacing200, base/* media.mediumUp */.BC.mediumUp(_templateObject9(), base/* layout.measurements.spacing400 */.bK.measurements.spacing400));
    }
    if (p.noPad === "both") {
        return (0,styled_components_browser_esm.css)(_templateObject11());
    }
    return (0,styled_components_browser_esm.css)(_templateObject13(), base/* layout.measurements.spacing200 */.bK.measurements.spacing200, base/* media.mediumUp */.BC.mediumUp(_templateObject12(), base/* layout.measurements.spacing400 */.bK.measurements.spacing400));
});
var GlobalStylesOverride = (0,styled_components_browser_esm.createGlobalStyle)(_templateObject15());

;// CONCATENATED MODULE: ./src/components/page/page-section/index.tsx


var PageSection = function(props) {
    return /*#__PURE__*/ react.createElement(PageSectionWrapper, {
        className: props.className,
        recessed: props.recessed,
        noBorder: props.noBorder
    }, props.recessed && /*#__PURE__*/ react.createElement(GlobalStylesOverride, null), /*#__PURE__*/ react.createElement(PageSectionContent, {
        noPad: props.noPad
    }, props.children));
};

;// CONCATENATED MODULE: ./src/components/page/index.ts







/***/ }),

/***/ 81013:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ page_content)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./src/components/ads/index.tsx
var ads = __webpack_require__(66589);
// EXTERNAL MODULE: ./src/components/ads/services/context.tsx
var context = __webpack_require__(31637);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
// EXTERNAL MODULE: ./src/areas/header/styles.ts
var styles = __webpack_require__(47609);
// EXTERNAL MODULE: ./src/components/sticky-tab-nav/constants.ts
var constants = __webpack_require__(72433);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/ads/services/appnexus/styles.ts
var appnexus_styles = __webpack_require__(59533);
// EXTERNAL MODULE: ./src/components/page/constants.ts
var page_constants = __webpack_require__(44307);
;// CONCATENATED MODULE: ./src/components/page/page-content/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      @media ",
        " {\n        /* Center content when the outsider ad is hidden */\n        margin-left: ",
        ";\n        margin-right: auto;\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      max-width: none;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      background-color: ",
        ";\n      /* @NOTE: Hardcoded breakpoint based on panorama_top visible width limit */\n      @media ",
        " {\n        margin-top: ",
        ";\n      }\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    width: 100%;\n    ",
        "\n    padding-left: 0;\n    padding-right: 0;\n    margin-right: ",
        ";\n    position: relative;\n\n    ",
        "\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n      position: absolute;\n      top: 0px;\n      left: 0px;\n      z-index: 0;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n      & > div {\n        overflow: hidden;\n        max-width: ",
        "px;\n        min-width: ",
        "px;\n        margin-left: -200px;\n      }\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n      margin-top: ",
        "px;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  align-self: stretch;\n  margin-bottom: ",
        ";\n  min-width: ",
        ";\n  width: ",
        ";\n  z-index: 100;\n  margin-right: ",
        ";\n\n  & > * {\n    margin-top: ",
        ";\n  }\n\n  ",
        " {\n    margin-left: 0;\n    margin-right: 0;\n  }\n\n  ",
        "\n\n  @media ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n      position: sticky;\n      top: calc(\n        ",
        " + ",
        " +\n          ",
        "\n      );\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  & .pj-ui-ad-container {\n    margin-left: 0;\n    margin-right: 0;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n      /* Align page content with header content when it exceeds the open sidebar (but only if we don't have a page without fixed max width) */\n      @media ",
        " {\n        margin-left: calc(\n          ((100vw - ",
        ") / 2) -\n            ",
        "px\n        );\n      }\n    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n    margin-left: auto;\n  "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n    width: 100%;\n    ",
        "\n    margin-right: auto;\n    margin-left: 0;\n    margin-bottom: ",
        ";\n\n    ",
        "\n\n    ",
        ";\n\n    @media ",
        " {\n      display: flex;\n      align-items: flex-start;\n      ",
        "\n      ",
        "\n      flex-direction: row-reverse;\n    }\n  "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}







var ref;
var Content = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Content",
    componentId: "sc-0-0"
})(function(props) {
    var ref1;
    return (0,styled_components_browser_esm.css)(_templateObject3(), !props.isWide && "max-width: ".concat((0,base/* remCalc */.vR)(1000), ";"), props.alignLeft ? "auto" : 0, props.hasAds && (0,styled_components_browser_esm.css)(_templateObject(), "screen and (max-width: ".concat(page_constants/* PAGE_CONTENT_GUTTER_BREAKPOINT */.OC, ")"), props.takeover ? 0 : "auto"), props.wideContent && (0,styled_components_browser_esm.css)(_templateObject1()), props.takeover && (0,styled_components_browser_esm.css)(_templateObject2(), props.theme.bg.primary, "screen and (min-width: 862px)", "".concat(((ref = (ref1 = props.takeover) === null || ref1 === void 0 ? void 0 : ref1.topMargin) !== null && ref !== void 0 ? ref : 130) + base/* layout.pageContent.gutter.value */.bK.pageContent.gutter.value, "px")));
});
var Wrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-1"
})(_templateObject4());
var TopAds = styled_components_browser_esm["default"].aside.withConfig({
    displayName: "TopAds",
    componentId: "sc-0-2"
})(_templateObject7(), function(props) {
    return props.takeover && (0,styled_components_browser_esm.css)(_templateObject5());
}, function(props) {
    var ref;
    return ((ref = props.takeover) === null || ref === void 0 ? void 0 : ref.offgrid) && (0,styled_components_browser_esm.css)(_templateObject6(), props.takeover.width, props.takeover.width);
});
var OutsiderAds = styled_components_browser_esm["default"].aside.withConfig({
    displayName: "OutsiderAds",
    componentId: "sc-0-3"
})(_templateObject9(), base/* layout.pageContent.gutter.rem */.bK.pageContent.gutter.rem, page_constants/* OUTSIDE_AD_MAX_WIDTH */.uw, page_constants/* OUTSIDE_AD_MAX_WIDTH */.uw, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.pageContent.gutter.rem */.bK.pageContent.gutter.rem, appnexus_styles/* AdPlacementContainer */.zM, function(props) {
    return props.takeover && (0,styled_components_browser_esm.css)(_templateObject8(), props.takeover.height);
}, "screen and (max-width: ".concat(page_constants/* PAGE_CONTENT_GUTTER_BREAKPOINT */.OC, ")"));
var SkyscraperAd = (0,styled_components_browser_esm["default"])(ads/* default */.Z).withConfig({
    displayName: "SkyscraperAd",
    componentId: "sc-0-4"
})(_templateObject11(), function(p) {
    return p.sticky && (0,styled_components_browser_esm.css)(_templateObject10(), styles/* height.desktop */.Cb.desktop, base/* layout.pageContent.gutter.rem */.bK.pageContent.gutter.rem, (0,base/* remCalc */.vR)(constants/* NAV_HEIGHT */.n));
});
var PageContent = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PageContent",
    componentId: "sc-0-5"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject14(), !props.isWide && "max-width: ".concat(base/* layout.pageContent.maxWidth.value */.bK.pageContent.maxWidth.value, "px;"), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, !props.isWide && (0,styled_components_browser_esm.css)(_templateObject12(), "(min-width: ".concat(page_constants/* PAGE_WITH_SIDEBAR_CONTENT_WIDTH */.Ky, "px)"), base/* layout.pageContent.maxWidth.rem */.bK.pageContent.maxWidth.rem, page_constants/* SIDEBAR_CONTENT_WIDTH */.HN + page_constants/* SIDEBAR_MENU_WIDTH */._A + base/* layout.pageContent.gutter.value */.bK.pageContent.gutter.value), base/* media.mediumDown */.BC.mediumDown(_templateObject13()), "screen and (min-width: ".concat(page_constants/* PAGE_CONTENT_GUTTER_BREAKPOINT */.OC, ")"), props.isWide && "justify-content: flex-end;", !props.isWide && "justify-content: center;");
});

// EXTERNAL MODULE: ./src/contexts/wide-context.tsx
var wide_context = __webpack_require__(59547);
;// CONCATENATED MODULE: ./src/components/page/page-content/index.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}






var topAdSpacing = {
    top: "10px"
};
var bottomAdSpacing = {
    bottom: "10px"
};
var page_content_PageContent = function(props) {
    var className = props.className, children = props.children, _adsDelayed = props.adsDelayed, adsDelayed = _adsDelayed === void 0 ? {} : _adsDelayed, _alignLeft = props.alignLeft, alignLeft = _alignLeft === void 0 ? false : _alignLeft, _wideContent = props.wideContent, wideContent = _wideContent === void 0 ? false : _wideContent, _withAds = props.withAds, withAds = _withAds === void 0 ? false : _withAds, _topPlacements = props.topPlacements, topPlacements = _topPlacements === void 0 ? [
        {
            scalable: true,
            formats: [
                "toppanorama_wde",
                "wallpaper"
            ],
            placement: "panorama_top",
            min: 861,
            max: 10000
        }
    ] : _topPlacements, _bottomPlacements = props.bottomPlacements, bottomPlacements = _bottomPlacements === void 0 ? [
        {
            placement: "panorama_footer",
            format: "panorama_4_wde",
            min: 1024,
            max: 10000,
            triggerPoint: 100
        },
        {
            placement: "dubbelpanorama3",
            format: "panorama_3",
            min: 0,
            max: 860,
            triggerPoint: 100
        }
    ] : _bottomPlacements;
    var adServiceContext = (0,context/* useAdServiceContext */.d)();
    var market = (0,react.useContext)(app_context/* AppContext */.Il).market;
    var isWide = (0,react.useContext)(wide_context/* WideContext */.Y).isWide;
    var adsActive = market && market.ads && market.ads.active;
    var showAds = withAds && adsActive;
    var takeover = showAds && adServiceContext && adServiceContext.takeover ? adServiceContext.takeover : undefined;
    return /*#__PURE__*/ react.createElement(PageContent, {
        "data-test": props["data-test"],
        className: className,
        isWide: isWide
    }, showAds && /*#__PURE__*/ react.createElement(OutsiderAds, {
        takeover: takeover,
        className: "outsider-ads"
    }, /*#__PURE__*/ react.createElement(SkyscraperAd, {
        key: "skyscraper_1",
        placement: "skyscraper_1",
        format: "widescreen_1",
        min: 1199,
        max: 10000,
        scalable: true,
        scaleBase: ".outsider-ads"
    }), /*#__PURE__*/ react.createElement(SkyscraperAd, {
        key: "skyscraper_2",
        placement: "skyscraper_2",
        format: "widescreen_2",
        min: 1199,
        max: 10000,
        scalable: true,
        scaleBase: ".outsider-ads"
    }), /*#__PURE__*/ react.createElement(SkyscraperAd, {
        key: "skyscraper_3",
        placement: "skyscraper_3",
        format: "widescreen_3",
        min: 1199,
        max: 10000,
        scalable: true,
        scaleBase: ".outsider-ads"
    })), /*#__PURE__*/ react.createElement(Wrapper, null, showAds && topPlacements.length > 0 && /*#__PURE__*/ react.createElement(TopAds, {
        takeover: takeover,
        className: "top-ads"
    }, topPlacements.map(function(adProps, index) {
        return /*#__PURE__*/ react.createElement(ads/* default */.Z, _extends({}, adProps, {
            key: "".concat(adProps.placement, "-").concat(index.toString()),
            isReady: adsDelayed[adProps.placement],
            spacing: takeover ? {} : topAdSpacing
        }));
    })), /*#__PURE__*/ react.createElement(Content, {
        takeover: takeover,
        hasAds: adsActive,
        wideContent: wideContent,
        alignLeft: alignLeft,
        isWide: isWide
    }, children), showAds && bottomPlacements.length > 0 && /*#__PURE__*/ react.createElement("aside", {
        className: "bottom-ads"
    }, bottomPlacements.map(function(adProps) {
        return /*#__PURE__*/ react.createElement(ads/* default */.Z, _extends({}, adProps, {
            key: adProps.placement,
            isReady: adsDelayed[adProps.placement],
            spacing: bottomAdSpacing
        }));
    }))));
};
/* harmony default export */ const page_content = (/*#__PURE__*/(0,react.memo)(page_content_PageContent));


/***/ }),

/***/ 57538:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ page_header)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(71016);
;// CONCATENATED MODULE: ./src/components/page/page-header/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: ",
        ";\n  gap: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 500px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var Root = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Root",
    componentId: "sc-0-0"
})(_templateObject(), function(props) {
    return props.hasDescription ? "start" : "center";
}, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var Title = (0,styled_components_browser_esm["default"])(variants.H1Text).withConfig({
    displayName: "Title",
    componentId: "sc-0-1"
})(_templateObject1(), function(props) {
    return props.hasMedia ? 0 : "default";
});
var Content = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Content",
    componentId: "sc-0-2"
})(_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var Description = (0,styled_components_browser_esm["default"])(variants.BodySmallText).withConfig({
    displayName: "Description",
    componentId: "sc-0-3"
})(_templateObject3());

;// CONCATENATED MODULE: ./src/components/page/page-header/index.tsx


var PageHeader = function(props) {
    var media = props.media, title = props.title, className = props.className, description = props.description;
    return /*#__PURE__*/ react.createElement(Root, {
        className: className,
        hasDescription: !!description
    }, media, /*#__PURE__*/ react.createElement(Content, null, /*#__PURE__*/ react.createElement(Title, {
        containerProps: {
            "data-test": "PageHeaderTitle"
        },
        hasMedia: !!media
    }, title), description && /*#__PURE__*/ react.createElement(Description, null, description)));
};
/* harmony default export */ const page_header = (PageHeader);


/***/ }),

/***/ 52474:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": () => (/* binding */ popular_searches_PopularSearches)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(7336);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(38689);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/magnifier/index.js
var magnifier = __webpack_require__(38314);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/index.js
var ui_text = __webpack_require__(49955);
// EXTERNAL MODULE: ./src/areas/search-suggestions/history-storage.tsx
var history_storage = __webpack_require__(55918);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(58912);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
;// CONCATENATED MODULE: ./src/components/popular-searches/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0 ",
        " 0;\n  margin-bottom: ",
        ";\n  display: flex;\n  flex-wrap: wrap;\n  gap: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var PopularSearches = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PopularSearches",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/components/popular-searches/index.tsx









var popular_searches_PopularSearches = function(props) {
    var popularSearches = props.popularSearches, onClick = props.onClick;
    var linkTo = (0,app_context/* useAppContext */.bp)().linkTo;
    if (!(popularSearches === null || popularSearches === void 0 ? void 0 : popularSearches.length)) {
        return null;
    }
    var handleClick = function(query) {
        (0,tracking/* trackInternalNavigationClick */.p)({
            scope: tracking/* InternalNavigationScope.QUICK_SEARCH_SUGGESTION */.U.QUICK_SEARCH_SUGGESTION,
            nextPage: linkTo("search", {
                query: encodeURIComponent(query)
            })
        });
        (0,history_storage/* addRecentSearch */._)(query);
        if (onClick) {
            onClick(query);
        }
    };
    return /*#__PURE__*/ react.createElement(PopularSearches, {
        "data-test": "PopularSearchesWrapper"
    }, popularSearches.map(function(search) {
        return (search === null || search === void 0 ? void 0 : search.query) && /*#__PURE__*/ react.createElement(variants.TonalButton, {
            key: search.query,
            container: clickable/* Clickable */.P,
            containerProps: {
                to: linkTo("search", {
                    query: search.query
                }),
                "data-test": "PopularSearchQuery"
            },
            onClick: function() {
                return handleClick(search.query);
            },
            size: variants.ButtonSize.SMALL
        }, /*#__PURE__*/ react.createElement(variants.ButtonIcon, null, /*#__PURE__*/ react.createElement(magnifier/* IconMagnifier */.j, null)), /*#__PURE__*/ react.createElement(variants.ButtonText, {
            behavior: ui_text.Behavior.OnelineEllipsis
        }, search.query));
    }));
};


/***/ }),

/***/ 88257:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": () => (/* binding */ createExtendedPrices),
  "h": () => (/* binding */ filterOffers)
});

// EXTERNAL MODULE: ./src/areas/product/utils/index.ts
var utils = __webpack_require__(33996);
;// CONCATENATED MODULE: ./src/components/price-list/shipping-sort.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var getSortedShipping = function(shippings, isSortByFastest, filters) {
    var isInstorePickupSelectedByUser = filters.some(function(f) {
        var ref;
        return f.type === "shipping-delivery-method" && ((ref = f.selection) === null || ref === void 0 ? void 0 : ref.includes("INSTORE_PICKUP"));
    });
    // Instore pickup should not be counted as a shipping method when sorting, unless specifically selected
    var filteredShippings = shippings;
    if (!isInstorePickupSelectedByUser) {
        filteredShippings = _toConsumableArray(shippings).filter(function(s) {
            return s.deliveryMethod !== "INSTORE_PICKUP";
        });
    }
    if (filteredShippings.length === 0) {
        return undefined;
    }
    var sortedShippings = sortShippings(filteredShippings, isSortByFastest ? sortByFastest : sortByCheapest, isSortByFastest ? sortByCheapest : sortByFastest);
    return sortedShippings[0];
};
var sortByCheapest = function(s1, s2) {
    if (s1.shippingCost === undefined && s2.shippingCost !== undefined) return 1;
    if (s1.shippingCost !== undefined && s2.shippingCost === undefined) return -1;
    if (s1.shippingCost === undefined && s2.shippingCost === undefined) return 0;
    return s1.shippingCost - s2.shippingCost;
};
var sortByFastest = function(s1, s2) {
    if (s1.deliveryDays === null && s2.deliveryDays !== null) return 1;
    if (s1.deliveryDays !== null && s2.deliveryDays === null) return -1;
    if (s1.deliveryDays === null && s2.deliveryDays === null) return 0;
    if (s1.deliveryDays.min !== s2.deliveryDays.min) {
        return s1.deliveryDays.min - s2.deliveryDays.min;
    }
    return s1.deliveryDays.max - s2.deliveryDays.max;
};
var sortShippings = function(shippings, primarySort, secondarySort) {
    if (shippings.length === 0) {
        return shippings;
    }
    return _toConsumableArray(shippings).sort(function(s1, s2) {
        var primarySortResult = primarySort(s1, s2);
        if (primarySortResult !== 0) {
            return primarySortResult;
        }
        return secondarySort(s1, s2);
    });
};

// EXTERNAL MODULE: ./src/components/price-list/utils.ts
var price_list_utils = __webpack_require__(67589);
;// CONCATENATED MODULE: ./src/components/price-list/filtering-generic.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


var filterOffer = function(offer, filter) {
    // Keep offers with missing info if we have a function defined for it
    return filter.missingInfoFn ? filter.filterFn(offer, filter.selection) || filter.missingInfoFn(offer) : filter.filterFn(offer, filter.selection);
};
function tryFindNewMainOffer(offer, filter) {
    var ref;
    var mainOfferIsValid = filter.filterFn(offer, filter.selection);
    if (mainOfferIsValid) return offer;
    var mainOfferHasMissingInfo = filter.missingInfoFn && filter.missingInfoFn(offer);
    if (!((ref = offer.alternativePrices) === null || ref === void 0 ? void 0 : ref.length)) {
        if (mainOfferHasMissingInfo) return offer;
        return null;
    }
    var firstValidAlternativeOffer = offer.alternativePrices.find(function(alt) {
        return filter.filterFn(alt, filter.selection);
    });
    // If no valid alt offer but a main offer with missing info, return the main offer
    if (!firstValidAlternativeOffer && mainOfferHasMissingInfo) {
        return offer;
    }
    // If no valid alt offer, try finding one with missing info
    if (!firstValidAlternativeOffer && filter.missingInfoFn) {
        firstValidAlternativeOffer = offer.alternativePrices.find(function(alt) {
            return filter.missingInfoFn(alt);
        });
    }
    // If no offer (incl. missing info) is valid, return no offer
    if (!firstValidAlternativeOffer) {
        return null;
    }
    return (0,price_list_utils/* replaceMainOfferWithAlternativeOffer */.O)(offer, firstValidAlternativeOffer);
}
var filterOffersGeneric = function(offers, filter) {
    if (!offers.length || !filter.active) {
        return offers;
    }
    if (!filter.filterAlternativeOffers || offers.every(function(offer) {
        var ref;
        return !((ref = offer.alternativePrices) === null || ref === void 0 ? void 0 : ref.length);
    })) {
        return offers.filter(function(mainOffer) {
            return filterOffer(mainOffer, filter);
        });
    }
    // Filtering alternative offers
    var filteredOffers = [];
    offers.forEach(function(offer) {
        var ref;
        var filteredAlternatives = (ref = offer.alternativePrices) === null || ref === void 0 ? void 0 : ref.filter(function(alt) {
            return filterOffer(alt, filter);
        });
        if (!(filteredAlternatives === null || filteredAlternatives === void 0 ? void 0 : filteredAlternatives.length)) {
            return;
        }
        var offerWithFilteredAlternatives = _objectSpreadProps(_objectSpread({}, offer), {
            alternativePrices: filteredAlternatives
        });
        var newMainOffer = tryFindNewMainOffer(offerWithFilteredAlternatives, filter);
        if (newMainOffer) {
            filteredOffers.push(newMainOffer);
        }
    });
    return filteredOffers;
};
var filterShippingsGeneric = function(offers, filters) {
    var applicapleFilters = filters.filter(function(filter) {
        return filter.active && filter.filterShippingFn;
    });
    var filteredOffers = offers.map(function(offer) {
        var ref;
        return _objectSpreadProps(_objectSpread({}, filterOfferShippings(offer, applicapleFilters)), {
            unfilteredShippings: offer === null || offer === void 0 ? void 0 : (ref = offer.shipping) === null || ref === void 0 ? void 0 : ref.nodes
        });
    });
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = filteredOffers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var offer = _step.value;
            if (offer.alternativePrices) {
                offer.alternativePrices = offer.alternativePrices.map(function(altOffer) {
                    return filterOfferShippings(altOffer, applicapleFilters);
                });
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return filteredOffers;
};
var filterOfferShippings = function(offer, filters) {
    if (!offer.shipping || !offer.shipping.nodes) {
        return offer;
    }
    var shippingNodes = offer.shipping.nodes;
    var filteredShippings = shippingNodes.filter(function(shipping) {
        return filters.every(function(filter) {
            return filter.filterShippingFn(shipping, filter.selection);
        });
    });
    var cheapest = getSortedShipping(filteredShippings, false, filters);
    var fastest = getSortedShipping(filteredShippings, true, filters);
    return _objectSpreadProps(_objectSpread({}, offer), {
        shipping: {
            cheapest: cheapest,
            fastest: fastest,
            nodes: filteredShippings
        }
    });
};

;// CONCATENATED MODULE: ./src/components/price-list/filtering.ts
function filtering_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function filtering_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            filtering_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function filtering_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function filtering_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        filtering_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


var createExtendedPrices = function(priceList, deals) {
    var ref;
    var offers = priceList === null || priceList === void 0 ? void 0 : (ref = priceList.nodes) === null || ref === void 0 ? void 0 : ref.filter(function(x) {
        return x;
    });
    var ref1;
    var extendedPrices = offers === null || offers === void 0 ? void 0 : offers.map(function(offer) {
        return filtering_objectSpreadProps(filtering_objectSpread({}, offer), {
            featured: (0,utils/* getIsFeatured */.ZF)(offer),
            dealOffers: (ref1 = deals === null || deals === void 0 ? void 0 : deals.filter(function(deal) {
                var ref;
                return deal.shopId === ((ref = offer.store) === null || ref === void 0 ? void 0 : ref.id);
            })) !== null && ref1 !== void 0 ? ref1 : []
        });
    });
    return extendedPrices !== null && extendedPrices !== void 0 ? extendedPrices : [];
};
var filterOffers = function(filters, priceList, deals) {
    var filteredOffers = createExtendedPrices(priceList, deals);
    filters.forEach(function(filter) {
        filteredOffers = filterOffersGeneric(filteredOffers, filter);
    });
    return filterShippingsGeneric(filteredOffers, filters);
};


/***/ }),

/***/ 87990:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": () => (/* binding */ getFiltersConfig)
/* harmony export */ });
/* unused harmony export isOfferWithMissingShippingInfo */
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79126);

var isOfferWithShippingInfoAndSelections = function(offer, selection) {
    var ref;
    return offer && "shipping" in offer && ((ref = offer.shipping) === null || ref === void 0 ? void 0 : ref.nodes) && selection && selection.length > 0;
};
var isOfferWithMissingShippingInfo = function(offer) {
    var ref, ref1;
    return !(offer && "shipping" in offer) || !((ref = offer.shipping) === null || ref === void 0 ? void 0 : ref.nodes) || !(((ref1 = offer.shipping) === null || ref1 === void 0 ? void 0 : ref1.nodes.length) > 0);
};
var getFiltersConfig = function() {
    return [
        {
            label: "stock-status.in_stock",
            type: _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterType.IN_STOCK */ .vA.IN_STOCK,
            placement: [
                _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterUIPlacementEnum.FILTER_MENU */ .jm.FILTER_MENU,
                _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterUIPlacementEnum.OFFERLIST_HEADER */ .jm.OFFERLIST_HEADER
            ],
            subPlacement: _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterUISubPlacementEnum.SHOW_ONLY */ .$4.SHOW_ONLY,
            filterFn: function(offer) {
                var ref;
                return Boolean((offer === null || offer === void 0 ? void 0 : (ref = offer.stock) === null || ref === void 0 ? void 0 : ref.status) === "in_stock");
            },
            missingInfoFn: function(offer) {
                var ref, ref1;
                return Boolean(!(offer === null || offer === void 0 ? void 0 : (ref = offer.stock) === null || ref === void 0 ? void 0 : ref.status) || (offer === null || offer === void 0 ? void 0 : (ref1 = offer.stock) === null || ref1 === void 0 ? void 0 : ref1.status) === "unknown");
            },
            filterAlternativeOffers: true,
            active: false,
            treatUnfeaturedAsMissingInfo: false
        },
        {
            label: "display.price_includes_shipping",
            translationPrefix: "common",
            type: _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterType.PRICES_INC_SHIPPING */ .vA.PRICES_INC_SHIPPING,
            placement: [
                _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterUIPlacementEnum.OFFERLIST_HEADER */ .jm.OFFERLIST_HEADER,
                _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterUIPlacementEnum.FILTER_MENU */ .jm.FILTER_MENU
            ],
            filterFn: function(offer) {
                var ref;
                return Boolean(offer === null || offer === void 0 ? void 0 : (ref = offer.price) === null || ref === void 0 ? void 0 : ref.inclShipping);
            },
            missingInfoFn: function(offer) {
                var ref;
                return !(offer === null || offer === void 0 ? void 0 : (ref = offer.price) === null || ref === void 0 ? void 0 : ref.inclShipping);
            },
            filterAlternativeOffers: true,
            active: false,
            treatUnfeaturedAsMissingInfo: true
        },
        {
            label: "price-filter.authorized-dealer",
            type: _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterType.AUTHORIZED_DEALER */ .vA.AUTHORIZED_DEALER,
            placement: [
                _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterUIPlacementEnum.FILTER_MENU */ .jm.FILTER_MENU
            ],
            subPlacement: _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterUISubPlacementEnum.SHOW_ONLY */ .$4.SHOW_ONLY,
            filterFn: function(offer) {
                return Boolean(offer && "authorizedDealer" in offer && offer.authorizedDealer);
            },
            filterAlternativeOffers: false,
            active: false
        },
        {
            label: "price-filter.international",
            type: _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterType.INTERNATIONAL */ .vA.INTERNATIONAL,
            placement: [
                _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterUIPlacementEnum.FILTER_MENU */ .jm.FILTER_MENU
            ],
            subPlacement: _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterUISubPlacementEnum.ADDITIVE */ .$4.ADDITIVE,
            filterFn: function(offer) {
                return Boolean(offer === null || offer === void 0 ? void 0 : offer.primaryMarket);
            },
            filterAlternativeOffers: true,
            active: true,
            additive: true
        },
        {
            label: "price-filter.not-for-sale",
            type: _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterType.NOT_FOR_SALE */ .vA.NOT_FOR_SALE,
            placement: [
                _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterUIPlacementEnum.FILTER_MENU */ .jm.FILTER_MENU
            ],
            subPlacement: _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterUISubPlacementEnum.ADDITIVE */ .$4.ADDITIVE,
            filterFn: function(offer) {
                var ref;
                return Boolean(offer && (offer === null || offer === void 0 ? void 0 : (ref = offer.availability) === null || ref === void 0 ? void 0 : ref.condition) !== "NotAvailableForOrder");
            },
            filterAlternativeOffers: true,
            active: true,
            additive: true
        },
        {
            label: "",
            type: _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterType.VARIANT_SIZE */ .vA.VARIANT_SIZE,
            placement: [
                _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterUIPlacementEnum.PRODUCT_HEADER */ .jm.PRODUCT_HEADER
            ],
            filterFn: function(offer, selection) {
                var ref;
                return Boolean(offer && (offer === null || offer === void 0 ? void 0 : (ref = offer.variantInfo) === null || ref === void 0 ? void 0 : ref.size) && (selection === null || selection === void 0 ? void 0 : selection.includes(offer.variantInfo.size)));
            },
            missingInfoFn: function(offer) {
                var ref;
                return !(offer === null || offer === void 0 ? void 0 : (ref = offer.variantInfo) === null || ref === void 0 ? void 0 : ref.size);
            },
            filterAlternativeOffers: true,
            active: false,
            selection: [],
            initialSelection: []
        },
        {
            label: "",
            type: _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterType.VARIANT_COLOR */ .vA.VARIANT_COLOR,
            placement: [
                _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterUIPlacementEnum.PRODUCT_HEADER */ .jm.PRODUCT_HEADER
            ],
            filterFn: function(offer, selection) {
                var ref, ref1;
                return Boolean((selection === null || selection === void 0 ? void 0 : selection.length) && (offer === null || offer === void 0 ? void 0 : (ref = offer.variantInfo) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.some(function(color) {
                    return selection.includes(color);
                })));
            },
            missingInfoFn: function(offer) {
                var ref, ref1;
                return !(offer === null || offer === void 0 ? void 0 : (ref = offer.variantInfo) === null || ref === void 0 ? void 0 : ref.colors) || (offer === null || offer === void 0 ? void 0 : (ref1 = offer.variantInfo) === null || ref1 === void 0 ? void 0 : ref1.colors.length) < 1;
            },
            filterAlternativeOffers: true,
            active: false,
            selection: [],
            initialSelection: []
        },
        {
            label: "",
            type: _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterType.CONDITION */ .vA.CONDITION,
            placement: [],
            filterFn: function(offer, selection) {
                return Boolean((offer === null || offer === void 0 ? void 0 : offer.condition) && (selection === null || selection === void 0 ? void 0 : selection.includes(offer === null || offer === void 0 ? void 0 : offer.condition)));
            },
            filterAlternativeOffers: true,
            active: false,
            selection: [],
            initialSelection: []
        },
        {
            label: "",
            type: _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterType.DELIVERY_METHOD */ .vA.DELIVERY_METHOD,
            placement: [
                _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterUIPlacementEnum.FILTER_MENU */ .jm.FILTER_MENU
            ],
            filterFn: function(offer, selection) {
                var ref;
                return Boolean(isOfferWithShippingInfoAndSelections(offer, selection) && ((ref = offer.shipping) === null || ref === void 0 ? void 0 : ref.nodes.some(function(node) {
                    return (node === null || node === void 0 ? void 0 : node.deliveryMethod) && (selection === null || selection === void 0 ? void 0 : selection.includes(node.deliveryMethod));
                })));
            },
            filterShippingFn: function(shipping, selection) {
                return Boolean(selection && shipping.deliveryMethod && selection.includes(shipping.deliveryMethod));
            },
            missingInfoFn: isOfferWithMissingShippingInfo,
            filterAlternativeOffers: true,
            active: false,
            selection: []
        },
        {
            label: "",
            type: _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterType.CARRIERS */ .vA.CARRIERS,
            placement: [
                _types__WEBPACK_IMPORTED_MODULE_0__/* .FilterUIPlacementEnum.FILTER_MENU */ .jm.FILTER_MENU
            ],
            filterFn: function(offer, selection) {
                var ref;
                return Boolean(isOfferWithShippingInfoAndSelections(offer, selection) && ((ref = offer.shipping) === null || ref === void 0 ? void 0 : ref.nodes.some(function(node) {
                    return (node === null || node === void 0 ? void 0 : node.carrier) && (selection === null || selection === void 0 ? void 0 : selection.includes(node.carrier));
                })));
            },
            filterShippingFn: function(shipping, selection) {
                return Boolean(selection && shipping.carrier && selection.includes(shipping.carrier));
            },
            missingInfoFn: isOfferWithMissingShippingInfo,
            filterAlternativeOffers: true,
            active: false,
            selection: []
        }
    ];
};


/***/ }),

/***/ 31780:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cv": () => (/* binding */ genericSort),
/* harmony export */   "Sr": () => (/* binding */ SortDirection),
/* harmony export */   "bo": () => (/* binding */ sortOffersByPrice)
/* harmony export */ });
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79126);
/* harmony import */ var src_areas_product_utils_product_condition_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83071);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


var ALMOST_INFINATE_SHIPPING_COST = 1000000;
var SortDirection;
(function(SortDirection) {
    SortDirection[SortDirection["Ascending"] = 0] = "Ascending";
    SortDirection[SortDirection["Descending"] = 1] = "Descending";
})(SortDirection || (SortDirection = {}));
var sortByPriceProp = function(priceDisplay) {
    var resolver = priceDisplay === _types__WEBPACK_IMPORTED_MODULE_0__/* .PriceDisplayEnum.PRICE_INCLUDES_SHIPPING */ .wB.PRICE_INCLUDES_SHIPPING ? function(offer) {
        var ref;
        return getPriceInclShipping(offer) || (offer === null || offer === void 0 ? void 0 : (ref = offer.price) === null || ref === void 0 ? void 0 : ref.exclShipping);
    } : function(offer) {
        return offer.price && offer.price.exclShipping;
    };
    return {
        resolver: resolver,
        sortDirection: SortDirection.Ascending
    };
};
var sortByShippingPriceProp = function() {
    var resolver = function(offer) {
        return getCheapestShippingCost(offer);
    };
    return {
        resolver: resolver,
        sortDirection: SortDirection.Ascending
    };
};
var sortByConditionProp = function() {
    var resolver = function(offer) {
        return offer.condition === src_areas_product_utils_product_condition_types__WEBPACK_IMPORTED_MODULE_1__/* .ConditionEnum.NEW */ .M.NEW ? 0 : 1;
    };
    return {
        resolver: resolver,
        sortDirection: SortDirection.Ascending
    };
};
var sortByStockStatusProp = function() {
    var resolver = function(offer) {
        var ref;
        return ((ref = offer.stock) === null || ref === void 0 ? void 0 : ref.status) === "in_stock" ? 0 : 1;
    };
    return {
        resolver: resolver,
        sortDirection: SortDirection.Ascending
    };
};
var sortByUserReviewProp = function() {
    var resolver = function(offer) {
        var ref, ref1;
        return ((ref = offer.store) === null || ref === void 0 ? void 0 : (ref1 = ref.userReviewSummary) === null || ref1 === void 0 ? void 0 : ref1.rating) || 0;
    };
    return {
        resolver: resolver,
        sortDirection: SortDirection.Descending
    };
};
var sortByUserReviewCountProp = function() {
    var resolver = function(offer) {
        var ref, ref1;
        return ((ref = offer.store) === null || ref === void 0 ? void 0 : (ref1 = ref.userReviewSummary) === null || ref1 === void 0 ? void 0 : ref1.countTotal) || 0;
    };
    return {
        resolver: resolver,
        sortDirection: SortDirection.Descending
    };
};
var getPriceInclShipping = function(offer) {
    var ref;
    var ref1;
    var basePrice = (ref1 = (ref = offer.price) === null || ref === void 0 ? void 0 : ref.exclShipping) !== null && ref1 !== void 0 ? ref1 : Infinity;
    var cheapestShipping = getCheapestShippingCost(offer);
    return basePrice + cheapestShipping;
};
var getCheapestShippingCost = function(offer) {
    var ref, ref1;
    var ref2;
    return (ref2 = (ref = offer.shipping) === null || ref === void 0 ? void 0 : (ref1 = ref.cheapest) === null || ref1 === void 0 ? void 0 : ref1.shippingCost) !== null && ref2 !== void 0 ? ref2 : ALMOST_INFINATE_SHIPPING_COST;
};
var sortOffersByPrice = function(priceDisplay, prices) {
    var priceSort = sortByPriceProp(priceDisplay);
    var shippingPriceProp = sortByShippingPriceProp();
    var conditionProp = sortByConditionProp();
    var stockStatusProp = sortByStockStatusProp();
    var userReviewProp = sortByUserReviewProp();
    var userReviewCountProp = sortByUserReviewCountProp();
    return genericSort(prices, priceSort, shippingPriceProp, conditionProp, stockStatusProp, userReviewProp, userReviewCountProp);
};
var genericSort = function(prices, primaryProp, secondaryProp, thirdProp, fouthProp, fifthProp, sixthProp) {
    return _toConsumableArray(prices).sort(function(a, b) {
        var firstSort = orderItem(a, b, primaryProp);
        if (firstSort !== 0) {
            return firstSort;
        }
        if (secondaryProp) {
            var secondSort = orderItem(a, b, secondaryProp);
            if (secondSort !== 0) {
                return secondSort;
            }
        }
        if (thirdProp) {
            var thirdSort = orderItem(a, b, thirdProp);
            if (thirdSort !== 0) {
                return thirdSort;
            }
        }
        if (fouthProp) {
            var fourthSort = orderItem(a, b, fouthProp);
            if (fourthSort !== 0) {
                return fourthSort;
            }
        }
        if (fifthProp) {
            var fifthSort = orderItem(a, b, fifthProp);
            if (fifthSort !== 0) {
                return fifthSort;
            }
        }
        if (sixthProp) {
            var sixthSort = orderItem(a, b, sixthProp);
            if (sixthSort !== 0) {
                return sixthSort;
            }
        }
        return 0;
    });
};
var orderItem = function(a, b, prop) {
    var aProp = prop.resolver(a);
    var bProp = prop.resolver(b);
    if (aProp < bProp) {
        return prop.sortDirection === SortDirection.Descending ? 1 : -1;
    }
    if (aProp > bProp) {
        return prop.sortDirection === SortDirection.Descending ? -1 : 1;
    }
    return 0;
};


/***/ }),

/***/ 79126:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$4": () => (/* binding */ FilterUISubPlacementEnum),
/* harmony export */   "$z": () => (/* binding */ SustainabilityEnum),
/* harmony export */   "hs": () => (/* binding */ EligibilityEnum),
/* harmony export */   "jm": () => (/* binding */ FilterUIPlacementEnum),
/* harmony export */   "vA": () => (/* binding */ FilterType),
/* harmony export */   "wB": () => (/* binding */ PriceDisplayEnum)
/* harmony export */ });
/* unused harmony exports SortOptionEnum, SortTypeEnum */
var PriceDisplayEnum;
(function(PriceDisplayEnum) {
    PriceDisplayEnum["PRICE"] = "price-excludes-shipping";
    PriceDisplayEnum["PRICE_INCLUDES_SHIPPING"] = "price_includes_shipping";
})(PriceDisplayEnum || (PriceDisplayEnum = {}));
var SortOptionEnum;
(function(SortOptionEnum) {
    SortOptionEnum["PRICE"] = "price";
    SortOptionEnum["PRICEANDSTOCKSTATUS"] = "price_in_stock";
})(SortOptionEnum || (SortOptionEnum = {}));
var FilterType;
(function(FilterType) {
    FilterType["PRICES_INC_SHIPPING"] = "prices_inc_shipping";
    FilterType["IN_STOCK"] = "in_stock";
    FilterType["AUTHORIZED_DEALER"] = "authorized_dealer";
    FilterType["PICKUP_ONLY"] = "pickup_only";
    FilterType["INTERNATIONAL"] = "international";
    FilterType["NOT_FOR_SALE"] = "not_for_sale";
    FilterType["VARIANT_SIZE"] = "variant_size";
    FilterType["VARIANT_COLOR"] = "variant_color";
    FilterType["CONDITION"] = "condition";
    FilterType["DELIVERY_METHOD"] = "shipping-delivery-method";
    FilterType["CARRIERS"] = "shipping-carriers";
})(FilterType || (FilterType = {}));
var SortTypeEnum;
(function(SortTypeEnum) {
    SortTypeEnum["LOWEST_PRICE"] = "lowest-price";
    SortTypeEnum["FASTEST_DELIVERY"] = "fastest-delivery";
})(SortTypeEnum || (SortTypeEnum = {}));
var FilterUIPlacementEnum;
(function(FilterUIPlacementEnum) {
    FilterUIPlacementEnum[FilterUIPlacementEnum["PRODUCT_HEADER"] = 0] = "PRODUCT_HEADER";
    FilterUIPlacementEnum[FilterUIPlacementEnum["FILTER_MENU"] = 1] = "FILTER_MENU";
    FilterUIPlacementEnum[FilterUIPlacementEnum["OFFERLIST_HEADER"] = 2] = "OFFERLIST_HEADER";
})(FilterUIPlacementEnum || (FilterUIPlacementEnum = {}));
var FilterUISubPlacementEnum;
(function(FilterUISubPlacementEnum) {
    FilterUISubPlacementEnum[FilterUISubPlacementEnum["SHOW_ONLY"] = 0] = "SHOW_ONLY";
    FilterUISubPlacementEnum[FilterUISubPlacementEnum["ADDITIVE"] = 1] = "ADDITIVE";
})(FilterUISubPlacementEnum || (FilterUISubPlacementEnum = {}));
var SustainabilityEnum;
(function(SustainabilityEnum) {
    SustainabilityEnum["SUSTAINABILITY_UNKNOWN"] = "SUSTAINABILITY_UNKNOWN";
    SustainabilityEnum["NOT_SUSTAINABLE"] = "NOT_SUSTAINABLE";
    SustainabilityEnum["SUSTAINABLE"] = "SUSTAINABLE";
})(SustainabilityEnum || (SustainabilityEnum = {}));
var EligibilityEnum;
(function(EligibilityEnum) {
    EligibilityEnum["ELIGIBILITY_UNKNOWN"] = "ELIGIBILITY_UNKNOWN";
    EligibilityEnum["ALL"] = "ALL";
    EligibilityEnum["MEMBERS"] = "MEMBERS";
})(EligibilityEnum || (EligibilityEnum = {}));


/***/ }),

/***/ 67589:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": () => (/* binding */ replaceMainOfferWithAlternativeOffer)
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var replaceMainOfferWithAlternativeOffer = function(offer, alternativeOffer) {
    if (!alternativeOffer) return offer;
    var newAlternatives = [
        alternativeOffer
    ].concat(_toConsumableArray(offer.alternativePrices.filter(function(alt) {
        return alt !== alternativeOffer;
    })));
    return _objectSpreadProps(_objectSpread({}, alternativeOffer), {
        __typename: offer.__typename,
        authorizedDealer: offer.authorizedDealer,
        featured: offer.featured,
        store: offer.store,
        unfilteredShippings: offer.unfilteredShippings,
        dealOffers: offer.dealOffers,
        alternativePrices: newAlternatives
    });
};


/***/ }),

/***/ 21753:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": () => (/* binding */ CompareCheckbox)
/* harmony export */ });
/* unused harmony export SelectedCheckbox */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71993);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61093);
/* harmony import */ var _prisjakt_ui_icon_check__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35964);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: calc(",
        " - 4px);\n  left: calc(",
        " - 4px);\n  z-index: 102;\n  padding: ",
        ";\n  background: rgba(255, 255, 255, 0.72);\n  border-radius: 4px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: ",
        "px;\n  height: ",
        "px;\n  background: ",
        ";\n  box-shadow: ",
        ";\n  border-radius: 3px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



// Prerequisites before replacing this with @prisjakt/ui/checkbox:
// 1. Change selected color on @prisjakt/ui/card from yellow to blue
// 2. Remove inner margin from @prisjakt/ui/checkbox
// 3. Maybe allow @prisjakt/ui/checkbox to be controlled (i.e. remove requirement of onChange)

var SIZE = 18;
var CompareCheckbox = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CheckboxWrapper, {
        className: props.className
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SelectedCheckbox, {
        $selected: props.selected
    }, props.selected && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_icon_check__WEBPACK_IMPORTED_MODULE_3__/* .IconCheck */ .N, {
        color: "base0",
        size: 14
    })));
};
var CheckboxWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
    displayName: "CheckboxWrapper",
    componentId: "sc-0-0"
})(_templateObject(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025);
var SelectedCheckbox = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
    displayName: "SelectedCheckbox",
    componentId: "sc-0-1"
})(_templateObject1(), SIZE, SIZE, function(p) {
    return p.$selected ? p.theme.colors.yellove500 : "transparent";
}, function(p) {
    return p.$selected ? "none" : "inset 0 0 0 1px ".concat(p.theme.lines.quaternary);
}, function(p) {
    return p.theme.colors.base0;
});


/***/ }),

/***/ 4450:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": () => (/* binding */ GridCardHeader)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _product_card_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39728);
/* harmony import */ var _compare_checkbox__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21753);
/* harmony import */ var _media__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52545);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95886);





var GridCardHeader = function(props) {
    var _marginRem = props.marginRem, marginRem = _marginRem === void 0 ? 1 : _marginRem, _imageSize = props.imageSize, imageSize = _imageSize === void 0 ? 140 : _imageSize;
    var ref = (0,_product_card_context__WEBPACK_IMPORTED_MODULE_1__/* .useProductCardContext */ .I)(), _product = ref.product, brand = _product.brand, media = _product.media, name = _product.name, tmp = ref.selectStates, ref1 = tmp === void 0 ? {} : tmp, selectable = ref1.selectable, _selected = ref1.selected, selected = _selected === void 0 ? false : _selected, _shouldLazyLoadImage = ref.shouldLazyLoadImage, shouldLazyLoadImage = _shouldLazyLoadImage === void 0 ? false : _shouldLazyLoadImage;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, selectable ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_compare_checkbox__WEBPACK_IMPORTED_MODULE_2__/* .CompareCheckbox */ .j, {
        selected: selected
    }) : null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_4__/* .Media */ .pU, {
        $marginRem: marginRem,
        $size: shouldLazyLoadImage ? "".concat(imageSize, "px") : "auto"
    }, (brand === null || brand === void 0 ? void 0 : brand.logo) && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_4__/* .BrandLogo */ .Oc, {
        src: brand.logo,
        alt: brand.name || ""
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_media__WEBPACK_IMPORTED_MODULE_3__/* .ProductMedia */ .S, {
        lazyLoadImage: shouldLazyLoadImage,
        imageSize: imageSize,
        imageSrc: media === null || media === void 0 ? void 0 : media.first,
        name: name || ""
    })));
};


/***/ }),

/***/ 95886:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BN": () => (/* binding */ StyledTopLeftArea),
/* harmony export */   "E": () => (/* binding */ Properties),
/* harmony export */   "Kk": () => (/* binding */ ActionButton),
/* harmony export */   "NX": () => (/* binding */ ShopLogo),
/* harmony export */   "Oc": () => (/* binding */ BrandLogo),
/* harmony export */   "VY": () => (/* binding */ Content),
/* harmony export */   "Zb": () => (/* binding */ Card),
/* harmony export */   "_0": () => (/* binding */ CenteredButtonText),
/* harmony export */   "pU": () => (/* binding */ Media),
/* harmony export */   "vN": () => (/* binding */ PriceWrapper),
/* harmony export */   "w9": () => (/* binding */ StyledPrice)
/* harmony export */ });
/* unused harmony exports PriceInfo, DiffPercentageCore, ClickOutFooter, fadeIn, ReportOverlay, Options, Option, Dropdown */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71993);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61093);
/* harmony import */ var src_ui_zindex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93497);
/* harmony import */ var _prisjakt_ui_card__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89695);
/* harmony import */ var _prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35967);
/* harmony import */ var _prisjakt_ui_dropdown__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42654);
/* harmony import */ var src_components_store_logo__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19247);
/* harmony import */ var _prisjakt_ui_button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17658);
/* harmony import */ var _prisjakt_design_tokens__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(43220);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      background-color: ",
        ";\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  height: 100%;\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 1 auto;\n  text-align: initial;\n  padding-top: 0;\n  word-break: break-word;\n  gap: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: ",
        ";\n  right: ",
        ";\n  display: flex;\n  flex-direction: column;\n  z-index: ",
        ";\n\n  > *:not(:first-child) {\n    margin-top: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  overflow: visible;\n  height: ",
        ";\n  margin: ",
        "rem 0 ",
        " 0;\n\n  &::after {\n    background-color: transparent;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    top: ",
        ";\n    left: ",
        ";\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  background: ",
        ";\n  padding: 0.1rem 0.4rem;\n  border-radius: 2px;\n\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    align-items: center;\n    flex: 0 1 auto;\n    width: 100%;\n    ",
        "\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  white-space: nowrap;\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  z-index: 2;\n  bottom: 0;\n  left: ",
        ";\n  max-height: 20px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  animation: ",
        " 250ms ease-in-out 1;\n  width: 100%;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-items: center;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  white-space: nowrap;\n  cursor: pointer;\n  padding: ",
        ";\n\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  min-height: 100%;\n  margin-right: ",
        ";\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: center;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  left: ",
        ";\n  top: ",
        ";\n  z-index: ",
        ";\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}









var Card = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_card__WEBPACK_IMPORTED_MODULE_3__.Card).withConfig({
    displayName: "Card",
    componentId: "sc-0-0"
})(_templateObject1(), function(p) {
    return p.background && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject(), p.theme.bg.primary);
});
var Content = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_card__WEBPACK_IMPORTED_MODULE_3__.CardContent).withConfig({
    displayName: "Content",
    componentId: "sc-0-1"
})(_templateObject2(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025);
var ActionButton = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "ActionButton",
    componentId: "sc-0-2"
})(_templateObject3(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, src_ui_zindex__WEBPACK_IMPORTED_MODULE_2__/* .zindex.actionButton */ .Y.actionButton, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100);
var PriceInfo = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "PriceInfo",
    componentId: "sc-0-3"
})(_templateObject4());
var Properties = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Properties",
    componentId: "sc-0-4"
})(function() {
    return "\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n";
});
var Media = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_card__WEBPACK_IMPORTED_MODULE_3__.CardMedia).withConfig({
    displayName: "Media",
    componentId: "sc-0-5"
})(_templateObject5(), function(p) {
    return p.$size;
}, function(p) {
    return p.$marginRem;
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var DiffPercentageCore = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "DiffPercentageCore",
    componentId: "sc-0-6"
})(_templateObject7(), function(p) {
    return p.theme.colors.redio500;
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumUp */ .BC.mediumUp(_templateObject6(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.productCardPaddingLarge */ .bK.productCardPaddingLarge, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.productCardPaddingLarge */ .bK.productCardPaddingLarge));
var PriceWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_4__.Row).withConfig({
    displayName: "PriceWrapper",
    componentId: "sc-0-7"
})(_templateObject8(), function(p) {
    return p.isKWLP && "justify-content: space-between";
});
var StyledPrice = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "StyledPrice",
    componentId: "sc-0-8"
})(_templateObject9(), function(p) {
    return p.flexEnd && "align-items: flex-end";
});
var BrandLogo = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].img.withConfig({
    displayName: "BrandLogo",
    componentId: "sc-0-9"
})(_templateObject10(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100);
var ShopLogo = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_components_store_logo__WEBPACK_IMPORTED_MODULE_6__/* .StoreLogo */ .Xv).withConfig({
    displayName: "ShopLogo",
    componentId: "sc-0-10"
})(_templateObject11(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var ClickOutFooter = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "ClickOutFooter",
    componentId: "sc-0-11"
})(_templateObject12());
var fadeIn = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.keyframes)(_templateObject13());
var ReportOverlay = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "ReportOverlay",
    componentId: "sc-0-12"
})(_templateObject14(), function(p) {
    return p.theme.text.secondary;
}, fadeIn);
var Options = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Options",
    componentId: "sc-0-13"
})(_templateObject15());
var Option = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].button.withConfig({
    displayName: "Option",
    componentId: "sc-0-14"
})(_templateObject16(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, function(p) {
    return p.theme.dropdowns.secondary.hoverBackground;
});
var Dropdown = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_dropdown__WEBPACK_IMPORTED_MODULE_5__/* .Dropdown */ .Lt).withConfig({
    displayName: "Dropdown",
    componentId: "sc-0-15"
})(_templateObject17(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var CenteredButtonText = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_button__WEBPACK_IMPORTED_MODULE_7__.ButtonText).withConfig({
    displayName: "CenteredButtonText",
    componentId: "sc-0-16"
})(_templateObject18());
var StyledTopLeftArea = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "StyledTopLeftArea",
    componentId: "sc-0-17"
})(_templateObject19(), _prisjakt_design_tokens__WEBPACK_IMPORTED_MODULE_8__.measurements.spacing075, _prisjakt_design_tokens__WEBPACK_IMPORTED_MODULE_8__.measurements.spacing075, src_ui_zindex__WEBPACK_IMPORTED_MODULE_2__/* .zindex.popover */ .Y.popover);


/***/ }),

/***/ 52545:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": () => (/* binding */ ProductMedia)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71993);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18026);
/* harmony import */ var src_components_lazy__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67506);
/* harmony import */ var src_components_product_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87044);
/* harmony import */ var src_components_skeleton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70867);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: auto;\n  height: 100%;\n  max-height: ",
        ";\n  object-fit: contain;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  max-height: ",
        ";\n  display: flex;\n  justify-content: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var ProductMedia = function(props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_2__/* .AppContext */ .Il), _market = ref.market, market = _market === void 0 ? {
        cdn: "https://cdn.pji.nu"
    } : _market;
    var lazyLoadImage = props.lazyLoadImage, imageSize = props.imageSize, imageSrc = props.imageSrc, name = props.name, renderWithHalo = props.renderWithHalo;
    var fallback = "".concat(market.cdn, "/product/standard/280/0.jpg");
    var productImage = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ProductImage, {
        src: imageSrc,
        name: name,
        fallback: fallback,
        height: imageSize,
        width: imageSize,
        $size: "".concat(imageSize, "px"),
        className: props.className
    });
    var halo = renderWithHalo ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(HaloWrapper, {
        $size: "".concat(imageSize, "px")
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
        viewBox: "0 0 100 100",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
        cx: "50",
        cy: "50",
        r: "50",
        fill: "#001624",
        fillOpacity: "0.06"
    }))) : null;
    var placeholder = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(param) {
        var inView = param.inView;
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_skeleton__WEBPACK_IMPORTED_MODULE_5__/* .SkeletonMedia */ .zN, {
            height: imageSize,
            width: imageSize,
            paused: !inView
        });
    }, [
        imageSize
    ]);
    return lazyLoadImage ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_lazy__WEBPACK_IMPORTED_MODULE_3__/* .Lazy */ .o, {
        offset: 0,
        placeholder: placeholder
    }, productImage, halo) : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, productImage, halo);
};
var ProductImage = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])(src_components_product_image__WEBPACK_IMPORTED_MODULE_4__/* .ProductImage */ .q).withConfig({
    displayName: "ProductImage",
    componentId: "sc-0-0"
})(_templateObject(), function(p) {
    return p.$size;
});
var HaloWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
    displayName: "HaloWrapper",
    componentId: "sc-0-1"
})(_templateObject1(), function(p) {
    return p.$size;
});


/***/ }),

/***/ 93256:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": () => (/* binding */ NewClickOutButton)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71993);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61093);
/* harmony import */ var _prisjakt_ui_button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17658);
/* harmony import */ var _prisjakt_ui_icon_outgoing_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43709);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50959);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3616);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      pointer-events: none;\n      opacity: 0.24;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        "\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  height: 42px;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n  & > * {\n    vertical-align: middle;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex: none;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1;\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  justify-content: center;\n\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  & > path {\n    fill: currentColor;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}






var ICON_SIZE = 15;
var NewClickOutButton = function(param) {
    var className = param.className, containerProps = param.containerProps, href = param.href, onClick = param.onClick, external = param.external, text = param.text, _buttonType = param.buttonType, buttonType = _buttonType === void 0 ? _prisjakt_ui_button__WEBPACK_IMPORTED_MODULE_2__.ButtonType.PRIMARY : _buttonType;
    var linkProps = external ? {
        href: href,
        rel: "nofollow",
        target: "_blank"
    } : {
        to: href
    };
    var disabled = !href;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createElement(OuterWrapper, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createElement(StyledButton, {
        className: className,
        containerProps: _objectSpreadProps(_objectSpread({}, containerProps, linkProps), {
            "data-testid": "click-out-button"
        }),
        container: external ? "a" : react_router_dom__WEBPACK_IMPORTED_MODULE_5__/* .Link */ .rU,
        disabled: disabled,
        onClick: onClick,
        fullWidth: true,
        type: disabled ? _prisjakt_ui_button__WEBPACK_IMPORTED_MODULE_2__.ButtonType.TONAL : buttonType,
        "data-testid": "click-out-button"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createElement(InnerWrapper, null, "".concat(text, " "), external && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createElement(IconWrapper, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createElement(IconOutgoingLinkWithColorFix, {
        size: ICON_SIZE
    })))));
};
var StyledButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_button__WEBPACK_IMPORTED_MODULE_2__.Button).withConfig({
    displayName: "StyledButton",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject1(), props.disabled && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject()));
});
var OuterWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "OuterWrapper",
    componentId: "sc-0-1"
})(_templateObject2());
var IconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "IconWrapper",
    componentId: "sc-0-2"
})(_templateObject3(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025);
var InnerWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "InnerWrapper",
    componentId: "sc-0-3"
})(_templateObject5(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.smallOnly */ .BC.smallOnly(_templateObject4()));
var IconOutgoingLinkWithColorFix = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_icon_outgoing_link__WEBPACK_IMPORTED_MODULE_3__/* .IconOutgoingLink */ .v).withConfig({
    displayName: "IconOutgoingLinkWithColorFix",
    componentId: "sc-0-4"
})(_templateObject6());


/***/ }),

/***/ 25653:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": () => (/* binding */ Price)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71016);
/* harmony import */ var src_components_currency__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49763);
/* harmony import */ var src_components_offer_price_price_text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28254);




var Price = function(props) {
    var _isDeal = props.isDeal, isDeal = _isDeal === void 0 ? false : _isDeal, price = props.price, currency = props.currency;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_offer_price_price_text__WEBPACK_IMPORTED_MODULE_3__/* .PriceText */ .X, {
        color: isDeal ? _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_1__.FontColor.NEGATIVE : _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_1__.FontColor.DARK
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_currency__WEBPACK_IMPORTED_MODULE_2__/* .Currency */ .F, {
        price: price,
        code: currency
    }));
};


/***/ }),

/***/ 62688:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Yu": () => (/* reexport */ ProductCompactListCard),
  "r4": () => (/* reexport */ ProductGridCard),
  "MP": () => (/* reexport */ ProductListCard)
});

// UNUSED EXPORTS: CompareCheckbox, mapDataToProps

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/product-card-old/product-card-context.tsx
var product_card_context = __webpack_require__(39728);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/card/index.js
var card = __webpack_require__(89695);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(38689);
// EXTERNAL MODULE: ./src/components/badges/deals-badge/index.tsx + 1 modules
var deals_badge = __webpack_require__(56355);
// EXTERNAL MODULE: ./src/components/badges/image-badges.tsx
var image_badges = __webpack_require__(39986);
// EXTERNAL MODULE: ./src/components/product-of-the-year/hooks.ts
var hooks = __webpack_require__(78060);
// EXTERNAL MODULE: ./src/components/product-card-old/components/grid/styles.ts
var styles = __webpack_require__(95886);
;// CONCATENATED MODULE: ./src/components/product-card-old/components/grid/top-left-area.tsx







var TopLeftArea = function() {
    var ref = (0,app_context/* useAppContext */.bp)(), market = ref.market, t = ref.t;
    var ref1 = (0,product_card_context/* useProductCardContext */.I)(), diffPercentage = ref1.diffPercentage, hasExpertBadge = ref1.hasExpertBadge, _product = ref1.product, id = _product.id, priceSummary = _product.priceSummary, _type = ref1.type, type = _type === void 0 ? "product" : _type;
    var expertTopRatedBadgeUrl = "".concat(market.cdn, "/g/expert/").concat(market.code, "/expert-toprated-badge.png");
    var productOfTheYearAward = (0,hooks/* useGetProductOfTheYear */.i)(type === "product" ? id : undefined);
    var renderBadge = function() {
        if (diffPercentage && (priceSummary === null || priceSummary === void 0 ? void 0 : priceSummary.regular)) return /*#__PURE__*/ react.createElement(deals_badge/* DealsBadge */.T, {
            "data-testid": "DealsBadge",
            priceDrop: diffPercentage,
            price: priceSummary === null || priceSummary === void 0 ? void 0 : priceSummary.regular,
            popoverUniqueId: id || 0
        });
        if (productOfTheYearAward === null || productOfTheYearAward === void 0 ? void 0 : productOfTheYearAward.awardLogo) {
            return /*#__PURE__*/ react.createElement(image_badges/* GridCardImageBadge */.ni, {
                badgeUrl: productOfTheYearAward.awardLogo,
                title: "".concat(productOfTheYearAward.awardName, " ").concat(productOfTheYearAward.year)
            });
        }
        if (hasExpertBadge) {
            return /*#__PURE__*/ react.createElement(image_badges/* GridCardImageBadge */.ni, {
                badgeUrl: expertTopRatedBadgeUrl,
                title: t("expert", "expert.top-rated-badge")
            });
        }
        return null;
    };
    var badge = renderBadge();
    if (!badge) return null;
    return /*#__PURE__*/ react.createElement(styles/* StyledTopLeftArea */.BN, null, badge);
};

;// CONCATENATED MODULE: ./src/components/product-card-old/components/grid/grid-card.tsx







var GridCard = function(props) {
    var children = props.children, className = props.className, _FooterArea = props.FooterArea, FooterArea = _FooterArea === void 0 ? null : _FooterArea, _isClickable = props.isClickable, isClickable = _isClickable === void 0 ? true : _isClickable, _outlined = props.outlined, outlined = _outlined === void 0 ? true : _outlined;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), renderMode = ref.renderMode, market = ref.market;
    var ref1 = (0,product_card_context/* useProductCardContext */.I)(), _ActionArea = ref1.ActionArea, ActionArea = _ActionArea === void 0 ? null : _ActionArea, background = ref1.background, onClick = ref1.onClick, pathName = ref1.product.pathName, tmp = ref1.selectStates, ref2 = tmp === void 0 ? {} : tmp, onDeselect = ref2.onDeselect, onSelect = ref2.onSelect, selectable = ref2.selectable, selected = ref2.selected;
    var onClickOrSelect = (0,react.useCallback)(function() {
        var handleSelect = function() {
            if (selected && onDeselect) onDeselect();
            else if (onSelect) onSelect();
        };
        if (selectable) handleSelect();
        else if (onClick) onClick();
    }, [
        selected,
        onDeselect,
        onSelect,
        selectable,
        onClick
    ]);
    return /*#__PURE__*/ react.createElement(styles/* Card */.Zb, {
        className: className,
        background: background,
        outlined: outlined,
        selected: selected,
        container: "article",
        containerProps: {
            "data-test": "ProductGridCard"
        }
    }, /*#__PURE__*/ react.createElement(TopLeftArea, null), ActionArea && market.login.enabled && /*#__PURE__*/ react.createElement(styles/* ActionButton */.Kk, null, ActionArea), isClickable ? /*#__PURE__*/ react.createElement(card.CardActionArea, {
        container: clickable/* Clickable */.P,
        containerProps: {
            to: selectable ? undefined : pathName,
            isExternal: renderMode === "native",
            onClick: onClickOrSelect,
            style: {
                flex: "1 1 auto",
                cursor: "pointer"
            }
        }
    }, children) : children, FooterArea);
};

// EXTERNAL MODULE: ./src/components/store-logo/index.tsx
var store_logo = __webpack_require__(19247);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(71016);
// EXTERNAL MODULE: ./src/components/rating/index.tsx + 1 modules
var components_rating = __webpack_require__(9160);
// EXTERNAL MODULE: ./src/components/product-card-old/components/price.tsx
var components_price = __webpack_require__(25653);
;// CONCATENATED MODULE: ./src/components/product-card-old/components/product-name.tsx


var ProductName = function(props) {
    var children = props.children;
    return /*#__PURE__*/ react.createElement(variants.TitleSmallText, {
        behavior: variants.Behavior.TwolineEllipsis,
        containerProps: {
            "data-test": "ProductName"
        }
    }, children);
};

// EXTERNAL MODULE: ./src/components/cdn-image/index.tsx
var cdn_image = __webpack_require__(23437);
// EXTERNAL MODULE: ./src/areas/keyword-landing-page/contexts.ts
var contexts = __webpack_require__(85944);
;// CONCATENATED MODULE: ./src/components/product-card-old/map-to-core-props.ts
var mapToCoreProperties = function(properties) {
    return Array.isArray(properties) ? properties.filter(function(param) {
        var isCore = param.isCore, pretty = param.pretty;
        return isCore && pretty !== null;
    }).map(function(item) {
        return getPropertyValueOrName(item);
    }).filter(function(item) {
        return item !== null;
    }).join(", ") : null;
};
var getPropertyValueOrName = function(property) {
    if (property.type === "boolean") {
        return property.pretty === "true" ? property.name : null;
    }
    var _pretty;
    return (_pretty = property.pretty) !== null && _pretty !== void 0 ? _pretty : null;
};

;// CONCATENATED MODULE: ./src/components/product-card-old/components/grid/grid-card-content.tsx












var GridCardContent = function() {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref = (0,product_card_context/* useProductCardContext */.I)(), showPrefixFromPrice = ref.showPrefixFromPrice, highlightedName = ref.highlightedName, _product = ref.product, aggregatedRating = _product.aggregatedRating, category = _product.category, name = _product.name, priceSummary = _product.priceSummary, properties = _product.properties, store = _product.store, userReviewSummary = _product.userReviewSummary, showCategoryButton = ref.showCategoryButton;
    var price = priceSummary === null || priceSummary === void 0 ? void 0 : priceSummary.regular;
    var rating = (aggregatedRating === null || aggregatedRating === void 0 ? void 0 : aggregatedRating.score) || (userReviewSummary === null || userReviewSummary === void 0 ? void 0 : userReviewSummary.rating);
    var reviewsCount = (aggregatedRating === null || aggregatedRating === void 0 ? void 0 : aggregatedRating.count) || (userReviewSummary === null || userReviewSummary === void 0 ? void 0 : userReviewSummary.count);
    var isKWLP = (0,contexts/* useIsKWLP */._)();
    var coreProperties = mapToCoreProperties(properties === null || properties === void 0 ? void 0 : properties.nodes);
    return /*#__PURE__*/ react.createElement(styles/* Content */.VY, null, (category === null || category === void 0 ? void 0 : category.name) && !showCategoryButton && /*#__PURE__*/ react.createElement(variants.CaptionText, {
        emphasis: variants.FontEmphasis.MEDIUM,
        flex: "none"
    }, category.name), /*#__PURE__*/ react.createElement(ProductName, null, highlightedName || name), typeof coreProperties === "string" && /*#__PURE__*/ react.createElement(styles/* Properties */.E, null, /*#__PURE__*/ react.createElement(variants.BodySmallText, {
        emphasis: variants.FontEmphasis.MEDIUM
    }, coreProperties)), rating && rating > 0 ? /*#__PURE__*/ react.createElement(components_rating/* default */.Z, {
        rate: rating,
        count: reviewsCount,
        showCounterAs: "number"
    }) : null, price != null && /*#__PURE__*/ react.createElement(styles/* PriceWrapper */.vN, {
        gap: 0.5,
        isKWLP: isKWLP
    }, /*#__PURE__*/ react.createElement(styles/* StyledPrice */.w9, {
        flexEnd: showPrefixFromPrice
    }, showPrefixFromPrice && /*#__PURE__*/ react.createElement(variants.BodySmallText, null, t("product", "price.from-abbr")), /*#__PURE__*/ react.createElement(components_price/* Price */.t, {
        price: price,
        currency: store === null || store === void 0 ? void 0 : store.currency
    })), store && (isKWLP ? /*#__PURE__*/ react.createElement(cdn_image/* CdnImage */.l, {
        name: store && store.id || "",
        alt: store && store.name || "",
        height: 22
    }) : /*#__PURE__*/ react.createElement(styles/* ShopLogo */.NX, {
        variant: store_logo/* StoreLogoVariant.CAMPAIGN */.mA.CAMPAIGN,
        name: store.name,
        storeId: store.id,
        featured: true,
        hasImage: store.hasLogo || false
    }))));
};

// EXTERNAL MODULE: ./src/components/product-card-old/components/grid/grid-card-header.tsx
var grid_card_header = __webpack_require__(4450);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/popover/index.js
var popover = __webpack_require__(22448);
// EXTERNAL MODULE: ./src/areas/product/utils/index.ts
var utils = __webpack_require__(33996);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/button/variants.js
var button_variants = __webpack_require__(7336);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/outgoing-link/index.js
var outgoing_link = __webpack_require__(43709);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
;// CONCATENATED MODULE: ./src/components/product-card-old/components/click-out-button.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n  & > * {\n    vertical-align: middle;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  height: 74px;\n  display: flex;\n  justify-content: center;\n  padding: ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 0 auto;\n  text-align: center;\n  overflow: hidden;\n  ",
        "\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: calc(100% - (",
        "px + ",
        "));\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    justify-content: center;\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  overflow: hidden;\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}






var ICON_SIZE = 15;
var ClickOutButton = function(props) {
    var className = props.className, href = props.href, _disabled = props.disabled, disabled = _disabled === void 0 ? false : _disabled, onClick = props.onClick, store = props.store, featured = props.featured, containerProps = props.containerProps;
    var renderButtonContent = function() {
        if (!store) {
            return null;
        }
        if (featured) {
            return /*#__PURE__*/ react.createElement(cdn_image/* CdnImage */.l, {
                name: store && store.id || "",
                alt: store && store.name || ""
            });
        }
        return store.name;
    };
    var renderClickOutIcon = function() {
        if (!featured) return null;
        return /*#__PURE__*/ react.createElement(IconWrapper, null, /*#__PURE__*/ react.createElement(outgoing_link/* IconOutgoingLink */.v, {
            color: "base400",
            size: ICON_SIZE
        }));
    };
    return /*#__PURE__*/ react.createElement(OuterWrapper, null, /*#__PURE__*/ react.createElement(button_variants.OutlinedButton, {
        className: className,
        containerProps: _objectSpread({}, containerProps, href && {
            href: href || "",
            rel: "nofollow",
            target: "_blank"
        }),
        container: href ? "a" : undefined,
        disabled: disabled,
        onClick: onClick,
        fullWidth: true
    }, /*#__PURE__*/ react.createElement(InnerWrapper, null, /*#__PURE__*/ react.createElement(StoreInfo, {
        image: store && featured || false
    }, renderButtonContent()), renderClickOutIcon())));
};
var IconWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "IconWrapper",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var OuterWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "OuterWrapper",
    componentId: "sc-0-1"
})(_templateObject1(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var StoreInfo = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StoreInfo",
    componentId: "sc-0-2"
})(_templateObject2(), function(p) {
    return !p.image ? "padding: 1px 0;" : "";
}, ICON_SIZE, base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var InnerWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "InnerWrapper",
    componentId: "sc-0-3"
})(_templateObject4(), base/* media.smallOnly */.BC.smallOnly(_templateObject3()));

// EXTERNAL MODULE: ./src/components/product-card-old/components/new-click-out-button.tsx
var new_click_out_button = __webpack_require__(93256);
// EXTERNAL MODULE: ./src/utils/click-out-bounce-helper.ts
var click_out_bounce_helper = __webpack_require__(9690);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 24 modules
var es = __webpack_require__(95939);
// EXTERNAL MODULE: ./src/areas/product/actions/product.ts + 1 modules
var actions_product = __webpack_require__(36483);
;// CONCATENATED MODULE: ./src/components/product-card-old/components/grid/grid-card-offer-footer.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function grid_card_offer_footer_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function grid_card_offer_footer_templateObject() {
    var data = grid_card_offer_footer_taggedTemplateLiteral([
        "\n  && {\n    justify-self: flex-end;\n    flex: 0;\n    ",
        ": 0;\n    gap: ",
        ";\n  }\n"
    ]);
    grid_card_offer_footer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}















var GridCardOfferFooter = function() {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref = (0,product_card_context/* useProductCardContext */.I)(), onClick = ref.onClick, product = ref.product;
    var featuredOverride = product.featuredOverride, pathName = product.pathName, store = product.store;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = _slicedToArray((0,react.useState)(false), 2), showPopover = ref1[0], setShowPopover = ref1[1];
    var uid = (0,react.useId)();
    var isKWLP = (0,contexts/* useIsKWLP */._)();
    var featured = (0,utils/* getIsFeatured */.ZF)({
        featuredOverride: featuredOverride,
        store: store,
        externalUri: pathName
    });
    var handleBounce = function() {
        var ref, ref1;
        var parsedProductId = parseInt(((ref = product.id) === null || ref === void 0 ? void 0 : ref.toString()) || "0", 10);
        dispatch((0,actions_product/* productClickOutBounce */.nA)({
            productId: parsedProductId,
            priceId: null,
            storeName: ((ref1 = product.store) === null || ref1 === void 0 ? void 0 : ref1.name) || ""
        }));
    };
    var handleClick = function() {
        if (!featured) setShowPopover(true);
        if (onClick) {
            onClick();
            (0,click_out_bounce_helper/* handleClickOutBounce */.y)(handleBounce);
        }
    };
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(FooterContent, {
        isKWLP: isKWLP
    }, isKWLP ? /*#__PURE__*/ react.createElement(new_click_out_button/* NewClickOutButton */.I, {
        href: pathName || "",
        onClick: handleClick,
        external: true,
        text: t("product", "external-link.visit-shop")
    }) : /*#__PURE__*/ react.createElement(ClickOutButton, {
        containerProps: {
            "aria-describedby": "offer-".concat(uid)
        },
        store: store,
        href: featured && pathName || "",
        onClick: handleClick,
        featured: featured
    })), !featured && /*#__PURE__*/ react.createElement(popover/* Popover */.J2, {
        id: "offer-".concat(uid),
        visible: showPopover,
        width: 250,
        offsetY: 0,
        offsetX: 0,
        verticalAlign: popover/* Alignment.End */.v2.End,
        horizontalAlign: popover/* Alignment.Center */.v2.Center,
        onClose: function() {
            return setShowPopover(false);
        },
        zIndex: 20
    }, /*#__PURE__*/ react.createElement(variants.BodySmallText, null, t("product", "transparency.store-info"))));
};
var FooterContent = (0,styled_components_browser_esm["default"])(card.CardContent).withConfig({
    displayName: "FooterContent",
    componentId: "sc-0-0"
})(grid_card_offer_footer_templateObject(), function(p) {
    return p.isKWLP ? "padding-top" : "padding";
}, base/* layout.measurements.spacing025 */.bK.measurements.spacing025);

// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/index.js
var ui_text = __webpack_require__(49955);
;// CONCATENATED MODULE: ./src/components/product-card-old/components/grid/grid-card-product-footer.tsx
function grid_card_product_footer_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function grid_card_product_footer_templateObject() {
    var data = grid_card_product_footer_taggedTemplateLiteral([
        "\n  && {\n    padding-top: 0;\n    justify-content: end;\n    gap: ",
        ";\n  }\n"
    ]);
    grid_card_product_footer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}












var GridCardProductFooter = function() {
    var isKWLP = (0,contexts/* useIsKWLP */._)();
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref = (0,product_card_context/* useProductCardContext */.I)(), onClick = ref.onClick, _product = ref.product, category = _product.category, pathName = _product.pathName, _showCategoryButton = ref.showCategoryButton, showCategoryButton = _showCategoryButton === void 0 ? false : _showCategoryButton;
    var footerContent = [];
    if (isKWLP) {
        footerContent.push(/*#__PURE__*/ react.createElement(new_click_out_button/* NewClickOutButton */.I, {
            key: "click-out-button",
            href: pathName || "",
            onClick: function() {
                return onClick === null || onClick === void 0 ? void 0 : onClick();
            },
            text: t("product", "kwlp.compare-prices")
        }));
    }
    var categoryAsCategory = category;
    if (showCategoryButton && (categoryAsCategory === null || categoryAsCategory === void 0 ? void 0 : categoryAsCategory.name) && (categoryAsCategory === null || categoryAsCategory === void 0 ? void 0 : categoryAsCategory.pathName)) {
        footerContent.push(/*#__PURE__*/ react.createElement(button_variants.TonalButton, {
            container: react_router_dom/* Link */.rU,
            containerProps: {
                to: categoryAsCategory.pathName
            },
            fullWidth: true
        }, /*#__PURE__*/ react.createElement(styles/* CenteredButtonText */._0, {
            behavior: ui_text.Behavior.OnelineEllipsis
        }, categoryAsCategory.name)));
    }
    return footerContent.length ? /*#__PURE__*/ react.createElement(Footer, null, footerContent) : null;
};
var Footer = (0,styled_components_browser_esm["default"])(card.CardContent).withConfig({
    displayName: "Footer",
    componentId: "sc-0-0"
})(grid_card_product_footer_templateObject(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025);

;// CONCATENATED MODULE: ./src/components/product-card-old/components/grid/index.tsx







var ProductGridCard = function(props) {
    var className = props.className;
    var ref = (0,product_card_context/* useProductCardContext */.I)(), FooterArea = ref.FooterArea, _type = ref.type, type = _type === void 0 ? "product" : _type;
    // The card shouldn't be clickable for offers
    var isClickable = type === "product";
    return /*#__PURE__*/ react.createElement(GridCard, {
        className: className,
        isClickable: isClickable,
        FooterArea: FooterArea || /*#__PURE__*/ react.createElement(grid_Footer, null),
        outlined: true
    }, /*#__PURE__*/ react.createElement(grid_card_header/* GridCardHeader */.S, null), /*#__PURE__*/ react.createElement(GridCardContent, null));
};
var grid_Footer = function() {
    var ref = (0,product_card_context/* useProductCardContext */.I)(), _type = ref.type, type = _type === void 0 ? "product" : _type;
    if (type === "product") return /*#__PURE__*/ react.createElement(GridCardProductFooter, null);
    if (type === "offer") return /*#__PURE__*/ react.createElement(GridCardOfferFooter, null);
    return null;
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/card/variants.js
var card_variants = __webpack_require__(11049);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/list/variants.js
var list_variants = __webpack_require__(35967);
;// CONCATENATED MODULE: ./src/components/product-card-old/components/list/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  cursor: pointer;\n  width: 100%;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n    grid-template-columns: auto minmax(0, 1fr);\n    grid-template-rows: auto 1fr;\n  "
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: auto 3fr 1fr;\n  width: 100%;\n\n  ",
        ";\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n  text-align: initial;\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = styles_taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = styles_taggedTemplateLiteral([
        "\n  align-items: flex-end;\n  justify-content: space-between;\n  flex: 1 1 auto;\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = styles_taggedTemplateLiteral([
        "\n    ",
        " {\n      padding-top: 0;\n    }\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = styles_taggedTemplateLiteral([
        "\n  && {\n    position: relative;\n    height: fit-content;\n    width: ",
        ";\n    padding: 0;\n    margin: ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  z-index: 2;\n  bottom: 0;\n  max-height: 24px;\n  background: rgba(255, 255, 255, 0.72);\n  border-radius: 4px;\n  padding: 2px;\n\n  &:not(:last-child) {\n    margin: 0;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = styles_taggedTemplateLiteral([
        "\n  align-items: center;\n  flex-wrap: wrap;\n\n  > * {\n    margin: 0;\n    max-width: max-content;\n\n    &:not(:last-child) {\n      margin-right: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = styles_taggedTemplateLiteral([
        "\n  background: ",
        ";\n  padding: 2px ",
        ";\n  border-radius: 3px;\n  width: max-content;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = styles_taggedTemplateLiteral([
        "\n    align-items: flex-start;\n    width: 100%;\n  "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  white-space: nowrap;\n  max-width: 100%;\n\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = styles_taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = styles_taggedTemplateLiteral([
        "\n  && {\n    align-items: center;\n    flex: 0 1 auto;\n    margin-top: auto;\n  }\n\n  svg {\n    fill: ",
        ";\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = styles_taggedTemplateLiteral([
        "\n  align-items: baseline;\n  flex-wrap: wrap;\n\n  /* stylelint-disable */\n  > * {\n    flex: 0 1 auto;\n  }\n  /* stylelint-enable */\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}





var CardActionArea = (0,styled_components_browser_esm["default"])(card.CardActionArea).withConfig({
    displayName: "CardActionArea",
    componentId: "sc-0-0"
})(styles_templateObject());
var Main = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Main",
    componentId: "sc-0-1"
})(styles_templateObject2(), base/* media.mediumDown */.BC.mediumDown(styles_templateObject1()));
var MainContent = (0,styled_components_browser_esm["default"])(card.CardContent).withConfig({
    displayName: "MainContent",
    componentId: "sc-0-2"
})(styles_templateObject3());
var PriceContent = (0,styled_components_browser_esm["default"])(card.CardContent).withConfig({
    displayName: "PriceContent",
    componentId: "sc-0-3"
})(_templateObject5(), base/* media.mediumDown */.BC.mediumDown(styles_templateObject4()));
var Card = (0,styled_components_browser_esm["default"])(card_variants/* RowCard */.Jz).withConfig({
    displayName: "Card",
    componentId: "sc-0-4"
})(_templateObject7(), base/* media.mediumDown */.BC.mediumDown(_templateObject6(), PriceContent));
var ImageWrapper = (0,styled_components_browser_esm["default"])(card.CardContent).withConfig({
    displayName: "ImageWrapper",
    componentId: "sc-0-5"
})(_templateObject8(), function(p) {
    return p.$size;
}, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var BrandLogo = styled_components_browser_esm["default"].img.withConfig({
    displayName: "BrandLogo",
    componentId: "sc-0-6"
})(_templateObject9());
var RowWrapper = (0,styled_components_browser_esm["default"])(list_variants.Row).withConfig({
    displayName: "RowWrapper",
    componentId: "sc-0-7"
})(_templateObject10(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var Tag = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Tag",
    componentId: "sc-0-8"
})(_templateObject11(), function(p) {
    return p.theme.bg.secondary;
}, base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var PriceRowWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PriceRowWrapper",
    componentId: "sc-0-9"
})(_templateObject13(), base/* media.mediumDown */.BC.mediumDown(_templateObject12()));
var CTAText = (0,styled_components_browser_esm["default"])(list_variants.Row).withConfig({
    displayName: "CTAText",
    componentId: "sc-0-10"
})(_templateObject15(), function(p) {
    return p.theme.icons.callToAction;
}, base/* media.mediumDown */.BC.mediumDown(_templateObject14()));
var PriceTextWrapper = (0,styled_components_browser_esm["default"])(list_variants.Row).withConfig({
    displayName: "PriceTextWrapper",
    componentId: "sc-0-11"
})(_templateObject16());

;// CONCATENATED MODULE: ./src/components/product-card-old/components/list/list-card.tsx




var ListCard = function(props) {
    var className = props.className, children = props.children, isClickable = props.isClickable;
    var ref = (0,product_card_context/* useProductCardContext */.I)(), ActionArea = ref.ActionArea, container = ref.container, onClick = ref.onClick, _product = ref.product, id = _product.id, pathName = _product.pathName, tmp = ref.selectStates, ref1 = tmp === void 0 ? {} : tmp, onDeselect = ref1.onDeselect, onSelect = ref1.onSelect, selectable = ref1.selectable, _selected = ref1.selected, selected = _selected === void 0 ? false : _selected;
    var handleSelect = function(productId) {
        if (!productId) {
            return;
        }
        if (selected && onDeselect) onDeselect();
        else if (onSelect) onSelect();
    };
    var handleOnClick = function() {
        if (onClick && id) onClick(id);
    };
    return /*#__PURE__*/ react.createElement(Card, {
        selected: selected,
        className: className,
        container: container,
        containerProps: {
            "data-test": "ProductListCard"
        }
    }, !selectable && ActionArea ? ActionArea : null, isClickable ? /*#__PURE__*/ react.createElement(CardActionArea, {
        container: clickable/* Clickable */.P,
        containerProps: {
            to: selectable ? undefined : pathName,
            onClick: selectable ? function() {
                return handleSelect(id);
            } : handleOnClick
        }
    }, /*#__PURE__*/ react.createElement(Main, null, children)) : /*#__PURE__*/ react.createElement(Main, null, children));
};

// EXTERNAL MODULE: ./src/components/currency/index.tsx
var currency = __webpack_require__(49763);
// EXTERNAL MODULE: ./src/ui/block/index.ts
var block = __webpack_require__(65176);
;// CONCATENATED MODULE: ./src/components/product-card-old/components/list/list-card-content.tsx












var ListCardContent = function(props) {
    var showFromPrice = props.showFromPrice;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref = (0,product_card_context/* useProductCardContext */.I)(), _diffPercentage = ref.diffPercentage, diffPercentage = _diffPercentage === void 0 ? 0 : _diffPercentage, highlightedName = ref.highlightedName, _product = ref.product, id = _product.id, aggregatedRating = _product.aggregatedRating, name = _product.name, popularity = _product.popularity, priceSummary = _product.priceSummary, properties = _product.properties, store = _product.store, userReviewSummary = _product.userReviewSummary;
    var coreProperties = mapToCoreProperties(properties === null || properties === void 0 ? void 0 : properties.nodes);
    var rank = popularity === null || popularity === void 0 ? void 0 : popularity.inCategory;
    var rating = (aggregatedRating === null || aggregatedRating === void 0 ? void 0 : aggregatedRating.score) || (userReviewSummary === null || userReviewSummary === void 0 ? void 0 : userReviewSummary.rating);
    var reviewsCount = (aggregatedRating === null || aggregatedRating === void 0 ? void 0 : aggregatedRating.count) || (userReviewSummary === null || userReviewSummary === void 0 ? void 0 : userReviewSummary.count);
    return /*#__PURE__*/ react.createElement(MainContent, null, /*#__PURE__*/ react.createElement(ProductName, null, highlightedName || name), coreProperties ? /*#__PURE__*/ react.createElement(variants.BodySmallText, {
        emphasis: variants.FontEmphasis.MEDIUM
    }, coreProperties) : null, /*#__PURE__*/ react.createElement(RowWrapper, null, rank ? /*#__PURE__*/ react.createElement(Tag, null, /*#__PURE__*/ react.createElement(variants.CaptionText, {
        emphasis: variants.FontEmphasis.MEDIUM
    }, t("product", "rank.position", {
        rank: rank
    }))) : null, rating ? /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(block/* MediumUp */.TD, null, /*#__PURE__*/ react.createElement(components_rating/* default */.Z, {
        rate: rating,
        count: reviewsCount,
        showCounter: true,
        showCounterAs: "number",
        showRate: true,
        showRateAs: "number"
    })), /*#__PURE__*/ react.createElement(block/* MobileOnly */.iB, null, /*#__PURE__*/ react.createElement(components_rating/* default */.Z, {
        rate: rating,
        count: reviewsCount,
        showCounter: true,
        showCounterAs: "number",
        showRate: true,
        showRateAs: "number",
        singleStar: true
    }))) : null), /*#__PURE__*/ react.createElement(RowWrapper, null, diffPercentage && (priceSummary === null || priceSummary === void 0 ? void 0 : priceSummary.regular) ? /*#__PURE__*/ react.createElement(deals_badge/* DealsBadge */.T, {
        "data-testid": "DealsBadge",
        priceDrop: diffPercentage,
        price: priceSummary === null || priceSummary === void 0 ? void 0 : priceSummary.regular,
        popoverUniqueId: id || 0
    }) : null, (priceSummary === null || priceSummary === void 0 ? void 0 : priceSummary.regular) && /*#__PURE__*/ react.createElement(PriceTextWrapper, {
        gap: 0.5
    }, showFromPrice && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(variants.BodySmallText, {
        emphasis: variants.FontEmphasis.LOW
    }, t("product", "price.from-abbr")), " "), /*#__PURE__*/ react.createElement(components_price/* Price */.t, {
        price: priceSummary === null || priceSummary === void 0 ? void 0 : priceSummary.regular,
        currency: store === null || store === void 0 ? void 0 : store.currency
    }), Boolean(priceSummary.includeShipping) && /*#__PURE__*/ react.createElement(variants.BodySmallText, {
        emphasis: variants.FontEmphasis.LOW
    }, t("product", "price.including-shipping", {
        price: /*#__PURE__*/ react.createElement(currency/* Currency */.F, {
            price: priceSummary.includeShipping
        })
    })))));
};

// EXTERNAL MODULE: ./src/components/product-card-old/components/compare-checkbox.tsx
var compare_checkbox = __webpack_require__(21753);
// EXTERNAL MODULE: ./src/components/product-card-old/components/media.tsx
var components_media = __webpack_require__(52545);
;// CONCATENATED MODULE: ./src/components/product-card-old/components/list/list-card-media.tsx





var ListCardMedia = function(props) {
    var ref = (0,product_card_context/* useProductCardContext */.I)(), _imageSize = ref.imageSize, imageSize = _imageSize === void 0 ? 100 : _imageSize, _product = ref.product, brand = _product.brand, media = _product.media, name = _product.name, tmp = ref.selectStates, ref1 = tmp === void 0 ? {} : tmp, selectable = ref1.selectable, _selected = ref1.selected, selected = _selected === void 0 ? false : _selected, _shouldLazyLoadImage = ref.shouldLazyLoadImage, shouldLazyLoadImage = _shouldLazyLoadImage === void 0 ? false : _shouldLazyLoadImage;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, selectable ? /*#__PURE__*/ react.createElement(compare_checkbox/* CompareCheckbox */.j, {
        selected: selected
    }) : null, /*#__PURE__*/ react.createElement(ImageWrapper, {
        $size: "".concat(imageSize, "px")
    }, (brand === null || brand === void 0 ? void 0 : brand.logo) && /*#__PURE__*/ react.createElement(BrandLogo, {
        src: brand.logo,
        alt: brand.name || ""
    }), props.children, /*#__PURE__*/ react.createElement(components_media/* ProductMedia */.S, {
        imageSrc: media === null || media === void 0 ? void 0 : media.first,
        imageSize: imageSize,
        name: name || "",
        lazyLoadImage: shouldLazyLoadImage
    })));
};

;// CONCATENATED MODULE: ./src/components/product-card-old/components/list/list-card-offer-footer.tsx
function list_card_offer_footer_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function list_card_offer_footer_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function list_card_offer_footer_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function list_card_offer_footer_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function list_card_offer_footer_slicedToArray(arr, i) {
    return list_card_offer_footer_arrayWithHoles(arr) || list_card_offer_footer_iterableToArrayLimit(arr, i) || list_card_offer_footer_unsupportedIterableToArray(arr, i) || list_card_offer_footer_nonIterableRest();
}
function list_card_offer_footer_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function list_card_offer_footer_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return list_card_offer_footer_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return list_card_offer_footer_arrayLikeToArray(o, minLen);
}
function list_card_offer_footer_templateObject() {
    var data = list_card_offer_footer_taggedTemplateLiteral([
        "\n    max-width: 100%;\n    grid-column-start: 1;\n    grid-column-end: 3;\n  "
    ]);
    list_card_offer_footer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function list_card_offer_footer_templateObject1() {
    var data = list_card_offer_footer_taggedTemplateLiteral([
        "\n  max-width: 250px;\n  min-width: 200px;\n  height: 100%;\n  display: flex;\n  align-items: center;\n\n  ",
        "\n"
    ]);
    list_card_offer_footer_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}












var ListCardOfferFooter = function() {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref = (0,product_card_context/* useProductCardContext */.I)(), onClick = ref.onClick, _product = ref.product, featuredOverride = _product.featuredOverride, pathName = _product.pathName, store = _product.store, id = _product.id;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = list_card_offer_footer_slicedToArray((0,react.useState)(false), 2), showPopover = ref1[0], setShowPopover = ref1[1];
    var uid = (0,react.useId)();
    var featured = (0,utils/* getIsFeatured */.ZF)({
        featuredOverride: featuredOverride,
        store: store,
        externalUri: pathName
    });
    var handleBounce = function() {
        var parsedProductId = parseInt((id || 0).toString(), 10);
        dispatch((0,actions_product/* productClickOutBounce */.nA)({
            productId: parsedProductId,
            priceId: null,
            storeName: store === null || store === void 0 ? void 0 : store.name
        }));
    };
    var handleClick = function() {
        if (!featured) setShowPopover(true);
        if (onClick) {
            onClick();
            (0,click_out_bounce_helper/* handleClickOutBounce */.y)(handleBounce);
        }
    };
    return /*#__PURE__*/ react.createElement(ButtonWrapper, null, /*#__PURE__*/ react.createElement(ClickOutButton, {
        store: store,
        href: featured && pathName || "",
        onClick: handleClick,
        featured: featured,
        containerProps: {
            "aria-describedby": "offer-".concat(uid)
        }
    }), !featured && /*#__PURE__*/ react.createElement(popover/* Popover */.J2, {
        id: "offer-".concat(uid),
        visible: showPopover,
        width: 250,
        offsetY: 0,
        offsetX: 0,
        verticalAlign: popover/* Alignment.Center */.v2.Center,
        horizontalAlign: popover/* Alignment.End */.v2.End,
        onClose: function() {
            return setShowPopover(false);
        },
        zIndex: 20
    }, /*#__PURE__*/ react.createElement(variants.BodySmallText, null, t("product", "transparency.store-info"))));
};
var ButtonWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ButtonWrapper",
    componentId: "sc-0-0"
})(list_card_offer_footer_templateObject1(), base/* media.mediumDown */.BC.mediumDown(list_card_offer_footer_templateObject()));

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/chevron-right/index.js
var chevron_right = __webpack_require__(46695);
;// CONCATENATED MODULE: ./src/components/product-card-old/components/list/list-card-product-footer.tsx






var ListCardProductFooter = function() {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref = (0,product_card_context/* useProductCardContext */.I)(), priceSummary = ref.product.priceSummary;
    var priceCount = priceSummary === null || priceSummary === void 0 ? void 0 : priceSummary.count;
    return priceCount ? /*#__PURE__*/ react.createElement(PriceContent, null, typeof priceCount === "number" && /*#__PURE__*/ react.createElement(CTAText, null, /*#__PURE__*/ react.createElement(variants.BodySmallText, {
        color: variants.FontColor.PRIMARY
    }, t("category", "product-offer.cta", {
        n: priceCount
    })), /*#__PURE__*/ react.createElement(chevron_right.IconChevronRight, {
        color: "maybeBlue700"
    }))) : null;
};

;// CONCATENATED MODULE: ./src/components/product-card-old/components/list/index.tsx










var ProductListCard = function(param) {
    var className = param.className;
    var ref = (0,app_context/* useAppContext */.bp)(), market = ref.market, t = ref.t;
    var ref1 = (0,product_card_context/* useProductCardContext */.I)(), hasExpertBadge = ref1.hasExpertBadge, id = ref1.product.id, _type = ref1.type, type = _type === void 0 ? "product" : _type;
    var expertTopRatedBadgeUrl = "".concat(market.cdn, "/g/expert/").concat(market.code, "/expert-toprated-badge.png");
    // The card shouldn't be clickable for offers
    var isClickable = type === "product";
    var productOfTheYearAward = (0,hooks/* useGetProductOfTheYear */.i)(type === "product" ? id : undefined);
    var productBadege = (0,react.useMemo)(function() {
        if (productOfTheYearAward === null || productOfTheYearAward === void 0 ? void 0 : productOfTheYearAward.awardLogo) {
            return /*#__PURE__*/ react.createElement(image_badges/* ListCardImageBadge */.rn, {
                badgeUrl: productOfTheYearAward.awardLogo,
                title: "".concat(productOfTheYearAward.awardName, " ").concat(productOfTheYearAward.year)
            });
        }
        if (hasExpertBadge) {
            return /*#__PURE__*/ react.createElement(image_badges/* ListCardImageBadge */.rn, {
                badgeUrl: expertTopRatedBadgeUrl,
                title: t("expert", "expert.top-rated-badge")
            });
        }
        return null;
    }, [
        productOfTheYearAward,
        hasExpertBadge,
        expertTopRatedBadgeUrl
    ]);
    return /*#__PURE__*/ react.createElement(ListCard, {
        className: className,
        isClickable: isClickable
    }, /*#__PURE__*/ react.createElement(ListCardMedia, null, " ", productBadege, " "), /*#__PURE__*/ react.createElement(ListCardContent, {
        showFromPrice: type === "product"
    }), /*#__PURE__*/ react.createElement(react.Fragment, null, type === "offer" && /*#__PURE__*/ react.createElement(ListCardOfferFooter, null), type === "product" && /*#__PURE__*/ react.createElement(ListCardProductFooter, null)));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/clickable/index.js
var ui_clickable = __webpack_require__(25181);
;// CONCATENATED MODULE: ./src/components/product-card-old/components/compact/styles.ts
function compact_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function compact_styles_templateObject() {
    var data = compact_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  display: grid;\n  grid-gap: ",
        ";\n  grid-auto-flow: column;\n  grid-template-columns: auto 1fr;\n  justify-items: start;\n  align-items: center;\n  padding: ",
        ";\n"
    ]);
    compact_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function compact_styles_templateObject1() {
    var data = compact_styles_taggedTemplateLiteral([
        "\n  ",
        ";\n  text-align: inherit;\n  cursor: pointer;\n\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    compact_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function compact_styles_templateObject2() {
    var data = compact_styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    compact_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function compact_styles_templateObject3() {
    var data = compact_styles_taggedTemplateLiteral([
        "\n  border-bottom: 1px solid ",
        ";\n  display: block;\n  position: relative;\n"
    ]);
    compact_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function compact_styles_templateObject4() {
    var data = compact_styles_taggedTemplateLiteral([
        "\n  justify-self: start;\n  text-align: left;\n  cursor: pointer;\n"
    ]);
    compact_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = compact_styles_taggedTemplateLiteral([
        "\n  display: inline-flex;\n  vertical-align: middle;\n  margin-left: ",
        ";\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var wrapperStyles = (0,styled_components_browser_esm.css)(compact_styles_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var ProductLink = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "ProductLink",
    componentId: "sc-0-0"
})(compact_styles_templateObject1(), wrapperStyles, function(p) {
    return base/* colorUtils.setRgbaAlpha */.$n.setRgbaAlpha(p.theme.colors.base800, "0.04");
});
var Wrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-1"
})(compact_styles_templateObject2(), wrapperStyles);
var ListItem = styled_components_browser_esm["default"].li.withConfig({
    displayName: "ListItem",
    componentId: "sc-0-2"
})(compact_styles_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.base200;
});
var OfferLink = (0,styled_components_browser_esm["default"])(ui_clickable.Clickable).withConfig({
    displayName: "OfferLink",
    componentId: "sc-0-3"
})(compact_styles_templateObject4());
var OfferStoreIconWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "OfferStoreIconWrapper",
    componentId: "sc-0-4"
})(styles_templateObject5(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025);

;// CONCATENATED MODULE: ./src/components/product-card-old/components/compact/compact-list-card.tsx



var CompactListCard = function(props) {
    var className = props.className, children = props.children, isClickable = props.isClickable;
    var ref = (0,product_card_context/* useProductCardContext */.I)(), onClick = ref.onClick, _product = ref.product, id = _product.id, pathName = _product.pathName, tmp = ref.selectStates, ref1 = tmp === void 0 ? {} : tmp, onDeselect = ref1.onDeselect, onSelect = ref1.onSelect, _selectable = ref1.selectable, selectable = _selectable === void 0 ? false : _selectable, _selected = ref1.selected, selected = _selected === void 0 ? false : _selected;
    var handleSelect = function(productId) {
        if (!productId) return;
        if (selected && onDeselect) onDeselect();
        else if (onSelect) onSelect();
    };
    var handleOnClick = function(productId) {
        if (!productId) return;
        if (onClick) onClick(productId);
    };
    return /*#__PURE__*/ react.createElement(ListItem, {
        className: className,
        "data-test": "ProductCompactListCard",
        isSelectingProducts: selectable,
        key: id
    }, isClickable ? /*#__PURE__*/ react.createElement(ProductLink, {
        to: selectable ? undefined : pathName,
        onClick: selectable ? function() {
            return handleSelect(id);
        } : function() {
            return handleOnClick(id);
        }
    }, children) : /*#__PURE__*/ react.createElement(Wrapper, null, children));
};

;// CONCATENATED MODULE: ./src/components/product-card-old/components/compact/compact-list-card-product-content.tsx




var RATING_TRANSLATION = {
    domain: "product",
    key: "product-card.n-ratings"
};
var CompactListCardProductContent = function() {
    var ref = (0,product_card_context/* useProductCardContext */.I)(), highlightedName = ref.highlightedName, _product = ref.product, aggregatedRating = _product.aggregatedRating, name = _product.name, userReviewSummary = _product.userReviewSummary;
    var rating = (aggregatedRating === null || aggregatedRating === void 0 ? void 0 : aggregatedRating.score) || (userReviewSummary === null || userReviewSummary === void 0 ? void 0 : userReviewSummary.rating);
    var reviewsCount = (aggregatedRating === null || aggregatedRating === void 0 ? void 0 : aggregatedRating.count) || (userReviewSummary === null || userReviewSummary === void 0 ? void 0 : userReviewSummary.count);
    return /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(ProductName, null, highlightedName || name), rating && rating > 0 ? /*#__PURE__*/ react.createElement(components_rating/* default */.Z, {
        rate: rating,
        singleStar: true,
        showRate: true,
        showCounter: true,
        count: reviewsCount,
        countTranslation: RATING_TRANSLATION,
        size: "small"
    }) : null);
};

// EXTERNAL MODULE: ./src/ui/zindex/index.ts
var zindex = __webpack_require__(93497);
;// CONCATENATED MODULE: ./src/components/product-card-old/components/compact/compact-list-card-offer-content.tsx
function compact_list_card_offer_content_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function compact_list_card_offer_content_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function compact_list_card_offer_content_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function compact_list_card_offer_content_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function compact_list_card_offer_content_slicedToArray(arr, i) {
    return compact_list_card_offer_content_arrayWithHoles(arr) || compact_list_card_offer_content_iterableToArrayLimit(arr, i) || compact_list_card_offer_content_unsupportedIterableToArray(arr, i) || compact_list_card_offer_content_nonIterableRest();
}
function compact_list_card_offer_content_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function compact_list_card_offer_content_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return compact_list_card_offer_content_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return compact_list_card_offer_content_arrayLikeToArray(o, minLen);
}
function compact_list_card_offer_content_templateObject() {
    var data = compact_list_card_offer_content_taggedTemplateLiteral([
        "\n  position: absolute;\n  z-index: ",
        ";\n"
    ]);
    compact_list_card_offer_content_templateObject = function _templateObject() {
        return data;
    };
    return data;
}













var CompactListCardOfferContent = function() {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref = (0,product_card_context/* useProductCardContext */.I)(), highlightedName = ref.highlightedName, onClick = ref.onClick, _product = ref.product, featuredOverride = _product.featuredOverride, name = _product.name, pathName = _product.pathName, store = _product.store, id = _product.id;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = compact_list_card_offer_content_slicedToArray((0,react.useState)(false), 2), showPopover = ref1[0], setShowPopover = ref1[1];
    var uid = (0,react.useId)();
    var featured = (0,utils/* getIsFeatured */.ZF)({
        featuredOverride: featuredOverride,
        store: store,
        externalUri: pathName
    });
    var handleBounce = function() {
        var parsedProductId = parseInt((id || 0).toString(), 10);
        dispatch((0,actions_product/* productClickOutBounce */.nA)({
            productId: parsedProductId,
            priceId: null,
            storeName: store === null || store === void 0 ? void 0 : store.name
        }));
    };
    var handleClick = function() {
        if (!featured) setShowPopover(true);
        if (onClick) {
            onClick();
            (0,click_out_bounce_helper/* handleClickOutBounce */.y)(handleBounce);
        }
    };
    var getContainerProps = function() {
        var containerProps = {
            target: "_blank",
            rel: "nofollow"
        };
        if (featured) {
            containerProps.href = pathName;
        }
        return containerProps;
    };
    var renderClickOutIcon = function() {
        if (!featured) return null;
        return /*#__PURE__*/ react.createElement(OfferStoreIconWrapper, null, /*#__PURE__*/ react.createElement(outgoing_link/* IconOutgoingLink */.v, {
            size: 14,
            color: "base400"
        }));
    };
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(OfferLink, {
        container: "a",
        containerProps: getContainerProps(),
        onClick: handleClick,
        "aria-describedby": "offer-".concat(uid)
    }, /*#__PURE__*/ react.createElement(variants.TitleSmallText, {
        containerProps: {
            "data-test": "OfferName"
        }
    }, highlightedName || (name && name.length > 100 ? "".concat(name.substring(0, 100), "...") : name), /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(variants.BodySmallText, {
        color: variants.FontColor.DARK,
        emphasis: variants.FontEmphasis.LOW
    }, store && store.name), renderClickOutIcon())))), !featured && /*#__PURE__*/ react.createElement(PopoverWrapper, null, /*#__PURE__*/ react.createElement(popover/* Popover */.J2, {
        id: "offer-".concat(uid),
        visible: showPopover,
        width: 250,
        offsetY: 0,
        offsetX: 0,
        verticalAlign: popover/* Alignment.Center */.v2.Center,
        horizontalAlign: popover/* Alignment.Start */.v2.Start,
        onClose: function() {
            return setShowPopover(false);
        },
        zIndex: zindex/* zindex.popover */.Y.popover
    }, /*#__PURE__*/ react.createElement(variants.BodySmallText, null, t("product", "transparency.store-info")))));
};
// Popover's outermost element must be absolute positioned to not claim space when in a css-grid layout
var PopoverWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PopoverWrapper",
    componentId: "sc-0-0"
})(compact_list_card_offer_content_templateObject(), zindex/* zindex.popover */.Y.popover);

// EXTERNAL MODULE: ./src/components/lazy/index.tsx
var lazy = __webpack_require__(67506);
// EXTERNAL MODULE: ./src/components/product-image/index.tsx
var product_image = __webpack_require__(87044);
;// CONCATENATED MODULE: ./src/components/product-card-old/components/compact/compact-list-card-media.tsx
function compact_list_card_media_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function compact_list_card_media_templateObject() {
    var data = compact_list_card_media_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    compact_list_card_media_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function compact_list_card_media_templateObject1() {
    var data = compact_list_card_media_taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n  position: relative;\n  top: 0;\n  left: 0;\n  height: 100%;\n"
    ]);
    compact_list_card_media_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function compact_list_card_media_templateObject2() {
    var data = compact_list_card_media_taggedTemplateLiteral([
        "\n  width: 45px;\n  box-sizing: content-box;\n"
    ]);
    compact_list_card_media_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function compact_list_card_media_templateObject3() {
    var data = compact_list_card_media_taggedTemplateLiteral([
        "\n  max-width: 40px;\n  text-overflow: ellipsis;\n  max-height: 80px;\n"
    ]);
    compact_list_card_media_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}







var CompactListCardMedia = function() {
    var ref = (0,product_card_context/* useProductCardContext */.I)(), _product = ref.product, media = _product.media, name = _product.name, category = _product.category, tmp = ref.selectStates, ref1 = tmp === void 0 ? {} : tmp, selectable = ref1.selectable, _selected = ref1.selected, selected = _selected === void 0 ? false : _selected;
    return /*#__PURE__*/ react.createElement(Media, null, selectable ? /*#__PURE__*/ react.createElement(CompareCheckbox, {
        selected: selected,
        "aria-label": name
    }) : null, /*#__PURE__*/ react.createElement(lazy/* Lazy */.o, {
        offset: 0
    }, /*#__PURE__*/ react.createElement(ImageContainer, null, /*#__PURE__*/ react.createElement(ListImage, {
        name: name,
        src: (media === null || media === void 0 ? void 0 : media.first) || "",
        fallback: category === null || category === void 0 ? void 0 : category.logo
    }))));
};
var Media = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Media",
    componentId: "sc-0-0"
})(compact_list_card_media_templateObject());
var CompareCheckbox = (0,styled_components_browser_esm["default"])(compare_checkbox/* CompareCheckbox */.j).withConfig({
    displayName: "CompareCheckbox",
    componentId: "sc-0-1"
})(compact_list_card_media_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var ImageContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ImageContainer",
    componentId: "sc-0-2"
})(compact_list_card_media_templateObject2());
var ListImage = (0,styled_components_browser_esm["default"])(product_image/* ProductImage */.q).withConfig({
    displayName: "ListImage",
    componentId: "sc-0-3"
})(compact_list_card_media_templateObject3());

;// CONCATENATED MODULE: ./src/components/product-card-old/components/compact/compact-list-card-price.tsx
function compact_list_card_price_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function compact_list_card_price_templateObject() {
    var data = compact_list_card_price_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n"
    ]);
    compact_list_card_price_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function compact_list_card_price_templateObject1() {
    var data = compact_list_card_price_taggedTemplateLiteral([
        "\n  align-items: baseline;\n  flex-wrap: wrap;\n  flex-direction: column;\n  text-align: end;\n"
    ]);
    compact_list_card_price_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function compact_list_card_price_templateObject2() {
    var data = compact_list_card_price_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-auto-flow: column;\n  grid-column-gap: ",
        ";\n"
    ]);
    compact_list_card_price_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}










var CompactListCardPrice = function(props) {
    var showFromPrice = props.showFromPrice;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref = (0,product_card_context/* useProductCardContext */.I)(), _diffPercentage = ref.diffPercentage, diffPercentage = _diffPercentage === void 0 ? 0 : _diffPercentage, _product = ref.product, id = _product.id, priceSummary = _product.priceSummary, store = _product.store;
    var price = priceSummary === null || priceSummary === void 0 ? void 0 : priceSummary.regular;
    return /*#__PURE__*/ react.createElement(PriceContainer, null, /*#__PURE__*/ react.createElement(list_variants.Row, null, price && /*#__PURE__*/ react.createElement(compact_list_card_price_PriceTextWrapper, null, /*#__PURE__*/ react.createElement(PriceText, null, diffPercentage ? /*#__PURE__*/ react.createElement(deals_badge/* DealsBadge */.T, {
        "data-testid": "DealsBadge",
        priceDrop: diffPercentage,
        price: price,
        popoverUniqueId: id || 0
    }) : null, /*#__PURE__*/ react.createElement("div", null, showFromPrice && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(variants.BodySmallText, {
        emphasis: variants.FontEmphasis.LOW
    }, t("product", "price.from-abbr")), " "), /*#__PURE__*/ react.createElement(components_price/* Price */.t, {
        price: price,
        currency: store === null || store === void 0 ? void 0 : store.currency
    }))), priceSummary.includeShipping ? /*#__PURE__*/ react.createElement(variants.BodySmallText, {
        emphasis: variants.FontEmphasis.LOW
    }, t("product", "price.including-shipping", {
        price: /*#__PURE__*/ react.createElement(currency/* Currency */.F, {
            key: priceSummary.includeShipping,
            price: priceSummary.includeShipping
        })
    })) : null)));
};
var PriceContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PriceContainer",
    componentId: "sc-0-0"
})(compact_list_card_price_templateObject());
var compact_list_card_price_PriceTextWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PriceTextWrapper",
    componentId: "sc-0-1"
})(compact_list_card_price_templateObject1());
var PriceText = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PriceText",
    componentId: "sc-0-2"
})(compact_list_card_price_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/components/product-card-old/components/compact/index.tsx







var ProductCompactListCard = function(props) {
    var className = props.className;
    var ref = (0,product_card_context/* useProductCardContext */.I)(), _type = ref.type, type = _type === void 0 ? "product" : _type;
    // The card shouldn't be clickable for offers
    var isClickable = type === "product";
    return /*#__PURE__*/ react.createElement(CompactListCard, {
        className: className,
        isClickable: isClickable
    }, /*#__PURE__*/ react.createElement(CompactListCardMedia, null), type === "product" && /*#__PURE__*/ react.createElement(CompactListCardProductContent, null), type === "offer" && /*#__PURE__*/ react.createElement(CompactListCardOfferContent, null), /*#__PURE__*/ react.createElement(CompactListCardPrice, {
        showFromPrice: type === "product"
    }));
};

;// CONCATENATED MODULE: ./src/components/product-card-old/map-to-props.ts
var mapDataToProps = function(item, type) {
    switch(type){
        case "product":
            {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6;
                var product = item;
                return {
                    type: "product",
                    id: product.id,
                    brand: product.brand,
                    imageSrc: (ref = product.media) === null || ref === void 0 ? void 0 : ref.first,
                    name: product.name,
                    link: product.pathName,
                    properties: (ref1 = product.properties) === null || ref1 === void 0 ? void 0 : ref1.nodes,
                    price: (ref2 = product.priceSummary) === null || ref2 === void 0 ? void 0 : ref2.regular,
                    priceInclShipping: (ref3 = product.priceSummary) === null || ref3 === void 0 ? void 0 : ref3.includeShipping,
                    rank: (ref4 = product.popularity) === null || ref4 === void 0 ? void 0 : ref4.inCategory,
                    rating: (ref5 = product.userReviewSummary) === null || ref5 === void 0 ? void 0 : ref5.rating,
                    reviewsCount: (ref6 = product.userReviewSummary) === null || ref6 === void 0 ? void 0 : ref6.count,
                    category: product.category
                };
            }
        case "offer":
            {
                var ref7;
                var offer = item;
                return {
                    type: "offer",
                    imageSrc: (ref7 = offer.media) === null || ref7 === void 0 ? void 0 : ref7.first,
                    link: offer.externalUri,
                    name: offer.name,
                    price: offer.offerPrice,
                    store: offer.store
                };
            }
        default:
            return {};
    }
};

;// CONCATENATED MODULE: ./src/components/product-card-old/index.tsx







/***/ }),

/***/ 39728:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": () => (/* binding */ useProductCardContext),
/* harmony export */   "h": () => (/* binding */ ProductCardContextContainer)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_areas_product_components_product_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16130);


var initialValue = {
    ActionArea: undefined,
    background: false,
    diffPercentage: undefined,
    FooterArea: undefined,
    hasExpertBadge: false,
    highlightedName: undefined,
    imageSize: undefined,
    onClick: undefined,
    onRankInCategoryClick: undefined,
    product: src_areas_product_components_product_context__WEBPACK_IMPORTED_MODULE_1__/* .EmptyProduct */ .jG,
    selectStates: undefined,
    shouldLazyLoadImage: false,
    type: "product"
};
var ProductCardContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(initialValue);
var useProductCardContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ProductCardContext);
};
var ProductCardContextContainer = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ProductCardContext.Provider, {
        value: props
    }, props.children);
};


/***/ }),

/***/ 74588:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": () => (/* binding */ BaseProductCard)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/product-card/contexts/product-card-context.tsx
var product_card_context = __webpack_require__(25562);
// EXTERNAL MODULE: ./src/components/product-card/types.ts
var types = __webpack_require__(73738);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/index.js
var design_tokens = __webpack_require__(43220);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/card/index.js
var card = __webpack_require__(89695);
;// CONCATENATED MODULE: ./src/components/product-card/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  height: 100%;\n  padding: ",
        ";\n  gap: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    justify-content: space-between;\n    padding: 0;\n    gap: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  gap: 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  justify-content: center;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  height: 100%;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: baseline;\n  gap: ",
        ";\n  flex-wrap: wrap;\n\n  > * {\n    flex-grow: 0;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var RAW_OFFER_LOW_OPACITY = 0.48;
var StyledProductCard = (0,styled_components_browser_esm["default"])(card.Card).withConfig({
    displayName: "StyledProductCard",
    componentId: "sc-0-0"
})(_templateObject(), design_tokens.measurements.spacing075, design_tokens.measurements.spacing050, function(p) {
    return p.$disabled && "opacity: ".concat(RAW_OFFER_LOW_OPACITY, "; pointer-events: none;");
});
var StyledCardContent = (0,styled_components_browser_esm["default"])(card.CardContent).withConfig({
    displayName: "StyledCardContent",
    componentId: "sc-0-1"
})(_templateObject1(), design_tokens.measurements.spacing050);
var FlexColumn = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FlexColumn",
    componentId: "sc-0-2"
})(_templateObject2(), design_tokens.measurements.spacing025);
var FlexColumnCompact = (0,styled_components_browser_esm["default"])(FlexColumn).withConfig({
    displayName: "FlexColumnCompact",
    componentId: "sc-0-3"
})(_templateObject3());
var ImageWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ImageWrapper",
    componentId: "sc-0-4"
})(_templateObject4());
var StyledCardActionArea = (0,styled_components_browser_esm["default"])(card.CardActionArea).withConfig({
    displayName: "StyledCardActionArea",
    componentId: "sc-0-5"
})(_templateObject5());
var VerticalTextAlignment = styled_components_browser_esm["default"].div.withConfig({
    displayName: "VerticalTextAlignment",
    componentId: "sc-0-6"
})(_templateObject6(), design_tokens.measurements.spacing025);

;// CONCATENATED MODULE: ./src/components/product-card/components/card-wrapper.tsx





var CardWrapper = function(param) {
    var children = param.children;
    var productCardData = (0,product_card_context/* useProductCardContext */.I$)();
    var loweredOpacity = productCardData.type === types/* ProductCardType.RAW_OFFER */.ZX.RAW_OFFER && !productCardData.data.offer.featured;
    return /*#__PURE__*/ react.createElement(StyledProductCard, {
        outlined: true,
        $disabled: loweredOpacity,
        containerProps: {
            "data-test": "CardWrapper",
            "data-testid": "CardWrapper",
            "data-opacity": loweredOpacity ? RAW_OFFER_LOW_OPACITY : 1
        }
    }, children);
};

// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(38689);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(58912);
;// CONCATENATED MODULE: ./src/components/product-card/components/card-clickable-area.tsx







var CardClickableArea = function(param) {
    var children = param.children;
    var renderMode = (0,app_context/* useAppContext */.bp)().renderMode;
    var productCardData = (0,product_card_context/* useProductCardContext */.I$)();
    var url = productCardData.data.product.productLink;
    if (productCardData.type === types/* ProductCardType.USED */.ZX.USED) {
        url += "".concat(url.match(/[?]/g) ? "&" : "?", "expand=used");
    }
    var onClick = function() {
        var ref, ref1;
        (ref = productCardData.customTracking) === null || ref === void 0 ? void 0 : (ref1 = ref.onCardClick) === null || ref1 === void 0 ? void 0 : ref1.call(ref);
        var index = productCardData.trackingIndex ? productCardData.trackingIndex + 1 : undefined;
        (0,tracking/* trackInternalNavigationClick */.p)({
            scope: productCardData.trackingScope,
            nextPage: url,
            index: index
        });
    };
    return /*#__PURE__*/ react.createElement(StyledCardActionArea, {
        container: clickable/* Clickable */.P,
        containerProps: {
            to: url,
            onClick: onClick,
            "data-testid": "CardClickableArea",
            isExternal: renderMode === "native"
        }
    }, /*#__PURE__*/ react.createElement(StyledCardContent, null, children));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(71016);
;// CONCATENATED MODULE: ./src/components/product-card/features/internal/features-utils.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

var hasFeatureEnabled = function(feature, productCardData) {
    var internalFeatures = {
        promotionOwnerPriceBadge: true,
        salesPriceText: true,
        memberPriceText: true,
        membershipRequiresCompensation: true,
        price: true
    };
    var boolFeatures = Object.entries(_objectSpread({}, internalFeatures, productCardData.features)).reduce(function(acc, param) {
        var _param = _slicedToArray(param, 2), key = _param[0], value = _param[1];
        if (value === true) {
            acc.push(key);
        }
        return acc;
    }, []);
    var allFeatures = _toConsumableArray(boolFeatures).concat(_toConsumableArray(productCardData.features.topLeftCorner), [
        productCardData.features.topRightCorner,
        productCardData.features.bottomRightCorner
    ]);
    return allFeatures.includes(feature);
};
var hasNoneOf = function(features, productCardData) {
    return !features.some(function(feature) {
        return showFeature(feature, productCardData);
    });
};

;// CONCATENATED MODULE: ./src/components/product-card/features/index.ts
function features_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


/**
 * * IMPORTANT
 *
 * Just because the feature itself is enabled, doesn't mean it should be displayed.
 *
 * Some features will be hidden due to another higher prio feature being displayed in the card already.
 *
 * Also, just because "deals is enabled" we don't want to show a badge for it, we also need to check if "offer.priceDrop > 0", see function "hasData".
 *
 * Beware: Don't perform infinite loops by having 2 features dependant on each other :)
 */ var showFeature = function(feature, productCardData) {
    var isEnabled = hasFeatureEnabled(feature, productCardData);
    var hasNoData = !hasData(feature, productCardData);
    if (!isEnabled || hasNoData) {
        return false;
    }
    var _obj;
    var dependencyMap = (_obj = {
        // Only display salesPrice if there is no memberPrice already.
        salesPrice: function() {
            return hasNoneOf([
                "memberPrice"
            ], productCardData);
        },
        // salesPriceText and memberPriceText are UX-special-cases where we at times want to show the badge/info but hide the
        // "previous price text". Reason: we do not want to show several kinds of "before pricedrop"-prices in the same card.
        salesPriceText: function() {
            return showFeature("salesPrice", productCardData) && hasNoneOf([
                "memberPrice"
            ], productCardData);
        },
        memberPriceText: function() {
            return showFeature("memberPrice", productCardData);
        },
        membershipRequiresCompensation: function() {
            return showFeature("memberPrice", productCardData);
        }
    }, features_defineProperty(_obj, types/* TopLeftCornerFeature.DEALS_BADGE */.ev.DEALS_BADGE, function() {
        return showFeature("deals", productCardData);
    }), features_defineProperty(_obj, types/* TopLeftCornerFeature.USED_BADGE */.ev.USED_BADGE, function() {
        return hasNoneOf([
            types/* TopLeftCornerFeature.DEALS_BADGE */.ev.DEALS_BADGE
        ], productCardData);
    }), features_defineProperty(_obj, types/* TopLeftCornerFeature.TOP_RATED_BADGE */.ev.TOP_RATED_BADGE, function() {
        return hasNoneOf([
            types/* TopLeftCornerFeature.DEALS_BADGE */.ev.DEALS_BADGE,
            types/* TopLeftCornerFeature.USED_BADGE */.ev.USED_BADGE
        ], productCardData);
    }), features_defineProperty(_obj, types/* TopLeftCornerFeature.POTY_BADGE */.ev.POTY_BADGE, function() {
        return hasNoneOf([
            types/* TopLeftCornerFeature.DEALS_BADGE */.ev.DEALS_BADGE,
            types/* TopLeftCornerFeature.USED_BADGE */.ev.USED_BADGE,
            types/* TopLeftCornerFeature.TOP_RATED_BADGE */.ev.TOP_RATED_BADGE
        ], productCardData);
    }), _obj);
    if (feature in dependencyMap) {
        return dependencyMap[feature]();
    }
    return true;
};
var hasData = function(feature, productCardData) {
    var promotionOwnerData = productCardData.promotionOwnerData;
    var _product = productCardData.data.product, priceDrop = _product.priceDrop, rating = _product.rating, category = _product.category, productOfTheYear = _product.productOfTheYear, isExpertTopRated = _product.isExpertTopRated;
    var _offer = productCardData.data.offer, originalPrice = _offer.originalPrice, memberPrice = _offer.memberPrice, membershipRequiresCompensation = _offer.membershipRequiresCompensation, price = _offer.price, condition = _offer.condition;
    var _obj;
    // Add all your data-dependencies here.
    // Example: if you want to show the DEALS_BADGE, you need to have a "priceDrop > 0".
    var hasDataMap = (_obj = {
        deals: priceDrop,
        price: price
    }, features_defineProperty(_obj, types/* TopLeftCornerFeature.DEALS_BADGE */.ev.DEALS_BADGE, true), features_defineProperty(_obj, types/* TopLeftCornerFeature.POTY_BADGE */.ev.POTY_BADGE, productOfTheYear), features_defineProperty(_obj, types/* TopLeftCornerFeature.TOP_RATED_BADGE */.ev.TOP_RATED_BADGE, isExpertTopRated), features_defineProperty(_obj, types/* TopLeftCornerFeature.USED_BADGE */.ev.USED_BADGE, condition !== "new"), features_defineProperty(_obj, types/* BottomRightCornerFeature.IMAGE_SEARCH */.rq.IMAGE_SEARCH, hasValidImageSearchCategory(productCardData)), features_defineProperty(_obj, "categoryName", category === null || category === void 0 ? void 0 : category.categoryName), features_defineProperty(_obj, "memberPrice", memberPrice && originalPrice && memberPrice < originalPrice), features_defineProperty(_obj, "memberPriceText", true), features_defineProperty(_obj, "membershipRequiresCompensation", membershipRequiresCompensation), features_defineProperty(_obj, "promotionOwnerPriceBadge", (promotionOwnerData === null || promotionOwnerData === void 0 ? void 0 : promotionOwnerData.price) && price && promotionOwnerData.price > price), features_defineProperty(_obj, "salesPrice", originalPrice && price && originalPrice > price), features_defineProperty(_obj, "salesPriceText", true), features_defineProperty(_obj, "rating", rating === null || rating === void 0 ? void 0 : rating.count), _obj);
    if (feature in hasDataMap) {
        return Boolean(hasDataMap[feature]);
    }
    return true;
};
var workJackets = 1629;
var childrensJackets = 1572;
var jackets = 1427;
var sneakers = 1490;
var VALID_IMAGE_SEARCH_CATEGORIES = [
    jackets,
    sneakers,
    childrensJackets,
    workJackets
];
// If we ever decide to remove the category-restraint of ImageSearch this function can get deleted
// and replaced by a simple "category?.categoryName" and we may delete "hierarchicalCategoryIds".
var hasValidImageSearchCategory = function(productCardData) {
    var ref, ref1;
    var category = productCardData.data.product.category;
    return Boolean((category === null || category === void 0 ? void 0 : category.categoryName) && ((ref = category.hierarchicalCategoryIds) === null || ref === void 0 ? void 0 : ref.length) && ((ref1 = category.hierarchicalCategoryIds) === null || ref1 === void 0 ? void 0 : ref1.some(function(id) {
        return VALID_IMAGE_SEARCH_CATEGORIES.includes(id);
    })));
};

;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/category.tsx




var Category = function() {
    var ref;
    var productCardData = (0,product_card_context/* useProductCardContext */.I$)();
    if (!showFeature("categoryName", productCardData)) return null;
    var categoryName = (ref = productCardData.data.product.category) === null || ref === void 0 ? void 0 : ref.categoryName;
    return /*#__PURE__*/ react.createElement(variants.CaptionText, {
        behavior: variants.Behavior.OnelineEllipsis,
        emphasis: variants.FontEmphasis.MEDIUM,
        containerProps: {
            "data-testid": "Category"
        }
    }, categoryName);
};

;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n      opacity: 0.2;\n    "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n    padding: ",
        ";\n    max-height: calc(180px + ",
        " * 2);\n\n    ",
        "\n  "
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var PADDING = design_tokens.measurements.spacing075;
var StyledImage = styled_components_browser_esm["default"].img.withConfig({
    displayName: "StyledImage",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(styles_templateObject1(), PADDING, PADDING, props.$isFallbackImage && (0,styled_components_browser_esm.css)(styles_templateObject()));
});

;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/image.tsx




var Image = function() {
    var market = (0,app_context/* useAppContext */.bp)().market;
    var productCardData = (0,product_card_context/* useProductCardContext */.I$)();
    var url = productCardData.data.product.logo;
    var fallback = "".concat(market.cdn, "/product/standard/280/0.jpg");
    return /*#__PURE__*/ react.createElement(StyledImage, {
        src: url || fallback,
        alt: "",
        "data-testid": "ProductCardImage",
        $isFallbackImage: !url
    });
};

;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/product-name.tsx



var ProductName = function() {
    var productCardData = (0,product_card_context/* useProductCardContext */.I$)();
    var text = productCardData.data.product.name;
    return /*#__PURE__*/ react.createElement(variants.TitleSmallText, {
        behavior: variants.Behavior.TwolineEllipsis,
        containerProps: {
            "data-testid": "ProductName",
            "data-test": "ProductName"
        }
    }, text);
};

// EXTERNAL MODULE: ./src/components/rating/index.tsx + 1 modules
var components_rating = __webpack_require__(9160);
;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/rating.tsx




var Rating = function() {
    var productCardData = (0,product_card_context/* useProductCardContext */.I$)();
    if (!showFeature("rating", productCardData)) return null;
    var rating = productCardData.data.product.rating;
    return /*#__PURE__*/ react.createElement(components_rating/* default */.Z, {
        rate: rating.score,
        count: rating.count,
        showCounterAs: "number",
        dataTestid: "Rating"
    });
};

// EXTERNAL MODULE: ./src/components/badges/deals-badge/index.tsx + 1 modules
var deals_badge = __webpack_require__(56355);
;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/top-left/deals-badge.tsx





var DealsBadge = function() {
    var productCardData = (0,product_card_context/* useProductCardContext */.I$)();
    if (!showFeature(types/* TopLeftCornerFeature.DEALS_BADGE */.ev.DEALS_BADGE, productCardData)) {
        return null;
    }
    var productId = productCardData.data.product.id;
    var priceDrop = productCardData.data.product.priceDrop;
    var price = productCardData.data.offer.price;
    if (!price || !priceDrop) return null;
    return /*#__PURE__*/ react.createElement(deals_badge/* DealsBadge */.T, {
        "data-testid": "DealsBadge",
        priceDrop: priceDrop,
        price: price,
        popoverUniqueId: productId
    });
};

// EXTERNAL MODULE: ./src/components/product-of-the-year/hooks.ts
var hooks = __webpack_require__(78060);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/badge/index.js
var badge = __webpack_require__(29242);
// EXTERNAL MODULE: ./src/components/badges/image-badges.tsx
var image_badges = __webpack_require__(39986);
;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/top-left/styles.ts
function top_left_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function top_left_styles_templateObject() {
    var data = top_left_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  left: ",
        ";\n  top: ",
        ";\n  z-index: 3;\n"
    ]);
    top_left_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function top_left_styles_templateObject1() {
    var data = top_left_styles_taggedTemplateLiteral([
        "\n  width: 56px;\n  top: ",
        ";\n  left: ",
        ";\n"
    ]);
    top_left_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = top_left_styles_taggedTemplateLiteral([
        "\n  max-width: 100%;\n  white-space: nowrap;\n  & > svg {\n    flex-shrink: 0;\n  }\n  & > span {\n    text-overflow: ellipsis;\n    overflow: hidden;\n  }\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var StyledTopLeftArea = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledTopLeftArea",
    componentId: "sc-0-0"
})(top_left_styles_templateObject(), design_tokens.measurements.spacing075, design_tokens.measurements.spacing075);
var StyledImageBadge = (0,styled_components_browser_esm["default"])(image_badges/* ImageBadge */.d3).withConfig({
    displayName: "StyledImageBadge",
    componentId: "sc-0-1"
})(top_left_styles_templateObject1(), design_tokens.measurements.spacing075, design_tokens.measurements.spacing075);
var StyledBadge = (0,styled_components_browser_esm["default"])(badge.Badge).withConfig({
    displayName: "StyledBadge",
    componentId: "sc-0-2"
})(styles_templateObject2());

;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/top-left/product-of-the-year-badge.tsx






var ProductOfTheYearBadge = function() {
    var productCardData = (0,product_card_context/* useProductCardContext */.I$)();
    var poty = (0,hooks/* useGetProductOfTheYear */.i)(productCardData.data.product.id);
    if (!(poty === null || poty === void 0 ? void 0 : poty.awardLogo) || !showFeature(types/* TopLeftCornerFeature.POTY_BADGE */.ev.POTY_BADGE, productCardData)) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(StyledImageBadge, {
        badgeUrl: poty.awardLogo,
        title: "".concat(poty.awardName, " ").concat(poty.year)
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/recycle/index.js
var recycle = __webpack_require__(4781);
// EXTERNAL MODULE: ./src/areas/product/utils/product-condition/index.ts
var product_condition = __webpack_require__(83681);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/tooltip/index.js
var tooltip = __webpack_require__(714);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/index.js
var ui = __webpack_require__(54262);
;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/top-left/used-badge.tsx










var UsedBadge = function() {
    var ref = (0,app_context/* useAppContext */.bp)(), market = ref.market, t = ref.t;
    var productCardData = (0,product_card_context/* useProductCardContext */.I$)();
    if (!showFeature(types/* TopLeftCornerFeature.USED_BADGE */.ev.USED_BADGE, productCardData)) {
        return null;
    }
    var condition = productCardData.data.offer.condition;
    if (!condition) return null;
    var tooltipText = market.code === "fr" ? (0,product_condition/* getConditionName */.v)(condition, t) : undefined;
    return /*#__PURE__*/ react.createElement(tooltip/* Tooltip */.u, {
        placement: ui/* Direction.Up */.Nm.Up,
        renderOnMouseOver: true,
        title: tooltipText
    }, /*#__PURE__*/ react.createElement(StyledBadge, {
        color: "GREEN",
        icon: recycle/* IconRecycle */.L,
        text: (0,product_condition/* getConditionName */.v)(condition, t),
        containerProps: {
            "data-testid": "UsedBadge"
        }
    }));
};

;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/top-left/top-rated-badge.tsx






var TopRatedBadge = function() {
    var ref = (0,app_context/* useAppContext */.bp)(), market = ref.market, t = ref.t;
    var productCardData = (0,product_card_context/* useProductCardContext */.I$)();
    if (!showFeature(types/* TopLeftCornerFeature.TOP_RATED_BADGE */.ev.TOP_RATED_BADGE, productCardData)) return null;
    return /*#__PURE__*/ react.createElement(StyledImageBadge, {
        badgeUrl: "".concat(market.cdn, "/g/expert/").concat(market.code, "/expert-toprated-badge.png"),
        title: t("expert", "expert.top-rated-badge")
    });
};

;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/top-left/top-left-area.tsx






var TopLeftArea = function() {
    return /*#__PURE__*/ react.createElement(StyledTopLeftArea, null, /*#__PURE__*/ react.createElement(ProductOfTheYearBadge, null), /*#__PURE__*/ react.createElement(TopRatedBadge, null), /*#__PURE__*/ react.createElement(DealsBadge, null), /*#__PURE__*/ react.createElement(UsedBadge, null));
};

;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/top-left/index.tsx


// EXTERNAL MODULE: ./src/components/action-buttons/add-to-list/index.tsx
var add_to_list = __webpack_require__(27890);
;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/top-right/add-to-list.tsx






var AddToList = function() {
    var ref = (0,app_context/* useAppContext */.bp)(), market = ref.market, renderMode = ref.renderMode;
    var productCardData = (0,product_card_context/* useProductCardContext */.I$)();
    if (!market.login.enabled || renderMode === "native") {
        return null;
    }
    if (!showFeature(types/* TopRightCornerFeature.ADD_TO_LIST */.I6.ADD_TO_LIST, productCardData)) {
        return null;
    }
    var _product = productCardData.data.product, id = _product.id, name = _product.name;
    return /*#__PURE__*/ react.createElement(add_to_list/* AddToListButton */.a, {
        productId: id,
        productName: name
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/button/index.js
var ui_button = __webpack_require__(17658);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/dropdown/index.js
var dropdown = __webpack_require__(42654);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/flag-outlined/index.js
var flag_outlined = __webpack_require__(69001);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/heart-filled/index.js
var heart_filled = __webpack_require__(63479);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/heart-outlined/index.js
var heart_outlined = __webpack_require__(92261);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/menu-kebab/index.js
var menu_kebab = __webpack_require__(47481);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/notification-outlined/index.js
var notification_outlined = __webpack_require__(72523);
// EXTERNAL MODULE: ./src/components/action-buttons/add-to-list/add-to-list-wrapper.tsx
var add_to_list_wrapper = __webpack_require__(99447);
// EXTERNAL MODULE: ./src/components/action-buttons/alert/alert-modal.tsx
var alert_modal = __webpack_require__(16772);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row/components/report-modal/index.tsx
var report_modal = __webpack_require__(5884);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/light-theme-colors.js
var light_theme_colors = __webpack_require__(24774);
;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/top-right/styles.ts
function top_right_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function top_right_styles_templateObject() {
    var data = top_right_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  right: ",
        ";\n  top: ",
        ";\n  z-index: 1;\n"
    ]);
    top_right_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function top_right_styles_templateObject1() {
    var data = top_right_styles_taggedTemplateLiteral([
        "\n  > button {\n    background-color: ",
        ";\n\n    &:hover {\n      background-color: ",
        ";\n    }\n  }\n\n  > .Floater {\n    left: unset;\n    right: 0;\n  }\n"
    ]);
    top_right_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function top_right_styles_templateObject2() {
    var data = top_right_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  white-space: nowrap;\n  cursor: pointer;\n  padding: ",
        ";\n  gap: ",
        ";\n  color: ",
        ";\n\n  &:not(:last-child) {\n    border-bottom: 1px solid ",
        ";\n  }\n\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    top_right_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var StyledTopRightArea = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledTopRightArea",
    componentId: "sc-0-0"
})(top_right_styles_templateObject(), design_tokens.measurements.spacing075, design_tokens.measurements.spacing075);
var CardDropdown = (0,styled_components_browser_esm["default"])(dropdown/* Dropdown */.Lt).withConfig({
    displayName: "CardDropdown",
    componentId: "sc-0-1"
})(top_right_styles_templateObject1(), light_theme_colors.staticBase0, light_theme_colors.staticBase200);
var DropdownItem = styled_components_browser_esm["default"].button.withConfig({
    displayName: "DropdownItem",
    componentId: "sc-0-2"
})(top_right_styles_templateObject2(), design_tokens.measurements.spacing050, design_tokens.measurements.spacing050, light_theme_colors.staticBase900, light_theme_colors.staticBase200, function(p) {
    return p.theme.dropdowns.secondary.hoverBackground;
});

;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/top-right/dropdown.tsx
function dropdown_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function dropdown_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function dropdown_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function dropdown_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function dropdown_slicedToArray(arr, i) {
    return dropdown_arrayWithHoles(arr) || dropdown_iterableToArrayLimit(arr, i) || dropdown_unsupportedIterableToArray(arr, i) || dropdown_nonIterableRest();
}
function dropdown_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return dropdown_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return dropdown_arrayLikeToArray(o, minLen);
}
















var Dropdown = function() {
    var ref = (0,app_context/* useAppContext */.bp)(), renderMode = ref.renderMode, t = ref.t, market = ref.market;
    var productCardData = (0,product_card_context/* useProductCardContext */.I$)();
    var ref1 = dropdown_slicedToArray((0,react.useState)(false), 2), reportModalIsOpen = ref1[0], setReportModalIsOpen = ref1[1];
    var ref2 = dropdown_slicedToArray((0,react.useState)(false), 2), alertModalIsOpen = ref2[0], setAlertModalIsOpen = ref2[1];
    if (!showFeature(types/* TopRightCornerFeature.DROPDOWN */.I6.DROPDOWN, productCardData)) {
        return null;
    }
    var nativeRenderMode = renderMode === "native";
    var displayAddToList = market.login.enabled && !nativeRenderMode;
    var displayAlert = !nativeRenderMode;
    var offer = productCardData.data.offer;
    var product = productCardData.data.product;
    var productId = product.id;
    var productName = product.name;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(report_modal/* ReportModal */.y, {
        isOpen: reportModalIsOpen,
        closeModal: function() {
            return setReportModalIsOpen(false);
        },
        priceId: offer.priceId,
        priceValue: offer.price,
        productName: productName,
        productImage: product.logo,
        stockStatus: offer.stockStatus,
        store: offer.storeId && offer.storeName ? {
            id: offer.storeId,
            name: offer.storeName
        } : null,
        isFeatured: offer.featured
    }), displayAlert && /*#__PURE__*/ react.createElement(alert_modal/* AlertModal */.V, {
        closeModal: function() {
            return setAlertModalIsOpen(false);
        },
        isOpen: alertModalIsOpen,
        productId: productId
    }), /*#__PURE__*/ react.createElement(CardDropdown, {
        elevation: ui_button.ButtonElevation.NONE,
        containerProps: {
            "data-testid": "Dropdown"
        }
    }, /*#__PURE__*/ react.createElement(dropdown/* DropdownToggle */.Z_, {
        onlyIcon: true,
        type: ui_button.ButtonType.OUTLINED,
        containerProps: {
            "data-testid": "DropdownToggleButton"
        }
    }, /*#__PURE__*/ react.createElement(menu_kebab/* IconMenuKebab */.Q, null)), /*#__PURE__*/ react.createElement(add_to_list_wrapper/* AddToListModalsWrapper */.w, {
        productId: productId,
        productName: productName
    }, function(onListClick, addedToList) {
        return /*#__PURE__*/ react.createElement(dropdown/* DropdownContent */.Nv, null, displayAddToList && /*#__PURE__*/ react.createElement(DropdownItem, {
            "aria-label": t("common", "button.save"),
            onClick: onListClick,
            "data-testid": "AddToListButton"
        }, addedToList ? /*#__PURE__*/ react.createElement(heart_filled/* IconHeartFilled */.g, null) : /*#__PURE__*/ react.createElement(heart_outlined/* IconHeartOutlined */.G, null), /*#__PURE__*/ react.createElement("span", null, addedToList ? t("lists", "list.save-to-list") : t("lists", "list.save-to-new-list"))), displayAlert && /*#__PURE__*/ react.createElement(DropdownItem, {
            onClick: function() {
                return setAlertModalIsOpen(true);
            },
            "data-testid": "ToggleAlertModalButton"
        }, /*#__PURE__*/ react.createElement(notification_outlined/* IconNotificationOutlined */.F, null), /*#__PURE__*/ react.createElement("span", null, t("alerts", "alert-form.create-button"))), /*#__PURE__*/ react.createElement(DropdownItem, {
            onClick: function() {
                return setReportModalIsOpen(true);
            },
            "data-testid": "ToggleReportModalButton"
        }, /*#__PURE__*/ react.createElement(flag_outlined/* IconFlagOutlined */.b, null), /*#__PURE__*/ react.createElement("span", null, t("feedback", "dialog.prompt-button"))));
    })));
};

;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/top-right/top-right-area.tsx




var TopRightArea = function() {
    return /*#__PURE__*/ react.createElement(StyledTopRightArea, null, /*#__PURE__*/ react.createElement(AddToList, null), /*#__PURE__*/ react.createElement(Dropdown, null));
};

;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/top-right/index.tsx


// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/outgoing-link/index.js
var outgoing_link = __webpack_require__(43709);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
;// CONCATENATED MODULE: ./src/components/product-card/components/bottom-half/clickout-button/styles.ts
function clickout_button_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function clickout_button_styles_templateObject() {
    var data = clickout_button_styles_taggedTemplateLiteral([
        "\n      opacity: 0.24;\n    "
    ]);
    clickout_button_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function clickout_button_styles_templateObject1() {
    var data = clickout_button_styles_taggedTemplateLiteral([
        "\n    ",
        "\n  "
    ]);
    clickout_button_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function clickout_button_styles_templateObject2() {
    var data = clickout_button_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  z-index: 10;\n"
    ]);
    clickout_button_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = clickout_button_styles_taggedTemplateLiteral([
        "\n  height: 42px;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = clickout_button_styles_taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n  & > * {\n    vertical-align: middle;\n  }\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = clickout_button_styles_taggedTemplateLiteral([
        "\n    display: flex;\n    flex: none;\n  "
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = clickout_button_styles_taggedTemplateLiteral([
        "\n  flex: 1;\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  justify-content: center;\n\n  ",
        ";\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = clickout_button_styles_taggedTemplateLiteral([
        "\n  & > path {\n    fill: currentColor;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}





var StyledButton = (0,styled_components_browser_esm["default"])(ui_button.Button).withConfig({
    displayName: "StyledButton",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(clickout_button_styles_templateObject1(), props.disabled && (0,styled_components_browser_esm.css)(clickout_button_styles_templateObject()));
});
var GrayClickOutWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "GrayClickOutWrapper",
    componentId: "sc-0-1"
})(clickout_button_styles_templateObject2());
var OuterWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "OuterWrapper",
    componentId: "sc-0-2"
})(styles_templateObject3());
var IconWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "IconWrapper",
    componentId: "sc-0-3"
})(styles_templateObject4(), design_tokens.measurements.spacing025);
var InnerWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "InnerWrapper",
    componentId: "sc-0-4"
})(styles_templateObject6(), base/* media.smallOnly */.BC.smallOnly(styles_templateObject5()));
var IconOutgoingLinkWithColorFix = (0,styled_components_browser_esm["default"])(outgoing_link/* IconOutgoingLink */.v).withConfig({
    displayName: "IconOutgoingLinkWithColorFix",
    componentId: "sc-0-5"
})(_templateObject7());

;// CONCATENATED MODULE: ./src/components/product-card/components/bottom-half/clickout-button/base-clickout-button.tsx



var ICON_SIZE = 15;
var BaseClickoutButton = function(param) {
    var href = param.href, onClick = param.onClick, text = param.text;
    var disabled = !href;
    var containerProps = {
        href: href,
        rel: "nofollow",
        target: "_blank",
        "data-testid": "ClickoutButton"
    };
    return /*#__PURE__*/ react.createElement(OuterWrapper, null, /*#__PURE__*/ react.createElement(StyledButton, {
        containerProps: containerProps,
        container: "a",
        disabled: disabled,
        fullWidth: true,
        onClick: onClick,
        type: disabled ? ui_button.ButtonType.TONAL : ui_button.ButtonType.PRIMARY
    }, /*#__PURE__*/ react.createElement(InnerWrapper, null, text, /*#__PURE__*/ react.createElement(IconWrapper, null, /*#__PURE__*/ react.createElement(IconOutgoingLinkWithColorFix, {
        size: ICON_SIZE
    })))));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/popover/index.js
var popover = __webpack_require__(22448);
;// CONCATENATED MODULE: ./src/components/product-card/components/bottom-half/clickout-button/gray-clickout-button.tsx
function gray_clickout_button_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function gray_clickout_button_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function gray_clickout_button_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function gray_clickout_button_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function gray_clickout_button_slicedToArray(arr, i) {
    return gray_clickout_button_arrayWithHoles(arr) || gray_clickout_button_iterableToArrayLimit(arr, i) || gray_clickout_button_unsupportedIterableToArray(arr, i) || gray_clickout_button_nonIterableRest();
}
function gray_clickout_button_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return gray_clickout_button_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return gray_clickout_button_arrayLikeToArray(o, minLen);
}






var GrayClickoutButton = function(param) {
    var text = param.text;
    var ref = gray_clickout_button_slicedToArray((0,react.useState)(false), 2), showPopover = ref[0], setShowPopover = ref[1];
    var t = (0,app_context/* useAppContext */.bp)().t;
    return /*#__PURE__*/ react.createElement(GrayClickOutWrapper, {
        style: {
            position: "relative"
        }
    }, /*#__PURE__*/ react.createElement(BaseClickoutButton, {
        href: null,
        text: text,
        onClick: function() {
            setShowPopover(true);
        }
    }), /*#__PURE__*/ react.createElement(popover/* Popover */.J2, {
        id: "popover",
        visible: showPopover,
        onClose: function() {
            return setShowPopover(false);
        },
        width: 250,
        offsetY: 0,
        offsetX: 0,
        verticalAlign: popover/* Alignment.End */.v2.End,
        horizontalAlign: popover/* Alignment.End */.v2.End,
        zIndex: 100
    }, /*#__PURE__*/ react.createElement(variants.BodySmallText, null, t("product", "transparency.store-info"))));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 24 modules
var es = __webpack_require__(95939);
// EXTERNAL MODULE: ./src/globals/tracking/conversion.ts + 1 modules
var conversion = __webpack_require__(56290);
// EXTERNAL MODULE: ./src/areas/product/actions/product.ts + 1 modules
var product = __webpack_require__(36483);
// EXTERNAL MODULE: ./src/utils/click-out-bounce-helper.ts
var click_out_bounce_helper = __webpack_require__(9690);
;// CONCATENATED MODULE: ./src/components/product-card/components/bottom-half/clickout-button/util.ts


var mapProductCardDataToTrackOfferClick = function(productCardData) {
    var offer = productCardData.data.offer;
    var dealIsDisplayed = showFeature("deals", productCardData);
    var promotionIsDisplayed = showFeature("promotionOwnerPriceBadge", productCardData);
    var conditionIsDisplayed = showFeature(types/* TopLeftCornerFeature.USED_BADGE */.ev.USED_BADGE, productCardData);
    var priceType = "regular";
    if (showFeature("salesPrice", productCardData)) {
        priceType = "sale";
    } else if (showFeature("memberPrice", productCardData)) {
        priceType = "member";
    }
    return {
        priceId: offer.priceId,
        scope: productCardData.trackingClickoutScope,
        condition: conditionIsDisplayed && offer.condition || undefined,
        isPjDeal: dealIsDisplayed || undefined,
        isPartOfPromotion: promotionIsDisplayed || undefined,
        priceType: priceType
    };
};

;// CONCATENATED MODULE: ./src/components/product-card/components/bottom-half/clickout-button/primary-clickout-button.tsx








var PrimaryClickoutButton = function(props) {
    var productCardData = (0,product_card_context/* useProductCardContext */.I$)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var productId = productCardData.data.product.id;
    var scope = productCardData.trackingClickoutScope;
    var _offer = productCardData.data.offer, offerLink = _offer.offerLink, _priceId = _offer.priceId, priceId = _priceId === void 0 ? "" : _priceId, price = _offer.price, stockStatus = _offer.stockStatus, condition = _offer.condition, storeName = _offer.storeName;
    var handleBounce = function() {
        dispatch((0,product/* productClickOutBounce */.nA)({
            productId: productId,
            priceId: priceId,
            storeName: storeName
        }));
    };
    var handleClickOut = function() {
        var ref, ref1;
        (ref = productCardData.customTracking) === null || ref === void 0 ? void 0 : (ref1 = ref.onClickout) === null || ref1 === void 0 ? void 0 : ref1.call(ref);
        if (!scope) return;
        (0,conversion/* trackOfferClickWithRevenue */.Rx)(mapProductCardDataToTrackOfferClick(productCardData));
        dispatch((0,product/* productPriceClick */.Po)(productId, price, true, "", false, scope, stockStatus, condition));
        (0,click_out_bounce_helper/* handleClickOutBounce */.y)(handleBounce);
    };
    return /*#__PURE__*/ react.createElement(BaseClickoutButton, {
        href: offerLink,
        onClick: handleClickOut,
        text: props.text
    });
};

;// CONCATENATED MODULE: ./src/components/product-card/components/bottom-half/clickout-button/clickout-button.tsx






var ClickoutButton = function() {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var productCardData = (0,product_card_context/* useProductCardContext */.I$)();
    if (!showFeature("clickoutButton", productCardData)) return null;
    var featured = productCardData.data.offer.featured;
    var text = t("product", "external-link.visit-shop");
    if (featured) {
        return /*#__PURE__*/ react.createElement(PrimaryClickoutButton, {
            text: text
        });
    }
    return /*#__PURE__*/ react.createElement(GrayClickoutButton, {
        text: text
    });
};

;// CONCATENATED MODULE: ./src/components/product-card/components/bottom-half/clickout-button/index.ts


;// CONCATENATED MODULE: ./src/components/product-card/components/bottom-half/store-info.tsx





var StoreInfo = function() {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var productCardData = (0,product_card_context/* useProductCardContext */.I$)();
    var storeCount = productCardData.data.product.storeCount;
    var storeName = productCardData.data.offer.storeName;
    var featured = productCardData.data.offer.featured;
    return /*#__PURE__*/ react.createElement(VerticalTextAlignment, null, /*#__PURE__*/ react.createElement(variants.CaptionStrongText, {
        emphasis: featured ? variants.FontEmphasis.HIGH : variants.FontEmphasis.LOW,
        containerProps: {
            "data-testid": "StoreInfoName"
        }
    }, storeName), storeCount && storeCount > 1 && /*#__PURE__*/ react.createElement(variants.CaptionText, {
        emphasis: variants.FontEmphasis.MEDIUM,
        containerProps: {
            "data-testid": "StoreInfoCount"
        }
    }, "+", storeCount - 1, "\xa0", t("search", "stores.title").toLocaleLowerCase()));
};

// EXTERNAL MODULE: ./src/areas/product/components/badges/index.ts + 4 modules
var badges = __webpack_require__(3460);
;// CONCATENATED MODULE: ./src/components/product-card/components/bottom-half/price-components/price-badges/membership-price-badge.tsx




var MembershipPriceBadge = function() {
    var productCardData = (0,product_card_context/* useProductCardContext */.I$)();
    if (!showFeature("memberPrice", productCardData)) return null;
    return /*#__PURE__*/ react.createElement(badges/* MembershipBadge */.fd, {
        isMembershipPrice: true
    });
};

;// CONCATENATED MODULE: ./src/components/product-card/components/bottom-half/price-components/price-explanations/paid-membership-info.tsx




var PaidMembershipInfo = function() {
    var productCardData = (0,product_card_context/* useProductCardContext */.I$)();
    if (!showFeature("membershipRequiresCompensation", productCardData)) {
        return null;
    }
    var isPaidMembership = productCardData.data.offer.membershipRequiresCompensation || false;
    return /*#__PURE__*/ react.createElement(badges/* MembershipInformation */.pb, {
        isMembershipPrice: true,
        isPaidMembership: isPaidMembership,
        smallerTextSize: false
    });
};

// EXTERNAL MODULE: ./src/components/currency/index.tsx
var currency = __webpack_require__(49763);
// EXTERNAL MODULE: ./src/components/offer/price/price-text.tsx
var price_text = __webpack_require__(28254);
;// CONCATENATED MODULE: ./src/components/product-card/components/bottom-half/price-components/price.tsx








var Price = function() {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var productCardData = (0,product_card_context/* useProductCardContext */.I$)();
    var isSalesPrice = showFeature("salesPrice", productCardData);
    var price = productCardData.data.offer.price;
    if (!showFeature("price", productCardData) || !price) return null;
    var memberPrice = productCardData.data.offer.memberPrice || Number.MAX_SAFE_INTEGER;
    var lowestPrice = Math.min(memberPrice, price);
    return /*#__PURE__*/ react.createElement(VerticalTextAlignment, null, /*#__PURE__*/ react.createElement(variants.BodySmallText, null, t("product", "price.from-abbr")), /*#__PURE__*/ react.createElement(price_text/* PriceText */.X, {
        color: isSalesPrice ? variants.FontColor.NEGATIVE : variants.FontColor.DARK
    }, /*#__PURE__*/ react.createElement(currency/* Currency */.F, {
        price: lowestPrice
    })));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/index.js
var ui_text = __webpack_require__(49955);
;// CONCATENATED MODULE: ./src/components/product-card/components/bottom-half/price-components/price-explanations/price-in-paranthesis.tsx






var PriceInParanthesis = function() {
    var productCardData = (0,product_card_context/* useProductCardContext */.I$)();
    if (!showFeature("memberPriceText", productCardData)) return null;
    var originalPrice = productCardData.data.offer.originalPrice;
    return /*#__PURE__*/ react.createElement(price_text/* PriceText */.X, {
        emphasis: ui_text.FontEmphasis.MEDIUM,
        scale: ui_text.FontScale.S,
        weight: ui_text.FontWeight.NORMAL,
        containerProps: {
            "data-testid": "PriceInParanthesis"
        }
    }, "(", /*#__PURE__*/ react.createElement(currency/* Currency */.F, {
        price: originalPrice
    }), ")");
};

;// CONCATENATED MODULE: ./src/components/product-card/components/bottom-half/price-components/price-explanations/styles.ts
function price_explanations_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function price_explanations_styles_templateObject() {
    var data = price_explanations_styles_taggedTemplateLiteral([
        "\n  text-decoration: line-through;\n"
    ]);
    price_explanations_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledStrikethroughPrice = (0,styled_components_browser_esm["default"])(price_text/* PriceText */.X).withConfig({
    displayName: "StyledStrikethroughPrice",
    componentId: "sc-0-0"
})(price_explanations_styles_templateObject());

;// CONCATENATED MODULE: ./src/components/product-card/components/bottom-half/price-components/price-explanations/price-strikethrough.tsx






var PriceStrikethrough = function() {
    var productCardData = (0,product_card_context/* useProductCardContext */.I$)();
    if (!showFeature("salesPriceText", productCardData)) return null;
    var originalPrice = productCardData.data.offer.originalPrice;
    return /*#__PURE__*/ react.createElement(StyledStrikethroughPrice, {
        emphasis: ui_text.FontEmphasis.MEDIUM,
        scale: ui_text.FontScale.S,
        weight: ui_text.FontWeight.NORMAL,
        containerProps: {
            "data-testid": "PriceStrikethrough"
        }
    }, /*#__PURE__*/ react.createElement(currency/* Currency */.F, {
        price: originalPrice
    }));
};

;// CONCATENATED MODULE: ./src/components/product-card/components/bottom-half/price-components/price-badges/promotion-owner-price-badge.tsx






var PromotionOwnerPriceBadge = function() {
    var market = (0,app_context/* useAppContext */.bp)().market;
    var productCardData = (0,product_card_context/* useProductCardContext */.I$)();
    if (!showFeature("promotionOwnerPriceBadge", productCardData)) {
        return null;
    }
    var owner = productCardData.promotionOwnerData;
    return /*#__PURE__*/ react.createElement(badge.Badge, {
        color: "GREY",
        size: badge.BadgeSize.SMALL,
        text: "".concat((0,currency/* formatCurrency */.xG)(owner.price, market.code, false), " • ").concat(owner.name),
        containerProps: {
            "data-testid": "PromotionOwnerPriceBadge"
        }
    });
};

;// CONCATENATED MODULE: ./src/components/product-card/components/bottom-half/price-components/price-badges/sales-price-badge.tsx




var SalesPriceBadge = function() {
    var productCardData = (0,product_card_context/* useProductCardContext */.I$)();
    if (!showFeature("salesPrice", productCardData)) return null;
    var _offer = productCardData.data.offer, price = _offer.price, priceExpires = _offer.priceExpires, originalPrice = _offer.originalPrice;
    return /*#__PURE__*/ react.createElement(badges/* CampaignBadge */.xV, {
        isCampaign: true,
        originalPrice: originalPrice,
        price: price,
        priceExpires: priceExpires,
        containerProps: {
            "data-testid": "SalesPriceBadge"
        }
    });
};

// EXTERNAL MODULE: ./src/components/product-card/contexts/image-search-modal-context.tsx + 7 modules
var image_search_modal_context = __webpack_require__(7186);
// EXTERNAL MODULE: ./src/hooks/experiments.ts
var experiments = __webpack_require__(46353);
;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/bottom-right/image-search/utils.tsx


// While the Image Search is under an experiment with multiple parameters it's easier to use this
// temporary helper function to hide the feature rather than complicate the showFeature function.
var showImageSearch = function(isImageSearchExperiment, productCardData, marketCode) {
    if (isImageSearchExperiment === "showAll") return true;
    if (isImageSearchExperiment === "limitedList" && marketCode === "se" && showFeature(types/* BottomRightCornerFeature.IMAGE_SEARCH */.rq.IMAGE_SEARCH, productCardData)) {
        return true;
    }
    return false;
};

// EXTERNAL MODULE: ./src/ui/block/index.ts
var block = __webpack_require__(65176);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/center-focus-strong/index.js
var center_focus_strong = __webpack_require__(24092);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon-interactive/index.js
var icon_interactive = __webpack_require__(28148);
;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/bottom-right/image-search/image-search.tsx











var ImageSearch = function() {
    var productCardData = (0,product_card_context/* useProductCardContext */.I$)();
    var openModal = (0,image_search_modal_context/* useImageSearchModalContext */.wJ)().openModal;
    var ref = (0,app_context/* useAppContext */.bp)(), t = ref.t, market = ref.market;
    var isImageSearchExperiment = (0,experiments/* useImageSearchExperiment */.sU)();
    if (!openModal || !showImageSearch(isImageSearchExperiment, productCardData, market.code)) {
        return null;
    }
    var onClick = function(e) {
        var ref;
        e.preventDefault();
        e.stopPropagation();
        var productId = productCardData.data.product.id;
        var imageSearchModels = productCardData.data.product.imageSearchModels;
        var categoryName = (ref = productCardData.data.product.category) === null || ref === void 0 ? void 0 : ref.categoryName;
        openModal({
            productId: productId,
            categoryName: categoryName,
            imageSearchModels: imageSearchModels
        });
    };
    return /*#__PURE__*/ react.createElement(block/* DesktopOnly */.NZ, null, /*#__PURE__*/ react.createElement("div", {
        onClick: function(e) {
            return e.stopPropagation();
        },
        "data-testid": "ImageSearchWrapper"
    }, /*#__PURE__*/ react.createElement(tooltip/* Tooltip */.u, {
        placement: ui/* Direction.Left */.Nm.Left,
        title: t("search", "visually-similar.tooltip")
    }, /*#__PURE__*/ react.createElement(icon_interactive/* InteractiveIcon */.z, {
        icon: center_focus_strong/* IconCenterFocusStrong */.a,
        size: 30,
        onClick: onClick
    }))));
};

;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/bottom-right/image-search/index.tsx


;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/bottom-right/styles.ts
function bottom_right_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function bottom_right_styles_templateObject() {
    var data = bottom_right_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  right: 0;\n  bottom: 0;\n"
    ]);
    bottom_right_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var StyledBottomRightArea = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledBottomRightArea",
    componentId: "sc-0-0"
})(bottom_right_styles_templateObject());

;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/bottom-right/bottom-right-area.tsx



var BottomRightArea = function() {
    return /*#__PURE__*/ react.createElement(StyledBottomRightArea, null, /*#__PURE__*/ react.createElement(ImageSearch, null));
};

;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/bottom-right/index.tsx


;// CONCATENATED MODULE: ./src/components/product-card/card-types/internal/base-product-card.tsx




















var BaseProductCard = function() {
    return /*#__PURE__*/ react.createElement(CardWrapper, null, /*#__PURE__*/ react.createElement(TopLeftArea, null), /*#__PURE__*/ react.createElement(TopRightArea, null), /*#__PURE__*/ react.createElement(CardClickableArea, null, /*#__PURE__*/ react.createElement(FlexColumn, null, /*#__PURE__*/ react.createElement(ImageWrapper, null, /*#__PURE__*/ react.createElement(Image, null), /*#__PURE__*/ react.createElement(BottomRightArea, null)), /*#__PURE__*/ react.createElement(Category, null), /*#__PURE__*/ react.createElement(ProductName, null), /*#__PURE__*/ react.createElement(Rating, null)), /*#__PURE__*/ react.createElement(FlexColumnCompact, null, /*#__PURE__*/ react.createElement(PaidMembershipInfo, null), /*#__PURE__*/ react.createElement(MembershipPriceBadge, null), /*#__PURE__*/ react.createElement(SalesPriceBadge, null), /*#__PURE__*/ react.createElement(VerticalTextAlignment, null, /*#__PURE__*/ react.createElement(Price, null), /*#__PURE__*/ react.createElement(PriceStrikethrough, null), /*#__PURE__*/ react.createElement(PriceInParanthesis, null)), /*#__PURE__*/ react.createElement(StoreInfo, null), /*#__PURE__*/ react.createElement(PromotionOwnerPriceBadge, null))), /*#__PURE__*/ react.createElement(ClickoutButton, null));
};


/***/ }),

/***/ 7186:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Eo": () => (/* binding */ ImageSearchModalProvider),
  "wJ": () => (/* binding */ useImageSearchModalContext)
});

// UNUSED EXPORTS: ImageSearchModalContext

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/modal/index.js
var modal = __webpack_require__(58709);
// EXTERNAL MODULE: ./src/components/modal-v2/modal.tsx
var modal_v2_modal = __webpack_require__(62122);
// EXTERNAL MODULE: ./src/hooks/use-gql-query.ts
var use_gql_query = __webpack_require__(63113);
// EXTERNAL MODULE: ./src/components/product-card/queries/image-search.graphql
var image_search_graphql = __webpack_require__(79018);
var image_search_graphql_default = /*#__PURE__*/__webpack_require__.n(image_search_graphql);
;// CONCATENATED MODULE: ./src/components/product-card/queries/use-image-search.ts


var CACHE_TIME_PER_PRODUCT_ID = 60 * 1000;
function useImageSearch(variables, enabled) {
    return (0,use_gql_query/* useGqlQuery */.n)({
        query: (image_search_graphql_default()),
        variables: variables,
        refetchOnReconnect: false,
        queryKey: [
            "use-image-search"
        ],
        enabled: enabled,
        staleTime: CACHE_TIME_PER_PRODUCT_ID
    });
}

// EXTERNAL MODULE: ./src/components/product-card/contexts/product-card-context.tsx
var product_card_context = __webpack_require__(25562);
// EXTERNAL MODULE: ./src/components/product-card/card-types/internal/base-product-card.tsx + 44 modules
var base_product_card = __webpack_require__(74588);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(58912);
// EXTERNAL MODULE: ./src/components/product-card/types.ts
var types = __webpack_require__(73738);
// EXTERNAL MODULE: ./src/components/product-card/mappers/map-product-card.ts
var map_product_card = __webpack_require__(30862);
;// CONCATENATED MODULE: ./src/components/product-card/card-types/image-search-product-card.tsx






var ImageSearchProductCard = function(param) {
    var customTracking = param.customTracking, product = param.product;
    var p = product;
    var data = (0,map_product_card/* mapProductCard */.V)({
        product: p
    });
    var initialState = {
        data: data,
        customTracking: customTracking,
        features: {
            categoryName: false,
            clickoutButton: false,
            deals: true,
            memberPrice: false,
            rating: true,
            salesPrice: false,
            topLeftCorner: [
                types/* TopLeftCornerFeature.POTY_BADGE */.ev.POTY_BADGE,
                types/* TopLeftCornerFeature.TOP_RATED_BADGE */.ev.TOP_RATED_BADGE,
                types/* TopLeftCornerFeature.DEALS_BADGE */.ev.DEALS_BADGE
            ],
            topRightCorner: types/* TopRightCornerFeature.ADD_TO_LIST */.I6.ADD_TO_LIST,
            bottomRightCorner: types/* BottomRightCornerFeature.IMAGE_SEARCH */.rq.IMAGE_SEARCH
        },
        trackingClickoutScope: null,
        trackingScope: tracking/* InternalNavigationScope.GRID_LAYOUT_PRODUCT_CARD */.U.GRID_LAYOUT_PRODUCT_CARD,
        type: types/* ProductCardType.IMAGE_SEARCH */.ZX.IMAGE_SEARCH
    };
    return /*#__PURE__*/ react.createElement(product_card_context/* ProductCardStateProvider */.pB, {
        initialState: initialState
    }, /*#__PURE__*/ react.createElement(base_product_card/* BaseProductCard */.k, null));
};

// EXTERNAL MODULE: ./src/components/loader/index.tsx + 1 modules
var loader = __webpack_require__(30082);
// EXTERNAL MODULE: ./src/client/data-layer.ts
var data_layer = __webpack_require__(80695);
;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/bottom-right/image-search/image-search-modal/tracking.ts

var trackImageSearchModalOpened = function(productId, categoryName, imageSearchModels) {
    var eventName = "imageSearchModalOpened";
    var eventData = {
        category: categoryName,
        productId: productId,
        modelIds: imageSearchModels === null || imageSearchModels === void 0 ? void 0 : imageSearchModels.join(",")
    };
    if (!eventData.category) delete eventData.category;
    if (!eventData.modelIds) delete eventData.modelIds;
    (0,data_layer/* pushEvent */.A)(eventName, eventData);
};

// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/index.js
var design_tokens = __webpack_require__(43220);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(71016);
;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/bottom-right/image-search/image-search-modal/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  overflow-x: hidden;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: ",
        ";\n  grid-auto-rows: minmax(0, auto);\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  padding: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var StyledModalBody = (0,styled_components_browser_esm["default"])(modal/* ModalBody */.fe).withConfig({
    displayName: "StyledModalBody",
    componentId: "sc-0-0"
})(_templateObject());
var GridRow = styled_components_browser_esm["default"].div.withConfig({
    displayName: "GridRow",
    componentId: "sc-0-1"
})(_templateObject1(), design_tokens.measurements.spacing100);
var GridItem = styled_components_browser_esm["default"].div.withConfig({
    displayName: "GridItem",
    componentId: "sc-0-2"
})(_templateObject2(), design_tokens.measurements.spacing025);
var StyledNoResultText = (0,styled_components_browser_esm["default"])(variants.H3Text).withConfig({
    displayName: "StyledNoResultText",
    componentId: "sc-0-3"
})(_templateObject3(), design_tokens.measurements.spacing050);
var StyledImage = styled_components_browser_esm["default"].img.withConfig({
    displayName: "StyledImage",
    componentId: "sc-0-4"
})(_templateObject4(), design_tokens.measurements.spacing050, design_tokens.measurements.spacing100, design_tokens.measurements.spacing150);
var StyledNoResultContent = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledNoResultContent",
    componentId: "sc-0-5"
})(_templateObject5());

;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/bottom-right/image-search/image-search-modal/image-search-modal-content.tsx







var ImageSearchModalContent = function(props) {
    var isOpen = props.isOpen, productId = props.productId, categoryName = props.categoryName, imageSearchModels = props.imageSearchModels;
    var ref = (0,app_context/* useAppContext */.bp)(), t = ref.t, market = ref.market;
    var ref1 = useImageSearch({
        productId: productId
    }, isOpen), data = ref1.data, isLoading = ref1.isLoading;
    var products = (data === null || data === void 0 ? void 0 : data.visuallySimilarProducts) || [];
    (0,react.useEffect)(function() {
        if (isOpen) {
            trackImageSearchModalOpened(productId, categoryName, imageSearchModels);
        }
    }, [
        isOpen,
        categoryName,
        productId,
        imageSearchModels
    ]);
    var renderNoResults = /*#__PURE__*/ react.createElement(StyledNoResultContent, null, /*#__PURE__*/ react.createElement(StyledNoResultText, null, t("search", "visually-similar.no-results")), /*#__PURE__*/ react.createElement(StyledImage, {
        src: "".concat(market.cdn, "/g/rfe/illustrations/no-search-result-illustration-309x229px.png"),
        alt: t("product", "results.no-product-found")
    }));
    var hasSearchResults = !isLoading && products.length > 0;
    var hasNoSearchResults = !isLoading && products.length === 0;
    return /*#__PURE__*/ react.createElement(StyledModalBody, null, isLoading && /*#__PURE__*/ react.createElement(loader/* default */.Z, {
        dataTestId: "loading-spinner"
    }), hasSearchResults ? /*#__PURE__*/ react.createElement(GridRow, null, products.map(function(product) {
        return /*#__PURE__*/ react.createElement(GridItem, {
            key: product.productId
        }, /*#__PURE__*/ react.createElement(ImageSearchProductCard, {
            product: product
        }));
    })) : null, hasNoSearchResults && renderNoResults);
};

;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/bottom-right/image-search/image-search-modal/image-search-modal.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}





var ImageSearchModal = function(props) {
    var isOpen = props.isOpen, closeModal = props.closeModal;
    var t = (0,app_context/* useAppContext */.bp)().t;
    return /*#__PURE__*/ react.createElement(modal_v2_modal["default"], {
        isOpen: isOpen,
        title: t("search", "visually-similar.modal-title"),
        size: modal/* ModalSizeEnum.MEDIUM */.E$.MEDIUM,
        onRequestClose: closeModal
    }, /*#__PURE__*/ react.createElement(ImageSearchModalContent, _extends({}, props)));
};

;// CONCATENATED MODULE: ./src/components/product-card/components/top-half/bottom-right/image-search/image-search-modal/index.tsx


;// CONCATENATED MODULE: ./src/components/product-card/contexts/image-search-modal-context.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


var ImageSearchModalContext = /*#__PURE__*/ (0,react.createContext)({
    openModal: undefined
});
var useImageSearchModalContext = function() {
    return (0,react.useContext)(ImageSearchModalContext);
};
var ImageSearchModalProvider = function(param) {
    var children = param.children;
    var ref = _slicedToArray((0,react.useState)(false), 2), showModal = ref[0], setShowModal = ref[1];
    var ref1 = _slicedToArray((0,react.useState)(0), 2), productId = ref1[0], setProductId = ref1[1];
    var ref2 = _slicedToArray((0,react.useState)(undefined), 2), imageSearchModels = ref2[0], setImageSearchModels = ref2[1];
    var ref3 = _slicedToArray((0,react.useState)(undefined), 2), categoryName = ref3[0], setCategoryName = ref3[1];
    var openModal = function(props) {
        setShowModal(true);
        setProductId(props.productId);
        setCategoryName(props.categoryName);
        setImageSearchModels(props.imageSearchModels);
    };
    var value = (0,react.useMemo)(function() {
        return {
            openModal: openModal
        };
    }, []);
    return /*#__PURE__*/ react.createElement(ImageSearchModalContext.Provider, {
        value: value
    }, children, showModal && /*#__PURE__*/ react.createElement(ImageSearchModal, {
        categoryName: categoryName,
        isOpen: showModal,
        productId: productId,
        imageSearchModels: imageSearchModels,
        closeModal: function() {
            return setShowModal(false);
        }
    }));
};


/***/ }),

/***/ 25562:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I$": () => (/* binding */ useProductCardContext),
/* harmony export */   "pB": () => (/* binding */ ProductCardStateProvider)
/* harmony export */ });
/* unused harmony export ProductCardContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73738);
/* harmony import */ var src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58912);



var emptyState = {
    data: {
        product: {
            id: 0,
            productLink: "",
            name: "",
            imageSearchModels: []
        },
        offer: {}
    },
    features: {
        categoryName: false,
        clickoutButton: false,
        deals: false,
        memberPrice: false,
        rating: false,
        salesPrice: false,
        topLeftCorner: [],
        topRightCorner: _types__WEBPACK_IMPORTED_MODULE_1__/* .TopRightCornerFeature.NONE */ .I6.NONE,
        bottomRightCorner: _types__WEBPACK_IMPORTED_MODULE_1__/* .BottomRightCornerFeature.NONE */ .rq.NONE
    },
    trackingClickoutScope: null,
    trackingScope: src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_2__/* .InternalNavigationScope.CAMPAIGN_PRODUCT_CARD */ .U.CAMPAIGN_PRODUCT_CARD,
    type: _types__WEBPACK_IMPORTED_MODULE_1__/* .ProductCardType.DEALS */ .ZX.DEALS
};
var ProductCardContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(emptyState);
var useProductCardContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ProductCardContext);
};
var ProductCardStateProvider = function(param) {
    var children = param.children, initialState = param.initialState;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ProductCardContext.Provider, {
        value: initialState
    }, children);
};


/***/ }),

/***/ 33409:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N8": () => (/* reexport */ DealsProductCard),
  "dK": () => (/* reexport */ PromotionProductCard),
  "Ie": () => (/* reexport */ UsedProductCard)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/product-card/card-types/internal/base-product-card.tsx + 44 modules
var base_product_card = __webpack_require__(74588);
// EXTERNAL MODULE: ./src/components/product-card/mappers/map-product-card.ts
var map_product_card = __webpack_require__(30862);
// EXTERNAL MODULE: ./src/components/product-card/types.ts
var types = __webpack_require__(73738);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(58912);
// EXTERNAL MODULE: ./src/components/product-card/contexts/product-card-context.tsx
var product_card_context = __webpack_require__(25562);
// EXTERNAL MODULE: ./src/client/data-layer.ts
var data_layer = __webpack_require__(80695);
;// CONCATENATED MODULE: ./src/areas/campaign/tracking.js

/**
 * Tracks a click on a campaign item (that is, a product in the campaign).
 * The structure matches the Redux action CAMPAIGN_ITEM_CLICK.
 */ var trackCampaignItemClick = function(item) {
    (0,data_layer/* pushEvent */.A)("campaignItemClick", {
        item: item
    });
};

// EXTERNAL MODULE: ./src/globals/tracking/conversion.ts + 1 modules
var conversion = __webpack_require__(56290);
;// CONCATENATED MODULE: ./src/components/product-card/card-types/deals-product-card.tsx








var DealsProductCard = function(param) {
    var product = param.product, trackingIndex = param.trackingIndex;
    var data = (0,map_product_card/* mapProductCard */.V)({
        product: product
    });
    var initialState = {
        data: data,
        customTracking: {
            onCardClick: function() {
                return sendCampaignItemClick(product);
            }
        },
        features: {
            categoryName: true,
            clickoutButton: true,
            deals: true,
            memberPrice: true,
            rating: true,
            salesPrice: true,
            topLeftCorner: [
                types/* TopLeftCornerFeature.DEALS_BADGE */.ev.DEALS_BADGE
            ],
            topRightCorner: types/* TopRightCornerFeature.DROPDOWN */.I6.DROPDOWN,
            bottomRightCorner: types/* BottomRightCornerFeature.NONE */.rq.NONE
        },
        trackingClickoutScope: conversion/* TrackClickScope.CAMPAIGN_LIST_ITEM */.b8.CAMPAIGN_LIST_ITEM,
        trackingIndex: trackingIndex,
        trackingScope: tracking/* InternalNavigationScope.CAMPAIGN_PRODUCT_CARD */.U.CAMPAIGN_PRODUCT_CARD,
        type: types/* ProductCardType.DEALS */.ZX.DEALS
    };
    return /*#__PURE__*/ react.createElement(product_card_context/* ProductCardStateProvider */.pB, {
        initialState: initialState
    }, /*#__PURE__*/ react.createElement(base_product_card/* BaseProductCard */.k, null));
};
var sendCampaignItemClick = function(product) {
    trackCampaignItemClick({
        external_uri: product.bestOffer.offerLink,
        price: product.bestOffer.price,
        product: product,
        store: {
            featured: product.bestOffer.featured,
            id: product.bestOffer.storeId,
            name: product.bestOffer.storeName
        }
    });
};

;// CONCATENATED MODULE: ./src/components/product-card/card-types/used-product-card.tsx







var UsedProductCard = function(param) {
    var product = param.product, customTracking = param.customTracking, trackingIndex = param.trackingIndex;
    var data = (0,map_product_card/* mapProductCard */.V)({
        product: product
    });
    var initialState = {
        data: data,
        customTracking: customTracking,
        features: {
            categoryName: true,
            clickoutButton: true,
            deals: false,
            memberPrice: true,
            rating: true,
            salesPrice: false,
            topLeftCorner: [
                types/* TopLeftCornerFeature.USED_BADGE */.ev.USED_BADGE
            ],
            topRightCorner: types/* TopRightCornerFeature.ADD_TO_LIST */.I6.ADD_TO_LIST,
            bottomRightCorner: types/* BottomRightCornerFeature.NONE */.rq.NONE
        },
        trackingClickoutScope: conversion/* TrackClickScope.USED_PRODUCT_CARD */.b8.USED_PRODUCT_CARD,
        trackingIndex: trackingIndex,
        trackingScope: tracking/* InternalNavigationScope.USED_PRODUCT */.U.USED_PRODUCT,
        type: types/* ProductCardType.USED */.ZX.USED
    };
    return /*#__PURE__*/ react.createElement(product_card_context/* ProductCardStateProvider */.pB, {
        initialState: initialState
    }, /*#__PURE__*/ react.createElement(base_product_card/* BaseProductCard */.k, null));
};

;// CONCATENATED MODULE: ./src/components/product-card/mappers/map-promotion-owner.ts
var mapPromotionOwner = function(param) {
    var product = param.product, promotionOwner = param.promotionOwner;
    if (!promotionOwner || !product.promotionShopPrices.length) return undefined;
    var promotionShopPrice = product.promotionShopPrices.find(function(shop) {
        return shop;
    });
    if (!promotionShopPrice) return undefined;
    return {
        name: promotionOwner.name,
        price: promotionShopPrice.price
    };
};

;// CONCATENATED MODULE: ./src/components/product-card/card-types/promotion-product-card.tsx








var PromotionProductCard = function(param) {
    var product = param.product, customTracking = param.customTracking, trackingIndex = param.trackingIndex, promotionOwner = param.promotionOwner;
    var data = (0,map_product_card/* mapProductCard */.V)({
        product: product
    });
    var initialState = {
        data: data,
        customTracking: customTracking,
        features: {
            categoryName: true,
            clickoutButton: false,
            deals: false,
            memberPrice: false,
            rating: true,
            salesPrice: false,
            topLeftCorner: [],
            topRightCorner: types/* TopRightCornerFeature.ADD_TO_LIST */.I6.ADD_TO_LIST,
            bottomRightCorner: types/* BottomRightCornerFeature.NONE */.rq.NONE
        },
        promotionOwnerData: mapPromotionOwner({
            product: product,
            promotionOwner: promotionOwner
        }),
        trackingClickoutScope: conversion/* TrackClickScope.PROMOTION_PRODUCT_CARD */.b8.PROMOTION_PRODUCT_CARD,
        trackingIndex: trackingIndex,
        trackingScope: tracking/* InternalNavigationScope.PROMOTION_PRODUCT */.U.PROMOTION_PRODUCT,
        type: types/* ProductCardType.PROMOTION_PRODUCT */.ZX.PROMOTION_PRODUCT
    };
    return /*#__PURE__*/ react.createElement(product_card_context/* ProductCardStateProvider */.pB, {
        initialState: initialState
    }, /*#__PURE__*/ react.createElement(base_product_card/* BaseProductCard */.k, null));
};

;// CONCATENATED MODULE: ./src/components/product-card/index.ts


 // Note: DO NOT export card-types/internal/BaseProductCard.


/***/ }),

/***/ 30862:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": () => (/* binding */ mapProductCard)
/* harmony export */ });
var mapProductCard = function(param) {
    var product = param.product;
    var aggregatedRating = product.aggregatedRating, parentCategoryIds = product.parentCategoryIds, categoryName = product.categoryName, logo = product.logo, name = product.name, priceDrop = product.priceDrop, productId = product.productId, storeCount = product.storeCount, productLink = product.productLink, imageSearchModels = product.imageSearchModels;
    var _bestOffer = product.bestOffer, condition = _bestOffer.condition, offerFeatured = _bestOffer.featured, membershipRequiresCompensation = _bestOffer.membershipRequiresCompensation, memberPrice = _bestOffer.memberPrice, offerLink = _bestOffer.offerLink, originalPrice = _bestOffer.originalPrice, price = _bestOffer.price, priceExpires = _bestOffer.priceExpires, priceId = _bestOffer.priceId, shopOfferId = _bestOffer.shopOfferId, stockStatus = _bestOffer.stockStatus, storeId = _bestOffer.storeId, storeName = _bestOffer.storeName;
    var featured = offerFeatured && Boolean(offerLink);
    var result = {
        offer: {
            condition: condition !== null && condition !== void 0 ? condition : "new",
            featured: featured,
            memberPrice: memberPrice !== null && memberPrice !== void 0 ? memberPrice : undefined,
            membershipRequiresCompensation: membershipRequiresCompensation !== null && membershipRequiresCompensation !== void 0 ? membershipRequiresCompensation : false,
            offerLink: offerLink,
            originalPrice: originalPrice !== null && originalPrice !== void 0 ? originalPrice : undefined,
            price: price,
            priceExpires: priceExpires !== null && priceExpires !== void 0 ? priceExpires : undefined,
            priceId: priceId,
            shopOfferId: shopOfferId,
            stockStatus: stockStatus,
            storeId: storeId,
            storeName: storeName
        },
        product: {
            rating: aggregatedRating !== null && aggregatedRating !== void 0 ? aggregatedRating : undefined,
            category: {
                hierarchicalCategoryIds: parentCategoryIds !== null && parentCategoryIds !== void 0 ? parentCategoryIds : undefined,
                categoryName: categoryName
            },
            logo: logo !== null && logo !== void 0 ? logo : undefined,
            priceDrop: priceDrop !== null && priceDrop !== void 0 ? priceDrop : undefined,
            id: productId,
            imageSearchModels: imageSearchModels,
            productLink: productLink,
            name: name,
            storeCount: storeCount
        }
    };
    return result;
};


/***/ }),

/***/ 73738:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I6": () => (/* binding */ TopRightCornerFeature),
/* harmony export */   "ZX": () => (/* binding */ ProductCardType),
/* harmony export */   "ev": () => (/* binding */ TopLeftCornerFeature),
/* harmony export */   "rq": () => (/* binding */ BottomRightCornerFeature)
/* harmony export */ });
var TopLeftCornerFeature;
(function(TopLeftCornerFeature) {
    TopLeftCornerFeature["DEALS_BADGE"] = "DEALS_BADGE";
    TopLeftCornerFeature["USED_BADGE"] = "USED_BADGE";
    TopLeftCornerFeature["POTY_BADGE"] = "POTY_BADGE";
    TopLeftCornerFeature["TOP_RATED_BADGE"] = "TOP_RATED_BADGE";
})(TopLeftCornerFeature || (TopLeftCornerFeature = {}));
var TopRightCornerFeature;
(function(TopRightCornerFeature) {
    TopRightCornerFeature["NONE"] = "NONE";
    TopRightCornerFeature["ADD_TO_LIST"] = "ADD_TO_LIST";
    TopRightCornerFeature["DROPDOWN"] = "DROPDOWN";
})(TopRightCornerFeature || (TopRightCornerFeature = {}));
var BottomRightCornerFeature;
(function(BottomRightCornerFeature) {
    BottomRightCornerFeature["NONE"] = "NONE";
    BottomRightCornerFeature["IMAGE_SEARCH"] = "IMAGE_SEARCH";
})(BottomRightCornerFeature || (BottomRightCornerFeature = {}));
var ProductCardType;
(function(ProductCardType) {
    ProductCardType["DEALS"] = "DEALS";
    ProductCardType["RAW_OFFER"] = "RAW_OFFER";
    ProductCardType["USED"] = "USED";
    ProductCardType["PROMOTION_PRODUCT"] = "PROMOTION_PRODUCT";
    ProductCardType["SEARCH_RESULT"] = "SEARCH_RESULT";
    ProductCardType["IMAGE_SEARCH"] = "IMAGE_SEARCH";
})(ProductCardType || (ProductCardType = {}));


/***/ }),

/***/ 87044:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": () => (/* binding */ ProductImage)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71993);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18026);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  opacity: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Image = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].img.withConfig({
    displayName: "Image",
    componentId: "sc-0-0"
})(_templateObject(), function(p) {
    return p.$fallback ? 0.2 : 1;
});
var ProductImage = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(function(param) {
    var fallback = param.fallback, src = param.src, name = param.name, className = param.className, height = param.height, width = param.width;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_2__/* .AppContext */ .Il), _market = ref.market, market = _market === void 0 ? {
        cdn: "https://cdn.pji.nu"
    } : _market;
    var fallbackImage = fallback && !/^https?:\/\//.test(fallback) ? market.cdn + fallback : fallback;
    var productImage = src || fallbackImage || "".concat(market.cdn, "/product/standard/280/0.jpg");
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Image, {
        src: productImage,
        alt: name || "",
        className: className,
        height: height,
        width: width,
        $fallback: Boolean(!src && fallback)
    });
});


/***/ }),

/***/ 78060:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": () => (/* binding */ useGetProductOfTheYear)
/* harmony export */ });
/* unused harmony export useProductOfTheYearAwards */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18026);


/**
 * Retrive Product of the Year awards
 *
 * @param {number} [year] Year to retrive awards from. If omitted retrive all years
 * @returns Array of ProductOfTheYearAward, sorted by year
 */ var useProductOfTheYearAwards = function(year) {
    var productOfTheYear = (0,src_components_app_context__WEBPACK_IMPORTED_MODULE_1__/* .useAppContext */ .bp)().productOfTheYear;
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return productOfTheYear.filter(function(award) {
            return year ? year === (award === null || award === void 0 ? void 0 : award.year) : true;
        }).map(function(award) {
            return {
                awardName: award.awardName,
                awardLogo: award.awardLogo,
                year: award.year,
                productId: award.product.id
            };
        }).sort(function(a, b) {
            return a.year - b.year;
        });
    }, [
        productOfTheYear,
        year
    ]);
};
/**
 * Check if product has Product of the Year award
 *
 * @param {(string | number)} [productId]
 * @returns IsProductOfTheYear object. Latest year if several awards are present. If no award then false is returned.
 */ var useGetProductOfTheYear = function(productId) {
    var productOfTheYearAwards = useProductOfTheYearAwards();
    if (!productId) return undefined;
    var thisProductOfTheYearAwards = productOfTheYearAwards.filter(function(award) {
        return "".concat(productId) === "".concat(award.productId);
    });
    if (thisProductOfTheYearAwards.length === 0) return undefined;
    var latestAward = thisProductOfTheYearAwards.pop();
    return latestAward;
};


/***/ }),

/***/ 9160:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ rating)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./src/ui/icons/index.ts + 4 modules
var icons = __webpack_require__(92356);
// EXTERNAL MODULE: ./src/components/rating/rating-helper.ts
var rating_helper = __webpack_require__(46626);
;// CONCATENATED MODULE: ./src/components/rating/constants.ts
var STAR_ICON_SIZE_SMALL = 12;
var STAR_ICON_SIZE_MEDIUM = 16;
var STAR_ICON_SIZE_LARGE = 18;
var STAR_ICON_SIZE_XL = 28;

// EXTERNAL MODULE: ./src/components/rating/styles.ts
var styles = __webpack_require__(31848);
;// CONCATENATED MODULE: ./src/components/rating/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}






var Rating = function(param) {
    var className = param.className, _interactive = param.interactive, interactive = _interactive === void 0 ? false : _interactive, _size = param.size, size = _size === void 0 ? "medium" : _size, _hide = param.hide, hide = _hide === void 0 ? false : _hide, _count = param.count, count = _count === void 0 ? 0 : _count, _counterPosition = param.counterPosition, counterPosition = _counterPosition === void 0 ? "right" : _counterPosition, dataTestid = param.dataTestid, _showCounter = param.showCounter, showCounter = _showCounter === void 0 ? true : _showCounter, _showCounterAs = param.showCounterAs, showCounterAs = _showCounterAs === void 0 ? "text" : _showCounterAs, _counterLimit = param.counterLimit, counterLimit = _counterLimit === void 0 ? 500 : _counterLimit, _countTranslation = param.countTranslation, countTranslation = _countTranslation === void 0 ? {
        domain: "reviews",
        key: "rating.n-reviews"
    } : _countTranslation, _rate = param.rate, rate = _rate === void 0 ? 0 : _rate, _nrOfDecimals = param.nrOfDecimals, nrOfDecimals = _nrOfDecimals === void 0 ? 1 : _nrOfDecimals, onChange = param.onChange, _singleStar = param.singleStar, singleStar = _singleStar === void 0 ? false : _singleStar, _centerAlign = param.centerAlign, centerAlign = _centerAlign === void 0 ? false : _centerAlign, _showRate = param.showRate, showRate = _showRate === void 0 ? false : _showRate, _showRateAs = param.showRateAs, showRateAs = _showRateAs === void 0 ? "number" : _showRateAs, _secondaryColors = param.secondaryColors, secondaryColors = _secondaryColors === void 0 ? false : _secondaryColors, _expertColors = param.expertColors, expertColors = _expertColors === void 0 ? false : _expertColors, styleCounterAsLink = param.styleCounterAsLink;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    if (hide) return null;
    var starCount = singleStar ? 1 : 5;
    var stars = _toConsumableArray(new Array(starCount)).map(function(_, i) {
        return i + 1;
    });
    var rating = rating_helper/* default.convert */.Z.convert(rate !== null && rate !== void 0 ? rate : 0, nrOfDecimals);
    var halfStar = rating.half !== rating.whole;
    var starSize;
    switch(size){
        case "xl":
            starSize = STAR_ICON_SIZE_XL;
            break;
        case "large":
            starSize = STAR_ICON_SIZE_LARGE;
            break;
        case "medium":
            starSize = STAR_ICON_SIZE_MEDIUM;
            break;
        case "small":
            starSize = STAR_ICON_SIZE_SMALL;
            break;
        default:
            break;
    }
    var getCounterText = function() {
        if (count === null) {
            return null;
        }
        var hasExceededLimit = count !== 0 && count > counterLimit;
        if (showCounterAs === "number") {
            return hasExceededLimit ? "".concat(counterLimit, "+") : count;
        }
        var countTranslationKey = hasExceededLimit ? "".concat(countTranslation.key, "-limited") : countTranslation.key;
        var maybeLimitedCount = hasExceededLimit ? counterLimit : count;
        return t(countTranslation.domain, countTranslationKey, {
            n: maybeLimitedCount,
            count: maybeLimitedCount
        });
    };
    if (interactive) return /*#__PURE__*/ react.createElement(InteractiveRating, {
        stars: stars,
        size: size,
        onChange: onChange,
        rate: rate
    });
    return /*#__PURE__*/ react.createElement(styles/* Rating */.iG, {
        className: className,
        centerAlign: centerAlign,
        "aria-label": t("reviews", "rating.rate-n-text-version", {
            n: rating.rounded
        }),
        "data-testid": dataTestid
    }, /*#__PURE__*/ react.createElement(styles/* StarsWrapper */.gL, {
        counterPosition: counterPosition
    }, /*#__PURE__*/ react.createElement(styles/* StarIcons */.Ob, {
        secondaryColors: secondaryColors,
        expertColors: expertColors,
        halfStar: halfStar,
        stars: stars,
        rating: rating,
        size: starSize
    }), showRate && rating.whole > 0 && // eslint-disable-next-line react/jsx-no-useless-fragment
    /*#__PURE__*/ react.createElement(react.Fragment, null, showRateAs === "text" ? /*#__PURE__*/ react.createElement(styles/* RateText */.eP, {
        size: size
    }, t("reviews", "rating.rate-n-text-version.md", {
        n: rating.rounded
    })) : /*#__PURE__*/ react.createElement(styles/* RateNumber */.xe, {
        size: size
    }, rating.rounded))), showCounter && count !== null && count > 0 && /*#__PURE__*/ react.createElement(styles/* CounterWrapper */.nU, null, "(", /*#__PURE__*/ react.createElement(styles/* Counter */.AT, {
        size: size,
        counterPosition: counterPosition,
        $linkStyles: styleCounterAsLink
    }, getCounterText()), ")"));
};
var InteractiveRating = function(param) {
    var stars = param.stars, size = param.size, rate = param.rate, onChange = param.onChange;
    var ref = _slicedToArray((0,react.useState)(0), 2), selectedRating = ref[0], setSelectedRating = ref[1];
    var handleChange = function(rating, e) {
        if (onChange) {
            onChange(rating * 2, e);
        }
        setSelectedRating(rating);
    };
    var reverseStars = (0,react.useMemo)(function() {
        return stars.reverse();
    }, [
        stars
    ]);
    // Uses a css technique to fills every star on the left side of selected radio button, in this labels
    // are floated to the right. To emit correct values i.e. first star emits 1 and so forth,
    // the map of rate values is reversed.
    return /*#__PURE__*/ react.createElement(styles/* Rating */.iG, null, /*#__PURE__*/ react.createElement(styles/* Fieldset */.pg, null, reverseStars.map(function(current) {
        return /*#__PURE__*/ react.createElement(react.Fragment, {
            key: current
        }, /*#__PURE__*/ react.createElement("input", {
            name: "rating",
            id: "rate-input-".concat(current),
            checked: selectedRating > 0 ? current === selectedRating : current === rating_helper/* default.toWhole */.Z.toWhole(rate !== null && rate !== void 0 ? rate : 0),
            onChange: function(e) {
                return handleChange(current, e);
            },
            value: current * 2,
            type: "radio"
        }), /*#__PURE__*/ react.createElement("label", {
            htmlFor: "rate-input-".concat(current)
        }, /*#__PURE__*/ react.createElement(icons/* StarIcon */.r7, {
            height: size === "medium" ? 16 : 12
        })));
    })));
};
/* harmony default export */ const rating = (Rating);


/***/ }),

/***/ 46626:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var RatingHelper = /*#__PURE__*/ function() {
    "use strict";
    function RatingHelper() {
        _classCallCheck(this, RatingHelper);
    }
    RatingHelper.toRounded = function toRounded(rating) {
        var nrOfDecimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        return parseFloat(rating.toFixed(nrOfDecimals));
    };
    RatingHelper.toRoundedString = function toRoundedString(rating) {
        var nrOfDecimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        return rating.toFixed(nrOfDecimals);
    };
    RatingHelper.toHalf = function toHalf(rating) {
        return Math.ceil(RatingHelper.toRounded(rating) * 2) / 2;
    };
    RatingHelper.toWhole = function toWhole(rating) {
        return Math.ceil(RatingHelper.toRounded(rating));
    };
    RatingHelper.convert = function convert(rating) {
        var nrOfDecimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        return {
            real: rating,
            rounded: RatingHelper.toRounded(rating, nrOfDecimals),
            roundedString: RatingHelper.toRoundedString(rating, nrOfDecimals),
            half: RatingHelper.toHalf(rating),
            whole: RatingHelper.toWhole(rating)
        };
    };
    return RatingHelper;
}();
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (RatingHelper);


/***/ }),

/***/ 58239:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ smiley_rating)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./src/components/rating/smiley-rating/rating-icon/index.tsx + 1 modules
var rating_icon = __webpack_require__(6511);
// EXTERNAL MODULE: ./src/components/rating/smiley-rating/utils.ts
var utils = __webpack_require__(1013);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
;// CONCATENATED MODULE: ./src/components/rating/smiley-rating/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      &::after {\n        content: attr(data-rating);\n        position: absolute;\n        bottom: -8px;\n        left: 50%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        width: 22px;\n        height: 13px;\n        border-radius: 8px;\n        font-size: 10px;\n        font-weight: 600;\n        font-stretch: normal;\n        font-style: normal;\n        line-height: normal;\n        letter-spacing: normal;\n        text-align: center;\n        background: ",
        ";\n        color: ",
        ";\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n          font-size: ",
        ";\n        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      &::after {\n        content: attr(data-rating);\n        display: inline;\n        line-height: 1.4;\n        font-size: ",
        ";\n        margin-left: ",
        ";\n        color: ",
        ";\n\n        ",
        "\n      }\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    align-items: center;\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    margin: 0 0 0 ",
        ";\n    font-size: ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var IconWrapper = styled_components_browser_esm["default"].div.attrs({
    "data-test": "Rating"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject3(), props.scoreVisibility === "compact" && (0,styled_components_browser_esm.css)(_templateObject(), props.theme.ratings.disabled.bg, props.theme.ratings.disabled.fg), props.scoreVisibility === "row" && (0,styled_components_browser_esm.css)(_templateObject2(), base/* layout.measurements.fontSizeNormal */.bK.measurements.fontSizeNormal, base/* layout.measurements.spacing025 */.bK.measurements.spacing025, function(p) {
        return p.theme.text.secondary;
    }, props.size === "small" && (0,styled_components_browser_esm.css)(_templateObject1(), base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall)));
});
var RatingSmiley = styled_components_browser_esm["default"].div.withConfig({
    displayName: "RatingSmiley",
    componentId: "sc-0-0"
})(_templateObject4());
var RatingCount = styled_components_browser_esm["default"].p.withConfig({
    displayName: "RatingCount",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject5(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall, props.theme.text.quaternary);
});

;// CONCATENATED MODULE: ./src/components/rating/smiley-rating/index.tsx





var smiley_rating_RatingSmiley = function(param) {
    var featured = param.featured, rating = param.rating, reviewCount = param.reviewCount, scoreVisibility = param.scoreVisibility, _size = param.size, size = _size === void 0 ? "normal" : _size, className = param.className;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var iconSize = size === "small" ? 17 : 20;
    var smileyRating = (0,utils/* getSmileyRating */.P)(rating.rounded);
    var label = t("reviews", "rating.rate-n-text-version", {
        n: rating.roundedString
    });
    if (!smileyRating) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(RatingSmiley, {
        className: className
    }, smileyRating.iconType ? /*#__PURE__*/ react.createElement(IconWrapper, {
        "aria-label": label,
        "data-rating": rating.roundedString,
        scoreVisibility: scoreVisibility,
        size: size
    }, /*#__PURE__*/ react.createElement(rating_icon/* default */.Z, {
        type: smileyRating.iconType,
        disabled: !featured,
        size: iconSize,
        ariaLabel: label
    })) : null, reviewCount && /*#__PURE__*/ react.createElement(RatingCount, null, "(".concat(reviewCount > 500 ? "500+" : reviewCount, ")")));
};
/* harmony default export */ const smiley_rating = (smiley_rating_RatingSmiley);


/***/ }),

/***/ 6511:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ rating_icon)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/rating/smiley-rating/types.ts
var types = __webpack_require__(83986);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/ui/icons/index.ts + 4 modules
var icons = __webpack_require__(92356);
;// CONCATENATED MODULE: ./src/components/rating/smiley-rating/rating-icon/styles.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  border-radius: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      background: ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        ";\n    background: ",
        ";\n\n    ",
        "\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      background: ",
        ";\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        ";\n    background: ",
        ";\n\n    ",
        "\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n      background: ",
        ";\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        ";\n    background: ",
        ";\n\n    ",
        "\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      background: ",
        ";\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        ";\n    background: ",
        ";\n\n    ",
        "\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n      background: ",
        ";\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        ";\n    background: ",
        ";\n\n    ",
        "\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}


var sharedStyles = (0,styled_components_browser_esm.css)(_templateObject(), function(p) {
    return p.size && p.size >= 48 ? "8px" : "4px";
});
var Angry = (0,styled_components_browser_esm["default"])(icons/* EmoticonAngry */.Sd).attrs(function(props) {
    return _objectSpreadProps(_objectSpread({}, props), {
        color: props.disabled ? props.theme.ratings.disabled.fg : props.theme.ratings.negative.fg,
        size: props.size || 21
    });
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject2(), sharedStyles, props.theme.ratings.negative.bg, props.disabled && (0,styled_components_browser_esm.css)(_templateObject1(), props.theme.ratings.disabled.bg));
});
var Dissatisfied = (0,styled_components_browser_esm["default"])(icons/* EmoticonDissatisfied */._z).attrs(function(props) {
    return _objectSpreadProps(_objectSpread({}, props), {
        color: props.disabled ? props.theme.ratings.disabled.fg : props.theme.ratings.negative.fg,
        size: props.size || 21
    });
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject4(), sharedStyles, props.theme.ratings.negative.bg, props.disabled && (0,styled_components_browser_esm.css)(_templateObject3(), props.theme.ratings.disabled.bg));
});
var Neutral = (0,styled_components_browser_esm["default"])(icons/* EmoticonNeutral */.sS).attrs(function(props) {
    return _objectSpreadProps(_objectSpread({}, props), {
        color: props.disabled ? props.theme.ratings.disabled.fg : props.theme.ratings.neutral.fg,
        size: props.size || 21
    });
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject6(), sharedStyles, props.theme.ratings.neutral.bg, props.disabled && (0,styled_components_browser_esm.css)(_templateObject5(), props.theme.ratings.disabled.bg));
});
var Smiling = (0,styled_components_browser_esm["default"])(icons/* EmoticonSmiling */.wr).attrs(function(props) {
    return _objectSpreadProps(_objectSpread({}, props), {
        color: props.disabled ? props.theme.ratings.disabled.fg : props.theme.ratings.positive.fg,
        size: props.size || 21
    });
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject8(), sharedStyles, props.theme.ratings.positive.bg, props.disabled && (0,styled_components_browser_esm.css)(_templateObject7(), props.theme.ratings.disabled.bg));
});
var Laughing = (0,styled_components_browser_esm["default"])(icons/* EmoticonLaughing */.X3).attrs(function(props) {
    return _objectSpreadProps(_objectSpread({}, props), {
        color: props.disabled ? props.theme.ratings.disabled.fg : props.theme.ratings.positive.fg,
        size: props.size || 21
    });
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject10(), sharedStyles, props.theme.ratings.positive.bg, props.disabled && (0,styled_components_browser_esm.css)(_templateObject9(), props.theme.ratings.disabled.bg));
});

;// CONCATENATED MODULE: ./src/components/rating/smiley-rating/rating-icon/index.tsx



var RatingIcon = function(param) {
    var disabled = param.disabled, size = param.size, type = param.type, ariaLabel = param.ariaLabel;
    switch(type){
        case types/* SmileyType.ANGRY */.P.ANGRY:
            return /*#__PURE__*/ react.createElement(Angry, {
                disabled: disabled,
                size: size,
                ariaLabel: ariaLabel
            });
        case types/* SmileyType.DISSATISFIED */.P.DISSATISFIED:
            return /*#__PURE__*/ react.createElement(Dissatisfied, {
                disabled: disabled,
                size: size,
                ariaLabel: ariaLabel
            });
        case types/* SmileyType.NEUTRAL */.P.NEUTRAL:
            return /*#__PURE__*/ react.createElement(Neutral, {
                disabled: disabled,
                size: size,
                ariaLabel: ariaLabel
            });
        case types/* SmileyType.SMILING */.P.SMILING:
            return /*#__PURE__*/ react.createElement(Smiling, {
                disabled: disabled,
                size: size,
                ariaLabel: ariaLabel
            });
        case types/* SmileyType.LAUGHING */.P.LAUGHING:
            return /*#__PURE__*/ react.createElement(Laughing, {
                disabled: disabled,
                size: size,
                ariaLabel: ariaLabel
            });
        default:
            return null;
    }
};
/* harmony default export */ const rating_icon = (RatingIcon);


/***/ }),

/***/ 83986:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": () => (/* binding */ SmileyType),
/* harmony export */   "S": () => (/* binding */ RatingString)
/* harmony export */ });
var SmileyType;
(function(SmileyType) {
    SmileyType["ANGRY"] = "smiley-angry";
    SmileyType["DISSATISFIED"] = "smiley-dissatisfied";
    SmileyType["NEUTRAL"] = "smiley-neutral";
    SmileyType["SMILING"] = "smiley-smiling";
    SmileyType["LAUGHING"] = "smiley-laughing";
})(SmileyType || (SmileyType = {}));
var RatingString;
(function(RatingString) {
    RatingString["terrible"] = "rating.terrible";
    RatingString["bad"] = "rating.bad";
    RatingString["ok"] = "rating.ok";
    RatingString["good"] = "rating.good";
    RatingString["excellent"] = "rating.excellent";
})(RatingString || (RatingString = {}));


/***/ }),

/***/ 1013:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": () => (/* binding */ getSmileyRating)
/* harmony export */ });
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83986);

var getSmileyRating = function(rating) {
    if (rating <= 1) {
        return {
            iconType: _types__WEBPACK_IMPORTED_MODULE_0__/* .SmileyType.ANGRY */ .P.ANGRY,
            text: _types__WEBPACK_IMPORTED_MODULE_0__/* .RatingString.terrible */ .S.terrible
        };
    }
    if (rating <= 2) {
        return {
            iconType: _types__WEBPACK_IMPORTED_MODULE_0__/* .SmileyType.DISSATISFIED */ .P.DISSATISFIED,
            text: _types__WEBPACK_IMPORTED_MODULE_0__/* .RatingString.bad */ .S.bad
        };
    }
    if (rating <= 3) {
        return {
            iconType: _types__WEBPACK_IMPORTED_MODULE_0__/* .SmileyType.NEUTRAL */ .P.NEUTRAL,
            text: _types__WEBPACK_IMPORTED_MODULE_0__/* .RatingString.ok */ .S.ok
        };
    }
    if (rating <= 4) {
        return {
            iconType: _types__WEBPACK_IMPORTED_MODULE_0__/* .SmileyType.SMILING */ .P.SMILING,
            text: _types__WEBPACK_IMPORTED_MODULE_0__/* .RatingString.good */ .S.good
        };
    }
    if (rating > 4) {
        return {
            iconType: _types__WEBPACK_IMPORTED_MODULE_0__/* .SmileyType.LAUGHING */ .P.LAUGHING,
            text: _types__WEBPACK_IMPORTED_MODULE_0__/* .RatingString.excellent */ .S.excellent
        };
    }
    return null;
};


/***/ }),

/***/ 89602:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18026);


var StarIcons = function(param) {
    var _size = param.size, size = _size === void 0 ? 16 : _size, stars = param.stars, rating = param.rating, secondaryColors = param.secondaryColors, expertColors = param.expertColors, halfStar = param.halfStar, className = param.className;
    var market = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_1__/* .AppContext */ .Il).market;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        style: {
            width: (size + 1) * stars.length,
            lineHeight: 0
        },
        className: className
    }, stars.map(function(star) {
        var cdn = market && market.cdn ? market.cdn : "https://cdn.pji.nu";
        var file = "empty-new";
        var alt = "Empty Star";
        if (halfStar && rating.whole === star) {
            // Half stars
            if (secondaryColors) {
                file = "alt-half";
                alt = "Half Star";
            } else if (expertColors) {
                file = "expert-half-new";
                alt = "Half Star";
            } else {
                file = "primary-half-new";
                alt = "Half Star";
            }
        } else if (rating.whole >= star) {
            if (secondaryColors) {
                file = "alt-full";
                alt = "Full Star";
            } else if (expertColors) {
                file = "expert-full-new";
                alt = "Full Star";
            } else {
                file = "primary-full-new";
                alt = "Full Star";
            }
        }
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
            key: "star-".concat(star),
            style: {
                width: size,
                height: size,
                marginRight: "1px"
            },
            src: "".concat(cdn, "/g/rfe/icons/stars/").concat(file, ".svg"),
            alt: "".concat(alt, " ").concat(star)
        });
    }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(StarIcons));


/***/ }),

/***/ 31848:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AT": () => (/* binding */ Counter),
/* harmony export */   "Ob": () => (/* binding */ StarIcons),
/* harmony export */   "eP": () => (/* binding */ RateText),
/* harmony export */   "gL": () => (/* binding */ StarsWrapper),
/* harmony export */   "iG": () => (/* binding */ Rating),
/* harmony export */   "nU": () => (/* binding */ CounterWrapper),
/* harmony export */   "pg": () => (/* binding */ Fieldset),
/* harmony export */   "xe": () => (/* binding */ RateNumber)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71993);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61093);
/* harmony import */ var _star_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89602);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  line-height: 1.4;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  line-height: 1.4;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline;\n  line-height: 1.2;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      text-decoration: underline;\n      &:hover {\n        color: ",
        ";\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        ";\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        ";\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      color: ",
        ";\n      position: relative;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n      padding-left: 0;\n      display: block;\n      width: 100%;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n    margin: 0;\n    line-height: 1.2;\n\n    ",
        "\n\n    ",
        "\n\n      ",
        "\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n      justify-content: center;\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n      display: flex;\n    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n    align-items: center;\n    gap: ",
        ";\n\n    ",
        "\n  "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        ";\n    "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        ";\n    "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n    font-weight: normal;\n    ",
        ";\n\n    p {\n      margin-bottom: 0;\n    }\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        ";\n    "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        ";\n    "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        ";\n    font-weight: bold;\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n  float: left;\n  padding: 0;\n  margin: 0;\n  border: none;\n  /* Float right to be able to use sibling selector (~) on hover\n  to be able to fill all previous icons with correct direction */\n  > label {\n    float: right;\n    cursor: pointer;\n  }\n\n  > input {\n    display: none;\n  }\n\n  /* highlight current and previous icons when checked */\n  > input:checked ~ label {\n    svg path {\n      fill: ",
        ";\n    }\n  }\n\n  &:not(:checked) > label:hover, /* highlight current icon on hover */\n      &:not(:checked) > label:hover ~ label, /* highlight previous icons on hover */\n      > input:checked + label:hover, /* highlight current icon on change */\n      > input:checked ~ label:hover,\n      > input:checked ~ label:hover ~ label {\n    svg path {\n      fill: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}



var sharedStyleSizeSmall = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject(), (0,src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .remCalc */ .vR)(12));
var sharedStyleSizeLarge = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject1(), (0,src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .remCalc */ .vR)(16));
var sharedStylesRateText = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject2());
var CounterWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "CounterWrapper",
    componentId: "sc-0-0"
})(_templateObject3(), function(p) {
    return p.theme.colors.base500;
});
var Counter = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({
    displayName: "Counter",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject9(), props.$linkStyles && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject4(), function(p) {
        return p.theme.text.callToActionHover;
    }), props.size === "small" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject5(), sharedStyleSizeSmall), props.size === "large" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject6(), sharedStyleSizeLarge), props.counterPosition === "right" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject7(), function(p) {
        return p.theme.text.tertiary;
    }), props.counterPosition === "bottom" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject8()));
});
var Rating = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.attrs({
    "data-test": "Rating"
}).withConfig({
    displayName: "Rating",
    componentId: "sc-0-2"
})(_templateObject11(), (0,src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .remCalc */ .vR)(2), function(props) {
    return props.centerAlign && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject10());
});
var StarsWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "StarsWrapper",
    componentId: "sc-0-3"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject13(), (0,src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .remCalc */ .vR)(4), props.counterPosition === "right" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject12()));
});
var StarIcons = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_star_icons__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    displayName: "StarIcons",
    componentId: "sc-0-4"
})(_templateObject14());
var RateText = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({
    displayName: "RateText",
    componentId: "sc-0-5"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject17(), sharedStylesRateText, props.size === "small" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject15(), sharedStyleSizeSmall), props.size === "large" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject16(), sharedStyleSizeLarge));
});
var RateNumber = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({
    displayName: "RateNumber",
    componentId: "sc-0-6"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject20(), sharedStylesRateText, props.size === "small" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject18(), sharedStyleSizeSmall), props.size === "large" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject19(), sharedStyleSizeLarge));
});
var Fieldset = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].fieldset.withConfig({
    displayName: "Fieldset",
    componentId: "sc-0-7"
})(_templateObject21(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .ratingStarColors.active */ .m4.active, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .ratingStarColors.active */ .m4.active);


/***/ }),

/***/ 35527:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bx": () => (/* binding */ LOAD_RECENTLY_VISITED),
/* harmony export */   "NU": () => (/* binding */ removeRecentlyVisitedItem),
/* harmony export */   "QN": () => (/* binding */ REMOVE_RECENTLY_VISITED_ITEM),
/* harmony export */   "e_": () => (/* binding */ loadRecentlyVisited)
/* harmony export */ });
var REMOVE_RECENTLY_VISITED_ITEM = "REMOVE_RECENTLY_VISITED_ITEM";
var LOAD_RECENTLY_VISITED = "LOAD_RECENTLY_VISITED";
var removeRecentlyVisitedItem = function(id) {
    return {
        type: REMOVE_RECENTLY_VISITED_ITEM,
        id: id
    };
};
var loadRecentlyVisited = function() {
    return {
        type: LOAD_RECENTLY_VISITED
    };
};


/***/ }),

/***/ 11169:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23114);

var RecentlyVisitedProductsLoader = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "secondary-content";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | secondary-content */ 88).then(__webpack_require__.bind(__webpack_require__, 43901));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(43901);
        }
        return eval("require.resolve")("./recently-visited");
    }
});
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (RecentlyVisitedProductsLoader);


/***/ }),

/***/ 95037:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": () => (/* binding */ CtxLink)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3616);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18026);



var CtxLink = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(function(props) {
    var renderMode = (0,src_components_app_context__WEBPACK_IMPORTED_MODULE_2__/* .useAppContext */ .bp)().renderMode;
    var legacyRenderMode = [
        "desktop",
        "mobile",
        "native"
    ].includes(renderMode);
    if (legacyRenderMode) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
            onClick: props.onClick,
            href: props.to
        }, props.children);
    }
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_router_dom__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rU, {
        onClick: props.onClick,
        to: props.to
    }, props.children);
});


/***/ }),

/***/ 67295:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71993);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61093);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: ",
        ";\n  margin-top: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Title = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h3.withConfig({
    displayName: "Title",
    componentId: "sc-0-0"
})(_templateObject(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing200 */ .bK.measurements.spacing200);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Title);


/***/ }),

/***/ 14984:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": () => (/* binding */ ScrollHandler),
/* harmony export */   "o": () => (/* binding */ getScrollPositionFromElement)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3616);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38209);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_throttle__WEBPACK_IMPORTED_MODULE_2__);



var ScrollHandler = function(props) {
    var onScrollCallback = props.onScrollCallback, _topMargin = props.topMargin, topMargin = _topMargin === void 0 ? 0 : _topMargin;
    var location = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_1__/* .useLocation */ .TH)();
    var handleScroll = lodash_throttle__WEBPACK_IMPORTED_MODULE_2___default()(function() {
        if (onScrollCallback) onScrollCallback();
    }, 400);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [
        handleScroll
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var element = document.getElementById(location.hash);
        if (!element) return;
        setTimeout(function() {
            window.scrollTo({
                behavior: "smooth",
                top: getScrollPositionFromElement(element, topMargin)
            });
        }, 100);
    }, [
        location,
        topMargin
    ]);
    return null;
};
function getScrollPositionFromElement(element, topMargin) {
    var ref;
    if (!element) {
        return 0;
    }
    var header = (ref = window.document.getElementsByTagName("header")) === null || ref === void 0 ? void 0 : ref[0];
    var _height;
    return element.getBoundingClientRect().top + window.scrollY - topMargin - ((_height = header === null || header === void 0 ? void 0 : header.getBoundingClientRect().height) !== null && _height !== void 0 ? _height : 0);
}


/***/ }),

/***/ 20351:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": () => (/* binding */ ScrollElement)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64966);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}


var _Component;
var ScrollElement = /*#__PURE__*/ function(_superClass) {
    "use strict";
    _inherits(ScrollElement, _superClass);
    var _super = _createSuper(ScrollElement);
    function ScrollElement() {
        _classCallCheck(this, ScrollElement);
        var _this;
        _this = _super.apply(this, arguments);
        _this.node = null;
        return _this;
    }
    var _proto = ScrollElement.prototype;
    _proto.componentDidMount = function componentDidMount() {
        (0,_map__WEBPACK_IMPORTED_MODULE_1__/* .set */ .t8)(this.props.name, this.node);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        (0,_map__WEBPACK_IMPORTED_MODULE_1__/* .clear */ .ZH)(this.props.name);
    };
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("section", {
            ref: function(node) {
                _this.node = node;
            },
            "data-test": this.props["data-test"],
            className: this.props.className
        }, this.props.children);
    };
    return ScrollElement;
}(_Component = react__WEBPACK_IMPORTED_MODULE_0__.Component);
ScrollElement.defaultProps = {
    children: null
};


/***/ }),

/***/ 64966:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U2": () => (/* binding */ get),
/* harmony export */   "ZH": () => (/* binding */ clear),
/* harmony export */   "t8": () => (/* binding */ set)
/* harmony export */ });
// This file is causing memory leaks
var map = {};
function set(key, value) {
    map[key] = value;
    return map;
}
function get(key) {
    return map[key];
}
function clear(key) {
    map[key] = undefined;
    return map;
}



/***/ }),

/***/ 67016:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xL": () => (/* reexport */ components_element/* ScrollElement */.x),
  "Rv": () => (/* reexport */ ScrollLink)
});

// UNUSED EXPORTS: SCROLL_DURATION

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
// EXTERNAL MODULE: ./src/components/scroll/components/map.ts
var map = __webpack_require__(64966);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
;// CONCATENATED MODULE: ./src/components/scroll/components/link/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  cursor: pointer;\n\n  &:hover {\n    p {\n      text-decoration: underline;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var StyledElement = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledElement",
    componentId: "sc-0-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/components/scroll/components/link/index.tsx
/* eslint-disable jsx-a11y/no-static-element-interactions */ function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}




var SCROLL_DURATION = 200;
var _Component;
var ScrollLink = /*#__PURE__*/ function(_superClass) {
    "use strict";
    _inherits(ScrollLink, _superClass);
    var _super = _createSuper(ScrollLink);
    function ScrollLink() {
        _classCallCheck(this, ScrollLink);
        var _this;
        _this = _super.apply(this, arguments);
        _this.onClickHandler = function(e) {
            _this.props.onClick(e);
            var contains = true;
            var current = e.target;
            while(contains){
                contains = Boolean(current && e.currentTarget.contains(current));
                // Exit while loop if we should scroll
                if (current && _this.props.shouldScroll(current)) {
                    var ele = (0,map/* get */.U2)(_this.props.to);
                    if (ele) {
                        _this.scrollTo(ele);
                    }
                    break;
                }
                current = current && current.parentNode;
            }
        };
        return _this;
    }
    var _proto = ScrollLink.prototype;
    _proto.scrollTo = function scrollTo(domElement) {
        var _props = this.props, direction = _props.direction, animate = _props.animate;
        if (!domElement) {
            return;
        }
        var offset = this.props.calculateOffset();
        var from = window.pageYOffset;
        var to = domElement.offsetTop - offset;
        if (direction === "up" && from < to) {
            return;
        }
        if (direction === "down" && from > to) {
            return;
        }
        // Init scroll animation.
        base/* animationUtils.tween */.ry.tween({
            from: from,
            to: to,
            duration: animate ? SCROLL_DURATION : 0,
            onUpdate: function onUpdate(value) {
                window.scrollTo(0, Math.round(value));
            }
        });
    };
    _proto.render = function render() {
        return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events
        /*#__PURE__*/ react.createElement(StyledElement, {
            className: "pj-ui-scroll-link ".concat(this.props.className),
            onClick: this.onClickHandler,
            as: this.props.component
        }, this.props.children));
    };
    return ScrollLink;
}(_Component = react.Component);
ScrollLink.defaultProps = {
    component: "span",
    shouldScroll: function() {
        return true;
    },
    calculateOffset: function() {
        return 0;
    },
    children: null,
    direction: "both",
    animate: true,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onClick: function() {},
    className: ""
};

// EXTERNAL MODULE: ./src/components/scroll/components/element/index.tsx
var components_element = __webpack_require__(20351);
;// CONCATENATED MODULE: ./src/components/scroll/index.ts





/***/ }),

/***/ 42199:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ search_bar)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/areas/search-suggestions/history-storage.tsx
var history_storage = __webpack_require__(55918);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(71016);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/list/variants.js
var list_variants = __webpack_require__(35967);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(38689);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/magnifier/index.js
var magnifier = __webpack_require__(38314);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/close/index.js
var icon_close = __webpack_require__(15309);
// EXTERNAL MODULE: ./src/ui/zindex/index.ts
var zindex = __webpack_require__(93497);
;// CONCATENATED MODULE: ./src/components/search-bar/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  from {\n    max-width: ",
        ";\n  }\n\n  to {\n    max-width: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  from {\n    max-width: ",
        ";\n  }\n\n  to {\n    max-width: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      padding: 0 ",
        ";\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        "\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n          animation: ",
        " 150ms;\n          width: ",
        ";\n        "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n          max-width: ",
        ";\n          width: auto;\n          animation: ",
        " 150ms;\n        "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        "\n\n      ",
        "\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    background-color: ",
        ";\n    height: 100%;\n    padding: 0 ",
        ";\n    user-select: none;\n    cursor: ",
        ";\n    width: ",
        ";\n    min-width: ",
        ";\n    transition: background-color 150ms ease;\n    overflow: hidden;\n    color: rgba(0, 0, 0, 1);\n\n    &:disabled {\n      color: rgba(0, 0, 0, 0.3);\n    }\n\n    &:hover {\n      background-color: ",
        ";\n    }\n\n    ",
        "\n\n    ",
        ";\n\n    ",
        ";\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n      box-shadow: none;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n        border-radius: ",
        ";\n      "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: ",
        ";\n    overflow: hidden;\n    position: relative;\n    border-radius: 4px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n    background: ",
        ";\n    z-index: ",
        ";\n\n    ",
        ";\n\n    ",
        " {\n      ",
        ";\n    }\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n    flex: 1 1 auto;\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  flex: 1 0 auto;\n  height: 100%;\n  opacity: 1;\n\n  ",
        ";\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n    height: 48px;\n  "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  background: transparent;\n  border: none;\n  width: 100%;\n  height: ",
        ";\n  flex-grow: 1;\n  padding: 0 ",
        ";\n\n  ",
        ";\n\n  &:focus {\n    outline: none;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  display: ",
        ";\n  justify-content: center;\n  align-items: center;\n  background-color: ",
        ";\n  color: ",
        ";\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  margin-right: ",
        ";\n  cursor: pointer;\n  transition: background-color 150ms ease;\n  flex: 0 0 auto;\n\n  &:hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n  > * {\n    align-items: center;\n    justify-content: center;\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n  display: ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n        width: 100%;\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        position: fixed;\n        z-index: ",
        ";\n        top: 0;\n        left: 0;\n        right: 0;\n        height: 56px;\n        background: ",
        ";\n        flex-direction: column;\n        height: 100vh;\n        max-width: initial;\n      "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        "\n    "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _taggedTemplateLiteral([
        "\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n  }\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  max-width: 590px;\n  display: flex;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        "\n    padding: 0 ",
        ";\n    z-index: ",
        ";\n  "
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _taggedTemplateLiteral([
        "\n    animation: ",
        " 120ms;\n    animation-fill-mode: forwards;\n  "
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  align-items: center;\n  flex-shrink: 0;\n  z-index: ",
        ";\n  ",
        ";\n  ",
        "\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        "\n  "
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = _taggedTemplateLiteral([
        "\n  height: 100%;\n  display: none;\n  align-items: center;\n  justify-content: center;\n  color: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}







var _measurements = base/* layout.measurements */.bK.measurements, spacing050 = _measurements.spacing050, spacing100 = _measurements.spacing100;
var BUTTON_MIN = "40px";
var BUTTON_MAX = "135px";
var scaleIn = (0,styled_components_browser_esm.keyframes)(_templateObject(), BUTTON_MIN, BUTTON_MAX);
var scaleOut = (0,styled_components_browser_esm.keyframes)(_templateObject1(), BUTTON_MAX, BUTTON_MIN);
var searchButtonColor = function(p) {
    if (!p.active) {
        return "";
    }
    return "background-color: ".concat(p.disabled ? "transparent" : p.theme.colors.yellove500, ";");
};
var SearchButton = styled_components_browser_esm["default"].button.withConfig({
    displayName: "SearchButton",
    componentId: "sc-0-0"
})(function(p) {
    return (0,styled_components_browser_esm.css)(_templateObject7(), p.theme.colors.yellove500, spacing100, p.disabled ? "initial" : "pointer", BUTTON_MIN, BUTTON_MIN, base/* colorUtils.shadeColor */.$n.shadeColor(p.theme.colors.yellove500, p.disabled ? 0 : -10), base/* media.mediumDown */.BC.mediumDown(_templateObject2(), spacing050), base/* media.smallOnly */.BC.smallOnly(_templateObject3(), searchButtonColor(p)), base/* media.mediumUp */.BC.mediumUp(_templateObject6(), p.disabled && (0,styled_components_browser_esm.css)(_templateObject4(), scaleOut, BUTTON_MIN), !p.disabled && (0,styled_components_browser_esm.css)(_templateObject5(), BUTTON_MAX, scaleIn)));
});
var StyledSearchBar = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledSearchBar",
    componentId: "sc-0-1"
})(function(p) {
    return (0,styled_components_browser_esm.css)(_templateObject10(), base/* layout.searchBar.height.desktop.rem */.bK.searchBar.height.desktop.rem, p.theme.colors.base0, zindex/* zindex.menu.searchSuggestions */.Y.menu.searchSuggestions, base/* media.smallOnly */.BC.smallOnly(_templateObject8()), SearchButton, base/* media.smallOnly */.BC.smallOnly(_templateObject9(), p.$active ? "4px" : 0));
});
var InputWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "InputWrapper",
    componentId: "sc-0-2"
})(_templateObject12(), base/* media.smallOnly */.BC.smallOnly(_templateObject11()));
var SearchInput = styled_components_browser_esm["default"].input.withConfig({
    displayName: "SearchInput",
    componentId: "sc-0-3"
})(_templateObject14(), base/* layout.searchBar.height.desktop.rem */.bK.searchBar.height.desktop.rem, spacing100, base/* media.smallOnly */.BC.smallOnly(_templateObject13()));
var ClearIcon = (0,styled_components_browser_esm["default"])(icon_close.IconClose).withConfig({
    displayName: "ClearIcon",
    componentId: "sc-0-4"
})(_templateObject15());
var ClearButton = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "ClearButton",
    componentId: "sc-0-5"
})(_templateObject16(), function(p) {
    return p.show ? "flex" : "none";
}, function(p) {
    return p.theme.bg.tertiary;
}, function(p) {
    return p.theme.icons.primary;
}, spacing100, function(p) {
    return base/* colorUtils.shadeColor */.$n.shadeColor(p.theme.bg.tertiary, -20);
});
var SearchIcon = (0,styled_components_browser_esm["default"])(magnifier/* IconMagnifier */.j).withConfig({
    displayName: "SearchIcon",
    componentId: "sc-0-6"
})(_templateObject17());
var SearchButtonText = (0,styled_components_browser_esm["default"])(variants.TitleSmallText).withConfig({
    displayName: "SearchButtonText",
    componentId: "sc-0-7"
})(_templateObject18());
var Text = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Text",
    componentId: "sc-0-8"
})(_templateObject20(), function(p) {
    return p.$visible ? "inline" : "none";
}, base/* media.smallOnly */.BC.smallOnly(_templateObject19()));
var searchBarMobile = function(p) {
    if (p.$active) {
        return (0,styled_components_browser_esm.css)(_templateObject22(), base/* media.smallOnly */.BC.smallOnly(_templateObject21(), zindex/* zindex.menu.searchBar */.Y.menu.searchBar, p.theme.bg.primary));
    }
    return null;
};
var fadeIn = (0,styled_components_browser_esm.keyframes)(_templateObject23());
var fadeOut = (0,styled_components_browser_esm.keyframes)(_templateObject24());
var SearchBarWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SearchBarWrapper",
    componentId: "sc-0-9"
})(_templateObject25(), function(p) {
    return p.$active ? "z-index: 109;" : "z-index:1;";
}, function(p) {
    return searchBarMobile(p);
});
var SearchBarGroup = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SearchBarGroup",
    componentId: "sc-0-10"
})(_templateObject28(), zindex/* zindex.menu.searchBar */.Y.menu.searchBar, function(p) {
    return base/* media.smallOnly */.BC.smallOnly(_templateObject26(), p.$active ? "box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2); max-width: 100%; height: 56px;" : "", spacing050, zindex/* zindex.modal */.Y.modal);
}, function(p) {
    return (0,styled_components_browser_esm.css)(_templateObject27(), p.$visible ? fadeIn : fadeOut);
});
var CloseButton = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "CloseButton",
    componentId: "sc-0-11"
})(_templateObject30(), function(p) {
    return p.theme.text.primary;
}, function(p) {
    return base/* media.smallOnly */.BC.smallOnly(_templateObject29(), !p.$visible ? "display: none;" : "display: flex;");
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@5.2.1_react@18.2.0/node_modules/react-router/esm/react-router.js + 3 modules
var react_router = __webpack_require__(14727);
// EXTERNAL MODULE: ./node_modules/.pnpm/query-string-for-all@6.8.3/node_modules/query-string-for-all/dist/index.js
var dist = __webpack_require__(25932);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-use@17.3.2_react-dom@18.2.0_react@18.2.0/node_modules/react-use/lib/useDebounce.js
var useDebounce = __webpack_require__(11139);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-use@17.3.2_react-dom@18.2.0_react@18.2.0/node_modules/react-use/lib/useClickAway.js
var useClickAway = __webpack_require__(40925);
// EXTERNAL MODULE: ./src/components/viewport/context.tsx
var context = __webpack_require__(84198);
;// CONCATENATED MODULE: ./src/areas/search-suggestions/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n    position: static;\n    overflow: auto;\n    height: 100vh;\n  "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  max-width: ",
        ";\n  margin: 0 auto;\n  position: absolute;\n  bottom: -15px;\n  z-index: ",
        ";\n  color: ",
        ";\n\n  ",
        ";\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n    position: relative;\n    padding: ",
        " 0;\n    overflow: hidden;\n    height: calc(100vh + 200px);\n  "
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  max-width: ",
        ";\n  width: 100%;\n\n  ",
        "\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = styles_taggedTemplateLiteral([
        "\n    border: none;\n    overflow: auto;\n    border-radius: none;\n    width: 100%;\n    min-height: 100%;\n    box-shadow: none;\n    background: transparent;\n  "
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin: 0 auto;\n  padding: ",
        " 0 ",
        ";\n  overflow: hidden;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  background: white;\n  border-radius: 4px;\n  list-style: none;\n  z-index: 1;\n  margin-top: -",
        ";\n  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);\n\n  ",
        "\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n  margin-top: ",
        ";\n  flex: 0 1 auto;\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = styles_taggedTemplateLiteral([
        ""
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = styles_taggedTemplateLiteral([
        "top: 56px; background-color: ",
        ";"
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = styles_taggedTemplateLiteral([
        "\n  ",
        "\n  position: fixed;\n  z-index: ",
        ";\n  height: 100vh;\n  width: 100vw;\n  top: 0;\n  left: 0;\n  background-color: ",
        ";\n  ",
        "\n"
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}




var Suggestions = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Suggestions",
    componentId: "sc-0-0"
})(styles_templateObject1(), base/* layout.pageContent.maxWidth.rem */.bK.pageContent.maxWidth.rem, zindex/* zindex.menu.searchSuggestions */.Y.menu.searchSuggestions, function(p) {
    return p.theme.text.primary;
}, base/* media.smallOnly */.BC.smallOnly(styles_templateObject()));
var Inner = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Inner",
    componentId: "sc-0-1"
})(styles_templateObject3(), base/* layout.pageContent.maxWidth.rem */.bK.pageContent.maxWidth.rem, base/* media.smallOnly */.BC.smallOnly(styles_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050));
var Items = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "Items",
    componentId: "sc-0-2"
})(styles_templateObject5(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.smallOnly */.BC.smallOnly(styles_templateObject4()));
var PopularSearchesTitle = (0,styled_components_browser_esm["default"])(variants.H4Text).withConfig({
    displayName: "PopularSearchesTitle",
    componentId: "sc-0-3"
})(styles_templateObject6(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var AdItem = styled_components_browser_esm["default"].li.withConfig({
    displayName: "AdItem",
    componentId: "sc-0-4"
})(styles_templateObject7());
var SuggestionOverlay = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SuggestionOverlay",
    componentId: "sc-0-5"
})(styles_templateObject9(), function(p) {
    return !p.$visible ? "display: none;" : "";
}, zindex/* zindex.menu.searchOverlay */.Y.menu.searchOverlay, function(p) {
    return p.theme.bg.overlay;
}, base/* media.smallOnly */.BC.smallOnly(styles_templateObject8(), function(p) {
    return p.theme.colors.base0;
}));

;// CONCATENATED MODULE: ./src/areas/search-suggestions/suggestion-box.tsx


var SuggestionBox = function(props) {
    var children = props.children, containerRef = props.containerRef;
    return /*#__PURE__*/ react.createElement(Suggestions, null, /*#__PURE__*/ react.createElement(Inner, null, /*#__PURE__*/ react.createElement(Items, {
        ref: containerRef,
        "data-test": "SearchSuggestionsBox",
        id: "overlaySearchResults",
        "aria-expanded": "true"
    }, children)));
};

// EXTERNAL MODULE: ./src/components/product-image/index.tsx
var product_image = __webpack_require__(87044);
// EXTERNAL MODULE: ./src/components/currency/index.tsx
var currency = __webpack_require__(49763);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/index.js
var ui_text = __webpack_require__(49955);
// EXTERNAL MODULE: ./src/areas/product-collection/components/products/highlighted-search-result.tsx
var highlighted_search_result = __webpack_require__(3049);
;// CONCATENATED MODULE: ./src/areas/search-suggestions/components/highlighted-name.tsx
function highlighted_name_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function highlighted_name_templateObject() {
    var data = highlighted_name_taggedTemplateLiteral([
        "\n  font-weight: ",
        ";\n"
    ]);
    highlighted_name_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function highlighted_name_templateObject1() {
    var data = highlighted_name_taggedTemplateLiteral([
        "\n  font-weight: ",
        ";\n"
    ]);
    highlighted_name_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var HighlightedName = function(props) {
    var query = props.query, children = props.children;
    var escapedRegExpQuery = query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    var re = new RegExp(escapedRegExpQuery, "gi");
    var highlight = children.match(re) || [];
    var highlightedName = children.replace(re, "[highlight]".concat(highlight[0] || "", "[/highlight]"));
    return(// NOTE: Don't let Google translate this as it will cause a client crash
    /*#__PURE__*/ react.createElement(highlighted_name_Text, {
        className: "notranslate"
    }, /*#__PURE__*/ react.createElement(highlighted_search_result/* default */.Z, {
        component: Highlight
    }, highlightedName || "")));
};
var highlighted_name_Text = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Text",
    componentId: "sc-0-0"
})(highlighted_name_templateObject(), ui_text.FontWeight.HEAVIEST);
var Highlight = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Highlight",
    componentId: "sc-0-1"
})(highlighted_name_templateObject1(), ui_text.FontWeight.NORMAL);

;// CONCATENATED MODULE: ./src/areas/search-suggestions/components/list-items/styles.ts
function list_items_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function list_items_styles_templateObject() {
    var data = list_items_styles_taggedTemplateLiteral([
        "\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  text-align: left;\n  height: ",
        ";\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n  opacity: ",
        ";\n  width: 100%;\n  transition: background-color 150ms ease;\n  color: ",
        ";\n\n  &:hover {\n    background-color: ",
        ";\n  }\n\n  > *:not(:last-child) {\n    margin-right: ",
        ";\n  }\n"
    ]);
    list_items_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function list_items_styles_templateObject1() {
    var data = list_items_styles_taggedTemplateLiteral([
        "\n  ",
        " {\n    background-color: rgba(72, 149, 182, 0.1);\n  }\n"
    ]);
    list_items_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function list_items_styles_templateObject2() {
    var data = list_items_styles_taggedTemplateLiteral([
        "\n  order: ",
        ";\n  ",
        ";\n  position: relative;\n"
    ]);
    list_items_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function list_items_styles_templateObject3() {
    var data = list_items_styles_taggedTemplateLiteral([
        "\n        background: transparent;\n      "
    ]);
    list_items_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function list_items_styles_templateObject4() {
    var data = list_items_styles_taggedTemplateLiteral([
        "\n  && {\n    ",
        ";\n  }\n\n  ",
        " {\n    /* suggestions gutter + icon size + icon spacing */\n    padding-left: 2.5rem;\n    height: 30px;\n  }\n"
    ]);
    list_items_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function list_items_styles_templateObject5() {
    var data = list_items_styles_taggedTemplateLiteral([
        "\n  align-items: center;\n"
    ]);
    list_items_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function list_items_styles_templateObject6() {
    var data = list_items_styles_taggedTemplateLiteral([
        "\n  && {\n    align-items: baseline;\n    flex: 0 1 auto;\n  }\n"
    ]);
    list_items_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function list_items_styles_templateObject7() {
    var data = list_items_styles_taggedTemplateLiteral([
        "\n  flex: 0 1 auto;\n"
    ]);
    list_items_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function list_items_styles_templateObject8() {
    var data = list_items_styles_taggedTemplateLiteral([
        "\n  flex: 1 0 auto;\n  align-self: baseline;\n"
    ]);
    list_items_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function list_items_styles_templateObject9() {
    var data = list_items_styles_taggedTemplateLiteral([
        ""
    ]);
    list_items_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    var data = list_items_styles_taggedTemplateLiteral([
        "\n  max-height: 24px;\n  margin-left: auto;\n\n  /* stylelint-disable-next-line value-no-vendor-prefix */\n  image-rendering: -webkit-optimize-contrast;\n"
    ]);
    styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}






var ITEM_HEIGHT = "40px";
var ListItemButton = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "ListItemButton",
    componentId: "sc-0-0"
})(list_items_styles_templateObject(), ITEM_HEIGHT, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, function(p) {
    return p.disabled ? 0.3 : 1;
}, function(p) {
    return p.theme.text.primary;
}, function(p) {
    return p.theme.colors.base200;
}, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var selectedStyles = (0,styled_components_browser_esm.css)(list_items_styles_templateObject1(), ListItemButton);
var ListItem = styled_components_browser_esm["default"].li.withConfig({
    displayName: "ListItem",
    componentId: "sc-0-1"
})(list_items_styles_templateObject2(), function(p) {
    return p.order || 1;
}, function(p) {
    return p.$selected && selectedStyles;
});
var SubListItem = (0,styled_components_browser_esm["default"])(ListItem).withConfig({
    displayName: "SubListItem",
    componentId: "sc-0-2"
})(list_items_styles_templateObject4(), function(p) {
    return p.$selected && (0,styled_components_browser_esm.css)(list_items_styles_templateObject3());
}, ListItemButton);
var Wrapper = (0,styled_components_browser_esm["default"])(list_variants.Row).attrs({
    gap: 0.5
}).withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-3"
})(list_items_styles_templateObject5());
var Labels = (0,styled_components_browser_esm["default"])(list_variants.Row).attrs(function(p) {
    return {
        gap: p.gap || 0.5
    };
}).withConfig({
    displayName: "Labels",
    componentId: "sc-0-4"
})(list_items_styles_templateObject6());
var NameLabel = (0,styled_components_browser_esm["default"])(variants.BodySmallText).withConfig({
    displayName: "NameLabel",
    componentId: "sc-0-5"
})(list_items_styles_templateObject7());
var SectionLabel = (0,styled_components_browser_esm["default"])(variants.CaptionText).withConfig({
    displayName: "SectionLabel",
    componentId: "sc-0-6"
})(list_items_styles_templateObject8());
var styles_SearchIcon = (0,styled_components_browser_esm["default"])(magnifier/* IconMagnifier */.j).attrs({
    color: "base500"
}).withConfig({
    displayName: "SearchIcon",
    componentId: "sc-0-7"
})(list_items_styles_templateObject9());
var ShopLogo = styled_components_browser_esm["default"].img.withConfig({
    displayName: "ShopLogo",
    componentId: "sc-0-8"
})(styles_templateObject10());

// EXTERNAL MODULE: ./src/components/offer/price/price-text.tsx
var price_text = __webpack_require__(28254);
;// CONCATENATED MODULE: ./src/areas/search-suggestions/components/list-items/product.tsx
function product_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function product_templateObject() {
    var data = product_taggedTemplateLiteral([
        "\n  && {\n    height: auto;\n    padding-top: ",
        ";\n    padding-bottom: ",
        ";\n  }\n"
    ]);
    product_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function product_templateObject1() {
    var data = product_taggedTemplateLiteral([
        "\n  height: 48px;\n"
    ]);
    product_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}











var ProductItem = function(props) {
    var id = props.id, text = props.text, price = props.price, order = props.order, selected = props.selected, onClick = props.onClick, query = props.query, category = props.category;
    var ref = (0,app_context/* useAppContext */.bp)(), _market = ref.market, market = _market === void 0 ? {
        cdn: "https://cdn.pji.nu"
    } : _market, t = ref.t;
    var imageSrc = "".concat(market.cdn, "/product/standard/80/").concat(id, ".jpg");
    return /*#__PURE__*/ react.createElement(ListItem, {
        "data-test": "ProductItem",
        order: order,
        $selected: selected
    }, /*#__PURE__*/ react.createElement(Button, {
        onClick: onClick
    }, /*#__PURE__*/ react.createElement(Wrapper, null, /*#__PURE__*/ react.createElement(Image, {
        src: imageSrc
    }), /*#__PURE__*/ react.createElement(Labels, null, /*#__PURE__*/ react.createElement(list_variants.Column, null, /*#__PURE__*/ react.createElement(NameLabel, {
        containerProps: {
            "data-test": "NameLabel"
        }
    }, /*#__PURE__*/ react.createElement(HighlightedName, {
        query: query
    }, text)), category && /*#__PURE__*/ react.createElement(variants.CaptionText, null, category)))), price ? /*#__PURE__*/ react.createElement(Labels, {
        gap: 0.25
    }, /*#__PURE__*/ react.createElement(variants.BodySmallText, {
        emphasis: variants.FontEmphasis.LOW
    }, t("product", "price.from-abbr")), /*#__PURE__*/ react.createElement(price_text/* PriceText */.X, null, /*#__PURE__*/ react.createElement(currency/* Currency */.F, {
        price: price
    }))) : null));
};
var Button = (0,styled_components_browser_esm["default"])(ListItemButton).withConfig({
    displayName: "Button",
    componentId: "sc-0-0"
})(product_templateObject(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var Image = (0,styled_components_browser_esm["default"])(product_image/* ProductImage */.q).withConfig({
    displayName: "Image",
    componentId: "sc-0-1"
})(product_templateObject1());

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/diagonal-arrow-up-left/index.js
var diagonal_arrow_up_left = __webpack_require__(36029);
;// CONCATENATED MODULE: ./src/areas/search-suggestions/components/extend-search-button.tsx
function extend_search_button_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function extend_search_button_templateObject() {
    var data = extend_search_button_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 24px;\n  width: 24px;\n  background-color: ",
        ";\n  border-radius: 50%;\n  color: ",
        ";\n  position: absolute;\n  top: 50%;\n  right: ",
        ";\n  transform: translateY(-50%);\n  cursor: pointer;\n\n  &:hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    extend_search_button_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var ExtendSearchButton = function(props) {
    var onClick = props.onClick;
    var handleClick = function(e) {
        e.preventDefault();
        e.stopPropagation();
        onClick();
    };
    return /*#__PURE__*/ react.createElement(extend_search_button_Button, {
        "data-test": "ExtendSearchButton",
        onClick: handleClick
    }, /*#__PURE__*/ react.createElement(diagonal_arrow_up_left/* IconDiagonalArrowUpLeft */.H, {
        size: 13,
        color: "base500"
    }));
};
var extend_search_button_Button = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "Button",
    componentId: "sc-0-0"
})(extend_search_button_templateObject(), function(p) {
    return p.theme.bg.secondary;
}, function(p) {
    return p.theme.icons.secondary;
}, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, function(p) {
    return p.theme.bg.tertiary;
});

;// CONCATENATED MODULE: ./src/areas/search-suggestions/components/list-items/brand.tsx






var BrandItem = function(props) {
    var categories = props.categories, id = props.id, onClick = props.onClick, onExtendSearch = props.onExtendSearch, order = props.order, query = props.query, selected = props.selected, text = props.text;
    var t = (0,app_context/* useAppContext */.bp)().t;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(ListItem, {
        "data-test": "BrandItem",
        $selected: selected,
        order: order
    }, /*#__PURE__*/ react.createElement(ListItemButton, {
        onClick: onClick
    }, /*#__PURE__*/ react.createElement(Wrapper, null, /*#__PURE__*/ react.createElement(styles_SearchIcon, {
        size: 16
    }), /*#__PURE__*/ react.createElement(Labels, null, /*#__PURE__*/ react.createElement(NameLabel, null, /*#__PURE__*/ react.createElement(HighlightedName, {
        query: query
    }, text))))), onExtendSearch && /*#__PURE__*/ react.createElement(ExtendSearchButton, {
        onClick: onExtendSearch
    })), categories === null || categories === void 0 ? void 0 : categories.map(function(category) {
        return category && category.path && /*#__PURE__*/ react.createElement(SubListItem, {
            key: category.text,
            $selected: false,
            order: order
        }, /*#__PURE__*/ react.createElement(ListItemButton, {
            to: "".concat(category.path, "?brand=").concat(id)
        }, /*#__PURE__*/ react.createElement(NameLabel, {
            emphasis: variants.FontEmphasis.MEDIUM
        }, t("common", "text.in"), " ", category.text)));
    }));
};

;// CONCATENATED MODULE: ./src/areas/search-suggestions/components/list-items/product-collection.tsx





var ProductCollectionItem = function(props) {
    var text = props.text, brands = props.brands, path = props.path, selected = props.selected, order = props.order, onClick = props.onClick, query = props.query;
    var t = (0,app_context/* useAppContext */.bp)().t;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(ListItem, {
        "data-test": "ProductCollectionItem",
        $selected: selected,
        order: order
    }, /*#__PURE__*/ react.createElement(ListItemButton, {
        onClick: onClick
    }, /*#__PURE__*/ react.createElement(Labels, null, /*#__PURE__*/ react.createElement(NameLabel, {
        containerProps: {
            "data-test": "NameLabel"
        }
    }, /*#__PURE__*/ react.createElement(HighlightedName, {
        query: query
    }, text)), /*#__PURE__*/ react.createElement(SectionLabel, null, t("search", "suggest.product_collection"))))), brands === null || brands === void 0 ? void 0 : brands.map(function(brand) {
        return brand && /*#__PURE__*/ react.createElement(SubListItem, {
            key: brand.text,
            $selected: false,
            order: order
        }, /*#__PURE__*/ react.createElement(ListItemButton, {
            to: "".concat(path, "?brand=").concat(brand.id)
        }, /*#__PURE__*/ react.createElement(NameLabel, {
            emphasis: variants.FontEmphasis.MEDIUM
        }, t("common", "text.by"), " ", brand.text)));
    }));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/history/index.js
var icon_history = __webpack_require__(24315);
;// CONCATENATED MODULE: ./src/areas/search-suggestions/components/list-items/history-item.tsx
function history_item_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function history_item_templateObject() {
    var data = history_item_taggedTemplateLiteral([
        "\n  align-items: center;\n  padding: ",
        " 0;\n  overflow: hidden;\n  margin-right: ",
        "px;\n"
    ]);
    history_item_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function history_item_templateObject1() {
    var data = history_item_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: ",
        ";\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: background-color 150ms ease;\n  color: ",
        ";\n  position: absolute;\n  top: 50%;\n  right: ",
        ";\n  transform: translateY(-50%);\n\n  &:hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    history_item_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function history_item_templateObject2() {
    var data = history_item_taggedTemplateLiteral([
        "\n  order: ",
        ";\n  margin-left: ",
        ";\n  margin-top: ",
        ";\n  flex: 0 1 auto;\n"
    ]);
    history_item_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function history_item_templateObject3() {
    var data = history_item_taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    history_item_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function history_item_templateObject4() {
    var data = history_item_taggedTemplateLiteral([
        "\n  flex: 0 1 auto;\n  order: ",
        ";\n  margin-left: ",
        ";\n  margin-top: ",
        ";\n\n  ",
        ";\n\n  button {\n    color: inherit;\n    cursor: pointer;\n  }\n"
    ]);
    history_item_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function history_item_templateObject5() {
    var data = history_item_taggedTemplateLiteral([
        "\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    history_item_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}










var ORDER = 100;
var HistoryItem = function(props) {
    var text = props.text, onDelete = props.onDelete, onClick = props.onClick, selected = props.selected, onClear = props.onClear, showClear = props.showClear;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var handleOnClick = (0,react.useCallback)(function() {
        onClick();
    }, [
        onClick
    ]);
    var handleOnDelete = (0,react.useCallback)(function(event) {
        onDelete(event);
    }, [
        onDelete
    ]);
    return /*#__PURE__*/ react.createElement(react.Fragment, null, showClear ? /*#__PURE__*/ react.createElement(history_item_ClearButton, {
        color: variants.FontColor.PRIMARY
    }, /*#__PURE__*/ react.createElement(clickable/* Clickable */.P, {
        onClick: onClear,
        "data-test": "ClearHistoryItemButton"
    }, t("common", "button.clear"))) : null, /*#__PURE__*/ react.createElement(ListItem, {
        "data-test": "HistoryItem",
        $selected: selected,
        order: ORDER
    }, /*#__PURE__*/ react.createElement(ListItemButton, {
        onClick: handleOnClick
    }, /*#__PURE__*/ react.createElement(ItemInner, {
        gap: 0.5
    }, /*#__PURE__*/ react.createElement(icon_history/* IconHistory */.H, {
        size: iconSize,
        color: "base400"
    }), /*#__PURE__*/ react.createElement(history_item_Text, null, text))), /*#__PURE__*/ react.createElement(RemoveButton, {
        onClick: handleOnDelete
    }, /*#__PURE__*/ react.createElement(icon_close.IconClose, {
        size: 12,
        color: "base600"
    }))));
};
var history_item_measurements = base/* layout.measurements */.bK.measurements, history_item_spacing050 = history_item_measurements.spacing050, history_item_spacing100 = history_item_measurements.spacing100;
var iconSize = 24;
var ItemInner = (0,styled_components_browser_esm["default"])(list_variants.Row).withConfig({
    displayName: "ItemInner",
    componentId: "sc-0-0"
})(history_item_templateObject(), history_item_spacing050, iconSize);
var RemoveButton = styled_components_browser_esm["default"].button.withConfig({
    displayName: "RemoveButton",
    componentId: "sc-0-1"
})(history_item_templateObject1(), function(p) {
    return p.theme.bg.secondary;
}, function(p) {
    return p.theme.icons.primary;
}, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, function(p) {
    return p.theme.bg.tertiary;
});
var Title = (0,styled_components_browser_esm["default"])(variants.H4Text).attrs({
    "data-test": "HistoryItemsTitle"
}).withConfig({
    displayName: "Title",
    componentId: "sc-0-2"
})(history_item_templateObject2(), ORDER, history_item_spacing100, history_item_spacing100);
var history_item_ClearButton = (0,styled_components_browser_esm["default"])(variants.TitleMediumText).withConfig({
    displayName: "ClearButton",
    componentId: "sc-0-3"
})(history_item_templateObject4(), ORDER + 1, history_item_spacing100, history_item_spacing100, base/* media.mediumUp */.BC.mediumUp(history_item_templateObject3()));
var history_item_Text = (0,styled_components_browser_esm["default"])(variants.BodySmallText).withConfig({
    displayName: "Text",
    componentId: "sc-0-4"
})(history_item_templateObject5());

;// CONCATENATED MODULE: ./src/areas/search-suggestions/components/list-items/keyword.tsx





var KeywordItem = function(props) {
    var text = props.text, order = props.order, selected = props.selected, onClick = props.onClick, onExtendSearch = props.onExtendSearch, query = props.query;
    return /*#__PURE__*/ react.createElement(ListItem, {
        "data-test": "KeywordItem",
        order: order,
        $selected: selected
    }, /*#__PURE__*/ react.createElement(ListItemButton, {
        onClick: onClick
    }, /*#__PURE__*/ react.createElement(Wrapper, null, /*#__PURE__*/ react.createElement(styles_SearchIcon, {
        size: 16
    }), /*#__PURE__*/ react.createElement(Labels, null, /*#__PURE__*/ react.createElement(list_variants.Column, null, /*#__PURE__*/ react.createElement(NameLabel, null, /*#__PURE__*/ react.createElement(HighlightedName, {
        query: query
    }, text)))))), onExtendSearch && /*#__PURE__*/ react.createElement(ExtendSearchButton, {
        onClick: onExtendSearch
    }));
};

;// CONCATENATED MODULE: ./src/areas/search-suggestions/components/list-items/shop.tsx




var ShopItem = function(props) {
    var id = props.id, text = props.text, selected = props.selected, order = props.order, onClick = props.onClick, query = props.query;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var logoUrl = "https://cdn.pji.nu/g/ftg_logos/store_".concat(id, ".png");
    return /*#__PURE__*/ react.createElement(ListItem, {
        "data-test": "ShopItem",
        $selected: selected,
        order: order
    }, /*#__PURE__*/ react.createElement(ListItemButton, {
        onClick: onClick
    }, /*#__PURE__*/ react.createElement(Labels, null, /*#__PURE__*/ react.createElement(NameLabel, null, /*#__PURE__*/ react.createElement(HighlightedName, {
        query: query
    }, text)), /*#__PURE__*/ react.createElement(SectionLabel, null, t("search", "suggest.store"))), /*#__PURE__*/ react.createElement(ShopLogo, {
        height: 24,
        alt: text,
        src: logoUrl
    })));
};

;// CONCATENATED MODULE: ./src/areas/search-suggestions/filter-helpers.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function extractFilter(suggestion) {
    var ref;
    if ((ref = suggestion.topBrands) === null || ref === void 0 ? void 0 : ref.length) {
        return _objectSpread({}, suggestion);
    }
    var brandFilter = suggestion.filters.find(function(filter) {
        return (filter === null || filter === void 0 ? void 0 : filter.__typename) === "BrandFilter";
    });
    var brandFilterData = brandFilter ? {
        text: "".concat(brandFilter.name, " ").concat(suggestion.text),
        path: "".concat(suggestion.path).concat(brandFilter.param)
    } : {};
    return _objectSpread({}, brandFilterData);
}

;// CONCATENATED MODULE: ./src/areas/search-suggestions/types.ts
var SuggestionTypeEnum;
(function(SuggestionTypeEnum) {
    SuggestionTypeEnum["SUGGESTED_PRODUCT"] = "SuggestedProduct";
    SuggestionTypeEnum["SUGGESTED_PRODUCT_COLLECTION"] = "SuggestedProductCollection";
    SuggestionTypeEnum["SUGGESTED_CATEGORY"] = "SuggestedCategory";
    SuggestionTypeEnum["SUGGESTED_VIRTAL_CATEGORY"] = "SuggestedVirtualCategory";
    SuggestionTypeEnum["SUGGESTED_SEARCH_PHRASE"] = "SuggestedSearchPhrase";
    SuggestionTypeEnum["SUGGESTED_BRAND"] = "SuggestedBrand";
    SuggestionTypeEnum["SUGGESTED_SHOP"] = "SuggestedShop";
    SuggestionTypeEnum["SUGGESTED_LANDING_PAGE"] = "SuggestedLandingPage";
})(SuggestionTypeEnum || (SuggestionTypeEnum = {}));
var SUGGESTION_ORDER = {
    SuggestedProduct: 2,
    SuggestedBrand: 1,
    SuggestedProductCollection: 1,
    SuggestedCategory: 1,
    SuggestedVirtualCategory: 1,
    SuggestedSearchPhrase: 1,
    SuggestedShop: 1,
    SuggestedLandingPage: 1
};

;// CONCATENATED MODULE: ./src/areas/search-suggestions/components/items.tsx










var SuggestionItems = function(props) {
    var handleClearHistory = props.handleClearHistory, handleClick = props.handleClick, handleDeleteHistory = props.handleDeleteHistory, items = props.items, onExtendSearch = props.onExtendSearch, query = props.query, selectedId = props.selectedId, products = props.products;
    var t = (0,app_context/* useAppContext */.bp)().t;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, items.map(function(suggestion, index) {
        var onSuggestionClickHandler = function() {
            return handleClick(suggestion, index);
        };
        switch(suggestion.__typename){
            case "SuggestedSearchPhrase":
                {
                    if (!query.length) return null;
                    return /*#__PURE__*/ react.createElement(KeywordItem, {
                        "data-test": "KeywordItem",
                        key: "".concat(suggestion.text, "-").concat(index.toString()),
                        text: suggestion.text,
                        order: SUGGESTION_ORDER[suggestion.__typename],
                        onClick: onSuggestionClickHandler,
                        onExtendSearch: function() {
                            return onExtendSearch(suggestion);
                        },
                        query: query,
                        selected: selectedId === suggestion.navId
                    });
                }
            case "SuggestedProductCollection":
                {
                    if (!suggestion.path || !query.length) return null;
                    var text = extractFilter(suggestion).text;
                    return /*#__PURE__*/ react.createElement(ProductCollectionItem, {
                        key: "".concat(suggestion.id, "-").concat(index.toString()),
                        id: suggestion.id,
                        text: text || suggestion.text,
                        brands: suggestion.topBrands,
                        path: suggestion.path,
                        order: SUGGESTION_ORDER[suggestion.__typename],
                        onClick: onSuggestionClickHandler,
                        query: query,
                        selected: selectedId === suggestion.navId
                    });
                }
            case "SuggestedLandingPage":
                {
                    if (!suggestion.path || !query.length) return null;
                    return /*#__PURE__*/ react.createElement(ProductCollectionItem, {
                        key: "".concat(suggestion.id, "-").concat(index.toString()),
                        id: suggestion.id,
                        text: suggestion.text,
                        path: suggestion.path,
                        order: SUGGESTION_ORDER[suggestion.__typename],
                        onClick: onSuggestionClickHandler,
                        query: query,
                        selected: selectedId === suggestion.navId
                    });
                }
            case "SuggestedVirtualCategory":
            case "SuggestedCategory":
                {
                    if (!query.length) return null;
                    return /*#__PURE__*/ react.createElement(ProductCollectionItem, {
                        key: "".concat(suggestion.id, "-").concat(index.toString()),
                        id: suggestion.id,
                        text: suggestion.text,
                        order: SUGGESTION_ORDER[suggestion.__typename],
                        path: "",
                        onClick: onSuggestionClickHandler,
                        query: query,
                        selected: selectedId === suggestion.navId
                    });
                }
            case "SuggestedBrand":
                {
                    if (!query.length) return null;
                    return /*#__PURE__*/ react.createElement(BrandItem, {
                        key: "".concat(suggestion.id, "-").concat(index.toString()),
                        id: suggestion.id,
                        text: suggestion.text,
                        categories: suggestion.topCategories,
                        order: SUGGESTION_ORDER[suggestion.__typename],
                        onClick: onSuggestionClickHandler,
                        onExtendSearch: function() {
                            return onExtendSearch(suggestion);
                        },
                        query: query,
                        selected: selectedId === suggestion.navId
                    });
                }
            case "SuggestedProduct":
                {
                    var ref;
                    if (!query.length) return null;
                    var price = (ref = products.find(function(p) {
                        return p.id === Number(suggestion.id);
                    })) === null || ref === void 0 ? void 0 : ref.price;
                    return /*#__PURE__*/ react.createElement(ProductItem, {
                        key: "".concat(suggestion.id, "-").concat(index.toString()),
                        id: suggestion.id,
                        text: suggestion.text,
                        price: price,
                        category: suggestion.category,
                        order: SUGGESTION_ORDER[suggestion.__typename],
                        onClick: onSuggestionClickHandler,
                        query: query,
                        selected: selectedId === suggestion.navId
                    });
                }
            case "SuggestedShop":
                {
                    if (!query.length) return null;
                    return /*#__PURE__*/ react.createElement(ShopItem, {
                        key: "".concat(suggestion.id, "-").concat(index.toString()),
                        id: suggestion.id,
                        text: suggestion.text,
                        order: SUGGESTION_ORDER[suggestion.__typename],
                        onClick: onSuggestionClickHandler,
                        query: query,
                        selected: selectedId === suggestion.navId
                    });
                }
            case "history":
                {
                    var firstHistoryItem = items === null || items === void 0 ? void 0 : items.findIndex(function(item) {
                        return item.__typename === "history";
                    });
                    return /*#__PURE__*/ react.createElement("div", {
                        "data-test": "HistoryItemWrapper",
                        key: index
                    }, firstHistoryItem === index && /*#__PURE__*/ react.createElement(Title, {
                        key: "history=title"
                    }, t("search", "search.recent-searches")), /*#__PURE__*/ react.createElement(HistoryItem, {
                        key: "".concat(suggestion.text, "-").concat(index + 100),
                        selected: suggestion.navId === selectedId,
                        onClick: onSuggestionClickHandler,
                        onDelete: function(e) {
                            return handleDeleteHistory(e, suggestion.text);
                        },
                        onClear: handleClearHistory,
                        text: suggestion.text,
                        showClear: index === firstHistoryItem && items.filter(function(s) {
                            return s.__typename === "history";
                        }).length > 2
                    }));
                }
            default:
                return null;
        }
    }));
};

// EXTERNAL MODULE: ./src/globals/api/requests.js
var requests = __webpack_require__(11124);
// EXTERNAL MODULE: ./src/areas/search-suggestions/query.graphql
var query_graphql = __webpack_require__(26585);
var query_graphql_default = /*#__PURE__*/__webpack_require__.n(query_graphql);
// EXTERNAL MODULE: ./src/client/data-layer.ts
var data_layer = __webpack_require__(80695);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(58912);
;// CONCATENATED MODULE: ./src/areas/search-suggestions/tracking.ts



var trackSearchSuggestionsListed = function(types) {
    (0,data_layer/* pushEvent */.A)("searchSuggestionsListed", {
        types: types
    });
};
var trackSearchSuggestionInternalNavigationClicked = function(type, index, linkUrl) {
    var scope;
    switch(type){
        case SuggestionTypeEnum.SUGGESTED_CATEGORY:
        case SuggestionTypeEnum.SUGGESTED_PRODUCT_COLLECTION:
        case SuggestionTypeEnum.SUGGESTED_VIRTAL_CATEGORY:
        case SuggestionTypeEnum.SUGGESTED_LANDING_PAGE:
        case SuggestionTypeEnum.SUGGESTED_BRAND:
            scope = tracking/* InternalNavigationScope.QUICK_SEARCH_CATEGORY */.U.QUICK_SEARCH_CATEGORY;
            break;
        case SuggestionTypeEnum.SUGGESTED_SEARCH_PHRASE:
            scope = tracking/* InternalNavigationScope.QUICK_SEARCH_SEARCH_SUGGESTIONS */.U.QUICK_SEARCH_SEARCH_SUGGESTIONS;
            break;
        case SuggestionTypeEnum.SUGGESTED_PRODUCT:
            scope = tracking/* InternalNavigationScope.QUICK_SEARCH_PRODUCT */.U.QUICK_SEARCH_PRODUCT;
            break;
        case SuggestionTypeEnum.SUGGESTED_SHOP:
            scope = tracking/* InternalNavigationScope.QUICK_SEARCH_STORE */.U.QUICK_SEARCH_STORE;
            break;
        case "history":
            scope = tracking/* InternalNavigationScope.QUICK_SEARCH_LATEST_SEARCHES */.U.QUICK_SEARCH_LATEST_SEARCHES;
            break;
        case "original":
            return;
        default:
            return;
    }
    (0,tracking/* trackInternalNavigationClick */.p)({
        index: index,
        scope: scope,
        nextPage: linkUrl
    });
};

// EXTERNAL MODULE: ./src/components/popular-searches/index.tsx + 1 modules
var popular_searches = __webpack_require__(52474);
// EXTERNAL MODULE: ./src/areas/search-suggestions/requests/popular-searches.graphql
var popular_searches_graphql = __webpack_require__(21598);
var popular_searches_graphql_default = /*#__PURE__*/__webpack_require__.n(popular_searches_graphql);
;// CONCATENATED MODULE: ./src/hooks/use-event-listener.ts

var useEventListener = function(eventName, // eslint-disable-next-line @typescript-eslint/ban-types
handler) {
    var element = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : typeof window === "undefined" ? null : window;
    // eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-empty-function
    var savedHandler = (0,react.useRef)(function() {});
    (0,react.useEffect)(function() {
        savedHandler.current = handler;
    }, [
        handler
    ]);
    (0,react.useEffect)(function() {
        var isSupported = element && element.addEventListener;
        if (!isSupported) {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return function() {};
        }
        var eventListener = function(event) {
            return savedHandler.current(event);
        };
        element.addEventListener(eventName, eventListener);
        return function() {
            element.removeEventListener(eventName, eventListener);
        };
    }, [
        eventName,
        element
    ]);
};

;// CONCATENATED MODULE: ./src/areas/search-suggestions/utils.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};


var mapNewTypes = {
    SuggestedProduct: "product",
    SuggestedBrand: "brand",
    SuggestedProductCollection: "product_collection",
    SuggestedCategory: "category",
    SuggestedShop: "store",
    SuggestedVirtualCategory: "vcategory",
    SuggestedLandingPage: "landing_page"
};
var constructNavigationUrl = function() {
    var _ref = _asyncToGenerator(function(suggestion, query) {
        var path;
        return __generator(this, function(_state) {
            switch(suggestion.__typename){
                case "SuggestedVirtualCategory":
                case "SuggestedCategory":
                case "SuggestedShop":
                case "SuggestedProduct":
                    return [
                        2,
                        gotoUrl(mapNewTypes[suggestion.__typename], suggestion.id.toString(), suggestion.text)
                    ];
                case "SuggestedSearchPhrase":
                case "SuggestedBrand":
                    return [
                        2,
                        "/search?search=".concat(encodeURIComponent(suggestion.text))
                    ];
                case "SuggestedProductCollection":
                    path = extractFilter(suggestion).path; // eslint-disable-line no-case-declarations
                    if (!path && !(suggestion === null || suggestion === void 0 ? void 0 : suggestion.path)) {
                        return [
                            2,
                            null
                        ];
                    }
                    return [
                        2,
                        path || suggestion.path || ""
                    ];
                case "SuggestedLandingPage":
                    if (!(suggestion === null || suggestion === void 0 ? void 0 : suggestion.path)) {
                        return [
                            2,
                            null
                        ];
                    }
                    return [
                        2,
                        suggestion.path || ""
                    ];
                default:
                    // Prevent race condition when pressing enter quickly after a search
                    // because `query` and `suggestion.text` states are out of sync.
                    return [
                        2,
                        "/search?search=".concat(encodeURIComponent(suggestion.navId === 0 ? query : suggestion.text))
                    ];
            }
            return [
                2
            ];
        });
    });
    return function constructNavigationUrl(suggestion, query) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/areas/search-suggestions/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function search_suggestions_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function search_suggestions_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                search_suggestions_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                search_suggestions_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function search_suggestions_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function search_suggestions_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            search_suggestions_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var search_suggestions_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};




















var NAV_ID_ORIGINAL = 0;
var LIMIT = 5;
var validTypes = Object.values(SuggestionTypeEnum);
var gotoUrl = function() {
    var _ref = search_suggestions_asyncToGenerator(function(type, id, queryParam, meta) {
        var params, res;
        return search_suggestions_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = {
                        q: queryParam,
                        meta: meta
                    };
                    return [
                        4,
                        fetch("/_internal/goto/".concat(type, "/").concat(id, "?").concat(dist_default().stringify(params)))
                    ];
                case 1:
                    res = _state.sent();
                    if (res.status !== 200) {
                        throw new Error("Cannot resolve url for ".concat(type));
                    }
                    return [
                        2,
                        res.text()
                    ];
            }
        });
    });
    return function gotoUrl(type, id, queryParam, meta) {
        return _ref.apply(this, arguments);
    };
}();
var createHistorySuggestion = function(query, index) {
    return {
        type: "history",
        __typename: "history",
        text: query,
        navId: 100 + index
    };
};
var createOriginalSuggestion = function(query) {
    return {
        navId: NAV_ID_ORIGINAL,
        text: query,
        type: "original",
        __typename: "original"
    };
};
var filterHistory = function(history, query) {
    return history.toLowerCase().indexOf(query === null || query === void 0 ? void 0 : query.toLowerCase()) > -1;
};
var search_suggestions_Suggestions = function(props) {
    var query = props.query, onClose = props.onClose, setQuery = props.setQuery, visible = props.visible, updatedInputElement = props.updatedInputElement, updatedSearchWrapperElement = props.updatedSearchWrapperElement;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), market = ref.market, t = ref.t, captureException = ref.captureException;
    var isMobile = (0,context/* useViewportContext */.Ak)().isMobile;
    var ref1 = _slicedToArray((0,react.useState)(0), 2), selected = ref1[0], setSelected = ref1[1];
    var ref2 = _slicedToArray((0,react.useState)(), 2), searchInputElement = ref2[0], setSearchInputElement = ref2[1];
    var ref3 = _slicedToArray((0,react.useState)(), 2), searchWrapperElement = ref3[0], setSearchWrapperElement = ref3[1];
    var containerRef = (0,react.useRef)(null);
    var history = (0,react_router/* useHistory */.k6)();
    // Keep track of the request count to discard old results
    var requestCount = (0,react.useRef)(0);
    var ref4 = _slicedToArray((0,react.useState)([]), 2), suggestions = ref4[0], setSuggestions = ref4[1];
    var ref5 = _slicedToArray((0,react.useState)([]), 2), products = ref5[0], setProducts = ref5[1];
    var ref6 = _slicedToArray((0,react.useState)([]), 2), popularSearches = ref6[0], setPopularSearches = ref6[1];
    // Tracking
    (0,useDebounce/* default */.Z)(function() {
        var suggestionsCount = suggestions.filter(function(suggestion) {
            return validTypes.includes(suggestion.type);
        }).length;
        if (visible && suggestionsCount) trackSearchSuggestionsListed(suggestions.map(function(item) {
            return item.type;
        }).join(", "));
    }, 500, [
        suggestions,
        visible
    ]);
    (0,react.useEffect)(function() {
        var getPopularSearches = function() {
            var _ref = search_suggestions_asyncToGenerator(function() {
                var ref, response;
                return search_suggestions_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,requests/* graphql */.BX)((popular_searches_graphql_default()))
                            ];
                        case 1:
                            response = _state.sent();
                            setPopularSearches((response === null || response === void 0 ? void 0 : response.data) ? (ref = response.data) === null || ref === void 0 ? void 0 : ref.popularSearches : []);
                            return [
                                2
                            ];
                    }
                });
            });
            return function getPopularSearches() {
                return _ref.apply(this, arguments);
            };
        }();
        getPopularSearches();
    }, []);
    (0,react.useEffect)(function() {
        var searchInput = Array.from(document.querySelectorAll('[data-suggestions="search"]')).find(function(el) {
            return _instanceof(el, HTMLInputElement) && el.offsetParent !== null;
        });
        if (searchInput) setSearchInputElement(searchInput);
        var searchWrapper = Array.from(document.querySelectorAll('[data-suggestions="searchWrapper"]')).find(function(el) {
            return _instanceof(el, HTMLDivElement) && el.offsetParent !== null;
        });
        if (searchWrapper) setSearchWrapperElement(searchWrapper);
    }, [
        visible
    ]);
    var setCurrentSuggestion = (0,react.useCallback)(function(suggestion) {
        var modifiedQuery = "".concat(suggestion.text.trim(), " ");
        setQuery(modifiedQuery);
        if (!searchInputElement) return;
        searchInputElement.value = modifiedQuery;
        searchInputElement.dispatchEvent(new CustomEvent("change"));
    }, [
        searchInputElement,
        setQuery
    ]);
    var handleClickPopular = function(popularQuery) {
        setQuery(popularQuery.trim());
        onClose();
    };
    var handleClickSuggestion = (0,react.useCallback)(function() {
        var _ref = search_suggestions_asyncToGenerator(function(suggestion, index) {
            var push, linkToUrl, currentQuery;
            return search_suggestions_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        push = history.push;
                        if ((suggestion.type === "original" || !suggestion.text) && query.length < 2) {
                            // Don't redirect to the full page result for queries that are too short or not set. It will just fail.
                            return [
                                2
                            ];
                        }
                        setQuery(suggestion.text.trim());
                        return [
                            4,
                            constructNavigationUrl(suggestion, query)
                        ];
                    case 1:
                        linkToUrl = _state.sent();
                        trackSearchSuggestionInternalNavigationClicked(suggestion.type, index, linkToUrl || "");
                        switch(suggestion.__typename){
                            case "SuggestedVirtualCategory":
                            case "SuggestedCategory":
                            case "SuggestedShop":
                            case "SuggestedProduct":
                                {
                                    try {
                                        if (!linkToUrl) return [
                                            2
                                        ];
                                        onClose();
                                        push(linkToUrl);
                                        break;
                                    // eslint-disable-next-line no-empty
                                    } catch (e) {}
                                    break;
                                }
                            case "SuggestedSearchPhrase":
                                onClose();
                                (0,history_storage/* addRecentSearch */._)(suggestion.text);
                                push(linkToUrl);
                                break;
                            case "SuggestedBrand":
                                onClose();
                                push(linkToUrl);
                                break;
                            case "SuggestedProductCollection":
                                if (!linkToUrl) return [
                                    2
                                ];
                                onClose();
                                push(linkToUrl);
                                break;
                            case "SuggestedLandingPage":
                                if (!linkToUrl) {
                                    return [
                                        2
                                    ];
                                }
                                onClose();
                                push(linkToUrl);
                                break;
                            default:
                                {
                                    currentQuery = suggestion.navId === 0 ? query : suggestion.text;
                                    onClose();
                                    (0,history_storage/* addRecentSearch */._)(currentQuery);
                                    push(linkToUrl);
                                }
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(suggestion, index) {
            return _ref.apply(this, arguments);
        };
    }(), [
        history,
        onClose,
        query
    ]);
    var handleKeyPress = function(e) {
        if (!containerRef.current) {
            return;
        }
        var key = e.key || e.keyCode;
        var originalSuggestion = createOriginalSuggestion(query);
        var activeSuggestions = [
            originalSuggestion
        ].concat(_toConsumableArray(suggestions))// Sort based on `navId` for navigation to work when changing displayed order
        .sort(function(a, b) {
            return a.navId > b.navId ? 1 : -1;
        });
        switch(key){
            case "Enter":
            case 13:
                {
                    var suggestion = activeSuggestions.find(function(s) {
                        return s.navId === selected;
                    }) || originalSuggestion;
                    var index = activeSuggestions.indexOf(suggestion);
                    if (suggestion.text.length > 0) {
                        handleClickSuggestion(suggestion, index);
                        if (searchInputElement) {
                            searchInputElement.blur();
                        }
                        e.stopPropagation();
                    }
                    break;
                }
            case "ArrowRight":
            case 39:
                {
                    var suggestion1 = activeSuggestions.find(function(s) {
                        return s.navId === selected;
                    });
                    if (suggestion1 && searchInputElement && searchInputElement.selectionStart === searchInputElement.selectionEnd && searchInputElement.selectionStart === searchInputElement.value.length) {
                        searchInputElement.value = "".concat(suggestion1.text, " ");
                        searchInputElement.dispatchEvent(new CustomEvent("focus"));
                    }
                    break;
                }
            case "ArrowUp":
            case "ArrowDown":
            case 38:
            case 40:
                {
                    e.preventDefault();
                    var nextItem;
                    var currentIndex = activeSuggestions.findIndex(function(s) {
                        return s.navId === selected;
                    });
                    if (key === 40 || key === "ArrowDown") {
                        // ArrowDown
                        nextItem = activeSuggestions[(currentIndex + 1) % activeSuggestions.length];
                    } else {
                        // ArrowUp
                        var nextIndex = currentIndex - 1 === -1 ? activeSuggestions.length - 1 : currentIndex - 1;
                        nextItem = activeSuggestions[nextIndex];
                    }
                    if (nextItem) {
                        if (searchInputElement) {
                            if (nextItem.type === "SuggestedProductCollection") {
                                var text = extractFilter(nextItem).text;
                                searchInputElement.value = text ? "".concat(text, " ") : "".concat(nextItem.text, " ");
                            } else {
                                searchInputElement.value = "".concat(nextItem.text, " ");
                            }
                        }
                        setSelected(nextItem.navId);
                    }
                    break;
                }
            case "Escape":
            case "Esc":
            case 27:
                e.preventDefault();
                break;
            default:
                break;
        }
    };
    var handleExtendSearch = function(suggestion) {
        setCurrentSuggestion(suggestion);
        if (searchInputElement) {
            searchInputElement.focus();
        }
    };
    useEventListener("keydown", handleKeyPress);
    (0,useClickAway/* default */.Z)(containerRef, function(e) {
        var ref;
        if (isMobile) return;
        if (_instanceof(e.target, Node) && (searchInputElement === e.target || (updatedInputElement === null || updatedInputElement === void 0 ? void 0 : updatedInputElement.current) === e.target || (updatedSearchWrapperElement === null || updatedSearchWrapperElement === void 0 ? void 0 : (ref = updatedSearchWrapperElement.current) === null || ref === void 0 ? void 0 : ref.contains(e.target)) || (searchWrapperElement === null || searchWrapperElement === void 0 ? void 0 : searchWrapperElement.contains(e.target)))) {
            // It's the search bar, we don't want to close
            return;
        }
        onClose();
    });
    (0,react.useEffect)(function() {
        // Clear old suggestions when erasing input query
        if (query.length === 0) {
            setSuggestions((0,history_storage/* getRecentSearches */.KM)(LIMIT).map(createHistorySuggestion));
        }
    }, [
        query
    ]);
    (0,react.useEffect)(function() {
        // Reset selected state when query changed
        if (selected !== 0) {
            setSelected(0);
        }
    }, [
        query
    ]);
    // Fetch the regular price for all products
    // Fetched in client for performance optimisations
    (0,useDebounce/* default */.Z)(/*#__PURE__*/ search_suggestions_asyncToGenerator(function() {
        var productIds, ref, ref1, res;
        return search_suggestions_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    // Disable fetching of prices based on feature level
                    if (FEATURE_TOGGLE >= 1) return [
                        2
                    ];
                    productIds = suggestions.filter(function(s) {
                        return s.__typename === "SuggestedProduct";
                    }).map(function(p) {
                        return p.__typename === "SuggestedProduct" && Number(p.id);
                    });
                    if (!(productIds === null || productIds === void 0 ? void 0 : productIds.length)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0,requests/* graphql */.BX)("\n            query productPrices($ids: [Int!]!) {\n              products(ids: $ids, allowMissing: true) {\n                id\n                priceSummary {\n                  regular\n                }\n              }\n            }\n          ", {
                            ids: productIds
                        })
                    ];
                case 1:
                    res = _state.sent();
                    if (res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : (ref1 = ref.products) === null || ref1 === void 0 ? void 0 : ref1.length) {
                        setProducts(res.data.products.map(function(p) {
                            return {
                                id: p.id,
                                price: p.priceSummary.regular
                            };
                        }));
                    }
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    }), 100, [
        suggestions
    ]);
    (0,useDebounce/* default */.Z)(/*#__PURE__*/ search_suggestions_asyncToGenerator(function() {
        var myRequestCount, ref, res, e;
        return search_suggestions_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (query.length === 0 || !query.trim()) {
                        return [
                            2
                        ];
                    }
                    myRequestCount = requestCount.current + 1;
                    requestCount.current = myRequestCount;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,requests/* graphql */.BX)((query_graphql_default()), {
                            query: query
                        })
                    ];
                case 2:
                    res = _state.sent();
                    if (myRequestCount !== requestCount.current) {
                        // The response we're processing is not from the latest request, discard it
                        return [
                            2
                        ];
                    }
                    if ((ref = res.errors) === null || ref === void 0 ? void 0 : ref.length) {
                        setSuggestions((0,history_storage/* getRecentSearches */.KM)(LIMIT).filter(function(s) {
                            return filterHistory(s, query);
                        }).map(createHistorySuggestion));
                        return [
                            2
                        ];
                    }
                    if (res.data) {
                        setSuggestions(_toConsumableArray((0,history_storage/* getRecentSearches */.KM)(LIMIT).filter(function(s) {
                            return filterHistory(s, query);
                        }).map(createHistorySuggestion)).concat(_toConsumableArray(res.data.searchSuggestions.map(function(s, index) {
                            return _objectSpreadProps(search_suggestions_objectSpread({}, s), {
                                type: s.__typename,
                                // Make sure navigation in based on the actual order displayed
                                navId: (s.__typename ? SUGGESTION_ORDER[s.__typename] * 10 : 10) + index
                            });
                        }))));
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    captureException(e);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), 100, [
        query,
        market
    ]);
    var handleDeleteHistory = function(e, historyQuery) {
        e.stopPropagation();
        (0,history_storage/* deleteRecentSearch */.DS)(historyQuery);
        setSuggestions(function(prevState) {
            return _toConsumableArray(prevState.filter(function(item) {
                return item.__typename !== "history";
            })).concat(_toConsumableArray((0,history_storage/* getRecentSearches */.KM)(LIMIT).filter(function(s) {
                return filterHistory(s, query);
            }).map(createHistorySuggestion)));
        });
    };
    var handleClearHistory = function() {
        (0,history_storage/* clearRecentSearches */.lU)();
        setSuggestions(function(prevState) {
            return _toConsumableArray(prevState.filter(function(item) {
                return item.__typename !== "history";
            }));
        });
    };
    if (!visible || !suggestions.length && !popularSearches.length) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(SuggestionOverlay, {
        $visible: visible
    }), /*#__PURE__*/ react.createElement(SuggestionBox, {
        containerRef: containerRef
    }, popularSearches.length && !suggestions.find(function(s) {
        return Object.values(SuggestionTypeEnum).includes(// Check if suggestions includes any actual suggestion results
        // recast because TS won't allow this check to ever be falsy.
        s.__typename);
    }) ? /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(PopularSearchesTitle, null, t("search", "search.popular-searches")), /*#__PURE__*/ react.createElement(popular_searches/* PopularSearches */.S, {
        popularSearches: popularSearches,
        onClick: handleClickPopular
    })) : null, /*#__PURE__*/ react.createElement(SuggestionItems, {
        query: query,
        items: suggestions,
        handleClick: handleClickSuggestion,
        selectedId: selected,
        handleClearHistory: handleClearHistory,
        handleDeleteHistory: handleDeleteHistory,
        onExtendSearch: handleExtendSearch,
        products: products
    })));
};
/* harmony default export */ const search_suggestions = (search_suggestions_Suggestions);

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/chevron-left/index.js
var chevron_left = __webpack_require__(22062);
// EXTERNAL MODULE: ./src/components/no-scroll/index.tsx
var no_scroll = __webpack_require__(84874);
// EXTERNAL MODULE: ./src/components/search-bar/search-bar-context.tsx
var search_bar_context = __webpack_require__(31623);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 24 modules
var es = __webpack_require__(95939);
// EXTERNAL MODULE: ./src/areas/search/actions/search.js
var search = __webpack_require__(30400);
;// CONCATENATED MODULE: ./src/components/search-bar/index.tsx
function search_bar_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function search_bar_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function search_bar_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function search_bar_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function search_bar_slicedToArray(arr, i) {
    return search_bar_arrayWithHoles(arr) || search_bar_iterableToArrayLimit(arr, i) || search_bar_unsupportedIterableToArray(arr, i) || search_bar_nonIterableRest();
}
function search_bar_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return search_bar_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return search_bar_arrayLikeToArray(o, minLen);
}















var SearchBar = function(props) {
    var ref = (0,search_bar_context/* useSearchBarContext */.J)(), value = ref.value, setValue = ref.setValue, active = ref.active, setActive = ref.setActive, focused = ref.focused, setFocused = ref.setFocused;
    var _query = props.query, query = _query === void 0 ? "" : _query, selected = props.selected, _disabled = props.disabled, disabled = _disabled === void 0 ? false : _disabled, _visible = props.visible, visible = _visible === void 0 ? false : _visible, searchFocus = props.searchFocus, searchBlur = props.searchBlur;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var searchBarRef = (0,react.useRef)(null);
    var history = (0,react_router_dom/* useHistory */.k6)();
    var location = (0,react_router_dom/* useLocation */.TH)();
    var ref1 = search_bar_slicedToArray((0,react.useState)(query), 2), currentQuery = ref1[0], setCurrentQuery = ref1[1];
    var searchCriteria = currentQuery.length >= 2;
    var handleChange = function(e) {
        var newValue = e.target.value;
        setCurrentQuery(newValue);
        if (searchCriteria && !active) {
            setActive(true);
        }
    };
    (0,react.useEffect)(function() {
        if (!location.pathname.includes("/search")) {
            setCurrentQuery("");
            return;
        }
        var url = location.search;
        var searchParam = new URLSearchParams(url).get("search") || "";
        setCurrentQuery(searchParam);
    }, [
        location
    ]);
    (0,react.useEffect)(function() {
        if (!searchBarRef.current) {
            return;
        }
        if (!visible) {
            setValue(currentQuery);
            return;
        }
        if (focused) {
            searchBarRef.current.focus();
        }
    }, [
        focused,
        searchBarRef,
        visible
    ]);
    (0,react.useEffect)(function() {
        if (value !== currentQuery) {
            setCurrentQuery(value);
        }
    }, [
        value
    ]);
    var handleSubmit = function(e) {
        e.preventDefault();
        if (disabled || !searchCriteria) {
            return;
        }
        (0,history_storage/* addRecentSearch */._)(currentQuery);
        setFocused(false);
        setActive(false);
        history.push("/search?search=".concat(encodeURIComponent(currentQuery)));
    };
    var handleClearSearchClick = function() {
        setCurrentQuery("");
        focusSearchBar();
    };
    var blurSearchBar = function() {
        setActive(false);
        setFocused(false);
        searchBlur();
    };
    var focusSearchBar = function() {
        if (!searchBarRef.current) {
            return;
        }
        searchBarRef.current.focus();
        if (!active) {
            setActive(true);
            searchFocus();
        }
    };
    useEventListener("focus-search-event", function(e) {
        if (!e.detail.focus || !visible || !searchBarRef.current) {
            return;
        }
        focusSearchBar();
    });
    useEventListener("keyup", function(e) {
        var key = e.key || e.keyCode;
        var isTabKey = key === "Tab" || key === 9;
        var isEscKey = key === "Escape" || key === "Esc" || key === 27;
        if (isTabKey || isEscKey) {
            setActive(false);
        }
    });
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(SearchBarWrapper, {
        $active: active
    }, /*#__PURE__*/ react.createElement(SearchBarGroup, {
        $active: active,
        $visible: visible
    }, /*#__PURE__*/ react.createElement(CloseButton, {
        $visible: active,
        onClick: function() {
            return blurSearchBar();
        }
    }, /*#__PURE__*/ react.createElement(chevron_left.IconChevronLeft, {
        size: 30
    })), /*#__PURE__*/ react.createElement(StyledSearchBar, {
        $active: active
    }, /*#__PURE__*/ react.createElement(InputWrapper, {
        "data-suggestions": "searchWrapper"
    }, /*#__PURE__*/ react.createElement(variants.BodyMediumText, null, /*#__PURE__*/ react.createElement("form", {
        action: "/search",
        onSubmit: handleSubmit,
        role: "search"
    }, /*#__PURE__*/ react.createElement(SearchInput, {
        onKeyDown: function(e) {
            if (e.key === "Enter") {
                e.preventDefault();
                (0,tracking/* trackInternalNavigationClick */.p)({
                    scope: tracking/* InternalNavigationScope.QUICK_SEARCH */.U.QUICK_SEARCH,
                    nextPage: "/search?search=".concat(encodeURIComponent(currentQuery))
                });
            }
        },
        ref: searchBarRef,
        value: currentQuery,
        name: "search",
        "data-suggestions": "search",
        role: "combobox",
        "aria-expanded": focused && active,
        "aria-owns": focused || active ? "overlaySearchResults" : undefined,
        "aria-autocomplete": "both",
        "aria-activedescendant": selected ? "selection".concat(selected) : "",
        autoCorrect: "off",
        autoCapitalize: "off",
        autoComplete: "off",
        spellCheck: false,
        type: "search",
        placeholder: t("search", "search.placeholder"),
        onChange: handleChange,
        maxLength: 256,
        onFocus: function() {
            return setFocused(true);
        },
        onClick: function() {
            return focusSearchBar();
        }
    }))), /*#__PURE__*/ react.createElement(ClearButton, {
        show: currentQuery.length > 0,
        "data-test": "ClearSearchButton",
        "data-testid": "clear-search-button",
        onClick: function() {
            return handleClearSearchClick();
        }
    }, /*#__PURE__*/ react.createElement(ClearIcon, {
        size: 12
    }))), /*#__PURE__*/ react.createElement(SearchButton, {
        disabled: !searchCriteria,
        active: active && visible,
        onClick: function(e) {
            (0,tracking/* trackInternalNavigationClick */.p)({
                scope: tracking/* InternalNavigationScope.QUICK_SEARCH */.U.QUICK_SEARCH,
                nextPage: "/search?search=".concat(encodeURIComponent(currentQuery))
            });
            handleSubmit(e);
        },
        "data-test": "SearchButton",
        type: "button",
        "aria-label": t("header", "search.button")
    }, /*#__PURE__*/ react.createElement(SearchButtonText, null, /*#__PURE__*/ react.createElement(list_variants.Row, {
        gap: 0.5
    }, /*#__PURE__*/ react.createElement(SearchIcon, {
        size: 20
    }), /*#__PURE__*/ react.createElement(Text, {
        $visible: searchCriteria
    }, t("header", "search.button"))))))), /*#__PURE__*/ react.createElement(search_suggestions, {
        visible: active && visible,
        query: currentQuery,
        setQuery: function(newQuery) {
            return setCurrentQuery(newQuery);
        },
        onClose: function() {
            return blurSearchBar();
        },
        updatedInputElement: null,
        updatedSearchWrapperElement: null
    })), /*#__PURE__*/ react.createElement(no_scroll/* default */.Z, {
        mobile: true,
        enabled: active && visible
    }));
};
var dispatchActions = {
    searchFocus: search/* default.searchFocus */.ZP.searchFocus,
    searchBlur: search/* default.searchBlur */.ZP.searchBlur
};
/* harmony default export */ const search_bar = ((0,es/* connect */.$j)(null, dispatchActions)(SearchBar));


/***/ }),

/***/ 31623:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": () => (/* binding */ useSearchBarContext),
/* harmony export */   "t": () => (/* binding */ SearchBarProvider)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

var SearchBarContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    value: "",
    focused: false,
    active: false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setValue: function() {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setActive: function() {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setFocused: function() {}
});
var useSearchBarContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(SearchBarContext);
};
var SearchBarProvider = function(param) {
    var children = param.children;
    var ref = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""), 2), value = ref[0], updateValue = ref[1];
    var ref1 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), 2), focused = ref1[0], updateFocused = ref1[1];
    var ref2 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), 2), active = ref2[0], updateActive = ref2[1];
    var setValue = function(newValue) {
        updateValue(newValue);
    };
    var setActive = function(activeValue) {
        updateActive(activeValue);
    };
    var setFocused = function(focusedValue) {
        updateFocused(focusedValue);
    };
    var contextValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return {
            value: value,
            setValue: setValue,
            active: active,
            setActive: setActive,
            focused: focused,
            setFocused: setFocused
        };
    }, [
        active,
        focused,
        value
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SearchBarContext.Provider, {
        value: contextValue
    }, children);
};


/***/ }),

/***/ 12884:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ show_more)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
;// CONCATENATED MODULE: ./src/components/show-more/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      font-size: ",
        ";\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    color: ",
        ";\n    text-decoration: none;\n\n    &:hover {\n      color: ",
        ";\n      cursor: pointer;\n    }\n\n    ",
        "\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        " {\n        display: none;\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        " {\n        max-height: ",
        "px;\n        white-space: pre-line;\n        overflow: hidden;\n      }\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var Button = styled_components_browser_esm["default"].button.withConfig({
    displayName: "Button",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject1(), props.theme.text.callToAction, props.theme.text.callToActionHover, props.size === "small" && (0,styled_components_browser_esm.css)(_templateObject(), base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall));
});
var TextLabel = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TextLabel",
    componentId: "sc-0-1"
})(_templateObject2());
var Text = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Text",
    componentId: "sc-0-2"
})(_templateObject3());
var ShowMore = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ShowMore",
    componentId: "sc-0-3"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject6(), props.expanded && props.hideOnExpand && (0,styled_components_browser_esm.css)(_templateObject4(), Button), !props.expanded && (0,styled_components_browser_esm.css)(_templateObject5(), TextLabel, props.maxHeight));
});

;// CONCATENATED MODULE: ./src/components/show-more/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



var show_more_ShowMore = function(param) {
    var children = param.children, className = param.className, _hideOnExpand = param.hideOnExpand, hideOnExpand = _hideOnExpand === void 0 ? false : _hideOnExpand, maxHeight = param.maxHeight, _size = param.size, size = _size === void 0 ? "normal" : _size, textIdentifier = param.textIdentifier;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref = _slicedToArray((0,react.useState)(false), 2), expanded = ref[0], setExpanded = ref[1];
    var ref1 = _slicedToArray((0,react.useState)(false), 2), showMore = ref1[0], setShowMore = ref1[1];
    var collapseOrExpand = expanded ? "symbol.collapse" : "symbol.expand";
    var expansionText = expanded ? t("common", "button.show-less") : t("common", "button.show-more");
    var textNode = (0,react.useCallback)(function(node) {
        if (node && node.parentElement) {
            var textHeight = node.getBoundingClientRect().height;
            var wrapperHeight = node.parentElement.getBoundingClientRect().height;
            setShowMore(textHeight > wrapperHeight);
        }
    }, []);
    var toggleExpansion = (0,react.useCallback)(function() {
        setExpanded(!expanded);
    }, [
        expanded
    ]);
    return /*#__PURE__*/ react.createElement(ShowMore, {
        className: className,
        expanded: expanded,
        hideOnExpand: hideOnExpand,
        maxHeight: maxHeight
    }, /*#__PURE__*/ react.createElement(TextLabel, null, /*#__PURE__*/ react.createElement(Text, {
        ref: textNode
    }, children)), showMore && /*#__PURE__*/ react.createElement(Button, {
        onClick: toggleExpansion,
        "aria-label": t("symbols", collapseOrExpand),
        "aria-expanded": expanded,
        "aria-controls": textIdentifier,
        size: size
    }, expansionText));
};
/* harmony default export */ const show_more = (/*#__PURE__*/(0,react.memo)(show_more_ShowMore));


/***/ }),

/***/ 70867:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zN": () => (/* reexport */ SkeletonMedia),
  "Bp": () => (/* reexport */ skeleton_paragraph_SkeletonParagraph)
});

// UNUSED EXPORTS: SkeletonCircle, SkeletonText

// EXTERNAL MODULE: ./src/components/skeleton/skeleton-text.tsx
var skeleton_text = __webpack_require__(7187);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/skeleton/styled.tsx
var styled = __webpack_require__(33132);
;// CONCATENATED MODULE: ./src/components/skeleton/skeleton-paragraph.tsx


var skeleton_paragraph_SkeletonParagraph = function(param) {
    var _count = param.count, count = _count === void 0 ? 1 : _count, circle = param.circle, height = param.height, width = param.width, _children = param.children, children = _children === void 0 ? /*#__PURE__*/ react.createElement(react.Fragment, null, "‌") : _children, flex = param.flex, paused = param.paused;
    var elements = [];
    for(var i = 0; i < count; i += 1){
        var elementWidth = count > 1 ? getVariableLength(i) : width;
        var style = {
            height: height,
            width: elementWidth
        };
        if (circle) {
            style.borderRadius = "50%";
            if (!width && !height) {
                style.width = "1em";
                style.height = "1em";
            }
        }
        elements.push(/*#__PURE__*/ react.createElement(react.Fragment, {
            key: i
        }, /*#__PURE__*/ react.createElement(styled/* SkeletonFrame */.p, {
            key: i,
            style: style,
            flex: flex,
            paused: paused
        }, children), count > 1 && /*#__PURE__*/ react.createElement("br", null)));
    }
    return /*#__PURE__*/ react.createElement(react.Fragment, null, elements);
};
function getVariableLength(i) {
    var width = 100;
    width = i % 2 === 0 ? 70 : width;
    width = i % 3 === 0 ? 80 : width;
    width = i % 5 === 0 ? 60 : width;
    width = i === 0 ? 90 : width;
    return "".concat(width, "%");
}

;// CONCATENATED MODULE: ./src/components/skeleton/skeleton-media.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}


var SkeletonMedia = function(props) {
    return /*#__PURE__*/ react.createElement(skeleton_paragraph_SkeletonParagraph, _extends({}, props, {
        flex: true
    }));
};

;// CONCATENATED MODULE: ./src/components/skeleton/skeleton-circle.tsx


var SkeletonCircle = function(props) {
    return /*#__PURE__*/ React.createElement(SkeletonParagraph, {
        height: props.diameter,
        width: props.diameter,
        circle: true,
        paused: props.paused
    });
};

;// CONCATENATED MODULE: ./src/components/skeleton/index.ts







/***/ }),

/***/ 7187:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": () => (/* binding */ SkeletonText)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33132);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}


var SkeletonText = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styled__WEBPACK_IMPORTED_MODULE_1__/* .SkeletonFrame */ .p, _extends({}, props));
};


/***/ }),

/***/ 33132:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": () => (/* binding */ SkeletonFrame)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71993);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61093);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  0% {\n    background-position: -200px 0;\n  }\n  100% {\n    background-position: calc(200px + 100%) 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  background-image: linear-gradient(\n    90deg,\n    ",
        ",\n    ",
        ",\n    ",
        "\n  );\n  background-size: 200px 100%;\n  background-repeat: no-repeat;\n  border-radius: 4px;\n  line-height: 1;\n  width: ",
        ";\n  height: ",
        ";\n  animation: ",
        " 1.2s ease-in-out infinite;\n  ",
        "\n  display: inline-block;\n  ",
        "\n  ",
        "\n\n  @media (prefers-reduced-motion) {\n    animation: none;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var skeletonKeyframes = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.keyframes)(_templateObject());
var _width, _height;
var SkeletonFrame = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({
    displayName: "SkeletonFrame",
    componentId: "sc-0-0"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.base0;
}, function(param) {
    var theme = param.theme;
    return theme.colors.base0;
}, function(param) {
    var theme = param.theme;
    return theme.colors.base100;
}, function(param) {
    var theme = param.theme;
    return theme.colors.base0;
}, function(p) {
    return (_width = p.width) !== null && _width !== void 0 ? _width : "100%";
}, function(p) {
    return (_height = p.height) !== null && _height !== void 0 ? _height : "1em";
}, skeletonKeyframes, function(p) {
    return p.paused && "animation-play-state: paused;";
}, function(p) {
    return p.marginBottom && "margin-bottom: ".concat(src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements */ .bK.measurements[p.marginBottom], ";");
}, function(p) {
    return p.flex && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject1());
});


/***/ }),

/***/ 56627:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": () => (/* reexport */ Spinner)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
;// CONCATENATED MODULE: ./src/components/spinner/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    0% {\n      transform: rotate(0) ",
        ";\n    }\n    100% {\n      transform: rotate(360deg) ",
        ";\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    0% {\n      transform: rotate(0) ",
        ";\n    }\n    100% {\n      transform: rotate(360deg) ",
        ";\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    0% {\n      transform: rotate(0) ",
        ";\n    }\n    100% {\n      transform: rotate(360deg) ",
        ";\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      transform-origin: 50% 0;\n      animation: ",
        " 0.6s infinite linear;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      left: 10px;\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n      right: 10px;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n      left: 50%;\n      transform-origin: 0 0;\n      animation: ",
        " 0.6s infinite linear;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      animation: ",
        " 0.6s infinite linear;\n      position: relative;\n      left: 0;\n      top: 0;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  border-radius: 50%;\n  display: block;\n  border: solid rgba(0, 0, 0, 0.2);\n  border-top-color: ",
        ";\n  position: absolute;\n  top: 50%;\n  ",
        "\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}

var translate = "translate3d(0, -50%, 0)";
var translateCenter = "translate3d(-50%, -50%, 0)";
var translateNone = "translate3d(0, 0, 0)";
var spin = (0,styled_components_browser_esm.keyframes)(_templateObject(), translate, translate);
var spinCenter = (0,styled_components_browser_esm.keyframes)(_templateObject1(), translateCenter, translateCenter);
var spinNone = (0,styled_components_browser_esm.keyframes)(_templateObject2(), translateNone, translateNone);
var StyledSpinner = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledSpinner",
    componentId: "sc-0-0"
})(_templateObject8(), function(p) {
    return p.theme.colors.base0;
}, function(p) {
    return (p.position === "left" || p.position === "right") && (0,styled_components_browser_esm.css)(_templateObject3(), spin);
}, function(p) {
    return p.position === "left" && (0,styled_components_browser_esm.css)(_templateObject4());
}, function(p) {
    return p.position === "right" && (0,styled_components_browser_esm.css)(_templateObject5());
}, function(p) {
    return p.position === "center" && (0,styled_components_browser_esm.css)(_templateObject6(), spinCenter);
}, function(p) {
    return p.position === "none" && (0,styled_components_browser_esm.css)(_templateObject7(), spinNone);
});

;// CONCATENATED MODULE: ./src/components/spinner/spinner.tsx


var getSpinnerSize = function(size) {
    return {
        height: size,
        width: size,
        borderWidth: spinnerBorderWidth(size)
    };
};
var spinnerBorderWidth = function(size) {
    if (size < 18) {
        return 2;
    }
    if (size > 36) {
        return 6;
    }
    return 4;
};
var Spinner = function(param) {
    var _isActive = param.isActive, isActive = _isActive === void 0 ? false : _isActive, _position = param.position, position = _position === void 0 ? "center" : _position, _size = param.size, size = _size === void 0 ? 24 : _size;
    var spinnerSize = getSpinnerSize(size);
    return isActive ? /*#__PURE__*/ react.createElement(StyledSpinner, {
        style: spinnerSize,
        position: position
    }) : null;
};

;// CONCATENATED MODULE: ./src/components/spinner/index.ts




/***/ }),

/***/ 43344:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ static_intercom)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 24 modules
var es = __webpack_require__(95939);
// EXTERNAL MODULE: ./src/components/spinner/index.ts + 2 modules
var spinner = __webpack_require__(56627);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/areas/feedback/actions/index.js
var actions = __webpack_require__(6416);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
// EXTERNAL MODULE: ./src/ui/zindex/index.ts
var zindex = __webpack_require__(93497);
;// CONCATENATED MODULE: ./src/components/static-intercom/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  width: 48px;\n  height: 48px;\n  cursor: pointer;\n  transform-origin: center center;\n  backface-visibility: hidden;\n  border-radius: 50%;\n  overflow: hidden;\n  background-color: ",
        ";\n  box-shadow: 0px 0px 25px 0px rgba(184, 184, 184, 0.5);\n  outline: none;\n  z-index: ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 0px;\n  bottom: 0px;\n  width: 100%;\n  opacity: 1;\n  transform: rotate(0deg) scale(1);\n  transition: transform 0.4s ease 0.2s;\n  cursor: pointer;\n\n  > svg {\n    width: 24px;\n    height: 24px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var Wrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-0"
})(_templateObject1(), function(p) {
    return p.theme.colors.maybeBlue500;
}, zindex/* zindex.modal */.Y.modal, base/* media.mediumDown */.BC.mediumDown(_templateObject()));
var Icon = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Icon",
    componentId: "sc-0-1"
})(_templateObject2());

;// CONCATENATED MODULE: ./src/components/static-intercom/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}







var LoadState;
(function(LoadState) {
    LoadState[LoadState["Init"] = 0] = "Init";
    LoadState[LoadState["Loading"] = 1] = "Loading";
    LoadState[LoadState["Failed"] = 2] = "Failed";
    LoadState[LoadState["Loaded"] = 3] = "Loaded";
})(LoadState || (LoadState = {}));
var StaticIntercom = function(param) {
    var open = param.open, startChat = param.startChat, customButton = param.customButton;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), lazyLoadIntercom = ref.market.lazyLoadIntercom;
    var ref1 = _slicedToArray((0,react.useState)(LoadState.Init), 2), loadState = ref1[0], setLoadState = ref1[1];
    var load = (0,react.useCallback)(function() {
        // Prevent queueing up multiple load events
        if (loadState === LoadState.Loading) return;
        // If Intercom hasnt been loaded in 5 seconds, it probably
        // means the client is preventing it from loading (AdBlock)
        if (![
            LoadState.Loaded,
            LoadState.Failed
        ].includes(loadState)) {
            setTimeout(function() {
                if (!window.Intercom) {
                    setLoadState(LoadState.Failed);
                    open();
                }
            }, 5000);
        }
        window.onIntercomLoadedCb = function(successful) {
            // If intercom fails to load, open up feedback dialog
            if (!successful) {
                open();
                setLoadState(LoadState.Failed);
            } else {
                setLoadState(LoadState.Loaded);
            }
            window.onIntercomLoadedCb = undefined;
        };
        switch(loadState){
            case LoadState.Init:
                {
                    setLoadState(LoadState.Loading);
                    startChat();
                    break;
                }
            case LoadState.Failed:
                {
                    open();
                    break;
                }
            case LoadState.Loaded:
                {
                    startChat();
                    break;
                }
            default:
                {
                    break;
                }
        }
    }, [
        loadState,
        open,
        startChat
    ]);
    var location = (0,react_router_dom/* useLocation */.TH)();
    (0,react.useEffect)(function() {
        if (/[?&]intercom=open(&|$)/.test(location.search)) {
            load();
        }
    }, [
        load,
        location.search
    ]);
    if (!customButton) {
        if (loadState === LoadState.Loaded || !lazyLoadIntercom) {
            return null;
        }
    }
    if (customButton) {
        return /*#__PURE__*/ react.createElement(customButton.type, _extends({}, customButton.props, {
            role: "button",
            tabIndex: 0,
            onClick: load
        }), loadState !== LoadState.Loading && customButton.props.children, /*#__PURE__*/ react.createElement(spinner/* Spinner */.$, {
            isActive: loadState === LoadState.Loading,
            position: "none"
        }));
    }
    return /*#__PURE__*/ react.createElement(Wrapper, {
        role: "button",
        tabIndex: 0,
        onClick: load
    }, /*#__PURE__*/ react.createElement(spinner/* Spinner */.$, {
        isActive: loadState === LoadState.Loading
    }), /*#__PURE__*/ react.createElement(Icon, {
        className: "intercom-46iydq e2ujk8f1"
    }, /*#__PURE__*/ react.createElement("svg", {
        focusable: "false",
        "aria-hidden": "true",
        viewBox: "0 0 28 32"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: loadState === LoadState.Loading ? "rgba(255,255,255,0.4)" : "#fff",
        d: "M28,32 C28,32 23.2863266,30.1450667 19.4727818,28.6592 L3.43749107,28.6592 C1.53921989,28.6592 0,27.0272 0,25.0144 L0,3.6448 C0,1.632 1.53921989,0 3.43749107,0 L24.5615088,0 C26.45978,0 27.9989999,1.632 27.9989999,3.6448 L27.9989999,22.0490667 L28,22.0490667 L28,32 Z M23.8614088,20.0181333 C23.5309223,19.6105242 22.9540812,19.5633836 22.5692242,19.9125333 C22.5392199,19.9392 19.5537934,22.5941333 13.9989999,22.5941333 C8.51321617,22.5941333 5.48178311,19.9584 5.4277754,19.9104 C5.04295119,19.5629428 4.46760991,19.6105095 4.13759108,20.0170667 C3.97913051,20.2124916 3.9004494,20.4673395 3.91904357,20.7249415 C3.93763774,20.9825435 4.05196575,21.2215447 4.23660523,21.3888 C4.37862552,21.5168 7.77411059,24.5386667 13.9989999,24.5386667 C20.2248893,24.5386667 23.6203743,21.5168 23.7623946,21.3888 C23.9467342,21.2215726 24.0608642,20.9827905 24.0794539,20.7254507 C24.0980436,20.4681109 24.0195551,20.2135019 23.8614088,20.0181333 Z"
    }))));
};
/* harmony default export */ const static_intercom = ((0,es/* connect */.$j)(undefined, actions/* default */.ZP)(/*#__PURE__*/ react.memo(StaticIntercom)));


/***/ }),

/***/ 72433:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": () => (/* binding */ NAV_HEIGHT_WITH_MARGIN),
/* harmony export */   "n": () => (/* binding */ NAV_HEIGHT)
/* harmony export */ });
var NAV_HEIGHT = 55;
var NAV_HEIGHT_WITH_MARGIN = NAV_HEIGHT + 16;


/***/ }),

/***/ 20132:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g": () => (/* binding */ StickyTabNavigation)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/scroll-handler/index.ts
var scroll_handler = __webpack_require__(14984);
// EXTERNAL MODULE: ./src/components/sticky-tab-nav/constants.ts
var constants = __webpack_require__(72433);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
// EXTERNAL MODULE: ./src/components/tabs-new/index.tsx + 1 modules
var tabs_new = __webpack_require__(56901);
// EXTERNAL MODULE: ./src/ui/zindex/index.ts
var zindex = __webpack_require__(93497);
;// CONCATENATED MODULE: ./src/components/sticky-tab-nav/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      z-index: ",
        ";\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      top: ",
        ";\n      height: ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    position: sticky;\n    top: ",
        ";\n    background: ",
        ";\n    z-index: ",
        ";\n    ",
        ";\n    height: ",
        ";\n\n    ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var SPACE_FOR_HEADER_MARGIN = 4;
var Tabs = (0,styled_components_browser_esm["default"])(tabs_new/* Tabs */.m).withConfig({
    displayName: "Tabs",
    componentId: "sc-0-0"
})(function(p) {
    return (0,styled_components_browser_esm.css)(_templateObject2(), p.$headerIsVisible ? base/* layout.headerHeight.desktop.rem */.bK.headerHeight.desktop.rem : 0, p.theme.bg.primary, zindex/* zindex.menu.sticky.normal */.Y.menu.sticky.normal, p.background && (0,styled_components_browser_esm.css)(_templateObject(), p.isSticky ? zindex/* zindex.menu.sticky.background.isSticky */.Y.menu.sticky.background.isSticky : zindex/* zindex.menu.sticky.background.default */.Y.menu.sticky.background["default"]), "".concat(constants/* NAV_HEIGHT */.n, "px"), base/* media.smallOnly */.BC.smallOnly(_templateObject1(), p.$headerIsVisible ? base/* layout.headerHeight.mobile.rem */.bK.headerHeight.mobile.rem : 0, "".concat(constants/* NAV_HEIGHT */.n - SPACE_FOR_HEADER_MARGIN, "px")));
});

// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(58912);
;// CONCATENATED MODULE: ./src/components/sticky-tab-nav/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}






var StickyTabNavigation = function(props) {
    var background = props.background, defaultActiveTabId = props.defaultActiveTabId, _headerIsVisible = props.headerIsVisible, headerIsVisible = _headerIsVisible === void 0 ? true : _headerIsVisible, onClick = props.onClick, _shouldScrollOnClick = props.shouldScrollOnClick, shouldScrollOnClick = _shouldScrollOnClick === void 0 ? true : _shouldScrollOnClick, tabs = props.tabs;
    var location = (0,react_router_dom/* useLocation */.TH)();
    var ref = _slicedToArray((0,react.useState)(defaultActiveTabId), 2), _activeTab = ref[0], _setActiveTab = ref[1];
    var ref1 = _slicedToArray((0,react.useState)(false), 2), _scrollOngoing = ref1[0], _setScrollOngoing = ref1[1];
    var ref2 = _slicedToArray((0,react.useState)(false), 2), isSticky = ref2[0], setIsSticky = ref2[1];
    var activeTab = (0,react.useRef)(_activeTab);
    var scrollOngoing = (0,react.useRef)(_scrollOngoing);
    var tabsRef = (0,react.useRef)(null);
    var sensitivity = 100;
    var setActiveTab = (0,react.useCallback)(function(data) {
        activeTab.current = data;
        _setActiveTab(data);
    }, []);
    (0,react.useEffect)(function() {
        activeTab.current = defaultActiveTabId;
        setActiveTab(defaultActiveTabId);
    }, [
        defaultActiveTabId,
        setActiveTab
    ]);
    var setScrollOngoing = (0,react.useCallback)(function(data) {
        scrollOngoing.current = data;
        _setScrollOngoing(data);
    }, []);
    var handleScrollOngoingState = (0,react.useCallback)(function(element) {
        if (activeTab.current === element.id && window.scrollY >= element.position && window.scrollY <= element.positionEnd) setScrollOngoing(false);
    }, [
        setScrollOngoing
    ]);
    var handleActiveStateOnClick = (0,react.useCallback)(function(tab, index) {
        setActiveTab(tab);
        if (shouldScrollOnClick) setScrollOngoing(true);
        if (onClick) onClick(tab);
        trackTabClick(tab, index);
    }, [
        onClick,
        shouldScrollOnClick,
        setActiveTab,
        setScrollOngoing
    ]);
    var trackTabClick = function(newHash, index) {
        var urlWithoutHash = location.pathname + location.search;
        (0,tracking/* trackInternalNavigationClick */.p)({
            scope: tracking/* InternalNavigationScope.TAB_BAR */.U.TAB_BAR,
            currentPage: urlWithoutHash + location.hash,
            nextPage: urlWithoutHash + newHash,
            index: index
        });
    };
    var handleActiveStateOnScroll = (0,react.useCallback)(function() {
        var newStickyValue = window.scrollY >= (0,scroll_handler/* getScrollPositionFromElement */.o)(tabsRef.current, 0);
        if (newStickyValue !== isSticky) {
            setIsSticky(newStickyValue);
        }
        var tabElements = tabs.map(function(tab) {
            var element = document.getElementById(tab.id);
            var position = (0,scroll_handler/* getScrollPositionFromElement */.o)(element, constants/* NAV_HEIGHT_WITH_MARGIN */.g);
            return {
                element: element,
                position: position,
                id: tab.id
            };
        }).map(function(element, index, array) {
            return _objectSpreadProps(_objectSpread({}, element), {
                positionEnd: array[index + 1] ? array[index + 1].position - 1 : document.body.scrollHeight
            });
        });
        tabElements.map(function(element) {
            if (!element.position) return null;
            // If there's an ongoing tab click scrollTo, do not change tab active state.
            if (scrollOngoing.current) {
                return handleScrollOngoingState(element);
            }
            // Sets active tab based on scroll position for manual scroll.
            if (activeTab.current !== element.id && window.scrollY + sensitivity >= element.position) {
                return setActiveTab(element.id);
            }
            // Set active tab to default if scroll position is lower than defaultActiveTab position
            if (activeTab.current !== element.id && element.id === defaultActiveTabId && window.scrollY < element.position) {
                return setActiveTab(defaultActiveTabId);
            }
            return null;
        });
    }, [
        setActiveTab,
        handleScrollOngoingState,
        tabs,
        defaultActiveTabId,
        isSticky
    ]);
    var allTabs = tabs.map(function(tab) {
        return _objectSpreadProps(_objectSpread({}, tab), {
            active: tab.id === activeTab.current,
            to: "".concat(location.pathname).concat(location.search).concat(tab.id)
        });
    });
    if (allTabs.length <= 1) return null;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, shouldScrollOnClick && /*#__PURE__*/ react.createElement(scroll_handler/* ScrollHandler */.Y, {
        onScrollCallback: handleActiveStateOnScroll,
        topMargin: constants/* NAV_HEIGHT_WITH_MARGIN */.g
    }), /*#__PURE__*/ react.createElement(Tabs, {
        background: background,
        isSticky: background && isSticky,
        onClick: handleActiveStateOnClick,
        ref: tabsRef,
        tabs: allTabs,
        $headerIsVisible: headerIsVisible
    }));
};


/***/ }),

/***/ 74233:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": () => (/* binding */ stock_status_StockStatus)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/stock-incoming/index.js
var stock_incoming = __webpack_require__(32095);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/stock-in-stock/index.js
var stock_in_stock = __webpack_require__(39306);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/stock-out-of-stock/index.js
var stock_out_of_stock = __webpack_require__(75295);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/stock-unknown/index.js
var stock_unknown = __webpack_require__(51890);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/index.js
var ui = __webpack_require__(54262);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/tooltip/index.js
var tooltip = __webpack_require__(714);
;// CONCATENATED MODULE: ./src/components/stock-status/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  min-height: 1.5rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: start;\n  flex-direction: column;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  text-align: left;\n  color: ",
        ";\n  &::first-letter {\n    text-transform: capitalize;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 0 0 auto;\n  *:first-child {\n    &::first-letter {\n      text-transform: capitalize;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  border-radius: 50%;\n  height: 10px;\n  width: 10px;\n  margin: 5px;\n  ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var StockStatus = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StockStatus",
    componentId: "sc-0-0"
})(_templateObject());
var IconAndText = styled_components_browser_esm["default"].div.withConfig({
    displayName: "IconAndText",
    componentId: "sc-0-1"
})(_templateObject1());
var Text = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Text",
    componentId: "sc-0-2"
})(_templateObject2(), function(props) {
    return !props.toneDown ? props.theme.colors.base500 : props.theme.colors.base600;
});
var Tooltip = (0,styled_components_browser_esm["default"])(tooltip/* Tooltip */.u).withConfig({
    displayName: "Tooltip",
    componentId: "sc-0-3"
})(_templateObject3());
var getIconStyling = function(theme, status, toneDown) {
    switch(status){
        case "in_stock_preorder":
        case "incoming":
            return "background-color: ".concat(theme.colors.base0, "; box-shadow: inset 0 0 0 2px ").concat(toneDown ? theme.colors.base300 : theme.colors.positive500);
        case "in_stock":
            return toneDown ? "background-color: ".concat(theme.colors.base200) : "background-color: ".concat(theme.colors.positive500);
        case "not_in_stock":
            return toneDown ? "background-color: ".concat(theme.colors.base200) : "background-color: ".concat(theme.colors.negative700);
        default:
            return toneDown ? "background-color: ".concat(theme.colors.base200, ";") : "background-color: ".concat(theme.colors.base500);
    }
};
var Icon = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Icon",
    componentId: "sc-0-4"
})(_templateObject4(), function(props) {
    return getIconStyling(props.theme, props.status, props.toneDown);
});

;// CONCATENATED MODULE: ./src/components/stock-status/index.tsx








var stock_status_StockStatus = /*#__PURE__*/ (0,react.memo)(function(props) {
    var className = props.className, size = props.size, status = props.status, statusText = props.statusText, tooltip = props.tooltip, _tooltipPlacement = props.tooltipPlacement, tooltipPlacement = _tooltipPlacement === void 0 ? ui/* Direction.Left */.Nm.Left : _tooltipPlacement, _featuredOffer = props.featuredOffer, featuredOffer = _featuredOffer === void 0 ? true : _featuredOffer;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var renderIconComponent = function(featured) {
        switch(status){
            case "in_stock_preorder":
            case "incoming":
                return /*#__PURE__*/ react.createElement(stock_incoming/* IconStockIncoming */.T, {
                    size: size,
                    color: featured ? "yellove700" : "base400"
                });
            case "in_stock":
                return /*#__PURE__*/ react.createElement(stock_in_stock/* IconStockInStock */.l, {
                    size: size,
                    color: featured ? "positive500" : "base400"
                });
            case "not_in_stock":
                return /*#__PURE__*/ react.createElement(stock_out_of_stock/* IconStockOutOfStock */.Y, {
                    size: size,
                    color: featured ? "redio700" : "base400"
                });
            default:
                return /*#__PURE__*/ react.createElement(stock_unknown/* IconStockUnknown */.v, {
                    size: size,
                    color: "base400"
                });
        }
    };
    var getStatusText = function() {
        if (status === "incoming" && statusText) {
            return statusText.replace(/-/g, "‑"); // Replace hyphen with hard hyphen to prevent row break in date (Eg in 2019-08-10).
        }
        return t("product", "stock-status.".concat(status || "unknown"));
    };
    return /*#__PURE__*/ react.createElement(Tooltip, {
        placement: tooltipPlacement,
        title: tooltip === true ? getStatusText() : tooltip,
        className: className,
        renderOnMouseOver: true
    }, /*#__PURE__*/ react.createElement(IconAndText, null, renderIconComponent(featuredOffer)));
});


/***/ }),

/***/ 19247:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Xv": () => (/* binding */ StoreLogo),
/* harmony export */   "mA": () => (/* reexport safe */ _styles__WEBPACK_IMPORTED_MODULE_3__.mA),
/* harmony export */   "uZ": () => (/* reexport safe */ _styles__WEBPACK_IMPORTED_MODULE_3__.uZ)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var src_components_cdn_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23437);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71016);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97659);





var StoreLogo = function(param) {
    var className = param.className, _featured = param.featured, featured = _featured === void 0 ? false : _featured, hasImage = param.hasImage, logoUrl = param.logoUrl, name = param.name, _showHighResolutionLogo = param.showHighResolutionLogo, showHighResolutionLogo = _showHighResolutionLogo === void 0 ? false : _showHighResolutionLogo, storeId = param.storeId, _variant = param.variant, variant = _variant === void 0 ? _styles__WEBPACK_IMPORTED_MODULE_3__/* .StoreLogoVariant.DEFAULT */ .mA.DEFAULT : _variant, _width = param.width, width = _width === void 0 ? 88 : _width;
    var shouldRenderLogo = hasImage && (featured || variant === _styles__WEBPACK_IMPORTED_MODULE_3__/* .StoreLogoVariant.CAMPAIGN */ .mA.CAMPAIGN);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_3__/* .StoreLogo */ .Xv, {
        className: className,
        logoWidth: width,
        showHighResolutionLogo: showHighResolutionLogo,
        showLogo: shouldRenderLogo,
        variant: variant
    }, shouldRenderLogo ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_cdn_image__WEBPACK_IMPORTED_MODULE_1__/* .CdnImage */ .l, {
        name: storeId,
        width: width,
        alt: name,
        logoUrl: logoUrl
    }) : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_3__/* .StoreLogoText */ .sd, {
        emphasis: _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_2__.FontEmphasis.LOW
    }, name));
};


/***/ }),

/***/ 97659:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Xv": () => (/* binding */ StoreLogo),
/* harmony export */   "mA": () => (/* binding */ StoreLogoVariant),
/* harmony export */   "sd": () => (/* binding */ StoreLogoText),
/* harmony export */   "uZ": () => (/* binding */ DEFAULT_STORE_LOGO_MAX_WIDTH)
/* harmony export */ });
/* unused harmony export campaignImageHeight */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71993);
/* harmony import */ var styled_tools__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55703);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61093);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71016);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 12px;\n  line-height: 1.3em;\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  max-height: ",
        "px;\n  overflow: hidden;\n  align-items: normal;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    font-size: 12px;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 10px;\n  color: ",
        ";\n  max-width: 100%;\n  height: ",
        "px;\n  line-height: ",
        "px;\n  padding: 0 4px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  text-align: center;\n  border: 1px solid ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  text-decoration: underline;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n      max-width: ",
        "px;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    max-width: ",
        "px;\n\n    ",
        ";\n\n    ",
        ";\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: normal;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}




var DEFAULT_STORE_LOGO_MAX_WIDTH = 68;
var DEFAULT_STORE_LOGO_MAX_HEIGHT = 31;
var StoreLogoVariant;
(function(StoreLogoVariant) {
    StoreLogoVariant["DEFAULT"] = "DEFAULT";
    StoreLogoVariant["CAMPAIGN"] = "CAMPAIGN";
    StoreLogoVariant["HEADING"] = "HEADING";
    StoreLogoVariant["REVIEWS"] = "REVIEWS";
    StoreLogoVariant["PRICE_LIST"] = "PRICE_LIST";
})(StoreLogoVariant || (StoreLogoVariant = {}));
var campaignImageHeight = 31;
var defaultNoLogoCss = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject());
var priceListNoLogoCss = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject1(), defaultNoLogoCss, DEFAULT_STORE_LOGO_MAX_HEIGHT);
var campaignNoLogoCss = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject3(), function(p) {
    return p.theme.colors.base700;
}, campaignImageHeight, campaignImageHeight, function(p) {
    return p.theme.colors.base200;
}, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.mediumUp */ .BC.mediumUp(_templateObject2()));
var reviewsNoLogoCss = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject4(), function(p) {
    return p.theme.colors.maybeBlue700;
});
var StoreLogo = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "StoreLogo",
    componentId: "sc-0-0"
})(function(props) {
    var _obj;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject6(), props.showHighResolutionLogo ? props.logoWidth / 2 : props.logoWidth, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .media.smallOnly */ .BC.smallOnly(_templateObject5(), props.showHighResolutionLogo ? DEFAULT_STORE_LOGO_MAX_WIDTH : props.logoWidth), (0,styled_tools__WEBPACK_IMPORTED_MODULE_1__/* .ifNotProp */ .Zn)("showLogo", (0,styled_tools__WEBPACK_IMPORTED_MODULE_1__/* .switchProp */ .db)("variant", (_obj = {}, _defineProperty(_obj, StoreLogoVariant.DEFAULT, defaultNoLogoCss), _defineProperty(_obj, StoreLogoVariant.HEADING, defaultNoLogoCss), _defineProperty(_obj, StoreLogoVariant.PRICE_LIST, priceListNoLogoCss), _defineProperty(_obj, StoreLogoVariant.CAMPAIGN, campaignNoLogoCss), _defineProperty(_obj, StoreLogoVariant.REVIEWS, reviewsNoLogoCss), _obj))));
});
var StoreLogoText = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_3__.CaptionText).withConfig({
    displayName: "StoreLogoText",
    componentId: "sc-0-1"
})(_templateObject7());


/***/ }),

/***/ 83563:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_L": () => (/* binding */ getGroupedPaymentProviders),
  "V7": () => (/* binding */ getPaymentOptions),
  "Qk": () => (/* binding */ getPaymentProviders)
});

;// CONCATENATED MODULE: ./src/components/store-payment/types.ts
var PaymentProviderGroup;
(function(PaymentProviderGroup) {
    PaymentProviderGroup[PaymentProviderGroup["Direct"] = 0] = "Direct";
    PaymentProviderGroup[PaymentProviderGroup["Invoice"] = 1] = "Invoice";
    PaymentProviderGroup[PaymentProviderGroup["Card"] = 2] = "Card";
})(PaymentProviderGroup || (PaymentProviderGroup = {}));

;// CONCATENATED MODULE: ./src/components/store-payment/utils.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

var PAYMENT_GROUP_SETTINGS = [
    {
        group: PaymentProviderGroup.Invoice,
        count: 1
    },
    {
        group: PaymentProviderGroup.Direct,
        count: 1
    },
    {
        group: PaymentProviderGroup.Card,
        count: 2
    }
];
var supportedPaymentOptions = [
    {
        name: "BITCOIN",
        translationKey: "store.payment-options-bitcoin"
    },
    {
        name: "CARD",
        translationKey: "store.payment-options-card"
    },
    {
        name: "CASH_ON_DELIVERY",
        translationKey: "store.payment-options-cash-on-delivery"
    },
    {
        name: "DIRECT",
        translationKey: "store.payment-options-direct"
    },
    {
        name: "INSTALLMENT",
        translationKey: "store.payment-options-installment"
    },
    {
        name: "INVOICE",
        translationKey: "store.payment-options-invoice"
    },
    {
        name: "PHONE_BILL",
        translationKey: "store.payment-options-phone-bill"
    },
    {
        name: "PREPAID",
        translationKey: "store.payment-options-prepaid"
    },
    {
        name: "SMS",
        translationKey: "store.payment-options-sms"
    }
];
var supportedPaymentProviders = [
    {
        name: "KLARNA",
        label: "Klarna",
        logo: "klarna.svg",
        group: PaymentProviderGroup.Invoice
    },
    // To be turned on when supported by backend ENUM
    // {
    //   name: 'MOBILE_PAY',
    //   label: 'Mobile pay',
    //   logo: 'mobile-pay.svg',
    // },
    // { name: 'DANKORT', label: 'Dankort', logo: 'dankort.svg', sortOrder: 3 },
    // { name: 'AFTERPAY', label: 'Afterpay', logo: 'afterpay.svg', sortOrder: 4 },
    {
        name: "SWISH",
        label: "Swish",
        logo: "swish.svg",
        group: PaymentProviderGroup.Direct
    },
    {
        name: "VIPPS",
        label: "Vipps",
        logo: "vipps.svg",
        group: PaymentProviderGroup.Direct
    },
    {
        name: "MASTER_CARD",
        label: "MasterCard",
        logo: "mastercard.svg",
        group: PaymentProviderGroup.Card
    },
    {
        name: "VISA",
        label: "Visa",
        logo: "visa.svg",
        group: PaymentProviderGroup.Card
    },
    {
        name: "PAYPAL",
        label: "PayPal",
        logo: "paypal.svg",
        group: PaymentProviderGroup.Direct
    },
    {
        name: "AMEX",
        label: "American Express",
        logo: "americanexpress.svg",
        group: PaymentProviderGroup.Card
    },
    {
        name: "SVEA_WEB_PAY",
        label: "SveaWebPay",
        logo: "svea_ekonomi.svg",
        group: PaymentProviderGroup.Invoice
    },
    {
        name: "PAYSON",
        label: "Payson",
        logo: "payson.svg",
        group: PaymentProviderGroup.Invoice
    },
    {
        name: "DINERS",
        label: "Diners Club",
        logo: "diners.svg",
        group: PaymentProviderGroup.Card
    }
];
var getPaymentOptions = function(store, t) {
    var ref, ref1;
    var ref2;
    var activePaymentOptions = (ref2 = (ref = store.payment) === null || ref === void 0 ? void 0 : (ref1 = ref.options) === null || ref1 === void 0 ? void 0 : ref1.filter(Boolean).map(function(option) {
        return option === null || option === void 0 ? void 0 : option.name;
    })) !== null && ref2 !== void 0 ? ref2 : [];
    var hasOptions = activePaymentOptions.length > 0;
    var options = supportedPaymentOptions.map(function(option) {
        return _objectSpreadProps(_objectSpread({}, option), {
            active: activePaymentOptions.includes(option.name),
            translatedName: t("store", option.translationKey)
        });
    }).sort(function(a, b) {
        if (a.active && b.active || !a.active && !b.active) {
            return a.translatedName.localeCompare(b.translatedName);
        }
        if (a.active) {
            return -1;
        }
        return 1;
    });
    return {
        hasOptions: hasOptions,
        options: options
    };
};
var compareSortOrder = function(a, b) {
    if (a.sortOrder < 0) {
        return 1;
    }
    if (b.sortOrder < 0) {
        return -1;
    }
    if (a.sortOrder < b.sortOrder) {
        return -1;
    }
    return 0;
};
var getPaymentProviders = function(store, market) {
    var ref, ref1, ref2;
    if (!store) {
        return {
            hasProviders: false,
            providers: []
        };
    }
    var marketPriorities = (market === null || market === void 0 ? void 0 : (ref = market.paymentProviders) === null || ref === void 0 ? void 0 : ref.priorities) ? market.paymentProviders.priorities : [];
    var ref3;
    var activePaymentProviders = (ref3 = (ref1 = store.payment) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.providers) === null || ref2 === void 0 ? void 0 : ref2.filter(Boolean).map(function(provider) {
        return provider === null || provider === void 0 ? void 0 : provider.name;
    })) !== null && ref3 !== void 0 ? ref3 : [];
    var hasProviders = activePaymentProviders.length > 0;
    var providers = supportedPaymentProviders === null || supportedPaymentProviders === void 0 ? void 0 : supportedPaymentProviders.map(function(provider) {
        return _objectSpreadProps(_objectSpread({}, provider), {
            sortOrder: marketPriorities.indexOf(provider.name),
            active: activePaymentProviders.includes(provider.name),
            logoUrl: "".concat(market.cdn, "/g/rfe/store/paymentprovider/").concat(provider.logo)
        });
    });
    var providersSortedByMarketPrio = _toConsumableArray(providers).sort(compareSortOrder);
    return {
        hasProviders: hasProviders,
        providers: providersSortedByMarketPrio
    };
};
var getGroupedPaymentProviders = function(store, market) {
    var ref, ref1;
    var ref2 = getPaymentProviders(store, market), providers = ref2.providers, hasProviders = ref2.hasProviders;
    var groupedProviders = [];
    var activeProviders = providers.filter(function(p) {
        return p.active;
    });
    if (hasProviders && (market === null || market === void 0 ? void 0 : (ref = market.paymentProviders) === null || ref === void 0 ? void 0 : (ref1 = ref.groupPriorities) === null || ref1 === void 0 ? void 0 : ref1.length)) {
        market.paymentProviders.groupPriorities.forEach(function(group) {
            var visibilitySetting = PAYMENT_GROUP_SETTINGS.find(function(setting) {
                return setting.group === group;
            });
            var visible = (visibilitySetting === null || visibilitySetting === void 0 ? void 0 : visibilitySetting.count) || 0;
            for(var index = 0; index < visible; index += 1){
                groupedProviders.push(getPrioritizedProvidersForGroup(activeProviders, group, index));
            }
        });
    } else if (hasProviders) {
        // Fallback if there are no group priorities for the market
        groupedProviders.push(activeProviders[0]);
    }
    return groupedProviders.filter(function(n) {
        return n;
    });
};
var getPrioritizedProvidersForGroup = function(providers, group, pos) {
    var providersFromGroup = providers.filter(function(p) {
        return p.group === group;
    });
    return providersFromGroup.length > pos ? providersFromGroup[pos] : null;
};


/***/ }),

/***/ 56901:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": () => (/* binding */ tabs_new_Tabs)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@5.2.1_react@18.2.0/node_modules/react-router/esm/react-router.js + 3 modules
var react_router = __webpack_require__(14727);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
;// CONCATENATED MODULE: ./src/components/tabs-new/styles.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    max-width: 100vw;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: bottom;\n\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n          left: 0;\n          right: 0;\n        "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      overflow: unset;\n\n      :before {\n        content: '';\n        position: absolute;\n        background-color: ",
        ";\n        left: -50vw;\n        right: -50vw;\n        z-index: -1;\n        height: 100%;\n        border-bottom: 1px solid ",
        ";\n\n        ",
        "\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      border-bottom: 1px solid ",
        ";\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    position: relative;\n    overflow: hidden;\n    display: flex;\n    width: 100%;\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    overflow-x: auto;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n    margin: 0 ",
        ";\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n      box-shadow: inset 0 -5px 0 -1px ",
        ";\n      color: ",
        ";\n\n      a:hover,\n      &:hover {\n        color: inherit;\n      }\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  height: 100%;\n  display: flex;\n  align-items: center;\n  padding: 0 ",
        ";\n  font-weight: 600;\n  cursor: pointer;\n  color: ",
        ";\n  transition: box-shadow 0.1s linear;\n  white-space: nowrap;\n\n  a:hover,\n  &:hover {\n    color: ",
        ";\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  html {\n    overflow-x: hidden !important;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}




var Tabs = styled_components_browser_esm["default"].nav.withConfig({
    displayName: "Tabs",
    componentId: "sc-0-0"
})(_templateObject1(), base/* media.mediumDown */.BC.mediumDown(_templateObject()));
var TabsBackground = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TabsBackground",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject5(), props.background && props.isSticky && (0,styled_components_browser_esm.css)(_templateObject3(), props.theme.bg.primary, props.theme.lines.primary, base/* media.mediumDown */.BC.mediumDown(_templateObject2())), !props.background && (0,styled_components_browser_esm.css)(_templateObject4(), props.theme.lines.primary));
});
var Wrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-2"
})(_templateObject8(), base/* media.smallOnly */.BC.smallOnly(_templateObject6()), base/* media.mediumUp */.BC.mediumUp(_templateObject7(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050));
var TabLink = (0,styled_components_browser_esm["default"])(function(_param) /*#__PURE__*/ {
    var active = _param.active, rest = _objectWithoutProperties(_param, [
        "active"
    ]);
    return react.createElement(react_router_dom/* Link */.rU, _extends({}, rest));
}).withConfig({
    displayName: "TabLink",
    componentId: "sc-0-3"
})(_templateObject10(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, function(props) {
    return props.theme.colors.base500;
}, function(props) {
    return props.theme.colors.base600;
}, function(props) {
    return props.active && (0,styled_components_browser_esm.css)(_templateObject9(), function(p) {
        return p.theme.colors.maybeBlue500;
    }, function(p) {
        return p.theme.text.primary;
    });
});
var Image = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Image",
    componentId: "sc-0-4"
})(_templateObject11(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var GlobalStylesOverride = (0,styled_components_browser_esm.createGlobalStyle)(_templateObject12());

;// CONCATENATED MODULE: ./src/components/tabs-new/index.tsx
function tabs_new_extends() {
    tabs_new_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return tabs_new_extends.apply(this, arguments);
}



var TabItem = function(param) {
    var active = param.active, id = param.id, index = param.index, onClick = param.onClick, scrollToTop = param.scrollToTop, title = param.title, to = param.to;
    var history = (0,react_router/* useHistory */.k6)();
    var handleOnClick = (0,react.useCallback)(function(e) {
        if (scrollToTop) {
            e.preventDefault();
            e.stopPropagation();
            // Scroll to top
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
            // Remove potential hash from url
            history.push(history.location.pathname + history.location.search);
        }
        if (!onClick) return null;
        return onClick(id, index);
    }, [
        id,
        onClick,
        scrollToTop,
        history
    ]);
    return /*#__PURE__*/ react.createElement(TabLink, {
        active: active,
        onClick: handleOnClick,
        to: to
    }, title);
};
var tabs_new_Tabs = /*#__PURE__*/ react.forwardRef(function(param, ref) {
    var className = param.className, onClick = param.onClick, tabs = param.tabs, background = param.background, isSticky = param.isSticky;
    return /*#__PURE__*/ react.createElement(Tabs, {
        className: className,
        ref: ref
    }, isSticky && /*#__PURE__*/ react.createElement(GlobalStylesOverride, null), /*#__PURE__*/ react.createElement(TabsBackground, {
        background: background,
        isSticky: isSticky
    }, /*#__PURE__*/ react.createElement(Wrapper, null, tabs.map(function(tab, index) {
        return /*#__PURE__*/ react.createElement(TabItem, tabs_new_extends({}, tab, {
            index: index,
            key: tab.id,
            onClick: onClick
        }));
    }))));
});


/***/ }),

/***/ 32673:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": () => (/* binding */ text_link_TextLink)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(38689);
;// CONCATENATED MODULE: ./src/components/text-link/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n\n  &:hover {\n    color: ",
        ";\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var TextLink = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "TextLink",
    componentId: "sc-0-0"
})(_templateObject(), function(p) {
    return p.theme.text.callToAction;
}, function(p) {
    return p.theme.text.callToActionHover;
});

;// CONCATENATED MODULE: ./src/components/text-link/index.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var text_link_TextLink = function(_param) /*#__PURE__*/ {
    var children = _param.children, props = _objectWithoutProperties(_param, [
        "children"
    ]);
    return react.createElement(TextLink, _extends({}, props), children);
};


/***/ }),

/***/ 88278:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lf": () => (/* binding */ promptToast),
/* harmony export */   "c7": () => (/* binding */ TOAST_PROMPT),
/* harmony export */   "i6": () => (/* binding */ requireToastContainer),
/* harmony export */   "xy": () => (/* binding */ TOAST_REQUIRED)
/* harmony export */ });
var TOAST_PROMPT = "TOAST_PROMPT";
var TOAST_REQUIRED = "TOAST_REQUIRED";
var promptToast = function(promptType, content) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return {
        type: TOAST_PROMPT,
        promptType: promptType,
        content: content,
        options: options
    };
};
var requireToastContainer = function() {
    return {
        type: TOAST_REQUIRED,
        required: true
    };
};


/***/ }),

/***/ 85048:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23114);

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,_loadable_component__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "toast";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | toast */ 578).then(__webpack_require__.bind(__webpack_require__, 73550));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(73550);
        }
        return eval("require.resolve")("./toast-container");
    }
}));


/***/ }),

/***/ 61041:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": () => (/* reexport */ Translate),
  "O": () => (/* reexport */ translator)
});

;// CONCATENATED MODULE: ./src/components/translate/translator.ts
var pluralForm = function(locale, count) {
    // Numeric check for pluralization count
    // Also, handle negative numbers, treat -1 as 1.
    var n = Math.abs(parseFloat(String(count)));
    if (isNaN(n) || !isFinite(n)) {
        return false;
    }
    switch(locale){
        // Rule: nplurals=2; plural=(n != 1);
        // Fallthrough where the same rule applies
        case "en":
        case "en_GB":
        case "en_IE":
        case "en_NZ":
        case "nb_NO":
        case "sv":
        case "fi":
        case "es":
        case "it":
        case "da":
            // Rule: nplurals=2; plural=(n != 1);
            return n !== 1 ? 1 : 0;
        case "fr":
            // Rule: nplurals=2; plural=(n > 1);
            return n > 1 ? 1 : 0;
        case "pl":
            // Rule: nplurals=3; plural=(n==1 ? 0 : n%10>=2 && n%10<=4 && (n%100<10 || n%100>=20) ? 1 : 2);
            if (n === 1) {
                return 0;
            }
            return n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
        default:
            return false;
    }
};
var getPluralIndex = function(translation, locale, params) {
    var pluralIndex = pluralForm(locale, params.n);
    if (typeof pluralIndex !== "boolean" && Array.isArray(translation)) {
        return translation[pluralIndex] !== undefined ? pluralIndex : false;
    }
    return false;
};
var translator = function(translations, locale) {
    return function(domain, text) {
        var params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
            react: true
        };
        if (!translations || !translations[domain] || !translations[domain][text]) {
            return text;
        }
        var translation = translations[domain][text];
        var pluralIndex = getPluralIndex(translation, locale, params);
        var translatedString = text;
        if (pluralIndex !== false) {
            translatedString = translation[pluralIndex];
        } else if (typeof translation === "string") {
            translatedString = translation;
        }
        var stringWithParams = Object.keys(params).reduce(function(string, key) {
            return string.replace(new RegExp("%".concat(!options.react ? "@?" : "").concat(key, "%"), "g"), params[key]);
        }, translatedString);
        if (!options.react) {
            return stringWithParams;
        }
        // Inject non-text components (replace placeholders that start with "@")
        var stringComponentArray = Object.keys(params).reduce(function(stringArray, key) {
            var newStringArray = [];
            stringArray.forEach(function(str) {
                if (typeof str === "string") {
                    var stringParts = str.split("%@".concat(key, "%"));
                    for(var i = stringParts.length - 1; i > 0; i -= 1){
                        stringParts.splice(i, 0, params[key]);
                    }
                    newStringArray = newStringArray.concat(stringParts.filter(function(item) {
                        return item !== "" && item !== undefined;
                    }));
                } else {
                    newStringArray.push(str);
                }
            });
            return newStringArray;
        }, [
            stringWithParams
        ]);
        // Return string if possible
        return stringComponentArray.length === 1 ? stringComponentArray[0] : stringComponentArray;
    };
};

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
;// CONCATENATED MODULE: ./src/components/translate/translate-func.ts
/* eslint-disable */ 

// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
;// CONCATENATED MODULE: ./src/components/translate/translate.tsx
/* eslint-disable react/no-danger */ function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function sanitizeParamForMarkdown(param) {
    return param.toString().replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
}
function sanitizeParamsForMarkdown(params) {
    return Object.keys(params).reduce(function(sanitizedParams, key) {
        return _objectSpreadProps(_objectSpread({}, sanitizedParams), _defineProperty({}, key, sanitizeParamForMarkdown(params[key])));
    }, {});
}
function getTextFromNode(node) {
    if (typeof node === "string") return node;
    return "";
}
var Translate = /*#__PURE__*/ (0,react.memo)(function(_param) {
    var domain = _param.domain, children = _param.children, params = _objectWithoutProperties(_param, [
        "domain",
        "children"
    ]);
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    if (!t) {
        return /*#__PURE__*/ react.createElement("span", null, children);
    }
    var childrenText = getTextFromNode(children);
    var isMarkdown = childrenText && childrenText.slice(-3) === ".md";
    var text = t(domain, // @ts-expect-error expects never for some reason
    childrenText, isMarkdown ? sanitizeParamsForMarkdown(params) : params);
    return isMarkdown ? /*#__PURE__*/ react.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: text
        }
    }) : /*#__PURE__*/ react.createElement("span", null, text);
});

;// CONCATENATED MODULE: ./src/components/translate/index.ts





/***/ }),

/***/ 93538:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": () => (/* binding */ user_avatar_UserAvatar)
});

// UNUSED EXPORTS: Symbol

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/account/index.js
var account = __webpack_require__(80019);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
;// CONCATENATED MODULE: ./src/components/user-avatar/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      &:hover,\n      .focus-visible & {\n        color: ",
        ";\n        background: ",
        ";\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  font-weight: 600;\n  font-size: ",
        "px;\n  text-transform: uppercase;\n  box-sizing: border-box;\n  height: ",
        "px;\n  width: ",
        "px;\n  border-radius: ",
        "px;\n  transition: all ",
        ";\n  overflow: hidden;\n  background: ",
        ";\n  color: ",
        ";\n\n  img {\n    transition: all ",
        ";\n    border-radius: ",
        "px;\n  }\n\n  svg path {\n    fill: currentColor;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  object-fit: cover;\n  width: ",
        "px;\n  height: ",
        "px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var UserAvatar = styled_components_browser_esm["default"].div.withConfig({
    displayName: "UserAvatar",
    componentId: "sc-0-0"
})(_templateObject1(), function(p) {
    return Math.round(0.67 * p.$size);
}, function(p) {
    return p.$size;
}, function(p) {
    return p.$size;
}, function(p) {
    return p.$size;
}, base/* layout.animations.buttonTransition */.bK.animations.buttonTransition, function(p) {
    switch(p.$userType){
        case "verifying":
            return p.theme.colors.base300;
        default:
            return p.theme.colors.base500;
    }
}, function(p) {
    return p.theme.colors.base0;
}, base/* layout.animations.buttonTransition */.bK.animations.buttonTransition, function(p) {
    return p.$size;
}, function(p) {
    return p.$isLinked && (0,styled_components_browser_esm.css)(_templateObject(), p.theme.colors.base0, p.theme.icons.callToActionHover);
});
var Image = styled_components_browser_esm["default"].img.withConfig({
    displayName: "Image",
    componentId: "sc-0-1"
})(_templateObject2(), function(p) {
    return p.width;
}, function(p) {
    return p.height;
});

;// CONCATENATED MODULE: ./src/components/user-avatar/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



var DEFAULT_SIZE = 32;
var user_avatar_UserAvatar = function(param) {
    var _size = param.size, size = _size === void 0 ? DEFAULT_SIZE : _size, className = param.className, avatar = param.avatar, displayName = param.displayName, email = param.email, _isLinked = param.isLinked, isLinked = _isLinked === void 0 ? true : _isLinked;
    var userType;
    if (!displayName) {
        userType = "verifying";
    } else {
        userType = "registered";
    }
    return /*#__PURE__*/ react.createElement(UserAvatar, {
        className: className,
        "data-test": "UserAvatar",
        $size: size,
        $isLinked: isLinked,
        $userType: userType
    }, /*#__PURE__*/ react.createElement(Symbol1, {
        userType: userType,
        displayName: displayName,
        avatar: avatar,
        email: email,
        size: size
    }));
};
var Symbol1 = function(param) {
    var userType = param.userType, displayName = param.displayName, avatar = param.avatar, email = param.email, _size = param.size, size = _size === void 0 ? DEFAULT_SIZE : _size;
    var ref = _slicedToArray((0,react.useState)(false), 2), imageError = ref[0], setImageError = ref[1];
    var onError = function() {
        setImageError(true);
    };
    if (userType !== "verifying" && avatar && !imageError) {
        return /*#__PURE__*/ react.createElement(Image, {
            alt: displayName || email || "",
            src: avatar,
            width: size,
            height: size,
            onError: onError
        });
    }
    var ref1;
    var firstChar = (ref1 = getFirstChar(displayName)) !== null && ref1 !== void 0 ? ref1 : getFirstChar(email);
    if (firstChar) {
        return /*#__PURE__*/ react.createElement("span", {
            style: {
                lineHeight: "".concat(size, "px")
            }
        }, firstChar);
    }
    return /*#__PURE__*/ react.createElement(account/* IconAccount */.U, {
        size: size * 0.75
    });
};

var getFirstChar = function(name) {
    var validNameOrEmail = /^[A-Za-z]/;
    if (name && name.match(validNameOrEmail)) {
        return name.charAt(0);
    }
    return undefined;
};


/***/ }),

/***/ 38539:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": () => (/* binding */ UxLiteQuestions)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23114);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}


var UxLiteQuestionsLoadable = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "ux-lite";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | ux-lite */ 314).then(__webpack_require__.bind(__webpack_require__, 61664));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(61664);
        }
        return eval("require.resolve")("./ux-lite-questions");
    }
});
var UxLiteQuestions = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(UxLiteQuestionsLoadable, _extends({}, props));
};


/***/ }),

/***/ 39632:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": () => (/* binding */ withViewport),
/* harmony export */   "t": () => (/* binding */ ViewportTracker)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38209);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_throttle__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61093);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



var ViewportTrackerContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createContext({});
ViewportTrackerContext.displayName = "ViewportTrackerContext";
var ViewportTracker = function(param) {
    var children = param.children;
    var state = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
        width: 0,
        height: 0,
        left: 0,
        top: 0,
        scroll: {
            xDirection: undefined,
            yDirection: undefined,
            x: -0,
            y: -0
        }
    });
    var ref = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(state.current), 2), viewport = ref[0], setViewport = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var onUpdateViewport = function onUpdateViewport() {
            var html = document.documentElement;
            var x = window.scrollX;
            var y = window.scrollY;
            var scrollChanged = x !== state.current.scroll.x || y !== state.current.scroll.y;
            var scroll = scrollChanged ? {
                xDirection: Math.sign(state.current.scroll.x - x),
                yDirection: Math.sign(state.current.scroll.y - y),
                x: x,
                y: y
            } : state.current.scroll;
            state.current = {
                width: window.innerWidth || html.clientWidth,
                height: window.innerHeight || html.clientHeight,
                left: window.pageXOffset || html.scrollLeft,
                top: window.pageYOffset || html.scrollTop,
                scroll: scroll
            };
            setViewport(state.current);
        };
        var throttledOnUpdateViewport = lodash_throttle__WEBPACK_IMPORTED_MODULE_1___default()(onUpdateViewport, 200);
        window.addEventListener("scroll", throttledOnUpdateViewport, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .browserSupports.passiveEventListener */ .TV.passiveEventListener() ? {
            passive: true
        } : false);
        onUpdateViewport();
        return function() {
            window.removeEventListener("scroll", throttledOnUpdateViewport);
        };
    }, []);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ViewportTrackerContext.Provider, {
        value: viewport
    }, children);
};
var withViewport = function(Component) {
    return function(props) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ViewportTrackerContext.Consumer, null, function(viewport) {
            return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, _extends({}, props, {
                viewport: viewport
            }));
        });
    };
};


/***/ }),

/***/ 84198:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ak": () => (/* binding */ useViewportContext),
/* harmony export */   "Pi": () => (/* binding */ ViewportContextContainer),
/* harmony export */   "ZP": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38209);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_throttle__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var shallowequal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50631);
/* harmony import */ var shallowequal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(shallowequal__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61093);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}




var ViewportContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createContext({});
ViewportContext.displayName = "ViewportContext";
var queries;
var getSizes = function() {
    if (!window) {
        // This should never happen (SSR always sends an initialValue) but just to be safe, here we go :)
        return {
            isMobile: false,
            isTablet: false,
            isDesktop: true
        };
    }
    if (!queries) {
        queries = {
            smallOnly: window.matchMedia(src_components_base__WEBPACK_IMPORTED_MODULE_3__/* .breakpoints.smallOnly */ .AV.smallOnly),
            mediumOnly: window.matchMedia(src_components_base__WEBPACK_IMPORTED_MODULE_3__/* .breakpoints.mediumOnly */ .AV.mediumOnly),
            largeUp: window.matchMedia(src_components_base__WEBPACK_IMPORTED_MODULE_3__/* .breakpoints.largeUp */ .AV.largeUp)
        };
    }
    return {
        isMobile: queries.smallOnly.matches,
        isTablet: queries.mediumOnly.matches,
        isDesktop: queries.largeUp.matches
    };
};
var ViewportContextContainer = function(param) {
    var children = param.children, _initialValue = param.initialValue, initialValue = _initialValue === void 0 ? undefined : _initialValue;
    // In SSR initialValue is guessed from the user agent
    var ref = _slicedToArray(react__WEBPACK_IMPORTED_MODULE_0__.useState(initialValue !== null && initialValue !== void 0 ? initialValue : getSizes()), 2), state = ref[0], setState = ref[1];
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function() {
        var onResize = lodash_throttle__WEBPACK_IMPORTED_MODULE_1___default()(function() {
            var sizes = getSizes();
            setState(function(s) {
                if (!shallowequal__WEBPACK_IMPORTED_MODULE_2___default()(sizes, s)) {
                    return sizes;
                }
                return s;
            });
        }, 200);
        window.addEventListener("resize", onResize);
        onResize();
        return function() {
            return window.removeEventListener("resize", onResize);
        };
    }, []);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ViewportContext.Provider, {
        value: state
    }, children);
};
var useViewportContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ViewportContext);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ViewportContext);


/***/ }),

/***/ 10297:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": () => (/* reexport safe */ _context__WEBPACK_IMPORTED_MODULE_2__.ZP),
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71993);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61093);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84198);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "display: none;"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "display: none;"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "display: none;"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  /* Hide element with slightly increased specificity. This allows us to extend this component\n    with custom display values and other styles rather than having to use it as a wrapper. */\n  && {\n    ",
        "\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var StyledViewport = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.attrs(// TODO: Remove all this?
function(param) {
    var mobile = param.mobile, tablet = param.tablet, desktop = param.desktop;
    return {
        "data-test": "Viewport",
        "data-test-mobile": mobile,
        "data-test-tablet": tablet,
        "data-test-desktop": desktop
    };
}).withConfig({
    displayName: "StyledViewport",
    componentId: "sc-0-0"
})(_templateObject3(), function(props) {
    return !props.mobile && src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.smallOnly */ .BC.smallOnly(_templateObject());
}, function(props) {
    return !props.tablet && src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumOnly */ .BC.mediumOnly(_templateObject1());
}, function(props) {
    return !props.desktop && src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.largeUp */ .BC.largeUp(_templateObject2());
});

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (StyledViewport);


/***/ }),

/***/ 77973:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": () => (/* binding */ YoutubeIcon)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/youtube/index.js
var youtube = __webpack_require__(94335);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
;// CONCATENATED MODULE: ./src/components/youtube-icon/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n\n    svg {\n      /* Needed to make red youtube icon appear over white arrow */\n      z-index: 2;\n    }\n\n    /* White arrow inside youtube icon */\n    &::after {\n      content: '';\n      background: ",
        ";\n      width: ",
        "px;\n      height: ",
        "px;\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n      z-index: 1;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var StyledYoutubeIcon = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledYoutubeIcon",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject(), function(p) {
        return p.theme.colors.base0;
    }, props.$size / 2, props.$size / 2);
});

;// CONCATENATED MODULE: ./src/components/youtube-icon/index.tsx



var YOUTUBE_ICON_SIZE_DEFAULT = 40;
var YoutubeIcon = function(props) {
    var className = props.className, _size = props.size, size = _size === void 0 ? YOUTUBE_ICON_SIZE_DEFAULT : _size;
    return /*#__PURE__*/ react.createElement(StyledYoutubeIcon, {
        className: className,
        $size: size
    }, /*#__PURE__*/ react.createElement(youtube/* IconYoutube */.z, {
        size: size,
        color: "staticRedio700"
    }));
};


/***/ }),

/***/ 5549:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ youtube)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/hooks/resize-observer.ts
var resize_observer = __webpack_require__(2613);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
;// CONCATENATED MODULE: ./src/components/youtube/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  overflow: hidden;\n  border-radius: 8px;\n  grid-area: youtube;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    max-height: unset;\n    height: 100%;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  max-height: 60vh;\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    max-height: unset;\n    height: 100%;\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  background: url(",
        ");\n  width: 100%;\n  height: 60vh;\n  max-height: ",
        "px;\n  background-size: cover;\n  position: relative;\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  cursor: pointer;\n  width: 100%;\n\n  svg {\n    height: 60px;\n    width: 86px;\n\n    path.yt-btn-bg {\n      transition: fill 150ms ease;\n      fill: rgba(0, 0, 0, 0.75);\n    }\n  }\n\n  &:hover {\n    svg path.yt-btn-bg {\n      fill: rgba(255, 0, 0, 1);\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var Wrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-0"
})(_templateObject());
var StyledIframe = styled_components_browser_esm["default"].iframe.withConfig({
    displayName: "StyledIframe",
    componentId: "sc-0-1"
})(_templateObject2(), base/* media.mediumDown */.BC.mediumDown(_templateObject1()));
var YTPlaceholder = styled_components_browser_esm["default"].div.withConfig({
    displayName: "YTPlaceholder",
    componentId: "sc-0-2"
})(_templateObject4(), function(p) {
    return p.thumbnail;
}, function(p) {
    return p.height;
}, base/* media.mediumDown */.BC.mediumDown(_templateObject3()));
var PlayButton = styled_components_browser_esm["default"].button.withConfig({
    displayName: "PlayButton",
    componentId: "sc-0-3"
})(_templateObject5());

;// CONCATENATED MODULE: ./src/components/youtube/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



var YoutubeLoader = function(param) {
    var className = param.className, thumbnail = param.thumbnail, id = param.id;
    var ref = (0,resize_observer/* useResizeObserver */.y)(), width = ref.width, videoRef = ref.ref;
    var ref1 = _slicedToArray((0,react.useState)(false), 2), load = ref1[0], setLoad = ref1[1];
    var height = width ? width / (16 / 9) : 320;
    return /*#__PURE__*/ react.createElement(Wrapper, {
        className: className,
        ref: videoRef
    }, load ? /*#__PURE__*/ react.createElement(StyledIframe, {
        title: "youtube video",
        width: "100%",
        height: height,
        src: "https://www.youtube.com/embed/".concat(id, "?autoplay=1&showinfo=0"),
        frameBorder: "0",
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        allowFullScreen: true
    }) : /*#__PURE__*/ react.createElement(YTPlaceholder, {
        height: height,
        thumbnail: thumbnail,
        onClick: function() {
            return setLoad(true);
        }
    }, /*#__PURE__*/ react.createElement(PlayButton, null, /*#__PURE__*/ react.createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 68 48",
        width: "100%"
    }, /*#__PURE__*/ react.createElement("path", {
        className: "yt-btn-bg",
        d: "M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z",
        fill: "#f00"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M 45,24 27,14 27,34",
        fill: "#fff"
    })))));
};
/* harmony default export */ const youtube = (/*#__PURE__*/(0,react.memo)(YoutubeLoader));


/***/ }),

/***/ 59547:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": () => (/* binding */ WideContextProvider),
/* harmony export */   "Y": () => (/* binding */ WideContext)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

var WideContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    isWide: false,
    setIsWide: function() {
        return null;
    }
});
var WideContextProvider = function(props) {
    var ref = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), 2), isWide = ref[0], setIsWide = ref[1];
    var contextValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return {
            isWide: isWide,
            setIsWide: setIsWide
        };
    }, [
        isWide
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(WideContext.Provider, {
        value: contextValue
    }, props.children);
};


/***/ }),

/***/ 46095:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DU": () => (/* binding */ INFO_PAGES_RECEIVE),
/* harmony export */   "NH": () => (/* binding */ SORT_CHANGE),
/* harmony export */   "R5": () => (/* binding */ DANGEROUS_CONFIG_RECEIVE),
/* harmony export */   "g8": () => (/* binding */ SESSION_RECEIVE),
/* harmony export */   "mT": () => (/* binding */ adsViewUpdate),
/* harmony export */   "rB": () => (/* binding */ sortChange)
/* harmony export */ });
/* unused harmony exports ADS_VIEW_UPDATE, dangerousConfigReceive */
var SORT_CHANGE = "SORT_CHANGE";
var ADS_VIEW_UPDATE = "ADS_VIEW_UPDATE";
var DANGEROUS_CONFIG_RECEIVE = "__DANGEROUS_CONFIG_RECEIVE";
var INFO_PAGES_RECEIVE = "INFO_PAGES_RECEIVE";
var SESSION_RECEIVE = "SESSION_RECEIVE";
function dangerousConfigReceive(data) {
    return {
        type: DANGEROUS_CONFIG_RECEIVE,
        market: data.market,
        markets: data.markets,
        server: data.server,
        routes: data.routes
    };
}
var sortChange = function(data) {
    return {
        type: SORT_CHANGE,
        data: data
    };
};
var adsViewUpdate = function(view) {
    return {
        type: ADS_VIEW_UPDATE,
        view: view
    };
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    sortChange: sortChange,
    adsViewUpdate: adsViewUpdate
});


/***/ }),

/***/ 52998:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": () => (/* binding */ formatDate)
/* harmony export */ });
var formatDate = function(value, locale, dateFormatOptions) {
    var defaultFormat = {
        day: "numeric",
        month: "short",
        year: "numeric"
    };
    var formattedDate = new Date(value).toLocaleDateString(locale, dateFormatOptions || defaultFormat);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - Need to check if replaceAll is defined because we get error reports in Sentry for it
    return (formattedDate === null || formattedDate === void 0 ? void 0 : formattedDate.replaceAll) ? formattedDate.replaceAll(".", "") : "";
};


/***/ }),

/***/ 24847:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ formatNumber)
/* harmony export */ });
// Formats number with thousands separator
function formatNumber(count, marketCode) {
    var countString = count.toString();
    if (countString.length <= 3) return count;
    switch(marketCode){
        case "se":
        case "no":
        case "dk":
        case "fi":
        case "fr":
            return countString.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
        case "gb":
            return count.toLocaleString("en-GB");
        default:
            return count.toLocaleString();
    }
}


/***/ }),

/***/ 56290:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b8": () => (/* binding */ TrackClickScope),
  "_L": () => (/* reexport */ mapStockStatusToGTMStockStatus),
  "Rx": () => (/* binding */ trackOfferClickWithRevenue),
  "Yn": () => (/* binding */ trackShopClickWithRevenue)
});

// UNUSED EXPORTS: TrackClickType

// EXTERNAL MODULE: ./src/client/data-layer.ts
var data_layer = __webpack_require__(80695);
;// CONCATENATED MODULE: ./src/globals/tracking/util.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var removeUndefinedFields = function(input) {
    var output = Object.keys(input).reduce(function(acc, key) {
        return input[key] === undefined ? _objectSpread({}, acc) : _objectSpreadProps(_objectSpread({}, acc), _defineProperty({}, key, input[key]));
    }, {});
    return output;
};
var mapStockStatusToGTMStockStatus = function(stockStatus) {
    switch(stockStatus){
        case "in_stock":
            return "in_stock";
        case "in_stock_preorder":
            return "preorder";
        case "incoming":
            return "backorder";
        case "not_in_stock":
            return "out_of_stock";
        case "unknown":
            return "unknown";
        default:
            return undefined;
    }
};

;// CONCATENATED MODULE: ./src/globals/tracking/conversion.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function conversion_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function conversion_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            conversion_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};



var TrackClickType;
(function(TrackClickType) {
    TrackClickType["RAW"] = "raw";
    TrackClickType["OFFER"] = "offer";
    TrackClickType["SHOP"] = "shop";
})(TrackClickType || (TrackClickType = {}));
var TrackClickScope;
(function(TrackClickScope) {
    TrackClickScope["PRICE_HISTORY"] = "product_price_history";
    TrackClickScope["PRICE_LIST"] = "product_price_list";
    TrackClickScope["PRICE_LIST_EXPANDED"] = "product_price_list_expanded";
    TrackClickScope["PROMOTION_MODAL"] = "promotion_modal";
    TrackClickScope["PROMOTION_PRODUCTS_PAGE_HEADER"] = "promotion_products_page_header";
    TrackClickScope["PROMOTION_PRODUCT_CARD"] = "promotion_product_card";
    TrackClickScope["SHOP_PAGE_HEADER"] = "shop_page_header";
    TrackClickScope["SHOP_PAGE_ABOUT"] = "shop_page_about";
    TrackClickScope["KEYWORD_PAGE"] = "keyword_page";
    TrackClickScope["SEARCH_RESULT_PAGE"] = "search_result_page";
    TrackClickScope["CAMPAIGN_SHOP_POPUP"] = "campaign_shop_popup";
    TrackClickScope["CAMPAIGN_LIST_ITEM"] = "campaign_list_item";
    TrackClickScope["USER_REVIEW_CARD"] = "user_review_card";
    TrackClickScope["USED_PRODUCT_CARD"] = "used_product_card";
})(TrackClickScope || (TrackClickScope = {}));
function fetchClickData(type, id) {
    return _fetchClickData.apply(this, arguments);
}
function _fetchClickData() {
    _fetchClickData = _asyncToGenerator(function(type, id) {
        var res, error;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!id) return [
                        2,
                        {}
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        fetch("/_internal/click-data/".concat(type, "/").concat(id))
                    ];
                case 2:
                    res = _state.sent();
                    return [
                        2,
                        res.json()
                    ];
                case 3:
                    error = _state.sent();
                    // Fail silently in case of adblocker
                    return [
                        2,
                        {}
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _fetchClickData.apply(this, arguments);
}
var trackOfferClickWithRevenue = function() {
    var _ref = _asyncToGenerator(function(data) {
        var priceId, isRawOffer, clickData, error, eventData, eventName;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    priceId = data.priceId;
                    isRawOffer = typeof priceId === "string" && priceId.includes("-");
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        fetchClickData(isRawOffer ? TrackClickType.RAW : TrackClickType.OFFER, priceId)
                    ];
                case 2:
                    clickData = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 4:
                    eventData = removeUndefinedFields(conversion_objectSpread({}, data, clickData));
                    eventName = isRawOffer ? "rawOfferClickWithRevenue" : "offerClickWithRevenue";
                    (0,data_layer/* pushEvent */.A)(eventName, eventData);
                    return [
                        2
                    ];
            }
        });
    });
    return function trackOfferClickWithRevenue(data) {
        return _ref.apply(this, arguments);
    };
}();
var trackShopClickWithRevenue = function() {
    var _ref = _asyncToGenerator(function(data) {
        var clickData, error;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        fetchClickData(TrackClickType.SHOP, String(data.shopId))
                    ];
                case 1:
                    clickData = _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        3,
                        3
                    ];
                case 3:
                    (0,data_layer/* pushEvent */.A)("shopClickWithRevenue", conversion_objectSpread({}, data, clickData));
                    return [
                        2
                    ];
            }
        });
    });
    return function trackShopClickWithRevenue(data) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 35298:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Em": () => (/* binding */ trackSortingSelectEvent),
/* harmony export */   "VN": () => (/* binding */ PageScope),
/* harmony export */   "YD": () => (/* binding */ trackFilterRemoveEvent),
/* harmony export */   "f9": () => (/* binding */ trackFilterSelectEvent)
/* harmony export */ });
/* harmony import */ var src_client_data_layer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80695);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

var PageScope;
(function(PageScope) {
    PageScope["CATEGORY"] = "Category";
    PageScope["CAMPAIGN"] = "Campaign";
    PageScope["DEALS"] = "Deals";
    PageScope["PROMOTION"] = "Promotion";
    PageScope["PROMOTION_PRODUCTS"] = "PromotionProducts";
    PageScope["USED"] = "Used";
    PageScope["SEARCH"] = "Search";
    PageScope["PRICE_HISTORY_GRAPH"] = "PriceHistoryGraph";
    PageScope["PRODUCT"] = "Product";
    PageScope["REVIEWS"] = "Reviews";
})(PageScope || (PageScope = {}));
var trackFilterSelectEvent = function(data) {
    var eventData = _objectSpread({}, data);
    if (!eventData.campaign) eventData.campaign = null;
    if (!eventData.category) eventData.category = null;
    if (!eventData.searchTerm) eventData.searchTerm = null;
    if (!eventData.translatedValue) eventData.translatedValue = data.value;
    (0,src_client_data_layer__WEBPACK_IMPORTED_MODULE_0__/* .pushEvent */ .A)("filterSelect", eventData);
};
var trackFilterRemoveEvent = function(data) {
    var eventData = _objectSpread({}, data);
    if (!eventData.campaign) eventData.campaign = null;
    if (!eventData.category) eventData.category = null;
    if (!eventData.searchTerm) eventData.searchTerm = null;
    if (!eventData.translatedValue) eventData.translatedValue = data.value;
    (0,src_client_data_layer__WEBPACK_IMPORTED_MODULE_0__/* .pushEvent */ .A)("filterRemove", eventData);
};
var trackSortingSelectEvent = function(data) {
    var eventData = _objectSpread({}, data);
    if (!eventData.campaign) eventData.campaign = null;
    if (!eventData.category) eventData.category = null;
    if (!eventData.searchTerm) eventData.searchTerm = null;
    (0,src_client_data_layer__WEBPACK_IMPORTED_MODULE_0__/* .pushEvent */ .A)("sortingSelect", eventData);
};


/***/ }),

/***/ 58912:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": () => (/* binding */ InternalNavigationScope),
/* harmony export */   "p": () => (/* binding */ trackInternalNavigationClick)
/* harmony export */ });
/* harmony import */ var src_client_data_layer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80695);

var trackInternalNavigationClick = function(data) {
    (0,src_client_data_layer__WEBPACK_IMPORTED_MODULE_0__/* .pushEvent */ .A)("internal_navigation_click", {
        scope: data.scope,
        current_page: data.currentPage || window.location.pathname + window.location.search + window.location.hash,
        next_page: data.nextPage,
        index: typeof data.index === "number" ? data.index + 1 : "no index"
    });
};
var InternalNavigationScope;
(function(InternalNavigationScope) {
    InternalNavigationScope["ABOUT_REVIEWS"] = "About reviews";
    InternalNavigationScope["ARTICLE_CONTENT_CARD"] = "Article - content card";
    InternalNavigationScope["ARTICLE_READ_MORE"] = "Article - read more";
    InternalNavigationScope["ARTICLE_SHOW_ALL"] = "Article - show all";
    InternalNavigationScope["ARTICLE_PRODUCT_CARD"] = "Article - product card";
    InternalNavigationScope["ARTICLE_PAGE_GO_TO"] = "Article-page - go to";
    InternalNavigationScope["AUTHORIZED_DEALER"] = "Authorized dealer";
    InternalNavigationScope["BANNER"] = "Banner";
    InternalNavigationScope["BRAND_CARD"] = "Brand - card";
    InternalNavigationScope["BRAND_CATEGORY_CARD"] = "Brand - category card";
    InternalNavigationScope["BRAND_CATEGORY_TREE"] = "Brand - category tree";
    InternalNavigationScope["BRAND_PRODUCT_CARD"] = "Brand - product card";
    InternalNavigationScope["BREADCRUMB"] = "Breadcrumb";
    InternalNavigationScope["CALL_TO_ACTION"] = "Call to action";
    InternalNavigationScope["CAMPAIGN_GO_TO"] = "Campaign - go to";
    InternalNavigationScope["CAMPAIGN_HEADER"] = "Campaign - header";
    InternalNavigationScope["CAMPAIGN_PRODUCT_CARD"] = "Campaign - product card";
    InternalNavigationScope["CAMPAIGN_SHOW_ALL"] = "Campaign - show all";
    InternalNavigationScope["CATEGORY_CARD"] = "Category - card";
    InternalNavigationScope["CATEGORY_INDEX_LINK"] = "Category index - link";
    InternalNavigationScope["CATEGORY_LIST_SUB_LVL"] = "Category list - sub level";
    InternalNavigationScope["CATEGORY_LIST_TOP_LVL"] = "Category list - top level";
    InternalNavigationScope["COMPACT_LIST_LAYOUT_PRODUCT_CARD"] = "Compact list layout - product card";
    InternalNavigationScope["COMPARE_PRODUCTS_PRODUCT_HEADER"] = "Compare products - product header";
    InternalNavigationScope["COMPARE_PRODUCTS_PRODUCT_IMAGE"] = "Compare products - product image";
    InternalNavigationScope["EXPERT_ADVISE_SHOW_ALL"] = "Expert advise - show all";
    InternalNavigationScope["EXPERT_ALL_CATEGORIES"] = "Expert - all categories";
    InternalNavigationScope["EXPERT_CATEGORIES"] = "Expert - categories";
    InternalNavigationScope["EXPERT_CATEGORY_AREA"] = "Expert - category area";
    InternalNavigationScope["EXPERT_PROFILE_GO_TO"] = "Expert profile - go to";
    InternalNavigationScope["EXPERT_INDEPENDENT_GUARANTEE"] = "Expert - independent guarantee";
    InternalNavigationScope["EXPERT_LIST_PROFILE_GO_TO"] = "Expert list profile - go to";
    InternalNavigationScope["EXPERT_LIST_EXPERT_PAGE_GO_TO"] = "Expert list expert-page - go to";
    InternalNavigationScope["EXPERT_ALSO_IN_CATEGORIES"] = "Expert - also in categories";
    InternalNavigationScope["EXPERT_PAGE_GO_TO"] = "Expert-page - go to";
    InternalNavigationScope["EXPERT_PROMO"] = "Expert - promo";
    InternalNavigationScope["EXPERT_RECOMMEND_PRODUCTS"] = "Expert - recommend products";
    InternalNavigationScope["EXPERT_SEARCH_RESULT_CATEGORY_GO_TO"] = "Expert search result - category go to";
    InternalNavigationScope["EXPERT_SEARCH_RESULT_PRODUCT_TEST_GO_TO"] = "Expert search result - product-test go to";
    InternalNavigationScope["EXPERT_SEARCH_RESULT_TOPLIST_GO_TO"] = "Expert search result - toplist go to";
    InternalNavigationScope["EXPERT_SHOW_ALL_IN_CATEGORY"] = "Expert - show all in category";
    InternalNavigationScope["EXPERT_TOP_LIST"] = "Expert - top list";
    InternalNavigationScope["EXPERT_GUIDE_PAGE_GO_TO"] = "Expert guide - go to";
    InternalNavigationScope["FALLBACK_RECOMMENDATIONS_PRODUCT_CARD"] = "Fallback recommendations - product card";
    InternalNavigationScope["FALLBACK_RECOMMENDATIONS_HEADER"] = "Fallback recommendations - header";
    InternalNavigationScope["FEATURED_CATEGORY_ARTICLE"] = "Featured category article";
    InternalNavigationScope["FEATURED_PRODUCTS_PRODUCTS_CARD"] = "Featured products - product card";
    InternalNavigationScope["FEATURED_PRODUCTS_HEADER"] = "Featured products - header";
    InternalNavigationScope["FOOTER_INFO_PAGES"] = "Footer - info pages";
    InternalNavigationScope["GRID_LAYOUT_PRODUCT_CARD"] = "Grid layout - product card";
    InternalNavigationScope["GUIDE_EXPERT_TOPLIST"] = "Guide - expert toplist";
    InternalNavigationScope["GUIDE_PAGE_GO_TO"] = "Guide-page - go to";
    InternalNavigationScope["HERO_BANNER"] = "Hero banner";
    InternalNavigationScope["LIST_LAYOUT_PRODUCT_CARD"] = "List layout - product card";
    InternalNavigationScope["LOGO"] = "Logo";
    InternalNavigationScope["MEGA_MENU"] = "Mega menu";
    InternalNavigationScope["MIXED_CONTENT_CARD"] = "Mixed content card";
    InternalNavigationScope["MY_PROFILE_SETTINGS_USER_DATA"] = "My profile - settings user data";
    InternalNavigationScope["MY_PROFILE_USER_REVIEW_CARD"] = "My profile - user review card";
    InternalNavigationScope["NAVIGATION_CAROUSEL"] = "Navigation carousel";
    InternalNavigationScope["NEWSLETTER_EMAIL_PRIVACY"] = "Newsletter - email privacy";
    InternalNavigationScope["NEW_PRODUCT_RELEASES_PRODUCT_CARD"] = "New Product releases - product card";
    InternalNavigationScope["NEW_PRODUCT_RELEASES_HEADER"] = "New Product releases - header";
    InternalNavigationScope["OTHER_PRODUCTS_PRODUCT_CARD"] = "Other popular products - product card";
    InternalNavigationScope["OTHER_VISITED_PRODUCTS_PRODUCT_CARD"] = "Other visited - product card";
    InternalNavigationScope["PERSONALIZED_RECOMMENDATIONS_PRODUCT_CARD"] = "Personalized recommendations - product card";
    InternalNavigationScope["PERSONALIZED_RECOMMENDATIONS_HEADER"] = "Personalized recommendations - header";
    InternalNavigationScope["PRODUCT_INFORMATION"] = "Product information";
    InternalNavigationScope["POPULAR_FACETS_HEADER"] = "Popular facets - header";
    InternalNavigationScope["POPULAR_FACETS_PRODUCT_CARD"] = "Popular facets - product card";
    InternalNavigationScope["POPULAR_PRODUCTS_HEADER"] = "Popular products - header";
    InternalNavigationScope["POPULAR_PRODUCTS_SHOW_ALL"] = "Popular products - show all";
    InternalNavigationScope["POPULAR_PRODUCTS_PRODUCT_CARD"] = "Popular products - product card";
    InternalNavigationScope["PRODUCT_LISTING_PRODUCT_CARD_CATEGORY_LINK"] = "Product listing - product card go to category link";
    InternalNavigationScope["PRODUCT_COLLECTION_SITEMAP_LINK"] = "Product-collection sitemap - link";
    InternalNavigationScope["PRODUCT_PRODUCT_HEADER"] = "Product - product header";
    InternalNavigationScope["PRODUCT_PRICE_HISTORY"] = "Product - Price History";
    InternalNavigationScope["PRODUCT_TEST_PAGE_GO_TO"] = "Product-test-page - go to";
    InternalNavigationScope["PRODUCT_TEST_SIDEBAR_FIND_BEST_PRICE"] = "Product-test - sidebar find best price";
    InternalNavigationScope["PRODUCT_TEST_SIDEBAR_PRODUCT_CARD"] = "Product-test - sidebar product card";
    InternalNavigationScope["PRODUCT_TEST_SIDEBAR_RANK_IN_CATEGORY"] = "Product-test - sidebar rank in category";
    InternalNavigationScope["PRODUCT_HEADER"] = "Product header";
    InternalNavigationScope["PROMOTION_MODAL"] = "Promotion - promotion modal";
    InternalNavigationScope["PROMOTION_CARD_SHOP"] = "Promotion - shop promotion card";
    InternalNavigationScope["PROMOTION_CARD_BRAND"] = "Promotion - brand promotion card";
    InternalNavigationScope["PROMOTION_PRODUCT"] = "Promotion products - product card";
    InternalNavigationScope["RECENT_SEARCHES_HERO"] = "Recent-searches - hero";
    InternalNavigationScope["RECENTLY_VISITED_PRODUCT_CARD"] = "Recently visited - product card";
    InternalNavigationScope["RECENTLY_VISITED_PRODUCT_COLLECTION_CARD"] = "Recently visited - product collection card";
    InternalNavigationScope["REVIEW_READ_ALL"] = "Review - read all";
    InternalNavigationScope["REVIEW_USER_CARD"] = "Review - user card";
    InternalNavigationScope["RATE_SHOP_GO_TO"] = "Rate shop - go to";
    InternalNavigationScope["RELATED_ARTICLE"] = "Related article";
    InternalNavigationScope["RELATED_SEARCHES_SHOW_MORE"] = "Related searches - show more";
    InternalNavigationScope["RELATED_SEARCHES_WORD"] = "Related searches - word";
    InternalNavigationScope["SECONDARY_NAVIGATION"] = "Secondary navigation";
    InternalNavigationScope["STORE_AWARD_CARD"] = "Store - award card";
    InternalNavigationScope["STORE_CARD"] = "Store - card";
    InternalNavigationScope["STORE_GO_TO"] = "Store - go to";
    InternalNavigationScope["STORE_REVIEW"] = "Store - review";
    InternalNavigationScope["TABLE_LAYOUT_PRODUCT_CARD"] = "Table layout - product card";
    InternalNavigationScope["TAB_BAR"] = "Tab bar";
    InternalNavigationScope["TOPLIST_COMPARE_PRODUCTS"] = "Toplist - compare products";
    InternalNavigationScope["TOPLIST_MORE_FROM_EXPERT"] = "Toplist - More from expert";
    InternalNavigationScope["TOPLIST_MORE_REVIEWS_FOR_CATEGORY"] = "Toplist - More reviews for category";
    InternalNavigationScope["TOPLIST_PAGE_GO_TO"] = "Toplist-page - go to";
    InternalNavigationScope["TOPLIST_PAGE_HEADLINE_GO_TO"] = "Toplist-page headline - go to";
    InternalNavigationScope["TOPLIST_PRODUCT_IN_TOPLIST"] = "Toplist - Product in toplist";
    InternalNavigationScope["TOPLIST_PRODUCT_TEST"] = "Toplist - product test";
    InternalNavigationScope["TRENDING_PRODUCTS_HEADER"] = "Trending products - header";
    InternalNavigationScope["TRENDING_PRODUCTS_PRODUCT_CARD"] = "Trending products - product card";
    InternalNavigationScope["USED_PRODUCT"] = "Used products - product card";
    InternalNavigationScope["QUICK_SEARCH"] = "Quick search - search button";
    InternalNavigationScope["QUICK_SEARCH_CATEGORY"] = "Quick search - Category";
    InternalNavigationScope["QUICK_SEARCH_LATEST_SEARCHES"] = "Quick search - Latest searches";
    InternalNavigationScope["QUICK_SEARCH_PRODUCT"] = "Quick search - Product";
    InternalNavigationScope["QUICK_SEARCH_STORE"] = "Quick search - Store";
    InternalNavigationScope["QUICK_SEARCH_SEARCH_SUGGESTIONS"] = "Quick search - Search suggestions";
    InternalNavigationScope["QUICK_SEARCH_SUGGESTION"] = "Quick search - Suggestion";
    InternalNavigationScope["SEARCH_SUGGESTION"] = "Search - Suggestion";
    InternalNavigationScope["SEARCH_RESULT_PAGE_INTERNAL_ANCHOR"] = "Search result page - internal anchor";
})(InternalNavigationScope || (InternalNavigationScope = {}));


/***/ }),

/***/ 46353:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ih": () => (/* binding */ useKWLPDeprioritizeNoImageOffers),
/* harmony export */   "RY": () => (/* binding */ useAllProductsFilter),
/* harmony export */   "U_": () => (/* binding */ useShowAllVariantsExperiment),
/* harmony export */   "V3": () => (/* binding */ usePromotionsPageExperiment),
/* harmony export */   "aP": () => (/* binding */ useKWLPLimitProducts),
/* harmony export */   "hv": () => (/* binding */ usePartnerVideoCarouselExperiment),
/* harmony export */   "k0": () => (/* binding */ useShortenOfferlistHideAdsExperiment),
/* harmony export */   "sU": () => (/* binding */ useImageSearchExperiment)
/* harmony export */ });
/* harmony import */ var src_components_experiment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75234);

var useKWLPLimitProducts = (0,src_components_experiment__WEBPACK_IMPORTED_MODULE_0__/* .createExperimentHook */ .m)("kwlp-limit-products", 100, {
    items24: 24,
    items48: 48
});
var useKWLPDeprioritizeNoImageOffers = (0,src_components_experiment__WEBPACK_IMPORTED_MODULE_0__/* .createExperimentHook */ .m)("kwlp-deprioritize-no-image-offers", false, {
    deprioritize: true
});
var useShowAllVariantsExperiment = (0,src_components_experiment__WEBPACK_IMPORTED_MODULE_0__/* .createExperimentHook */ .m)("show-all-variants", false, {
    show: true
});
var useAllProductsFilter = (0,src_components_experiment__WEBPACK_IMPORTED_MODULE_0__/* .createExperimentHook */ .m)("search-page-all-products-searchable", false, {
    allProductsFilter: true
});
var usePartnerVideoCarouselExperiment = (0,src_components_experiment__WEBPACK_IMPORTED_MODULE_0__/* .createExperimentHook */ .m)("partner-video-carousel", false, {
    show: true
});
// TODO: Remove experiment when going live with Promotions hub page
var usePromotionsPageExperiment = (0,src_components_experiment__WEBPACK_IMPORTED_MODULE_0__/* .createExperimentHook */ .m)("promotions-page", false, {
    show: true
});
var useImageSearchExperiment = (0,src_components_experiment__WEBPACK_IMPORTED_MODULE_0__/* .createExperimentHook */ .m)("image-search", "hide", {
    limitedList: "limitedList",
    showAll: "showAll"
});
var useShortenOfferlistHideAdsExperiment = (0,src_components_experiment__WEBPACK_IMPORTED_MODULE_0__/* .createExperimentHook */ .m)("shorten-offerlist-hide-ads", "baseline", {
    shorten: "shorten",
    shortenPlusButton: "shorten-plus-button"
});


/***/ }),

/***/ 2613:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": () => (/* binding */ useResizeObserver)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function useResizeObserver() {
    var ref = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), 2), width = ref[0], setWidth = ref[1];
    var ref1 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), 2), height = ref1[0], setHeight = ref1[1];
    var ref2 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), 2), contentRect = ref2[0], setContentRect = ref2[1];
    // Use a state entry for the observed node in order to update when the node changes. The state
    // setter can be directly reused as a callback ref.
    // https://reactjs.org/docs/hooks-faq.html#how-can-i-measure-a-dom-node
    var ref3 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), 2), node = ref3[0], ref4 = ref3[1];
    // Init the ResizeObserver on mount and use the same instance throughout the hook's lifetime
    var observerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (observerRef.current) {
            return;
        }
        if (observerRef.current || !("ResizeObserver" in window)) {
            return;
        }
        observerRef.current = new ResizeObserver(function(entries) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var entry = _step.value;
                    var contentBoxSize = Array.isArray(entry.contentBoxSize) ? entry.contentBoxSize[0] : entry.contentBoxSize;
                    var ref;
                    setWidth((ref = contentBoxSize === null || contentBoxSize === void 0 ? void 0 : contentBoxSize.inlineSize) !== null && ref !== void 0 ? ref : entry.contentRect.width);
                    var ref1;
                    setHeight((ref1 = contentBoxSize === null || contentBoxSize === void 0 ? void 0 : contentBoxSize.blockSize) !== null && ref1 !== void 0 ? ref1 : entry.contentRect.height);
                    setContentRect(entry.contentRect);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
    }, []);
    // Update the observed nodes when the node changes
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var resizeObserver = observerRef.current;
        if (!resizeObserver || !_instanceof(node, Element)) {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return function() {};
        }
        resizeObserver.observe(node);
        return function() {
            return resizeObserver.unobserve(node);
        };
    }, [
        node
    ]);
    return {
        width: width,
        height: height,
        ref: ref4,
        node: node,
        contentRect: contentRect
    };
}


/***/ }),

/***/ 68141:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": () => (/* binding */ useGqlMutation)
/* harmony export */ });
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30519);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95939);
/* harmony import */ var src_client_gql_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35063);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



function useGqlMutation(options) {
    var mutation = options.mutation, _ = options.variables, useMutationOptions = _objectWithoutProperties(options, [
        "mutation",
        "variables"
    ]);
    var activeCampaign = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.globals.campaigns.active.find(function(c) {
            return c.type === "OFFER";
        });
    });
    var variables = _objectSpreadProps(_objectSpread({}, options.variables), {
        campaignId: activeCampaign === null || activeCampaign === void 0 ? void 0 : activeCampaign.id
    });
    var result = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_0__/* .useMutation */ .Db)(_objectSpread({
        mutationFn: function() {
            return src_client_gql_client__WEBPACK_IMPORTED_MODULE_2__/* .gqlClient.request */ .N.request(mutation, variables);
        }
    }, useMutationOptions));
    return result;
}


/***/ }),

/***/ 63113:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": () => (/* binding */ useGqlQuery)
/* harmony export */ });
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30519);
/* harmony import */ var src_client_gql_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35063);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function useGqlQuery(options) {
    var queryKey = options.queryKey, query = options.query, _variables = options.variables, variables = _variables === void 0 ? {} : _variables, rest = _objectWithoutProperties(options, [
        "queryKey",
        "query",
        "variables"
    ]);
    var result = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_0__/* .useQuery */ .aM)(_objectSpreadProps(_objectSpread({}, rest), {
        queryKey: options.queryKey.concat([
            variables
        ]),
        queryFn: function() {
            return src_client_gql_client__WEBPACK_IMPORTED_MODULE_1__/* .gqlClient.request */ .N.request(query, variables);
        },
        enabled: options.enabled
    }));
    return result;
}


/***/ }),

/***/ 32990:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": () => (/* binding */ useIsAuthenticated)
/* harmony export */ });
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95939);

var useIsAuthenticated = function() {
    return (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(function(state) {
        return state.areas.account.isAuthenticated;
    });
};


/***/ }),

/***/ 74993:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": () => (/* binding */ useLocalStorage)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

var useLocalStorage = function(key, initialValue) {
    var ref = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function() {
        try {
            // Get from local storage by key
            var item = window.localStorage.getItem(key);
            // Parse stored json or if none return initialValue
            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            // If error also return initialValue
            return initialValue;
        }
    }), 2), storedValue = ref[0], setStoredValue = ref[1];
    // Return a wrapped version of useState's setter function that ...
    // ... persists the new value to localStorage.
    var setValue = function(value) {
        try {
            // Allow value to be a function so we have same API as useState
            var valueToStore = _instanceof(value, Function) ? value(storedValue) : value;
            // Save state
            setStoredValue(value);
            // Save to local storage
            window.localStorage.setItem(key, JSON.stringify(valueToStore));
        } catch (error) {
        // A more advanced implementation would handle the error case
        }
    };
    return [
        storedValue,
        setValue
    ];
};


/***/ }),

/***/ 5148:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": () => (/* binding */ useMatchedRoute)
/* harmony export */ });
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18026);
/* harmony import */ var src_routes_match_route__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55196);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3616);
/* harmony import */ var src_routes_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(729);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50959);
/* harmony import */ var src_components_experiment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75234);






function useMatchedRoute() {
    var context = (0,src_components_app_context__WEBPACK_IMPORTED_MODULE_0__/* .useAppContext */ .bp)();
    var market = context.market;
    var location = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_2__/* .useLocation */ .TH)();
    var experiments = (0,react__WEBPACK_IMPORTED_MODULE_4__.useContext)(src_components_experiment__WEBPACK_IMPORTED_MODULE_5__/* .ExperimentContext */ .T);
    return (0,src_routes_match_route__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        useClassicUrls: market.useClassicUrls,
        useHashForProductTabs: market.useHashForProductTabs,
        routeConfig: (0,src_routes_config__WEBPACK_IMPORTED_MODULE_3__/* .buildRouteConfig */ .v)(market.code, market.routes),
        location: location,
        marketCode: market.code,
        experiments: experiments.selectedVariants
    });
}


/***/ }),

/***/ 62950:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": () => (/* binding */ usePageMetaTags)
/* harmony export */ });
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18026);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95939);
/* harmony import */ var src_hooks_use_meta_tags__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79965);
/* harmony import */ var src_hooks_use_matched_route__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5148);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}




function usePageMetaTags(data) {
    var context = (0,src_components_app_context__WEBPACK_IMPORTED_MODULE_0__/* .useAppContext */ .bp)();
    var matchedRoute = (0,src_hooks_use_matched_route__WEBPACK_IMPORTED_MODULE_3__/* .useMatchedRoute */ .M)();
    var hrefLang = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.globals.hrefLang;
    });
    var metaTags = {};
    if (matchedRoute && matchedRoute.metaTags) {
        metaTags = matchedRoute.metaTags(_objectSpread({
            data: data,
            hrefLang: hrefLang,
            routeName: matchedRoute.name
        }, matchedRoute.variables), context);
    }
    (0,src_hooks_use_meta_tags__WEBPACK_IMPORTED_MODULE_2__/* .useMetaTags */ .k)({
        metaTags: metaTags
    });
}


/***/ }),

/***/ 98854:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": () => (/* binding */ usePageQuery)
/* harmony export */ });
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30519);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95939);
/* harmony import */ var src_client_gql_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35063);
/* harmony import */ var src_hooks_use_page_meta_tags__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62950);
/* harmony import */ var src_hooks_use_route_loaded__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46925);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





function usePageQuery(options) {
    var routeName = options.routeName, query = options.query, rest = _objectWithoutProperties(options, [
        "routeName",
        "query"
    ]);
    var activeCampaign = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.globals.campaigns.active.find(function(c) {
            return c.type === "OFFER";
        });
    });
    var variables = _objectSpreadProps(_objectSpread({}, options.variables), {
        campaignId: activeCampaign === null || activeCampaign === void 0 ? void 0 : activeCampaign.id
    });
    var result = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_0__/* .useQuery */ .aM)(_objectSpread({
        queryKey: [
            routeName,
            "page",
            variables
        ],
        queryFn: function() {
            return src_client_gql_client__WEBPACK_IMPORTED_MODULE_2__/* .gqlClient.request */ .N.request(query, variables);
        },
        useErrorBoundary: true
    }, rest));
    (0,src_hooks_use_route_loaded__WEBPACK_IMPORTED_MODULE_4__/* .useRouteLoaded */ .N)(result.data, result.isFetching);
    (0,src_hooks_use_page_meta_tags__WEBPACK_IMPORTED_MODULE_3__/* .usePageMetaTags */ .p)(result.data);
    return result;
}


/***/ }),

/***/ 46925:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": () => (/* binding */ useRouteLoaded)
/* harmony export */ });
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18026);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var src_routes_match_route__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55196);
/* harmony import */ var react_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14727);
/* harmony import */ var src_routes_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(729);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95939);
/* harmony import */ var src_components_location_context__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68410);
/* harmony import */ var src_components_experiment__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(75234);
/* harmony import */ var src_components_ads_services_context__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31637);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}









function useRouteLoaded(data, isFetching) {
    var location = (0,react_router__WEBPACK_IMPORTED_MODULE_3__/* .useLocation */ .TH)();
    var context = (0,src_components_app_context__WEBPACK_IMPORTED_MODULE_0__/* .useAppContext */ .bp)();
    var market = context.market;
    var ref = (0,src_components_location_context__WEBPACK_IMPORTED_MODULE_6__/* .useLocationContext */ .F)(), currentLocation = ref.currentLocation, previousLocation = ref.previousLocation;
    var ref1 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), 2), isNewLocation = ref1[0], setIsNewLocation = ref1[1];
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useDispatch */ .I0)();
    var hrefLang = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(function(state) {
        return state.globals.hrefLang;
    });
    var experiments = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(src_components_experiment__WEBPACK_IMPORTED_MODULE_7__/* .ExperimentContext */ .T);
    var adServiceContext = (0,src_components_ads_services_context__WEBPACK_IMPORTED_MODULE_8__/* .useAdServiceContext */ .d)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setIsNewLocation(true);
    }, [
        currentLocation
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref;
        if (!(window === null || window === void 0 ? void 0 : window.dataLayer) || !data || !isNewLocation || isFetching) {
            return;
        }
        var route = (0,src_routes_match_route__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            useClassicUrls: market.useClassicUrls,
            useHashForProductTabs: market.useHashForProductTabs,
            routeConfig: (0,src_routes_config__WEBPACK_IMPORTED_MODULE_4__/* .buildRouteConfig */ .v)(market.code, market.routes),
            location: location,
            marketCode: market.code,
            experiments: experiments.experiments
        });
        var ref1;
        var meta = (ref1 = route === null || route === void 0 ? void 0 : (ref = route.metaTags) === null || ref === void 0 ? void 0 : ref.call(route, _objectSpread({
            data: data,
            routeName: route.name,
            hrefLang: hrefLang
        }, route.variables), context)) !== null && ref1 !== void 0 ? ref1 : {};
        var routeData = {
            page: route && route.name,
            meta: meta,
            section: route && route.match && route.match.params && route.match.params.section || undefined,
            previousLocation: getUrlHostPrefix() + previousLocation,
            currentLocation: getUrlHostPrefix() + currentLocation
        };
        // Since Google Tag Manager does a recursive merge of data in its data layer
        // we do a reset of our route data here to avoid merges of arrays and objects
        // when navigating between routes with the same route name
        var dataReset = {};
        Object.keys(data).forEach(function(key) {
            dataReset[key] = undefined;
        });
        window.dataLayer.push(_objectSpread({
            event: "resetRouteDataLayer"
        }, routeData, dataReset));
        window.dataLayer.push(_objectSpread({
            event: "routeLoaded"
        }, routeData, data));
        var action = {
            type: "ROUTE_LOADED",
            location: location,
            route: route,
            data: data
        };
        dispatch(action);
        setIsNewLocation(false);
        if (adServiceContext) {
            adServiceContext.update();
        }
    }, [
        isNewLocation,
        data,
        isFetching
    ]);
}
var getUrlHostPrefix = function() {
    return  true ? "".concat(window.location.protocol, "//").concat(window.location.host) : 0;
};


/***/ }),

/***/ 65195:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": () => (/* binding */ useSchibstedAccount)
/* harmony export */ });
/* harmony import */ var _prisjakt_schibsted_account_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78764);
/* harmony import */ var _prisjakt_schibsted_account_react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_prisjakt_schibsted_account_react__WEBPACK_IMPORTED_MODULE_0__);

// Used for tests.
var dummyAccount = {
    session: undefined,
    login: function() {
        return undefined;
    },
    logout: function() {
        return undefined;
    },
    showSimplifiedLoginWidget: function() {
        return Promise.resolve(false);
    },
    refreshSession: function() {
        return Promise.resolve();
    },
    profilePageUrl: function() {
        return "";
    }
};
var useSchibstedAccount = function() {
    try {
        return (0,_prisjakt_schibsted_account_react__WEBPACK_IMPORTED_MODULE_0__.useAccount)();
    } catch (e) {
        return dummyAccount;
    }
};



/***/ }),

/***/ 17716:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": () => (/* binding */ useShowUXFeedback),
/* harmony export */   "s": () => (/* binding */ ONE_DAY)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

var ONE_DAY = 86400 * 1000;
var useShowUXFeedback = function(/* A number in milliseconds that specifies how long time the feedback should be
  hidden (from timeSinceLastShown)  */ timeout, /* A number in milliseconds that specifies the last time the feedback was shown */ timeSinceLastShown) {
    var /* A number between 0 - 1 that specifies how often the feedback should appear,
  where 0 is 0% and 1 is 100%.  */ distribution = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
    var ref = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), 2), shouldShow = ref[0], setShouldShow = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setShouldShow(Math.random() < distribution && new Date().valueOf() - timeout > timeSinceLastShown);
    }, [
        distribution,
        timeout,
        timeSinceLastShown
    ]);
    return shouldShow;
};


/***/ }),

/***/ 53249:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": () => (/* binding */ useEffectOnMount)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);

/**
 * Hook to use when you want to execute only on mounting.
 * This will avoid eslint warnings when using an empty dependency array, and clearly states your intentions.
 */ var useEffectOnMount = function(effect) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(effect, []);
};


/***/ }),

/***/ 729:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": () => (/* binding */ buildRouteConfig)
});

;// CONCATENATED MODULE: ./src/components/meta-tags/article.js
var getCanonicalPath = function(article, market) {
    // Handle Black Friday 2019 featured article.
    // It is an article merged from several articles so
    // canonicals for merged articles should point on campaign page
    if (article.related.campaign && article.related.campaign.id === 2) {
        if (market.code === "se" && [
            43,
            169,
            177
        ].includes(article.id)) {
            return article.related.campaign.web_uri.responsive;
        }
        if (market.code === "no" && [
            51,
            55,
            54
        ].includes(article.id)) {
            return article.related.campaign.web_uri.responsive;
        }
        if (market.code === "gb" && [
            85,
            84,
            69
        ].includes(article.id)) {
            return article.related.campaign.web_uri.responsive;
        }
        if (market.code === "fi" && [
            20,
            17
        ].includes(article.id)) {
            return article.related.campaign.web_uri.responsive;
        }
    }
    if (article.related.campaign && article.featured) {
        // Use campaign page as canonical if article is featured
        return article.related.campaign.web_uri.responsive;
    }
    if (article.related.category && article.featured) {
        // Use category page as canonical if article is featured
        return article.related.category.pathName;
    }
    return article.pathName;
};
/* harmony default export */ function article(param, param1) {
    var data = param.data, market = param1.market, t = param1.t;
    if (!data) {
        return {};
    }
    var article = data.article;
    if (!article) {
        return {};
    }
    var canonicalUrl = market.domain + getCanonicalPath(article, market);
    var articleUrl = market.domain + article.pathName;
    var openGraph = [
        {
            key: "title",
            content: article.title
        },
        {
            key: "type",
            content: "article"
        },
        {
            key: "url",
            content: articleUrl
        },
        {
            key: "image",
            content: article.imageUrl
        }
    ];
    return {
        title: t("meta", "article.page-title", {
            title: article.title
        }),
        description: article.preamble,
        canonical: canonicalUrl,
        structuredData: undefined,
        openGraph: openGraph,
        // We only support hreflang tags on campaign articles for now
        hrefLang: article.related.campaign ? article.hrefLang : []
    };
};

// EXTERNAL MODULE: ./config/dist/markets/index.js
var markets = __webpack_require__(92331);
;// CONCATENATED MODULE: ./src/components/meta-tags/product/aggregate-rating.ts
function aggregateRating(product, market, t) {
    var ref, ref1, ref2;
    return {
        "@type": "AggregateRating",
        url: market.domain + product.pathName,
        ratingValue: ((ref = product.aggregatedRatingSummary) === null || ref === void 0 ? void 0 : ref.summary.rating.score) || ((ref1 = product.userReviewSummary) === null || ref1 === void 0 ? void 0 : ref1.rating) || 0,
        ratingCount: ((ref2 = product.aggregatedRatingSummary) === null || ref2 === void 0 ? void 0 : ref2.summary.rating.count) || product.userReviewSummary.count || 0,
        worstRating: 0,
        bestRating: 5,
        name: t("reviews", "panel.title")
    };
}

// EXTERNAL MODULE: ./src/components/price-list/filtering.ts + 2 modules
var filtering = __webpack_require__(88257);
// EXTERNAL MODULE: ./src/components/price-list/filters-config.ts
var filters_config = __webpack_require__(87990);
// EXTERNAL MODULE: ./src/components/currency/index.tsx
var currency = __webpack_require__(49763);
;// CONCATENATED MODULE: ./src/components/meta-tags/product/constants.ts
var sectionMap = {
    main: "product",
    properties: "productProperties",
    reviews: "productReviews",
    statistics: "productPriceHistory"
};
var sectionClassicParam = {
    main: "p",
    properties: "e",
    reviews: "o",
    statistics: "pu"
};

// EXTERNAL MODULE: ./src/components/price-list/sort-by-price.ts
var sort_by_price = __webpack_require__(31780);
// EXTERNAL MODULE: ./src/components/price-list/types.ts
var types = __webpack_require__(79126);
;// CONCATENATED MODULE: ./src/components/meta-tags/product/utils.ts






/**
 * Hackish way of emulating the default client side filtering of offers on product page.
 */ function getLowestPrice(product) {
    var ref, ref1, ref2, ref3;
    var defaultFilters = (0,filters_config/* getFiltersConfig */.I)();
    var filteredOffers = (0,filtering/* filterOffers */.h)(defaultFilters, product.prices);
    var firstSort = (0,sort_by_price/* sortOffersByPrice */.bo)(types/* PriceDisplayEnum.PRICE */.wB.PRICE, filteredOffers);
    return (firstSort === null || firstSort === void 0 ? void 0 : (ref = firstSort[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.price) === null || ref1 === void 0 ? void 0 : ref1.exclShipping) || (firstSort === null || firstSort === void 0 ? void 0 : (ref2 = firstSort[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.price) === null || ref3 === void 0 ? void 0 : ref3.inclShipping);
}
function getMeta(product, market) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    return {
        name: product.name,
        numberOfShops: ((ref = product.prices) === null || ref === void 0 ? void 0 : (ref1 = ref.meta) === null || ref1 === void 0 ? void 0 : ref1.itemsTotal) || 0,
        numberOfOffers: ((ref2 = product.prices) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.nodes) === null || ref3 === void 0 ? void 0 : ref3.length) || 0,
        lowestPrice: (0,currency/* formatCurrency */.xG)(getLowestPrice(product), market, false) || "",
        brand: (ref4 = product.brand) === null || ref4 === void 0 ? void 0 : ref4.name,
        category: ((ref5 = product.category) === null || ref5 === void 0 ? void 0 : ref5.name) || ""
    };
}
function getTitleTranslationKey(section, product, market) {
    switch(section){
        case "properties":
            return "product-properties.title";
        case "reviews":
            return "product-reviews.title";
        case "statistics":
            return "product-price-history.title";
        default:
            {
                // @NOTE: Product meta data experiment (NO, DK, FR, FI only)
                // Return different meta data based on product ID
                if (![
                    "no",
                    "dk",
                    "fr",
                    "fi"
                ].includes(market)) {
                    return "product.title";
                }
                switch(product.id % 10){
                    case 2:
                        return "product.title-alt-1";
                    case 4:
                        return "product.title-alt-2";
                    case 6:
                        return "product.title-alt-3";
                    case 8:
                        return "product.title-alt-4";
                    default:
                        return "product.title";
                }
            }
    }
}
function getRoundedCurrency(price, param) {
    var code = param.code;
    var ref;
    return parseFloat(price.toFixed((ref = currency/* MarketSettings */.Gr[code]) === null || ref === void 0 ? void 0 : ref.numberOfDecimals));
}
function getMainDescriptionTranslationKey(product, market) {
    if (!product.prices || !product.prices.meta || !product.prices.meta.itemsTotal) {
        return "product-no-shops.description";
    }
    if (!product.brand) {
        return "product-no-brand.description";
    }
    // @NOTE: Product meta data experiment (NO, DK, FR, FI only)
    // Return different meta data based on product ID
    if (![
        "no",
        "dk",
        "fr",
        "fi"
    ].includes(market)) {
        return "product.description";
    }
    switch(product.id % 10){
        case 1:
            return "product.description-alt-1";
        case 3:
            return "product.description-alt-2";
        case 5:
            return "product.description-alt-3";
        case 7:
            return "product.description-alt-4";
        default:
            return "product.description";
    }
}
function getDescriptionTranslationKey(section, product, market) {
    switch(section){
        case "properties":
            return "product-properties.description";
        case "reviews":
            return "product-reviews.description";
        case "statistics":
            return "product-price-history.description";
        default:
            return getMainDescriptionTranslationKey(product, market);
    }
}
function formatUrl(market, section, url, id) {
    if (!market) {
        return url;
    }
    if (!section || section === "main" || market && market.useHashForProductTabs) {
        return url;
    }
    if (/\?p=/.test(url)) {
        return url.replace("?p=".concat(id), "?".concat(sectionClassicParam[section], "=").concat(id));
    }
    if (/--p/.test(url)) {
        return "".concat(url, "/").concat(section);
    }
    return url;
}
function getLinkType(section) {
    return sectionMap[section || "main"];
}
function getCanonical(product, section, market, linkTo) {
    return market.domain + (market.useHashForProductTabs ? linkTo("product", product) : linkTo(getLinkType(section), product));
}
function getHrefLang(product, markets, section) {
    return product.hrefLang ? product.hrefLang.filter(function(h) {
        return h !== undefined && h !== null && h.locale && h.url;
    }).map(function(item) {
        var locale = item.locale, url = item.url;
        return {
            locale: locale,
            url: formatUrl(Object.values(markets).find(function(m) {
                return m.hrefLang && m.hrefLang.indexOf(locale) !== -1;
            }), section, url, product.id)
        };
    }) : [];
}

// EXTERNAL MODULE: ./src/areas/product/utils/product-condition/types.ts
var product_condition_types = __webpack_require__(83071);
;// CONCATENATED MODULE: ./src/components/meta-tags/product/aggregate-offer.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}




function aggregateOffer(product, market) {
    var _Math, _Math1;
    // Filtering out all offers that aren't displayed initially on the product page
    // because they are hidden by filters
    var initialFilters = (0,filters_config/* getFiltersConfig */.I)();
    var offers = (0,filtering/* filterOffers */.h)(initialFilters, product === null || product === void 0 ? void 0 : product.prices).filter(function(offer) {
        return offer.condition === product_condition_types/* ConditionEnum.NEW */.M.NEW;
    });
    var prices = offers.map(function(price) {
        var ref;
        return price === null || price === void 0 ? void 0 : (ref = price.price) === null || ref === void 0 ? void 0 : ref.exclShipping;
    }).filter(function(price) {
        return price !== undefined && price !== null;
    });
    return {
        "@type": "AggregateOffer",
        url: market.domain + product.pathName,
        lowPrice: getRoundedCurrency((_Math = Math).min.apply(_Math, _toConsumableArray(prices)), market),
        highPrice: getRoundedCurrency((_Math1 = Math).max.apply(_Math1, _toConsumableArray(prices)), market),
        offerCount: prices.length,
        priceCurrency: market.currency
    };
}

;// CONCATENATED MODULE: ./src/components/meta-tags/product/brand.ts
function brand(productBrand) {
    return {
        "@type": "Brand",
        name: productBrand.name
    };
}

;// CONCATENATED MODULE: ./src/components/meta-tags/product/offer.ts

function offer(product, market) {
    return {
        "@type": "Offer",
        url: market.domain + product.pathName,
        price: getRoundedCurrency(product.priceSummary.regular, market),
        priceCurrency: market.currency
    };
}

;// CONCATENATED MODULE: ./src/components/meta-tags/product/rating.ts
/**
 *
 * @param val Expects a value between 0 and 10, which will then be normalized to 0 and 5.
 * @returns Rating
 */ function rating(val) {
    return {
        "@type": "Rating",
        worstRating: 0,
        bestRating: 5,
        ratingValue: val || 0
    };
}

;// CONCATENATED MODULE: ./src/components/meta-tags/product/review.ts

function reviews(product, t) {
    return product.userReviews.nodes.filter(function(r) {
        return r !== undefined && r !== null;
    }).map(function(item) {
        return review(item, t);
    });
}
function review(item, t) {
    var ref;
    var ref1;
    // @NOTE: Do not include "reviewBody: item.reviewText," (potential XSS).
    return {
        "@type": "Review",
        datePublished: item.updatedAt || undefined,
        reviewRating: rating(item.convertedRating),
        author: {
            "@type": "Person",
            // @NOTE: This assumes display names are validated (!)
            name: (ref1 = (ref = item.user) === null || ref === void 0 ? void 0 : ref.name) !== null && ref1 !== void 0 ? ref1 : t("reviews", "user.guest")
        }
    };
}

;// CONCATENATED MODULE: ./src/components/meta-tags/product/core-property-value.ts
function corePropertyValue(product, t) {
    var booleanStrings = {
        true: t("product", "property.boolean-yes"),
        false: t("product", "property.boolean-no")
    };
    return product.coreProperties.nodes.filter(function(item) {
        return item.name && item.prettyTable;
    }).map(function(item) {
        return {
            "@type": "PropertyValue",
            name: item.name,
            value: item.type === "boolean" ? booleanStrings[item.prettyTable || "true"] : item.prettyTable
        };
    });
}

;// CONCATENATED MODULE: ./src/components/meta-tags/product/product-schema.ts
function productSchema(product, description) {
    return {
        "@context": "https://schema.org",
        "@type": "Product",
        name: product.name,
        description: description
    };
}

;// CONCATENATED MODULE: ./src/components/meta-tags/product/open-graph.ts
function graph(product, meta, description, market, t) {
    return [
        {
            key: "title",
            content: t("meta", "product.og-title", meta)
        },
        {
            key: "description",
            content: description
        },
        {
            key: "url",
            content: market.domain + product.pathName
        },
        {
            key: "type",
            content: "product"
        },
        product.priceSummary && {
            key: "amount",
            content: product.priceSummary.regular || product.priceSummary.alternative
        },
        {
            key: "currency",
            content: market.currency
        },
        product.category && {
            key: "category",
            content: product.category.name
        },
        product.media && {
            key: "image",
            content: product.media.first
        }
    ].filter(Boolean);
}

;// CONCATENATED MODULE: ./src/components/meta-tags/product/faq.ts
function faqPage(product) {
    if (!(product === null || product === void 0 ? void 0 : product.faqs)) return null;
    return {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: product.faqs.filter(Boolean).map(function(f) {
            return faqSchema(f);
        }) || []
    };
}
function faqSchema(faq) {
    return {
        "@type": "Question",
        name: faq.question,
        acceptedAnswer: {
            "@type": "Answer",
            text: faq.answer
        }
    };
}

;// CONCATENATED MODULE: ./src/components/meta-tags/product/product.js











/* harmony default export */ function product(param, param1) {
    var data = param.data, section = param.section, market = param1.market, t = param1.t, linkTo = param1.linkTo;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
    if (!data) {
        return {};
    }
    var product = data.product;
    if (!product) {
        return {};
    }
    var meta = getMeta(product, market.code);
    var metadata = product.metadata;
    var title = metadata ? metadata.title : t("meta", getTitleTranslationKey(section, product, market.code), meta);
    var description = metadata ? metadata.description : t("meta", getDescriptionTranslationKey(section, product, market.code), meta);
    var structuredData = productSchema(product, description);
    if ((ref = product.media) === null || ref === void 0 ? void 0 : ref.first) {
        structuredData.image = product.media.first;
    }
    if ((ref1 = product.brand) === null || ref1 === void 0 ? void 0 : ref1.name) {
        structuredData.brand = brand(product.brand);
    }
    if ((product === null || product === void 0 ? void 0 : (ref2 = product.aggregatedRatingSummary) === null || ref2 === void 0 ? void 0 : ref2.score) && (product === null || product === void 0 ? void 0 : (ref3 = product.aggregatedRatingSummary) === null || ref3 === void 0 ? void 0 : ref3.count) || (product === null || product === void 0 ? void 0 : (ref4 = product.userReviewSummary) === null || ref4 === void 0 ? void 0 : ref4.rating) && (product === null || product === void 0 ? void 0 : (ref5 = product.userReviewSummary) === null || ref5 === void 0 ? void 0 : ref5.count)) {
        structuredData.aggregateRating = aggregateRating(product, market, t);
    }
    var aggregateOffers = aggregateOffer(product, market);
    if (aggregateOffers.offerCount > 0) {
        structuredData.offers = aggregateOffers;
    } else if (product.priceSummary && product.priceSummary.regular) {
        structuredData.offers = offer(product, market);
    }
    if (product.userReviews) {
        structuredData.review = reviews(product);
    }
    if (product.releaseDate) {
        structuredData.releaseDate = product.releaseDate;
    }
    if ((ref6 = product.coreProperties) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.nodes) === null || ref7 === void 0 ? void 0 : ref7.length) {
        structuredData.additionalProperty = corePropertyValue(product, t);
    }
    var openGraph = graph(product, meta, description, market, t);
    var hrefLang = getHrefLang(product, markets/* marketConfig */.q, section);
    var canonical = getCanonical(product, section, market, linkTo);
    var faq = faqPage(product, market, t);
    return {
        title: title,
        description: description,
        hasAdultContent: !!((ref8 = product.category) === null || ref8 === void 0 ? void 0 : ref8.hasAdultContent),
        thumbnail: (ref9 = product.media) === null || ref9 === void 0 ? void 0 : ref9.first,
        openGraph: openGraph,
        structuredData: [
            structuredData,
            faq
        ],
        breadcrumb: (ref10 = product.category) === null || ref10 === void 0 ? void 0 : ref10.path,
        canonical: canonical,
        android: product.pathName,
        ios: "/product/".concat(product.id),
        hrefLang: hrefLang,
        noIndex: Boolean(product.noIndex),
        botify: {
            page: "product",
            category: (ref11 = product.category) === null || ref11 === void 0 ? void 0 : ref11.id,
            parentCategory: ((ref12 = product.category) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.path) === null || ref13 === void 0 ? void 0 : (ref14 = ref13[product.category.path.length - 2]) === null || ref14 === void 0 ? void 0 : ref14.id) || null,
            mainCategory: (ref15 = product.category) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.path) === null || ref16 === void 0 ? void 0 : (ref17 = ref16[0]) === null || ref17 === void 0 ? void 0 : ref17.id
        }
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/product-compare.js
// We only want to index compare pages in these categories and only if they
// have a high rank in popularity. This logic is also reflected in
// our sitemap generator. We do this to avoid bloating our Google index
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var versusCategories = [
    "103",
    "350",
    "500",
    "401"
];
var versusProductLimit = 25;
/* harmony default export */ function product_compare(param, param1) {
    var data = param.data, linkTo = param1.linkTo, t = param1.t;
    if (!data) {
        return {
            title: t("meta", "product-compare.title-fallback"),
            noIndex: true
        };
    }
    var category = data.category, products = data.products;
    var isVersus = products && products.length === 2;
    var categoryProps = {};
    var path = linkTo("productCompare", {
        category: category,
        products: products
    });
    if (category) {
        categoryProps.thumbnail = category.logo;
        categoryProps.breadcrumb = category.path.concat([
            {
                name: t("category", "product-compare.breadcrumb"),
                pathName: path
            }
        ]);
    }
    var noIndex = true;
    var title = t("meta", "product-compare.title-fallback");
    var description = null;
    if (isVersus) {
        title = t("meta", "product-compare.versus-title", {
            name1: products[0].name,
            name2: products[1].name
        });
        description = t("meta", "product-compare.versus-description", {
            name1: products[0].name,
            name2: products[1].name
        });
        noIndex = !(category && versusCategories.indexOf(category.id) > -1 && products[0].popularity.inCategory <= versusProductLimit && products[1].popularity.inCategory <= versusProductLimit);
    } else if (category) {
        title = t("meta", "product-compare.title", {
            categoryName: category.name
        });
    }
    return _objectSpreadProps(_objectSpread({}, categoryProps), {
        noIndex: noIndex,
        title: title,
        description: description
    });
};

;// CONCATENATED MODULE: ./src/components/meta-tags/product-alert.js
/* harmony default export */ function product_alert() {
    return {
        noIndex: true
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/start.js
/* harmony default export */ function start(param, param1) {
    var hrefLang = param.hrefLang, market = param1.market, t = param1.t;
    return {
        title: t("meta", "landing.title"),
        description: t("meta", "landing.description"),
        canonical: market.domain,
        openGraph: [
            {
                key: "title",
                content: t("meta", "company.name")
            },
            {
                key: "type",
                content: "website"
            },
            {
                key: "image",
                content: "".concat(market.cdn, "/g/rfe/logos/logo_v2_symbol.png")
            },
            {
                key: "url",
                content: market.domain
            }
        ],
        structuredData: {
            "@context": "http://schema.org",
            "@type": "WebSite",
            url: market.domain,
            potentialAction: {
                "@type": "SearchAction",
                target: "".concat(market.domain, "/search?search={search_term}"),
                "query-input": "required minLength=2 name=search_term"
            }
        },
        android: "/",
        ios: "/",
        hrefLang: Object.keys(hrefLang.start).map(function(locale) {
            return {
                locale: locale,
                url: hrefLang.start[locale]
            };
        })
    };
};

// EXTERNAL MODULE: ./node_modules/.pnpm/querystring@0.2.1/node_modules/querystring/index.js
var querystring = __webpack_require__(97150);
;// CONCATENATED MODULE: ./src/components/meta-tags/category.js
function category_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function category_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return category_arrayLikeToArray(arr);
}
function category_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function category_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function category_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function category_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            category_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function category_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function category_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        category_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || category_unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function category_toConsumableArray(arr) {
    return category_arrayWithoutHoles(arr) || category_iterableToArray(arr) || category_unsupportedIterableToArray(arr) || category_nonIterableSpread();
}
function category_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return category_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return category_arrayLikeToArray(o, minLen);
}

var isFilterCategory = function(category) {
    return /^s/.test(category.id) || category.filterId !== null;
};
var getParentPath = function(category) {
    return category.path && category.path.length > 0 ? category.path.slice(-1).pop().pathName : category.pathName;
};
var getPopularBrands = function(products) {
    var brandsAggregation = products.reduce(function(brands, product) {
        if (!product.brand) {
            return brands;
        }
        var brand = product.brand.name;
        return Object.assign(brands, category_defineProperty({}, brand, (brands[brand] || 0) + 1));
    }, {});
    return Object.keys(brandsAggregation).sort(function(a, b) {
        return brandsAggregation[b] - brandsAggregation[a];
    });
};
var getUrlsForSEO = function(domain, path, pageInfo) {
    var currentOffset = pageInfo.offset || 0;
    var currentLimit = pageInfo.limit;
    var ref = _slicedToArray(path.split("?"), 2), pathName = ref[0], query = ref[1];
    var qs = querystring.parse(query || {});
    var prevOffset = Math.max(0, currentOffset - currentLimit);
    var prevParams = category_objectSpread({}, qs, prevOffset > 0 ? {
        offset: prevOffset
    } : {});
    var nextParams = category_objectSpreadProps(category_objectSpread({}, qs), {
        offset: currentOffset + currentLimit
    });
    var canonicalParams = category_objectSpread({}, qs, currentOffset > 0 && {
        offset: currentOffset
    });
    var sortedCanonicalQuery = Object.keys(canonicalParams).sort().reduce(function(q, key) {
        return category_objectSpreadProps(category_objectSpread({}, q), category_defineProperty({}, key, canonicalParams[key]));
    }, {});
    return {
        prev: domain + pathName + (Object.keys(prevParams).length > 0 ? "?".concat(querystring.encode(prevParams)) : ""),
        next: domain + pathName + (Object.keys(nextParams).length > 0 ? "?".concat(querystring.encode(nextParams)) : ""),
        canonical: domain + pathName + (Object.keys(sortedCanonicalQuery).length > 0 ? "?".concat(querystring.encode(sortedCanonicalQuery)) : "")
    };
};
var addBrandToCategoryUrl = function(category, url) {
    if (!category.brand) {
        return url;
    }
    if (/[?&]k=/.test(url)) {
        return "".concat(url, "&t=").concat(category.brand.id);
    }
    if (/--c/.test(url)) {
        var separator = url.indexOf("?") === -1 ? "?" : "&";
        return "".concat(url).concat(separator, "brand=").concat(category.brand.id);
    }
    return url;
};
/* harmony default export */ function category(param, param1) {
    var data = param.data, market = param1.market, t = param1.t;
    var ref, ref1;
    if (!data) {
        return {};
    }
    if (((ref = data.categoryTree) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.id) === "v1004") {
        var ref2;
        // Meta tags for services page
        var tags = {
            title: t("meta", "landing.title"),
            description: t("meta", "landing.description"),
            canonical: market.domain,
            openGraph: []
        };
        return category_objectSpreadProps(category_objectSpread({}, tags), {
            openGraph: [
                {
                    key: "title",
                    content: t("meta", "company.name")
                },
                {
                    key: "type",
                    content: "website"
                },
                ((ref2 = data.categoryTree) === null || ref2 === void 0 ? void 0 : ref2[0]) && {
                    key: "image",
                    content: data.categoryTree[0].logo
                },
                {
                    key: "url",
                    content: market.domain
                }
            ].filter(Boolean)
        });
    }
    var category = data.category;
    if (!category) {
        return {};
    }
    var meta = {
        data: category.name,
        name: category.name
    };
    var categoryNames = [
        category.name
    ].concat(category_toConsumableArray(category.categories ? category.categories.nodes.map(function(c) {
        return c.name;
    }).slice(0, 3) : [])).join(", ");
    var productCount = category.productCount;
    var popularBrands = getPopularBrands(category.products.nodes).slice(0, 3).join(", ");
    var description = t("meta", "category.description", {
        categoryNames: categoryNames,
        productCount: productCount,
        popularBrands: popularBrands
    });
    var openGraph = [
        {
            key: "title",
            content: t("meta", "category.og-title", {
                name: category.name
            })
        },
        {
            key: "url",
            content: market.domain + category.pathName
        },
        {
            key: "desc",
            content: description
        },
        {
            key: "type",
            content: "product.group"
        },
        {
            key: "image",
            content: category.logo
        }
    ];
    var isFilter = isFilterCategory(category);
    var path = isFilter ? getParentPath(category) : category.pathName;
    // Will only use these values if its not a filtered result and we are viewing the leaf node in the category tree
    var ref3 = !isFilter && category.immediateProducts ? getUrlsForSEO(market.domain, path, category.products.pageInfo) : {}, prev = ref3.prev, canonical = ref3.canonical, next = ref3.next;
    // Trying to prevent indexation of empty category pages with huge offsets
    var noIndex = category.immediateProducts && category.products.pageInfo.offset > 0 && !category.products.nodes.length;
    return {
        canonical: canonical || market.domain + path,
        next: category.products.pageInfo.hasNext && next,
        prev: category.products.pageInfo.hasPrevious && prev,
        thumbnail: category.logo,
        hasAdultContent: category.hasAdultContent,
        description: description,
        title: t("meta", "category.title", meta),
        openGraph: openGraph,
        breadcrumb: category.path,
        structuredData: [
            {
                "@context": "http://schema.org",
                "@type": "Thing",
                name: category.name,
                description: description,
                image: category.logo,
                url: market.domain + category.pathName
            }
        ],
        android: category.pathName,
        ios: "/category/".concat(category.id),
        hrefLang: category.hrefLang && category.hrefLang.map(function(link) {
            return category_objectSpreadProps(category_objectSpread({}, link), {
                url: addBrandToCategoryUrl(category, link.url)
            });
        }),
        botify: {
            page: "category",
            category: category.id,
            parentCategory: category.path && category.path[category.path.length - 2] ? category.path[category.path.length - 2].id : null,
            mainCategory: category.path && category.path.length > 0 && category.path[0].id
        },
        noIndex: noIndex
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/store.js
/* harmony default export */ function store(param, param1) {
    var data = param.data, market = param1.market, t = param1.t;
    if (!data) {
        return {};
    }
    var store = data.store;
    if (!store) {
        return {};
    }
    var url = market.domain + store.pathName;
    var meta = {
        name: store.name
    };
    var structuredData = {
        "@context": "http://schema.org",
        "@type": "Organization",
        name: store.name,
        url: url
    };
    // Only add ratings if there is a set rating value
    if (store.userReviewSummary.count && store.userReviewSummary.rating) {
        structuredData.aggregateRating = {
            "@type": "AggregateRating",
            ratingValue: store.userReviewSummary.rating,
            url: url,
            ratingCount: store.userReviewSummary.count,
            worstRating: 0,
            bestRating: 5,
            name: t("reviews", "panel.title")
        };
        // Add the reviews
        // @NOTE: Do not include "reviewBody: item.reviewText," (potential XSS).
        structuredData.review = store.userReviews && store.userReviews.nodes ? store.userReviews.nodes.map(function(item) {
            return {
                "@type": "Review",
                datePublished: item.updatedAt,
                reviewRating: {
                    "@type": "Rating",
                    worstRating: 0,
                    bestRating: 5,
                    ratingValue: parseFloat((item.rating / 2).toFixed(1))
                },
                author: {
                    "@type": "Person",
                    // @NOTE: This assumes display names are validated (!)
                    name: item.user ? item.user.name : t("reviews", "user.guest")
                }
            };
        }) : [];
    }
    // TODO: Less hacky solution
    var storeLogoUrl = "".concat(market.imageCdnUrl, "image/store/").concat(store.id, ".png?w=88");
    var openGraph = [
        {
            key: "title",
            content: t("meta", "store.og-title", {
                name: store.name
            })
        },
        {
            key: "url",
            content: market.domain + store.pathName
        },
        {
            key: "type",
            content: "company"
        },
        {
            key: "image",
            content: storeLogoUrl
        }
    ];
    return {
        title: t("meta", "store.title", meta),
        description: t("meta", "store.description", meta),
        thumbnail: storeLogoUrl,
        canonical: market.domain + store.pathName,
        structuredData: structuredData,
        openGraph: openGraph,
        android: store.pathName,
        ios: "/store/".concat(store.id),
        hrefLang: store.hrefLang
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/campaign.js
/* harmony default export */ function campaign(param, param1) {
    var hrefLang = param.hrefLang, data = param.data, t = param1.t;
    if (!data) {
        return {};
    }
    var campaign = data.campaign;
    var title = campaign ? campaign.facetted.seoTitle : t("campaigns", "themes.title");
    var description = campaign ? campaign.facetted.seoDescription : t("campaigns", "themes.description");
    var campaignLogoBanner = campaign && campaign.banners && campaign.banners.length > 0 ? campaign.banners.find(function(item) {
        return item.type.toUpperCase() === "BANNER_LOGO_BIG";
    }) : undefined;
    var campaignImage = campaignLogoBanner ? campaignLogoBanner.imageUrl : undefined;
    var canonical = campaign ? campaign.facetted.canonical : undefined;
    var openGraph = campaign && [
        {
            key: "title",
            content: title
        },
        {
            key: "description",
            content: description
        },
        {
            key: "url",
            content: canonical
        },
        campaignImage && {
            key: "image",
            content: campaignImage
        },
        {
            key: "type",
            content: "website"
        }
    ];
    var structuredData = [];
    if (campaign) {
        var structuredDataCampaign = {
            "@context": "http://schema.org",
            "@type": "Thing",
            name: title,
            description: campaign.description.page,
            url: canonical
        };
        if (campaignImage) {
            structuredDataCampaign.image = campaignImage;
        }
        structuredData = [
            structuredDataCampaign
        ];
    }
    return {
        title: title,
        description: description,
        canonical: canonical,
        openGraph: openGraph,
        structuredData: structuredData,
        hrefLang: campaign ? campaign.hrefLang : Object.keys(hrefLang.campaignMain).map(function(locale) {
            return {
                locale: locale,
                url: hrefLang.campaignMain[locale]
            };
        })
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/info-page.ts
/* harmony default export */ function info_page(param, param1) {
    var data = param.data, market = param1.market, t = param1.t;
    var domain = market.domain;
    var ref = (data === null || data === void 0 ? void 0 : data.page) || {}, title = ref.title, pathName = ref.pathName, hrefLang = ref.hrefLang;
    var canonical = domain && pathName ? new URL(pathName, domain).toString() : undefined;
    return {
        title: title ? t("meta", "info.page-title", {
            title: title
        }) : undefined,
        description: t("meta", "info.description"),
        canonical: canonical,
        hrefLang: hrefLang,
        openGraph: []
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/brand.js
/* harmony default export */ function meta_tags_brand(param, param1) {
    var data = param.data, market = param1.market, t = param1.t;
    if (!data) {
        return {};
    }
    var brand = data.brand;
    if (!brand) {
        return {};
    }
    var meta = {
        name: brand.name,
        productCount: brand.productsTotal
    };
    var openGraph = [
        {
            key: "title",
            content: brand.name
        },
        {
            key: "type",
            content: "company"
        },
        {
            key: "image",
            content: brand.logo
        }
    ];
    return {
        canonical: market.domain + brand.pathName,
        thumbnail: brand.logo,
        description: t("meta", "brand.description", meta),
        title: t("meta", "brand.title", meta),
        openGraph: openGraph,
        structuredData: undefined,
        hrefLang: brand.hrefLang,
        noIndex: !brand.productsTotal
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/login.js
/* harmony default export */ function login(props, param) {
    var t = param.t;
    return {
        title: t("meta", "login.title")
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/shop-of-the-year-landing-page.js
/* harmony default export */ function shop_of_the_year_landing_page(param, param1) {
    var data = param.data, market = param1.market, t = param1.t;
    if (!data) {
        return {};
    }
    var year = data.shopOfTheYear ? data.shopOfTheYear.year : "";
    var cdnDir = "".concat(market.cdn, "/g/store_of_the_year/").concat(year, "/").concat(market.code);
    var badgeURI = "".concat(cdnDir, "/award/main_award.png");
    var openGraph = [
        {
            key: "title",
            content: t("campaigns", "shop-of-the-year.meta-title", {
                year: year
            })
        },
        {
            key: "type",
            content: "website"
        },
        {
            key: "image",
            content: badgeURI
        }
    ];
    return {
        thumbnail: badgeURI,
        description: t("campaigns", "shop-of-the-year.active-header-description", {
            year: year
        }),
        title: t("campaigns", "shop-of-the-year.title"),
        openGraph: openGraph,
        structuredData: undefined,
        hrefLang: []
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/shop-of-the-year-category.js
/* harmony default export */ function shop_of_the_year_category(param, param1) {
    var data = param.data, t = param1.t;
    if (!data) {
        return {};
    }
    var category = data.shopOfTheYearCategory;
    var sotyTitle = t("campaigns", "shop-of-the-year.title");
    var categoryTitle = t("campaigns", "shop-of-the-year.category-title", {
        category: category.name
    });
    var pageTitle = "".concat(sotyTitle, " - ").concat(categoryTitle);
    var openGraph = [
        {
            key: "title",
            content: pageTitle
        },
        {
            key: "type",
            content: "website"
        }
    ];
    return {
        title: pageTitle,
        openGraph: openGraph,
        structuredData: undefined,
        hrefLang: []
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/shop-of-the-year-winners.js
/* harmony default export */ function shop_of_the_year_winners(param, param1) {
    var data = param.data, market = param1.market, t = param1.t, linkTo = param1.linkTo;
    if (!data) {
        return {};
    }
    var year = data.shopOfTheYear ? data.shopOfTheYear.year : "";
    var cdnDir = "".concat(market.cdn, "/g/store_of_the_year/").concat(year, "/").concat(market.code);
    var badgeURI = "".concat(cdnDir, "/award/main_award.png");
    var openGraph = [
        {
            key: "title",
            content: t("campaigns", "shop-of-the-year.winners-page-title", {
                year: year
            })
        },
        {
            key: "type",
            content: "website"
        },
        {
            key: "image",
            content: badgeURI
        }
    ];
    return {
        canonical: "".concat(market.domain, "/").concat(linkTo("shopOfTheYearWinners", {
            year: year
        })),
        thumbnail: badgeURI,
        description: t("campaigns", "shop-of-the-year.winners-description", {
            year: year
        }),
        title: t("campaigns", "shop-of-the-year.winners-page-title", {
            year: year
        }),
        openGraph: openGraph,
        structuredData: undefined,
        hrefLang: []
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/shop-of-the-year.js


/* harmony default export */ function shop_of_the_year(props, context) {
    if (!props.data) {
        return {};
    }
    if (props.data.shopOfTheYear) {
        return shop_of_the_year_landing_page(props, context);
    }
    return shop_of_the_year_winners(props, context);
};

;// CONCATENATED MODULE: ./src/components/meta-tags/promotion-products.ts
/* harmony default export */ function promotion_products(param, param1) {
    var data = param.data, linkTo = param1.linkTo, market = param1.market, t = param1.t;
    var ref, ref1, ref2, ref3, ref4, ref5;
    if (!(data === null || data === void 0 ? void 0 : (ref = data.promotion) === null || ref === void 0 ? void 0 : ref.id) || !(data === null || data === void 0 ? void 0 : (ref1 = data.promotion) === null || ref1 === void 0 ? void 0 : ref1.title) || !(data === null || data === void 0 ? void 0 : (ref2 = data.promotion) === null || ref2 === void 0 ? void 0 : ref2.description) || !(data === null || data === void 0 ? void 0 : (ref3 = data.promotion) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.owner) === null || ref4 === void 0 ? void 0 : ref4.name)) {
        return {};
    }
    var title = "".concat(t("meta", "site.name"), " | ").concat(data.promotion.owner.name, " | ").concat(data.promotion.title);
    var description = data.promotion.description;
    var canonical = "".concat(market.domain).concat(linkTo("promotions", {
        id: data === null || data === void 0 ? void 0 : (ref5 = data.promotion) === null || ref5 === void 0 ? void 0 : ref5.id
    }));
    return {
        noIndex: true,
        title: title,
        description: description,
        canonical: canonical
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/promotions.ts
/* harmony default export */ function promotions(_data, param) {
    var t = param.t, linkTo = param.linkTo, market = param.market;
    return {
        title: "".concat(t("meta", "site.name"), " | ").concat(t("meta", "promotions-list.title")),
        description: t("meta", "promotions-list.description"),
        canonical: "".concat(market.domain).concat(linkTo("promotions"))
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/used-products.ts
/* harmony default export */ function used_products(_data, param) {
    var t = param.t, linkTo = param.linkTo, market = param.market;
    return {
        title: "".concat(t("meta", "site.name"), " | ").concat(t("meta", "used-products.title")),
        description: t("meta", "used-products.description"),
        canonical: "".concat(market.domain).concat(linkTo("used"))
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/search.js
/* harmony default export */ function search(param, param1) {
    var data = param.data, t = param1.t;
    if (!data) {
        return {};
    }
    var search = data.newSearch || data.search;
    if (!search) {
        return {};
    }
    var meta = {
        query: search.query
    };
    return {
        noIndex: true,
        description: t("meta", "search.description", meta),
        title: t("meta", "search.title", meta)
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/generic.js
var titles = {
    login: {
        domain: "account",
        key: "login.title"
    },
    forgotPassword: {
        domain: "account",
        key: "forgot-password.title"
    },
    forgotPasswordChange: {
        domain: "account",
        key: "forgot-password-change.title"
    },
    personalization: {
        domain: "account",
        key: "personalization.headline"
    },
    trackingSettings: {
        domain: "tracking-settings",
        key: "page.title"
    },
    settings: {
        domain: "account",
        key: "settings.title"
    },
    categoryIndex: {
        domain: "category",
        key: "category-index.categories"
    }
};
/* harmony default export */ function generic(param, param1) {
    var routeName = param.routeName, t = param1.t;
    return {
        title: titles[routeName] ? "".concat(t(titles[routeName].domain, titles[routeName].key), " | ").concat(t("meta", "site.name")) : t("meta", "landing.title")
    };
};

// EXTERNAL MODULE: ./src/areas/editorial-content/components/slices/rich-text/index.tsx + 1 modules
var rich_text = __webpack_require__(76891);
;// CONCATENATED MODULE: ./src/components/meta-tags/editorial-content/faq.ts

function faq_faqPage(faqData) {
    return {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqData.items.filter(Boolean).map(function(f) {
            return faq_faqSchema(f);
        }) || []
    };
}
function faq_faqSchema(faq) {
    return {
        "@type": "Question",
        name: (0,rich_text/* plainText */.K)(faq.question),
        acceptedAnswer: {
            "@type": "Answer",
            text: (0,rich_text/* plainText */.K)(faq.answer)
        }
    };
}

;// CONCATENATED MODULE: ./src/components/meta-tags/product-collection.ts
function product_collection_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function product_collection_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            product_collection_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function product_collection_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function product_collection_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        product_collection_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var getSlice = function(slices, type) {
    return Array.isArray(slices) ? slices.find(function(slice) {
        return slice.__typename === type;
    }) : undefined;
};
/* harmony default export */ function product_collection(param, param1) {
    var data = param.data, t = param1.t;
    var ref, ref1;
    if (!data || !data.productCollection) {
        return {};
    }
    var _productCollection = data.productCollection, slices = _productCollection.slices, indexable = _productCollection.indexable;
    var metaData = getSlice(slices, "MetaDataSlice");
    var breadcrumb = getSlice(slices, "BreadcrumbsSlice");
    var productSlice = getSlice(slices, "ProductsSlice");
    var faqSlice = getSlice(slices, "PrismicSliceFaqSection");
    if (!metaData) {
        return {};
    }
    var noIndex = (productSlice === null || productSlice === void 0 ? void 0 : (ref = productSlice.products) === null || ref === void 0 ? void 0 : ref.length) === 0 || indexable === false;
    var title = metaData.title, description = metaData.description, hrefLang = metaData.hrefLang, image = metaData.image, metaUrls = metaData.url, pagination = metaData.pagination;
    var ref2 = metaUrls || {}, current = ref2.current, next = ref2.next, prev = ref2.prev;
    var titleWithPagination = pagination && pagination.currentPage > 1 ? t("meta", "product-collection.paginated-title", product_collection_objectSpreadProps(product_collection_objectSpread({}, pagination), {
        title: title
    })) : title;
    var descriptionWithPagination = pagination && pagination.currentPage > 1 ? t("meta", "product-collection.paginated-description", product_collection_objectSpreadProps(product_collection_objectSpread({}, pagination), {
        description: description || ""
    })) : description;
    return {
        title: titleWithPagination,
        description: descriptionWithPagination,
        hasAdultContent: data.productCollection.hasAdultContent,
        canonical: noIndex ? undefined : current,
        noIndex: noIndex,
        breadcrumb: breadcrumb && breadcrumb.items,
        structuredData: (faqSlice === null || faqSlice === void 0 ? void 0 : (ref1 = faqSlice.items) === null || ref1 === void 0 ? void 0 : ref1.length) ? [
            faq_faqPage(faqSlice)
        ] : [],
        openGraph: [
            {
                key: "title",
                content: title
            },
            {
                key: "url",
                content: current
            },
            {
                key: "desc",
                content: descriptionWithPagination
            },
            {
                key: "type",
                content: "product.group"
            },
            {
                key: "image",
                content: image
            }
        ],
        thumbnail: image,
        hrefLang: hrefLang,
        next: next,
        prev: prev
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/product-collection-sitemap.ts
/* harmony default export */ function product_collection_sitemap(props, param) {
    var t = param.t;
    var data = props.data;
    if (!(data === null || data === void 0 ? void 0 : data.productCollectionSitemap)) {
        return {};
    }
    var title = t("meta", "product-collection-sitemap.title", {
        title: data.productCollectionSitemap.name || ""
    });
    var description = t("meta", "product-collection-sitemap.description", {
        title: data.productCollectionSitemap.name || ""
    });
    return {
        noIndex: true,
        follow: true,
        title: title,
        description: description,
        openGraph: [
            {
                key: "title",
                content: title
            },
            {
                key: "desc",
                content: description
            },
            {
                key: "type",
                content: "website"
            }
        ]
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/editorial-content/editorial-content.ts
function editorial_content_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function editorial_content_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return editorial_content_arrayLikeToArray(arr);
}
function editorial_content_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function editorial_content_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function editorial_content_toConsumableArray(arr) {
    return editorial_content_arrayWithoutHoles(arr) || editorial_content_iterableToArray(arr) || editorial_content_unsupportedIterableToArray(arr) || editorial_content_nonIterableSpread();
}
function editorial_content_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return editorial_content_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return editorial_content_arrayLikeToArray(o, minLen);
}

var isPrismicSliceHeroTitle = function(value) {
    return value !== null && typeof value === "object" && "heroImage" in value;
};
var isPrismicSliceImage = function(value) {
    return value !== null && typeof value === "object" && "image" in value;
};
var getFirstTextContent = function(content) {
    var ref;
    return (ref = content.find(function(item) {
        return "text" in item;
    })) === null || ref === void 0 ? void 0 : ref.text;
};
/* harmony default export */ function editorial_content(param, param1) {
    var data = param.data, market = param1.market, t = param1.t;
    var ref, ref1, ref2;
    if (!(data === null || data === void 0 ? void 0 : data.prismicArticle)) {
        return {};
    }
    var domain = market.domain;
    var _prismicArticle = data.prismicArticle, pathName = _prismicArticle.pathName, datePublished = _prismicArticle.publishedAt, dateModified = _prismicArticle.updatedAt, prismicData = _prismicArticle.data;
    var articleUrl = domain && pathName ? new URL(pathName, domain).toString() : undefined;
    var _title;
    var articleTitle = (_title = prismicData.meta.title) !== null && _title !== void 0 ? _title : getFirstTextContent(prismicData.title);
    var _description;
    var articleDescription = (_description = prismicData.meta.description) !== null && _description !== void 0 ? _description : ((ref = prismicData.metaDescription) === null || ref === void 0 ? void 0 : ref.length) ? getFirstTextContent(prismicData.metaDescription) : undefined;
    var featuredImage = (ref1 = prismicData.featuredImage) === null || ref1 === void 0 ? void 0 : ref1.url;
    var articleImages = [
        featuredImage
    ].concat(editorial_content_toConsumableArray(prismicData.body.map(function(slice) {
        if (slice.type === "HERO_TITLE" && isPrismicSliceHeroTitle(slice.primary)) {
            var ref;
            return (ref = slice.primary.heroImage) === null || ref === void 0 ? void 0 : ref.url;
        }
        if (slice.type === "IMAGE" && isPrismicSliceImage(slice.primary)) {
            return slice.primary.image.url;
        }
        return undefined;
    }))).filter(function(value) {
        return typeof value === "string";
    });
    var openGraph = [
        {
            key: "title",
            content: articleTitle
        },
        {
            key: "type",
            content: "article"
        },
        {
            key: "url",
            content: articleUrl
        },
        {
            key: "image",
            content: articleImages[0]
        }
    ];
    var structuredData = {
        "@context": "http://schema.org",
        "@type": "Article",
        datePublished: datePublished,
        dateModified: dateModified,
        headline: articleTitle,
        image: articleImages[0],
        description: articleDescription
    };
    var articleFaqSlice = (ref2 = prismicData.body.find(function(slice) {
        return slice.type === "FAQ_SECTION";
    })) === null || ref2 === void 0 ? void 0 : ref2.primary;
    return {
        title: t("meta", "article.page-title", {
            title: articleTitle
        }),
        description: articleDescription,
        canonical: articleUrl,
        structuredData: articleFaqSlice ? [
            structuredData,
            faq_faqPage(articleFaqSlice)
        ] : structuredData,
        openGraph: openGraph,
        hrefLang: []
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/editorial-content/editorial-content-listing.js
/* harmony default export */ function editorial_content_listing(_, param) {
    var market = param.market, t = param.t;
    return {
        title: t("meta", "articles.title"),
        description: undefined,
        canonical: "".concat(market.domain).concat(market.routes && market.routes.editorialContentListing && market.routes.editorialContentListing.path || "/articles"),
        openGraph: [],
        structuredData: undefined,
        hrefLang: undefined
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/user-profile.tsx
var profileMetaTags = function(param, param1) {
    var data = param.data, offset = param.offset, section = param.section, market = param1.market, t = param1.t;
    if (!data || !data.user) {
        return {};
    }
    var baseUrl = "".concat(market.domain, "/user/").concat(data.user.id);
    // Canonicalise to the section URL
    var url = section ? "".concat(baseUrl, "/").concat(section) : "".concat(baseUrl, "/reviews");
    // Self canonicalise each offset page to make Google index it as its
    // own unique page
    var canonical = offset ? "".concat(url, "?offset=").concat(offset) : url;
    var metaTags = {
        title: t("meta", "profile.page-title", {
            user: data.user.displayName || t("account", "profile.title")
        }),
        description: null,
        canonical: canonical,
        openGraph: [],
        structuredData: undefined,
        hrefLang: []
    };
    return metaTags;
};
/* harmony default export */ const user_profile = (profileMetaTags);

;// CONCATENATED MODULE: ./src/components/meta-tags/public-list.ts
/* harmony default export */ function public_list(param, param1) {
    var data = param.data, t = param1.t;
    var ref;
    if (!(data === null || data === void 0 ? void 0 : data.list)) return {};
    var title = ((ref = data.list.user) === null || ref === void 0 ? void 0 : ref.displayName) ? t("meta", "list.title", {
        name: data.list.name,
        owner: data.list.user.displayName
    }) : data.list.name;
    return {
        title: title
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/helpers/expert-category-mappings.json
const expert_category_mappings_namespaceObject = JSON.parse('{"hP":{"Hörlurar":"hörlurar","Datorer":"dator","Högtalare":"högtalare","Eltandborstar":"eltandborste","Barnstolar":"barnstol","TV":"tv","Surfplattor":"surfplatta","Babyvakter":"babyvakt","Bilbarnstolar":"bilbarnstol","Köksassistenter":"köksassistent","Mobiltelefoner":"mobiltelefon","Drönare":"drönare","Barnvagnar":"barnvagn","Spelkonsoler":"spelkonsol","Blenders":"blender","Spel":"spel","Kaffemaskiner":"kaffemaskin","Bärselar":"bärsele","Åkpåsar":"åkpåse","Skrivare":"skrivare","Elvispar":"elvisp","Babysitters":"babysitter","Objektiv":"objektiv","Kameror":"kamera","Stavmixers":"stavmixer","Smarta klockor":"smart klocka","Bildskärmar":"bildskärm","Glassmaskiner":"glassmaskin","Grillar":"grill","Hårfönar":"hårfön","Hårtrimmers":"hårtrimmer","Kaffekvarnar":"kaffekvarn","Läsplattor":"läsplatta","Locktänger":"locktång","Matberedare":"matberedare","Övervakningskameror":"övervakningskamera","Plattänger":"plattång","Rakapparater":"rakapparat","Robotdammsugare":"robotdammsugare","Routrar":"router","Smarta lampor":"smart lampa","Barngrindar":"barngrind","Barnsängar":"barnsäng","Cyklar":"cykel","Däck":"däck","Dammsugare":"dammsugare","Diskmaskiner":"diskmaskin","Elcyklar":"elcykel","Ficklampor":"ficklampa","Fiske":"fiskepryl","Frysar":"frys","Kylskåp":"kylskåp","Längdskidor":"längdskidor","Löpband":"löpband","Motionscyklar":"motionscykel","Powerbanks":"powerbank","Roddmaskiner":"roddmaskin","Sällskapsspel":"sällskapsspel","Brädspel":"brädspel","Schampo":"schampo","Skäggolja":"skäggolja","Skötbord":"skötbord","Skötväskor":"skötväska","Skridskor":"skridskor","Stegräknare":"stegräknare","Tvättmaskiner":"tvättmaskin","Värmepumpar":"värmepump","Cykelvagnar":"cykelvagn","Concealer":"concealer","Balsam":"balsam","Foundation":"foundation","Stekpannor":"stekpanna","Hårinpackning":"hårinpackning","Tangentbord":"tangentbord","Mascara":"mascara","Primer":"primer","Projektorer":"projektor","Löparskor":"löparsko","Sous vide":"sous vide","Vakuumförpackare":"vakuumförpackare","Smarta hubbar":"smart hubb","Datormöss":"datormus","Tält":"tält","Liggunderlag":"liggunderlag","Sovsäckar":"sovsäck","Ansiktsmasker":"ansiktsmask","Jackor":"jacka","Pannlampor":"pannlampa","Robotgräsklippare":"robotgräsklippare","Ryggsäckar":"ryggsäck","Stormkök":"stormkök","Vandringskängor":"vandringskänga","Solkräm":"solkräm","Grästrimmrar & röjsågar":"grästrimmer & röjsåg","Personvågar":"personvåg","Smarta lås":"smart lås","Ansiktsrengöring":"ansiktsrengöring","Brun utan sol":"brun utan sol","Läppglans":"läppglans","Massageapparater":"massageapparat","Puder & mineralpuder":"puder","Kolsyremaskiner":"kolsyremaskin","Vattenkokare":"vattenkokare","Stektermometrar":"stektermometer","Contouring & highlighter":"highlighter","Duschtvål":"duschtvål","Kajal & eyeliner":"kajalpenna","Serum":"serum","Sminksvamp":"sminksvamp","Padel":"padeltillbehör","Grilltillbehör":"grilltillbehör","Fläktar":"fläkt","Kokplattor":"kokplatta","Fritöser":"airfryer","Parfym":"parfym","Ansiktskräm":"ansiktskräm","Ögonvård":"ögonvård","Peeling":"peeling","Riskokare":"riskokare","Fotvård":"fotvård","Nagellack":"nagellack","Kockknivar":"kockkniv","Bakmaskiner":"bakmaskin","Vinkylar":"vinkyl","Våffeljärn":"våffeljärn","Slow cookers":"slow cooker","Mattork":"mattork","Termoskannor":"termoskanna","Pizzaugnar":"pizzaugn","Body lotion & krämer":"body lotion","Skidhandskar":"skidhandske","Luftfuktare":"luftfuktare","Avfuktare":"avfuktare","Luftrenare":"luftrenare","Skidglasögon":"skidglasögon","Skidhjälmar":"skidhjälm","Ögonbrynsgel":"ögonbrynsgel","Smörgåsgrillar":"smörgåsgrill","Blenders & stavmixers":"blender & stavmixer","Gödsel":"gödsel","Mandoliner":"mandolin","Portabel AC":"portabel ac","Värmeskydd":"värmeskydd","Grytor & kastruller":"kastrull och gryta","Alpinskydd - Ryggskydd":"ryggskydd","Popcornmaskiner":"popcornmaskin","Pastamaskiner":"pastamaskin","Mjölkskummare":"mjölkskummare","Knivslipar":"knivslip"},"l2":{"Hörlurar":"hörlurarna","Datorer":"datorn","Högtalare":"högtalaren","Eltandborstar":"eltandborsten","Barnstolar":"barnstolen","TV":"tv:n","Surfplattor":"surfplattan","Babyvakter":"babyvakten","Bilbarnstolar":"bilbarnstolen","Köksassistenter":"köksassistenten","Mobiltelefoner":"mobiltelefonen","Drönare":"drönaren","Barnvagnar":"barnvagnen","Spelkonsoler":"spelkonsolen","Blenders":"blendern","Spel":"spelet","Kaffemaskiner":"kaffemaskinen","Bärselar":"bärselen","Åkpåsar":"åkpåsen","Skrivare":"skrivaren","Elvispar":"elvispen","Babysitters":"babysittern","Objektiv":"objektivet","Kameror":"kameran","Stavmixers":"stavmixern","Smarta klockor":"smarta klockan","Bildskärmar":"bildskärmen","Glassmaskiner":"glassmaskinen","Grillar":"grillen","Hårfönar":"hårfönen","Hårtrimmers":"hårtrimmern","Kaffekvarnar":"kaffekvarnen","Läsplattor":"läsplattan","Locktänger":"locktången","Matberedare":"matberedaren","Övervakningskameror":"övervakningskameran","Plattänger":"plattången","Rakapparater":"rakapparaten","Robotdammsugare":"robotdammsugaren","Routrar":"routern","Smarta lampor":"smarta lampan","Barngrindar":"barngrinden","Barnsängar":"barnsängen","Cyklar":"cykeln","Däck":"däcket","Dammsugare":"dammsugaren","Diskmaskiner":"diskmaskinen","Elcyklar":"elcykeln","Ficklampor":"ficklampan","Fiske":"fiskeprylen","Frysar":"frysen","Kylskåp":"kylskåpet","Längdskidor":"längdskidorna","Löpband":"löpbandet","Motionscyklar":"motionscykeln","Powerbanks":"powerbanken","Roddmaskiner":"roddmaskinen","Sällskapsspel":"sällskapsspelet","Brädspel":"brädspelet","Schampo":"schampot","Skäggolja":"skäggoljan","Skötbord":"skötbordet","Skötväskor":"skötväskan","Skridskor":"skridskorna","Stegräknare":"stegräknaren","Tvättmaskiner":"tvättmaskinen","Värmepumpar":"värmepumpen","Cykelvagnar":"cykelvagnen","Concealer":"concealern","Balsam":"balsamet","Foundation":"foundationet","Stekpannor":"stekpannan","Hårinpackning":"hårinpackningen","Tangentbord":"tangentbordet","Mascara":"mascaran","Primer":"primern","Projektorer":"projektorn","Löparskor":"löparskon","Sous vide":"sous vide-maskinen","Vakuumförpackare":"vakuumförpackaren","Smarta hubbar":"smarta hubben","Datormöss":"datormusen","Tält":"tältet","Liggunderlag":"liggunderlaget","Sovsäckar":"sovsäcken","Ansiktsmasker":"ansiktsmasken","Jackor":"jackan","Pannlampor":"pannlampan","Robotgräsklippare":"robotgräsklipparen","Ryggsäckar":"ryggsäcken","Stormkök":"stormköket","Vandringskängor":"vandringskängan","Solkräm":"solkrämen","Grästrimmrar & röjsågar":"grästrimmern & röjsågen","Personvågar":"personvågen","Smarta lås":"smarta låset","Ansiktsrengöring":"ansiktsrengöringen","Brun utan sol":"brun utan sol","Läppglans":"läppglanset","Massageapparater":"massageapparaten","Puder & mineralpuder":"pudret","Kolsyremaskiner":"kolsyremaskinen","Vattenkokare":"vattenkokaren","Stektermometrar":"stektermometern","Contouring & highlighter":"highlightern","Duschtvål":"duschtvålen","Kajal & eyeliner":"kajalpennan","Serum":"serumet","Sminksvamp":"sminksvampen","Padel":"padeltillbehöret","Grilltillbehör":"grilltillbehöret","Fläktar":"fläkten","Kokplattor":"kokplattan","Fritöser":"airfryern","Parfym":"parfymen","Ansiktskräm":"ansiktskrämen","Ögonvård":"ögonvårdsprodukten","Peeling":"peelingen","Riskokare":"riskokaren","Fotvård":"fotvården","Nagellack":"nagellacket","Kockknivar":"kockkniven","Bakmaskiner":"bakmaskinen","Vinkylar":"vinkylen","Våffeljärn":"våffeljärnet","Slow cookers":"slow cookern","Mattork":"mattorken","Termoskannor":"termoskannan","Pizzaugnar":"pizzaugnen","Body lotion & krämer":"body lotionen","Skidhandskar":"skidhandsken","Luftfuktare":"luftfuktaren","Avfuktare":"avfuktaren","Luftrenare":"luftrenaren","Skidglasögon":"skidglasögonen","Skidhjälmar":"skidhjälmen","Ögonbrynsgel":"ögonbrynsgelen","Smörgåsgrillar":"smörgåsgrillen","Blenders & stavmixers":"blendern & stavmixern","Gödsel":"gödslen","Mandoliner":"mandolinen","Portabel AC":"portabla ac:n","Värmeskydd":"värmeskyddet","Grytor & kastruller":"kastrullen och grytan","Alpinskydd - Ryggskydd":"ryggskyddet","Popcornmaskiner":"popcornmaskinen","Pastamaskiner":"pastamaskinen","Mjölkskummare":"mjölkskummaren","Knivslipar":"knivslipen"}}');
;// CONCATENATED MODULE: ./src/components/meta-tags/expert-test.ts

var expertTest = function(param, param1) {
    var data = param.data, t = param1.t, market = param1.market;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19;
    if (!data) {
        return {};
    }
    var test = data.test;
    var category = (data.test.product || {}).category;
    if (!test) return {};
    var title = ((ref = test.metaTitle) === null || ref === void 0 ? void 0 : ref.replace("Advized.se", t("meta", "site.name"))) || t("meta", "expert.test-title", {
        title: ((ref1 = test.product) === null || ref1 === void 0 ? void 0 : ref1.name) || ""
    });
    var description = test.metaDescription || t("meta", "expert.test-description", {
        category: (category === null || category === void 0 ? void 0 : category.name) ? "".concat(expert_category_mappings_namespaceObject.l2[category === null || category === void 0 ? void 0 : category.name] || (category === null || category === void 0 ? void 0 : category.name.toLowerCase()), " ") : "",
        title: ((ref2 = test.product) === null || ref2 === void 0 ? void 0 : ref2.name) || ""
    });
    var openGraph = [
        {
            key: "url",
            content: test.fullUrl
        },
        {
            key: "title",
            content: title
        },
        {
            key: "description",
            content: description
        },
        {
            key: "type",
            content: "website"
        },
        {
            key: "image",
            content: (ref3 = test.imageWithSize) === null || ref3 === void 0 ? void 0 : ref3.src
        },
        {
            key: "siteName",
            content: t("meta", "site.name")
        },
        {
            key: "brand",
            content: (ref4 = test.product) === null || ref4 === void 0 ? void 0 : ref4.advizedBrand
        },
        {
            key: "priceAmount",
            content: (ref5 = test.product) === null || ref5 === void 0 ? void 0 : ref5.priceSummary.regular
        },
        {
            key: "priceCurrency",
            content: market.currency
        }
    ];
    var structuredData = {
        "@context": "http://schema.org",
        "@type": "Product",
        name: (ref6 = test.product) === null || ref6 === void 0 ? void 0 : ref6.name,
        description: description,
        lowPrice: (ref7 = test.product) === null || ref7 === void 0 ? void 0 : ref7.priceSummary.regular,
        image: [
            (ref8 = test.product) === null || ref8 === void 0 ? void 0 : ref8.media.first
        ],
        datePublished: new Date(parseInt(test.publishedAt, 10)).toISOString(),
        offers: {
            "@type": "Offer",
            url: "".concat(market.domain, "  ").concat((ref9 = test.product) === null || ref9 === void 0 ? void 0 : ref9.pathName),
            price: (ref10 = test.product) === null || ref10 === void 0 ? void 0 : ref10.priceSummary.regular,
            priceCurrency: market.currency
        },
        brand: {
            "@type": "Brand",
            name: (ref11 = test.product) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.advizedBrand) === null || ref12 === void 0 ? void 0 : ref12.replace(/<(.|\n)*?>/g, "")
        },
        review: {
            "@type": "Review",
            reviewRating: {
                "@type": "Rating",
                ratingValue: test.grade / 2,
                bestRating: 5,
                worstRating: 1
            },
            author: {
                "@type": "Person",
                name: test.expert.name
            },
            reviewBody: (ref13 = test.suitedForLong) === null || ref13 === void 0 ? void 0 : ref13.replace(/<(.|\n)*?>/g, ""),
            positiveNotes: {
                "@type": "ItemList",
                itemListElement: (ref14 = test.plus) === null || ref14 === void 0 ? void 0 : ref14.map(function(val) {
                    return val === null || val === void 0 ? void 0 : val.replace(/<(.|\n)*?>/g, "");
                }),
                itemListOrder: "https://schema.org/ItemListOrderDescending"
            },
            negativeNotes: {
                "@type": "ItemList",
                itemListElement: (ref15 = test.minus) === null || ref15 === void 0 ? void 0 : ref15.map(function(val) {
                    return val === null || val === void 0 ? void 0 : val.replace(/<(.|\n)*?>/g, "");
                }),
                itemListOrder: "https://schema.org/ItemListOrderDescending"
            },
            video: ((ref16 = test.video) === null || ref16 === void 0 ? void 0 : ref16.id) ? {
                "@type": "VideoObject",
                name: (ref17 = test.product) === null || ref17 === void 0 ? void 0 : ref17.name,
                description: description,
                thumbnailurl: (ref18 = test.video) === null || ref18 === void 0 ? void 0 : ref18.thumbnail,
                uploadDate: new Date(parseInt(test.publishedAt, 10)).toISOString(),
                embedUrl: "https://www.youtube.com/watch?v=".concat((ref19 = test.video) === null || ref19 === void 0 ? void 0 : ref19.id)
            } : undefined
        }
    };
    return {
        description: description,
        title: title,
        canonical: test.fullUrl,
        openGraph: openGraph,
        structuredData: structuredData
    };
};
/* harmony default export */ const expert_test = (expertTest);

;// CONCATENATED MODULE: ./src/components/meta-tags/expert-toplists.ts
var expertToplists = function(param, param1) {
    var data = param.data, t = param1.t;
    var ref, ref1;
    if (!data) {
        return {};
    }
    var toplist = data.toplist;
    if (!(toplist === null || toplist === void 0 ? void 0 : toplist.toplists) || !toplist.toplists[0]) return {};
    var description = t("meta", "expert.toplists-description", {
        title: toplist.name.toLowerCase()
    });
    var title = t("meta", "expert.toplists-title", {
        title: toplist.name,
        experts: toplist.toplists.length === 1 ? t("meta", "expert.toplists-singular-expert") : t("meta", "expert.toplists-plural-expert"),
        year: toplist.toplists[0].publishedAt && new Date(parseInt(toplist.toplists[0].publishedAt, 10)).getFullYear() === new Date().getFullYear() ? "".concat(new Date().getFullYear(), " ") : ""
    });
    var image = toplist.toplists[0] && ((ref1 = (ref = toplist.toplists[0].description) === null || ref === void 0 ? void 0 : ref.find(function(d) {
        return d.type === "image";
    })) === null || ref1 === void 0 ? void 0 : ref1.data);
    var openGraph = [
        {
            key: "url",
            content: toplist.fullUrl
        },
        {
            key: "title",
            content: toplist.name
        },
        {
            key: "description",
            content: description
        },
        {
            key: "type",
            content: "article"
        },
        {
            key: "image",
            content: image
        },
        {
            key: "siteName",
            content: t("meta", "site.name")
        }
    ];
    return {
        title: title,
        description: description,
        openGraph: openGraph,
        structuredData: undefined,
        canonical: toplist.fullUrl
    };
};
/* harmony default export */ const expert_toplists = (expertToplists);

;// CONCATENATED MODULE: ./src/components/meta-tags/expert-guide.ts
var expertGuide = function(param, param1) {
    var data = param.data, t = param1.t;
    var ref, ref1;
    if (!data || !data.guide) {
        return {};
    }
    var guide = data.guide;
    var title = ((ref = guide.metaTitle) === null || ref === void 0 ? void 0 : ref.replace("Advized.se", t("meta", "site.name"))) || t("meta", "expert.guide-title", {
        title: guide.title
    });
    var description = guide.description || t("meta", "expert.guide-description", {
        category: guide.category.name.toLowerCase()
    });
    var openGraph = [
        {
            key: "url",
            content: guide.fullUrl
        },
        {
            key: "title",
            content: title
        },
        {
            key: "description",
            content: description
        },
        {
            key: "type",
            content: "article"
        },
        {
            key: "image",
            content: (ref1 = guide.image) === null || ref1 === void 0 ? void 0 : ref1.src
        },
        {
            key: "siteName",
            content: t("meta", "site.name")
        }
    ];
    return {
        description: description,
        title: title,
        canonical: guide.fullUrl,
        openGraph: openGraph,
        structuredData: undefined
    };
};
/* harmony default export */ const expert_guide = (expertGuide);

;// CONCATENATED MODULE: ./src/components/meta-tags/expert-profile.ts
var expertProfile = function(param, param1) {
    var data = param.data, t = param1.t;
    var ref;
    if (!data) {
        return {};
    }
    var expert = data.expert;
    if (!expert) return {};
    var getCategoriesString = function(categories) {
        if (categories.length === 1) {
            return categories[0].name.toLowerCase();
        }
        if (categories.length === 2) {
            return t("meta", "expert.profile-description-categories-multiple", {
                category1: categories[0].name.toLowerCase(),
                category2: categories[1].name.toLowerCase()
            });
        }
        if (categories.length === 3) {
            return "".concat(categories[0].name.toLowerCase(), ", ").concat(t("meta", "expert.profile-description-categories-multiple", {
                category1: categories[1].name.toLowerCase(),
                category2: categories[2].name.toLowerCase()
            }));
        }
        if (categories.length > 3) {
            return categories.map(function(category) {
                return category.name;
            }).join(", ");
        }
        return "";
    };
    var firstname = expert.name.split(" ")[0];
    var title = t("meta", "expert.profile-title", {
        name: expert.name
    });
    var description = t("meta", "expert.profile-description", {
        categories: ((ref = expert.categories) === null || ref === void 0 ? void 0 : ref.length) ? t("meta", "expert.profile-description-categories", {
            categories: getCategoriesString(expert.categories)
        }) : "",
        fullname: expert.name,
        firstname: firstname[firstname.length - 1] === "s" ? firstname : "".concat(firstname, "s")
    });
    return {
        title: title,
        description: description,
        canonical: expert.fullUrl,
        openGraph: [
            {
                key: "url",
                content: expert.fullUrl
            },
            {
                key: "title",
                content: title
            },
            {
                key: "description",
                content: description
            },
            {
                key: "type",
                content: "website"
            },
            {
                key: "siteName",
                content: t("meta", "site.name")
            }
        ],
        structuredData: undefined
    };
};
/* harmony default export */ const expert_profile = (expertProfile);

;// CONCATENATED MODULE: ./src/components/meta-tags/expert-category.ts

var expertCategory = function(param, param1) {
    var data = param.data, t = param1.t;
    if (!data || !data.expertCategoryPage) {
        return {};
    }
    var category = (data.expertCategoryPage || {}).category;
    if (!(category === null || category === void 0 ? void 0 : category.name)) return {};
    return {
        description: t("meta", "expert.category-description", {
            category: expert_category_mappings_namespaceObject.hP[category.name] || (category === null || category === void 0 ? void 0 : category.name.toLowerCase())
        }),
        title: t("meta", "expert.category-title", {
            category: expert_category_mappings_namespaceObject.l2[category === null || category === void 0 ? void 0 : category.name] || (category === null || category === void 0 ? void 0 : category.name.toLowerCase()),
            year: new Date().getFullYear()
        }),
        canonical: category.fullUrl,
        openGraph: undefined,
        structuredData: undefined
    };
};
/* harmony default export */ const expert_category = (expertCategory);

;// CONCATENATED MODULE: ./src/components/meta-tags/expert-landing-page.ts
var expertLandingPageMetaTags = function(param, param1) {
    var data = param.data, t = param1.t, linkTo = param1.linkTo, market = param1.market;
    if (!data || !data.expertLandingPage) {
        return {};
    }
    var title = t("meta", "expert.landing-page-title");
    var description = t("meta", "expert.landing-page-description");
    var openGraph = [
        {
            key: "url",
            content: "".concat(market.domain).concat(linkTo("experts"))
        },
        {
            key: "title",
            content: title
        },
        {
            key: "description",
            content: description
        },
        {
            key: "type",
            content: "website"
        },
        {
            key: "siteName",
            content: t("meta", "site.name")
        }
    ];
    return {
        description: description,
        title: title,
        openGraph: openGraph,
        canonical: "".concat(market.domain).concat(linkTo("experts")),
        structuredData: undefined
    };
};
/* harmony default export */ const expert_landing_page = (expertLandingPageMetaTags);

;// CONCATENATED MODULE: ./src/components/meta-tags/keyword-landing-page.ts
function keyword_landing_page_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function keyword_landing_page_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            keyword_landing_page_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function keyword_landing_page_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function keyword_landing_page_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        keyword_landing_page_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/* harmony default export */ function keyword_landing_page(kwlpData, param) {
    var market = param.market, t = param.t;
    if (!kwlpData.data) return {};
    var _keywordLandingPage = kwlpData.data.keywordLandingPage, url = _keywordLandingPage.url, _categories = _keywordLandingPage.categories, categories = _categories.nodes, title = _keywordLandingPage.title, inSitemap = _keywordLandingPage.inSitemap, parentCategory = _keywordLandingPage.parentCategory, hasAdultContent = _keywordLandingPage.hasAdultContent, metaDescription = _keywordLandingPage.metaDescription, descriptionObject = _keywordLandingPage.description;
    var canonical = market.domain + url;
    var noIndex = !inSitemap;
    var breadcrumb = parentCategory === null || parentCategory === void 0 ? void 0 : parentCategory.path;
    var firstLetterVariantA = /^[a-i]/i;
    var firstLetterVariantB = /^[j-r]/i;
    var variantA = firstLetterVariantA.test(title);
    var variantB = firstLetterVariantB.test(title);
    var keyword = "".concat(title[0].toUpperCase()).concat(title.slice(1));
    var isOffersOnly = !categories.length;
    var description = setUpDescription({
        keyword: keyword,
        categories: categories,
        t: t,
        isOffersOnly: isOffersOnly,
        metaDescription: metaDescription,
        descriptionText: descriptionObject === null || descriptionObject === void 0 ? void 0 : descriptionObject.text
    });
    var isExperimentalMarket = [
        "no",
        "dk",
        "fr",
        "fi"
    ].includes(market.code);
    var titleDescription = {};
    if (variantA && isExperimentalMarket) {
        titleDescription = {
            title: t("meta", "keyword-landing-page.title", {
                keyword: keyword
            }),
            description: t("meta", "keyword-landing-page.description-experiment", {
                keyword: keyword
            })
        };
    } else if (variantB && isExperimentalMarket) {
        titleDescription = {
            title: t("meta", "keyword-landing-page.title-experiment", {
                keyword: keyword
            }),
            description: description
        };
    } else {
        titleDescription = {
            title: t("meta", "keyword-landing-page.title", {
                keyword: keyword
            }),
            description: description
        };
    }
    var maxImagePreview = "standard";
    return keyword_landing_page_objectSpreadProps(keyword_landing_page_objectSpread({}, titleDescription), {
        canonical: canonical,
        noIndex: noIndex,
        breadcrumb: breadcrumb,
        maxImagePreview: maxImagePreview,
        hasAdultContent: hasAdultContent
    });
};
var setUpDescription = function(param) {
    var keyword = param.keyword, categories = param.categories, t = param.t, isOffersOnly = param.isOffersOnly, metaDescription = param.metaDescription, descriptionText = param.descriptionText;
    if (metaDescription) {
        return metaDescription;
    }
    if (descriptionText) {
        return descriptionText;
    }
    if (isOffersOnly) {
        return t("meta", "keyword-landing-page.description-offers-only", {
            keyword: keyword
        });
    }
    return t("meta", "keyword-landing-page.description", {
        keyword: keyword,
        categories: categories.map(function(category) {
            return category === null || category === void 0 ? void 0 : category.name;
        }).join(" ")
    });
};

;// CONCATENATED MODULE: ./src/components/meta-tags/keyword-listing.ts
/* harmony default export */ function keyword_listing(param, param1) {
    var data = param.data, t = param1.t;
    var ref = (data === null || data === void 0 ? void 0 : data.popularSearchTerms) || {}, _keywords = ref.keywords, keywords = _keywords === void 0 ? [] : _keywords, _categories = ref.categories, categories = _categories === void 0 ? [] : _categories;
    var categoryNames = categories.slice(0, 3).map(function(param) {
        var name = param.name;
        return name;
    });
    var keywordNames = keywords.slice(0, 3).map(function(param) {
        var name = param.name;
        return name;
    });
    var title = t("meta", "keyword-listing.title", {
        category: categoryNames[0]
    });
    var description = t("meta", "keyword-listing.description", {
        keyword: keywordNames.join(", "),
        categories: categoryNames.join(", ")
    });
    return {
        noIndex: true,
        follow: true,
        title: title,
        description: description
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/changelog-landing-page.js
/* harmony default export */ function changelog_landing_page(_, param) {
    var market = param.market, t = param.t;
    return {
        title: t("changelog", "changelog.title"),
        description: undefined,
        canonical: "".concat(market.domain).concat(market.routes && market.routes.changelogLandingPage && market.routes.changelogLandingPage.path || "/changelog"),
        openGraph: [],
        structuredData: undefined,
        hrefLang: undefined
    };
};

;// CONCATENATED MODULE: ./src/components/meta-tags/definitions.js



































/* harmony default export */ const definitions = ({
    article: article,
    product: product,
    productCompare: product_compare,
    productAlert: product_alert,
    start: start,
    category: category,
    store: store,
    campaign: campaign,
    infoPage: info_page,
    brand: meta_tags_brand,
    login: login,
    shopOfTheYearLandingPage: shop_of_the_year_landing_page,
    shopOfTheYearCategory: shop_of_the_year_category,
    shopOfTheYearWinners: shop_of_the_year_winners,
    shopOfTheYear: shop_of_the_year,
    promotionProducts: promotion_products,
    promotions: promotions,
    usedProducts: used_products,
    search: search,
    generic: generic,
    productCollection: product_collection,
    productCollectionSitemap: product_collection_sitemap,
    editorialContent: editorial_content,
    editorialContentListing: editorial_content_listing,
    userProfile: user_profile,
    publicList: public_list,
    expertTest: expert_test,
    expertToplists: expert_toplists,
    expertGuide: expert_guide,
    expertProfile: expert_profile,
    expertCategory: expert_category,
    expertLandingPage: expert_landing_page,
    keywordLandingPage: keyword_landing_page,
    keywordListing: keyword_listing,
    changelogLandingPage: changelog_landing_page
});

// EXTERNAL MODULE: ./src/areas/landing-page/index.js
var landing_page = __webpack_require__(25997);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/areas/product/components/offer-list-filter-context/index.tsx
var offer_list_filter_context = __webpack_require__(65884);
// EXTERNAL MODULE: ./src/areas/product/product-page.tsx
var product_page = __webpack_require__(7119);
// EXTERNAL MODULE: ./src/components/loader/index.tsx + 1 modules
var loader = __webpack_require__(30082);
// EXTERNAL MODULE: ./src/components/page/index.ts + 3 modules
var page = __webpack_require__(62372);
// EXTERNAL MODULE: ./src/areas/product/query.graphql
var query_graphql = __webpack_require__(42318);
var query_graphql_default = /*#__PURE__*/__webpack_require__.n(query_graphql);
// EXTERNAL MODULE: ./src/hooks/use-page-query.ts
var use_page_query = __webpack_require__(98854);
;// CONCATENATED MODULE: ./src/areas/product/queries/use-product-page.ts


function useProductPageQuery(variables) {
    return (0,use_page_query/* usePageQuery */.v)({
        query: (query_graphql_default()),
        routeName: "product",
        variables: variables,
        keepPreviousData: false
    });
}

// EXTERNAL MODULE: ./src/hooks/use-matched-route.ts
var use_matched_route = __webpack_require__(5148);
// EXTERNAL MODULE: ./src/areas/product/constants.ts
var constants = __webpack_require__(48458);
;// CONCATENATED MODULE: ./src/areas/product/index.tsx









var Product = function(props) {
    var route = (0,use_matched_route/* useMatchedRoute */.M)();
    var variables = route === null || route === void 0 ? void 0 : route.variables;
    var ref = useProductPageQuery(variables), data = ref.data, isLoading = ref.isLoading, isSuccess = ref.isSuccess;
    var routeSection = props.routeSection;
    if (!isLoading && !isSuccess) {
        return null;
    }
    return /*#__PURE__*/ react.createElement("div", {
        key: variables.id
    }, /*#__PURE__*/ react.createElement(offer_list_filter_context/* OfferListFilterContextContainer */.p, null, /*#__PURE__*/ react.createElement(page/* PageContent */.JH, {
        withAds: true
    }, isLoading && /*#__PURE__*/ react.createElement(loader/* default */.Z, null), isSuccess && /*#__PURE__*/ react.createElement(product_page/* ProductPage */.e, {
        data: data,
        routeSection: routeSection
    }))));
};
Product.graphQL = (query_graphql_default());
// Group on product ID, ignore section param
Product.group = function(param) {
    var name = param.name, match = param.match;
    return "".concat(name, "_").concat(match && match.params ? match.params.id : "unknown");
};
Product.variables = function(param) {
    var id = param.id, marketCode = param.marketCode;
    var expertsEnabled = [
        "se",
        "no"
    ].includes(marketCode);
    var includeRecommendations = ![
        "no"
    ].includes(marketCode);
    return {
        id: parseInt(id, 10),
        marketCode: marketCode,
        recommendationsContextId: constants/* PRODUCT_CONTEXT_ID */.S,
        expertsEnabled: expertsEnabled,
        includeRecommendations: includeRecommendations
    };
};
/* harmony default export */ const areas_product = (Product);

// EXTERNAL MODULE: ./src/areas/product-compare/index.js
var areas_product_compare = __webpack_require__(53358);
// EXTERNAL MODULE: ./src/areas/category/index.js
var areas_category = __webpack_require__(99120);
// EXTERNAL MODULE: ./src/areas/category-index/index.js
var category_index = __webpack_require__(23902);
// EXTERNAL MODULE: ./src/areas/product-collection/index.js
var areas_product_collection = __webpack_require__(9543);
// EXTERNAL MODULE: ./src/areas/keyword-landing-page/index.js
var areas_keyword_landing_page = __webpack_require__(25334);
// EXTERNAL MODULE: ./src/areas/keyword-listing/index.js
var areas_keyword_listing = __webpack_require__(11782);
// EXTERNAL MODULE: ./src/areas/product-collection-sitemap/index.js
var areas_product_collection_sitemap = __webpack_require__(37254);
// EXTERNAL MODULE: ./src/areas/store/index.js
var areas_store = __webpack_require__(28319);
// EXTERNAL MODULE: ./src/areas/brand/index.js
var areas_brand = __webpack_require__(98675);
// EXTERNAL MODULE: ./src/areas/info/index.js
var info = __webpack_require__(91762);
// EXTERNAL MODULE: ./src/areas/editorial-content/index.js
var areas_editorial_content = __webpack_require__(13664);
// EXTERNAL MODULE: ./src/areas/editorial-content-listing/index.js
var areas_editorial_content_listing = __webpack_require__(36579);
// EXTERNAL MODULE: ./src/areas/campaign/themes.js
var themes = __webpack_require__(52452);
// EXTERNAL MODULE: ./src/areas/campaign/index.tsx
var areas_campaign = __webpack_require__(37067);
// EXTERNAL MODULE: ./src/areas/scoped-search-pages/promotions-page/index.tsx
var promotions_page = __webpack_require__(63644);
// EXTERNAL MODULE: ./src/areas/scoped-search-pages/promotion-products-page/index.tsx
var promotion_products_page = __webpack_require__(32561);
// EXTERNAL MODULE: ./src/areas/scoped-search-pages/used-products-page/index.tsx
var used_products_page = __webpack_require__(41258);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_react-dom@18.2.0_react@18.2.0_redux@4.0.1/node_modules/react-redux/es/index.js + 24 modules
var es = __webpack_require__(95939);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@5.2.1_react@18.2.0/node_modules/react-router/esm/react-router.js + 3 modules
var react_router = __webpack_require__(14727);
// EXTERNAL MODULE: ./node_modules/.pnpm/query-string-for-all@6.8.3/node_modules/query-string-for-all/dist/index.js
var dist = __webpack_require__(25932);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(18026);
// EXTERNAL MODULE: ./src/components/toast-container/actions/index.ts
var actions = __webpack_require__(88278);
;// CONCATENATED MODULE: ./src/areas/newsletter-verification/actions/index.ts
var NEWSLETTER_SUBSCRIBE_VERIFIED = "NEWSLETTER_SUBSCRIBE_VERIFIED";
var newsletterSubscribeVerified = function(email) {
    return {
        type: NEWSLETTER_SUBSCRIBE_VERIFIED,
        email: email
    };
};
/* harmony default export */ const newsletter_verification_actions = ({
    newsletterSubscribeVerified: newsletterSubscribeVerified
});

;// CONCATENATED MODULE: ./src/areas/newsletter-verification/index.tsx







var NewsletterVerification = function(props) {
    var t = react.useContext(app_context/* AppContext */.Il).t;
    var location = (0,react_router/* useLocation */.TH)();
    var promptToast = props.promptToast, newsletterSubscribeVerified = props.newsletterSubscribeVerified;
    react.useEffect(function() {
        var ref = dist_default().parse(location.search), email = ref.email, hash = ref.hash;
        fetch("/_internal/newsletter/confirm-subscription", {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                email: email,
                hash: hash
            })
        }).then(function(res) {
            return res.json();
        }).then(function(param) {
            var success = param.success;
            if (success) {
                newsletterSubscribeVerified(String(email));
                promptToast("success", t("footer", "newsletter.subscription-confirmed"));
            } else {
                promptToast("error", t("errors", "internal.unknown"));
            }
        }).catch(function() {
            promptToast("error", t("errors", "internal.unknown"));
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ react.createElement(react_router/* Redirect */.l_, {
        to: "/"
    });
};
// eslint-disable-next-line @typescript-eslint/no-empty-function
/* harmony default export */ const newsletter_verification = ((0,es/* connect */.$j)(function() {}, {
    promptToast: actions/* promptToast */.Lf,
    newsletterSubscribeVerified: newsletterSubscribeVerified
})(NewsletterVerification));

// EXTERNAL MODULE: ./src/areas/article/index.js
var areas_article = __webpack_require__(57378);
// EXTERNAL MODULE: ./src/areas/search/index.js
var areas_search = __webpack_require__(93600);
// EXTERNAL MODULE: ./src/areas/user/tracking-settings-loadable.js
var tracking_settings_loadable = __webpack_require__(73158);
// EXTERNAL MODULE: ./src/areas/user/personalization-loadable.js
var personalization_loadable = __webpack_require__(72275);
// EXTERNAL MODULE: ./src/areas/account/profile/user-profile-loadable.tsx
var user_profile_loadable = __webpack_require__(6859);
// EXTERNAL MODULE: ./src/areas/account/profile/my-profile-loadable.tsx
var my_profile_loadable = __webpack_require__(84026);
// EXTERNAL MODULE: ./src/areas/expert/product-test/index.js
var product_test = __webpack_require__(25485);
// EXTERNAL MODULE: ./src/areas/expert/toplists/index.js
var toplists = __webpack_require__(42683);
// EXTERNAL MODULE: ./src/areas/expert/profile/index.js
var profile = __webpack_require__(4489);
// EXTERNAL MODULE: ./src/areas/expert/guide/index.js
var guide = __webpack_require__(82829);
// EXTERNAL MODULE: ./src/areas/expert/category/index.js
var areas_expert_category = __webpack_require__(45705);
// EXTERNAL MODULE: ./src/areas/expert/landing-page/index.js
var areas_expert_landing_page = __webpack_require__(53380);
// EXTERNAL MODULE: ./src/areas/changelog/landing-page/index.js
var areas_changelog_landing_page = __webpack_require__(13736);
// EXTERNAL MODULE: ./src/areas/account/index.tsx
var account = __webpack_require__(78879);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(3616);
// EXTERNAL MODULE: ./src/components/breadcrumbs/index.tsx
var breadcrumbs = __webpack_require__(45183);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(7336);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/text/variants.js
var text_variants = __webpack_require__(71016);
// EXTERNAL MODULE: ./src/hooks/use-page-meta-tags.ts
var use_page_meta_tags = __webpack_require__(62950);
// EXTERNAL MODULE: ./src/hooks/use-route-loaded.ts
var use_route_loaded = __webpack_require__(46925);
// EXTERNAL MODULE: ./src/areas/alerts/unsubscribe/mutation.graphql
var mutation_graphql = __webpack_require__(12541);
var mutation_graphql_default = /*#__PURE__*/__webpack_require__.n(mutation_graphql);
// EXTERNAL MODULE: ./src/hooks/use-gql-mutation.ts
var use_gql_mutation = __webpack_require__(68141);
;// CONCATENATED MODULE: ./src/areas/alerts/unsubscribe/queries/useAlertUnsubscribeMutation.ts


function useAlertUnsubscribeMutation(variables) {
    return (0,use_gql_mutation/* useGqlMutation */.c)({
        mutation: (mutation_graphql_default()),
        variables: variables
    });
}

// EXTERNAL MODULE: ./src/components/page/page-content/index.tsx + 1 modules
var page_content = __webpack_require__(81013);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
;// CONCATENATED MODULE: ./src/areas/alerts/unsubscribe/components/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n  column-gap: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin: ",
        " 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  text-decoration: underline;\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    margin-left: 0;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  margin: ",
        " 0 ",
        "\n    ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var Header = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Header",
    componentId: "sc-0-0"
})(_templateObject());
var Body = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Body",
    componentId: "sc-0-1"
})(_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.theme.colors.base500;
});
var Footer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Footer",
    componentId: "sc-0-2"
})(_templateObject2(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var ProductLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "ProductLink",
    componentId: "sc-0-3"
})(_templateObject3(), function(p) {
    return p.theme.text.callToAction;
}, function(p) {
    return p.theme.text.callToActionHover;
});
var BreadCrumbWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BreadCrumbWrapper",
    componentId: "sc-0-4"
})(_templateObject5(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.smallOnly */.BC.smallOnly(_templateObject4()));
var Content = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Content",
    componentId: "sc-0-5"
})(_templateObject6(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/areas/alerts/unsubscribe/components/index.tsx













var AlertUnsubscribePageLoader = function() {
    var route = (0,use_matched_route/* useMatchedRoute */.M)();
    var ref = useAlertUnsubscribeMutation(route.variables), data = ref.data, isLoading = ref.isLoading, isSuccess = ref.isSuccess, mutate = ref.mutate;
    (0,react.useEffect)(function() {
        mutate();
    }, []);
    (0,use_route_loaded/* useRouteLoaded */.N)(data);
    (0,use_page_meta_tags/* usePageMetaTags */.p)(data);
    if (!isLoading && !isSuccess) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(page_content/* default */.Z, null, isLoading ? /*#__PURE__*/ react.createElement(loader/* default */.Z, null) : null, isSuccess && data ? /*#__PURE__*/ react.createElement(AlertUnsubscribePage, {
        data: data
    }) : null);
};
var AlertUnsubscribePage = function(param) {
    var data = param.data;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var product = data.alertUnsubscribe.product;
    var ref;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(BreadCrumbWrapper, null, /*#__PURE__*/ react.createElement(breadcrumbs/* Breadcrumbs */.O, {
        crumbs: [
            {
                title: t("alerts", "alerts.title")
            }
        ]
    })), /*#__PURE__*/ react.createElement(Content, null, /*#__PURE__*/ react.createElement(Header, null, /*#__PURE__*/ react.createElement(text_variants.TitleMediumText, null, t("alerts", "unsubscribe.removed")), /*#__PURE__*/ react.createElement(Body, null, /*#__PURE__*/ react.createElement("span", null, t("alerts", "unsubscribe.no-more-notifications")), /*#__PURE__*/ react.createElement(ProductLink, {
        to: (ref = product === null || product === void 0 ? void 0 : product.pathName) !== null && ref !== void 0 ? ref : ""
    }, product === null || product === void 0 ? void 0 : product.name))), /*#__PURE__*/ react.createElement(Footer, null, /*#__PURE__*/ react.createElement(variants.PrimaryButton, {
        container: react_router_dom/* Link */.rU,
        containerProps: {
            to: "/"
        }
    }, t("common", "button.go-home")))));
};

;// CONCATENATED MODULE: ./src/areas/alerts/unsubscribe/index.js


var unsubscribe_AlertUnsubscribePage = AlertUnsubscribePageLoader;
unsubscribe_AlertUnsubscribePage.defaultProps = {};
unsubscribe_AlertUnsubscribePage.graphQL = (mutation_graphql_default());
unsubscribe_AlertUnsubscribePage.variables = function(param) {
    var key = param.key;
    return {
        token: key || ""
    };
};
/* harmony default export */ const unsubscribe = (unsubscribe_AlertUnsubscribePage);

// EXTERNAL MODULE: ./src/areas/account/settings/components/subscription-settings/unsubscribe-landing-page/unsubscribe-landing-page-loadable.tsx
var unsubscribe_landing_page_loadable = __webpack_require__(36151);
// EXTERNAL MODULE: ./src/areas/shop-of-the-year/index.js
var areas_shop_of_the_year = __webpack_require__(60473);
// EXTERNAL MODULE: ./src/areas/public-list/index.js
var areas_public_list = __webpack_require__(66917);
;// CONCATENATED MODULE: ./src/routes/config.ts
function config_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function config_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            config_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function config_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}








































var loginEnabledMarkets = Object.values(markets/* marketConfig */.q).filter(function(market) {
    return market.login.enabled === true;
}).map(function(market) {
    return market.countryCode;
});
var buildRouteConfig = function(market, routes) {
    var obj = config_objectSpreadProps(config_objectSpread({
        start: {
            path: "/",
            component: landing_page/* default */.Z,
            exact: true,
            metaTags: definitions.start,
            cacheControl: {
                maxAge: "1h",
                maxStale: "30m"
            }
        },
        newsletterVerify: {
            path: "/newsletter/verify",
            component: newsletter_verification
        },
        search: {
            path: "/search",
            component: areas_search/* default */.Z,
            metaTags: definitions.search
        },
        productCompare: {
            path: "/compare/products/:productIds?",
            component: areas_product_compare/* default */.Z,
            metaTags: definitions.productCompare
        },
        product: {
            path: "*--p:id(\\d+)/:section(properties|reviews|statistics)?",
            component: areas_product,
            metaTags: definitions.product,
            cacheControl: {
                maxAge: "12h",
                maxStale: "30m"
            }
        },
        category: {
            path: "*--c:id([sv]?\\d+)",
            component: areas_category/* default */.Z,
            metaTags: definitions.category,
            cacheControl: {
                maxAge: "4h",
                maxStale: "30m"
            }
        },
        categoryIndex: {
            path: "/categories",
            component: category_index/* default */.Z,
            metaTags: definitions.generic
        },
        productCollection: {
            path: "/:type(c|o)/:slug",
            component: areas_product_collection/* default */.Z,
            metaTags: definitions.productCollection,
            cacheControl: {
                maxAge: "4h",
                maxStale: "30m"
            }
        },
        keywordLandingPage: {
            path: [
                "/s/:slug",
                "/sq/:query/:source?"
            ],
            component: areas_keyword_landing_page/* default */.Z,
            // Improve the meta tags.
            metaTags: definitions.keywordLandingPage,
            cacheControl: {
                maxAge: "4h",
                maxStale: "30m"
            }
        },
        keywordListingPage: {
            path: "/kw/:id",
            component: areas_keyword_listing/* default */.Z,
            metaTags: definitions.keywordListing,
            cacheControl: {
                maxAge: "4h",
                maxStale: "30m"
            }
        },
        productCollectionSitemap: {
            path: "/cm/:slug",
            component: areas_product_collection_sitemap/* default */.Z,
            metaTags: definitions.productCollectionSitemap,
            cacheControl: {
                maxAge: "4h",
                maxStale: "30m"
            }
        },
        store: {
            path: "*--s:id(\\d+)/:section(reviews)?",
            component: areas_store/* default */.Z,
            metaTags: definitions.store
        },
        brand: {
            path: "*--b:id(\\d+)",
            component: areas_brand/* default */.Z,
            metaTags: definitions.brand
        },
        infoPage: {
            path: "*--i:id(\\d+)",
            component: info/* default */.Z,
            metaTags: definitions.infoPage,
            cacheControl: {
                maxAge: "1h",
                maxStale: "30m"
            }
        },
        article: {
            path: "*--a:id(\\d+)",
            component: areas_article/* default */.Z,
            metaTags: definitions.article,
            cacheControl: {
                maxAge: "1h",
                maxStale: "30m"
            }
        },
        editorialContent: {
            path: [
                "*--ec:id([\\w\\-]+)",
                "*--cl:id([\\w\\-]+)",
                "/prismic-preview"
            ],
            component: areas_editorial_content/* default */.Z,
            metaTags: definitions.editorialContent
        },
        editorialContentListing: {
            path: "/articles",
            component: areas_editorial_content_listing/* default */.Z,
            metaTags: definitions.editorialContentListing
        },
        prismicInfoPage: {
            path: "/info/*--ip:id([\\w\\-]+)",
            component: areas_editorial_content/* default */.Z,
            metaTags: definitions.editorialContent
        },
        promotions: {
            path: "/promotions",
            component: promotions_page/* default */.Z,
            metaTags: definitions.promotions
        },
        promotionProducts: {
            path: "/promotions/:id(\\w+)",
            component: promotion_products_page/* default */.Z,
            metaTags: definitions.promotionProducts
        },
        usedProducts: {
            path: "/used",
            component: used_products_page/* default */.Z,
            metaTags: definitions.usedProducts
        },
        themes: {
            path: "/campaigns",
            component: themes/* default */.Z,
            metaTags: definitions.campaign,
            exact: true,
            cacheControl: {
                maxAge: "4h",
                maxStale: "30m"
            }
        },
        campaign: {
            path: "/campaigns/:name?",
            // Campaign pages uses AWS and elasticsearch internally for performance
            // and load reasons, we don't want to trigger a new fetch on url change.
            fetchStrategy: "initial-only",
            component: areas_campaign/* default */.Z,
            metaTags: definitions.campaign,
            cacheControl: {
                maxAge: "4h",
                maxStale: "30m"
            }
        }
    }, loginEnabledMarkets.includes(market) && {
        signup: {
            path: "/signup",
            exact: true,
            component: account/* SchibstedLoginRedirect */.P,
            metaTags: definitions.generic
        }
    }, loginEnabledMarkets.includes(market) && {
        login: {
            path: "/login",
            component: account/* SchibstedLoginRedirect */.P,
            metaTags: definitions.generic
        }
    }, loginEnabledMarkets.includes(market) && {
        loginError: {
            path: "/login/error/:error?",
            component: account/* SchibstedLoginError */.T,
            metaTags: definitions.generic
        }
    }, loginEnabledMarkets.includes(market) && {
        profile: {
            path: "/account/profile/:section(reviews|settings|lists|shop-preference)?",
            component: my_profile_loadable/* default */.Z,
            metaTags: definitions.generic
        }
    }, loginEnabledMarkets.includes(market) && {
        user: {
            path: "/user/:id/:section(reviews|lists)?",
            component: user_profile_loadable/* default */.Z,
            metaTags: definitions.userProfile
        }
    }), {
        trackingSettings: {
            path: "/privacy-settings",
            component: tracking_settings_loadable/* default */.Z,
            metaTags: definitions.generic
        },
        alertUnsubscribe: {
            path: "/alerts/unsubscribe",
            component: unsubscribe,
            metaTags: definitions.generic
        },
        unsubscribe: {
            path: "/unsubscribe",
            component: unsubscribe_landing_page_loadable/* default */.Z,
            metaTags: definitions.generic
        },
        shopOfTheYear: {
            path: "/shop-of-the-year",
            component: areas_shop_of_the_year/* ShopOfTheYearLandingPage */.U,
            metaTags: definitions.shopOfTheYear
        },
        shopOfTheYearWinners: {
            path: "/shop-of-the-year/:section",
            component: areas_shop_of_the_year/* ShopOfTheYearLandingPage */.U,
            metaTags: definitions.shopOfTheYear
        },
        shopOfTheYearCategory: {
            path: "/shop-of-the-year/:year/category/:id",
            component: areas_shop_of_the_year/* ShopOfTheYearLandingPage */.U,
            metaTags: definitions.shopOfTheYearCategory
        },
        personalization: {
            path: "/personalization",
            component: personalization_loadable/* default */.Z,
            metaTags: definitions.generic
        },
        publicList: {
            path: "/list/*--l:id",
            component: areas_public_list/* default */.Z,
            metaTags: definitions.publicList
        },
        expertProductTest: {
            path: "/tests/:slug?",
            relativePath: "/tests",
            component: product_test/* default */.Z,
            metaTags: definitions.expertTest
        },
        expertToplists: {
            path: "/toplists/:slug?",
            relativePath: "/toplists",
            component: toplists/* default */.Z,
            metaTags: definitions.expertToplists
        },
        expertGuide: {
            path: "/guides/:slug?",
            relativePath: "/guides",
            component: guide/* default */.Z,
            metaTags: definitions.expertGuide
        },
        expertProfile: {
            path: "/experts/profile/:slug?",
            relativePath: "/experts/profile",
            component: profile/* default */.Z,
            metaTags: definitions.expertProfile
        },
        expertCategory: {
            path: "/experts/:slug",
            relativePath: "/experts",
            component: areas_expert_category/* default */.Z,
            metaTags: definitions.expertCategory
        },
        expertLandingPage: {
            path: "/experts",
            component: areas_expert_landing_page/* default */.Z,
            metaTags: definitions.expertLandingPage,
            exact: true
        },
        changelogLandingPage: {
            path: "/changelog",
            component: areas_changelog_landing_page/* default */.Z,
            metaTags: definitions.changelogLandingPage
        }
    });
    return Object.keys(obj).reduce(function(curr, key) {
        // eslint-disable-next-line no-param-reassign
        curr[key] = config_objectSpreadProps(config_objectSpread({}, obj[key]), {
            path: (routes === null || routes === void 0 ? void 0 : routes[key]) ? routes[key].path : obj[key].path
        });
        return curr;
    }, {});
};


/***/ }),

/***/ 84270:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "UQ": () => (/* reexport */ Accordion),
  "vF": () => (/* reexport */ AccordionContent),
  "_m": () => (/* reexport */ AccordionHeader)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
;// CONCATENATED MODULE: ./src/ui/accordion/accordion-context.tsx

var AccordionContext = /*#__PURE__*/ react.createContext({
    expanded: false,
    disabled: false,
    id: "",
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    toggle: function() {}
});

// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
// EXTERNAL MODULE: ./src/components/base/index.js + 6 modules
var base = __webpack_require__(61093);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@5.0.4_react-dom@18.2.0_react@18.2.0_styled-components@5.3.5_tslib@2.4.1/node_modules/@prisjakt/ui/icon/plus/index.js
var plus = __webpack_require__(34101);
;// CONCATENATED MODULE: ./src/ui/accordion/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  padding: ",
        ";\n  && {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  cursor: pointer;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  transform: ",
        ";\n  transition: transform 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  padding-top: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  max-height: ",
        ";\n  transition: max-height 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  overflow: hidden;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var AccordionWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AccordionWrapper",
    componentId: "sc-0-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.bg.tertiary;
}, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var StyledHeader = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledHeader",
    componentId: "sc-0-1"
})(_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledIconPlus = (0,styled_components_browser_esm["default"])(plus/* IconPlus */.S).withConfig({
    displayName: "StyledIconPlus",
    componentId: "sc-0-2"
})(_templateObject2(), function(param) {
    var expanded = param.expanded;
    return expanded ? "rotate(45deg)" : "rotate(0deg)";
});
var StyledContent = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledContent",
    componentId: "sc-0-3"
})(_templateObject3(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var StyledContentWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledContentWrapper",
    componentId: "sc-0-4"
})(_templateObject4(), function(param) {
    var expanded = param.expanded;
    return expanded ? "500px" : "0";
});

;// CONCATENATED MODULE: ./src/ui/accordion/accordion.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



/**
 * Should have 2 children - AccordionHeader and AccordionContent
 */ var Accordion = function(param) {
    var children = param.children, id = param.id, onChange = param.onChange, _expanded = param.expanded, expanded = _expanded === void 0 ? false : _expanded, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled;
    var ref = _slicedToArray((0,react.useState)(function() {
        return expanded;
    }), 2), expandedState = ref[0], setExpandedState = ref[1];
    var toggle = react.useCallback(function(event) {
        setExpandedState(!expandedState);
        if (onChange) {
            onChange(event, !expandedState);
        }
    }, [
        expandedState,
        setExpandedState,
        onChange
    ]);
    var context = react.useMemo(function() {
        return {
            expanded: Boolean(expandedState),
            toggle: toggle,
            disabled: Boolean(disabled),
            id: id
        };
    }, [
        expandedState,
        toggle,
        disabled,
        id
    ]);
    return /*#__PURE__*/ react.createElement(AccordionWrapper, {
        "aria-labelledby": id
    }, /*#__PURE__*/ react.createElement(AccordionContext.Provider, {
        value: context
    }, children));
};

;// CONCATENATED MODULE: ./src/ui/accordion/accordion-content.tsx



var AccordionContent = function(param) {
    var children = param.children;
    var ref = react.useContext(AccordionContext), expanded = ref.expanded, id = ref.id;
    return /*#__PURE__*/ react.createElement(StyledContentWrapper, {
        expanded: expanded,
        "aria-labelledby": "accordion-header".concat(id)
    }, /*#__PURE__*/ react.createElement(StyledContent, null, children));
};

;// CONCATENATED MODULE: ./src/ui/accordion/accordion-header.tsx



var AccordionHeader = function(param) {
    var children = param.children, onClick = param.onClick;
    var ref = react.useContext(AccordionContext), disabled = ref.disabled, expanded = ref.expanded, toggle = ref.toggle, id = ref.id;
    var handleChange = function(event) {
        if (!disabled) {
            toggle(event);
            if (onClick) {
                onClick(event);
            }
        }
    };
    return /*#__PURE__*/ react.createElement(StyledHeader, {
        disabled: disabled,
        onClick: handleChange,
        "aria-expanded": expanded,
        role: "button",
        "aria-controls": "accordion-content".concat(id),
        id: "accordion-header".concat(id)
    }, /*#__PURE__*/ react.createElement(StyledIconPlus, {
        expanded: expanded
    }), children);
};

;// CONCATENATED MODULE: ./src/ui/accordion/index.tsx






/***/ }),

/***/ 65176:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H5": () => (/* binding */ MediumDown),
/* harmony export */   "NZ": () => (/* binding */ DesktopOnly),
/* harmony export */   "TD": () => (/* binding */ MediumUp),
/* harmony export */   "iB": () => (/* binding */ MobileOnly)
/* harmony export */ });
/* unused harmony exports TabletOnly, MobileAndDesktopOnly */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71993);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61093);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50959);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        " display: none;"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n          ",
        "\n        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    && {\n      ",
        "\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var hideInViewports = function(viewports) {
    return function(Component) {
        return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(Component).withConfig({
            displayName: "hideInViewports",
            componentId: "sc-0-0"
        })(_templateObject2(), viewports.map(function(viewport) {
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject1(), viewport(_templateObject()));
        }));
    };
};
var applyStyles = function(param) {
    var child = param.children, className = param.className;
    if (!(0,react__WEBPACK_IMPORTED_MODULE_2__.isValidElement)(child)) {
        return null;
    }
    return (0,react__WEBPACK_IMPORTED_MODULE_2__.cloneElement)(child, {
        className: className
    });
};
/**
 * These components apply a className to their given child in order to hide it in certain viewports.
 * For them to work, they can only be given a single child that takes a `className` prop that then passes it
 * to its inner-most HTML element. If you want to give them multiple children, or if it's not suitable to
 * pass along `className` all the way down, wrap the childen in an HTML element (e.g. a `div`).
 */ var DesktopOnly = hideInViewports([
    src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown
])(applyStyles);
var TabletOnly = hideInViewports([
    src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.smallOnly */ .BC.smallOnly,
    src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.largeUp */ .BC.largeUp
])(applyStyles);
var MobileAndDesktopOnly = hideInViewports([
    src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumOnly */ .BC.mediumOnly
])(applyStyles);
var MobileOnly = hideInViewports([
    src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumUp */ .BC.mediumUp
])(applyStyles);
var MediumDown = hideInViewports([
    src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.largeUp */ .BC.largeUp
])(applyStyles);
var MediumUp = hideInViewports([
    src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.smallOnly */ .BC.smallOnly
])(applyStyles);


/***/ }),

/***/ 92356:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "nQ": () => (/* reexport */ check),
  "Sd": () => (/* reexport */ EmoticonAngry),
  "_z": () => (/* reexport */ EmoticonDissatisfied),
  "X3": () => (/* reexport */ EmoticonLaughing),
  "sS": () => (/* reexport */ EmoticonNeutral),
  "wr": () => (/* reexport */ EmoticonSmiling),
  "r7": () => (/* reexport */ star)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_react-dom@18.2.0_react-is@18.2.0_react@18.2.0/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(71993);
;// CONCATENATED MODULE: ./src/ui/icons/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    g,\n    path,\n    circle {\n      fill: ",
        ";\n      stroke: ",
        ";\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      path {\n        fill: ",
        ";\n      }\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  stop-color: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  stop-color: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  stop-color: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}

function iconColor(color) {
    var noFill = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, noStroke = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var fillColor = noFill ? "none" : color;
    var strokeColor = noStroke ? "none" : color;
    return (0,styled_components_browser_esm.css)(_templateObject(), fillColor, strokeColor);
}
function getCheckColorFromStyle(theme, style) {
    switch(style){
        case "neutral-light":
            return theme.colors.base0;
        case "primary":
        default:
            return theme.colors.base700;
    }
}
function getStarColorFromStyle(theme, style) {
    switch(style){
        case "active":
            return theme.colors.yellove700;
        case "inactive":
        case "active-alt":
            return theme.colors.base300;
        case "inactive-alt":
            return theme.colors.base500;
        case "half-alt":
        case "half":
        default:
            return theme.colors.base700;
    }
}
function checkIconStyles(theme, iconStyle) {
    return iconColor(getCheckColorFromStyle(theme, iconStyle), true, false);
}
function starIconStyles(theme, iconStyle) {
    return iconColor(getStarColorFromStyle(theme, iconStyle), false, true);
}
var StyledCheckIcon = styled_components_browser_esm["default"].svg.withConfig({
    displayName: "StyledCheckIcon",
    componentId: "sc-0-0"
})(_templateObject1(), function(p) {
    return checkIconStyles(p.theme, p.$styling);
});
var StyledStarIcon = styled_components_browser_esm["default"].svg.withConfig({
    displayName: "StyledStarIcon",
    componentId: "sc-0-1"
})(_templateObject3(), function(p) {
    return starIconStyles(p.theme, p.$styling);
}, function(p) {
    return (p.$styling === "half-alt" || p.$styling === "half") && (0,styled_components_browser_esm.css)(_templateObject2(), p.$styling === "half" ? "url(#halfGradient)" : "url(#halfGradientAlt)");
});
var StopFirstHalf = styled_components_browser_esm["default"].stop.withConfig({
    displayName: "StopFirstHalf",
    componentId: "sc-0-2"
})(_templateObject4(), function(p) {
    return p.theme.colors.yellove700;
});
var StopFirstHalfAlt = styled_components_browser_esm["default"].stop.withConfig({
    displayName: "StopFirstHalfAlt",
    componentId: "sc-0-3"
})(_templateObject5(), function(p) {
    return p.theme.colors.base500;
});
var StopSecondHalf = styled_components_browser_esm["default"].stop.withConfig({
    displayName: "StopSecondHalf",
    componentId: "sc-0-4"
})(_templateObject6(), function(p) {
    return p.theme.colors.base300;
});

;// CONCATENATED MODULE: ./src/ui/icons/check.tsx


var CheckIcon = function(param) {
    var _checked = param.checked, checked = _checked === void 0 ? false : _checked, _partial = param.partial, partial = _partial === void 0 ? false : _partial, _height = param.height, height = _height === void 0 ? 8 : _height, _left = param.left, left = _left === void 0 ? 0 : _left, _top = param.top, top = _top === void 0 ? 0 : _top, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "4" : _strokeWidth, _styling = param.styling, styling = _styling === void 0 ? "primary" : _styling;
    return /*#__PURE__*/ react.createElement(StyledCheckIcon, {
        $styling: styling,
        height: height,
        width: height,
        viewBox: "0 0 34 34",
        fill: "none",
        strokeLinecap: "miter",
        strokeLinejoin: "butt",
        strokeWidth: strokeWidth,
        stroke: "currentcolor",
        style: {
            left: left,
            top: top
        }
    }, checked && /*#__PURE__*/ react.createElement("path", {
        d: "M3 16 L14 24 26 4"
    }), partial && /*#__PURE__*/ react.createElement("path", {
        d: "M4 16 L24 16"
    }));
};
/* harmony default export */ const check = (CheckIcon);

;// CONCATENATED MODULE: ./src/ui/icons/star.tsx


var StarIcon = function(param) {
    var title = param.title, _styling = param.styling, styling = _styling === void 0 ? "inactive" : _styling, _height = param.height, height = _height === void 0 ? 13 : _height, _secondaryColors = param.secondaryColors, secondaryColors = _secondaryColors === void 0 ? false : _secondaryColors;
    var modifier = styling;
    if (secondaryColors) {
        modifier = "".concat(styling, "-alt");
    }
    return /*#__PURE__*/ react.createElement(StyledStarIcon, {
        $styling: modifier,
        height: height,
        width: height,
        viewBox: "0 0 13 13"
    }, /*#__PURE__*/ react.createElement("defs", null, /*#__PURE__*/ react.createElement("linearGradient", {
        id: "halfGradient"
    }, /*#__PURE__*/ react.createElement(StopFirstHalf, {
        offset: "50%"
    }), /*#__PURE__*/ react.createElement(StopSecondHalf, {
        offset: "50%"
    })), /*#__PURE__*/ react.createElement("linearGradient", {
        id: "halfGradientAlt"
    }, /*#__PURE__*/ react.createElement(StopFirstHalfAlt, {
        offset: "50%"
    }), /*#__PURE__*/ react.createElement(StopSecondHalf, {
        offset: "50%"
    }))), title && /*#__PURE__*/ react.createElement("title", null, title), /*#__PURE__*/ react.createElement("path", {
        d: "M13 4.805c0 .114-.068.24-.203.375L9.96 7.945l.672 3.907c.005.036.008.088.008.156a.46.46 0 0 1-.082.277.276.276 0 0 1-.239.113.632.632 0 0 1-.312-.093L6.5 10.46l-3.508 1.844a.664.664 0 0 1-.312.093c-.11 0-.192-.037-.246-.113a.46.46 0 0 1-.082-.277c0-.031.005-.084.015-.156l.672-3.907L.195 5.18C.065 5.04 0 4.914 0 4.805c0-.193.146-.313.438-.36l3.921-.57L6.117.32c.1-.213.227-.32.383-.32s.284.107.383.32L8.64 3.875l3.921.57c.292.047.438.167.438.36z",
        fill: "#002136"
    }));
};
/* harmony default export */ const star = (StarIcon);

;// CONCATENATED MODULE: ./src/ui/icons/emoticons.tsx

var EmoticonAngry = function(param) {
    var ariaLabel = param.ariaLabel, className = param.className, _color = param.color, color = _color === void 0 ? "#505050" : _color, _size = param.size, size = _size === void 0 ? 21 : _size;
    return /*#__PURE__*/ react.createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        role: "img",
        "aria-label": ariaLabel
    }, /*#__PURE__*/ react.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#FFF",
        fillOpacity: "0",
        d: "M16 2c7.732 0 14 6.268 14 14s-6.268 14-14 14S2 23.732 2 16 8.268 2 16 2zm0 14c-3.866 0-7 3.526-7 7.875 0 0 3.542 1.125 7.063 1.125C19.542 25 23 23.875 23 23.875 23 19.525 19.866 16 16 16z"
    }), /*#__PURE__*/ react.createElement("path", {
        stroke: color,
        strokeWidth: "2",
        d: "M10.035 23.13c1.178.314 3.608.87 6.028.87 2.38 0 4.749-.551 5.903-.865-.152-1.618-.794-3.073-1.764-4.164C19.127 17.76 17.645 17 16 17s-3.127.761-4.202 1.97c-.97 1.091-1.611 2.544-1.763 4.16z"
    }), /*#__PURE__*/ react.createElement("g", {
        stroke: color,
        strokeWidth: "2"
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M23.741 8.5l-3.586 4h5.09M8.504 8.5l3.587 4H7"
    }))));
};
var EmoticonDissatisfied = function(param) {
    var ariaLabel = param.ariaLabel, className = param.className, _color = param.color, color = _color === void 0 ? "#505050" : _color, _size = param.size, size = _size === void 0 ? 21 : _size;
    return /*#__PURE__*/ react.createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        role: "img",
        "aria-label": ariaLabel
    }, /*#__PURE__*/ react.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ react.createElement("g", {
        stroke: color,
        strokeWidth: "2"
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M20 18a6 6 0 0 0-6 6M22.618 12.25c-.329.332-.704.5-1.118.5-.414 0-.79-.168-1.06-.44l2.178-.06zm-11 0c-.329.332-.704.5-1.118.5-.414 0-.79-.168-1.06-.44l2.178-.06z"
    }))));
};
var EmoticonNeutral = function(param) {
    var ariaLabel = param.ariaLabel, className = param.className, _color = param.color, color = _color === void 0 ? "#505050" : _color, _size = param.size, size = _size === void 0 ? 21 : _size;
    return /*#__PURE__*/ react.createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        role: "img",
        "aria-label": ariaLabel
    }, /*#__PURE__*/ react.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ react.createElement("g", {
        stroke: color,
        strokeWidth: "2"
    }, /*#__PURE__*/ react.createElement("circle", {
        cx: "10",
        cy: "12",
        r: "1"
    }), /*#__PURE__*/ react.createElement("circle", {
        cx: "22",
        cy: "12",
        r: "1"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M12 20.5h8"
    }))));
};
var EmoticonSmiling = function(param) {
    var ariaLabel = param.ariaLabel, className = param.className, _color = param.color, color = _color === void 0 ? "#505050" : _color, _size = param.size, size = _size === void 0 ? 21 : _size;
    return /*#__PURE__*/ react.createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        role: "img",
        "aria-label": ariaLabel
    }, /*#__PURE__*/ react.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ react.createElement("g", {
        stroke: color,
        strokeWidth: "2"
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M10 18a6 6 0 1 0 12 0M11 12a.997.997 0 0 1-1 1 .997.997 0 0 1-1-1 .997.997 0 0 1 1-1 .997.997 0 0 1 1 1zm12 0a.997.997 0 0 1-1 1 .997.997 0 0 1-1-1 .997.997 0 0 1 1-1 .997.997 0 0 1 1 1z"
    }))));
};
var EmoticonLaughing = function(param) {
    var ariaLabel = param.ariaLabel, className = param.className, _color = param.color, color = _color === void 0 ? "#505050" : _color, _size = param.size, size = _size === void 0 ? 21 : _size;
    return /*#__PURE__*/ react.createElement("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        role: "img",
        "aria-label": ariaLabel
    }, /*#__PURE__*/ react.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "none",
        d: "M16 2c7.732 0 14 6.268 14 14s-6.268 14-14 14S2 23.732 2 16 8.268 2 16 2zm.063 14C12.542 16 9 17.125 9 17.125 9 21.475 12.134 25 16 25s7-3.526 7-7.875c0 0-3.458-1.125-6.937-1.125z"
    }), /*#__PURE__*/ react.createElement("g", {
        stroke: color,
        strokeWidth: "2"
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M10.035 17.87c1.178-.314 3.608-.87 6.028-.87 2.38 0 4.749.551 5.903.865-.152 1.618-.794 3.073-1.764 4.164C19.127 23.24 17.645 24 16 24s-3.127-.761-4.202-1.97c-.97-1.091-1.611-2.544-1.763-4.16zM13.215 12.456a3 3 0 1 0-5.909 1.042M24.694 13.498a3 3 0 0 0-5.909-1.042"
    }))));
};

;// CONCATENATED MODULE: ./src/ui/icons/index.ts






/***/ }),

/***/ 59303:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": () => (/* binding */ ExternalLink),
/* harmony export */   "h": () => (/* binding */ InternalLink)
/* harmony export */ });
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3616);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71993);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var InternalLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])(react_router_dom__WEBPACK_IMPORTED_MODULE_0__/* .Link */ .rU).withConfig({
    displayName: "InternalLink",
    componentId: "sc-0-0"
})(_templateObject(), function(props) {
    return props.theme.text.linkExternal;
}, function(props) {
    return props.theme.text.linkExternalHover;
});
var ExternalLink = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].a.attrs({
    rel: "noopener nofollow",
    target: "_blank"
}).withConfig({
    displayName: "ExternalLink",
    componentId: "sc-0-1"
})(_templateObject1(), function(props) {
    return props.theme.text.linkExternal;
}, function(props) {
    return props.theme.text.linkExternalHover;
});


/***/ }),

/***/ 93497:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": () => (/* binding */ zindex)
/* harmony export */ });
var zindex = {
    modal: 200,
    menu: {
        header: 107,
        searchSuggestions: 110,
        searchOverlay: 100,
        searchBar: 120,
        left: 105,
        sticky: {
            normal: 10,
            background: {
                default: 99,
                isSticky: 102
            }
        },
        filter: 107,
        offerlistFilters: 106,
        experimentEditor: 101,
        mega: 107,
        mobile: {
            overlay: 108,
            content: 109
        }
    },
    overlay: 106,
    ads: {
        outside: 100
    },
    graph: 99,
    popover: 4,
    tooltip: 103,
    actionButtonDropdown: 103,
    actionButton: 2
};


/***/ }),

/***/ 9690:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": () => (/* binding */ handleClickOutBounce)
/* harmony export */ });
var handleClickOutBounce = function(callback) {
    // Start a timer when a user clicks out on a product
    // if they return to Prisjakt within 15 seconds
    // display an error report button in the price row.
    var startTime = Date.now();
    var onRefocus = function() {
        if (Date.now() - startTime > 15000 && document.visibilityState === "visible") {
            document.removeEventListener("visibilitychange", onRefocus);
            return;
        }
        if (document.visibilityState === "visible") {
            callback();
            document.removeEventListener("visibilitychange", onRefocus);
        }
    };
    document.addEventListener("visibilitychange", onRefocus);
};


/***/ }),

/***/ 60591:
/***/ ((module) => {

module.exports = "query myProfile($offset: Int, $getProduct: Boolean = true, $getStore: Boolean = true) {\n  me {\n    reviews(offset: $offset, limit: 10) {\n      totalItems\n      pageInfo {\n        limit\n        offset\n        hasNext\n        hasPrevious\n      }\n      nodes {\n        ...GenericUserReview\n      }\n    }\n  }\n}\n\nfragment GenericUserReview on UserReview {\n  id\n  reviewText\n  rating\n  convertedRating\n  purchaseDate\n  likeScore\n  views\n  underInvestigation\n  createdAt\n  updatedAt\n  createdAtFromNow: createdAt(fromNow: true, suffix: false)\n  updatedAtFromNow: updatedAt(fromNow: true, suffix: false)\n  localizedCreatedAt: createdAt(format: \"L\")\n  localizedUpdatedAt: updatedAt(format: \"L\")\n  isPublished\n  originMarket\n  user {\n    id\n    name\n    displayName\n    reviewCount\n  }\n  product @include(if: $getProduct) {\n    id\n    name\n    pathName\n    priceSummary {\n      regular\n    }\n    userReviewSummary {\n      rating\n      count\n    }\n    aggregatedRating {\n      score\n      count\n    }\n    media {\n      first(width: _140)\n    }\n  }\n  store @include(if: $getStore) {\n    id\n    name\n    pathName\n    userReviewSummary {\n      rating\n      countTotal\n      count\n    }\n    hasLogo\n    logo(width: _176)\n    featured\n  }\n}"

/***/ }),

/***/ 97731:
/***/ ((module) => {

module.exports = "query userQuery($id: Int!, $offset: Int, $getProduct: Boolean = true, $getStore: Boolean = true, $isReviewsTab: Boolean = false, $isListsTab: Boolean = false, $limit: Int = 30, $sort: String = \"published\") {\n  user(id: $id) {\n    id\n    displayName\n    reviewCount\n    memberSince\n    statistics {\n      helpfulScore\n    }\n    reviews(offset: $offset) @include(if: $isReviewsTab) {\n      totalItems\n      pageInfo {\n        limit\n        offset\n        hasNext\n        hasPrevious\n      }\n      nodes {\n        ...GenericUserReview\n      }\n    }\n    ...userLists\n  }\n}\n\nfragment GenericUserReview on UserReview {\n  id\n  reviewText\n  rating\n  convertedRating\n  purchaseDate\n  likeScore\n  views\n  underInvestigation\n  createdAt\n  updatedAt\n  createdAtFromNow: createdAt(fromNow: true, suffix: false)\n  updatedAtFromNow: updatedAt(fromNow: true, suffix: false)\n  localizedCreatedAt: createdAt(format: \"L\")\n  localizedUpdatedAt: updatedAt(format: \"L\")\n  isPublished\n  originMarket\n  user {\n    id\n    name\n    displayName\n    reviewCount\n  }\n  product @include(if: $getProduct) {\n    id\n    name\n    pathName\n    priceSummary {\n      regular\n    }\n    userReviewSummary {\n      rating\n      count\n    }\n    aggregatedRating {\n      score\n      count\n    }\n    media {\n      first(width: _140)\n    }\n  }\n  store @include(if: $getStore) {\n    id\n    name\n    pathName\n    userReviewSummary {\n      rating\n      countTotal\n      count\n    }\n    hasLogo\n    logo(width: _176)\n    featured\n  }\n}\n\nfragment userLists on UserProfile {\n  lists(offset: $offset, limit: $limit, sort: $sort) @include(if: $isListsTab) {\n    pageInfo {\n      limit\n      offset\n      hasNext\n      hasPrevious\n    }\n    nodes {\n      ...listItem\n    }\n  }\n}\n\nfragment listItem on ListItem {\n  id\n  ... on AlertProduct {\n    __typename\n    priceThreshold\n    alertType\n    priceStep\n    storePreference\n    storeGradeThreshold\n    product {\n      preloaded: __typename\n      id\n      name\n      stockStatus\n      category {\n        id\n        name\n      }\n      latestPriceChange {\n        time(fromNow: true)\n        amount\n      }\n      priceSummary {\n        regular\n      }\n      userReviewSummary {\n        rating\n        count\n      }\n      aggregatedRating {\n        score\n        count\n      }\n      media {\n        first(width: _280)\n      }\n      pathName\n    }\n  }\n  ... on AlertSearch {\n    __typename\n    search {\n      id\n      name\n      filterId\n      pathName\n      productsCount\n    }\n  }\n  ...listProduct\n  ... on ListSearch {\n    __typename\n    quantity\n    search {\n      id\n      name\n      filterId\n      pathName\n      productsCount\n    }\n  }\n  ... on ListCategory {\n    __typename\n    name\n    created(fromNow: true)\n    icon\n    pathName\n    itemsCount\n    priceSummary\n    inventory\n    visibility\n  }\n}\n\nfragment listProduct on ListProduct {\n  __typename\n  quantity\n  product {\n    preloaded: __typename\n    id\n    name\n    description\n    category {\n      id\n      name\n    }\n    priceSummary {\n      regular\n      alternative\n    }\n    userReviewSummary {\n      rating\n      count\n    }\n    aggregatedRating {\n      score\n      count\n    }\n    media {\n      first(width: _280)\n    }\n    pathName\n  }\n}"

/***/ }),

/***/ 7432:
/***/ ((module) => {

module.exports = "mutation dislikeShop($shopId: String!) {\n  dislikeShop(shopId: $shopId) {\n    success\n  }\n}"

/***/ }),

/***/ 70518:
/***/ ((module) => {

module.exports = "mutation likeShop($shopId: String!) {\n  likeShop(shopId: $shopId) {\n    success\n  }\n}"

/***/ }),

/***/ 74035:
/***/ ((module) => {

module.exports = "query meShopPreferenceState {\n  me {\n    likes {\n      shops\n    }\n    dislikes {\n      shops\n    }\n  }\n}"

/***/ }),

/***/ 91302:
/***/ ((module) => {

module.exports = "mutation updateSubsciptionSetting($id: ID!, $subscribed: Boolean!) {\n  updateSubscriptionSetting(id: $id, subscribed: $subscribed) {\n    channels {\n      mail {\n        id\n        subscribed\n      }\n      push {\n        id\n        subscribed\n      }\n    }\n  }\n}"

/***/ }),

/***/ 12541:
/***/ ((module) => {

module.exports = "mutation alertUnsubscribe($token: String!) {\n  alertUnsubscribe(token: $token) {\n    product {\n      pathName\n      name\n    }\n  }\n}"

/***/ }),

/***/ 2222:
/***/ ((module) => {

module.exports = "query article($id: Int!) {\n  article(id: $id) {\n    id\n    title\n    preamble\n    body\n    byline\n    publishedAt\n    featured\n    imageUrl\n    imageCaption\n    metaTitle\n    metaDescription\n    pathName\n    related {\n      campaign {\n        id\n        name\n        slug\n        title {\n          short\n        }\n        description {\n          short\n        }\n        web_uri {\n          mobile\n          desktop\n          responsive\n        }\n      }\n      category {\n        id\n        name\n        pathName\n        path {\n          id\n          name\n          pathName\n        }\n      }\n      articles {\n        id\n        title\n        preamble\n        imageUrl\n        pathName\n        publishedAt\n      }\n    }\n    hrefLang {\n      url\n      locale\n    }\n  }\n}"

/***/ }),

/***/ 51882:
/***/ ((module) => {

module.exports = "query brandPage($id: ID!) {\n  brand(id: $id) {\n    ...brandPage\n    ...brandProductListing\n    ...videoListing\n    ...categoryListing\n    ...premiumBrandContent\n  }\n}\n\nfragment brandPage on Brand {\n  id\n  name\n  pathName\n  featured\n  logo\n  externalUri\n  externalUriText\n  premium\n  header\n  description\n  hrefLang {\n    locale\n    url\n  }\n  productsTotal\n}\n\nfragment brandProductListing on Brand {\n  products(limit: 10, onlyFromFeaturedStores: true) {\n    nodes {\n      preloaded: __typename\n      id\n      name\n      pathName\n      description\n      media {\n        first(width: _280)\n      }\n      priceSummary {\n        regular\n        alternative\n      }\n      userReviewSummary {\n        rating\n      }\n      aggregatedRating {\n        score\n      }\n    }\n  }\n}\n\nfragment videoListing on Brand {\n  media {\n    videos {\n      source_id\n      thumbnail\n      embed_url\n    }\n  }\n}\n\nfragment categoryListing on Brand {\n  categories(limit: 5) {\n    nodes {\n      preloaded: __typename\n      id\n      name\n      pathName\n      productCollection\n      logo(width: _192)\n    }\n  }\n  ...categoryTreeListing\n}\n\nfragment categoryTreeListing on Brand {\n  categoryTree(depth: 3) {\n    ...CategoryFields\n    children {\n      ...CategoryFields\n      children {\n        ...CategoryFields\n      }\n    }\n  }\n}\n\nfragment CategoryFields on CategoryTree {\n  preloaded: __typename\n  id\n  name\n  name_hierarchical\n  logo\n  semantic_id\n  product_collection\n}\n\nfragment premiumBrandContent on Brand {\n  featuredProducts {\n    id\n    name\n    pathName\n    media {\n      first(width: _800)\n    }\n    priceSummary {\n      regular\n      alternative\n      inStock\n    }\n    category {\n      id\n      name\n      productCollection\n    }\n  }\n}"

/***/ }),

/***/ 19478:
/***/ ((module) => {

module.exports = "query campaignPage($id: ID, $campaignId: ID, $campaignSlug: ID, $filters: [CampaignFilter!]!, $campaignDeals: Boolean = false, $onlyFromFeaturedStores: Boolean = false, $getDealsProducts: Boolean = false, $categoryIds: [ID], $page: Int! = 0, $sortType: SearchV3Sorting!, $filtersV2: [SearchFilter!]!) {\n  ...campaignDealsRoot @include(if: $campaignDeals)\n  ...dealsProducts @include(if: $getDealsProducts)\n  campaign(id: $id, slug: $campaignSlug, filters: $filters) {\n    id\n    name\n    slug\n    tagline\n    hrefLang {\n      locale\n      url\n    }\n    web_uri {\n      mobile\n      desktop\n      responsive\n    }\n    facetted {\n      title\n      seoTitle\n      description\n      seoDescription\n      tagline\n      canonical\n      isFacetted\n    }\n    title {\n      short\n      long\n      page\n    }\n    description {\n      short\n      long\n      page\n    }\n    descriptionHtml {\n      short\n      long\n      page\n    }\n    banners {\n      url\n      type\n      imageUrl\n    }\n    state\n    type\n    start(format: \"x\")\n    end(format: \"x\")\n    countdown(format: \"x\")\n    articles {\n      id\n      title\n      preamble\n      body\n      byline\n      publishedAt\n      featured\n      imageUrl\n      imageCaption\n      pathName\n    }\n  }\n  ...campaignContent\n}\n\nfragment campaignContent on RootQuery {\n  articles(type: CAMPAIGN) {\n    id\n    publishedAt\n    title\n    preamble\n    imageUrl\n    imageCaption\n    pathName\n    featured\n  }\n  campaigns(inactive: true) {\n    id\n    name\n    slug\n    type\n    tagline\n    title {\n      short\n      long\n      page\n    }\n    description {\n      short\n      long\n      page\n    }\n    web_uri {\n      mobile\n      desktop\n      responsive\n    }\n    media {\n      images {\n        featured\n      }\n    }\n    banners {\n      url\n      type\n      imageUrl\n    }\n    state\n    start(format: \"x\")\n    end(format: \"x\")\n    countdown(format: \"x\")\n  }\n  categoryTree(depth: 7) {\n    id\n    name\n    children {\n      id\n      name\n      children {\n        id\n        name\n        children {\n          id\n          name\n          children {\n            id\n            name\n            children {\n              id\n              name\n              children {\n                id\n                name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment dealsProducts on RootQuery {\n  searchV3 {\n    products(\n      sortType: $sortType\n      page: $page\n      filters: $filtersV2\n      order: desc\n      searchType: deals\n    ) {\n      items {\n        ... on ProductCard {\n          productId\n          priceDrop\n          dealUpdateTime\n          logo\n          name\n          aggregatedRating {\n            score\n            count\n          }\n          productLink\n          storeCount\n          categoryName\n          bestOffer {\n            storeId\n            stockStatus\n            shopOfferId\n            storeName\n            originalPrice\n            memberPrice\n            price\n            offerLink\n            featured\n            priceExpires\n            membershipRequiresCompensation\n          }\n          __typename\n        }\n      }\n      categoryAggregations {\n        key\n        parentKey\n        count\n        name\n        logo\n      }\n      brandsAggregations {\n        key\n        count\n        name\n      }\n      priceHistogram {\n        min\n        max\n        count\n      }\n      hasMorePages\n      didYouMean\n      numberOfHits\n    }\n  }\n}\n\nfragment campaignDealsRoot on RootQuery {\n  campaignDeals(\n    campaignId: $campaignId\n    onlyFromFeaturedStores: $onlyFromFeaturedStores\n    categoryIds: $categoryIds\n  ) {\n    id\n    externalUri\n    price {\n      diffPercentage\n      previousPrice\n      compareDaysAgo\n      id\n    }\n    store {\n      id\n      name\n      hasLogo\n      featured\n    }\n    product {\n      preloaded: __typename\n      description\n      id\n      name\n      pathName\n      media {\n        first(width: _280)\n      }\n      userReviewSummary {\n        rating\n        count\n      }\n      priceSummary {\n        regular\n        alternative\n        inStock\n        count\n      }\n      category {\n        name\n      }\n      isExpertTopRated\n    }\n  }\n}"

/***/ }),

/***/ 98553:
/***/ ((module) => {

module.exports = "query campaignPageThemes {\n  ...campaignContent\n}\n\nfragment campaignContent on RootQuery {\n  articles(type: CAMPAIGN) {\n    id\n    publishedAt\n    title\n    preamble\n    imageUrl\n    imageCaption\n    pathName\n    featured\n  }\n  campaigns(inactive: true) {\n    id\n    name\n    slug\n    type\n    tagline\n    title {\n      short\n      long\n      page\n    }\n    description {\n      short\n      long\n      page\n    }\n    web_uri {\n      mobile\n      desktop\n      responsive\n    }\n    media {\n      images {\n        featured\n      }\n    }\n    banners {\n      url\n      type\n      imageUrl\n    }\n    state\n    start(format: \"x\")\n    end(format: \"x\")\n    countdown(format: \"x\")\n  }\n  categoryTree(depth: 7) {\n    id\n    name\n    children {\n      id\n      name\n      children {\n        id\n        name\n        children {\n          id\n          name\n          children {\n            id\n            name\n            children {\n              id\n              name\n              children {\n                id\n                name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}"

/***/ }),

/***/ 44125:
/***/ ((module) => {

module.exports = "query getCategoryIndex {\n  categoryIndex {\n    id\n    name\n    pathName\n    type\n  }\n}"

/***/ }),

/***/ 48472:
/***/ ((module) => {

module.exports = "query categoryPage($id: ID!, $offset: Int!, $filterId: ID, $brand: ID, $sort: String, $direction: SortDirection, $compareIds: [ID] = [\"_core_\"], $isServices: Boolean!, $campaignId: ID, $categoryIds: [ID], $onlyFromFeaturedStores: Boolean, $isVirtualCategory: Boolean!) {\n  categoryTree(idId: $id, flattenChildren: true, flattenChildrenLimit: 15) {\n    id\n    name\n    logo\n    semantic_id\n    product_collection\n    externalUri\n    children {\n      id\n      name\n      semantic_id\n      product_collection\n      externalUri\n      logo\n    }\n  }\n  category(id: $id, filterId: $filterId, brandId: $brand) @skip(if: $isServices) {\n    ...category\n    ...subCategoryListing\n    ...categoryProductListing\n    brand {\n      ...brandPage\n    }\n  }\n  ...campaignDealsRoot\n  newProducts: recommendation {\n    newReleases(categoryId: $id, limit: 16, onlyFromFeaturedStores: false) @skip(if: $isVirtualCategory) {\n      nodes {\n        id\n        name\n        pathName\n        description\n        highlight\n        isExpertTopRated\n        category {\n          name\n          pathName\n        }\n        popularity {\n          total\n          inCategory\n        }\n        brand {\n          name\n          logo\n        }\n        media {\n          first(width: _280)\n        }\n        priceSummary {\n          regular\n          alternative\n          includeShipping\n          count(type: _regular)\n        }\n        userReviewSummary {\n          rating\n          count\n        }\n        aggregatedRating {\n          score\n          count\n        }\n      }\n    }\n  }\n}\n\nfragment category on Category {\n  id\n  filterId\n  name\n  aliases\n  description(html: true)\n  logo\n  immediateProducts\n  hasAdultContent\n  productCount: products_total\n  storesCount\n  pathName\n  semanticId\n  defaultLayoutMode\n  hrefLang {\n    locale\n    url\n  }\n  path {\n    id\n    name\n    pathName\n  }\n  markets {\n    market\n    lang\n    desktop\n  }\n  articles {\n    id\n    title\n    preamble\n    body\n    byline\n    publishedAt\n    featured\n    imageUrl\n    imageCaption\n    pathName\n  }\n  productCollection\n  newPopularSearchTerms {\n    popularKeywords {\n      name\n      url\n    }\n    trendingKeywords {\n      name\n      url\n    }\n  }\n  popularProducts: products(\n    limit: 24\n    sort: \"popularity\"\n    onlyFromFeaturedStores: true\n  ) {\n    nodes {\n      id\n      name\n      pathName\n      description\n      highlight\n      isExpertTopRated\n      category {\n        name\n        pathName\n      }\n      popularity {\n        total\n        inCategory\n      }\n      brand {\n        name\n        logo\n      }\n      media {\n        first(width: _280)\n      }\n      priceSummary {\n        regular\n        alternative\n        includeShipping\n        count(type: _regular)\n      }\n      userReviewSummary {\n        rating\n        count\n      }\n      aggregatedRating {\n        score\n        count\n      }\n      dealInfo {\n        dealPercentage\n      }\n    }\n  }\n  trendingProducts(onlyFromFeaturedStores: true) {\n    id\n    name\n    pathName\n    category\n    price\n    url\n    userReviewSummary {\n      rating\n      count\n    }\n    aggregatedRating {\n      score\n      count\n    }\n    imageUrl\n    isExpertTopRated\n  }\n}\n\nfragment subCategoryListing on Category {\n  categories {\n    nodes {\n      id\n      name\n      logo\n      pathName\n      path {\n        id\n        name\n      }\n    }\n  }\n  brands(limit: 4, sort: \"popularity\") {\n    nodes {\n      id\n      name\n    }\n  }\n  categoryTree {\n    id\n    name\n    logo\n    semantic_id\n    product_collection\n    externalUri\n    children {\n      id\n      name\n      semantic_id\n      product_collection\n      externalUri\n      logo\n    }\n  }\n}\n\nfragment brandPage on Brand {\n  id\n  name\n  pathName\n  featured\n  logo\n  externalUri\n  externalUriText\n  premium\n  header\n  description\n  hrefLang {\n    locale\n    url\n  }\n  productsTotal\n}\n\nfragment categoryProductListing on Category {\n  products(\n    offset: $offset\n    limit: 24\n    sort: $sort\n    direction: $direction\n    brand: $brand\n  ) {\n    pageInfo {\n      offset\n      limit\n      hasNext\n      hasPrevious\n      selectedProperties {\n        id\n        name\n      }\n      sort {\n        name\n        direction\n        available\n      }\n    }\n    nodes {\n      preloaded: __typename\n      id\n      name\n      pathName\n      description\n      category {\n        name\n        pathName\n      }\n      brand {\n        name\n        featured\n        logo\n      }\n      media {\n        first(width: _280)\n      }\n      priceSummary {\n        regular\n        alternative\n        includeShipping\n        count(type: _regular)\n      }\n      userReviewSummary {\n        rating\n        count\n      }\n      aggregatedRating {\n        score\n        count\n      }\n      campaigns {\n        id\n      }\n      dealInfo {\n        dealPercentage\n      }\n      properties(ids: $compareIds) {\n        nodes {\n          id\n          type\n          name\n          pretty(mode: simple)\n          prettyTable: pretty(mode: table)\n          prettyVerbose: pretty(mode: verbose)\n        }\n      }\n      popularity {\n        total\n        inCategory\n      }\n    }\n  }\n}\n\nfragment campaignDealsRoot on RootQuery {\n  campaignDeals(\n    campaignId: $campaignId\n    onlyFromFeaturedStores: $onlyFromFeaturedStores\n    categoryIds: $categoryIds\n  ) {\n    id\n    externalUri\n    price {\n      diffPercentage\n      previousPrice\n      compareDaysAgo\n      id\n    }\n    store {\n      id\n      name\n      hasLogo\n      featured\n    }\n    product {\n      preloaded: __typename\n      description\n      id\n      name\n      pathName\n      media {\n        first(width: _280)\n      }\n      userReviewSummary {\n        rating\n        count\n      }\n      priceSummary {\n        regular\n        alternative\n        inStock\n        count\n      }\n      category {\n        name\n      }\n      isExpertTopRated\n    }\n  }\n}"

/***/ }),

/***/ 84261:
/***/ ((module) => {

module.exports = "query changelogArticles {\n  prismicArticles(type: CHANGELOG) {\n    pageInfo {\n      offset\n      limit\n    }\n    nodes {\n      id\n      pathName\n      publishedAt(format: \"DD MMM, YYYY\")\n      data {\n        title {\n          ...richContentFragment\n        }\n        secondaryTitle {\n          ...richContentFragment\n        }\n        metaDescription {\n          ...richContentFragment\n        }\n        metaDescriptionLong {\n          ...richContentFragment\n        }\n        featuredImage {\n          ...imageFragment\n        }\n      }\n    }\n  }\n}\n\nfragment richContentFragment on PrismicRichContent {\n  ... on PrismicRichText {\n    type\n    text\n    spans {\n      data {\n        linkType\n        url\n        target\n      }\n      type\n      start\n      end\n    }\n  }\n  ... on PrismicImage {\n    url\n    dimensions {\n      width\n      height\n    }\n    alt\n    copyright\n  }\n}\n\nfragment imageFragment on PrismicImage {\n  url\n  dimensions {\n    width\n    height\n  }\n  alt\n  copyright\n  Mobile {\n    url\n    dimensions {\n      width\n      height\n    }\n    alt\n    copyright\n  }\n  Desktop {\n    url\n    dimensions {\n      width\n      height\n    }\n    alt\n    copyright\n  }\n}"

/***/ }),

/***/ 50973:
/***/ ((module) => {

module.exports = "query prismicArticlesQuery($page: Int, $pageSize: Int) {\n  prismicArticles(type: EDITORIAL_CONTENT, page: $page, pageSize: $pageSize) {\n    pageInfo {\n      limit\n      offset\n      hasNext\n      hasPrevious\n    }\n    totalCount\n    nodes {\n      id\n      pathName\n      publishedAt\n      updatedAt\n      data {\n        title {\n          ...richContentFragment\n        }\n        metaDescription {\n          ...richContentFragment\n        }\n        featuredImage {\n          ...imageFragment\n        }\n      }\n    }\n  }\n}\n\nfragment richContentFragment on PrismicRichContent {\n  ... on PrismicRichText {\n    type\n    text\n    spans {\n      data {\n        linkType\n        url\n        target\n      }\n      type\n      start\n      end\n    }\n  }\n  ... on PrismicImage {\n    url\n    dimensions {\n      width\n      height\n    }\n    alt\n    copyright\n  }\n}\n\nfragment imageFragment on PrismicImage {\n  url\n  dimensions {\n    width\n    height\n  }\n  alt\n  copyright\n  Mobile {\n    url\n    dimensions {\n      width\n      height\n    }\n    alt\n    copyright\n  }\n  Desktop {\n    url\n    dimensions {\n      width\n      height\n    }\n    alt\n    copyright\n  }\n}"

/***/ }),

/***/ 81474:
/***/ ((module) => {

module.exports = "query prismicArticle($id: ID!, $ref: String) {\n  prismicArticle(id: $id, ref: $ref) {\n    id\n    uid\n    pathName\n    slugs\n    tags\n    updatedAt\n    publishedAt\n    type\n    data {\n      meta {\n        title\n        description\n      }\n      metaDescription {\n        ...richContentFragment\n      }\n      featuredImage {\n        ...imageFragment\n      }\n      body {\n        type\n        label\n        primary {\n          __typename\n          ... on PrismicSliceImage {\n            imageLinkOrPath\n            image {\n              ...imageFragment\n            }\n          }\n          ... on PrismicSliceImageText {\n            imageLinkOrPath\n            backgroundColor\n            gridLayout\n            text {\n              ...richContentFragment\n            }\n            image {\n              ...imageFragment\n            }\n          }\n          ... on PrismicSliceTextImage {\n            imageLinkOrPath\n            backgroundColor\n            gridLayout\n            text {\n              ...richContentFragment\n            }\n            image {\n              ...imageFragment\n            }\n          }\n          ... on PrismicSliceTextText {\n            backgroundColor\n            gridLayout\n            textBefore {\n              ...richContentFragment\n            }\n            textAfter {\n              ...richContentFragment\n            }\n          }\n          ... on PrismicSliceHeroTitle {\n            textColor\n            textAlign\n            heroBackgroundColor\n            titleBoxWidth\n            title {\n              ...richContentFragment\n            }\n            secondaryTitle {\n              ...richContentFragment\n            }\n            heroImage {\n              url\n              dimensions {\n                width\n                height\n              }\n              alt\n              copyright\n              Mobile {\n                url\n                dimensions {\n                  width\n                  height\n                }\n                alt\n                copyright\n              }\n              Desktop {\n                url\n                dimensions {\n                  width\n                  height\n                }\n                alt\n                copyright\n              }\n            }\n          }\n          ... on PrismicSliceText {\n            text {\n              ...richContentFragment\n            }\n            backgroundColor\n            textAlign\n          }\n          ... on PrismicSliceProduct {\n            title {\n              ...richContentFragment\n            }\n            product {\n              ...toplistProduct\n            }\n          }\n          ... on PrismicSlicePopularProducts {\n            popularFacet {\n              title\n              url\n              linkText\n              products {\n                id\n                pathName\n                name\n                media {\n                  first(width: _280)\n                }\n                priceSummary {\n                  regular\n                  alternative\n                  inStock\n                }\n                userReviewSummary {\n                  rating\n                  count\n                }\n                aggregatedRating {\n                  score\n                  count\n                }\n                popularity {\n                  total\n                  inCategory\n                }\n                brand {\n                  name\n                }\n                diffPercentage\n                isExpertTopRated\n              }\n            }\n          }\n          ... on PrismicSliceProductList {\n            title {\n              ...richContentFragment\n            }\n            listType\n            products {\n              id\n              name\n              pathName\n              media {\n                first(width: _280)\n              }\n              userReviewSummary {\n                rating\n                count\n              }\n              aggregatedRating {\n                score\n                count\n              }\n              priceSummary {\n                regular\n                alternative\n                inStock\n              }\n              diffPercentage\n              isExpertTopRated\n            }\n          }\n          ... on PrismicSliceVideo {\n            video {\n              url\n            }\n            backgroundColor\n          }\n          ... on PrismicSliceVideoText {\n            text {\n              ...richContentFragment\n            }\n            video {\n              url\n            }\n            gridLayout\n            backgroundColor\n          }\n          ... on PrismicSliceTextVideo {\n            text {\n              ...richContentFragment\n            }\n            video {\n              url\n            }\n            gridLayout\n            backgroundColor\n          }\n          ... on PrismicSliceCallToAction {\n            buttonTitle\n            buttonUrl\n          }\n          ... on PrismicSliceFaqSection {\n            faqTitle {\n              ...richContentFragment\n            }\n            items {\n              question {\n                ...richContentFragment\n              }\n              answer {\n                ...richContentFragment\n              }\n            }\n          }\n          ... on PrismicFrontPageBanner {\n            link\n            textColor\n            buttonText\n            buttonColor\n            image {\n              ...imageFragment\n            }\n            title {\n              ...richContentFragment\n            }\n            subtitle {\n              ...richContentFragment\n            }\n          }\n          ... on PrismicSliceCategories {\n            optionalTitle {\n              ...richContentFragment\n            }\n            categories {\n              type\n              id\n              name\n              path\n              image\n              fallbackImage\n            }\n          }\n          ... on PrismicSliceArticleCarousel {\n            articles {\n              id\n              image {\n                ...imageFragment\n              }\n              slugs\n              title {\n                ...richContentFragment\n              }\n              preamble {\n                ...richContentFragment\n              }\n            }\n          }\n          ... on PrismicSliceColumns {\n            columnsTitle {\n              ...richContentFragment\n            }\n            columnsDescription {\n              ...richContentFragment\n            }\n            pictureCarousel\n            columns {\n              backgroundcolor\n              buttonText {\n                ...richContentFragment\n              }\n              buttonLinkOrPath\n              buttonType\n              text {\n                ...richContentFragment\n              }\n              title {\n                ...richContentFragment\n              }\n              image {\n                ...imageFragment\n              }\n              imageLinkOrPath\n              imageIsOfProduct\n              textColor\n              heightOfImage\n              useImageAsBackground\n            }\n          }\n          ... on PrismicSliceNewsletter {\n            header\n            width\n          }\n        }\n      }\n      title {\n        ...richContentFragment\n      }\n    }\n  }\n}\n\nfragment richContentFragment on PrismicRichContent {\n  ... on PrismicRichText {\n    type\n    text\n    spans {\n      data {\n        linkType\n        url\n        target\n      }\n      type\n      start\n      end\n    }\n  }\n  ... on PrismicImage {\n    url\n    dimensions {\n      width\n      height\n    }\n    alt\n    copyright\n  }\n}\n\nfragment imageFragment on PrismicImage {\n  url\n  dimensions {\n    width\n    height\n  }\n  alt\n  copyright\n  Mobile {\n    url\n    dimensions {\n      width\n      height\n    }\n    alt\n    copyright\n  }\n  Desktop {\n    url\n    dimensions {\n      width\n      height\n    }\n    alt\n    copyright\n  }\n}\n\nfragment toplistProduct on Product {\n  id\n  name\n  pathName\n  userReviewSummary {\n    rating\n    count\n  }\n  aggregatedRating {\n    score\n    count\n  }\n  diffPercentage\n  category {\n    name\n    pathName\n  }\n  media {\n    first(width: _280)\n  }\n  priceSummary {\n    regular\n    count\n  }\n  popularity {\n    inCategory\n  }\n  prices {\n    nodes {\n      id\n      shopOfferId\n      condition\n      availability {\n        condition\n      }\n      price {\n        inclShipping\n        exclShipping\n      }\n      primaryMarket\n      store {\n        id\n        name\n        logo\n        hasLogo\n        featured\n        userReviewSummary {\n          rating\n          count\n        }\n        market\n      }\n      stock {\n        status\n      }\n      externalUri\n    }\n  }\n}"

/***/ }),

/***/ 51307:
/***/ ((module) => {

module.exports = "query expertCategoryPageQuery($slug: String!) {\n  expertCategoryPage(url: $slug) {\n    category {\n      name\n      activeExperts\n      description\n      descriptionImage\n      fullUrl\n    }\n    toplistHeadlines {\n      __typename\n      id\n      url\n      name\n      toplists {\n        publishedAt\n        date(format: \"D MMMM\")\n        expert {\n          name\n          avatar\n          url\n        }\n        products {\n          id\n          order\n          image\n        }\n        headlineInfo {\n          otherExperts {\n            name\n            avatar\n          }\n          likes\n        }\n        description {\n          type\n          data\n        }\n      }\n    }\n    tests {\n      __typename\n      id\n      publishedAt\n      url\n      title\n      likes\n      grade\n      gradeNotConverted\n      date(format: \"D MMMM\")\n      expert {\n        name\n        avatar\n        url\n      }\n      imageWithSize(size: x2) {\n        src\n      }\n    }\n    guides {\n      __typename\n      id\n      publishedAt\n      url\n      title\n      likes\n      date(format: \"D MMMM\")\n      expert {\n        name\n        avatar\n        url\n      }\n      image(size: x2) {\n        src\n        alt\n      }\n    }\n  }\n}"

/***/ }),

/***/ 78242:
/***/ ((module) => {

module.exports = "query expertGuide($slug: String!) {\n  guide(url: $slug) {\n    id\n    title\n    metaTitle\n    bonusContent\n    description\n    published\n    hasVideo\n    category {\n      name\n      url\n    }\n    expert {\n      id\n      name\n      url\n      avatar\n      bio\n      categories {\n        name\n        url\n      }\n    }\n    image(size: x4) {\n      alt\n      src\n    }\n    video {\n      thumbnail\n      id\n      info\n    }\n    mainContent {\n      headline\n      text\n      images(size: x3) {\n        src\n      }\n    }\n    products {\n      id\n      name\n      pathName\n      priceSummary {\n        regular\n      }\n      media {\n        first(width: _280)\n      }\n      userReviewSummary {\n        rating\n        count\n      }\n    }\n    otherLists {\n      title\n      url\n      expert\n      productName\n      productBrand\n      productImage\n      listCount\n    }\n  }\n}"

/***/ }),

/***/ 6547:
/***/ ((module) => {

module.exports = "query ExpertLandingPage($skipNews: Int = 0, $skipGuides: Int = 0, $skipToplists: Int = 0, $skipTests: Int = 0, $popCategories: [String], $limit: Int) {\n  expertLandingPage(\n    skipNews: $skipNews\n    skipGuides: $skipGuides\n    skipToplists: $skipToplists\n    skipTests: $skipTests\n    limit: $limit\n  ) {\n    experts {\n      id\n      name\n      avatar\n      url\n    }\n    expertCount\n    items {\n      ...listItems\n    }\n    menuCategories {\n      label\n      icon\n      children {\n        label\n        url\n      }\n    }\n  }\n  popularCategories(popCategories: $popCategories, limit: $limit) {\n    items {\n      ...listItems\n    }\n  }\n}\n\nfragment listItems on LandingPageItems {\n  tests {\n    __typename\n    id\n    publishedAt\n    url\n    title\n    grade\n    likes\n    date(format: \"D MMMM\")\n    imageWithSize(size: x2) {\n      src\n      alt\n    }\n    expert {\n      name\n      avatar\n      url\n    }\n    category {\n      name\n      url\n    }\n    product {\n      category {\n        name\n      }\n    }\n  }\n  toplists {\n    __typename\n    id\n    publishedAt\n    id\n    title\n    publishedAt\n    date(format: \"D MMMM\")\n    headlineInfo {\n      url\n      likes\n      otherExperts {\n        name\n        avatar\n      }\n    }\n    products {\n      id\n      order\n      image\n    }\n    description {\n      type\n      data\n    }\n    category {\n      name\n      url\n    }\n    expert {\n      name\n      avatar\n      url\n    }\n  }\n}"

/***/ }),

/***/ 12551:
/***/ ((module) => {

module.exports = "query expertProductTest($slug: String!, $getProduct: Boolean = false, $getStore: Boolean = false) {\n  test(url: $slug) {\n    id\n    metaDescription\n    metaTitle\n    grade\n    gradeNotConverted\n    date(format: \"D MMMM YYYY\")\n    publishedAt\n    title\n    plus\n    minus\n    description\n    url\n    fullUrl\n    hasVideo\n    likes\n    category {\n      name\n      url\n    }\n    expert {\n      id\n      name\n      avatar\n      url\n      bio\n      categories {\n        name\n        url\n      }\n    }\n    imageWithSize(size: x3) {\n      src\n      alt\n    }\n    suitedFor {\n      headline\n      text\n      grade\n      gradeNotConverted\n    }\n    notSuitedFor {\n      headline\n      text\n      grade\n      gradeNotConverted\n    }\n    suitedForLong\n    mainContent {\n      headline\n      text\n      images(size: x3) {\n        src\n      }\n    }\n    aboutBrand {\n      headline\n      text\n      images(size: x3) {\n        src\n      }\n    }\n    specifications {\n      type\n      description\n    }\n    video {\n      id\n      thumbnail\n    }\n    product {\n      advizedBrand\n      advizedCategory\n      id\n      name\n      userReviewSummary {\n        rating\n        countTotal\n      }\n      userReviews(limit: 5) {\n        nodes {\n          ...GenericUserReview\n          translation {\n            text: reviewText\n            language\n            service {\n              name\n              uri\n            }\n          }\n        }\n      }\n      media {\n        first(width: _140)\n      }\n      pathName\n      priceSummary {\n        regular\n      }\n      category {\n        name\n        pathName\n      }\n      popularity {\n        inCategory\n      }\n    }\n  }\n}\n\nfragment GenericUserReview on UserReview {\n  id\n  reviewText\n  rating\n  convertedRating\n  purchaseDate\n  likeScore\n  views\n  underInvestigation\n  createdAt\n  updatedAt\n  createdAtFromNow: createdAt(fromNow: true, suffix: false)\n  updatedAtFromNow: updatedAt(fromNow: true, suffix: false)\n  localizedCreatedAt: createdAt(format: \"L\")\n  localizedUpdatedAt: updatedAt(format: \"L\")\n  isPublished\n  originMarket\n  user {\n    id\n    name\n    displayName\n    reviewCount\n  }\n  product @include(if: $getProduct) {\n    id\n    name\n    pathName\n    priceSummary {\n      regular\n    }\n    userReviewSummary {\n      rating\n      count\n    }\n    aggregatedRating {\n      score\n      count\n    }\n    media {\n      first(width: _140)\n    }\n  }\n  store @include(if: $getStore) {\n    id\n    name\n    pathName\n    userReviewSummary {\n      rating\n      countTotal\n      count\n    }\n    hasLogo\n    logo(width: _176)\n    featured\n  }\n}"

/***/ }),

/***/ 62754:
/***/ ((module) => {

module.exports = "query expertProfile($slug: String!) {\n  expert(url: $slug) {\n    fullUrl\n    name\n    avatar\n    likes\n    bio\n    priorities\n    socialMedia {\n      type\n      link\n    }\n    categories {\n      name\n      url\n    }\n    toplists {\n      __typename\n      id\n      title\n      publishedAt\n      date(format: \"D MMMM\")\n      headlineInfo {\n        url\n        likes\n      }\n      category {\n        name\n        url\n      }\n      description {\n        data\n        type\n      }\n      products {\n        id\n        image\n        order\n      }\n    }\n    tests {\n      __typename\n      id\n      publishedAt\n      title\n      url\n      likes\n      date(format: \"D MMMM\")\n      grade\n      category {\n        name\n        url\n      }\n      imageWithSize(size: x2) {\n        src\n      }\n    }\n    guides {\n      __typename\n      id\n      publishedAt\n      url\n      title\n      likes\n      date(format: \"D MMMM\")\n      category {\n        name\n        url\n      }\n      image(size: x2) {\n        src\n        alt\n      }\n    }\n  }\n}"

/***/ }),

/***/ 63405:
/***/ ((module) => {

module.exports = "query ExpertToplists($slug: String!) {\n  toplist(url: $slug) {\n    id\n    name\n    likes\n    fullUrl\n    toplists {\n      id\n      title\n      publishedAt\n      date(format: \"D MMM YYYY\")\n      description {\n        type\n        data\n      }\n      expert {\n        id\n        name\n        avatar\n        likes\n        url\n        slug\n        bio\n        categories {\n          name\n          url\n        }\n      }\n      category {\n        url\n        name\n      }\n      products {\n        id\n        plus\n        minus\n        description\n        advizedBrand\n        video {\n          id\n          thumbnail\n          info\n        }\n        test {\n          url\n          expert {\n            name\n            slug\n          }\n          video {\n            id\n            thumbnail\n          }\n        }\n      }\n      pjProducts {\n        ...toplistProduct\n      }\n    }\n  }\n}\n\nfragment toplistProduct on Product {\n  id\n  name\n  pathName\n  userReviewSummary {\n    rating\n    count\n  }\n  aggregatedRating {\n    score\n    count\n  }\n  diffPercentage\n  category {\n    name\n    pathName\n  }\n  media {\n    first(width: _280)\n  }\n  priceSummary {\n    regular\n    count\n  }\n  popularity {\n    inCategory\n  }\n  prices {\n    nodes {\n      id\n      shopOfferId\n      condition\n      availability {\n        condition\n      }\n      price {\n        inclShipping\n        exclShipping\n      }\n      primaryMarket\n      store {\n        id\n        name\n        logo\n        hasLogo\n        featured\n        userReviewSummary {\n          rating\n          count\n        }\n        market\n      }\n      stock {\n        status\n      }\n      externalUri\n    }\n  }\n}"

/***/ }),

/***/ 13278:
/***/ ((module) => {

module.exports = "query infoPage($id: ID) {\n  pageContent: page(type: INFO_PAGE, id: $id) {\n    id\n    title\n    body: markdown(format: true)\n    pathName\n    hrefLang {\n      locale\n      url\n    }\n  }\n}"

/***/ }),

/***/ 25559:
/***/ ((module) => {

module.exports = "query keywordLandingPage($slug: String, $query: String, $offset: Int, $limit: Int, $source: KeywordLandingPageSource) {\n  keywordLandingPage(slug: $slug, query: $query, source: $source) {\n    title\n    url\n    published\n    inSitemap\n    hasAdultContent\n    publishedAt\n    sourceId\n    metaDescription\n    label\n    description {\n      text\n      descriptionSource\n    }\n    items(offset: $offset, limit: $limit) {\n      pageInfo {\n        offset\n        limit\n        total\n        pages\n      }\n      nodes {\n        ... on Product {\n          __typename\n          id\n          name\n          pathName\n          userReviewSummary {\n            rating\n            count\n          }\n          aggregatedRating {\n            score\n            count\n          }\n          priceSummary {\n            regular\n            alternative\n            count\n          }\n          media {\n            first(width: _140)\n            firstLarge: first(width: _280)\n          }\n          dealInfo {\n            dealPercentage\n          }\n          properties(coreOnly: true) {\n            nodes {\n              id\n              type\n              name\n              isCore\n              pretty(mode: simple)\n              prettyTable: pretty(mode: table)\n              unit\n              ... on PropertyBoolean {\n                boolean\n              }\n              ... on PropertyString {\n                value\n              }\n              ... on PropertyList {\n                values\n              }\n              ... on PropertyNumber {\n                number\n              }\n              ... on PropertyInterval {\n                from\n                to\n              }\n            }\n          }\n          isExpertTopRated\n        }\n        ... on Offer {\n          __typename\n          offerId: id\n          name\n          externalUri\n          media {\n            first\n          }\n          store {\n            name\n            id\n            featured\n            currency\n          }\n          offerPrice {\n            regular\n          }\n        }\n      }\n    }\n    categories(limit: 10) {\n      pageInfo {\n        total\n      }\n      nodes {\n        type\n        id\n        name\n        path\n        image\n        productCount\n      }\n    }\n    parentCategory {\n      path {\n        id\n        name\n        pathName\n      }\n    }\n  }\n  popularSearches {\n    query\n  }\n}"

/***/ }),

/***/ 66120:
/***/ ((module) => {

module.exports = "query keywordListingPage($ids: [String!], $limit: Int, $includeRandom: Boolean) {\n  popularSearchTerms(ids: $ids, limit: $limit, includeRandom: $includeRandom) {\n    keywords {\n      name\n      url\n    }\n    categories {\n      id\n      name\n      url\n      imageUrl\n      classicId\n    }\n  }\n}"

/***/ }),

/***/ 77166:
/***/ ((module) => {

module.exports = "query landingPage($campaignId: ID, $skip: Boolean = false, $onlyFromFeaturedStores: Boolean = true, $categoryIds: [ID]) {\n  ...rootCategories\n  ...featuredProducts\n  ...campaignDealsRoot\n  ...featuredArticle\n  ...popularFacets\n  ...expertContent @skip(if: $skip)\n  shopOfTheYear {\n    year\n  }\n  frontPageBanner {\n    link\n    textColor\n    buttonText\n    buttonColor\n    image {\n      ...imageFragment\n    }\n    title {\n      ...richContentFragment\n    }\n    subtitle {\n      ...richContentFragment\n    }\n  }\n  prismicArticlesHighlighted: prismicArticles(tags: [\"frontpage-highlighted\"]) {\n    nodes {\n      id\n      pathName\n      data {\n        title {\n          ...richContentFragment\n        }\n        metaDescription {\n          ...richContentFragment\n        }\n        featuredImage {\n          ...imageFragment\n        }\n      }\n    }\n  }\n  prismicArticles(tags: [\"frontpage\"]) {\n    nodes {\n      id\n      pathName\n      data {\n        title {\n          ...richContentFragment\n        }\n        metaDescription {\n          ...richContentFragment\n        }\n        featuredImage {\n          ...imageFragment\n        }\n      }\n    }\n  }\n}\n\nfragment rootCategories on RootQuery {\n  rootCategories: categoryTree(depth: 7, flattenChildren: true) {\n    id\n    name\n    logo\n    semantic_id\n    product_collection\n    externalUri\n    children {\n      id\n      name\n      semantic_id\n      product_collection\n      externalUri\n    }\n  }\n}\n\nfragment campaignDealsRoot on RootQuery {\n  campaignDeals(\n    campaignId: $campaignId\n    onlyFromFeaturedStores: $onlyFromFeaturedStores\n    categoryIds: $categoryIds\n  ) {\n    id\n    externalUri\n    price {\n      diffPercentage\n      previousPrice\n      compareDaysAgo\n      id\n    }\n    store {\n      id\n      name\n      hasLogo\n      featured\n    }\n    product {\n      preloaded: __typename\n      description\n      id\n      name\n      pathName\n      media {\n        first(width: _280)\n      }\n      userReviewSummary {\n        rating\n        count\n      }\n      priceSummary {\n        regular\n        alternative\n        inStock\n        count\n      }\n      category {\n        name\n      }\n      isExpertTopRated\n    }\n  }\n}\n\nfragment featuredProducts on RootQuery {\n  featuredProductsArray {\n    title\n    linkTitle\n    linkUrl\n    products {\n      id\n      name\n      pathName\n      media {\n        first(width: _140)\n      }\n      priceSummary {\n        regular\n      }\n      category {\n        id\n        name\n      }\n      isExpertTopRated\n    }\n  }\n}\n\nfragment featuredArticle on RootQuery {\n  featuredArticle {\n    title\n    preamble\n    imageUrl\n    pathName\n  }\n}\n\nfragment popularFacets on RootQuery {\n  popularFacets {\n    title\n    url\n    linkText\n    products(onlyFromFeaturedStores: true) {\n      id\n      pathName\n      name\n      media {\n        first(width: _280)\n      }\n      priceSummary {\n        regular\n        alternative\n        inStock\n      }\n      userReviewSummary {\n        rating\n        count\n      }\n      aggregatedRating {\n        score\n        count\n      }\n      popularity {\n        total\n        inCategory\n      }\n      brand {\n        name\n      }\n      isExpertTopRated\n    }\n  }\n}\n\nfragment richContentFragment on PrismicRichContent {\n  ... on PrismicRichText {\n    type\n    text\n    spans {\n      data {\n        linkType\n        url\n        target\n      }\n      type\n      start\n      end\n    }\n  }\n  ... on PrismicImage {\n    url\n    dimensions {\n      width\n      height\n    }\n    alt\n    copyright\n  }\n}\n\nfragment imageFragment on PrismicImage {\n  url\n  dimensions {\n    width\n    height\n  }\n  alt\n  copyright\n  Mobile {\n    url\n    dimensions {\n      width\n      height\n    }\n    alt\n    copyright\n  }\n  Desktop {\n    url\n    dimensions {\n      width\n      height\n    }\n    alt\n    copyright\n  }\n}\n\nfragment expertContent on RootQuery {\n  expertLandingPage(\n    skipNews: 0\n    skipGuides: 0\n    skipToplists: 0\n    skipTests: 0\n    limit: 4\n  ) {\n    expertCount\n    experts {\n      name\n      avatar\n      url\n    }\n    items {\n      tests {\n        __typename\n        id\n        url\n        title\n        publishedAt\n        category {\n          name\n          url\n        }\n        expert {\n          name\n          avatar\n        }\n        date(format: \"D MMMM\")\n        imageWithSize(size: x2) {\n          src\n          alt\n        }\n      }\n      toplists {\n        __typename\n        id\n        title\n        publishedAt\n        date(format: \"D MMMM\")\n        category {\n          name\n          url\n        }\n        expert {\n          name\n          avatar\n          url\n        }\n        headlineInfo {\n          url\n          otherExperts {\n            name\n            avatar\n          }\n          likes\n        }\n        products {\n          id\n          order\n        }\n        description {\n          type\n          data\n        }\n      }\n    }\n  }\n}"

/***/ }),

/***/ 48993:
/***/ ((module) => {

module.exports = "query productCollectionSitemap($slug: String) {\n  productCollectionSitemap(slug: $slug) {\n    name\n    sitemapCollection {\n      property\n      sitemapItems {\n        path\n        title\n      }\n    }\n  }\n}"

/***/ }),

/***/ 50699:
/***/ ((module) => {

module.exports = "query productCollectionPage($slug: String, $id: String, $query: ProductCollectionQueryInput, $productPropertyIds: [ID!] = [\"_core_\"], $productPropertyColumnIds: [String!], $onlyFeaturedFilters: Boolean) {\n  productCollection(\n    id: $id\n    slug: $slug\n    query: $query\n    onlyFeaturedFilters: $onlyFeaturedFilters\n  ) {\n    id\n    slug\n    name\n    indexable\n    url\n    aliases\n    hasAdultContent\n    categories {\n      id\n    }\n    query {\n      aggregations {\n        id\n        size\n      }\n    }\n    categoryPath {\n      id\n      slug\n      name\n      pathName\n    }\n    newPopularSearchTerms {\n      popularKeywords {\n        name\n        url\n      }\n      trendingKeywords {\n        name\n        url\n      }\n    }\n    filters {\n      ... on ProductCollectionTermFilter {\n        id\n        type\n        property\n      }\n      ... on ProductCollectionTermsFilter {\n        ids\n        type\n        property\n      }\n      ... on ProductCollectionRangeFilter {\n        type\n        property\n        to\n        from\n      }\n      ... on ProductCollectionRangeGroupFilter {\n        type\n        key\n        property\n      }\n      ... on ProductCollectionBooleanFilter {\n        id\n        type\n        property\n      }\n      ... on ProductCollectionNameSearchFilter {\n        query\n        type\n      }\n    }\n    slices {\n      __typename\n      ... on BreadcrumbsSlice {\n        id\n        items {\n          name\n          pathName\n        }\n      }\n      ... on NavigationSlice {\n        id\n        property\n        links {\n          id\n          value\n          count\n          path\n          productMedia {\n            first(width: _280)\n          }\n          fallbackImage\n          indexable\n        }\n      }\n      ... on SecondaryNavigationSlice {\n        id\n        navigationItems {\n          title\n          url\n        }\n      }\n      ... on HeaderBlockSlice {\n        id\n        title\n        description\n        logo\n        pagination {\n          pages\n          currentPage\n        }\n      }\n      ... on DescriptionSlice {\n        id\n        description\n      }\n      ... on FilterSlice {\n        id\n        productsCount\n        sections {\n          __typename\n          ... on AggregationSectionInterface {\n            id\n            title\n            property\n            featured\n            group\n          }\n          ... on ListSection {\n            multiple\n            hasMore\n            search\n            items {\n              id\n              value\n              count\n              indexable\n            }\n            popular {\n              id\n              value\n              count\n              indexable\n            }\n          }\n          ... on ListTreeSection {\n            multiple\n            hasMore\n            search\n            items {\n              id\n              value\n              count\n              indexable\n              selectable\n              parentId\n            }\n          }\n          ... on RangeSection {\n            count\n            min\n            max\n            unit\n            valueType\n            histogram {\n              scale\n              largestBucketCount\n              buckets {\n                id\n                count\n                from\n                to\n              }\n            }\n          }\n          ... on RangeGroupSection {\n            multiple\n            groups {\n              id\n              count\n              from\n              to\n              value\n            }\n          }\n          ... on BooleanSection {\n            items {\n              id\n              value\n              count\n            }\n          }\n          ... on UnsupportedSection {\n            type\n          }\n        }\n        filters {\n          __typename\n          ... on ProductCollectionTermsFilter {\n            property\n            title\n            values\n            ids\n            clearFilterPath\n          }\n          ... on ProductCollectionTermFilter {\n            property\n            title\n            value\n            id\n            clearFilterPath\n          }\n          ... on ProductCollectionRangeFilter {\n            property\n            title\n            value\n            clearFilterPath\n            from\n            to\n            unit\n          }\n          ... on ProductCollectionRangeGroupFilter {\n            title\n            type\n            key\n            values\n            property\n            unit\n          }\n          ... on ProductCollectionBooleanFilter {\n            property\n            title\n            id\n            clearFilterPath\n          }\n          ... on ProductCollectionNameSearchFilter {\n            query\n            type\n          }\n        }\n      }\n      ... on ProductsSlice {\n        id\n        pageInfo {\n          sort {\n            name\n            direction\n          }\n          offset\n          limit\n        }\n        products {\n          id\n          pathName\n          name\n          stockStatus\n          indexingDate(format: distance)\n          media {\n            first(width: _140)\n          }\n          priceSummary {\n            regular\n            includeShipping\n            count(type: _regular)\n          }\n          userReviewSummary {\n            rating\n            count\n          }\n          aggregatedRating {\n            score\n            count\n          }\n          dealInfo {\n            dealPercentage\n          }\n          properties(ids: $productPropertyIds, coreOnly: true) {\n            nodes {\n              id\n              type\n              name\n              isCore\n              pretty(mode: table)\n              unit\n              ... on PropertyBoolean {\n                boolean\n              }\n              ... on PropertyString {\n                value\n              }\n              ... on PropertyList {\n                values\n              }\n              ... on PropertyNumber {\n                number\n              }\n              ... on PropertyInterval {\n                from\n                to\n              }\n            }\n          }\n          popularity {\n            total\n            inCategory\n          }\n          category {\n            logo\n          }\n          brand {\n            name\n            logo\n          }\n          highlight\n          cheapestPrice(\n            featured: true\n            inStock: true\n            excludeTypes: [not_in_mint_condition, not_available_for_purchase, used_product]\n          ) {\n            externalUri\n            store {\n              name\n              logo\n              userReviewSummary {\n                rating\n              }\n            }\n            price {\n              exclShipping\n              exclShipping\n            }\n          }\n          isExpertTopRated\n        }\n        productsCount\n        storeCount\n        legalText\n        availableSorts\n        currentSort\n        maxHitsAmount\n        sortDirection\n        featuredProperties {\n          id\n          name\n          type\n          unit\n        }\n        propertyColumns(ids: $productPropertyColumnIds) {\n          __typename\n          ... on ProductCollectionTruePropertyColumn {\n            id\n            name\n            type\n            unit\n          }\n          ... on ProductCollectionSimulatedPropertyColumn {\n            id\n          }\n        }\n        preferredViewMode\n      }\n      ... on MetaDataSlice {\n        title\n        description\n        image\n        name\n        url {\n          current\n          next\n          prev\n        }\n        hrefLang {\n          url\n          locale\n        }\n        pagination {\n          pages\n          currentPage\n        }\n      }\n      ... on AdsSlice {\n        categoryPath\n      }\n      ... on PrismicSliceFaqSection {\n        faqTitle {\n          ...richContentFragment\n        }\n        items {\n          question {\n            ...richContentFragment\n          }\n          answer {\n            ...richContentFragment\n          }\n        }\n      }\n      ... on FeaturedArticlesSlice {\n        featuredArticle {\n          id\n          pathName\n          data {\n            title {\n              ...richContentFragment\n            }\n            metaDescription {\n              ...richContentFragment\n            }\n            featuredImage {\n              ...imageFragment\n            }\n            body(type: PRODUCT_LIST) {\n              type\n              primary {\n                __typename\n                ...expertArticleProducts\n              }\n            }\n          }\n        }\n        toplistArticles {\n          __typename\n          id\n          title\n          url\n          category {\n            name\n            url\n          }\n          date(format: \"D MMMM\")\n          publishedAt\n          description {\n            type\n            data\n          }\n          expert {\n            name\n            url\n            avatar\n          }\n          headlineInfo {\n            likes\n            url\n            otherExperts {\n              name\n              avatar\n            }\n          }\n          products {\n            image\n            order\n          }\n          pjProducts {\n            id\n            name\n            media {\n              first(width: _280)\n            }\n            pathName\n          }\n          image(size: x3) {\n            src\n            alt\n          }\n        }\n      }\n      ... on ExpertSlice {\n        expert {\n          toplistsCount\n          testsCount\n          guidesCount\n          category {\n            name\n            descriptionImage\n            url\n          }\n          tests {\n            __typename\n            id\n            title\n            url\n            grade\n            date(format: \"D MMMM\")\n            publishedAt\n            likes\n            expert {\n              name\n              url\n              avatar\n            }\n            imageWithSize(size: x2) {\n              src\n              alt\n            }\n          }\n          toplists {\n            __typename\n            id\n            title\n            url\n            date(format: \"D MMMM\")\n            publishedAt\n            description {\n              type\n              data\n            }\n            expert {\n              name\n              url\n              avatar\n            }\n            headlineInfo {\n              likes\n              url\n              otherExperts {\n                name\n                avatar\n              }\n            }\n            products {\n              image\n              order\n            }\n          }\n        }\n      }\n    }\n    trendingProducts(onlyFromFeaturedStores: true) {\n      id\n      name\n      pathName\n      category\n      price\n      url\n      userReviewSummary {\n        rating\n        count\n      }\n      aggregatedRating {\n        score\n        count\n      }\n      imageUrl\n      isExpertTopRated\n    }\n  }\n}\n\nfragment richContentFragment on PrismicRichContent {\n  ... on PrismicRichText {\n    type\n    text\n    spans {\n      data {\n        linkType\n        url\n        target\n      }\n      type\n      start\n      end\n    }\n  }\n  ... on PrismicImage {\n    url\n    dimensions {\n      width\n      height\n    }\n    alt\n    copyright\n  }\n}\n\nfragment imageFragment on PrismicImage {\n  url\n  dimensions {\n    width\n    height\n  }\n  alt\n  copyright\n  Mobile {\n    url\n    dimensions {\n      width\n      height\n    }\n    alt\n    copyright\n  }\n  Desktop {\n    url\n    dimensions {\n      width\n      height\n    }\n    alt\n    copyright\n  }\n}\n\nfragment expertArticleProducts on PrismicSliceProductList {\n  listType\n  products {\n    id\n    name\n    pathName\n    media {\n      first(width: _280)\n    }\n    userReviewSummary {\n      rating\n      count\n    }\n    priceSummary {\n      regular\n      alternative\n      inStock\n    }\n  }\n}"

/***/ }),

/***/ 88273:
/***/ ((module) => {

module.exports = "query productComparePage($categoryId: ID!, $productIds: [Int!]!, $productIdRelated: Int, $fetchCategory: Boolean = true) {\n  ...categoryProps @include(if: $fetchCategory)\n  products(ids: $productIds, compare: true) {\n    id\n    name\n    description\n    pathName\n    stockStatus\n    releaseDate\n    priceSummary {\n      regular\n      count\n      includeShipping\n    }\n    userReviewSummary {\n      rating\n      count\n    }\n    aggregatedRating {\n      score\n      count\n    }\n    media {\n      first(width: _280)\n    }\n    hrefLang {\n      locale\n      url\n    }\n    brand {\n      id\n      name\n      featured\n      logo\n      pathName\n    }\n    popularity {\n      inCategory\n    }\n    reviewBadges {\n      id\n      name\n      sentiment\n      nrOfPositiveReviews\n      nrOfReviews\n    }\n    ...productProperties\n  }\n  relatedProducts(productId: $productIdRelated) {\n    id\n    name\n    imageUrl\n    price\n  }\n}\n\nfragment categoryProps on RootQuery {\n  category(id: $categoryId) {\n    id\n    logo\n    name\n    pathName\n    semanticId\n    path {\n      id\n      name\n      pathName\n    }\n  }\n}\n\nfragment productProperties on Product {\n  properties {\n    nodes {\n      id\n      type\n      name\n      children\n      isRoot\n      isCore\n      isDiff\n      unit\n      comment\n      ... on PropertyBoolean {\n        boolean\n      }\n      ... on PropertyCategory {\n        id\n      }\n      ... on PropertyNumber {\n        number\n      }\n      ... on PropertyInterval {\n        id\n      }\n      ... on PropertyLink {\n        links {\n          url\n          languages\n        }\n      }\n      ... on PropertyList {\n        values\n        categoryLinks\n      }\n      ... on PropertyString {\n        value\n        categoryLink\n      }\n      ... on PropertyInterval {\n        from\n        to\n      }\n    }\n  }\n}"

/***/ }),

/***/ 66490:
/***/ ((module) => {

module.exports = "query fetchLists($limit: Int, $offset: Int) {\n  me {\n    id\n    lists(limit: $limit, offset: $offset, sort: \"accessed\") {\n      pageInfo {\n        hasNext\n      }\n      nodes {\n        id\n        ... on ListCategory {\n          name\n          inventory\n        }\n      }\n    }\n  }\n}"

/***/ }),

/***/ 50536:
/***/ ((module) => {

module.exports = "query productMedia($id: Int!) {\n  product(id: $id) {\n    media {\n      first(width: _280)\n      images(width: _280)\n      large: images(width: _800)\n      videos {\n        source_id\n        embed_url\n        thumbnail\n      }\n    }\n  }\n}"

/***/ }),

/***/ 59086:
/***/ ((module) => {

module.exports = "query priceHistoryV2($id: Int!, $timeRange: TimeRange!, $importantDates: Boolean = false) {\n  product(id: $id) {\n    historyV2(timeRange: $timeRange) {\n      historyItems {\n        date\n        name\n        price\n        isMembershipPrice\n        isPaidMembership\n        shopName\n        shopId\n        active\n      }\n      historyAllShops {\n        id\n        name\n      }\n      oldestHistoryItem\n      newestHistoryItem\n    }\n  }\n  ...importantDates @include(if: $importantDates)\n}\n\nfragment importantDates on RootQuery {\n  importantDates {\n    startDate\n    endDate\n    name\n  }\n}"

/***/ }),

/***/ 547:
/***/ ((module) => {

module.exports = "query productTabProperties($id: Int!) {\n  product(id: $id) {\n    ...productProperties\n  }\n}\n\nfragment productProperties on Product {\n  properties {\n    nodes {\n      id\n      type\n      name\n      children\n      isRoot\n      isCore\n      isDiff\n      unit\n      comment\n      ... on PropertyBoolean {\n        boolean\n      }\n      ... on PropertyCategory {\n        id\n      }\n      ... on PropertyNumber {\n        number\n      }\n      ... on PropertyInterval {\n        id\n      }\n      ... on PropertyLink {\n        links {\n          url\n          languages\n        }\n      }\n      ... on PropertyList {\n        values\n        categoryLinks\n      }\n      ... on PropertyString {\n        value\n        categoryLink\n      }\n      ... on PropertyInterval {\n        from\n        to\n      }\n    }\n  }\n}"

/***/ }),

/***/ 42318:
/***/ ((module) => {

module.exports = "query productPage($id: Int!, $recommendationsContextId: String, $personalizationClientId: String, $marketCode: String, $includeRecommendations: Boolean!, $expertsEnabled: Boolean!) {\n  product(id: $id) {\n    ...productPage\n    ...productPageExpertContent @include(if: $expertsEnabled)\n    prices {\n      ...priceList\n    }\n    relations {\n      type\n      relations {\n        name\n        sortPriority\n        selected\n      }\n    }\n    category {\n      products(limit: 10, sort: \"popularity\", getProperties: false) {\n        nodes {\n          id\n        }\n      }\n    }\n    popularProducts(onlyFromFeaturedStores: true) {\n      id\n      name\n      pathName\n      category\n      price\n      url\n      userReviewSummary {\n        rating\n        count\n      }\n      aggregatedRating {\n        score\n        count\n      }\n      imageUrl\n      isExpertTopRated\n    }\n    trendingProducts(onlyFromFeaturedStores: true) {\n      id\n      name\n      pathName\n      category\n      price\n      url\n      userReviewSummary {\n        rating\n        count\n      }\n      aggregatedRating {\n        score\n        count\n      }\n      imageUrl\n      isExpertTopRated\n    }\n    isExpertTopRated\n    metadata {\n      title\n      description\n    }\n  }\n  ...recommendations @include(if: $includeRecommendations)\n  prismicArticles(tags: [\"productpage-priceinfo\"]) {\n    nodes {\n      pathName\n    }\n  }\n}\n\nfragment productPage on Product {\n  id\n  name\n  description(html: true)\n  pathName\n  stockStatus\n  releaseDate\n  noIndex\n  userReviewSummary {\n    rating\n    count\n    countTotal\n  }\n  aggregatedRatingSummary {\n    summary {\n      rating {\n        score\n        count\n      }\n    }\n  }\n  hrefLang {\n    locale\n    url\n  }\n  coreProperties: properties(ids: \"_core_\") {\n    nodes {\n      __typename\n      id\n      name\n      type\n      pretty\n      prettyVerbose: pretty(mode: verbose)\n      prettyTable: pretty(mode: table)\n      ... on PropertyString {\n        valueId\n        categoryLink\n      }\n      ... on PropertyList {\n        values\n        valueIds\n        categoryLinks\n      }\n      ... on PropertyBoolean {\n        boolean\n      }\n    }\n  }\n  brand {\n    id\n    name\n    featured\n    logo\n    pathName\n  }\n  priceSummary {\n    regular\n    alternative\n  }\n  media {\n    count\n    first(width: _280)\n  }\n  category {\n    id\n    logo\n    name\n    pathName\n    productCollection\n    hasAdultContent\n    path {\n      id\n      name\n      pathName\n    }\n  }\n  sparkline {\n    values\n  }\n  popularity {\n    total\n    inCategory\n  }\n  productDescription {\n    preamble\n    descriptionPoints {\n      title\n      text\n    }\n    articles {\n      name\n      url\n    }\n  }\n  faqs {\n    id\n    question\n    answer\n  }\n  dealInfo {\n    dealPercentage\n    offers {\n      shopId\n      shopOfferId\n    }\n  }\n}\n\nfragment priceList on PriceList {\n  meta {\n    itemsTotal\n    storeStatistics {\n      totalCount\n      featuredCount\n    }\n  }\n  nodes {\n    ...priceListItem\n  }\n}\n\nfragment priceListItem on Price {\n  __typename\n  id\n  shopOfferId\n  name\n  externalUri\n  primaryMarket\n  membershipProgram {\n    name\n    requiresCompensation\n  }\n  stock {\n    status\n    statusText\n  }\n  condition\n  availability {\n    condition\n    availabilityDate\n  }\n  price {\n    inclShipping\n    exclShipping\n    originalCurrency\n  }\n  offerPrices {\n    price {\n      exclShipping\n      inclShipping\n      endDate\n    }\n    originalPrice {\n      exclShipping\n      inclShipping\n    }\n    memberPrice {\n      exclShipping\n      inclShipping\n      endDate\n    }\n  }\n  store {\n    id\n    name\n    featured\n    hasLogo\n    logo(width: _176)\n    pathName\n    providedByStore {\n      generalInformation\n    }\n    userReviewSummary {\n      rating\n      count\n      countTotal\n    }\n    market\n    marketplace\n    countryCode\n    primaryMarket\n    currency\n    payment {\n      options {\n        name\n      }\n      providers {\n        name\n      }\n    }\n  }\n  authorizedDealer\n  alternativePrices(includeMainPrice: true) {\n    __typename\n    id\n    shopOfferId\n    name\n    externalUri\n    primaryMarket\n    stock {\n      status\n      statusText\n    }\n    condition\n    availability {\n      condition\n      availabilityDate\n    }\n    price {\n      exclShipping\n      inclShipping\n      originalCurrency\n    }\n    offerPrices {\n      price {\n        exclShipping\n        inclShipping\n        endDate\n      }\n      originalPrice {\n        exclShipping\n        inclShipping\n      }\n      memberPrice {\n        exclShipping\n        inclShipping\n        endDate\n      }\n    }\n    variantInfo {\n      size\n      sizeSystem\n      colors\n    }\n    shipping {\n      cheapest {\n        deliveryDays {\n          min\n          max\n        }\n        shippingCost\n        carrier\n      }\n      fastest {\n        deliveryDays {\n          min\n          max\n        }\n        shippingCost\n      }\n      nodes {\n        deliveryMethod\n        carrier\n        deliveryDays {\n          min\n          max\n        }\n        shippingCost\n        sustainability\n        eligibility\n      }\n    }\n    shopHasUniqueShippings\n    ourChoiceScore\n    featuredOverride\n  }\n  variantInfo {\n    size\n    sizeSystem\n    colors\n  }\n  shipping {\n    cheapest {\n      deliveryDays {\n        min\n        max\n      }\n      shippingCost\n      carrier\n      sustainability\n    }\n    fastest {\n      deliveryDays {\n        min\n        max\n      }\n      shippingCost\n      carrier\n      sustainability\n    }\n    nodes {\n      deliveryMethod\n      carrier\n      deliveryDays {\n        min\n        max\n      }\n      shippingCost\n      sustainability\n      eligibility\n    }\n  }\n  shopHasUniqueShippings\n  ourChoiceScore\n  featuredOverride\n  membershipLink\n  promotion {\n    id\n    description\n    startDate\n    endDate\n    imageUrl\n    owner {\n      id\n      name\n      type\n    }\n    title\n    numberOfProducts\n  }\n}\n\nfragment recommendations on RootQuery {\n  recommendations(\n    clientId: $personalizationClientId\n    marketCode: $marketCode\n    contextId: $recommendationsContextId\n    productId: $id\n  ) {\n    model\n    recommendations(onlyFromFeaturedStores: true) {\n      score\n      product {\n        id\n        name\n        pathName: semanticId\n        brand {\n          id\n          name\n        }\n        price {\n          regular\n        }\n        media {\n          first\n        }\n        uri\n        webUri\n        userReviews {\n          rating\n          count\n        }\n        aggregatedRating {\n          score\n          count\n        }\n        category {\n          name\n        }\n        isExpertTopRated\n      }\n    }\n    personalized\n    version\n  }\n}\n\nfragment productPageExpertContent on Product {\n  expertContent {\n    totalCount\n    experts {\n      name\n      avatar\n      url\n    }\n    selected {\n      ... on ProductPageExpertTest {\n        __typename\n        rating\n        date(format: \"D MMMM YYYY\")\n        title\n        plus\n        minus\n        imageWithSize {\n          src\n          alt\n        }\n        suitedForLong\n        suitedFor {\n          headline\n          text\n        }\n        url\n        expert {\n          name\n          avatar\n          url\n        }\n        category {\n          name\n        }\n      }\n      ... on ProductPageToplist {\n        __typename\n        title\n        url\n        category {\n          name\n        }\n        expert {\n          name\n          avatar\n          url\n        }\n        products {\n          id\n          plus\n          minus\n          description\n        }\n      }\n    }\n    toplists {\n      toplists {\n        title\n        description {\n          type\n          data\n        }\n        headlineInfo {\n          url\n        }\n        products {\n          id\n          plus\n          minus\n        }\n      }\n    }\n  }\n}"

/***/ }),

/***/ 40857:
/***/ ((module) => {

module.exports = "query publicList($id: Int!, $limit: Int, $offset: Int, $sort: String, $direction: SortDirection) {\n  list(id: $id) {\n    id\n    name\n    pathName\n    created\n    priceSummary\n    itemsCount\n    icon\n    likes\n    visibility\n    user {\n      id\n      displayName\n    }\n    items(limit: $limit, offset: $offset, sort: $sort, direction: $direction) {\n      nodes {\n        ...listItemFragment\n      }\n      pageInfo {\n        limit\n        offset\n        hasNext\n        hasPrevious\n        sort {\n          name\n          direction\n        }\n      }\n    }\n  }\n}\n\nfragment listItemFragment on ListItem {\n  id\n  ... on AlertProduct {\n    __typename\n    priceThreshold\n    alertType\n    priceStep\n    storePreference\n    storeGradeThreshold\n    product {\n      preloaded: __typename\n      id\n      name\n      stockStatus\n      category {\n        id\n        name\n      }\n      latestPriceChange {\n        time(fromNow: true)\n        amount\n      }\n      priceSummary {\n        regular\n      }\n      userReviewSummary {\n        rating\n        count\n      }\n      media {\n        first(width: _280)\n      }\n      pathName\n    }\n  }\n  ... on AlertSearch {\n    __typename\n    search {\n      id\n      name\n      filterId\n      pathName\n      productsCount\n    }\n  }\n  ...listItemProductFragment\n  ... on ListSearch {\n    __typename\n    quantity\n    search {\n      id\n      name\n      filterId\n      pathName\n      productsCount\n    }\n  }\n  ... on ListCategory {\n    __typename\n    name\n    created(fromNow: true)\n    icon\n    pathName\n    itemsCount\n    priceSummary\n    inventory\n    visibility\n  }\n}\n\nfragment listItemProductFragment on ListProduct {\n  __typename\n  quantity\n  product {\n    preloaded: __typename\n    id\n    name\n    description\n    category {\n      id\n      name\n    }\n    priceSummary {\n      regular\n      alternative\n    }\n    userReviewSummary {\n      rating\n      count\n    }\n    aggregatedRating {\n      score\n      count\n    }\n    media {\n      first(width: _280)\n    }\n    pathName\n  }\n}"

/***/ }),

/***/ 4692:
/***/ ((module) => {

module.exports = "fragment GenericUserReview on UserReview {\n  id\n  reviewText\n  rating\n  convertedRating\n  purchaseDate\n  likeScore\n  views\n  underInvestigation\n  createdAt\n  updatedAt\n  createdAtFromNow: createdAt(fromNow: true, suffix: false)\n  updatedAtFromNow: updatedAt(fromNow: true, suffix: false)\n  localizedCreatedAt: createdAt(format: \"L\")\n  localizedUpdatedAt: updatedAt(format: \"L\")\n  isPublished\n  originMarket\n  user {\n    id\n    name\n    displayName\n    reviewCount\n  }\n  product @include(if: $getProduct) {\n    id\n    name\n    pathName\n    priceSummary {\n      regular\n    }\n    userReviewSummary {\n      rating\n      count\n    }\n    aggregatedRating {\n      score\n      count\n    }\n    media {\n      first(width: _140)\n    }\n  }\n  store @include(if: $getStore) {\n    id\n    name\n    pathName\n    userReviewSummary {\n      rating\n      countTotal\n      count\n    }\n    hasLogo\n    logo(width: _176)\n    featured\n  }\n}"

/***/ }),

/***/ 58948:
/***/ ((module) => {

module.exports = "query promotionProductsPage($id: String!) {\n  promotion(id: $id) {\n    id\n    title\n    description\n    imageUrl\n    promotionUrl\n    startDate\n    endDate\n    numberOfProducts\n    owner {\n      id\n      name\n      type\n    }\n  }\n}"

/***/ }),

/***/ 68035:
/***/ ((module) => {

module.exports = "query promotions($page: Int! = 0, $filters: [PromotionSearchFilter!]!) {\n  searchV3 {\n    promotions(page: $page, filters: $filters) {\n      items {\n        id\n        description\n        imageUrl\n        owner {\n          id\n          name\n          type\n        }\n        promotionUrl\n        title\n        startDate\n        endDate\n        numberOfProducts\n      }\n      typeAggregations {\n        key\n        name\n        count\n      }\n      shopAggregations {\n        key\n        count\n        name\n      }\n      hasMorePages\n      numberOfHits\n    }\n  }\n}"

/***/ }),

/***/ 76599:
/***/ ((module) => {

module.exports = "query usedProducts($page: Int!, $sortType: SearchV3Sorting!, $filters: [SearchFilter!]!) {\n  searchV3 {\n    products(\n      sortType: $sortType\n      page: $page\n      filters: $filters\n      order: desc\n      searchType: used\n    ) {\n      items {\n        ... on ProductCard {\n          productId\n          priceDrop\n          dealUpdateTime\n          logo\n          name\n          aggregatedRating {\n            score\n            count\n          }\n          productLink\n          storeCount\n          categoryName\n          bestOffer {\n            storeId\n            stockStatus\n            shopOfferId\n            storeName\n            price\n            originalPrice\n            memberPrice\n            offerLink\n            featured\n            priceExpires\n            condition\n            membershipRequiresCompensation\n          }\n          __typename\n        }\n      }\n      availabilityAggregations {\n        key\n        count\n        name\n      }\n      brandsAggregations {\n        key\n        count\n        name\n      }\n      categoryAggregations {\n        key\n        parentKey\n        count\n        name\n        logo\n      }\n      priceHistogram {\n        min\n        max\n        count\n      }\n      ratingHistogram {\n        key\n        count\n      }\n      shopAggregations {\n        key\n        count\n        name\n      }\n      hasMorePages\n      didYouMean\n      numberOfHits\n    }\n  }\n}"

/***/ }),

/***/ 26585:
/***/ ((module) => {

module.exports = "query suggestions($query: String!) {\n  searchSuggestions(query: $query) {\n    ... on SuggestedProduct {\n      __typename\n      text\n      id\n      category\n    }\n    ... on SuggestedBrand {\n      __typename\n      text\n      id\n      topCategories {\n        text\n        id\n        path\n      }\n    }\n    ... on SuggestedProductCollection {\n      __typename\n      text\n      id\n      path\n      topBrands {\n        text\n        id\n      }\n      filters {\n        ... on BrandFilter {\n          __typename\n          id\n          name\n          param\n        }\n      }\n    }\n    ... on SuggestedCategory {\n      __typename\n      text\n      id\n    }\n    ... on SuggestedVirtualCategory {\n      __typename\n      text\n      id\n    }\n    ... on SuggestedSearchPhrase {\n      __typename\n      text\n    }\n    ... on SuggestedLandingPage {\n      __typename\n      text\n      id\n      path\n    }\n    ... on SuggestedShop {\n      __typename\n      id\n      text\n    }\n  }\n}"

/***/ }),

/***/ 21598:
/***/ ((module) => {

module.exports = "query getPopularSearches {\n  popularSearches {\n    query\n  }\n}"

/***/ }),

/***/ 13897:
/***/ ((module) => {

module.exports = "query searchPage($query: String!, $offset: Int, $limit: Int, $sort: SearchProductSortingEnum, $order: SearchOrder, $categoryFilters: [String], $brandFilters: [String], $ratingFilters: [String], $priceFilters: [String], $dealsFilters: [String], $availabilityFilters: [String], $productDetailFilters: [String], $getExperts: Boolean = false, $allProductsFilter: Boolean = false) {\n  newSearch(\n    query: $query\n    categoryFilter: $categoryFilters\n    brandFilter: $brandFilters\n    ratingFilter: $ratingFilters\n    priceFilter: $priceFilters\n    dealsFilter: $dealsFilters\n    availabilityFilter: $availabilityFilters\n    productDetailFilter: $productDetailFilters\n    allProductsFilter: $allProductsFilter\n  ) {\n    errorOccured\n    query\n    results {\n      products(offset: $offset, limit: $limit, sort: $sort, order: $order) {\n        pageInfo {\n          offset\n          limit\n          total\n          pages\n          sort {\n            name\n            direction\n          }\n        }\n        nodes {\n          ... on Product {\n            __typename\n            id\n            name\n            category {\n              path {\n                id\n                name\n              }\n            }\n            pathName\n            userReviewSummary {\n              rating\n              count\n            }\n            aggregatedRating {\n              score\n              count\n            }\n            priceSummary {\n              regular\n              alternative\n              count\n            }\n            media {\n              first(width: _280)\n            }\n            dealInfo {\n              dealPercentage\n            }\n            isExpertTopRated\n          }\n          ... on Offer {\n            __typename\n            offerId: id\n            name\n            externalUri\n            media {\n              first\n            }\n            store {\n              name\n              id\n              featured\n              currency\n            }\n            offerPrice {\n              regular\n            }\n            featuredOverride\n          }\n        }\n      }\n      categories(limit: 16) {\n        pageInfo {\n          total\n        }\n        nodes {\n          type\n          id\n          name\n          path\n          image\n          productCount\n          productMedia\n        }\n      }\n      brands(limit: 10) {\n        pageInfo {\n          total\n        }\n        nodes {\n          id\n          name\n          brandLogo\n          pathName\n        }\n      }\n      shops {\n        pageInfo {\n          total\n        }\n        nodes {\n          id\n          name\n          hasLogo\n          pathName\n        }\n      }\n      articlesResult @include(if: $getExperts) {\n        items {\n          tests {\n            __typename\n            id\n            title\n            url\n            likes\n            grade\n            gradeNotConverted\n            date(format: \"D MMMM yyyy\")\n            imageWithSize(size: x2) {\n              src\n              alt\n            }\n            expert {\n              name\n              avatar\n              url\n            }\n            publishedAt\n            order\n          }\n          toplists {\n            __typename\n            id\n            title\n            likes\n            date(format: \"D MMMM YYYY\")\n            headlineInfo {\n              url\n            }\n            products {\n              name\n              image\n              order\n            }\n            pjProducts {\n              id\n              name\n              media {\n                first(width: _140)\n              }\n            }\n            expert {\n              name\n              avatar\n              url\n            }\n            description {\n              type\n              data\n            }\n            publishedAt\n            order\n            image(size: x2) {\n              src\n              alt\n            }\n          }\n          guides {\n            __typename\n            id\n            title\n            url\n            likes\n            date(format: \"D MMMM YYYY\")\n            image(size: x2) {\n              src\n              alt\n            }\n            expert {\n              name\n              avatar\n              url\n            }\n            description\n            publishedAt\n            order\n          }\n          articles {\n            __typename\n            id\n            title\n            description\n            image {\n              src\n              alt\n            }\n            link\n            date\n            order\n          }\n          videos {\n            __typename\n            id\n            youtubeId\n            previewImage\n            order\n            title\n            author\n          }\n        }\n      }\n    }\n    filters {\n      category {\n        id\n        name\n        productCount\n        selected\n      }\n      productDetail {\n        ... on SearchProductDetailFilterOptionInterface {\n          id\n          title\n          featured\n          type\n        }\n        ... on ListFilterOption {\n          multiple\n          options: newOptions {\n            ... on SearchFilterOptionItem {\n              id\n              value\n              name\n              count\n            }\n          }\n        }\n        ... on BooleanFilterOption {\n          multiple\n          options: newOptions {\n            ... on SearchFilterOptionItem {\n              id\n              value\n              name\n              count\n            }\n          }\n        }\n        ... on RangeFilterOption {\n          min\n          max\n          maxMatchingProducts\n          unit\n          scale\n          options: newOptions {\n            ... on SearchFilterRangeItem {\n              products\n              from\n              to\n            }\n          }\n        }\n        ... on UnsupportedFilterOption {\n          type\n        }\n      }\n      brand {\n        id\n        name\n        productCount\n        selected\n      }\n      availability {\n        id\n        name\n        productCount\n        selected\n      }\n      rating {\n        min\n        max\n        histogram {\n          key\n          count\n        }\n      }\n      price {\n        min\n        max\n        histogram {\n          key\n          count\n          from\n          to\n        }\n      }\n      deals {\n        min\n        max\n        histogram {\n          key\n          count\n        }\n      }\n    }\n  }\n  popularSearches {\n    query\n  }\n  keywordSuggestions(query: $query) {\n    query\n  }\n  didYouMean(query: $query) {\n    text\n  }\n}"

/***/ }),

/***/ 99230:
/***/ ((module) => {

module.exports = "query sotyPage($year: Int, $getProduct: Boolean = false, $getStore: Boolean = true) {\n  shopOfTheYear(year: $year) {\n    year\n    leaderboards {\n      nodes {\n        id\n        name\n        isSpecial\n        mainAward\n        logo\n        leaderboard {\n          id\n          name\n          pathName\n          hasLogo\n          featured\n        }\n      }\n    }\n    charity {\n      name\n      description\n      logo\n    }\n    featuredArticle {\n      title\n      preamble\n      imageUrl\n      pathName\n    }\n  }\n  latestReviews(limit: 20, reviewType: STORES) {\n    ...GenericUserReview\n  }\n  prismicArticles(tags: [\"shop-of-the-year\"], sort: lastPublicationDate) {\n    nodes {\n      id\n      pathName\n      tags\n      data {\n        title {\n          ...richContentFragment\n        }\n        metaDescription {\n          ...richContentFragment\n        }\n        featuredImage {\n          ...imageFragment\n        }\n      }\n    }\n  }\n}\n\nfragment GenericUserReview on UserReview {\n  id\n  reviewText\n  rating\n  convertedRating\n  purchaseDate\n  likeScore\n  views\n  underInvestigation\n  createdAt\n  updatedAt\n  createdAtFromNow: createdAt(fromNow: true, suffix: false)\n  updatedAtFromNow: updatedAt(fromNow: true, suffix: false)\n  localizedCreatedAt: createdAt(format: \"L\")\n  localizedUpdatedAt: updatedAt(format: \"L\")\n  isPublished\n  originMarket\n  user {\n    id\n    name\n    displayName\n    reviewCount\n  }\n  product @include(if: $getProduct) {\n    id\n    name\n    pathName\n    priceSummary {\n      regular\n    }\n    userReviewSummary {\n      rating\n      count\n    }\n    aggregatedRating {\n      score\n      count\n    }\n    media {\n      first(width: _140)\n    }\n  }\n  store @include(if: $getStore) {\n    id\n    name\n    pathName\n    userReviewSummary {\n      rating\n      countTotal\n      count\n    }\n    hasLogo\n    logo(width: _176)\n    featured\n  }\n}\n\nfragment richContentFragment on PrismicRichContent {\n  ... on PrismicRichText {\n    type\n    text\n    spans {\n      data {\n        linkType\n        url\n        target\n      }\n      type\n      start\n      end\n    }\n  }\n  ... on PrismicImage {\n    url\n    dimensions {\n      width\n      height\n    }\n    alt\n    copyright\n  }\n}\n\nfragment imageFragment on PrismicImage {\n  url\n  dimensions {\n    width\n    height\n  }\n  alt\n  copyright\n  Mobile {\n    url\n    dimensions {\n      width\n      height\n    }\n    alt\n    copyright\n  }\n  Desktop {\n    url\n    dimensions {\n      width\n      height\n    }\n    alt\n    copyright\n  }\n}"

/***/ }),

/***/ 50191:
/***/ ((module) => {

module.exports = "mutation MyProductsImport($listId: Int!) {\n  myProductsImport(listId: $listId) {\n    id\n  }\n}"

/***/ }),

/***/ 16242:
/***/ ((module) => {

module.exports = "mutation AddProductsToMyProducts($productIds: [Int!]!) {\n  myProductsItemsAdd(productIds: $productIds) {\n    id\n  }\n}"

/***/ }),

/***/ 96398:
/***/ ((module) => {

module.exports = "query storePage($id: Int!, $offset: Int!, $getProduct: Boolean = false, $getStore: Boolean = false, $invalidateCache: Boolean, $limit: Int = 12, $sort: String = \"popularity\", $userReviewLimit: Int = 10, $userReviewSort: String = \"date\", $userReviewFilter: ReviewFilter = ALL) {\n  store(id: $id) {\n    id\n    name\n    hasLogo\n    logo(width: _176)\n    externalUri\n    externalUriText\n    featured\n    pathName\n    countryCode\n    countryName\n    currency\n    hrefLang {\n      locale\n      url\n    }\n    providedByStore {\n      generalInformation\n    }\n    consumerInformation {\n      time\n      message\n    }\n    storeOfTheYearAwards {\n      id\n      categoryId\n      name\n      resourceName\n      logo\n      year\n      mainAward\n      isSpecial\n      isPrimary\n    }\n    companyName\n    companyNumber\n    supportTelephone\n    supportOnsite\n    payment {\n      options {\n        name\n      }\n      providers {\n        name\n      }\n    }\n    marketplace\n    companyInfoUrl\n    languages {\n      support\n    }\n    ...storeUserReviews\n    products(limit: $limit, sort: $sort, onlyFromFeaturedStores: true) {\n      nodes {\n        id\n        pathName\n        name\n        media {\n          first(width: _140)\n        }\n        priceSummary {\n          regular\n          alternative\n        }\n        userReviewSummary {\n          rating\n          count\n        }\n        aggregatedRating {\n          score\n          count\n        }\n        prices {\n          nodes {\n            id\n            store {\n              id\n            }\n            price {\n              exclShipping\n            }\n          }\n        }\n        isExpertTopRated\n      }\n    }\n  }\n}\n\nfragment storeUserReviews on Store {\n  userReviewSummary {\n    rating\n    count\n    countTotal\n    distributionNew {\n      score\n      count\n      percentage\n    }\n  }\n  userReviews(\n    offset: $offset\n    limit: $userReviewLimit\n    sort: $userReviewSort\n    filter: $userReviewFilter\n    invalidateCache: $invalidateCache\n  ) {\n    myReview {\n      id\n      rating\n      reviewText\n      createdAt\n      localizedCreatedAt: createdAt(format: \"L\")\n      localizedUpdatedAt: updatedAt(format: \"L\")\n    }\n    pageInfo {\n      offset\n      limit\n      hasNext\n      hasPrevious\n    }\n    nodes {\n      ...GenericUserReview\n      reply\n      replyDate\n      translation {\n        text: reviewText\n        language\n        service {\n          name\n          uri\n        }\n      }\n      verifiedPurchase\n    }\n  }\n}\n\nfragment GenericUserReview on UserReview {\n  id\n  reviewText\n  rating\n  convertedRating\n  purchaseDate\n  likeScore\n  views\n  underInvestigation\n  createdAt\n  updatedAt\n  createdAtFromNow: createdAt(fromNow: true, suffix: false)\n  updatedAtFromNow: updatedAt(fromNow: true, suffix: false)\n  localizedCreatedAt: createdAt(format: \"L\")\n  localizedUpdatedAt: updatedAt(format: \"L\")\n  isPublished\n  originMarket\n  user {\n    id\n    name\n    displayName\n    reviewCount\n  }\n  product @include(if: $getProduct) {\n    id\n    name\n    pathName\n    priceSummary {\n      regular\n    }\n    userReviewSummary {\n      rating\n      count\n    }\n    aggregatedRating {\n      score\n      count\n    }\n    media {\n      first(width: _140)\n    }\n  }\n  store @include(if: $getStore) {\n    id\n    name\n    pathName\n    userReviewSummary {\n      rating\n      countTotal\n      count\n    }\n    hasLogo\n    logo(width: _176)\n    featured\n  }\n}"

/***/ }),

/***/ 42409:
/***/ ((module) => {

module.exports = "query personalization($personalizationClientId: String) {\n  recommendation {\n    products(personalizationClientId: $personalizationClientId, limit: 20) {\n      fallbackToDefault\n      nodes {\n        category {\n          id\n          name\n          logo(width: _96)\n          productCollection\n        }\n      }\n    }\n  }\n}"

/***/ }),

/***/ 79018:
/***/ ((module) => {

module.exports = "query imageSearch($productId: Int!) {\n  visuallySimilarProducts(productId: $productId) {\n    productId\n    priceDrop\n    dealUpdateTime\n    imageSearchModels\n    logo\n    name\n    aggregatedRating {\n      score\n      count\n    }\n    productLink\n    storeCount\n    parentCategoryIds\n    categoryName\n    bestOffer {\n      condition\n      featured\n      memberPrice\n      membershipRequiresCompensation\n      offerLink\n      originalPrice\n      price\n      priceExpires\n      shopOfferId\n      stockStatus\n      storeId\n      storeName\n    }\n    __typename\n  }\n}"

/***/ }),

/***/ 21440:
/***/ (() => {

/* (ignored) */

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/amd define */
/******/ 	(() => {
/******/ 		__webpack_require__.amdD = function () {
/******/ 			throw new Error('define cannot be used indirect');
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/amd options */
/******/ 	(() => {
/******/ 		__webpack_require__.amdO = {};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/ensure chunk */
/******/ 	(() => {
/******/ 		__webpack_require__.f = {};
/******/ 		// This file contains only the entry chunk.
/******/ 		// The chunk loading function for additional chunks
/******/ 		__webpack_require__.e = (chunkId) => {
/******/ 			return Promise.all(Object.keys(__webpack_require__.f).reduce((promises, key) => {
/******/ 				__webpack_require__.f[key](chunkId, promises);
/******/ 				return promises;
/******/ 			}, []));
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/get javascript chunk filename */
/******/ 	(() => {
/******/ 		// This function allow to reference async chunks
/******/ 		__webpack_require__.u = (chunkId) => {
/******/ 			// return url for filenames based on template
/******/ 			return "" + {"34":"1379d18bda88cbd4a8f3","46":"a2a33ab486ebfd123265","56":"e2591f442d38384a086d","88":"f74afccb59ade1784202","119":"8137cc766e2805c81372","120":"72663cc9d74bcd330ead","159":"3b52df93074649f086ba","191":"334986f128a232dc254a","236":"2f6fa0f5777a5708e8f0","241":"891024ff825cc2a81672","283":"4d2c717cbb20226e2fbe","314":"94121143ef7895cd3959","340":"00a407bf0b2b3c5324e4","362":"d83023956ad0e5d12078","373":"b98519fc7258e51e6dcd","378":"7ea636562dfc45d48aa7","406":"bcedce327ede7915650e","408":"3debfbca95c8f5fafee6","422":"9eeb3bc6882a40ddcaa6","464":"5d079b809330e64505d3","495":"33f171843d51a855fb71","536":"1a68773471a582ad325d","554":"1a13c6037b0eb7189ec8","557":"cff0fcaacf02a7b673d6","570":"f03668e05a6306bbbcca","578":"81354023ce28d4a903e5","603":"20631b1171c518021597","617":"d61cc7061f62e9e7daf2","625":"d66fd6dfcb8a1bf44491","687":"9bbc246834e3a67531eb","722":"938a774cb7f4ab849d51","737":"f59d0872468169561dfa","781":"53815aa127cf36b6d370","802":"60e700f55c2d43bdef5b","827":"b91d4a43b90da867355d","831":"67835b2f103d5b18a225","835":"5d5e8467aebb87d64cc1","845":"fd3e29a782bd936172dd","850":"49deea836d03895a07a8","877":"4bf108f41d82244147d4","897":"a7c4cc4b4b601b3ab4e2","912":"3b21d20a27e9d8f9be3f","942":"65aa2fd3a72f8f237222","970":"9cdaa0599cae035476da"}[chunkId] + "/" + chunkId + ".js";
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/get mini-css chunk filename */
/******/ 	(() => {
/******/ 		// This function allow to reference async chunks
/******/ 		__webpack_require__.miniCssF = (chunkId) => {
/******/ 			// return url for filenames based on template
/******/ 			return undefined;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/harmony module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.hmd = (module) => {
/******/ 			module = Object.create(module);
/******/ 			if (!module.children) module.children = [];
/******/ 			Object.defineProperty(module, 'exports', {
/******/ 				enumerable: true,
/******/ 				set: () => {
/******/ 					throw new Error('ES Modules may not assign module.exports or exports.*, Use ESM export syntax, instead: ' + module.id);
/******/ 				}
/******/ 			});
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/load script */
/******/ 	(() => {
/******/ 		var inProgress = {};
/******/ 		var dataWebpackPrefix = "@prisjakt/responsive-frontend:";
/******/ 		// loadScript function to load a script via script tag
/******/ 		__webpack_require__.l = (url, done, key, chunkId) => {
/******/ 			if(inProgress[url]) { inProgress[url].push(done); return; }
/******/ 			var script, needAttach;
/******/ 			if(key !== undefined) {
/******/ 				var scripts = document.getElementsByTagName("script");
/******/ 				for(var i = 0; i < scripts.length; i++) {
/******/ 					var s = scripts[i];
/******/ 					if(s.getAttribute("src") == url || s.getAttribute("data-webpack") == dataWebpackPrefix + key) { script = s; break; }
/******/ 				}
/******/ 			}
/******/ 			if(!script) {
/******/ 				needAttach = true;
/******/ 				script = document.createElement('script');
/******/ 		
/******/ 				script.charset = 'utf-8';
/******/ 				script.timeout = 120;
/******/ 				if (__webpack_require__.nc) {
/******/ 					script.setAttribute("nonce", __webpack_require__.nc);
/******/ 				}
/******/ 				script.setAttribute("data-webpack", dataWebpackPrefix + key);
/******/ 				script.src = url;
/******/ 			}
/******/ 			inProgress[url] = [done];
/******/ 			var onScriptComplete = (prev, event) => {
/******/ 				// avoid mem leaks in IE.
/******/ 				script.onerror = script.onload = null;
/******/ 				clearTimeout(timeout);
/******/ 				var doneFns = inProgress[url];
/******/ 				delete inProgress[url];
/******/ 				script.parentNode && script.parentNode.removeChild(script);
/******/ 				doneFns && doneFns.forEach((fn) => (fn(event)));
/******/ 				if(prev) return prev(event);
/******/ 			}
/******/ 			;
/******/ 			var timeout = setTimeout(onScriptComplete.bind(null, undefined, { type: 'timeout', target: script }), 120000);
/******/ 			script.onerror = onScriptComplete.bind(null, script.onerror);
/******/ 			script.onload = onScriptComplete.bind(null, script.onload);
/******/ 			needAttach && document.head.appendChild(script);
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__webpack_require__.p = "";
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			826: 0
/******/ 		};
/******/ 		
/******/ 		__webpack_require__.f.j = (chunkId, promises) => {
/******/ 				// JSONP chunk loading for javascript
/******/ 				var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
/******/ 				if(installedChunkData !== 0) { // 0 means "already installed".
/******/ 		
/******/ 					// a Promise means "currently loading".
/******/ 					if(installedChunkData) {
/******/ 						promises.push(installedChunkData[2]);
/******/ 					} else {
/******/ 						if(true) { // all chunks have JS
/******/ 							// setup Promise in chunk cache
/******/ 							var promise = new Promise((resolve, reject) => (installedChunkData = installedChunks[chunkId] = [resolve, reject]));
/******/ 							promises.push(installedChunkData[2] = promise);
/******/ 		
/******/ 							// start chunk loading
/******/ 							var url = __webpack_require__.p + __webpack_require__.u(chunkId);
/******/ 							// create error before stack unwound to get useful stacktrace later
/******/ 							var error = new Error();
/******/ 							var loadingEnded = (event) => {
/******/ 								if(__webpack_require__.o(installedChunks, chunkId)) {
/******/ 									installedChunkData = installedChunks[chunkId];
/******/ 									if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
/******/ 									if(installedChunkData) {
/******/ 										var errorType = event && (event.type === 'load' ? 'missing' : event.type);
/******/ 										var realSrc = event && event.target && event.target.src;
/******/ 										error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
/******/ 										error.name = 'ChunkLoadError';
/******/ 										error.type = errorType;
/******/ 										error.request = realSrc;
/******/ 										installedChunkData[1](error);
/******/ 									}
/******/ 								}
/******/ 							};
/******/ 							__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
/******/ 						} else installedChunks[chunkId] = 0;
/******/ 					}
/******/ 				}
/******/ 		};
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// module factories are used so entry inlining is disabled
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, [300], () => (__webpack_require__(4779)))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;